/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "scripts/" + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 267);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(34);
var hide = __webpack_require__(25);
var redefine = __webpack_require__(26);
var ctx = __webpack_require__(35);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(476)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pSBC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getContrastYIQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hexToRgb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);


var getOffset = function getOffset(element) {
  if (!element.getClientRects().length) {
    return {
      top: 0,
      left: 0
    };
  }

  var rect = element.getBoundingClientRect();
  var win = element.ownerDocument.defaultView;
  return {
    top: rect.top + win.pageYOffset,
    left: rect.left + win.pageXOffset
  };
};

var pSBC = function pSBC(p, c0, c1, l) {
  var r,
      g,
      b,
      P,
      f,
      t,
      h,
      i = parseInt,
      m = Math.round,
      a = typeof c1 == "string";
  if (typeof p != "number" || p < -1 || p > 1 || typeof c0 != "string" || c0[0] != 'r' && c0[0] != '#' || c1 && !a) return null;
  if (!this.pSBCr) this.pSBCr = function (d) {
    var n = d.length,
        x = {};

    if (n > 9) {
      var _d, _d2;

      (_d = d = d.split(","), _d2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_d, 4), r = _d2[0], g = _d2[1], b = _d2[2], a = _d2[3], _d), n = d.length;
      if (n < 3 || n > 4) return null;
      x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1;
    } else {
      if (n == 8 || n == 6 || n < 4) return null;
      if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
      d = i(d.slice(1), 16);
      if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1;
    }

    return x;
  };
  h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = this.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? this.pSBCr(c1) : P ? {
    r: 0,
    g: 0,
    b: 0,
    a: -1
  } : {
    r: 255,
    g: 255,
    b: 255,
    a: -1
  }, p = P ? p * -1 : p, P = 1 - p;
  if (!f || !t) return null;
  if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);else r = m(Math.pow(P * Math.pow(f.r, 2) + p * Math.pow(t.r, 2), 0.5)), g = m(Math.pow(P * Math.pow(f.g, 2) + p * Math.pow(t.g, 2), 0.5)), b = m(Math.pow(P * Math.pow(f.b, 2) + p * Math.pow(t.b, 2), 0.5));
  a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
  if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
};

var getContrastYIQ = function getContrastYIQ(hexcolor) {
  if (hexcolor) {
    hexcolor = hexcolor.replace("#", "");
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000; // 'True' if for dark text, 'False' is for lighter text

    return yiq >= 128 ? true : false;
  }
};

var hexToRgb = function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};



/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["e"] = find;
/* harmony export (immutable) */ __webpack_exports__["a"] = children;
/* harmony export (immutable) */ __webpack_exports__["j"] = text;
/* harmony export (immutable) */ __webpack_exports__["g"] = parents;
/* harmony export (immutable) */ __webpack_exports__["h"] = prevAll;
/* harmony export (immutable) */ __webpack_exports__["f"] = offset;
/* harmony export (immutable) */ __webpack_exports__["c"] = filterLI;
/* harmony export (immutable) */ __webpack_exports__["d"] = filterLIA;
/* harmony export (immutable) */ __webpack_exports__["i"] = reClass;
/**
 * Create an element with classname.
 *
 * @param 	{string}		selector	The nodeName and classnames for the element to create.
 * @return	{HTMLElement}				The created element.
 */
function create(selector) {
    var args = selector.split('.');
    var elem = document.createElement(args.shift());
    //  IE11:
    args.forEach(function (classname) {
        elem.classList.add(classname);
    });
    //  Better browsers:
    // elem.classList.add(...args);
    return elem;
}
/**
 * Find all elements matching the selector.
 * Basically the same as element.querySelectorAll() but it returns an actuall array.
 *
 * @param 	{HTMLElement} 	element Element to search in.
 * @param 	{string}		filter	The filter to match.
 * @return	{array}					Array of elements that match the filter.
 */
function find(element, filter) {
    return Array.prototype.slice.call(element.querySelectorAll(filter));
}
/**
 * Find all child elements matching the (optional) selector.
 *
 * @param 	{HTMLElement} 	element Element to search in.
 * @param 	{string}		filter	The filter to match.
 * @return	{array}					Array of child elements that match the filter.
 */
function children(element, filter) {
    var children = Array.prototype.slice.call(element.children);
    return filter
        ? children.filter(function (child) { return child.matches(filter); })
        : children;
}
/**
 * Find text excluding text from within child elements.
 * @param   {HTMLElement}   element Element to search in.
 * @return  {string}                The text.
 */
function text(element) {
    return Array.prototype.slice
        .call(element.childNodes)
        .filter(function (child) { return child.nodeType == 3; })
        .map(function (child) { return child.textContent; })
        .join(' ');
}
/**
 * Find all preceding elements matching the selector.
 *
 * @param 	{HTMLElement} 	element Element to start searching from.
 * @param 	{string}		filter	The filter to match.
 * @return	{array}					Array of preceding elements that match the selector.
 */
function parents(element, filter) {
    /** Array of preceding elements that match the selector. */
    var parents = [];
    /** Array of preceding elements that match the selector. */
    var parent = element.parentElement;
    while (parent) {
        parents.push(parent);
        parent = parent.parentElement;
    }
    return filter
        ? parents.filter(function (parent) { return parent.matches(filter); })
        : parents;
}
/**
 * Find all previous siblings matching the selecotr.
 *
 * @param 	{HTMLElement} 	element Element to start searching from.
 * @param 	{string}		filter	The filter to match.
 * @return	{array}					Array of previous siblings that match the selector.
 */
function prevAll(element, filter) {
    /** Array of previous siblings that match the selector. */
    var previous = [];
    /** Current element in the loop */
    var current = element.previousElementSibling;
    while (current) {
        if (!filter || current.matches(filter)) {
            previous.push(current);
        }
        current = current.previousElementSibling;
    }
    return previous;
}
/**
 * Get an element offset relative to the document.
 *
 * @param 	{HTMLElement}	 element 			Element to start measuring from.
 * @param 	{string}		 [direction=top] 	Offset top or left.
 * @return	{number}							The element offset relative to the document.
 */
function offset(element, direction) {
    return (element.getBoundingClientRect()[direction] +
        document.body[direction === 'left' ? 'scrollLeft' : 'scrollTop']);
}
/**
 * Filter out non-listitem listitems.
 * @param  {array} listitems 	Elements to filter.
 * @return {array}				The filtered set of listitems.
 */
function filterLI(listitems) {
    return listitems.filter(function (listitem) { return !listitem.matches('.mm-hidden'); });
}
/**
 * Find anchors in listitems (excluding anchor that open a sub-panel).
 * @param  {array} 	listitems 	Elements to filter.
 * @return {array}				The found set of anchors.
 */
function filterLIA(listitems) {
    var anchors = [];
    filterLI(listitems).forEach(function (listitem) {
        anchors.push.apply(anchors, children(listitem, 'a.mm-listitem__text'));
    });
    return anchors.filter(function (anchor) { return !anchor.matches('.mm-btn_next'); });
}
/**
 * Refactor a classname on multiple elements.
 * @param {HTMLElement} element 	Element to refactor.
 * @param {string}		oldClass 	Classname to remove.
 * @param {string}		newClass 	Classname to add.
 */
function reClass(element, oldClass, newClass) {
    if (element.matches('.' + oldClass)) {
        element.classList.remove(oldClass);
        element.classList.add(newClass);
    }
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__options__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configs__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translations_translate__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_i18n__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_matchmedia__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_helpers__ = __webpack_require__(13);







//  Add the translations.
Object(__WEBPACK_IMPORTED_MODULE_2__translations_translate__["a" /* default */])();
/**
 * Class for a mobile menu.
 */
var Mmenu = /** @class */ (function () {
    /**
     * Create a mobile menu.
     * @param {HTMLElement|string} 	menu						The menu node.
     * @param {object} 				[options=Mmenu.options]		Options for the menu.
     * @param {object} 				[configs=Mmenu.configs]		Configuration options for the menu.
     */
    function Mmenu(menu, options, configs) {
        //	Extend options and configuration from defaults.
        this.opts = Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["a" /* extend */])(options, Mmenu.options);
        this.conf = Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["a" /* extend */])(configs, Mmenu.configs);
        //	Methods to expose in the API.
        this._api = [
            'bind',
            'initPanel',
            'initListview',
            'openPanel',
            'closePanel',
            'closeAllPanels',
            'setSelected',
        ];
        //	Storage objects for nodes, variables, hooks and click handlers.
        this.node = {};
        this.vars = {};
        this.hook = {};
        this.clck = [];
        //	Get menu node from string or element.
        this.node.menu =
            typeof menu == 'string' ? document.querySelector(menu) : menu;
        if (typeof this._deprecatedWarnings == 'function') {
            this._deprecatedWarnings();
        }
        this._initWrappers();
        this._initAddons();
        this._initExtensions();
        this._initHooks();
        this._initAPI();
        this._initMenu();
        this._initPanels();
        this._initOpened();
        this._initAnchors();
        __WEBPACK_IMPORTED_MODULE_5__modules_matchmedia__["b" /* watch */]();
        return this;
    }
    /**
     * Open a panel.
     * @param {HTMLElement} panel				Panel to open.
     * @param {boolean}		[animation=true]	Whether or not to open the panel with an animation.
     */
    Mmenu.prototype.openPanel = function (panel, animation) {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger('openPanel:before', [panel]);
        //	Find panel.
        if (!panel) {
            return;
        }
        if (!panel.matches('.mm-panel')) {
            panel = panel.closest('.mm-panel');
        }
        if (!panel) {
            return;
        }
        //	/Find panel.
        if (typeof animation != 'boolean') {
            animation = true;
        }
        //	Open a "vertical" panel.
        if (panel.parentElement.matches('.mm-listitem_vertical')) {
            //	Open current and all vertical parent panels.
            __WEBPACK_IMPORTED_MODULE_3__modules_dom__["g" /* parents */](panel, '.mm-listitem_vertical').forEach(function (listitem) {
                listitem.classList.add('mm-listitem_opened');
                __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](listitem, '.mm-panel').forEach(function (panel) {
                    panel.classList.remove('mm-hidden');
                });
            });
            //	Open first non-vertical parent panel.
            var parents = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["g" /* parents */](panel, '.mm-panel').filter(function (panel) { return !panel.parentElement.matches('.mm-listitem_vertical'); });
            this.trigger('openPanel:start', [panel]);
            if (parents.length) {
                this.openPanel(parents[0]);
            }
            this.trigger('openPanel:finish', [panel]);
            //	Open a "horizontal" panel.
        }
        else {
            if (panel.matches('.mm-panel_opened')) {
                return;
            }
            var panels = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](this.node.pnls, '.mm-panel'), current_1 = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](this.node.pnls, '.mm-panel_opened')[0];
            //	Close all child panels.
            panels
                .filter(function (parent) { return parent !== panel; })
                .forEach(function (parent) {
                parent.classList.remove('mm-panel_opened-parent');
            });
            //	Open all parent panels.
            var parent_1 = panel['mmParent'];
            while (parent_1) {
                parent_1 = parent_1.closest('.mm-panel');
                if (parent_1) {
                    if (!parent_1.parentElement.matches('.mm-listitem_vertical')) {
                        parent_1.classList.add('mm-panel_opened-parent');
                    }
                    parent_1 = parent_1['mmParent'];
                }
            }
            //	Add classes for animation.
            panels.forEach(function (panel) {
                panel.classList.remove('mm-panel_highest');
            });
            panels
                .filter(function (hidden) { return hidden !== current_1; })
                .filter(function (hidden) { return hidden !== panel; })
                .forEach(function (hidden) {
                hidden.classList.add('mm-hidden');
            });
            panel.classList.remove('mm-hidden');
            /**	Start opening the panel. */
            var openPanelStart_1 = function () {
                if (current_1) {
                    current_1.classList.remove('mm-panel_opened');
                }
                panel.classList.add('mm-panel_opened');
                if (panel.matches('.mm-panel_opened-parent')) {
                    if (current_1) {
                        current_1.classList.add('mm-panel_highest');
                    }
                    panel.classList.remove('mm-panel_opened-parent');
                }
                else {
                    if (current_1) {
                        current_1.classList.add('mm-panel_opened-parent');
                    }
                    panel.classList.add('mm-panel_highest');
                }
                //	Invoke "start" hook.
                _this.trigger('openPanel:start', [panel]);
            };
            /**	Finish opening the panel. */
            var openPanelFinish_1 = function () {
                if (current_1) {
                    current_1.classList.remove('mm-panel_highest');
                    current_1.classList.add('mm-hidden');
                }
                panel.classList.remove('mm-panel_highest');
                //	Invoke "finish" hook.
                _this.trigger('openPanel:finish', [panel]);
            };
            if (animation && !panel.matches('.mm-panel_noanimation')) {
                //	Without the timeout the animation will not work because the element had display: none;
                setTimeout(function () {
                    //	Callback
                    Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["d" /* transitionend */])(panel, function () {
                        openPanelFinish_1();
                    }, _this.conf.transitionDuration);
                    openPanelStart_1();
                }, this.conf.openingInterval);
            }
            else {
                openPanelStart_1();
                openPanelFinish_1();
            }
        }
        //	Invoke "after" hook.
        this.trigger('openPanel:after', [panel]);
    };
    /**
     * Close a panel.
     * @param {HTMLElement} panel Panel to close.
     */
    Mmenu.prototype.closePanel = function (panel) {
        //	Invoke "before" hook.
        this.trigger('closePanel:before', [panel]);
        var li = panel.parentElement;
        //	Only works for "vertical" panels.
        if (li.matches('.mm-listitem_vertical')) {
            li.classList.remove('mm-listitem_opened');
            panel.classList.add('mm-hidden');
            //	Invoke main hook.
            this.trigger('closePanel', [panel]);
        }
        //	Invoke "after" hook.
        this.trigger('closePanel:after', [panel]);
    };
    /**
     * Close all opened panels.
     * @param {HTMLElement} panel Panel to open after closing all other panels.
     */
    Mmenu.prototype.closeAllPanels = function (panel) {
        //	Invoke "before" hook.
        this.trigger('closeAllPanels:before');
        //	Close all "vertical" panels.
        var listitems = this.node.pnls.querySelectorAll('.mm-listitem');
        listitems.forEach(function (listitem) {
            listitem.classList.remove('mm-listitem_selected');
            listitem.classList.remove('mm-listitem_opened');
        });
        //	Close all "horizontal" panels.
        var panels = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](this.node.pnls, '.mm-panel'), opened = panel ? panel : panels[0];
        __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](this.node.pnls, '.mm-panel').forEach(function (panel) {
            if (panel !== opened) {
                panel.classList.remove('mm-panel_opened');
                panel.classList.remove('mm-panel_opened-parent');
                panel.classList.remove('mm-panel_highest');
                panel.classList.add('mm-hidden');
            }
        });
        //	Open first panel.
        this.openPanel(opened, false);
        //	Invoke "after" hook.
        this.trigger('closeAllPanels:after');
    };
    /**
     * Toggle a panel opened/closed.
     * @param {HTMLElement} panel Panel to open or close.
     */
    Mmenu.prototype.togglePanel = function (panel) {
        var listitem = panel.parentElement;
        //	Only works for "vertical" panels.
        if (listitem.matches('.mm-listitem_vertical')) {
            this[listitem.matches('.mm-listitem_opened')
                ? 'closePanel'
                : 'openPanel'](panel);
        }
    };
    /**
     * Display a listitem as being "selected".
     * @param {HTMLElement} listitem Listitem to mark.
     */
    Mmenu.prototype.setSelected = function (listitem) {
        //	Invoke "before" hook.
        this.trigger('setSelected:before', [listitem]);
        //	First, remove the selected class from all listitems.
        __WEBPACK_IMPORTED_MODULE_3__modules_dom__["e" /* find */](this.node.menu, '.mm-listitem_selected').forEach(function (li) {
            li.classList.remove('mm-listitem_selected');
        });
        //	Next, add the selected class to the provided listitem.
        listitem.classList.add('mm-listitem_selected');
        //	Invoke "after" hook.
        this.trigger('setSelected:after', [listitem]);
    };
    /**
     * Bind functions to a hook (subscriber).
     * @param {string} 		hook The hook.
     * @param {function} 	func The function.
     */
    Mmenu.prototype.bind = function (hook, func) {
        //	Create an array for the hook if it does not yet excist.
        this.hook[hook] = this.hook[hook] || [];
        //	Push the function to the array.
        this.hook[hook].push(func);
    };
    /**
     * Invoke the functions bound to a hook (publisher).
     * @param {string} 	hook  	The hook.
     * @param {array}	[args] 	Arguments for the function.
     */
    Mmenu.prototype.trigger = function (hook, args) {
        if (this.hook[hook]) {
            for (var h = 0, l = this.hook[hook].length; h < l; h++) {
                this.hook[hook][h].apply(this, args);
            }
        }
    };
    /**
     * Create the API.
     */
    Mmenu.prototype._initAPI = function () {
        var _this = this;
        //	We need this=that because:
        //	1) the "arguments" object can not be referenced in an arrow function in ES3 and ES5.
        var that = this;
        this.API = {};
        this._api.forEach(function (fn) {
            _this.API[fn] = function () {
                var re = that[fn].apply(that, arguments); // 1)
                return typeof re == 'undefined' ? that.API : re;
            };
        });
        //	Store the API in the HTML node for external usage.
        this.node.menu['mmApi'] = this.API;
    };
    /**
     * Bind the hooks specified in the options (publisher).
     */
    Mmenu.prototype._initHooks = function () {
        for (var hook in this.opts.hooks) {
            this.bind(hook, this.opts.hooks[hook]);
        }
    };
    /**
     * Initialize the wrappers specified in the options.
     */
    Mmenu.prototype._initWrappers = function () {
        //	Invoke "before" hook.
        this.trigger('initWrappers:before');
        for (var w = 0; w < this.opts.wrappers.length; w++) {
            var wrpr = Mmenu.wrappers[this.opts.wrappers[w]];
            if (typeof wrpr == 'function') {
                wrpr.call(this);
            }
        }
        //	Invoke "after" hook.
        this.trigger('initWrappers:after');
    };
    /**
     * Initialize all available add-ons.
     */
    Mmenu.prototype._initAddons = function () {
        //	Invoke "before" hook.
        this.trigger('initAddons:before');
        for (var addon in Mmenu.addons) {
            Mmenu.addons[addon].call(this);
        }
        //	Invoke "after" hook.
        this.trigger('initAddons:after');
    };
    /**
     * Initialize the extensions specified in the options.
     */
    Mmenu.prototype._initExtensions = function () {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger('initExtensions:before');
        //	Convert array to object with array.
        if (Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["e" /* type */])(this.opts.extensions) == 'array') {
            this.opts.extensions = {
                all: this.opts.extensions,
            };
        }
        //	Loop over object.
        Object.keys(this.opts.extensions).forEach(function (query) {
            var classnames = _this.opts.extensions[query].map(function (extension) { return 'mm-menu_' + extension; });
            if (classnames.length) {
                __WEBPACK_IMPORTED_MODULE_5__modules_matchmedia__["a" /* add */](query, function () {
                    //  IE11:
                    classnames.forEach(function (classname) {
                        _this.node.menu.classList.add(classname);
                    });
                    //  Better browsers:
                    // this.node.menu.classList.add(...classnames);
                }, function () {
                    //  IE11:
                    classnames.forEach(function (classname) {
                        _this.node.menu.classList.remove(classname);
                    });
                    //  Better browsers:
                    // this.node.menu.classList.remove(...classnames);
                });
            }
        });
        //	Invoke "after" hook.
        this.trigger('initExtensions:after');
    };
    /**
     * Initialize the menu.
     */
    Mmenu.prototype._initMenu = function () {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger('initMenu:before');
        //	Add class to the wrapper.
        this.node.wrpr = this.node.wrpr || this.node.menu.parentElement;
        this.node.wrpr.classList.add('mm-wrapper');
        //	Add an ID to the menu if it does not yet have one.
        this.node.menu.id = this.node.menu.id || Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["f" /* uniqueId */])();
        //	Wrap the panels in a node.
        var panels = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('div.mm-panels');
        __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](this.node.menu).forEach(function (panel) {
            if (_this.conf.panelNodetype.indexOf(panel.nodeName.toLowerCase()) >
                -1) {
                panels.append(panel);
            }
        });
        this.node.menu.append(panels);
        this.node.pnls = panels;
        //	Add class to the menu.
        this.node.menu.classList.add('mm-menu');
        //	Invoke "after" hook.
        this.trigger('initMenu:after');
    };
    /**
     * Initialize panels.
     */
    Mmenu.prototype._initPanels = function () {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger('initPanels:before');
        //	Open / close panels.
        this.clck.push(function (anchor, args) {
            if (args.inMenu) {
                var href = anchor.getAttribute('href');
                if (href && href.length > 1 && href.slice(0, 1) == '#') {
                    try {
                        var panel = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["e" /* find */](_this.node.menu, href)[0];
                        if (panel && panel.matches('.mm-panel')) {
                            if (anchor.parentElement.matches('.mm-listitem_vertical')) {
                                _this.togglePanel(panel);
                            }
                            else {
                                _this.openPanel(panel);
                            }
                            return true;
                        }
                    }
                    catch (err) { }
                }
            }
        });
        /** The panels to initiate */
        var panels = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](this.node.pnls);
        panels.forEach(function (panel) {
            _this.initPanel(panel);
        });
        //	Invoke "after" hook.
        this.trigger('initPanels:after');
    };
    /**
     * Initialize a single panel and its children.
     * @param {HTMLElement} panel The panel to initialize.
     */
    Mmenu.prototype.initPanel = function (panel) {
        var _this = this;
        /** Query selector for possible node-types for panels. */
        var panelNodetype = this.conf.panelNodetype.join(', ');
        if (panel.matches(panelNodetype)) {
            //  Only once
            if (!panel.matches('.mm-panel')) {
                panel = this._initPanel(panel);
            }
            if (panel) {
                /** The sub panels. */
                var children_1 = [];
                //	Find panel > panel
                children_1.push.apply(children_1, __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](panel, '.' + this.conf.classNames.panel));
                //	Find panel listitem > panel
                __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](panel, '.mm-listview').forEach(function (listview) {
                    __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](listview, '.mm-listitem').forEach(function (listitem) {
                        children_1.push.apply(children_1, __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](listitem, panelNodetype));
                    });
                });
                //  Initiate subpanel(s).
                children_1.forEach(function (child) {
                    _this.initPanel(child);
                });
            }
        }
    };
    /**
     * Initialize a single panel.
     * @param  {HTMLElement} 		panel 	Panel to initialize.
     * @return {HTMLElement|null} 			Initialized panel.
     */
    Mmenu.prototype._initPanel = function (panel) {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger('initPanel:before', [panel]);
        //	Refactor panel classnames
        __WEBPACK_IMPORTED_MODULE_3__modules_dom__["i" /* reClass */](panel, this.conf.classNames.panel, 'mm-panel');
        __WEBPACK_IMPORTED_MODULE_3__modules_dom__["i" /* reClass */](panel, this.conf.classNames.nopanel, 'mm-nopanel');
        __WEBPACK_IMPORTED_MODULE_3__modules_dom__["i" /* reClass */](panel, this.conf.classNames.inset, 'mm-listview_inset');
        if (panel.matches('.mm-listview_inset')) {
            panel.classList.add('mm-nopanel');
        }
        //	Stop if not supposed to be a panel.
        if (panel.matches('.mm-nopanel')) {
            return null;
        }
        /** The original ID on the node. */
        var id = panel.id || Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["f" /* uniqueId */])();
        //  Vertical panel.
        var vertical = panel.matches('.' + this.conf.classNames.vertical) ||
            !this.opts.slidingSubmenus;
        panel.classList.remove(this.conf.classNames.vertical);
        //	Wrap UL/OL in DIV
        if (panel.matches('ul, ol')) {
            panel.removeAttribute('id');
            /** The panel. */
            var wrapper = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('div');
            //	Wrap the listview in the panel.
            panel.before(wrapper);
            wrapper.append(panel);
            panel = wrapper;
        }
        panel.id = id;
        panel.classList.add('mm-panel');
        panel.classList.add('mm-hidden');
        /** The parent listitem. */
        var parent = [panel.parentElement].filter(function (listitem) {
            return listitem.matches('li');
        })[0];
        if (vertical) {
            if (parent) {
                parent.classList.add('mm-listitem_vertical');
            }
        }
        else {
            this.node.pnls.append(panel);
        }
        if (parent) {
            //	Store parent/child relation.
            parent['mmChild'] = panel;
            panel['mmParent'] = parent;
            //	Add open link to parent listitem
            if (parent && parent.matches('.mm-listitem')) {
                if (!__WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](parent, '.mm-btn').length) {
                    /** The text node. */
                    var item = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](parent, '.mm-listitem__text')[0];
                    if (item) {
                        /** The open link. */
                        var button = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('a.mm-btn.mm-btn_next.mm-listitem__btn');
                        button.setAttribute('href', '#' + panel.id);
                        //  If the item has no link,
                        //      Replace the item with the open link.
                        if (item.matches('span')) {
                            button.classList.add('mm-listitem__text');
                            button.innerHTML = item.innerHTML;
                            parent.insertBefore(button, item.nextElementSibling);
                            item.remove();
                        }
                        //  Otherwise, insert the button after the text.
                        else {
                            parent.insertBefore(button, __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](parent, '.mm-panel')[0]);
                        }
                    }
                }
            }
        }
        this._initNavbar(panel);
        __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](panel, 'ul, ol').forEach(function (listview) {
            _this.initListview(listview);
        });
        //	Invoke "after" hook.
        this.trigger('initPanel:after', [panel]);
        return panel;
    };
    /**
     * Initialize a navbar.
     * @param {HTMLElement} panel Panel for the navbar.
     */
    Mmenu.prototype._initNavbar = function (panel) {
        //	Invoke "before" hook.
        this.trigger('initNavbar:before', [panel]);
        //	Only one navbar per panel.
        if (__WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](panel, '.mm-navbar').length) {
            return;
        }
        /** The parent listitem. */
        var parentListitem = null;
        /** The parent panel. */
        var parentPanel = null;
        //  The parent panel was specified in the data-mm-parent attribute.
        if (panel.getAttribute('data-mm-parent')) {
            parentPanel = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["e" /* find */](this.node.pnls, panel.getAttribute('data-mm-parent'))[0];
        }
        // if (panel.dataset.mmParent) { // IE10 has no dataset
        // parentPanel = DOM.find(this.node.pnls, panel.dataset.mmParent)[0];
        // }
        //  The parent panel from a listitem.
        else {
            parentListitem = panel['mmParent'];
            if (parentListitem) {
                parentPanel = parentListitem.closest('.mm-panel');
            }
        }
        //  No navbar needed for vertical submenus.
        if (parentListitem && parentListitem.matches('.mm-listitem_vertical')) {
            return;
        }
        /** The navbar element. */
        var navbar = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('div.mm-navbar');
        //  Hide navbar if specified in options.
        if (!this.opts.navbar.add) {
            navbar.classList.add('mm-hidden');
        }
        //  Sticky navbars.
        else if (this.opts.navbar.sticky) {
            navbar.classList.add('mm-navbar_sticky');
        }
        //  Add the back button.
        if (parentPanel) {
            /** The back button. */
            var prev = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('a.mm-btn.mm-btn_prev.mm-navbar__btn');
            prev.setAttribute('href', '#' + parentPanel.id);
            navbar.append(prev);
        }
        /** The anchor that opens the panel. */
        var opener = null;
        //  The anchor is in a listitem.
        if (parentListitem) {
            opener = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](parentListitem, '.mm-listitem__text')[0];
        }
        //  The anchor is in a panel.
        else if (parentPanel) {
            opener = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["e" /* find */](parentPanel, 'a[href="#' + panel.id + '"]')[0];
        }
        //  Add the title.
        var title = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('a.mm-navbar__title');
        var titleText = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('span');
        title.append(titleText);
        titleText.innerHTML =
            // panel.dataset.mmTitle || // IE10 has no dataset :(
            panel.getAttribute('data-mm-title') ||
                (opener ? opener.textContent : '') ||
                this.i18n(this.opts.navbar.title) ||
                this.i18n('Menu');
        switch (this.opts.navbar.titleLink) {
            case 'anchor':
                if (opener) {
                    title.setAttribute('href', opener.getAttribute('href'));
                }
                break;
            case 'parent':
                if (parentPanel) {
                    title.setAttribute('href', '#' + parentPanel.id);
                }
                break;
        }
        navbar.append(title);
        panel.prepend(navbar);
        //	Invoke "after" hook.
        this.trigger('initNavbar:after', [panel]);
    };
    /**
     * Initialize a listview.
     * @param {HTMLElement} listview Listview to initialize.
     */
    Mmenu.prototype.initListview = function (listview) {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger('initListview:before', [listview]);
        __WEBPACK_IMPORTED_MODULE_3__modules_dom__["i" /* reClass */](listview, this.conf.classNames.nolistview, 'mm-nolistview');
        if (!listview.matches('.mm-nolistview')) {
            listview.classList.add('mm-listview');
            __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](listview).forEach(function (listitem) {
                listitem.classList.add('mm-listitem');
                __WEBPACK_IMPORTED_MODULE_3__modules_dom__["i" /* reClass */](listitem, _this.conf.classNames.selected, 'mm-listitem_selected');
                __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](listitem, 'a, span').forEach(function (item) {
                    if (!item.matches('.mm-btn')) {
                        item.classList.add('mm-listitem__text');
                    }
                });
            });
        }
        //	Invoke "after" hook.
        this.trigger('initListview:after', [listview]);
    };
    /**
     * Find and open the correct panel after creating the menu.
     */
    Mmenu.prototype._initOpened = function () {
        //	Invoke "before" hook.
        this.trigger('initOpened:before');
        /** The selected listitem(s). */
        var listitems = this.node.pnls.querySelectorAll('.mm-listitem_selected');
        /** The last selected listitem. */
        var lastitem = null;
        //	Deselect the listitems.
        listitems.forEach(function (listitem) {
            lastitem = listitem;
            listitem.classList.remove('mm-listitem_selected');
        });
        //	Re-select the last listitem.
        if (lastitem) {
            lastitem.classList.add('mm-listitem_selected');
        }
        /**	The current opened panel. */
        var current = lastitem
            ? lastitem.closest('.mm-panel')
            : __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](this.node.pnls, '.mm-panel')[0];
        //	Open the current opened panel.
        this.openPanel(current, false);
        //	Invoke "after" hook.
        this.trigger('initOpened:after');
    };
    /**
     * Initialize anchors in / for the menu.
     */
    Mmenu.prototype._initAnchors = function () {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger('initAnchors:before');
        document.addEventListener('click', function (evnt) {
            /** The clicked element. */
            var target = evnt.target.closest('a[href]');
            if (!target) {
                return;
            }
            /** Arguments passed to the bound methods. */
            var args = {
                inMenu: target.closest('.mm-menu') === _this.node.menu,
                inListview: target.matches('.mm-listitem > a'),
                toExternal: target.matches('[rel="external"]') ||
                    target.matches('[target="_blank"]'),
            };
            var onClick = {
                close: null,
                setSelected: null,
                preventDefault: target.getAttribute('href').slice(0, 1) == '#',
            };
            //	Find hooked behavior.
            for (var c = 0; c < _this.clck.length; c++) {
                var click = _this.clck[c].call(_this, target, args);
                if (click) {
                    if (typeof click == 'boolean') {
                        evnt.preventDefault();
                        return;
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["e" /* type */])(click) == 'object') {
                        onClick = Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["a" /* extend */])(click, onClick);
                    }
                }
            }
            //	Default behavior for anchors in lists.
            if (args.inMenu && args.inListview && !args.toExternal) {
                //	Set selected item, Default: true
                if (Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["g" /* valueOrFn */])(target, _this.opts.onClick.setSelected, onClick.setSelected)) {
                    _this.setSelected(target.parentElement);
                }
                //	Prevent default / don't follow link. Default: false.
                if (Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["g" /* valueOrFn */])(target, _this.opts.onClick.preventDefault, onClick.preventDefault)) {
                    evnt.preventDefault();
                }
                //	Close menu. Default: false
                if (Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["g" /* valueOrFn */])(target, _this.opts.onClick.close, onClick.close)) {
                    if (_this.opts.offCanvas &&
                        typeof _this.close == 'function') {
                        _this.close();
                    }
                }
            }
        }, true);
        //	Invoke "after" hook.
        this.trigger('initAnchors:after');
    };
    /**
     * Get the translation for a text.
     * @param  {string} text 	Text to translate.
     * @return {string}			The translated text.
     */
    Mmenu.prototype.i18n = function (text) {
        return __WEBPACK_IMPORTED_MODULE_4__modules_i18n__["b" /* get */](text, this.conf.language);
    };
    /**	Default options for menus. */
    Mmenu.options = __WEBPACK_IMPORTED_MODULE_0__options__["a" /* default */];
    /**	Default configuration for menus. */
    Mmenu.configs = __WEBPACK_IMPORTED_MODULE_1__configs__["a" /* default */];
    /**	Available add-ons for the plugin. */
    Mmenu.addons = {};
    /** Available wrappers for the plugin. */
    Mmenu.wrappers = {};
    /**	Globally used HTML elements. */
    Mmenu.node = {};
    /** Globally used variables. */
    Mmenu.vars = {};
    return Mmenu;
}());
/* harmony default export */ __webpack_exports__["a"] = (Mmenu);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(68)('wks');
var uid = __webpack_require__(52);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(37);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extend;
/* harmony export (immutable) */ __webpack_exports__["c"] = touchDirection;
/* harmony export (immutable) */ __webpack_exports__["e"] = type;
/* harmony export (immutable) */ __webpack_exports__["g"] = valueOrFn;
/* harmony export (immutable) */ __webpack_exports__["d"] = transitionend;
/* harmony export (immutable) */ __webpack_exports__["f"] = uniqueId;
/* harmony export (immutable) */ __webpack_exports__["b"] = originalId;
/**
 * Deep extend an object with the given defaults.
 * Note that the extended object is not a clone, meaning the original object will also be updated.
 *
 * @param 	{object}	orignl	The object to extend to.
 * @param 	{object}	dfault	The object to extend from.
 * @return	{object}			The extended "orignl" object.
 */
function extend(orignl, dfault) {
    if (type(orignl) != 'object') {
        orignl = {};
    }
    if (type(dfault) != 'object') {
        dfault = {};
    }
    for (var k in dfault) {
        if (!dfault.hasOwnProperty(k)) {
            continue;
        }
        if (typeof orignl[k] == 'undefined') {
            orignl[k] = dfault[k];
        }
        else if (type(orignl[k]) == 'object') {
            extend(orignl[k], dfault[k]);
        }
    }
    return orignl;
}
/**
 * Detect the touch / dragging direction on a touch device.
 *
 * @param   {HTMLElement} surface   The element to monitor for touch events.
 * @return  {object}                Object with "get" function.
 */
function touchDirection(surface) {
    var direction = '';
    surface.addEventListener('touchmove', function (evnt) {
        direction = '';
        if (evnt.movementY > 0) {
            direction = 'down';
        }
        else if (evnt.movementY < 0) {
            direction = 'up';
        }
    });
    return {
        get: function () { return direction; }
    };
}
/**
 * Get the type of any given variable. Improvement of "typeof".
 *
 * @param 	{any}		variable	The variable.
 * @return	{string}				The type of the variable in lowercase.
 */
function type(variable) {
    return {}.toString
        .call(variable)
        .match(/\s([a-zA-Z]+)/)[1]
        .toLowerCase();
}
/**
 * Find the value from an option or function.
 * @param 	{HTMLElement} 	element 	Scope for the function.
 * @param 	{any} 			[option] 	Value or function.
 * @param 	{any} 			[dfault] 	Default fallback value.
 * @return	{any}						The given evaluation of the given option, or the default fallback value.
 */
function valueOrFn(element, option, dfault) {
    if (typeof option == 'function') {
        var value = option.call(element);
        if (typeof value != 'undefined') {
            return value;
        }
    }
    if ((option === null ||
        typeof option == 'function' ||
        typeof option == 'undefined') &&
        typeof dfault != 'undefined') {
        return dfault;
    }
    return option;
}
/**
 * Set and invoke a (single) transition-end function with fallback.
 *
 * @param {HTMLElement} 	element 	Scope for the function.
 * @param {function}		func		Function to invoke.
 * @param {number}			duration	The duration of the animation (for the fallback).
 */
function transitionend(element, func, duration) {
    var _ended = false, _fn = function (evnt) {
        if (typeof evnt !== 'undefined') {
            if (evnt.target !== element) {
                return;
            }
        }
        if (!_ended) {
            element.removeEventListener('transitionend', _fn);
            element.removeEventListener('webkitTransitionEnd', _fn);
            func.call(element);
        }
        _ended = true;
    };
    element.addEventListener('transitionend', _fn);
    element.addEventListener('webkitTransitionEnd', _fn);
    setTimeout(_fn, duration * 1.1);
}
/**
 * Get a (page wide) unique ID.
 */
function uniqueId() {
    return 'mm-' + __id++;
}
var __id = 0;
/**
 * Get the original ID from a possibly prefixed ID.
 * @param id The possibly prefixed ID.
 */
function originalId(id) {
    if (id.slice(0, 3) == 'mm-') {
        return id.slice(3);
    }
    return id;
}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var IE8_DOM_DEFINE = __webpack_require__(146);
var toPrimitive = __webpack_require__(40);
var dP = Object.defineProperty;

exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(41);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_EndPoints__ = __webpack_require__(590);



var securityAuth = wpvue_script_data_params.data.site_data.enable_api_auth_secret;
var securityAuthCode = wpvue_script_data_params.data.site_data.api_auth_secret;
var getHomePage = "";
var getNavLinks = "";
var getFooter = "";
var getBody = "";
var getArchive = "";
var getHomepagewithscroll = "";
var getSearchResult = "";
var userArticleVote = "";
var getPreview = "";
var get404Body = "";

if (securityAuth) {
  getHomePage = function getHomePage(country, state, userId, preview) {
    if (preview) {
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].HomePage).concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&preview=true&secret_key=").concat(securityAuthCode));
    } else {
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].HomePage).concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&secret_key=").concat(securityAuthCode));
    }
  };

  getHomepagewithscroll = function getHomepagewithscroll(country, state, userId, preview) {
    if (preview) {
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].HomePage).concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&preview=true&secret_key=").concat(securityAuthCode, "&scroll=true"));
    } else {
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].HomePage).concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&secret_key=").concat(securityAuthCode, "&scroll=true"));
    }
  };

  getNavLinks = function getNavLinks(country, state) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].NavLinks).concat(country, "&state=").concat(state, "&secret_key=").concat(securityAuthCode));
  };

  getFooter = function getFooter(country, state) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Footer, "/?country=").concat(country, "&state=").concat(state, "&secret_key=").concat(securityAuthCode));
  };

  getBody = function getBody(country, state, slug, userId) {
    var castoplist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var castoplistValue = '';

    for (var _i = 0, _Object$entries = Object.entries(castoplist); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      castoplistValue = castoplistValue + '&' + key + '=' + value;
    }

    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Body).concat(slug, "&country=").concat(country, "&state=").concat(state, "&user_id=").concat(userId).concat(castoplistValue, "&secret_key=").concat(securityAuthCode));
  };

  getArchive = function getArchive(country, state, archive, page, sortOrder, userId, term) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Archive, "?archive=").concat(archive, "&country=").concat(country, "&state=").concat(state, "&orderby=title&order=").concat(sortOrder, "&page=").concat(page, "&user_id=").concat(userId, "&term=").concat(term, "&secret_key=").concat(securityAuthCode));
  };

  getSearchResult = function getSearchResult(country, state, text, page, sortOrder, userId, orderBy) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].post("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Search).concat(text, "&country=").concat(country, "&state=").concat(state, "&orderby=").concat(orderBy || 'relevance', "&order=").concat(sortOrder, "&page=").concat(page, "&user_id=").concat(userId, "&secret_key=").concat(securityAuthCode));
  };

  userArticleVote = function userArticleVote(country, state, slug, userId, vote) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].ArticleVote).concat(slug, "&country=").concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&vote=").concat(vote, "&secret_key=").concat(securityAuthCode));
  };

  getPreview = function getPreview(country, state, slug, userId) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Body).concat(slug, "&country=").concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&preview=true&secret_key=").concat(securityAuthCode));
  }; //404 edit


  get404Body = function get404Body(country, state, slug, userId) {
    var castoplist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var body404Data = {
      'resource_id': slug,
      'country': country,
      'state': state,
      'user_id': userId,
      'secret_key': securityAuthCode
    }; // return HttpClient.post(`${END_POINT.Body}${slug}`, body404Data)

    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Body).concat(slug, "&") + Object.keys(body404Data).filter(function (i) {
      return i !== "resource_id";
    }).map(function (key) {
      return "".concat(key, "=").concat(body404Data[key]);
    }).join("&"));
  }; //get404Body = (country, state, slug, userId) => HttpClient.post(`${END_POINT.Body}${slug}&country=${country}&state=${state}&user_id=${userId}&secret_key=${securityAuthCode}`)

} else {
  getHomePage = function getHomePage(country, state, userId, preview) {
    if (preview) {
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].HomePage).concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&preview=true"));
    } else {
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].HomePage).concat(country, "&state=").concat(state, "&user_id=").concat(userId));
    }
  };

  getHomepagewithscroll = function getHomepagewithscroll(country, state, userId, preview) {
    if (preview) {
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].HomePage).concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&preview=true&scroll=true"));
    } else {
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].HomePage).concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&scroll=true"));
    }
  };

  getNavLinks = function getNavLinks(country, state) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].NavLinks).concat(country, "&state=").concat(state));
  };

  getFooter = function getFooter(country, state) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Footer, "/?country=").concat(country, "&state=").concat(state));
  };

  getBody = function getBody(country, state, slug, userId) {
    var castoplist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var castoplistValue = '';

    for (var _i2 = 0, _Object$entries2 = Object.entries(castoplist); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_Object$entries2[_i2], 2),
          key = _Object$entries2$_i[0],
          value = _Object$entries2$_i[1];

      castoplistValue = castoplistValue + '&' + key + '=' + value;
    }

    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Body).concat(slug, "&country=").concat(country, "&state=").concat(state, "&user_id=").concat(userId).concat(castoplistValue)); // let bodyData = {
    //     'resource_id': slug,
    //     'country': country,
    //     'state': state,
    //     'user_id': userId,
    //     ...castoplist
    // }
    // return HttpClient.post(`${END_POINT.Body}${slug}`, bodyData)
  };

  getArchive = function getArchive(country, state, archive, page, sortOrder, userId, term) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Archive, "?archive=").concat(archive, "&country=").concat(country, "&state=").concat(state, "&orderby=title&order=").concat(sortOrder, "&page=").concat(page, "&user_id=").concat(userId, "&term=").concat(term));
  }; //Search api need to be done as post method


  getSearchResult = function getSearchResult(country, state, text, page, sortOrder, userId, orderBy) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].post("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Search).concat(text, "&country=").concat(country, "&state=").concat(state, "&orderby=").concat(orderBy || 'relevance', "&order=").concat(sortOrder, "&page=").concat(page, "&user_id=").concat(userId));
  };

  userArticleVote = function userArticleVote(country, state, slug, userId, vote) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].ArticleVote).concat(slug, "&country=").concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&vote=").concat(vote));
  };

  getPreview = function getPreview(country, state, slug, userId) {
    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Body).concat(slug, "&country=").concat(country, "&state=").concat(state, "&user_id=").concat(userId, "&preview=true"));
  }; //404 edit


  get404Body = function get404Body(country, state, slug, userId) {
    var castoplist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var body404Data = {
      'resource_id': slug,
      'country': country,
      'state': state,
      'user_id': userId
    }; // return HttpClient.post(`${END_POINT.Body}${slug}`, body404Data)

    return __WEBPACK_IMPORTED_MODULE_1__api_HttpClient__["a" /* default */].get("".concat(__WEBPACK_IMPORTED_MODULE_2__api_EndPoints__["a" /* default */].Body).concat(slug, "&") + Object.keys(body404Data).filter(function (i) {
      return i !== "resource_id";
    }).map(function (key) {
      return "".concat(key, "=").concat(body404Data[key]);
    }).join("&"));
  }; //get404Body = (country, state, slug, userId) => HttpClient.get(`${END_POINT.Body}${slug}&country=${country}&state=${state}&user_id=${userId}&preview=1`)

}

var HttpService = {
  getHomePage: getHomePage,
  getNavLinks: getNavLinks,
  getFooter: getFooter,
  getBody: getBody,
  getArchive: getArchive,
  getHomepagewithscroll: getHomepagewithscroll,
  getSearchResult: getSearchResult,
  userArticleVote: userArticleVote,
  getPreview: getPreview,
  get404Body: get404Body
};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abfab7e0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(601);
function injectStyle (ssrContext) {
  __webpack_require__(599)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-abfab7e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abfab7e0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomComponent_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad9a36c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomComponent_vue__ = __webpack_require__(591);
function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ad9a36c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad9a36c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return metaChanger; });
var metaChanger = function metaChanger(metaTags) {
  metaTags.forEach(function (element) {
    if (element.name && element.name != 'title') {
      if (document.querySelector("meta[name='".concat(element.name, "']"))) {
        document.querySelector("meta[name='".concat(element.name, "']")).setAttribute('content', element.content ? unescapeHtml(element.content) : element.content);
      } else {
        var tag = document.createElement('meta');
        Object.keys(element).forEach(function (key) {
          tag.setAttribute(key, element[key] ? unescapeHtml(element[key]) : element[key]);
        });
        document.head.appendChild(tag);
      }
    }

    if (element.property) {
      if (document.querySelector("meta[property='".concat(element.property, "']"))) {
        document.querySelector("meta[property='".concat(element.property, "']")).setAttribute('content', element.content ? unescapeHtml(element.content) : element.content);
      } else {
        var _tag = document.createElement('meta');

        Object.keys(element).forEach(function (key) {
          _tag.setAttribute(key, element[key] ? unescapeHtml(element[key]) : element[key]);
        });
        document.head.appendChild(_tag);
      }
    }
  });
};

var unescapeHtml = function unescapeHtml(text) {
  var specialchars = [['–', '&ndash;'], ['—', '&mdash;'], ['·', '&middot;'], ['•', '&bull;'], ['⋆', '&#8902;'], ['«', '&laquo;'], ['»', '&raquo;'], ['<', '&lt;'], ['>', '&gt;']];

  if (!text) {
    return text;
  }

  var unescapedString = text; // For each of the special characters,

  var len = specialchars.length;

  for (var x = 0; x < len; x++) {
    // Replace all instances of the special character with its entity.
    unescapedString = unescapedString.replace(new RegExp(specialchars[x][1], 'g'), specialchars[x][0]);
  }

  return unescapedString;
};



/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg width='14' height='10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.602.449c.447.432.447 1.13 0 1.561L6.169 9.19a1.161 1.161 0 01-.809.324c-.292 0-.585-.109-.808-.324L.835 5.599a1.076 1.076 0 010-1.56 1.17 1.17 0 011.617 0L5.36 6.846 11.985.449a1.17 1.17 0 011.617 0z' fill='%23fff'/%3E%3C/svg%3E"

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(242);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_022e2682_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(642);
function injectStyle (ssrContext) {
  __webpack_require__(640)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-022e2682"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_022e2682_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedLinks_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f27e3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatedLinks_vue__ = __webpack_require__(604);
function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72f27e3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f27e3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatedLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15);
var createDesc = __webpack_require__(51);
module.exports = __webpack_require__(14) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(25);
var has = __webpack_require__(29);
var SRC = __webpack_require__(52)('src');
var $toString = __webpack_require__(271);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(34).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(7);
var defined = __webpack_require__(41);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(219);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(69);
var defined = __webpack_require__(41);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(70);
var createDesc = __webpack_require__(51);
var toIObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(40);
var has = __webpack_require__(29);
var IE8_DOM_DEFINE = __webpack_require__(146);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(14) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(29);
var toObject = __webpack_require__(16);
var IE_PROTO = __webpack_require__(113)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(21);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StarRating_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08056de9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StarRating_vue__ = __webpack_require__(612);
function injectStyle (ssrContext) {
  __webpack_require__(610)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08056de9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StarRating_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08056de9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StarRating_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(8);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(34);
var fails = __webpack_require__(7);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(35);
var IObject = __webpack_require__(69);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(12);
var asc = __webpack_require__(129);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(14)) {
  var LIBRARY = __webpack_require__(48);
  var global = __webpack_require__(5);
  var fails = __webpack_require__(7);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(90);
  var $buffer = __webpack_require__(137);
  var ctx = __webpack_require__(35);
  var anInstance = __webpack_require__(58);
  var propertyDesc = __webpack_require__(51);
  var hide = __webpack_require__(25);
  var redefineAll = __webpack_require__(60);
  var toInteger = __webpack_require__(37);
  var toLength = __webpack_require__(12);
  var toIndex = __webpack_require__(174);
  var toAbsoluteIndex = __webpack_require__(54);
  var toPrimitive = __webpack_require__(40);
  var has = __webpack_require__(29);
  var classof = __webpack_require__(64);
  var isObject = __webpack_require__(8);
  var toObject = __webpack_require__(16);
  var isArrayIter = __webpack_require__(126);
  var create = __webpack_require__(55);
  var getPrototypeOf = __webpack_require__(32);
  var gOPN = __webpack_require__(56).f;
  var getIterFn = __webpack_require__(128);
  var uid = __webpack_require__(52);
  var wks = __webpack_require__(11);
  var createArrayMethod = __webpack_require__(43);
  var createArrayIncludes = __webpack_require__(80);
  var speciesConstructor = __webpack_require__(72);
  var ArrayIterators = __webpack_require__(131);
  var Iterators = __webpack_require__(66);
  var $iterDetect = __webpack_require__(85);
  var setSpecies = __webpack_require__(57);
  var arrayFill = __webpack_require__(130);
  var arrayCopyWithin = __webpack_require__(163);
  var $DP = __webpack_require__(15);
  var $GOPD = __webpack_require__(31);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(169);
var $export = __webpack_require__(0);
var shared = __webpack_require__(68)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(172))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var symbols = {
  "USD": {
    "symbol": "$",
    "name": "US Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USD",
    "name_plural": "US dollars"
  },
  "CAD": {
    "symbol": "CA$",
    "name": "Canadian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CAD",
    "name_plural": "Canadian dollars"
  },
  "EUR": {
    "symbol": "€",
    "name": "Euro",
    "symbol_native": "€",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EUR",
    "name_plural": "euros"
  },
  "AED": {
    "symbol": "AED",
    "name": "United Arab Emirates Dirham",
    "symbol_native": "د.إ.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AED",
    "name_plural": "UAE dirhams"
  },
  "AFN": {
    "symbol": "Af",
    "name": "Afghan Afghani",
    "symbol_native": "؋",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AFN",
    "name_plural": "Afghan Afghanis"
  },
  "ALL": {
    "symbol": "ALL",
    "name": "Albanian Lek",
    "symbol_native": "Lek",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ALL",
    "name_plural": "Albanian lekë"
  },
  "AMD": {
    "symbol": "AMD",
    "name": "Armenian Dram",
    "symbol_native": "դր.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AMD",
    "name_plural": "Armenian drams"
  },
  "ARS": {
    "symbol": "AR$",
    "name": "Argentine Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ARS",
    "name_plural": "Argentine pesos"
  },
  "AUD": {
    "symbol": "AU$",
    "name": "Australian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AUD",
    "name_plural": "Australian dollars"
  },
  "AZN": {
    "symbol": "man.",
    "name": "Azerbaijani Manat",
    "symbol_native": "ман.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AZN",
    "name_plural": "Azerbaijani manats"
  },
  "BAM": {
    "symbol": "KM",
    "name": "Bosnia-Herzegovina Convertible Mark",
    "symbol_native": "KM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BAM",
    "name_plural": "Bosnia-Herzegovina convertible marks"
  },
  "BDT": {
    "symbol": "Tk",
    "name": "Bangladeshi Taka",
    "symbol_native": "৳",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BDT",
    "name_plural": "Bangladeshi takas"
  },
  "BGN": {
    "symbol": "BGN",
    "name": "Bulgarian Lev",
    "symbol_native": "лв.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BGN",
    "name_plural": "Bulgarian leva"
  },
  "BHD": {
    "symbol": "BD",
    "name": "Bahraini Dinar",
    "symbol_native": "د.ب.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "BHD",
    "name_plural": "Bahraini dinars"
  },
  "BIF": {
    "symbol": "FBu",
    "name": "Burundian Franc",
    "symbol_native": "FBu",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BIF",
    "name_plural": "Burundian francs"
  },
  "BND": {
    "symbol": "BN$",
    "name": "Brunei Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BND",
    "name_plural": "Brunei dollars"
  },
  "BOB": {
    "symbol": "Bs",
    "name": "Bolivian Boliviano",
    "symbol_native": "Bs",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOB",
    "name_plural": "Bolivian bolivianos"
  },
  "BRL": {
    "symbol": "R$",
    "name": "Brazilian Real",
    "symbol_native": "R$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BRL",
    "name_plural": "Brazilian reals"
  },
  "BWP": {
    "symbol": "BWP",
    "name": "Botswanan Pula",
    "symbol_native": "P",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BWP",
    "name_plural": "Botswanan pulas"
  },
  "BYN": {
    "symbol": "Br",
    "name": "Belarusian Ruble",
    "symbol_native": "руб.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BYN",
    "name_plural": "Belarusian rubles"
  },
  "BZD": {
    "symbol": "BZ$",
    "name": "Belize Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BZD",
    "name_plural": "Belize dollars"
  },
  "CDF": {
    "symbol": "CDF",
    "name": "Congolese Franc",
    "symbol_native": "FrCD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CDF",
    "name_plural": "Congolese francs"
  },
  "CHF": {
    "symbol": "CHF",
    "name": "Swiss Franc",
    "symbol_native": "CHF",
    "decimal_digits": 2,
    "rounding": 0.05,
    "code": "CHF",
    "name_plural": "Swiss francs"
  },
  "CLP": {
    "symbol": "CL$",
    "name": "Chilean Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CLP",
    "name_plural": "Chilean pesos"
  },
  "CNY": {
    "symbol": "CN¥",
    "name": "Chinese Yuan",
    "symbol_native": "CN¥",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CNY",
    "name_plural": "Chinese yuan"
  },
  "COP": {
    "symbol": "CO$",
    "name": "Colombian Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "COP",
    "name_plural": "Colombian pesos"
  },
  "CRC": {
    "symbol": "₡",
    "name": "Costa Rican Colón",
    "symbol_native": "₡",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CRC",
    "name_plural": "Costa Rican colóns"
  },
  "CVE": {
    "symbol": "CV$",
    "name": "Cape Verdean Escudo",
    "symbol_native": "CV$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CVE",
    "name_plural": "Cape Verdean escudos"
  },
  "CZK": {
    "symbol": "Kč",
    "name": "Czech Republic Koruna",
    "symbol_native": "Kč",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CZK",
    "name_plural": "Czech Republic korunas"
  },
  "DJF": {
    "symbol": "Fdj",
    "name": "Djiboutian Franc",
    "symbol_native": "Fdj",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "DJF",
    "name_plural": "Djiboutian francs"
  },
  "DKK": {
    "symbol": "Dkr",
    "name": "Danish Krone",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DKK",
    "name_plural": "Danish kroner"
  },
  "DOP": {
    "symbol": "RD$",
    "name": "Dominican Peso",
    "symbol_native": "RD$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DOP",
    "name_plural": "Dominican pesos"
  },
  "DZD": {
    "symbol": "DA",
    "name": "Algerian Dinar",
    "symbol_native": "د.ج.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DZD",
    "name_plural": "Algerian dinars"
  },
  "EEK": {
    "symbol": "Ekr",
    "name": "Estonian Kroon",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EEK",
    "name_plural": "Estonian kroons"
  },
  "EGP": {
    "symbol": "EGP",
    "name": "Egyptian Pound",
    "symbol_native": "ج.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EGP",
    "name_plural": "Egyptian pounds"
  },
  "ERN": {
    "symbol": "Nfk",
    "name": "Eritrean Nakfa",
    "symbol_native": "Nfk",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ERN",
    "name_plural": "Eritrean nakfas"
  },
  "ETB": {
    "symbol": "Br",
    "name": "Ethiopian Birr",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ETB",
    "name_plural": "Ethiopian birrs"
  },
  "GBP": {
    "symbol": "£",
    "name": "British Pound Sterling",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GBP",
    "name_plural": "British pounds sterling"
  },
  "GEL": {
    "symbol": "GEL",
    "name": "Georgian Lari",
    "symbol_native": "GEL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GEL",
    "name_plural": "Georgian laris"
  },
  "GHS": {
    "symbol": "GH₵",
    "name": "Ghanaian Cedi",
    "symbol_native": "GH₵",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GHS",
    "name_plural": "Ghanaian cedis"
  },
  "GNF": {
    "symbol": "FG",
    "name": "Guinean Franc",
    "symbol_native": "FG",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "GNF",
    "name_plural": "Guinean francs"
  },
  "GTQ": {
    "symbol": "GTQ",
    "name": "Guatemalan Quetzal",
    "symbol_native": "Q",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GTQ",
    "name_plural": "Guatemalan quetzals"
  },
  "HKD": {
    "symbol": "HK$",
    "name": "Hong Kong Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HKD",
    "name_plural": "Hong Kong dollars"
  },
  "HNL": {
    "symbol": "HNL",
    "name": "Honduran Lempira",
    "symbol_native": "L",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HNL",
    "name_plural": "Honduran lempiras"
  },
  "HRK": {
    "symbol": "kn",
    "name": "Croatian Kuna",
    "symbol_native": "kn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HRK",
    "name_plural": "Croatian kunas"
  },
  "HUF": {
    "symbol": "Ft",
    "name": "Hungarian Forint",
    "symbol_native": "Ft",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "HUF",
    "name_plural": "Hungarian forints"
  },
  "IDR": {
    "symbol": "Rp",
    "name": "Indonesian Rupiah",
    "symbol_native": "Rp",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IDR",
    "name_plural": "Indonesian rupiahs"
  },
  "ILS": {
    "symbol": "₪",
    "name": "Israeli New Sheqel",
    "symbol_native": "₪",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ILS",
    "name_plural": "Israeli new sheqels"
  },
  "INR": {
    "symbol": "Rs",
    "name": "Indian Rupee",
    "symbol_native": "টকা",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "INR",
    "name_plural": "Indian rupees"
  },
  "IQD": {
    "symbol": "IQD",
    "name": "Iraqi Dinar",
    "symbol_native": "د.ع.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IQD",
    "name_plural": "Iraqi dinars"
  },
  "IRR": {
    "symbol": "IRR",
    "name": "Iranian Rial",
    "symbol_native": "﷼",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IRR",
    "name_plural": "Iranian rials"
  },
  "ISK": {
    "symbol": "Ikr",
    "name": "Icelandic Króna",
    "symbol_native": "kr",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ISK",
    "name_plural": "Icelandic krónur"
  },
  "JMD": {
    "symbol": "J$",
    "name": "Jamaican Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "JMD",
    "name_plural": "Jamaican dollars"
  },
  "JOD": {
    "symbol": "JD",
    "name": "Jordanian Dinar",
    "symbol_native": "د.أ.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "JOD",
    "name_plural": "Jordanian dinars"
  },
  "JPY": {
    "symbol": "¥",
    "name": "Japanese Yen",
    "symbol_native": "￥",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "JPY",
    "name_plural": "Japanese yen"
  },
  "KES": {
    "symbol": "Ksh",
    "name": "Kenyan Shilling",
    "symbol_native": "Ksh",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KES",
    "name_plural": "Kenyan shillings"
  },
  "KHR": {
    "symbol": "KHR",
    "name": "Cambodian Riel",
    "symbol_native": "៛",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KHR",
    "name_plural": "Cambodian riels"
  },
  "KMF": {
    "symbol": "CF",
    "name": "Comorian Franc",
    "symbol_native": "FC",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KMF",
    "name_plural": "Comorian francs"
  },
  "KRW": {
    "symbol": "₩",
    "name": "South Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KRW",
    "name_plural": "South Korean won"
  },
  "KWD": {
    "symbol": "KD",
    "name": "Kuwaiti Dinar",
    "symbol_native": "د.ك.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "KWD",
    "name_plural": "Kuwaiti dinars"
  },
  "KZT": {
    "symbol": "KZT",
    "name": "Kazakhstani Tenge",
    "symbol_native": "тңг.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KZT",
    "name_plural": "Kazakhstani tenges"
  },
  "LBP": {
    "symbol": "LB£",
    "name": "Lebanese Pound",
    "symbol_native": "ل.ل.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "LBP",
    "name_plural": "Lebanese pounds"
  },
  "LKR": {
    "symbol": "SLRs",
    "name": "Sri Lankan Rupee",
    "symbol_native": "SL Re",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LKR",
    "name_plural": "Sri Lankan rupees"
  },
  "LTL": {
    "symbol": "Lt",
    "name": "Lithuanian Litas",
    "symbol_native": "Lt",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LTL",
    "name_plural": "Lithuanian litai"
  },
  "LVL": {
    "symbol": "Ls",
    "name": "Latvian Lats",
    "symbol_native": "Ls",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LVL",
    "name_plural": "Latvian lati"
  },
  "LYD": {
    "symbol": "LD",
    "name": "Libyan Dinar",
    "symbol_native": "د.ل.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "LYD",
    "name_plural": "Libyan dinars"
  },
  "MAD": {
    "symbol": "MAD",
    "name": "Moroccan Dirham",
    "symbol_native": "د.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MAD",
    "name_plural": "Moroccan dirhams"
  },
  "MDL": {
    "symbol": "MDL",
    "name": "Moldovan Leu",
    "symbol_native": "MDL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MDL",
    "name_plural": "Moldovan lei"
  },
  "MGA": {
    "symbol": "MGA",
    "name": "Malagasy Ariary",
    "symbol_native": "MGA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MGA",
    "name_plural": "Malagasy Ariaries"
  },
  "MKD": {
    "symbol": "MKD",
    "name": "Macedonian Denar",
    "symbol_native": "MKD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MKD",
    "name_plural": "Macedonian denari"
  },
  "MMK": {
    "symbol": "MMK",
    "name": "Myanma Kyat",
    "symbol_native": "K",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MMK",
    "name_plural": "Myanma kyats"
  },
  "MOP": {
    "symbol": "MOP$",
    "name": "Macanese Pataca",
    "symbol_native": "MOP$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MOP",
    "name_plural": "Macanese patacas"
  },
  "MUR": {
    "symbol": "MURs",
    "name": "Mauritian Rupee",
    "symbol_native": "MURs",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MUR",
    "name_plural": "Mauritian rupees"
  },
  "MXN": {
    "symbol": "MX$",
    "name": "Mexican Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXN",
    "name_plural": "Mexican pesos"
  },
  "MYR": {
    "symbol": "RM",
    "name": "Malaysian Ringgit",
    "symbol_native": "RM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MYR",
    "name_plural": "Malaysian ringgits"
  },
  "MZN": {
    "symbol": "MTn",
    "name": "Mozambican Metical",
    "symbol_native": "MTn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MZN",
    "name_plural": "Mozambican meticals"
  },
  "NAD": {
    "symbol": "N$",
    "name": "Namibian Dollar",
    "symbol_native": "N$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NAD",
    "name_plural": "Namibian dollars"
  },
  "NGN": {
    "symbol": "₦",
    "name": "Nigerian Naira",
    "symbol_native": "₦",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NGN",
    "name_plural": "Nigerian nairas"
  },
  "NIO": {
    "symbol": "C$",
    "name": "Nicaraguan Córdoba",
    "symbol_native": "C$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NIO",
    "name_plural": "Nicaraguan córdobas"
  },
  "NOK": {
    "symbol": "Nkr",
    "name": "Norwegian Krone",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NOK",
    "name_plural": "Norwegian kroner"
  },
  "NPR": {
    "symbol": "NPRs",
    "name": "Nepalese Rupee",
    "symbol_native": "नेरू",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NPR",
    "name_plural": "Nepalese rupees"
  },
  "NZD": {
    "symbol": "NZ$",
    "name": "New Zealand Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NZD",
    "name_plural": "New Zealand dollars"
  },
  "OMR": {
    "symbol": "OMR",
    "name": "Omani Rial",
    "symbol_native": "ر.ع.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "OMR",
    "name_plural": "Omani rials"
  },
  "PAB": {
    "symbol": "B/.",
    "name": "Panamanian Balboa",
    "symbol_native": "B/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PAB",
    "name_plural": "Panamanian balboas"
  },
  "PEN": {
    "symbol": "S/.",
    "name": "Peruvian Nuevo Sol",
    "symbol_native": "S/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PEN",
    "name_plural": "Peruvian nuevos soles"
  },
  "PHP": {
    "symbol": "₱",
    "name": "Philippine Peso",
    "symbol_native": "₱",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PHP",
    "name_plural": "Philippine pesos"
  },
  "PKR": {
    "symbol": "PKRs",
    "name": "Pakistani Rupee",
    "symbol_native": "₨",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PKR",
    "name_plural": "Pakistani rupees"
  },
  "PLN": {
    "symbol": "zł",
    "name": "Polish Zloty",
    "symbol_native": "zł",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PLN",
    "name_plural": "Polish zlotys"
  },
  "PYG": {
    "symbol": "₲",
    "name": "Paraguayan Guarani",
    "symbol_native": "₲",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PYG",
    "name_plural": "Paraguayan guaranis"
  },
  "QAR": {
    "symbol": "QR",
    "name": "Qatari Rial",
    "symbol_native": "ر.ق.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "QAR",
    "name_plural": "Qatari rials"
  },
  "RON": {
    "symbol": "RON",
    "name": "Romanian Leu",
    "symbol_native": "RON",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RON",
    "name_plural": "Romanian lei"
  },
  "RSD": {
    "symbol": "din.",
    "name": "Serbian Dinar",
    "symbol_native": "дин.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RSD",
    "name_plural": "Serbian dinars"
  },
  "RUB": {
    "symbol": "RUB",
    "name": "Russian Ruble",
    "symbol_native": "₽.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RUB",
    "name_plural": "Russian rubles"
  },
  "RWF": {
    "symbol": "RWF",
    "name": "Rwandan Franc",
    "symbol_native": "FR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RWF",
    "name_plural": "Rwandan francs"
  },
  "SAR": {
    "symbol": "SR",
    "name": "Saudi Riyal",
    "symbol_native": "ر.س.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SAR",
    "name_plural": "Saudi riyals"
  },
  "SDG": {
    "symbol": "SDG",
    "name": "Sudanese Pound",
    "symbol_native": "SDG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SDG",
    "name_plural": "Sudanese pounds"
  },
  "SEK": {
    "symbol": "Skr",
    "name": "Swedish Krona",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SEK",
    "name_plural": "Swedish kronor"
  },
  "SGD": {
    "symbol": "S$",
    "name": "Singapore Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SGD",
    "name_plural": "Singapore dollars"
  },
  "SOS": {
    "symbol": "Ssh",
    "name": "Somali Shilling",
    "symbol_native": "Ssh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SOS",
    "name_plural": "Somali shillings"
  },
  "SYP": {
    "symbol": "SY£",
    "name": "Syrian Pound",
    "symbol_native": "ل.س.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SYP",
    "name_plural": "Syrian pounds"
  },
  "THB": {
    "symbol": "฿",
    "name": "Thai Baht",
    "symbol_native": "฿",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "THB",
    "name_plural": "Thai baht"
  },
  "TND": {
    "symbol": "DT",
    "name": "Tunisian Dinar",
    "symbol_native": "د.ت.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "TND",
    "name_plural": "Tunisian dinars"
  },
  "TOP": {
    "symbol": "T$",
    "name": "Tongan Paʻanga",
    "symbol_native": "T$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TOP",
    "name_plural": "Tongan paʻanga"
  },
  "TRY": {
    "symbol": "TL",
    "name": "Turkish Lira",
    "symbol_native": "TL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TRY",
    "name_plural": "Turkish Lira"
  },
  "TTD": {
    "symbol": "TT$",
    "name": "Trinidad and Tobago Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TTD",
    "name_plural": "Trinidad and Tobago dollars"
  },
  "TWD": {
    "symbol": "NT$",
    "name": "New Taiwan Dollar",
    "symbol_native": "NT$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TWD",
    "name_plural": "New Taiwan dollars"
  },
  "TZS": {
    "symbol": "TSh",
    "name": "Tanzanian Shilling",
    "symbol_native": "TSh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "TZS",
    "name_plural": "Tanzanian shillings"
  },
  "UAH": {
    "symbol": "₴",
    "name": "Ukrainian Hryvnia",
    "symbol_native": "₴",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UAH",
    "name_plural": "Ukrainian hryvnias"
  },
  "UGX": {
    "symbol": "USh",
    "name": "Ugandan Shilling",
    "symbol_native": "USh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UGX",
    "name_plural": "Ugandan shillings"
  },
  "UYU": {
    "symbol": "$U",
    "name": "Uruguayan Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYU",
    "name_plural": "Uruguayan pesos"
  },
  "UZS": {
    "symbol": "UZS",
    "name": "Uzbekistan Som",
    "symbol_native": "UZS",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UZS",
    "name_plural": "Uzbekistan som"
  },
  "VEF": {
    "symbol": "Bs.F.",
    "name": "Venezuelan Bolívar",
    "symbol_native": "Bs.F.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VEF",
    "name_plural": "Venezuelan bolívars"
  },
  "VND": {
    "symbol": "₫",
    "name": "Vietnamese Dong",
    "symbol_native": "₫",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "VND",
    "name_plural": "Vietnamese dong"
  },
  "XAF": {
    "symbol": "FCFA",
    "name": "CFA Franc BEAC",
    "symbol_native": "FCFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XAF",
    "name_plural": "CFA francs BEAC"
  },
  "XOF": {
    "symbol": "CFA",
    "name": "CFA Franc BCEAO",
    "symbol_native": "CFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XOF",
    "name_plural": "CFA francs BCEAO"
  },
  "YER": {
    "symbol": "YR",
    "name": "Yemeni Rial",
    "symbol_native": "ر.ي.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "YER",
    "name_plural": "Yemeni rials"
  },
  "ZAR": {
    "symbol": "R",
    "name": "South African Rand",
    "symbol_native": "R",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZAR",
    "name_plural": "South African rand"
  },
  "ZMK": {
    "symbol": "ZK",
    "name": "Zambian Kwacha",
    "symbol_native": "ZK",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ZMK",
    "name_plural": "Zambian kwachas"
  },
  "ZWL": {
    "symbol": "ZWL$",
    "name": "Zimbabwean Dollar",
    "symbol_native": "ZWL$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ZWL",
    "name_plural": "Zimbabwean Dollar"
  },
  "CFP": {
    "symbol": "CFP",
    "name": "CFP Franc",
    "symbol_native": "₣"
  },
  "ANG": {
    "symbol": "ANG",
    "name": "Netherlands Antillean guilder",
    "symbol_native": "NAƒ"
  },
  "SSP": {
    "symbol": "SS£",
    "name": "South Sudanese pound",
    "symbol_native": "£"
  },
  "XBT": {
    "symbol": "₿",
    "name": "Bitcoin",
    "symbol_native": "₿"
  },
  "BTC": {
    "symbol": "₿",
    "name": "Bitcoin",
    "symbol_native": "₿"
  },
  "ETH": {
    "symbol": "Ξ",
    "name": "Ethereum",
    "symbol_native": "Ξ"
  }
};
var postAppend = ["FR", "DE", "ES", "NO", "FI", "DK", "GL", "FO", "SE", "AX", "BE", "LT", "LV", "SJ", "SX", "SS"];

var currency = function currency(val, code) {
  var country_code = $cookies.get('wp-country');

  if (code === null || code === '' || code === undefined) {
    return "$".concat(val);
  }

  if (postAppend.indexOf(country_code) > -1) {
    return "".concat(val).concat(symbols[code].symbol_native);
  } else {
    return "".concat(symbols[code].symbol_native).concat(val);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (currency);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(52)('meta');
var isObject = __webpack_require__(8);
var has = __webpack_require__(29);
var setDesc = __webpack_require__(15).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(7)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(11)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(25)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(148);
var enumBugKeys = __webpack_require__(114);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(37);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(4);
var dPs = __webpack_require__(149);
var enumBugKeys = __webpack_require__(114);
var IE_PROTO = __webpack_require__(113)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(111)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(115).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(148);
var hiddenKeys = __webpack_require__(114).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var dP = __webpack_require__(15);
var DESCRIPTORS = __webpack_require__(14);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(35);
var call = __webpack_require__(161);
var isArrayIter = __webpack_require__(126);
var anObject = __webpack_require__(4);
var toLength = __webpack_require__(12);
var getIterFn = __webpack_require__(128);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(26);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg width='1920' height='1125' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_d)'%3E%3Cmask id='a' maskUnits='userSpaceOnUse' x='0' y='-2' width='1920' height='1107'%3E%3Cpath fill='url(%23paint0_linear)' d='M0-2h1920v1107H0z'/%3E%3Cpath d='M1920-2H0v1107h1920V-2z' fill='%23232529'/%3E%3Cpath fill='%23C4C4C4' d='M608 402h405v198H608z'/%3E%3Cpath stroke='%23FF0404' stroke-width='4' d='M1279 553h40v40h-40z'/%3E%3C/mask%3E%3Cg mask='url(%23a)'%3E%3Cpath fill='%23080438' d='M0 75.481h1920v1030.49H0z'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='960' y1='-2' x2='960' y2='1105' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%232D4260'/%3E%3Cstop offset='1' stop-color='%2310213A'/%3E%3C/linearGradient%3E%3Cfilter id='filter0_d' x='-15' y='65.481' width='1950' height='1059.52' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dy='5'/%3E%3CfeGaussianBlur stdDeviation='7.5'/%3E%3CfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0'/%3E%3CfeBlend in2='BackgroundImageFix' result='effect1_dropShadow'/%3E%3CfeBlend in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E"

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(15).f;
var has = __webpack_require__(29);
var TAG = __webpack_require__(11)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(36);
var TAG = __webpack_require__(11)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(41);
var fails = __webpack_require__(7);
var spaces = __webpack_require__(117);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(564);

var iterableToArray = __webpack_require__(565);

var unsupportedIterableToArray = __webpack_require__(190);

var nonIterableSpread = __webpack_require__(566);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(34);
var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(48) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(36);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(4);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(21);
var SPECIES = __webpack_require__(11)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg width='10' height='10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M.897.897a.812.812 0 000 1.149l2.872 2.872L.897 7.791A.813.813 0 102.046 8.94l2.872-2.873L7.791 8.94A.813.813 0 008.94 7.791L6.067 4.918 8.94 2.046A.812.812 0 107.791.896L4.918 3.77 2.046.897a.813.813 0 00-1.15 0z' fill='%23fff'/%3E%3C/svg%3E"

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = add;
/* harmony export (immutable) */ __webpack_exports__["b"] = watch;
/* unused harmony export fire */
/** Collection of callback functions for media querys. */
var listeners = {};
/**
 * Bind functions to a matchMedia listener (subscriber).
 *
 * @param {string|number} 	query 	Media query to match or number for min-width.
 * @param {function} 		yes 	Function to invoke when the media query matches.
 * @param {function} 		no 		Function to invoke when the media query doesn't match.
 */
function add(query, yes, no) {
    if (typeof query == 'number') {
        query = '(min-width: ' + query + 'px)';
    }
    listeners[query] = listeners[query] || [];
    listeners[query].push({ yes: yes, no: no });
}
/**
 * Initialize the matchMedia listener.
 */
function watch() {
    var _loop_1 = function (query) {
        var mqlist = window.matchMedia(query);
        fire(query, mqlist);
        mqlist.onchange = function (evnt) {
            fire(query, mqlist);
        };
    };
    for (var query in listeners) {
        _loop_1(query);
    }
}
/**
 * Invoke the "yes" or "no" function for a matchMedia listener (publisher).
 *
 * @param {string} 			query 	Media query to check for.
 * @param {MediaQueryList} 	mqlist 	Media query list to check with.
 */
function fire(query, mqlist) {
    var fn = mqlist.matches ? 'yes' : 'no';
    for (var m = 0; m < listeners[query].length; m++) {
        listeners[query][m][fn]();
    }
}


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_head__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Index__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Search_Search__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Preview__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Archive__ = __webpack_require__(145);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var routes = [{
  path: '',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_Home__["default"],
  name: 'home'
}, {
  path: '/search/:searchText',
  component: __WEBPACK_IMPORTED_MODULE_5__pages_Search_Search__["default"],
  name: 'search'
}, {
  path: '/preview',
  component: __WEBPACK_IMPORTED_MODULE_6__pages_Preview__["default"],
  name: 'preview'
}, {
  path: '/news-archive/:term',
  component: __WEBPACK_IMPORTED_MODULE_8__pages_Archive__["default"],
  name: 'News Archive',
  meta: {
    taxonomy: 'news_cat'
  }
}, {
  path: '/streamers-archive/:term',
  component: __WEBPACK_IMPORTED_MODULE_8__pages_Archive__["default"],
  name: 'Streams Archive',
  meta: {
    taxonomy: 'streamer'
  }
}, {
  path: '/:postSlug',
  name: 'Index',
  component: __WEBPACK_IMPORTED_MODULE_4__pages_Index__["default"],
  props: true
}, {
  path: '*',
  name: '404',
  component: __WEBPACK_IMPORTED_MODULE_7__pages_404__["default"],
  meta: {
    title: '404 - Not Found',
    metaTags: [{
      name: 'description',
      content: 'You are lost!'
    }, {
      property: 'og:description',
      content: 'You are lost!'
    }]
  }
}];
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes,
  mode: 'history',
  base: '',
  // Prevents window from scrolling back to top
  // when navigating between components/views
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

function loadView(view) {
  var viewName = view === 'GamePaid' ? 'GameFree' : view;
  return function () {
    return __webpack_require__(706)("./".concat(viewName, "/").concat(viewName, ".vue"));
  };
} // Add custom routes components


var custom_rc = [];

if (wpvue_script_data_params.data.post_types) {
  for (var key in wpvue_script_data_params.data.post_types) {
    var type = key;
    var item_comp = '',
        slug_arr = type.split('_');
    slug_arr.map(function (part) {
      item_comp += part.charAt(0).toUpperCase() + part.slice(1);
    });
    custom_rc.push({
      path: "/".concat(type, "/:postSlug"),
      name: item_comp,
      component: loadView(item_comp)
    });
  }

  ;
  if (custom_rc.length != 0) router.addRoutes(custom_rc);
} // Add dynamic post routes


var d_routes = wpvue_script_data_params.data.routes;

if (d_routes) {
  if (d_routes != null || d_routes.length != 0) {
    var routes_posts = [];
    d_routes.map(function (route) {
      if (route.hasOwnProperty('modified_base')) {
        routes_posts.push({
          path: "/".concat(route.modified_base, "/:postSlug"),
          name: route.name,
          component: function component(resolve) {
            __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(739)("./".concat(route.component_base, "/").concat(route.component_base, ".vue"))]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
          }
        });
      } else {
        routes_posts.push(route);
      }
    });
    router.addRoutes(routes_posts);
  }
}

; // This callback runs before every route change, including on page load.

router.beforeEach(function (to, from, next) {
  var routes_meta = wpvue_script_data_params.data.routes_meta;
  var route_slug = to.params.postSlug ? to.params.postSlug : wpvue_script_data_params.frontpage_slug; // Reset localstorage

  if (route_slug != localStorage.getItem("storedPageName")) {
    //localStorage.clear()
    localStorage.removeItem('storedPageName');
  }

  var route_meta = to.meta;

  if (route_slug) {
    route_meta = routes_meta && routes_meta[route_slug] ? routes_meta[route_slug] : route_meta;
  } // Remove any stale meta tags from the document using the key attribute we set below.


  Array.from(document.querySelectorAll('[vue-router-head-controlled]')).map(function (el) {
    return el.parentNode.removeChild(el);
  });
  if (!route_meta) return next();
  if (route_meta.title) document.title = unescapeHtml(route_meta.title); // Add scripts into actual elements in the head.

  if (route_meta.scripts) {
    route_meta.scripts.map(function (tagDef) {
      var script = document.createElement('script');
      Object.keys(tagDef).forEach(function (key) {
        if (key == 'body') {
          script.appendChild(document.createTextNode(tagDef[key]));
        } else {
          script.setAttribute(key, tagDef[key]);
        }
      });
      script.setAttribute('vue-router-head-controlled', '');
      var vueapp = document.getElementById('app');

      if (!tagDef.hasOwnProperty('placed') || tagDef['placed'] == 'header') {
        if (script) {
          document.head.appendChild(script);
        }
      } else if (tagDef['placed'] == 'body_top') {
        if (vueapp && script) {
          vueapp.insertAdjacentElement('beforebegin', script);
        }
      } else if (tagDef['placed'] == 'body_bottom') {
        if (vueapp && script) {
          vueapp.insertAdjacentElement('afterend', script);
        }
      } else if (tagDef['placed'] == 'footer') {
        var body = document.querySelector('body');

        if (body && script) {
          body.insertAdjacentElement('beforeend', script);
        }
      } else {}
    });
  } // Add link into actual elements in the head.


  if (route_meta.scripts) {
    route_meta.styles.map(function (tagDef) {
      var link = document.createElement('link');
      Object.keys(tagDef).forEach(function (key) {
        link.setAttribute(key, tagDef[key]);
      });
      link.setAttribute('vue-router-head-controlled', '');
      return link;
    }).forEach(function (link) {
      return document.head.appendChild(link);
    });
  } // Skip rendering meta tags if there are none.


  if (!route_meta.metaTags) return next(); // Turn the meta tag definitions into actual elements in the head.

  route_meta.metaTags.forEach(function (tagDef) {});
  next();
});

function unescapeHtml(text) {
  var specialchars = [['–', '&ndash;'], ['—', '&mdash;'], ['·', '&middot;'], ['•', '&bull;'], ['⋆', '&#8902;'], ['«', '&laquo;'], ['»', '&raquo;'], ['<', '&lt;'], ['<', '&#060;'], ['>', '&gt;'], ['>', '&#062;'], ["'", '&#039;'], ['"', '&quot;'], ['"', '&#x22;'], ['"', '&#034;'], ['&', '&amp;'], ['&', '&#038;'], ['&', '&#x26;']];

  if (!text) {
    return text;
  }

  var unescapedString = text; // For each of the special characters,

  var len = specialchars.length;

  for (var x = 0; x < len; x++) {
    // Replace all instances of the special character with its entity.
    unescapedString = unescapedString.replace(new RegExp(specialchars[x][1], 'g'), specialchars[x][0]);
  }

  return unescapedString;
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLang; });
var lang = {
  "ca": "AD",
  "en": "GB",
  "ar": "AE",
  "ru": "RU",
  "da": "DE",
  "et": "EE",
  "el": "GR",
  "ga": "IE",
  "sl": "SI",
  "sv": "SE",
  "zh": "CN",
  "cs": "CZ",
  "ja": "JP",
  "ko": "KR"
};

var getLang = function getLang(iso) {
  if (lang[iso]) {
    return lang[iso];
  } else {
    return iso;
  }
};



/***/ }),
/* 77 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeLayout1_vue__ = __webpack_require__(216);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2c052a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeLayout1_vue__ = __webpack_require__(592);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c2c052a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeLayout1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2c052a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeLayout1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeLayout2_vue__ = __webpack_require__(227);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cec19694_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeLayout2_vue__ = __webpack_require__(595);
function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cec19694"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeLayout2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cec19694_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeLayout2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(30);
var toLength = __webpack_require__(12);
var toAbsoluteIndex = __webpack_require__(54);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(36);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(37);
var defined = __webpack_require__(41);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(8);
var cof = __webpack_require__(36);
var MATCH = __webpack_require__(11)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(11)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(64);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(165);
var redefine = __webpack_require__(26);
var hide = __webpack_require__(25);
var fails = __webpack_require__(7);
var defined = __webpack_require__(41);
var wks = __webpack_require__(11);
var regexpExec = __webpack_require__(132);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(26);
var redefineAll = __webpack_require__(60);
var meta = __webpack_require__(49);
var forOf = __webpack_require__(59);
var anInstance = __webpack_require__(58);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var $iterDetect = __webpack_require__(85);
var setToStringTag = __webpack_require__(63);
var inheritIfRequired = __webpack_require__(118);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(25);
var uid = __webpack_require__(52);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(48) || !__webpack_require__(7)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(5)[K];
});


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(21);
var ctx = __webpack_require__(35);
var forOf = __webpack_require__(59);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = add;
/* harmony export (immutable) */ __webpack_exports__["b"] = get;
/* unused harmony export all */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(13);

var translations = {};
/**
 * Add translations to a language.
 * @param {object}  text        Object of key/value translations.
 * @param {string}  language    The translated language.
 */
function add(text, language) {
    if (typeof translations[language] == 'undefined') {
        translations[language] = {};
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* extend */])(translations[language], text);
}
/**
 * Find a translated text in a language.
 * @param   {string} text       The text to find the translation for.
 * @param   {string} language   The language to search in.
 * @return  {string}            The translated text.
 */
function get(text, language) {
    if (typeof language == 'string' &&
        typeof translations[language] != 'undefined') {
        return translations[language][text] || text;
    }
    return text;
}
/**
 * Get all translated text in a language.
 * @param   {string} language   The language to search for.
 * @return  {object}            The translations.
 */
function all(language) {
    return translations;
}


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = on;
/* harmony export (immutable) */ __webpack_exports__["a"] = off;
/* harmony export (immutable) */ __webpack_exports__["c"] = trigger;
/**
 * Make the first letter in a word uppercase.
 * @param {string} word The word.
 */
function ucFirst(word) {
    if (!word) {
        return '';
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
}
/**
 * Bind an event listener to an element.
 * @param {HTMLElement} element     The element to bind the event listener to.
 * @param {string}      evnt        The event to listen to.
 * @param {funcion}     handler     The function to invoke.
 */
function on(element, evnt, handler) {
    //  Extract the event name and space from the event (the event can include a namespace (click.foo)).
    var evntParts = evnt.split('.');
    evnt = 'mmEvent' + ucFirst(evntParts[0]) + ucFirst(evntParts[1]);
    element[evnt] = element[evnt] || [];
    element[evnt].push(handler);
    element.addEventListener(evntParts[0], handler);
}
/**
 * Remove an event listener from an element.
 * @param {HTMLElement} element The element to remove the event listeners from.
 * @param {string}      evnt    The event to remove.
 */
function off(element, evnt) {
    //  Extract the event name and space from the event (the event can include a namespace (click.foo)).
    var evntParts = evnt.split('.');
    evnt = 'mmEvent' + ucFirst(evntParts[0]) + ucFirst(evntParts[1]);
    (element[evnt] || []).forEach(function (handler) {
        element.removeEventListener(evntParts[0], handler);
    });
}
/**
 * Trigger the bound event listeners on an element.
 * @param {HTMLElement} element     The element of which to trigger the event listeners from.
 * @param {string}      evnt        The event to trigger.
 * @param {object}      [options]   Options to pass to the handler.
 */
function trigger(element, evnt, options) {
    var evntParts = evnt.split('.');
    evnt = 'mmEvent' + ucFirst(evntParts[0]) + ucFirst(evntParts[1]);
    (element[evnt] || []).forEach(function (handler) {
        handler(options || {});
    });
}


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotSupportModal_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd42c204_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotSupportModal_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(637)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotSupportModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd42c204_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotSupportModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Article_vue__ = __webpack_require__(229);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5426f52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Article_vue__ = __webpack_require__(605);
function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5426f52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Article_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5426f52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Article_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Review_vue__ = __webpack_require__(232);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba9ee58e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Review_vue__ = __webpack_require__(643);
function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba9ee58e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Review_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba9ee58e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Review_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewWithBlocks_vue__ = __webpack_require__(243);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f61dbd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewWithBlocks_vue__ = __webpack_require__(646);
function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32f61dbd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewWithBlocks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f61dbd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewWithBlocks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameGuideHolder_vue__ = __webpack_require__(244);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dca6d04_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GameGuideHolder_vue__ = __webpack_require__(649);
function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7dca6d04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameGuideHolder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dca6d04_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GameGuideHolder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameFree_vue__ = __webpack_require__(245);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_331378b8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GameFree_vue__ = __webpack_require__(661);
function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-331378b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameFree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_331378b8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GameFree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DefaultPage_vue__ = __webpack_require__(248);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7695d3b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultPage_vue__ = __webpack_require__(664);
function injectStyle (ssrContext) {
  __webpack_require__(662)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7695d3b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DefaultPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7695d3b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapTemplate_vue__ = __webpack_require__(249);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5118edfa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapTemplate_vue__ = __webpack_require__(672);
function injectStyle (ssrContext) {
  __webpack_require__(665)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5118edfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5118edfa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutUs_vue__ = __webpack_require__(251);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8296bac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutUs_vue__ = __webpack_require__(675);
function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8296bac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8296bac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarTemplate_vue__ = __webpack_require__(252);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713899e7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarTemplate_vue__ = __webpack_require__(682);
function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-713899e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713899e7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentOptions_vue__ = __webpack_require__(255);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71c4e1f1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentOptions_vue__ = __webpack_require__(685);
function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71c4e1f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71c4e1f1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoftwareProviders_vue__ = __webpack_require__(256);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce5355d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoftwareProviders_vue__ = __webpack_require__(688);
function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce5355d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoftwareProviders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce5355d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoftwareProviders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Promotions_vue__ = __webpack_require__(257);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b4b1a8a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Promotions_vue__ = __webpack_require__(691);
function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b4b1a8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Promotions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b4b1a8a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Promotions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(258);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d6b8e08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(694);
function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d6b8e08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d6b8e08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Streams_vue__ = __webpack_require__(259);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_356e2eb1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Streams_vue__ = __webpack_require__(697);
function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-356e2eb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Streams_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_356e2eb1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Streams_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(34);
var LIBRARY = __webpack_require__(48);
var wksExt = __webpack_require__(147);
var defineProperty = __webpack_require__(15).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(68)('keys');
var uid = __webpack_require__(52);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(4);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(35)(Function.call, __webpack_require__(31).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var setPrototypeOf = __webpack_require__(116).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(37);
var defined = __webpack_require__(41);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(48);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(26);
var hide = __webpack_require__(25);
var Iterators = __webpack_require__(66);
var $iterCreate = __webpack_require__(123);
var setToStringTag = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(32);
var ITERATOR = __webpack_require__(11)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(55);
var descriptor = __webpack_require__(51);
var setToStringTag = __webpack_require__(63);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(25)(IteratorPrototype, __webpack_require__(11)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(84);
var defined = __webpack_require__(41);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(11)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(66);
var ITERATOR = __webpack_require__(11)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(15);
var createDesc = __webpack_require__(51);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(64);
var ITERATOR = __webpack_require__(11)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(34).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(360);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(54);
var toLength = __webpack_require__(12);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(50);
var step = __webpack_require__(164);
var Iterators = __webpack_require__(66);
var toIObject = __webpack_require__(30);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(122)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(71);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(83)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(35);
var invoke = __webpack_require__(154);
var html = __webpack_require__(115);
var cel = __webpack_require__(111);
var global = __webpack_require__(5);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(36)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var macrotask = __webpack_require__(134).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(36)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(21);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(14);
var LIBRARY = __webpack_require__(48);
var $typed = __webpack_require__(90);
var hide = __webpack_require__(25);
var redefineAll = __webpack_require__(60);
var fails = __webpack_require__(7);
var anInstance = __webpack_require__(58);
var toInteger = __webpack_require__(37);
var toLength = __webpack_require__(12);
var toIndex = __webpack_require__(174);
var gOPN = __webpack_require__(56).f;
var dP = __webpack_require__(15).f;
var arrayFill = __webpack_require__(130);
var setToStringTag = __webpack_require__(63);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i], vm);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
  if (!valid && haveExpectedTypes) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

function assertType (value, type, vm) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    try {
      valid = value instanceof type;
    } catch (e) {
      warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
      valid = false;
    }
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

var functionTypeCheckRE = /^\s*function (\w+)/;

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(functionTypeCheckRE);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  // check if we need to specify expected value
  if (
    expectedTypes.length === 1 &&
    isExplicable(expectedType) &&
    isExplicable(typeof value) &&
    !isBoolean(expectedType, receivedType)
  ) {
    message += " with value " + (styleValue(value, expectedType));
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + (styleValue(value, receivedType)) + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable (value) {
  return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    var vnode = res && res[0];
    return res && (
      !vnode ||
      (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallbackRender,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) {
    // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn('slot v-bind without argument expects an Object', this);
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes =
      scopedSlotFn(props) ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  } else {
    nodes =
      this.$slots[name] ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
  return eventKeyCode === undefined
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  // we know it's MountedComponentVNode but flow doesn't
  vnode,
  // activeInstance in lifecycle state
  parent
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
    (!newScopedSlots && vm.$scopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        var info = "callback for watcher \"" + (this.expression) + "\"";
        invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      } else if (vm.$options.methods && key in vm.$options.methods) {
        warn(("The computed property \"" + key + "\" is already defined as a method."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
      pushTarget();
      invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
      popTarget();
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */





function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var entry = cache[key];
    if (entry) {
      var name = entry.name;
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var entry = cache[key];
  if (entry && (!current || entry.tag !== current.tag)) {
    entry.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  methods: {
    cacheVNode: function cacheVNode() {
      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var vnodeToCache = ref.vnodeToCache;
      var keyToCache = ref.keyToCache;
      if (vnodeToCache) {
        var tag = vnodeToCache.tag;
        var componentInstance = vnodeToCache.componentInstance;
        var componentOptions = vnodeToCache.componentOptions;
        cache[keyToCache] = {
          name: getComponentName(componentOptions),
          tag: tag,
          componentInstance: componentInstance,
        };
        keys.push(keyToCache);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
        this.vnodeToCache = null;
      }
    }
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.cacheVNode();
    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  updated: function updated () {
    this.cacheVNode();
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        // delay setting the cache until update
        this.vnodeToCache = vnode;
        this.keyToCache = key;
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.14';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key &&
    a.asyncFactory === b.asyncFactory && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur, vnode.data.pre);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value, isInPre) {
  if (isInPre || el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /[ \f\t\r\n]+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!(
    el.component ||
    el.attrsMap[':is'] ||
    el.attrsMap['v-bind:is'] ||
    !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag))
  ); };
  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + ".apply(null, arguments)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ").apply(null, arguments)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  // fix #11483, Root level <script> tags should not be rendered.
  var code = ast ? (ast.tag === 'script' ? 'null' : genElement(ast, state)) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? (",function(){return " + children + "}") : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33), __webpack_require__(471).setImmediate))

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return touch; });
/** Whether or not touch gestures are supported by the browser. */
var touch = 'ontouchstart' in window ||
    (navigator.msMaxTouchPoints ? true : false) ||
    false;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagBlock_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07b6b668_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagBlock_vue__ = __webpack_require__(658);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07b6b668"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07b6b668_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(215);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2592243a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(596);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2592243a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(228);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb5d061a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(698);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb5d061a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(260);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb74eadc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(701);
function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb74eadc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb74eadc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__ = __webpack_require__(261);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55233fdc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__ = __webpack_require__(702);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55233fdc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Archive_vue__ = __webpack_require__(262);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72c838b0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Archive_vue__ = __webpack_require__(705);
function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72c838b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Archive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72c838b0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Archive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(14) && !__webpack_require__(7)(function () {
  return Object.defineProperty(__webpack_require__(111)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(11);


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(29);
var toIObject = __webpack_require__(30);
var arrayIndexOf = __webpack_require__(80)(false);
var IE_PROTO = __webpack_require__(113)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15);
var anObject = __webpack_require__(4);
var getKeys = __webpack_require__(53);

module.exports = __webpack_require__(14) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(30);
var gOPN = __webpack_require__(56).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(14);
var getKeys = __webpack_require__(53);
var gOPS = __webpack_require__(81);
var pIE = __webpack_require__(70);
var toObject = __webpack_require__(16);
var IObject = __webpack_require__(69);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(21);
var isObject = __webpack_require__(8);
var invoke = __webpack_require__(154);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(5).parseInt;
var $trim = __webpack_require__(65).trim;
var ws = __webpack_require__(117);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(5).parseFloat;
var $trim = __webpack_require__(65).trim;

module.exports = 1 / $parseFloat(__webpack_require__(117) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(36);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(8);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(120);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(4);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(21);
var toObject = __webpack_require__(16);
var IObject = __webpack_require__(69);
var toLength = __webpack_require__(12);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(54);
var toLength = __webpack_require__(12);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(132);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(14) && /./g.flags != 'g') __webpack_require__(15).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(71)
});


/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(136);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(170);
var validate = __webpack_require__(61);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(89)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(15).f;
var create = __webpack_require__(55);
var redefineAll = __webpack_require__(60);
var ctx = __webpack_require__(35);
var anInstance = __webpack_require__(58);
var forOf = __webpack_require__(59);
var $iterDefine = __webpack_require__(122);
var step = __webpack_require__(164);
var setSpecies = __webpack_require__(57);
var DESCRIPTORS = __webpack_require__(14);
var fastKey = __webpack_require__(49).fastKey;
var validate = __webpack_require__(61);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(170);
var validate = __webpack_require__(61);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(89)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var each = __webpack_require__(43)(0);
var redefine = __webpack_require__(26);
var meta = __webpack_require__(49);
var assign = __webpack_require__(151);
var weak = __webpack_require__(173);
var isObject = __webpack_require__(8);
var validate = __webpack_require__(61);
var NATIVE_WEAK_MAP = __webpack_require__(61);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(89)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(60);
var getWeak = __webpack_require__(49).getWeak;
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var anInstance = __webpack_require__(58);
var forOf = __webpack_require__(59);
var createArrayMethod = __webpack_require__(43);
var $has = __webpack_require__(29);
var validate = __webpack_require__(61);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(37);
var toLength = __webpack_require__(12);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(56);
var gOPS = __webpack_require__(81);
var anObject = __webpack_require__(4);
var Reflect = __webpack_require__(5).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(82);
var isObject = __webpack_require__(8);
var toLength = __webpack_require__(12);
var ctx = __webpack_require__(35);
var IS_CONCAT_SPREADABLE = __webpack_require__(11)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(12);
var repeat = __webpack_require__(119);
var defined = __webpack_require__(41);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var getKeys = __webpack_require__(53);
var toIObject = __webpack_require__(30);
var isEnum = __webpack_require__(70).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(64);
var from = __webpack_require__(180);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(59);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Header__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Footer__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_LoaderSpinner__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_AdminPanelBar__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_custom_block_Newsletter__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_Pages_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App",
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Header__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_layouts_Footer__["a" /* default */],
    LoaderSpinner: __WEBPACK_IMPORTED_MODULE_2__components_ui_LoaderSpinner__["a" /* default */],
    AdminPanelBar: __WEBPACK_IMPORTED_MODULE_3__components_layouts_AdminPanelBar__["a" /* default */],
    Newsletter: __WEBPACK_IMPORTED_MODULE_4__components_custom_block_Newsletter__["a" /* default */]
  },
  data: function data() {
    return {
      headerComponent: {
        regulationBanner: {},
        carnivalBanner: {},
        menus: [],
        logo: ""
      },
      footerComponent: {
        footerMenuTitle1: "",
        footerMenuTitle2: "",
        footerMenuTitle3: "",
        footerMenu1: [],
        footerMenu2: [],
        footerMenu3: [],
        copyright_text: "",
        footer_text2: "",
        securityImages: [],
        socialIcons: [],
        footerMenuCount1: "",
        footerMenuOffset1: "",
        footerMenuText1: "",
        footerMenuLink1: "",
        footerMenuCount2: "",
        footerMenuOffset2: "",
        footerMenuText2: "",
        footerMenuLink2: "",
        footerMenuCount3: "",
        footerMenuOffset3: "",
        footerMenuText3: "",
        footerMenuLink3: ""
      },
      pageLoaded: false,
      pageSideImages: false
    };
  },
  created: function created() {
    var head = document.head || document.getElementsByTagName("head")[0],
        style = document.createElement("style");
    head.appendChild(style);
    style.type = "text/css";
    style.id = "vars-root";
    var varsStyle = document.getElementById("vars-root");
    var primaryBtn = this.$root.color_schema.primary_btn;
    var varsEle = ":root{--primary-btn-hover-color:".concat(this.$root.override_ctabtntxt_color ? this.$root.ctabtn_txt_color : Object(__WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["a" /* getContrastYIQ */])(primaryBtn) ? "#ffffff" : "#222222", ";--override-primary-btn-text-color:").concat(this.$root.override_ctabtntxt_color ? this.$root.ctabtn_txt_color : "", ";--hover-color:").concat(primaryBtn, ";--rotate-color:").concat(primaryBtn, ";--primary-btn:").concat(primaryBtn, ";--primary-btn-hover:").concat(this.pSBC(-0.2, primaryBtn), ";--text-link-color:#0084FF;--primary-color:").concat(this.$root.color_schema.primary, ";--secondary-color:").concat(this.$root.color_schema.secondary, ";--des-color:#fff;--cas-hover-color:#fff;--heading-font:").concat(this.$root.font_family.heading, ";--paragraph-font:").concat(this.$root.font_family.paragraph, ";--default-regular:").concat(this.$root.font_family.default_regular, ";--default-bold:").concat(this.$root.font_family.default_bold, ";--bg-image:url(").concat(this.$root.color_schema.site_bg_img, ")repeat;--bg-color:").concat(this.$root.color_schema.site_bg_color, ";--search-icon:url(").concat(this.$root.site_url).concat(this.$root.asset_path, "/svg-icons/search-sml.svg);--primary-search-bg:").concat(this.pSBC(0.4, this.$root.color_schema.primary), ";}");
    if (varsStyle) varsStyle.innerText = varsEle;
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_6__api_Pages_api__["a" /* HttpService */].getNavLinks(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state")).then(function (res) {
      var resData = res.data.data;
      var navMenu = resData.nav_menus;
      _this.pageSideImages = _this.$root.page_side_images;
      _this.headerComponent.menus = Object.keys(navMenu.main_menu.items).length > 0 ? navMenu.main_menu.items : [];
      _this.headerComponent.logo = resData.logo_url;
      _this.headerComponent.regulationBanner = resData.top_ribbon;
      _this.headerComponent.carnivalBanner = resData.hasOwnProperty("offer_banner") ? resData.offer_banner : {}; // Footer Menu Titles

      _this.footerComponent.footerMenuTitle1 = navMenu.footer_menu_1 && Object.keys(navMenu.footer_menu_1).length > 0 ? navMenu.footer_menu_1.name : "";
      _this.footerComponent.footerMenuTitle2 = navMenu.footer_menu_2 && Object.keys(navMenu.footer_menu_2).length > 0 ? navMenu.footer_menu_2.name : "";
      _this.footerComponent.footerMenuTitle3 = navMenu.footer_menu_3 && Object.keys(navMenu.footer_menu_3).length > 0 ? navMenu.footer_menu_3.name : ""; // Footer Menus

      _this.footerComponent.footerMenu1 = navMenu.footer_menu_1 && Object.keys(navMenu.footer_menu_1).length > 0 ? navMenu.footer_menu_1.items : [];
      _this.footerComponent.footerMenu2 = navMenu.footer_menu_2 && Object.keys(navMenu.footer_menu_2).length > 0 ? navMenu.footer_menu_2.items : [];
      _this.footerComponent.footerMenu3 = navMenu.footer_menu_3 && Object.keys(navMenu.footer_menu_3).length > 0 ? navMenu.footer_menu_3.items : []; // Footer Menus Count, Offset, Label, Link

      _this.footerComponent.footerMenuCount1 = navMenu.footer_menu_1 && Object.keys(navMenu.footer_menu_1).length > 0 && navMenu.footer_menu_1.count ? navMenu.footer_menu_1.count : "";
      _this.footerComponent.footerMenuOffset1 = navMenu.footer_menu_1 && Object.keys(navMenu.footer_menu_1).length > 0 && navMenu.footer_menu_1.offset ? parseInt(navMenu.footer_menu_1.offset) : navMenu.footer_menu_1 && Object.keys(navMenu.footer_menu_1).length > 0 && navMenu.footer_menu_1.count ? navMenu.footer_menu_1.count : "";
      _this.footerComponent.footerMenuText1 = navMenu.footer_menu_1 && Object.keys(navMenu.footer_menu_1).length > 0 && navMenu.footer_menu_1.texts_for_more ? navMenu.footer_menu_1.texts_for_more : "";
      _this.footerComponent.footerMenuLink1 = navMenu.footer_menu_1 && Object.keys(navMenu.footer_menu_1).length > 0 && navMenu.footer_menu_1.link_for_more ? navMenu.footer_menu_1.link_for_more : "";
      _this.footerComponent.footerMenuCount2 = navMenu.footer_menu_2 && Object.keys(navMenu.footer_menu_2).length > 0 && navMenu.footer_menu_2.count ? navMenu.footer_menu_2.count : "";
      _this.footerComponent.footerMenuOffset2 = navMenu.footer_menu_2 && Object.keys(navMenu.footer_menu_2).length > 0 && navMenu.footer_menu_2.offset ? parseInt(navMenu.footer_menu_2.offset) : navMenu.footer_menu_2 && Object.keys(navMenu.footer_menu_2).length > 0 && navMenu.footer_menu_2.count ? navMenu.footer_menu_2.count : "";
      _this.footerComponent.footerMenuText2 = navMenu.footer_menu_2 && Object.keys(navMenu.footer_menu_2).length > 0 && navMenu.footer_menu_2.texts_for_more ? navMenu.footer_menu_2.texts_for_more : "";
      _this.footerComponent.footerMenuLink2 = navMenu.footer_menu_2 && Object.keys(navMenu.footer_menu_2).length > 0 && navMenu.footer_menu_2.link_for_more ? navMenu.footer_menu_2.link_for_more : "";
      _this.footerComponent.footerMenuCount3 = navMenu.footer_menu_3 && Object.keys(navMenu.footer_menu_3).length > 0 && navMenu.footer_menu_3.count ? navMenu.footer_menu_3.count : "";
      _this.footerComponent.footerMenuOffset3 = navMenu.footer_menu_3 && Object.keys(navMenu.footer_menu_3).length > 0 && navMenu.footer_menu_3.offset ? parseInt(navMenu.footer_menu_3.offset) : navMenu.footer_menu_3 && Object.keys(navMenu.footer_menu_3).length > 0 && navMenu.footer_menu_3.count ? navMenu.footer_menu_3.count : "";
      _this.footerComponent.footerMenuText3 = navMenu.footer_menu_3 && Object.keys(navMenu.footer_menu_3).length > 0 && navMenu.footer_menu_3.texts_for_more ? navMenu.footer_menu_3.texts_for_more : "";
      _this.footerComponent.footerMenuLink3 = navMenu.footer_menu_3 && Object.keys(navMenu.footer_menu_3).length > 0 && navMenu.footer_menu_3.link_for_more ? navMenu.footer_menu_3.link_for_more : ""; // Show Mobile Sticky Menu

      if (_this.$root.show_stickymenu) {
        if (_this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
          if (_this.headerComponent.regulationBanner.show_top_bar) {
            document.body.style.paddingTop = "132px";
          } else if (_this.headerComponent.carnivalBanner.enable_banner) {
            document.body.style.paddingTop = "125px";
          } else {
            document.body.style.paddingTop = "80px";
          }
        }
      }
    }).catch(function (err) {
      return console.log(err);
    }); // To Top Show Hide Event

    window.addEventListener("scroll", function () {
      var appDom = document.getElementById("app");
      var reviewDom = document.querySelector("#review-sticky-card .sticky-inner");
      var scTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scTop > 60) {
        appDom.classList.add("scrolling");

        if (reviewDom && reviewDom.getBoundingClientRect().top > 0) {
          document.getElementById("top-btn").style.bottom = "".concat(reviewDom.clientHeight + 20, "px");
        } else {
          if (window.innerWidth > 991 && window.innerWidth < 1412) {
            document.getElementById("top-btn").style.bottom = "70px";
          } else {
            document.getElementById("top-btn").style.bottom = "20px";
          }
        }
      } else {
        appDom.classList.remove("scrolling");
      }
    }, {
      passive: true
    });
    window.addEventListener("click", function (event) {
      if (!_this.$root.enable_piwik_reload) {
        var target = event.target;

        while (target && target.tagName !== "A") {
          target = target.parentNode;
        }

        if (target && target.matches("a:not([href*='://'])") && target.href) {
          var altKey = event.altKey,
              ctrlKey = event.ctrlKey,
              metaKey = event.metaKey,
              shiftKey = event.shiftKey,
              button = event.button,
              defaultPrevented = event.defaultPrevented;
          if (target.href.includes("javascript")) return; // don't handle with control keys

          if (metaKey || altKey || ctrlKey || shiftKey) return; // don't handle when preventDefault called

          if (defaultPrevented) return; // don't handle right clicks

          if (button !== undefined && button !== 0) return; // don't handle if `target="_blank"`

          if (target && target.getAttribute) {
            var linkTarget = target.getAttribute("target");
            if (/\b_blank\b/i.test(linkTarget)) return;
          } // don't handle same page links/anchors


          var url = new URL(target.href);
          var to = url.pathname;

          if (window.location.pathname !== to && event.preventDefault) {
            event.preventDefault();

            _this.$router.push(to);
          }
        }
      }
    });
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.updateSideAds);
    window.addEventListener("scroll", this.updateSideAdsTop);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.updateSideAds);
    window.removeEventListener("scroll", this.updateSideAdsTop);
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["a" /* getContrastYIQ */],
    scrollToTop: function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    updateSideAdsTop: function updateSideAdsTop() {
      // This function should only work with "small" banners
      if (!this.pageSideImages || this.pageSideImages.size === "large") return;
      var selectors = [".carnival-banner", ".regulation-banner", "#header", ".panel-wrapper"];
      var offsetTop = 0;
      selectors.forEach(function (selector) {
        var item = document.querySelector(selector);

        if (item) {
          var rect = item.getBoundingClientRect();
          var rectHeight = item.offsetHeight || rect.height;
          offsetTop = offsetTop + (rect.top >= -rectHeight ? rectHeight : 0);
        }
      });
      document.querySelectorAll(".background-logo").forEach(function (item) {
        item.style.top = "".concat(offsetTop, "px");
      });
    },
    updateSideAds: function updateSideAds() {
      if (!this.pageSideImages) return;
      var bodyWidth = document.body.getBoundingClientRect().width;
      var containerWidth = document.querySelector(".container") ? document.querySelector(".container").getBoundingClientRect().width : 1240; // Default width

      var finalWidth = (bodyWidth - containerWidth) / 2;
      document.querySelectorAll(".background-logo").forEach(function (item) {
        item.style.visibility = "visible";
        item.style.width = "".concat(finalWidth, "px");
      });
      this.updateSideAdsTop();
    }
  },
  watch: {
    '$root.body_loading_status': function $rootBody_loading_status() {
      var _this2 = this;

      if (this.$root.body_loading_status) {
        this.pageLoaded = true;
        __WEBPACK_IMPORTED_MODULE_6__api_Pages_api__["a" /* HttpService */].getFooter(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state")).then(function (res) {
          _this2.footerComponent.copyright_text = res.data.data.footer_fields.copyright_text;
          _this2.footerComponent.footer_text2 = res.data.data.footer_fields.footer_text2;
          _this2.footerComponent.securityImages = res.data.data.security_images;
          _this2.footerComponent.socialIcons = res.data.data.social_icons;
          _this2.footerComponent.disclaimer = res.data.data.footer_fields.disclaimer;

          _this2.updateSideAds();
        }).catch(function (err) {
          console.log(err);

          _this2.updateSideAds();
        });
      }
    }
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_NavMenu_vue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_HeaderMobMenu_HeaderMobMenu__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Header",
  components: {
    NavMenu: __WEBPACK_IMPORTED_MODULE_0__components_ui_NavMenu_vue__["a" /* default */],
    HeaderMobMenu: __WEBPACK_IMPORTED_MODULE_1__components_layouts_HeaderMobMenu_HeaderMobMenu__["a" /* default */]
  },
  data: function data() {
    return {
      searchText: "",
      siteName: wpvue_script_data_params.site_name,
      regulationBanner: true,
      carnivalBanner: true,
      regulationBannerHeight: 0,
      carnivalBannerHeight: 0,
      mobileMenuOpen: false,
      stickyHeaderTop: 0,
      stickyRegulationBannerTop: 0
    };
  },
  props: {
    headerComponent: {
      regulationBanner: {},
      carnivalBanner: {},
      menus: [],
      logo: ""
    }
  },
  created: function created() {
    if (this.$route.name === "search") {
      this.searchText = this.$route.params.searchText;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      if (document.getElementById("regulation-banner")) {
        _this.regulationBannerHeight = document.getElementById("regulation-banner").clientHeight;
      }
    });
    window.addEventListener("scroll", function () {
      var element = document.getElementById("regulation-banner");

      if (element && _this.regulationBannerHeight <= 0) {
        _this.regulationBannerHeight = element.clientHeight;
      }

      if (element && (!document.querySelectorAll(".background-logo-small") || window.innerWidth < 1240)) {
        var scTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scTop > 10) {
          element.style.height = 0;
          element.style.padding = "0";
          element.style.display = "none";

          if (_this.$root.show_stickymenu && _this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            document.body.style.paddingTop = "80px";
          }
        } else {
          element.style.height = "".concat(_this.regulationBannerHeight, "px");
          element.style.padding = "10px 0";
          element.style.display = "block";

          if (_this.$root.show_stickymenu && _this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            if (scTop === 0) {
              document.body.style.paddingTop = "".concat(_this.regulationBannerHeight + 80, "px");
            } else {
              document.body.style.paddingTop = "80px";
            }
          }
        }
      } //Sticky regulation banner


      var elementSty = document.getElementById("sticky-regulation-banner");

      if (elementSty) {
        var scTopsty = window.pageYOffset || document.documentElement.scrollTop;

        if (scTopsty > 10) {
          if (_this.headerComponent.regulationBanner.enable_regulation_banner_sticky) {
            elementSty.classList.add("sticky-regulation-banner");
            elementSty.style.height = "".concat(elementSty.offsetHeight, "px");
            elementSty.style.padding = "10px 0";
            elementSty.style.display = "block";
          } else {
            elementSty.style.height = 0;
            elementSty.style.padding = "0";
            elementSty.style.display = "none";
          }

          if (_this.$root.show_stickymenu && _this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            if (document.getElementById("header")) {
              document.getElementById("header").style.top = "".concat(elementSty.offsetHeight, "px");
              document.body.style.paddingTop = "".concat(elementSty.offsetHeight + 80, "px");
            } else {
              document.body.style.paddingTop = "80px";
            }
          }
        } else {
          if (_this.headerComponent.regulationBanner.enable_regulation_banner_sticky) {
            elementSty.classList.remove("sticky-regulation-banner");
          }

          elementSty.style.height = "".concat(elementSty.offsetHeight, "px");
          elementSty.style.padding = "10px 0";
          elementSty.style.display = "block";

          if (_this.$root.show_stickymenu && _this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            if (scTopsty === 0) {
              document.body.style.paddingTop = "".concat(elementSty.offsetHeight + 80, "px");
            } else {
              document.body.style.paddingTop = "".concat(elementSty.offsetHeight + 80, "px");
            }

            elementSty.style.top = "0px";
            if (document.getElementById("header")) document.getElementById("header").style.top = "0px";
          }
        }
      } // Admin Bar checking


      if (document.getElementById("panel-wrapper")) {
        if (document.getElementById("review-sticky-card")) {
          if (window.pageYOffset >= 338) {
            if (document.getElementById("sticky-header")) {
              document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
            }
          } else {
            if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
          }
        } else {
          if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
        }
      } else {
        if (document.getElementById("sticky-regulation-banner")) {
          if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
        } else {
          if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "0px";
        }
      }

      if (document.getElementById("sticky-header")) {
        var scrollDist = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollDist > 10 && window.innerWidth > 991) {
          document.getElementById("sticky-header").style.display = "block";
        } else {
          document.getElementById("sticky-header").style.display = "none";
        }
      }
    }, {
      passive: true
    });
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["a" /* getContrastYIQ */],
    searchItem: function searchItem() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        name: "search",
        params: {
          searchText: this.searchText
        }
      }).catch(function (err) {});
    },
    menuOpen: function menuOpen(val) {
      this.mobileMenuOpen = val;
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavMenu_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ce095a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavMenu_vue__ = __webpack_require__(488);
function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57ce095a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ce095a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChildMenu__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["menu"],
  methods: {
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["a" /* getContrastYIQ */]
  },
  components: {
    ChildMenu: __WEBPACK_IMPORTED_MODULE_0__ChildMenu__["a" /* default */]
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChildMenu_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eed0880_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChildMenu_vue__ = __webpack_require__(484);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2eed0880"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChildMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eed0880_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChildMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChildMenu__ = __webpack_require__(187);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ChildMenu",
  props: ["menus", "left", "top"],
  components: {
    ChildMenu: __WEBPACK_IMPORTED_MODULE_0__ChildMenu__["a" /* default */]
  },
  mounted: function mounted() {// var that = this;
    // var childLi = document.querySelectorAll(".child-li");
    // childLi.forEach((ele) =>
    //   ele.addEventListener("mouseenter", function (event) {
    //     console.log("mouse-enter");
    //     //that.showChild(event);
    //     let childMenu = event.target.querySelector(".child-menu");
    //     if (childMenu) {
    //       childMenu.classList.add("child-menu-open");
    //     }
    //   })
    // );
    // childLi.forEach((ele) =>
    //   ele.addEventListener("mouseleave", function (event) {
    //     console.log("mouse-leave");
    //     //that.hideChild(event);
    //     let childMenu = event.target.querySelector(".child-menu");
    //     if (childMenu) {
    //       childMenu.classList.remove("child-menu-open");
    //     }
    //   })
    // );
  },
  methods: {// showChild: function (event) {
    //   let childMenu = event.target.querySelector(".child-menu");
    //   if (childMenu) {
    //     childMenu.style.visibility = "visible";
    //     childMenu.style.opacity = 1;
    //   }
    // },
    // hideChild: function (event) {
    //   let childMenu = event.target.querySelector(".child-menu");
    //   if (childMenu) {
    //     childMenu.style.visibility = "hidden";
    //     childMenu.style.opacity = 0;
    //   }
    // },
  }
});

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(485);

var iterableToArrayLimit = __webpack_require__(486);

var unsupportedIterableToArray = __webpack_require__(190);

var nonIterableRest = __webpack_require__(487);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(191);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileChildMenu__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mmenu_js_src_mmenu__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mmenu_js_dist_mmenu_polyfills__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mmenu_js_dist_mmenu_polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mmenu_js_dist_mmenu_polyfills__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "HeaderMobMenu",
  props: ["menus", "regulationBanner", "carnivalBanner", "regulationBannerSticky"],
  data: function data() {
    return {
      searchText: "",
      menuOpen: false,
      api: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    // if (window.innerWidth < 991) {
    //   this.onLoad();
    // }
    // window.addEventListener("resize", () => {
    //   this.onLoad();
    //   let windowWidth = window.innerWidth;
    //   if (!this.smallCardView && windowWidth >= 768) {
    //     this.smallCardView = true;
    //   }
    // });
    var menu = new __WEBPACK_IMPORTED_MODULE_1_mmenu_js_src_mmenu__["a" /* default */]("#mob-menu", {
      offcanvas: true
    });
    this.api = menu.API; // Remove href for all button

    document.querySelectorAll("a[href^='#mm']").forEach(function (ele) {
      var val = ele.getAttribute("href");
      ele.removeAttribute("href");
      ele.setAttribute("opentab", val);
      var pageLinkNode = ele.parentNode.querySelector(".page-links");

      if (pageLinkNode) {
        pageLinkNode.setAttribute("opentab", val);
      }
    });
    document.querySelectorAll("a[href='#app']").forEach(function (ele) {
      ele.removeAttribute("href");
      ele.setAttribute("opentab", "#app");
    }); // Open Close panel for opentab

    document.querySelectorAll("a[opentab^='#mm']").forEach(function (ele) {
      return ele.addEventListener("click", function () {
        var val = ele.getAttribute("opentab");

        _this.api.openPanel(document.querySelector(val));
      });
    }); // Replace Back to Menu title

    document.querySelectorAll(".mm-navbar__title span").forEach(function (ele) {
      if (_this.$root.i18n.back_to_menu) {
        ele.innerText = _this.$root.i18n.back_to_menu.toUpperCase();
      }
    });
    var that = this;
    document.body.addEventListener("click", function (event) {
      var menuDOM = document.getElementById("mob-menu");
      var headerDOM = document.getElementById("header");

      if (that.menuOpen && event.target != menuDOM && !menuDOM.contains(event.target) && event.target != headerDOM && !headerDOM.contains(event.target)) {
        that.closeMobMenu();
      }
    });
  },
  components: {
    MobileChildMenu: __WEBPACK_IMPORTED_MODULE_0__MobileChildMenu__["a" /* default */]
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__["a" /* getContrastYIQ */],
    closeMobMenu: function closeMobMenu() {
      this.menuOpen = false;
      this.$emit("menuOpen", false);

      if (this.menuOpen) {
        this.api.open();
      } else {
        this.api.close();
      }
    },
    openMobMenu: function openMobMenu() {
      this.menuOpen = true;
      this.$emit("menuOpen", true);

      if (this.menuOpen) {
        this.api.open();
      } else {
        this.api.close();
      }
    },
    searchItem: function searchItem() {
      this.closeMobMenu();
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        name: "search",
        params: {
          searchText: this.searchText
        }
      }).catch(function (err) {});
    },
    getHeaderHeight: function getHeaderHeight(regBanner, carBanner, regBannerSticky) {
      var headerDom = document.getElementById("header");

      if (headerDom) {
        if (carBanner && document.getElementById("carnival-banner")) {
          if (regBanner && document.getElementById("regulation-banner")) {
            return "".concat(document.getElementById("carnival-banner").offsetHeight + document.getElementById("regulation-banner").offsetHeight + headerDom.offsetHeight + (regBannerSticky && document.getElementById("sticky-regulation-banner") ? document.getElementById("sticky-regulation-banner").offsetHeight : 0), "px");
          } else {
            return "".concat(document.getElementById("carnival-banner").offsetHeight + headerDom.offsetHeight + (regBannerSticky && document.getElementById("sticky-regulation-banner") ? document.getElementById("sticky-regulation-banner").offsetHeight : 0), "px");
          }
        } else {
          if (regBanner && document.getElementById("regulation-banner")) {
            return "".concat(document.getElementById("regulation-banner").offsetHeight + headerDom.offsetHeight + (regBannerSticky && document.getElementById("sticky-regulation-banner") ? document.getElementById("sticky-regulation-banner").offsetHeight : 0), "px");
          } else {
            return "".concat(headerDom.offsetHeight + (regBannerSticky && document.getElementById("sticky-regulation-banner") ? document.getElementById("sticky-regulation-banner").offsetHeight : 0), "px");
          }
        }
      }
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileChildMenu_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0460f8ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileChildMenu_vue__ = __webpack_require__(494);
function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0460f8ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileChildMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0460f8ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileChildMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileChildMenu__ = __webpack_require__(193);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MobileChildMenu",
  props: ["menus", "parent"],
  components: {
    MobileChildMenu: __WEBPACK_IMPORTED_MODULE_0__MobileChildMenu__["a" /* default */]
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    blockUI: true,
    moveBackground: true
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    aria: true,
    text: true
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            aria: options,
            text: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    fix: true
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            fix: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var opts = {
    height: 'default'
};
/* harmony default export */ __webpack_exports__["a"] = (opts);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean' && options) {
        options = {
            height: 'auto'
        };
    }
    if (typeof options == 'string') {
        options = {
            height: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    close: false,
    open: false
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            close: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    add: false,
    visible: {
        min: 1,
        max: 3
    }
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            add: options
        };
    }
    if (typeof options == 'number') {
        options = {
            add: true,
            visible: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    if (typeof options.visible == 'number') {
        options.visible = {
            min: options.visible,
            max: options.visible
        };
    }
    return options;
}
;


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    add: false,
    addTo: 'panels',
    count: false
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            add: options,
            addTo: 'panels',
            count: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    if (options.addTo == 'panels') {
        options.addTo = '.mm-listview';
    }
    return options;
}


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    add: false,
    addTo: 'panels'
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            add: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    if (options.addTo == 'panels') {
        options.addTo = '.mm-listview';
    }
    return options;
}


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    open: false,
    node: null
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            open: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    drop: false,
    fitViewport: true,
    event: 'click',
    position: {},
    tip: true
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean' && options) {
        options = {
            drop: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    if (typeof options.position == 'string') {
        options.position = {
            of: options.position
        };
    }
    return options;
}
;


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_helpers__ = __webpack_require__(13);

var options = {
    use: false,
    top: [],
    bottom: [],
    position: 'left',
    type: 'default'
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__modules_helpers__["e" /* type */])(options) == 'array') {
        options = {
            use: true,
            top: options
        };
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__modules_helpers__["e" /* type */])(options) != 'object') {
        options = {};
    }
    if (typeof options.use == 'undefined') {
        options.use = true;
    }
    if (typeof options.use == 'boolean' && options.use) {
        options.use = true;
    }
    return options;
}


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    add: false,
    blockPanel: true,
    hideDivider: false,
    hideNavbar: true,
    visible: 3
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            add: options
        };
    }
    if (typeof options == 'number' ||
        typeof options == 'string') {
        options = {
            add: true,
            visible: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    enable: false,
    enhance: false
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean' || typeof options == 'string') {
        options = {
            enable: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    load: false
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            load: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = [];
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean' && options) {
        options = {};
    }
    if (typeof options != 'object') {
        options = {};
    }
    if (typeof options.content == 'undefined') {
        options.content = ['prev', 'title'];
    }
    if (!(options.content instanceof Array)) {
        options.content = [options.content];
    }
    if (typeof options.use == 'undefined') {
        options.use = true;
    }
    if (typeof options.use == 'boolean' && options.use) {
        options.use = true;
    }
    return options;
}
;


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    scroll: false,
    update: false
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            scroll: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    add: false,
    addTo: 'panels',
    cancel: false,
    noResults: 'No results found.',
    placeholder: 'Search',
    panel: {
        add: false,
        dividers: true,
        fx: 'none',
        id: null,
        splash: null,
        title: 'Search'
    },
    search: true,
    showTextItems: false,
    showSubPanels: true
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            add: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    if (typeof options.panel == 'boolean') {
        options.panel = {
            add: options.panel
        };
    }
    if (typeof options.panel != 'object') {
        options.panel = {};
    }
    //	Extend logical options.
    if (options.addTo == 'panel') {
        options.panel.add = true;
    }
    if (options.panel.add) {
        options.showSubPanels = false;
        if (options.panel.splash) {
            options.cancel = true;
        }
    }
    return options;
}
;


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    add: false,
    addTo: 'panels'
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            add: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    current: true,
    hover: false,
    parent: false
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            hover: options,
            parent: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extendShorthandOptions;
var options = {
    collapsed: {
        use: false,
        blockMenu: true,
        hideDivider: false,
        hideNavbar: true
    },
    expanded: {
        use: false,
        initial: 'open'
    }
};
/* harmony default export */ __webpack_exports__["a"] = (options);
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
function extendShorthandOptions(options) {
    if (typeof options == 'string' ||
        (typeof options == 'boolean' && options) ||
        typeof options == 'number') {
        options = {
            expanded: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    //	Extend collapsed shorthand options.
    if (typeof options.collapsed == 'boolean' && options.collapsed) {
        options.collapsed = {
            use: true
        };
    }
    if (typeof options.collapsed == 'string' ||
        typeof options.collapsed == 'number') {
        options.collapsed = {
            use: options.collapsed
        };
    }
    if (typeof options.collapsed != 'object') {
        options.collapsed = {};
    }
    //	Extend expanded shorthand options.
    if (typeof options.expanded == 'boolean' && options.expanded) {
        options.expanded = {
            use: true
        };
    }
    if (typeof options.expanded == 'string' ||
        typeof options.expanded == 'number') {
        options.expanded = {
            use: options.expanded
        };
    }
    if (typeof options.expanded != 'object') {
        options.expanded = {};
    }
    return options;
}


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_HomeLayout1__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_HomeLayout2__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Pages_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  data: function data() {
    return {
      responseData: "",
      templateCheck: ""
    };
  },
  components: {
    HomeLayout1: __WEBPACK_IMPORTED_MODULE_0__pages_HomeLayout1__["default"],
    HomeLayout2: __WEBPACK_IMPORTED_MODULE_1__pages_HomeLayout2__["default"]
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__api_Pages_api__["a" /* HttpService */].getHomePage(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$root.user_id, this.isPreview).then(function (res) {
      var resData1 = res.data.data;
      _this.templateCheck = resData1.hasOwnProperty("template") ? resData1.template : "";

      if (_this.templateCheck === "home-with-default") {
        _this.responseData = resData1;
      } else {
        _this.responseData = resData1;
      }

      _this.$root.loading = false;
      setTimeout(function () {
        if (res.status == 200) {
          __WEBPACK_IMPORTED_MODULE_2__api_Pages_api__["a" /* HttpService */].getHomepagewithscroll(_this.$root.wp_country && _this.$root.wp_country != "" ? _this.$root.wp_country : _this.$cookies.get("wp-country"), _this.$root.wp_state && _this.$root.wp_state != "" ? _this.$root.wp_state : _this.$cookies.get("wp-state"), _this.$root.user_id, _this.isPreview).then(function (res) {
            var resData2 = res.data.data;
            _this.templateCheck = resData2.hasOwnProperty("template") ? resData2.template : "";

            if (_this.templateCheck === "home-with-default") {
              _this.responseData.content.blocks = _this.responseData.content.blocks.concat(resData2.content.blocks);
            } else {
              _this.responseData.content.blocks = _this.responseData.content.blocks.concat(resData2.content.blocks);
            }

            _this.$root.loading = false;
            _this.$root.body_loading_status = true;
          }).catch(function (err) {
            return console.log(err);
          });
        }
      }, 2000);
    }).catch(function (err) {
      return console.log(err);
    });
  },
  beforeCreate: function beforeCreate() {
    this.$root.loading = true;
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_meta_changer__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  props: ["homeLayout1Data"],
  data: function data() {
    return {
      blockData1: [],
      blockData2: [],
      bluebar: {},
      recommend_section: {},
      content_after_top_games: "",
      content_after_best_payment_methods: {},
      card_testimonials: {},
      assets_images: {},
      isPreview: false,
      // Variables for infinite scroll
      pageBlockData1: [],
      pageBlockData2: [],
      block1Index: 0,
      block2Index: 0,
      card_testimonials_columns: "",
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      busy: false,
      scriptFlag: 0,
      showDesHom: false,
      auhtorBlockdata: [],
      rightBlockdata: []
    };
  },
  components: {
    CustomComponent: __WEBPACK_IMPORTED_MODULE_1__components_CustomComponent__["a" /* default */]
  },
  methods: {
    getOffset: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["b" /* getOffset */],
    pSBC: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["d" /* pSBC */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_4__misc_meta_changer__["a" /* metaChanger */],
    pageCountText: function pageCountText(hideShowCount, count, singularText, pluralText) {
      if (count === 0) {
        return hideShowCount ? "" : "0 ".concat(singularText);
      } else if (count > 1) {
        return pluralText != "" ? "".concat(count, " ").concat(pluralText) : "".concat(count, " ").concat(singularText);
      } else {
        return "".concat(count, " ").concat(singularText);
      }
    },
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function mutationObserve(mutations) {
      if (this.pageBlockData1.length < this.blockData1.length) {
        var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

        if (mainContentArea < window.innerHeight) {
          this.pageBlockData1 = this.blockData1.slice(0, this.block1Index + 1);
          this.block1Index++;
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.pageBlockData1.length < this.blockData1.length || this.pageBlockData2.length < this.blockData2.length) {
        this.busy = true;

        if (this.pageBlockData1.length < this.blockData1.length) {
          this.pageBlockData1 = this.blockData1.slice(0, this.block1Index + 1);
          this.block1Index++;
        } else {
          this.pageBlockData2 = this.blockData2.slice(0, this.block2Index + 1);
          this.block2Index++;
        } //this.heightCheck();


        this.busy = false;
      }
    },
    itemFAQBlue: function itemFAQBlue(data) {
      var finalData = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        finalData.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return finalData;
    }
  },
  // beforeCreate: function () {
  //   this.$root.loading = true;
  // },
  created: function created() {
    if (this.$root.routes_meta[wpvue_script_data_params.frontpage_slug] && this.$root.routes_meta[wpvue_script_data_params.frontpage_slug].metaTags) this.metaChanger(this.$root.routes_meta[wpvue_script_data_params.frontpage_slug].metaTags);

    if (Object.keys(this.$route.query).length > 0 && this.$route.query.preview) {
      if (this.$route.query.page === "home") {
        this.isPreview = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
          path: "preview",
          query: this.$route.query
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.homeLayout1Data) {
      this.blockData1 = [];
      var block1 = [];
      var data = this.homeLayout1Data;
      var blocks = data.content.blocks;
      var meta = data.meta;
      var toplist = blocks.filter(function (ele) {
        return ele.blockName === "wpvcb/casino-toplist" && (ele.attrs.style === "home_top_3" || !ele.attrs.style);
      }).sort(function (ele) {
        return ele.attrs.style === "home_top_3" ? -1 : 1;
      });
      block1.push.apply(block1, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(toplist));
      var faqBlue = blocks.filter(function (ele) {
        return ele.blockName === "wpvcb/faq" && ele.attrs && ele.attrs.style === "blue_bg";
      });
      var reqArray = ["wpvcb/home-promote-banner", "wpvcb/best-payment-methods", "wpvcb/game-guide-categories", "wpvcb/top-games", "wpvcb/top-games-articles"];
      reqArray.forEach(function (item) {
        var tempBlock = blocks.filter(function (ele) {
          return ele.blockName === item;
        });

        if (tempBlock.length > 0) {
          block1.push(tempBlock.shift());
        }
      });
      this.blockData1 = block1;
      var topGamesLoc = this.blockData1.map(function (ele, index) {
        return ele.blockName === "wpvcb/top-games" ? index : null;
      }).filter(function (val) {
        return val != null;
      }).shift();
      var topArtLoc = this.blockData1.map(function (ele, index) {
        return ele.blockName === "wpvcb/top-games-articles" ? index : null;
      }).filter(function (val) {
        return val != null;
      }).shift();

      if (faqBlue.length > 0) {
        if (topGamesLoc) {
          block1.splice.apply(block1, [topGamesLoc + 1, 0].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(faqBlue)));
        } else if (topArtLoc) {
          block1.splice.apply(block1, [topArtLoc, 0].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(faqBlue)));
        } else {
          block1.push.apply(block1, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(faqBlue));
        }
      }

      var block2 = blocks.filter(function (ele) {
        return reqArray.indexOf(ele.blockName) === -1 && ["wpvcb/casino-toplist", "wpvcb/faq", null].indexOf(ele.blockName) === -1;
      });
      var otherToplist = blocks.filter(function (ele) {
        return ele.blockName === "wpvcb/casino-toplist" && ele.attrs.style && ele.attrs.style != "home_top_3" || ele.blockName === "wpvcb/faq" && !ele.attrs.hasOwnProperty("style");
      });
      this.blockData2 = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(block2), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(otherToplist));

      if (meta.bluebar) {
        this.bluebar = meta.bluebar;
      } else {
        this.bluebar = {};
      }

      if (meta.card_testimonials) {
        this.card_testimonials = meta.card_testimonials;
        this.card_testimonials_columns = meta.card_testimonials_columns;
      } else {
        this.card_testimonials = [];
        this.card_testimonials_columns = "";
      }

      if (meta.content_after_best_payment_methods) {
        this.content_after_best_payment_methods = meta.content_after_best_payment_methods;
      } else {
        this.content_after_best_payment_methods = {};
      }

      if (meta.content_after_top_games) {
        this.content_after_top_games = meta.content_after_top_games;
      } else {
        this.content_after_top_games = "";
      }

      if (meta.recommend_section) {
        this.recommend_section = meta.recommend_section;
      } else {
        this.recommend_section = {};
      }

      document.getElementById("schema-script").innerHTML = data.schema; // Author Blocks Filtered

      var atBlock = blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

      var rightBlock = blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Adminbar Data

      this.$root.adminBarData = Object.keys(data.toolbar).length > 0 ? data.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : ""; // if (this.$root.enable_lazyload) {
      //   this.pageBlockData1.push(this.blockData1[this.block1Index]);
      //   this.block1Index++;
      //   this.$root.show_footer = false;
      // } else {

      this.pageBlockData1 = this.blockData1;
      this.pageBlockData2 = this.blockData2;
      this.$root.show_footer = true; //}

      if (this.scriptFlag === 0 && blocks.filter(function (ele) {
        return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
      }).length > 0) {
        this.youtubeInit();
        this.scriptFlag++;
      } //this.$root.loading = false;


      this.$nextTick(function () {
        return _this.heightCheck();
      });
      var that = this;
      window.addEventListener("scroll", function () {
        that.heightCheck();
      }, {
        passive: true
      });
      window.addEventListener("resize", function () {
        that.heightCheck();
      });
    }

    if (window.innerWidth > 576) {
      this.showDesHom = true;
    } else {
      this.showDesHom = false;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blockData1 = [];
    this.blockData2 = [];
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
    });
  },
  watch: {
    pageBlockData1: function pageBlockData1() {
      if (this.pageBlockData1.length === this.blockData1.length && this.pageBlockData2.length === this.blockData2.length) {
        this.$root.show_footer = true;
      }
    },
    pageBlockData2: function pageBlockData2() {
      if (this.pageBlockData1.length === this.blockData1.length && this.pageBlockData2.length === this.blockData2.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_Pages_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_lang__ = __webpack_require__(76);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CustomComponent',
  data: function data() {
    return {
      blockName: '',
      assetSizes: '',
      userArticleVote: {
        disabled: false,
        helpful: null
      },
      hideBonusLabel: false,
      rightContent: {},
      supportedLang: []
    };
  },
  props: ['blockData', 'recommendSection', 'bluebar', 'pageData', 'showHideObj', 'pageValue', 'blockIndex', 'scheme'],
  created: function created() {
    var _this = this;

    this.blockName = this.blockData.blockName;
    var asset_sizes = global.wpvue_script_data_params.data.site_data.asset_sizes;
    this.assetSizes = Object.keys(asset_sizes).length > 0 ? asset_sizes : "";

    if (this.pageData) {
      this.getBonusShowHide(this.pageData);

      if (this.pageData.supported_language) {
        this.supportedLang = JSON.parse(this.pageData.supported_language.language_name).map(function (ele) {
          return _this.getLang(ele);
        });
      } else {
        this.supportedLang = [];
      }
    }
  },
  mounted: function mounted() {
    if (this.blockName === 'wpvcb/home-banner') {
      this.loadComponentScript('home-banner');
    } else if (this.blockName === 'wpvcb/blue-progressive-block') {
      this.loadComponentScript('blue-progressive-block');
    } else if (this.blockName === 'wpvcb/content-icon-block') {
      this.loadComponentScript('content-icon-block');
    } else if (this.blockName === 'wpvcb/home-card-testimonials') {
      this.loadComponentScript('home-card-testimonials');
    } else if (this.blockName === 'wpvcb/faq') {
      this.loadComponentScript('faq-block');
    } else if (this.blockName === 'wpvcb/bullet-block') {
      this.loadComponentScript('bullet-block');
    } else if (this.blockName === 'wpvcb/testimonials') {
      this.loadComponentScript('user-testimonials');
    } else if (this.blockName === 'wpvcb/comparison-list-block') {
      this.loadComponentScript('comparison-list');
    } else if (this.blockName === 'wpvcb/published-date') {
      this.loadComponentScript('published-date');
    } else if (this.blockName === 'wpvcb/geo-text') {
      this.loadComponentScript('geo-text');
    } else if (this.blockName === 'wpvcb/custom-iframe') {
      this.loadComponentScript('custom-iframe');
    } else if (this.blockName === 'wpvcb/related-articles') {
      this.loadComponentScript('related-articles');
    } else if (this.blockName === 'wpvcb/geo-image') {
      this.loadComponentScript('geo-image');
    } else if (this.blockName === 'yoast/faq-block') {
      this.loadComponentScript('yoast-faq');
    } else if (this.blockName === 'wpvcb/news-block') {
      this.loadComponentScript('news-block');
    } else if (this.blockName === 'wpvcb/stream-block') {
      this.loadComponentScript('stream-block');
    } else if (this.blockName === 'wpvcb/author-block') {
      this.loadComponentScript('author-block');
    } else if (this.blockName === 'wpvcb/top-games') {
      this.loadComponentScript('top-games');
    } else if (this.blockName === 'wpvcb/howto-block') {
      this.loadComponentScript('howto-block');
    } else if (this.blockName === 'wpvcb/link-block') {
      this.loadComponentScript('link-block');
    } else if (this.blockName === 'wpvcb/intro-block') {
      this.loadComponentScript('intro-block');
    } else if (this.blockName === 'wpvcb/bonus-cards') {
      this.loadComponentScript('bonus-cards');
    } else if (this.blockName === 'wpvcb/tab-switcher') {
      this.loadComponentScript('tab-switcher');
    } else if (this.blockName === 'wpvcb/other-software-provider') {
      this.loadComponentScript('other-software-provider');
    } else if (this.blockName === 'wpvcb/bonus-information-block') {
      this.loadComponentScript('bonus-information-block');
    } else if (this.blockName === 'wpvcb/alternative-software-provider' && !!this.blockData.filtered_content.alternative_software_providers.posts) {
      this.loadComponentScript('alternative-software-provider');
    } else if (this.blockName === 'wpvcb/game-guide-categories') {
      this.loadComponentScript('game-guide-categories');
    } else if (this.blockName === 'wpvcb/best-payment-methods') {
      this.loadComponentScript('best-payment-methods');
    } else if (this.blockName === 'wpvcb/latest-casino') {
      this.loadComponentScript('latest-casino');
    } else if (this.blockName === 'wpvcb/top-promotions') {
      this.loadComponentScript('top-promotions');
    } else if (this.blockName === 'wpvcb/whitebg-content-block') {
      this.loadComponentScript('whitebg-content');
    } else if (this.blockName === 'wpvcb/team-block') {
      this.loadComponentScript('team-block');
    } else if (this.blockName === 'wpvcb/poker-hands') {
      this.loadComponentScript('poker-hands');
    } else if (this.blockName === 'wpvcb/newsletter') {
      this.loadComponentScript('newsletter-block');
    } else if (this.blockName === 'wpvcb/feature-promotion') {
      this.loadComponentScript('feature-promotion');
    } else if (this.blockName === 'wpvcb/home-promote-banner') {
      this.loadComponentScript('home-promote-banner');
    } else if (this.blockName === 'wpvcb/youtube-film-strip') {
      this.loadComponentScript('youtube-film-strip');
    } else if (this.blockName === 'wpvcb/exclusive-casino') {
      this.loadComponentScript('exclusive-casino');
    } else if (this.blockName === 'wpvcb/article-banner') {
      this.loadComponentScript('article-banner');
    } else if (this.blockName === 'wpvcb/pu-reference') {
      this.loadComponentScript('pu-reference');
    } else if (this.blockName === 'wpvcb/similar-casinos') {
      this.loadComponentScript('similar-casinos');
    } else if (this.blockName === 'wpvcb/casino-toplist' && !!this.blockData.filtered_content) {
      this.loadComponentScript('casino-toplist');
    } else if (this.blockName === 'wpvcb/main-casino-toplist') {
      this.loadComponentScript('main-casino-toplist');
    } else if (this.blockName === 'wpvcb/article-helpful-vote') {
      this.loadComponentScript('article-helpful-vote');
    } else if (this.blockName === 'wpvcb/top-games-articles') {
      this.loadComponentScript('top-games-articles');
    } else if (this.blockName === 'simpletoc/toc') {
      this.loadComponentScript('simple-toc');
    } else if (this.blockName === 'wpvcb/alternative-payment-options' && !!this.blockData.filtered_content.alternative_payment_methods) {
      this.loadComponentScript('alternative-payment-options');
    } else if (this.blockName === 'wpvcb/software-provider-block') {
      this.loadComponentScript('software-provider-block');
    } else if (this.blockName === 'wpvcb/payment-option-block') {
      this.loadComponentScript('payment-option-block');
    } else if (this.blockName === 'wpvcb/languages-supports-block') {
      this.loadComponentScript('languages-supports-block');
    } else if (this.blockName === 'wpvcb/recommended-casinos') {
      this.loadComponentScript('recommended-casinos');
    } else if (this.blockName === 'core/shortcode') {
      this.loadComponentScript('core-shortcode');
    } else if (this.blockName === null) {
      this.loadComponentScript('null-block');
    } else if (this.isCoreBlock(this.blockName) && this.blockName != null) {
      this.loadComponentScript('core-content');
    }
  },
  methods: {
    getLang: __WEBPACK_IMPORTED_MODULE_1__misc_lang__["a" /* getLang */],
    getBonusShowHide: function getBonusShowHide(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    },
    changeCasloading: function changeCasloading(event) {
      this.$root.casloading = event.detail[0];
    },
    routeToPage: function routeToPage(event) {
      this.$router.push("".concat(event.detail[0]));
    },
    getUserArticleVote: function getUserArticleVote(event) {
      var _this2 = this;

      var value = "".concat(event.detail[0]);

      if (this.$root.user_id != 0) {
        __WEBPACK_IMPORTED_MODULE_0__api_Pages_api__["a" /* HttpService */].userArticleVote(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.params.postSlug, this.$root.user_id, value).then(function (res) {
          var resData = res.data.data;

          if (resData.user_vote === false) {
            _this2.userArticleVote.disabled = false;
          } else if (resData.user_vote === "up") {
            _this2.userArticleVote.disabled = true;
            _this2.userArticleVote.helpful = true;
          } else if (resData.user_vote === "down") {
            _this2.userArticleVote.disabled = true;
            _this2.userArticleVote.helpful = false;
          }
        }).catch(function (err) {
          return console.log(err);
        });
      } else {
        this.userArticleVote.disabled = true;
      }
    },
    getAlternativePaymentData: function getAlternativePaymentData(paymentData) {
      var _this3 = this;

      return JSON.stringify(paymentData.map(function (ele) {
        return {
          ID: ele.ID,
          title: ele.title,
          slug: ele.slug,
          post_name: ele.post_name,
          post_type: ele.post_type,
          payment_category: ele.payment_category,
          count: {
            url: ele.count.asset_category_name === _this3.assetSizes.pao_asset_sizes.medium ? ele.count.url : '',
            name: ele.count.name,
            overview: ele.count.overview,
            toplist_count: ele.count.toplist_count
          }
        };
      }));
    },
    getOtherSoftwareProviderData: function getOtherSoftwareProviderData(softwareData) {
      return JSON.stringify(softwareData.map(function (ele) {
        return {
          soft_info: {
            sw_name: ele.soft_info.sw_name,
            swa_url: ele.soft_info.swa_url
          },
          slug: ele.slug,
          type: ele.type
        };
      }));
    },
    getBestPaymentData: function getBestPaymentData(paymentData) {
      return JSON.stringify(paymentData.map(function (ele) {
        return {
          ID: ele.ID,
          post_title: ele.post_title,
          slug: ele.slug,
          post_name: ele.post_name,
          type: ele.type,
          payment_category: ele.payment_category,
          casino_count: {
            url: ele.casino_count.url,
            name: ele.casino_count.name,
            overview: ele.casino_count.overview,
            toplist_count: ele.casino_count.toplist_count
          }
        };
      }));
    },
    getAlternativeSoftwareProviderData: function getAlternativeSoftwareProviderData(softwareData) {
      return JSON.stringify(softwareData.filter(function (ele) {
        return ele.soft_info.sw_overview;
      }).map(function (ele) {
        return {
          soft_info: {
            sw_name: ele.soft_info.sw_name,
            swa_url: ele.soft_info.swa_url,
            sw_overview: ele.soft_info.sw_overview,
            products_count: ele.soft_info.products_count
          },
          ID: ele.ID,
          slug: ele.slug,
          type: ele.type
        };
      }));
    },
    isCoreBlock: function isCoreBlock(block) {
      var vue_blocks = Object.values(global.wpvue_script_data_params.data.vue_blocks);
      if (!(vue_blocks.indexOf(block) > -1)) return true;else return false;
    },
    exclusiveCasinoData: function exclusiveCasinoData(casinoData) {
      var _this4 = this;

      return JSON.stringify(casinoData.map(function (ele) {
        return {
          product_name: ele.product_name,
          go_link: ele.go_link,
          slug: ele.slug,
          rating: ele.rating,
          bonus_match: ele.bonus_match,
          review_link: ele.review_link,
          exclusive_bonus_amount: ele.exclusive_bonus_amount,
          exclusive_bonus_match: ele.exclusive_bonus_match,
          bonus_amount: ele.bonus_amount,
          bonus_currency: ele.bonus_currency,
          freespin: ele.freespin,
          freebie_name: ele.freebie_name,
          show_freebie_currency: ele.show_freebie_currency,
          cta_button_text: ele.cta_button_text,
          bonus_tc: ele.bonus_tc,
          terms: ele.terms,
          term_link: ele.term_link,
          asset_url: _this4.getAssetUrl(ele.product_assets, _this4.assetSizes.pro_asset_sizes.medium),
          bg_asset_url: _this4.getAssetUrl(ele.product_assets, _this4.assetSizes.pro_asset_sizes.background),
          banned_time_from: ele.banned_time_from,
          banned_time_to: ele.banned_time_to,
          show_bonus: ele.show_bonus,
          hide_bonus: ele.hide_bonus,
          hide_toplist: ele.hide_toplist
        };
      }));
    },
    getTopGamesData: function getTopGamesData(gamesData) {
      return JSON.stringify(gamesData.map(function (ele) {
        return {
          banner: ele.banner,
          title: ele.title,
          post_title: ele.post_title,
          category: ele.category,
          geo_provider_partners_data: ele.geo_provider_partners_data ? {
            current: {
              go_link: ele.geo_provider_partners_data.current.go_link,
              product_name: ele.geo_provider_partners_data.current.product_name,
              slug: ele.geo_provider_partners_data.current.slug
            }
          } : undefined,
          game_tag: ele.game_tag ? {
            color: ele.game_tag.color,
            tag_name: ele.game_tag.tag_name
          } : {},
          meta: {
            play_for_free_url: ele.meta.play_for_free_url
          },
          slug: ele.slug,
          post_type: ele.post_type,
          type: ele.type,
          provider_name: ele.provider_name,
          provider_link: ele.provider_link
        };
      }));
    },
    coreBlockData: function coreBlockData(blockData) {
      if (blockData.innerBlocks.length > 0) {
        return JSON.stringify(blockData.filtered_content);
      } else {
        return JSON.stringify(blockData.innerHTML);
      }
    },
    coreBlockAttrs: function coreBlockAttrs(blockData) {
      if (Object.keys(blockData.attrs).length > 0) {
        return JSON.stringify(blockData.attrs);
      } else {
        return '';
      }
    },
    yoastFaqData: function yoastFaqData(blockData) {
      if (blockData.attrs && blockData.attrs.questions.length > 0) {
        return JSON.stringify(blockData.attrs.questions.map(function (ele) {
          return {
            id: ele.id,
            jsonAnswer: ele.jsonAnswer,
            jsonQuestion: ele.jsonQuestion
          };
        }));
      } else {
        return '[]';
      }
    },
    gameGuideData: function gameGuideData(blockData) {
      return JSON.stringify(blockData.filtered_content.map(function (ele) {
        return {
          name: ele.name,
          thumbnail: ele.thumbnail,
          hover_thumbnail: ele.hover_thumbnail,
          description: ele.description,
          goto: ele.goto
        };
      }));
    },
    getAssetUrl: function getAssetUrl(assetsArray, assetCatName) {
      var filteredAsset = assetsArray.filter(function (ele) {
        return ele.asset_category_name === assetCatName;
      });
      if (filteredAsset.length > 0) return filteredAsset[0].url;else return this.$root.site_url + this.$root.asset_path + '/failure.png';
    },
    getHomeBannerToplist: function getHomeBannerToplist(toplistData) {
      var _this5 = this;

      if (!toplistData) return [];
      return JSON.stringify(toplistData.map(function (ele) {
        return {
          product_name: ele.product_name,
          go_link: ele.go_link,
          slug: ele.slug,
          asset_url: _this5.getAssetUrl(ele.product_assets, _this5.assetSizes.pro_asset_sizes.medium),
          goto: ele.goto,
          tags: ele.tags,
          review_link: ele.review_link,
          bonus_match: ele.bonus_match,
          bonus_amount: ele.bonus_amount,
          exclusive_bonus_amount: ele.exclusive_bonus_amount,
          exclusive_bonus_match: ele.exclusive_bonus_match,
          bonus_currency: ele.bonus_currency,
          freespin: ele.freespin,
          freebie_name: ele.freebie_name,
          show_freebie_currency: ele.show_freebie_currency,
          cta_button_text: ele.cta_button_text,
          bonus_tc: ele.bonus_tc,
          terms: ele.terms,
          banned_time_from: ele.banned_time_from,
          banned_time_to: ele.banned_time_to,
          show_bonus: ele.show_bonus,
          hide_bonus: ele.hide_bonus,
          hide_toplist: ele.hide_toplist
        };
      }));
    },
    getSimilarCasinoData: function getSimilarCasinoData(toplistData) {
      var _this6 = this;

      return JSON.stringify(toplistData.map(function (ele) {
        return {
          product_name: ele.product_name,
          go_link: ele.go_link,
          slug: ele.slug,
          bg_asset_url: _this6.getAssetUrl(ele.product_assets, _this6.assetSizes.pro_asset_sizes.background).includes('failure') ? _this6.getAssetUrl(ele.product_assets, 'product_logo_background') : _this6.getAssetUrl(ele.product_assets, _this6.assetSizes.pro_asset_sizes.background),
          img_asset_url: _this6.getAssetUrl(ele.product_assets, _this6.assetSizes.pro_asset_sizes.medium),
          tags: ele.tags,
          review_link: ele.review_link,
          rating: ele.rating,
          bonus_match: ele.bonus_match,
          bonus_amount: ele.bonus_amount,
          exclusive_bonus_amount: ele.exclusive_bonus_amount,
          exclusive_bonus_match: ele.exclusive_bonus_match,
          bonus_currency: ele.bonus_currency,
          freespin: ele.freespin,
          freebie_name: ele.freebie_name,
          show_freebie_currency: ele.show_freebie_currency,
          cta_button_text: ele.cta_button_text,
          bonus_tc: ele.bonus_tc,
          terms: ele.terms,
          supported_payments: ele.supported_payments,
          supported_payments_total: ele.supported_payments_total
        };
      }));
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(570);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(28);
var normalizeHeaderName = __webpack_require__(575);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(223);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(223);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);
var settle = __webpack_require__(576);
var buildURL = __webpack_require__(220);
var buildFullPath = __webpack_require__(578);
var parseHeaders = __webpack_require__(581);
var isURLSameOrigin = __webpack_require__(582);
var createError = __webpack_require__(224);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(583);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(577);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_meta_changer__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  props: ["homeLayout2Data"],
  data: function data() {
    return {
      blockData: [],
      bluebar: {},
      recommend_section: {},
      content_after_top_games: "",
      content_after_best_payment_methods: {},
      assets_images: {},
      isPreview: false,
      // Variables for infinite scroll
      pageBlockData: [],
      blockIndex: 0,
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      busy: false,
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: []
    };
  },
  components: {
    CustomComponent: __WEBPACK_IMPORTED_MODULE_1__components_CustomComponent__["a" /* default */]
  },
  methods: {
    getOffset: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["b" /* getOffset */],
    pSBC: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["d" /* pSBC */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_4__misc_meta_changer__["a" /* metaChanger */],
    pageCountText: function pageCountText(hideShowCount, count, singularText, pluralText) {
      if (count === 0) {
        return hideShowCount ? "" : "0 ".concat(singularText);
      } else if (count > 1) {
        return pluralText != "" ? "".concat(count, " ").concat(pluralText) : "".concat(count, " ").concat(singularText);
      } else {
        return "".concat(count, " ").concat(singularText);
      }
    },
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function mutationObserve(mutations) {
      if (this.pageBlockData.length < this.blockData.length) {
        var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

        if (mainContentArea < window.innerHeight) {
          this.pageBlockData = this.blockData.slice(0, this.blockIndex + 1);
          this.blockIndex++;
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.pageBlockData.length < this.blockData.length) {
        this.busy = true;
        this.pageBlockData = this.blockData.slice(0, this.blockIndex + 1);
        this.blockIndex++; //this.heightCheck();

        this.busy = false;
      }
    },
    itemFAQBlue: function itemFAQBlue(data) {
      var finalData = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        finalData.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return finalData;
    }
  },
  // beforeCreate: function () {
  //   this.$root.loading = true;
  // },
  created: function created() {
    if (this.$root.routes_meta[wpvue_script_data_params.frontpage_slug] && this.$root.routes_meta[wpvue_script_data_params.frontpage_slug].metaTags) this.metaChanger(this.$root.routes_meta[wpvue_script_data_params.frontpage_slug].metaTags);

    if (Object.keys(this.$route.query).length > 0 && this.$route.query.preview) {
      if (this.$route.query.page === "home") {
        this.isPreview = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
          path: "preview",
          query: this.$route.query
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.homeLayout2Data) {
      this.blockData = [];
      var block = [];
      var data = this.homeLayout2Data;
      var blocks = data.content.blocks;
      var meta = data.meta;
      var homebannerBlock = blocks.filter(function (ele) {
        return ele.blockName === "wpvcb/home-banner";
      });
      block.push.apply(block, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(homebannerBlock));
      var introBlock = blocks.filter(function (ele) {
        return ele.blockName === "wpvcb/intro-block";
      });
      block.push.apply(block, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(introBlock));
      var toplist = blocks.filter(function (ele) {
        return ele.blockName === "wpvcb/casino-toplist" && (ele.attrs.style === "home_top_3" || !ele.attrs.style);
      }).sort(function (ele) {
        return ele.attrs.style === "home_top_3" ? -1 : 1;
      });
      block.push.apply(block, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(toplist));
      var otherBlocks = blocks.filter(function (ele) {
        return !(ele.blockName === "wpvcb/casino-toplist" && (ele.attrs.style === "home_top_3" || !ele.attrs.style)) && !(ele.blockName === "wpvcb/intro-block") && !(ele.blockName === "wpvcb/home-banner");
      });
      block.push.apply(block, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(otherBlocks));
      this.blockData = block;

      if (meta.bluebar) {
        this.bluebar = meta.bluebar;
      } else {
        this.bluebar = {};
      }

      if (meta.content_after_best_payment_methods) {
        this.content_after_best_payment_methods = meta.content_after_best_payment_methods;
      } else {
        this.content_after_best_payment_methods = {};
      }

      if (meta.content_after_top_games) {
        this.content_after_top_games = meta.content_after_top_games;
      } else {
        this.content_after_top_games = "";
      }

      if (meta.recommend_section) {
        this.recommend_section = meta.recommend_section;
      } else {
        this.recommend_section = {};
      }

      document.getElementById("schema-script").innerHTML = data.schema; // Author Blocks Filtered

      var atBlock = blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

      var rightBlock = blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Adminbar Data

      this.$root.adminBarData = Object.keys(data.toolbar).length > 0 ? data.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : ""; // if (this.$root.enable_lazyload) {
      //   this.pageBlockData.push(this.blockData[this.blockIndex]);
      //   this.blockIndex++;
      //   this.$root.show_footer = false;
      // } else {

      this.pageBlockData = this.blockData;
      this.$root.show_footer = true; //}
      //this.$root.loading = false; not included

      if (this.scriptFlag === 0 && blocks.filter(function (ele) {
        return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
      }).length > 0) {
        this.youtubeInit();
        this.scriptFlag++;
      }

      this.$nextTick(function () {
        return _this.heightCheck();
      });
      var that = this;
      window.addEventListener("scroll", function () {
        that.heightCheck();
      }, {
        passive: true
      });
      window.addEventListener("resize", function () {
        that.heightCheck();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blockData = [];
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
    });
  },
  watch: {
    pageBlockData: function pageBlockData() {
      if (this.pageBlockData.length === this.blockData.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Article__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Review_Review__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Review_ReviewWithBlocks__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_GameGuideHolder__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_GameFree_GameFree__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_DefaultPage__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_MapTemplate__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_AboutUs__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_CalendarTemplate__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_PaymentOptions_PaymentOptions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_SoftwareProviders_SoftwareProviders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Promotions_Promotions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_News_News__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Streams_Streams__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_HomeLayout1__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_HomeLayout2__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_Pages_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Index",
  components: {
    Article: __WEBPACK_IMPORTED_MODULE_0__pages_Article__["default"],
    Review: __WEBPACK_IMPORTED_MODULE_1__pages_Review_Review__["default"],
    News: __WEBPACK_IMPORTED_MODULE_12__pages_News_News__["default"],
    Streams: __WEBPACK_IMPORTED_MODULE_13__pages_Streams_Streams__["default"],
    GameFree: __WEBPACK_IMPORTED_MODULE_4__pages_GameFree_GameFree__["default"],
    PaymentOptions: __WEBPACK_IMPORTED_MODULE_9__pages_PaymentOptions_PaymentOptions__["default"],
    GameGuideHolder: __WEBPACK_IMPORTED_MODULE_3__pages_GameGuideHolder__["default"],
    SoftwareProviders: __WEBPACK_IMPORTED_MODULE_10__pages_SoftwareProviders_SoftwareProviders__["default"],
    Promotions: __WEBPACK_IMPORTED_MODULE_11__pages_Promotions_Promotions__["default"],
    DefaultPage: __WEBPACK_IMPORTED_MODULE_5__pages_DefaultPage__["default"],
    MapTemplate: __WEBPACK_IMPORTED_MODULE_6__pages_MapTemplate__["default"],
    AboutUs: __WEBPACK_IMPORTED_MODULE_7__pages_AboutUs__["default"],
    CalendarTemplate: __WEBPACK_IMPORTED_MODULE_8__pages_CalendarTemplate__["default"],
    NotFound: __WEBPACK_IMPORTED_MODULE_14__pages_404__["default"],
    ReviewWithBlocks: __WEBPACK_IMPORTED_MODULE_2__pages_Review_ReviewWithBlocks__["default"],
    HomeLayout1: __WEBPACK_IMPORTED_MODULE_15__pages_HomeLayout1__["default"],
    HomeLayout2: __WEBPACK_IMPORTED_MODULE_16__pages_HomeLayout2__["default"]
  },
  data: function data() {
    return {
      responseData: "",
      typeCheck: "",
      templateCheck: ""
    };
  },
  created: function created() {
    this.getIndexData();
  },
  methods: {
    getIndexData: function getIndexData() {
      var _this = this;

      var caslist = {};
      var storedBreadcrumbData = localStorage.getItem("storedbreadcrumbData");

      if (storedBreadcrumbData && storedBreadcrumbData !== 'undefined' && JSON.parse(storedBreadcrumbData || "[]").length > 0) {
        var that = this;
        var catList = JSON.parse(storedBreadcrumbData || "[]").filter(function (ele) {
          return ele.slug === that.$route.params.postSlug;
        });

        if (catList.length > 0 && catList[0].hasOwnProperty("cat")) {
          caslist = {
            cat: catList[0].cat
          };
        } else {
          if (localStorage.getItem("storedPageName") === that.$route.params.postSlug) caslist = {
            cat: localStorage.getItem("storedData")
          };
        }
      }

      __WEBPACK_IMPORTED_MODULE_17__api_Pages_api__["a" /* HttpService */].getBody(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.params.postSlug, this.$root.user_id, caslist).then(function (res) {
        var resData = res.data.data;

        if (resData.hasOwnProperty("code")) {
          _this.typeCheck = "error";
        } else {
          _this.typeCheck = resData.type;
          _this.templateCheck = resData.template;

          if (_this.typeCheck === "post") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "game-guide-holder") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "about-us") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "game_free" || _this.typeCheck === "game_paid") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && (_this.templateCheck === "default-page" || _this.templateCheck === "")) {
            _this.responseData = resData;
          } else if (_this.typeCheck === "news") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "streams") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "usmap-page") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "home-with-default") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "feast-group") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "review" && !_this.templateCheck) {
            _this.responseData = resData;
          } else if (_this.typeCheck === "review" && _this.templateCheck) {
            _this.responseData = resData;
          } else if (_this.typeCheck === "software_providers") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "promotions" || _this.typeCheck === "page" && _this.templateCheck === "promotions-landing") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "payment_options") {
            _this.responseData = resData;
          }
        }

        _this.$root.loading = false;
        _this.$root.body_loading_status = true;
      }).catch(function (err) {
        _this.typeCheck = "error";
        _this.$root.loading = false;
      });
    }
  },
  beforeCreate: function beforeCreate() {
    this.$root.loading = true;
  },
  watch: {
    $route: function $route() {
      this.$root.loading = true;
      this.responseData = "";
      this.getIndexData();
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_meta_changer__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Article",
  props: ["articleData"],
  data: function data() {
    return {
      helpful: null,
      top_block: {
        type: Object,
        default: function _default() {}
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      top_casino_title: "",
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      bluebar: {}
    };
  },
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_2__components_custom_block_RelatedLinks__["a" /* default */]
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags); // Schema Append

    document.getElementById("schema-script").innerHTML = this.articleData.schema; // Blocks Filtered

    var title = this.articleData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/heading") {
        return ele.filtered_content;
      }
    });
    var content = this.articleData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/paragraph") {
        return ele.filtered_content;
      }
    });
    var emoji_section = this.articleData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/html") {
        return ele.filtered_content;
      }
    });
    this.top_block = {
      title: title,
      content: content,
      emoji_section: emoji_section
    }; // More Payments Bottom Card

    this.morePaymentBottom = this.articleData.meta.more_payment_method; // Author Blocks Filtered

    var atBlock = this.articleData.content.blocks.filter(function (ele) {
      if (ele.blockName === "wpvcb/author-block") {
        return ele.filtered_content;
      }
    });
    if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

    var rightBlock = this.articleData.content.blocks.filter(function (ele) {
      if (ele.blockName === "wpvcb/right-content-simpletoc") {
        return ele.filtered_content;
      }
    });
    if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Adminbar Data

    this.$root.adminBarData = Object.keys(this.articleData.toolbar).length > 0 ? this.articleData.toolbar : "";
    this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

    this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
  },
  mounted: function mounted() {
    var _this = this;

    // if (this.$root.enable_lazyload) {
    //   this.incrementBlockDataValue();
    //   this.$root.show_footer = false;
    // } else {
    this.blockData = this.articleData.content.blocks;
    this.$root.show_footer = true; //}

    if (this.scriptFlag === 0 && this.articleData.content.blocks.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(function () {
      return _this.heightCheck();
    });
    var that = this;
    window.addEventListener("scroll", function () {
      that.heightCheck();
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
    });
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["a" /* getContrastYIQ */],
    getOffset: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["b" /* getOffset */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_4__misc_meta_changer__["a" /* metaChanger */],
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function mutationObserve(mutations) {
      if (this.blockData.length < this.articleData.content.blocks.length) {
        var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.blockData.length < this.articleData.content.blocks.length) {
        this.busy = true;
        this.incrementBlockDataValue(); //this.heightCheck();

        this.busy = false;
      }
    },
    incrementBlockDataValue: function incrementBlockDataValue() {
      this.blockData = this.articleData.content.blocks.slice(0, this.blockDataIndex + 1);
      this.blockDataIndex++;
    },
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    }
  },
  watch: {
    blockData: function blockData() {
      if (this.blockData.length === this.articleData.content.blocks.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Breadcrumb",
  props: ["breadcrumbData", "dark", "templateName", "gameBlockTitle"],
  methods: {
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__["a" /* getContrastYIQ */]
  },
  mounted: function mounted() {
    if (this.breadcrumbData) {
      localStorage.setItem("storedbreadcrumbData", JSON.stringify(this.breadcrumbData));

      if (this.breadcrumbData.length > 0) {
        var catNewsList = this.breadcrumbData.filter(function (ele) {
          return ele.hasOwnProperty("cat");
        });

        if (catNewsList.length > 0) {
          localStorage.setItem("storedData", catNewsList[0].cat);
          localStorage.setItem("storedPageName", catNewsList[0].slug);
        }
      }
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//import { dragscroll } from "vue-dragscroll";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "RelatedLinks",
  props: ["relatedLinkData"],
  // directives: {
  //   dragscroll: dragscroll,
  // },
  mounted: function mounted() {
    var target = this.$refs.hRScroll;

    if (target) {
      target.addEventListener("wheel", function (event) {
        var toLeft = event.deltaY < 0 && target.scrollLeft > 0;
        var toRight = event.deltaY > 0 && target.scrollLeft < target.scrollWidth - target.clientWidth;

        if (toLeft || toRight) {
          event.preventDefault();
          target.scrollLeft += event.deltaY;
        }
      });
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_SimilarCasino__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_StarRating__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_custom_block_ContentIcon__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_custom_block_BonusInformation__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_custom_block_ComparisonList__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_custom_block_PromotionBannerSuggest__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_custom_block_Author__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_custom_block_NotSupportModal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__misc_currency__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__misc_lang__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_Pages_api__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Review",
  props: ["reviewData"],
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2__components_ui_StarRating__["a" /* default */],
    SimilarCasino: __WEBPACK_IMPORTED_MODULE_1__components_layouts_SimilarCasino__["a" /* default */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components_layouts_Breadcrumb__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_4__components_custom_block_RelatedLinks__["a" /* default */],
    ContentIcon: __WEBPACK_IMPORTED_MODULE_5__components_custom_block_ContentIcon__["a" /* default */],
    PromotionBannerSuggest: __WEBPACK_IMPORTED_MODULE_8__components_custom_block_PromotionBannerSuggest__["a" /* default */],
    ComparisonList: __WEBPACK_IMPORTED_MODULE_7__components_custom_block_ComparisonList__["a" /* default */],
    BonusInformation: __WEBPACK_IMPORTED_MODULE_6__components_custom_block_BonusInformation__["a" /* default */],
    Author: __WEBPACK_IMPORTED_MODULE_9__components_custom_block_Author__["a" /* default */],
    NotSupportModal: __WEBPACK_IMPORTED_MODULE_10__components_custom_block_NotSupportModal__["a" /* default */],
    NotFound: __WEBPACK_IMPORTED_MODULE_11__pages_404__["default"]
  },
  filters: {
    currency: __WEBPACK_IMPORTED_MODULE_12__misc_currency__["a" /* default */]
  },
  data: function data() {
    return {
      pageAttr: {
        type: Object,
        default: function _default() {}
      },
      pageData: {
        type: Object,
        default: function _default() {}
      },
      tabData: {},
      supportEmail: "",
      contactName: "",
      contactNumber: "",
      breadCrumb: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      supportedLang: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      showHideObj: {
        spTop: false,
        pmTop: false,
        liscTop: false,
        spMidSc: false,
        liscUnderSc: false,
        dipositSc: false,
        withdrawSc: false
      },
      activeKey: "",
      scrollOffset: 0,
      metaData: "",
      busy: false,
      pageIndex: 0,
      stickyNavTop: 0,
      showSticky: true,
      clickCount: 0,
      topStickyHeight: 0,
      topHeaderStickyHeight: 0,
      hideBonusLabel: false,
      hideToplistLabel: false,
      auhtorBlockdata: [],
      typeCheck: ""
    };
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_14__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_14__misc_misc_function__["a" /* getContrastYIQ */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_15__misc_meta_changer__["a" /* metaChanger */],
    getOffset: __WEBPACK_IMPORTED_MODULE_14__misc_misc_function__["b" /* getOffset */],
    getLang: __WEBPACK_IMPORTED_MODULE_13__misc_lang__["a" /* getLang */],
    getStarPercentage: function getStarPercentage(rating) {
      // Direct fill color
      // if (rating === 1) {
      //   return {
      //     background:
      //       "linear-gradient(90deg,#dd1d00 -2.17%,#dd1d00 37.74%,#dd1d00 72.86%,#dd1d00 100%)",
      //     width: (rating / 5) * 100 + "%",
      //   };
      // } else if (rating > 1 && rating <= 3) {
      //   return {
      //     background:
      //       "linear-gradient(90deg,#f6ad00 -2.17%,#f6ad00 37.74%,#f6ad00 72.86%,#f6ad00 100%)",
      //     width: (rating / 5) * 100 + "%",
      //   };
      // } else if (rating > 3 && rating <= 5) {
      //   return {
      //     background:
      //       "linear-gradient(90deg,#4caf50 -2.17%,#4caf50 37.74%,#4caf50 72.86%,#4caf50 100%)",
      //     width: (rating / 5) * 100 + "%",
      //   };
      // }
      //// Gradient color
      if (rating === 1) {
        return {
          background: "linear-gradient(90deg,#dd1d00 -2.17%,#dd1d00 37.74%,#dd1d00 72.86%,#dd1d00 100%)",
          width: rating / 5 * 100 + "%"
        };
      } else if (rating > 1 && rating <= 3) {
        return {
          background: "linear-gradient(90deg,#dd1d00 -2.17%,#f6ad00 37.74%,#f6ad00 72.86%,#f6ad00 100%)",
          width: rating / 5 * 100 + "%"
        };
      } else if (rating > 3 && rating <= 5) {
        if (rating > 3 && rating <= 4) {
          return {
            background: "linear-gradient(90deg,#dd1d00 -2.17%,#f6ad00 37.74%,#7cdd00 72.86%,#7cdd00 100%)",
            width: rating / 5 * 100 + "%"
          };
        } else {
          return {
            background: "linear-gradient(90deg,#dd1d00 -2.17%,#f6ad00 37.74%,#7cdd00 72.86%,#68c783 100%)",
            width: rating / 5 * 100 + "%"
          };
        }
      }
    },
    prosconsReview: function prosconsReview(value) {
      var filterpositiveValue = value.filter(function (ele) {
        return ele.is_positive === "1";
      });
      var negativeValue = value.filter(function (elem) {
        return elem.is_positive === "0";
      });

      if (negativeValue.length > 0) {
        if (filterpositiveValue.length > 0) {
          var retArr = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(filterpositiveValue.slice(0, 3)), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(negativeValue.slice(0, 1)));
          return retArr;
        }
      } else {
        if (filterpositiveValue.length > 0) {
          return filterpositiveValue.slice(0, 4);
        }
      }
    },
    getFinalStarPercentage: function getFinalStarPercentage(rating) {
      if (rating === 1) {
        return "#dd1d00";
      } else if (rating > 1 && rating <= 3) {
        return "#f6ad00";
      } else if (rating > 3 && rating <= 5) {
        return "#4caf50";
      }
    },
    getFinalStarPercentageLabel: function getFinalStarPercentageLabel(rating) {
      if (rating > 0 && rating <= 3) {
        return this.$root.i18n.review_1_to_3_rating_label;
      } else if (rating > 3 && rating <= 5) {
        return this.$root.i18n.review_4_to_5_rating_label;
      }
    },
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    getBonusShowHide: function getBonusShowHide(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    },
    updateBonusHeight: function updateBonusHeight() {
      var heightArr = [];
      document.querySelectorAll(".sticky-inner").forEach(function (ele) {
        heightArr.push(ele.clientHeight);
      });
      this.topStickyHeight = Math.max.apply(Math, heightArr);

      if (document.getElementById("review-sticky-card")) {
        if (window.innerWidth > 991) {
          document.getElementById("review-sticky-card").style.top = "-".concat(this.topStickyHeight + 1, "px");
        } else {
          document.getElementById("review-sticky-card").style.top = null;
        }
      }

      this.topHeaderStickyHeight = document.getElementById("sticky-header") ? document.getElementById("sticky-header").offsetHeight : 0;
      document.querySelectorAll(".sticky-review-card").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightArr), "px");
      });
    },
    loadMore: function loadMore() {
      this.busy = true;
      this.pageIndex++;
      this.busy = false;
    },
    getPageData: function getPageData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_16__api_Pages_api__["a" /* HttpService */].getBody(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.params.postSlug, this.$root.user_id).then(function (res) {
        // this.pageData = res.data.data.content.blocks
        //   .filter((ele) => ele.blockName === "wpvcb/review-details")
        //   .shift()
        //   ? res.data.data.content.blocks
        //       .filter((ele) => ele.blockName === "wpvcb/review-details")
        //       .shift().filtered_content
        //   : "";
        _this.pageData = res.data.data.partner;

        if (_this.pageData) {
          if (_this.pageData.product_information && _this.pageData.product_information.support_email.length > 0) {
            _this.supportEmail = _this.pageData.product_information.support_email[0].email_address;
          } else {
            _this.supportEmail = "";
          }

          if (_this.pageData.product_information && _this.pageData.product_information.contact_number.length > 0) {
            _this.contactNumber = _this.pageData.product_information.contact_number[0].contact_number;
            _this.contactName = _this.pageData.product_information.contact_number[0].title;
          } else {
            _this.contactNumber = "";
            _this.contactName = "";
          }

          if (_this.pageData.supported_language) {
            _this.supportedLang = JSON.parse(_this.pageData.supported_language.language_name).map(function (ele) {
              return _this.getLang(ele);
            });
          } else {
            _this.supportedLang = [];
          }
        }

        _this.metaData = res.data.data.meta; // this.pageAttr = res.data.data.content.blocks
        //   .filter((ele) => ele.blockName === "wpvcb/review-details")
        //   .shift()
        //   ? res.data.data.content.blocks
        //       .filter((ele) => ele.blockName === "wpvcb/review-details")
        //       .shift().attrs
        //   : "";

        _this.pageAttr = res.data.data.attrs;
        _this.tabData = res.data.data.review_details.tab;
        _this.breadCrumb = res.data.data.breadcrumb; // More Payments Bottom Card

        _this.morePaymentBottom = res.data.data.meta.more_payment_method; // Author Blocks Filtered

        var atBlock = res.data.data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/author-block") {
            return ele.filtered_content;
          }
        });
        if (atBlock.length > 0) _this.auhtorBlockdata = atBlock.shift().filtered_content; // Schema Append

        document.getElementById("schema-script").innerHTML = res.data.data.schema; // Adminbar Data

        _this.$root.adminBarData = Object.keys(res.data.data.toolbar).length > 0 ? res.data.data.toolbar : "";
        _this.$root.disable = _this.$root.adminBarData ? _this.$root.adminBarData.visible : false; //NotSupportBanner

        _this.$root.notsupportbannerData = res.data.data.not_supported_banner && Object.keys(res.data.data.not_supported_banner).length > 0 ? res.data.data.not_supported_banner : "";
        _this.$root.disableNotSupportBanner = _this.pageData && _this.pageData.product_id ? false : true;
        _this.$root.noScroll = _this.pageData && _this.pageData.product_id ? false : true;
        _this.$root.notsupportassetSizes = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : "";
        _this.$root.notSupportPageType = "review"; // Assets Sizes

        _this.assets_images = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : "";
        if (_this.pageData) _this.getBonusShowHide(_this.pageData);

        if (_this.tabData.length === 0 || _this.tabData && _this.tabData.filter(function (ele) {
          return ele.tab_content;
        }).length === 0) {
          _this.pageIndex = 2;
        }

        if (!_this.$root.enable_lazyload) {
          _this.pageIndex = 4;
          _this.$root.show_footer = true;
        } else {
          _this.$root.show_footer = false;
        }

        _this.$root.loading = false;
        _this.$root.body_loading_status = true;
      }).catch(function (err) {
        _this.typeCheck = "error";
        _this.$root.loading = false;
      });
    },
    scrollPage: function scrollPage(ref) {
      if (document.getElementById("panel-wrapper")) {
        if (document.getElementById("review-sticky-card")) {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight - 10;
            } else {
              this.scrollOffset = 20 + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight - 10;
            } else {
              this.scrollOffset = 20 + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
            }
          }
        } else {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight - 10;
            } else {
              this.scrollOffset = 20 + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight - 10;
            }
          }
        }
      } else {
        if (document.getElementById("review-sticky-card")) {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
            } else {
              this.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
            } else {
              this.scrollOffset = document.getElementById("review-sticky-card").offsetHeight;
            }
          }
        } else {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight;
            } else {
              this.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("sticky-header").offsetHeight;
            }
          }
        }
      }

      var topLoc = 0;

      if (window.innerWidth <= 768) {
        if (this.stickyNavTop === 0 && this.clickCount === 0) {
          topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top) - 80 - 20;
          this.clickCount++;
        } else topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top) - 80;
      } else {
        if (this.stickyNavTop === 0) {
          if (this.topHeaderStickyHeight === 0) {
            if (document.getElementById("sticky-regulation-banner")) {
              if (document.getElementById("sticky-header")) {
                topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top + document.getElementById("sticky-header").offsetHeight - this.scrollOffset - 144);
              } else {
                topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 49 - 20);
              }
            } else {
              if (document.getElementById("sticky-header")) {
                topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top + document.getElementById("sticky-header").offsetHeight - this.scrollOffset - 165);
              } else {
                topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 70 - 20);
              }
            }
          } else {
            if (document.getElementById("sticky-header")) {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top + document.getElementById("sticky-header").offsetHeight - this.scrollOffset - 70 - 20);
            } else {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 70);
            }
          }
        } else if (this.stickyNavTop === document.getElementById("panel-wrapper") ? document.getElementById("panel-wrapper").offsetHeight : "") {
          if (document.getElementById("sticky-header")) {
            topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 120);
          } else {
            topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 70);
          }
        } else {
          if (document.getElementById("panel-wrapper")) {
            if (document.getElementById("sticky-header")) {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 70 - 20);
            } else {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 40);
            }
          } else {
            if (document.getElementById("sticky-header")) {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 50 - 20);
            } else {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 50 - 20);
            }
          }
        }
      }

      window.scrollTo({
        top: topLoc,
        behavior: "smooth"
      });
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags);

    if (this.reviewData != undefined) {
      // this.pageData = this.reviewData.content.blocks
      //   .filter((ele) => ele.blockName === "wpvcb/review-details")
      //   .shift()
      //   ? this.reviewData.content.blocks
      //       .filter((ele) => ele.blockName === "wpvcb/review-details")
      //       .shift().filtered_content
      //   : "";
      this.pageData = this.reviewData.partner;

      if (this.pageData) {
        if (this.pageData.product_information && this.pageData.product_information.support_email.length > 0) {
          this.supportEmail = this.pageData.product_information.support_email[0].email_address;
        } else {
          this.supportEmail = "";
        }

        if (this.pageData.product_information && this.pageData.product_information.contact_number.length > 0) {
          this.contactNumber = this.pageData.product_information.contact_number[0].contact_number;
          this.contactName = this.pageData.product_information.contact_number[0].title;
        } else {
          this.contactNumber = "";
          this.contactName = "";
        }

        if (this.pageData.supported_language) {
          this.supportedLang = JSON.parse(this.pageData.supported_language.language_name).map(function (ele) {
            return _this2.getLang(ele);
          });
        } else {
          this.supportedLang = [];
        }
      }

      this.metaData = this.reviewData.meta; // this.pageAttr = this.reviewData.content.blocks
      //   .filter((ele) => ele.blockName === "wpvcb/review-details")
      //   .shift()
      //   ? this.reviewData.content.blocks
      //       .filter((ele) => ele.blockName === "wpvcb/review-details")
      //       .shift().attrs
      //   : "";

      this.pageAttr = this.reviewData.attrs;
      this.tabData = this.reviewData.review_details.tab;
      this.breadCrumb = this.reviewData.breadcrumb; // More Payments Bottom Card

      this.morePaymentBottom = this.reviewData.meta.more_payment_method; // Author Blocks Filtered

      var atBlock = this.reviewData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // Schema Append

      document.getElementById("schema-script").innerHTML = this.reviewData.schema; // Adminbar Data

      this.$root.adminBarData = Object.keys(this.reviewData.toolbar).length > 0 ? this.reviewData.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; //NotSupportBanner

      this.$root.notsupportbannerData = this.reviewData.not_supported_banner && Object.keys(this.reviewData.not_supported_banner).length > 0 ? this.reviewData.not_supported_banner : "";
      this.$root.disableNotSupportBanner = this.pageData && this.pageData.product_id ? false : true;
      this.$root.noScroll = this.pageData && this.pageData.product_id ? false : true;
      this.$root.notsupportassetSizes = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
      this.$root.notSupportPageType = "review"; // Assets Sizes

      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
      if (this.pageData) this.getBonusShowHide(this.pageData);

      if (this.tabData.length === 0 || this.tabData && this.tabData.filter(function (ele) {
        return ele.tab_content;
      }).length === 0) {
        this.pageIndex = 2;
      }

      if (!this.$root.enable_lazyload) {
        this.pageIndex = 4;
        this.$root.show_footer = true;
      } else {
        this.$root.show_footer = false;
      }
    } else {
      this.$root.loading = true;
      this.getPageData();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.heightCheck();
    this.$nextTick(function () {
      _this3.updateBonusHeight();
    });
    var that = this;
    window.addEventListener("scroll", function () {
      if (window.innerWidth > 991) {
        if (document.getElementById("panel-wrapper")) {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              } else {
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              }
            } else {
              document.getElementById("review-sticky-card").style.top = "-".concat(that.topStickyHeight + 1, "px");

              if (document.getElementById("sticky-regulation-banner")) {
                if (window.pageYOffset === 0) {
                  document.getElementById("sticky-regulation-banner").style.top = 0;
                } else {
                  document.getElementById("sticky-regulation-banner").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                }

                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");
              } else {
                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight);
              }
            }

            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
              }
            }
          }
        } else {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = 0;
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              } else {
                document.getElementById("review-sticky-card").style.top = 0;

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              }
            } else {
              document.getElementById("review-sticky-card").style.top = "-".concat(that.topStickyHeight + 1, "px");

              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = 0;

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = 0;
              }
            }

            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("review-sticky-card").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = 0;
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              //if (window.pageYOffset >= 550) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                } else {
                  that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight;
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  that.stickyNavTop = document.getElementById("sticky-header").offsetHeight;
                } else {
                  that.stickyNavTop = 0;
                }
              } // } else {
              //   that.stickyNavTop = 0;
              // }

            }
          }
        }
      } else {
        if (that.$root.show_stickymenu && that.$root.show_stickymenu_mobile && window.innerWidth < 992) {
          that.stickyNavTop = 70;
        }
      }

      if (document.getElementById("sticky-nav")) {
        var stickyParent = document.getElementById("sticky-nav").parentNode;

        if (window.pageYOffset > Math.ceil(that.getOffset(stickyParent).top + stickyParent.clientHeight - window.innerHeight + 400)) {
          //that.showSticky = false;
          that.stickyNavTop = 0;
        } else {
          that.showSticky = true;

          if (that.$root.show_stickymenu && that.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            that.stickyNavTop = 70;
          }
        }

        if (document.getElementById("review-sticky-card")) {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              that.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
            } else {
              that.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              that.scrollOffset = document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
            } else {
              that.scrollOffset = document.getElementById("review-sticky-card").offsetHeight;
            }
          }
        }

        Object.keys(that.$refs).forEach(function (key) {
          if (that.$refs[key][0]) {
            if (window.innerWidth <= 768) {
              if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top) - 80) {
                that.activeKey = key;
                that.clickCount++;
              }
            } else {
              if (document.getElementById("panel-wrapper")) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 70 - 50 - 20)) {
                      that.activeKey = key;
                    }
                  } else {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 50 - 40)) {
                      that.activeKey = key;
                    }
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 70 - 20)) {
                      that.activeKey = key;
                    }
                  } else {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 40)) {
                      that.activeKey = key;
                    }
                  }
                }
              } else {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 50 - 50 - 20)) {
                      that.activeKey = key;
                    }
                  } else {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 70 - 50 - 20)) {
                      that.activeKey = key;
                    }
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 50 - 20)) {
                      that.activeKey = key;
                    }
                  } else {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 70 - 20)) {
                      that.activeKey = key;
                    }
                  }
                }
              }
            }
          }
        });
      } //that.heightCheck();

    }, {
      passive: true
    });
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
      var windowWidth = window.innerWidth;

      if (!this.smallCardView && windowWidth >= 768) {
        this.smallCardView = true;
      }

      if (window.innerWidth > 991) {
        if (document.getElementById("panel-wrapper")) {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              } else {
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              }
            } else {
              document.getElementById("review-sticky-card").style.top = "-".concat(that.topStickyHeight + 1, "px");

              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight);
                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");
              } else {
                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight);
              }
            }

            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
              }
            }
          }
        } else {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = 0;
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              } else {
                document.getElementById("review-sticky-card").style.top = 0;

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              }
            } else {
              document.getElementById("review-sticky-card").style.top = "-".concat(that.topStickyHeight + 1, "px");

              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = 0;

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = 0;
              }
            }

            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("review-sticky-card").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = 0;
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              //if (window.pageYOffset >= 550) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                } else {
                  that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight;
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  that.stickyNavTop = document.getElementById("sticky-header").offsetHeight;
                } else {
                  that.stickyNavTop = 0;
                }
              } // } else {
              //   that.stickyNavTop = 0;
              // }

            }
          }
        }
      } else {
        if (document.getElementById("panel-wrapper")) {
          that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
        } else {
          that.stickyNavTop = 0;
        }
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
    });

    if (window.innerWidth > 991) {
      document.getElementById("sticky-header") ? document.getElementById("sticky-header").style.top = "0" : "";
    }
  },
  watch: {
    "$route.params.postSlug": function $routeParamsPostSlug() {
      if (this.reviewData != undefined) {} else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    pageIndex: function pageIndex() {
      if (this.pageIndex > 3) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimilarCasino_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a82993f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimilarCasino_vue__ = __webpack_require__(613);
function injectStyle (ssrContext) {
  __webpack_require__(608)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a82993f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimilarCasino_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a82993f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimilarCasino_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_currency__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_StarRating__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SimilarCasino",
  props: ["componentData", "componentTitle", "componentDescription", "assetsSize", "componentAttrs", "pageTemplate"],
  data: function data() {
    return {
      modalOnDisplay: null,
      modalIdArr: [],
      hideBonusLabel: false,
      hideToplistLabel: false
    };
  },
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2__components_ui_StarRating__["a" /* default */]
  },
  filters: {
    currency: __WEBPACK_IMPORTED_MODULE_1__misc_currency__["a" /* default */]
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__["a" /* getContrastYIQ */],
    showHideModal: function showHideModal(id) {
      this.modalOnDisplay = id;
    },
    getBonusShowHide: function getBonusShowHide(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.componentData && this.componentData.length > 0) this.getBonusShowHide(this.componentData[0]);
    this.componentData.forEach(function (ele) {
      _this.modalIdArr.push(Math.floor(Math.random() * (1000 - 1 + 1)) + 1);
    });
    var that = this;
    document.body.addEventListener("click", function (event) {
      var modal = document.getElementById("modal-content-".concat(that.modalOnDisplay));
      var showBtn = document.getElementById("show-btn-".concat(that.modalOnDisplay));

      if (modal && event.target != modal && !modal.contains(event.target) && event.target != showBtn && !showBtn.contains(event.target)) {
        that.showHideModal(null);
      }
    });
    var maxHeight = 0;
    document.querySelectorAll(".similar-card-bonus").forEach(function (ele) {
      if (maxHeight <= ele.offsetHeight) {
        maxHeight = ele.offsetHeight;
      }
    });
    document.querySelectorAll(".similar-card-bonus").forEach(function (ele) {
      ele.style.height = "".concat(maxHeight, "px");
    });
    var maxNameHeight = 0;
    document.querySelectorAll(".cas-nam").forEach(function (ele) {
      if (maxNameHeight <= ele.offsetHeight) {
        maxNameHeight = ele.offsetHeight;
      }
    });
    document.querySelectorAll(".cas-nam").forEach(function (ele) {
      ele.style.height = "".concat(maxNameHeight, "px");
    });
    var maxRevHeight = 0;
    document.querySelectorAll(".rev-text").forEach(function (ele) {
      if (maxRevHeight <= ele.offsetHeight) {
        maxRevHeight = ele.offsetHeight;
      }
    });
    document.querySelectorAll(".rev-text").forEach(function (ele) {
      ele.style.height = "".concat(maxRevHeight, "px");
    });
    var maxBtnHeight = 0;
    document.querySelectorAll(".cus-sim-btn").forEach(function (ele) {
      if (maxBtnHeight <= ele.offsetHeight) {
        maxBtnHeight = ele.offsetHeight;
      }
    });
    document.querySelectorAll(".cus-sim-btn").forEach(function (ele) {
      ele.style.height = "".concat(maxBtnHeight, "px");
    });
    var maxTermHeight = 0;
    document.querySelectorAll(".terms-sim").forEach(function (ele) {
      if (maxTermHeight <= ele.offsetHeight) {
        maxTermHeight = ele.offsetHeight;
      }
    });
    document.querySelectorAll(".terms-sim").forEach(function (ele) {
      ele.style.height = "".concat(maxTermHeight, "px");
    });
    var maxPayImgHeight = 0;
    document.querySelectorAll(".pay-img").forEach(function (ele) {
      if (maxPayImgHeight <= ele.offsetHeight) {
        maxPayImgHeight = ele.offsetHeight;
      }
    });
    document.querySelectorAll(".pay-img").forEach(function (ele) {
      ele.style.height = "".concat(maxPayImgHeight, "px");
    });
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "StarRating",
  props: {
    rating: Number,
    noText: Boolean,
    classParam: String
  },
  computed: {
    ratioMath: function ratioMath() {
      if (this.rating >= 4 && this.rating < 4.5 && this.rating < 5) {
        return Math.floor(this.rating);
      } else if (this.rating >= 3 && this.rating < 3.5 && this.rating < 5) {
        return Math.floor(this.rating);
      } else if (this.rating >= 2 && this.rating < 2.5 && this.rating < 5) {
        return Math.floor(this.rating);
      } else if (this.rating >= 1 && this.rating < 1.5 && this.rating < 5) {
        return Math.floor(this.rating);
      } else if (this.rating >= 0 && this.rating < 0.5 && this.rating < 5) {
        return Math.floor(this.rating);
      } else if (this.rating >= 4.5 && this.rating < 5) {
        return Math.ceil(this.rating);
      } else if (this.rating >= 3.5 && this.rating < 5) {
        return Math.ceil(this.rating);
      } else if (this.rating >= 2.5 && this.rating < 5) {
        return Math.ceil(this.rating);
      } else if (this.rating >= 1.5 && this.rating < 5) {
        return Math.ceil(this.rating);
      } else if (this.rating >= 0.5 && this.rating < 5) {
        return Math.ceil(this.rating);
      } else {
        return Math.ceil(this.rating);
      }
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ContentIcon",
  props: ["contentIconData", "partnerInfo", "buttonCheck", "templateCheck"],
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__["d" /* pSBC */]
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_currency__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BonusInformation",
  props: ["bonusData", "bonusPartnerData", "assetsSize", "hideBonusLabelB", "bonusPrimaryColour"],
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__["a" /* getContrastYIQ */],
    getOffset: __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__["b" /* getOffset */]
  },
  filters: {
    currency: __WEBPACK_IMPORTED_MODULE_1__misc_currency__["a" /* default */]
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ComparisonList",
  props: ["comparisonData", "comparisonAttrs", "page", "partnerProcons"]
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc_countries__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_StarRating__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PromotionBannerSuggest",
  props: ["promoData"],
  data: function data() {
    return {
      timer_html: "",
      timer_width: "",
      strCls: "star-cls"
    };
  },
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1__components_ui_StarRating__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    this.updateTimerPromo();
    this.interval = setInterval(this.updateTimerPromo, 60000);
    this.$nextTick(function () {
      _this.updateBonusHeight();
    });
    window.addEventListener("resize", function () {
      _this.updateBonusHeight();
    });
  },
  methods: {
    getCountryName: __WEBPACK_IMPORTED_MODULE_0__misc_countries__["b" /* getCountryName */],
    getCountryFlag: __WEBPACK_IMPORTED_MODULE_0__misc_countries__["a" /* getCountryFlag */],
    pSBC: __WEBPACK_IMPORTED_MODULE_2__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_2__misc_misc_function__["a" /* getContrastYIQ */],
    getPartnerImg: function getPartnerImg(assets) {
      var img_src = assets.filter(function (ele) {
        return ele.asset_category_name === "product_logo";
      })[0];

      if (Object.keys(img_src).length > 0 && img_src.url) {
        return img_src.url;
      } else {
        return null;
      }
    },
    updateBonusHeight: function updateBonusHeight() {
      var heightArr = [];
      document.querySelectorAll(".prob-text").forEach(function (ele) {
        heightArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".prob-text").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightArr), "px");
      });
      var heightTermArr = [];
      document.querySelectorAll(".prob-term").forEach(function (ele) {
        heightTermArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".prob-term").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightTermArr), "px");
      });
      var heightTimeArr = [];
      document.querySelectorAll(".prob-time").forEach(function (ele) {
        heightTimeArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".prob-time").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightTimeArr), "px");
      });
    },
    updateTimerPromo: function updateTimerPromo() {
      if (this.promoData && Object.keys(this.promoData).length > 0 && this.promoData.metadata && this.promoData.metadata.promotion_end_date && this.promoData.metadata.promotion_end_date != "") {
        this.timer_html = "";
        var timer_calc = Date.parse(this.promoData.metadata.promotion_end_date) + 86400000 - Date.parse(new Date());
        var months = Math.floor(timer_calc / (1000 * 60 * 60 * 24 * 30));
        var days = Math.floor(timer_calc / (1000 * 60 * 60 * 24) % 30);
        var hours = Math.floor(timer_calc % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(timer_calc % (1000 * 60 * 60) / (1000 * 60));

        if (months > 0) {
          this.timer_html += "<span class=\"fw-bold\">".concat(months, "</span> ").concat(this.$root.i18n.months.charAt(0).toUpperCase() + this.$root.i18n.months.slice(1), ", <span class=\"fw-bold\">").concat(days, "</span> ").concat(this.$root.i18n.days.charAt(0).toUpperCase() + this.$root.i18n.days.slice(1), ", <span class=\"fw-bold\">").concat(hours, "</span> ").concat(this.$root.i18n.hours.charAt(0).toUpperCase() + this.$root.i18n.hours.slice(1), ", <span class=\"fw-bold\">").concat(minutes, "</span> ").concat(this.$root.i18n.mins.charAt(0).toUpperCase() + this.$root.i18n.mins.slice(1));
          this.timer_width = "300px";
        } else if (days > 0) {
          this.timer_html += "<span class=\"fw-bold\">".concat(days, "</span> ").concat(this.$root.i18n.days.charAt(0).toUpperCase() + this.$root.i18n.days.slice(1), ", <span class=\"fw-bold\">").concat(hours, "</span> ").concat(this.$root.i18n.hours.charAt(0).toUpperCase() + this.$root.i18n.hours.slice(1), ", <span class=\"fw-bold\">").concat(minutes, "</span> ").concat(this.$root.i18n.mins.charAt(0).toUpperCase() + this.$root.i18n.mins.slice(1));
          this.timer_width = "260px";
        } else if (hours > 0) {
          this.timer_html += "<span class=\"fw-bold\">".concat(hours, "</span> ").concat(this.$root.i18n.hours.charAt(0).toUpperCase() + this.$root.i18n.hours.slice(1), ", <span class=\"fw-bold\">").concat(minutes, "</span> ").concat(this.$root.i18n.mins.charAt(0).toUpperCase() + this.$root.i18n.mins.slice(1));
          this.timer_width = "220px";
        } else if (minutes > 0) {
          this.timer_html += "<span class=\"fw-bold\">".concat(minutes, "</span> ").concat(this.$root.i18n.mins.charAt(0).toUpperCase() + this.$root.i18n.mins.slice(1));
          this.timer_width = "200px";
        } else {
          this.timer_html = "";
          this.timer_width = "200px";
        }
      }
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Author",
  props: ["authorData"]
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_StarRating__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NotSupportModal",
  props: ["notsupportbannerData", "relative"],
  data: function data() {
    return {
      notSupportWidth: 0
    };
  },
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0__components_ui_StarRating__["a" /* default */]
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["a" /* getContrastYIQ */],
    getOffset: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["b" /* getOffset */],
    closeModal: function closeModal() {
      this.$root.disableNotSupportBanner = false;
      this.$root.noScroll = false;
      this.$root.notSupportPageType = "";
      this.$root.notSupportType = "";
    },
    resetTitleHeight: function resetTitleHeight() {
      document.querySelectorAll(".software-title").forEach(function (ele) {
        ele.style.height = "auto";
      });
      document.querySelectorAll(".payment-title").forEach(function (ele) {
        ele.style.height = "auto";
      });

      if (this.notSupportWidth > 767) {
        document.querySelectorAll(".review-title").forEach(function (ele) {
          ele.style.height = "auto";
        });
      }
    },
    updateBonusHeight: function updateBonusHeight() {
      var PaymenttitleHeight = 0;
      document.querySelectorAll(".payment-title").forEach(function (ele) {
        if (ele.clientHeight > PaymenttitleHeight) {
          PaymenttitleHeight = ele.clientHeight;
        }
      });
      document.querySelectorAll(".payment-title").forEach(function (ele) {
        ele.style.height = "".concat(PaymenttitleHeight, "px");
      });
      var SoftwaretitleHeight = 0;
      document.querySelectorAll(".software-title").forEach(function (ele) {
        if (ele.clientHeight > SoftwaretitleHeight) {
          SoftwaretitleHeight = ele.clientHeight;
        }
      });
      document.querySelectorAll(".software-title").forEach(function (ele) {
        ele.style.height = "".concat(SoftwaretitleHeight, "px");
      });

      if (this.notSupportWidth > 767) {
        var ReviewtitleHeight = 0;
        document.querySelectorAll(".review-title").forEach(function (ele) {
          if (ele.clientHeight > ReviewtitleHeight) {
            ReviewtitleHeight = ele.clientHeight;
          }
        });
        document.querySelectorAll(".review-title").forEach(function (ele) {
          ele.style.height = "".concat(ReviewtitleHeight, "px");
        });
      }
    }
  },
  created: function created() {
    this.notSupportWidth = window.innerWidth;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.resetTitleHeight();

      _this.updateBonusHeight();

      _this.notSupportWidth = window.innerWidth;
    });
    window.addEventListener("resize", function () {
      _this.resetTitleHeight();

      _this.updateBonusHeight();

      _this.notSupportWidth = window.innerWidth;
    });
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_StarRating__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Pages_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_currency__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NotFound",
  data: function data() {
    return {
      page404Data: "",
      page404DataBlocks: [],
      gamesTop3: [],
      gamesTop3Title: [],
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      hideBonusLabelGB: false,
      hideToplistLabelGB: false,
      bluebar: {},
      crownIcon: ''
    };
  },
  components: {
    CustomComponent: __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_1__components_ui_StarRating__["a" /* default */]
  },
  created: function created() {
    var assetPath = "".concat(global.wpvue_script_data_params.site_url, "/wp-content/themes/wpvue/src/assets/images");
    this.crownIcon = global.wpvue_script_data_params.data.site_data.theme_icons.crown || assetPath + '/svg-icons/crown.svg';
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.show_footer = true;
    __WEBPACK_IMPORTED_MODULE_2__api_Pages_api__["a" /* HttpService */].get404Body(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$root.page404_id, this.$root.user_id).then(function (res) {
      _this.page404Data = res.data.data;
      _this.page404DataBlocks = res.data.data.content.blocks; // GameTop3

      _this.gamesTop3 = [];

      _this.page404DataBlocks.forEach(function (ele) {
        if (ele.blockName === "wpvcb/casino-toplist" && ele.attrs && ele.attrs.style === "gamepage_top_3") {
          _this.gamesTop3.push(ele.filtered_content);

          _this.gamesTop3Title.push(ele.attrs.block_title ? ele.attrs.block_title : "");
        }
      }); // Assets Sizes


      _this.assets_images = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : ""; //console.log(this.gamesTop3);

      if (_this.gamesTop3.length > 0) _this.getBonusShowHideGB(_this.gamesTop3[0][0]);

      _this.$nextTick(function () {
        _this.updateBonusHeight();
      });

      window.addEventListener("resize", function () {
        _this.updateBonusHeight();

        var windowWidth = window.innerWidth;

        if (!_this.smallCardView && windowWidth >= 768) {
          _this.smallCardView = true;
        }
      });
      _this.$root.body_loading_status = true;
    }).catch(function (err) {
      return console.log(err);
    });
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__["a" /* getContrastYIQ */],
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    },
    updateBonusHeight: function updateBonusHeight() {
      var heightArr = [];
      document.querySelectorAll(".gamefree-casino-404").forEach(function (ele) {
        heightArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".gamefree-casino-404").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightArr), "px");
      });
      var heightTermsArr = [];
      document.querySelectorAll(".terms-404").forEach(function (ele) {
        heightTermsArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".terms-404").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightTermsArr), "px");
      });
    },
    getBonusShowHideGB: function getBonusShowHideGB(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabelGB = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabelGB = true;
      }
    }
  },
  filters: {
    currency: __WEBPACK_IMPORTED_MODULE_3__misc_currency__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_SimilarCasino__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_StarRating__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_custom_block_NotSupportModal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__misc_currency__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__misc_lang__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_Pages_api__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ReviewWithBlocks",
  props: ["reviewNewData"],
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2__components_ui_StarRating__["a" /* default */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_3__components_CustomComponent__["a" /* default */],
    SimilarCasino: __WEBPACK_IMPORTED_MODULE_1__components_layouts_SimilarCasino__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_6__components_custom_block_RelatedLinks__["a" /* default */],
    NotFound: __WEBPACK_IMPORTED_MODULE_7__pages_404__["default"],
    NotSupportModal: __WEBPACK_IMPORTED_MODULE_5__components_custom_block_NotSupportModal__["a" /* default */]
  },
  filters: {
    currency: __WEBPACK_IMPORTED_MODULE_8__misc_currency__["a" /* default */]
  },
  data: function data() {
    return {
      pageAttr: {
        type: Object,
        default: function _default() {}
      },
      pageData: {
        type: Object,
        default: function _default() {}
      },
      tabData: {},
      supportEmail: "",
      contactName: "",
      contactNumber: "",
      breadCrumb: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      supportedLang: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      showHideObj: {
        spTop: false,
        pmTop: false,
        liscTop: false,
        spMidSc: false,
        liscUnderSc: false,
        dipositSc: false,
        withdrawSc: false
      },
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      activeKey: "",
      scrollOffset: 0,
      metaData: "",
      busy: false,
      pageIndex: 0,
      stickyNavTop: 0,
      showSticky: true,
      clickCount: 0,
      topStickyHeight: 0,
      topHeaderStickyHeight: 0,
      hideBonusLabel: false,
      hideToplistLabel: false,
      auhtorBlockdata: [],
      rightBlockdata: [],
      scriptFlag: 0,
      typeCheck: "",
      bluebar: {}
    };
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_10__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_10__misc_misc_function__["a" /* getContrastYIQ */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_11__misc_meta_changer__["a" /* metaChanger */],
    getOffset: __WEBPACK_IMPORTED_MODULE_10__misc_misc_function__["b" /* getOffset */],
    getLang: __WEBPACK_IMPORTED_MODULE_9__misc_lang__["a" /* getLang */],
    getStarPercentage: function getStarPercentage(rating) {
      //// Gradient color
      if (rating === 1) {
        return {
          background: "linear-gradient(90deg,#dd1d00 -2.17%,#dd1d00 37.74%,#dd1d00 72.86%,#dd1d00 100%)",
          width: rating / 5 * 100 + "%"
        };
      } else if (rating > 1 && rating <= 3) {
        return {
          background: "linear-gradient(90deg,#dd1d00 -2.17%,#f6ad00 37.74%,#f6ad00 72.86%,#f6ad00 100%)",
          width: rating / 5 * 100 + "%"
        };
      } else if (rating > 3 && rating <= 5) {
        if (rating > 3 && rating <= 4) {
          return {
            background: "linear-gradient(90deg,#dd1d00 -2.17%,#f6ad00 37.74%,#7cdd00 72.86%,#7cdd00 100%)",
            width: rating / 5 * 100 + "%"
          };
        } else {
          return {
            background: "linear-gradient(90deg,#dd1d00 -2.17%,#f6ad00 37.74%,#7cdd00 72.86%,#68c783 100%)",
            width: rating / 5 * 100 + "%"
          };
        }
      }
    },
    prosconsReview: function prosconsReview(value) {
      var filterpositiveValue = value.filter(function (ele) {
        return ele.is_positive === "1";
      });
      var negativeValue = value.filter(function (elem) {
        return elem.is_positive === "0";
      });

      if (negativeValue.length > 0) {
        if (filterpositiveValue.length > 0) {
          var retArr = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(filterpositiveValue.slice(0, 3)), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(negativeValue.slice(0, 1)));
          return retArr;
        }
      } else {
        if (filterpositiveValue.length > 0) {
          return filterpositiveValue.slice(0, 4);
        }
      }
    },
    getFinalStarPercentage: function getFinalStarPercentage(rating) {
      if (rating === 1) {
        return "#dd1d00";
      } else if (rating > 1 && rating <= 3) {
        return "#f6ad00";
      } else if (rating > 3 && rating <= 5) {
        return "#4caf50";
      }
    },
    getFinalStarPercentageLabel: function getFinalStarPercentageLabel(rating) {
      if (rating > 0 && rating <= 3) {
        return this.$root.i18n.review_1_to_3_rating_label;
      } else if (rating > 3 && rating <= 5) {
        return this.$root.i18n.review_4_to_5_rating_label;
      }
    },
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    getBonusShowHide: function getBonusShowHide(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    },
    updateBonusHeight: function updateBonusHeight() {
      var heightArr = [];
      document.querySelectorAll(".sticky-inner").forEach(function (ele) {
        heightArr.push(ele.clientHeight);
      });
      this.topStickyHeight = Math.max.apply(Math, heightArr);

      if (document.getElementById("review-sticky-card")) {
        if (window.innerWidth > 991) {
          document.getElementById("review-sticky-card").style.top = "-".concat(this.topStickyHeight + 1, "px");
        } else {
          document.getElementById("review-sticky-card").style.top = null;
        }
      }

      this.topHeaderStickyHeight = document.getElementById("sticky-header") ? document.getElementById("sticky-header").offsetHeight : 0;
      document.querySelectorAll(".sticky-review-card").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightArr), "px");
      });
    },
    loadMore: function loadMore() {
      this.busy = true;
      this.pageIndex++;
      this.busy = false;
    },
    getPageData: function getPageData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_12__api_Pages_api__["a" /* HttpService */].getBody(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.params.postSlug, this.$root.user_id).then(function (res) {
        // this.pageData = res.data.data.content.blocks
        //   .filter((ele) => ele.blockName === "wpvcb/review-details")
        //   .shift()
        //   ? res.data.data.content.blocks
        //       .filter((ele) => ele.blockName === "wpvcb/review-details")
        //       .shift().filtered_content
        //   : "";
        _this.pageData = res.data.data.partner;

        if (_this.pageData) {
          if (_this.pageData.product_information && _this.pageData.product_information.support_email.length > 0) {
            _this.supportEmail = _this.pageData.product_information.support_email[0].email_address;
          } else {
            _this.supportEmail = "";
          }

          if (_this.pageData.product_information && _this.pageData.product_information.contact_number.length > 0) {
            _this.contactNumber = _this.pageData.product_information.contact_number[0].contact_number;
            _this.contactName = _this.pageData.product_information.contact_number[0].title;
          } else {
            _this.contactNumber = "";
            _this.contactName = "";
          }

          if (_this.pageData.supported_language) {
            _this.supportedLang = JSON.parse(_this.pageData.supported_language.language_name).map(function (ele) {
              return _this.getLang(ele);
            });
          } else {
            _this.supportedLang = [];
          }
        }

        _this.metaData = res.data.data.meta; // this.pageAttr = res.data.data.content.blocks
        //   .filter((ele) => ele.blockName === "wpvcb/review-details")
        //   .shift()
        //   ? res.data.data.content.blocks
        //       .filter((ele) => ele.blockName === "wpvcb/review-details")
        //       .shift().attrs
        //   : "";

        _this.pageAttr = res.data.data.attrs;
        _this.tabData = res.data.data.content.blocks;
        _this.breadCrumb = res.data.data.breadcrumb; // More Payments Bottom Card

        _this.morePaymentBottom = res.data.data.meta.more_payment_method; // Author Blocks Filtered

        var atBlock = res.data.data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/author-block") {
            return ele.filtered_content;
          }
        });
        if (atBlock.length > 0) _this.auhtorBlockdata = atBlock.shift().filtered_content; // Schema Append

        document.getElementById("schema-script").innerHTML = res.data.data.schema; // Adminbar Data

        _this.$root.adminBarData = Object.keys(res.data.data.toolbar).length > 0 ? res.data.data.toolbar : "";
        _this.$root.disable = _this.$root.adminBarData ? _this.$root.adminBarData.visible : false; //NotSupportBanner

        _this.$root.notsupportbannerData = res.data.data.not_supported_banner && Object.keys(res.data.data.not_supported_banner).length > 0 ? res.data.data.not_supported_banner : "";
        _this.$root.disableNotSupportBanner = _this.pageData && _this.pageData.product_id ? false : true;
        _this.$root.noScroll = _this.pageData && _this.pageData.product_id ? false : true;
        _this.$root.notsupportassetSizes = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : "";
        _this.$root.notSupportPageType = "review"; // RightContent Blocks Filtered

        var rightBlock = res.data.data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/right-content-simpletoc") {
            return ele.filtered_content;
          }
        });
        if (rightBlock.length > 0) _this.rightBlockdata = rightBlock.shift().filtered_content; // Assets Sizes

        _this.assets_images = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : "";
        if (_this.pageData) _this.getBonusShowHide(_this.pageData);

        if (_this.tabData.length === 0 || _this.tabData && _this.tabData.filter(function (ele) {
          return ele.tab_content;
        }).length === 0) {
          _this.pageIndex = 2;
        }

        if (!_this.$root.enable_lazyload) {
          _this.pageIndex = 4;
          _this.$root.show_footer = true;
        } else {
          _this.$root.show_footer = false;
        }

        _this.$root.loading = false;
        _this.$root.body_loading_status = true;
      }).catch(function (err) {
        _this.typeCheck = "error";
        _this.$root.loading = false;
      });
    },
    scrollPage: function scrollPage(ref) {
      if (document.getElementById("panel-wrapper")) {
        if (document.getElementById("review-sticky-card")) {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight - 10;
            } else {
              this.scrollOffset = 20 + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight - 10;
            } else {
              this.scrollOffset = 20 + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
            }
          }
        } else {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight - 10;
            } else {
              this.scrollOffset = 20 + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight - 10;
            }
          }
        }
      } else {
        if (document.getElementById("review-sticky-card")) {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
            } else {
              this.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
            } else {
              this.scrollOffset = document.getElementById("review-sticky-card").offsetHeight;
            }
          }
        } else {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight;
            } else {
              this.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset = document.getElementById("sticky-header").offsetHeight;
            }
          }
        }
      }

      var topLoc = 0;

      if (window.innerWidth <= 768) {
        if (this.stickyNavTop === 0 && this.clickCount === 0) {
          topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top) - 80 - 20;
          this.clickCount++;
        } else topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top) - 80;
      } else {
        if (this.stickyNavTop === 0) {
          if (this.topHeaderStickyHeight === 0) {
            if (document.getElementById("sticky-regulation-banner")) {
              if (document.getElementById("sticky-header")) {
                topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top + document.getElementById("sticky-header").offsetHeight - this.scrollOffset - 144);
              } else {
                topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 49 - 20);
              }
            } else {
              if (document.getElementById("sticky-header")) {
                topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top + document.getElementById("sticky-header").offsetHeight - this.scrollOffset - 165);
              } else {
                topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 70 - 20);
              }
            }
          } else {
            if (document.getElementById("sticky-header")) {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top + document.getElementById("sticky-header").offsetHeight - this.scrollOffset - 70 - 20);
            } else {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 70);
            }
          }
        } else if (this.stickyNavTop === document.getElementById("panel-wrapper") ? document.getElementById("panel-wrapper").offsetHeight : "") {
          if (document.getElementById("sticky-header")) {
            topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 120);
          } else {
            topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 70);
          }
        } else {
          if (document.getElementById("panel-wrapper")) {
            if (document.getElementById("sticky-header")) {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 70 - 20);
            } else {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 40);
            }
          } else {
            if (document.getElementById("sticky-header")) {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 50 - 20);
            } else {
              topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 50 - 20);
            }
          }
        }
      }

      window.scrollTo({
        top: topLoc,
        behavior: "smooth"
      });
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags);

    if (this.reviewNewData != undefined) {
      // this.pageData = this.reviewNewData.content.blocks
      //   .filter((ele) => ele.blockName === "wpvcb/review-details")
      //   .shift()
      //   ? this.reviewNewData.content.blocks
      //       .filter((ele) => ele.blockName === "wpvcb/review-details")
      //       .shift().filtered_content
      //   : "";
      this.pageData = this.reviewNewData.partner;

      if (this.pageData) {
        if (this.pageData.product_information && this.pageData.product_information.support_email.length > 0) {
          this.supportEmail = this.pageData.product_information.support_email[0].email_address;
        } else {
          this.supportEmail = "";
        }

        if (this.pageData.product_information && this.pageData.product_information.contact_number.length > 0) {
          this.contactNumber = this.pageData.product_information.contact_number[0].contact_number;
          this.contactName = this.pageData.product_information.contact_number[0].title;
        } else {
          this.contactNumber = "";
          this.contactName = "";
        }

        if (this.pageData.supported_language) {
          this.supportedLang = JSON.parse(this.pageData.supported_language.language_name).map(function (ele) {
            return _this2.getLang(ele);
          });
        } else {
          this.supportedLang = [];
        }
      }

      this.metaData = this.reviewNewData.meta; // this.pageAttr = this.reviewNewData.content.blocks
      //   .filter((ele) => ele.blockName === "wpvcb/review-details")
      //   .shift()
      //   ? this.reviewNewData.content.blocks
      //       .filter((ele) => ele.blockName === "wpvcb/review-details")
      //       .shift().attrs
      //   : "";

      this.pageAttr = this.reviewNewData.attrs;
      this.tabData = this.reviewNewData.content.blocks;
      this.breadCrumb = this.reviewNewData.breadcrumb; // More Payments Bottom Card

      this.morePaymentBottom = this.reviewNewData.meta.more_payment_method; // Author Blocks Filtered

      var atBlock = this.reviewNewData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // Schema Append

      document.getElementById("schema-script").innerHTML = this.reviewNewData.schema; // Adminbar Data

      this.$root.adminBarData = Object.keys(this.reviewNewData.toolbar).length > 0 ? this.reviewNewData.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; //NotSupportBanner

      this.$root.notsupportbannerData = this.reviewNewData.not_supported_banner && Object.keys(this.reviewNewData.not_supported_banner).length > 0 ? this.reviewNewData.not_supported_banner : "";
      this.$root.disableNotSupportBanner = this.pageData && this.pageData.product_id ? false : true;
      this.$root.noScroll = this.pageData && this.pageData.product_id ? false : true;
      this.$root.notsupportassetSizes = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
      this.$root.notSupportPageType = "review"; // RightContent Blocks Filtered

      var rightBlock = this.reviewNewData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Assets Sizes

      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
      if (this.pageData) this.getBonusShowHide(this.pageData);

      if (this.tabData.length === 0 || this.tabData && this.tabData.filter(function (ele) {
        return ele.tab_content;
      }).length === 0) {
        this.pageIndex = 2;
      }

      if (!this.$root.enable_lazyload) {
        this.pageIndex = 4;
        this.$root.show_footer = true;
      } else {
        this.$root.show_footer = false;
      }
    } else {
      this.$root.loading = true;
      this.getPageData();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.heightCheck();

      _this3.updateBonusHeight();
    });

    if (this.scriptFlag === 0 && this.tabData.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    var that = this;
    window.addEventListener("scroll", function () {
      if (window.innerWidth > 991) {
        if (document.getElementById("panel-wrapper")) {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              } else {
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              }
            } else {
              document.getElementById("review-sticky-card").style.top = "-".concat(that.topStickyHeight + 1, "px");

              if (document.getElementById("sticky-regulation-banner")) {
                if (window.pageYOffset === 0) {
                  document.getElementById("sticky-regulation-banner").style.top = 0;
                } else {
                  document.getElementById("sticky-regulation-banner").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                }

                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");
              } else {
                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight);
              }
            }

            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
              }
            }
          }
        } else {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = 0;
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              } else {
                document.getElementById("review-sticky-card").style.top = 0;

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              }
            } else {
              document.getElementById("review-sticky-card").style.top = "-".concat(that.topStickyHeight + 1, "px");

              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = 0;

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = 0;
              }
            }

            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("review-sticky-card").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = 0;
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              //if (window.pageYOffset >= 550) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                } else {
                  that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight;
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  that.stickyNavTop = document.getElementById("sticky-header").offsetHeight;
                } else {
                  that.stickyNavTop = 0;
                }
              } // } else {
              //   that.stickyNavTop = 0;
              // }

            }
          }
        }
      } else {
        if (that.$root.show_stickymenu && that.$root.show_stickymenu_mobile && window.innerWidth < 992) {
          that.stickyNavTop = 70;
        }
      }

      if (document.getElementById("sticky-nav")) {
        var stickyParent = document.getElementById("sticky-nav").parentNode.parentNode.parentNode;

        if (window.pageYOffset > Math.ceil(that.getOffset(stickyParent).top + stickyParent.clientHeight - window.innerHeight + 200)) {
          //that.showSticky = false;
          that.stickyNavTop = 0;
        } else {
          that.showSticky = true;

          if (that.$root.show_stickymenu && that.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            that.stickyNavTop = 70;
          }
        }

        if (document.getElementById("review-sticky-card")) {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              that.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
            } else {
              that.scrollOffset = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              that.scrollOffset = document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
            } else {
              that.scrollOffset = document.getElementById("review-sticky-card").offsetHeight;
            }
          }
        }

        Object.keys(that.$refs).forEach(function (key) {
          if (that.$refs[key][0]) {
            if (window.innerWidth <= 768) {
              if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top) - 80) {
                that.activeKey = key;
                that.clickCount++;
              }
            } else {
              if (document.getElementById("panel-wrapper")) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 70 - 50 - 20)) {
                      that.activeKey = key;
                    }
                  } else {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 50 - 40)) {
                      that.activeKey = key;
                    }
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 70 - 20)) {
                      that.activeKey = key;
                    }
                  } else {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 40)) {
                      that.activeKey = key;
                    }
                  }
                }
              } else {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 50 - 50 - 20)) {
                      that.activeKey = key;
                    }
                  } else {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 70 - 50 - 20)) {
                      that.activeKey = key;
                    }
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 50 - 20)) {
                      that.activeKey = key;
                    }
                  } else {
                    if (Math.ceil(window.pageYOffset) >= Math.ceil(that.getOffset(that.$refs[key][0]).top - that.scrollOffset - 70 - 20)) {
                      that.activeKey = key;
                    }
                  }
                }
              }
            }
          }
        });
      } //that.heightCheck();

    }, {
      passive: true
    });
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
      var windowWidth = window.innerWidth;

      if (!this.smallCardView && windowWidth >= 768) {
        this.smallCardView = true;
      }

      if (window.innerWidth > 991) {
        if (document.getElementById("panel-wrapper")) {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              } else {
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              }
            } else {
              document.getElementById("review-sticky-card").style.top = "-".concat(that.topStickyHeight + 1, "px");

              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight);
                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");
              } else {
                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = "".concat(document.getElementById("panel-wrapper").offsetHeight);
              }
            }

            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
              }
            }
          }
        } else {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = 0;
                document.getElementById("review-sticky-card").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              } else {
                document.getElementById("review-sticky-card").style.top = 0;

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("review-sticky-card").offsetHeight, "px");
                }
              }
            } else {
              document.getElementById("review-sticky-card").style.top = "-".concat(that.topStickyHeight + 1, "px");

              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById("sticky-regulation-banner").style.top = 0;

                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("sticky-header")) document.getElementById("sticky-header").style.top = 0;
              }
            }

            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("review-sticky-card").offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop = document.getElementById("review-sticky-card").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById("review-sticky-card").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = 0;
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              //if (window.pageYOffset >= 550) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight;
                } else {
                  that.stickyNavTop = document.getElementById("sticky-regulation-banner").offsetHeight;
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  that.stickyNavTop = document.getElementById("sticky-header").offsetHeight;
                } else {
                  that.stickyNavTop = 0;
                }
              } // } else {
              //   that.stickyNavTop = 0;
              // }

            }
          }
        }
      } else {
        if (document.getElementById("panel-wrapper")) {
          that.stickyNavTop = document.getElementById("panel-wrapper").offsetHeight;
        } else {
          that.stickyNavTop = 0;
        }
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
    });

    if (window.innerWidth > 991) {
      document.getElementById("sticky-header") ? document.getElementById("sticky-header").style.top = "0" : "";
    }
  },
  watch: {
    "$route.params.postSlug": function $routeParamsPostSlug() {
      if (this.reviewNewData != undefined) {} else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    pageIndex: function pageIndex() {
      if (this.pageIndex > 3) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "GameGuideHolder",
  props: ["gameguideholderData"],
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_2__components_custom_block_RelatedLinks__["a" /* default */]
  },
  data: function data() {
    return {
      searchQuery: "",
      resources: "",
      oldResources: "",
      listview: true,
      top_block: {
        type: Object,
        default: function _default() {}
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      bluebar: {}
    };
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags); // Schema Append

    document.getElementById("schema-script").innerHTML = this.gameguideholderData.schema; // Blocks Filtered

    var title = this.gameguideholderData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/heading") {
        return ele.filtered_content;
      }
    });
    var content = this.gameguideholderData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/paragraph") {
        return ele.filtered_content;
      }
    });
    var emoji_section = this.gameguideholderData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/html") {
        return ele.filtered_content;
      }
    });
    this.top_block = {
      title: title,
      content: content,
      emoji_section: emoji_section
    }; // More Payments Bottom Card

    this.morePaymentBottom = this.gameguideholderData.meta.more_payment_method; // Author Blocks Filtered

    var atBlock = this.gameguideholderData.content.blocks.filter(function (ele) {
      if (ele.blockName === "wpvcb/author-block") {
        return ele.filtered_content;
      }
    });
    if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

    var rightBlock = this.gameguideholderData.content.blocks.filter(function (ele) {
      if (ele.blockName === "wpvcb/right-content-simpletoc") {
        return ele.filtered_content;
      }
    });
    if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Adminbar Data

    this.$root.adminBarData = Object.keys(this.gameguideholderData.toolbar).length > 0 ? this.gameguideholderData.toolbar : "";
    this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

    this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
  },
  mounted: function mounted() {
    var _this = this;

    // if (this.$root.enable_lazyload) {
    //   this.blockData.push(
    //     this.gameguideholderData.content.blocks[this.blockDataIndex]
    //   );
    //   this.blockDataIndex++;
    //   this.$root.show_footer = false;
    // } else {
    this.blockData = this.gameguideholderData.content.blocks;
    this.$root.show_footer = true; //}

    if (this.scriptFlag === 0 && this.gameguideholderData.content.blocks.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(function () {
      return _this.heightCheck();
    });
    var that = this;
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
    });
  },
  computed: {
    resultQuery: function resultQuery() {
      var _this2 = this;

      if (this.searchQuery) {
        return this.resources.filter(function (item) {
          return _this2.searchQuery.toLowerCase().split(" ").every(function (v) {
            return item.name.toLowerCase().includes(v);
          });
        });
      } else {
        return this.resources;
      }
    }
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__["a" /* getContrastYIQ */],
    getOffset: __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__["b" /* getOffset */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_3__misc_meta_changer__["a" /* metaChanger */],
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function mutationObserve(mutations) {
      if (this.blockData.length < this.gameguideholderData.content.blocks.length) {
        var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

        if (mainContentArea < window.innerHeight) {
          this.blockData = this.gameguideholderData.content.blocks.slice(0, this.blockDataIndex + 1);
          this.blockDataIndex++;
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.blockData.length < this.gameguideholderData.content.blocks.length) {
        this.busy = true;
        this.blockData = this.gameguideholderData.content.blocks.slice(0, this.blockDataIndex + 1);
        this.blockDataIndex++; //this.heightCheck();

        this.busy = false;
      }
    },
    getResult: function getResult(value) {
      if (value) {
        this.resources = this.oldResources.filter(function (item) {
          return value.toLowerCase().split(" ").every(function (v) {
            return item.name.toLowerCase().includes(v);
          });
        });
      } else {
        this.resources = this.oldResources;
      }
    },
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    }
  },
  watch: {
    blockData: function blockData() {
      if (this.blockData.length === this.gameguideholderData.content.blocks.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_StarRating__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_custom_block_IntroBlock__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_custom_block_TagBlock__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__misc_currency__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_Pages_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_fullscreen__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__(138);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













__WEBPACK_IMPORTED_MODULE_12_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_fullscreen___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "GameFree",
  props: ["gamesData", "gameTemplate"],
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0__components_ui_StarRating__["a" /* default */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_1__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_3__components_custom_block_RelatedLinks__["a" /* default */],
    IntroBlock: __WEBPACK_IMPORTED_MODULE_4__components_custom_block_IntroBlock__["a" /* default */],
    NotFound: __WEBPACK_IMPORTED_MODULE_5__pages_404__["default"],
    TagBlock: __WEBPACK_IMPORTED_MODULE_6__components_custom_block_TagBlock__["a" /* default */]
  },
  data: function data() {
    return {
      gameTopHeaderTitle: "",
      gamespageData: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      casinoTopList: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      top_block: {
        type: Object,
        default: function _default() {}
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      gamesTop3: [],
      gamesTop3Title: [],
      gamesTop3Attrs: {},
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      showData: true,
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      endOfblockData: false,
      gameOverlay: false,
      hideBonusLabelGB: false,
      hideToplistLabelGB: false,
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      introblockData: [],
      widthofgamesection: 0,
      typeCheck: "",
      bluebar: {},
      titleComponent: "",
      crownIcon: ""
    };
  },
  filters: {
    currency: __WEBPACK_IMPORTED_MODULE_7__misc_currency__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags);

    if (this.$root.hasPlay) {
      this.showData = false;
    } else {
      this.showData = true;
    }

    this.widthofgamesection = window.innerWidth;

    if (this.gamesData != undefined) {
      this.gamespageData = this.gamesData; // Schema Append

      document.getElementById("schema-script").innerHTML = this.gamespageData.schema; // Blocks Filtered

      var title = this.gamespageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "core/heading") {
          return ele.filtered_content;
        }
      });
      var content = this.gamespageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "core/paragraph") {
          return ele.filtered_content;
        }
      });
      var emoji_section = this.gamespageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "core/html") {
          return ele.filtered_content;
        }
      });
      this.top_block = {
        title: title,
        content: content,
        emoji_section: emoji_section
      }; // Filter games top 3

      this.gamesTop3 = [];
      this.gamespageData.content.blocks.forEach(function (ele) {
        if (ele.blockName === "wpvcb/casino-toplist" && ele.attrs && ele.attrs.style === "gamepage_top_3") {
          _this.gamesTop3.push(ele.filtered_content);

          _this.gamesTop3Title.push(ele.attrs.block_title ? ele.attrs.block_title : "");

          _this.gamesTop3Attrs = ele.attrs;
        }
      }); // Remove Games Top 3 from main blocks

      this.gamespageData.content.blocks = this.gamespageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/casino-toplist" && ele.attrs && ele.attrs.style === "gamepage_top_3") {
          return false;
        } else {
          return true;
        }
      }); // More Payments Bottom Card

      this.morePaymentBottom = this.gamespageData.meta.more_payment_method; // Author Blocks Filtered

      var atBlock = this.gamespageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

      var rightBlock = this.gamespageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Intro Block

      var introIndex = this.gamespageData.content.blocks.map(function (ele, index) {
        if (ele.blockName === "wpvcb/intro-block") {
          return index;
        }
      });

      if (introIndex[0] != undefined) {
        this.introblockData = this.gamespageData.content.blocks[introIndex[0]].filtered_content;
        this.gamespageData.content.blocks.splice(introIndex[0], 1);
      } // Adminbar Data


      this.$root.adminBarData = Object.keys(this.gamespageData.toolbar).length > 0 ? this.gamespageData.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
      if (this.gamespageData.meta && this.gamespageData.meta.geo_provider_partners_data && this.gamespageData.meta.geo_provider_partners_data.current) this.getBonusShowHideGB(this.gamespageData.meta.geo_provider_partners_data.current);
    } else {
      this.$root.loading = true;
      this.gamespageData = {};
      this.getData();
    }

    this.titleComponent = this.gamesTop3Attrs && this.gamesTop3Attrs.hasOwnProperty('title_tag') && this.gamesTop3Attrs.title_tag != '' ? this.gamesTop3Attrs.title_tag : 'span';
    var assetPath = "".concat(global.wpvue_script_data_params.site_url, "/wp-content/themes/wpvue/src/assets/images");
    this.crownIcon = global.wpvue_script_data_params.data.site_data.theme_icons.crown || assetPath + '/svg-icons/crown.svg';
  },
  mounted: function mounted() {
    var _this2 = this;

    var maxHeight = 0;
    document.querySelectorAll(".gamefree-casino").forEach(function (ele) {
      if (maxHeight <= ele.offsetHeight) {
        maxHeight = ele.offsetHeight;
      }
    });
    document.querySelectorAll(".gamefree-casino").forEach(function (ele) {
      ele.style.height = "".concat(maxHeight, "px");
    });
    var maxTermHeight = 0;
    document.querySelectorAll(".gam-term").forEach(function (ele) {
      if (maxTermHeight <= ele.offsetHeight) {
        maxTermHeight = ele.offsetHeight;
      }
    });
    document.querySelectorAll(".gam-term").forEach(function (ele) {
      ele.style.height = "".concat(maxTermHeight, "px");
    });
    var maxStickyHeight = 0;
    document.querySelectorAll(".sticky-review-card").forEach(function (ele) {
      if (maxStickyHeight <= ele.offsetHeight) {
        maxStickyHeight = ele.offsetHeight;
      }
    });
    document.querySelectorAll(".sticky-review-card").forEach(function (ele) {
      ele.style.height = "".concat(maxStickyHeight, "px");
    });

    if (window.innerWidth > 991 && this.gameTemplate) {
      var maxGameRightHeight = 0;
      document.querySelectorAll(".game-right").forEach(function (ele) {
        if (maxGameRightHeight <= ele.offsetHeight) {
          maxGameRightHeight = ele.offsetHeight;
        }
      });
      document.querySelectorAll(".game-left").forEach(function (ele) {
        if (maxGameRightHeight > 557) {
          ele.style.height = "".concat(maxGameRightHeight, "px");
        } else {
          ele.style.height = "".concat(557, "px");
        }
      });
    }

    if (Object.keys(this.gamespageData).length > 0) {
      //if (!this.$root.enable_lazyload) {
      this.blockData = this.gamespageData.content.blocks;
      this.blockDataIndex = this.gamespageData.content.blocks.length;
      this.$root.show_footer = true; // } else {
      //   if (this.gamespageData.content.blocks.length > 0) {
      //     this.incrementBlockDataValue();
      //     this.$root.show_footer = false;
      //   } else {
      //     this.$root.show_footer = true;
      //   }
      // }
    }

    if (this.scriptFlag === 0 && this.gamespageData.content.blocks.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(function () {
      return _this2.heightCheck();
    });
    var that = this;
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      _this2.widthofgamesection = window.innerWidth;
      that.heightCheck();
      that.iframeShowHideEvent();
      that.stopScrollCheck();
      if (!_this2.showData) that.openFullscreen();
    });
    var meta = this.gamespageData.meta;

    if (meta.bluebar) {
      this.bluebar = meta.bluebar;
    } else {
      this.bluebar = {};
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.hasPlay = false;
    this.showData = true;
    this.iframeShowHideEvent();
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
      that.iframeShowHideEvent();
      that.stopScrollCheck();
      that.openFullscreen();
    });
    document.getElementById("app").classList.remove("no-scroll");
  },
  watch: {
    $route: function $route() {
      if (this.$root.hasPlay) {
        this.showData = false;
      } else {
        this.showData = true;
      }

      if (this.gamesData != undefined) {} else {
        this.$root.loading = true;
        this.gamespageData = {};
        this.getData();
      }

      this.gamespageData = "";
    },
    blockData: function blockData() {
      if (this.blockData.length === this.gamespageData.content.blocks.length) {
        this.$root.show_footer = true;
      }
    },
    showData: function showData() {
      this.iframeShowHideEvent();
      if (this.showData) document.getElementById("app").classList.remove("no-scroll");else this.stopScrollCheck();
    }
  },
  computed: {
    color: function color() {
      var rgb = this.hexToRgb("#060236");
      return "rgba(".concat(rgb.r, ",").concat(rgb.g, ",").concat(rgb.b, ", 0.8)");
    }
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_9__misc_misc_function__["d" /* pSBC */],
    hexToRgb: __WEBPACK_IMPORTED_MODULE_9__misc_misc_function__["c" /* hexToRgb */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_9__misc_misc_function__["a" /* getContrastYIQ */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_8__misc_meta_changer__["a" /* metaChanger */],
    getOffset: __WEBPACK_IMPORTED_MODULE_9__misc_misc_function__["b" /* getOffset */],
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function mutationObserve(mutations) {
      if (Object.keys(this.gamespageData).length > 0 && this.blockData.length < this.gamespageData.content.blocks.length) {
        var appHeight = document.getElementById("app").offsetHeight;

        if (appHeight < window.innerHeight) {
          this.blockData = this.gamespageData.content.blocks.slice(0, this.blockDataIndex + 1);
          this.blockDataIndex++;
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (Object.keys(this.gamespageData).length > 0 && this.blockData.length < this.gamespageData.content.blocks.length) {
        this.busy = true;
        this.blockData = this.gamespageData.content.blocks.slice(0, this.blockDataIndex + 1);
        this.blockDataIndex++;
        this.busy = false; //this.heightCheck();
      } else {
        this.endOfblockData = true;
      }
    },
    incrementBlockDataValue: function incrementBlockDataValue() {
      if (this.gamespageData && this.gamespageData.content.blocks && !(this.gamespageData.meta && this.gamespageData.meta.geo_provider_partners_data && this.gamespageData.meta.geo_provider_partners_data.current)) {
        this.blockData = this.gamespageData.content.blocks.slice(0, this.blockDataIndex + 1);
        this.blockDataIndex++;
      }
    },
    todo: function todo() {
      var self = this;
      this.intervalid1 = setTimeout(function () {
        if (window.innerWidth >= 320) {
          var stickyShow = document.getElementById("game_review_flex");
          self.gameOverlay = true;
          stickyShow.style.display = "none";

          if (window.innerWidth > 991 && self.gameTemplate) {
            var maxGameRightHeight = 0;
            document.querySelectorAll(".game-right").forEach(function (ele) {
              if (maxGameRightHeight <= ele.offsetHeight) {
                maxGameRightHeight = ele.offsetHeight;
              }
            });
            document.querySelectorAll(".wrapper-game-iframe").forEach(function (ele) {
              if (maxGameRightHeight > 557) {
                ele.style.height = "".concat(maxGameRightHeight - 8, "px");
              } else {
                ele.style.height = "".concat(557, "px");
              }
            });
            document.querySelectorAll(".game-space").forEach(function (ele) {
              if (maxGameRightHeight > 557) {
                ele.style.height = "".concat(maxGameRightHeight - 8, "px");
              } else {
                ele.style.height = "".concat(557, "px");
              }
            });
          } else {
            if (this.gamespageData.meta && this.gamespageData.meta.enable_different_free_game_url_for_mobile) {
              document.querySelectorAll(".wrapper-iframe").forEach(function (ele) {
                if (maxGameRightHeight > 557) {
                  ele.style.height = "".concat(maxGameRightHeight - 8, "px");
                } else {
                  ele.style.height = "".concat(557, "px");
                }
              });
            }
          }
        }
      }, this.$root.game_overlay_screen_time * 1000);
    },
    overlayHide: function overlayHide() {
      this.gameOverlay = false;

      if (window.innerWidth > 991 && this.gameTemplate) {
        var maxGameRightHeight = 0;
        document.querySelectorAll(".game-right").forEach(function (ele) {
          if (maxGameRightHeight <= ele.offsetHeight) {
            maxGameRightHeight = ele.offsetHeight;
          }
        });
        document.querySelectorAll(".wrapper-game-iframe").forEach(function (ele) {
          if (maxGameRightHeight > 557) {
            ele.style.height = "".concat(maxGameRightHeight - 90 - 8, "px");
          } else {
            ele.style.height = "".concat(557 - 90, "px");
          }
        });

        if (this.gamesTop3 && this.gamesTop3.length > 0) {
          document.querySelectorAll(".game-space").forEach(function (ele) {
            if (maxGameRightHeight > 557) {
              ele.style.height = "".concat(maxGameRightHeight - 90 - 8, "px");
            } else {
              ele.style.height = "".concat(557 - 90, "px");
            }
          });
        } else {
          document.querySelectorAll(".game-space").forEach(function (ele) {
            ele.style.height = "".concat(557 + 90, "px");
          });
        }
      }

      var stickyShow = document.getElementById("game_review_flex");
      stickyShow.style.display = "block";
    },
    getData: function getData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_10__api_Pages_api__["a" /* HttpService */].getBody(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.params.postSlug, this.$root.user_id).then(function (res) {
        _this3.gamespageData = res.data.data; // Schema Append

        document.getElementById("schema-script").innerHTML = _this3.gamespageData.schema; // Blocks Filtered

        var title = _this3.gamespageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "core/heading") {
            return ele.filtered_content;
          }
        });

        var content = _this3.gamespageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "core/paragraph") {
            return ele.filtered_content;
          }
        });

        var emoji_section = _this3.gamespageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "core/html") {
            return ele.filtered_content;
          }
        });

        _this3.top_block = {
          title: title,
          content: content,
          emoji_section: emoji_section
        }; // Filter games top 3

        _this3.gamesTop3 = [];

        _this3.gamespageData.content.blocks.forEach(function (ele) {
          if (ele.blockName === "wpvcb/casino-toplist" && ele.attrs && ele.attrs.style === "gamepage_top_3") {
            _this3.gamesTop3.push(ele.filtered_content);

            _this3.gamesTop3Title.push(ele.attrs.block_title ? ele.attrs.block_title : "");

            _this3.gamesTop3Attrs = ele.attrs;
          }
        }); // Remove Games Top 3 from main blocks


        _this3.gamespageData.content.blocks = _this3.gamespageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/casino-toplist" && ele.attrs && ele.attrs.style === "gamepage_top_3") {
            return false;
          } else {
            return true;
          }
        }); // More Payments Bottom Card

        _this3.morePaymentBottom = _this3.gamespageData.meta.more_payment_method; // Author Blocks Filtered

        var atBlock = _this3.gamespageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/author-block") {
            return ele.filtered_content;
          }
        });

        if (atBlock.length > 0) _this3.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

        var rightBlock = _this3.gamespageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/right-content-simpletoc") {
            return ele.filtered_content;
          }
        });

        if (rightBlock.length > 0) _this3.rightBlockdata = rightBlock.shift().filtered_content; // Intro Block

        var introIndex = _this3.gamespageData.content.blocks.map(function (ele, index) {
          if (ele.blockName === "wpvcb/intro-block") {
            return index;
          }
        });

        if (introIndex[0] != undefined) {
          _this3.introblockData = _this3.gamespageData.content.blocks[introIndex[0]].filtered_content;

          _this3.gamespageData.content.blocks.splice(introIndex[0], 1);
        } // Adminbar Data


        _this3.$root.adminBarData = Object.keys(_this3.gamespageData.toolbar).length > 0 ? _this3.gamespageData.toolbar : "";
        _this3.$root.disable = _this3.$root.adminBarData ? _this3.$root.adminBarData.visible : false; // Assets Sizes

        _this3.assets_images = Object.keys(_this3.$root.asset_sizes).length > 0 ? _this3.$root.asset_sizes : "";
        if (_this3.gamespageData.meta && _this3.gamespageData.meta.geo_provider_partners_data && _this3.gamespageData.meta.geo_provider_partners_data.current) _this3.getBonusShowHideGB(_this3.gamespageData.meta.geo_provider_partners_data.current); //if (!this.$root.enable_lazyload) {

        _this3.blockData = _this3.gamespageData.content.blocks;
        _this3.blockDataIndex = _this3.gamespageData.content.blocks.length;
        _this3.$root.show_footer = true; // } else {
        //   if (this.gamespageData.content.blocks.length > 0) {
        //     this.incrementBlockDataValue();
        //     this.$root.show_footer = false;
        //   } else {
        //     this.$root.show_footer = true;
        //   }
        // }

        _this3.$root.loading = false;
        _this3.$root.body_loading_status = true;
      }).catch(function (err) {
        _this3.typeCheck = "error";
        _this3.$root.loading = false;
      });
    },
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    },
    showIframe: function showIframe() {
      this.showData = !this.showData;

      if (this.gamespageData.meta.geo_provider_partners_data && this.gamespageData.meta.geo_provider_partners_data.current) {
        this.todo();
      }

      if (window.innerWidth > 991 && this.gameTemplate) {
        var maxGameRightHeight = 0;
        document.querySelectorAll(".game-right").forEach(function (ele) {
          if (maxGameRightHeight <= ele.offsetHeight) {
            maxGameRightHeight = ele.offsetHeight;
          }
        });
        document.querySelectorAll(".game-left").forEach(function (ele) {
          if (maxGameRightHeight > 557) {
            ele.style.height = "".concat(maxGameRightHeight - 90 - 8, "px");
          } else {
            ele.style.height = "".concat(557 - 90, "px");
          }
        });
      } //this.openFullscreen();

    },
    getRoundedRating: function getRoundedRating(rating) {
      if (rating - Math.floor(rating) >= 0.5) {
        return Math.ceil(rating);
      } else {
        return Math.floor(rating);
      }
    },
    checkOrientationLandscape: function checkOrientationLandscape() {
      return window.innerHeight < window.innerWidth;
    },
    iframeFull: function iframeFull() {
      if (window.innerWidth <= 1200) {
        return this.checkOrientationLandscape();
      } else {
        return false;
      }
    },
    iframeShowHideEvent: function iframeShowHideEvent() {
      var appDom = document.getElementById("app");
      var header = document.getElementById("header");

      if (!this.showData) {
        if (window.innerWidth <= 1200) {
          if (this.checkOrientationLandscape()) {
            appDom.classList.add("iframe-full");
            header.classList.add("hide-header");
          } else {
            appDom.classList.remove("iframe-full");
            header.classList.remove("hide-header");
          }
        } else {
          appDom.classList.remove("iframe-full");
          header.classList.remove("hide-header");
        }
      } else {
        appDom.classList.remove("iframe-full");
        header.classList.remove("hide-header");
      }
    },
    stopScrollCheck: function stopScrollCheck() {
      if (!(this.gamespageData.meta && this.gamespageData.meta.enable_different_free_game_url_for_mobile)) {
        var appDom = document.getElementById("app");

        if (!this.showData) {
          if (window.innerWidth <= 1200) {
            if (this.checkOrientationLandscape()) {
              appDom.classList.remove("no-scroll");
            } else {
              appDom.classList.add("no-scroll");
            }
          } else {
            appDom.classList.remove("no-scroll");
          }
        }
      }
    },
    openFullscreen: function openFullscreen() {
      if (!(this.gamespageData.meta && this.gamespageData.meta.enable_different_free_game_url_for_mobile)) {
        if (window.innerWidth <= 1200 && window.innerWidth > window.innerHeight) {
          if (!this.$refs["fullscreen"].getState()) {
            this.$refs["fullscreen"].enter();
          }
        } else {
          if (this.$refs["fullscreen"].getState()) {
            this.$refs["fullscreen"].exit();
          }
        }

        if (window.innerWidth > 991 && this.gameTemplate) {
          var maxGameRightHeight = 0;
          document.querySelectorAll(".game-right").forEach(function (ele) {
            if (maxGameRightHeight <= ele.offsetHeight) {
              maxGameRightHeight = ele.offsetHeight;
            }
          });
          document.querySelectorAll(".wrapper-game-iframe").forEach(function (ele) {
            if (maxGameRightHeight > 557) {
              ele.style.height = "".concat(maxGameRightHeight - 90 - 8, "px");
            } else {
              ele.style.height = "".concat(557 - 90, "px");
            }
          });
        }
      }
    },
    getBonusShowHideGB: function getBonusShowHideGB(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabelGB = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabelGB = true;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_custom_block_TagBlock__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "IntroBlock",
  props: ["introBlockData", "pageName"],
  data: function data() {
    return {
      showFullText: false,
      introinnerWidth: 0
    };
  },
  components: {
    TagBlock: __WEBPACK_IMPORTED_MODULE_0__components_custom_block_TagBlock__["a" /* default */]
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["a" /* getContrastYIQ */],
    showMoreText: function showMoreText() {
      this.showFullText = !this.showFullText;

      if (this.showFullText) {
        document.querySelector(".intro-content").classList.add("none-height");
        document.querySelector(".intro-content").classList.remove("intro-hover");
      } else {
        document.querySelector(".intro-content").classList.remove("none-height");
        document.querySelector(".intro-content").classList.add("intro-hover");
      }
    },
    getRouteLink: function getRouteLink(slug, type) {
      var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var post_types = Object.values(global.wpvue_script_data_params.data.post_types);

      if (slug === 'home') {
        return "/";
      } else {
        if (post_types.indexOf(type) > -1) return base ? "/".concat(base, "/").concat(slug) : "/".concat(type, "/").concat(slug ? slug.replace('/', '') : '');else return base ? "/".concat(base, "/").concat(slug) : "/".concat(slug ? slug.replace('/', '') : '');
      }
    },
    getAltText: function getAltText(altText, url) {
      var textAlt = '';

      if (altText && altText != '') {
        textAlt = altText;
      } else {
        if (url) textAlt = url.substring(url.lastIndexOf('/') + 1).split('.')[0];
      }

      return textAlt;
    }
  },
  created: function created() {
    this.introinnerWidth = window.innerWidth;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {});
    window.addEventListener("resize", function () {
      _this.introinnerWidth = window.innerWidth;
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TagBlock",
  props: ["attrs", "title", "block", "usTag", "sty", "colorEnable", "titleAlign"],
  computed: {
    tag: function tag() {
      if (this.attrs && this.attrs.hasOwnProperty("title_tag")) return this.attrs && this.attrs.hasOwnProperty("title_tag") ? this.attrs.title_tag : "span";
    }
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_0__misc_misc_function__["a" /* getContrastYIQ */]
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DefaultPage",
  props: ["defaultPageData"],
  data: function data() {
    return {
      top_block: {
        type: Object,
        default: function _default() {}
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      bluebar: {}
    };
  },
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_2__components_custom_block_RelatedLinks__["a" /* default */]
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags); // Schema Append

    document.getElementById("schema-script").innerHTML = this.defaultPageData.schema; // Blocks Filtered

    var title = this.defaultPageData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/heading") {
        return ele.filtered_content;
      }
    });
    var content = this.defaultPageData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/paragraph") {
        return ele.filtered_content;
      }
    });
    var emoji_section = this.defaultPageData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/html") {
        return ele.filtered_content;
      }
    });
    this.top_block = {
      title: title,
      content: content,
      emoji_section: emoji_section
    }; // More Payments Bottom Card

    this.morePaymentBottom = this.defaultPageData.meta.more_payment_method; // Author Blocks Filtered

    var atBlock = this.defaultPageData.content.blocks.filter(function (ele) {
      if (ele.blockName === "wpvcb/author-block") {
        return ele.filtered_content;
      }
    });
    if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

    var rightBlock = this.defaultPageData.content.blocks.filter(function (ele) {
      if (ele.blockName === "wpvcb/right-content-simpletoc") {
        return ele.filtered_content;
      }
    });
    if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Adminbar Data

    this.$root.adminBarData = Object.keys(this.defaultPageData.toolbar).length > 0 ? this.defaultPageData.toolbar : "";
    this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

    this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
  },
  mounted: function mounted() {
    var _this = this;

    // if (this.$root.enable_lazyload) {
    //   this.incrementBlockDataValue();
    //   this.$root.show_footer = false;
    // } else {
    this.blockData = this.defaultPageData.content.blocks;
    this.$root.show_footer = true; //}

    if (this.scriptFlag === 0 && this.defaultPageData.content.blocks.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(function () {
      return _this.heightCheck();
    });
    var that = this;
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
    });
    var meta = this.defaultPageData.meta;

    if (meta.bluebar) {
      this.bluebar = meta.bluebar;
    } else {
      this.bluebar = {};
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
    });
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__["a" /* getContrastYIQ */],
    getOffset: __WEBPACK_IMPORTED_MODULE_4__misc_misc_function__["b" /* getOffset */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_3__misc_meta_changer__["a" /* metaChanger */],
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserveDefault: function mutationObserveDefault(mutations) {
      if (this.blockData.length < this.defaultPageData.content.blocks.length) {
        var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.blockData.length < this.defaultPageData.content.blocks.length) {
        this.busy = true;
        this.incrementBlockDataValue(); //this.heightCheck();

        this.busy = false;
      }
    },
    incrementBlockDataValue: function incrementBlockDataValue() {
      this.blockData = this.defaultPageData.content.blocks.slice(0, this.blockDataIndex + 1);
      this.blockDataIndex++;
    },
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    }
  },
  watch: {
    blockData: function blockData() {
      if (this.blockData.length === this.defaultPageData.content.blocks.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_custom_block_USMap__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MapTemplate",
  props: ["mapTemplateData"],
  data: function data() {
    return {
      top_block: {
        type: Object,
        default: function _default() {}
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      mapBlock: false,
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      bluebar: {}
    };
  },
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_2__components_CustomComponent__["a" /* default */],
    USMap: __WEBPACK_IMPORTED_MODULE_1__components_custom_block_USMap__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_3__components_custom_block_RelatedLinks__["a" /* default */]
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags); // Schema Append

    document.getElementById("schema-script").innerHTML = this.mapTemplateData.schema; // Blocks Filtered

    var title = this.mapTemplateData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/heading") {
        return ele.filtered_content;
      }
    });
    var content = this.mapTemplateData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/paragraph") {
        return ele.filtered_content;
      }
    });
    var emoji_section = this.mapTemplateData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/html") {
        return ele.filtered_content;
      }
    });
    this.top_block = {
      title: title,
      content: content,
      emoji_section: emoji_section
    }; // More Payments Bottom Card

    this.morePaymentBottom = this.mapTemplateData.meta.more_payment_method; // Author Blocks Filtered

    var atBlock = this.mapTemplateData.content.blocks.filter(function (ele) {
      if (ele.blockName === "wpvcb/author-block") {
        return ele.filtered_content;
      }
    });
    if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

    var rightBlock = this.mapTemplateData.content.blocks.filter(function (ele) {
      if (ele.blockName === "wpvcb/right-content-simpletoc") {
        return ele.filtered_content;
      }
    });
    if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Adminbar Data

    this.$root.adminBarData = Object.keys(this.mapTemplateData.toolbar).length > 0 ? this.mapTemplateData.toolbar : "";
    this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

    this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
  },
  mounted: function mounted() {
    var _this = this;

    // if (this.$root.enable_lazyload) {
    //   this.incrementBlockDataValue();
    //   this.$root.show_footer = false;
    // } else {
    this.blockData = this.mapTemplateData.content.blocks;
    this.$root.show_footer = true; //}

    if (this.scriptFlag === 0 && this.mapTemplateData.content.blocks.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    var _arrmap = [];
    _arrmap = this.mapTemplateData.content.blocks.filter(function (ele, index) {
      return ele.blockName === "wpvcb/us-map-data" && index === 0;
    });
    if (_arrmap.length > 0) this.mapBlock = true;
    this.$nextTick(function () {
      return _this.heightCheck();
    });
    var that = this;
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
    });
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["a" /* getContrastYIQ */],
    getOffset: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["b" /* getOffset */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_4__misc_meta_changer__["a" /* metaChanger */],
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserveDefault: function mutationObserveDefault(mutations) {
      if (this.blockData.length < this.mapTemplateData.content.blocks.length) {
        var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.blockData.length < this.mapTemplateData.content.blocks.length) {
        this.busy = true;
        this.incrementBlockDataValue(); //this.heightCheck();

        this.busy = false;
      }
    },
    incrementBlockDataValue: function incrementBlockDataValue() {
      this.blockData = this.mapTemplateData.content.blocks.slice(0, this.blockDataIndex + 1);
      this.blockDataIndex++;
    },
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    }
  },
  watch: {
    blockData: function blockData() {
      if (this.blockData.length === this.mapTemplateData.content.blocks.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_states__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_custom_block_TagBlock__ = __webpack_require__(140);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "USMap",
  props: ["usmapData", "heightVal"],
  components: {
    TagBlock: __WEBPACK_IMPORTED_MODULE_4__components_custom_block_TagBlock__["a" /* default */]
  },
  data: function data() {
    return {
      states: [],
      infoBoxPosition: {
        X: 0,
        Y: 0
      },
      infoPosition: {
        display: "none"
      },
      currentListIndex: 0,
      stateDefaultDisplay: 0,
      stateTopList: []
    };
  },
  computed: {
    stateLegalStatus: function stateLegalStatus() {
      return typeof this.$root.selectedState.age_casinos === "string" && this.$root.selectedState.age_casinos.length !== 0;
    },
    stateURL: function stateURL() {
      return typeof this.$root.selectedState.url === "string" && this.$root.selectedState.url.length !== 0;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    window.removeEventListener("resize", function () {
      _this.setInfoBoxPosition();

      _this.moveOnLocation();

      var windowWidth = window.innerWidth;

      if (!_this.smallCardView && windowWidth >= 768) {
        _this.smallCardView = true;
      }
    });
    window.removeEventListener("mousemove", function (e) {
      if (e.target) {
        if (document.getElementById("js-map-tooltip") && document.getElementById("js-map-tooltip").contains(e.target)) {} else {
          _this.unpointLocation(e);
        }
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.states = Object(__WEBPACK_IMPORTED_MODULE_2__misc_states__["a" /* getCountryCode */])(this.usmapData.selected_map);
    this.setStates();
    this.$nextTick(function () {//this.updateBonusHeight();
    });
    window.addEventListener("resize", function () {
      _this2.setInfoBoxPosition();

      _this2.moveOnLocation();

      var windowWidth = window.innerWidth;

      if (!_this2.smallCardView && windowWidth >= 768) {
        _this2.smallCardView = true;
      }
    });
    window.addEventListener("mousemove", function (e) {
      if (e.target) {
        if (document.getElementById("js-map-tooltip") && document.getElementById("js-map-tooltip").contains(e.target)) {} else {
          _this2.unpointLocation(e);
        }
      }
    }); // StateList Section Data Extraction

    Array.prototype.eachSlice = function (size) {
      this.arr = [];

      for (var i = 0, l = this.length; i < l; i += size) {
        this.arr.push(this.slice(i, i + size));
      }

      return this.arr;
    };

    var offsetLength = parseInt(this.$root.display_offset); //this.attrs.hasOwnProperty("display_offset") ? parseInt(this.attrs.display_offset) : parseInt(this.$root.display_offset);

    this.stateDefaultDisplay = parseInt(this.$root.default_display); // this.attrs.hasOwnProperty("default_display")
    //   ? parseInt(this.attrs.default_display)
    //   : parseInt(this.$root.default_display);

    var stateDefaultArray = Object.values(this.usmapData.states_data).slice(0, this.stateDefaultDisplay);
    var stateRemainingArray = Object.values(this.usmapData.states_data).slice(this.stateDefaultDisplay);
    this.stateTopList = [stateDefaultArray].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(stateRemainingArray.eachSlice(offsetLength)));
  },
  methods: {
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["a" /* getContrastYIQ */],
    pSBC: __WEBPACK_IMPORTED_MODULE_3__misc_misc_function__["d" /* pSBC */],
    setStates: function setStates() {
      var _this3 = this;

      this.states = this.states.map(function (state) {
        if (_this3.usmapData) {
          if (_this3.usmapData.states_data[state.state_code]) {
            return _objectSpread(_objectSpread({}, state), {}, {
              url: _this3.usmapData.states_data[state.state_code].url,
              age_casinos: _this3.usmapData.states_data[state.state_code].age_casinos,
              age_casinos_lbl: _this3.usmapData.states_data[state.state_code].age_casinos_lbl,
              age_poker_rooms: _this3.usmapData.states_data[state.state_code].age_poker_rooms,
              age_poker_rooms_lbl: _this3.usmapData.states_data[state.state_code].age_poker_rooms_lbl,
              age_bingo: _this3.usmapData.states_data[state.state_code].age_bingo,
              age_bingo_lbl: _this3.usmapData.states_data[state.state_code].age_bingo_lbl,
              age_lottery: _this3.usmapData.states_data[state.state_code].age_lottery,
              age_lottery_lbl: _this3.usmapData.states_data[state.state_code].age_lottery_lbl,
              age_dog_horse_racing: _this3.usmapData.states_data[state.state_code].age_dog_horse_racing,
              age_dog_horse_racing_lbl: _this3.usmapData.states_data[state.state_code].age_dog_horse_racing_lbl
            });
          }

          return state;
        }
      });
    },
    setInfoBoxPosition: function setInfoBoxPosition(e) {
      var _this4 = this;

      if (window.innerWidth > 1024) {
        if (this.states.length > 1 && e && e.target) {
          this.states.forEach(function (state) {
            if (state.state_code === e.target.getAttribute("data-name") && e.target.getAttribute("data-age") != "N/A" && e.target.getAttribute("data-age") != null) {
              _this4.$root.selectedState = state;
            }
          });
        }
      } else {
        this.infoPosition = {
          display: "none"
        };
      }
    },
    getFillColor: function getFillColor(age) {
      var status = {
        18: this.usmapData && this.usmapData.colors && Object.keys(this.usmapData.colors).length > 0 ? this.usmapData.colors.color_18 : null,
        "18-only-cruises": this.usmapData && this.usmapData.colors && Object.keys(this.usmapData.colors).length > 0 ? this.usmapData.colors.color_18 : null,
        "18-indian-casinos": this.usmapData && this.usmapData.colors && Object.keys(this.usmapData.colors).length > 0 ? this.usmapData.colors.color_18 : null,
        "18-21": this.usmapData && this.usmapData.colors && Object.keys(this.usmapData.colors).length > 0 ? this.usmapData.colors.color_21 : null,
        20: this.usmapData && this.usmapData.colors && Object.keys(this.usmapData.colors).length > 0 ? this.usmapData.colors.color_20 : null,
        21: this.usmapData && this.usmapData.colors && Object.keys(this.usmapData.colors).length > 0 ? this.usmapData.colors.color_21 : null,
        "N/A": this.usmapData && this.usmapData.colors && Object.keys(this.usmapData.colors).length > 0 ? this.usmapData.colors.color_na : null,
        null: this.usmapData && this.usmapData.colors && Object.keys(this.usmapData.colors).length > 0 ? this.usmapData.colors.color_null : null
      };
      return status[age];
    },
    moveOnLocation: function moveOnLocation(e) {
      var _this5 = this;

      if (window.innerWidth > 1024 && e && e.target) {
        this.states.forEach(function (state) {
          if (state.state_code === e.target.getAttribute("data-name") && e.target.getAttribute("data-age") != "N/A" && e.target.getAttribute("data-age") != null) {
            var tooltipArrowHeight = 8;
            var tooltipHeight = document.getElementById("js-map-tooltip").offsetHeight + tooltipArrowHeight;
            var tooltipWidth = document.getElementById("js-map-tooltip").offsetWidth;
            _this5.infoBoxPosition.Y = "".concat(e.clientY - document.getElementById("pt").getBoundingClientRect().top - tooltipHeight, "px");
            _this5.infoBoxPosition.X = "".concat(e.clientX - document.getElementById("pt").getBoundingClientRect().left, "px");
            _this5.infoPosition = {
              display: "block",
              transform: "translate(".concat(_this5.infoBoxPosition.X, ", ").concat(_this5.infoBoxPosition.Y, ")")
            };
            _this5.$root.pathValue = e.clientY;
          }
        });
      } else {
        this.infoPosition = {
          display: "none"
        };
      }
    },
    unpointLocation: function unpointLocation(e) {
      if (this.$root.pathValue === e.clientY) {} else {
        this.$root.selectedState = {};
      }
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Pages_api__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AboutUs",
  props: ["aboutUsData"],
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_1__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_3__components_custom_block_RelatedLinks__["a" /* default */],
    NotFound: __WEBPACK_IMPORTED_MODULE_4__pages_404__["default"]
  },
  data: function data() {
    var _ref;

    return _ref = {
      diposit: true,
      showMorePros: false,
      withdraw: true,
      showPros: true,
      pageData: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      top_block: {
        type: Object,
        default: function _default() {}
      },
      diposit_withdraw: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      diposit_only: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      withdraw_only: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      breadcrumb: {
        type: Array,
        default: function _default() {
          return [];
        }
      }
    }, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "top_block", {
      type: Object,
      default: function _default() {}
    }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "assets_images", {
      type: Object,
      default: function _default() {}
    }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "blockData1", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "blockData2", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "blockData3", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "pageBlockData1", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "pageBlockData2", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "pageBlockData3", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "block1Index", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "block2Index", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "block3Index", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "embedBlockNameList", ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"]), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "blockData", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "blockDataIndex", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "busy", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "endOfblockData", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "hideBonusLabel", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "hideToplistLabel", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "scriptFlag", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "auhtorBlockdata", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "rightBlockdata", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "typeCheck", ""), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "bluebar", {}), _ref;
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["a" /* getContrastYIQ */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_6__misc_meta_changer__["a" /* metaChanger */],
    getOffset: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["b" /* getOffset */],
    showProConsTab: function showProConsTab() {
      this.showPros = !this.showPros;
    },
    getPageData: function getPageData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_7__api_Pages_api__["a" /* HttpService */].getBody(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.params.postSlug, this.$root.user_id).then(function (res) {
        _this.blockData1 = [];
        _this.blockData3 = [];
        var res_data = res.data.data;
        _this.blockData2 = res_data.content.blocks;
        Object.keys(res_data.meta).forEach(function (key) {
          if (key != "more_payment_method" && key != "teams_section" && key != "timeline_section") _this.blockData1.push({
            blockName: key,
            data: res_data.meta[key]
          });
        });
        Object.keys(res_data.meta).forEach(function (key1) {
          if (key1 === "teams_section" || key1 === "timeline_section") _this.blockData3.push({
            blockName: key1,
            data: res_data.meta[key1]
          });
        }); // Assets Sizes

        _this.assets_images = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : ""; // More Payments Bottom Card

        _this.morePaymentBottom = res_data.meta.more_payment_method; // Author Blocks Filtered

        var atBlock = _this.blockData2.filter(function (ele) {
          if (ele.blockName === "wpvcb/author-block") {
            return ele.filtered_content;
          }
        });

        if (atBlock.length > 0) _this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

        var rightBlock = res_data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/right-content-simpletoc") {
            return ele.filtered_content;
          }
        });
        if (rightBlock.length > 0) _this.rightBlockdata = rightBlock.shift().filtered_content; // Breadcrumb

        _this.breadcrumb = res_data.breadcrumb; // Adminbar Data

        _this.$root.adminBarData = Object.keys(res_data.toolbar).length > 0 ? res_data.toolbar : "";
        _this.$root.disable = _this.$root.adminBarData ? _this.$root.adminBarData.visible : false; // Schema Append

        document.getElementById("schema-script").innerHTML = res_data.schema; //this.getBonusShowHide(this.top_section);
      }, function (err) {
        return console.log(err);
      }, function () {
        // if (!this.$root.enable_lazyload) {
        _this.pageBlockData1 = _this.blockData1;
        _this.pageBlockData2 = _this.blockData2;
        _this.$root.show_footer = true;
        _this.$root.body_loading_status = true; // } else {
        // if (Object.keys(this.blockData1).length > 0) {
        //   this.pageBlockData1.push(this.blockData1[this.block1Index]);
        //   this.block1Index++;
        //   this.$root.show_footer = false;
        // } else {
        //   this.$root.show_footer = true;
        // }
        //}
      }).catch(function (err) {
        _this.typeCheck = "error";
        _this.$root.loading = false;
      });
    },
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function mutationObserve(mutations) {
      if (this.pageBlockData1.length < this.blockData1.length || this.pageBlockData2.length < this.blockData2.length || this.pageBlockData3.length < this.blockData3.length) {
        if (this.pageBlockData1.length < this.blockData1.length) {
          var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

          if (mainContentArea < window.innerHeight) {
            //this.incrementBlockDataValue();
            this.pageBlockData1 = this.blockData1.slice(0, this.block1Index + 1);
            this.block1Index++;
            this.heightCheck();
          }
        } else if (this.pageBlockData2.length < this.blockData2.length) {
          var _mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

          if (_mainContentArea < window.innerHeight) {
            //this.incrementBlockDataValue();
            this.pageBlockData2 = this.blockData2.slice(0, this.block2Index + 1);
            this.block2Index++;
            this.heightCheck();
          }
        } else {
          var _mainContentArea2 = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

          if (_mainContentArea2 < window.innerHeight) {
            //this.incrementBlockDataValue();
            this.pageBlockData3 = this.blockData3.slice(0, this.block3Index + 1);
            this.block3Index++;
            this.heightCheck();
          }
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.pageBlockData1.length < this.blockData1.length || this.pageBlockData2.length < this.blockData2.length || this.pageBlockData3.length < this.blockData3.length) {
        this.busy = true; //this.incrementBlockDataValue();

        if (this.pageBlockData1.length < this.blockData1.length) {
          this.pageBlockData1 = this.blockData1.slice(0, this.block1Index + 1);
          this.block1Index++;
        } else if (this.pageBlockData2.length < this.blockData2.length) {
          this.pageBlockData2 = this.blockData2.slice(0, this.block2Index + 1);
          this.block2Index++;
        } else {
          this.pageBlockData3 = this.blockData3.slice(0, this.block3Index + 1);
          this.block3Index++;
        } //this.heightCheck();


        this.busy = false;
      }
    },
    incrementBlockDataValue: function incrementBlockDataValue() {
      this.blockData = this.pageData.slice(0, this.blockDataIndex + 1);
      this.blockDataIndex++;
    },
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    },
    getBonusShowHide: function getBonusShowHide(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    }
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags);
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.aboutUsData != undefined) {
      this.blockData1 = [];
      this.blockData3 = [];
      var res_data = this.aboutUsData;
      this.blockData2 = res_data.content.blocks;
      Object.keys(res_data.meta).forEach(function (key) {
        if (key != "more_payment_method" && key != "teams_section" && key != "timeline_section") _this2.blockData1.push({
          blockName: key,
          data: res_data.meta[key]
        });
      });
      Object.keys(res_data.meta).forEach(function (key1) {
        if (key1 === "teams_section" || key1 === "timeline_section") _this2.blockData3.push({
          blockName: key1,
          data: res_data.meta[key1]
        });
      }); // Assets Sizes

      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : ""; // More Payments Bottom Card

      this.morePaymentBottom = res_data.meta.more_payment_method; // Author Blocks Filtered

      var atBlock = this.blockData2.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

      var rightBlock = res_data.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Breadcrumb

      this.breadcrumb = res_data.breadcrumb; // Adminbar Data

      this.$root.adminBarData = Object.keys(res_data.toolbar).length > 0 ? res_data.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // if (!this.$root.enable_lazyload) {

      this.pageBlockData1 = this.blockData1;
      this.pageBlockData2 = this.blockData2;
      this.pageBlockData3 = this.blockData3;
      this.$root.show_footer = true; // } else {
      // if (Object.keys(this.blockData1).length > 0) {
      //   this.pageBlockData1.push(this.blockData1[this.block1Index]);
      //   this.block1Index++;
      //   this.$root.show_footer = false;
      // } else {
      //   this.$root.show_footer = true;
      // }
      //}
      // Schema Append

      document.getElementById("schema-script").innerHTML = res_data.schema; //this.getBonusShowHide(this.top_section);
    } else {
      this.$root.loading = true;
      this.getPageData();
    }

    if (this.scriptFlag === 0 && this.pageBlockData2.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(function () {
      return _this2.heightCheck();
    });
    var that = this;
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
    });
  },
  watch: {
    "$route.params.postSlug": function $routeParamsPostSlug() {
      if (this.softwareProviderData != undefined) {} else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    blockData: function blockData() {
      if (this.blockData.length === this.pageData.length) {
        this.$root.show_footer = true;
      }
    },
    pageBlockData1: function pageBlockData1() {
      if (this.pageBlockData1.length === this.blockData1.length && this.pageBlockData2.length === this.blockData2.length) {
        this.$root.show_footer = true;
      }
    },
    pageBlockData2: function pageBlockData2() {
      if (this.pageBlockData1.length === this.blockData1.length && this.pageBlockData2.length === this.blockData2.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_custom_block_AdventCalendar__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CalendarTemplate",
  props: ["calendarData"],
  data: function data() {
    return {
      top_block: {
        type: Object,
        default: function _default() {}
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      calendarBlock: false,
      adventCalendarAttrs_: {},
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      bluebar: {}
    };
  },
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Breadcrumb__["a" /* default */],
    AdventCalendar: __WEBPACK_IMPORTED_MODULE_1__components_custom_block_AdventCalendar__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_2__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_3__components_custom_block_RelatedLinks__["a" /* default */]
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags); // Schema Append

    document.getElementById("schema-script").innerHTML = this.calendarData.schema; // Blocks Filtered

    var title = this.calendarData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/heading") {
        return ele.filtered_content;
      }
    });
    var content = this.calendarData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/paragraph") {
        return ele.filtered_content;
      }
    });
    var emoji_section = this.calendarData.content.blocks.filter(function (ele) {
      if (ele.blockName === "core/html") {
        return ele.filtered_content;
      }
    });
    this.top_block = {
      title: title,
      content: content,
      emoji_section: emoji_section
    }; // More Payments Bottom Card

    this.morePaymentBottom = this.calendarData.meta.more_payment_method; // Author Blocks Filtered

    var atBlock = this.calendarData.content.blocks.filter(function (ele) {
      if (ele.blockName === "wpvcb/author-block") {
        return ele.filtered_content;
      }
    });
    if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

    var rightBlock = this.calendarData.content.blocks.filter(function (ele) {
      if (ele.blockName === "wpvcb/right-content-simpletoc") {
        return ele.filtered_content;
      }
    });
    if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Adminbar Data

    this.$root.adminBarData = Object.keys(this.calendarData.toolbar).length > 0 ? this.calendarData.toolbar : "";
    this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

    this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
  },
  mounted: function mounted() {
    var _this = this;

    // if (this.$root.enable_lazyload) {
    //   this.incrementBlockDataValue();
    //   this.$root.show_footer = false;
    // } else {
    this.blockData = this.calendarData.content.blocks;
    this.$root.show_footer = true; //}

    if (this.calendarData.feast_data && Object.keys(this.calendarData.feast_data).length > 0) this.calendarBlock = true;
    this.adventCalendarAttrs_ = {
      feast_heading: this.calendarData.feast_heading && this.calendarData.feast_heading != "" ? this.calendarData.feast_heading : null,
      feast_sub_heading: this.calendarData.feast_sub_heading && this.calendarData.feast_sub_heading != "" ? this.calendarData.feast_sub_heading : null,
      feast_background: this.calendarData.feast_background && this.calendarData.feast_background != "" ? this.calendarData.feast_background : null,
      feast_card_background: this.calendarData.feast_card_background && this.calendarData.feast_card_background != "" ? this.calendarData.feast_card_background : null,
      card_coming_soon_image: this.calendarData.card_coming_soon_image && this.calendarData.card_coming_soon_image != "" ? this.calendarData.card_coming_soon_image : null
    };

    if (this.scriptFlag === 0 && this.calendarData.content.blocks.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(function () {
      return _this.heightCheck();
    });
    var that = this;
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
    });
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["a" /* getContrastYIQ */],
    getOffset: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["b" /* getOffset */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_4__misc_meta_changer__["a" /* metaChanger */],
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserveDefault: function mutationObserveDefault(mutations) {
      if (this.blockData.length < this.calendarData.content.blocks.length) {
        var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.blockData.length < this.calendarData.content.blocks.length) {
        this.busy = true;
        this.incrementBlockDataValue(); //this.heightCheck();

        this.busy = false;
      }
    },
    incrementBlockDataValue: function incrementBlockDataValue() {
      this.blockData = this.calendarData.content.blocks.slice(0, this.blockDataIndex + 1);
      this.blockDataIndex++;
    },
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    }
  },
  watch: {
    blockData: function blockData() {
      if (this.blockData.length === this.calendarData.content.blocks.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_currency__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_StarRating__ = __webpack_require__(39);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AdventCalendar",
  props: ["adventCalendarData", "adventCalendarAttrs", "adventCalendarBreadcrumbs", "activeBreadcrumb", "assetsSize"],
  data: function data() {
    return {
      hideBonusLabel: false,
      strCls: "star-cls",
      adventFinalData: {},
      currentData: {},
      crownIcon: ''
    };
  },
  filters: {
    currency: __WEBPACK_IMPORTED_MODULE_2__misc_currency__["a" /* default */]
  },
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components_layouts_Breadcrumb__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_4__components_ui_StarRating__["a" /* default */]
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["a" /* getContrastYIQ */],
    updateBonusHeight: function updateBonusHeight() {
      var heightArr = [];
      document.querySelectorAll(".advent-bonus").forEach(function (ele) {
        heightArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".advent-bonus").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightArr), "px");
      });
    },
    getTimeStamp: function getTimeStamp(time, text) {
      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var timestamp = "";

      if (text === "today") {
        var _year = new Date().getFullYear();

        var _month = new Date().getMonth() + 1;

        var _day = value === null ? new Date().getDate() : new Date().getDate() - Number(value);

        if (_day <= 9) _day = "0".concat(_day);
        timestamp = new Date("".concat(_year, "-").concat(_month, "-").concat(_day)).getTime();
        return timestamp;
      }

      var year = time.slice(0, 4);
      var month = time.slice(4, 6);
      var day = time.slice(6, 8);
      timestamp = new Date("".concat(year, "-").concat(month, "-").concat(day)).getTime();
      return timestamp;
    }
  },
  created: function created() {
    var assetPath = "".concat(global.wpvue_script_data_params.site_url, "/wp-content/themes/wpvue/src/assets/images");
    this.crownIcon = global.wpvue_script_data_params.data.site_data.theme_icons.crown || assetPath + '/svg-icons/crown.svg';
  },
  mounted: function mounted() {
    var _this = this;

    var _filterData = [];
    Object.keys(this.adventCalendarData.data).forEach(function (ele) {
      if (_this.adventCalendarData.data[ele].type === "promotion" && Object.keys(_this.adventCalendarData.data[ele].partner_information).length > 0 && Object.keys(_this.adventCalendarData.data[ele].promotion_information).length > 0 || _this.adventCalendarData.data[ele].type === "partner" && Object.keys(_this.adventCalendarData.data[ele].partner_information).length > 0) return _filterData.push(_this.adventCalendarData.data[ele]);
    });
    this.adventFinalData = [].concat(_filterData);

    var _filterCurrentData = _filterData.filter(function (ele) {
      return Number(ele.Ymd.slice(6, 8)) === new Date().getDate();
    });

    this.currentData = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_filterCurrentData);
    this.$nextTick(function () {
      _this.updateBonusHeight();
    });
    window.addEventListener("resize", function () {
      _this.updateBonusHeight();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    window.removeEventListener("resize", function () {
      _this2.updateBonusHeight();
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Patetrn.f3fbd0c.svg";

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_StarRating__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_custom_block_NotSupportModal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__misc_currency__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_Pages_api__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PaymentOptions",
  props: ["paymentData"],
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1__components_ui_StarRating__["a" /* default */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_2__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_4__components_custom_block_RelatedLinks__["a" /* default */],
    NotSupportModal: __WEBPACK_IMPORTED_MODULE_5__components_custom_block_NotSupportModal__["a" /* default */],
    NotFound: __WEBPACK_IMPORTED_MODULE_6__pages_404__["default"]
  },
  data: function data() {
    var _ref;

    return _ref = {
      diposit: true,
      showMorePros: false,
      withdraw: true,
      showPros: true,
      pageData: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      top_block: {
        type: Object,
        default: function _default() {}
      },
      feature_image: "",
      page_title: "",
      top_casino_title: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      diposit_withdraw: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      diposit_only: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      withdraw_only: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      top_section: {
        type: Object,
        default: function _default() {}
      },
      advantage: {
        title: "",
        options: {
          type: Array,
          default: function _default() {
            return [];
          }
        }
      },
      disadvantage: {
        title: {
          type: String,
          default: function _default() {
            return "";
          }
        },
        options: {
          type: Array,
          default: function _default() {
            return [];
          }
        }
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      breadcrumb: {
        type: Array,
        default: function _default() {
          return [];
        }
      }
    }, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "top_block", {
      type: Object,
      default: function _default() {}
    }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "assets_images", {
      type: Object,
      default: function _default() {}
    }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "embedBlockNameList", ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"]), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "blockData", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "blockDataIndex", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "busy", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "endOfblockData", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "hideBonusLabel", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "hideToplistLabel", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "scriptFlag", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "paymentProcons", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "paymentProconsArr", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "auhtorBlockdata", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "rightBlockdata", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "noPartnerAvailableOption", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "noPartnerAvailableText", ""), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "paymentWidth", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "typeCheck", ""), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "bluebar", {}), _ref;
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_8__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_8__misc_misc_function__["a" /* getContrastYIQ */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_9__misc_meta_changer__["a" /* metaChanger */],
    getOffset: __WEBPACK_IMPORTED_MODULE_8__misc_misc_function__["b" /* getOffset */],
    showProConsTab: function showProConsTab() {
      this.showPros = !this.showPros;
    },
    getPageData: function getPageData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_10__api_Pages_api__["a" /* HttpService */].getBody(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.params.postSlug, this.$root.user_id).then(function (res) {
        var res_data = res.data.data;
        _this.pageData = res_data.content.blocks;
        var top_casino = res_data.top_casino;
        _this.top_casino_title = top_casino ? top_casino.group_title : "";
        _this.page_title = res_data.title;
        _this.feature_image = res_data.feature_image;
        _this.top_section = res_data.topsection ? res_data.topsection.shift() : "";
        _this.noPartnerAvailableOption = res_data.hasOwnProperty("no_partner_available_option") ? res_data.no_partner_available_option : false;
        if (_this.noPartnerAvailableOption) _this.noPartnerAvailableText = res_data.hasOwnProperty("no_partner_available_text") ? res_data.no_partner_available_text : ""; //payment procons

        _this.paymentProcons = res_data.payment_procons;

        if (_this.paymentProcons) {
          _this.paymentProconsArr = res_data.hasOwnProperty("procons") ? res_data.procons : [];
        } // Assets Sizes


        _this.assets_images = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : ""; // Pros Cons Section

        _this.advantage.title = res_data.meta.advantage_title;
        _this.advantage.options = res_data.meta.advantage_options;
        _this.disadvantage.title = res_data.meta.disadvantage_title;
        _this.disadvantage.options = res_data.meta.disadvantage_options; // More Payments Bottom Card

        _this.morePaymentBottom = res_data.meta.more_payment_method; // Author Blocks Filtered

        var atBlock = res_data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/author-block") {
            return ele.filtered_content;
          }
        });
        if (atBlock.length > 0) _this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

        var rightBlock = res_data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/right-content-simpletoc") {
            return ele.filtered_content;
          }
        });
        if (rightBlock.length > 0) _this.rightBlockdata = rightBlock.shift().filtered_content; // Breadcrumb

        _this.breadcrumb = res_data.breadcrumb; // Adminbar Data

        _this.$root.adminBarData = Object.keys(res_data.toolbar).length > 0 ? res_data.toolbar : "";
        _this.$root.disable = _this.$root.adminBarData ? _this.$root.adminBarData.visible : false; //NotSupportBanner

        _this.$root.notsupportbannerData = res_data.not_supported_banner && Object.keys(res_data.not_supported_banner).length > 0 ? res_data.not_supported_banner : "";
        _this.$root.disableNotSupportBanner = _this.top_section && Object.keys(_this.top_section).length > 0 ? false : true;
        _this.$root.noScroll = _this.top_section && Object.keys(_this.top_section).length > 0 ? false : true;
        _this.$root.notsupportassetSizes = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : "";
        _this.$root.notSupportPageType = "payment";
        _this.$root.notSupportType = res_data.type; // Schema Append

        document.getElementById("schema-script").innerHTML = res_data.schema;

        _this.getBonusShowHide(_this.top_section); // if (!this.$root.enable_lazyload) {


        _this.blockData = _this.pageData;
        _this.blockDataIndex = _this.pageData.length;
        _this.$root.show_footer = true;
        _this.$root.body_loading_status = true; // } else {
        // if (this.pageData.length > 0) {
        //   if (!this.top_section) {
        //     this.blockData.push(this.pageData[this.blockDataIndex]);
        //     this.blockDataIndex++;
        //   }
        //   this.$root.show_footer = false;
        // } else {
        //   this.$root.show_footer = true;
        // }
        //}
      }).catch(function (err) {
        _this.typeCheck = "error";
        _this.$root.loading = false;
      });
    },
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function mutationObserve(mutations) {
      if (this.blockData.length < this.pageData.length) {
        var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.blockData.length < this.pageData.length) {
        this.busy = true;
        this.incrementBlockDataValue(); //this.heightCheck();

        this.busy = false;
      } else {
        this.endOfblockData = true;
      }
    },
    incrementBlockDataValue: function incrementBlockDataValue() {
      this.blockData = this.pageData.slice(0, this.blockDataIndex + 1);
      this.blockDataIndex++;
    },
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    },
    getBonusShowHide: function getBonusShowHide(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    }
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags);
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.paymentData != undefined) {
      var res_data = this.paymentData;
      this.pageData = res_data.content.blocks;
      var top_casino = res_data.top_casino;
      this.top_casino_title = top_casino ? top_casino.group_title : "";
      this.page_title = res_data.title;
      this.feature_image = res_data.feature_image;
      this.top_section = res_data.topsection ? res_data.topsection.shift() : "";
      this.noPartnerAvailableOption = res_data.hasOwnProperty("no_partner_available_option") ? res_data.no_partner_available_option : false;
      if (this.noPartnerAvailableOption) this.noPartnerAvailableText = res_data.hasOwnProperty("no_partner_available_text") ? res_data.no_partner_available_text : ""; //payment procons

      this.paymentProcons = res_data.payment_procons;

      if (this.paymentProcons) {
        this.paymentProconsArr = res_data.hasOwnProperty("procons") ? res_data.procons : [];
      } // Assets Sizes


      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : ""; // Pros Cons Section

      this.advantage.title = res_data.meta.advantage_title;
      this.advantage.options = res_data.meta.advantage_options;
      this.disadvantage.title = res_data.meta.disadvantage_title;
      this.disadvantage.options = res_data.meta.disadvantage_options; // More Payments Bottom Card

      this.morePaymentBottom = res_data.meta.more_payment_method; // Author Blocks Filtered

      var atBlock = res_data.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

      var rightBlock = res_data.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Breadcrumb

      this.breadcrumb = res_data.breadcrumb; // Adminbar Data

      this.$root.adminBarData = Object.keys(res_data.toolbar).length > 0 ? res_data.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; //NotSupportBanner

      this.$root.notsupportbannerData = res_data.not_supported_banner && Object.keys(res_data.not_supported_banner).length > 0 ? res_data.not_supported_banner : "";
      this.$root.disableNotSupportBanner = this.top_section && Object.keys(this.top_section).length > 0 ? false : true;
      this.$root.noScroll = this.top_section && Object.keys(this.top_section).length > 0 ? false : true;
      this.$root.notsupportassetSizes = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
      this.$root.notSupportPageType = "payment";
      this.$root.notSupportType = res_data.type; //if (!this.$root.enable_lazyload) {

      this.blockData = this.pageData;
      this.blockDataIndex = this.pageData.length;
      this.$root.show_footer = true; // } else {
      //   if (this.pageData.length > 0) {
      //     if (!this.top_section) {
      //       this.blockData.push(this.pageData[this.blockDataIndex]);
      //       this.blockDataIndex++;
      //     }
      //     this.$root.show_footer = false;
      //   } else {
      //     this.$root.show_footer = true;
      //   }
      // }
      // Schema Append

      document.getElementById("schema-script").innerHTML = res_data.schema;
      this.getBonusShowHide(this.top_section);
    } else {
      this.$root.loading = true;
      this.getPageData();
    }

    if (this.scriptFlag === 0 && this.pageData.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(function () {
      _this2.heightCheck();

      _this2.paymentWidth = window.innerWidth;
    });
    var that = this;
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
      that.paymentWidth = window.innerWidth;
    });
    var meta = this.paymentData.meta;

    if (meta.bluebar) {
      this.bluebar = meta.bluebar;
    } else {
      this.bluebar = {};
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
    });
  },
  filters: {
    currency: __WEBPACK_IMPORTED_MODULE_7__misc_currency__["a" /* default */]
  },
  watch: {
    "$route.params.postSlug": function $routeParamsPostSlug() {
      if (this.paymentData != undefined) {} else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    blockData: function blockData() {
      if (this.blockData.length === this.pageData.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_StarRating__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_custom_block_NotSupportModal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__misc_currency__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_Pages_api__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SoftwareProviders",
  props: ["softwareProviderData"],
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_1__components_ui_StarRating__["a" /* default */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_2__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_4__components_custom_block_RelatedLinks__["a" /* default */],
    NotSupportModal: __WEBPACK_IMPORTED_MODULE_5__components_custom_block_NotSupportModal__["a" /* default */],
    NotFound: __WEBPACK_IMPORTED_MODULE_6__pages_404__["default"]
  },
  data: function data() {
    var _ref;

    return _ref = {
      diposit: true,
      showMorePros: false,
      withdraw: true,
      showPros: true,
      pageData: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      top_block: {
        type: Object,
        default: function _default() {}
      },
      feature_image: "",
      feature_pro_name: "",
      page_title: "",
      top_casino_title: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      diposit_withdraw: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      diposit_only: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      withdraw_only: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      top_section: {
        type: Object,
        default: function _default() {}
      },
      advantage: {
        title: "",
        options: {
          type: Array,
          default: function _default() {
            return [];
          }
        }
      },
      disadvantage: {
        title: {
          type: String,
          default: function _default() {
            return "";
          }
        },
        options: {
          type: Array,
          default: function _default() {
            return [];
          }
        }
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      breadcrumb: {
        type: Array,
        default: function _default() {
          return [];
        }
      }
    }, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "top_block", {
      type: Object,
      default: function _default() {}
    }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "assets_images", {
      type: Object,
      default: function _default() {}
    }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "embedBlockNameList", ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"]), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "blockData", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "blockDataIndex", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "busy", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "endOfblockData", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "hideBonusLabel", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "hideToplistLabel", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "scriptFlag", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "softwareProcons", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "softwareProconsArr", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "auhtorBlockdata", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "rightBlockdata", []), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "noPartnerAvailableOption", false), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "noPartnerAvailableText", ""), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "softwareWidth", 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "typeCheck", ""), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ref, "bluebar", {}), _ref;
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_8__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_8__misc_misc_function__["a" /* getContrastYIQ */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_9__misc_meta_changer__["a" /* metaChanger */],
    getOffset: __WEBPACK_IMPORTED_MODULE_8__misc_misc_function__["b" /* getOffset */],
    showProConsTab: function showProConsTab() {
      this.showPros = !this.showPros;
    },
    getPageData: function getPageData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_10__api_Pages_api__["a" /* HttpService */].getBody(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.params.postSlug, this.$root.user_id).then(function (res) {
        var res_data = res.data.data;
        _this.pageData = res_data.content.blocks;
        var top_casino = res_data.top_casino;
        _this.top_casino_title = top_casino ? top_casino.group_title : "";
        _this.page_title = res_data.title;
        _this.feature_pro_name = res_data.topsection_sofft_info && res_data.topsection_sofft_info.length > 0 ? res_data.topsection_sofft_info[0].sw_name : "";
        _this.feature_image = res_data.topsection_sofft_info && res_data.topsection_sofft_info.length > 0 ? res_data.topsection_sofft_info.shift().swa_url : "";
        _this.top_section = res_data.topsection ? res_data.topsection.shift() : "";
        _this.noPartnerAvailableOption = res_data.hasOwnProperty("no_partner_available_option") ? res_data.no_partner_available_option : false;
        if (_this.noPartnerAvailableOption) _this.noPartnerAvailableText = res_data.hasOwnProperty("no_partner_available_text") ? res_data.no_partner_available_text : ""; //software procons

        _this.softwareProcons = res_data.software_procons;

        if (_this.softwareProcons) {
          _this.softwareProconsArr = res_data.hasOwnProperty("procons") ? res_data.procons : [];
        } // Assets Sizes


        _this.assets_images = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : ""; // Pros Cons Section

        _this.advantage.title = res_data.meta.advantage_title;
        _this.advantage.options = res_data.meta.advantage_options;
        _this.disadvantage.title = res_data.meta.disadvantage_title;
        _this.disadvantage.options = res_data.meta.disadvantage_options; // More Payments Bottom Card

        _this.morePaymentBottom = res_data.meta.more_payment_method; // Author Blocks Filtered

        var atBlock = res_data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/author-block") {
            return ele.filtered_content;
          }
        });
        if (atBlock.length > 0) _this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

        var rightBlock = res_data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/right-content-simpletoc") {
            return ele.filtered_content;
          }
        });
        if (rightBlock.length > 0) _this.rightBlockdata = rightBlock.shift().filtered_content; // Breadcrumb

        _this.breadcrumb = res_data.breadcrumb; // Adminbar Data

        _this.$root.adminBarData = Object.keys(res_data.toolbar).length > 0 ? res_data.toolbar : "";
        _this.$root.disable = _this.$root.adminBarData ? _this.$root.adminBarData.visible : false; //NotSupportBanner

        _this.$root.notsupportbannerData = res_data.not_supported_banner && Object.keys(res_data.not_supported_banner).length > 0 ? res_data.not_supported_banner : "";
        _this.$root.disableNotSupportBanner = _this.top_section && Object.keys(_this.top_section).length > 0 ? false : true;
        _this.$root.noScroll = _this.top_section && Object.keys(_this.top_section).length > 0 ? false : true;
        _this.$root.notsupportassetSizes = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : "";
        _this.$root.notSupportPageType = "software";
        _this.$root.notSupportType = res_data.type; // Schema Append

        document.getElementById("schema-script").innerHTML = res_data.schema;

        _this.getBonusShowHide(_this.top_section);
      }, function (err) {
        return console.log(err);
      }, function () {
        // if (!this.$root.enable_lazyload) {
        _this.blockData = _this.pageData;
        _this.blockDataIndex = _this.pageData.length;
        _this.$root.show_footer = true;
        _this.$root.body_loading_status = true; // } else {
        // if (this.pageData.length > 0) {
        //   if (!this.top_section) {
        //     this.blockData.push(this.pageData[this.blockDataIndex]);
        //     this.blockDataIndex++;
        //   }
        //   this.$root.show_footer = false;
        // } else {
        //   this.$root.show_footer = true;
        // }
        //}
      }).catch(function (err) {
        _this.typeCheck = "error";
        _this.$root.loading = false;
      });
    },
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function mutationObserve(mutations) {
      if (this.blockData.length < this.pageData.length) {
        var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.blockData.length < this.pageData.length) {
        this.busy = true;
        this.incrementBlockDataValue(); //this.heightCheck();

        this.busy = false;
      } else {
        this.endOfblockData = true;
      }
    },
    incrementBlockDataValue: function incrementBlockDataValue() {
      this.blockData = this.pageData.slice(0, this.blockDataIndex + 1);
      this.blockDataIndex++;
    },
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    },
    getBonusShowHide: function getBonusShowHide(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    }
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags);
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.softwareProviderData != undefined) {
      var res_data = this.softwareProviderData;
      this.pageData = res_data.content.blocks;
      var top_casino = res_data.top_casino;
      this.top_casino_title = top_casino ? top_casino.group_title : "";
      this.page_title = res_data.title;
      this.feature_pro_name = res_data.topsection_sofft_info && res_data.topsection_sofft_info.length > 0 ? res_data.topsection_sofft_info[0].sw_name : "";
      this.feature_image = res_data.topsection_sofft_info && res_data.topsection_sofft_info.length > 0 ? res_data.topsection_sofft_info.shift().swa_url : "";
      this.top_section = res_data.topsection ? res_data.topsection.shift() : "";
      this.noPartnerAvailableOption = res_data.hasOwnProperty("no_partner_available_option") ? res_data.no_partner_available_option : false;
      if (this.noPartnerAvailableOption) this.noPartnerAvailableText = res_data.hasOwnProperty("no_partner_available_text") ? res_data.no_partner_available_text : ""; //software procons

      this.softwareProcons = res_data.software_procons;

      if (this.softwareProcons) {
        this.softwareProconsArr = res_data.hasOwnProperty("procons") ? res_data.procons : [];
      } // Assets Sizes


      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : ""; // Pros Cons Section

      this.advantage.title = res_data.meta.advantage_title;
      this.advantage.options = res_data.meta.advantage_options;
      this.disadvantage.title = res_data.meta.disadvantage_title;
      this.disadvantage.options = res_data.meta.disadvantage_options; // More Payments Bottom Card

      this.morePaymentBottom = res_data.meta.more_payment_method; // Author Blocks Filtered

      var atBlock = res_data.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

      var rightBlock = res_data.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Breadcrumb

      this.breadcrumb = res_data.breadcrumb; // Adminbar Data

      this.$root.adminBarData = Object.keys(res_data.toolbar).length > 0 ? res_data.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; //NotSupportBanner

      this.$root.notsupportbannerData = res_data.not_supported_banner && Object.keys(res_data.not_supported_banner).length > 0 ? res_data.not_supported_banner : "";
      this.$root.disableNotSupportBanner = this.top_section && Object.keys(this.top_section).length > 0 ? false : true;
      this.$root.noScroll = this.top_section && Object.keys(this.top_section).length > 0 ? false : true;
      this.$root.notsupportassetSizes = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
      this.$root.notSupportPageType = "software";
      this.$root.notSupportType = res_data.type; // if (!this.$root.enable_lazyload) {

      this.blockData = this.pageData;
      this.blockDataIndex = this.pageData.length;
      this.$root.show_footer = true; // } else {
      // if (this.pageData.length > 0) {
      //   if (!this.top_section) {
      //     this.incrementBlockDataValue();
      //   }
      //   this.$root.show_footer = false;
      // } else {
      //   this.$root.show_footer = true;
      // }
      //}
      // Schema Append

      document.getElementById("schema-script").innerHTML = res_data.schema;
      this.getBonusShowHide(this.top_section);
    } else {
      this.$root.loading = true;
      this.getPageData();
    }

    if (this.scriptFlag === 0 && this.pageData.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(function () {
      _this2.heightCheck();

      _this2.softwareWidth = window.innerWidth;
    });
    var that = this;
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
      that.softwareWidth = window.innerWidth;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
    });
  },
  filters: {
    currency: __WEBPACK_IMPORTED_MODULE_7__misc_currency__["a" /* default */]
  },
  watch: {
    "$route.params.postSlug": function $routeParamsPostSlug() {
      if (this.softwareProviderData != undefined) {} else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    blockData: function blockData() {
      if (this.blockData.length === this.pageData.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_StarRating__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Pages_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Promotions",
  props: ["promotionData"],
  data: function data() {
    return {
      helpful: null,
      top_block: {
        type: Object,
        default: function _default() {}
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      promotionPageData: [],
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      top_casino_title: "",
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      timer_html: "",
      timer_width: "",
      strCls: "star-cls",
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      typeCheck: "",
      bluebar: {}
    };
  },
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0__components_ui_StarRating__["a" /* default */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_1__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_3__components_custom_block_RelatedLinks__["a" /* default */],
    NotFound: __WEBPACK_IMPORTED_MODULE_4__pages_404__["default"]
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags);
  },
  mounted: function mounted() {
    var _this = this;

    if (this.promotionData != undefined) {
      this.promotionPageData = this.promotionData; // Schema Append

      document.getElementById("schema-script").innerHTML = this.promotionPageData.schema; // Blocks Filtered

      var title = this.promotionPageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "core/heading") {
          return ele.filtered_content;
        }
      });
      var content = this.promotionPageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "core/paragraph") {
          return ele.filtered_content;
        }
      });
      var emoji_section = this.promotionPageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "core/html") {
          return ele.filtered_content;
        }
      });
      this.top_block = {
        title: title,
        content: content,
        emoji_section: emoji_section
      }; // More Payments Bottom Card

      this.morePaymentBottom = this.promotionPageData.meta.more_payment_method; // Author Blocks Filtered

      var atBlock = this.promotionPageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

      var rightBlock = this.promotionPageData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Adminbar Data

      this.$root.adminBarData = Object.keys(this.promotionPageData.toolbar).length > 0 ? this.promotionPageData.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";
      this.updateTimerPromo();
      this.interval = setInterval(this.updateTimerPromo, 60000); // if (this.$root.enable_lazyload) {
      //   this.blockData.push(
      //     this.promotionPageData.content.blocks[this.blockDataIndex]
      //   );
      //   this.blockDataIndex++;
      //   this.$root.show_footer = false;
      // } else {

      this.blockData = this.promotionPageData.content.blocks;
      this.$root.show_footer = true; //}
    } else {
      this.$root.loading = true;
      this.promotionPageData = [];
      this.getPageData();
    }

    if (this.scriptFlag === 0 && this.promotionPageData.content.blocks.filter(function (ele) {
      return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
    }).length > 0) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(function () {
      _this.updateBonusHeight();

      _this.heightCheck();
    });
    var that = this;
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
    });
    var meta = this.promotionPageData.meta;

    if (meta.bluebar) {
      this.bluebar = meta.bluebar;
    } else {
      this.bluebar = {};
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
    });
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["a" /* getContrastYIQ */],
    getOffset: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["b" /* getOffset */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_6__misc_meta_changer__["a" /* metaChanger */],
    getPartnerImg: function getPartnerImg(assets) {
      var img_src = assets.filter(function (ele) {
        return ele.asset_category_name === "product_logo";
      })[0];

      if (Object.keys(img_src).length > 0 && img_src.url) {
        return img_src.url;
      } else {
        return null;
      }
    },
    updateBonusHeight: function updateBonusHeight() {
      var heightArr = [];
      document.querySelectorAll(".promto-text").forEach(function (ele) {
        heightArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".promto-text").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightArr), "px");
      });
      var heightTermArr = [];
      document.querySelectorAll(".promto-term").forEach(function (ele) {
        heightTermArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".promto-term").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightTermArr), "px");
      });
      var heightTimeArr = [];
      document.querySelectorAll(".promto-time").forEach(function (ele) {
        heightTimeArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".promto-time").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightTimeArr), "px");
      });
    },
    updateTimerPromo: function updateTimerPromo() {
      if (this.promotionPageData && this.promotionPageData.featured_promotion && Object.keys(this.promotionPageData.featured_promotion).length > 0) {
        this.timer_html = "";
        var timer_calc = Date.parse(this.promotionPageData.featured_promotion.metadata.promotion_end_date) + 86400000 - Date.parse(new Date());
        var months = Math.floor(timer_calc / (1000 * 60 * 60 * 24 * 30));
        var days = Math.floor(timer_calc / (1000 * 60 * 60 * 24) % 30);
        var hours = Math.floor(timer_calc % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(timer_calc % (1000 * 60 * 60) / (1000 * 60));

        if (months > 0) {
          this.timer_html += "<span class=\"fw-bold\">".concat(months, "</span> ").concat(this.$root.i18n.months.charAt(0).toUpperCase() + this.$root.i18n.months.slice(1), ", <span class=\"fw-bold\">").concat(days, "</span> ").concat(this.$root.i18n.days.charAt(0).toUpperCase() + this.$root.i18n.days.slice(1), ", <span class=\"fw-bold\">").concat(hours, "</span> ").concat(this.$root.i18n.hours.charAt(0).toUpperCase() + this.$root.i18n.hours.slice(1), ", <span class=\"fw-bold\">").concat(minutes, "</span> ").concat(this.$root.i18n.mins.charAt(0).toUpperCase() + this.$root.i18n.mins.slice(1));
          this.timer_width = "300px";
        } else if (days > 0) {
          this.timer_html += "<span class=\"fw-bold\">".concat(days, "</span> ").concat(this.$root.i18n.days.charAt(0).toUpperCase() + this.$root.i18n.days.slice(1), ", <span class=\"fw-bold\">").concat(hours, "</span> ").concat(this.$root.i18n.hours.charAt(0).toUpperCase() + this.$root.i18n.hours.slice(1), ", <span class=\"fw-bold\">").concat(minutes, "</span> ").concat(this.$root.i18n.mins.charAt(0).toUpperCase() + this.$root.i18n.mins.slice(1));
          this.timer_width = "260px";
        } else if (hours > 0) {
          this.timer_html += "<span class=\"fw-bold\">".concat(hours, "</span> ").concat(this.$root.i18n.hours.charAt(0).toUpperCase() + this.$root.i18n.hours.slice(1), ", <span class=\"fw-bold\">").concat(minutes, "</span> ").concat(this.$root.i18n.mins.charAt(0).toUpperCase() + this.$root.i18n.mins.slice(1));
          this.timer_width = "220px";
        } else if (minutes > 0) {
          this.timer_html += "<span class=\"fw-bold\">".concat(minutes, "</span> ").concat(this.$root.i18n.mins.charAt(0).toUpperCase() + this.$root.i18n.mins.slice(1));
          this.timer_width = "200px";
        } else {
          this.timer_html = "";
          this.timer_width = "200px";
        }
      }
    },
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function mutationObserve(mutations) {
      if (this.blockData.length < this.promotionPageData.content.blocks.length) {
        var mainContentArea = this.getOffset(mutations[0].target).top + mutations[0].target.offsetHeight;

        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function loadMore() {
      if (this.blockData.length < this.promotionPageData.content.blocks.length) {
        this.busy = true;
        this.incrementBlockDataValue(); //this.heightCheck();

        this.busy = false;
      }
    },
    incrementBlockDataValue: function incrementBlockDataValue() {
      this.blockData = this.promotionPageData.content.blocks.slice(0, this.blockDataIndex + 1);
      this.blockDataIndex++;
    },
    itemFAQ: function itemFAQ(data) {
      var FAQitems = [];
      data.forEach(function (ele) {
        var id = ele.id,
            title = ele.faq_question,
            content = ele.faq_answer;
        var is_active = false;

        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({
          id: id,
          title: title,
          content: content,
          is_active: is_active
        });
      });
      return FAQitems;
    },
    getPageData: function getPageData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7__api_Pages_api__["a" /* HttpService */].getBody(this.$route.params.postSlug, this.$root.user_id).then(function (res) {
        _this2.promotionPageData = res.data.data; // Schema Append

        document.getElementById("schema-script").innerHTML = _this2.promotionPageData.schema; // Blocks Filtered

        var title = _this2.promotionPageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "core/heading") {
            return ele.filtered_content;
          }
        });

        var content = _this2.promotionPageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "core/paragraph") {
            return ele.filtered_content;
          }
        });

        var emoji_section = _this2.promotionPageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "core/html") {
            return ele.filtered_content;
          }
        });

        _this2.top_block = {
          title: title,
          content: content,
          emoji_section: emoji_section
        }; // More Payments Bottom Card

        _this2.morePaymentBottom = _this2.promotionPageData.meta.more_payment_method; // Author Blocks Filtered

        var atBlock = _this2.promotionPageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/author-block") {
            return ele.filtered_content;
          }
        });

        if (atBlock.length > 0) _this2.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

        var rightBlock = _this2.promotionPageData.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/right-content-simpletoc") {
            return ele.filtered_content;
          }
        });

        if (rightBlock.length > 0) _this2.rightBlockdata = rightBlock.shift().filtered_content; // Adminbar Data

        _this2.$root.adminBarData = Object.keys(_this2.promotionPageData.toolbar).length > 0 ? _this2.promotionPageData.toolbar : "";
        _this2.$root.disable = _this2.$root.adminBarData ? _this2.$root.adminBarData.visible : false; // Assets Sizes

        _this2.assets_images = Object.keys(_this2.promotionPageData.asset_sizes).length > 0 ? _this2.promotionPageData.asset_sizes : "";

        _this2.updateTimerPromo();

        _this2.interval = setInterval(_this2.updateTimerPromo, 60000); //if (!this.$root.enable_lazyload) {

        _this2.blockData = _this2.promotionPageData;
        _this2.blockDataIndex = _this2.promotionPageData.length;
        _this2.$root.show_footer = true;
        _this2.$root.body_loading_status = true; // } else {
        // if (!this.top_section) {
        //   this.blockData.push(this.promotionPageData[this.blockDataIndex]);
        //   this.blockDataIndex++;
        // }
        // this.$root.show_footer = false;
        //}
      }).catch(function (err) {
        _this2.typeCheck = "error";
        _this2.$root.loading = false;
      });
    }
  },
  watch: {
    "$route.params.postSlug": function $routeParamsPostSlug() {
      if (this.promotionPageData != undefined) {} else {
        this.$root.loading = true;
        this.promotionPageData = [];
        this.getPageData();
      }
    },
    blockData: function blockData() {
      if (this.blockData.length === this.promotionPageData.content.blocks.length) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_lang__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Pages_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "News",
  props: ["newsData"],
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_2__components_custom_block_RelatedLinks__["a" /* default */],
    NotFound: __WEBPACK_IMPORTED_MODULE_3__pages_404__["default"]
  },
  data: function data() {
    return {
      pageAttr: {
        type: Object,
        default: function _default() {}
      },
      pageData: {
        type: Object,
        default: function _default() {}
      },
      tabData: {},
      supportEmail: "",
      contactName: "",
      contactNumber: "",
      breadCrumb: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      supportedLang: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      showHideObj: {
        spTop: false,
        pmTop: false,
        liscTop: false,
        spMidSc: false,
        liscUnderSc: false,
        dipositSc: false,
        withdrawSc: false
      },
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      activeKey: "",
      scrollOffset: 0,
      metaData: "",
      busy: false,
      pageIndex: 0,
      stickyNavTop: 0,
      showSticky: true,
      clickCount: 0,
      topStickyHeight: 0,
      topHeaderStickyHeight: 0,
      hideBonusLabel: false,
      hideToplistLabel: false,
      pageMenuBlock: [],
      auhtorBlockdata: [],
      rightBlockdata: [],
      scriptFlag: 0,
      typeCheck: "",
      bluebar: {}
    };
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["a" /* getContrastYIQ */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_6__misc_meta_changer__["a" /* metaChanger */],
    getOffset: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["b" /* getOffset */],
    getLang: __WEBPACK_IMPORTED_MODULE_4__misc_lang__["a" /* getLang */],
    getHeightHeader: function getHeightHeader() {
      if (window.innerWidth > 991) {
        if (document.getElementById("panel-wrapper")) {
          if (document.getElementById("sticky-nav")) {
            if (document.getElementById("sticky-regulation-banner")) {
              if (document.getElementById("header")) {
                this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
              } else {
                this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");
              }
            } else {
              if (document.getElementById("regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                }
              }
            }
          }
        } else {
          if (document.getElementById("sticky-nav")) {
            if (document.getElementById("sticky-regulation-banner")) {
              if (document.getElementById("header")) {
                this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
              } else {
                this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
              }
            } else {
              if (document.getElementById("regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = document.getElementById("regulation-banner").offsetHeight + 0;
                }
              } else {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = 0;
                }
              }
            }
          }
        }
      } else {
        if (this.$root.show_stickymenu && this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
          this.stickyNavTop = 70;
        }
      }
    },
    getHeightHeaderScroll: function getHeightHeaderScroll() {
      if (window.pageYOffset > 10) {
        if (window.innerWidth > 991) {
          if (document.getElementById("panel-wrapper")) {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                }
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-header").offsetHeight, "px");
                } else {
                  this.stickyNavTop = 0;
                }
              }
            }
          }
        } else {
          if (this.$root.show_stickymenu && this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            this.stickyNavTop = 70;
          }
        }
      } else {
        if (window.innerWidth > 991) {
          if (document.getElementById("panel-wrapper")) {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("regulation-banner")) {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                  } else {
                    this.stickyNavTop = "".concat(document.getElementById("regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight, "px");
                  }
                } else {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                  } else {
                    this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                  }
                }
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("regulation-banner")) {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = "".concat(document.getElementById("regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                  } else {
                    this.stickyNavTop = document.getElementById("regulation-banner").offsetHeight + 0;
                  }
                } else {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = "".concat(document.getElementById("header").offsetHeight - 10, "px");
                  } else {
                    this.stickyNavTop = 0;
                  }
                }
              }
            }
          }
        } else {
          if (this.$root.show_stickymenu && this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            this.stickyNavTop = 70;
          }
        }
      }
    },
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    getBonusShowHide: function getBonusShowHide(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    },
    updateBonusHeight: function updateBonusHeight() {
      var heightArr = [];
      document.querySelectorAll(".sticky-inner").forEach(function (ele) {
        heightArr.push(ele.clientHeight);
      });
      this.topStickyHeight = Math.max.apply(Math, heightArr);

      if (document.getElementById("review-sticky-card")) {
        if (window.innerWidth > 991) {
          document.getElementById("review-sticky-card").style.top = "-".concat(this.topStickyHeight + 1, "px");
        } else {
          document.getElementById("review-sticky-card").style.top = null;
        }
      }

      this.topHeaderStickyHeight = document.getElementById("sticky-header") ? document.getElementById("sticky-header").offsetHeight : 0;
      document.querySelectorAll(".sticky-review-card").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightArr), "px");
      });
    },
    loadMore: function loadMore() {
      this.busy = true;
      this.pageIndex++;
      this.busy = false;
    },
    getPageData: function getPageData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_7__api_Pages_api__["a" /* HttpService */].getBody(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.params.postSlug, this.$root.user_id).then(function (res) {
        _this.pageAttr = res.data.data.attrs;
        _this.tabData = res.data.data.content.blocks;
        _this.breadCrumb = res.data.data.breadcrumb;
        _this.pageMenuBlock = _this.tabData.map(function (ele) {
          return ele.blockName;
        }).indexOf("wpvcb/page-menu-blocks-scroll") > -1; // More Payments Bottom Card

        _this.morePaymentBottom = res.data.data.meta.more_payment_method; // Author Blocks Filtered

        var atBlock = res.data.data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/author-block") {
            return ele.filtered_content;
          }
        });
        if (atBlock.length > 0) _this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

        var rightBlock = res.data.data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/right-content-simpletoc") {
            return ele.filtered_content;
          }
        });
        if (rightBlock.length > 0) _this.rightBlockdata = rightBlock.shift().filtered_content; // Schema Append

        document.getElementById("schema-script").innerHTML = res.data.data.schema; // Adminbar Data

        _this.$root.adminBarData = Object.keys(res.data.data.toolbar).length > 0 ? res.data.data.toolbar : "";
        _this.$root.disable = _this.$root.adminBarData ? _this.$root.adminBarData.visible : false; // Assets Sizes

        _this.assets_images = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : "";

        if (_this.tabData.length === 0 || _this.tabData && _this.tabData.filter(function (ele) {
          return ele.tab_content;
        }).length === 0) {
          _this.pageIndex = 2;
        }

        if (!_this.$root.enable_lazyload) {
          _this.pageIndex = 2;
          _this.$root.show_footer = true;
        } else {
          _this.$root.show_footer = false;
        }

        _this.$root.loading = false;
        _this.$root.body_loading_status = true;

        if (_this.scriptFlag === 0 && res.data.data.content.blocks.filter(function (ele) {
          return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
        }).length > 0) {
          _this.youtubeInit();

          _this.scriptFlag++;
        }
      }).catch(function (err) {
        _this.typeCheck = "error";
        _this.$root.loading = false;
      });
    },
    scrollPage: function scrollPage(ref) {
      if (this.activeKey === "") {
        this.activeKey = ref;
        var tabTop = 0;

        if (this.$root.show_stickymenu && this.$root.show_stickymenu_desktop) {
          tabTop = this.getOffset(this.$refs[ref][0]).top - 30;
        } else {
          tabTop = this.getOffset(this.$refs[ref][0]).top + 90;
        }

        window.scrollTo({
          top: tabTop - 200,
          behavior: "smooth"
        });
      } else {
        if (this.activeKey != ref) {
          this.activeKey = ref;
          var _tabTop = 0;

          if (this.$root.show_stickymenu && this.$root.show_stickymenu_desktop) {
            _tabTop = this.getOffset(this.$refs[ref][0]).top;
          } else {
            _tabTop = this.getOffset(this.$refs[ref][0]).top + 120;
          }

          window.scrollTo({
            top: _tabTop - 180,
            behavior: "smooth"
          });
        }
      }
    }
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags);

    if (this.newsData != undefined) {
      this.pageAttr = this.newsData.attrs;
      this.tabData = this.newsData.content.blocks;
      this.breadCrumb = this.newsData.breadcrumb;
      this.pageMenuBlock = this.tabData.map(function (ele) {
        return ele.blockName;
      }).indexOf("wpvcb/page-menu-blocks-scroll") > -1; // More Payments Bottom Card

      this.morePaymentBottom = this.newsData.meta.more_payment_method; // Author Blocks Filtered

      var atBlock = this.newsData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

      var rightBlock = this.newsData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Schema Append

      document.getElementById("schema-script").innerHTML = this.newsData.schema; // Adminbar Data

      this.$root.adminBarData = Object.keys(this.newsData.toolbar).length > 0 ? this.newsData.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";

      if (this.tabData.length === 0 || this.tabData && this.tabData.filter(function (ele) {
        return ele.tab_content;
      }).length === 0) {
        this.pageIndex = 2;
      }

      if (!this.$root.enable_lazyload) {
        this.pageIndex = 2;
        this.$root.show_footer = true;
      } else {
        this.$root.show_footer = false;
      }

      if (this.scriptFlag === 0 && this.newsData.content.blocks.filter(function (ele) {
        return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
      }).length > 0) {
        this.youtubeInit();
        this.scriptFlag++;
      }
    } else {
      this.$root.loading = true;
      this.getPageData();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.heightCheck();

      _this2.updateBonusHeight();

      _this2.getHeightHeader();
    });
    var refOffsetTop = [];

    if (this.pageMenuBlock) {
      window.addEventListener("scroll", function () {
        if (!(refOffsetTop.length > 0)) {
          for (var ref in that.$refs) {
            if (ref != "") {
              if (_this2.$root.show_stickymenu && _this2.$root.show_stickymenu_desktop) {
                refOffsetTop.push({
                  ref: ref,
                  offset: that.getOffset(that.$refs[ref][0]).top - 60
                });
              } else {
                refOffsetTop.push({
                  ref: ref,
                  offset: that.getOffset(that.$refs[ref][0]).top + 60
                });
              }
            }
          }
        }

        var pageOffset = window.pageYOffset + 180;
        var tabArray = [];
        refOffsetTop.forEach(function (ele) {
          if (ele.offset <= pageOffset) {
            tabArray.push(ele.ref);
          }
        });

        if (tabArray.length > 0) {
          that.activeKey = tabArray[tabArray.length - 1];
        }
      }, {
        passive: true
      });
    }

    var that = this;
    window.addEventListener("scroll", function () {
      that.getHeightHeaderScroll(); //that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
      that.getHeightHeader();
      var windowWidth = window.innerWidth;

      if (!this.smallCardView && windowWidth >= 768) {
        this.smallCardView = true;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
    });

    if (window.innerWidth > 991) {
      document.getElementById("sticky-header") ? document.getElementById("sticky-header").style.top = "0" : "";
    }
  },
  watch: {
    "$route.params.postSlug": function $routeParamsPostSlug() {
      if (this.newsData != undefined) {} else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    pageIndex: function pageIndex() {
      if (this.pageIndex > 3) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_custom_block_RelatedLinks__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_lang__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__misc_meta_changer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Pages_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Streams",
  props: ["streamsData"],
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__["a" /* default */],
    CustomComponent: __WEBPACK_IMPORTED_MODULE_0__components_CustomComponent__["a" /* default */],
    RelatedLinks: __WEBPACK_IMPORTED_MODULE_2__components_custom_block_RelatedLinks__["a" /* default */],
    NotFound: __WEBPACK_IMPORTED_MODULE_3__pages_404__["default"]
  },
  data: function data() {
    return {
      pageAttr: {
        type: Object,
        default: function _default() {}
      },
      pageData: {
        type: Object,
        default: function _default() {}
      },
      tabData: {},
      supportEmail: "",
      contactName: "",
      contactNumber: "",
      breadCrumb: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      assets_images: {
        type: Object,
        default: function _default() {}
      },
      morePaymentBottom: {
        type: Object,
        default: function _default() {}
      },
      supportedLang: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      showHideObj: {
        spTop: false,
        pmTop: false,
        liscTop: false,
        spMidSc: false,
        liscUnderSc: false,
        dipositSc: false,
        withdrawSc: false
      },
      embedBlockNameList: ["core-embed/facebook", "core-embed/twitter", "core-embed/instagram", "core-embed/tumblr", "core-embed/tiktok"],
      activeKey: "",
      scrollOffset: 0,
      metaData: "",
      busy: false,
      pageIndex: 0,
      stickyNavTop: 0,
      showSticky: true,
      clickCount: 0,
      topStickyHeight: 0,
      topHeaderStickyHeight: 0,
      hideBonusLabel: false,
      hideToplistLabel: false,
      pageMenuBlock: [],
      auhtorBlockdata: [],
      rightBlockdata: [],
      scriptFlag: 0,
      typeCheck: "",
      host: "",
      videoId: ""
    };
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["a" /* getContrastYIQ */],
    metaChanger: __WEBPACK_IMPORTED_MODULE_6__misc_meta_changer__["a" /* metaChanger */],
    getOffset: __WEBPACK_IMPORTED_MODULE_5__misc_misc_function__["b" /* getOffset */],
    getLang: __WEBPACK_IMPORTED_MODULE_4__misc_lang__["a" /* getLang */],
    getHeightHeader: function getHeightHeader() {
      if (window.innerWidth > 991) {
        if (document.getElementById("panel-wrapper")) {
          if (document.getElementById("sticky-nav")) {
            if (document.getElementById("sticky-regulation-banner")) {
              if (document.getElementById("header")) {
                this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
              } else {
                this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");
              }
            } else {
              if (document.getElementById("regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                }
              }
            }
          }
        } else {
          if (document.getElementById("sticky-nav")) {
            if (document.getElementById("sticky-regulation-banner")) {
              if (document.getElementById("header")) {
                this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
              } else {
                this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
              }
            } else {
              if (document.getElementById("regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = document.getElementById("regulation-banner").offsetHeight + 0;
                }
              } else {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = 0;
                }
              }
            }
          }
        }
      } else {
        if (this.$root.show_stickymenu && this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
          this.stickyNavTop = 70;
        }
      }
    },
    getHeightHeaderScroll: function getHeightHeaderScroll() {
      if (window.pageYOffset > 10) {
        if (window.innerWidth > 991) {
          if (document.getElementById("panel-wrapper")) {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-header").offsetHeight, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                }
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("sticky-header").offsetHeight, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-header").offsetHeight, "px");
                } else {
                  this.stickyNavTop = 0;
                }
              }
            }
          }
        } else {
          if (this.$root.show_stickymenu && this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            this.stickyNavTop = 70;
          }
        }
      } else {
        if (window.innerWidth > 991) {
          if (document.getElementById("panel-wrapper")) {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("regulation-banner")) {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                  } else {
                    this.stickyNavTop = "".concat(document.getElementById("regulation-banner").offsetHeight + document.getElementById("panel-wrapper").offsetHeight, "px");
                  }
                } else {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                  } else {
                    this.stickyNavTop = "".concat(document.getElementById("panel-wrapper").offsetHeight, "px");
                  }
                }
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                } else {
                  this.stickyNavTop = "".concat(document.getElementById("sticky-regulation-banner").offsetHeight, "px");
                }
              } else {
                if (document.getElementById("regulation-banner")) {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = "".concat(document.getElementById("regulation-banner").offsetHeight + document.getElementById("header").offsetHeight - 10, "px");
                  } else {
                    this.stickyNavTop = document.getElementById("regulation-banner").offsetHeight + 0;
                  }
                } else {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = "".concat(document.getElementById("header").offsetHeight - 10, "px");
                  } else {
                    this.stickyNavTop = 0;
                  }
                }
              }
            }
          }
        } else {
          if (this.$root.show_stickymenu && this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            this.stickyNavTop = 70;
          }
        }
      }
    },
    heightCheck: function heightCheck() {
      var appDOM = document.getElementById("app");
      var windowHeight = window.innerHeight;
      var appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;

      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    getBonusShowHide: function getBonusShowHide(partner) {
      var hideBonus = this.getCASToplistShowHideData(partner);

      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    },
    updateBonusHeight: function updateBonusHeight() {
      var heightArr = [];
      document.querySelectorAll(".sticky-inner").forEach(function (ele) {
        heightArr.push(ele.clientHeight);
      });
      this.topStickyHeight = Math.max.apply(Math, heightArr);

      if (document.getElementById("review-sticky-card")) {
        if (window.innerWidth > 991) {
          document.getElementById("review-sticky-card").style.top = "-".concat(this.topStickyHeight + 1, "px");
        } else {
          document.getElementById("review-sticky-card").style.top = null;
        }
      }

      this.topHeaderStickyHeight = document.getElementById("sticky-header") ? document.getElementById("sticky-header").offsetHeight : 0;
      document.querySelectorAll(".sticky-review-card").forEach(function (ele) {
        ele.style.height = "".concat(Math.max.apply(Math, heightArr), "px");
      });
    },
    loadMore: function loadMore() {
      this.busy = true;
      this.pageIndex++;
      this.busy = false;
    },
    getPageData: function getPageData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_7__api_Pages_api__["a" /* HttpService */].getBody(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.params.postSlug, this.$root.user_id).then(function (res) {
        _this.pageAttr = res.data.data.attrs;
        _this.tabData = res.data.data.content.blocks;
        _this.breadCrumb = res.data.data.breadcrumb;
        _this.pageMenuBlock = _this.tabData.map(function (ele) {
          return ele.blockName;
        }).indexOf("wpvcb/page-menu-blocks-scroll") > -1; // More Payments Bottom Card

        _this.morePaymentBottom = res.data.data.meta.more_payment_method; // Author Blocks Filtered

        var atBlock = res.data.data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/author-block") {
            return ele.filtered_content;
          }
        });
        if (atBlock.length > 0) _this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

        var rightBlock = res.data.data.content.blocks.filter(function (ele) {
          if (ele.blockName === "wpvcb/right-content-simpletoc") {
            return ele.filtered_content;
          }
        });
        if (rightBlock.length > 0) _this.rightBlockdata = rightBlock.shift().filtered_content; // Schema Append

        document.getElementById("schema-script").innerHTML = res.data.data.schema; // Adminbar Data

        _this.$root.adminBarData = Object.keys(res.data.data.toolbar).length > 0 ? res.data.data.toolbar : "";
        _this.$root.disable = _this.$root.adminBarData ? _this.$root.adminBarData.visible : false; // Assets Sizes

        _this.assets_images = Object.keys(_this.$root.asset_sizes).length > 0 ? _this.$root.asset_sizes : "";

        if (_this.tabData.length === 0 || _this.tabData && _this.tabData.filter(function (ele) {
          return ele.tab_content;
        }).length === 0) {
          _this.pageIndex = 2;
        }

        if (!_this.$root.enable_lazyload) {
          _this.pageIndex = 2;
          _this.$root.show_footer = true;
        } else {
          _this.$root.show_footer = false;
        }

        _this.$root.loading = false;

        if (_this.scriptFlag === 0 && res.data.data.content.blocks.filter(function (ele) {
          return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
        }).length > 0) {
          _this.youtubeInit();

          _this.scriptFlag++;
        }
      }).catch(function (err) {
        _this.typeCheck = "error";
        _this.$root.loading = false;
      });
    },
    scrollPage: function scrollPage(ref) {
      if (this.activeKey === "") {
        this.activeKey = ref;
        var tabTop = 0;

        if (this.$root.show_stickymenu && this.$root.show_stickymenu_desktop) {
          tabTop = this.getOffset(this.$refs[ref][0]).top - 30;
        } else {
          tabTop = this.getOffset(this.$refs[ref][0]).top + 90;
        }

        window.scrollTo({
          top: tabTop - 200,
          behavior: "smooth"
        });
      } else {
        if (this.activeKey != ref) {
          this.activeKey = ref;
          var _tabTop = 0;

          if (this.$root.show_stickymenu && this.$root.show_stickymenu_desktop) {
            _tabTop = this.getOffset(this.$refs[ref][0]).top;
          } else {
            _tabTop = this.getOffset(this.$refs[ref][0]).top + 120;
          }

          window.scrollTo({
            top: _tabTop - 180,
            behavior: "smooth"
          });
        }
      }
    }
  },
  created: function created() {
    if (this.$root.routes_meta[this.$route.params.postSlug] && this.$root.routes_meta[this.$route.params.postSlug].metaTags) this.metaChanger(this.$root.routes_meta[this.$route.params.postSlug].metaTags);

    if (this.streamsData != undefined) {
      this.pageAttr = this.streamsData.attrs;
      this.tabData = this.streamsData.content.blocks;
      this.breadCrumb = this.streamsData.breadcrumb;
      this.pageMenuBlock = this.tabData.map(function (ele) {
        return ele.blockName;
      }).indexOf("wpvcb/page-menu-blocks-scroll") > -1; // More Payments Bottom Card

      this.morePaymentBottom = this.streamsData.meta.more_payment_method; // Author Blocks Filtered

      var atBlock = this.streamsData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0) this.auhtorBlockdata = atBlock.shift().filtered_content; // RightContent Blocks Filtered

      var rightBlock = this.streamsData.content.blocks.filter(function (ele) {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0) this.rightBlockdata = rightBlock.shift().filtered_content; // Schema Append

      document.getElementById("schema-script").innerHTML = this.streamsData.schema; // Adminbar Data

      this.$root.adminBarData = Object.keys(this.streamsData.toolbar).length > 0 ? this.streamsData.toolbar : "";
      this.$root.disable = this.$root.adminBarData ? this.$root.adminBarData.visible : false; // Assets Sizes

      this.assets_images = Object.keys(this.$root.asset_sizes).length > 0 ? this.$root.asset_sizes : "";

      if (this.tabData.length === 0 || this.tabData && this.tabData.filter(function (ele) {
        return ele.tab_content;
      }).length === 0) {
        this.pageIndex = 2;
      }

      if (!this.$root.enable_lazyload) {
        this.pageIndex = 2;
        this.$root.show_footer = true;
      } else {
        this.$root.show_footer = false;
      }

      if (this.scriptFlag === 0 && this.streamsData.content.blocks.filter(function (ele) {
        return ele.blockName === "wpvcb/custom-youtube" || ele.blockName === "wpvcb/youtube-film-strip";
      }).length > 0) {
        this.youtubeInit();
        this.scriptFlag++;
      }
    } else {
      this.$root.loading = true;
      this.getPageData();
    }

    this.videoId = this.streamsData.video_id;
    this.host = location.host;
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.heightCheck();

      _this2.updateBonusHeight();

      _this2.getHeightHeader();
    });
    var refOffsetTop = [];

    if (this.pageMenuBlock) {
      window.addEventListener("scroll", function () {
        if (!(refOffsetTop.length > 0)) {
          for (var ref in that.$refs) {
            if (ref != "") {
              if (_this2.$root.show_stickymenu && _this2.$root.show_stickymenu_desktop) {
                refOffsetTop.push({
                  ref: ref,
                  offset: that.getOffset(that.$refs[ref][0]).top - 60
                });
              } else {
                refOffsetTop.push({
                  ref: ref,
                  offset: that.getOffset(that.$refs[ref][0]).top + 60
                });
              }
            }
          }
        }

        var pageOffset = window.pageYOffset + 180;
        var tabArray = [];
        refOffsetTop.forEach(function (ele) {
          if (ele.offset <= pageOffset) {
            tabArray.push(ele.ref);
          }
        });

        if (tabArray.length > 0) {
          that.activeKey = tabArray[tabArray.length - 1];
        }
      }, {
        passive: true
      });
    }

    var that = this;
    window.addEventListener("scroll", function () {
      that.getHeightHeaderScroll(); //that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.addEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
      that.getHeightHeader();
      var windowWidth = window.innerWidth;

      if (!this.smallCardView && windowWidth >= 768) {
        this.smallCardView = true;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", function () {
      that.heightCheck();
    }, {
      passive: true
    });
    window.removeEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
    });

    if (window.innerWidth > 991) {
      document.getElementById("sticky-header") ? document.getElementById("sticky-header").style.top = "0" : "";
    }
  },
  watch: {
    "$route.params.postSlug": function $routeParamsPostSlug() {
      if (this.streamsData != undefined) {} else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    pageIndex: function pageIndex() {
      if (this.pageIndex > 3) {
        this.$root.show_footer = true;
      }
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Pages_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Search",
  data: function data() {
    return {
      searchText: "",
      sortAsc: true,
      totalResultsCount: 0,
      pageData: [],
      currentPage: 1,
      breadcrumbData: [],
      paginationNumbers: 0,
      orderBy: "relevance"
    };
  },
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Breadcrumb__["a" /* default */]
  },
  filters: {
    titleCase: function titleCase(value) {
      value = value.trim().toLowerCase();
      return Array.prototype.map.call(value, function (chr, index) {
        return index === 0 ? chr.toUpperCase() : chr;
      }).join("");
    }
  },
  beforeCreate: function beforeCreate() {
    this.$root.loading = true;
  },
  mounted: function mounted() {
    this.searchResult();
  },
  beforeDestroy: function beforeDestroy() {
    this.subscription.unsubscribe();
  },
  watch: {
    "$route.params.searchText": function $routeParamsSearchText() {
      this.$root.loading = true;
      this.currentPage = 1;
      this.searchResult();
    }
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["a" /* getContrastYIQ */],
    searchResult: function searchResult() {
      var _this = this;

      this.searchText = this.$route.params.searchText.trim();
      var sortOrder = this.sortAsc ? "asc" : "desc";
      __WEBPACK_IMPORTED_MODULE_2__api_Pages_api__["a" /* HttpService */].getSearchResult(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.searchText, this.currentPage, sortOrder, this.$root.user_id, this.orderBy).then(function (res) {
        _this.pageData = res.data.data.results;
        _this.totalResultsCount = res.data.data.total_results_count;
        _this.breadcrumbData = res.data.data.breadcrumb;
        _this.paginationNumbers = Math.ceil(_this.totalResultsCount / res.data.data.query.posts_per_page); // Adminbar Data

        _this.$root.adminBarData = Object.keys(res.data.data.toolbar).length > 0 ? res.data.data.toolbar : "";
        _this.$root.disable = _this.$root.adminBarData ? _this.$root.adminBarData.visible : false;
        _this.$root.loading = false;
        _this.$root.show_footer = true;
        _this.$root.body_loading_status = true;
      }).catch(function (err) {
        return console.log(err);
      });
    },
    nextPage: function nextPage() {
      ++this.currentPage;
      this.$root.loading = true;
      this.searchResult();
    },
    prevPage: function prevPage() {
      this.currentPage--;
      this.$root.loading = true;
      this.searchResult();
    },
    changePage: function changePage(i) {
      this.currentPage = i;
      this.$root.loading = true;
      this.searchResult();
    },
    getRange: function getRange(start, end, range) {
      var arr = new Array(range).fill().map(function (val, index) {
        return index + 1;
      });
      return arr.filter(function (val) {
        return val >= start && val < start + end;
      });
    },
    sortResult: function sortResult() {
      this.sortAsc = !this.sortAsc;
      this.orderBy = "title";
      this.$root.loading = true;
      this.searchResult();
    }
  },
  computed: {
    totalPages: function totalPages() {
      if (this.totalResultsCount % 10 != 0) {
        return Math.floor(this.totalResultsCount / 10 + 1);
      } else {
        return Math.round(this.totalResultsCount / 10);
      }
    },
    calcResultCount: function calcResultCount() {
      var firstCount = 1;
      var lastCount = 10;

      if (this.totalResultsCount > 0) {
        if (this.currentPage > 1) {
          firstCount += (this.currentPage - 1) * 10;
          lastCount = this.currentPage * 10;
        }

        if (lastCount > this.totalResultsCount) {
          lastCount = this.totalResultsCount;
        }
      } else {
        firstCount = 0;
        lastCount = 0;
      }

      return {
        firstCount: firstCount,
        lastCount: lastCount
      };
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Article__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Review_Review__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Review_ReviewWithBlocks__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_News_News__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Streams_Streams__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_GameGuideHolder__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_GameFree_GameFree__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_DefaultPage__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_MapTemplate__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_AboutUs__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_CalendarTemplate__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_PaymentOptions_PaymentOptions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_SoftwareProviders_SoftwareProviders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Promotions_Promotions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_404__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_HomeLayout1__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_HomeLayout2__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_Pages_api__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Preview",
  components: {
    Article: __WEBPACK_IMPORTED_MODULE_0__pages_Article__["default"],
    Review: __WEBPACK_IMPORTED_MODULE_1__pages_Review_Review__["default"],
    ReviewWithBlocks: __WEBPACK_IMPORTED_MODULE_2__pages_Review_ReviewWithBlocks__["default"],
    News: __WEBPACK_IMPORTED_MODULE_3__pages_News_News__["default"],
    Streams: __WEBPACK_IMPORTED_MODULE_4__pages_Streams_Streams__["default"],
    GameFree: __WEBPACK_IMPORTED_MODULE_6__pages_GameFree_GameFree__["default"],
    PaymentOptions: __WEBPACK_IMPORTED_MODULE_11__pages_PaymentOptions_PaymentOptions__["default"],
    GameGuideHolder: __WEBPACK_IMPORTED_MODULE_5__pages_GameGuideHolder__["default"],
    SoftwareProviders: __WEBPACK_IMPORTED_MODULE_12__pages_SoftwareProviders_SoftwareProviders__["default"],
    Promotions: __WEBPACK_IMPORTED_MODULE_13__pages_Promotions_Promotions__["default"],
    DefaultPage: __WEBPACK_IMPORTED_MODULE_7__pages_DefaultPage__["default"],
    MapTemplate: __WEBPACK_IMPORTED_MODULE_8__pages_MapTemplate__["default"],
    AboutUs: __WEBPACK_IMPORTED_MODULE_9__pages_AboutUs__["default"],
    CalendarTemplate: __WEBPACK_IMPORTED_MODULE_10__pages_CalendarTemplate__["default"],
    NotFound: __WEBPACK_IMPORTED_MODULE_14__pages_404__["default"],
    HomeLayout1: __WEBPACK_IMPORTED_MODULE_15__pages_HomeLayout1__["default"],
    HomeLayout2: __WEBPACK_IMPORTED_MODULE_16__pages_HomeLayout2__["default"]
  },
  data: function data() {
    return {
      responseData: "",
      typeCheck: "",
      templateCheck: ""
    };
  },
  beforeCreate: function beforeCreate() {
    this.$root.loading = true;
  },
  created: function created() {
    this.getPreviewData();
  },
  methods: {
    getPreviewData: function getPreviewData() {
      var _this = this;

      var caslist = {};
      var storedBreadcrumbData = localStorage.getItem("storedbreadcrumbData");

      if (storedBreadcrumbData && storedBreadcrumbData !== 'undefined' && JSON.parse(storedBreadcrumbData || "[]").length > 0) {
        var that = this;
        var catList = JSON.parse(storedBreadcrumbData || "[]").filter(function (ele) {
          return ele.slug === that.$route.params.postSlug;
        });

        if (catList.length > 0 && catList[0].hasOwnProperty("cat")) {
          caslist = {
            cat: catList[0].cat
          };
        } else {
          if (localStorage.getItem("storedPageName") === that.$route.params.postSlug) caslist = {
            cat: localStorage.getItem("storedData")
          };
        }
      }

      __WEBPACK_IMPORTED_MODULE_17__api_Pages_api__["a" /* HttpService */].getPreview(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.query.page_id ? this.$route.query.page_id : this.$route.query.p, this.$root.user_id, caslist).then(function (res) {
        var resData = res.data.data;

        if (resData.hasOwnProperty("code")) {
          _this.typeCheck = "error";
        } else {
          _this.typeCheck = resData.type;
          _this.templateCheck = resData.template;

          if (_this.typeCheck === "post") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "game-guide-holder") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "about-us") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "game_free" || _this.typeCheck === "game_paid") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && (_this.templateCheck === "default-page" || _this.templateCheck === "")) {
            _this.responseData = resData;
          } else if (_this.typeCheck === "news") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "streams") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "usmap-page") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "page" && _this.templateCheck === "feast-group") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "review" && !_this.templateCheck) {
            _this.responseData = resData;
          } else if (_this.typeCheck === "review" && _this.templateCheck) {
            _this.responseData = resData;
          } else if (_this.typeCheck === "software_providers") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "promotions" || _this.typeCheck === "page" && _this.templateCheck === "promotions-landing") {
            _this.responseData = resData;
          } else if (_this.typeCheck === "payment_options") {
            _this.responseData = resData;
          }
        }

        _this.$root.loading = false;
        _this.$root.body_loading_status = true;
      }).catch(function (err) {
        _this.typeCheck = "error";
        _this.$root.loading = false;
      });
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Pages_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_404__ = __webpack_require__(23);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Archive",
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({
      term: "",
      sortAsc: true,
      totalResultsCount: 0,
      pageData: [],
      currentPage: 1,
      breadcrumbData: [],
      paginationNumbers: 0,
      typeCheck: ""
    }, "term", {});
  },
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_layouts_Breadcrumb__["a" /* default */],
    NotFound: __WEBPACK_IMPORTED_MODULE_4__pages_404__["default"]
  },
  beforeCreate: function beforeCreate() {
    this.$root.loading = true;
  },
  mounted: function mounted() {
    this.archiveResult();
  },
  methods: {
    pSBC: __WEBPACK_IMPORTED_MODULE_2__misc_misc_function__["d" /* pSBC */],
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_2__misc_misc_function__["a" /* getContrastYIQ */],
    archiveResult: function archiveResult() {
      var _this = this;

      this.term = this.$route.params.term.trim();
      var sortOrder = this.sortAsc ? "asc" : "desc";
      __WEBPACK_IMPORTED_MODULE_3__api_Pages_api__["a" /* HttpService */].getArchive(this.$root.wp_country && this.$root.wp_country != "" ? this.$root.wp_country : this.$cookies.get("wp-country"), this.$root.wp_state && this.$root.wp_state != "" ? this.$root.wp_state : this.$cookies.get("wp-state"), this.$route.meta.taxonomy, this.currentPage, sortOrder, this.$root.user_id, this.term).then(function (res) {
        if (res.data.data.results) {
          _this.pageData = res.data.data.results;
          _this.term = res.data.data.term;
          _this.totalResultsCount = res.data.data.total_results_count;
          _this.breadcrumbData = res.data.data.breadcrumb;
          _this.paginationNumbers = Math.ceil(_this.totalResultsCount / res.data.data.query.posts_per_page); // Adminbar Data

          _this.$root.adminBarData = Object.keys(res.data.data.toolbar).length > 0 ? res.data.data.toolbar : "";
          _this.$root.disable = _this.$root.adminBarData ? _this.$root.adminBarData.visible : false;
          _this.$root.loading = false;
          _this.$root.show_footer = true;
          _this.$root.body_loading_status = true;
        } else {
          _this.typeCheck = "error";
        }
      }).catch(function (err) {
        _this.typeCheck = "error";
      });
    },
    nextPage: function nextPage() {
      ++this.currentPage;
      this.$root.loading = true;
      this.archiveResult();
    },
    prevPage: function prevPage() {
      this.currentPage--;
      this.$root.loading = true;
      this.archiveResult();
    },
    changePage: function changePage(i) {
      this.currentPage = i;
      this.$root.loading = true;
      this.archiveResult();
    },
    getRange: function getRange(start, end, range) {
      var arr = new Array(range).fill().map(function (val, index) {
        return index + 1;
      });
      return arr.filter(function (val) {
        return val >= start && val < start + end;
      });
    },
    sortResult: function sortResult() {
      this.sortAsc = !this.sortAsc;
      this.$root.loading = true;
      this.archiveResult();
    }
  },
  computed: {
    totalPages: function totalPages() {
      if (this.totalResultsCount % 10 != 0) {
        return Math.floor(this.totalResultsCount / 10 + 1);
      } else {
        return Math.round(this.totalResultsCount / 10);
      }
    },
    calcResultCount: function calcResultCount() {
      var firstCount = 1;
      var lastCount = 10;

      if (this.totalResultsCount > 0) {
        if (this.currentPage > 1) {
          firstCount += (this.currentPage - 1) * 10;
          lastCount = this.currentPage * 10;
        }

        if (lastCount > this.totalResultsCount) {
          lastCount = this.totalResultsCount;
        }
      } else {
        firstCount = 0;
        lastCount = 0;
      }

      return {
        firstCount: firstCount,
        lastCount: lastCount
      };
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc_slide_up_down__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_NavMenu__ = __webpack_require__(185);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Footer",
  components: {
    NavMenu: __WEBPACK_IMPORTED_MODULE_2__components_ui_NavMenu__["a" /* default */]
  },
  data: function data() {
    return {
      selectedMenu: null
    };
  },
  props: {
    footerComponent: {
      footerMenuTitle1: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuTitle2: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuTitle3: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenu1: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      footerMenu2: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      footerMenu3: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      copyright_text: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      securityImages: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      footerMenuCount1: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuOffset1: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuText1: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuLink1: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuCount2: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuOffset2: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuText2: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuLink2: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuCount3: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuOffset3: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuText3: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      footerMenuLink3: {
        type: String,
        default: function _default() {
          return "";
        }
      },
      disclaimer: {
        type: String,
        default: ""
      }
    }
  },
  methods: {
    getContrastYIQ: __WEBPACK_IMPORTED_MODULE_1__misc_misc_function__["a" /* getContrastYIQ */],
    expandFooterMenu: function expandFooterMenu(index) {
      var element = document.getElementById("footer-content-" + index);
      var icon = document.getElementById("footer-icon-" + index);

      if (this.selectedMenu === index) {
        this.selectedMenu = null;
        icon.classList.remove("rotate-180");
        Object(__WEBPACK_IMPORTED_MODULE_0__misc_slide_up_down__["b" /* slideUp */])(element, {
          duration: 100
        });
      } else {
        this.selectedMenu = index;
        icon.classList.add("rotate-180");
        Object(__WEBPACK_IMPORTED_MODULE_0__misc_slide_up_down__["a" /* slideDown */])(element, {
          duration: 100
        });
      }
    },
    getRoutePath: function getRoutePath(slug, type) {
      if (slug === "home") {
        return "/";
      } else if (type != "page" && type != "post" && type != "review" && type != "") {
        return "/".concat(type, "/").concat(slug);
      } else {
        return "/".concat(slug);
      }
    }
  },
  watch: {
    selectedMenu: function selectedMenu(currVal, prevVal) {
      if (prevVal != null) {
        var element = document.getElementById("footer-content-" + prevVal);
        var icon = document.getElementById("footer-icon-" + prevVal);
        icon.classList.remove("rotate-180");
        Object(__WEBPACK_IMPORTED_MODULE_0__misc_slide_up_down__["b" /* slideUp */])(element, {
          duration: 300
        });
      }
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoadingSpinner"
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AdminPanelBar",
  props: ["adminBarData"]
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Newsletter",
  props: ["componentData", "componentAttrs"],
  data: function data() {
    return {
      email: null,
      validation: {
        email: true,
        checkbox1: true,
        checkbox2: true
      },
      checkbox: {
        checkbox1: false,
        checkbox2: false
      },
      submission: false,
      submitted: false
    };
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.submission = true;

      if (!this.checkbox.checkbox1) {
        this.validation.checkbox1 = false;
        this.submission = false;
      }

      if (!this.checkbox.checkbox2) {
        this.validation.checkbox2 = false;
        this.submission = false;
      }

      var emailExp = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      var regex = new RegExp(emailExp);

      if (!this.email || !this.email.match(regex)) {
        this.validation.email = false;
        this.$refs.email.focus();
        this.submission = false;
      }

      if (this.validation.checkbox1 && this.validation.checkbox2 && this.validation.email) {
        var session_url = "/wp-json/wpvue/v1/newsletter";
        var body = {
          EmailAddress: this.email
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(session_url, body, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }).then(function () {
          _this.submitted = true;
          _this.submission = false;
        }).catch(function (error) {
          console.log('Error Submitting', error);
        }); //setTimeout(() => {
        //this.$refs.formNews.submit();
        // let body = {
        //   email: this.email,
        // };
        // axios.post(
        //   `https://api.aweber.com/1.0/accounts/${this.$root.aweber.account_id}/lists/${this.$root.aweber.listname}/subscribers?ws.op=create`,
        //   body,
        //   {
        //     headers: {
        //       Accept: "application/json",
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${this.$root.aweber.token.access_token}`,
        //     },
        //   }
        // ).subscribe((res) => {
        //   if (res.status === 201) {
        //     this.submitted = true;
        //     this.submission = false;
        //   }
        // });
        //}, 1000);
      }
    }
  },
  mounted: function mounted() {
    this.redirect = this.$root.site_url + "/" + this.$route.params.postSlug;
    this.listname = this.$root.listname;
  },
  watch: {
    email: function email() {
      this.validation.email = true;
    },
    "checkbox.checkbox1": function checkboxCheckbox1() {
      this.validation.checkbox1 = this.checkbox.checkbox1;
    },
    "checkbox.checkbox2": function checkboxCheckbox2() {
      this.validation.checkbox2 = this.checkbox.checkbox2;
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(268);
module.exports = __webpack_require__(470);


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(269);

__webpack_require__(466);

__webpack_require__(467);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(270);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(131);
__webpack_require__(374);
__webpack_require__(165);
__webpack_require__(375);
__webpack_require__(166);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(169);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
module.exports = __webpack_require__(34);


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(29);
var DESCRIPTORS = __webpack_require__(14);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(26);
var META = __webpack_require__(49).KEY;
var $fails = __webpack_require__(7);
var shared = __webpack_require__(68);
var setToStringTag = __webpack_require__(63);
var uid = __webpack_require__(52);
var wks = __webpack_require__(11);
var wksExt = __webpack_require__(147);
var wksDefine = __webpack_require__(112);
var enumKeys = __webpack_require__(272);
var isArray = __webpack_require__(82);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var toObject = __webpack_require__(16);
var toIObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(40);
var createDesc = __webpack_require__(51);
var _create = __webpack_require__(55);
var gOPNExt = __webpack_require__(150);
var $GOPD = __webpack_require__(31);
var $GOPS = __webpack_require__(81);
var $DP = __webpack_require__(15);
var $keys = __webpack_require__(53);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(56).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(70).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(48)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(25)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(68)('native-function-to-string', Function.toString);


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(53);
var gOPS = __webpack_require__(81);
var pIE = __webpack_require__(70);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(55) });


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperty: __webpack_require__(15).f });


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperties: __webpack_require__(149) });


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(30);
var $getOwnPropertyDescriptor = __webpack_require__(31).f;

__webpack_require__(42)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(16);
var $getPrototypeOf = __webpack_require__(32);

__webpack_require__(42)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(16);
var $keys = __webpack_require__(53);

__webpack_require__(42)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(42)('getOwnPropertyNames', function () {
  return __webpack_require__(150).f;
});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(49).onFreeze;

__webpack_require__(42)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(49).onFreeze;

__webpack_require__(42)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(49).onFreeze;

__webpack_require__(42)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(8);

__webpack_require__(42)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(8);

__webpack_require__(42)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(8);

__webpack_require__(42)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(151) });


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(152) });


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(116).set });


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(64);
var test = {};
test[__webpack_require__(11)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(26)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(153) });


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(14) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(32);
var HAS_INSTANCE = __webpack_require__(11)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(15).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(155);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(156);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var has = __webpack_require__(29);
var cof = __webpack_require__(36);
var inheritIfRequired = __webpack_require__(118);
var toPrimitive = __webpack_require__(40);
var fails = __webpack_require__(7);
var gOPN = __webpack_require__(56).f;
var gOPD = __webpack_require__(31).f;
var dP = __webpack_require__(15).f;
var $trim = __webpack_require__(65).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(55)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(14) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(26)(global, NUMBER, $Number);
}


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(37);
var aNumberValue = __webpack_require__(157);
var repeat = __webpack_require__(119);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(7)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(7);
var aNumberValue = __webpack_require__(157);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(5).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(158) });


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(158);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(156);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(155);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(159);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(120);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(121);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(160) });


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(159) });


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(120) });


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(121);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(121);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(54);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(30);
var toLength = __webpack_require__(12);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(65)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(83)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(122)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(83)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(12);
var context = __webpack_require__(124);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(125)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(124);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(125)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(119)
});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(12);
var context = __webpack_require__(124);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(125)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(27)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(27)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(27)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(27)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(27)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(27)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(27)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(27)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(27)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(27)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(27)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(27)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(27)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(40);

$export($export.P + $export.F * __webpack_require__(7)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(349);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(7);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(26)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(11)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(25)(proto, TO_PRIMITIVE, __webpack_require__(352));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(40);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(82) });


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(35);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var call = __webpack_require__(161);
var isArrayIter = __webpack_require__(126);
var toLength = __webpack_require__(12);
var createProperty = __webpack_require__(127);
var getIterFn = __webpack_require__(128);

$export($export.S + $export.F * !__webpack_require__(85)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(127);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(7)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(30);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(69) != Object || !__webpack_require__(38)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(115);
var cof = __webpack_require__(36);
var toAbsoluteIndex = __webpack_require__(54);
var toLength = __webpack_require__(12);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(7)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(21);
var toObject = __webpack_require__(16);
var fails = __webpack_require__(7);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(38)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(43)(0);
var STRICT = __webpack_require__(38)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var isArray = __webpack_require__(82);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(43)(1);

$export($export.P + $export.F * !__webpack_require__(38)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(43)(2);

$export($export.P + $export.F * !__webpack_require__(38)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(43)(3);

$export($export.P + $export.F * !__webpack_require__(38)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(43)(4);

$export($export.P + $export.F * !__webpack_require__(38)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(162);

$export($export.P + $export.F * !__webpack_require__(38)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(162);

$export($export.P + $export.F * !__webpack_require__(38)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(80)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(38)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(30);
var toInteger = __webpack_require__(37);
var toLength = __webpack_require__(12);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(38)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(163) });

__webpack_require__(50)('copyWithin');


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(130) });

__webpack_require__(50)('fill');


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(43)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(50)(KEY);


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(43)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(50)(KEY);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('Array');


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var inheritIfRequired = __webpack_require__(118);
var dP = __webpack_require__(15).f;
var gOPN = __webpack_require__(56).f;
var isRegExp = __webpack_require__(84);
var $flags = __webpack_require__(71);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(14) && (!CORRECT_NEW || __webpack_require__(7)(function () {
  re2[__webpack_require__(11)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(26)(global, 'RegExp', $RegExp);
}

__webpack_require__(57)('RegExp');


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(166);
var anObject = __webpack_require__(4);
var $flags = __webpack_require__(71);
var DESCRIPTORS = __webpack_require__(14);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(26)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4);
var toLength = __webpack_require__(12);
var advanceStringIndex = __webpack_require__(133);
var regExpExec = __webpack_require__(86);

// @@match logic
__webpack_require__(87)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(12);
var toInteger = __webpack_require__(37);
var advanceStringIndex = __webpack_require__(133);
var regExpExec = __webpack_require__(86);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(87)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4);
var sameValue = __webpack_require__(152);
var regExpExec = __webpack_require__(86);

// @@search logic
__webpack_require__(87)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(84);
var anObject = __webpack_require__(4);
var speciesConstructor = __webpack_require__(72);
var advanceStringIndex = __webpack_require__(133);
var toLength = __webpack_require__(12);
var callRegExpExec = __webpack_require__(86);
var regexpExec = __webpack_require__(132);
var fails = __webpack_require__(7);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(87)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(48);
var global = __webpack_require__(5);
var ctx = __webpack_require__(35);
var classof = __webpack_require__(64);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(8);
var aFunction = __webpack_require__(21);
var anInstance = __webpack_require__(58);
var forOf = __webpack_require__(59);
var speciesConstructor = __webpack_require__(72);
var task = __webpack_require__(134).set;
var microtask = __webpack_require__(135)();
var newPromiseCapabilityModule = __webpack_require__(136);
var perform = __webpack_require__(167);
var userAgent = __webpack_require__(88);
var promiseResolve = __webpack_require__(168);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(11)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(60)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(63)($Promise, PROMISE);
__webpack_require__(57)(PROMISE);
Wrapper = __webpack_require__(34)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(85)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(173);
var validate = __webpack_require__(61);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(89)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(90);
var buffer = __webpack_require__(137);
var anObject = __webpack_require__(4);
var toAbsoluteIndex = __webpack_require__(54);
var toLength = __webpack_require__(12);
var isObject = __webpack_require__(8);
var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
var speciesConstructor = __webpack_require__(72);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(57)(ARRAY_BUFFER);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(90).ABV, {
  DataView: __webpack_require__(137).DataView
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(21);
var anObject = __webpack_require__(4);
var rApply = (__webpack_require__(5).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(7)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(55);
var aFunction = __webpack_require__(21);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var bind = __webpack_require__(153);
var rConstruct = (__webpack_require__(5).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(15);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(40);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(7)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(31).f;
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(123)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(32);
var has = __webpack_require__(29);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(4);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(31);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(32);
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(175) });


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(15);
var gOPD = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(32);
var has = __webpack_require__(29);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(51);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(116);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(80)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(50)('includes');


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(176);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(12);
var aFunction = __webpack_require__(21);
var arraySpeciesCreate = __webpack_require__(129);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(50)('flatMap');


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(176);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(12);
var toInteger = __webpack_require__(37);
var arraySpeciesCreate = __webpack_require__(129);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(50)('flatten');


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(83)(true);
var $fails = __webpack_require__(7);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(177);
var userAgent = __webpack_require__(88);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(177);
var userAgent = __webpack_require__(88);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(65)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(65)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(41);
var toLength = __webpack_require__(12);
var isRegExp = __webpack_require__(84);
var getFlags = __webpack_require__(71);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(123)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('asyncIterator');


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('observable');


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(175);
var toIObject = __webpack_require__(30);
var gOPD = __webpack_require__(31);
var createProperty = __webpack_require__(127);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(178)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(178)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var aFunction = __webpack_require__(21);
var $defineProperty = __webpack_require__(15);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(14) && $export($export.P + __webpack_require__(91), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var aFunction = __webpack_require__(21);
var $defineProperty = __webpack_require__(15);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(14) && $export($export.P + __webpack_require__(91), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(32);
var getOwnPropertyDescriptor = __webpack_require__(31).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(14) && $export($export.P + __webpack_require__(91), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(32);
var getOwnPropertyDescriptor = __webpack_require__(31).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(14) && $export($export.P + __webpack_require__(91), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(179)('Map') });


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(179)('Set') });


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(92)('Map');


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(92)('Set');


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(92)('WeakMap');


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(92)('WeakSet');


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(93)('Map');


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(93)('Set');


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(93)('WeakMap');


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(93)('WeakSet');


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(36);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(181);
var fround = __webpack_require__(160);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(181) });


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(34);
var global = __webpack_require__(5);
var speciesConstructor = __webpack_require__(72);
var promiseResolve = __webpack_require__(168);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(136);
var perform = __webpack_require__(167);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(4);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(4);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(32);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(171);
var from = __webpack_require__(180);
var metadata = __webpack_require__(45);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(32);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(4);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(4);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(32);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(45);
var anObject = __webpack_require__(4);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(45);
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(21);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(135)();
var process = __webpack_require__(5).process;
var isNode = __webpack_require__(36)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(5);
var core = __webpack_require__(34);
var microtask = __webpack_require__(135)();
var OBSERVABLE = __webpack_require__(11)('observable');
var aFunction = __webpack_require__(21);
var anObject = __webpack_require__(4);
var anInstance = __webpack_require__(58);
var redefineAll = __webpack_require__(60);
var hide = __webpack_require__(25);
var forOf = __webpack_require__(59);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(57)('Observable');


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(88);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(134);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(131);
var getKeys = __webpack_require__(53);
var redefine = __webpack_require__(26);
var global = __webpack_require__(5);
var hide = __webpack_require__(25);
var Iterators = __webpack_require__(66);
var wks = __webpack_require__(11);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(468);
module.exports = __webpack_require__(34).RegExp.escape;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(469)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_smoothscroll_polyfill__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_smoothscroll_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_smoothscroll_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_css_vars_ponyfill__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookies__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__misc_constant__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lazyload__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_inline_svg__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_inline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_inline_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_mutation_observer__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_mutation_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_mutation_observer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_position_sticky__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_position_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_position_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__misc_misc_function__ = __webpack_require__(6);

 // Polyfills












__WEBPACK_IMPORTED_MODULE_2_smoothscroll_polyfill___default.a.polyfill();
Object(__WEBPACK_IMPORTED_MODULE_3_css_vars_ponyfill__["a" /* default */])({
  onlyLegacy: true
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('inline-svg', __WEBPACK_IMPORTED_MODULE_9_vue_inline_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_mutation_observer___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_6__misc_constant__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__misc_misc_function__["d" /* pSBC */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_position_sticky___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_lazyload__["a" /* default */], {
  preLoad: 1.3,
  loading: wpvue_script_data_params.data.site_data.image_loader ? wpvue_script_data_params.data.site_data.image_loader : "".concat(wpvue_script_data_params.site_url, "/wp-content/themes/wpvue/src/assets/img-loader/loader.gif"),
  error: "".concat(wpvue_script_data_params.site_url, "/wp-content/themes/wpvue/src/assets/img-loader/error.png"),
  attempt: 2
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.errorHandler = function (err, com, info) {
  console.log("Error: ".concat(err.message, "\nBlock Name: ").concat(com.$options._componentTag));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.ignoredElements = ['home-banner', 'casino-toplist', 'main-casino-toplist', 'blue-progressive-block', 'content-icon-block', 'game-guide-categories', 'best-payment-methods', 'home-card-testimonials', 'whitebg-content', 'faq-block', 'top-games', 'tab-switcher', 'latest-casino', 'user-testimonials', 'comparison-list', 'published-date', 'geo-text', 'geo-image', 'yoast-faq', 'author-block', 'team-block', 'poker-hands', 'youtube-film-strip', 'home-promote-banner', 'exclusive-casino', 'article-banner', 'howto-block', 'article-helpful-vote', 'related-articles', 'other-software-provider', 'intro-block', 'bonus-cards', 'bullet-block', 'top-games-articles', 'alternative-software-provider', 'alternative-payment-options', 'similar-casinos', 'newsletter-block', 'core-shortcode', "stream-block", 'news-block', 'top-promotions', 'feature-promotion', 'software-provider-block', 'payment-option-block', 'languages-supports-block', 'bonus-information-block', 'core-content', 'link-block', 'pu-reference'];
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  data: {
    loading: false,
    casloading: false,
    maincasloading: false,
    disable: false,
    hasPlay: false,
    adminBarData: {},
    disableNotSupportBanner: false,
    notsupportbannerData: {},
    notsupportassetSizes: {},
    noScroll: false,
    notSupportPageType: "",
    notSupportType: "",
    pathValue: 0,
    selectedState: {},
    show_footer: !wpvue_script_data_params.data.site_data.enable_lazyload,
    show_stickymenu: wpvue_script_data_params.data.site_data.enable_stickymenu,
    show_stickymenu_desktop: wpvue_script_data_params.data.site_data.stickymenu_desktop,
    show_stickymenu_mobile: wpvue_script_data_params.data.site_data.stickymenu_mobile,
    game_overlay_screen_time: wpvue_script_data_params.data.site_data.game_overlay_screen_time,
    enable_api_auth_secret: wpvue_script_data_params.data.site_data.enable_api_auth_secret,
    api_auth_secret: wpvue_script_data_params.data.site_data.api_auth_secret,
    routes_meta: wpvue_script_data_params.data.routes_meta,
    site_url: wpvue_script_data_params.site_url,
    user_id: wpvue_script_data_params.user_id,
    page404_id: wpvue_script_data_params.page404_id,
    page404_slug: wpvue_script_data_params.page404_slug,
    asset_path: '/wp-content/themes/wpvue/src/assets/images',
    color_schema: wpvue_script_data_params.data.site_data.color_schema,
    font_family: wpvue_script_data_params.data.site_data.font_family,
    default_display: wpvue_script_data_params.data.site_data.cas_data.default_display,
    display_offset: wpvue_script_data_params.data.site_data.cas_data.display_offset,
    enable_partner_name_review_link: wpvue_script_data_params.data.site_data.cas_data.enable_partner_name_review_link,
    enable_lazyload: wpvue_script_data_params.data.site_data.enable_lazyload,
    i18n: wpvue_script_data_params.i18n,
    goto_link: wpvue_script_data_params.data.site_data.color_schema.promote_partner ? wpvue_script_data_params.data.site_data.color_schema.promote_partner.go_link : '',
    slug: wpvue_script_data_params.data.site_data.color_schema.promote_partner ? wpvue_script_data_params.data.site_data.color_schema.promote_partner.slug : '',
    listname: wpvue_script_data_params.data.site_data.aweber_listname,
    homepageId: wpvue_script_data_params.frontpage_id,
    //aweber: wpvue_script_data_params.data.site_data.aweber,
    campaignmonitor: wpvue_script_data_params.data.site_data.campaignmonitor,
    wp_country: wpvue_script_data_params.data.site_data.country,
    wp_state: wpvue_script_data_params.data.site_data.state,
    po_qty: wpvue_script_data_params.data.site_data.cas_data.po_qty,
    sp_qty: wpvue_script_data_params.data.site_data.cas_data.sp_qty,
    free_games_global_countries: wpvue_script_data_params.data.site_data.cas_data.free_games_global_countries,
    youtube_script_path: wpvue_script_data_params.data.site_data.youtube_script_path,
    custom_loader: wpvue_script_data_params.data.site_data.loader,
    user_agents: wpvue_script_data_params.data.site_data.user_agents,
    asset_sizes: wpvue_script_data_params.data.site_data.asset_sizes,
    disable_freegame_banner_outlink: wpvue_script_data_params.data.site_data.disable_freegame_banner_outlink,
    image_loader: wpvue_script_data_params.data.site_data.image_loader,
    enable_cta_partner_bonus: wpvue_script_data_params.data.site_data.cas_data.enable_cta_partner_bonus,
    enable_cta_partner_logo: wpvue_script_data_params.data.site_data.cas_data.enable_cta_partner_logo,
    hide_game_playnow_btn: wpvue_script_data_params.data.site_data.hide_game_playnow_btn,
    change_cta_to_sponsored: wpvue_script_data_params.data.site_data.cas_data.change_cta_to_sponsored,
    disable_bonus_cta_on_review: wpvue_script_data_params.data.site_data.cas_data.disable_bonus_cta_on_review,
    enable_piwik_reload: wpvue_script_data_params.data.site_data.enable_piwik_reload,
    disable_not_supported_banner: wpvue_script_data_params.data.site_data.cas_data.disable_not_supported_banner,
    enable_loader: wpvue_script_data_params.data.site_data.enable_loader,
    override_ctabtntxt_color: wpvue_script_data_params.data.site_data.color_schema.override_ctabtntxt_color,
    ctabtn_txt_color: wpvue_script_data_params.data.site_data.color_schema.ctabtn_txt_color,
    body_loading_status: false,
    page_side_images: wpvue_script_data_params.data.site_data.page_side_images
  },
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(472);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33), __webpack_require__(182)))

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326ab9ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(728);
function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326ab9ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(475);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4658f220", content, true, {});

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(46);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "*{box-sizing:border-box}a,button,input{transition:all .25s ease-in-out}body{font-family:var(--default-regular);font-weight:400;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;background:#f2f5f9}img{max-width:100%;height:auto}a,a:focus{text-decoration:none;outline:0}a,li{font-size:inherit;line-height:1.4;color:#222}a:focus,a:hover{color:inherit}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{-webkit-animation-name:fadeIn;animation-name:fadeIn}.container{width:1240px;margin:0 auto;padding:0 20px;position:relative;z-index:1}@media (min-width:320px){.container{width:100%}}@media (min-width:768px){.container{padding:0 15px}}@media (min-width:1280px){.container{width:1240px}}.container-fluid{padding:0 15px}.container-small{max-width:1000px}.row{margin:0 -8px;position:relative}.row:after,.row:before{content:\"\";display:table;clear:both}.row [class^=col-]{padding:0 8px;float:left;width:100%}.row-flex{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.row-flex-direction{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.row-flex-wrap{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.row-flex-end{-webkit-box-align:flex-end;-ms-flex-align:flex-end;align-items:flex-end}.row-flex-center{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.row-flex .col{float:none}@media (min-width:576px){.row .col-sm-1{width:8.33333333%}.row .col-sm-2{width:16.66666667%}.row .col-sm-3{width:25%}.row .col-sm-4{width:33.33333333%}.row .col-sm-5{width:41.66666667%}.row .col-sm-6{width:50%}.row .col-sm-7{width:58.33333333%}.row .col-sm-8{width:66.66666667%}.row .col-sm-9{width:75%}.row .col-sm-10{width:83.33333333%}.row .col-sm-11{width:91.66666667%}.row .col-sm-12{width:100%}}@media (min-width:768px){.row .col-md-1{width:8.33333333%}.row .col-md-2{width:16.66666667%}.row .col-md-3{width:25%}.row .col-md-4{width:33.33333333%}.row .col-md-5{width:41.66666667%}.row .col-md-6{width:50%}.row .col-md-7{width:58.33333333%}.row .col-md-8{width:66.66666667%}.row .col-md-9{width:75%}.row .col-md-10{width:83.33333333%}.row .col-md-11{width:91.66666667%}.row .col-md-12{width:100%}}@media (min-width:992px){.row .col-lg-1{width:8.33333333%}.row .col-lg-2{width:16.66666667%}.row .col-lg-3{width:25%}.row .col-lg-4{width:33.33333333%}.row .col-lg-5{width:41.66666667%}.row .col-lg-6{width:50%}.row .col-lg-7{width:58.33333333%}.row .col-lg-8{width:66.66666667%}.row .col-lg-9{width:75%}.row .col-lg-10{width:83.33333333%}.row .col-lg-11{width:91.66666667%}.row .col-lg-12{width:100%}}@media (min-width:1200px){.row .col-xl-1{width:8.33333333%}.row .col-xl-2{width:16.66666667%}.row .col-xl-3{width:25%}.row .col-xl-4{width:33.33333333%}.row .col-xl-5{width:41.66666667%}.row .col-xl-6{width:50%}.row .col-xl-7{width:58.33333333%}.row .col-xl-8{width:66.66666667%}.row .col-xl-9{width:75%}.row .col-xl-10{width:83.33333333%}.row .col-xl-11{width:91.66666667%}.row .col-xl-12{width:100%}}.main-content-area{background-color:#f1f2f3;position:relative}a,abbr,acronym,address,applet,article,aside,audio,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}:focus{outline:0}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration,input[type=search]::-webkit-search-results-button,input[type=search]::-webkit-search-results-decoration{-webkit-appearance:none;-moz-appearance:none}input[type=search]{-webkit-appearance:none;-moz-appearance:none}audio,canvas,video{display:inline-block;*display:inline;*zoom:1;max-width:100%}audio:not([controls]){display:none;height:0}[hidden]{display:none}html{font-size:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}a:focus{outline:thin dotted}a:active,a:hover{outline:0}img{border:0;-ms-interpolation-mode:bicubic}figure,form{margin:0}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0;white-space:normal;*margin-left:-7px}button,input,select,textarea{font-size:100%;margin:0;vertical-align:baseline;*vertical-align:middle}button,input{line-height:normal}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer;*overflow:visible}button[disabled],html input[disabled]{cursor:default}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0;*height:13px;*width:13px}input[type=search]{-webkit-appearance:textfield;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}textarea{overflow:auto;vertical-align:top}table{border-collapse:collapse;border-spacing:0}button,html,input,select,textarea{color:#222}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}img{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.chromeframe{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}*,:focus{outline:0;box-sizing:border-box;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body{background:#fbfbfb}body,p{font-size:16px;line-height:160%;font-family:Helvetica}p{margin:0 0 20px;color:#222;font-weight:400;overflow-wrap:break-word}p a{text-decoration:underline}h1,h2,h3,h4,h5,h6{padding:0}h1{font-family:Helvetica;font-size:24px;font-weight:700;line-height:160%;margin:0 0 16px;color:#222}@media (min-width:576px){h1{font-size:32px}}h2{font-family:Helvetica;font-size:22px;font-weight:700;line-height:160%;margin:0 0 16px;color:#222}@media (min-width:576px){h2{font-size:28px}}h3{font-family:Helvetica;font-size:20px;font-weight:700;line-height:160%;margin:0 0 16px;color:#222}@media (min-width:576px){h3{font-size:24px}}h4{font-family:Helvetica;font-size:18px;font-weight:700;line-height:160%;margin:0 0 16px;color:#222}@media (min-width:576px){h4{font-size:22px}}h5{font-size:16px;line-height:160%;margin:0 0 12px;font-family:Helvetica;font-weight:700;color:#222}@media (min-width:576px){h5{font-size:18px}}h6{font-size:14px;line-height:160%;margin:0 0 12px;font-family:Helvetica;font-weight:700;color:#222}@media (min-width:576px){h6{font-size:16px}}.span-h1,.span-h2,.span-h3,.span-h4,.span-h5,.span-h6{padding:0;display:block}.span-h1{font-family:Helvetica;font-size:24px;font-weight:700;line-height:160%;margin:0 0 16px;color:#222}@media (min-width:576px){.span-h1{font-size:32px}}.span-h2{font-family:Helvetica;font-size:22px;font-weight:700;line-height:160%;margin:0 0 16px;color:#222}@media (min-width:576px){.span-h2{font-size:28px}}.span-h3{font-family:Helvetica;font-size:20px;font-weight:700;line-height:160%;margin:0 0 16px;color:#222}@media (min-width:576px){.span-h3{font-size:24px}}.span-h4{font-family:Helvetica;font-size:18px;font-weight:700;line-height:160%;margin:0 0 16px;color:#222}@media (min-width:576px){.span-h4{font-size:22px}}.span-h5{font-size:16px;line-height:160%;margin:0 0 12px;font-family:Helvetica;font-weight:700;color:#222}@media (min-width:576px){.span-h5{font-size:18px}}.span-h6{font-size:14px;line-height:160%;margin:0 0 12px;font-family:Helvetica;font-weight:700;color:#222}@media (min-width:576px){.span-h6{font-size:16px}}.span-caption,.span-caption-link{font-size:12px;line-height:160%;font-weight:400}.span-caption-link{text-decoration:underline}.span-caption-bold-upper{font-weight:700}.span-caption-bold-upper,.span-caption-upper{font-size:12px;line-height:160%;text-decoration:underline;text-transform:uppercase}.span-caption-upper{font-weight:400}.span-caption-bold{font-size:12px;line-height:160%;font-weight:700;text-decoration:underline}.span-caption-small{font-size:10px;line-height:160%;font-weight:400}.text-right{text-align:right}.left{float:left}.right{float:right}.align-right{float:right;margin:0 0 35px 35px}.align-left,.align-right{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.align-left{float:left;margin:0 35px 35px 0}.terms-and-conditions{margin-top:12px;font-size:14px;line-height:150%;color:#aeaeae;font-family:var(--default-regular)}@media (min-width:576px){.terms-and-conditions{margin-top:18px;line-height:25px}}.gray-bg{background-color:#f5f6fc}.arrow{cursor:pointer;position:absolute;top:7px;right:-10px;width:5px;height:8px;transition:transform .1s}.arrow-bottom,.arrow-top{background-color:#3d29b1;height:1px;left:0;position:absolute;top:50%;width:100%}.arrow-top{transform:rotate(45deg);transform-origin:bottom right}.arrow-bottom{transform:rotate(-45deg);transform-origin:top right}.mt-35{margin-top:35px}.exclusive-tag{width:90px;font-size:16px;color:#fff;background:#f53980;text-align:center;padding:3px}.exclusive-tag,.rating-wrapper-small{-webkit-border-radius:50px;-moz-border-radius:50px;border-radius:50px}.rating-wrapper-small{min-width:74.64px;height:27px;padding:0 10px;background:#f6f6f6;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.rating-wrapper-small .radio-stars{margin-right:5px}.rating-wrapper-small .radio-stars img{margin:0;width:17px}.rating-wrapper-small .radio-star-total{font-weight:400;font-size:16px;line-height:19px;letter-spacing:.2em}.rating-wrapper-small .radio-star-total span{font-weight:700;font-size:16px}@media (min-width:992px){.hide-lg{display:none}}.hide-sm{display:none!important}@media (min-width:992px){.hide-sm{display:block!important}}.mt-38{margin-top:38px}.mb-32{margin-bottom:32px}.clearfix{overflow:auto}.clearfix:after{content:\"\";clear:both;display:table}.pt-7{padding-top:7px}.pt-10{padding-top:10px}.pt-37{padding-top:21px}@media (min-width:768px){.pt-37{padding-top:37px}}.pt-50{padding-top:21px}@media (min-width:768px){.pt-50{padding-top:50px}}.pb-25{padding-bottom:25px}.bg-gray{background-color:#f2f5fa}.mobile-scroller{overflow-x:auto;white-space:nowrap;padding-bottom:27px}@media (min-width:992px){.mobile-scroller{overflow-x:visible;white-space:normal;padding-bottom:0}}.mobile-scroller .row{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.mobile-scroller .row .col-md-3{width:100%}@media (min-width:992px){.mobile-scroller .row{display:block;-ms-flex-wrap:unset;flex-wrap:unset}.mobile-scroller .row .col-md-3{width:25%}}.mobile-scroller-editor{padding-bottom:0}.mobile-scroller-editor::-webkit-scrollbar-thumb,.mobile-scroller-editor::-webkit-scrollbar-track{display:none}.mobile-scroller-editor img{max-width:none}@media (min-width:576px){.mobile-scroller-editor img{max-width:100%}}.mobile-scroller::-webkit-scrollbar-track{background-color:hsla(0,0%,68%,.2);margin:0 20px}.mobile-scroller::-webkit-scrollbar-thumb{background-color:#e8321d;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.mobile-scroller::-webkit-scrollbar{height:2px}.rm-scroll::-webkit-scrollbar{height:0!important}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.mobile-scroller{scrollbar-base-color:#e8321d;scrollbar-face-color:#e8321d;scrollbar-3dlight-color:#e8321d;scrollbar-highlight-color:#e8321d;scrollbar-track-color:#666;scrollbar-arrow-color:#e8321d;scrollbar-shadow-color:#e8321d;scrollbar-dark-shadow-color:#e8321d}.mobile-scroller:after{content:\"\";height:32px;display:block}}@supports (-ms-ime-align:auto){.mobile-scroller:after{content:\"\";height:16px;display:block}}.mobile-scroller{scrollbar-width:thin;scrollbar-color:#666 #efefef}.display-flex{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.editor-content ul{list-style-type:none;padding:0;margin-bottom:16px;overflow-wrap:break-word}.editor-content ul li{font-style:normal;font-weight:400;font-size:16px;line-height:25px;position:relative;padding-left:37px;margin-bottom:16px}.editor-content ul li span,.editor-content ul li strong{font-weight:700}.editor-content .cross-div ul li,.editor-content .tick-div-blue ul li,.editor-content .tick-div-green ul li{line-height:25px;padding-left:37px;margin-bottom:12px}.editor-content ul li:before{position:absolute;content:\"\";top:1px;left:0;background:#0084ff url(" + escape(__webpack_require__(22)) + ") no-repeat;background-position:50%;background-size:14px}.editor-content .tick-div-green ul li:before,.editor-content ul li:before{display:inline-block;transform:translateY(0);height:26px;width:26px;border-radius:100%}.editor-content .tick-div-green ul li:before{top:0;background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;background-position:50%;background-size:14px}.editor-content .tick-div-blue ul li:before{display:inline-block;transform:translateY(0);height:26px;width:26px;top:1px;background:#0084ff url(" + escape(__webpack_require__(22)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:14px}.editor-content .cross-div ul li:before{position:absolute;left:0;top:0;transform:translate(0);background:#fe4646 url(" + escape(__webpack_require__(73)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:13px;width:26px;height:26px}.editor-content .image-div ul li:before{content:\"\";left:0;top:7px;width:11px;height:14px;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;position:absolute;background:var(--image-url);background-size:contain}.editor-content ol{list-style-type:none;padding:0;margin-bottom:20px;counter-reset:item}.editor-content ol li{font-style:normal;font-weight:400;font-size:16px;line-height:27px;position:relative;padding-left:37px;margin-bottom:12px;display:block}.editor-content ol li span,.editor-content ol li strong{font-weight:700}.editor-content ol li:before{position:absolute;left:0;top:0;transform:translateY(0);content:counter(item);counter-increment:item;color:#fff;font-weight:700;width:26px;height:26px;text-align:center;background:#0084ff;line-height:25px;border-radius:100%;font-size:16px;display:flex;align-items:center;justify-content:center}.editor-content .num-cls ol li{line-height:27px;padding-left:37px;margin-bottom:12px}.editor-content .num-cls ol li:before{position:absolute;left:0;top:0;transform:translateY(0);content:counter(item);counter-increment:item;color:#fff;font-weight:700;width:26px;height:26px;text-align:center;background:#0084ff;line-height:25px;border-radius:100%;font-size:16px}.editor-content .white-number ol li:before{background:#fff;color:#0084ff;display:flex;align-items:center;justify-content:center}.custom-font{width:100%}.custom-font a{text-decoration:underline;cursor:pointer}@media (max-width:576px){.max-content-area iframe{height:auto;width:auto}}.cas-term a,.terms-conditions a{cursor:pointer;text-decoration:underline}.block-content-light div,.block-content-light div a,.block-content-light div li,.block-content-light div p,.block-content-light div ul,.block-content-light h1,.block-content-light h2,.block-content-light h3,.block-content-light h3 a,.block-content-light h3 li,.block-content-light h3 p,.block-content-light h3 ul,.block-content-light h4,.block-content-light h5,.block-content-light h6{color:#fff!important}.block-content-light div a,.block-content-light h3 a{text-decoration:underline;cursor:pointer}.block-content-light a,.block-content-light li,.block-content-light p,.block-content-light ul{color:#fff!important}.block-content-light a{text-decoration:underline;cursor:pointer}.block-content-dark div,.block-content-dark div li,.block-content-dark div p,.block-content-dark div ul,.block-content-dark h1,.block-content-dark h2,.block-content-dark h3,.block-content-dark h3 li,.block-content-dark h3 p,.block-content-dark h3 ul,.block-content-dark h4,.block-content-dark h5,.block-content-dark h6{color:#222!important}.block-content-dark div a,.block-content-dark h3 a{text-decoration:underline;cursor:pointer}.block-content-dark li,.block-content-dark p,.block-content-dark ul{color:#222!important}.block-content-dark a{text-decoration:underline;cursor:pointer}.fw-bold{font-weight:700!important}.widget-title br{display:inline-block}@media (min-width:420px){.widget-title br{display:none}}.white-bg-block .accord-content,.white-bg-block .accord-header,.white-bg-block .accord-wrapper{color:#fff;background:var(--praimry-bg)}.white-bg-block .accord-content h3,.white-bg-block .accord-content p,.white-bg-block .accord-header h3,.white-bg-block .accord-header p,.white-bg-block .accord-wrapper h3,.white-bg-block .accord-wrapper p{color:#fff}.promotion-card-content .pimg{border-radius:10px;height:90px;width:90px;max-height:90px}.vm--container .custom-modal{max-width:80vw!important;border-radius:12px!important;height:max-content!important}@media (max-width:992px){.vm--container .custom-modal{left:10vw!important}}.tab-right h2{width:78%}.tab-right p{display:none}@media (min-width:768px){.tab-right p{color:#222;margin-bottom:20px;display:block}}.tab-right ul{list-style:none;column-count:0;-webkit-column-count:0;-moz-column-count:0;padding-top:20px}@media (min-width:768px){.tab-right ul{column-count:2;-webkit-column-count:2;-moz-column-count:2}}.tab-right li{margin-bottom:0;padding-inline-start:22px;font-size:16px;line-height:250%;color:#e8321d;color:var(--text-link-color)!important;text-decoration:underline;border-bottom:1px solid #ececec}@media (min-width:768px){.tab-right li{border-bottom:0;line-height:21px;color:#ea4734;padding-inline-start:17px;margin-bottom:5px}}.tab-right li:before{content:\"\\2022\";color:red;color:var(--text-link-color);font-weight:700;display:inline-block;width:1em;margin-left:-1em}blockquote{position:relative;padding-left:95px;margin:40px 0 64px;display:block;border:none!important}@media (min-width:768px){blockquote{display:block}}blockquote p{font-size:16px;line-height:160%;color:#222;margin-bottom:10px;font-style:italic}blockquote h6{margin-bottom:0}.show-read-more p{font-size:16px;line-height:160%;min-height:auto}@media (max-width:576px){.show-read-more p{display:-webkit-box;line-clamp:6;-webkit-line-clamp:6;-webkit-box-orient:vertical;overflow:hidden}}.selection-inner h2{margin-bottom:20px;color:#222}@media (min-width:992px){.selection-inner h2{margin:0 0 10px}}.selection-inner p{margin-bottom:20px;color:#222}@media (min-width:992px){.selection-inner p{margin-bottom:0}}.promotion-bottom-content p{color:#222;margin-bottom:28px}@media (max-width:576px){.selection-list-box:hover h1,h2,h3,h4,h5,h6{color:#222}}.selection-list-box-cardT:hover h1,.selection-list-box-cardT:hover h2,.selection-list-box-cardT:hover h3,.selection-list-box-cardT:hover h4,.selection-list-box-cardT:hover h5,.selection-list-box-cardT:hover h6{color:#fff}@media (max-width:576px){.selection-list-box-cardT:hover h1,.selection-list-box-cardT:hover h2,.selection-list-box-cardT:hover h3,.selection-list-box-cardT:hover h4,.selection-list-box-cardT:hover h5,.selection-list-box-cardT:hover h6{color:#222}}.selection-list-box:hover p{position:relative;color:#fff;z-index:1}@media (max-width:576px){.selection-list-box:hover p{color:#222}}.selection-list-box:hover p a{color:#fff!important}@media (max-width:576px){.selection-list-box:hover p a{color:#9b9b9b}}.selection-list-box:hover li{color:#fff}@media (max-width:576px){.selection-list-box:hover li{color:#222}}.selection-list-box:hover li a{color:#fff!important}@media (max-width:576px){.selection-list-box:hover li a{color:#9b9b9b}}.selection-list-box:hover span.span-h5{color:#fff}@media (max-width:576px){.selection-list-box:hover span.span-h5{color:#222}}.wp-block-quote{text-align:center;padding-left:0!important}.wp-block-quote p{position:relative}.wp-block-quote p:before{position:relative;content:\"\\201C\";font-size:96px;top:30px;right:8px}@media (max-width:576px){.wp-block-quote p:before{font-size:60px;top:15px}}.wp-block-quote p:after{position:absolute;content:\"\\201E\";font-size:96px;bottom:40px;margin-left:8px}@media (max-width:576px){.wp-block-quote p:after{font-size:60px;bottom:26px}}.wpvcb-custom-table-block{overflow:hidden}.wpvcb-custom-table-block a{position:relative;top:5px}.wp-block-table thead{border-bottom:none!important}.wpvcb-custom-table-block thead tr th{border:none;padding:15px;font-weight:700;text-align:center}.wpvcb-custom-table-block thead tr th:first-child{padding:15px}.wpvcb-custom-table-block tbody tr td{border:none;background:#fff;padding:9px;border-bottom:1px solid #e6e8ea;text-align:left;vertical-align:middle}.wpvcb-custom-table-block tbody tr td:first-child{padding-left:20px}.wpvcb-custom-table-block tbody tr td img{display:block;margin:auto}.wpvcb-custom-table-block tbody tr:last-child td{border:none}.wpvcb-custom-table-block thead tr:first-child th:first-child{border-top-left-radius:12px}.wpvcb-custom-table-block thead tr:first-child th:last-child{border-top-right-radius:12px}.wpvcb-custom-table-block tbody tr:last-child td:first-child{border-bottom-left-radius:12px}.wpvcb-custom-table-block tbody tr:last-child td:last-child{border-bottom-right-radius:12px}.arrow-cls{display:none}@media (max-width:576px){.arrow-cls{position:absolute;top:0;width:410px;display:none;justify-content:space-around}}@media (max-width:376px){.arrow-cls{width:356px}}@media (max-width:320px){.arrow-cls{width:320px}}@media (max-width:576px){.wpvcb-custom-table-block{position:relative;width:100vh;width:max-content;width:-moz-max-content;width:-webkit-max-content;width:-o-max-content;width:-ms-max-content;padding-left:20px;padding-right:20px;margin-top:30px}}@media (max-width:576px){.wpvcb-custom-table-block a{margin:0}}@media (max-width:576px){.wpvcb-custom-table-block tbody tr{display:flex;flex-wrap:wrap}}@media (max-width:576px){.wpvcb-custom-table-block tbody tr td{padding-left:11px;width:115px}}@media (max-width:576px){.wpvcb-custom-table-block tbody tr td:first-child{padding-left:14px;width:145px}}@media (max-width:576px){.wpvcb-custom-table-block thead tr{display:flex;flex-wrap:wrap}}@media (max-width:576px){.wpvcb-custom-table-block thead tr th{width:115px;display:inline-flex;align-items:center;justify-content:center;padding:10px}}@media (max-width:576px){.wpvcb-custom-table-block thead tr th:first-child{width:145px}}@media (max-width:576px){#cust-tbl{position:relative}}@media (max-width:576px){.left-arrow-cls{width:60%;transform:rotateY(180deg)}}@media (max-width:320px){.left-arrow-cls{width:40%}}.wpvcb-custom-table-block a i img{margin:0;margin-left:5px;margin-bottom:1px}@media (max-width:576px){.custom-ratio{width:auto!important;height:auto!important;padding-bottom:56.25%}}@media (max-width:576px){.custom-ratio iframe{position:absolute;height:100%!important;width:100%!important}}body .vp-center{justify-content:left!important}.icon-blue_tick{background:#0084ff url(" + escape(__webpack_require__(22)) + ") no-repeat;background-position:50%;background-size:14px}.icon-blue_tick,.icon-green_tick{position:relative;display:inline-block;height:26px;width:26px;min-width:26px;top:0;border-radius:100%;margin-right:10px}.icon-green_tick{background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;background-position:50%;background-size:14px}.icon-blue_number{background:#0084ff}.icon-blue_number,.icon-green_number{display:inline-block;transform:translateY(0);color:#fff;font-weight:700;width:26px;height:26px;min-width:26px;text-align:center;line-height:25px;border-radius:100%;font-size:16px;margin-right:10px}.icon-green_number{background:#5abc5e}@media only screen and (-o-min-device-pixel-ratio:1.5),only screen and (-webkit-min-device-pixel-ratio:1.5),only screen and (min--moz-device-pixel-ratio:1.5),only screen and (min-device-pixel-ratio:1.5){body,html{width:100%;overflow-x:hidden}}body{width:100%;overflow-x:hidden}.fa{font:normal normal normal 14px/1 FontAwesome!important}.ver-tab .fa{font-size:22px!important;font-weight:700!important}.sr-only{position:absolute;width:1px;height:1px;overflow:hidden;margin:-1px;padding:0;clip:rect(0,0,0,0);border:0}.btn-xl{max-width:380px;width:100%;border-width:2px}.router-link-exact-active{color:#e8321d!important}.editor-content .max-cntent-area{max-width:960px}.editor-content img{margin-bottom:20px}.editor-content strong{font-weight:700}.editor-content .accord-header img{margin-bottom:0}.casino-card{box-shadow:0 1px 8px 0 rgba(0,0,0,.2);background:#fff;padding:10px}.casino-card-horizontal{margin-top:15px;box-shadow:none;-webkit-box-shadow:none;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-card-horizontal:hover{cursor:default}.casino-card-horizontal:hover .cta:not(.cta-primary){background-color:#9a2b28;border-color:#9a2b28;color:#fff;box-shadow:none!important;-webkit-box-shadow:none!important}.casino-card-horizontal:hover .cct-next{box-shadow:inset 0 -4px 4px #e6e6e6;-webkit-box-shadow:inset 0 -4px 4px #e6e6e6}.casino-card-horizontal:hover .promotion-bonus{color:#e8321d}.casino-card-horizontal:hover .casino-card-top p{color:#f2232a}.casino-card-horizontal:focus{cursor:pointer}.casino-card-horizontal:focus .cta{background-color:#9a2b28;border-color:#9a2b28;color:#fff;box-shadow:none!important;-webkit-box-shadow:none!important}.casino-card-horizontal:focus .cct-next{box-shadow:inset 0 -4px 4px #e6e6e6;-webkit-box-shadow:inset 0 -4px 4px #e6e6e6}.casino-card-horizontal__m{margin-top:10px;border:2px solid transparent;padding:16px 10px 12px;position:relative}@media (min-width:576px){.casino-card-horizontal__m{padding:10px}}.casino-card-horizontal__m .casino-card-right{padding-right:0!important}.casino-card-horizontal__m.top-choice{padding-top:32px}@media (min-width:576px){.casino-card-horizontal__m.top-choice{padding-top:10px}}.casino-card-horizontal__m.normal-choice{padding-top:32px}@media (min-width:576px){.casino-card-horizontal__m.normal-choice{padding-top:10px}}.casino-card-row{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:576px){.casino-card-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}.casino-card-row-left{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:10px}@media (min-width:576px){.casino-card-row-left{margin-bottom:0}}.casino-card-row-right{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:initial;-ms-flex-align:initial;align-items:initial;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}@media (min-width:576px){.casino-card-row-right{-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:auto}}@media (min-width:1024px){.casino-card-row-right{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.casino-card-row-right .casino-card-text{margin-left:0;margin-bottom:8px}@media (min-width:576px){.casino-card-row-right .casino-card-text{margin-bottom:10px}}@media (min-width:1024px){.casino-card-row-right .casino-card-text{margin-bottom:0;margin-left:20px}}.casino-card .card-logo{width:100%;max-width:48px;height:48px;-webkit-border-radius:7.41818px;-moz-border-radius:7.41818px;border-radius:7.41818px}@media (min-width:576px){.casino-card .card-logo{max-width:90px;height:90px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}}.casino-card .card-logo .div-partner-logo,.casino-card .card-logo a,.casino-card .card-logo div.div-partner-logo{display:block;border-radius:5px;overflow:hidden;position:relative}.casino-card .card-logo a img,.casino-card .card-logo div.div-partner-logo img{width:100%;height:100%;object-fit:cover;margin-bottom:0;-webkit-border-radius:7.41818px;-moz-border-radius:7.41818px;border-radius:7.41818px}@media (min-width:576px){.casino-card .card-logo a img,.casino-card .card-logo div.div-partner-logo img{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}}.casino-card .card-logo a .stripe,.casino-card .card-logo div.div-partner-logo .stripe{position:absolute;width:100%;height:20px;bottom:0;left:0;overflow:hidden;background-color:#ffd039;display:none}@media (min-width:576px){.casino-card .card-logo a .stripe,.casino-card .card-logo div.div-partner-logo .stripe{display:block}}.casino-card .card-logo a .stripe img,.casino-card .card-logo div.div-partner-logo .stripe img{width:14px;height:14px;margin:3px auto;object-fit:contain}.casino-card .card-text p{margin-bottom:0;color:#222;margin-bottom:2px}@media (min-width:576px){.casino-card .card-text p{margin-bottom:8px}}@media (min-width:1200px){.casino-card .card-text p{font-size:16px}}.casino-card .card-text h4{color:#222;font-weight:600}.casino-card .card-text h4 span{font-size:12px;font-weight:400}.casino-card .casino-card-right{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-right:15px}.casino-card .casino-card-right .cta{margin-left:0;line-height:18px;font-family:var(--default-bold);font-size:14px;font-weight:700;margin-top:0;max-width:100%;min-width:100%;padding:14px 20px;box-shadow:inset 0 -4px 4px #d40d13;-webkit-box-shadow:inset 0 -4px 4px #d40d13}@media (min-width:576px){.casino-card .casino-card-right .cta{max-width:265px;min-width:265px;line-height:22px;font-size:18px}}@media (min-width:1024px){.casino-card .casino-card-right .cta{margin-left:35px;padding:16px 20px}}@media (min-width:1200px){.casino-card .casino-card-right .cta{min-width:280px}}.casino-card .casino-card-right .cta img{margin:0 12px 0 0;width:18px;vertical-align:middle}@media (min-width:576px){.casino-card .casino-card-right .cta img{width:24px;margin:0 8px 0 0}}.casino-card .casino-card-right .cta:focus{color:#fff}.casino-card .rating-review{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-width:197px;height:40px;padding:4px 15px;background:#fff3eb;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.casino-card .rating-review,.casino-card .rating-review .rating-stars{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.casino-card .rating-review .rating-stars img{width:19px;height:19px;margin-right:5px}.casino-card .rating-review .rating-value{font-size:14px;line-height:14px;padding-right:8px;color:#ff8126}.casino-card .rating-review .rating-value .result{font-weight:700;font-size:16px;line-height:33px}.casino-card-lists ul{margin:0;padding:0;list-style-type:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}@media (min-width:992px){.casino-card-lists ul{-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}.casino-card-lists ul li{margin:0 16px 15px 0;padding:0;list-style-type:none}@media (min-width:992px){.casino-card-lists ul li{margin:0 16px 0 0}}@media (min-width:1200px){.casino-card-lists ul li{margin:0 32px 0 0}}.casino-card-lists ul li:before{display:none}.casino-card-lists ul li figure{overflow:hidden;width:50px;height:50px;background:#f6f5f5;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;padding:0;font-weight:700;font-size:16px;line-height:25px;color:#aeaeae;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.casino-card-lists ul li figure img{margin:0}.casino-card-lists ul li:last-child{margin-right:0}.casino-card-lang-lists ul{margin:0;padding:0;list-style-type:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.casino-card-lang-lists ul li{width:36px;height:36px;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;overflow:hidden;margin:0 6px 0 0;padding:0;border:1px solid #bbb}.casino-card-lang-lists ul li:before{display:none}.casino-card-lang-lists ul li img{width:100%;height:100%;object-fit:cover;margin-bottom:0}.casino-card-software{box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;padding:0;margin-bottom:35px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-top:30px;flex-wrap:wrap;width:100%}@media (min-width:768px){.casino-card-software{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:50%}}.casino-card-software .col-sm-6{width:100%}.casino-card-software .card-icon{padding:16px;border-right:0;min-width:106px;text-align:left;padding-bottom:0}@media (min-width:576px){.casino-card-software .card-icon{padding:24px;padding-bottom:0}}@media (min-width:768px){.casino-card-software .card-icon{text-align:center;padding:24px;border-right:1px solid #f1f2f3}}.casino-card-software .card-icon img{margin-bottom:0}.casino-card-software .card-content{padding:16px;width:100%}@media (min-width:576px){.casino-card-software .card-content{padding:24px}}@media (min-width:768px){.casino-card-software .card-content{width:calc(100% - 106px);padding:30px}}.casino-card-software .card-content-bottom{border-top:1px solid #f1f2f3;padding-top:20px;margin-top:15px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:1024px){.casino-card-software .card-content-bottom{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.casino-card-software .card-content-bottom-left{min-width:100%;margin-bottom:0}@media (min-width:1024px){.casino-card-software .card-content-bottom-left{min-width:204px}}.casino-card-software .card-content-bottom-left p{margin-bottom:0}.casino-card-software .card-content-bottom-right .customer-support-info{display:block;padding-top:0}@media (min-width:576px){.casino-card-software .card-content-bottom-right .customer-support-info{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-ms-flex-wrap:wrap;flex-wrap:wrap}}@media (min-width:1024px){.casino-card-software .card-content-bottom-right .customer-support-info{-ms-flex-wrap:nowrap;flex-wrap:nowrap;padding-top:5px}}.casino-card-software .card-content-bottom-right .customer-support-info p{color:#222;margin-right:25px;margin-bottom:6px;display:-webkit-box;display:-ms-flexbox;display:flex}@media (min-width:576px){.casino-card-software .card-content-bottom-right .customer-support-info p{margin-bottom:0}}@media (min-width:1200px){.casino-card-software .card-content-bottom-right .customer-support-info p{margin-right:50px}}.casino-card-software .card-content-bottom-right .customer-support-info p i{margin-right:10px;width:10px}.casino-card-software .card-content-bottom-right .customer-support-info p i img{margin:0}.casino-card-software .casino-card-lists ul li:nth-child(4n){margin-right:0}@media (min-width:576px){.casino-card-software .casino-card-lists ul li:nth-child(4n){margin-right:15px}}.casino-card-payment-method .card-content-bottom{border-top:0;padding-top:0;margin-top:0}.casino-card-payment-method .card-content-bottom-left{min-width:auto}@media (min-width:576px){.casino-card-payment-method .card-content-bottom-left{min-width:350px}}.casino-card-payment-method .card-content-bottom .casino-card-lists ul{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}@media (min-width:1200px){.casino-card-payment-method .card-content-bottom .casino-card-lists ul{-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}.casino-card-payment-method .card-content-bottom .casino-card-lists ul li{margin-right:16px;margin-bottom:0}.casino-card-payment-method .card-content-bottom .casino-card-lists ul li:nth-child(4n){margin-right:0}@media (min-width:576px){.casino-card-payment-method .card-content-bottom .casino-card-lists ul li:nth-child(4n){margin-right:15px}}.casino-card-security .half-column{display:block;margin-bottom:20px}.casino-card-security .half-column:last-child{margin-bottom:0}@media (min-width:576px){.casino-card-security .half-column{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0}}@media (min-width:1024px){.casino-card-security .half-column{margin-bottom:0}}.casino-card-security .half-column-img{min-width:82px;margin-bottom:22px}@media (min-width:576px){.casino-card-security .half-column-img{margin-bottom:0;min-width:107px}}.casino-card-security .half-column-img img{margin-bottom:0}.casino-card-security .half-column-text{padding-left:0;padding-right:0}@media (min-width:576px){.casino-card-security .half-column-text{padding-left:20px;padding-right:20px}}@media (min-width:1080px){.casino-card-security .half-column-text{padding-left:28px;padding-right:0}}.casino-card-security .half-column-text h6{margin-bottom:5px}.casino-card-security .half-column-text p{margin-bottom:0}.casino-card-bonus{height:auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:1024px){.casino-card-bonus{min-height:320px;height:auto;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}@media (min-width:1200px){.casino-card-bonus{height:281px}}.casino-card-bonus .bonus-card-logo{background:linear-gradient(89.55deg,#ffc300 .31%,#ff9600 99.64%);box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px 12px 0 0;-moz-border-radius:12px 12px 0 0;border-radius:12px 12px 0 0;width:100%;height:145px;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (min-width:1024px){.casino-card-bonus .bonus-card-logo{width:300px;height:100%;-webkit-border-radius:12px 0 0 12px;-moz-border-radius:12px 0 0 12px;border-radius:12px 0 0 12px}}.casino-card-bonus .bonus-card-logo img{margin-bottom:0}.casino-card-bonus .bonus-card-content{width:100%;padding:22px 16px 17px}@media (min-width:576px){.casino-card-bonus .bonus-card-content{padding:30px 45px 20px}}@media (min-width:1024px){.casino-card-bonus .bonus-card-content{width:calc(100% - 300px)}}.casino-card-bonus .bonus-card-content-top{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}@media (min-width:1024px){.casino-card-bonus .bonus-card-content-top{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}.casino-card-bonus .bonus-card-content-top .half-column{-webkit-box-flex:unset;-ms-flex:unset;flex:unset}@media (min-width:1024px){.casino-card-bonus .bonus-card-content-top .half-column{-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0}}.casino-card-bonus .bonus-card-content-top .half-column .bonus-card-rating{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:10px}.casino-card-bonus .bonus-card-content-top .half-column .bonus-card-rating p{margin:0 20px 0 0}.casino-card-bonus .bonus-card-content-top .half-column-cont{max-width:300px}.casino-card-bonus .bonus-card-content-top .half-column-cont h2{margin:0}@media (min-width:768px){.casino-card-bonus .bonus-card-content-top .half-column-cont h2{margin:0 0 16px}}.casino-card-bonus .bonus-card-content-top .half-column-cont span{font-size:16px;line-height:120%;font-weight:700}.casino-card-bonus .bonus-card-content-top .half-column .cta{min-width:100%;float:left;margin:25px 0;font-weight:900;font-size:16px;line-height:20px}@media (min-width:576px){.casino-card-bonus .bonus-card-content-top .half-column .cta{min-width:332px;font-weight:600;font-size:18px;line-height:1}}@media (min-width:1024px){.casino-card-bonus .bonus-card-content-top .half-column .cta{float:right}}.casino-card-bonus .bonus-card-content-bottom{border-top:1px solid #f1f2f3;padding-top:20px}@media (max-width:576px){.casino-card-bonus .bonus-card-content-bottom h6{font-size:18px}}.casino-card-similar{text-align:center;padding:15px}.casino-card-similar:first-child{border:0}.casino-card-similar a.casino-name{font-weight:400;font-size:14px;line-height:160%;color:var(--text-link-color);text-decoration:underline;margin-bottom:10px;display:none}@media (min-width:768px){.casino-card-similar a.casino-name{font-size:16px}}@media (min-width:1024px){.casino-card-similar a.casino-name{display:inline-block}}.casino-card-similar .similar-card-logo{position:relative;margin-bottom:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start}@media (min-width:1024px){.casino-card-similar .similar-card-logo{display:block;margin-bottom:27px}}.casino-card-similar .similar-card-logo img{width:90px;height:90px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;object-fit:cover;margin:0 auto}@media (min-width:1024px){.casino-card-similar .similar-card-logo img{width:145px;height:145px}}.casino-card-similar .similar-card-logo .rating-wrap{position:absolute;bottom:-4px;left:0;right:0;display:none}.casino-card-similar .similar-card-logo .rating-wrap .rating-wrapper-small{margin:auto;display:inline-flex;width:auto}.casino-card-similar .similar-card-logo .rating-wrap .rating-wrapper-small .radio-stars img{width:17px;height:17px;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;object-fit:none}@media (min-width:1024px){.casino-card-similar .similar-card-logo .rating-wrap{display:block}}.casino-card-similar .similar-card-logo-mobile{display:block;text-align:left;padding-left:10px;padding-right:20px}.casino-card-similar .similar-card-logo-mobile .rating-wrap{position:static;margin-bottom:10px;display:block}.casino-card-similar .similar-card-logo-mobile .rating-wrap .rating-wrapper-small{margin:auto;display:inline-flex;width:auto;min-width:auto;height:20px}.casino-card-similar .similar-card-logo-mobile .rating-wrap .rating-wrapper-small .radio-stars img{width:12px;height:12px;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;object-fit:none}.casino-card-similar .similar-card-logo-mobile .rating-wrap .rating-wrapper-small .radio-star-total{font-size:12px;line-height:15px;padding-left:0}.casino-card-similar .similar-card-logo-mobile .rating-wrap .rating-wrapper-small .radio-star-total span{font-size:12px}.casino-card-similar .similar-card-logo-mobile a.casino-name{font-weight:400;font-size:14px;line-height:160%;color:var(--text-link-color);text-decoration:underline;margin-bottom:0;display:inline-block}@media (min-width:768px){.casino-card-similar .similar-card-logo-mobile a.casino-name{font-size:16px}}@media (min-width:1024px){.casino-card-similar .similar-card-logo-mobile{display:none}}.casino-card-similar p{color:#676767;font-weight:400;margin-bottom:10px}.casino-card-similar h2{margin-bottom:15px}.casino-card-similar .casino-card-lists{text-align:left;margin-top:20px}.casino-card-similar .casino-card-lists h6{font-weight:400;color:#676767}.casino-card-similar .casino-card-lists ul li{margin:0 8px 0 0}.casino-card-similar .casino-card-lists ul li:last-child{margin-right:0}@media (min-width:1200px){.casino-card-similar .casino-card-lists ul li{margin:0 16px 0 0}}.casino-card-similar__review{box-shadow:0 5px 15px rgba(0,0,0,.05)}.casino-card-payment-toplist{margin:0;min-height:auto;height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:768px){.casino-card-payment-toplist{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;min-height:400px}}.casino-card-payment-toplist .bonus-card-logo{background:#f6f5f5;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;width:100%;height:170px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:35px;box-shadow:none}@media (min-width:768px){.casino-card-payment-toplist .bonus-card-logo{width:285px;height:auto;-webkit-border-radius:12px 0 0 12px;-moz-border-radius:12px 0 0 12px;border-radius:12px 0 0 12px;box-shadow:0 5px 15px rgba(0,0,0,.05);padding:25px}}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-logo{width:310px;padding:30px}}@media (min-width:1080px){.casino-card-payment-toplist .bonus-card-logo{width:360px;padding:45px}}@media (min-width:1200px){.casino-card-payment-toplist .bonus-card-logo{width:400px}}.casino-card-payment-toplist .bonus-card-logo img{height:100%}@media (min-width:768px){.casino-card-payment-toplist .bonus-card-logo img{height:auto}}.casino-card-payment-toplist .bonus-card-content{padding:15px 20px;width:100%}@media (min-width:768px){.casino-card-payment-toplist .bonus-card-content{width:calc(100% - 310px);padding:30px 45px}}@media (min-width:1080px){.casino-card-payment-toplist .bonus-card-content{padding:35px 55px 30px 50px;width:calc(100% - 360px)}}@media (min-width:1200px){.casino-card-payment-toplist .bonus-card-content{width:calc(100% - 400px);padding:35px 75px 30px 70px}}.casino-card-payment-toplist .bonus-card-content-top{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-bottom:15px}@media (min-width:1200px){.casino-card-payment-toplist .bonus-card-content-top{padding-bottom:28px}}.casino-card-payment-toplist .bonus-card-content-top h6{margin-bottom:20px;color:#222}.casino-card-payment-toplist .bonus-card-content-top ul.proslist{column-count:unset}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-top ul.proslist{column-count:2}}.casino-card-payment-toplist .bonus-card-content-top ul.proslist li{margin-bottom:22px;width:100%}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-top ul.proslist li{width:50%}}.casino-card-payment-toplist .bonus-card-content-top .why-use .show-more{display:flex;position:relative;font-weight:400;font-size:14px;line-height:17px;color:#222;padding-left:0;margin-top:20px;align-items:center}.casino-card-payment-toplist .bonus-card-content-top .why-use .show-more i{background:#f1f2f3;border-radius:5px;display:inline-block;width:20px;height:20px;position:relative;margin-right:10px}.casino-card-payment-toplist .bonus-card-content-top .why-use .show-more i:after,.casino-card-payment-toplist .bonus-card-content-top .why-use .show-more i:before{position:absolute;content:\"\";left:4px;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);width:10px;height:2px;background:#bdbdbe}.casino-card-payment-toplist .bonus-card-content-top .why-use .show-more i:before{width:2px;height:10px;left:8px}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-top .why-use .show-more{display:none}}.casino-card-payment-toplist .bonus-card-content-top .why-use .show-less{display:flex;position:relative;font-weight:400;font-size:14px;line-height:17px;color:#222;padding-left:0;margin-top:20px;align-items:center}@media (min-width:768px){.casino-card-payment-toplist .bonus-card-content-top .why-use .show-less{margin-top:6px;margin:6px 3px 10px}}.casino-card-payment-toplist .bonus-card-content-top .why-use .show-less i{background:#f1f2f3;border-radius:5px;display:inline-block;width:20px;height:20px;position:relative;margin-right:10px}.casino-card-payment-toplist .bonus-card-content-top .why-use .show-less i:after{position:absolute;content:\"\";left:4px;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);width:10px;height:2px;background:#bdbdbe}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-top .why-use .show-less{display:none}}.casino-card-payment-toplist .bonus-card-content-top .why-use ul.proslist{height:20px;overflow:hidden;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-top .why-use ul.proslist{height:auto;overflow:visible}}.casino-card-payment-toplist .bonus-card-content-top .why-use.expanded ul.proslist{height:auto;padding-bottom:10px}.casino-card-payment-toplist .bonus-card-content-bottom{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-top:15px;padding-bottom:24px}@media (min-width:768px){.casino-card-payment-toplist .bonus-card-content-bottom{-webkit-box-align:start;-ms-flex-align:start;align-items:start;padding-top:16px;padding-bottom:30px}}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-icon{width:72px;position:relative}@media (min-width:768px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-icon{width:90px}}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-icon img{width:72px;height:72px;object-fit:cover}@media (min-width:768px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-icon img{width:90px;height:90px}}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-icon i.best-reward{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#fff;box-shadow:0 5px 5px rgba(0,0,0,.05);-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;width:35px;height:35px;position:absolute;left:3px;bottom:-17px}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-icon i.best-reward img{width:13px;height:18px}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-icon i.best-reward{display:none}}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont{width:calc(100% - 72px);padding-left:0}@media (min-width:768px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont{padding-left:15px;width:calc(100% - 90px)}}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;padding-top:0;padding-bottom:0;margin-bottom:0}@media (min-width:768px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice{padding-bottom:10px}}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice{padding-bottom:12px}}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice .best-choice-cont{padding-left:10px}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice .best-choice-cont h6{font-weight:700;color:#e8321d;margin-bottom:0}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice .best-choice-cont .best-rating{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice .best-choice-cont .best-rating{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice .best-choice-cont .best-rating p{margin-bottom:0;margin-right:0}@media (min-width:768px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice .best-choice-cont .best-rating p{margin-right:20px}}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice .best-choice-cont .best-rating .rating-wrapper{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice .best-choice-cont .best-rating .rating-wrapper{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice i{display:none}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .best-choice i{display:block}}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont h2{margin-bottom:20px}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .btn-block{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .btn-block .cta-promotion{margin:0 38px 0 0;min-width:230px}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont .btn-block .read-review{font-weight:400;font-size:16px;line-height:19px;color:#9b9b9b}.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont-title{display:none}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content-bottom .best-choice-casino-cont-title{display:block}}.casino-card-payment-toplist .bonus-card-content .view-mob{display:block;text-align:center}.casino-card-payment-toplist .bonus-card-content .view-mob h2{font-weight:900;margin-bottom:0}.casino-card-payment-toplist .bonus-card-content .view-mob .btn-block{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.casino-card-payment-toplist .bonus-card-content .view-mob .btn-block .cta-promotion{margin:25px auto 12px;width:100%;font-weight:900}.casino-card-payment-toplist .bonus-card-content .view-mob .btn-block .read-review{text-decoration:underline;color:#9b9b9b;font-size:14px}@media (min-width:992px){.casino-card-payment-toplist .bonus-card-content .view-mob{display:none}}.casino-card-emoji{padding:25px;margin-top:38px;display:none}@media (min-width:768px){.casino-card-emoji{display:block}}@media (min-width:992px){.casino-card-emoji{padding:34px 30px 29px;margin-top:25px}}.casino-card-emoji .emoji-icon i{width:110px;height:110px;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;background:#f6f5f5;padding:16px;display:block}@media (min-width:992px){.casino-card-emoji .emoji-icon i{width:133px;height:133px}}.casino-card-emoji .emoji-icon i img{margin:0}.casino-card-emoji .emoji-content{padding-left:25px;width:calc(100% - 110px)}@media (min-width:992px){.casino-card-emoji .emoji-content{padding-left:43px;width:calc(100% - 133px)}}.casino-card-emoji .emoji-content p{font-weight:700;color:#e8321d;margin:0}@media (min-width:992px){.casino-card-emoji .emoji-content p{font-size:16px}}.casino-card-pros-cons{background:#fff;box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;margin:35px 0;padding:30px}.casino-card-pros-cons.desk-view{display:none}@media (min-width:768px){.casino-card-pros-cons.desk-view{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}.casino-card-pros-cons .divider{width:1px;background:#f1f2f3;margin:0 32px}.casino-card-pros-cons .half-col{flex:1 0 0}.casino-card-pros-cons .half-col h2{margin-top:-6px;margin-bottom:21px}.casino-card-guide{box-shadow:0 4.94764px 14.8429px rgba(0,0,0,.05);width:46%;height:165px;padding:18px;position:relative;overflow:hidden;-webkit-transition:all .5s;-moz-transition:all .5s;-ms-transition:all .5s;-o-transition:all .5s;transition:all .5s;margin:0 5.3px 10.3px}@media (min-width:768px){.casino-card-guide{width:22%;margin:0 9.3px 20.3px}}@media (min-width:992px){.casino-card-guide{width:18%;margin:0 9.3px 20.3px}}@media (min-width:1024px){.casino-card-guide{width:18%;margin:0 9.3px 20.3px}}@media (min-width:1200px){.casino-card-guide{width:15%;margin:0 9px 20.3px}}@media (min-width:1280px){.casino-card-guide{width:182px;margin:0 8px 23px}}.casino-card-guide:first-child{border:0;margin-top:0}.casino-card-guide span.span-h6{font-weight:700;color:#232529;max-width:100%;margin:0 0 7px;display:block!important}.casino-card-guide .guide-icon{position:absolute;right:-25px;bottom:-7px}@media (min-width:576px){.casino-card-guide .guide-icon{right:-25px;bottom:-9px}}@media (min-width:640px){.casino-card-guide .guide-icon{right:-25px;bottom:-9px}}@media (min-width:768px){.casino-card-guide .guide-icon{right:-8px;bottom:-8px}}.casino-card-guide .guide-icon i{display:block;width:100%;height:100%}.casino-card-guide .guide-icon i img{margin:0;max-width:100%}.casino-card-guide .guide-icon-normal{display:block;height:118px;width:118px}.casino-card-guide .guide-icon-hover{width:88px;height:88px;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;background:#fff;display:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0}@media (min-width:576px){.casino-card-guide .guide-icon-hover{width:98px;height:98px}}@media (min-width:768px){.casino-card-guide .guide-icon-hover{width:118px;height:118px}}.casino-card-guide .arrow-link{position:absolute;left:auto;bottom:24px}@media (min-width:576px){.casino-card-guide .arrow-link{left:24px}}.casino-card-guide .arrow-link img{margin:0;width:15px;height:14px}.casino-card-guide:hover{background:#e8321d}.casino-card-guide:hover span.span-h6{color:#fff}.casino-card-guide:hover .arrow-link img{-webkit-filter:brightness(0) invert(1);filter:brightness(0) invert(1)}.casino-card-recommended{box-shadow:0 5px 15px rgba(0,0,0,.05);margin:60px 0 48px;padding:0;cursor:none}.casino-card-recommended-row{display:-webkit-box;display:-ms-flexbox;display:flex}.casino-card-recommended-row .recommended-content{width:100%;padding:20px 16px}@media (min-width:768px){.casino-card-recommended-row .recommended-content{width:60%;padding:25px 20px}}@media (min-width:1080px){.casino-card-recommended-row .recommended-content{width:504px;padding:38px 60px 25px 50px}}.casino-card-recommended-row .recommended-content-top{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;margin-bottom:24px}@media (min-width:768px){.casino-card-recommended-row .recommended-content-top{margin-bottom:20px}}.casino-card-recommended-row .recommended-content-top .recommended-logo{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;width:68px;height:68px;position:relative}@media (min-width:768px){.casino-card-recommended-row .recommended-content-top .recommended-logo{width:96px;height:96px}}.casino-card-recommended-row .recommended-content-top .recommended-logo img{width:100%;height:100%;object-fit:cover}.casino-card-recommended-row .recommended-content-top .recommended-logo i.recommended-icon{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#fff;box-shadow:0 5px 5px rgba(0,0,0,.05);-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;width:35px;height:35px;position:absolute;left:3px;bottom:-17px}.casino-card-recommended-row .recommended-content-top .recommended-logo i.recommended-icon img{width:20px;height:19px;margin-bottom:0}@media (min-width:768px){.casino-card-recommended-row .recommended-content-top .recommended-logo i.recommended-icon{display:none}}.casino-card-recommended-row .recommended-content-top .content-top-right{padding-left:16px;padding-top:2px}@media (min-width:768px){.casino-card-recommended-row .recommended-content-top .content-top-right{padding-left:22px}}.casino-card-recommended-row .recommended-content-top .content-top-right h6{color:#e8321d;margin:0}@media (min-width:768px){.casino-card-recommended-row .recommended-content-top .content-top-right h6{margin:0 0 7px}}.casino-card-recommended-row .recommended-content-top .content-top-right p{margin:0}@media (min-width:768px){.casino-card-recommended-row .recommended-content-top .content-top-right p{margin:0 0 12px}}.casino-card-recommended-row .recommended-content-top .content-top-right .rating-wrapper{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.casino-card-recommended-row .recommended-content-bottom{text-align:center}@media (min-width:768px){.casino-card-recommended-row .recommended-content-bottom{text-align:left}}.casino-card-recommended-row .recommended-content-bottom h1{font-weight:900;color:#222;margin-bottom:24px}@media (min-width:992px){.casino-card-recommended-row .recommended-content-bottom h1{margin-bottom:42px}}.casino-card-recommended-row .recommended-content-bottom .cta-promotion{margin:0 0 12px}@media (min-width:768px){.casino-card-recommended-row .recommended-content-bottom .cta-promotion{margin:0 0 22px}}.casino-card-recommended-row .recommended-content-bottom .read-review{font-weight:400;font-size:14px;line-height:112.95%;text-decoration-line:underline;color:#222;display:block;margin:0 auto;width:max-content}.casino-card-recommended-row .recommended-content-bottom .read-review:hover{text-decoration-line:none}@media (min-width:768px){.casino-card-recommended-row .recommended-content-bottom .read-review{font-size:16px;line-height:19px}}.casino-card-recommended-row .recommended-img{display:none}@media (min-width:768px){.casino-card-recommended-row .recommended-img{display:block;width:40%}}@media (min-width:1080px){.casino-card-recommended-row .recommended-img{width:calc(100% - 504px)}}.casino-card-recommended-row .recommended-img img{margin:0;-webkit-border-radius:0 12px 12px 0;-moz-border-radius:0 12px 12px 0;border-radius:0 12px 12px 0;height:100%;object-fit:cover;width:100%}.casino-card-related{padding:0;min-width:218px}.casino-card-related:first-child{border:0;margin-top:0}.casino-card-related .related-article-img{height:171px}@media (min-width:992px){.casino-card-related .related-article-img{height:220px}}.casino-card-related .related-article-img img{-webkit-border-radius:12px 12px 0 0;-moz-border-radius:12px 12px 0 0;border-radius:12px 12px 0 0;width:100%;height:100%;object-fit:cover}.casino-card-related .related-article-content{padding:16px 16px 35px;position:relative;white-space:normal}@media (min-width:992px){.casino-card-related .related-article-content{padding:16px 20px 35px}}.casino-card-related .related-article-content h3{font-weight:900;margin-bottom:4px}@media (min-width:992px){.casino-card-related .related-article-content p{margin:0 0 20px}}.casino-card-related .related-article-content .arrow-link{position:absolute;right:20px;bottom:15px}.casino-card-related .related-article-content .arrow-link img{-webkit-filter:grayscale(1) invert(1);filter:grayscale(1) invert(1)}.casino-card-related:hover .arrow-link img{-webkit-filter:grayscale(0) invert(0);filter:grayscale(0) invert(0)}.casino-card.top-choice{border:3px solid #ffd039;margin-top:8px}@media (min-width:576px){.casino-card.top-choice{border:2px solid #ffd039}}.casino-card.top-choice .card-sticky{display:table;margin:auto;font-size:12px;line-height:20px;font-weight:700;padding:0 10px;min-width:160px;position:absolute;top:0;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);-webkit-border-radius:0 0 12px 12px;-moz-border-radius:0 0 12px 12px;border-radius:0 0 12px 12px}.casino-card.top-choice .card-sticky img{margin-right:12px;width:13px;margin-bottom:0}@media (min-width:576px){.casino-card.top-choice .card-sticky{display:none}}.casino-card.normal-choice{border:0;margin-top:8px}@media (min-width:576px){.casino-card.normal-choice{border:0}}.casino-card.normal-choice .card-sticky{display:table;margin:auto;font-size:12px;line-height:20px;font-weight:700;padding:0 10px;min-width:160px;position:absolute;top:0;left:50%;text-align:center;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);-webkit-border-radius:0 0 12px 12px;-moz-border-radius:0 0 12px 12px;border-radius:0 0 12px 12px}.casino-card.normal-choice .card-sticky img{margin-right:12px;width:13px;margin-bottom:0}@media (min-width:576px){.casino-card.normal-choice .card-sticky{display:none}}.faq-holder{background-color:#080438;background-size:contain!important;padding:50px 0}.faq-holder h2{color:#fff;margin-bottom:25px}@media (min-width:768px){.faq-holder{background-size:cover!important}}@media (max-width:576px){.faq-holder{background-attachment:scroll!important;background-position:0!important;background-repeat:no-repeat!important;background-size:cover!important}}.ct-section-title{margin-top:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ct-section-title h2{font-weight:600;margin-bottom:0}.ct-section-title h2 img{width:18px;height:18px}.ct-section-title__m{margin-top:26px}.ct-section-link{position:relative;margin-top:3px;margin-right:13px;margin-left:auto;color:#3d29b1}.ct-section-link:hover .arrow{color:#222}.ct-online-casino{padding:30px 0}.ct-online-casino h1.widget-title{margin-bottom:10px}.ct-online-casino h1.widget-title br{display:inline-block}@media (min-width:420px){.ct-online-casino h1.widget-title br{display:none}}@media (min-width:768px){.ct-online-casino h1.widget-title{line-height:160%;margin-bottom:15px;font-size:32px}}@media (min-width:992px){.ct-online-casino h1.widget-title{font-size:32px}}.ct-online-casino .content p{margin-bottom:0}.ct-online-casino-games{padding:40px 0}.ct-bonus-banner{padding:30px 0}.review-top-menu{margin-bottom:30px;background:#f1f2f3}.review-top-menu ul{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow-x:auto;overflow-y:hidden;white-space:nowrap;border-bottom:1px solid #bbb;max-width:960px}.review-top-menu ul li{margin-right:30px;display:inline-block;padding:10px 0;position:relative;font-weight:400;font-size:16px;color:#9b9b9b;line-height:25px}.review-top-menu ul li,.review-top-menu ul li:after{-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s}.review-top-menu ul li:after{position:absolute;content:\"\";left:0;bottom:-5px;width:100%;height:3px;background:#e8321d}.review-top-menu ul li.active,.review-top-menu ul li:hover{color:#e8321d}.review-top-menu ul li.active:after,.review-top-menu ul li:hover:after{bottom:0}.review-top-menu ul li.active{font-weight:700}.terms_tc{text-decoration:underline;font-size:12px;line-height:160%;cursor:default}.cas-link{cursor:pointer}.custom-btn{background:var(--primary-btn)!important;border-color:var(--primary-btn)!important;box-shadow:inset 0 -4px 4px var(--primary-btn)!important}@media (min-width:992px){.custom-btn:hover{background:var(--primary-btn-hover)!important;border-color:var(--primary-btn-hover)!important;box-shadow:inset 0 -4px 4px var(--primary-btn-hover)!important}}.custom-btn-clr{background:transparent;border:2px solid #222!important;color:#222!important;box-shadow:none}@media (min-width:992px){.custom-btn-clr:hover{background:#222!important;color:#fff!important}}.custom-btn-sec{background:#f2f2f2;background:var(--primary-btn)!important;color:#373a3c}@media (min-width:992px){.custom-btn-sec:hover{background:var(--primary-btn)!important;color:#fff!important}}.custom-btn-game-mini{background:transparent;border:2px solid #222!important;color:#222!important;box-shadow:none}@media (min-width:992px){.custom-btn-game-mini:hover{background:#222!important;color:#fff!important}}.cta-overlay .back-btn{color:#fff!important;border-color:#fff!important}.cta-overlay .how-about,.cta-overlay .span{color:#fff!important}.cta-overlay .get-a{color:#fff}.text-gray,.text-gray a{color:#222!important}.text-white,.text-white a{color:#fff!important}.text-light,.text-light a{color:#e3e3e3!important}.text-nav{color:#222!important}.text-nav a{color:#9b9b9b!important}.text-cta-override,.text-cta-override a{color:var(--override-primary-btn-text-color)!important}.custom-background-image{background:var(--bg-image);background-color:var(--bg-color);background-size:300px 200px;background-attachment:fixed}.custom-background-color{background:#f1f2f3;margin:0 auto;max-width:1240px;position:relative}.cursor-link{cursor:default}.pt-20{padding-top:20px}.overflow-auto{overflow:auto}.py-15{padding-top:15px;padding-bottom:15px}.ct-related-article{overflow:auto}.main-tag{width:100%;height:100%;position:fixed;z-index:0}.wp-has-aspect-ratio{text-align:var(--align)}.alignleft{float:left;margin:0 20px 20px 0}.alignright{float:right;margin:0 0 20px 20px}.aligncenter{display:block;margin:0 auto}.fa,.far,.fas{font-family:Font Awesome\\ 5 Free!important}.fab{font-family:Font Awesome\\ 5 Brands!important}h1 img{max-height:39px}.casino-right{height:100%}.casino-right img{height:auto}img[lazy=loading]{height:100px;width:100px}.d-flex{display:flex}.accordion-row{overflow:auto}.accord-content{display:none;padding:0 20px 20px;background-color:#fff;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;border-top-left-radius:0;border-top-right-radius:0}.accord-content p{margin-bottom:0}.rotate{transform:rotate(180deg);transition:.3s;fill:#f1f2f3}.rotate2{transform:rotate(0deg);transition:.3s;fill:var(--rotate-color)}.accord-wrapper{margin-bottom:20px;box-shadow:0 4px 4px rgba(0,0,0,.25)}.accord-wrapper,.accord-wrapper .accord-header{background-color:#fff;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px}.accord-wrapper .accord-header{display:flex;justify-content:space-between;align-items:center;font-weight:700;font-size:24px;line-height:38px;padding:17px;margin-bottom:0;cursor:pointer}.accord-wrapper .accord-header img{max-width:100%;height:auto;-webkit-filter:grayscale(1) invert(1);filter:grayscale(1) invert(1)}.accord-wrapper .accord-header img.rotate2{-webkit-filter:grayscale(0) invert(0);filter:grayscale(0) invert(0)}.accord-wrapper .accord-header h3{margin-bottom:0;font-size:18px}@media (min-width:768px){.accord-wrapper .accord-header h3{font-size:22px}}@media (min-width:768px){.accord-wrapper .accord-header{padding:20px}}.cta{-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px;padding:10px 20px;display:inline-block;text-decoration:none;font-size:14px;font-weight:600;color:#fff;border:1px solid transparent;line-height:1;max-width:100%}.cta,.cta-block{text-align:center}.cta-block{display:block;max-width:inherit;width:100%}.cta-primary{background:#e8321d;color:#fff;border-color:#e8321d;box-shadow:inset 0 -4px 4px #d40d13;cursor:pointer;min-height:55px}.cta-primary:active,.cta-primary:hover{color:#fff}.cta-primary:not(.cta-outline){box-shadow:inset 0 -7px 0 rgba(0,0,0,.25)!important;border:0}.cta-secondary{background:transparent;color:#e8321d;border-color:#e8321d;min-height:55px}.cta-transparent{background:transparent;color:#fff}.cta-transparent:hover{background:#e8321d;color:#fff}.cta-promotion{margin:25px auto 0;max-width:100%;padding:17px 14px;font-size:18px;line-height:100%;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.cta-promotion img{display:inline-block;vertical-align:bottom;margin-right:5px}.cta-readmore{padding:7px;font-size:10px;width:70px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.cta-outline{background:transparent;border:2px solid #fff;color:#fff;box-shadow:none}.cta-yellow{background:#ffd039;border:0;box-shadow:inset 0 -4px 4px #ebb300;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;font-weight:700;font-size:18px;line-height:100%;color:#222;min-width:200px}.cta-yellow__lg{line-height:100%;min-width:270px}.cta-yellow:hover{background:#fff;color:#e8321d;box-shadow:none}.cta-large{max-width:380px;width:100%;font-size:18px;line-height:22px;font-family:var(--default-regular);cursor:pointer}.cta-lg-br{border-width:2px}.cta-gray{background-color:#f2f2f2;color:#222;border-color:#f2f2f2;box-shadow:none}.pt-26{padding-top:26px!important}.text-center{text-align:center}.mobile-scroll-container{padding:0 0 0 20px}@media (min-width:768px){.mobile-scroll-container{padding:0 15px}}.pu-faq-ct10-wrap a{text-decoration:none!important}.lazy-hidden{opacity:1!important}.cas-term{width:auto!important;cursor:default}.cas-term,.terms-conditions{text-decoration:none!important}.terms-conditions a{cursor:pointer;text-decoration:underline!important}.terms-conditions a:hover{color:var(--text-link-color)}.terms-condition a{cursor:pointer;text-decoration:underline!important}.terms-condition a:hover{color:var(--primary-btn)}.div-term span a:hover,.gm-terms span a:hover,.rev-terms-condition span a:hover,.terms-404 span a:hover,.terms-condition-exclu span a:hover,.terms-condition-latest span a:hover,.terms-condition-similar span a:hover,.trm-card span a:hover{color:var(--text-link-color)}.card-stroke{padding-top:5px}.ratio-16-9{position:relative;padding-top:56.25%;height:0;overflow:hidden}.ratio-16-9 iframe{width:100%;height:100%;position:absolute;top:0;left:0;display:block}.media-padding-right .wp-block-media-text__content{padding:0 0 0 8%!important}@media (max-width:600px){.media-padding-right .wp-block-media-text__content{padding:0!important}}.media-padding-left .wp-block-media-text__content{padding:0 8% 0 0!important}@media (max-width:600px){.media-padding-left .wp-block-media-text__content{padding:0!important}}.text-hover:hover,.text-hover:hover a,.text-hover:hover span{color:var(--hover-color)!important}.custom-btn-white{color:var(--primary-btn);background:#fff;border-color:var(--primary-btn);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:none}.sticky-inner{background:var(--primary-btn)}@media (min-width:992px){.sticky-inner{background:#fff}}.custom-hover-sec .left-arrow{fill:var(--secondary-color)}.custom-hover-sec:hover{background:var(--secondary-color)!important}.custom-hover-sec:hover .left-arrow{fill:#fff}.primary-background{background:var(--primary-color)}.breadcrumbs ul li .router-link-exact-active{color:var(--primary-btn)!important}.search-bg{background-color:var(--primary-search-bg)}#header{background-color:var(--primary-color)}.iframe-full .regulation-banner{display:none}.iframe-full .mobile-menu-close{background-color:transparent!important}.iframe-full .mobile-menu-open{background-color:var(--primary-color)!important}.iframe-full .menu-bars{fill:#fff}.iframe-full .ct-footer,.iframe-full .to-top{display:none}.no-scroll{height:100vh;overflow-y:hidden}.fade-enter-active,.fade-leave-active{transition:opacity .6s}.fade-enter,.fade-leave-to{opacity:0}.fixed-header{padding-top:70px}@media (min-width:992px){.fixed-header{padding-top:0}}section{background-color:#f1f2f3}.link-hover:hover{color:#232529!important;text-decoration:underline}.copyright-nt a,.copyright a{text-decoration:none!important}@media (min-width:576px){.wd-670{width:670px;margin:0 auto}}@media (max-width:576px){.pd-rt{padding:0!important}}.slick-slider ul li{padding-left:0!important}.slick-slider ul li:before{background:none!important}.hover-btn .hover-text{display:none}@media (min-width:992px){.hover-btn{position:relative}.hover-btn .hover-text{opacity:0;transition:.2s cubic-bezier(.5,-1,.5,2);transform:translateY(-20px);min-width:.3em;display:inline-block}.hover-btn .hover-text:nth-child(60){transition-delay:.42s}.hover-btn .hover-text:nth-child(59){transition-delay:.413s}.hover-btn .hover-text:nth-child(58){transition-delay:.406s}.hover-btn .hover-text:nth-child(57){transition-delay:.399s}.hover-btn .hover-text:nth-child(56){transition-delay:.392s}.hover-btn .hover-text:nth-child(55){transition-delay:.385s}.hover-btn .hover-text:nth-child(54){transition-delay:.378s}.hover-btn .hover-text:nth-child(53){transition-delay:.371s}.hover-btn .hover-text:nth-child(52){transition-delay:.364s}.hover-btn .hover-text:nth-child(51){transition-delay:.357s}.hover-btn .hover-text:nth-child(50){transition-delay:.35s}.hover-btn .hover-text:nth-child(49){transition-delay:.343s}.hover-btn .hover-text:nth-child(48){transition-delay:.336s}.hover-btn .hover-text:nth-child(47){transition-delay:.329s}.hover-btn .hover-text:nth-child(46){transition-delay:.322s}.hover-btn .hover-text:nth-child(45){transition-delay:.315s}.hover-btn .hover-text:nth-child(44){transition-delay:.308s}.hover-btn .hover-text:nth-child(43){transition-delay:.301s}.hover-btn .hover-text:nth-child(42){transition-delay:.294s}.hover-btn .hover-text:nth-child(41){transition-delay:.287s}.hover-btn .hover-text:nth-child(40){transition-delay:.28s}.hover-btn .hover-text:nth-child(39){transition-delay:.273s}.hover-btn .hover-text:nth-child(38){transition-delay:.266s}.hover-btn .hover-text:nth-child(37){transition-delay:.259s}.hover-btn .hover-text:nth-child(36){transition-delay:.252s}.hover-btn .hover-text:nth-child(35){transition-delay:.245s}.hover-btn .hover-text:nth-child(34){transition-delay:.238s}.hover-btn .hover-text:nth-child(33){transition-delay:.231s}.hover-btn .hover-text:nth-child(32){transition-delay:.224s}.hover-btn .hover-text:nth-child(31){transition-delay:.217s}.hover-btn .hover-text:nth-child(30){transition-delay:.21s}.hover-btn .hover-text:nth-child(29){transition-delay:.203s}.hover-btn .hover-text:nth-child(28){transition-delay:.196s}.hover-btn .hover-text:nth-child(27){transition-delay:.189s}.hover-btn .hover-text:nth-child(26){transition-delay:.182s}.hover-btn .hover-text:nth-child(25){transition-delay:.175s}.hover-btn .hover-text:nth-child(24){transition-delay:.168s}.hover-btn .hover-text:nth-child(23){transition-delay:.161s}.hover-btn .hover-text:nth-child(22){transition-delay:.154s}.hover-btn .hover-text:nth-child(21){transition-delay:.147s}.hover-btn .hover-text:nth-child(20){transition-delay:.14s}.hover-btn .hover-text:nth-child(19){transition-delay:.133s}.hover-btn .hover-text:nth-child(18){transition-delay:.126s}.hover-btn .hover-text:nth-child(17){transition-delay:.119s}.hover-btn .hover-text:nth-child(16){transition-delay:.112s}.hover-btn .hover-text:nth-child(15){transition-delay:.105s}.hover-btn .hover-text:nth-child(14){transition-delay:98ms}.hover-btn .hover-text:nth-child(13){transition-delay:91ms}.hover-btn .hover-text:nth-child(12){transition-delay:84ms}.hover-btn .hover-text:nth-child(11){transition-delay:77ms}.hover-btn .hover-text:nth-child(10){transition-delay:.07s}.hover-btn .hover-text:nth-child(9){transition-delay:63ms}.hover-btn .hover-text:nth-child(8){transition-delay:56ms}.hover-btn .hover-text:nth-child(7){transition-delay:49ms}.hover-btn .hover-text:nth-child(6){transition-delay:42ms}.hover-btn .hover-text:nth-child(5){transition-delay:35ms}.hover-btn .hover-text:nth-child(4){transition-delay:28ms}.hover-btn .hover-text:nth-child(3){transition-delay:21ms}.hover-btn .hover-text:nth-child(2){transition-delay:14ms}.hover-btn .hover-text:first-child{transition-delay:7ms}.hover-btn .cta-text{position:absolute;left:50%;top:50%;transition:.2s cubic-bezier(.5,-1,.5,2);transform:translate(-50%,-50%);width:100%}.hover-btn:hover .cta-text{opacity:0;transform:translate(-50%,20px)}.hover-btn:hover .hover-text{opacity:1;transform:translate(0)}}.game-btn{color:#fff!important}.partner-logo .partner-hover{display:none}@media (min-width:992px){.partner-logo{position:relative!important;display:inline-flex!important;top:0!important;justify-content:center!important}.partner-logo .partner-hover{display:none}.partner-logo:hover .partner-hover{display:flex;position:absolute;justify-content:center;align-items:center;background:rgba(0,0,0,.6);border-radius:12px;animation:fadeIn ease .3s;top:0;left:0}.partner-logo:hover .partner-hover-inner{width:35px;height:35px;background:var(--primary-btn);border-radius:50%;display:flex;justify-content:center;align-items:center}.partner-logo:hover .wd-excl{width:100%;height:100%}.partner-logo:hover .wd-latest{width:90px;height:90px}.partner-logo:hover .wd-sim{width:50px;height:50px;border-radius:5px}.partner-logo:hover .wd-topfull{width:162px;height:162px;border-radius:50%}.partner-logo:hover .wd-casitem{width:100%;height:100%;border-radius:4px}.partner-logo:hover .wd-castop{width:90px;height:90px;border-radius:10px}.partner-logo:hover .wd-rev-stic{width:85px;height:85px}.partner-logo:hover .wd-rev-bann{width:100%;height:100%}.partner-logo:hover .wd-rev-end{width:100%;height:100%;border-radius:12px 0 0 12px}.partner-logo:hover .wd-gam-bann{width:100%;height:100%;border-radius:10px}.partner-logo:hover .wd-gam-stick{width:65px;height:65px}.partner-logo:hover .wd-gam-ifrm{width:100%;height:100%;border-radius:10px;left:0}.partner-logo:hover .wd-gam-cas{width:100%;height:100%;border-radius:8px}.partner-logo:hover .wd-recm{width:100%;height:100%}.partner-logo:hover .wd-pay-bann,.partner-logo:hover .wd-soft-bann{width:90px;height:90px}.partner-logo:hover .wd-promo{width:100%;height:100%;border-radius:5px}.partner-logo:hover .wd-notsup{width:57px;height:57px}.partner-logo:hover .wd-homebanner{width:60px;height:60px;border-radius:5px}}.partner-logo-castop .partner-hover{display:none}@media (min-width:992px){.partner-logo-castop{position:relative!important;display:inline-flex!important;top:0!important;justify-content:center!important}.partner-logo-castop .partner-hover{display:none}.partner-logo-castop:hover .partner-hover{display:flex;position:absolute;justify-content:center;align-items:center;background:rgba(0,0,0,.6);width:90px;height:90px;border-radius:10px;animation:fadeIn ease .3s;left:0}.partner-logo-castop:hover .partner-hover-inner{width:35px;height:35px;background:var(--primary-btn);border-radius:50%;display:flex;justify-content:center;align-items:center}}.checkbox-label-error:before{border:2px solid var(--primary-btn)}.checkbox-label-selected:before{background-color:var(--primary-btn)}.checkbox-error{background:var(--primary-btn)}.arrow-up{border-bottom:10px solid var(--primary-btn)}.arrow-down{border-top:10px solid var(--primary-btn)}.email-error{background:var(--primary-btn)}.email-error-input{border:1.4px solid var(--primary-btn)!important;color:var(--primary-btn)}.email-error-wrapper svg{fill:var(--primary-btn)!important}.name-error{background:var(--primary-btn)}.name-error-input{border:1.4px solid var(--primary-btn)!important;color:var(--primary-btn)}.name-error-wrapper svg{fill:var(--primary-btn)!important}.msg-error{background:var(--primary-btn)}.msg-error-input{border:1.4px solid var(--primary-btn)!important;color:var(--primary-btn)}.msg-error-wrapper svg{fill:var(--primary-btn)!important}.submission-spinner{text-align:center}.submission-spinner svg{fill:var(--primary-btn)}.selection-list-box a{color:var(--text-link-color)}@media (min-width:768px){.selection-list-box:hover{background-color:var(--primary-btn)!important}}@media (max-width:576px){.rm-m-20{margin:0 -20px}}.span-no-text{color:var(--primary-color)}.wd-auto{width:auto!important}td h5{color:#fff}.con-ht{display:block}.con-ht ul li{position:relative;font-weight:400;font-size:14px;line-height:26px;color:#222;margin-bottom:10px;padding-left:35px}@media (min-width:576px){.con-ht ul li{font-size:16px}}.con-ht ul li:last-child{margin-bottom:0}.con-ht ul li:after{position:absolute;content:\"\";left:0;height:26px;width:26px;min-width:26px;top:0;background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:14px;margin-right:10px}.con-ht p{font-size:14px}@media (min-width:576px){.con-ht p{font-size:16px}}.con-ht a{text-decoration:underline;font-size:14px}@media (min-width:576px){.con-ht a{font-size:16px}}.core-btn a{color:#fff!important;text-decoration:none!important}.core-btn a:hover{text-decoration:underline!important}.free-spin-card .bg-holder:after{background:linear-gradient(179.52deg,var(--primary-btn) -1.05%,rgba(254,70,70,0) 99.58%)}.core-text-white h1,.core-text-white h2,.core-text-white h3,.core-text-white h4,.core-text-white h5,.core-text-white h6{color:#fff!important}.core-text-gray h1,.core-text-gray h2,.core-text-gray h3,.core-text-gray h4,.core-text-gray h5,.core-text-gray h6{color:#222!important}input[type=search]::-webkit-input-placeholder{line-height:20px}.user-dot-class{position:static;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:26px}@media (min-width:576px){.user-dot-class{margin-top:75px}}.user-dot-class li{width:14px;height:14px;margin:0 6px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:3px solid transparent;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%}.user-dot-class li,.user-dot-class li button{-webkit-transition:all .5s;-moz-transition:all .5s;-ms-transition:all .5s;-o-transition:all .5s;transition:all .5s}.user-dot-class li button{width:8px;height:8px;background:#0165f7;border:1px solid #0165f7;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;padding:0;opacity:1}.user-dot-class li.slick-active{border-color:#0165f7}.user-dot-class li.slick-active button{width:8px;height:8px;background:transparent;border-color:transparent}.user-testimonials .slick-slider .slick-list .slick-slide{margin:0 2px}@media (min-width:576px){.user-testimonials .slick-slider .slick-list .slick-slide{margin:0 12px}}@media (max-width:576px){.v-hl-container{margin:0 15px!important}}img[lazy=loading]{object-fit:contain}.mob-terms .terms-conditions{color:#fff}.mob-terms .terms-conditions a{color:#fff!important;text-decoration:underline!important}.custom-yt{margin-bottom:20px}.custom-yt-left{display:flex;justify-content:flex-start}.custom-yt-center{display:flex;justify-content:center}.custom-yt-right{display:flex;justify-content:flex-end}.online-gambling-blue-content ul,.online-gambling-green-content ul,.online-gambling-red-content ul{margin-bottom:16px!important}.generic-comparision-table{overflow:auto;border:0;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;border-collapse:inherit;margin-bottom:0;border:1px solid #bdbdbe;border-top:0;border-bottom:0;border-radius:10px 10px 0 0}@media (min-width:576px){.generic-comparision-table{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;border:0;overflow:visible;margin-bottom:25px;border-top:10px;border-bottom:10px;border-radius:10px}}.generic-comparision-table.remove-border{border-bottom:1px solid #bdbdbe!important;border-radius:10px!important}@media (min-width:576px){.generic-comparision-table.remove-border{border:0!important}}.generic-comparision-table table{width:100%;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;overflow:hidden;border-collapse:inherit}@media (min-width:768px){.generic-comparision-table table{-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;border:1px solid #bdbdbe}}.generic-comparision-table table thead{background:#3d5b70}.generic-comparision-table table th{padding:16px;font-family:Helvetica;font-weight:700;font-size:16px;line-height:26px;color:#fff;border:0;text-align:center;min-width:120px}@media (min-width:576px){.generic-comparision-table table th{min-width:auto}}@media (min-width:768px){.generic-comparision-table table th{text-align:left}}.generic-comparision-table table th:first-child{-webkit-border-radius:10px 0 0 0;-moz-border-radius:10px 0 0 0;border-radius:10px 0 0 0;padding-left:16px}@media (min-width:768px){.generic-comparision-table table th:first-child{padding-left:20px}}.generic-comparision-table table th:last-child{-webkit-border-radius:0 10px 0 0;-moz-border-radius:0 10px 0 0;border-radius:0 10px 0 0}.generic-comparision-table table tbody tr:nth-child(2n) td{background:#fff}.generic-comparision-table table tbody tr.even td{background:#fff!important}.generic-comparision-table table tbody tr.odd td{background:#f1f2f3!important}.generic-comparision-table table tbody tr:last-child td:first-child{-webkit-border-radius:0 0 0 10px;-moz-border-radius:0 0 0 10px;border-radius:0 0 0 10px}.generic-comparision-table table tbody tr:last-child td:last-child{-webkit-border-radius:0 0 10px 0;-moz-border-radius:0 0 10px 0;border-radius:0 0 10px 0}.generic-comparision-table table tbody tr td .tbl-clm-wrap a{color:var(--text-link-color);cursor:pointer;text-decoration:underline}.generic-comparision-table table tbody tr.show-tbl-cls{display:table-row}.generic-comparision-table table tbody tr.hide-tbl-cls{display:none}.generic-comparision-table table tbody tr.show-more-wrap{display:none;cursor:pointer}@media (min-width:768px){.generic-comparision-table table tbody tr.show-more-wrap{display:table-row}}.generic-comparision-table table tbody tr.show-more-wrap td a{font-weight:700;color:var(--text-link-color)}@media (min-width:768px){.generic-comparision-table table tbody tr.show-more-wrap td a{color:#222}}.generic-comparision-table table tbody tr.show-more-wrap td svg path{fill:#0084ff}@media (min-width:768px){.generic-comparision-table table tbody tr.show-more-wrap td svg path{fill:#222}}.generic-comparision-table table tbody tr.show-more-wrap td:hover a{color:var(--text-link-color)}.generic-comparision-table table tbody tr.show-more-wrap td:hover svg path{fill:var(--text-link-color)}.generic-comparision-table table tbody tr.show-less-wrap{display:none;cursor:pointer}.generic-comparision-table table tbody tr.show-less-wrap td a{font-weight:700;color:var(--text-link-color)}@media (min-width:768px){.generic-comparision-table table tbody tr.show-less-wrap td a{color:#222}}.generic-comparision-table table tbody tr.show-less-wrap td svg{transform:rotate(180deg);position:relative;top:-1px}.generic-comparision-table table tbody tr.show-less-wrap td svg path{fill:#0084ff}@media (min-width:768px){.generic-comparision-table table tbody tr.show-less-wrap td svg path{fill:#222}}.generic-comparision-table table tbody tr.show-less-wrap td:hover a{color:var(--text-link-color)}.generic-comparision-table table tbody tr.show-less-wrap td:hover svg path{fill:var(--text-link-color)}.generic-comparision-table table tbody tr.show-data{display:table-row!important}.generic-comparision-table table tbody tr.hide-data{display:none!important}.generic-comparision-table table td{padding:16px 8px;border:0;border-top:1px solid #bdbdbe;border-right:1px solid #bdbdbe;font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;vertical-align:middle;background:#f1f2f3;text-align:center;min-width:120px}@media (min-width:576px){.generic-comparision-table table td{min-width:auto}}@media (min-width:768px){.generic-comparision-table table td{text-align:left;padding:16px}}@media (max-width:576px){.generic-comparision-table table td{text-align:center!important}}.generic-comparision-table table td:first-child{text-align:center}.generic-comparision-table table td:last-child{border-right:0}.generic-comparision-table table td p{margin-bottom:0;font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;display:block;flex-wrap:wrap}@media (max-width:576px){.generic-comparision-table table td p{flex-wrap:wrap;justify-content:center;text-align:center}}.generic-comparision-table table td .tbl-clm-wrap img{width:100px;height:100px;max-height:100px;max-width:100px;object-fit:contain;margin-bottom:0}.generic-comparision-table table td .tbl-clm-wrap .tbl-clm-text{display:block;margin-top:20px}@media (max-width:576px){.generic-comparision-table table td i{margin:0 7px}}.generic-comparision-table table td ol{list-style:none;counter-reset:li}.generic-comparision-table table td ol li{counter-increment:li;font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;position:relative;padding-left:0;padding-top:34px;margin-bottom:10px}.generic-comparision-table table td ol li:last-child{margin-bottom:0}@media (min-width:768px){.generic-comparision-table table td ol li{padding-left:34px;padding-top:0}}.generic-comparision-table table td ol li:before{position:absolute;content:counter(li);left:0;top:0;right:0;margin:auto;width:26px;height:26px;-webkit-border-radius:50px;-moz-border-radius:50px;border-radius:50px;background:#0084ff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff}@media (min-width:768px){.generic-comparision-table table td ol li:before{right:auto}}.generic-comparision-table table td ul li{padding-left:0;padding-top:34px;font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;position:relative;margin-bottom:10px}.generic-comparision-table table td ul li:last-child{margin-bottom:0}@media (min-width:768px){.generic-comparision-table table td ul li{padding-left:34px;padding-top:0}}.generic-comparision-table table td ul li:before{position:absolute;content:\"\";left:0;top:0;right:0;width:26px;height:26px;margin:auto;-webkit-border-radius:50px;-moz-border-radius:50px;border-radius:50px;background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat 50%;background-size:14px 10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (min-width:768px){.generic-comparision-table table td ul li:before{right:auto}}.generic-comparision-table .wpvcb-table-page-link{display:block;margin-top:10px;text-decoration:underline}.generic-comparision-table .wpvcb-table-page-link img{margin-bottom:2px;margin-left:5px}.mobile-show-hide-btn{display:block;width:100%;text-align:center;border-radius:0 0 10px 10px;border:1px solid #bdbdbe;margin-bottom:20px}@media (min-width:768px){.mobile-show-hide-btn{display:none}}.mobile-show-hide-btn .show-more-wrap-mobile{display:block;cursor:pointer;padding:15px;border-radius:0 0 10px 10px;font-weight:700}@media (min-width:768px){.mobile-show-hide-btn .show-more-wrap-mobile{display:none}}.mobile-show-hide-btn .show-more-wrap-mobile a{color:var(--text-link-color)!important}.mobile-show-hide-btn .show-more-wrap-mobile svg{margin-left:3px}.mobile-show-hide-btn .show-more-wrap-mobile svg path{fill:var(--text-link-color)!important}.mobile-show-hide-btn .show-more-wrap-mobile.show-data{display:block!important}.mobile-show-hide-btn .show-more-wrap-mobile.hide-data{display:none!important}.mobile-show-hide-btn .show-less-wrap-mobile{display:none;cursor:pointer;font-weight:700;padding:15px;border-radius:0 0 10px 10px}.mobile-show-hide-btn .show-less-wrap-mobile a{color:var(--text-link-color)!important}.mobile-show-hide-btn .show-less-wrap-mobile svg{transform:rotate(180deg);position:relative;top:-1px;margin-left:3px}.mobile-show-hide-btn .show-less-wrap-mobile svg path{fill:var(--text-link-color)!important}.mobile-show-hide-btn .show-less-wrap-mobile.show-data{display:block!important}.mobile-show-hide-btn .show-less-wrap-mobile.hide-data{display:none!important}.even{background:#fff!important}.odd{background:#f1f2f3!important}.intro-content p{margin-bottom:0}.hide-header{display:none}.custm-text a,.custm-text ol li a,.custm-text p a,.custm-text ul li a{text-decoration:underline;cursor:pointer}.custm-text a,.custm-text a:hover{color:var(--text-link-color)}.cont-title h1,.cont-title h2,.cont-title h3,.cont-title h4,.cont-title h5,.cont-title h6,.cont-title span{margin-bottom:0}.banner-content p,.recomended-card-cont .casino-block .cas-title-bonus .cas-bonus{color:var(--des-color)}#app{background:#f1f2f3}.to-top{visibility:hidden;opacity:.7;width:55px;height:55px;display:block;position:fixed;bottom:20px;right:30px;z-index:99;cursor:pointer}.scrolling .to-top{visibility:visible}.ct-inner-banner{position:relative;z-index:5}.background-logo{position:fixed;visibility:hidden;transition:top .1s ease-in-out}.background-logo.left-side{left:0;text-align:right;padding-right:5px}.background-logo.right-side{right:0;text-align:left;padding-left:5px}.background-logo-large{top:0;height:100vh;z-index:4}.background-logo-small{z-index:25}@media (max-width:1270px){.background-logo-large{display:none}}@media (max-width:1600px){.background-logo-small{display:none}}footer{position:relative;z-index:5}", ""]);

// exports


/***/ }),
/* 476 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e96b151e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(708);
function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e96b151e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e96b151e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(479);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3af0a936", content, true, {});

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-e96b151e]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-e96b151e]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-e96b151e]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-e96b151e]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-e96b151e]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-e96b151e]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-e96b151e]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-e96b151e]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-e96b151e]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-e96b151e]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-e96b151e]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-e96b151e]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.search-wrapper[data-v-e96b151e]{display:flex!important;background-color:var(--primary-color)}.search-wrapper span[data-v-e96b151e]{flex:1}#header-content[data-v-e96b151e],#header[data-v-e96b151e]{background-color:var(--primary-color)}#header-content[data-v-e96b151e]{display:none}@media (min-width:992px){#header-content[data-v-e96b151e]{display:block}}.regulation-banner[data-v-e96b151e]{display:block;position:relative;overflow:hidden;z-index:9;padding:10px 0;background:#fcfcfc;-webkit-transition:all .6s ease-in-out;-o-transition:all .6s ease-in-out;transition:all .6s ease-in-out}.regulation-banner-row[data-v-e96b151e]{height:100%;display:flex}@media (max-width:576px){.regulation-banner-row[data-v-e96b151e]{flex-wrap:wrap}}.regulation-banner-text[data-v-e96b151e]{font-size:12px;line-height:20px;margin-bottom:6px;display:none}@media (min-width:576px){.regulation-banner-text[data-v-e96b151e]{flex:1;margin-bottom:0}}@media (min-width:992px){.regulation-banner-text[data-v-e96b151e]{display:block}}.regulation-banner .icons-column[data-v-e96b151e]{flex:1;display:flex;justify-content:space-around;max-height:40px}@media (min-width:992px){.regulation-banner .icons-column[data-v-e96b151e]{justify-content:flex-end}}.regulation-banner .icons-column a>img[data-v-e96b151e],.regulation-banner .icons-column img[data-v-e96b151e]{height:32px;max-width:100%}.desk-reg[data-v-e96b151e]{display:none}@media (min-width:576px){.desk-reg[data-v-e96b151e]{display:block}}.mob-reg[data-v-e96b151e]{display:block;width:100%}@media (min-width:576px){.mob-reg[data-v-e96b151e]{display:none}}header[data-v-e96b151e]{position:relative;width:100%;background:#080438;padding:10px 0;min-height:60px;z-index:9}@media (min-width:1024px){header[data-v-e96b151e]{padding:0;min-height:auto}}.logo[data-v-e96b151e]{position:relative;z-index:123;padding:15px;padding-left:0;font:18px verdana;color:#6ddb07;float:none;width:100%;text-align:center;cursor:pointer;padding:0}.logo a[data-v-e96b151e]{color:#6ddb07;display:inline-block}@media (min-width:1024px){.logo[data-v-e96b151e]{padding:4px 23px 4px 0;padding-left:0}}.cssmenu[data-v-e96b151e]{z-index:100;background:inherit;font-family:var(--default-regular)}.cssmenu[data-v-e96b151e],.cssmenu ul[data-v-e96b151e]{border:0;list-style:none;line-height:1;display:block;position:relative;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.cssmenu ul[data-v-e96b151e]{float:right}.cssmenu ul li[data-v-e96b151e],.cssmenu ul li a[data-v-e96b151e]{border:0;list-style:none;line-height:1;display:block;position:relative;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.cssmenu ul li a[data-v-e96b151e]{font-family:var(--default-regular);font-weight:400}.cssmenu ul li a input[data-v-e96b151e]{font-family:var(--default-regular);position:relative;width:100%;border-radius:10px!important;padding:4px;text-indent:26px;display:inline-block;border:none}.cssmenu ul li a input[data-v-e96b151e]:focus,.cssmenu ul li a input[data-v-e96b151e]:hover{border-radius:10px!important}@media (min-width:1024px){.cssmenu ul li a input[data-v-e96b151e]{width:87px}}.cssmenu ul li span[data-v-e96b151e]{border:0;list-style:none;line-height:1;display:block;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;font-family:var(--default-regular);font-weight:400;position:relative}.cssmenu ul li span input[data-v-e96b151e]{font-family:var(--default-regular);position:relative;width:100%;border-radius:10px!important;padding:4px;text-indent:26px;display:inline-block;border:none}.cssmenu ul li span input[data-v-e96b151e]:focus,.cssmenu ul li span input[data-v-e96b151e]:hover{border-radius:10px!important}@media (min-width:1024px){.cssmenu ul li span input[data-v-e96b151e]{width:87px}}.cssmenu ul li.active[data-v-e96b151e]{-webkit-transition:background .3s ease;-ms-transition:background .3s ease;transition:background .3s ease}.cssmenu ul li.active a[data-v-e96b151e]{color:#fff;opacity:1}.cssmenu ul li.active[data-v-e96b151e]:hover,.cssmenu ul li.has-sub.active[data-v-e96b151e]{-webkit-transition:background .3s ease;-ms-transition:background .3s ease;transition:background .3s ease}.cssmenu ul ul[data-v-e96b151e]{position:absolute;left:-9999px}.cssmenu ul ul li[data-v-e96b151e]{height:0;-webkit-transition:all .25s ease;-ms-transition:all .25s ease;background:#333;transition:all .25s ease}.cssmenu ul ul li a[data-v-e96b151e]{border-bottom:1px solid hsla(0,0%,59%,.15);padding:11px 15px;width:170px;font-size:12px;text-decoration:none;color:#ddd;font-weight:400}.cssmenu ul ul li a[data-v-e96b151e]:hover{color:#fff}.cssmenu ul ul li:last-child>a[data-v-e96b151e]{border-bottom:0}.cssmenu ul ul li:hover>a[data-v-e96b151e]{color:#fff}.cssmenu ul ul li span[data-v-e96b151e]{border-bottom:1px solid hsla(0,0%,59%,.15);padding:11px 15px;width:170px;font-size:12px;text-decoration:none;color:#ddd;font-weight:400}.cssmenu ul ul li span[data-v-e96b151e]:hover{color:#fff}.cssmenu ul ul li:last-child>span[data-v-e96b151e]{border-bottom:0}.cssmenu ul ul li:hover>span[data-v-e96b151e]{color:#fff}.cssmenu ul ul ul[data-v-e96b151e]{margin-left:100%;top:0}.cssmenu ul ul ul li.active a[data-v-e96b151e]{border-left:1px solid #222}.cssmenu ul ul li.last-item>a[data-v-e96b151e]{border-bottom:0}.cssmenu ul ul li.has-sub[data-v-e96b151e]:hover{background:#363636}.cssmenu ul ul>li.has-sub:hover>a[data-v-e96b151e]:before{top:17px;height:0}.cssmenu #head-mobile[data-v-e96b151e]{border:0;list-style:none;line-height:1;display:block;position:relative;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:none}.cssmenu>ul[data-v-e96b151e]:after,.cssmenu[data-v-e96b151e]:after{content:\".\";display:block;clear:both;visibility:hidden;line-height:0;height:0}.cssmenu>ul>li[data-v-e96b151e]{float:left}.cssmenu>ul>li:last-child a[data-v-e96b151e]{position:relative;margin-top:15px;margin-left:20px;line-height:1.2}@media (min-width:1024px){.cssmenu>ul>li:last-child a[data-v-e96b151e]{margin-left:10px}}@media (min-width:1200px){.cssmenu>ul>li:last-child a[data-v-e96b151e]{margin-left:60px}}@media (min-width:1280px){.cssmenu>ul>li:last-child a[data-v-e96b151e]{margin-left:80px}}.cssmenu>ul>li:last-child a[data-v-e96b151e]:hover{border-radius:10px!important}.cssmenu>ul>li:last-child a[data-v-e96b151e]:before{position:absolute;left:7px;content:\"\";top:7px;background:var(--search-icon) no-repeat;width:12px;height:12px;z-index:1}.cssmenu>ul>li:last-child span[data-v-e96b151e]{position:relative;margin-top:15px;margin-left:20px;line-height:1.2}@media (min-width:1024px){.cssmenu>ul>li:last-child span[data-v-e96b151e]{margin-left:10px}}@media (min-width:1200px){.cssmenu>ul>li:last-child span[data-v-e96b151e]{margin-left:60px}}@media (min-width:1280px){.cssmenu>ul>li:last-child span[data-v-e96b151e]{margin-left:50px}}.cssmenu>ul>li:last-child span[data-v-e96b151e]:hover{border-radius:10px!important}.cssmenu>ul>li>a[data-v-e96b151e]{margin:20px;font-size:15px;letter-spacing:0;text-decoration:none;opacity:.7;color:#fff;font-family:var(--default-regular);font-weight:300}@media (min-width:1024px){.cssmenu>ul>li>a[data-v-e96b151e]{margin:30px 10px;font-size:14px}}@media (min-width:1200px){.cssmenu>ul>li>a[data-v-e96b151e]{margin:30px 20px;font-size:15px}}.cssmenu>ul>li>a[data-v-e96b151e]:last-child{background-color:transparent;border:none;border-radius:10px;opacity:1;display:flex}@media (min-width:1024px){.cssmenu>ul>li>a[data-v-e96b151e]:last-child{margin-right:0;display:block}}.cssmenu>ul>li>a[data-v-e96b151e]:last-child:hover{border-radius:10px}.cssmenu>ul>li>a img[data-v-e96b151e]{display:inline-block;max-width:100%;height:auto;vertical-align:bottom;margin-right:10px}@media (min-width:1024px){.cssmenu>ul>li>a img[data-v-e96b151e]{margin-right:5px}}@media (min-width:1200px){.cssmenu>ul>li>a img[data-v-e96b151e]{margin-right:10px}}.cssmenu>ul>li:hover>a[data-v-e96b151e]{color:#fff;opacity:1}.cssmenu>ul>li:hover img[data-v-e96b151e]{color:#fff}.cssmenu>ul>li.has-sub>a[data-v-e96b151e]{padding-right:30px}.cssmenu>ul>li.has-sub>a[data-v-e96b151e]:after{position:absolute;top:22px;right:11px;width:8px;height:2px;display:block;background:#ddd;content:\"\"}.cssmenu>ul>li.has-sub>a[data-v-e96b151e]:before{position:absolute;top:19px;right:14px;display:block;width:2px;height:8px;background:#ddd;content:\"\";-webkit-transition:all .25s ease;-ms-transition:all .25s ease;transition:all .25s ease}.cssmenu>ul>li.has-sub:hover>a[data-v-e96b151e]:before{top:23px;height:0}.cssmenu>ul>li.has-sub>ul>li.active>a[data-v-e96b151e],.cssmenu>ul ul>li.has-sub>ul>li.active>a[data-v-e96b151e]{border-top:1px solid #333}.cssmenu li:hover>ul[data-v-e96b151e]{left:auto}.cssmenu li:hover>ul>li[data-v-e96b151e]{height:35px}@media (min-width:992px){.logo[data-v-e96b151e]{float:left;width:14%}}input[type=search][data-v-e96b151e]::-webkit-input-placeholder{line-height:20px}[data-v-e96b151e]::-webkit-input-placeholder{font-size:12px;font-style:normal;font-family:var(--default-regular);position:absolute;top:3px}[data-v-e96b151e]::-moz-placeholder{font-size:12px;font-style:normal;font-family:var(--default-regular);position:absolute;top:3px}[data-v-e96b151e]:-ms-input-placeholder{font-size:12px;font-style:normal;font-family:var(--default-regular);position:absolute;top:3px}[data-v-e96b151e]:-moz-placeholder{font-size:12px;font-style:normal;font-family:var(--default-regular);position:absolute;top:3px}.cssmenu ul[data-v-e96b151e]{left:-20px;right:-20px}@media (min-width:1024px){.cssmenu ul[data-v-e96b151e]{left:-15px;right:-15px}}.icon-wrap[data-v-e96b151e]{margin-left:10px;display:inline-flex;align-items:center}.sticky-header[data-v-e96b151e]{position:fixed;display:none;z-index:999990}.sticky-header .logo[data-v-e96b151e]{padding:11px 23px 11px 0}.sticky-header .search-wrapper span[data-v-e96b151e]{margin:19px 0 17px 10px!important}@media (min-width:1200px){.sticky-header .search-wrapper span[data-v-e96b151e]{margin:19px 0 17px 50px!important}}.regulation-banner-sticky[data-v-e96b151e]{position:fixed;display:none;z-index:999990}.mob-fixed[data-v-e96b151e]{position:fixed;top:0;width:100%;z-index:9999}@media (min-width:992px){.mob-fixed[data-v-e96b151e]{position:relative}}.src-icon[data-v-e96b151e]{position:absolute;left:8px;z-index:10;top:8px}.logo .log-img[data-v-e96b151e],.logo .log-img img[data-v-e96b151e]{width:130px;height:52px}.carnival-banner[data-v-e96b151e]{height:45px;line-height:15px;display:flex;justify-content:center;align-items:center;background-position:50%!important;position:relative;z-index:7}.carnival-banner .first-text[data-v-e96b151e]{display:block;font-size:18px;color:#fff}@media (max-width:576px){.carnival-banner .first-text[data-v-e96b151e]{padding:10px}}.carnival-banner .sec-text[data-v-e96b151e]{display:block;font-size:18px}.sticky-regulation-banner[data-v-e96b151e]{left:0;right:0;z-index:1000;position:fixed}@media (min-width:992px){.d-md-none[data-v-e96b151e]{display:none}}", ""]);

// exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(481);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("75b3405d", content, true, {});

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-57ce095a]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-57ce095a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-57ce095a]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-57ce095a]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-57ce095a]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-57ce095a]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-57ce095a]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-57ce095a]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-57ce095a]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-57ce095a]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-57ce095a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-57ce095a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.header-arrow[data-v-57ce095a]{margin-left:auto}@media (min-width:992px){.header-arrow[data-v-57ce095a]{display:none}}.nav-link[data-v-57ce095a]{margin:21px 0;padding:0 5px;font-size:15px;display:inline-flex;background-color:transparent;border:none;border-radius:10px;opacity:1;color:#fff;font-family:var(--default-regular);font-weight:300}@media (min-width:1200px){.nav-link[data-v-57ce095a]{padding:0 10px}}.nav-link span[data-v-57ce095a]{line-height:18px}span[data-v-57ce095a]{color:#fff}img[data-v-57ce095a]{display:inline-block;max-width:100%;height:auto;vertical-align:bottom;margin-right:10px}@media (min-width:1024px){img[data-v-57ce095a]{margin-right:5px}}@media (min-width:1200px){img[data-v-57ce095a]{margin-right:10px}}.child-menu[data-v-57ce095a]{visibility:hidden;opacity:0;position:absolute;width:100%;z-index:1;right:105%;left:0!important;top:100%;padding:10px 0;min-width:max-content;height:inherit;box-sizing:border-box;box-shadow:0 4px 30px rgba(0,0,0,.2);margin:0;background-color:#fff;transition:.5s}.child-menu li[data-v-57ce095a]{background-color:#fff!important;padding-bottom:28px}.child-menu li a[data-v-57ce095a]{color:#222!important;padding:0!important;border-bottom:none!important;margin:0}.child-menu li[data-v-57ce095a]:first-child{padding-top:16px}.child-menu li[data-v-57ce095a]:last-child{padding-bottom:16px}.nav-list[data-v-57ce095a]{display:flex!important;background:var(--primary-bg);max-width:unset;overflow-wrap:normal}@media (min-width:1024px){.nav-list[data-v-57ce095a]{max-width:135px;overflow-wrap:break-word}}@media (min-width:1200px){.nav-list[data-v-57ce095a]{max-width:unset;overflow-wrap:normal}}.nav-list[data-v-57ce095a]:hover{background:hsla(0,0%,100%,.3)}.nav-list:hover .child-menu[data-v-57ce095a]{visibility:visible;opacity:1}.grayscale-invert-dark[data-v-57ce095a],.grayscale-invert[data-v-57ce095a]{filter:grayscale(1) invert(1);-webkit-filter:grayscale(1) invert(1)}.grayscale-invert-dark[data-v-57ce095a]{max-height:17px;max-width:17px;display:inline-block;height:auto;vertical-align:bottom;margin-right:10px;-ms-filter:grayscale(1) invert(1)}.grayscale-invert-dark svg>path[data-v-57ce095a]{fill:#222!important}@media (min-width:1024px){.grayscale-invert-dark[data-v-57ce095a]{margin-right:5px}}@media (min-width:1200px){.grayscale-invert-dark[data-v-57ce095a]{margin-right:10px}}.grayscale-invert-light[data-v-57ce095a]{max-height:17px;max-width:17px;display:inline-block;height:auto;vertical-align:bottom;margin-right:10px}.grayscale-invert-light svg>path[data-v-57ce095a]{fill:#fff}@media (min-width:1024px){.grayscale-invert-light[data-v-57ce095a]{margin-right:5px}}@media (min-width:1200px){.grayscale-invert-light[data-v-57ce095a]{margin-right:10px}}.span-text[data-v-57ce095a]{line-height:18px}.sticky-header .cssmenu>ul>li>a.nav-link[data-v-57ce095a]{margin:24px 0}", ""]);

// exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(483);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("698e9070", content, true, {});

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-2eed0880]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-2eed0880]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-2eed0880]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-2eed0880]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-2eed0880]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-2eed0880]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-2eed0880]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-2eed0880]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-2eed0880]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-2eed0880]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-2eed0880]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-2eed0880]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.arrow-left[data-v-2eed0880]{float:right;padding-left:4px}.child-menu[data-v-2eed0880]{visibility:hidden;opacity:0;position:absolute;width:100%;z-index:1;right:105%;left:var(--left-val)!important;top:var(--top-val);padding:0 10px;min-width:240px;min-width:max-content;min-width:-moz-max-content;min-width:-webkit-max-content;min-width:-o-max-content;height:inherit;box-sizing:border-box;box-shadow:0 4px 30px rgba(0,0,0,.2);margin:0;background-color:#fff;transition:.5s}.child-menu li[data-v-2eed0880]{background-color:#fff!important;padding:0 10px;padding-bottom:28px;position:relative}.child-menu li a[data-v-2eed0880]{margin:0;margin-right:10px}.child-menu li a[data-v-2eed0880],.child-menu li span[data-v-2eed0880]{color:#222!important;padding:0!important;border-bottom:none!important;font-size:15px;font-weight:300}.child-menu li span[data-v-2eed0880]{margin:0}.child-menu li[data-v-2eed0880]:first-child{padding-top:16px}.child-menu li[data-v-2eed0880]:last-child{padding-bottom:16px}.child-menu-open[data-v-2eed0880]{visibility:visible;opacity:1}.cssmenu>ul>li:nth-last-child(2) ul.child-menu li ul li[data-v-2eed0880]{max-width:140px}", ""]);

// exports


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menus && _vm.menus.length > 0)?_c('ul',{staticClass:"child-menu",style:({ '--left-val': _vm.left, '--top-val': _vm.top })},_vm._l((_vm.menus),function(menu){return _c('li',{key:menu.id,staticClass:"child-li"},[(menu.object === 'custom')?[(menu.url && menu.url != '')?_c('a',{staticClass:"nav-link link-hover",attrs:{"title":menu.title,"href":menu.url}},[_vm._v(_vm._s(menu.title))]):[_c('span',{staticClass:"link-hover"},[_vm._v(_vm._s(menu.title))])]]:[(_vm.$root.enable_piwik_reload)?[_c('a',{staticClass:"nav-link link-hover",attrs:{"title":menu.title,"href":_vm.getRouteLink(menu.slug, menu.object, menu.base_slug, menu.url)}},[_vm._v(_vm._s(menu.title))])]:[_c('router-link',{staticClass:"nav-link link-hover",attrs:{"title":menu.title,"tag":"a","to":_vm.getRouteLink(menu.slug, menu.object, menu.base_slug, menu.url)}},[_vm._v(_vm._s(menu.title))])]],_vm._v(" "),(menu.children && menu.children.length > 0)?_c('span',{staticClass:"arrow-left"},[_c('svg',{attrs:{"width":"6","height":"9","viewBox":"0 0 6 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.0078125 7.93875L3.44656 4.5L0.0078125 1.06125L1.06906 0L5.56906 4.5L1.06906\n                  9L0.0078125 7.93875Z","fill":"#333333"}})])]):_vm._e(),_vm._v(" "),(menu.children && menu.children.length > 0)?[_c('ChildMenu',{attrs:{"menus":menu.children,"left":"100%","top":"0%"}})]:_vm._e()],2)}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 485 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 487 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-list",style:({ '--primary-bg': _vm.$root.color_schema.primary })},[(_vm.menu.object === 'custom')?[(_vm.menu.url && _vm.menu.url != '')?_c('a',{staticClass:"nav-link",attrs:{"title":_vm.menu.title,"href":_vm.menu.url}},[(_vm.menu.menu_item_icon)?_c('object',{class:{
          'grayscale-invert-light': !_vm.getContrastYIQ(
            _vm.$root.color_schema.primary
          ),
          'grayscale-invert-dark': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
        },attrs:{"data":_vm.menu.menu_item_icon,"type":"image/svg+xml"}}):_vm._e(),_vm._v(" "),_c('span',{class:{
          'text-nav': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
          'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
        }},[_vm._v(_vm._s(_vm.menu.title))])]):[(_vm.menu.menu_item_icon)?_c('object',{class:{
          'nav-link': true,
          'grayscale-invert-light': !_vm.getContrastYIQ(
            _vm.$root.color_schema.primary
          ),
          'grayscale-invert-dark': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
        },attrs:{"data":_vm.menu.menu_item_icon,"type":"image/svg+xml"}}):_vm._e(),_vm._v(" "),_c('span',{class:{
          'span-text nav-link': true,
          'text-nav': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
          'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
        }},[_vm._v(_vm._s(_vm.menu.title))])]]:[(_vm.$root.enable_piwik_reload)?[_c('a',{staticClass:"nav-link",attrs:{"title":_vm.menu.title,"href":_vm.getRouteLink(_vm.menu.slug, _vm.menu.object, _vm.menu.base_slug)}},[(_vm.menu.menu_item_icon)?_c('object',{class:{
            'grayscale-invert-light': !_vm.getContrastYIQ(
              _vm.$root.color_schema.primary
            ),
            'grayscale-invert-dark': _vm.getContrastYIQ(
              _vm.$root.color_schema.primary
            ),
          },attrs:{"data":_vm.menu.menu_item_icon,"type":"image/svg+xml"}}):_vm._e(),_vm._v(" "),_c('span',{class:{
            'text-nav': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
            'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
          }},[_vm._v(_vm._s(_vm.menu.title))])])]:[_c('router-link',{staticClass:"nav-link",attrs:{"title":_vm.menu.title,"tag":"a","to":_vm.getRouteLink(_vm.menu.slug, _vm.menu.object, _vm.menu.base_slug)}},[(_vm.menu.menu_item_icon)?_c('object',{class:{
            'grayscale-invert-light': !_vm.getContrastYIQ(
              _vm.$root.color_schema.primary
            ),
            'grayscale-invert-dark': _vm.getContrastYIQ(
              _vm.$root.color_schema.primary
            ),
          },attrs:{"data":_vm.menu.menu_item_icon,"type":"image/svg+xml"}}):_vm._e(),_vm._v(" "),_c('span',{class:{
            'text-nav': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
            'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
          }},[_vm._v(_vm._s(_vm.menu.title))])])]],_vm._v(" "),(_vm.menu.children && _vm.menu.children.length > 0)?[_c('ChildMenu',{attrs:{"menus":_vm.menu.children,"left":"0%","top":"100%"}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderMobMenu_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d427f97_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderMobMenu_vue__ = __webpack_require__(707);
function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d427f97"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderMobMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d427f97_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderMobMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(491);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("11d5f2a4", content, true, {});

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-7d427f97]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-7d427f97]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-7d427f97]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-7d427f97]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-7d427f97]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-7d427f97]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-7d427f97]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-7d427f97]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-7d427f97]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-7d427f97]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-7d427f97]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-7d427f97]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.d-none[data-v-7d427f97]{display:none}.search[data-v-7d427f97]{background-color:var(--primary-search-bg);padding:5px 30px;margin:10px 6px;width:100%;box-sizing:border-box;border:0;border-radius:5px;font-size:16px}.search input[data-v-7d427f97]{width:100%;background-color:var(--primary-search-bg);border-width:0;color:#222}.search input[data-v-7d427f97]::placeholder{color:#222}.search[data-v-7d427f97]:before{position:absolute;left:12px;content:\"\";top:20px;background:var(--search-icon) no-repeat;width:12px;height:12px;z-index:1}.button[data-v-7d427f97]{width:44px;position:absolute;left:0;top:-6px;cursor:pointer;z-index:12399994}@media (min-width:992px){.button[data-v-7d427f97]{display:none}}.page-links[data-v-7d427f97]{color:#191923!important;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;color:inherit;display:block;padding:15px 20px 15px 11px;margin:0;flex-grow:1;flex-basis:10%;font-weight:500;font-size:16px;line-height:21px;font-family:var(--default-regular)}.page-links img[data-v-7d427f97]{max-height:17px;max-width:17px}.grayscale-invert[data-v-7d427f97]{filter:grayscale(1) invert(1);-webkit-filter:grayscale(1) invert(1)}.mt-10[data-v-7d427f97]{margin-top:10px}.menu-bars[data-v-7d427f97],.menu-close[data-v-7d427f97]{height:16px;margin-top:22px}.menu-close[data-v-7d427f97]{font-size:42px;line-height:100%;font-weight:700}", ""]);

// exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(493);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("51c79f64", content, true, {});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".page-links[data-v-0460f8ec],.parent-link[data-v-0460f8ec]{color:#191923!important;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;color:inherit;display:block;padding:15px 20px 15px 11px;margin:0;flex-grow:1;flex-basis:10%;font-weight:500;font-size:16px;line-height:21px;font-family:var(--default-regular)}.parent-link span[data-v-0460f8ec]{color:#191923!important}.mb-span[data-v-0460f8ec]{padding-left:23px}", ""]);

// exports


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[(_vm.parent)?_c('li',[(_vm.$root.enable_piwik_reload)?[(_vm.parent.object === 'custom')?_c('a',{staticClass:"parent-link",attrs:{"href":_vm.parent.url},on:{"click":function($event){return _vm.$emit('closePanel')}}},[_c('span',[_vm._v(_vm._s(_vm.parent.title))])]):_c('a',{staticClass:"parent-link",attrs:{"href":_vm.getRouteLink(_vm.parent.slug, _vm.parent.object, _vm.parent.base_slug)},on:{"click":function($event){return _vm.$emit('closePanel')}}},[_c('span',[_vm._v(_vm._s(_vm.parent.title))])])]:[(_vm.parent.object === 'custom')?_c('a',{staticClass:"parent-link",attrs:{"href":_vm.parent.url},on:{"click":function($event){return _vm.$emit('closePanel')}}},[_c('span',[_vm._v(_vm._s(_vm.parent.title))])]):_c('router-link',{staticClass:"parent-link",attrs:{"to":_vm.getRouteLink(_vm.parent.slug, _vm.parent.object, _vm.parent.base_slug)},nativeOn:{"click":function($event){return _vm.$emit('closePanel')}}},[_c('span',[_vm._v(_vm._s(_vm.parent.title))])])]],2):_vm._e(),_vm._v(" "),_vm._l((_vm.menus),function(menu){return _c('li',{key:menu.ID},[(menu.children && menu.children.length > 0)?[_c('a',{staticClass:"page-links"},[_c('span',[_vm._v(_vm._s(menu.title))])]),_vm._v(" "),_c('MobileChildMenu',{attrs:{"parent":menu,"menus":menu.children},on:{"closePanel":function($event){return _vm.$emit('closePanel')}}})]:[(menu.object === 'custom')?[(menu.url && menu.url != '')?_c('a',{staticClass:"page-links",attrs:{"href":menu.url},on:{"click":function($event){return _vm.$emit('closePanel')}}},[_c('span',[_vm._v(_vm._s(menu.title))])]):[_c('span',{staticClass:"mb-span"},[_vm._v(_vm._s(menu.title))])]]:[(_vm.$root.enable_piwik_reload)?[_c('a',{staticClass:"page-links",attrs:{"href":_vm.getRouteLink(menu.slug, menu.object, menu.base_slug)},on:{"click":function($event){return _vm.$emit('closePanel')}}},[_c('span',[_vm._v(_vm._s(menu.title))])])]:[_c('router-link',{staticClass:"page-links",attrs:{"to":_vm.getRouteLink(menu.slug, menu.object, menu.base_slug)},nativeOn:{"click":function($event){return _vm.$emit('closePanel')}}},[_c('span',[_vm._v(_vm._s(menu.title))])])]]]],2)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dist_core_offcanvas_mmenu_offcanvas__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dist_core_screenreader_mmenu_screenreader__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dist_core_scrollbugfix_mmenu_scrollbugfix__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dist_addons_autoheight_mmenu_autoheight__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dist_addons_backbutton_mmenu_backbutton__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dist_addons_columns_mmenu_columns__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dist_addons_counters_mmenu_counters__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dist_addons_dividers_mmenu_dividers__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dist_addons_drag_mmenu_drag__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dist_addons_dropdown_mmenu_dropdown__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dist_addons_fixedelements_mmenu_fixedelements__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dist_addons_iconbar_mmenu_iconbar__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dist_addons_iconpanels_mmenu_iconpanels__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dist_addons_keyboardnavigation_mmenu_keyboardnavigation__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dist_addons_lazysubmenus_mmenu_lazysubmenus__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__dist_addons_navbars_mmenu_navbars__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__dist_addons_pagescroll_mmenu_pagescroll__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__dist_addons_searchfield_mmenu_searchfield__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dist_addons_sectionindexer_mmenu_sectionindexer__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__dist_addons_setselected_mmenu_setselected__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__dist_addons_sidebar_mmenu_sidebar__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__dist_addons_toggles_mmenu_toggles__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__dist_wrappers_angular_mmenu_angular__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__dist_wrappers_bootstrap_mmenu_bootstrap__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__dist_wrappers_olark_mmenu_olark__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__dist_wrappers_turbolinks_mmenu_turbolinks__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__dist_wrappers_wordpress_mmenu_wordpress__ = __webpack_require__(558);
/*!
 * mmenu.js
 * mmenujs.com
 *
 * Copyright (c) Fred Heusschen
 * frebsite.nl
 */

//	Core


//	Core add-ons




//	Add-ons




















//	Wrappers






__WEBPACK_IMPORTED_MODULE_0__dist_core_oncanvas_mmenu_oncanvas__["a" /* default */].addons = {
    //	Core add-ons
    offcanvas: __WEBPACK_IMPORTED_MODULE_1__dist_core_offcanvas_mmenu_offcanvas__["a" /* default */],
    screenReader: __WEBPACK_IMPORTED_MODULE_2__dist_core_screenreader_mmenu_screenreader__["a" /* default */],
    scrollBugFix: __WEBPACK_IMPORTED_MODULE_3__dist_core_scrollbugfix_mmenu_scrollbugfix__["a" /* default */],

    //	Add-ons
    autoHeight: __WEBPACK_IMPORTED_MODULE_4__dist_addons_autoheight_mmenu_autoheight__["a" /* default */],
    backButton: __WEBPACK_IMPORTED_MODULE_5__dist_addons_backbutton_mmenu_backbutton__["a" /* default */],
    columns: __WEBPACK_IMPORTED_MODULE_6__dist_addons_columns_mmenu_columns__["a" /* default */],
    counters: __WEBPACK_IMPORTED_MODULE_7__dist_addons_counters_mmenu_counters__["a" /* default */],
    dividers: __WEBPACK_IMPORTED_MODULE_8__dist_addons_dividers_mmenu_dividers__["a" /* default */],
    drag: __WEBPACK_IMPORTED_MODULE_9__dist_addons_drag_mmenu_drag__["a" /* default */],
    dropdown: __WEBPACK_IMPORTED_MODULE_10__dist_addons_dropdown_mmenu_dropdown__["a" /* default */],
    fixedElements: __WEBPACK_IMPORTED_MODULE_11__dist_addons_fixedelements_mmenu_fixedelements__["a" /* default */],
    iconbar: __WEBPACK_IMPORTED_MODULE_12__dist_addons_iconbar_mmenu_iconbar__["a" /* default */],
    iconPanels: __WEBPACK_IMPORTED_MODULE_13__dist_addons_iconpanels_mmenu_iconpanels__["a" /* default */],
    keyboardNavigation: __WEBPACK_IMPORTED_MODULE_14__dist_addons_keyboardnavigation_mmenu_keyboardnavigation__["a" /* default */],
    lazySubmenus: __WEBPACK_IMPORTED_MODULE_15__dist_addons_lazysubmenus_mmenu_lazysubmenus__["a" /* default */],
    navbars: __WEBPACK_IMPORTED_MODULE_16__dist_addons_navbars_mmenu_navbars__["a" /* default */],
    pageScroll: __WEBPACK_IMPORTED_MODULE_17__dist_addons_pagescroll_mmenu_pagescroll__["a" /* default */],
    searchfield: __WEBPACK_IMPORTED_MODULE_18__dist_addons_searchfield_mmenu_searchfield__["a" /* default */],
    sectionIndexer: __WEBPACK_IMPORTED_MODULE_19__dist_addons_sectionindexer_mmenu_sectionindexer__["a" /* default */],
    setSelected: __WEBPACK_IMPORTED_MODULE_20__dist_addons_setselected_mmenu_setselected__["a" /* default */],
    sidebar: __WEBPACK_IMPORTED_MODULE_21__dist_addons_sidebar_mmenu_sidebar__["a" /* default */],
    toggles: __WEBPACK_IMPORTED_MODULE_22__dist_addons_toggles_mmenu_toggles__["a" /* default */]
};

//	Wrappers
__WEBPACK_IMPORTED_MODULE_0__dist_core_oncanvas_mmenu_oncanvas__["a" /* default */].wrappers = {
    angular: __WEBPACK_IMPORTED_MODULE_23__dist_wrappers_angular_mmenu_angular__["a" /* default */],
    bootstrap: __WEBPACK_IMPORTED_MODULE_24__dist_wrappers_bootstrap_mmenu_bootstrap__["a" /* default */],
    olark: __WEBPACK_IMPORTED_MODULE_25__dist_wrappers_olark_mmenu_olark__["a" /* default */],
    turbolinks: __WEBPACK_IMPORTED_MODULE_26__dist_wrappers_turbolinks_mmenu_turbolinks__["a" /* default */],
    wordpress: __WEBPACK_IMPORTED_MODULE_27__dist_wrappers_wordpress_mmenu_wordpress__["a" /* default */]
};

//  Export module
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__dist_core_oncanvas_mmenu_oncanvas__["a" /* default */]);

//	Global namespace
if (window) {
    window.Mmenu = __WEBPACK_IMPORTED_MODULE_0__dist_core_oncanvas_mmenu_oncanvas__["a" /* default */];
}

//	jQuery plugin
(function ($) {
    if ($) {
        $.fn.mmenu = function (options, configs) {
            var $result = $();

            this.each(function (e, element) {
                //	Don't proceed if the element already is a mmenu.
                if (element.mmApi) {
                    return;
                }

                var menu = new __WEBPACK_IMPORTED_MODULE_0__dist_core_oncanvas_mmenu_oncanvas__["a" /* default */](element, options, configs),
                    $menu = $(menu.node.menu);

                //	Store the API for backward compat.
                $menu.data('mmenu', menu.API);

                $result = $result.add($menu);
            });

            return $result;
        };
    }
})(window.jQuery || window.Zepto || null);


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var options = {
    hooks: {},
    extensions: [],
    wrappers: [],
    navbar: {
        add: true,
        sticky: true,
        title: 'Menu',
        titleLink: 'parent'
    },
    onClick: {
        close: null,
        preventDefault: null,
        setSelected: true
    },
    slidingSubmenus: true
};
/* harmony default export */ __webpack_exports__["a"] = (options);


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var configs = {
    classNames: {
        inset: 'Inset',
        nolistview: 'NoListview',
        nopanel: 'NoPanel',
        panel: 'Panel',
        selected: 'Selected',
        vertical: 'Vertical'
    },
    language: null,
    openingInterval: 25,
    panelNodetype: ['ul', 'ol', 'div'],
    transitionDuration: 400
};
/* harmony default export */ __webpack_exports__["a"] = (configs);


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_i18n__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nl__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fa__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__de__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ru__ = __webpack_require__(502);





/* harmony default export */ __webpack_exports__["a"] = (function () {
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_1__nl__["a" /* default */], 'nl');
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_2__fa__["a" /* default */], 'fa');
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_3__de__["a" /* default */], 'de');
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_4__ru__["a" /* default */], 'ru');
});


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'Menu': 'Menu'
});


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'Menu': 'منو'
});


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'Menu': 'Menü'
});


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'Menu': 'Меню'
});


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_eventlisteners__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_helpers__ = __webpack_require__(13);







//  Add the options and configs.
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].options.offCanvas = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].configs.offCanvas = __WEBPACK_IMPORTED_MODULE_2__configs__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    if (!this.opts.offCanvas) {
        return;
    }
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.offCanvas);
    this.opts.offCanvas = Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].options.offCanvas);
    var configs = this.conf.offCanvas;
    //	Add methods to the API.
    this._api.push('open', 'close', 'setPage');
    //	Setup the menu.
    this.vars.opened = false;
    //	Add off-canvas behavior.
    this.bind('initMenu:before', function () {
        //	Clone if needed.
        if (configs.clone) {
            //	Clone the original menu and store it.
            _this.node.menu = _this.node.menu.cloneNode(true);
            //	Prefix all ID's in the cloned menu.
            if (_this.node.menu.id) {
                _this.node.menu.id = 'mm-' + _this.node.menu.id;
            }
            __WEBPACK_IMPORTED_MODULE_3__modules_dom__["e" /* find */](_this.node.menu, '[id]').forEach(function (elem) {
                elem.id = 'mm-' + elem.id;
            });
        }
        _this.node.wrpr = document.body;
        //	Prepend to the <body>
        document
            .querySelector(configs.menu.insertSelector)[configs.menu.insertMethod](_this.node.menu);
    });
    this.bind('initMenu:after', function () {
        //	Setup the UI blocker.
        initBlocker.call(_this);
        //	Setup the page.
        _this.setPage(__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.page);
        //	Setup window events.
        initWindow.call(_this);
        //	Setup the menu.
        _this.node.menu.classList.add('mm-menu_offcanvas');
        //	Open if url hash equals menu id (usefull when user clicks the hamburger icon before the menu is created)
        var hash = window.location.hash;
        if (hash) {
            var id = Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["b" /* originalId */])(_this.node.menu.id);
            if (id && id == hash.slice(1)) {
                setTimeout(function () {
                    _this.open();
                }, 1000);
            }
        }
    });
    //	Sync the blocker to target the page.
    this.bind('setPage:after', function (page) {
        if (__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.blck) {
            __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.blck, 'a').forEach(function (anchor) {
                anchor.setAttribute('href', '#' + page.id);
            });
        }
    });
    //	Add screenreader / aria support
    this.bind('open:start:sr-aria', function () {
        __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(_this.node.menu, 'hidden', false);
    });
    this.bind('close:finish:sr-aria', function () {
        __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(_this.node.menu, 'hidden', true);
    });
    this.bind('initMenu:after:sr-aria', function () {
        __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(_this.node.menu, 'hidden', true);
    });
    //	Add screenreader / text support
    this.bind('initBlocker:after:sr-text', function () {
        __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.blck, 'a').forEach(function (anchor) {
            anchor.innerHTML = __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_text(_this.i18n(_this.conf.screenReader.text.closeMenu));
        });
    });
    //	Add click behavior.
    //	Prevents default behavior when clicking an anchor
    this.clck.push(function (anchor, args) {
        //	Open menu if the clicked anchor links to the menu
        var id = Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["b" /* originalId */])(_this.node.menu.id);
        if (id) {
            if (anchor.matches('[href="#' + id + '"]')) {
                //	Opening this menu from within this menu
                //		-> Open menu
                if (args.inMenu) {
                    _this.open();
                    return true;
                }
                //	Opening this menu from within a second menu
                //		-> Close the second menu before opening this menu
                var menu = anchor.closest('.mm-menu');
                if (menu) {
                    var api = menu['mmApi'];
                    if (api && api.close) {
                        api.close();
                        Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["d" /* transitionend */])(menu, function () {
                            _this.open();
                        }, _this.conf.transitionDuration);
                        return true;
                    }
                }
                //	Opening this menu
                _this.open();
                return true;
            }
        }
        //	Close menu
        id = __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.page.id;
        if (id) {
            if (anchor.matches('[href="#' + id + '"]')) {
                _this.close();
                return true;
            }
        }
        return;
    });
});
/**
 * Open the menu.
 */
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].prototype.open = function () {
    var _this = this;
    //	Invoke "before" hook.
    this.trigger('open:before');
    if (this.vars.opened) {
        return;
    }
    this._openSetup();
    //	Without the timeout, the animation won't work because the menu had display: none;
    setTimeout(function () {
        _this._openStart();
    }, this.conf.openingInterval);
    //	Invoke "after" hook.
    this.trigger('open:after');
};
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].prototype._openSetup = function () {
    var _this = this;
    var options = this.opts.offCanvas;
    //	Close other menus
    this.closeAllOthers();
    //	Trigger window-resize to measure height
    __WEBPACK_IMPORTED_MODULE_4__modules_eventlisteners__["c" /* trigger */](window, 'resize.page', { force: true });
    var clsn = ['mm-wrapper_opened'];
    //	Add options
    if (options.blockUI) {
        clsn.push('mm-wrapper_blocking');
    }
    if (options.blockUI == 'modal') {
        clsn.push('mm-wrapper_modal');
    }
    if (options.moveBackground) {
        clsn.push('mm-wrapper_background');
    }
    //  IE11:
    clsn.forEach(function (classname) {
        _this.node.wrpr.classList.add(classname);
    });
    //  Better browsers:
    // this.node.wrpr.classList.add(...clsn);
    //	Open
    //	Without the timeout, the animation won't work because the menu had display: none;
    setTimeout(function () {
        _this.vars.opened = true;
    }, this.conf.openingInterval);
    this.node.menu.classList.add('mm-menu_opened');
};
/**
 * Finish opening the menu.
 */
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].prototype._openStart = function () {
    var _this = this;
    //	Callback when the page finishes opening.
    Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["d" /* transitionend */])(__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.page, function () {
        _this.trigger('open:finish');
    }, this.conf.transitionDuration);
    //	Opening
    this.trigger('open:start');
    this.node.wrpr.classList.add('mm-wrapper_opening');
};
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].prototype.close = function () {
    var _this = this;
    //	Invoke "before" hook.
    this.trigger('close:before');
    if (!this.vars.opened) {
        return;
    }
    //	Callback when the page finishes closing.
    Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["d" /* transitionend */])(__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.page, function () {
        _this.node.menu.classList.remove('mm-menu_opened');
        var classnames = [
            'mm-wrapper_opened',
            'mm-wrapper_blocking',
            'mm-wrapper_modal',
            'mm-wrapper_background'
        ];
        //  IE11:
        classnames.forEach(function (classname) {
            _this.node.wrpr.classList.remove(classname);
        });
        //  Better browsers:
        // this.node.wrpr.classList.remove(...classnames);
        _this.vars.opened = false;
        _this.trigger('close:finish');
    }, this.conf.transitionDuration);
    //	Closing
    this.trigger('close:start');
    this.node.wrpr.classList.remove('mm-wrapper_opening');
    //	Invoke "after" hook.
    this.trigger('close:after');
};
/**
 * Close all other menus.
 */
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].prototype.closeAllOthers = function () {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_3__modules_dom__["e" /* find */](document.body, '.mm-menu_offcanvas').forEach(function (menu) {
        if (menu !== _this.node.menu) {
            var api = menu['mmApi'];
            if (api && api.close) {
                api.close();
            }
        }
    });
};
/**
 * Set the "page" node.
 *
 * @param {HTMLElement} page Element to set as the page.
 */
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].prototype.setPage = function (page) {
    //	Invoke "before" hook.
    this.trigger('setPage:before', [page]);
    var configs = this.conf.offCanvas;
    //	If no page was specified, find it.
    if (!page) {
        /** Array of elements that are / could be "the page". */
        var pages = typeof configs.page.selector == 'string'
            ? __WEBPACK_IMPORTED_MODULE_3__modules_dom__["e" /* find */](document.body, configs.page.selector)
            : __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](document.body, configs.page.nodetype);
        //	Filter out elements that are absolutely not "the page".
        pages = pages.filter(function (page) { return !page.matches('.mm-menu, .mm-wrapper__blocker'); });
        //	Filter out elements that are configured to not be "the page".
        if (configs.page.noSelector.length) {
            pages = pages.filter(function (page) { return !page.matches(configs.page.noSelector.join(', ')); });
        }
        //	Wrap multiple pages in a single element.
        if (pages.length > 1) {
            var wrapper_1 = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('div');
            pages[0].before(wrapper_1);
            pages.forEach(function (page) {
                wrapper_1.append(page);
            });
            pages = [wrapper_1];
        }
        page = pages[0];
    }
    page.classList.add('mm-page');
    page.classList.add('mm-slideout');
    page.id = page.id || Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["f" /* uniqueId */])();
    __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.page = page;
    //	Invoke "after" hook.
    this.trigger('setPage:after', [page]);
};
/**
 * Initialize the window.
 */
var initWindow = function () {
    var _this = this;
    //	Prevent tabbing
    //	Because when tabbing outside the menu, the element that gains focus will be centered on the screen.
    //	In other words: The menu would move out of view.
    __WEBPACK_IMPORTED_MODULE_4__modules_eventlisteners__["a" /* off */](document.body, 'keydown.tabguard');
    __WEBPACK_IMPORTED_MODULE_4__modules_eventlisteners__["b" /* on */](document.body, 'keydown.tabguard', function (evnt) {
        if (evnt.keyCode == 9) {
            if (_this.node.wrpr.matches('.mm-wrapper_opened')) {
                evnt.preventDefault();
            }
        }
    });
};
/**
 * Initialize "blocker" node
 */
var initBlocker = function () {
    var _this = this;
    //	Invoke "before" hook.
    this.trigger('initBlocker:before');
    var options = this.opts.offCanvas, configs = this.conf.offCanvas;
    if (!options.blockUI) {
        return;
    }
    //	Create the blocker node.
    if (!__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.blck) {
        var blck = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('div.mm-wrapper__blocker.mm-slideout');
        blck.innerHTML = '<a></a>';
        //	Append the blocker node to the body.
        document.querySelector(configs.menu.insertSelector).append(blck);
        //	Store the blocker node.
        __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.blck = blck;
    }
    //	Close the menu when
    //		1) clicking,
    //		2) touching or
    //		3) dragging the blocker node.
    var closeMenu = function (evnt) {
        evnt.preventDefault();
        evnt.stopPropagation();
        if (!_this.node.wrpr.matches('.mm-wrapper_modal')) {
            _this.close();
        }
    };
    __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.blck.addEventListener('mousedown', closeMenu); // 1
    __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.blck.addEventListener('touchstart', closeMenu); // 2
    __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].node.blck.addEventListener('touchmove', closeMenu); // 3
    //	Invoke "after" hook.
    this.trigger('initBlocker:after');
};


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var configs = {
    clone: false,
    menu: {
        insertMethod: 'prepend',
        insertSelector: 'body'
    },
    page: {
        nodetype: 'div',
        selector: null,
        noSelector: []
    }
};
/* harmony default export */ __webpack_exports__["a"] = (configs);


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translations_translate__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_helpers__ = __webpack_require__(13);







//  Add the translations.
Object(__WEBPACK_IMPORTED_MODULE_3__translations_translate__["a" /* default */])();
//  Add the options and configs.
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].options.screenReader = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].configs.screenReader = __WEBPACK_IMPORTED_MODULE_2__configs__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    //	Extend options.
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.screenReader);
    this.opts.screenReader = Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].options.screenReader);
    //	Extend configs.
    var configs = this.conf.screenReader;
    //	Add Aria-* attributes
    if (options.aria) {
        //	Add screenreader / aria hooks for add-ons
        //	In orde to keep this list short, only extend hooks that are actually used by other add-ons.
        this.bind('initAddons:after', function () {
            _this.bind('initMenu:after', function () {
                this.trigger('initMenu:after:sr-aria', [].slice.call(arguments));
            });
            _this.bind('initNavbar:after', function () {
                this.trigger('initNavbar:after:sr-aria', [].slice.call(arguments));
            });
            _this.bind('openPanel:start', function () {
                this.trigger('openPanel:start:sr-aria', [].slice.call(arguments));
            });
            _this.bind('close:start', function () {
                this.trigger('close:start:sr-aria', [].slice.call(arguments));
            });
            _this.bind('close:finish', function () {
                this.trigger('close:finish:sr-aria', [].slice.call(arguments));
            });
            _this.bind('open:start', function () {
                this.trigger('open:start:sr-aria', [].slice.call(arguments));
            });
            _this.bind('initOpened:after', function () {
                this.trigger('initOpened:after:sr-aria', [].slice.call(arguments));
            });
        });
        //	Update aria-hidden for hidden / visible listitems
        this.bind('updateListview', function () {
            _this.node.pnls
                .querySelectorAll('.mm-listitem')
                .forEach(function (listitem) {
                __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(listitem, 'hidden', listitem.matches('.mm-hidden'));
            });
        });
        //	Update aria-hidden for the panels when opening and closing a panel.
        this.bind('openPanel:start', function (panel) {
            /** Panels that should be considered "hidden". */
            var hidden = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](_this.node.pnls, '.mm-panel')
                .filter(function (hide) { return hide !== panel; })
                .filter(function (hide) { return !hide.parentElement.matches('.mm-panel'); });
            /** Panels that should be considered "visible". */
            var visible = [panel];
            __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](panel, '.mm-listitem_vertical .mm-listitem_opened').forEach(function (listitem) {
                visible.push.apply(visible, __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](listitem, '.mm-panel'));
            });
            //	Set the panels to be considered "hidden" or "visible".
            hidden.forEach(function (panel) {
                __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(panel, 'hidden', true);
            });
            visible.forEach(function (panel) {
                __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(panel, 'hidden', false);
            });
        });
        this.bind('closePanel', function (panel) {
            __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(panel, 'hidden', true);
        });
        // //	Add aria-haspopup and aria-owns to prev- and next buttons.
        // this.bind('initPanel:after', (panel: HTMLElement) => {
        //     DOM.find(panel, '.mm-btn').forEach(button => {
        //         Mmenu.sr_aria(button, 'haspopup', true);
        //         let href = button.getAttribute('href');
        //         if (href) {
        //             Mmenu.sr_aria(button, 'owns', href.replace('#', ''));
        //         }
        //     });
        // });
        //	Add aria-hidden for navbars in panels.
        this.bind('initNavbar:after', function (panel) {
            /** The navbar in the panel. */
            var navbar = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](panel, '.mm-navbar')[0];
            /** Whether or not the navbar should be considered "hidden". */
            var hidden = navbar.matches('.mm-hidden');
            //	Set the navbar to be considered "hidden" or "visible".
            __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(navbar, 'hidden', hidden);
        });
        //	Text
        if (options.text) {
            //	Add aria-hidden to titles in navbars
            if (this.opts.navbar.titleLink == 'parent') {
                this.bind('initNavbar:after', function (panel) {
                    /** The navbar in the panel. */
                    var navbar = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](panel, '.mm-navbar')[0];
                    /** Whether or not the navbar should be considered "hidden". */
                    var hidden = navbar.querySelector('.mm-btn_prev')
                        ? true
                        : false;
                    //	Set the navbar-title to be considered "hidden" or "visible".
                    __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(__WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](navbar, '.mm-navbar__title')[0], 'hidden', hidden);
                });
            }
        }
    }
    //	Add screenreader text
    if (options.text) {
        //	Add screenreader / text hooks for add-ons
        //	In orde to keep this list short, only extend hooks that are actually used by other add-ons.
        this.bind('initAddons:after', function () {
            _this.bind('setPage:after', function () {
                this.trigger('setPage:after:sr-text', [].slice.call(arguments));
            });
            _this.bind('initBlocker:after', function () {
                this.trigger('initBlocker:after:sr-text', [].slice.call(arguments));
            });
        });
        //	Add text to the prev-buttons.
        this.bind('initNavbar:after', function (panel) {
            var navbar = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](panel, '.mm-navbar')[0];
            if (navbar) {
                var button = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](navbar, '.mm-btn_prev')[0];
                if (button) {
                    button.innerHTML = __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_text(_this.i18n(configs.text.closeSubmenu));
                }
            }
        });
        //	Add text to the next-buttons.
        this.bind('initListview:after', function (listview) {
            var parent = listview.closest('.mm-panel')['mmParent'];
            if (parent) {
                var next = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](parent, '.mm-btn_next')[0];
                if (next) {
                    var text = _this.i18n(configs.text[next.parentElement.matches('.mm-listitem_vertical')
                        ? 'toggleSubmenu'
                        : 'openSubmenu']);
                    next.innerHTML += __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_text(text);
                }
            }
        });
    }
});
//	Methods
(function () {
    var attr = function (element, attr, value) {
        element[attr] = value;
        if (value) {
            element.setAttribute(attr, value.toString());
        }
        else {
            element.removeAttribute(attr);
        }
    };
    /**
     * Add aria (property and) attribute to a HTML element.
     *
     * @param {HTMLElement} 	element	The node to add the attribute to.
     * @param {string}			name	The (non-aria-prefixed) attribute name.
     * @param {string|boolean}	value	The attribute value.
     */
    __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria = function (element, name, value) {
        attr(element, 'aria-' + name, value);
    };
    /**
     * Add role attribute to a HTML element.
     *
     * @param {HTMLElement}		element	The node to add the attribute to.
     * @param {string|boolean}	value	The attribute value.
     */
    __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_role = function (element, value) {
        attr(element, 'role', value);
    };
    /**
     * Wrap a text in a screen-reader-only node.
     *
     * @param 	{string} text	The text to wrap.
     * @return	{string}		The wrapped text.
     */
    __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].sr_text = function (text) {
        return '<span class="mm-sronly">' + text + '</span>';
    };
})();


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var configs = {
    text: {
        closeMenu: 'Close menu',
        closeSubmenu: 'Close submenu',
        openSubmenu: 'Open submenu',
        toggleSubmenu: 'Toggle submenu'
    }
};
/* harmony default export */ __webpack_exports__["a"] = (configs);


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_i18n__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nl__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fa__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__de__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ru__ = __webpack_require__(511);





/* harmony default export */ __webpack_exports__["a"] = (function () {
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_1__nl__["a" /* default */], 'nl');
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_2__fa__["a" /* default */], 'fa');
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_3__de__["a" /* default */], 'de');
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_4__ru__["a" /* default */], 'ru');
});


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'Close menu': 'Menu sluiten',
    'Close submenu': 'Submenu sluiten',
    'Open submenu': 'Submenu openen',
    'Toggle submenu': 'Submenu wisselen'
});


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'Close menu': 'بستن منو',
    'Close submenu': 'بستن زیرمنو',
    'Open submenu': 'بازکردن زیرمنو',
    'Toggle submenu': 'سوییچ زیرمنو'
});


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'Close menu': 'Menü schließen',
    'Close submenu': 'Untermenü schließen',
    'Open submenu': 'Untermenü öffnen',
    'Toggle submenu': 'Untermenü wechseln'
});


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'Close menu': 'Закрыть меню',
    'Close submenu': 'Закрыть подменю',
    'Open submenu': 'Открыть подменю',
    'Toggle submenu': 'Переключить подменю'
});


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_support__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_helpers__ = __webpack_require__(13);






//  Add the options.
__WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].options.scrollBugFix = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    //	The scrollBugFix add-on fixes a scrolling bug
    //		1) on touch devices
    //		2) in an off-canvas menu
    //		3) that -when opened- blocks the UI from interaction
    if (!__WEBPACK_IMPORTED_MODULE_3__modules_support__["a" /* touch */] || // 1
        !this.opts.offCanvas || // 2
        !this.opts.offCanvas.blockUI // 3
    ) {
        return;
    }
    //	Extend options.
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.scrollBugFix);
    this.opts.scrollBugFix = Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__oncanvas_mmenu_oncanvas__["a" /* default */].options.scrollBugFix);
    if (!options.fix) {
        return;
    }
    var touchDir = Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["c" /* touchDirection */])(this.node.menu);
    /**
     * Prevent an event from doing its default and stop its propagation.
     * @param {ScrollBehavior} evnt The event to stop.
     */
    function stop(evnt) {
        evnt.preventDefault();
        evnt.stopPropagation();
    }
    //  Prevent the page from scrolling when scrolling in the menu.
    this.node.menu.addEventListener('scroll', stop, {
        //  Make sure to tell the browser the event will be prevented.
        passive: false,
    });
    //  Prevent the page from scrolling when dragging in the menu.
    this.node.menu.addEventListener('touchmove', function (evnt) {
        var wrapper = evnt.target.closest('.mm-panel, .mm-iconbar__top, .mm-iconbar__bottom');
        if (wrapper && wrapper.closest('.mm-listitem_vertical')) {
            wrapper = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["g" /* parents */](wrapper, '.mm-panel').pop();
        }
        if (wrapper) {
            //  When dragging a non-scrollable panel,
            //      we can simple preventDefault and stopPropagation.
            if (wrapper.scrollHeight === wrapper.offsetHeight) {
                stop(evnt);
            }
            //  When dragging a scrollable panel,
            //      that is fully scrolled up (or down).
            //      It will not trigger the scroll event when dragging down (or up) (because you can't scroll up (or down)),
            //      so we need to match the dragging direction with the scroll position before preventDefault and stopPropagation,
            //      otherwise the panel would not scroll at all in any direction.
            else if (
            //  When scrolled up and dragging down
            (wrapper.scrollTop == 0 && touchDir.get() == 'down') ||
                //  When scrolled down and dragging up
                (wrapper.scrollHeight ==
                    wrapper.scrollTop + wrapper.offsetHeight &&
                    touchDir.get() == 'up')) {
                stop(evnt);
            }
            //  When dragging anything other than a panel.
        }
        else {
            stop(evnt);
        }
    }, {
        //  Make sure to tell the browser the event can be prevented.
        passive: false,
    });
    //  Some small additional improvements
    //	Scroll the current opened panel to the top when opening the menu.
    this.bind('open:start', function () {
        var panel = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel_opened')[0];
        if (panel) {
            panel.scrollTop = 0;
        }
    });
    //	Fix issue after device rotation change.
    window.addEventListener('orientationchange', function (evnt) {
        var panel = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel_opened')[0];
        if (panel) {
            panel.scrollTop = 0;
            //	Apparently, changing the overflow-scrolling property triggers some event :)
            panel.style['-webkit-overflow-scrolling'] = 'auto';
            panel.style['-webkit-overflow-scrolling'] = 'touch';
        }
    });
});


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_helpers__ = __webpack_require__(13);





//	Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.autoHeight = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.autoHeight);
    this.opts.autoHeight = Object(__WEBPACK_IMPORTED_MODULE_3__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.autoHeight);
    if (options.height != 'auto' && options.height != 'highest') {
        return;
    }
    var setHeight = (function () {
        var getCurrent = function () {
            var panel = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel_opened')[0];
            if (panel) {
                panel = measurablePanel(panel);
            }
            //	Fallback, just to be sure we have a panel.
            if (!panel) {
                panel = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel')[0];
            }
            return panel.scrollHeight;
        };
        var getHighest = function () {
            var highest = 0;
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel').forEach(function (panel) {
                panel = measurablePanel(panel);
                highest = Math.max(highest, panel.scrollHeight);
            });
            return highest;
        };
        var measurablePanel = function (panel) {
            //	If it's a vertically expanding panel...
            if (panel.parentElement.matches('.mm-listitem_vertical')) {
                //	...find the first parent panel that isn't.
                panel = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["g" /* parents */](panel, '.mm-panel').filter(function (panel) {
                    return !panel.parentElement.matches('.mm-listitem_vertical');
                })[0];
            }
            return panel;
        };
        return function () {
            if (_this.opts.offCanvas && !_this.vars.opened) {
                return;
            }
            var _hgh = 0;
            var _dif = _this.node.menu.offsetHeight - _this.node.pnls.offsetHeight;
            //	The "measuring" classname undoes some CSS to be able to measure the height.
            _this.node.menu.classList.add('mm-menu_autoheight-measuring');
            //	Measure the height.
            if (options.height == 'auto') {
                _hgh = getCurrent();
            }
            else if (options.height == 'highest') {
                _hgh = getHighest();
            }
            //	Set the height.
            _this.node.menu.style.height = _hgh + _dif + 'px';
            //	Remove the "measuring" classname.
            _this.node.menu.classList.remove('mm-menu_autoheight-measuring');
        };
    })();
    //	Add the autoheight class to the menu.
    this.bind('initMenu:after', function () {
        _this.node.menu.classList.add('mm-menu_autoheight');
    });
    if (this.opts.offCanvas) {
        //	Measure the height when opening the off-canvas menu.
        this.bind('open:start', setHeight);
    }
    if (options.height == 'highest') {
        //	Measure the height when initiating panels.
        this.bind('initPanels:after', setHeight);
    }
    if (options.height == 'auto') {
        //	Measure the height when updating listviews.
        this.bind('updateListview', setHeight);
        //	Measure the height when opening a panel.
        this.bind('openPanel:start', setHeight);
    }
});


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_helpers__ = __webpack_require__(13);





//	Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.backButton = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    if (!this.opts.offCanvas) {
        return;
    }
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.backButton);
    this.opts.backButton = Object(__WEBPACK_IMPORTED_MODULE_3__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.backButton);
    var _menu = '#' + this.node.menu.id;
    //	Close menu
    if (options.close) {
        var states = [];
        var setStates = function () {
            states = [_menu];
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel_opened, .mm-panel_opened-parent').forEach(function (panel) {
                states.push('#' + panel.id);
            });
        };
        this.bind('open:finish', function () {
            history.pushState(null, document.title, _menu);
        });
        this.bind('open:finish', setStates);
        this.bind('openPanel:finish', setStates);
        this.bind('close:finish', function () {
            states = [];
            history.back();
            history.pushState(null, document.title, location.pathname + location.search);
        });
        window.addEventListener('popstate', function (evnt) {
            if (_this.vars.opened) {
                if (states.length) {
                    states = states.slice(0, -1);
                    var hash = states[states.length - 1];
                    if (hash == _menu) {
                        _this.close();
                    }
                    else {
                        _this.openPanel(_this.node.menu.querySelector(hash));
                        history.pushState(null, document.title, _menu);
                    }
                }
            }
        });
    }
    if (options.open) {
        window.addEventListener('popstate', function (evnt) {
            if (!_this.vars.opened && location.hash == _menu) {
                _this.open();
            }
        });
    }
});


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_helpers__ = __webpack_require__(13);





//	Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.columns = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.columns);
    this.opts.columns = Object(__WEBPACK_IMPORTED_MODULE_3__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.columns);
    //	Add the columns
    if (options.add) {
        options.visible.min = Math.max(1, Math.min(6, options.visible.min));
        options.visible.max = Math.max(options.visible.min, Math.min(6, options.visible.max));
        /** Columns related clasnames for the menu. */
        var colm = [];
        /** Columns related clasnames for the panels. */
        var colp = [];
        /** Classnames to remove from panels in favor of showing columns. */
        var rmvc = [
            'mm-panel_opened',
            'mm-panel_opened-parent',
            'mm-panel_highest',
        ];
        for (var i = 0; i <= options.visible.max; i++) {
            colm.push('mm-menu_columns-' + i);
            colp.push('mm-panel_columns-' + i);
        }
        rmvc.push.apply(rmvc, colp);
        //	Close all later opened panels
        this.bind('openPanel:before', function (panel) {
            /** The parent panel. */
            var parent;
            if (panel) {
                parent = panel['mmParent'];
            }
            if (!parent) {
                return;
            }
            if (parent.classList.contains('mm-listitem_vertical')) {
                return;
            }
            parent = parent.closest('.mm-panel');
            if (!parent) {
                return;
            }
            var classname = parent.className;
            if (!classname.length) {
                return;
            }
            classname = classname.split('mm-panel_columns-')[1];
            if (!classname) {
                return;
            }
            var colnr = parseInt(classname.split(' ')[0], 10) + 1;
            while (colnr > 0) {
                panel = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel_columns-' + colnr)[0];
                if (panel) {
                    colnr++;
                    panel.classList.add('mm-hidden');
                    //  IE11:
                    rmvc.forEach(function (classname) {
                        panel.classList.remove(classname);
                    });
                    //  Better browsers:
                    // panel.classList.remove(...rmvc);
                }
                else {
                    colnr = -1;
                    break;
                }
            }
        });
        this.bind('openPanel:start', function (panel) {
            if (panel) {
                /** The parent panel. */
                var parent_1 = panel['mmParent'];
                if (parent_1 &&
                    parent_1.classList.contains('mm-listitem_vertical')) {
                    return;
                }
            }
            var columns = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel_opened-parent').length;
            if (!panel.matches('.mm-panel_opened-parent')) {
                columns++;
            }
            columns = Math.min(options.visible.max, Math.max(options.visible.min, columns));
            //  IE11:
            colm.forEach(function (classname) {
                _this.node.menu.classList.remove(classname);
            });
            //  Better browsers:
            // this.node.menu.classList.remove(...colm);
            _this.node.menu.classList.add('mm-menu_columns-' + columns);
            var panels = [];
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel').forEach(function (panel) {
                //  IE11:
                colp.forEach(function (classname) {
                    panel.classList.remove(classname);
                });
                //  Better browsers:
                // panel.classList.remove(...colp);
                if (panel.matches('.mm-panel_opened-parent')) {
                    panels.push(panel);
                }
            });
            panels.push(panel);
            panels.slice(-options.visible.max).forEach(function (panel, p) {
                panel.classList.add('mm-panel_columns-' + p);
            });
        });
    }
});


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_helpers__ = __webpack_require__(13);





//	Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.counters = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
//	Add the classnames.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].configs.classNames.counters = {
    counter: 'Counter',
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.counters);
    this.opts.counters = Object(__WEBPACK_IMPORTED_MODULE_3__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.counters);
    //	Refactor counter class
    this.bind('initListview:after', function (listview) {
        var cntrclss = _this.conf.classNames.counters.counter, counters = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](listview, '.' + cntrclss);
        counters.forEach(function (counter) {
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["i" /* reClass */](counter, cntrclss, 'mm-counter');
        });
    });
    //	Add the counters after a listview is initiated.
    if (options.add) {
        this.bind('initListview:after', function (listview) {
            if (!listview.matches(options.addTo)) {
                return;
            }
            var parent = listview.closest('.mm-panel')['mmParent'];
            if (parent) {
                //	Check if no counter already excists.
                if (!__WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](parent, '.mm-counter').length) {
                    var btn = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](parent, '.mm-btn')[0];
                    if (btn) {
                        btn.prepend(__WEBPACK_IMPORTED_MODULE_2__modules_dom__["b" /* create */]('span.mm-counter'));
                    }
                }
            }
        });
    }
    if (options.count) {
        var count = function (listview) {
            var panels = listview
                ? [listview.closest('.mm-panel')]
                : __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel');
            panels.forEach(function (panel) {
                var parent = panel['mmParent'];
                if (!parent) {
                    return;
                }
                var counter = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](parent, '.mm-counter')[0];
                if (!counter) {
                    return;
                }
                var listitems = [];
                __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](panel, '.mm-listview').forEach(function (listview) {
                    listitems.push.apply(listitems, __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](listview));
                });
                counter.innerHTML = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["c" /* filterLI */](listitems).length.toString();
            });
        };
        this.bind('initListview:after', count);
        this.bind('updateListview', count);
    }
});


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_helpers__ = __webpack_require__(13);





//	Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.dividers = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
//  Add the classnames.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].configs.classNames.divider = 'Divider';
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.dividers);
    this.opts.dividers = Object(__WEBPACK_IMPORTED_MODULE_3__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.dividers);
    //	Refactor divider classname
    this.bind('initListview:after', function (listview) {
        __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](listview).forEach(function (listitem) {
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["i" /* reClass */](listitem, _this.conf.classNames.divider, 'mm-divider');
            if (listitem.matches('.mm-divider')) {
                listitem.classList.remove('mm-listitem');
            }
        });
    });
    //	Add dividers
    if (options.add) {
        this.bind('initListview:after', function (listview) {
            if (!listview.matches(options.addTo)) {
                return;
            }
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](listview, '.mm-divider').forEach(function (divider) {
                divider.remove();
            });
            var lastletter = '', listitems = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](listview);
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["c" /* filterLI */](listitems).forEach(function (listitem) {
                var letter = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](listitem, '.mm-listitem__text')[0]
                    .textContent.trim()
                    .toLowerCase()[0];
                if (letter.length && letter != lastletter) {
                    lastletter = letter;
                    var divider = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["b" /* create */]('li.mm-divider');
                    divider.textContent = letter;
                    listview.insertBefore(divider, listitem);
                }
            });
        });
    }
});


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__drag_open__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_helpers__ = __webpack_require__(13);





//	Add the options and configs.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.drag = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    if (!this.opts.offCanvas) {
        return;
    }
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.drag);
    this.opts.drag = Object(__WEBPACK_IMPORTED_MODULE_3__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.drag);
    //	Drag open the menu
    if (options.open) {
        this.bind('setPage:after', function (page) {
            __WEBPACK_IMPORTED_MODULE_2__drag_open__["a" /* default */].call(_this, options.node || page);
        });
    }
});


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_dragevents_index__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_eventlisteners__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_matchmedia__ = __webpack_require__(74);




/** Instance of the DragEvents class. */
var dragInstance = null;
/** THe node that can be dragged. */
var dragNode = null;
/** How far the page (or menu) can be dragged. */
var maxDistance = 0;
/* harmony default export */ __webpack_exports__["a"] = (function (page) {
    var _this = this;
    /** Variables that vary for each menu position (top, right, bottom, left. front, back). */
    var vars = {};
    /** Whether or not the page or menu is actually being moved. */
    var moving = false;
    /**
     * Add the dragging events.
     */
    var addEvents = function () {
        if (dragNode) {
            //  Prepare the page or menu to be moved.
            __WEBPACK_IMPORTED_MODULE_2__modules_eventlisteners__["b" /* on */](dragNode, 'dragStart', function (evnt) {
                if (evnt['detail'].direction == vars.direction) {
                    moving = true;
                    //  Class prevents interaction with the page.
                    _this.node.wrpr.classList.add('mm-wrapper_dragging');
                    //  Prepare the menu to be opened.
                    _this._openSetup();
                    _this.trigger('open:start');
                    //  Get the maximum distance to move out the page or menu.
                    maxDistance = _this.node.menu[vars.axis == 'x' ? 'clientWidth' : 'clientHeight'];
                }
            });
            //  Move the page or menu when dragging.
            __WEBPACK_IMPORTED_MODULE_2__modules_eventlisteners__["b" /* on */](dragNode, 'dragMove', function (evnt) {
                if (evnt['detail'].axis == vars.axis) {
                    if (moving) {
                        var distance = evnt['detail']['distance' + vars.axis.toUpperCase()];
                        switch (vars.position) {
                            case 'right':
                            case 'bottom':
                                distance = Math.min(Math.max(distance, -maxDistance), 0);
                                break;
                            default:
                                distance = Math.max(Math.min(distance, maxDistance), 0);
                        }
                        //  Deviate for position front (the menu starts out of view).
                        if (vars.zposition == 'front') {
                            switch (vars.position) {
                                case 'right':
                                case 'bottom':
                                    distance += maxDistance;
                                    break;
                                default:
                                    distance -= maxDistance;
                                    break;
                            }
                        }
                        vars.slideOutNodes.forEach(function (node) {
                            node.style['transform'] =
                                'translate' +
                                    vars.axis.toUpperCase() +
                                    '(' +
                                    distance +
                                    'px)';
                        });
                    }
                }
            });
            //  Stop the page or menu from being moved.
            __WEBPACK_IMPORTED_MODULE_2__modules_eventlisteners__["b" /* on */](dragNode, 'dragEnd', function (evnt) {
                if (evnt['detail'].axis == vars.axis) {
                    if (moving) {
                        moving = false;
                        _this.node.wrpr.classList.remove('mm-wrapper_dragging');
                        vars.slideOutNodes.forEach(function (node) {
                            node.style['transform'] = '';
                        });
                        //  Determine if the menu should open or close.
                        var open_1 = Math.abs(evnt['detail']['distance' + vars.axis.toUpperCase()]) >=
                            maxDistance * 0.75;
                        if (!open_1) {
                            var movement = evnt['detail']['movement' + vars.axis.toUpperCase()];
                            switch (vars.position) {
                                case 'right':
                                case 'bottom':
                                    open_1 = movement <= 0;
                                    break;
                                default:
                                    open_1 = movement >= 0;
                                    break;
                            }
                        }
                        if (open_1) {
                            _this._openStart();
                        }
                        else {
                            _this.close();
                        }
                    }
                }
            });
        }
    };
    /**
     * Remove the dragging events.
     */
    var removeEvents = function () {
        if (dragNode) {
            __WEBPACK_IMPORTED_MODULE_2__modules_eventlisteners__["a" /* off */](dragNode, 'dragStart');
            __WEBPACK_IMPORTED_MODULE_2__modules_eventlisteners__["a" /* off */](dragNode, 'dragMove');
            __WEBPACK_IMPORTED_MODULE_2__modules_eventlisteners__["a" /* off */](dragNode, 'dragEnd');
        }
    };
    var addMatchMedia = function () {
        var queries = Object.keys(_this.opts.extensions);
        if (queries.length) {
            //  A media query that'll match if any of the other media query matches:
            //    set the defaults if it doesn't match.
            __WEBPACK_IMPORTED_MODULE_3__modules_matchmedia__["a" /* add */](queries.join(', '), function () { }, function () {
                vars = getPositionVars(vars, [], _this.node.menu);
            });
            //  The other media queries.
            queries.forEach(function (query) {
                __WEBPACK_IMPORTED_MODULE_3__modules_matchmedia__["a" /* add */](query, function () {
                    vars = getPositionVars(vars, _this.opts.extensions[query], _this.node.menu);
                }, function () { });
            });
            //  No extensions, just use the defaults.
        }
        else {
            vars = getPositionVars(vars, [], _this.node.menu);
        }
    };
    //  Remove events from previous "page"
    removeEvents();
    //  Store new "page"
    dragNode = page;
    //  Initialize the drag events.
    dragInstance = new __WEBPACK_IMPORTED_MODULE_0__modules_dragevents_index__["a" /* default */](dragNode);
    addMatchMedia();
    addMatchMedia = function () { };
    addEvents();
});
var getPositionVars = function (vars, extensions, menu) {
    //  Default position and z-position.
    vars.position = 'left';
    vars.zposition = 'back';
    //  Find position.
    ['right', 'top', 'bottom'].forEach(function (pos) {
        if (extensions.indexOf('position-' + pos) > -1) {
            vars.position = pos;
        }
    });
    //  Find z-position.
    ['front', 'top', 'bottom'].forEach(function (pos) {
        if (extensions.indexOf('position-' + pos) > -1) {
            vars.zposition = 'front';
        }
    });
    //  Set the area where the dragging can start.
    dragInstance.area = {
        top: vars.position == 'bottom' ? '75%' : 0,
        right: vars.position == 'left' ? '75%' : 0,
        bottom: vars.position == 'top' ? '75%' : 0,
        left: vars.position == 'right' ? '75%' : 0
    };
    //  What side of the menu to measure (width or height).
    //  What axis to drag the menu along (x or y).
    switch (vars.position) {
        case 'top':
        case 'bottom':
            vars.axis = 'y';
            break;
        default:
            vars.axis = 'x';
    }
    //  What direction to drag in.
    switch (vars.position) {
        case 'top':
            vars.direction = 'Down';
            break;
        case 'right':
            vars.direction = 'Left';
            break;
        case 'bottom':
            vars.direction = 'Up';
            break;
        default:
            vars.direction = 'Right';
    }
    //  What nodes to slide out while dragging.
    switch (vars.zposition) {
        case 'front':
            vars.slideOutNodes = [menu];
            break;
        default:
            vars.slideOutNodes = __WEBPACK_IMPORTED_MODULE_1__modules_dom__["e" /* find */](document.body, '.mm-slideout');
    }
    return vars;
};


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__support__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(13);





var DragEvents = /** @class */ (function () {
    /**
     * Create the gestures.
     * @param {HTMLElement} surface     The surface for the gesture.
     * @param {object}      area        Restriction where on the surface the gesture can be started.
     * @param {object}      treshold    Treshold for the gestures.
     */
    function DragEvents(surface, area, treshold) {
        this.surface = surface;
        this.area = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* extend */])(area, __WEBPACK_IMPORTED_MODULE_1__defaults__["a" /* area */]);
        this.treshold = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* extend */])(treshold, __WEBPACK_IMPORTED_MODULE_1__defaults__["b" /* treshold */]);
        //	Set the mouse/touch events.
        if (!this.surface['mmHasDragEvents']) {
            this.surface.addEventListener(__WEBPACK_IMPORTED_MODULE_0__support__["a" /* touch */] ? 'touchstart' : 'mousedown', this.start.bind(this));
            this.surface.addEventListener(__WEBPACK_IMPORTED_MODULE_0__support__["a" /* touch */] ? 'touchend' : 'mouseup', this.stop.bind(this));
            this.surface.addEventListener(__WEBPACK_IMPORTED_MODULE_0__support__["a" /* touch */] ? 'touchleave' : 'mouseleave', this.stop.bind(this));
            this.surface.addEventListener(__WEBPACK_IMPORTED_MODULE_0__support__["a" /* touch */] ? 'touchmove' : 'mousemove', this.move.bind(this));
        }
        this.surface['mmHasDragEvents'] = true;
    }
    /**
     * Starting the touch gesture.
     * @param {Event} event The touch event.
     */
    DragEvents.prototype.start = function (event) {
        this.currentPosition = {
            x: event.touches ? event.touches[0].pageX : event.pageX || 0,
            y: event.touches ? event.touches[0].pageY : event.pageY || 0
        };
        /** The widht of the surface. */
        var width = this.surface.clientWidth;
        /** The height of the surface. */
        var height = this.surface.clientHeight;
        //  Check if the gesture started below the area.top.
        var top = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* percentage2number */])(this.area.top, height);
        if (typeof top == 'number') {
            if (this.currentPosition.y < top) {
                return;
            }
        }
        //  Check if the gesture started before the area.right.
        var right = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* percentage2number */])(this.area.right, width);
        if (typeof right == 'number') {
            right = width - right;
            if (this.currentPosition.x > right) {
                return;
            }
        }
        //  Check if the gesture started above the area.bottom.
        var bottom = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* percentage2number */])(this.area.bottom, height);
        if (typeof bottom == 'number') {
            bottom = height - bottom;
            if (this.currentPosition.y > bottom) {
                return;
            }
        }
        //  Check if the gesture started after the area.left.
        var left = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* percentage2number */])(this.area.left, width);
        if (typeof left == 'number') {
            if (this.currentPosition.x < left) {
                return;
            }
        }
        //	Store the start x- and y-position.
        this.startPosition = {
            x: this.currentPosition.x,
            y: this.currentPosition.y
        };
        //	Set the state of the gesture to "watching".
        this.state = __WEBPACK_IMPORTED_MODULE_2__settings__["b" /* state */].watching;
    };
    /**
     * Stopping the touch gesture.
     * @param {Event} event The touch event.
     */
    DragEvents.prototype.stop = function (event) {
        //	Dispatch the "dragEnd" events.
        if (this.state == __WEBPACK_IMPORTED_MODULE_2__settings__["b" /* state */].dragging) {
            /** The direction. */
            var dragDirection = this._dragDirection();
            /** The event information. */
            var detail = this._eventDetail(dragDirection);
            this._dispatchEvents('drag*End', detail);
            //	Dispatch the "swipe" events.
            if (Math.abs(this.movement[this.axis]) > this.treshold.swipe) {
                /** The direction. */
                var swipeDirection = this._swipeDirection();
                detail.direction = swipeDirection;
                this._dispatchEvents('swipe*', detail);
            }
        }
        //	Set the state of the gesture to "inactive".
        this.state = __WEBPACK_IMPORTED_MODULE_2__settings__["b" /* state */].inactive;
    };
    /**
     * Doing the touch gesture.
     * @param {Event} event The touch event.
     */
    DragEvents.prototype.move = function (event) {
        switch (this.state) {
            case __WEBPACK_IMPORTED_MODULE_2__settings__["b" /* state */].watching:
            case __WEBPACK_IMPORTED_MODULE_2__settings__["b" /* state */].dragging:
                var position = {
                    x: event.changedTouches
                        ? event.touches[0].pageX
                        : event.pageX || 0,
                    y: event.changedTouches
                        ? event.touches[0].pageY
                        : event.pageY || 0
                };
                this.movement = {
                    x: position.x - this.currentPosition.x,
                    y: position.y - this.currentPosition.y
                };
                this.distance = {
                    x: position.x - this.startPosition.x,
                    y: position.y - this.startPosition.y
                };
                this.currentPosition = {
                    x: position.x,
                    y: position.y
                };
                this.axis =
                    Math.abs(this.distance.x) > Math.abs(this.distance.y)
                        ? 'x'
                        : 'y';
                /** The direction. */
                var dragDirection = this._dragDirection();
                /** The event information. */
                var detail = this._eventDetail(dragDirection);
                //	Watching for the gesture to go past the treshold.
                if (this.state == __WEBPACK_IMPORTED_MODULE_2__settings__["b" /* state */].watching) {
                    if (Math.abs(this.distance[this.axis]) > this.treshold.start) {
                        this._dispatchEvents('drag*Start', detail);
                        //	Set the state of the gesture to "inactive".
                        this.state = __WEBPACK_IMPORTED_MODULE_2__settings__["b" /* state */].dragging;
                    }
                }
                //	Dispatch the "drag" events.
                if (this.state == __WEBPACK_IMPORTED_MODULE_2__settings__["b" /* state */].dragging) {
                    this._dispatchEvents('drag*Move', detail);
                }
                break;
        }
    };
    /**
     * Get the event details.
     * @param {string}  direction   Direction for the event (up, right, down, left).
     * @return {object}             The event details.
     */
    DragEvents.prototype._eventDetail = function (direction) {
        var distX = this.distance.x;
        var distY = this.distance.y;
        if (this.axis == 'x') {
            distX -= distX > 0 ? this.treshold.start : 0 - this.treshold.start;
        }
        if (this.axis == 'y') {
            distY -= distY > 0 ? this.treshold.start : 0 - this.treshold.start;
        }
        return {
            axis: this.axis,
            direction: direction,
            movementX: this.movement.x,
            movementY: this.movement.y,
            distanceX: distX,
            distanceY: distY
        };
    };
    /**
     * Dispatch the events
     * @param {string} eventName    The name for the events to dispatch.
     * @param {object} detail       The event details.
     */
    DragEvents.prototype._dispatchEvents = function (eventName, detail) {
        /** General event, e.g. "drag" */
        var event = new CustomEvent(eventName.replace('*', ''), { detail: detail });
        this.surface.dispatchEvent(event);
        /** Axis event, e.g. "dragX" */
        var axis = new CustomEvent(eventName.replace('*', this.axis.toUpperCase()), { detail: detail });
        this.surface.dispatchEvent(axis);
        /** Direction event, e.g. "dragLeft" */
        var direction = new CustomEvent(eventName.replace('*', detail.direction), {
            detail: detail
        });
        this.surface.dispatchEvent(direction);
    };
    /**
     * Get the dragging direction.
     * @return {string} The direction in which the user is dragging.
     */
    DragEvents.prototype._dragDirection = function () {
        return __WEBPACK_IMPORTED_MODULE_2__settings__["a" /* directionNames */][this.axis][this.distance[this.axis] > 0 ? 0 : 1];
    };
    /**
     * Get the dragging direction.
     * @return {string} The direction in which the user is dragging.
     */
    DragEvents.prototype._swipeDirection = function () {
        return __WEBPACK_IMPORTED_MODULE_2__settings__["a" /* directionNames */][this.axis][this.movement[this.axis] > 0 ? 0 : 1];
    };
    return DragEvents;
}());
/* harmony default export */ __webpack_exports__["a"] = (DragEvents);


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return touch; });
/** Whether or not touch gestures are supported by the browser. */
var touch = 'ontouchstart' in window ||
    (navigator.msMaxTouchPoints ? true : false) ||
    false;


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return area; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return treshold; });
/** How far from the sides the gesture can start. */
var area = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
/** Tresholds for gestures. */
var treshold = {
    start: 15,
    swipe: 15
};


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return directionNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/** Names of the possible directions. */
var directionNames = {
    x: ['Right', 'Left'],
    y: ['Down', 'Up']
};
/** States for the gesture. */
var state = {
    inactive: 0,
    watching: 1,
    dragging: 2
};


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return percentage2number; });
/**
 * Calculate a distance from a percentage.
 * @param  {string|number}   position   The percentage (e.g. "75%").
 * @param  {number}          size       The available width or height in pixels.
 * @return {number}                     The calculated distance.
 */
var percentage2number = function (position, size) {
    if (typeof position == 'string') {
        if (position.slice(-1) == '%') {
            position = parseInt(position.slice(0, -1), 10);
            position = size * (position / 100);
        }
    }
    return position;
};


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_helpers__ = __webpack_require__(13);






//	Add the options and configs.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.dropdown = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].configs.dropdown = __WEBPACK_IMPORTED_MODULE_2__configs__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    if (!this.opts.offCanvas) {
        return;
    }
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.dropdown);
    this.opts.dropdown = Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.dropdown);
    var configs = this.conf.dropdown;
    if (!options.drop) {
        return;
    }
    var button;
    this.bind('initMenu:after', function () {
        _this.node.menu.classList.add('mm-menu_dropdown');
        if (typeof options.position.of != 'string') {
            var id = Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["b" /* originalId */])(_this.node.menu.id);
            if (id) {
                options.position.of = '[href="#' + id + '"]';
            }
        }
        if (typeof options.position.of != 'string') {
            return;
        }
        //	Get the button to put the menu next to
        button = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["e" /* find */](document.body, options.position.of)[0];
        //	Emulate hover effect
        var events = options.event.split(' ');
        if (events.length == 1) {
            events[1] = events[0];
        }
        if (events[0] == 'hover') {
            button.addEventListener('mouseenter', function () {
                _this.open();
            }, { passive: true });
        }
        if (events[1] == 'hover') {
            _this.node.menu.addEventListener('mouseleave', function () {
                _this.close();
            }, { passive: true });
        }
    });
    //	Add/remove classname and style when opening/closing the menu
    this.bind('open:start', function () {
        _this.node.menu['mmStyle'] = _this.node.menu.getAttribute('style');
        _this.node.wrpr.classList.add('mm-wrapper_dropdown');
    });
    this.bind('close:finish', function () {
        _this.node.menu.setAttribute('style', _this.node.menu['mmStyle']);
        _this.node.wrpr.classList.remove('mm-wrapper_dropdown');
    });
    /**
     * Find the position (x, y) and sizes (width, height) for the menu.
     *
     * @param  {string} dir The direction to measure ("x" for horizontal, "y" for vertical)
     * @param  {object} obj The object where (previously) measured values are stored.
     * @return {object}		The object where measered values are stored.
     */
    var getPosition = function (dir, obj) {
        var css = obj[0], cls = obj[1];
        var _outerSize = dir == 'x' ? 'offsetWidth' : 'offsetHeight', _startPos = dir == 'x' ? 'left' : 'top', _stopPos = dir == 'x' ? 'right' : 'bottom', _size = dir == 'x' ? 'width' : 'height', _winSize = dir == 'x' ? 'innerWidth' : 'innerHeight', _maxSize = dir == 'x' ? 'maxWidth' : 'maxHeight', _position = null;
        var startPos = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["f" /* offset */](button, _startPos), stopPos = startPos + button[_outerSize], windowSize = window[_winSize];
        /** Offset for the menu relative to the button. */
        var offs = configs.offset.button[dir] + configs.offset.viewport[dir];
        //	Position set in option
        if (options.position[dir]) {
            switch (options.position[dir]) {
                case 'left':
                case 'bottom':
                    _position = 'after';
                    break;
                case 'right':
                case 'top':
                    _position = 'before';
                    break;
            }
        }
        //	Position not set in option, find most space
        if (_position === null) {
            _position =
                startPos + (stopPos - startPos) / 2 < windowSize / 2
                    ? 'after'
                    : 'before';
        }
        //	Set position and max
        var val, max;
        if (_position == 'after') {
            val = dir == 'x' ? startPos : stopPos;
            max = windowSize - (val + offs);
            css[_startPos] = val + configs.offset.button[dir] + 'px';
            css[_stopPos] = 'auto';
            if (options.tip) {
                cls.push('mm-menu_tip-' + (dir == 'x' ? 'left' : 'top'));
            }
        }
        else {
            val = dir == 'x' ? stopPos : startPos;
            max = val - offs;
            css[_stopPos] =
                'calc( 100% - ' + (val - configs.offset.button[dir]) + 'px )';
            css[_startPos] = 'auto';
            if (options.tip) {
                cls.push('mm-menu_tip-' + (dir == 'x' ? 'right' : 'bottom'));
            }
        }
        if (options.fitViewport) {
            css[_maxSize] = Math.min(configs[_size].max, max) + 'px';
        }
        return [css, cls];
    };
    function position() {
        var _this = this;
        if (!this.vars.opened) {
            return;
        }
        this.node.menu.setAttribute('style', this.node.menu['mmStyle']);
        var obj = [{}, []];
        obj = getPosition.call(this, 'y', obj);
        obj = getPosition.call(this, 'x', obj);
        for (var s in obj[0]) {
            this.node.menu.style[s] = obj[0][s];
        }
        if (options.tip) {
            var classnames = [
                'mm-menu_tip-left',
                'mm-menu_tip-right',
                'mm-menu_tip-top',
                'mm-menu_tip-bottom'
            ];
            //  IE11:
            classnames.forEach(function (classname) {
                _this.node.menu.classList.remove(classname);
            });
            obj[1].forEach(function (classname) {
                _this.node.menu.classList.add(classname);
            });
            //  Better browsers:
            // this.node.menu.classList.remove(...classnames);
            // this.node.menu.classList.add(...obj[1]);
        }
    }
    this.bind('open:start', position);
    window.addEventListener('resize', function (evnt) {
        position.call(_this);
    }, { passive: true });
    if (!this.opts.offCanvas.blockUI) {
        window.addEventListener('scroll', function (evnt) {
            position.call(_this);
        }, { passive: true });
    }
});


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var configs = {
    offset: {
        button: {
            x: -5,
            y: 5
        },
        viewport: {
            x: 20,
            y: 20
        }
    },
    height: {
        max: 880
    },
    width: {
        max: 440
    }
};
/* harmony default export */ __webpack_exports__["a"] = (configs);


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configs__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);



//	Add the configs.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].configs.fixedElements = __WEBPACK_IMPORTED_MODULE_1__configs__["a" /* default */];
//	Add the classnames.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].configs.classNames.fixedElements = {
    fixed: 'Fixed'
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    if (!this.opts.offCanvas) {
        return;
    }
    var configs = this.conf.fixedElements;
    var _fixd, fixed, wrppr;
    this.bind('setPage:after', function (page) {
        _fixd = _this.conf.classNames.fixedElements.fixed;
        wrppr = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](document, configs.insertSelector)[0];
        fixed = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](page, '.' + _fixd);
        fixed.forEach(function (fxd) {
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["i" /* reClass */](fxd, _fixd, 'mm-slideout');
            wrppr[configs.insertMethod](fxd);
        });
    });
});


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var configs = {
    insertMethod: 'append',
    insertSelector: 'body'
};
/* harmony default export */ __webpack_exports__["a"] = (configs);


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_matchmedia__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_helpers__ = __webpack_require__(13);






//  Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.iconbar = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.iconbar);
    this.opts.iconbar = Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.iconbar);
    if (!options.use) {
        return;
    }
    var iconbar;
    ['top', 'bottom'].forEach(function (position, n) {
        var ctnt = options[position];
        //	Extend shorthand options
        if (Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["e" /* type */])(ctnt) != 'array') {
            ctnt = [ctnt];
        }
        //	Create node
        var part = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["b" /* create */]('div.mm-iconbar__' + position);
        //	Add content
        for (var c = 0, l = ctnt.length; c < l; c++) {
            if (typeof ctnt[c] == 'string') {
                part.innerHTML += ctnt[c];
            }
            else {
                part.append(ctnt[c]);
            }
        }
        if (part.children.length) {
            if (!iconbar) {
                iconbar = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["b" /* create */]('div.mm-iconbar');
            }
            iconbar.append(part);
        }
    });
    //	Add to menu
    if (iconbar) {
        //	Add the iconbar.
        this.bind('initMenu:after', function () {
            _this.node.menu.prepend(iconbar);
        });
        //	En-/disable the iconbar.
        var classname_1 = 'mm-menu_iconbar-' + options.position;
        var enable = function () {
            _this.node.menu.classList.add(classname_1);
            __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(iconbar, 'hidden', false);
        };
        var disable = function () {
            _this.node.menu.classList.remove(classname_1);
            __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(iconbar, 'hidden', true);
        };
        if (typeof options.use == 'boolean') {
            this.bind('initMenu:after', enable);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_3__modules_matchmedia__["a" /* add */](options.use, enable, disable);
        }
        //	Tabs
        if (options.type == 'tabs') {
            iconbar.classList.add('mm-iconbar_tabs');
            iconbar.addEventListener('click', function (evnt) {
                var anchor = evnt.target;
                if (!anchor.matches('a')) {
                    return;
                }
                if (anchor.matches('.mm-iconbar__tab_selected')) {
                    evnt.stopImmediatePropagation();
                    return;
                }
                try {
                    var panel = _this.node.menu.querySelector(anchor.getAttribute('href'))[0];
                    if (panel && panel.matches('.mm-panel')) {
                        evnt.preventDefault();
                        evnt.stopImmediatePropagation();
                        _this.openPanel(panel, false);
                    }
                }
                catch (err) { }
            });
            var selectTab_1 = function (panel) {
                __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](iconbar, 'a').forEach(function (anchor) {
                    anchor.classList.remove('mm-iconbar__tab_selected');
                });
                var anchor = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](iconbar, '[href="#' + panel.id + '"]')[0];
                if (anchor) {
                    anchor.classList.add('mm-iconbar__tab_selected');
                }
                else {
                    var parent_1 = panel['mmParent'];
                    if (parent_1) {
                        selectTab_1(parent_1.closest('.mm-panel'));
                    }
                }
            };
            this.bind('openPanel:start', selectTab_1);
        }
    }
});


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_helpers__ = __webpack_require__(13);





//	Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.iconPanels = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.iconPanels);
    this.opts.iconPanels = Object(__WEBPACK_IMPORTED_MODULE_3__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.iconPanels);
    var keepFirst = false;
    if (options.visible == 'first') {
        keepFirst = true;
        options.visible = 1;
    }
    options.visible = Math.min(3, Math.max(1, options.visible));
    options.visible++;
    //	Add the iconpanels
    if (options.add) {
        this.bind('initMenu:after', function () {
            var classnames = ['mm-menu_iconpanel'];
            if (options.hideNavbar) {
                classnames.push('mm-menu_hidenavbar');
            }
            if (options.hideDivider) {
                classnames.push('mm-menu_hidedivider');
            }
            //  IE11:
            classnames.forEach(function (classname) {
                _this.node.menu.classList.add(classname);
            });
            //  Better browsers:
            // this.node.menu.classList.add(...classnames);
        });
        var classnames_1 = [];
        if (!keepFirst) {
            for (var i = 0; i <= options.visible; i++) {
                classnames_1.push('mm-panel_iconpanel-' + i);
            }
        }
        this.bind('openPanel:start', function (panel) {
            var panels = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel');
            panel = panel || panels[0];
            if (panel.parentElement.matches('.mm-listitem_vertical')) {
                return;
            }
            if (keepFirst) {
                panels.forEach(function (panel, p) {
                    panel.classList[p == 0 ? 'add' : 'remove']('mm-panel_iconpanel-first');
                });
            }
            else {
                //	Remove the "iconpanel" classnames from all panels.
                panels.forEach(function (panel) {
                    //  IE11:
                    classnames_1.forEach(function (classname) {
                        panel.classList.remove(classname);
                    });
                    //  Better browsers:
                    // panel.classList.remove(...classnames);
                });
                //	Filter out panels that are not opened.
                panels = panels.filter(function (panel) {
                    return panel.matches('.mm-panel_opened-parent');
                });
                //	Add the current panel to the list.
                var panelAdded_1 = false;
                panels.forEach(function (elem) {
                    if (panel === elem) {
                        panelAdded_1 = true;
                    }
                });
                if (!panelAdded_1) {
                    panels.push(panel);
                }
                //	Remove the "hidden" classname from all opened panels.
                panels.forEach(function (panel) {
                    panel.classList.remove('mm-hidden');
                });
                //	Slice the opened panels to the max visible amount.
                panels = panels.slice(-options.visible);
                //	Add the "iconpanel" classnames.
                panels.forEach(function (panel, p) {
                    panel.classList.add('mm-panel_iconpanel-' + p);
                });
            }
        });
        this.bind('initPanel:after', function (panel) {
            if (options.blockPanel &&
                !panel.parentElement.matches('.mm-listitem_vertical') &&
                !__WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](panel, '.mm-panel__blocker')[0]) {
                var blocker = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["b" /* create */]('a.mm-panel__blocker');
                blocker.setAttribute('href', '#' + panel.closest('.mm-panel').id);
                panel.prepend(blocker);
            }
        });
    }
});


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_eventlisteners__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_support__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_helpers__ = __webpack_require__(13);







//  Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.keyboardNavigation = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    //	Keyboard navigation on touchscreens opens the virtual keyboard :/
    //	Lets prevent that.
    if (__WEBPACK_IMPORTED_MODULE_4__modules_support__["a" /* touch */]) {
        return;
    }
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.keyboardNavigation);
    this.opts.keyboardNavigation = Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.keyboardNavigation);
    //	Enable keyboard navigation
    if (options.enable) {
        var menuStart_1 = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["b" /* create */]('button.mm-tabstart.mm-sronly'), menuEnd_1 = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["b" /* create */]('button.mm-tabend.mm-sronly'), blockerEnd_1 = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["b" /* create */]('button.mm-tabend.mm-sronly');
        this.bind('initMenu:after', function () {
            if (options.enhance) {
                _this.node.menu.classList.add('mm-menu_keyboardfocus');
            }
            initWindow.call(_this, options.enhance);
        });
        this.bind('initOpened:before', function () {
            _this.node.menu.prepend(menuStart_1);
            _this.node.menu.append(menuEnd_1);
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.menu, '.mm-navbars-top, .mm-navbars-bottom').forEach(function (navbars) {
                navbars.querySelectorAll('.mm-navbar__title').forEach(function (title) {
                    title.setAttribute('tabindex', '-1');
                });
            });
        });
        this.bind('initBlocker:after', function () {
            __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].node.blck.append(blockerEnd_1);
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].node.blck, 'a')[0].classList.add('mm-tabstart');
        });
        var focusable_1 = 'input, select, textarea, button, label, a[href]';
        var setFocus = function (panel) {
            panel =
                panel || __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel_opened')[0];
            var focus = null;
            //	Focus already is on an element in a navbar in this menu.
            var navbar = document.activeElement.closest('.mm-navbar');
            if (navbar) {
                if (navbar.closest('.mm-menu') == _this.node.menu) {
                    return;
                }
            }
            //	Set the focus to the first focusable element by default.
            if (options.enable == 'default') {
                //	First visible anchor in a listview in the current panel.
                focus = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](panel, '.mm-listview a[href]:not(.mm-hidden)')[0];
                //	First focusable and visible element in the current panel.
                if (!focus) {
                    focus = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](panel, focusable_1 + ':not(.mm-hidden)')[0];
                }
                //	First focusable and visible element in a navbar.
                if (!focus) {
                    var elements_1 = [];
                    __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.menu, '.mm-navbars_top, .mm-navbars_bottom').forEach(function (navbar) {
                        elements_1.push.apply(elements_1, __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](navbar, focusable_1 + ':not(.mm-hidden)'));
                    });
                    focus = elements_1[0];
                }
            }
            //	Default.
            if (!focus) {
                focus = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.menu, '.mm-tabstart')[0];
            }
            if (focus) {
                focus.focus();
            }
        };
        this.bind('open:finish', setFocus);
        this.bind('openPanel:finish', setFocus);
        //	Add screenreader / aria support.
        this.bind('initOpened:after:sr-aria', function () {
            [_this.node.menu, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].node.blck].forEach(function (element) {
                __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](element, '.mm-tabstart, .mm-tabend').forEach(function (tabber) {
                    __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(tabber, 'hidden', true);
                    __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_role(tabber, 'presentation');
                });
            });
        });
    }
});
/**
 * Initialize the window for keyboard navigation.
 * @param {boolean} enhance - Whether or not to also rich enhance the keyboard behavior.
 **/
var initWindow = function (enhance) {
    var _this = this;
    //	Re-enable tabbing in general
    __WEBPACK_IMPORTED_MODULE_3__modules_eventlisteners__["a" /* off */](document.body, 'keydown.tabguard');
    //	Intersept the target when tabbing.
    __WEBPACK_IMPORTED_MODULE_3__modules_eventlisteners__["a" /* off */](document.body, 'focusin.tabguard');
    __WEBPACK_IMPORTED_MODULE_3__modules_eventlisteners__["b" /* on */](document.body, 'focusin.tabguard', function (evnt) {
        if (_this.node.wrpr.matches('.mm-wrapper_opened')) {
            var target = evnt.target;
            if (target.matches('.mm-tabend')) {
                var next = void 0;
                //	Jump from menu to blocker.
                if (target.parentElement.matches('.mm-menu')) {
                    if (__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].node.blck) {
                        next = __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].node.blck;
                    }
                }
                //	Jump to opened menu.
                if (target.parentElement.matches('.mm-wrapper__blocker')) {
                    next = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](document.body, '.mm-menu_offcanvas.mm-menu_opened')[0];
                }
                //	If no available element found, stay in current element.
                if (!next) {
                    next = target.parentElement;
                }
                if (next) {
                    __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](next, '.mm-tabstart')[0].focus();
                }
            }
        }
    });
    //	Add Additional keyboard behavior.
    __WEBPACK_IMPORTED_MODULE_3__modules_eventlisteners__["a" /* off */](document.body, 'keydown.navigate');
    __WEBPACK_IMPORTED_MODULE_3__modules_eventlisteners__["b" /* on */](document.body, 'keydown.navigate', function (evnt) {
        var target = evnt.target;
        var menu = target.closest('.mm-menu');
        if (menu) {
            var api = menu['mmApi'];
            if (!target.matches('input, textarea')) {
                switch (evnt.keyCode) {
                    //	press enter to toggle and check
                    case 13:
                        if (target.matches('.mm-toggle') ||
                            target.matches('.mm-check')) {
                            target.dispatchEvent(new Event('click'));
                        }
                        break;
                    //	prevent spacebar or arrows from scrolling the page
                    case 32: //	space
                    case 37: //	left
                    case 38: //	top
                    case 39: //	right
                    case 40: //	bottom
                        evnt.preventDefault();
                        break;
                }
            }
            if (enhance) {
                //	special case for input
                if (target.matches('input')) {
                    switch (evnt.keyCode) {
                        //	empty searchfield with esc
                        case 27:
                            target.value = '';
                            break;
                    }
                }
                else {
                    var api_1 = menu['mmApi'];
                    switch (evnt.keyCode) {
                        //	close submenu with backspace
                        case 8:
                            var parent_1 = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](menu, '.mm-panel_opened')[0]['mmParent'];
                            if (parent_1) {
                                api_1.openPanel(parent_1.closest('.mm-panel'));
                            }
                            break;
                        //	close menu with esc
                        case 27:
                            if (menu.matches('.mm-menu_offcanvas')) {
                                api_1.close();
                            }
                            break;
                    }
                }
            }
        }
    });
};


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_helpers__ = __webpack_require__(13);





//	Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.lazySubmenus = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.lazySubmenus);
    this.opts.lazySubmenus = Object(__WEBPACK_IMPORTED_MODULE_3__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.lazySubmenus);
    if (options.load) {
        //	Prevent all sub panels from being initialized.
        this.bind('initPanels:before', function () {
            var panels = [];
            //	Find all potential subpanels.
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](_this.node.pnls, 'li').forEach(function (listitem) {
                panels.push.apply(panels, __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](listitem, _this.conf.panelNodetype.join(', ')));
            });
            //	Filter out all non-panels and add the lazyload classes
            panels
                .filter(function (panel) { return !panel.matches('.mm-listview_inset'); })
                .filter(function (panel) { return !panel.matches('.mm-nolistview'); })
                .filter(function (panel) { return !panel.matches('.mm-nopanel'); })
                .forEach(function (panel) {
                var classnames = [
                    'mm-panel_lazysubmenu',
                    'mm-nolistview',
                    'mm-nopanel',
                ];
                //  IE11:
                classnames.forEach(function (classname) {
                    panel.classList.add(classname);
                });
                //  Better browsers:
                // panel.classList.add(...classnames);
            });
        });
        //	re-enable the default opened panel to be initialized.
        this.bind('initPanels:before', function () {
            var panels = [];
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](_this.node.pnls, '.' + _this.conf.classNames.selected).forEach(function (listitem) {
                panels.push.apply(panels, __WEBPACK_IMPORTED_MODULE_2__modules_dom__["g" /* parents */](listitem, '.mm-panel_lazysubmenu'));
            });
            if (panels.length) {
                panels.forEach(function (panel) {
                    console.log(panel);
                    var classnames = [
                        'mm-panel_lazysubmenu',
                        'mm-nolistview',
                        'mm-nopanel',
                    ];
                    //  IE11:
                    classnames.forEach(function (classname) {
                        panel.classList.remove(classname);
                    });
                    //  Better browsers:
                    // panel.classList.remove(...classnames);
                });
            }
        });
        //	initPanel for current- and sub panels before openPanel
        this.bind('openPanel:before', function (panel) {
            var panels = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](panel, '.mm-panel_lazysubmenu').filter(function (panel) {
                return !panel.matches('.mm-panel_lazysubmenu .mm-panel_lazysubmenu');
            });
            if (panel.matches('.mm-panel_lazysubmenu')) {
                panels.unshift(panel);
            }
            panels.forEach(function (panel) {
                var classnames = [
                    'mm-panel_lazysubmenu',
                    'mm-nolistview',
                    'mm-nopanel',
                ];
                //  IE11:
                classnames.forEach(function (classname) {
                    panel.classList.remove(classname);
                });
                //  Better browsers:
                // child.classList.remove(...classnames);
                _this.initPanel(panel);
            });
        });
    }
});


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Navbars;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_matchmedia__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navbar_breadcrumbs__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navbar_close__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navbar_prev__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__navbar_searchfield__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__navbar_title__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__navbar_tabs__ = __webpack_require__(540);






//  Add the options and configs.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.navbars = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].configs.navbars = __WEBPACK_IMPORTED_MODULE_2__configs__["a" /* default */];
//  Add the classnames.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].configs.classNames.navbars = {
    panelPrev: 'Prev',
    panelTitle: 'Title'
};





Navbars.navbarContents = {
    breadcrumbs: __WEBPACK_IMPORTED_MODULE_5__navbar_breadcrumbs__["a" /* default */],
    close: __WEBPACK_IMPORTED_MODULE_6__navbar_close__["a" /* default */],
    prev: __WEBPACK_IMPORTED_MODULE_7__navbar_prev__["a" /* default */],
    searchfield: __WEBPACK_IMPORTED_MODULE_8__navbar_searchfield__["a" /* default */],
    title: __WEBPACK_IMPORTED_MODULE_9__navbar_title__["a" /* default */]
};

Navbars.navbarTypes = {
    tabs: __WEBPACK_IMPORTED_MODULE_10__navbar_tabs__["a" /* default */]
};
function Navbars() {
    var _this = this;
    var navs = this.opts.navbars;
    if (typeof navs == 'undefined') {
        return;
    }
    if (!(navs instanceof Array)) {
        navs = [navs];
    }
    var navbars = {};
    if (!navs.length) {
        return;
    }
    navs.forEach(function (options) {
        options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(options);
        if (!options.use) {
            return false;
        }
        //	Create the navbar element.
        var navbar = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('div.mm-navbar');
        //	Get the position for the navbar.
        var position = options.position;
        //	Restrict the position to either "bottom" or "top" (default).
        if (position !== 'bottom') {
            position = 'top';
        }
        //	Create the wrapper for the navbar position.
        if (!navbars[position]) {
            navbars[position] = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('div.mm-navbars_' + position);
        }
        navbars[position].append(navbar);
        //	Add content to the navbar.
        for (var c = 0, l = options.content.length; c < l; c++) {
            var ctnt = options.content[c];
            //	The content is a string.
            if (typeof ctnt == 'string') {
                var func = Navbars.navbarContents[ctnt];
                //	The content refers to one of the navbar-presets ("prev", "title", etc).
                if (typeof func == 'function') {
                    //	Call the preset function.
                    func.call(_this, navbar);
                    //	The content is just HTML.
                }
                else {
                    //	Add the HTML.
                    //  Wrap the HTML in a single node
                    var node = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["b" /* create */]('span');
                    node.innerHTML = ctnt;
                    //  If there was only a single node, use that.
                    var children = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](node);
                    if (children.length == 1) {
                        node = children[0];
                    }
                    navbar.append(node);
                }
                //	The content is not a string, it must be an element.
            }
            else {
                navbar.append(ctnt);
            }
        }
        //	The type option is set.
        if (typeof options.type == 'string') {
            //	The function refers to one of the navbar-presets ("tabs").
            var func = Navbars.navbarTypes[options.type];
            if (typeof func == 'function') {
                //	Call the preset function.
                func.call(_this, navbar);
            }
        }
        //	En-/disable the navbar.
        var enable = function () {
            navbar.classList.remove('mm-hidden');
            __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(navbar, 'hidden', false);
        };
        var disable = function () {
            navbar.classList.add('mm-hidden');
            __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(navbar, 'hidden', true);
        };
        if (typeof options.use != 'boolean') {
            __WEBPACK_IMPORTED_MODULE_4__modules_matchmedia__["a" /* add */](options.use, enable, disable);
        }
    });
    //	Add to menu.
    this.bind('initMenu:after', function () {
        for (var position in navbars) {
            _this.node.menu[position == 'bottom' ? 'append' : 'prepend'](navbars[position]);
        }
    });
}


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var configs = {
    breadcrumbs: {
        separator: '/',
        removeFirst: false
    }
};
/* harmony default export */ __webpack_exports__["a"] = (configs);


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_dom__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = (function (navbar) {
    var _this = this;
    //	Add content
    var breadcrumbs = __WEBPACK_IMPORTED_MODULE_1__modules_dom__["b" /* create */]('div.mm-navbar__breadcrumbs');
    navbar.append(breadcrumbs);
    this.bind('initNavbar:after', function (panel) {
        if (panel.querySelector('.mm-navbar__breadcrumbs')) {
            return;
        }
        __WEBPACK_IMPORTED_MODULE_1__modules_dom__["a" /* children */](panel, '.mm-navbar')[0].classList.add('mm-hidden');
        var crumbs = [], breadcrumbs = __WEBPACK_IMPORTED_MODULE_1__modules_dom__["b" /* create */]('span.mm-navbar__breadcrumbs'), current = panel, first = true;
        while (current) {
            current = current.closest('.mm-panel');
            if (!current.parentElement.matches('.mm-listitem_vertical')) {
                var title = __WEBPACK_IMPORTED_MODULE_1__modules_dom__["e" /* find */](current, '.mm-navbar__title span')[0];
                if (title) {
                    var text = title.textContent;
                    if (text.length) {
                        crumbs.unshift(first
                            ? '<span>' + text + '</span>'
                            : '<a href="#' +
                                current.id +
                                '">' +
                                text +
                                '</a>');
                    }
                }
                first = false;
            }
            current = current['mmParent'];
        }
        if (_this.conf.navbars.breadcrumbs.removeFirst) {
            crumbs.shift();
        }
        breadcrumbs.innerHTML = crumbs.join('<span class="mm-separator">' +
            _this.conf.navbars.breadcrumbs.separator +
            '</span>');
        __WEBPACK_IMPORTED_MODULE_1__modules_dom__["a" /* children */](panel, '.mm-navbar')[0].append(breadcrumbs);
    });
    //	Update for to opened panel
    this.bind('openPanel:start', function (panel) {
        var crumbs = panel.querySelector('.mm-navbar__breadcrumbs');
        breadcrumbs.innerHTML = crumbs ? crumbs.innerHTML : '';
    });
    //	Add screenreader / aria support
    this.bind('initNavbar:after:sr-aria', function (panel) {
        __WEBPACK_IMPORTED_MODULE_1__modules_dom__["e" /* find */](panel, '.mm-breadcrumbs a').forEach(function (anchor) {
            __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(anchor, 'owns', anchor.getAttribute('href').slice(1));
        });
    });
});


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_dom__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = (function (navbar) {
    var _this = this;
    //	Add content
    var close = __WEBPACK_IMPORTED_MODULE_1__modules_dom__["b" /* create */]('a.mm-btn.mm-btn_close.mm-navbar__btn');
    navbar.append(close);
    //	Update to page node
    this.bind('setPage:after', function (page) {
        close.setAttribute('href', '#' + page.id);
    });
    //	Add screenreader / text support
    this.bind('setPage:after:sr-text', function () {
        close.innerHTML = __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_text(_this.i18n(_this.conf.screenReader.text.closeMenu));
    });
});


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_dom__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = (function (navbar) {
    var _this = this;
    //	Add content.
    var prev = __WEBPACK_IMPORTED_MODULE_1__modules_dom__["b" /* create */]('a.mm-btn.mm-btn_prev.mm-navbar__btn');
    navbar.append(prev);
    this.bind('initNavbar:after', function (panel) {
        __WEBPACK_IMPORTED_MODULE_1__modules_dom__["a" /* children */](panel, '.mm-navbar')[0].classList.add('mm-hidden');
    });
    //	Update to opened panel.
    var org;
    var _url, _txt;
    this.bind('openPanel:start', function (panel) {
        if (panel.parentElement.matches('.mm-listitem_vertical')) {
            return;
        }
        org = panel.querySelector('.' + _this.conf.classNames.navbars.panelPrev);
        if (!org) {
            org = panel.querySelector('.mm-navbar__btn.mm-btn_prev');
        }
        _url = org ? org.getAttribute('href') : '';
        _txt = org ? org.innerHTML : '';
        if (_url) {
            prev.setAttribute('href', _url);
        }
        else {
            prev.removeAttribute('href');
        }
        prev.classList[_url || _txt ? 'remove' : 'add']('mm-hidden');
        prev.innerHTML = _txt;
    });
    //	Add screenreader / aria support
    this.bind('initNavbar:after:sr-aria', function (panel) {
        __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(panel.querySelector('.mm-navbar'), 'hidden', true);
    });
    this.bind('openPanel:start:sr-aria', function (panel) {
        __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(prev, 'hidden', prev.matches('.mm-hidden'));
        __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(prev, 'owns', (prev.getAttribute('href') || '').slice(1));
    });
});


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_helpers__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = (function (navbar) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__modules_helpers__["e" /* type */])(this.opts.searchfield) != 'object') {
        this.opts.searchfield = {};
    }
    var searchfield = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["b" /* create */]('div.mm-navbar__searchfield');
    navbar.append(searchfield);
    this.opts.searchfield.add = true;
    this.opts.searchfield.addTo = [searchfield];
});


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_dom__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = (function (navbar) {
    var _this = this;
    //	Add content to the navbar.
    var title = __WEBPACK_IMPORTED_MODULE_1__modules_dom__["b" /* create */]('a.mm-navbar__title');
    var titleText = __WEBPACK_IMPORTED_MODULE_1__modules_dom__["b" /* create */]('span');
    title.append(titleText);
    navbar.append(title);
    //	Update the title to the opened panel.
    var _url, _txt;
    var original;
    this.bind('openPanel:start', function (panel) {
        //	Do nothing in a vertically expanding panel.
        if (panel.parentElement.matches('.mm-listitem_vertical')) {
            return;
        }
        //	Find the original title in the opened panel.
        original = panel.querySelector('.' + _this.conf.classNames.navbars.panelTitle);
        if (!original) {
            original = panel.querySelector('.mm-navbar__title span');
        }
        //	Get the URL for the title.
        _url =
            original && original.closest('a')
                ? original.closest('a').getAttribute('href')
                : '';
        if (_url) {
            title.setAttribute('href', _url);
        }
        else {
            title.removeAttribute('href');
        }
        //	Get the text for the title.
        _txt = original ? original.innerHTML : '';
        titleText.innerHTML = _txt;
    });
    //	Add screenreader / aria support
    var prev;
    this.bind('openPanel:start:sr-aria', function (panel) {
        if (_this.opts.screenReader.text) {
            if (!prev) {
                var navbars = __WEBPACK_IMPORTED_MODULE_1__modules_dom__["a" /* children */](_this.node.menu, '.mm-navbars_top, .mm-navbars_bottom');
                navbars.forEach(function (navbar) {
                    var btn = navbar.querySelector('.mm-btn_prev');
                    if (btn) {
                        prev = btn;
                    }
                });
            }
            if (prev) {
                var hidden = true;
                if (_this.opts.navbar.titleLink == 'parent') {
                    hidden = !prev.matches('.mm-hidden');
                }
                __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].sr_aria(title, 'hidden', hidden);
            }
        }
    });
});


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_dom__ = __webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = (function (navbar) {
    var _this = this;
    navbar.classList.add('mm-navbar_tabs');
    navbar.parentElement.classList.add('mm-navbars_has-tabs');
    var anchors = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["a" /* children */](navbar, 'a');
    navbar.addEventListener('click', function (evnt) {
        var anchor = evnt.target;
        if (!anchor.matches('a')) {
            return;
        }
        if (anchor.matches('.mm-navbar__tab_selected')) {
            evnt.stopImmediatePropagation();
            return;
        }
        try {
            _this.openPanel(_this.node.menu.querySelector(anchor.getAttribute('href')), false);
            evnt.stopImmediatePropagation();
        }
        catch (err) { }
    });
    function selectTab(panel) {
        anchors.forEach(function (anchor) {
            anchor.classList.remove('mm-navbar__tab_selected');
        });
        var anchor = anchors.filter(function (anchor) {
            return anchor.matches('[href="#' + panel.id + '"]');
        })[0];
        if (anchor) {
            anchor.classList.add('mm-navbar__tab_selected');
        }
        else {
            var parent = panel['mmParent'];
            if (parent) {
                selectTab.call(this, parent.closest('.mm-panel'));
            }
        }
    }
    this.bind('openPanel:start', selectTab);
});


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_helpers__ = __webpack_require__(13);






//	Add the options and configs.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.pageScroll = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].configs.pageScroll = __WEBPACK_IMPORTED_MODULE_2__configs__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.pageScroll);
    this.opts.pageScroll = Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.pageScroll);
    var configs = this.conf.pageScroll;
    /** The currently "active" section */
    var section;
    function scrollTo() {
        if (section) {
            // section.scrollIntoView({ behavior: 'smooth' });
            window.scrollTo({
                top: section.getBoundingClientRect().top +
                    document.scrollingElement.scrollTop -
                    configs.scrollOffset,
                behavior: 'smooth'
            });
        }
        section = null;
    }
    function anchorInPage(href) {
        try {
            if (href != '#' && href.slice(0, 1) == '#') {
                return __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].node.page.querySelector(href);
            }
            return null;
        }
        catch (err) {
            return null;
        }
    }
    //	Scroll to section after clicking menu item.
    if (options.scroll) {
        this.bind('close:finish', function () {
            scrollTo();
        });
    }
    //	Add click behavior.
    //	Prevents default behavior when clicking an anchor.
    if (this.opts.offCanvas && options.scroll) {
        this.clck.push(function (anchor, args) {
            section = null;
            //	Don't continue if the clicked anchor is not in the menu.
            if (!args.inMenu) {
                return;
            }
            //	Don't continue if the targeted section is not on the page.
            var href = anchor.getAttribute('href');
            section = anchorInPage(href);
            if (!section) {
                return;
            }
            //	If the sidebar add-on is "expanded"...
            if (_this.node.menu.matches('.mm-menu_sidebar-expanded') &&
                _this.node.wrpr.matches('.mm-wrapper_sidebar-expanded')) {
                //	... scroll the page to the section.
                scrollTo();
                //	... otherwise...
            }
            else {
                //	... close the menu.
                return {
                    close: true
                };
            }
        });
    }
    //	Update selected menu item after scrolling.
    if (options.update) {
        var scts_1 = [];
        this.bind('initListview:after', function (listview) {
            var listitems = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](listview, '.mm-listitem');
            __WEBPACK_IMPORTED_MODULE_3__modules_dom__["d" /* filterLIA */](listitems).forEach(function (anchor) {
                var href = anchor.getAttribute('href');
                var section = anchorInPage(href);
                if (section) {
                    scts_1.unshift(section);
                }
            });
        });
        var _selected_1 = -1;
        window.addEventListener('scroll', function (evnt) {
            var scrollTop = window.scrollY;
            for (var s = 0; s < scts_1.length; s++) {
                if (scts_1[s].offsetTop < scrollTop + configs.updateOffset) {
                    if (_selected_1 !== s) {
                        _selected_1 = s;
                        var panel = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel_opened')[0];
                        var listitems = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["e" /* find */](panel, '.mm-listitem');
                        var anchors = __WEBPACK_IMPORTED_MODULE_3__modules_dom__["d" /* filterLIA */](listitems);
                        anchors = anchors.filter(function (anchor) {
                            return anchor.matches('[href="#' + scts_1[s].id + '"]');
                        });
                        if (anchors.length) {
                            _this.setSelected(anchors[0].parentElement);
                        }
                    }
                    break;
                }
            }
        });
    }
});


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var configs = {
    scrollOffset: 0,
    updateOffset: 50
};
/* harmony default export */ __webpack_exports__["a"] = (configs);


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translations_translate__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_eventlisteners__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_helpers__ = __webpack_require__(13);
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};








//  Add the translations.
Object(__WEBPACK_IMPORTED_MODULE_3__translations_translate__["a" /* default */])();
//  Add the options and configs.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.searchfield = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].configs.searchfield = __WEBPACK_IMPORTED_MODULE_2__configs__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.searchfield);
    this.opts.searchfield = Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.searchfield);
    var configs = this.conf.searchfield;
    if (!options.add) {
        return;
    }
    //	Blur searchfield
    this.bind('close:start', function () {
        __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](_this.node.menu, '.mm-searchfield').forEach(function (input) {
            input.blur();
        });
    });
    this.bind('initPanel:after', function (panel) {
        var searchpanel = null;
        //	Add the search panel
        if (options.panel.add) {
            searchpanel = initSearchPanel.call(_this);
        }
        //	Add the searchfield
        var addTo = null;
        switch (options.addTo) {
            case 'panels':
                addTo = [panel];
                break;
            case 'panel':
                addTo = [searchpanel];
                break;
            default:
                if (typeof options.addTo == 'string') {
                    addTo = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](_this.node.menu, options.addTo);
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["e" /* type */])(options.addTo) == 'array') {
                    addTo = options.addTo;
                }
                break;
        }
        addTo.forEach(function (form) {
            form = initSearchfield.call(_this, form);
            if (options.search && form) {
                initSearching.call(_this, form);
            }
        });
        //	Add the no-results message
        if (options.noResults) {
            initNoResultsMsg.call(_this, options.panel.add ? searchpanel : panel);
        }
    });
    //	Add click behavior.
    //	Prevents default behavior when clicking an anchor
    this.clck.push(function (anchor, args) {
        if (args.inMenu) {
            if (anchor.matches('.mm-searchfield__btn')) {
                //	Clicking the clear button
                if (anchor.matches('.mm-btn_close')) {
                    var form = anchor.closest('.mm-searchfield'), input = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](form, 'input')[0];
                    input.value = '';
                    _this.search(input);
                    return true;
                }
                //	Clicking the submit button
                if (anchor.matches('.mm-btn_next')) {
                    var form = anchor.closest('form');
                    if (form) {
                        form.submit();
                    }
                    return true;
                }
            }
        }
    });
});
var initSearchPanel = function () {
    var options = this.opts.searchfield, configs = this.conf.searchfield;
    var searchpanel = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](this.node.pnls, '.mm-panel_search')[0];
    //	Only once
    if (searchpanel) {
        return searchpanel;
    }
    searchpanel = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]('div.mm-panel.mm-panel_search.mm-hidden');
    if (options.panel.id) {
        searchpanel.id = options.panel.id;
    }
    if (options.panel.title) {
        searchpanel.setAttribute('data-mm-title', options.panel.title);
        // searchpanel.dataset.mmTitle = options.panel.title; // IE10 has no dataset :(
    }
    var listview = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]('ul');
    searchpanel.append(listview);
    this.node.pnls.append(searchpanel);
    this.initListview(listview);
    this._initNavbar(searchpanel);
    switch (options.panel.fx) {
        case false:
            break;
        case 'none':
            searchpanel.classList.add('mm-panel_noanimation');
            break;
        default:
            searchpanel.classList.add('mm-panel_fx-' + options.panel.fx);
            break;
    }
    //	Add splash content
    if (options.panel.splash) {
        var splash = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]('div.mm-panel__content');
        splash.innerHTML = options.panel.splash;
        searchpanel.append(splash);
    }
    searchpanel.classList.add('mm-panel');
    searchpanel.classList.add('mm-hidden');
    this.node.pnls.append(searchpanel);
    return searchpanel;
};
var initSearchfield = function (wrapper) {
    var options = this.opts.searchfield, configs = this.conf.searchfield;
    //	No searchfield in vertical submenus
    if (wrapper.parentElement.matches('.mm-listitem_vertical')) {
        return null;
    }
    //	Only one searchfield per panel
    var form = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](wrapper, '.mm-searchfield')[0];
    if (form) {
        return form;
    }
    function addAttributes(element, attr) {
        if (attr) {
            for (var a in attr) {
                element.setAttribute(a, attr[a]);
            }
        }
    }
    var form = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]((configs.form ? 'form' : 'div') + '.mm-searchfield'), field = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]('div.mm-searchfield__input'), input = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]('input');
    input.type = 'text';
    input.autocomplete = 'off';
    input.placeholder = this.i18n(options.placeholder);
    field.append(input);
    form.append(field);
    wrapper.prepend(form);
    //	Add attributes to the input
    addAttributes(input, configs.input);
    //	Add the clear button
    if (configs.clear) {
        var anchor = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]('a.mm-btn.mm-btn_close.mm-searchfield__btn');
        anchor.setAttribute('href', '#');
        field.append(anchor);
    }
    //	Add attributes and submit to the form
    addAttributes(form, configs.form);
    if (configs.form && configs.submit && !configs.clear) {
        var anchor = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]('a.mm-btn.mm-btn_next.mm-searchfield__btn');
        anchor.setAttribute('href', '#');
        field.append(anchor);
    }
    if (options.cancel) {
        var anchor = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]('a.mm-searchfield__cancel');
        anchor.setAttribute('href', '#');
        anchor.textContent = this.i18n('cancel');
        form.append(anchor);
    }
    return form;
};
var initSearching = function (form) {
    var _this = this;
    var options = this.opts.searchfield, configs = this.conf.searchfield;
    var data = {};
    //	In the searchpanel.
    if (form.closest('.mm-panel_search')) {
        data.panels = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](this.node.pnls, '.mm-panel');
        data.noresults = [form.closest('.mm-panel')];
        //	In a panel
    }
    else if (form.closest('.mm-panel')) {
        data.panels = [form.closest('.mm-panel')];
        data.noresults = data.panels;
        //	Not in a panel, global
    }
    else {
        data.panels = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](this.node.pnls, '.mm-panel');
        data.noresults = [this.node.menu];
    }
    //	Filter out search panel
    data.panels = data.panels.filter(function (panel) { return !panel.matches('.mm-panel_search'); });
    //	Filter out vertical submenus
    data.panels = data.panels.filter(function (panel) { return !panel.parentElement.matches('.mm-listitem_vertical'); });
    //  Find listitems and dividers.
    data.listitems = [];
    data.dividers = [];
    data.panels.forEach(function (panel) {
        var _a, _b;
        (_a = data.listitems).push.apply(_a, __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](panel, '.mm-listitem'));
        (_b = data.dividers).push.apply(_b, __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](panel, '.mm-divider'));
    });
    var searchpanel = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](this.node.pnls, '.mm-panel_search')[0], input = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](form, 'input')[0], cancel = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](form, '.mm-searchfield__cancel')[0];
    input['mmSearchfield'] = data;
    //	Open the splash panel when focussing the input.
    if (options.panel.add && options.panel.splash) {
        __WEBPACK_IMPORTED_MODULE_5__modules_eventlisteners__["a" /* off */](input, 'focus.splash');
        __WEBPACK_IMPORTED_MODULE_5__modules_eventlisteners__["b" /* on */](input, 'focus.splash', function (evnt) {
            _this.openPanel(searchpanel);
        });
    }
    if (options.cancel) {
        //	Show the cancel button when focussing the input.
        __WEBPACK_IMPORTED_MODULE_5__modules_eventlisteners__["a" /* off */](input, 'focus.cancel');
        __WEBPACK_IMPORTED_MODULE_5__modules_eventlisteners__["b" /* on */](input, 'focus.cancel', function (evnt) {
            cancel.classList.add('mm-searchfield__cancel-active');
        });
        //	Close the splash panel when clicking the cancel button.
        __WEBPACK_IMPORTED_MODULE_5__modules_eventlisteners__["a" /* off */](cancel, 'click.splash');
        __WEBPACK_IMPORTED_MODULE_5__modules_eventlisteners__["b" /* on */](cancel, 'click.splash', function (evnt) {
            evnt.preventDefault();
            cancel.classList.remove('mm-searchfield__cancel-active');
            if (searchpanel.matches('.mm-panel_opened')) {
                var parents = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel_opened-parent');
                if (parents.length) {
                    _this.openPanel(parents[parents.length - 1]);
                }
            }
        });
    }
    //	Focus the input in the searchpanel when opening the searchpanel.
    if (options.panel.add && options.addTo == 'panel') {
        this.bind('openPanel:finish', function (panel) {
            if (panel === searchpanel) {
                input.focus();
            }
        });
    }
    //	Search while typing.
    __WEBPACK_IMPORTED_MODULE_5__modules_eventlisteners__["a" /* off */](input, 'input.search');
    __WEBPACK_IMPORTED_MODULE_5__modules_eventlisteners__["b" /* on */](input, 'input.search', function (evnt) {
        switch (evnt.keyCode) {
            case 9: //	tab
            case 16: //	shift
            case 17: //	control
            case 18: //	alt
            case 37: //	left
            case 38: //	top
            case 39: //	right
            case 40: //	bottom
                break;
            default:
                _this.search(input);
                break;
        }
    });
    //	Search initially.
    this.search(input);
};
var initNoResultsMsg = function (wrapper) {
    if (!wrapper) {
        return;
    }
    var options = this.opts.searchfield, configs = this.conf.searchfield;
    //	Not in a panel
    if (!wrapper.closest('.mm-panel')) {
        wrapper = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](this.node.pnls, '.mm-panel')[0];
    }
    //	Only once
    if (__WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](wrapper, '.mm-panel__noresultsmsg').length) {
        return;
    }
    //	Add no-results message
    var message = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]('div.mm-panel__noresultsmsg.mm-hidden');
    message.innerHTML = this.i18n(options.noResults);
    wrapper.append(message);
};
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].prototype.search = function (input, query) {
    var _a;
    var _this = this;
    var options = this.opts.searchfield, configs = this.conf.searchfield;
    query = query || '' + input.value;
    query = query.toLowerCase().trim();
    var data = input['mmSearchfield'];
    var form = input.closest('.mm-searchfield'), buttons = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](form, '.mm-btn'), searchpanel = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](this.node.pnls, '.mm-panel_search')[0];
    /** The panels. */
    var panels = data.panels;
    /** The "no results" messages in a cloned array. */
    var noresults = data.noresults;
    /** The listitems in a cloned array. */
    var listitems = data.listitems;
    /** Tje dividers in a cloned array. */
    var dividers = data.dividers;
    //	Reset previous results
    listitems.forEach(function (listitem) {
        listitem.classList.remove('mm-listitem_nosubitems');
        listitem.classList.remove('mm-listitem_onlysubitems');
        listitem.classList.remove('mm-hidden');
    });
    if (searchpanel) {
        __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](searchpanel, '.mm-listview')[0].innerHTML = '';
    }
    panels.forEach(function (panel) {
        panel.scrollTop = 0;
    });
    //	Search
    if (query.length) {
        //	Initially hide all dividers.
        dividers.forEach(function (divider) {
            divider.classList.add('mm-hidden');
        });
        //	Hide listitems that do not match.
        listitems.forEach(function (listitem) {
            var text = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](listitem, '.mm-listitem__text')[0];
            var add = false;
            //  The listitem should be shown if:
            //          1) The text matches the query and
            //          2a) The text is a open-button and
            //          2b) the option showSubPanels is set to true.
            //      or  3a) The text is not an anchor and
            //          3b) the option showTextItems is set to true.
            //      or  4)  The text is an anchor.
            //  1
            if (text &&
                __WEBPACK_IMPORTED_MODULE_4__modules_dom__["j" /* text */](text)
                    .toLowerCase()
                    .indexOf(query) > -1) {
                //  2a
                if (text.matches('.mm-listitem__btn')) {
                    //  2b
                    if (options.showSubPanels) {
                        add = true;
                    }
                }
                //  3a
                else if (!text.matches('a')) {
                    //  3b
                    if (options.showTextItems) {
                        add = true;
                    }
                }
                // 4
                else {
                    add = true;
                }
            }
            if (!add) {
                listitem.classList.add('mm-hidden');
            }
        });
        /** Whether or not the query yielded results. */
        var hasResults = listitems.filter(function (listitem) { return !listitem.matches('.mm-hidden'); }).length;
        //	Show all mached listitems in the search panel
        if (options.panel.add) {
            //	Clone all matched listitems into the search panel
            var allitems_1 = [];
            panels.forEach(function (panel) {
                var listitems = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["c" /* filterLI */](__WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](panel, '.mm-listitem'));
                listitems = listitems.filter(function (listitem) { return !listitem.matches('.mm-hidden'); });
                if (listitems.length) {
                    //  Add a divider to indicate in what panel the listitems were.
                    if (options.panel.dividers) {
                        var divider = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["b" /* create */]('li.mm-divider');
                        var title = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](panel, '.mm-navbar__title')[0];
                        if (title) {
                            divider.innerHTML = title.innerHTML;
                            allitems_1.push(divider);
                        }
                    }
                    listitems.forEach(function (listitem) {
                        allitems_1.push(listitem.cloneNode(true));
                    });
                }
            });
            //	Remove toggles and checks.
            allitems_1.forEach(function (listitem) {
                listitem
                    .querySelectorAll('.mm-toggle, .mm-check')
                    .forEach(function (element) {
                    element.remove();
                });
            });
            //	Add to the search panel.
            (_a = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](searchpanel, '.mm-listview')[0]).append.apply(_a, allitems_1);
            //	Open the search panel.
            this.openPanel(searchpanel);
        }
        else {
            //	Also show listitems in sub-panels for matched listitems
            if (options.showSubPanels) {
                panels.forEach(function (panel) {
                    var listitems = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](panel, '.mm-listitem');
                    __WEBPACK_IMPORTED_MODULE_4__modules_dom__["c" /* filterLI */](listitems).forEach(function (listitem) {
                        var child = listitem['mmChild'];
                        if (child) {
                            __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](child, '.mm-listitem').forEach(function (listitem) {
                                listitem.classList.remove('mm-hidden');
                            });
                        }
                    });
                });
            }
            //	Update parent for sub-panel
            //  .reverse() mutates the original array, therefor we "clone" it first using [...panels].
            __spreadArrays(panels).reverse().forEach(function (panel, p) {
                var parent = panel['mmParent'];
                if (parent) {
                    //	The current panel has mached listitems
                    var listitems_1 = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](panel, '.mm-listitem');
                    if (__WEBPACK_IMPORTED_MODULE_4__modules_dom__["c" /* filterLI */](listitems_1).length) {
                        //	Show parent
                        if (parent.matches('.mm-hidden')) {
                            parent.classList.remove('mm-hidden');
                        }
                        parent.classList.add('mm-listitem_onlysubitems');
                    }
                    else if (!input.closest('.mm-panel')) {
                        if (panel.matches('.mm-panel_opened') ||
                            panel.matches('.mm-panel_opened-parent')) {
                            //	Compensate the timeout for the opening animation
                            setTimeout(function () {
                                _this.openPanel(parent.closest('.mm-panel'));
                            }, (p + 1) * (_this.conf.openingInterval * 1.5));
                        }
                        parent.classList.add('mm-listitem_nosubitems');
                    }
                }
            });
            //	Show parent panels of vertical submenus
            panels.forEach(function (panel) {
                var listitems = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](panel, '.mm-listitem');
                __WEBPACK_IMPORTED_MODULE_4__modules_dom__["c" /* filterLI */](listitems).forEach(function (listitem) {
                    __WEBPACK_IMPORTED_MODULE_4__modules_dom__["g" /* parents */](listitem, '.mm-listitem_vertical').forEach(function (parent) {
                        if (parent.matches('.mm-hidden')) {
                            parent.classList.remove('mm-hidden');
                            parent.classList.add('mm-listitem_onlysubitems');
                        }
                    });
                });
            });
            //	Show first preceeding divider of parent
            panels.forEach(function (panel) {
                var listitems = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](panel, '.mm-listitem');
                __WEBPACK_IMPORTED_MODULE_4__modules_dom__["c" /* filterLI */](listitems).forEach(function (listitem) {
                    var divider = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["h" /* prevAll */](listitem, '.mm-divider')[0];
                    if (divider) {
                        divider.classList.remove('mm-hidden');
                    }
                });
            });
        }
        //	Show submit / clear button
        buttons.forEach(function (button) { return button.classList.remove('mm-hidden'); });
        //	Show/hide no results message
        noresults.forEach(function (wrapper) {
            __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](wrapper, '.mm-panel__noresultsmsg').forEach(function (message) {
                return message.classList[hasResults ? 'add' : 'remove']('mm-hidden');
            });
        });
        if (options.panel.add) {
            //	Hide splash
            if (options.panel.splash) {
                __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](searchpanel, '.mm-panel__content').forEach(function (splash) {
                    return splash.classList.add('mm-hidden');
                });
            }
            //	Re-show original listitems when in search panel
            listitems.forEach(function (listitem) {
                return listitem.classList.remove('mm-hidden');
            });
            dividers.forEach(function (divider) { return divider.classList.remove('mm-hidden'); });
        }
        //	Don't search
    }
    else {
        //	Show all items
        listitems.forEach(function (listitem) { return listitem.classList.remove('mm-hidden'); });
        dividers.forEach(function (divider) { return divider.classList.remove('mm-hidden'); });
        //	Hide submit / clear button
        buttons.forEach(function (button) { return button.classList.add('mm-hidden'); });
        //	Hide no results message
        noresults.forEach(function (wrapper) {
            __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](wrapper, '.mm-panel__noresultsmsg').forEach(function (message) {
                return message.classList.add('mm-hidden');
            });
        });
        if (options.panel.add) {
            //	Show splash
            if (options.panel.splash) {
                __WEBPACK_IMPORTED_MODULE_4__modules_dom__["e" /* find */](searchpanel, '.mm-panel__content').forEach(function (splash) {
                    return splash.classList.remove('mm-hidden');
                });
                //	Close panel
            }
            else if (!input.closest('.mm-panel_search')) {
                var opened = __WEBPACK_IMPORTED_MODULE_4__modules_dom__["a" /* children */](this.node.pnls, '.mm-panel_opened-parent');
                this.openPanel(opened.slice(-1)[0]);
            }
        }
    }
    //	Update for other addons
    this.trigger('updateListview');
};


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var configs = {
    clear: false,
    form: false,
    input: false,
    submit: false
};
/* harmony default export */ __webpack_exports__["a"] = (configs);


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_i18n__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nl__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fa__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__de__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ru__ = __webpack_require__(549);





/* harmony default export */ __webpack_exports__["a"] = (function () {
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_1__nl__["a" /* default */], 'nl');
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_2__fa__["a" /* default */], 'fa');
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_3__de__["a" /* default */], 'de');
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_i18n__["a" /* add */])(__WEBPACK_IMPORTED_MODULE_4__ru__["a" /* default */], 'ru');
});


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    Search: 'Zoeken',
    'No results found.': 'Geen resultaten gevonden.',
    cancel: 'annuleren'
});


/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    Search: 'جستجو',
    'No results found.': 'نتیجه‌ای یافت نشد.',
    cancel: 'انصراف'
});


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    Search: 'Suche',
    'No results found.': 'Keine Ergebnisse gefunden.',
    cancel: 'beenden'
});


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    Search: 'Найти',
    'No results found.': 'Ничего не найдено.',
    cancel: 'отменить'
});


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_support__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_helpers__ = __webpack_require__(13);






//  Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.sectionIndexer = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.sectionIndexer);
    this.opts.sectionIndexer = Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.sectionIndexer);
    if (!options.add) {
        return;
    }
    this.bind('initPanels:after', function () {
        //	Add the indexer, only if it does not allready excists
        if (!_this.node.indx) {
            var buttons_1 = '';
            'abcdefghijklmnopqrstuvwxyz'.split('').forEach(function (letter) {
                buttons_1 += '<a href="#">' + letter + '</a>';
            });
            var indexer = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["b" /* create */]('div.mm-sectionindexer');
            indexer.innerHTML = buttons_1;
            _this.node.pnls.prepend(indexer);
            _this.node.indx = indexer;
            //	Prevent default behavior when clicking an anchor
            _this.node.indx.addEventListener('click', function (evnt) {
                var anchor = evnt.target;
                if (anchor.matches('a')) {
                    evnt.preventDefault();
                }
            });
            //	Scroll onMouseOver / onTouchStart
            var mouseOverEvent = function (evnt) {
                if (!evnt.target.matches('a')) {
                    return;
                }
                var letter = evnt.target.textContent, panel = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.pnls, '.mm-panel_opened')[0];
                var newTop = -1, oldTop = panel.scrollTop;
                panel.scrollTop = 0;
                __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](panel, '.mm-divider')
                    .filter(function (divider) { return !divider.matches('.mm-hidden'); })
                    .forEach(function (divider) {
                    if (newTop < 0 &&
                        letter ==
                            divider.textContent
                                .trim()
                                .slice(0, 1)
                                .toLowerCase()) {
                        newTop = divider.offsetTop;
                    }
                });
                panel.scrollTop = newTop > -1 ? newTop : oldTop;
            };
            if (__WEBPACK_IMPORTED_MODULE_3__modules_support__["a" /* touch */]) {
                _this.node.indx.addEventListener('touchstart', mouseOverEvent);
                _this.node.indx.addEventListener('touchmove', mouseOverEvent);
            }
            else {
                _this.node.indx.addEventListener('mouseover', mouseOverEvent);
            }
        }
        //	Show or hide the indexer
        _this.bind('openPanel:start', function (panel) {
            var active = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](panel, '.mm-divider').filter(function (divider) { return !divider.matches('.mm-hidden'); }).length;
            _this.node.indx.classList[active ? 'add' : 'remove']('mm-sectionindexer_active');
        });
    });
});


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_helpers__ = __webpack_require__(13);





//	Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.setSelected = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.setSelected);
    this.opts.setSelected = Object(__WEBPACK_IMPORTED_MODULE_3__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.setSelected);
    //	Find current by URL
    if (options.current == 'detect') {
        var findCurrent_1 = function (url) {
            url = url.split('?')[0].split('#')[0];
            var anchor = _this.node.menu.querySelector('a[href="' + url + '"], a[href="' + url + '/"]');
            if (anchor) {
                _this.setSelected(anchor.parentElement);
            }
            else {
                var arr = url.split('/').slice(0, -1);
                if (arr.length) {
                    findCurrent_1(arr.join('/'));
                }
            }
        };
        this.bind('initMenu:after', function () {
            findCurrent_1.call(_this, window.location.href);
        });
        //	Remove current selected item
    }
    else if (!options.current) {
        this.bind('initListview:after', function (listview) {
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](listview, '.mm-listitem_selected').forEach(function (listitem) {
                listitem.classList.remove('mm-listitem_selected');
            });
        });
    }
    //	Add :hover effect on items
    if (options.hover) {
        this.bind('initMenu:after', function () {
            _this.node.menu.classList.add('mm-menu_selected-hover');
        });
    }
    //	Set parent item selected for submenus
    if (options.parent) {
        this.bind('openPanel:finish', function (panel) {
            //	Remove all
            __WEBPACK_IMPORTED_MODULE_2__modules_dom__["e" /* find */](_this.node.pnls, '.mm-listitem_selected-parent').forEach(function (listitem) {
                listitem.classList.remove('mm-listitem_selected-parent');
            });
            //	Move up the DOM tree
            var parent = panel['mmParent'];
            while (parent) {
                if (!parent.matches('.mm-listitem_vertical')) {
                    parent.classList.add('mm-listitem_selected-parent');
                }
                parent = parent.closest('.mm-panel');
                parent = parent['mmParent'];
            }
        });
        this.bind('initMenu:after', function () {
            _this.node.menu.classList.add('mm-menu_selected-parent');
        });
    }
});


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_matchmedia__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_helpers__ = __webpack_require__(13);






//  Add the options.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.sidebar = __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    if (!this.opts.offCanvas) {
        return;
    }
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__options__["b" /* extendShorthandOptions */])(this.opts.sidebar);
    this.opts.sidebar = Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["a" /* extend */])(options, __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].options.sidebar);
    //	Collapsed
    if (options.collapsed.use) {
        //	Make the menu collapsable.
        this.bind('initMenu:after', function () {
            _this.node.menu.classList.add('mm-menu_sidebar-collapsed');
            if (options.collapsed.blockMenu &&
                _this.opts.offCanvas &&
                !__WEBPACK_IMPORTED_MODULE_2__modules_dom__["a" /* children */](_this.node.menu, '.mm-menu__blocker')[0]) {
                var anchor = __WEBPACK_IMPORTED_MODULE_2__modules_dom__["b" /* create */]('a.mm-menu__blocker');
                anchor.setAttribute('href', '#' + _this.node.menu.id);
                _this.node.menu.prepend(anchor);
            }
            if (options.collapsed.hideNavbar) {
                _this.node.menu.classList.add('mm-menu_hidenavbar');
            }
            if (options.collapsed.hideDivider) {
                _this.node.menu.classList.add('mm-menu_hidedivider');
            }
        });
        //	En-/disable the collapsed sidebar.
        var enable = function () {
            _this.node.wrpr.classList.add('mm-wrapper_sidebar-collapsed');
        };
        var disable = function () {
            _this.node.wrpr.classList.remove('mm-wrapper_sidebar-collapsed');
        };
        if (typeof options.collapsed.use == 'boolean') {
            this.bind('initMenu:after', enable);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_3__modules_matchmedia__["a" /* add */](options.collapsed.use, enable, disable);
        }
    }
    //	Expanded
    if (options.expanded.use) {
        //	Make the menu expandable
        this.bind('initMenu:after', function () {
            _this.node.menu.classList.add('mm-menu_sidebar-expanded');
        });
        //	En-/disable the expanded sidebar.
        var enable = function () {
            _this.node.wrpr.classList.add('mm-wrapper_sidebar-expanded');
            if (!_this.node.wrpr.matches('.mm-wrapper_sidebar-closed')) {
                _this.open();
            }
        };
        var disable = function () {
            _this.node.wrpr.classList.remove('mm-wrapper_sidebar-expanded');
            _this.close();
        };
        if (typeof options.expanded.use == 'boolean') {
            this.bind('initMenu:after', enable);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_3__modules_matchmedia__["a" /* add */](options.expanded.use, enable, disable);
        }
        //  Manually en-/disable the expanded sidebar (open / close the menu)
        this.bind('close:start', function () {
            if (_this.node.wrpr.matches('.mm-wrapper_sidebar-expanded')) {
                _this.node.wrpr.classList.add('mm-wrapper_sidebar-closed');
                if (options.expanded.initial == 'remember') {
                    window.localStorage.setItem('mmenuExpandedState', 'closed');
                }
            }
        });
        this.bind('open:start', function () {
            if (_this.node.wrpr.matches('.mm-wrapper_sidebar-expanded')) {
                _this.node.wrpr.classList.remove('mm-wrapper_sidebar-closed');
                if (options.expanded.initial == 'remember') {
                    window.localStorage.setItem('mmenuExpandedState', 'open');
                }
            }
        });
        //  Set the initial state
        var initialState = options.expanded.initial;
        if (options.expanded.initial == 'remember') {
            var state = window.localStorage.getItem('mmenuExpandedState');
            switch (state) {
                case 'open':
                case 'closed':
                    initialState = state;
                    break;
            }
        }
        if (initialState == 'closed') {
            this.bind('initMenu:after', function () {
                _this.node.wrpr.classList.add('mm-wrapper_sidebar-closed');
            });
        }
        //	Add click behavior.
        //	Prevents default behavior when clicking an anchor
        this.clck.push(function (anchor, args) {
            if (args.inMenu && args.inListview) {
                if (_this.node.wrpr.matches('.mm-wrapper_sidebar-expanded')) {
                    return {
                        close: options.expanded.initial == 'closed'
                    };
                }
            }
        });
    }
});


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_dom__ = __webpack_require__(9);


//	Add the classnames.
__WEBPACK_IMPORTED_MODULE_0__core_oncanvas_mmenu_oncanvas__["a" /* default */].configs.classNames.toggles = {
    toggle: 'Toggle',
    check: 'Check'
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    this.bind('initPanel:after', function (panel) {
        //	Refactor toggle classes
        __WEBPACK_IMPORTED_MODULE_1__modules_dom__["e" /* find */](panel, 'input').forEach(function (input) {
            __WEBPACK_IMPORTED_MODULE_1__modules_dom__["i" /* reClass */](input, _this.conf.classNames.toggles.toggle, 'mm-toggle');
            __WEBPACK_IMPORTED_MODULE_1__modules_dom__["i" /* reClass */](input, _this.conf.classNames.toggles.check, 'mm-check');
        });
    });
});


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
    this.opts.onClick = {
        close: true,
        preventDefault: false,
        setSelected: true
    };
});
;


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_dom__ = __webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _this = this;
    //	Create the menu
    if (this.node.menu.matches('.navbar-collapse')) {
        //	No need for cloning the menu...
        if (this.conf.offCanvas) {
            this.conf.offCanvas.clone = false;
        }
        //	... We'll create a new menu
        var nav = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["b" /* create */]('nav'), panel = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["b" /* create */]('div');
        nav.append(panel);
        __WEBPACK_IMPORTED_MODULE_0__modules_dom__["a" /* children */](this.node.menu).forEach(function (child) {
            switch (true) {
                case child.matches('.navbar-nav'):
                    panel.append(cloneNav(child));
                    break;
                case child.matches('.dropdown-menu'):
                    panel.append(cloneDropdown(child));
                    break;
                case child.matches('.form-inline'):
                    _this.conf.searchfield.form = {
                        action: child.getAttribute('action') || null,
                        method: child.getAttribute('method') || null,
                    };
                    _this.conf.searchfield.input = {
                        name: child.querySelector('input').getAttribute('name') ||
                            null,
                    };
                    _this.conf.searchfield.clear = false;
                    _this.conf.searchfield.submit = true;
                    break;
                default:
                    panel.append(child.cloneNode(true));
                    break;
            }
        });
        //	Set the menu
        this.bind('initMenu:before', function () {
            document.body.prepend(nav);
            _this.node.menu = nav;
        });
        //	Hijack the toggler.
        var parent_1 = this.node.menu.parentElement;
        if (parent_1) {
            var toggler = parent_1.querySelector('.navbar-toggler');
            if (toggler) {
                toggler.removeAttribute('data-target');
                // delete toggler.dataset.target; // IE10 has no dataset :(
                toggler.removeAttribute('aria-controls');
                //	Remove all bound events.
                toggler.outerHTML = toggler.outerHTML;
                toggler = parent_1.querySelector('.navbar-toggler');
                //  Open the menu on-click.
                toggler.addEventListener('click', function (evnt) {
                    evnt.preventDefault();
                    evnt.stopImmediatePropagation();
                    _this[_this.vars.opened ? 'close' : 'open']();
                });
            }
        }
    }
    function cloneLink(anchor) {
        var link = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["b" /* create */](anchor.matches('a') ? 'a' : 'span');
        //	Copy attributes
        var attr = ['href', 'title', 'target'];
        for (var a = 0; a < attr.length; a++) {
            if (anchor.getAttribute(attr[a])) {
                link.setAttribute(attr[a], anchor.getAttribute(attr[a]));
            }
        }
        //	Copy contents
        link.innerHTML = anchor.innerHTML;
        //	Remove Screen reader text.
        __WEBPACK_IMPORTED_MODULE_0__modules_dom__["e" /* find */](link, '.sr-only').forEach(function (sro) {
            sro.remove();
        });
        return link;
    }
    function cloneDropdown(dropdown) {
        var list = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["b" /* create */]('ul');
        __WEBPACK_IMPORTED_MODULE_0__modules_dom__["a" /* children */](dropdown).forEach(function (anchor) {
            var item = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["b" /* create */]('li');
            if (anchor.matches('.dropdown-divider')) {
                item.classList.add('Divider');
            }
            else if (anchor.matches('.dropdown-item')) {
                item.append(cloneLink(anchor));
            }
            list.append(item);
        });
        return list;
    }
    function cloneNav(nav) {
        var list = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["b" /* create */]('ul');
        __WEBPACK_IMPORTED_MODULE_0__modules_dom__["e" /* find */](nav, '.nav-item').forEach(function (anchor) {
            var item = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["b" /* create */]('li');
            if (anchor.matches('.active')) {
                item.classList.add('Selected');
            }
            if (!anchor.matches('.nav-link')) {
                var dropdown = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["a" /* children */](anchor, '.dropdown-menu')[0];
                if (dropdown) {
                    item.append(cloneDropdown(dropdown));
                }
                anchor = __WEBPACK_IMPORTED_MODULE_0__modules_dom__["a" /* children */](anchor, '.nav-link')[0];
            }
            item.prepend(cloneLink(anchor));
            list.append(item);
        });
        return list;
    }
});


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
    this.conf.offCanvas.page.noSelector.push('#olark');
});
;


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var classnames;
    document.addEventListener('turbolinks:before-visit', function (evnt) {
        classnames = document
            .querySelector('.mm-wrapper')
            .className.split(' ')
            .filter(function (name) { return /mm-/.test(name); });
    });
    document.addEventListener('turbolinks:load', function (evnt) {
        if (typeof classnames === 'undefined') {
            return;
        }
        document.querySelector('.mm-wrapper').className = classnames;
    });
});


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
    this.conf.classNames.selected = 'current-menu-item';
    var wpadminbar = document.getElementById('wpadminbar');
    if (wpadminbar) {
        wpadminbar.style.position = 'fixed';
        wpadminbar.classList.add('mm-slideout');
    }
});


/***/ }),
/* 559 */
/***/ (function(module, exports) {

// Source: https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// Source: https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function(s) {
            var matches = (
                    this.document || this.ownerDocument
                ).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1;
        };
}

// Source: https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
(function(arr) {
    arr.forEach(function(item) {
        if (item.hasOwnProperty('prepend')) {
            return;
        }
        Object.defineProperty(item, 'prepend', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function(argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(
                        isNode
                            ? argItem
                            : document.createTextNode(String(argItem))
                    );
                });

                this.insertBefore(docFrag, this.firstChild);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
(function(arr) {
    arr.forEach(function(item) {
        if (item.hasOwnProperty('append')) {
            return;
        }
        Object.defineProperty(item, 'append', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function append() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function(argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(
                        isNode
                            ? argItem
                            : document.createTextNode(String(argItem))
                    );
                });

                this.appendChild(docFrag);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/before()/before().md
(function(arr) {
    arr.forEach(function(item) {
        if (item.hasOwnProperty('before')) {
            return;
        }
        Object.defineProperty(item, 'before', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function before() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function(argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(
                        isNode
                            ? argItem
                            : document.createTextNode(String(argItem))
                    );
                });

                this.parentNode.insertBefore(docFrag, this);
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function(arr) {
    arr.forEach(function(item) {
        if (item.hasOwnProperty('remove')) {
            return;
        }
        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                if (this.parentNode !== null) this.parentNode.removeChild(this);
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.5.3
  * (c) 2021 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (false) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/+/g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (false) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && ((pathLowerCase === baseLowerCase) ||
    (pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0))) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  if (false) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.5.3';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
;(function() {

  'use strict'

  var opt = {
    complement: window.document.title,
    separator: '|'
  }

  var diffTitle = {}
  var els = []
  var diffEls = []
  var installed = false

  var util = {
    /**
     * Shorthand
     * @type {Object}
     */
    shorthand: {
      ch: 'charset',
      tg: 'target',
      n: 'name',
      he: 'http-equiv',
      ip: 'itemprop',
      c: 'content',
      p: 'property',
      sc: 'scheme',
      r: 'rel',
      h: 'href',
      sz: 'sizes',
      t: 'type',
      s: 'src',
      a: 'async',
      d: 'defer',
      i: 'inner'
    },

    /**
     * This function return the element <head>
     * @type {Function}
     * @return {Object}
     */
    getPlace: function (place) {
      return window.document.getElementsByTagName(place)[0]
    },

    /**
     * Undo the window.document title for previous state
     * @type {Function}
     * @param  {Object} state
     */
    undoTitle: function (state) {
      if (!state.before) return
      window.document.title = state.before
    },

    /**
     * Undo elements to its previous state
     * @type {Function}
     */
    undo: function () {
      if (!els.length) return
      els.forEach(function (el) {
        el.parentElement.removeChild(el)
      })
      els = []
    },

    /**
     * Set attributes in element
     * @type {Function}
     * @param  {Object} obj
     * @param  {HTMLElement} el
     * @return {HTMLElement} with defined attributes
     */
    prepareElement: function (obj, el) {
      var self = this
      Object.keys(obj).forEach(function (prop) {
        var sh = self.shorthand[prop] || prop
        if (sh.match(/(body|undo|replace)/g)) return
        if (sh === 'inner') {
          el.textContent = obj[prop]
          return
        }
        el.setAttribute(sh, obj[prop])
      })
      return el
    },

    /**
     * Change window.document title
     * @type {Function}
     * @param  {Object} obj
     */
    title: function (obj) {
      if (!obj) return
      diffTitle.before = opt.complement
      var title = obj.inner + ' ' + (obj.separator || opt.separator) +
        ' ' +  (obj.complement || opt.complement)
      window.document.title = title.trim()
    },

    /**
     * Update Element
     */
    update: function () {
      if (!els.length) return
      els.forEach(function(el, key) {
        if (diffEls[key] && !diffEls[key].isEqualNode(el)) {
          el.parentElement.replaceChild(diffEls[key], els[key])
          els.splice(key, 1, diffEls[key])
          return
        }
      })
      diffEls = []
    },

    /**
     * Add Elements
     * @param {Object} obj
     * @param {HTMLElement} el
     * @param {HTMLElement} parent
     */
    add: function (obj, el, parent) {
      parent.appendChild(el)
      // Fixed elements that do not suffer removal
      if (obj.undo !== undefined && !obj.undo) return
      // Elements which are removed
      els.push(el)
    },

    /**
     * Handle of create elements
     * @type {Function}
     * @param  {Array} arr
     * @param  {String} tag   - style, link, meta, script, base
     * @param  {String} place - Default 'head'
     * @param  {Boolean} update
     */
    handle: function (arr, tag, place, update) {
      var self = this
      if (!arr) return
      arr.forEach(function (obj) {
        var parent = (obj.body) ? self.getPlace('body') : self.getPlace(place)
        var el = window.document.getElementById(obj.id)
        if (!el) {
          el = window.document.createElement(tag)
          update = false
        }
        // Elements that will substitute data
        if (el.hasAttribute('id')) {
          self.prepareElement(obj, el)
          return
        }
        // Other elements
        el = self.prepareElement(obj, el)
        // Updated elements
        if (update) {
          diffEls.push(el)
          return
        }
        // Append Elements
        self.add(obj, el, parent)
      })
    }
  }

  /**
   * Plugin | vue-head
   * @param  {Function} Vue
   * @param  {Object} options
   */
  function VueHead (Vue, options) {
    if (installed) return

    installed = true

    if (options) {
      Vue.util.extend(opt, options)
    }

    /**
     * Initializes and updates the elements in the head
     * @param  {Boolean} update
     */
    function init (update) {
      var self = this
      var head = (typeof self.$options.head === 'function') ? self.$options.head.bind(self)() : self.$options.head
      if (!head) return
      Object.keys(head).forEach(function (key) {
        var prop = head[key]
        if (!prop) return
        var obj = (typeof prop === 'function') ? head[key].bind(self)() : head[key]
        if (key === 'title') {
          util[key](obj)
          return
        }
        util.handle(obj, key, 'head', update)
      })
      self.$emit('okHead')
    }

    /**
     * Remove the meta tags elements in the head
     */
    function destroy () {
      if (!this.$options.head) return
      util.undoTitle(diffTitle)
      util.undo()
    }

    // v1
    if (Vue.version.match(/[1].(.)+/g)) {
      Vue.mixin({
        ready: function () {
          init.call(this)
        },
        destroyed: function () {
          destroy.call(this)
        },
        events: {
          updateHead: function () {
            init.call(this, true)
            util.update()
          }
        }
      })
    }
    // v2
    if (Vue.version.match(/[2].(.)+/g)) {
      Vue.mixin({
        created: function () {
          var self = this
          self.$on('updateHead', function () {
            init.call(this, true)
            util.update()
          })
        },
        mounted: function () {
          init.call(this)
        },
        beforeDestroy: function () {
          destroy.call(this)
        }
      })
    }
  }

  VueHead.version = '2.2.0'

  // auto install
  if (typeof Vue !== 'undefined') {
    Vue.use(VueHead)
  }

  if(true) {
    module.exports = VueHead
  } else if(typeof define === 'function' && define.amd) {
    define(function () { return VueHead })
  } else if (typeof window !== 'undefined') {
    window.VueHead = VueHead
  }

})()


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("37db8b35", content, true, {});

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-0c2c052a]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-0c2c052a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-0c2c052a]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-0c2c052a]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-0c2c052a]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-0c2c052a]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-0c2c052a]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-0c2c052a]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-0c2c052a]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-0c2c052a]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-0c2c052a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-0c2c052a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.pt-40[data-v-0c2c052a]{padding-top:40px!important}.sl-4[data-v-0c2c052a]{width:33.33%}.sl-6[data-v-0c2c052a]{width:50%}.m-10[data-v-0c2c052a]{margin:10px 0}.m-20[data-v-0c2c052a]{margin:20px 0}.p-20[data-v-0c2c052a]{padding:20px 0}.nopadding[data-v-0c2c052a]{padding-left:0!important;padding-right:0!important}.ct-online-casino[data-v-0c2c052a]{clear:both;display:flex;align-items:center;width:100%;background:#fff;padding:24px 20px 20px;margin-top:0;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}@media (min-width:768px){.ct-online-casino[data-v-0c2c052a]{padding:25px;margin-top:14px}}.ct-online-casino.add-icon-text-repeater[data-v-0c2c052a]{flex-direction:column!important}.ct-online-casino .casino-top[data-v-0c2c052a]{display:flex}.ct-online-casino .casino-bottom[data-v-0c2c052a]{display:flex;flex-direction:column;align-items:center;border:.5px solid #dfe1e3;margin-top:15px;border-radius:5px;width:100%}@media (min-width:992px){.ct-online-casino .casino-bottom[data-v-0c2c052a]{flex-direction:row}}.ct-online-casino .casino-bottom .card-repeater[data-v-0c2c052a]{display:flex;align-items:center;justify-content:space-between;width:100%;min-width:100%;border-right:0;border-bottom:.5px solid #dfe1e3;padding:5px 10px;min-height:68px}@media (min-width:992px){.ct-online-casino .casino-bottom .card-repeater[data-v-0c2c052a]{min-height:59px;min-width:290px;border-right:.5px solid #dfe1e3;border-bottom:0}}.ct-online-casino .casino-bottom .card-repeater[data-v-0c2c052a]:last-child{border-bottom:0}@media (min-width:992px){.ct-online-casino .casino-bottom .card-repeater[data-v-0c2c052a]:last-child{border-right:0}}.ct-online-casino .casino-bottom .card-repeater-img[data-v-0c2c052a]{width:48px;height:48px;border-radius:50%;margin-right:8px}.ct-online-casino .casino-bottom .card-repeater-icon-text[data-v-0c2c052a]{margin:0;font-size:14px;text-align:left;display:block;min-width:110px;margin-right:8px}@media (min-width:576px){.ct-online-casino .casino-bottom .card-repeater-icon-text[data-v-0c2c052a]{min-width:80%}}@media (min-width:992px){.ct-online-casino .casino-bottom .card-repeater-icon-text[data-v-0c2c052a]{min-width:130px}}.ct-online-casino .casino-bottom .card-repeater-text[data-v-0c2c052a]{color:#448e47;text-align:right;width:calc(100% - 110px);margin:0;overflow-wrap:anywhere}@media (min-width:576px){.ct-online-casino .casino-bottom .card-repeater-text[data-v-0c2c052a]{width:100%}}@media (min-width:992px){.ct-online-casino .casino-bottom .card-repeater-text[data-v-0c2c052a]{width:calc(100% - 130px)}}.ct-online-casino .casino-left[data-v-0c2c052a]{width:100%}@media (min-width:768px){.ct-online-casino .casino-left[data-v-0c2c052a]{width:calc(85% - 64px);margin-right:64px}}.ct-online-casino .casino-right[data-v-0c2c052a]{width:15%;display:none}@media (min-width:768px){.ct-online-casino .casino-right[data-v-0c2c052a]{display:block}}.ct-online-casino .casino-right img[data-v-0c2c052a]{width:170px;height:170px}.ct-online-casino .content p[data-v-0c2c052a]{color:#222}.ct-card-grp .cta[data-v-0c2c052a]{margin-top:0;padding:15px}.card-flex-row[data-v-0c2c052a]{display:-webkit-box;display:-ms-flexbox;display:flex;align-items:flex-end}.card-sticky[data-v-0c2c052a]{padding:5px 30px;background:#ffd039;margin:0 auto;text-align:center;display:table;border-bottom-right-radius:10px;border-bottom-left-radius:10px;font-size:16px;font-weight:600}.card-sticky img[data-v-0c2c052a]{margin-right:8px;display:inline-block;vertical-align:baseline}.ct-card-horizontal[data-v-0c2c052a]{padding:24px 0}.casino-header[data-v-0c2c052a]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-0c2c052a]{text-align:center;color:#fff;font-weight:700;padding:8px}.casino-header-home[data-v-0c2c052a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:10px 0}.casino-header-home .casino-inner[data-v-0c2c052a]{color:#fff;text-align:center;border-right:1px solid #fff;-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;display:none}.casino-header-home .casino-inner[data-v-0c2c052a]:last-child{border-right:0;display:block}.casino-header-home .casino-inner h2[data-v-0c2c052a]{color:#fff;border-right:0;font-weight:700;padding:0 8px}.casino-header-home .casino-inner span[data-v-0c2c052a]{color:#fff;border-right:0;font-weight:700;font-size:12px;line-height:26px;padding:0 8px}@media (min-width:576px){.casino-header-home .casino-inner span[data-v-0c2c052a]{font-size:16px;line-height:160%}}.casino-header-home .casino-inner span img[data-v-0c2c052a]{width:18px;height:18px}.casino-header-home .casino-inner img[data-v-0c2c052a]{vertical-align:top;margin-right:8px;margin-top:3px}@media (min-width:768px){.casino-header-home .casino-inner[data-v-0c2c052a]{display:block}}.p-20-both[data-v-0c2c052a]{padding:10px 20px}.promotion-bottom-content[data-v-0c2c052a]{width:100%;margin-top:24px}@media (min-width:992px){.promotion-bottom-content[data-v-0c2c052a]{width:82%;margin-top:40px}}.promotion-bottom-content h2[data-v-0c2c052a]{color:#222;margin-top:0;margin-bottom:13px}@media (min-width:992px){.promotion-bottom-content h2[data-v-0c2c052a]{margin-top:80px;margin-bottom:25px}}.cta-show[data-v-0c2c052a]{color:#ebebeb;font-size:16px;cursor:pointer;border-radius:0;border:none;width:auto;float:right;padding:0;margin:20px 0;text-decoration:underline}.cta-show[data-v-0c2c052a]:focus,.cta-show[data-v-0c2c052a]:hover{color:#fff;text-decoration:underline}.cta-show .fa[data-v-0c2c052a]{margin-left:6px;font-weight:600}.promotion-inner[data-v-0c2c052a]{position:static;width:auto;text-align:center}@media (min-width:992px){.promotion-inner[data-v-0c2c052a]{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute}}.promotion-inner p[data-v-0c2c052a]{white-space:nowrap;font-weight:700;margin-bottom:0;margin-top:25px;display:none}@media (min-width:992px){.promotion-inner p[data-v-0c2c052a]{display:inline-block}}.promotion-inner-img[data-v-0c2c052a]{min-height:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (min-width:992px){.promotion-inner-img[data-v-0c2c052a]{min-height:92px}}.selection-holder[data-v-0c2c052a]{padding:19px 0 40px}@media (min-width:992px){.selection-holder[data-v-0c2c052a]{padding:35px 0 70px}}@media (max-width:576px){.selection-holder .mobile-scroller .selection-list-box[data-v-0c2c052a]:last-child{margin-right:22px}}.selection-holder .container[data-v-0c2c052a]{padding-right:20px}@media (min-width:768px){.selection-holder .container[data-v-0c2c052a]{padding:0 15px}}.selection-holder .promotion-card[data-v-0c2c052a]{background:#fff;transition:all .3s ease;-webkit-transition:all .3s ease;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.selection-holder .promotion-card h3[data-v-0c2c052a]{margin-bottom:0;padding:15px}.selection-holder .promotion-card-img[data-v-0c2c052a]{border-top-left-radius:5px;border-top-right-radius:5px;height:200px}.selection-holder .promotion-card-img img[data-v-0c2c052a]{width:100%;height:100%;object-fit:cover}.selection-holder .promotion-card-content[data-v-0c2c052a]{padding:30px}.selection-holder .promotion-card-content .promotion-title a[data-v-0c2c052a]{font-size:16px;font-weight:700}.selection-holder .promotion-card-content p[data-v-0c2c052a]{color:#7e7e7e;margin:10px 0}.selection-holder .promotion-card-content .game-card-info[data-v-0c2c052a]{display:flex;align-items:center;justify-content:space-between;padding:10px 0 20px;border-bottom:1px solid #ebebeb}.selection-holder .promotion-card-content .game-card-info .cta-promotion[data-v-0c2c052a]{margin:0;max-width:155px;padding:15px;font-size:13px;-webkit-border-radius:30px;-moz-border-radius:30px;border-radius:30px}.selection-holder .promotion-card-content .provider-info[data-v-0c2c052a]{display:flex;justify-content:space-between;align-items:center;padding-top:15px}.selection-holder .promotion-card-content .selection-icon[data-v-0c2c052a]{display:inline-block;margin-bottom:20px}.selection-holder .promotion-card[data-v-0c2c052a]:hover{background:#080438;transition:all .3s ease;-webkit-transition:all .3s ease}.selection-holder .promotion-card:hover .selection-icon svg path[data-v-0c2c052a]{color:#fff}.selection-holder .row .col-md-10[data-v-0c2c052a]{width:100%;padding-right:28px}@media (min-width:768px){.selection-holder .row .col-md-10[data-v-0c2c052a]{padding-right:0}}@media (min-width:1024px){.selection-holder .row .col-md-10[data-v-0c2c052a]{width:83.33333333%}}.selection-listing[data-v-0c2c052a]{box-shadow:0 1px 8px rgba(0,0,0,.08)}@media (max-width:576px){.selection-inner[data-v-0c2c052a]{padding-left:30px!important;padding-right:30px!important}}.selection-list[data-v-0c2c052a]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;width:fit-content;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;overflow:visible;box-shadow:none;margin-top:20px;padding-bottom:13px;background:transparent}@media (max-width:576px){.selection-list[data-v-0c2c052a]{padding-left:22px}}@media (min-width:768px){.selection-list[data-v-0c2c052a]{background:#fff;-ms-flex-wrap:wrap;flex-wrap:wrap;overflow:hidden;box-shadow:0 1px 8px rgba(0,0,0,.1);padding-bottom:0}}.selection-list-box[data-v-0c2c052a]{min-height:200px;background:#fff;min-width:252px;overflow:hidden;padding:20px 20px 24px;position:relative;transition:all .1s ease;-webkit-transition:all .1s ease;margin-right:16px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;white-space:normal}@media (min-width:768px){.selection-list-box[data-v-0c2c052a]{margin:0;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;min-width:auto;padding:40px 30px 30px}}.selection-list-box .btm-img[data-v-0c2c052a]{position:absolute;display:none;bottom:-30px;right:-30px;filter:opacity(0);opacity:0}@media (min-width:768px){.selection-list-box .btm-img[data-v-0c2c052a]{display:block}}.selection-list-box object[data-v-0c2c052a]{margin-bottom:20px;width:24px;height:24px}@media (min-width:768px){.selection-list-box object[data-v-0c2c052a]{margin-bottom:15px;width:48px;height:48px}}.selection-list-box svg[data-v-0c2c052a]{margin-bottom:20px;width:24px;height:24px}@media (min-width:768px){.selection-list-box svg[data-v-0c2c052a]{margin-bottom:15px;width:48px;height:48px}}.selection-list-box p[data-v-0c2c052a]{min-height:110px}@media (min-width:768px){.selection-list-box p[data-v-0c2c052a]{min-height:auto}}.selection-list-box a[data-v-0c2c052a]{color:var(--primary-btn)}.selection-list-box .read-more[data-v-0c2c052a]{font-weight:700;font-size:12px;line-height:15px;color:#e8321d}.selection-list-box .read-more img[data-v-0c2c052a]{margin-left:8px}@media (min-width:768px){.selection-list-box .read-more[data-v-0c2c052a]{display:none}}.selection-list-box .testi-card[data-v-0c2c052a]{display:block}.selection-list-box .testi-card-hover[data-v-0c2c052a]{display:none}@media (min-width:768px){.selection-list-box[data-v-0c2c052a]:hover{background-color:var(--primary-btn);transition:all .1s ease;-webkit-transition:all .1s ease}.selection-list-box:hover .btm-img[data-v-0c2c052a]{filter:contrast(.8);width:220px;height:auto;opacity:.2}.selection-list-box:hover h1[data-v-0c2c052a],.selection-list-box:hover h2[data-v-0c2c052a],.selection-list-box:hover h3[data-v-0c2c052a],.selection-list-box:hover h4[data-v-0c2c052a],.selection-list-box:hover h5[data-v-0c2c052a],.selection-list-box:hover h6[data-v-0c2c052a],.selection-list-box:hover span[data-v-0c2c052a]{color:#fff}.selection-list-box:hover p[data-v-0c2c052a]{position:relative;color:#fff;z-index:1}.selection-list-box:hover li[data-v-0c2c052a],.selection-list-box:hover li a[data-v-0c2c052a],.selection-list-box:hover p a[data-v-0c2c052a]{color:#fff}.selection-list-box:hover .testi-card[data-v-0c2c052a]{display:none}.selection-list-box:hover .testi-card-hover[data-v-0c2c052a]{display:block}}.normal-hide[data-v-0c2c052a]{display:none;margin-bottom:21px}.normal-show[data-v-0c2c052a]{display:block;margin-bottom:21px}.selection-list-box:hover .normal-hide[data-v-0c2c052a]{display:block}.selection-list-box:hover .normal-show[data-v-0c2c052a]{display:none}.ct-game-guide[data-v-0c2c052a]{background-color:#f1f2f3;padding:32px 0 38px}@media (min-width:768px){.ct-game-guide[data-v-0c2c052a]{padding:60px 0}}.ct-game-guide .info-card[data-v-0c2c052a]{background-color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;margin-bottom:20px}@media (min-width:768px){.ct-game-guide .info-card[data-v-0c2c052a]{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;margin-bottom:12px}}.ct-game-guide .info-card .info-card-img[data-v-0c2c052a]{width:100%;min-height:155px;cursor:pointer}.ct-game-guide .info-card .info-card-img img[data-v-0c2c052a]{max-height:155px}@media (min-width:768px){.ct-game-guide .info-card .info-card-img[data-v-0c2c052a]{width:45%;min-height:auto}.ct-game-guide .info-card .info-card-img img[data-v-0c2c052a]{max-height:none}}@media (min-width:992px){.ct-game-guide .info-card .info-card-img[data-v-0c2c052a]{width:30%}}.ct-game-guide .info-card .info-card-content[data-v-0c2c052a]{width:100%;min-height:auto;padding:16px 20px}@media (min-width:768px){.ct-game-guide .info-card .info-card-content[data-v-0c2c052a]{width:55%;min-height:110px;padding:45px}}@media (min-width:992px){.ct-game-guide .info-card .info-card-content[data-v-0c2c052a]{width:70%}}.ct-game-guide .info-card .info-card-content a[data-v-0c2c052a]{min-width:100%;margin:12px auto 0}@media (min-width:768px){.ct-game-guide .info-card .info-card-content a[data-v-0c2c052a]{min-width:191px;margin:25px auto 0}}.ct-game-guide .info-card .info-card-content h2[data-v-0c2c052a]{color:#030030;margin-bottom:28px}@media (min-width:768px){.ct-game-guide .info-card .info-card-content h2[data-v-0c2c052a]{margin:0 0 16px;color:#222}}.game-header[data-v-0c2c052a]{background:#222;padding:12px;border-top-right-radius:10px;border-top-left-radius:10px}.game-header h2[data-v-0c2c052a]{margin-bottom:0;color:#fff;padding:5px;text-align:center}.info-card[data-v-0c2c052a]{margin-bottom:20px;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;box-shadow:0 3px 8px 0 rgba(0,0,0,.2);overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.info-card-horizontal[data-v-0c2c052a],.info-card[data-v-0c2c052a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:768px){.info-card-horizontal[data-v-0c2c052a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.info-card-img[data-v-0c2c052a]{position:relative;width:30%;background-color:#f5f6fc}.info-card-img img[data-v-0c2c052a]{position:relative;width:100%;height:100%;object-fit:cover;object-position:center}.info-card-content[data-v-0c2c052a]{width:70%;min-height:110px;padding:45px}.info-card-content h2[data-v-0c2c052a]{margin-bottom:3px}.info-card-content h6[data-v-0c2c052a]{margin-bottom:5px}.info-card-content p[data-v-0c2c052a]{margin-left:0;margin-bottom:8px;color:#222}.info-card-content a[data-v-0c2c052a]{box-shadow:inset 0 -4px 4px #d02916;min-width:191px}.info-card-content a[data-v-0c2c052a]:focus,.info-card-content a[data-v-0c2c052a]:hover{background-color:#9a2b28;box-shadow:none;-webkit-box-shadow:none;border-color:#9a2b28;color:#fff}.show-read-more[data-v-0c2c052a]{display:none}@media (min-width:768px){.show-read-more[data-v-0c2c052a]{display:block}}.show-read-more-mob[data-v-0c2c052a]{display:none}@media (max-width:576px){.show-read-more-mob[data-v-0c2c052a]{display:block}}.hidden-methods[data-v-0c2c052a]{margin-top:0}@media (min-width:992px){.hidden-methods[data-v-0c2c052a]{margin-top:18px}}.white-space-nowrap[data-v-0c2c052a]{white-space:wrap!important}@media (min-width:992px){.white-space-nowrap[data-v-0c2c052a]{white-space:nowrap!important}}@media (min-width:992px){.payment-btn[data-v-0c2c052a]{min-height:68px;display:flex!important;align-items:center!important;justify-content:center}}.loader-spinner[data-v-0c2c052a]{text-align:center}.custom-color a[data-v-0c2c052a]{color:var(--primary-btn)}.pt-24[data-v-0c2c052a]{padding-top:24px}.selection-list-box .arrow-left[data-v-0c2c052a]{width:4.5px!important;height:7px!important;margin-left:8px!important;margin-bottom:0!important}.rm-casino-border[data-v-0c2c052a]{border-bottom-left-radius:0;border-bottom-right-radius:0}", ""]);

// exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(191);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 565 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 566 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(568);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6cc1c9fc", content, true, {});

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var Buffer = __webpack_require__(586).Buffer;

var username = wpvue_script_data_params.data.site_data.api_auth_user;
var password = wpvue_script_data_params.data.site_data.api_auth_pass;
var token = Buffer.from("".concat(username, ":").concat(password), 'utf8').toString('base64');
var HttpClient = {};

if (!wpvue_script_data_params.data.site_data.disable_auth) {
  HttpClient = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: "".concat(wpvue_script_data_params.rest_api_url),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Basic ".concat(token)
    },
    maxContentLength: Infinity,
    maxBodyLength: Infinity
  });
} else {
  HttpClient = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: "".concat(wpvue_script_data_params.rest_api_url),
    headers: {
      'Content-Type': 'application/json'
    },
    maxContentLength: 20000,
    maxBodyLength: 20000
  });
}

/* harmony default export */ __webpack_exports__["a"] = (HttpClient);

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);
var bind = __webpack_require__(219);
var Axios = __webpack_require__(571);
var mergeConfig = __webpack_require__(225);
var defaults = __webpack_require__(222);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(226);
axios.CancelToken = __webpack_require__(584);
axios.isCancel = __webpack_require__(221);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(585);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);
var buildURL = __webpack_require__(220);
var InterceptorManager = __webpack_require__(572);
var dispatchRequest = __webpack_require__(573);
var mergeConfig = __webpack_require__(225);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);
var transformData = __webpack_require__(574);
var isCancel = __webpack_require__(221);
var defaults = __webpack_require__(222);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(224);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(579);
var combineURLs = __webpack_require__(580);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(28);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(226);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(587)
var ieee754 = __webpack_require__(588)
var isArray = __webpack_require__(589)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 588 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 589 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  NavLinks: 'casbase/v1/get_header/?country=',
  Footer: 'casbase/v1/get_footer',
  HomePage: 'casbase/v1/home/?country=',
  Body: 'casbase/v1/get_body/?resource_id=',
  Search: 'casbase/v1/search/?s=',
  ArticleVote: 'casbase/v1/article_vote/?resource_id=',
  Archive: 'wpvue/v1/archive/'
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-component-wrap"},[(_vm.blockName === 'wpvcb/home-banner')?[_c('home-banner',{attrs:{"mobile-bg-image":_vm.blockData.filtered_content.enable_mobile_bg ?
            _vm.blockData.filtered_content.mobile_bg_image : '',"logo-image":_vm.blockData.filtered_content.logo_image,"logo-title":_vm.blockData.filtered_content.logo_title,"bg-image":_vm.blockData.filtered_content.bg_image,"banner-style":_vm.blockData.filtered_content.banner_style,"heading-tag":_vm.blockData.filtered_content.heading_tag,"enable-font-color":_vm.blockData.filtered_content.custom_font_color || 'white',"heading":_vm.blockData.filtered_content.heading,"disable-show-more-mob":_vm.blockData.filtered_content.disable_showmore_mobile,"mobile-text":_vm.blockData.filtered_content.mobile_text,"no-mob-lines":_vm.blockData.filtered_content.no_of_lines_mobile,"banner-text":_vm.blockData.filtered_content.text,"no-banner-lines":_vm.blockData.filtered_content.no_of_lines,"banner-guide-cards":JSON.stringify(_vm.blockData.filtered_content.cards),"recommended-title-tag":_vm.blockData.filtered_content.recommended_title_tag,"recommended-by":_vm.blockData.filtered_content.recommended_by,"toplist-data":_vm.getHomeBannerToplist(_vm.blockData.filtered_content.toplist_data),"toplist-bg-color":_vm.blockData.filtered_content.toplist_bg_color,"toplist-bns-color":_vm.blockData.filtered_content.toplist_bns_color || 'white',"toplist-bns-hover-color":_vm.blockData.filtered_content.toplist_bns_hover_color,"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/home-card-testimonials')?[_c('home-card-testimonials',{attrs:{"card-style":_vm.blockData.filtered_content.style,"column-number":_vm.blockData.filtered_content.card_testimonials_columns,"card-testimonial-data":JSON.stringify(_vm.blockData.filtered_content.card_testimonials),"card-data":JSON.stringify(_vm.blockData.filtered_content.cards)}})]:(_vm.blockName === 'wpvcb/blue-progressive-block')?[_c('blue-progressive-block',{style:(_vm.blockData.filtered_content.style),attrs:{"bg_pattern":_vm.blockData.attrs.bg_pattern,"bg_color":_vm.blockData.filtered_content.bg_color || '#0084ff',"title_tag":_vm.blockData.attrs.title_tag,"title":_vm.blockData.filtered_content.title,"content":_vm.blockData.filtered_content.content,"logo":_vm.blockData.filtered_content.logo}})]:(_vm.blockName === 'wpvcb/content-icon-block')?[_c('content-icon-block',{attrs:{"template-check":'false',"button-check":("" + (Object.keys(_vm.blockData.filtered_content).length > 0
                ? _vm.blockData.filtered_content &&
                    _vm.blockData.filtered_content.cta_partner &&
                    Object.keys(_vm.blockData.filtered_content.cta_partner).length > 0
                    ? true
                    : false
                : false)),"partner-info":_vm.blockData.filtered_content.cta_partner || '',"icon":_vm.blockData.filtered_content.icon,"content":_vm.blockData.filtered_content.content}})]:(_vm.blockName === 'wpvcb/faq')?[_c('faq-block',{attrs:{"bg-pattern":_vm.blockData.filtered_content.faq_data.bg_pattern,"faq-name":_vm.blockData.filtered_content.faq_data.faq_name,"faq-style":_vm.blockData.filtered_content.faq_data.style,"faq-data":JSON.stringify(_vm.blockData.filtered_content.data)}})]:(_vm.blockName === 'wpvcb/testimonials')?[_c('user-testimonials',{attrs:{"heading":_vm.blockData.filtered_content.heading,"sub-heading":_vm.blockData.filtered_content.sub_heading,"testimonial-data":JSON.stringify(_vm.blockData.filtered_content.testimonials)}})]:(_vm.blockName === 'wpvcb/comparison-list-block')?[_c('comparison-list',{attrs:{"block-title":_vm.blockData.filtered_content.block_title,"comparison-style":_vm.blockData.filtered_content.style,"disabled-icon":_vm.blockData.filtered_content.disabled_icon,"comparison-right-data":JSON.stringify(_vm.blockData.filtered_content.right),"comparison-left-data":JSON.stringify(_vm.blockData.filtered_content.left)}})]:(_vm.blockName === 'wpvcb/published-date')?[_c('published-date',{attrs:{"publish-date":_vm.blockData.filtered_content.publish_date,"est-min-read":_vm.blockData.filtered_content.est_minutes_read}})]:(_vm.blockName === 'wpvcb/top-promotions')?[_c('top-promotions',{attrs:{"block-title":_vm.blockData.attrs.block_title,"enable-show-all-link":_vm.blockData.attrs.enable_show_all_link,"show-all-link":_vm.blockData.attrs.show_all_link,"display-offset":_vm.blockData.attrs.display_offset,"default-display":_vm.blockData.attrs.default_display,"promotion-data":JSON.stringify(_vm.blockData.filtered_content),"block-use":'block',"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/geo-text')?[_c('geo-text',{attrs:{"text-tag":_vm.blockData.filtered_content.tag,"text-content":_vm.blockData.filtered_content.content}})]:(_vm.blockName === 'wpvcb/bullet-block')?[_c('bullet-block',{attrs:{"bullet-style":_vm.blockData.filtered_content.style,"bullet-content":_vm.blockData.filtered_content.content,"custom-bullet":_vm.blockData.filtered_content.custom_bullet}})]:(_vm.blockName === 'wpvcb/news-block')?[_c('news-block',{attrs:{"news-block-data":JSON.stringify(_vm.blockData.filtered_content),"news-block-attrs":JSON.stringify(_vm.blockData.attrs),"post-slug":_vm.$route.params.postSlug,"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/stream-block')?[_c('stream-block',{attrs:{"stream-block-data":JSON.stringify(_vm.blockData.filtered_content),"stream-block-attrs":JSON.stringify(_vm.blockData.attrs),"post-slug":_vm.$route.params.postSlug,"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/geo-image')?[_c('geo-image',{attrs:{"img-url":_vm.blockData.filtered_content.img_url,"img-alt":_vm.blockData.filtered_content.img_alt,"imgWidth":_vm.blockData.filtered_content.img_width,"imgHeight":_vm.blockData.filtered_content.img_height}})]:(_vm.blockName === 'yoast/faq-block')?[_c('yoast-faq',{attrs:{"faq-data":_vm.yoastFaqData(_vm.blockData)}})]:(_vm.blockName === 'wpvcb/author-block')?[_c('author-block',{attrs:{"block-style":_vm.blockData.filtered_content.style,"move-author-description-below":_vm.blockData.filtered_content.move_author_description_below,"post-date-read-time":_vm.blockData.filtered_content.post_date_read_time,"author-data":JSON.stringify(_vm.blockData.filtered_content.data)}})]:(_vm.blockName === 'wpvcb/game-guide-categories')?[_c('game-guide-categories',{attrs:{"block-style":_vm.blockData.attrs.style,"enable-search":_vm.blockData.attrs.enable_search,"block-data":_vm.gameGuideData(_vm.blockData),"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/tab-switcher')?[_c('tab-switcher',{attrs:{"tab-switcher-data":JSON.stringify(_vm.blockData.filtered_content)}})]:(_vm.blockName === 'wpvcb/best-payment-methods')?[_c('best-payment-methods',{attrs:{"bg-pattern":_vm.blockData.attrs.bg_pattern,"payment-style":_vm.blockData.attrs.style,"block-title":_vm.blockData.attrs.block_title,"block-title-tag":_vm.blockData.attrs.title_tag,"before-content":_vm.blockData.attrs.before_content,"remove-cas-count":_vm.blockData.attrs.remove_cascount,"enable-show-all-link":_vm.blockData.attrs.enable_show_all_link,"show-all-label":_vm.blockData.attrs.show_all_label,"show-all-link":_vm.blockData.attrs.show_all_link,"after-content":_vm.blockData.attrs.after_content,"payment-data":_vm.getBestPaymentData(_vm.blockData.filtered_content),"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/latest-casino')?[_c('latest-casino',{attrs:{"block-title":_vm.blockData.attrs.block_title,"latest-casino-data":JSON.stringify(_vm.blockData.filtered_content),"pro-asset-size":_vm.assetSizes.pro_asset_sizes.medium,"bottom-link":_vm.blockData.attrs.enable_link,"bottom-link-url":_vm.blockData.attrs.link_url,"bottom-link-label":_vm.blockData.attrs.link_label}})]:(_vm.blockName === 'wpvcb/link-block')?[_c('link-block',{attrs:{"link-block-title":_vm.blockData.filtered_content.title,"link-block-link":_vm.blockData.filtered_content.link}})]:(_vm.blockName === 'wpvcb/alternative-payment-options' && !!_vm.blockData.filtered_content.alternative_payment_methods)?[_c('alternative-payment-options',{attrs:{"block-style":_vm.blockData.filtered_content.alternative_payment_methods.style,"block-title":_vm.blockData.filtered_content.alternative_payment_methods.title,"block-description":_vm.blockData.filtered_content.alternative_payment_methods.description,"payment-methods-data":_vm.getAlternativePaymentData(_vm.blockData.filtered_content.alternative_payment_methods.posts),"payments-tag-order":JSON.stringify(_vm.blockData.filtered_content.alternative_payment_methods.payment_tags_order),"remove-cas-count":_vm.blockData.filtered_content.alternative_payment_methods.remove_cascount,"spa-router":_vm.$root.enable_piwik_reload,"per-page":_vm.blockData.filtered_content.per_page},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/team-block')?[_c('team-block',{attrs:{"title":_vm.blockData.filtered_content.title,"title-tag":_vm.blockData.filtered_content.title_tag,"description":_vm.blockData.filtered_content.description,"teams":JSON.stringify(_vm.blockData.filtered_content.teams_section.teams)}})]:(_vm.blockName === 'wpvcb/custom-iframe')?[_c('custom-iframe',{attrs:{"iframe-data":JSON.stringify(_vm.blockData.filtered_content)}})]:(_vm.blockName === 'wpvcb/whitebg-content-block')?[_c('whitebg-content',{attrs:{"block-title":_vm.blockData.filtered_content.title,"title-icon":_vm.blockData.filtered_content.title_icon,"content-icon":_vm.blockData.filtered_content.content_icon,"content":_vm.blockData.filtered_content.content}})]:(_vm.blockName === 'wpvcb/top-games')?[_c('top-games',{attrs:{"block-style":_vm.blockData.attrs.style,"block-title":_vm.blockData.attrs.block_title,"block-data":_vm.getTopGamesData(_vm.blockData.filtered_content.data),"disable-review":_vm.blockData.attrs.disable_review,"enable-filter":_vm.blockData.attrs.enable_filters,"show-all-games-link":_vm.blockData.attrs.enable_show_all_games_link ? _vm.blockData.attrs.show_all_games_link : '',"enable-selected-game-cats":_vm.blockData.filtered_content.attrs.enable_selected_game_cats,"single-cat":_vm.blockData.filtered_content.attrs.single_cat,"single-cat-name":_vm.blockData.filtered_content.attrs.single_cat_name,"default-display":_vm.blockData.filtered_content.attrs.default_display,"load-offset":_vm.blockData.filtered_content.attrs.load_offset,"main-cas-loading":false,"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/poker-hands')?[_c('poker-hands',{attrs:{"poker-hand-data":JSON.stringify(_vm.blockData.filtered_content.info)}})]:(_vm.blockName === 'wpvcb/home-promote-banner')?[_c('home-promote-banner',{attrs:{"banner-data":JSON.stringify(_vm.blockData.filtered_content)}})]:(_vm.blockName === 'wpvcb/youtube-film-strip')?[_c('youtube-film-strip',{attrs:{"youtube-data":JSON.stringify(_vm.blockData.filtered_content)}})]:(_vm.blockName === 'wpvcb/other-software-provider')?[_c('other-software-provider',{attrs:{"block-title":_vm.blockData.attrs.block_title,"description":_vm.blockData.attrs.description,"software-provider-data":_vm.getOtherSoftwareProviderData(_vm.blockData.filtered_content.posts),"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/alternative-software-provider' && !!_vm.blockData.filtered_content.alternative_software_providers.posts)?[_c('alternative-software-provider',{attrs:{"block-title":_vm.blockData.filtered_content.alternative_software_providers.block_title,"description":_vm.blockData.filtered_content.alternative_software_providers.description,"remove-cas-count":_vm.blockData.filtered_content.alternative_software_providers.remove_cascount,"software-provider-data":_vm.getAlternativeSoftwareProviderData(_vm.blockData.filtered_content.alternative_software_providers.posts),"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/related-articles')?[_c('related-articles',{attrs:{"block-title":_vm.blockData.attrs.block_title,"related-article-attrs":_vm.blockData.attrs.enable_rich_pins,"related-article-attrs-title":_vm.blockData.attrs.rich_pins_button_text,"block-data":JSON.stringify(_vm.blockData.filtered_content),"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/similar-casinos')?[_c('similar-casinos',{attrs:{"block-title":_vm.blockData.attrs.block_title,"block-data":_vm.getSimilarCasinoData(_vm.blockData.filtered_content),"enable-payment-popup":_vm.blockData.attrs.enable_payment_popup,"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/exclusive-casino')?[_c('exclusive-casino',{attrs:{"exclusive-casino-data":_vm.exclusiveCasinoData(_vm.blockData.filtered_content.casinos),"first-card":JSON.stringify(_vm.blockData.filtered_content.first_card),"bg-image":_vm.blockData.filtered_content.bg_image,"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/article-banner')?[_c('article-banner',{attrs:{"content-width":_vm.blockData.filtered_content.content_width,"title":_vm.blockData.filtered_content.title,"url":_vm.blockData.filtered_content.url,"text-align":_vm.blockData.filtered_content.text_align,"enable-text-logo":_vm.blockData.filtered_content.enable_text_logo,"enable-text":_vm.blockData.filtered_content.enable_text,"text-logo":_vm.blockData.filtered_content.text_logo,"text-tag":_vm.blockData.filtered_content.text_tag,"text":_vm.blockData.filtered_content.text}})]:(_vm.blockName === 'wpvcb/article-helpful-vote')?[_c('article-helpful-vote',{attrs:{"article-vote-data":JSON.stringify(_vm.blockData.filtered_content),"disabled":_vm.userArticleVote.disabled,"helpful":_vm.userArticleVote.helpful},on:{"getUserArticleVote":_vm.getUserArticleVote}})]:(_vm.blockName === 'wpvcb/casino-toplist' && !!_vm.blockData.filtered_content)?[_c('casino-toplist',{attrs:{"toplist-style":_vm.blockData.attrs.style,"recommend-section":JSON.stringify(_vm.recommendSection),"block-data":JSON.stringify(_vm.blockData.filtered_content),"block-attrs":JSON.stringify(_vm.blockData.attrs),"page-value":_vm.pageValue,"assets-size":JSON.stringify(_vm.assetSizes),"bluebar":JSON.stringify(_vm.bluebar),"product-info-name":_vm.pageData ? _vm.pageData.product_information.name : null,"cas-loading":_vm.$root.casloading,"post-slug":_vm.$route.params.postSlug,"spa-router":_vm.$root.enable_piwik_reload,"block-index":_vm.blockIndex},on:{"changeCasloading":_vm.changeCasloading,"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/main-casino-toplist')?[_c('main-casino-toplist',{attrs:{"block-data":JSON.stringify(_vm.blockData.filtered_content),"block-attrs":JSON.stringify(_vm.blockData.attrs),"page-value":'home',"assets-size":JSON.stringify(_vm.assetSizes),"cas-loading":_vm.$root.casloading,"spa-router":_vm.$root.enable_piwik_reload},on:{"changeCasloading":_vm.changeCasloading,"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/howto-block')?[_c('howto-block',{attrs:{"title":_vm.blockData.filtered_content.title,"title-tag":_vm.blockData.filtered_content.title_tag,"intro":_vm.blockData.filtered_content.intro,"custom-font-color":_vm.blockData.filtered_content.enable_background ? _vm.blockData.filtered_content.custom_font_color : '',"steps":JSON.stringify(_vm.blockData.filtered_content.steps),"enable-bigger-image":_vm.blockData.filtered_content.enable_bigger_image,"hide-list-numbers":_vm.blockData.filtered_content.hide_list_numbers,"howto-id":("howto-" + _vm.blockIndex)}})]:(_vm.blockName === 'wpvcb/bonus-cards')?[_c('bonus-cards',{attrs:{"bonus-style":_vm.blockData.filtered_content.style,"bonus-info":JSON.stringify(_vm.blockData.filtered_content.info)}})]:(_vm.blockName === 'wpvcb/pu-reference')?[_c('pu-reference',{attrs:{"title":_vm.blockData.filtered_content.title,"title-tag":_vm.blockData.filtered_content.title_tag,"block-style":_vm.blockData.filtered_content.style,"refs-item":JSON.stringify(_vm.blockData.filtered_content.ref_items)}})]:(_vm.blockName === 'wpvcb/intro-block')?[_c('intro-block',{attrs:{"intro-block-data":JSON.stringify(_vm.blockData.filtered_content),"page-name":'home'}})]:(_vm.blockName === 'wpvcb/newsletter')?[_c('newsletter-block',{attrs:{"bg-pattern":_vm.blockData.attrs.bg_pattern,"post-slug":_vm.$route.params.postSlug || ''}})]:(_vm.blockName === 'wpvcb/top-games-articles')?[_c('top-games-articles',{attrs:{"top-article-title":_vm.blockData.attrs.block_title,"game-top-attrs-data":_vm.blockData.attrs.enable_rich_pins,"game-top-article-attrs-title-data":_vm.blockData.attrs.rich_pins_button_text,"top-article-data":JSON.stringify(_vm.blockData.filtered_content),"block-style":_vm.blockData.attrs.style,"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/feature-promotion')?[_c('feature-promotion',{attrs:{"partner-information":JSON.stringify(_vm.blockData.filtered_content.partner_information),"meta-data":JSON.stringify(_vm.blockData.filtered_content.metadata),"short-descrp":_vm.blockData.filtered_content.short_descrp,"spa-router":_vm.$root.enable_piwik_reload},on:{"emitSpaRoute":_vm.routeToPage}})]:(_vm.blockName === 'wpvcb/software-provider-block')?[_c('software-provider-block',{attrs:{"product-information":_vm.pageData ? JSON.stringify(_vm.pageData.product_information) : null,"software-provider":_vm.pageData ? JSON.stringify(_vm.pageData.software_provider) : null,"product-name":_vm.pageData.product_name,"product-licences":_vm.pageData ? JSON.stringify(_vm.pageData.product_licences) : null,"block-data":JSON.stringify(_vm.blockData.filtered_content),"show-hide-obj":JSON.stringify(_vm.showHideObj),"id":"review-casino-card-software"}})]:(_vm.blockName === 'wpvcb/payment-option-block')?[_c('payment-option-block',{attrs:{"supported-payments":_vm.pageData ? JSON.stringify(_vm.pageData.supported_payments) : null,"minimum-deposit":_vm.pageData ? _vm.pageData.minimum_deposit : null,"minimum-withdraw":_vm.pageData ? JSON.stringify(_vm.pageData.minimum_withdraw) : null,"bonus-currency":_vm.pageData ? _vm.pageData.bonus_currency : null,"block-data":JSON.stringify(_vm.blockData.filtered_content),"show-hide-obj":JSON.stringify(_vm.showHideObj),"id":"review-casino-card-payment-method"}})]:(_vm.blockName === 'wpvcb/languages-supports-block')?[_c('languages-supports-block',{attrs:{"supported-lang":_vm.supportedLang,"contact-number":_vm.pageData ? _vm.pageData.product_information.contact_number[0].contact_number : '',"support-email":_vm.pageData ? _vm.pageData.product_information.support_email[0].email_address : '',"contact-name":_vm.pageData ? _vm.pageData.product_information.contact_number[0].title : '',"block-data":JSON.stringify(_vm.blockData.filtered_content)}})]:(_vm.blockName === 'wpvcb/bonus-information-block')?[_c('bonus-information-block',{attrs:{"hide-bonus-label":_vm.hideBonusLabel,"assets-size":JSON.stringify(_vm.assetSizes),"bonus-data":JSON.stringify(_vm.blockData.filtered_content),"bonus-partner-data":_vm.pageData ? JSON.stringify(_vm.pageData.product_information) : null,"bonus-primary-colour":_vm.pageData ? _vm.pageData.primary_colour : null}})]:(_vm.blockName === 'wpvcb/recommended-casinos')?[_c('recommended-casinos',{attrs:{"block-data":JSON.stringify(_vm.blockData.filtered_content)}})]:(_vm.blockName === 'core/shortcode')?[_c('core-shortcode',{attrs:{"block-data":_vm.blockData.filtered_content}})]:(_vm.blockName === null)?[_c('null-block',{attrs:{"block-data":_vm.blockData.filtered_content}})]:(_vm.isCoreBlock(_vm.blockName) && _vm.blockName != null)?[(_vm.blockName === 'simpletoc/toc')?[_c('simple-toc',{attrs:{"simple-toc-data":_vm.blockData.innerHTML,"no-of-title-display":_vm.blockData.attrs.no_of_title_display,"right-content":_vm.rightContent}})]:[_c('core-content',{attrs:{"block-data":_vm.coreBlockData(_vm.blockData),"block-attrs":_vm.coreBlockAttrs(_vm.blockData),"block-name":_vm.blockName,"page-value":_vm.pageValue,"scheme":_vm.scheme}})]]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{directives:[{name:"observer",rawName:"v-observer",value:(_vm.mutationObserve),expression:"mutationObserve"}],staticClass:"main-content-area"},[(_vm.pageBlockData1 && _vm.pageBlockData1.length > 0)?[_vm._l((_vm.pageBlockData1),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"pageValue":'home',"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]})]:_vm._e(),_vm._v(" "),(_vm.pageBlockData2 && _vm.pageBlockData2.length > 0)?[_vm._l((_vm.pageBlockData2),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"pageValue":'home',"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]}),_vm._v(" "),(_vm.auhtorBlockdata && _vm.pageBlockData2.length === _vm.blockData2.length)?void 0:_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(594);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("e6795132", content, true, {});

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-cec19694]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-cec19694]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-cec19694]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-cec19694]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-cec19694]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-cec19694]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-cec19694]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-cec19694]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-cec19694]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-cec19694]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-cec19694]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-cec19694]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.arrow-left[data-v-cec19694]{height:8px!important;width:6px!important;margin-bottom:0!important}.pt-40[data-v-cec19694]{padding-top:40px!important}.sl-4[data-v-cec19694]{width:33.33%}.sl-6[data-v-cec19694]{width:50%}.m-10[data-v-cec19694]{margin:10px 0}.m-20[data-v-cec19694]{margin:20px 0}.p-20[data-v-cec19694]{padding:20px 0}.nopadding[data-v-cec19694]{padding-left:0!important;padding-right:0!important}.ct-online-casino[data-v-cec19694]{clear:both;display:flex;align-items:center;width:100%;background:#fff;padding:24px 20px 20px;margin-top:0;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}@media (min-width:768px){.ct-online-casino[data-v-cec19694]{padding:25px;margin-top:14px}}.ct-online-casino.add-icon-text-repeater[data-v-cec19694]{flex-direction:column!important}.ct-online-casino .casino-top[data-v-cec19694]{display:flex}.ct-online-casino .casino-bottom[data-v-cec19694]{display:flex;flex-direction:column;align-items:center;border:.5px solid #dfe1e3;margin-top:15px;border-radius:5px;width:100%}@media (min-width:992px){.ct-online-casino .casino-bottom[data-v-cec19694]{flex-direction:row}}.ct-online-casino .casino-bottom .card-repeater[data-v-cec19694]{display:flex;align-items:center;justify-content:space-between;width:100%;min-width:100%;border-right:0;border-bottom:.5px solid #dfe1e3;padding:5px 10px;min-height:68px}@media (min-width:992px){.ct-online-casino .casino-bottom .card-repeater[data-v-cec19694]{min-height:59px;min-width:290px;border-right:.5px solid #dfe1e3;border-bottom:0}}.ct-online-casino .casino-bottom .card-repeater[data-v-cec19694]:last-child{border-bottom:0}@media (min-width:992px){.ct-online-casino .casino-bottom .card-repeater[data-v-cec19694]:last-child{border-right:0}}.ct-online-casino .casino-bottom .card-repeater-img[data-v-cec19694]{width:48px;height:48px;border-radius:50%;margin-right:8px}.ct-online-casino .casino-bottom .card-repeater-icon-text[data-v-cec19694]{margin:0;font-size:14px;text-align:left;display:block;min-width:110px;margin-right:8px}@media (min-width:576px){.ct-online-casino .casino-bottom .card-repeater-icon-text[data-v-cec19694]{min-width:80%}}@media (min-width:992px){.ct-online-casino .casino-bottom .card-repeater-icon-text[data-v-cec19694]{min-width:130px}}.ct-online-casino .casino-bottom .card-repeater-text[data-v-cec19694]{color:#448e47;text-align:right;width:calc(100% - 110px);margin:0;overflow-wrap:anywhere}@media (min-width:576px){.ct-online-casino .casino-bottom .card-repeater-text[data-v-cec19694]{width:100%}}@media (min-width:992px){.ct-online-casino .casino-bottom .card-repeater-text[data-v-cec19694]{width:calc(100% - 130px)}}.ct-online-casino .casino-left[data-v-cec19694]{width:100%}@media (min-width:768px){.ct-online-casino .casino-left[data-v-cec19694]{width:calc(85% - 64px);margin-right:64px}}.ct-online-casino .casino-right[data-v-cec19694]{width:15%;display:none}@media (min-width:768px){.ct-online-casino .casino-right[data-v-cec19694]{display:block}}.ct-online-casino .casino-right img[data-v-cec19694]{width:170px;height:170px}.ct-online-casino .content p[data-v-cec19694]{color:#222}.ct-card-grp .cta[data-v-cec19694]{margin-top:0;padding:15px}.card-flex-row[data-v-cec19694]{display:-webkit-box;display:-ms-flexbox;display:flex;align-items:flex-end}.card-sticky[data-v-cec19694]{padding:5px 30px;background:#ffd039;margin:0 auto;text-align:center;display:table;border-bottom-right-radius:10px;border-bottom-left-radius:10px;font-size:16px;font-weight:600}.card-sticky img[data-v-cec19694]{margin-right:8px;display:inline-block;vertical-align:baseline}.ct-card-horizontal[data-v-cec19694]{padding:24px 0}.casino-header[data-v-cec19694]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-cec19694]{text-align:center;color:#fff;font-weight:700;padding:8px}.casino-header-home[data-v-cec19694]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:10px 0}.casino-header-home .casino-inner[data-v-cec19694]{color:#fff;text-align:center;border-right:1px solid #fff;-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;display:none}.casino-header-home .casino-inner[data-v-cec19694]:last-child{border-right:0;display:block}.casino-header-home .casino-inner h2[data-v-cec19694]{color:#fff;border-right:0;font-weight:700;padding:0 8px}.casino-header-home .casino-inner span[data-v-cec19694]{color:#fff;border-right:0;font-weight:700;font-size:12px;line-height:26px;padding:0 8px}@media (min-width:576px){.casino-header-home .casino-inner span[data-v-cec19694]{font-size:16px;line-height:150%}}.casino-header-home .casino-inner span img[data-v-cec19694]{width:18px;height:18px}.casino-header-home .casino-inner img[data-v-cec19694]{vertical-align:top;margin-right:8px;margin-top:3px}@media (min-width:768px){.casino-header-home .casino-inner[data-v-cec19694]{display:block}}.p-20-both[data-v-cec19694]{padding:10px 20px}.promotion-bottom-content[data-v-cec19694]{width:100%;margin-top:24px}@media (min-width:992px){.promotion-bottom-content[data-v-cec19694]{width:82%;margin-top:40px}}.promotion-bottom-content h2[data-v-cec19694]{color:#222;margin-top:0;margin-bottom:13px}@media (min-width:992px){.promotion-bottom-content h2[data-v-cec19694]{margin-top:80px;margin-bottom:25px}}.cta-show[data-v-cec19694]{color:#ebebeb;font-size:16px;cursor:pointer;border-radius:0;border:none;width:auto;float:right;padding:0;margin:20px 0;text-decoration:underline}.cta-show[data-v-cec19694]:focus,.cta-show[data-v-cec19694]:hover{color:#fff;text-decoration:underline}.cta-show .fa[data-v-cec19694]{margin-left:6px;font-weight:600}.promotion-inner[data-v-cec19694]{position:static;width:auto;text-align:center}@media (min-width:992px){.promotion-inner[data-v-cec19694]{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute}}.promotion-inner p[data-v-cec19694]{white-space:nowrap;font-weight:700;margin-bottom:0;margin-top:25px;display:none}@media (min-width:992px){.promotion-inner p[data-v-cec19694]{display:inline-block}}.promotion-inner-img[data-v-cec19694]{min-height:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (min-width:992px){.promotion-inner-img[data-v-cec19694]{min-height:92px}}.selection-holder[data-v-cec19694]{padding:19px 0 40px}@media (min-width:992px){.selection-holder[data-v-cec19694]{padding:35px 0 70px}}.selection-holder .container[data-v-cec19694]{padding-right:0}@media (min-width:768px){.selection-holder .container[data-v-cec19694]{padding:0 15px}}.selection-holder .promotion-card[data-v-cec19694]{background:#fff;transition:all .3s ease;-webkit-transition:all .3s ease;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.selection-holder .promotion-card h3[data-v-cec19694]{margin-bottom:0;padding:15px}.selection-holder .promotion-card-img[data-v-cec19694]{border-top-left-radius:5px;border-top-right-radius:5px;height:200px}.selection-holder .promotion-card-img img[data-v-cec19694]{width:100%;height:100%;object-fit:cover}.selection-holder .promotion-card-content[data-v-cec19694]{padding:30px}.selection-holder .promotion-card-content .promotion-title a[data-v-cec19694]{font-size:16px;font-weight:700}.selection-holder .promotion-card-content p[data-v-cec19694]{color:#7e7e7e;margin:10px 0}.selection-holder .promotion-card-content .game-card-info[data-v-cec19694]{display:flex;align-items:center;justify-content:space-between;padding:10px 0 20px;border-bottom:1px solid #ebebeb}.selection-holder .promotion-card-content .game-card-info .cta-promotion[data-v-cec19694]{margin:0;max-width:155px;padding:15px;font-size:13px;-webkit-border-radius:30px;-moz-border-radius:30px;border-radius:30px}.selection-holder .promotion-card-content .provider-info[data-v-cec19694]{display:flex;justify-content:space-between;align-items:center;padding-top:15px}.selection-holder .promotion-card-content .selection-icon[data-v-cec19694]{display:inline-block;margin-bottom:20px}.selection-holder .promotion-card[data-v-cec19694]:hover{background:#080438;transition:all .3s ease;-webkit-transition:all .3s ease}.selection-holder .promotion-card:hover .selection-icon svg path[data-v-cec19694]{color:#fff}.selection-holder .row .col-md-10[data-v-cec19694]{width:100%;padding-right:28px}@media (min-width:768px){.selection-holder .row .col-md-10[data-v-cec19694]{padding-right:0}}@media (min-width:1024px){.selection-holder .row .col-md-10[data-v-cec19694]{width:83.33333333%}}.selection-listing[data-v-cec19694]{box-shadow:0 1px 8px rgba(0,0,0,.08)}.selection-list[data-v-cec19694]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;width:100%;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;overflow:visible;box-shadow:none;margin-top:20px;padding-bottom:13px;background:transparent}@media (min-width:768px){.selection-list[data-v-cec19694]{background:#fff;-ms-flex-wrap:wrap;flex-wrap:wrap;overflow:hidden;box-shadow:0 1px 8px rgba(0,0,0,.1);padding-bottom:0}}.selection-list-box[data-v-cec19694]{min-height:200px;background:#fff;min-width:252px;overflow:hidden;padding:20px 20px 24px;position:relative;transition:all .1s ease;-webkit-transition:all .1s ease;margin-right:16px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;white-space:normal}@media (min-width:768px){.selection-list-box[data-v-cec19694]{margin:0;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;min-width:auto;padding:40px 30px 30px}}.selection-list-box .btm-img[data-v-cec19694]{position:absolute;display:none;bottom:-30px;right:-30px;filter:opacity(0);opacity:0}@media (min-width:768px){.selection-list-box .btm-img[data-v-cec19694]{display:block}}.selection-list-box object[data-v-cec19694]{margin-bottom:20px;width:24px;height:24px}@media (min-width:768px){.selection-list-box object[data-v-cec19694]{margin-bottom:15px;width:48px;height:48px}}.selection-list-box svg[data-v-cec19694]{margin-bottom:20px;width:24px;height:24px}@media (min-width:768px){.selection-list-box svg[data-v-cec19694]{margin-bottom:15px;width:48px;height:48px}}.selection-list-box p[data-v-cec19694]{min-height:110px}@media (min-width:768px){.selection-list-box p[data-v-cec19694]{min-height:auto}}.selection-list-box a[data-v-cec19694]{color:var(--primary-btn)}.selection-list-box .read-more[data-v-cec19694]{font-weight:700;font-size:12px;line-height:15px;color:#e8321d}.selection-list-box .read-more img[data-v-cec19694]{margin-left:8px}@media (min-width:768px){.selection-list-box .read-more[data-v-cec19694]{display:none}}.selection-list-box .testi-card[data-v-cec19694]{display:block}.selection-list-box .testi-card-hover[data-v-cec19694]{display:none}@media (min-width:768px){.selection-list-box[data-v-cec19694]:hover{background-color:var(--primary-btn);transition:all .1s ease;-webkit-transition:all .1s ease}.selection-list-box:hover .btm-img[data-v-cec19694]{filter:contrast(.8);width:220px;height:auto;opacity:.2}.selection-list-box:hover h5[data-v-cec19694]{color:#fff}.selection-list-box:hover p[data-v-cec19694]{position:relative;color:#fff;z-index:1}.selection-list-box:hover li[data-v-cec19694],.selection-list-box:hover li a[data-v-cec19694],.selection-list-box:hover p a[data-v-cec19694]{color:#fff}.selection-list-box:hover .testi-card[data-v-cec19694]{display:none}.selection-list-box:hover .testi-card-hover[data-v-cec19694]{display:block}}.normal-hide[data-v-cec19694]{display:none;margin-bottom:21px}.normal-show[data-v-cec19694]{display:block;margin-bottom:21px}.selection-list-box:hover .normal-hide[data-v-cec19694]{display:block}.selection-list-box:hover .normal-show[data-v-cec19694]{display:none}.ct-game-guide[data-v-cec19694]{background-color:#f1f2f3;padding:32px 0 38px}@media (min-width:768px){.ct-game-guide[data-v-cec19694]{padding:60px 0}}.ct-game-guide .info-card[data-v-cec19694]{background-color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;margin-bottom:20px}@media (min-width:768px){.ct-game-guide .info-card[data-v-cec19694]{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;margin-bottom:12px}}.ct-game-guide .info-card .info-card-img[data-v-cec19694]{width:100%;min-height:155px;cursor:pointer}.ct-game-guide .info-card .info-card-img img[data-v-cec19694]{max-height:155px}@media (min-width:768px){.ct-game-guide .info-card .info-card-img[data-v-cec19694]{width:45%;min-height:auto}.ct-game-guide .info-card .info-card-img img[data-v-cec19694]{max-height:none}}@media (min-width:992px){.ct-game-guide .info-card .info-card-img[data-v-cec19694]{width:30%}}.ct-game-guide .info-card .info-card-content[data-v-cec19694]{width:100%;min-height:auto;padding:16px 20px}@media (min-width:768px){.ct-game-guide .info-card .info-card-content[data-v-cec19694]{width:55%;min-height:110px;padding:45px}}@media (min-width:992px){.ct-game-guide .info-card .info-card-content[data-v-cec19694]{width:70%}}.ct-game-guide .info-card .info-card-content a[data-v-cec19694]{min-width:100%;margin:12px auto 0}@media (min-width:768px){.ct-game-guide .info-card .info-card-content a[data-v-cec19694]{min-width:191px;margin:25px auto 0}}.ct-game-guide .info-card .info-card-content h2[data-v-cec19694]{color:#030030;margin-bottom:28px}@media (min-width:768px){.ct-game-guide .info-card .info-card-content h2[data-v-cec19694]{margin:0 0 16px;color:#222}}.game-header[data-v-cec19694]{background:#222;padding:12px;border-top-right-radius:10px;border-top-left-radius:10px}.game-header h2[data-v-cec19694]{margin-bottom:0;color:#fff;padding:5px;text-align:center}.info-card[data-v-cec19694]{margin-bottom:20px;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;box-shadow:0 3px 8px 0 rgba(0,0,0,.2);overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.info-card-horizontal[data-v-cec19694],.info-card[data-v-cec19694]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:768px){.info-card-horizontal[data-v-cec19694]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.info-card-img[data-v-cec19694]{position:relative;width:30%;background-color:#f5f6fc}.info-card-img img[data-v-cec19694]{position:relative;width:100%;height:100%;object-fit:cover;object-position:center}.info-card-content[data-v-cec19694]{width:70%;min-height:110px;padding:45px}.info-card-content h2[data-v-cec19694]{margin-bottom:3px}.info-card-content h6[data-v-cec19694]{margin-bottom:5px}.info-card-content p[data-v-cec19694]{margin-left:0;margin-bottom:8px;color:#222}.info-card-content a[data-v-cec19694]{box-shadow:inset 0 -4px 4px #d02916;min-width:191px}.info-card-content a[data-v-cec19694]:focus,.info-card-content a[data-v-cec19694]:hover{background-color:#9a2b28;box-shadow:none;-webkit-box-shadow:none;border-color:#9a2b28;color:#fff}.show-read-more[data-v-cec19694]{display:none}@media (min-width:768px){.show-read-more[data-v-cec19694]{display:block}}.show-read-more-mob[data-v-cec19694]{display:none}@media (max-width:576px){.show-read-more-mob[data-v-cec19694]{display:block}}.hidden-methods[data-v-cec19694]{margin-top:0}@media (min-width:992px){.hidden-methods[data-v-cec19694]{margin-top:18px}}.white-space-nowrap[data-v-cec19694]{white-space:wrap!important}@media (min-width:992px){.white-space-nowrap[data-v-cec19694]{white-space:nowrap!important}}@media (min-width:992px){.payment-btn[data-v-cec19694]{min-height:68px;display:flex!important;align-items:center!important;justify-content:center}}.loader-spinner[data-v-cec19694]{text-align:center}.custom-color a[data-v-cec19694]{color:var(--primary-btn)}.pt-24[data-v-cec19694]{padding-top:24px}.rm-casino-border[data-v-cec19694]{border-bottom-left-radius:0;border-bottom-right-radius:0}", ""]);

// exports


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{directives:[{name:"observer",rawName:"v-observer",value:(_vm.mutationObserve),expression:"mutationObserve"}],staticClass:"main-content-area"},[(_vm.pageBlockData && _vm.pageBlockData.length > 0)?[_vm._l((_vm.pageBlockData),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"pageValue":'home',"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]}),_vm._v(" "),(_vm.auhtorBlockdata && _vm.pageBlockData.length === _vm.blockData.length)?void 0:_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.templateCheck === 'home-with-default' && _vm.responseData)?_c('HomeLayout2',{key:_vm.responseData.content.blocks.length,attrs:{"homeLayout2Data":_vm.responseData}}):(_vm.responseData)?_c('HomeLayout1',{key:_vm.responseData.content.blocks.length,attrs:{"homeLayout1Data":_vm.responseData}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(598);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("17c29b56", content, true, {});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-d5426f52]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-d5426f52]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-d5426f52]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-d5426f52]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-d5426f52]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-d5426f52]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-d5426f52]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-d5426f52]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-d5426f52]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-d5426f52]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-d5426f52]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-d5426f52]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.pt-37[data-v-d5426f52]{padding-top:37px}.hide-mob[data-v-d5426f52]{display:none}@media (min-width:768px){.hide-mob[data-v-d5426f52]{display:block}}.casino-header[data-v-d5426f52]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-d5426f52]{text-align:center;color:#fff;font-weight:700;padding:8px}", ""]);

// exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(600);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("668987cd", content, true, {});

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-abfab7e0]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-abfab7e0]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-abfab7e0]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-abfab7e0]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-abfab7e0]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-abfab7e0]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-abfab7e0]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-abfab7e0]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-abfab7e0]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-abfab7e0]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-abfab7e0]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-abfab7e0]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.breadcrumbs[data-v-abfab7e0]{margin-bottom:10px}@media (min-width:576px){.breadcrumbs[data-v-abfab7e0]{margin-bottom:20px}}.breadcrumbs ul[data-v-abfab7e0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}@media (min-width:576px){.breadcrumbs ul[data-v-abfab7e0]{-ms-flex-wrap:nowrap;flex-wrap:nowrap}}.breadcrumbs ul li[data-v-abfab7e0]{font-weight:300;font-size:12px;font-family:var(--default-regular);line-height:19px;color:#fff;position:relative;padding-right:16px}.breadcrumbs ul li[data-v-abfab7e0]:after{position:absolute;content:\">\";right:5px;top:50%;transform:translateY(-50%);color:#fff;font-size:12px}.breadcrumbs ul li[data-v-abfab7e0]:last-child:after{display:none}.breadcrumbs ul li[data-v-abfab7e0]:last-child{background:none;margin-right:0;padding-right:0}.breadcrumbs ul li a[data-v-abfab7e0]{color:#fff;font-weight:300;font-family:var(--default-regular);text-decoration:none}.breadcrumbs ul li.active[data-v-abfab7e0],.breadcrumbs ul li a[data-v-abfab7e0]:hover{color:#e8321d}.breadcrumbs ul li .router-link-exact-active[data-v-abfab7e0]{color:var(--primary-btn)!important}.breadcrumbs-invert ul li[data-v-abfab7e0],.breadcrumbs-invert ul li[data-v-abfab7e0]:after,.breadcrumbs-invert ul li a[data-v-abfab7e0]{color:#222}.breadcrumbs-invert ul li a[data-v-abfab7e0]:hover{color:#e8321d}.breadcrumbs-light ul li[data-v-abfab7e0],.breadcrumbs-light ul li[data-v-abfab7e0]:after,.breadcrumbs-light ul li a[data-v-abfab7e0]{color:hsla(0,0%,100%,.7)!important}.breadcrumbs-light ul li a[data-v-abfab7e0]:hover{color:var(--primary-btn)!important}.breadcrumbs-dark ul li[data-v-abfab7e0],.breadcrumbs-dark ul li[data-v-abfab7e0]:after,.breadcrumbs-dark ul li a[data-v-abfab7e0]{color:#222}.breadcrumbs-dark ul li a[data-v-abfab7e0]:hover{color:var(--primary-btn)!important}@media (min-width:992px){.game-ul[data-v-abfab7e0]{width:73%}}.game-span[data-v-abfab7e0]{width:27%;float:left;font-size:20px;line-height:26px;text-align:center;display:none}@media (min-width:992px){.game-span[data-v-abfab7e0]{display:block}}", ""]);

// exports


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    breadcrumbs: true,
    'breadcrumbs-dark': _vm.dark,
    'breadcrumbs-light': !_vm.dark,
  },style:({ '--primary-btn': _vm.dark ? '#0084ff' : '#ffffff' })},[_c('ul',{class:{ 'game-ul': _vm.templateName && _vm.gameBlockTitle != '' }},_vm._l((_vm.breadcrumbData),function(data,index){return _c('li',{key:index},[(_vm.$root.enable_piwik_reload)?[(index === _vm.breadcrumbData.length - 1)?[(data.type === 'custom')?_c('span',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            }},[_vm._v(_vm._s(data.title))]):_c('span',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            }},[_vm._v(_vm._s(data.title)+"\n          ")])]:[(data.type === 'custom')?_c('a',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            },attrs:{"title":data.title,"href":data.url}},[_vm._v(_vm._s(data.title))]):_c('a',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            },attrs:{"title":data.title,"href":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(data.title)+"\n          ")])]]:[(index === _vm.breadcrumbData.length - 1)?[(data.type === 'custom')?_c('span',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            }},[_vm._v(_vm._s(data.title))]):_c('span',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            }},[_vm._v(_vm._s(data.title)+"\n          ")])]:[(data.type === 'custom')?_c('a',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            },attrs:{"title":data.title,"href":data.url}},[_vm._v(_vm._s(data.title))]):_c('router-link',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            },attrs:{"title":data.title,"to":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(data.title)+"\n          ")])]]],2)}),0),_vm._v(" "),(_vm.templateName && _vm.gameBlockTitle != '')?_c('span',{class:{
      'span-h1 custom-font-1 cust-h1 game-span': true,
      'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
    }},[_vm._v(_vm._s(_vm.gameBlockTitle))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(603);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("63810f14", content, true, {});

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-72f27e3a]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-72f27e3a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-72f27e3a]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-72f27e3a]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-72f27e3a]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-72f27e3a]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-72f27e3a]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-72f27e3a]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-72f27e3a]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-72f27e3a]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-72f27e3a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-72f27e3a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (max-width:576px){.page-links-outr[data-v-72f27e3a]{padding-top:20px}}.page-links-outr .container[data-v-72f27e3a]{padding:0}@media (min-width:768px){.page-links-outr .container[data-v-72f27e3a]{padding:0 15px}}.page-links-outr .ct-related-page-links[data-v-72f27e3a]{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;padding:0 20px;margin:0;display:block}@media (min-width:768px){.page-links-outr .ct-related-page-links[data-v-72f27e3a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:35px 0 25px;padding:0}}.page-links-outr .ct-related-page-links-header[data-v-72f27e3a]{background-color:#002844;width:100%;padding:8px 8px 8px 20px;border-top-left-radius:5px;border-top-right-radius:5px;display:flex;align-items:center}.page-links-outr .ct-related-page-links-header .span-h6[data-v-72f27e3a]{font-weight:700;font-size:16px;line-height:160%;color:#fff;margin-bottom:0;white-space:break-spaces}@media (min-width:768px){.page-links-outr .ct-related-page-links-header .span-h6[data-v-72f27e3a]{margin-bottom:0;margin-right:27px}}.page-links-outr .ct-related-page-links-content[data-v-72f27e3a]{background-color:#264860;width:100%;padding:16px 16px 16px 20px;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.page-links-outr .ct-related-page-links-content ul[data-v-72f27e3a]{overflow-x:auto!important;white-space:nowrap;display:flex;align-items:center}@media (min-width:768px){.page-links-outr .ct-related-page-links-content ul[data-v-72f27e3a]{overflow-x:hidden!important}}.page-links-outr .ct-related-page-links-content ul[data-v-72f27e3a]:hover{overflow:auto!important}.page-links-outr .ct-related-page-links-content ul li[data-v-72f27e3a]{margin-right:40px;display:inline-block}.page-links-outr .ct-related-page-links-content ul li[data-v-72f27e3a]:hover{text-decoration:underline}.page-links-outr .ct-related-page-links-content ul li[data-v-72f27e3a]:last-child{margin-right:0}.page-links-outr .ct-related-page-links-content ul li a[data-v-72f27e3a]{font-size:16px;line-height:160%;color:#fff;font-family:var(--default-regular)}.page-links-outr .ct-related-page-links .router-link-exact-active[data-v-72f27e3a]{color:#fff!important}.pb-0[data-v-72f27e3a]{padding-bottom:0!important}.scroll-hover[data-v-72f27e3a]:hover::-webkit-scrollbar{height:6px}.mobile-scroller[data-v-72f27e3a]::-webkit-scrollbar{height:6px!important}.mobile-scroller[data-v-72f27e3a]::-webkit-scrollbar-thumb{background-color:#333!important}.mobile-scroller[data-v-72f27e3a]::-webkit-scrollbar-track{margin:0!important}", ""]);

// exports


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.relatedLinkData &&
    _vm.relatedLinkData.options &&
    _vm.relatedLinkData.options.length > 0
  )?_c('section',{staticClass:"page-links-outr pb-25"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"ct-related-page-links"},[_c('div',{staticClass:"ct-related-page-links-header"},[_c('span',{staticClass:"span-h6 custom-font-1"},[_vm._v(_vm._s(_vm.relatedLinkData.heading))])]),_vm._v(" "),_c('div',{staticClass:"ct-related-page-links-content"},[_c('ul',{ref:"hRScroll",staticClass:"mobile-scroller scroll-hover pb-0"},_vm._l((_vm.relatedLinkData.options),function(option,index){return _c('li',{key:index},[(_vm.$root.enable_piwik_reload)?[_c('a',{staticClass:"cat-cls",attrs:{"title":option.title,"href":_vm.getRouteLink(option.link.post_name, option.link.post_type)}},[_vm._v(_vm._s(option.title))])]:[_c('router-link',{staticClass:"cat-cls",attrs:{"title":option.title,"to":_vm.getRouteLink(option.link.post_name, option.link.post_type)}},[_vm._v(_vm._s(option.title))])]],2)}),0)])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{
    'main-content-area': true,
    'custom-background-image': _vm.$root.color_schema.site_bg_img,
  },style:({
    '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
    '--bg-color': _vm.$root.color_schema.site_bg_color,
  })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"observer",rawName:"v-observer",value:(_vm.mutationObserve),expression:"mutationObserve"}],class:{
      'custom-background-color': _vm.$root.color_schema.site_bg_img,
      'pb-25 pt-26': true,
    }},[_c('section',{staticClass:"ct-article"},[_c('div',{staticClass:"container overflow-auto"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.articleData.breadcrumb,"dark":true}})],1)])]),_vm._v(" "),_vm._l((_vm.blockData),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]}),_vm._v(" "),(
        _vm.morePaymentBottom &&
        _vm.blockData.length === _vm.articleData.content.blocks.length
      )?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(
        _vm.auhtorBlockdata &&
        _vm.blockData.length === _vm.articleData.content.blocks.length
      )?void 0:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(607);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d02e6790", content, true, {});

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(46);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-ba9ee58e]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-ba9ee58e]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-ba9ee58e]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-ba9ee58e]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-ba9ee58e]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-ba9ee58e]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-ba9ee58e]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-ba9ee58e]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-ba9ee58e]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-ba9ee58e]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-ba9ee58e]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.lang-img[data-v-ba9ee58e]{height:36px;width:36px}.px-0[data-v-ba9ee58e]{padding-left:0!important;padding-right:0!important}.pb-1[data-v-ba9ee58e]{padding-top:1px!important}.ct-inner-banner[data-v-ba9ee58e]{padding:0 0 45px;background:#070438 url(" + escape(__webpack_require__(62)) + ") no-repeat 0 0}.ct-inner-banner .game-space[data-v-ba9ee58e]{position:relative;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space[data-v-ba9ee58e]{min-height:auto}}.ct-inner-banner .game-space img[data-v-ba9ee58e]{border-radius:10px;box-shadow:0 5px 15px rgba(0,0,0,.05);height:100%;object-fit:cover;width:auto;max-height:321px;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space img[data-v-ba9ee58e]{width:100%;max-height:none;min-height:auto}}.ct-inner-banner .game-space-content[data-v-ba9ee58e]{position:absolute;left:0;right:0;top:0;bottom:0;padding:20px}.ct-inner-banner .game-space-content .button-block[data-v-ba9ee58e],.ct-inner-banner .game-space-content[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-inner-banner .game-space-content .button-block[data-v-ba9ee58e]{width:100%;margin-bottom:15px}.ct-inner-banner .game-space-content .button-block .cta[data-v-ba9ee58e]{min-width:100%;margin:5px 0;font-weight:700;font-size:14px;line-height:17px;padding:10px 18px}@media (min-width:768px){.ct-inner-banner .game-space-content .button-block .cta[data-v-ba9ee58e]{min-width:330px;margin:10px 0;padding:15px 18px;font-size:18px;line-height:22px}}.ct-inner-banner .game-space-content .game-logo img[data-v-ba9ee58e]{box-shadow:none;max-height:none;min-height:auto}@media (min-width:768px){.ct-inner-banner .row .col-md-8[data-v-ba9ee58e]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-8[data-v-ba9ee58e]{width:66.66666667%;float:left}}@media (min-width:768px){.ct-inner-banner .row .col-md-4[data-v-ba9ee58e]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-4[data-v-ba9ee58e]{width:33.33333333%;float:left}}.ct-inner-banner-lft[data-v-ba9ee58e]{margin-bottom:19px}@media (min-width:992px){.ct-inner-banner-lft[data-v-ba9ee58e]{margin-bottom:0}}@media (min-width:1360px){.ct-inner-banner-lft[data-v-ba9ee58e]{width:906px!important}}@media (min-width:1360px){.ct-inner-banner-rgt[data-v-ba9ee58e]{width:314px!important}}.new-review-banner-card[data-v-ba9ee58e]{padding:12px 16px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;box-shadow:none}@media (min-width:576px){.new-review-banner-card[data-v-ba9ee58e]{padding:20px}}@media (min-width:1200px){.new-review-banner-card[data-v-ba9ee58e]{padding:30px}}.new-review-banner-card-top[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:768px){.new-review-banner-card-top[data-v-ba9ee58e]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-top-left[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:auto;margin:0 -7px 18px -6px}@media (min-width:350px){.new-review-banner-card-top-left[data-v-ba9ee58e]{margin:0 -7px 18px 5px;justify-content:unset!important}}@media (min-width:576px){.new-review-banner-card-top-left[data-v-ba9ee58e]{width:100%;margin:0 0 28px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}}@media (min-width:768px){.new-review-banner-card-top-left[data-v-ba9ee58e]{margin:0 0 45px}}@media (min-width:1024px){.new-review-banner-card-top-left[data-v-ba9ee58e]{width:calc(100% - 400px);margin:0 0 5px}}@media (min-width:1080px){.new-review-banner-card-top-left[data-v-ba9ee58e]{width:calc(100% - 430px)}}@media (min-width:1200px){.new-review-banner-card-top-left[data-v-ba9ee58e]{width:calc(100% - 495px)}}.new-review-banner-card-top-left .review-left-img[data-v-ba9ee58e]{min-width:79px;max-width:79px;height:79px;background:#fff;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative}.new-review-banner-card-top-left .review-left-img a[data-v-ba9ee58e]{box-shadow:0 2px 4px rgba(0,0,0,.2);border-radius:12px;overflow:visible;margin-top:0}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img a[data-v-ba9ee58e]{margin-top:4px}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-img a[data-v-ba9ee58e]{margin-top:4px}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-img a[data-v-ba9ee58e]{margin-top:0}}.new-review-banner-card-top-left .review-left-img img[data-v-ba9ee58e]{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img img[data-v-ba9ee58e]{height:100%;width:100%}}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img[data-v-ba9ee58e]{min-width:245px;max-width:245px;height:245px}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-img[data-v-ba9ee58e]{min-width:245px;max-width:245px;height:245px}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-img[data-v-ba9ee58e]{min-width:250px;max-width:250px;height:250px}}.new-review-banner-card-top-left .review-left-img .exclusive-tag[data-v-ba9ee58e]{position:absolute;left:0;right:0;margin:auto;height:20px;font-size:12px;line-height:15px;width:100%;bottom:0;border-radius:0;border-bottom-left-radius:8px;border-bottom-right-radius:8px;display:flex;justify-content:center;align-items:center}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img .exclusive-tag[data-v-ba9ee58e]{bottom:14px;width:210px;height:28px;font-size:17px;line-height:28px;z-index:10;border-radius:8px}}.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-ba9ee58e]{width:18px!important;height:18px!important;border-radius:0!important;object-fit:contain!important}@media (max-width:576px){.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-ba9ee58e]{margin:0 auto;width:14px!important;height:14px!important}}@media (min-width:576px){.new-review-banner-card-top-left .review-left-img .exclusive-tag p[data-v-ba9ee58e]{font-weight:700;margin-top:0;font-size:12px;margin:0}}@media (max-width:768px){.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-ba9ee58e],.new-review-banner-card-top-left .review-left-img .exclusive-tag svg[data-v-ba9ee58e]{width:12px}}.new-review-banner-card-top-left .review-left-content[data-v-ba9ee58e]{padding:10px 0 5px 15px;height:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content[data-v-ba9ee58e]{padding:0 30px}}.new-review-banner-card-top-left .review-left-content .approve[data-v-ba9ee58e]{font-weight:400;font-size:12px;line-height:15px;color:#9b9b9b;margin-bottom:8px;margin-top:10px;display:block}.new-review-banner-card-top-left .review-left-content .approve i[data-v-ba9ee58e]{margin-right:5px}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .approve i[data-v-ba9ee58e]{margin-right:7px}}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .approve[data-v-ba9ee58e]{font-size:14px;line-height:17px;color:#aeaeae}}.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:0;margin-top:0}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-ba9ee58e]{margin-bottom:4px;margin-top:0}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-ba9ee58e]{-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:4px;margin-top:0}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-ba9ee58e]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:4px;margin-top:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar p[data-v-ba9ee58e]{margin-bottom:4px;font-weight:400;color:#222;padding-right:7px}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .exclusive-bar p[data-v-ba9ee58e]{margin-bottom:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar .exclusive-tag[data-v-ba9ee58e]{margin-left:30px;display:none}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar .exclusive-tag[data-v-ba9ee58e]{display:none}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-rating[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title[data-v-ba9ee58e]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title p[data-v-ba9ee58e]{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;margin-bottom:4px;margin-top:4px;font-size:14px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title p[data-v-ba9ee58e]{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;margin-bottom:4px;font-size:16px}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:0;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;margin-bottom:5px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust[data-v-ba9ee58e]{margin-left:8px;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;margin-bottom:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust strong[data-v-ba9ee58e]{font-weight:700;font-size:10px;line-height:1;text-transform:uppercase;color:#4caf50}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust i[data-v-ba9ee58e]{background:#4caf50;width:8.35px;height:8.35px;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:3.65px}.new-review-banner-card-top-left .review-left-content-title[data-v-ba9ee58e]{display:none}.new-review-banner-card-top-left .review-left-content-title h1[data-v-ba9ee58e]{margin-bottom:12px}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-content-title h1[data-v-ba9ee58e]{margin-bottom:12px}}.new-review-banner-card-top-left .review-left-content-title .cta[data-v-ba9ee58e]{min-width:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content-title[data-v-ba9ee58e]{display:block}}.new-review-banner-card-top .view-mob[data-v-ba9ee58e]{display:block;text-align:center}.new-review-banner-card-top .view-mob h1[data-v-ba9ee58e]{margin-bottom:17px;padding:0 10%}.new-review-banner-card-top .view-mob .cta-promo-review[data-v-ba9ee58e]{font-size:18px;line-height:100%;margin-top:0;display:block}@media (min-width:768px){.new-review-banner-card-top .view-mob[data-v-ba9ee58e]{display:none}}.new-review-banner-card-top-right[data-v-ba9ee58e]{min-width:100%;margin-top:17px;border-top:0;border-right:0;border-left:0;padding:0}@media (min-width:768px){.new-review-banner-card-top-right[data-v-ba9ee58e]{width:calc(100% - 315px);min-width:calc(100% - 315px);border-right:1px solid #e5e5e5;border-left:0;padding:0 45px 0 0;margin-top:0}}@media (min-width:1024px){.new-review-banner-card-top-right[data-v-ba9ee58e]{width:400px;min-width:auto;padding:0 0 0 35px;border-right:0;border-left:1px solid #e5e5e5}}@media (min-width:1080px){.new-review-banner-card-top-right[data-v-ba9ee58e]{width:430px}}@media (min-width:1200px){.new-review-banner-card-top-right[data-v-ba9ee58e]{width:495px}}.new-review-banner-card-top-right h6[data-v-ba9ee58e]{color:#222}@media (min-width:576px){.new-review-banner-card-top-right h6[data-v-ba9ee58e]{margin:0 0 3px;color:#222}}.new-review-banner-card-top-right p[data-v-ba9ee58e]{color:#222}@media (min-width:576px){.new-review-banner-card-top-right p[data-v-ba9ee58e]{margin:0 0 20px;color:#465867}}.new-review-banner-card-bottom[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-top:0;padding:16px 0 0;min-width:100%;width:100%}@media (min-width:768px){.new-review-banner-card-bottom[data-v-ba9ee58e]{padding:0 0 0 45px;margin-top:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:315px;width:315px}}@media (min-width:1024px){.new-review-banner-card-bottom[data-v-ba9ee58e]{border-top:1px solid #e5e5e5;width:100%;min-width:auto;padding:24px 0 0;margin-top:32px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-bottom .casino-card-lists[data-v-ba9ee58e]{margin-bottom:0}@media (min-width:768px){.new-review-banner-card-bottom .casino-card-lists[data-v-ba9ee58e]{margin-bottom:10px}}@media (min-width:1200px){.new-review-banner-card-bottom .casino-card-lists[data-v-ba9ee58e]{margin-bottom:0}}.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-ba9ee58e]{margin-right:15px}.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-ba9ee58e]:last-child{margin-right:0}@media (min-width:992px){.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-ba9ee58e]{margin-right:16px}}.ct-editor-section .container[data-v-ba9ee58e]{position:static}.editor-content .max-cntent-area[data-v-ba9ee58e]{max-width:960px}.editor-content img[data-v-ba9ee58e]{margin-bottom:20px}.editor-content ul[data-v-ba9ee58e]{list-style-type:none;padding:0}.editor-content ul li[data-v-ba9ee58e]{font-style:normal;font-weight:400;font-size:16px;line-height:25px;position:relative;padding-left:20px;margin-bottom:15px}.editor-content ul li span[data-v-ba9ee58e]{font-weight:700}#sticky-nav[data-v-ba9ee58e]{padding-bottom:30px}.review-top-menu[data-v-ba9ee58e]{padding-bottom:30px;padding-top:14px;background:#fff;border-bottom:1px solid #bbb;padding:0 14px;height:53px;margin-bottom:0}.review-top-menu .scroll-nav[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow-x:auto;overflow-y:hidden;white-space:nowrap;border-bottom:1px solid #bbb;max-width:1210px;margin:0 auto;height:53px}.review-top-menu .scroll-nav .scroll-item[data-v-ba9ee58e]{margin-right:30px;display:inline-block;padding:10px 0;position:relative;font-weight:700;font-size:18px;color:#222;line-height:25px;cursor:pointer;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s}.review-top-menu .scroll-nav .scroll-item.active[data-v-ba9ee58e],.review-top-menu .scroll-nav .scroll-item[data-v-ba9ee58e]:hover{color:var(--primary-btn)}.review-top-menu .scroll-nav .scroll-item.active[data-v-ba9ee58e]:after,.review-top-menu .scroll-nav .scroll-item[data-v-ba9ee58e]:hover:after{bottom:0}.review-top-menu .scroll-nav .scroll-item.active[data-v-ba9ee58e]{font-weight:700}.sticky[data-v-ba9ee58e]{position:-webkit-sticky;position:sticky;top:0;z-index:5}.casino-card-lists ul li[data-v-ba9ee58e]{margin:0 32px 0 0}.casino-card-lang-lists ul[data-v-ba9ee58e]{margin:0}@media (min-width:992px){.casino-card-lists ul[data-v-ba9ee58e]{margin-bottom:20px}}.casino-card-lang-lists ul li[data-v-ba9ee58e]{width:36px;height:36px;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;overflow:hidden;margin:0 6px 6px 0;padding:0;border:1px solid #bbb}.new-review-banner-card-top-right h6[data-v-ba9ee58e],.review-banner-card-top-right h6[data-v-ba9ee58e]{margin-bottom:3px}.review-top-menu ul li a[data-v-ba9ee58e],.review-top-menu ul li a[data-v-ba9ee58e]:active{padding:10px 20px 10px 0;font-weight:400;font-size:16px;color:#9b9b9b;line-height:25px}.rating-wrapper-small .radio-star-total[data-v-ba9ee58e]{padding-left:10px;line-height:20px}.casino-card-lists ul li[data-v-ba9ee58e]{margin:0 12px 0 0;padding:0;list-style-type:none}@media (min-width:374px){.casino-card-lists ul li[data-v-ba9ee58e]{margin:0 16px 0 0}}.casino-card-lists__review h6[data-v-ba9ee58e]{font-weight:400}.bonus-card-logo[data-v-ba9ee58e]{background:#fff!important;height:280px!important}.bonus-card-logo a[data-v-ba9ee58e]{text-align:center}.bonus-card-logo img[data-v-ba9ee58e]{height:100%;width:100%;object-fit:cover;border-radius:12px 12px 0 0}@media (min-width:992px){.bonus-card-logo img[data-v-ba9ee58e]{border-radius:12px 0 0 12px;width:100%}}@media (min-width:768px){.bonus-card-logo[data-v-ba9ee58e]{height:100%!important}}.bonus-card-content[data-v-ba9ee58e]{overflow:hidden;display:flex;flex-wrap:wrap;align-items:center}@media (min-width:768px){.bonus-card-content[data-v-ba9ee58e]{padding:30px 45px}}.bonus-card-content-top[data-v-ba9ee58e]{width:100%}.justify-flex-start[data-v-ba9ee58e]{justify-content:flex-start!important}@media (max-width:990px){.license-right[data-v-ba9ee58e]{display:flex;align-items:center;justify-content:flex-end;margin-top:10px;margin-bottom:10px!important}}@media (min-width:992px){.license-right[data-v-ba9ee58e]{text-align:right}}@media (min-width:992px){.justify-flex-end[data-v-ba9ee58e]{justify-content:flex-end!important}}.justify-flex-end li[data-v-ba9ee58e]:last-child{margin-right:0}.casino-card-bonus[data-v-ba9ee58e]{margin:0;flex-direction:row}@media (min-width:992px){.casino-card-bonus[data-v-ba9ee58e]{padding:16px;min-height:296px}}@media (min-width:1200px){.casino-card-bonus[data-v-ba9ee58e]{min-height:296px;height:auto}}.casino-card-bonus .bonus-card-logo[data-v-ba9ee58e]{padding:16px;box-shadow:none;height:auto!important;min-height:280px!important;position:relative}@media (min-width:768px){.casino-card-bonus .bonus-card-logo[data-v-ba9ee58e]{padding:0;box-shadow:0 5px 15px rgba(0,0,0,.05);width:265px;min-height:265px!important;border-radius:0;border-top-left-radius:12px}}@media (min-width:992px){.casino-card-bonus .bonus-card-logo[data-v-ba9ee58e]{border-radius:5px}}.casino-card-bonus .bonus-card-logo img[data-v-ba9ee58e]{border-radius:5px}@media (min-width:768px){.casino-card-bonus .bonus-card-logo img[data-v-ba9ee58e]{border-radius:0;border-top-left-radius:12px;border-bottom-left-radius:12px}}@media (min-width:992px){.casino-card-bonus .bonus-card-logo img[data-v-ba9ee58e]{border-radius:5px}}@media (min-width:768px){.casino-card-bonus .bonus-card-logo img.no-terms[data-v-ba9ee58e]{border-bottom-left-radius:0}}@media (min-width:992px){.casino-card-bonus .bonus-card-logo img.no-terms[data-v-ba9ee58e]{border-radius:5px}}.casino-card-bonus .bonus-card-content[data-v-ba9ee58e]{padding:0 16px 16px}@media (min-width:768px){.casino-card-bonus .bonus-card-content[data-v-ba9ee58e]{padding:20px 0 20px 16px;align-items:flex-start;width:calc(100% - 265px);flex-direction:row;min-height:265px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content[data-v-ba9ee58e]{padding:0 0 0 16px}}.casino-card-bonus .bonus-card-content-top[data-v-ba9ee58e]{flex-direction:column}@media (min-width:768px){.casino-card-bonus .bonus-card-content-top[data-v-ba9ee58e]{align-items:center;flex-direction:row}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-top[data-v-ba9ee58e]{margin-bottom:16px;align-items:flex-start}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-top .half-column-cont[data-v-ba9ee58e]{max-width:450px}}.casino-card-bonus .bonus-card-content-top .half-column-cont .bonus-card-rating[data-v-ba9ee58e]{flex-direction:column;justify-content:center;align-items:flex-start}.casino-card-bonus .bonus-card-content-top .half-column-cont .bonus-card-rating p[data-v-ba9ee58e]{font-weight:700}.casino-card-bonus .bonus-card-content-top .half-column-cont span[data-v-ba9ee58e]{font-size:22px}@media (min-width:992px){.casino-card-bonus .bonus-card-content-top .half-column-cont span[data-v-ba9ee58e]{font-size:28px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-top .play_term_wrapper[data-v-ba9ee58e]{align-items:flex-end}}.casino-card-bonus .bonus-card-content-top .play_term_wrapper a[data-v-ba9ee58e]{min-width:100%}@media (min-width:768px){.casino-card-bonus .bonus-card-content-top .play_term_wrapper a[data-v-ba9ee58e]{min-width:150px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-top .play_term_wrapper a[data-v-ba9ee58e]{min-width:332px}}.casino-card-bonus .bonus-card-content-bottom[data-v-ba9ee58e]{padding-top:16px;width:100%}@media (min-width:768px){.casino-card-bonus .bonus-card-content-bottom[data-v-ba9ee58e]{padding-top:8px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-bottom[data-v-ba9ee58e]{padding-top:16px}}.casino-card-bonus .bonus-card-content-bottom .span-h6[data-v-ba9ee58e]{font-size:16px;margin-bottom:12px}@media (min-width:768px){.casino-card-bonus .bonus-card-content-bottom .span-h6[data-v-ba9ee58e]{font-size:16px;margin-bottom:6px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-bottom .span-h6[data-v-ba9ee58e]{font-size:16px;margin-bottom:12px}}.casino-card-bonus .bonus-card-content-bottom .proslist-rev li[data-v-ba9ee58e]{margin-bottom:14px}@media (min-width:768px){.casino-card-bonus .bonus-card-content-bottom .proslist-rev li[data-v-ba9ee58e]{margin-bottom:1px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-bottom .proslist-rev li[data-v-ba9ee58e]{margin-bottom:14px}}@media (min-width:768px){.offset-md-1[data-v-ba9ee58e]{margin-left:2.33333%}}.play_term_wrapper[data-v-ba9ee58e]{display:flex;flex-direction:column;align-items:center}.play_term_wrapper .terms_tc[data-v-ba9ee58e]{margin-bottom:8px}.play_term_wrapper .btn-cust[data-v-ba9ee58e]{margin:18px 0!important}.mx-0[data-v-ba9ee58e]{margin-left:0;margin-right:0}.flex-wrap[data-v-ba9ee58e]{flex-wrap:wrap!important}.sticky-review-card[data-v-ba9ee58e]{bottom:0;left:0;right:0;z-index:1000;position:fixed;color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.05);transition:top .3s ease-out}@media (min-width:992px){.sticky-review-card .rating-wrapper-small[data-v-ba9ee58e]{display:inline-flex;height:24px;border-radius:50px;margin-left:15px;padding:1px 7px}.sticky-review-card .rating-wrapper-small .radio-star-total[data-v-ba9ee58e]{margin-left:0}}.sticky-review-card .sticky-inner[data-v-ba9ee58e]{background:var(--primary-btn);position:absolute;bottom:0;width:100%;max-width:78.125rem;padding:10px;display:flex;align-items:center;margin:0 auto;flex-wrap:wrap}@media (min-width:768px){.sticky-review-card .sticky-inner[data-v-ba9ee58e]{flex-wrap:nowrap}}@media (min-width:992px){.sticky-review-card .sticky-inner[data-v-ba9ee58e]{background:#fff;position:relative}}.sticky-review-card .sticky-inner .md-rating[data-v-ba9ee58e]{margin-top:10px;display:none}@media (min-width:768px){.sticky-review-card .sticky-inner .md-rating[data-v-ba9ee58e]{margin-top:8px;margin-left:-12px;display:inline-flex;height:18px;border-radius:50px;padding:1px 7px;align-items:stretch}}.sticky-review-card .sticky-inner .md-rating .radio-stars[data-v-ba9ee58e]{height:14px;width:14px}.sticky-review-card .sticky-inner .md-rating .radio-stars img[data-v-ba9ee58e]{border-radius:0;vertical-align:text-top}.sticky-review-card .sticky-inner .md-rating .radio-star-total[data-v-ba9ee58e]{font-size:14px;line-height:15px;padding-left:0;display:inline-flex;align-items:center}.sticky-review-card .sticky-inner .md-rating .radio-star-total span[data-v-ba9ee58e]{font-size:14px;line-height:15px}@media (min-width:992px){.sticky-review-card .sticky-inner .md-rating[data-v-ba9ee58e]{display:none}}.sticky-review-card .sticky-inner .sticky-text[data-v-ba9ee58e]{font-size:.875rem;margin-left:10px;margin-right:auto;line-height:.75rem;width:calc(100% - 60px)}@media (min-width:576px){.sticky-review-card .sticky-inner .sticky-text[data-v-ba9ee58e]{line-height:unset}}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text[data-v-ba9ee58e]{width:100%;margin-left:80px}}.sticky-review-card .sticky-inner .sticky-text .product-name[data-v-ba9ee58e]{display:flex;padding:0 0 5px}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text .product-name[data-v-ba9ee58e]{display:none}}.sticky-review-card .sticky-inner .sticky-text .product-name .best-rating[data-v-ba9ee58e]{margin-left:8px}.sticky-review-card .sticky-inner .sticky-text .sticky-title[data-v-ba9ee58e]{display:none}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .sticky-title[data-v-ba9ee58e]{display:flex}}.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-ba9ee58e]{font-weight:900;font-size:.875rem;line-height:14px}@media (min-width:576px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-ba9ee58e]{line-height:25px}}.sticky-review-card .sticky-inner .sticky-text .bonus-text a[data-v-ba9ee58e]{color:#fff}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-ba9ee58e]{font-size:.85rem}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-ba9ee58e]{font-size:1.625rem}.sticky-review-card .sticky-inner .sticky-text .bonus-text a[data-v-ba9ee58e]{color:#222}}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text[data-v-ba9ee58e]{font-size:.85rem}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text[data-v-ba9ee58e]{margin-left:0}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .terms-conditions[data-v-ba9ee58e]{padding-top:5px!important}}.sticky-review-card .sticky-inner .affliate-logo[data-v-ba9ee58e]{height:50px;width:50px;min-height:50px;min-width:50px;box-shadow:0 5px 15px rgba(0,0,0,.09);left:0;position:relative}.sticky-review-card .sticky-inner .affliate-logo img[data-v-ba9ee58e]{border-radius:12px}@media (min-width:768px){.sticky-review-card .sticky-inner .affliate-logo[data-v-ba9ee58e]{top:-25px;position:absolute}}@media (min-width:992px){.sticky-review-card .sticky-inner .affliate-logo[data-v-ba9ee58e]{width:85px;min-width:85px;height:85px;min-height:85px;top:0;left:0;position:relative;margin-right:30px}}.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-ba9ee58e]{display:none;font-size:18px;line-height:100%;margin:auto 2px!important}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-ba9ee58e]{display:block;background:var(--primary-btn);border-color:var(--primary-btn);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:inset 0 -4px 4px var(--primary-btn);min-width:280px;font-weight:900}}.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-ba9ee58e]:hover{background:var(--primary-btn-hover);border-color:var(--primary-btn-hover);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn-hover);box-shadow:inset 0 -4px 4px var(--primary-btn-hover)}.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-ba9ee58e]{display:none;font-size:18px;line-height:100%;color:#3672f8!important}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-ba9ee58e]{display:block;background:#fff;border-color:var(--primary-btn);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:none;margin:0;min-width:210px;height:34px;margin-left:auto}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-ba9ee58e]{display:none}}.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-ba9ee58e]:hover{color:#fff;background:var(--primary-btn-hover);border-color:var(--primary-btn-hover);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn-hover);box-shadow:inset 0 -4px 4px var(--primary-btn-hover)}.sticky-review-card .sticky-inner .sticky-play-btn-mobile[data-v-ba9ee58e]{background:#fff;color:var(--primary-btn);color:#3672f8!important;border-color:var(--primary-btn);box-shadow:none;margin:0;line-height:100%;font-size:.75rem;width:78px;height:34px;padding:10px 20px}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-play-btn-mobile[data-v-ba9ee58e]{display:none}}@media (min-width:992px){.sticky-review-card[data-v-ba9ee58e]{top:-110px;height:110px;background:#fff;color:#222}}.mr-30[data-v-ba9ee58e]{margin-right:30px!important}.minus[data-v-ba9ee58e]:before{content:\"-\";font-size:1.9rem}.h-100[data-v-ba9ee58e]{height:100%}.w-100[data-v-ba9ee58e]{width:100%}.lang-flag[data-v-ba9ee58e]{height:34px!important;width:60px!important;object-fit:cover}.flex-wrap[data-v-ba9ee58e]{display:flex;flex-wrap:wrap}figure>img[data-v-ba9ee58e]{height:100%;width:100%}.md-rating .radio-star-total[data-v-ba9ee58e],.md-rating .radio-star-total span[data-v-ba9ee58e]{color:#000!important;font-size:10px!important;line-height:10px!important}.view-mob .span-h1[data-v-ba9ee58e]{font-size:24px!important;line-height:27px!important}@media (min-width:576px){.view-mob .span-h1[data-v-ba9ee58e]{font-size:36px!important;line-height:44px!important}}.rv-terms[data-v-ba9ee58e]{display:block}.desk-terms[data-v-ba9ee58e]{display:none}@media (min-width:576px){.desk-terms[data-v-ba9ee58e]{display:block}}.mob-terms[data-v-ba9ee58e]{display:block;font-size:.75rem;line-height:13px;width:100%;text-align:center;padding:10px 0 0}@media (min-width:576px){.mob-terms[data-v-ba9ee58e]{display:none}}.mob-terms .terms-conditions[data-v-ba9ee58e]{color:#fff}.mob-terms .terms-conditions a[data-v-ba9ee58e]{color:#fff!important;text-decoration:underline!important}.mob-terms .mob-cas-term[data-v-ba9ee58e]{color:#fff}.div-term[data-v-ba9ee58e]{position:absolute;background-color:#dfe1e3;padding:7px;left:0;width:100%;border-bottom-right-radius:12px;border-bottom-left-radius:12px;line-height:20px;position:static;width:auto;margin:0 -16px -20px;text-align:center}@media (min-width:768px){.div-term[data-v-ba9ee58e]{padding:10px 12px;text-align:left;position:static;width:auto;margin:0 -20px -20px}}@media (min-width:992px){.div-term[data-v-ba9ee58e]{padding:5px 12px;position:static;width:auto;margin:0 -30px -30px}}.div-term a[data-v-ba9ee58e]{cursor:pointer;color:var(--primary-btn)}.div-term a[data-v-ba9ee58e]:hover{color:var(--primary-btn)}.terms-d[data-v-ba9ee58e]{position:relative}.stick-img img[data-v-ba9ee58e]{width:100%}.desk-bonus[data-v-ba9ee58e]{display:none}@media (min-width:576px){.desk-bonus[data-v-ba9ee58e]{display:block}}.mob-bonus[data-v-ba9ee58e]{display:block}@media (min-width:576px){.mob-bonus[data-v-ba9ee58e]{display:none}}.overall-rating[data-v-ba9ee58e]{background:#fff;border:1px solid #f3f2f5;box-shadow:0 0 20px 0 rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.overall-rating .rating-header[data-v-ba9ee58e]{background:#f7f7f7;-webkit-border-radius:12px 12px 0 0;-moz-border-radius:12px 12px 0 0;border-radius:12px 12px 0 0;padding:5px 10px 4px 16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}@media (min-width:992px){.overall-rating .rating-header[data-v-ba9ee58e]{padding:7px 30px 6px 26px}}.overall-rating .rating-header .span-h2[data-v-ba9ee58e]{font-weight:700;color:#020100;margin:0;font-size:20px}@media (min-width:576px){.overall-rating .rating-header .span-h2[data-v-ba9ee58e]{font-size:22px}}.overall-rating .rating-header .rating-count[data-v-ba9ee58e]{min-width:65px;min-height:43px;-webkit-border-radius:7.75px;-moz-border-radius:7.75px;border-radius:7.75px;position:relative}.overall-rating .rating-header .rating-count .comment[data-v-ba9ee58e]{position:absolute;left:0;right:0;bottom:0;-webkit-border-radius:0 0 7.75px 7.75px;-moz-border-radius:0 0 7.75px 7.75px;border-radius:0 0 7.75px 7.75px;font-style:italic;font-weight:400;font-size:12px;line-height:15px;text-align:center;letter-spacing:-.03em;color:#fff;padding:1px 5px;display:block;box-shadow:inset 0 0 40px rgba(0,0,0,.2)}.overall-rating .rating-header .rating-count-top[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.overall-rating .rating-header .rating-count-top .value[data-v-ba9ee58e]{font-weight:700;font-size:18px;line-height:27px;text-align:center;letter-spacing:-.03em;color:#fff;margin-top:2px}@media (min-width:576px){.overall-rating .rating-header .rating-count-top .value[data-v-ba9ee58e]{font-size:20px}}.overall-rating .rating-header .rating-count-top .full-star[data-v-ba9ee58e]{margin-left:4px;width:14px;height:14px;background:#fabf00;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;margin-right:0;position:relative;font-style:normal}.overall-rating .rating-header .rating-count-top .full-star[data-v-ba9ee58e]:after{content:\" \\2605\";position:absolute;top:50%;left:50%;color:#fff;font-size:10px;transform:translate(-50%,-50%)}.overall-rating .progress-bar-block[data-v-ba9ee58e]{padding:8px 8px 20px}@media (min-width:992px){.overall-rating .progress-bar-block[data-v-ba9ee58e]{padding:20px 35px 19px 27px}}.overall-rating .progress-bar-block .bar-row[data-v-ba9ee58e]{margin-bottom:20px}.overall-rating .progress-bar-block .bar-row[data-v-ba9ee58e]:last-child{margin-bottom:0}.overall-rating .progress-bar-block .bar-row .label[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:5px}.overall-rating .progress-bar-block .bar-row .label p[data-v-ba9ee58e]{font-weight:400;color:#222;margin:0;font-size:14px;overflow-wrap:anywhere;margin-right:10px}@media (min-width:992px){.overall-rating .progress-bar-block .bar-row .label p[data-v-ba9ee58e]{font-size:16px}}.overall-rating .progress-bar-block .bar-row .label span[data-v-ba9ee58e]{font-weight:700;font-size:18px;line-height:30px;text-align:right;text-transform:capitalize;color:#222;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (min-width:992px){.overall-rating .progress-bar-block .bar-row .label span[data-v-ba9ee58e]{font-size:20px}}.overall-rating .progress-bar-block .bar-row .label span .full-star[data-v-ba9ee58e]{margin-left:8.5px;width:14px;height:14px;background:#fabf00;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;margin-right:0;position:relative;bottom:1px;font-style:normal}.overall-rating .progress-bar-block .bar-row .label span .full-star[data-v-ba9ee58e]:after{content:\" \\2605\";position:absolute;top:50%;left:50%;color:#fff;font-size:10px;transform:translate(-50%,-50%)}.overall-rating .progress-bar-block .bar-row .bar-rail[data-v-ba9ee58e]{width:100%;height:6px;background:hsla(0,1%,81%,.6);-webkit-border-radius:52.8455px;-moz-border-radius:52.8455px;border-radius:52.8455px;overflow:hidden}.overall-rating .progress-bar-block .bar-row .bar-rail .progress-indicator[data-v-ba9ee58e]{-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;height:6px}.wd-mar[data-v-ba9ee58e]{width:100%!important}@media (max-width:1024px){.wd-mar[data-v-ba9ee58e]{margin-left:0}}.cust-span[data-v-ba9ee58e]{font-size:24px!important;line-height:27px!important}@media (min-width:576px){.cust-span[data-v-ba9ee58e]{font-size:32px!important;line-height:40px!important}}@media (min-width:576px){.ct-btn[data-v-ba9ee58e]{margin-top:0!important}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust i img[data-v-ba9ee58e]{width:8.35px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content[data-v-ba9ee58e]{width:calc(100% - 250px)}}.rev-terms-condition[data-v-ba9ee58e]{background:#dfe1e3;border-bottom-left-radius:12px;border-bottom-right-radius:12px;padding:5px 12px;line-height:20px;width:100%;text-align:center}@media (min-width:768px){.rev-terms-condition[data-v-ba9ee58e]{text-align:left}}.rev-terms-condition a[data-v-ba9ee58e]{cursor:pointer}.rev-terms-condition a[data-v-ba9ee58e]:hover{color:var(--primary-btn)}.rm-border[data-v-ba9ee58e]{border-bottom-right-radius:0!important}.exclu-rev[data-v-ba9ee58e],.exclu-rev img[data-v-ba9ee58e],.rm-border[data-v-ba9ee58e]{border-bottom-left-radius:0!important}.pay-i[data-v-ba9ee58e],.prod-i[data-v-ba9ee58e],.soft-i[data-v-ba9ee58e]{margin-right:0!important}.stripe-sticky[data-v-ba9ee58e]{display:block!important;text-align:center}.stripe-sticky p[data-v-ba9ee58e]{font-weight:700}.stripe-sticky[data-v-ba9ee58e]{position:absolute;width:50px;top:50%;transform:translateY(6px);overflow:hidden;border-bottom-left-radius:10px;border-bottom-right-radius:10px;background-color:#ffd039;display:none;height:20px;line-height:20px}@media (min-width:768px){.stripe-sticky[data-v-ba9ee58e]{display:block;bottom:0;left:0;width:100%}}@media (min-width:992px){.stripe-sticky[data-v-ba9ee58e]{transform:translateY(25px)}}.stripe-sticky img[data-v-ba9ee58e]{width:14px!important;height:14px!important;margin:3px auto;border-radius:0!important}@media (max-width:768px){.stripe-sticky svg[data-v-ba9ee58e]{width:12px}}.desk-excl[data-v-ba9ee58e]{display:none}@media (min-width:768px){.desk-excl[data-v-ba9ee58e]{display:flex}}.desk-excl img[data-v-ba9ee58e]{margin-right:5px}.mob-excl[data-v-ba9ee58e]{display:block}@media (min-width:768px){.mob-excl[data-v-ba9ee58e]{display:none}}@media (max-width:767px){.mob-excl[data-v-ba9ee58e]{display:block;margin:0 auto}}.desk-ra-excl[data-v-ba9ee58e]{display:none}@media (min-width:768px){.desk-ra-excl[data-v-ba9ee58e]{display:flex}}.mob-ra-excl[data-v-ba9ee58e]{display:block}@media (min-width:768px){.mob-ra-excl[data-v-ba9ee58e]{display:none}}.exclusive-tag-rev[data-v-ba9ee58e]{position:absolute;left:0;right:0;margin:0 16px;font-size:12px;line-height:15px;border-radius:0 0 5px 5px;width:calc(100% - 32px);bottom:10px;height:28px;display:flex;justify-content:center}@media (min-width:768px){.exclusive-tag-rev[data-v-ba9ee58e]{border-radius:8px;margin:auto;bottom:14px;width:90%;font-size:17px;line-height:28px;z-index:10}}@media (min-width:992px){.exclusive-tag-rev[data-v-ba9ee58e]{width:210px;bottom:10px}}.exclusive-tag-rev img[data-v-ba9ee58e]{width:18px!important;height:18px!important;border-radius:0!important;object-fit:contain!important;margin-right:5px}.exclusive-tag-rev p[data-v-ba9ee58e]{font-weight:700;font-size:12px;margin:0;display:flex;align-items:center}.exclu-rev[data-v-ba9ee58e]{position:relative}.casino-card ul.proslist-rev[data-v-ba9ee58e]{margin:0;padding:0;list-style:none;column-count:0;display:block}@media (min-width:576px){.casino-card ul.proslist-rev[data-v-ba9ee58e]{column-count:2;-ms-flex-wrap:wrap;flex-wrap:wrap;display:-webkit-box;display:-ms-flexbox;display:flex}}.casino-card ul.proslist-rev li[data-v-ba9ee58e]{width:100%;text-align:left;padding-left:32px;line-height:25px;color:#222;margin-bottom:14px;background-size:15px 15px}.casino-card ul.proslist-rev li[data-v-ba9ee58e]:last-child{margin-bottom:0}@media (min-width:576px){.casino-card ul.proslist-rev li[data-v-ba9ee58e]{width:50%}}.casino-card ul.proslist-rev li.pros[data-v-ba9ee58e]{column-count:unset;display:block;position:relative}.casino-card ul.proslist-rev li.pros[data-v-ba9ee58e]:before{position:absolute;content:\"\";left:0;top:4px;display:inline-block;transform:translateY(0);height:18px;width:18px;background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:10px}.casino-card ul.proslist-rev li.pros li[data-v-ba9ee58e]{width:100%;font-size:16px;line-height:25px;margin-bottom:25px;background-position:0 5px}.casino-card ul.proslist-rev li.pros li[data-v-ba9ee58e]:last-child{margin-bottom:0}.casino-card ul.proslist-rev li.cons[data-v-ba9ee58e]{column-count:unset;display:block;position:relative}.casino-card ul.proslist-rev li.cons[data-v-ba9ee58e]:before{position:absolute;content:\"\";left:0;top:4px;display:inline-block;transform:translateY(0);height:18px;width:18px;background:#fe4646 url(" + escape(__webpack_require__(73)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:10px}.casino-card ul.proslist-rev li.cons li[data-v-ba9ee58e]{width:100%;font-size:16px;line-height:25px;margin-bottom:25px;background-size:15px 15px}.casino-card ul.proslist-rev li.cons li[data-v-ba9ee58e]:last-child{margin-bottom:0}.p-caption[data-v-ba9ee58e]{font-weight:700;margin-bottom:0}.casino-card-lists ul li figure img[data-v-ba9ee58e]{margin:0}.developer-card[data-v-ba9ee58e]{background:#fff;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;padding:16px;width:100%;max-width:600px}.developer-card .card-header[data-v-ba9ee58e]{background:#f1f2f3;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;padding:19px 16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:16px;flex-wrap:wrap}@media (min-width:576px){.developer-card .card-header[data-v-ba9ee58e]{padding:20px 16px}}@media (min-width:992px){.developer-card .card-header[data-v-ba9ee58e]{flex-wrap:nowrap}}.developer-card .card-header .first-head[data-v-ba9ee58e]{margin-right:0}@media (min-width:992px){.developer-card .card-header .first-head[data-v-ba9ee58e]{margin-right:8px}}.developer-card .card-header .second-head[data-v-ba9ee58e]{margin-top:8px}@media (min-width:992px){.developer-card .card-header .second-head[data-v-ba9ee58e]{margin-top:0}}.developer-card .card-header p[data-v-ba9ee58e]{margin-bottom:0;font-family:Helvetica;font-weight:400;font-size:16px;line-height:1;color:#222}.developer-card .card-header p strong[data-v-ba9ee58e]{font-weight:700}.developer-card .card-header p i[data-v-ba9ee58e]{margin-right:8px}.developer-card .card-header p i img[data-v-ba9ee58e]{width:19px;margin-bottom:0}.developer-card .card-body .withdrl[data-v-ba9ee58e]{margin-top:16px}.developer-card .card-body .span-h6[data-v-ba9ee58e]{font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;margin-bottom:8px}.developer-card .card-body ul[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin:0 -6px}.developer-card .card-body ul li[data-v-ba9ee58e]{font-style:normal;font-weight:400;font-size:16px;line-height:25px;position:relative;margin:0 8px 12px}@media (min-width:375px){.developer-card .card-body ul li[data-v-ba9ee58e]{margin:0 9px 12px}}@media (min-width:425px){.developer-card .card-body ul li[data-v-ba9ee58e]{margin:0 14px 12px}}@media (min-width:576px){.developer-card .card-body ul li[data-v-ba9ee58e]{margin:0 6px 8px}}.developer-card .card-body ul li figure[data-v-ba9ee58e]{overflow:hidden;width:44px;height:44px;background:#f1f2f3;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;padding:0;font-weight:700;font-size:16px;line-height:25px;color:#aeaeae;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.developer-card .card-body ul li figure img[data-v-ba9ee58e]{margin:0}@media (min-width:576px){.developer-card .card-body ul li figure[data-v-ba9ee58e]{width:60px;height:60px}}.developer-card .card-body .support-links[data-v-ba9ee58e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 0 0;flex-direction:column}@media (min-width:992px){.developer-card .card-body .support-links[data-v-ba9ee58e]{-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;flex-direction:column}}.developer-card .card-body .support-links p[data-v-ba9ee58e]{margin-bottom:14px;font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;margin-right:0}@media (min-width:576px){.developer-card .card-body .support-links p[data-v-ba9ee58e]{margin-right:0;margin-bottom:18px}}.developer-card .card-body .support-links p[data-v-ba9ee58e]:last-child{margin-bottom:0}.developer-card .card-body .support-links p i[data-v-ba9ee58e]{top:2px;position:relative;margin-right:8px}@media (min-width:576px){.developer-card .card-body .support-links p i[data-v-ba9ee58e]{margin-right:4px}}.developer-card .card-footer[data-v-ba9ee58e]{border-top:1px solid #bdbdbe;padding:16px 0 0;margin-top:8px}.developer-card .card-footer span[data-v-ba9ee58e]{font-family:Helvetica;font-weight:700;font-size:12px;line-height:14px;text-transform:uppercase;color:#222}.developer-card .card-footer span i[data-v-ba9ee58e]{margin-left:8px}.developer-card .card-footer span i img[data-v-ba9ee58e]{width:50px;margin-bottom:0}.casino-card-software-recomend[data-v-ba9ee58e]{width:100%}.review-banner-support li[data-v-ba9ee58e]{margin:0 auto 0 0!important}@media (min-width:576px){.review-banner-support li[data-v-ba9ee58e]{margin:0 16px 0 0!important}}.review-banner-support li[data-v-ba9ee58e]:last-child{margin:0!important}.review-banner-support li figure[data-v-ba9ee58e]{width:44px;height:44px;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}@media (min-width:576px){.review-banner-support li figure[data-v-ba9ee58e]{width:60px;height:60px}}.span-caption-override[data-v-ba9ee58e]{font-size:16px!important;font-weight:700!important}", ""]);

// exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(609);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5c66e91c", content, true, {});

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-1a82993f]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-1a82993f]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-1a82993f]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-1a82993f]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-1a82993f]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-1a82993f]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-1a82993f]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-1a82993f]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-1a82993f]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-1a82993f]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-1a82993f]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-1a82993f]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.modal-wrapper[data-v-1a82993f]{display:none;max-width:280px;background:#fff;position:absolute;top:43px;right:0;box-shadow:0 5px 15px rgba(0,0,0,.05);border-radius:12px;max-width:220px;max-height:max-content;z-index:100}@media (min-width:768px){.modal-wrapper[data-v-1a82993f]{display:block}}.pos-relative[data-v-1a82993f]{position:relative}.mr-0[data-v-1a82993f]{margin-right:0!important}.terms_tc[data-v-1a82993f]{color:#222}.ct-similar-casino-cards[data-v-1a82993f]{padding-bottom:30px}.ct-similar-casino-cards .container[data-v-1a82993f]{padding-right:20px;z-index:8}@media (min-width:1024px){.ct-similar-casino-cards .container[data-v-1a82993f]{padding:0 15px}}.ct-similar-casino-cards .mobile-scroller[data-v-1a82993f]::-webkit-scrollbar-track{background-color:#fff}.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-1a82993f]{padding:0 8px}@media (min-width:992px){.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-1a82993f]{padding:0 4px}}@media (min-width:1200px){.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-1a82993f]{padding:0 8px}}.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-1a82993f]:last-child{padding-right:22px}@media (min-width:576px){.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-1a82993f]:last-child{padding-right:8px}}.ct-similar-casino-cards .mobile-scroller .casino-card-similar[data-v-1a82993f]{padding:15px;white-space:normal;min-width:254px;max-width:300px}@media (min-width:992px){.ct-similar-casino-cards .mobile-scroller .casino-card-similar[data-v-1a82993f]{padding:10px;min-width:auto}}@media (min-width:1200px){.ct-similar-casino-cards .mobile-scroller .casino-card-similar[data-v-1a82993f]{padding:15px}}.ct-review-toplist-page[data-v-1a82993f]{padding-top:30px}.preview[data-v-1a82993f]{margin:0}.casino-card-similar h2[data-v-1a82993f]{height:48px}@media (min-width:992px){.casino-card-similar h2[data-v-1a82993f]{height:56px}}.text-center[data-v-1a82993f]{text-align:center!important}.cursor-default[data-v-1a82993f]{cursor:default!important}.minus[data-v-1a82993f]:before{content:\"-\";font-size:1.9rem}.payment-list[data-v-1a82993f]{justify-content:space-between!important;flex-wrap:wrap!important}.payment-list li[data-v-1a82993f]{margin-right:0!important}.modal-list[data-v-1a82993f]{display:flex;justify-content:flex-start!important;flex-wrap:wrap!important;padding:10px!important}.modal-list li[data-v-1a82993f]{margin:8px!important}.show-btn-sm[data-v-1a82993f]{display:block}@media (min-width:768px){.show-btn-sm[data-v-1a82993f]{display:none}}.show-btn-md[data-v-1a82993f]{cursor:pointer;display:none}@media (min-width:768px){.show-btn-md[data-v-1a82993f]{display:block}}.hide-btn[data-v-1a82993f]{cursor:pointer}@media (max-width:768px){.hide-btn[data-v-1a82993f]{display:none}}.d-none[data-v-1a82993f]{display:none}.similar-card-bonus[data-v-1a82993f]{display:flex;justify-content:center;flex-direction:column}figure>img[data-v-1a82993f]{height:100%;width:100%}.mw-260[data-v-1a82993f]{min-width:260px}@media (min-width:992px){.mw-260[data-v-1a82993f]{min-width:auto}}.term-re[data-v-1a82993f]{border-bottom-left-radius:0;border-bottom-right-radius:0}.terms-condition-similar[data-v-1a82993f]{background:#dfe1e3;display:block;padding:7px 8px;margin:0;width:100%;font-weight:400;color:#222;border-bottom-left-radius:12px;border-bottom-right-radius:12px;line-height:15px;font-size:.75rem;white-space:pre-wrap;min-width:254px;text-align:left}.terms-condition-similar span[data-v-1a82993f]{margin:auto 0}@media (min-width:768px){.terms-condition-similar[data-v-1a82993f]{line-height:18px;font-size:.75rem;text-align:left}}.terms-condition-similar a[data-v-1a82993f]{cursor:pointer;font-size:12px;text-decoration:underline!important}.terms-condition-similar a[data-v-1a82993f]:hover{color:var(--primary-btn)}.casino-card-lists[data-v-1a82993f]{margin-top:10px!important}.casino-card-lists h6[data-v-1a82993f]{margin:0!important}.ltc-row[data-v-1a82993f]{width:fit-content!important}@media (min-width:768px){.ltc-row[data-v-1a82993f]{width:auto!important}}@media (max-width:576px){.ltc-row[data-v-1a82993f]:before{padding-left:22px}}@media (max-width:576px){.pd-rt h2[data-v-1a82993f],.pd-rt p[data-v-1a82993f]{padding-left:22px;padding-right:22px}}.emt-sp[data-v-1a82993f]{display:none}@media (min-width:992px){.emt-sp[data-v-1a82993f]{display:block;margin-bottom:34px}}.sim-logo img[data-v-1a82993f]{min-width:50px}@media (max-width:768px){.sim-logo[data-v-1a82993f]{display:contents}}.sm-img[data-v-1a82993f]{margin:0!important}.pay-space[data-v-1a82993f]{display:block;margin-top:10px!important;min-height:69px}@media (min-width:992px){.cas-nam[data-v-1a82993f]{display:flex!important;justify-content:center;align-items:center}}.stripe-sim[data-v-1a82993f]{display:block;text-align:center}.stripe-sim span[data-v-1a82993f]{font-size:12px;font-weight:700;line-height:160%;color:#fff;display:flex!important;justify-content:center;align-items:center;top:0;position:relative;height:28px}.stripe-sim span img[data-v-1a82993f],.stripe-sim span svg[data-v-1a82993f]{position:relative;width:18px!important;min-width:18px!important;top:0;height:18px!important;border-radius:0!important;object-fit:contain!important;margin:0;margin-right:5px}.stripe-sim[data-v-1a82993f]{position:absolute;width:100%;height:28px;overflow:hidden;top:50%;border-bottom-left-radius:10px;border-bottom-right-radius:10px;background-color:#ffd039;display:none}@media (min-width:576px){.stripe-sim[data-v-1a82993f]{display:block}}@media (min-width:992px){.stripe-sim[data-v-1a82993f]{display:block;top:0;left:0;border-radius:0;border-top-left-radius:10px;border-top-right-radius:10px}}@media (max-width:992px){.stripe-sim[data-v-1a82993f]{width:90px;height:20px;margin:0 auto}}@media (max-width:576px){.stripe-sim[data-v-1a82993f]{transform:translateY(26px)}}.sim-best-ch p[data-v-1a82993f]{color:#222}.desk-sim[data-v-1a82993f]{display:none!important}@media (min-width:992px){.desk-sim[data-v-1a82993f]{display:flex!important}}.mob-sim[data-v-1a82993f]{display:block;margin:4px auto!important;width:14px!important;min-width:14px!important;height:14px!important;object-fit:contain!important}@media (min-width:992px){.mob-sim[data-v-1a82993f]{display:none}}.new-casino-card-section[data-v-1a82993f]{padding-bottom:25px}.new-casino-card-row[data-v-1a82993f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0 -6px}.mobile-scroller .row.row-stretch[data-v-1a82993f],.new-casino-card-row[data-v-1a82993f]{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.new-casino-card[data-v-1a82993f]{-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;overflow:hidden;position:relative;max-width:100%;min-width:280px;margin:0 auto 16px}@media (min-width:576px){.new-casino-card[data-v-1a82993f]{margin:0}}@media (min-width:1024px){.new-casino-card[data-v-1a82993f]{min-width:auto}}.new-casino-card .bg-holder[data-v-1a82993f]{overflow:hidden;z-index:-1}.new-casino-card .bg-holder[data-v-1a82993f],.new-casino-card .bg-holder[data-v-1a82993f]:after{position:absolute;width:100%;height:100%;top:0;left:0;-webkit-border-radius:10px 10px 0 0;-moz-border-radius:10px 10px 0 0;border-radius:10px 10px 0 0}.new-casino-card .bg-holder[data-v-1a82993f]:after{content:\"\";right:0;bottom:0;background:rgba(0,0,0,.6)}.new-casino-card .bg-holder img[data-v-1a82993f]{width:100%;height:100%;object-fit:cover}.new-casino-card-content[data-v-1a82993f]{position:relative;z-index:1;padding:32px 16px 16px;text-align:center}.new-casino-card-content .cas-panel[data-v-1a82993f]{margin-bottom:35px}.new-casino-card-content .cas-panel .cas-logo[data-v-1a82993f]{width:50px;height:50px;margin-bottom:8px;display:inline-block}.new-casino-card-content .cas-panel .cas-logo img[data-v-1a82993f]{width:100%;height:100%;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.new-casino-card-content .cas-panel .cas-title[data-v-1a82993f]{font-family:Helvetica;font-weight:700;font-size:18px;line-height:21px;color:#fff;margin-bottom:10px;display:block}.new-casino-card-content .cas-panel .rating-wrapper[data-v-1a82993f]{line-height:1}.new-casino-card-content .cas-panel .rating-wrapper .rating-star-total[data-v-1a82993f]{font-family:Helvetica;font-weight:400;font-size:16px;color:#fff}.new-casino-card-content .cas-panel .rating-wrapper .rating-star-total span[data-v-1a82993f]{font-weight:700;font-size:16px}.new-casino-card-content .bonus-text[data-v-1a82993f]{font-family:Helvetica;font-weight:700;color:#fff;font-size:22px;line-height:25px;margin-bottom:34px;white-space:normal}.new-casino-card-content .bonus-text a[data-v-1a82993f]{color:#fff}.new-casino-card-content .bonus-text a[data-v-1a82993f]:hover{color:var(--primary-btn)!important}.new-casino-card-content .review-link[data-v-1a82993f]{display:inline-block;font-family:Helvetica;font-weight:400;font-size:16px;line-height:18px;color:#fff;text-align:center;text-decoration:underline;margin-bottom:32px}.new-casino-card-content .review-link[data-v-1a82993f]:hover{text-decoration:underline}.new-casino-card-content .cta-primary[data-v-1a82993f]{display:block;background:#fe4646;box-shadow:0 2px 4px rgba(0,0,0,.2);-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;font-family:Helvetica;font-weight:700;font-size:18px;line-height:21px;max-width:100%;border:0;padding:17px 20px;margin:0}.new-casino-card-content .payment-options[data-v-1a82993f]{margin-top:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.new-casino-card-content .payment-options li[data-v-1a82993f]{margin:0 4px}.new-casino-card-content .payment-options li figure[data-v-1a82993f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#fff;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;width:30px;height:30px;font-family:Helvetica;font-weight:700;font-size:12px;line-height:14px;color:#bdbdbe}.new-casino-card-content .payment-options li figure img[data-v-1a82993f]{height:100%;width:100%;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;object-fit:contain}.new-casino-card-content .payment-options li figure .more-pay[data-v-1a82993f]{display:flex;justify-content:center;align-items:center;color:inherit}.new-casino-card-content .payment-options li figure .more-pay[data-v-1a82993f]:hover{color:#222}.new-casino-card-content .payment-options li figure .more-pay:hover i[data-v-1a82993f]{filter:brightness(2) invert(1) sepia(.01)}.new-casino-card-content .payment-options li figure .more-pay i[data-v-1a82993f]{display:flex;justify-content:center;align-items:center}.new-casino-card-content .payment-options li figure .more-pay i img[data-v-1a82993f]{width:7px;height:7px}.new-casino-card .terms[data-v-1a82993f]{background:#dfe1e3;-webkit-border-radius:0 0 10px 10px;-moz-border-radius:0 0 10px 10px;border-radius:0 0 10px 10px;padding:7px 8px;text-align:center}.new-casino-card .terms p[data-v-1a82993f]{font-family:Helvetica;font-weight:400;font-size:12px;line-height:14px;color:#222;margin:0}.new-casino-card.no-bg[data-v-1a82993f]{filter:drop-shadow(0 5px 15px rgba(0,0,0,.05))}.new-casino-card.no-bg .new-casino-card-content[data-v-1a82993f]{background:#fff;padding:16px}.new-casino-card.no-bg .new-casino-card-content .cas-panel[data-v-1a82993f]{margin-bottom:22px}.new-casino-card.no-bg .new-casino-card-content .cas-panel .cas-logo[data-v-1a82993f]{width:90px;height:90px}.new-casino-card.no-bg .new-casino-card-content .cas-panel .cas-title[data-v-1a82993f]{color:#222;margin-bottom:8px}.new-casino-card.no-bg .new-casino-card-content .cas-panel .rating-wrapper .rating-star-total[data-v-1a82993f]{color:#222}.new-casino-card.no-bg .new-casino-card-content ul.feature-lists[data-v-1a82993f]{margin-bottom:22px;padding-left:21px}.new-casino-card.no-bg .new-casino-card-content ul.feature-lists li[data-v-1a82993f]{font-family:Helvetica;font-weight:400;font-size:12px;line-height:14px;color:#222;margin-bottom:12px;position:relative;padding-left:20px;text-align:left}.new-casino-card.no-bg .new-casino-card-content ul.feature-lists li[data-v-1a82993f]:last-child{margin-bottom:0}.new-casino-card.no-bg .new-casino-card-content ul.feature-lists li[data-v-1a82993f]:after{position:absolute;content:\"\";left:0;top:0;width:0;height:0;border-bottom:11px solid #5abc5e;border-left:6px solid transparent;border-right:6px solid transparent}.new-casino-card.no-bg .new-casino-card-content .review-link[data-v-1a82993f]{font-size:12px;line-height:14px;color:#9b9b9b;margin-bottom:16px}.triangle[data-v-1a82993f]{position:absolute;top:2px;left:2px;background-color:#0084ff;text-align:left}.triangle i[data-v-1a82993f]{position:absolute;z-index:1;transform:rotate(90deg);left:5px;top:5px}.triangle i img[data-v-1a82993f]{width:18px;height:18px}.triangle.blue[data-v-1a82993f]{background-color:#0084ff}.triangle.yellow[data-v-1a82993f]{background-color:#ffd03a}.triangle.yellow i[data-v-1a82993f]{left:2px}.triangle[data-v-1a82993f]:after,.triangle[data-v-1a82993f]:before{content:\"\";position:absolute;background-color:inherit}.triangle[data-v-1a82993f],.triangle[data-v-1a82993f]:after,.triangle[data-v-1a82993f]:before{width:32px;height:32px;border-top-right-radius:8px}.triangle[data-v-1a82993f]:after,.triangle[data-v-1a82993f]:before{border-top-right-radius:15px}.triangle[data-v-1a82993f]{transform:rotate(-90deg)}.triangle[data-v-1a82993f]:before{transform:rotate(-135deg) skewX(-45deg) scale(1.41,.707) translateY(-50%)}.triangle[data-v-1a82993f]:after{transform:rotate(135deg) skewY(-45deg) scale(.707,1.41) translate(50%)}.new-game-card-row[data-v-1a82993f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0 -6px}.mobile-scroller.disable[data-v-1a82993f]{overflow-x:hidden}@media (min-width:576px){.mobile-scroller.disable[data-v-1a82993f]{overflow-x:hidden}}.mobile-scroller.disable .row[data-v-1a82993f]{-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0 -8px}@media (min-width:420px){.mobile-scroller.disable .row[data-v-1a82993f]{margin:0}}@media (min-width:576px){.mobile-scroller.disable .row[data-v-1a82993f]{-ms-flex-wrap:nowrap;flex-wrap:nowrap;margin:0 -8px}}.mobile-scroller[data-v-1a82993f]::-webkit-scrollbar{height:0}.mobile-scroller[data-v-1a82993f]:hover{overflow-x:auto!important}@media (min-width:992px){.mobile-scroller[data-v-1a82993f]:hover{overflow-x:hidden!important}}", ""]);

// exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(611);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0553361d", content, true, {});

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-08056de9]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-08056de9]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-08056de9]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-08056de9]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-08056de9]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-08056de9]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-08056de9]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-08056de9]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-08056de9]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-08056de9]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-08056de9]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-08056de9]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.rating-wrapper[data-v-08056de9]{display:flex;align-items:center;justify-content:center;flex-wrap:wrap}.rating-stars[data-v-08056de9]{display:flex;position:relative;unicode-bidi:bidi-override;direction:ltr;counter-reset:star-rating;font-size:0;margin-left:0;margin-right:0;padding-right:7px}.rating-stars img[data-v-08056de9]{width:14px;height:auto;margin-right:4px;border-radius:2px;margin-bottom:0!important;cursor:default}.rating-star-total[data-v-08056de9]{pointer-events:none;direction:ltr;unicode-bidi:bidi-override;position:relative;right:-2px;top:1px;color:#222;font-size:16px}.rating-star-total span[data-v-08056de9]{font-size:16px;font-weight:700;font-family:var(--default-bold)}.casino-list-ratings[data-v-08056de9]{align-items:start;flex-direction:column;justify-content:flex-start}@media (min-width:420px){.casino-list-ratings[data-v-08056de9]{align-items:center;flex-direction:row}}.full-star[data-v-08056de9]{width:14px;height:14px;background:#fabf00;border-radius:2px;margin-right:3px;position:relative}.full-star span[data-v-08056de9]{position:absolute;height:100%;width:50%;top:0;left:50%;background:#e5e5e5}.full-star.clear[data-v-08056de9]{background:#e5e5e5}.full-star[data-v-08056de9]:after{content:\" \\2605\";position:absolute;top:50%;left:50%;color:#fff;font-size:10px;transform:translate(-50%,-50%)}.star-cls .rating-star-total[data-v-08056de9]{color:#fff!important}.usertest-star[data-v-08056de9]{justify-content:flex-start!important}.rev-star[data-v-08056de9]{margin-left:10px}", ""]);

// exports


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['rating-wrapper', _vm.classParam ? _vm.classParam : '']},[_c('div',{staticClass:"rating-stars"},[_vm._l((Math.floor(_vm.rating)),function(n){return _c('div',{key:n + '-f-star',staticClass:"full-star"})}),_vm._v(" "),(_vm.rating % 1 >= 0.5)?_c('div',{staticClass:"full-star"},[_c('span')]):_vm._e(),_vm._v(" "),_vm._l((5 - _vm.ratioMath),function(k){return _c('div',{key:k + '-no-star',staticClass:"full-star clear"})})],2),_vm._v(" "),(!_vm.noText)?_c('div',{staticClass:"rating-star-total"},[_c('span',[_vm._v(_vm._s(_vm.rating))]),_vm._v(" / 5\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideToplistLabel)?_c('div',{staticClass:"new-casino-card-section"},[_c('div',{staticClass:"container"},[(_vm.componentTitle && _vm.componentTitle != '')?_c('h2',[_vm._v("\n      "+_vm._s(_vm.componentTitle)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobile-scroller disable"},[_c('div',{staticClass:"row"},_vm._l((_vm.componentData),function(card,index){return _c('div',{key:index,staticClass:"col-lg-3"},[_c('div',{staticClass:"new-casino-card"},[_c('div',{staticClass:"new-casino-card-content"},[(Object.keys(_vm.hasTag(card.tags)).length > 0)?_c('div',{staticClass:"triangle",style:({
                  backgroundColor:
                    Object.keys(_vm.hasTag(card.tags)).length > 0
                      ? _vm.hasTag(card.tags).color
                      : null,
                })},[_c('i',[_c('img',{attrs:{"src":_vm.hasTag(card.tags).icon,"width":"14","height":"14","alt":"tag-icons"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bg-holder"},[_c('img',{attrs:{"src":card.product_assets.filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assetsSize.pro_asset_sizes.background; }
                    ).length > 0
                      ? card.product_assets
                          .filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assetsSize.pro_asset_sizes.background; }
                          )
                          .shift().url
                      : card.product_assets.filter(
                          function (ele) { return ele.asset_category_name ===
                            'product_logo_background'; }
                        ).length > 0
                      ? card.product_assets
                          .filter(
                            function (ele) { return ele.asset_category_name ===
                              'product_logo_background'; }
                          )
                          .shift().url
                      : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"alt":_vm.getAltText(
                      card.product_name,
                      card.product_assets.filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assetsSize.pro_asset_sizes.background; }
                      ).length > 0
                        ? card.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assetsSize.pro_asset_sizes.background; }
                            )
                            .shift().url
                        : card.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              'product_logo_background'; }
                          ).length > 0
                        ? card.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                'product_logo_background'; }
                            )
                            .shift().url
                        : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
                    )}})]),_vm._v(" "),_c('div',{staticClass:"cas-panel"},[(_vm.checkImageAsset(card.product_assets))?[_c('a',{staticClass:"partner-logo sim-logo cas-link cas-logo",attrs:{"title":card.product_name,"href":_vm.getGoLink(card.go_link, card.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[(
                        _vm.$root.enable_lazyload &&
                        _vm.assetsSize &&
                        _vm.assetsSize.pro_asset_sizes
                      )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                        card.product_assets.filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assetsSize.pro_asset_sizes.medium; }
                        ).length > 0
                          ? card.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assetsSize.pro_asset_sizes.medium; }
                              )
                              .shift().url
                          : ''
                      ),expression:"\n                        card.product_assets.filter(\n                          (ele) =>\n                            ele.asset_category_name ===\n                            assetsSize.pro_asset_sizes.medium\n                        ).length > 0\n                          ? card.product_assets\n                              .filter(\n                                (ele) =>\n                                  ele.asset_category_name ===\n                                  assetsSize.pro_asset_sizes.medium\n                              )\n                              .shift().url\n                          : ''\n                      "}],staticClass:"sm-img",attrs:{"height":"50","width":"50","alt":_vm.getAltText(
                          card.product_name,
                          card.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assetsSize.pro_asset_sizes.medium; }
                          ).length > 0
                            ? card.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assetsSize.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : ''
                        )}}):(_vm.assetsSize && _vm.assetsSize.pro_asset_sizes)?_c('img',{staticClass:"sm-img",attrs:{"src":card.product_assets.filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assetsSize.pro_asset_sizes.medium; }
                        ).length > 0
                          ? card.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assetsSize.pro_asset_sizes.medium; }
                              )
                              .shift().url
                          : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"height":"50","width":"50","alt":_vm.getAltText(
                          card.product_name,
                          card.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assetsSize.pro_asset_sizes.medium; }
                          ).length > 0
                            ? card.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assetsSize.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/failure.png'
                        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-sim"},[_c('div',{staticClass:"partner-hover-inner",style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])])]:_vm._e(),_vm._v(" "),_c('a',{staticClass:"cas-title cas-link text-hover",attrs:{"title":card.product_name,"href":_vm.getGoLink(card.go_link, card.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'}},[_vm._v(_vm._s(card.product_name)+"\n                ")]),_vm._v(" "),_c('StarRating',{attrs:{"rating":parseFloat((card.rating / 2).toFixed(1)),"classParam":'star-cls'}})],2),_vm._v(" "),_c('span',{staticClass:"bonus-text similar-card-bonus text-hover"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(
                      card.bonus_match &&
                      card.exclusive_bonus_amount &&
                      card.exclusive_bonus_match
                    )?_c('a',{staticClass:"cas-link",attrs:{"title":card.product_name,"href":_vm.getGoLink(card.go_link, card.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[_vm._v(_vm._s(card.exclusive_bonus_match)+"%\n                    "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                    "+_vm._s(_vm._f("currency")(card.exclusive_bonus_amount,card.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                      card.bonus_match &&
                      !card.exclusive_bonus_amount &&
                      card.bonus_amount
                    )?_c('a',{staticClass:"cas-link",attrs:{"title":card.product_name,"href":_vm.getGoLink(card.go_link, card.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[_vm._v(_vm._s(card.bonus_match)+"% "+_vm._s(_vm.$root.i18n.up_to)+"\n                    "+_vm._s(_vm._f("currency")(card.bonus_amount,card.bonus_currency)))]):_vm._e(),_vm._v(" "),(card.freespin || card.freebie_name)?_c('a',{staticClass:"cas-link",attrs:{"title":card.product_name,"href":_vm.getGoLink(card.go_link, card.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[(
                        (card.exclusive_bonus_amount || card.bonus_amount) &&
                        card.bonus_match
                      )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(card.freespin)?[(card.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(card.freespin,card.bonus_currency)))]:[_vm._v(_vm._s(card.freespin))],_vm._v("\n                      "+_vm._s(card.freebie_name)+"\n                    ")]:[_vm._v(_vm._s(card.freebie_name))]],2):_vm._e()]],2),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(card.review_link)?_c('a',{staticClass:"review-link rev-text",attrs:{"title":card.product_name,"href":_vm.getRouteLink(card.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                      _vm.$root.i18n.read_our_review,
                      card.product_name
                    )))]):_c('span',{staticClass:"emt-sp rev-text"},[_vm._v(" ")])]:[(card.review_link)?_c('router-link',{staticClass:"review-link rev-text",attrs:{"title":card.product_name,"to":_vm.getRouteLink(card.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                      _vm.$root.i18n.read_our_review,
                      card.product_name
                    )))]):_c('span',{staticClass:"emt-sp rev-text"},[_vm._v(" ")])],_vm._v(" "),_c('a',{class:{
                  'cta cta-primary cta-block cta-promotion btn-gray custom-btn cus-sim-btn hover-btn cas-link': true,
                  'text-white':
                    !_vm.$root.override_ctabtntxt_color &&
                    !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-gray':
                    !_vm.$root.override_ctabtntxt_color &&
                    _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-cta-override': _vm.$root.override_ctabtntxt_color,
                },style:({
                  '--primary-btn': _vm.$root.color_schema.primary_btn,
                  '--primary-btn-hover': _vm.pSBC(
                    -0.2,
                    _vm.$root.color_schema.primary_btn
                  ),
                }),attrs:{"title":card.product_name,"href":_vm.getGoLink(card.go_link, card.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(card.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "simpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2),_vm._v(" "),(
                  card.supported_payments.length > 0 &&
                  card.supported_payments_total > 0
                )?_c('ul',{staticClass:"payment-options pos-relative pay-img"},[_vm._l((card.supported_payments.slice(0, 3)),function(data,index){return _c('li',{key:index + 'k'},[_c('figure',{staticClass:"popup-btn-content"},[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url),"width":"50","height":"50"}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url),"width":"50","height":"50"}})])])}),_vm._v(" "),(card.supported_payments_total === 4)?_vm._l((card.supported_payments.slice(3)),function(data,index){return _c('li',{key:index},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url),"width":"50","height":"50"}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url),"width":"50","height":"50"}})])])}):_vm._e(),_vm._v(" "),(card.supported_payments_total > 4)?_c('li',{staticClass:"show-btn-sm"},[_c('figure',[(_vm.$root.enable_piwik_reload)?[_c('a',{staticClass:"more-pay",attrs:{"title":card.product_name,"href":_vm.getRouteLink(card.review_link, 'review')}},[_c('i',[_c('img',{attrs:{"width":"13","height":"13","src":_vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                        "+_vm._s(card.supported_payments_total -
                          (card.supported_payments.length > 3
                            ? 3
                            : card.supported_payments.length))+"\n                      ")])]:[_c('router-link',{staticClass:"more-pay",attrs:{"title":card.product_name,"to":_vm.getRouteLink(card.review_link, 'review')}},[_c('i',[_c('img',{attrs:{"width":"13","height":"13","src":_vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                        "+_vm._s(card.supported_payments_total -
                          (card.supported_payments.length > 3
                            ? 3
                            : card.supported_payments.length))+"\n                      ")])]],2)]):_vm._e(),_vm._v(" "),(_vm.componentAttrs && _vm.componentAttrs.enable_payment_popup)?[(card.supported_payments_total > 4)?_c('li',{class:{
                      'show-btn-md': true,
                      'd-none': _vm.modalOnDisplay == _vm.modalIdArr[index],
                    },attrs:{"id":("show-btn-" + (_vm.modalIdArr[index]))},on:{"click":function($event){return _vm.showHideModal(_vm.modalIdArr[index])}}},[_c('figure',{staticClass:"popup-btn-content"},[_c('span',{staticClass:"plus"},[_c('i',[_c('img',{staticClass:"plus",attrs:{"width":"13","height":"13","src":_vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                        "+_vm._s(card.supported_payments_total -
                          (card.supported_payments.length > 3
                            ? 3
                            : card.supported_payments.length))+"\n                      ")])])]):_vm._e(),_vm._v(" "),(_vm.modalOnDisplay == _vm.modalIdArr[index])?_c('li',{staticClass:"hide-btn",on:{"click":function($event){return _vm.showHideModal(null)}}},[_vm._m(0,true)]):_vm._e(),_vm._v(" "),(card.supported_payments_total > 4)?[(_vm.modalOnDisplay == _vm.modalIdArr[index])?_c('div',{staticClass:"modal-wrapper",attrs:{"id":("modal-content-" + (_vm.modalIdArr[index]))}},[_c('ul',{staticClass:"modal-list"},_vm._l((card.supported_payments.slice(3)),function(data,index){return _c('li',{key:index},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],staticClass:"modal-img",attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{staticClass:"modal-img",attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}),0)]):_vm._e()]:_vm._e()]:[(card.supported_payments_total > 4)?_c('li',{staticClass:"show-btn-md"},[_c('figure',[(_vm.$root.enable_piwik_reload)?[_c('a',{staticClass:"more-pay",attrs:{"title":card.product_name,"href":_vm.getRouteLink(card.review_link, 'review')}},[_c('i',[_c('img',{attrs:{"width":"13","height":"13","src":_vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                          "+_vm._s(card.supported_payments_total -
                            (card.supported_payments.length > 3
                              ? 3
                              : card.supported_payments.length))+"\n                        ")])]:[_c('router-link',{staticClass:"more-pay",attrs:{"title":card.product_name,"to":_vm.getRouteLink(card.review_link, 'review')}},[_c('i',[_c('img',{attrs:{"width":"13","height":"13","src":_vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                          "+_vm._s(card.supported_payments_total -
                            (card.supported_payments.length > 3
                              ? 3
                              : card.supported_payments.length))+"\n                        ")])]],2)]):_vm._e()]],2):_c('div',{staticClass:"payment-options pos-relative pay-img"},[_vm._v("\n                 \n              ")])],2),_vm._v(" "),(
                (card.bonus_tc && card.bonus_tc != '') ||
                (card.terms && card.terms != '')
              )?_c('div',{staticClass:"terms-condition-similar terms-sim"},[(card.bonus_tc && card.bonus_tc != '')?_c('span',{staticClass:"cas-term",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(card.bonus_tc.trim())}}):_vm._e(),_vm._v(" "),(
                  card.bonus_tc &&
                  card.terms &&
                  card.bonus_tc != '' &&
                  card.terms != ''
                )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(card.terms && card.terms != '')?_c('a',{staticClass:"cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"href":_vm.getGoLink(card.term_link, card.slug),"target":"_blank"}},[_vm._v(_vm._s(card.terms))]):_vm._e()]):_c('div',{staticClass:"terms-condition-similar terms-sim"},[_vm._v(" ")])])])}),0)])])]):_c('div',{staticClass:"container text-center pt-10"},[_vm._v("\n  "+_vm._s(_vm.$root.i18n.no_toplist_available_intime)+"\n")])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"popup-btn-content"},[_c('span',{staticClass:"minus"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentIcon_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4984b84c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentIcon_vue__ = __webpack_require__(617);
function injectStyle (ssrContext) {
  __webpack_require__(615)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4984b84c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4984b84c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(616);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("de4bb6f2", content, true, {});

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-4984b84c]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-4984b84c]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-4984b84c]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-4984b84c]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-4984b84c]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-4984b84c]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-4984b84c]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-4984b84c]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-4984b84c]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-4984b84c]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-4984b84c]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-4984b84c]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.content-icon[data-v-4984b84c]{margin:0 0 20px -2px}.content-icon img[data-v-4984b84c]{margin:0;opacity:1;width:48px;height:48px}.content-icon-block[data-v-4984b84c]{display:block;box-sizing:border-box;padding:20px 20px 1px;margin:0 0 20px;box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;background:#fff}@media (min-width:576px){.content-icon-block[data-v-4984b84c]{display:inline-block;padding:20px 20px 0}}.btn-cls[data-v-4984b84c]{text-align:center;margin-bottom:20px}.custom-btn[data-v-4984b84c]{min-width:230px;width:100%;margin:0!important}@media (min-width:576px){.custom-btn[data-v-4984b84c]{min-width:335px}}.wdm-100[data-v-4984b84c]{min-width:100%}", ""]);

// exports


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.contentIconData)?_c('section',{class:{ 'content-icon-block': true, 'wdm-100': !_vm.templateCheck }},[_c('div',{staticClass:"content-icon"},[(_vm.contentIconData.icon)?_c('img',{attrs:{"src":_vm.contentIconData.icon,"height":"48","width":"48","alt":"Content Icon"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"editor-content wd-100 d-flex"},[_c('div',{staticClass:"custom-font tick-div-blue custm-text cont-title",style:({
          '--heading-font': _vm.$root.font_family.heading,
          '--primary-btn': _vm.$root.color_schema.primary_btn,
          '--paragraph-font': _vm.$root.font_family.paragraph,
        }),domProps:{"innerHTML":_vm._s(_vm.contentIconData.content)}})]),_vm._v(" "),(_vm.buttonCheck)?_c('div',{staticClass:"btn-cls"},[(_vm.partnerInfo && _vm.partnerInfo != '')?_c('a',{class:{'cta cta-primary cta-promotion custom-btn cas-link hover-btn':true,
        'text-white':
          !_vm.$root.override_ctabtntxt_color,
        'text-cta-override': _vm.$root.override_ctabtntxt_color,
        },style:({
          '--primary-btn': _vm.$root.color_schema.primary_btn,
          '--primary-btn-hover': _vm.pSBC(-0.2, _vm.$root.color_schema.primary_btn),
        }),attrs:{"title":_vm.partnerInfo.product_name,"href":_vm.getGoLink(_vm.partnerInfo.go_link, _vm.partnerInfo.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.partnerInfo.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "conipp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BonusInformation_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67bb017c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BonusInformation_vue__ = __webpack_require__(621);
function injectStyle (ssrContext) {
  __webpack_require__(619)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67bb017c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BonusInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67bb017c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BonusInformation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(620);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("a27fd082", content, true, {});

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-67bb017c]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-67bb017c]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-67bb017c]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-67bb017c]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-67bb017c]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-67bb017c]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-67bb017c]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-67bb017c]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-67bb017c]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-67bb017c]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-67bb017c]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-67bb017c]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.bonus-info .bonus-information[data-v-67bb017c]{background:#fff;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;padding:7px 12px 20px;max-width:1014px;margin-bottom:28px}@media (min-width:576px){.bonus-info .bonus-information[data-v-67bb017c]{padding:29px 24px 32px;margin-bottom:40px}}.bonus-info .bonus-information h1[data-v-67bb017c]{font-weight:700;color:#373a3c;margin-bottom:14px}@media (min-width:992px){.bonus-info .bonus-information h1[data-v-67bb017c]{margin-bottom:26px}}.bonus-info .bonus-information .cas-logo[data-v-67bb017c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;margin-bottom:12px}@media (min-width:576px){.bonus-info .bonus-information .cas-logo[data-v-67bb017c]{margin-bottom:24px}}.bonus-info .bonus-information .cas-logo a[data-v-67bb017c]{width:100%}.bonus-info .bonus-information .cas-logo img[data-v-67bb017c]{width:100%;height:155px;border-radius:5px;margin:0;object-fit:contain}.bonus-info .bonus-information .bonus-text[data-v-67bb017c]{font-weight:700;font-size:18px;line-height:27px;color:#373a3c;margin-bottom:9px;display:block}@media (min-width:576px){.bonus-info .bonus-information .bonus-text[data-v-67bb017c]{font-size:28px;line-height:34px;margin-bottom:12px}}@media (min-width:992px){.bonus-info .bonus-information .bonus-text[data-v-67bb017c]{font-size:32px;line-height:39px;margin-bottom:5px}}.bonus-info .bonus-information .deposit-heading[data-v-67bb017c]{font-weight:400;font-size:16px;line-height:24px;color:#4d4d4d;margin-bottom:12px}@media (min-width:992px){.bonus-info .bonus-information .deposit-heading[data-v-67bb017c]{font-size:20px;line-height:30px}}.bonus-info .bonus-information h3[data-v-67bb017c]{font-weight:700;color:#373a3c;margin-bottom:12px}@media (min-width:992px){.bonus-info .bonus-information h3[data-v-67bb017c]{margin-bottom:6px}}.bonus-info .bonus-information p[data-v-67bb017c]{font-weight:400;color:#4d4d4d;margin-bottom:15px}.bonus-info .bonus-information .cta-primary[data-v-67bb017c]{font-weight:700;font-size:14px;line-height:14px;letter-spacing:.02em;padding:14px 20px;display:flex;justify-content:center;align-items:center}@media (min-width:992px){.bonus-info .bonus-information .cta-primary[data-v-67bb017c]{font-size:18px;line-height:18px;padding:16px 20px}}.bonus-info .bonus-information .terms[data-v-67bb017c]{margin-top:11px;display:block}@media (min-width:576px){.bonus-info .bonus-information .terms[data-v-67bb017c]{display:block}}@media (min-width:992px){.bonus-info .bonus-information .terms[data-v-67bb017c]{margin-top:14px}}.bonus-info .bonus-information .terms a[data-v-67bb017c],.bonus-info .bonus-information .terms h6[data-v-67bb017c]{font-weight:400;font-size:16px;line-height:160%;text-decoration-line:underline;text-transform:uppercase;color:#9a9a9a;display:inline-block;margin-bottom:7}.bonus-info .bonus-information .terms p[data-v-67bb017c]{font-weight:400;text-align:justify;color:#9a9a9a;margin-bottom:0}.bonus-info .bonus-info-box[data-v-67bb017c]{background:#f7f7f7;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;padding:24px 24px 28px;margin-bottom:17px}.bonus-info .bonus-info-box ul[data-v-67bb017c]{list-style:none;margin:0;padding:0;-webkit-column-count:unset;-moz-column-count:unset;column-count:unset}@media (min-width:576px){.bonus-info .bonus-info-box ul[data-v-67bb017c]{-webkit-column-count:2;-moz-column-count:2;column-count:2;margin:0 -25px}}.bonus-info .bonus-info-box ul li[data-v-67bb017c]{position:static;border-bottom:1px solid #d7d9da;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-size:13px;line-height:32px}@media (min-width:576px){.bonus-info .bonus-info-box ul li[data-v-67bb017c]{margin:0 25px;font-size:16px;line-height:34px;min-height:46px}}@media (min-width:992px){.bonus-info .bonus-info-box ul li[data-v-67bb017c]{font-size:18px;line-height:44px}}@media (max-width:576px){.bonus-info .bonus-info-box ul li[data-v-67bb017c]{line-height:13px!important;padding:9px 0!important}}.bonus-info .bonus-info-box ul li span[data-v-67bb017c]{font-weight:400;color:#4d4d4d}@media (max-width:576px){.bonus-info .bonus-info-box ul li span[data-v-67bb017c]{flex:0 0 auto}}.bonus-info .bonus-info-box ul li strong[data-v-67bb017c]{font-weight:700;text-align:right;letter-spacing:.02em;color:#4d4d4d}@media (max-width:576px){.bonus-info .bonus-info-box ul li strong[data-v-67bb017c]{line-height:16px;flex:1 1 auto}}.bonus-info .bonus-info-box ul li[data-v-67bb017c]:before{background:none!important}@media (min-width:992px){.bonus-info .bonus-information .cas-logo img[data-v-67bb017c]{width:auto}}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.bonus-info .bonus-info-box ul li[data-v-67bb017c]{display:block}.bonus-info .bonus-info-box ul li strong[data-v-67bb017c]{float:right;text-align:right}}", ""]);

// exports


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideBonusLabelB && _vm.bonusPartnerData && Object.keys(_vm.bonusPartnerData).length > 0)?_c('div',{staticClass:"bonus-info"},[_c('div',{staticClass:"bonus-information"},[(_vm.bonusData.title && _vm.bonusData.title != '')?_c('h2',{staticClass:"custom-font-1"},[_vm._v("\n      "+_vm._s(_vm.bonusData.title)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cas-logo",style:({ background: _vm.bonusPrimaryColour })},[(_vm.bonusPartnerData && _vm.bonusPartnerData.go_link)?_c('a',{staticClass:"partner-logo cas-link",attrs:{"title":_vm.bonusPartnerData.product_name,"href":_vm.getGoLink(_vm.bonusPartnerData.go_link, _vm.bonusPartnerData.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}},[(_vm.assetsSize && _vm.assetsSize.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
              _vm.bonusPartnerData.product_assets.filter(
                function (ele) { return ele.asset_category_name === _vm.assetsSize.pro_asset_sizes.large; }
              ).length > 0
                ? _vm.bonusPartnerData.product_assets
                    .filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assetsSize.pro_asset_sizes.large; }
                    )
                    .shift().url
                : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
            ),expression:"\n              bonusPartnerData.product_assets.filter(\n                (ele) =>\n                  ele.asset_category_name === assetsSize.pro_asset_sizes.large\n              ).length > 0\n                ? bonusPartnerData.product_assets\n                    .filter(\n                      (ele) =>\n                        ele.asset_category_name ===\n                        assetsSize.pro_asset_sizes.large\n                    )\n                    .shift().url\n                : $root.site_url + $root.asset_path + '/failure.png'\n            "}],attrs:{"height":"","width":"","alt":_vm.getAltText(
                _vm.bonusPartnerData.name,
                _vm.bonusPartnerData.product_assets.filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assetsSize.pro_asset_sizes.large; }
                ).length > 0
                  ? _vm.bonusPartnerData.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assetsSize.pro_asset_sizes.large; }
                      )
                      .shift().url
                  : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
              )}}):_c('img',{attrs:{"src":_vm.bonusPartnerData.product_assets.filter(
                function (ele) { return ele.asset_category_name === _vm.assetsSize.pro_asset_sizes.large; }
              ).length > 0
                ? _vm.bonusPartnerData.product_assets
                    .filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assetsSize.pro_asset_sizes.large; }
                    )
                    .shift().url
                : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"height":"","width":"","alt":_vm.getAltText(
                _vm.bonusPartnerData.name,
                _vm.bonusPartnerData.product_assets.filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assetsSize.pro_asset_sizes.large; }
                ).length > 0
                  ? _vm.bonusPartnerData.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assetsSize.pro_asset_sizes.large; }
                      )
                      .shift().url
                  : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
              )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-bann"},[_c('div',{staticClass:"partner-hover-inner",style:({
                '--primary-btn': _vm.$root.color_schema.primary_btn,
                '--primary-btn-hover': _vm.pSBC(
                  -0.2,
                  _vm.$root.color_schema.primary_btn
                ),
              })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]:_vm._e()],2):[(_vm.assetsSize && _vm.assetsSize.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
              _vm.bonusPartnerData.product_assets
                .filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assetsSize.pro_asset_sizes.large; }
                )
                .shift().url
            ),expression:"\n              bonusPartnerData.product_assets\n                .filter(\n                  (ele) =>\n                    ele.asset_category_name ===\n                    assetsSize.pro_asset_sizes.large\n                )\n                .shift().url\n            "}],attrs:{"height":"","width":"","alt":_vm.getAltText(
                _vm.bonusPartnerData.name,
                _vm.bonusPartnerData.product_assets
                  .filter(
                    function (ele) { return ele.asset_category_name ===
                      _vm.assetsSize.pro_asset_sizes.large; }
                  )
                  .shift().url
              )}}):_c('img',{attrs:{"src":_vm.bonusPartnerData.product_assets
                .filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assetsSize.pro_asset_sizes.large; }
                )
                .shift().url,"height":"","width":"","alt":_vm.getAltText(
                _vm.bonusPartnerData.name,
                _vm.bonusPartnerData.product_assets
                  .filter(
                    function (ele) { return ele.asset_category_name ===
                      _vm.assetsSize.pro_asset_sizes.large; }
                  )
                  .shift().url
              )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-bann"},[_c('div',{staticClass:"partner-hover-inner",style:({
                '--primary-btn': _vm.$root.color_schema.primary_btn,
                '--primary-btn-hover': _vm.pSBC(
                  -0.2,
                  _vm.$root.color_schema.primary_btn
                ),
              })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]:_vm._e()]],2),_vm._v(" "),_c('span',{staticClass:"bonus-text custom-font-1"},[(_vm.hideBonusLabelB)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(
            _vm.bonusPartnerData.bonus_match &&
            _vm.bonusPartnerData.exclusive_bonus_amount &&
            _vm.bonusPartnerData.exclusive_bonus_match
          )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.bonusPartnerData.product_name,"href":_vm.getGoLink(_vm.bonusPartnerData.go_link, _vm.bonusPartnerData.slug),"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.bonusPartnerData.exclusive_bonus_match)+"%\n          "+_vm._s(_vm.$root.i18n.welcome_bonus)+" "+_vm._s(_vm.$root.i18n.up_to)+"\n          "+_vm._s(_vm._f("currency")(_vm.bonusPartnerData.exclusive_bonus_amount,_vm.bonusPartnerData.bonus_currency)))]):_vm._e(),_vm._v(" "),(
            _vm.bonusPartnerData.bonus_match &&
            !_vm.bonusPartnerData.exclusive_bonus_amount &&
            _vm.bonusPartnerData.bonus_amount
          )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.bonusPartnerData.product_name,"href":_vm.getGoLink(_vm.bonusPartnerData.go_link, _vm.bonusPartnerData.slug),"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.bonusPartnerData.bonus_match)+"% "+_vm._s(_vm.$root.i18n.welcome_bonus)+"\n          "+_vm._s(_vm.$root.i18n.up_to)+"\n          "+_vm._s(_vm._f("currency")(_vm.bonusPartnerData.bonus_amount,_vm.bonusPartnerData.bonus_currency)))]):_vm._e(),_vm._v(" "),(
            _vm.bonusPartnerData.freespin &&
            _vm.bonusPartnerData.freebie_name &&
            !_vm.bonusPartnerData.exclusive_bonus_amount &&
            !_vm.bonusPartnerData.bonus_amount
          )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.bonusPartnerData.product_name,"href":_vm.getGoLink(_vm.bonusPartnerData.go_link, _vm.bonusPartnerData.slug),"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.bonusPartnerData.freespin)+"\n          "+_vm._s(_vm.bonusPartnerData.freebie_name))]):_vm._e(),_vm._v(" "),(
            _vm.bonusPartnerData.bonus_amount &&
            !_vm.bonusPartnerData.bonus_match &&
            !_vm.bonusPartnerData.exclusive_bonus_amount &&
            !_vm.bonusPartnerData.freespin &&
            _vm.bonusPartnerData.freebie_name
          )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.bonusPartnerData.product_name,"href":_vm.getGoLink(_vm.bonusPartnerData.go_link, _vm.bonusPartnerData.slug),"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.bonusPartnerData.bonus_amount,_vm.bonusPartnerData.bonus_currency))+"\n          "+_vm._s(_vm.bonusPartnerData.bonus_name))]):_vm._e(),_vm._v(" "),(_vm.bonusPartnerData.freespin || _vm.bonusPartnerData.freebie_name)?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.bonusPartnerData.product_name,"href":_vm.getGoLink(_vm.bonusPartnerData.go_link, _vm.bonusPartnerData.slug),"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"target":"_blank"}},[(
              (_vm.bonusPartnerData.exclusive_bonus_amount ||
                _vm.bonusPartnerData.bonus_amount) &&
              _vm.bonusPartnerData.bonus_match
            )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.bonusPartnerData.freespin)?[(_vm.bonusPartnerData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.bonusPartnerData.freespin,_vm.bonusPartnerData.bonus_currency)))]:[_vm._v(_vm._s(_vm.bonusPartnerData.freespin))],_vm._v("\n            "+_vm._s(_vm.bonusPartnerData.freebie_name)+"\n          ")]:[_vm._v(_vm._s(_vm.bonusPartnerData.freebie_name))]],2):_vm._e()]],2),_vm._v(" "),(_vm.bonusData.make_first_deposit_to_claim)?_c('div',{staticClass:"deposit-heading"},[_vm._v("\n      "+_vm._s(_vm.bonusData.make_first_deposit_to_claim)+"\n    ")]):_vm._e(),_vm._v(" "),(!_vm.hideBonusLabelB)?_c('div',{staticClass:"bonus-info-box"},[_c('h3',[_vm._v(_vm._s(_vm.$root.i18n.bonus_info))]),_vm._v(" "),_c('ul',[(
            (_vm.bonusPartnerData.bonus_match &&
              _vm.bonusPartnerData.exclusive_bonus_amount &&
              _vm.bonusPartnerData.exclusive_bonus_match) ||
            (_vm.bonusPartnerData.bonus_match &&
              !_vm.bonusPartnerData.exclusive_bonus_amount &&
              _vm.bonusPartnerData.bonus_amount)
          )?_c('li',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.welcome_bonus))]),_c('strong',[(
                _vm.bonusPartnerData.bonus_match &&
                _vm.bonusPartnerData.exclusive_bonus_amount &&
                _vm.bonusPartnerData.exclusive_bonus_match
              )?[_vm._v(_vm._s(_vm.bonusPartnerData.exclusive_bonus_match)+"%\n              "+_vm._s(_vm.$root.i18n.up_to)+"\n              "+_vm._s(_vm._f("currency")(_vm.bonusPartnerData.exclusive_bonus_amount,_vm.bonusPartnerData.bonus_currency))+"\n            ")]:_vm._e(),_vm._v(" "),(
                _vm.bonusPartnerData.bonus_match &&
                !_vm.bonusPartnerData.exclusive_bonus_amount &&
                _vm.bonusPartnerData.bonus_amount
              )?[_vm._v(_vm._s(_vm.bonusPartnerData.bonus_match)+"%\n              "+_vm._s(_vm.$root.i18n.up_to)+"\n              "+_vm._s(_vm._f("currency")(_vm.bonusPartnerData.bonus_amount,_vm.bonusPartnerData.bonus_currency)))]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.bonusPartnerData.minimum_deposit)?_c('li',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.min_deposit))]),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.bonusPartnerData.minimum_deposit,_vm.bonusPartnerData.bonus_currency)))])]):_vm._e(),_vm._v(" "),(_vm.bonusPartnerData.freespin)?_c('li',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.free_spins)+"  ")]),_vm._v(" "),_c('strong',[(_vm.bonusPartnerData.freespin)?[(_vm.bonusPartnerData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.bonusPartnerData.freespin,_vm.bonusPartnerData.bonus_currency)))]:[_vm._v(_vm._s(_vm.bonusPartnerData.freespin))],_vm._v("\n              "+_vm._s(_vm.bonusPartnerData.freebie_name)+"\n            ")]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.bonusPartnerData.bonus_amount)?_c('li',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.max_bonus))]),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.bonusPartnerData.bonus_amount,_vm.bonusPartnerData.bonus_currency)))])]):_vm._e(),_vm._v(" "),(_vm.bonusPartnerData.bonus_match)?_c('li',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.match_bonus))]),_c('strong',[_vm._v(" "+_vm._s(_vm.bonusPartnerData.bonus_match)+"%")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.hideBonusLabelB)?_c('h3',[_vm._v("\n      "+_vm._s(_vm.$root.i18n.here_the_desciption_of_how_to_get_the_bonus)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.bonusPartnerData.bonus_summary && !_vm.hideBonusLabelB)?_c('p',[_vm._v("\n      "+_vm._s(_vm.bonusPartnerData.bonus_summary)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.bonusPartnerData.go_link && !_vm.hideBonusLabelB)?[_c('a',{class:{
          'cta cta-primary cta-promotion cta-block cta-promo-review custom-btn hover-btn cas-link ': true,
          'text-white game-btn':
            !_vm.$root.override_ctabtntxt_color &&
            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
          'text-gray':
            !_vm.$root.override_ctabtntxt_color &&
            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
          'text-cta-override': _vm.$root.override_ctabtntxt_color,
        },style:({
          '--primary-btn': _vm.$root.color_schema.primary_btn,
          '--primary-btn-hover': _vm.pSBC(-0.2, _vm.$root.color_schema.primary_btn),
        }),attrs:{"title":_vm.bonusPartnerData.product_name,"href":_vm.getGoLink(_vm.bonusPartnerData.go_link, _vm.bonusPartnerData.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.bonusPartnerData.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "revspp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]:_vm._e(),_vm._v(" "),(_vm.bonusPartnerData.bonus_tc && _vm.bonusPartnerData.bonus_tc != '')?_c('div',{staticClass:"terms"},[(_vm.bonusPartnerData.bonus_tc && _vm.bonusPartnerData.bonus_tc != '')?_c('span',{staticClass:"terms_tc cas-term rv-terms",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(_vm.bonusPartnerData.bonus_tc)}}):_vm._e(),_vm._v(" "),(
          _vm.bonusPartnerData.bonus_tc &&
          _vm.bonusPartnerData.terms &&
          _vm.bonusPartnerData.bonus_tc != '' &&
          _vm.bonusPartnerData.terms != ''
        )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.bonusPartnerData.terms && _vm.bonusPartnerData.terms != '')?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"title":_vm.bonusPartnerData.product_name,"href":_vm.getGoLink(_vm.bonusPartnerData.term_link, _vm.bonusPartnerData.slug),"target":"_blank"}},[_vm._v(_vm._s(_vm.bonusPartnerData.terms))]):_vm._e()]):_vm._e()],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComparisonList_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4519e592_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComparisonList_vue__ = __webpack_require__(627);
function injectStyle (ssrContext) {
  __webpack_require__(623)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4519e592"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComparisonList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4519e592_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComparisonList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(624);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("62d6e5a3", content, true, {});

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(46);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-4519e592]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-4519e592]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-4519e592]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-4519e592]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-4519e592]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-4519e592]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-4519e592]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-4519e592]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-4519e592]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-4519e592]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-4519e592]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-4519e592]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.online-gambling[data-v-4519e592]{display:block;margin:27px 0 37px}@media (min-width:768px){.online-gambling[data-v-4519e592]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}.online-gambling-half[data-v-4519e592]{-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;margin-right:0;margin-bottom:15px}.online-gambling-half h6[data-v-4519e592]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #bbb;padding-bottom:15px;margin-bottom:0}.online-gambling-half h6 i[data-v-4519e592]{margin-right:10px}.online-gambling-half h6 i img[data-v-4519e592]{margin-bottom:0}.online-gambling-half ul[data-v-4519e592]{margin:0}.online-gambling-half ul li[data-v-4519e592]{padding:17px 0;color:#222;margin-bottom:0}.online-gambling-half ul li[data-v-4519e592]:before{display:none}@media (min-width:768px){.online-gambling-half[data-v-4519e592]{margin-right:42px;margin-bottom:0}}.online-gambling-exclusive .online-gambling-half h6[data-v-4519e592]{padding-left:14px}.online-gambling-exclusive .online-gambling-half ul li[data-v-4519e592]{padding-left:44px}.online-gambling-exclusive .online-gambling-half.green h6[data-v-4519e592]{border-bottom:2px solid #148743}.online-gambling-exclusive .online-gambling-half.green ul li[data-v-4519e592]{background:url(" + escape(__webpack_require__(625)) + ") no-repeat 14px 21px;background-size:15px 15px}.online-gambling-exclusive .online-gambling-half.orange h6[data-v-4519e592]{border-bottom:2px solid #e8321d}.online-gambling-exclusive .online-gambling-half.orange ul li[data-v-4519e592]{background:url(" + escape(__webpack_require__(626)) + ") no-repeat 14px 23px;background-size:15px 15px}.online-gambling-container[data-v-4519e592]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0 -10px}@media (max-width:1024px){.online-gambling-container[data-v-4519e592]{flex-wrap:wrap}}@media (min-width:992px){.online-gambling-green[data-v-4519e592]{width:610px}}@media (min-width:992px){.online-gambling-red[data-v-4519e592]{width:610px;margin:0 10px}}@media (min-width:992px){.online-gambling-blue[data-v-4519e592]{width:610px}}.online-gambling-green[data-v-4519e592]{width:100%;background:#e2f3e3;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:0 10px}.online-gambling-green-header[data-v-4519e592]{padding:15px;background:#5abc5e;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:10px 10px 0;min-height:50px}.online-gambling-green-header p[data-v-4519e592]{font-weight:700;color:#fff;margin-bottom:0;position:relative}.online-gambling-green-header i[data-v-4519e592]{width:22px;height:22px;position:relative;float:left;top:0;right:0;margin-right:10px}.online-gambling-green-header i img[data-v-4519e592]{margin-bottom:0!important}.online-gambling-green-content[data-v-4519e592]{padding:18px 18px 0 24px}.online-gambling-green-content ul[data-v-4519e592]{margin-bottom:16px}.online-gambling-green-content ul li[data-v-4519e592]{position:relative;margin-bottom:20px;font-weight:400;font-size:18px;line-height:28px;padding-left:23px}.online-gambling-green-content ul li[data-v-4519e592]:last-child{margin-bottom:0}.online-gambling-green-content ul li strong[data-v-4519e592]{font-weight:700}.online-gambling-green-content ul li[data-v-4519e592]:after{position:absolute;content:\"\";left:0;top:6px;width:15px;height:16px}.online-gambling-red[data-v-4519e592]{width:100%;background:#f9e6e6;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:0 10px}@media (max-width:992px){.online-gambling-red[data-v-4519e592]{margin-top:20px}}.online-gambling-red-header[data-v-4519e592]{padding:15px;background:#fe4646;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:10px 10px 0;min-height:50px}.online-gambling-red-header p[data-v-4519e592]{font-weight:700;color:#fff;margin-bottom:0;position:relative}.online-gambling-red-header i[data-v-4519e592]{width:26px;height:26px;position:relative;top:0;right:0;float:left;margin-right:10px}.online-gambling-red-header i img[data-v-4519e592]{margin-bottom:0!important}.online-gambling-red-content[data-v-4519e592]{padding:18px 18px 0 24px}.online-gambling-red-content ul[data-v-4519e592]{margin-bottom:16px}.online-gambling-red-content ul li[data-v-4519e592]{position:relative;margin-bottom:20px;font-weight:400;font-size:18px;line-height:28px;padding-left:23px}.online-gambling-red-content ul li[data-v-4519e592]:last-child{margin-bottom:0}.online-gambling-red-content ul li strong[data-v-4519e592]{font-weight:700}.online-gambling-red-content ul li[data-v-4519e592]:after{position:absolute;content:\"\";left:0;top:6px;width:15px;height:16px}.online-gambling-red .online-gambling-red-header[data-v-4519e592]{background:#fe4646}.online-gambling-red .online-gambling-red-header i[data-v-4519e592]{padding:0}.online-gambling-blue[data-v-4519e592]{width:100%;background:#fff;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:10px}@media (min-width:1280px){.online-gambling-blue[data-v-4519e592]{margin:0 10px}}.online-gambling-blue-header[data-v-4519e592]{padding:15px;background:#0084ff;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:10px 10px 0;min-height:50px}.online-gambling-blue-header p[data-v-4519e592]{font-size:22px;font-weight:700;color:#fff;margin-bottom:0;position:relative}.online-gambling-blue-header i[data-v-4519e592]{width:26px;height:26px;position:relative;float:left;top:0;right:0;margin-right:10px}.online-gambling-blue-header i img[data-v-4519e592]{margin-bottom:0!important}.online-gambling-blue-content[data-v-4519e592]{padding:18px 18px 0 24px}.online-gambling-blue-content ul[data-v-4519e592]{margin-bottom:16px}.online-gambling-blue-content ul li[data-v-4519e592]{position:relative;margin-bottom:20px;font-weight:400;font-size:18px;line-height:28px;padding-left:23px}.online-gambling-blue-content ul li[data-v-4519e592]:last-child{margin-bottom:0}.online-gambling-blue-content ul li strong[data-v-4519e592]{font-weight:700}.online-gambling-blue-content ul li[data-v-4519e592]:after{position:absolute;content:\"\";left:0;top:6px;width:15px;height:16px}.online-gambling-blue .online-gambling-blue-header[data-v-4519e592]{background:#0084ff}.online-gambling-blue .online-gambling-blue-header i[data-v-4519e592]{padding:0}.cons-li[data-v-4519e592],.pros-li[data-v-4519e592]{padding-left:37px!important;margin-bottom:12px!important}@media (min-width:992px){.wd-50[data-v-4519e592]{width:50%}}", ""]);

// exports


/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg width='13' height='12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.5.44l6.495 11.25H.005L6.5.44z' fill='%23148743'/%3E%3C/svg%3E"

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg width='13' height='12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.5 11.44L.005.19h12.99L6.5 11.44z' fill='%23FF4C48'/%3E%3C/svg%3E"

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'pt-10 pb-25': true }},[(_vm.page === 'review')?[(_vm.comparisonData.block_title && _vm.comparisonData.block_title != '')?_c('span',{staticClass:"span-h2"},[_vm._v(_vm._s(_vm.comparisonData.block_title)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"online-gambling-container"},[_c('div',{class:{
          'online-gambling-green':
            _vm.comparisonData.style === 'pros_cons_comparison',
          'online-gambling-blue':
            _vm.comparisonData.style === 'general_comparison',
        }},[_c('div',{class:{
            'online-gambling-green-header':
              _vm.comparisonData.style === 'pros_cons_comparison',
            'online-gambling-blue-header':
              _vm.comparisonData.style === 'general_comparison',
          }},[_c('p',[(!_vm.comparisonData.disabled_icon)?_c('i',[(_vm.comparisonData.left.icon)?[_c('img',{attrs:{"src":_vm.comparisonData.left.icon,"width":"26","height":"26","alt":"Tick Big"}})]:[_c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19.8644 2.43441C17.5097 0.245343 14.0078 0.639093 11.8464 3.07191L10.9999 4.02347L10.1535 3.07191C7.99643 0.639093 4.49018 0.245343 2.13549 2.43441C-0.562943 4.94691 -0.70474 9.45628 1.7101 12.1797L10.0246 21.5453C10.5617 22.15 11.4339 22.15 11.971 21.5453L20.2855 12.1797C22.7046 9.45628 22.5628 4.94691 19.8644 2.43441Z","fill":"white"}})])]],2):_vm._e(),_vm._v(_vm._s(_vm.comparisonData.left.heading)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"online-gambling-green-content"},[_c('div',{class:{
              'custom-font custm-text': true,
              'tick-div-green':
                _vm.comparisonData.style === 'pros_cons_comparison' &&
                _vm.comparisonData.left.content.indexOf('ul') > 0,
              'tick-div-blue':
                _vm.comparisonData.style === 'general_comparison' &&
                _vm.comparisonData.left.content.indexOf('ul') > 0,
              'num-cls':
                _vm.comparisonData.style === 'general_comparison' &&
                _vm.comparisonData.left.content.indexOf('ol') > 0,
            },style:({
              '--heading-font': _vm.$root.font_family.heading,
              '--paragraph-font': _vm.$root.font_family.paragraph,
            }),domProps:{"innerHTML":_vm._s(_vm.comparisonData.left.content)}})])]),_vm._v(" "),_c('div',{class:{
          'online-gambling-red':
            _vm.comparisonData.style === 'pros_cons_comparison',
          'online-gambling-blue':
            _vm.comparisonData.style === 'general_comparison',
        }},[_c('div',{class:{
            'online-gambling-red-header':
              _vm.comparisonData.style === 'pros_cons_comparison',
            'online-gambling-blue-header':
              _vm.comparisonData.style === 'general_comparison',
          }},[_c('p',[(!_vm.comparisonData.disabled_icon)?_c('i',[(_vm.comparisonData.right.icon)?[_c('img',{attrs:{"src":_vm.comparisonData.right.icon,"width":"26","height":"26","alt":"Cross Big"}})]:[_c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20.3541 1.95916L20.251 1.84197C18.2744 -0.361156 15.1806 -0.581468 12.9635 1.14822L14.4373 5.99509L10.3123 8.99509L12.3748 14.9951L6.18728 8.24509L10.3123 5.24509L9.08338 1.19041C6.86189 -0.581468 3.73807 -0.375218 1.74861 1.84666L1.64549 1.95916C-0.447091 4.29353 -0.537325 8.01072 1.33182 10.4998L10.4455 20.7467C10.7506 21.0888 11.2447 21.0888 11.5498 20.7467L20.6678 10.4951C22.5369 8.01072 22.4467 4.29353 20.3541 1.95916Z","fill":"white"}})])]],2):_vm._e(),_vm._v(_vm._s(_vm.comparisonData.right.heading)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"online-gambling-red-content"},[_c('div',{class:{
              'custom-font custm-text': true,
              'cross-div':
                _vm.comparisonData.style === 'pros_cons_comparison' &&
                _vm.comparisonData.right.content.indexOf('ul') > 0,
              'tick-div-blue':
                _vm.comparisonData.style === 'general_comparison' &&
                _vm.comparisonData.right.content.indexOf('ul') > 0,
              'num-cls':
                _vm.comparisonData.style === 'general_comparison' &&
                _vm.comparisonData.right.content.indexOf('ol') > 0,
            },style:({
              '--heading-font': _vm.$root.font_family.heading,
              '--paragraph-font': _vm.$root.font_family.paragraph,
            }),domProps:{"innerHTML":_vm._s(_vm.comparisonData.right.content)}})])])])]:(_vm.page === 'partner-review-block')?[(
        _vm.partnerProcons &&
        _vm.partnerProcons.length > 0 &&
        (_vm.partnerProcons.filter(function (ele) { return ele.is_positive === '1'; }) ||
          _vm.partnerProcons.filter(function (ele) { return ele.is_positive === '0'; }))
      )?[(_vm.comparisonData.block_title && _vm.comparisonData.block_title != '')?_c('span',{staticClass:"span-h2"},[_vm._v(_vm._s(_vm.comparisonData.block_title)+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"online-gambling-container"},[(
            _vm.partnerProcons.filter(function (ele) { return ele.is_positive === '1'; }).length > 0
          )?_c('div',{class:{
            'online-gambling-green':
              _vm.comparisonData.style === 'pros_cons_comparison',
            'online-gambling-blue':
              _vm.comparisonData.style === 'general_comparison',
            'wd-50':
              _vm.partnerProcons.filter(function (ele) { return ele.is_positive === '0'; })
                .length === 0,
          }},[_c('div',{class:{
              'online-gambling-green-header':
                _vm.comparisonData.style === 'pros_cons_comparison',
              'online-gambling-blue-header':
                _vm.comparisonData.style === 'general_comparison',
            }},[_c('p',[(!_vm.comparisonData.disabled_icon)?_c('i',[(_vm.comparisonData.left.icon)?[_c('img',{attrs:{"src":_vm.comparisonData.left.icon,"width":"26","height":"26","alt":"Tick Big"}})]:[_c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19.8644 2.43441C17.5097 0.245343 14.0078 0.639093 11.8464 3.07191L10.9999 4.02347L10.1535 3.07191C7.99643 0.639093 4.49018 0.245343 2.13549 2.43441C-0.562943 4.94691 -0.70474 9.45628 1.7101 12.1797L10.0246 21.5453C10.5617 22.15 11.4339 22.15 11.971 21.5453L20.2855 12.1797C22.7046 9.45628 22.5628 4.94691 19.8644 2.43441Z","fill":"white"}})])]],2):_vm._e(),_vm._v(_vm._s(_vm.$root.i18n.pros)+"\n            ")])]),_vm._v(" "),_c('div',{class:{
              'online-gambling-green-content custm-text': true,
              'tick-div-green':
                _vm.comparisonData.style === 'pros_cons_comparison',
            }},[_c('ul',_vm._l((_vm.partnerProcons.filter(
                  function (ele) { return ele.is_positive === '1'; }
                )),function(data,index){return _c('li',{key:index,staticClass:"pros-li"},[_vm._v("\n                "+_vm._s(data.description)+"\n              ")])}),0)])]):_vm._e(),_vm._v(" "),(
            _vm.partnerProcons.filter(function (ele) { return ele.is_positive === '0'; }).length > 0
          )?_c('div',{class:{
            'online-gambling-red':
              _vm.comparisonData.style === 'pros_cons_comparison',
            'online-gambling-blue':
              _vm.comparisonData.style === 'general_comparison',
            'wd-50':
              _vm.partnerProcons.filter(function (ele) { return ele.is_positive === '1'; })
                .length === 0,
          }},[_c('div',{class:{
              'online-gambling-red-header':
                _vm.comparisonData.style === 'pros_cons_comparison',
              'online-gambling-blue-header':
                _vm.comparisonData.style === 'general_comparison',
            }},[_c('p',[(!_vm.comparisonData.disabled_icon)?_c('i',[(_vm.comparisonData.right.icon)?[_c('img',{attrs:{"src":_vm.comparisonData.right.icon,"width":"26","height":"26","alt":"Cross Big"}})]:[_c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20.3541 1.95916L20.251 1.84197C18.2744 -0.361156 15.1806 -0.581468 12.9635 1.14822L14.4373 5.99509L10.3123 8.99509L12.3748 14.9951L6.18728 8.24509L10.3123 5.24509L9.08338 1.19041C6.86189 -0.581468 3.73807 -0.375218 1.74861 1.84666L1.64549 1.95916C-0.447091 4.29353 -0.537325 8.01072 1.33182 10.4998L10.4455 20.7467C10.7506 21.0888 11.2447 21.0888 11.5498 20.7467L20.6678 10.4951C22.5369 8.01072 22.4467 4.29353 20.3541 1.95916Z","fill":"white"}})])]],2):_vm._e(),_vm._v(_vm._s(_vm.$root.i18n.cons)+"\n            ")])]),_vm._v(" "),_c('div',{class:{
              'online-gambling-red-content custm-text': true,
              'cross-div': _vm.comparisonData.style === 'pros_cons_comparison',
            }},[_c('ul',_vm._l((_vm.partnerProcons.filter(
                  function (ele) { return ele.is_positive === '0'; }
                )),function(data,index){return _c('li',{key:index,staticClass:"cons-li"},[_vm._v("\n                "+_vm._s(data.description)+"\n              ")])}),0)])]):_vm._e()])]:_vm._e()]:[(_vm.comparisonData.block_title && _vm.comparisonData.block_title != '')?_c('span',{staticClass:"span-h2"},[_vm._v(_vm._s(_vm.comparisonData.block_title)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"online-gambling-container"},[_c('div',{class:{
          'online-gambling-green':
            _vm.comparisonData.style === 'pros_cons_comparison',
          'online-gambling-blue':
            _vm.comparisonData.style === 'general_comparison',
        }},[_c('div',{class:{
            'online-gambling-green-header':
              _vm.comparisonData.style === 'pros_cons_comparison',
            'online-gambling-blue-header':
              _vm.comparisonData.style === 'general_comparison',
          }},[_c('p',[(!_vm.comparisonData.disabled_icon)?_c('i',[(_vm.comparisonData.left.icon)?[_c('img',{attrs:{"src":_vm.comparisonData.left.icon,"width":"26","height":"26","alt":"Tick Big"}})]:[_c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19.8644 2.43441C17.5097 0.245343 14.0078 0.639093 11.8464 3.07191L10.9999 4.02347L10.1535 3.07191C7.99643 0.639093 4.49018 0.245343 2.13549 2.43441C-0.562943 4.94691 -0.70474 9.45628 1.7101 12.1797L10.0246 21.5453C10.5617 22.15 11.4339 22.15 11.971 21.5453L20.2855 12.1797C22.7046 9.45628 22.5628 4.94691 19.8644 2.43441Z","fill":"white"}})])]],2):_vm._e(),_vm._v(_vm._s(_vm.comparisonData.left.heading)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"online-gambling-green-content"},[_c('div',{class:{
              'custom-font custm-text': true,
              'tick-div-green':
                _vm.comparisonData.style === 'pros_cons_comparison' &&
                _vm.comparisonData.left.content.indexOf('ul') > 0,
              'tick-div-blue':
                _vm.comparisonData.style === 'general_comparison' &&
                _vm.comparisonData.left.content.indexOf('ul') > 0,
              'num-cls':
                _vm.comparisonData.style === 'general_comparison' &&
                _vm.comparisonData.left.content.indexOf('ol') > 0,
            },style:({
              '--heading-font': _vm.$root.font_family.heading,
              '--paragraph-font': _vm.$root.font_family.paragraph,
            }),domProps:{"innerHTML":_vm._s(_vm.comparisonData.left.content)}})])]),_vm._v(" "),_c('div',{class:{
          'online-gambling-red':
            _vm.comparisonData.style === 'pros_cons_comparison',
          'online-gambling-blue':
            _vm.comparisonData.style === 'general_comparison',
        }},[_c('div',{class:{
            'online-gambling-red-header':
              _vm.comparisonData.style === 'pros_cons_comparison',
            'online-gambling-blue-header':
              _vm.comparisonData.style === 'general_comparison',
          }},[_c('p',[(!_vm.comparisonData.disabled_icon)?_c('i',[(_vm.comparisonData.right.icon)?[_c('img',{attrs:{"src":_vm.comparisonData.right.icon,"width":"26","height":"26","alt":"Cross Big"}})]:[_c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20.3541 1.95916L20.251 1.84197C18.2744 -0.361156 15.1806 -0.581468 12.9635 1.14822L14.4373 5.99509L10.3123 8.99509L12.3748 14.9951L6.18728 8.24509L10.3123 5.24509L9.08338 1.19041C6.86189 -0.581468 3.73807 -0.375218 1.74861 1.84666L1.64549 1.95916C-0.447091 4.29353 -0.537325 8.01072 1.33182 10.4998L10.4455 20.7467C10.7506 21.0888 11.2447 21.0888 11.5498 20.7467L20.6678 10.4951C22.5369 8.01072 22.4467 4.29353 20.3541 1.95916Z","fill":"white"}})])]],2):_vm._e(),_vm._v(_vm._s(_vm.comparisonData.right.heading)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"online-gambling-red-content"},[_c('div',{class:{
              'custom-font custm-text': true,
              'cross-div':
                _vm.comparisonData.style === 'pros_cons_comparison' &&
                _vm.comparisonData.right.content.indexOf('ul') > 0,
              'tick-div-blue':
                _vm.comparisonData.style === 'general_comparison' &&
                _vm.comparisonData.right.content.indexOf('ul') > 0,
              'num-cls':
                _vm.comparisonData.style === 'general_comparison' &&
                _vm.comparisonData.right.content.indexOf('ol') > 0,
            },style:({
              '--heading-font': _vm.$root.font_family.heading,
              '--paragraph-font': _vm.$root.font_family.paragraph,
            }),domProps:{"innerHTML":_vm._s(_vm.comparisonData.right.content)}})])])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromotionBannerSuggest_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05030a3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromotionBannerSuggest_vue__ = __webpack_require__(632);
function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05030a3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromotionBannerSuggest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05030a3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromotionBannerSuggest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(630);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("715e1c90", content, true, {});

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-05030a3a]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-05030a3a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-05030a3a]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-05030a3a]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-05030a3a]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-05030a3a]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-05030a3a]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-05030a3a]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-05030a3a]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-05030a3a]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-05030a3a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-05030a3a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.offer-card[data-v-05030a3a]{z-index:1;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;padding:0 12px;position:relative;overflow:hidden}.offer-card[data-v-05030a3a]:before{content:\"\";position:absolute;height:100%;width:100%;top:0;left:0;background:linear-gradient(180deg,transparent,rgba(0,0,0,.522118) 6.04%,rgba(0,0,0,.83));z-index:0}.offer-card-big .timer-text[data-v-05030a3a]{margin:24px auto}.offer-card-big .timer-text svg[data-v-05030a3a]{margin-right:22px}.offer-card-big .terms[data-v-05030a3a]{display:block}@media (min-width:576px){.offer-card-big .terms[data-v-05030a3a]{display:none}}.offer-card-big.suggested[data-v-05030a3a]{border:2px solid #0165f7}.offer-card-bg[data-v-05030a3a]{position:absolute;top:0;left:0;height:100%;width:100%;z-index:-1}.offer-card-bg img[data-v-05030a3a]{object-fit:cover;height:100%}.offer-card-meta[data-v-05030a3a]{display:inline-flex;position:relative;top:8px}@media (min-width:576px){.offer-card-meta[data-v-05030a3a]{position:relative;top:12px}}@media (min-width:1200px){.offer-card-meta[data-v-05030a3a]{position:absolute;top:12px}}.offer-card-logo[data-v-05030a3a]{height:50px;width:50px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;overflow:hidden}.offer-card-title[data-v-05030a3a]{font-size:16px;line-height:115%;font-weight:700;margin-left:8px;color:#fff}@media (min-width:576px){.offer-card-title[data-v-05030a3a]{line-height:150%}}.offer-card-bonus[data-v-05030a3a]{position:relative;width:100%;margin:20px auto;padding:10px 16px 18px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;border:2px dashed #fff}.offer-card-bonus .bonus-text[data-v-05030a3a]{display:block;margin:0 auto;color:#fff;text-align:center;font-size:16px;line-height:22px;font-weight:700;font-family:var(--paragraph-font)}@media (min-width:576px){.offer-card-bonus .bonus-text[data-v-05030a3a]{font-size:32px;line-height:48px;width:465px}}@media (min-width:576px){.offer-card-bonus[data-v-05030a3a]{width:643px;padding:27px;margin:40px auto}}.offer-card-bonus .mobile-tags[data-v-05030a3a]{display:flex;justify-content:center;margin-bottom:6px}.offer-card-bonus .mobile-tags span[data-v-05030a3a]{padding:7px 6px 5px;font-size:12px;line-height:11px;margin:0 3px}.offer-card-bonus .mobile-tags span svg[data-v-05030a3a]{top:1px!important}@media (min-width:576px){.offer-card-bonus .mobile-tags[data-v-05030a3a]{display:none}}.offer-card-tags[data-v-05030a3a]{position:absolute;top:12px;right:12px;display:none}.offer-card-tags span[data-v-05030a3a]{display:block;margin-bottom:7px;padding:4px 12px;width:114px;font-size:12px;line-height:18px}@media (min-width:576px){.offer-card-tags[data-v-05030a3a]{display:inline-block}}@media (min-width:768px){.offer-card-small[data-v-05030a3a]{width:360px}}@media (min-width:1200px){.offer-card-small[data-v-05030a3a]{width:380px}}.offer-card-small .card-tags[data-v-05030a3a]{display:flex;justify-content:center;margin-bottom:6px}.offer-card-small .card-tags span[data-v-05030a3a]{padding:3px 6px;width:64px;font-size:8px;line-height:8px;margin:0 3px}.offer-card-small .card-tags span svg[data-v-05030a3a]{top:1px!important}.offer-card-small .offer-card-meta[data-v-05030a3a]{position:relative;top:12px}.offer-card-small .offer-card-bonus[data-v-05030a3a]{width:100%;padding:10px 16px 18px}.offer-card-small .offer-card-bonus .bonus-text[data-v-05030a3a]{font-size:16px;line-height:18px;width:calc(100% - 32px);font-family:var(--paragraph-font)}@media (min-width:576px){.offer-card-small .offer-card-bonus .bonus-text[data-v-05030a3a]{font-size:24px;line-height:26px;width:339px}}.offer-card .pro-promotion-tag[data-v-05030a3a]{background:#ffd039;text-align:center;font-weight:600;-webkit-border-radius:100px;-moz-border-radius:100px;border-radius:100px}.offer-card .pro-promotion-tag svg[data-v-05030a3a]{position:relative;top:5px}.offer-card .pro-suggestion-tag[data-v-05030a3a]{color:#fff;background:#0165f7;text-align:center;font-weight:600;-webkit-border-radius:100px;-moz-border-radius:100px;border-radius:100px}.offer-card .pro-suggestion-tag svg[data-v-05030a3a]{position:relative;top:5px}.offer-card .cta[data-v-05030a3a]{max-width:375px;margin:0 auto;display:block}.offer-card .timer-text[data-v-05030a3a]{position:relative;margin:14px auto;display:block;text-align:center;font-size:12px;line-height:15px;color:#fe4646;white-space:normal;margin-bottom:24px}@media (min-width:768px){.offer-card .timer-text[data-v-05030a3a]{font-size:16px;line-height:19px}}@media (min-width:992px){.offer-card .timer-text[data-v-05030a3a]{font-size:16px}}.offer-card .timer-text svg[data-v-05030a3a]{vertical-align:text-bottom;margin-right:6px}@media (min-width:576px){.offer-card .timer-text svg[data-v-05030a3a]{margin-right:16px}}.offer-card .terms[data-v-05030a3a]{padding:5px 11px;background:rgba(239,241,245,.1);margin:0 -12px;text-align:center}.offer-card .terms span[data-v-05030a3a]{font-size:10px;line-height:15px;color:#c4c7c9}.text-bold[data-v-05030a3a]{font-weight:700;margin-left:5px}.wrapper-header[data-v-05030a3a]{font-weight:900;font-size:26px;line-height:31px;padding-bottom:8px;display:flex;align-items:baseline}.wrapper-header .hd-span[data-v-05030a3a]{color:#fff}@media (min-width:768px){.wrapper-header[data-v-05030a3a]{font-size:36px;line-height:54px}}.img-desktop[data-v-05030a3a]{width:100%;object-fit:cover}.img-mobile[data-v-05030a3a]{display:block;height:100%;width:100%;object-position:center;object-fit:cover}@media (min-width:992px){.img-mobile[data-v-05030a3a]{display:none}}.img-desktop[data-v-05030a3a]{display:none}@media (min-width:992px){.img-desktop[data-v-05030a3a]{display:block}}.star-cls[data-v-05030a3a]{justify-content:normal!important}.time-text[data-v-05030a3a]{width:70px}@media (min-width:576px){.time-text[data-v-05030a3a]{width:75px}}.partner-name[data-v-05030a3a]{color:#fff!important}.pt-100 img[data-v-05030a3a],.pt-100[data-v-05030a3a]{width:100%;height:100%}.game-btn[data-v-05030a3a],.promto-term[data-v-05030a3a]{position:relative}.desk-text[data-v-05030a3a]{display:none}@media (min-width:576px){.desk-text[data-v-05030a3a]{display:block}}.mob-text[data-v-05030a3a]{display:block}@media (min-width:576px){.mob-text[data-v-05030a3a]{display:none}}", ""]);

// exports


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCountryName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCountryFlag; });
var country = {
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Aland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthelemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Bonaire, Saint Eustatius and Saba",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos Islands",
  CD: "Democratic Republic of the Congo",
  CF: "Central African Republic",
  CG: "Republic of the Congo",
  CH: "Switzerland",
  CI: "Ivory Coast",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curacao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestinian Territory",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Swaziland",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "East Timor",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Vatican",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "British Virgin Islands",
  VI: "U.S. Virgin Islands",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe"
};

var getCountryName = function getCountryName(iso2) {
  return country[iso2];
};

var getCountryFlag = function getCountryFlag(iso2, size) {
  return "https://www.countryflags.io/".concat(iso2, "/flat/").concat(size ? size : 64, ".png");
};



/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.promoData &&
    Object.keys(_vm.promoData).length > 0 &&
    Object.keys(_vm.promoData.partner_information).length > 0
  )?_c('div',{staticClass:"pb-25"},[(_vm.promoData.metadata)?_c('div',{staticClass:"offer-wrapper"},[_c('div',{staticClass:"offer-card offer-card-big suggested"},[_c('div',{staticClass:"offer-card-bg"},[_c('img',{staticClass:"img-desktop",attrs:{"src":_vm.promoData.metadata.desktop_header_image,"alt":_vm.promoData.metadata.partner
              ? _vm.getAltText(
                  _vm.promoData.metadata.partner.post_title,
                  _vm.promoData.metadata.desktop_header_image
                )
              : 'Header Desktop Image'}}),_vm._v(" "),_c('img',{staticClass:"img-mobile",attrs:{"src":_vm.promoData.metadata.mobile_header_image,"alt":_vm.promoData.metadata.partner
              ? _vm.getAltText(
                  _vm.promoData.metadata.partner.post_title,
                  _vm.promoData.metadata.desktop_header_image
                )
              : 'Header Mobile Image'}})]),_vm._v(" "),(_vm.promoData.partner_information)?_c('div',{staticClass:"offer-card-meta"},[_c('div',{staticClass:"offer-card-logo"},[(_vm.promoData.partner_information.go_link)?_c('a',{staticClass:"affiliate-logo partner-logo pt-100 cas-link",attrs:{"title":_vm.promoData.partner_information.product_name,"href":_vm.getGoLink(
                _vm.promoData.partner_information.go_link,
                _vm.promoData.partner_information.slug
              ),"rel":_vm.$root.change_cta_to_sponsored
                ? 'nofollow sponsored'
                : 'nofollow',"target":"_blank"}},[(
                _vm.promoData.partner_information.product_assets &&
                _vm.getPartnerImg(_vm.promoData.partner_information.product_assets)
              )?_c('img',{attrs:{"src":_vm.getPartnerImg(_vm.promoData.partner_information.product_assets),"alt":_vm.getAltText(
                  _vm.promoData.partner_information.product_name,
                  _vm.getPartnerImg(_vm.promoData.partner_information.product_assets)
                )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-promo"},[_c('div',{staticClass:"partner-hover-inner",style:({
                  '--primary-btn': _vm.$root.color_schema.primary_btn,
                  '--primary-btn-hover': _vm.pSBC(
                    -0.2,
                    _vm.$root.color_schema.primary_btn
                  ),
                })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"offer-card-title"},[(_vm.$root.enable_piwik_reload)?[(_vm.promoData.partner_information.review_link)?_c('a',{staticClass:"partner-name custom-font-1 text-hover",attrs:{"title":_vm.promoData.partner_information.product_name,"href":_vm.getRouteLink(
                  _vm.promoData.partner_information.review_link,
                  'review'
                )}},[_c('span',[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                    _vm.$root.i18n.partner_name_review,
                    _vm.promoData.partner_information.product_name
                  ))+"\n              ")])]):_c('span',{staticClass:"partner-name custom-font-1"},[_vm._v(_vm._s(_vm.promoData.partner_information.product_name))])]:[(_vm.promoData.partner_information.review_link)?_c('router-link',{staticClass:"partner-name custom-font-1 text-hover",attrs:{"title":_vm.promoData.partner_information.product_name,"to":_vm.getRouteLink(
                  _vm.promoData.partner_information.review_link,
                  'review'
                )}},[_c('span',[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                    _vm.$root.i18n.partner_name_review,
                    _vm.promoData.partner_information.product_name
                  ))+"\n              ")])]):_c('span',{staticClass:"partner-name custom-font-1"},[_vm._v(_vm._s(_vm.promoData.partner_information.product_name))])],_vm._v(" "),_c('StarRating',{attrs:{"rating":parseFloat(
                (_vm.promoData.partner_information.rating / 2).toFixed(1)
              ),"classParam":_vm.strCls}})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"offer-card-tags"},[_c('span',{staticClass:"pro-promotion-tag"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"}},[_c('path',{attrs:{"d":"M7.97849 4.95613C7.94088 4.87537 7.85987 4.82354 7.77065 4.82354H5.05211L7.73508 0.587447C7.77981 0.516795 7.78256 0.427324 7.7422 0.354146C7.70182 0.280725 7.62472 0.235291 7.54122 0.235291H3.87063C3.78369 0.235291 3.7043 0.284381 3.66532 0.362157L0.224142 7.24451C0.188574 7.31541 0.192472 7.39982 0.234223 7.46749C0.276217 7.53516 0.349852 7.57645 0.429457 7.57645H2.78849L0.217931 13.6816C0.17411 13.786 0.213119 13.9071 0.309687 13.9663C0.346841 13.989 0.388135 14 0.429214 14C0.495054 14 0.559979 13.9718 0.604957 13.9185L7.94615 5.20088C8.00371 5.13254 8.0161 5.03711 7.97849 4.95613Z","fill":"black"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.97849 4.95613C7.94088 4.87537 7.85987 4.82354 7.77065 4.82354H5.05211L7.73508 0.587447C7.77981 0.516795 7.78256 0.427324 7.7422 0.354146C7.70182 0.280725 7.62472 0.235291 7.54122 0.235291H3.87063C3.78369 0.235291 3.7043 0.284381 3.66532 0.362157L0.224142 7.24451C0.188574 7.31541 0.192472 7.39982 0.234223 7.46749C0.276217 7.53516 0.349852 7.57645 0.429457 7.57645H2.78849L0.217931 13.6816C0.17411 13.786 0.213119 13.9071 0.309687 13.9663C0.346841 13.989 0.388135 14 0.429214 14C0.495054 14 0.559979 13.9718 0.604957 13.9185L7.94615 5.20088C8.00371 5.13254 8.0161 5.03711 7.97849 4.95613Z","fill":"black"}})]),_vm._v("\n          "+_vm._s(_vm.$root.i18n.promotion)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"pro-suggestion-tag"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}},[_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M10.4896 9.65479C10.2314 9.65479 10.0217 9.4458 10.021 9.18738C10.0201 8.92859 10.2294 8.71802 10.4883 8.71729C11.6658 8.71362 12.786 8.00269 13.6426 6.71533C14.4647 5.47974 14.9478 3.86389 15.0214 2.12354H12.9567C12.6978 2.12354 12.4879 1.9137 12.4879 1.65479C12.4879 1.39587 12.6978 1.18604 12.9567 1.18604H15.5C15.7589 1.18604 15.9688 1.39587 15.9688 1.65479C15.9688 3.75513 15.4198 5.73669 14.4232 7.23474C13.3878 8.79065 11.9915 9.65015 10.4912 9.65479C10.4907 9.65479 10.4902 9.65479 10.4896 9.65479Z","fill":"#FF8E1D"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.44788 9.65479C5.44727 9.65479 5.4469 9.65479 5.44641 9.65479C3.94617 9.65015 2.54968 8.79065 1.5144 7.23474C0.5177 5.73669 -0.03125 3.75513 -0.03125 1.65479C-0.03125 1.39587 0.178589 1.18604 0.4375 1.18604H2.98084C3.23975 1.18604 3.44959 1.39587 3.44959 1.65479C3.44959 1.9137 3.23975 2.12354 2.98084 2.12354H0.916138C0.989746 3.86389 1.47278 5.47974 2.29492 6.71533C3.15149 8.00269 4.27173 8.71362 5.44922 8.71729C5.70813 8.71802 5.91736 8.92859 5.91651 9.18738C5.91577 9.4458 5.70606 9.65466 5.44788 9.65479Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.9897 0.03125H2.948C2.68921 0.03125 2.47925 0.241089 2.47925 0.5C2.47925 3.25354 3.01917 5.84973 3.99939 7.81018C4.62744 9.06616 5.39551 9.97791 6.24487 10.4999V13.052C6.24487 13.3109 6.45483 13.5208 6.71362 13.5208H9.22412C9.48303 13.5208 9.69287 13.3109 9.69287 13.052V10.4999C10.5422 9.97803 11.3104 9.06616 11.9384 7.81018C12.9186 5.84973 13.4585 3.25354 13.4585 0.5C13.4585 0.241089 13.2487 0.03125 12.9897 0.03125Z","fill":"#FFD12B"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9.69275 13.052V10.4999C10.5421 9.97803 11.3103 9.06616 11.9382 7.81018C12.9185 5.84973 13.4584 3.25354 13.4584 0.5C13.4584 0.241089 13.2485 0.03125 12.9896 0.03125H7.96875V13.5208H9.224C9.48291 13.5208 9.69275 13.3109 9.69275 13.052Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.4791 12.5833H5.45837C4.50781 12.5833 3.73438 13.3567 3.73438 14.3073V15.5625C3.73438 15.8213 3.94421 16.0311 4.20312 16.0311H11.7344C11.9933 16.0311 12.2031 15.8213 12.2031 15.5625V14.3073C12.2031 13.3567 11.4298 12.5833 10.4791 12.5833Z","fill":"#FF8E1D"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.4791 12.5833H7.96875V16.0311H11.7344C11.9933 16.0311 12.2031 15.8213 12.2031 15.5625V14.3073C12.2031 13.3567 11.4298 12.5833 10.4791 12.5833Z","fill":"#FF6D15"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.2363 16.0311H3.70093C3.44214 16.0311 3.23218 15.8213 3.23218 15.5625C3.23218 15.3036 3.44214 15.0938 3.70093 15.0938H12.2363C12.4952 15.0938 12.7051 15.3036 12.7051 15.5625C12.7051 15.8213 12.4952 16.0311 12.2363 16.0311Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.2365 15.0938H7.96875V16.0311H12.2365C12.4954 16.0311 12.7052 15.8213 12.7052 15.5625C12.7052 15.3036 12.4954 15.0938 12.2365 15.0938Z","fill":"#FF8E1D"}})]),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"16","height":"16","fill":"white"}})])])]),_vm._v("\n          "+_vm._s(_vm.$root.i18n.suggested)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"offer-card-bonus"},[_c('div',{staticClass:"mobile-tags"},[_c('span',{staticClass:"pro-promotion-tag"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"5","height":"9","viewBox":"0 0 5 9","fill":"none"}},[_c('path',{attrs:{"d":"M4.98659 3.18601C4.96308 3.13409 4.91245 3.10077 4.85668 3.10077H3.1576L4.83445 0.37757C4.86241 0.332151 4.86413 0.274634 4.83891 0.227591C4.81367 0.180392 4.76548 0.151184 4.71329 0.151184H2.41918C2.36484 0.151184 2.31522 0.182742 2.29086 0.232741L0.140119 4.65711C0.117889 4.70269 0.120326 4.75696 0.14642 4.80046C0.172666 4.84396 0.218688 4.8705 0.268441 4.8705H1.74284L0.136238 8.79522C0.108849 8.86232 0.13323 8.94018 0.193585 8.97824C0.216806 8.99284 0.242615 8.99991 0.26829 8.99991C0.309439 8.99991 0.350018 8.98177 0.378128 8.94756L4.96637 3.34335C5.00235 3.29942 5.01009 3.23807 4.98659 3.18601Z","fill":"black"}})]),_vm._v("\n            "+_vm._s(_vm.$root.i18n.promotion)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"pro-suggestion-tag"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"}},[_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M5.24506 4.82739C5.11597 4.82739 5.01111 4.7229 5.01074 4.59369C5.01032 4.46429 5.11493 4.35901 5.24439 4.35864C5.83313 4.35681 6.39325 4.00134 6.82154 3.35767C7.23261 2.73987 7.47413 1.93195 7.51093 1.06177H6.47858C6.34913 1.06177 6.24421 0.956848 6.24421 0.827393C6.24421 0.697937 6.34913 0.593018 6.47858 0.593018H7.75025C7.87971 0.593018 7.98463 0.697937 7.98463 0.827393C7.98463 1.87756 7.71015 2.86835 7.21186 3.61737C6.69416 4.39532 5.99598 4.82507 5.24585 4.82739C5.24561 4.82739 5.24536 4.82739 5.24506 4.82739Z","fill":"#FF8E1D"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.72394 4.82739C2.72363 4.82739 2.72345 4.82739 2.72321 4.82739C1.97308 4.82507 1.27484 4.39532 0.757202 3.61737C0.25885 2.86835 -0.015625 1.87756 -0.015625 0.827393C-0.015625 0.697937 0.0892945 0.593018 0.21875 0.593018H1.49042C1.61987 0.593018 1.72479 0.697937 1.72479 0.827393C1.72479 0.956848 1.61987 1.06177 1.49042 1.06177H0.458069C0.494873 1.93195 0.736389 2.73987 1.14746 3.35767C1.57574 4.00134 2.13586 4.35681 2.72461 4.35864C2.85407 4.35901 2.95868 4.46429 2.95825 4.59369C2.95789 4.7229 2.85303 4.82733 2.72394 4.82739Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.495 0.015625H1.47412C1.34473 0.015625 1.23975 0.120544 1.23975 0.25C1.23975 1.62677 1.5097 2.92487 1.99982 3.90509C2.31384 4.53308 2.69788 4.98895 3.12256 5.24994V6.526C3.12256 6.65546 3.22754 6.76038 3.35693 6.76038H4.61218C4.74164 6.76038 4.84656 6.65546 4.84656 6.526V5.24994C5.27124 4.98901 5.65533 4.53308 5.9693 3.90509C6.45941 2.92487 6.72937 1.62677 6.72937 0.25C6.72937 0.120544 6.62445 0.015625 6.495 0.015625Z","fill":"#FFD12B"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4.84637 6.526V5.24994C5.27106 4.98901 5.65515 4.53308 5.96912 3.90509C6.45923 2.92487 6.72919 1.62677 6.72919 0.25C6.72919 0.120544 6.62427 0.015625 6.49481 0.015625H3.98438V6.76038H4.612C4.74146 6.76038 4.84637 6.65546 4.84637 6.526Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.23956 6.29163H2.72919C2.25391 6.29163 1.86719 6.67835 1.86719 7.15363V7.78126C1.86719 7.91065 1.97211 8.01557 2.10156 8.01557H5.86719C5.99664 8.01557 6.10156 7.91065 6.10156 7.78126V7.15363C6.10156 6.67835 5.7149 6.29163 5.23956 6.29163Z","fill":"#FF8E1D"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.23956 6.29163H3.98438V8.01557H5.86719C5.99664 8.01557 6.10156 7.91065 6.10156 7.78126V7.15363C6.10156 6.67835 5.7149 6.29163 5.23956 6.29163Z","fill":"#FF6D15"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.11829 8.01557H1.85059C1.72119 8.01557 1.61621 7.91065 1.61621 7.78125C1.61621 7.6518 1.72119 7.54688 1.85059 7.54688H6.11829C6.24774 7.54688 6.35266 7.6518 6.35266 7.78125C6.35266 7.91065 6.24774 8.01557 6.11829 8.01557Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.11822 7.54688H3.98438V8.01557H6.11822C6.24768 8.01557 6.3526 7.91065 6.3526 7.78125C6.3526 7.6518 6.24768 7.54688 6.11822 7.54688Z","fill":"#FF8E1D"}})]),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"8","height":"8","fill":"white"}})])])]),_vm._v("\n            "+_vm._s(_vm.$root.i18n.suggested)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"desk-text"},[(_vm.promoData.partner_information.go_link)?_c('a',{staticClass:"partner-name promto-text custom-font-1 cas-link text-hover",attrs:{"title":_vm.promoData.partner_information.product_name,"href":_vm.getGoLink(
                _vm.promoData.partner_information.go_link,
                _vm.promoData.partner_information.slug
              ),"rel":_vm.$root.change_cta_to_sponsored
                ? 'nofollow sponsored'
                : 'nofollow',"target":"_blank"}},[(_vm.promoData.short_descrp.length < 130)?_c('span',{staticClass:"bonus-text"},[_vm._v(_vm._s(_vm.promoData.short_descrp))]):_c('span',{staticClass:"bonus-text"},[_vm._v(_vm._s(_vm.promoData.short_descrp.slice(0, 130) + "..."))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mob-text"},[(_vm.promoData.partner_information.go_link)?_c('a',{staticClass:"partner-name promto-text custom-font-1 cas-link text-hover",attrs:{"title":_vm.promoData.partner_information.product_name,"href":_vm.getGoLink(
                _vm.promoData.partner_information.go_link,
                _vm.promoData.partner_information.slug
              ),"rel":_vm.$root.change_cta_to_sponsored
                ? 'nofollow sponsored'
                : 'nofollow',"target":"_blank"}},[(_vm.promoData.short_descrp.length < 100)?_c('span',{staticClass:"bonus-text"},[_vm._v(_vm._s(_vm.promoData.short_descrp))]):_c('span',{staticClass:"bonus-text"},[_vm._v(_vm._s(_vm.promoData.short_descrp.slice(0, 100) + "..."))])]):_vm._e()])]),_vm._v(" "),(
          _vm.promoData.partner_information &&
          _vm.promoData.partner_information.go_link
        )?_c('a',{class:{
          'cta cta-primary cta-promotion ml-0 custom-btn btn-width cta-large game-btn hover-btn cas-link': true,
          'text-white':
            !_vm.$root.override_ctabtntxt_color &&
            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
          'text-gray':
            !_vm.$root.override_ctabtntxt_color &&
            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
          'text-cta-override': _vm.$root.override_ctabtntxt_color,
        },style:({
          '--primary-btn': _vm.$root.color_schema.primary_btn,
          '--primary-btn-hover': _vm.pSBC(-0.2, _vm.$root.color_schema.primary_btn),
        }),attrs:{"title":_vm.promoData.partner_information.product_name,"href":_vm.getGoLink(
            _vm.promoData.partner_information.go_link,
            _vm.promoData.partner_information.slug
          ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.promoData.partner_information.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "simpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e(),_vm._v(" "),(_vm.timer_html.length > 0)?_c('span',{staticClass:"timer-text promto-time"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"}},[_c('path',{attrs:{"d":"M13.1265 2.24486L12.4548 3.40718L14.7823 4.75061L15.454 3.58826C15.639 3.26561 15.5289 2.85623 15.2075 2.66983L14.0452 1.99809C13.7236 1.81188 13.313 1.92205 13.1265 2.24486Z","fill":"#FE4646"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.9999 3.02484C9.42474 3.02484 9.83974 3.06641 10.2499 3.125V2.03781L11.1093 2.03124V0.625C11.1093 0.279543 10.8297 0 10.4843 0H7.52209C7.17664 0 6.89709 0.279543 6.89709 0.625V2.03124L7.7499 2.03781V3.125C8.16007 3.06641 8.57507 3.02484 8.9999 3.02484Z","fill":"#FE4646"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9 3.75C4.51268 3.75 0.875 7.38765 0.875 11.875C0.875 16.3624 4.51268 20 9 20C13.4873 20 17.125 16.3624 17.125 11.875C17.125 7.38765 13.4873 3.75 9 3.75ZM12.7969 15.6938L8.06248 12.4161V7.78889H9.42876V11.7003L13.5745 14.5705L12.7969 15.6938Z","fill":"#FE4646"}})]),_vm._v(" "),_c('span',{staticClass:"time-text"},[_vm._v("\n          "+_vm._s(_vm.$root.i18n.time_left.charAt(0).toUpperCase() +
            _vm.$root.i18n.time_left.slice(1))+":\n        ")]),_vm._v(" "),_c('span',{staticClass:"text-bold",domProps:{"innerHTML":_vm._s(_vm.timer_html)}})]):_vm._e(),_vm._v(" "),(
          _vm.promoData.partner_information.bonus_tc &&
          _vm.promoData.partner_information.bonus_tc != ''
        )?_c('div',{staticClass:"terms promto-term"},[(
            _vm.promoData.partner_information.bonus_tc &&
            _vm.promoData.partner_information.bonus_tc != ''
          )?_c('span',{staticClass:"terms_tc cas-term",style:({
            '--primary-btn': _vm.$root.color_schema.primary_btn,
          }),domProps:{"innerHTML":_vm._s(_vm.promoData.partner_information.bonus_tc)}}):_vm._e(),_vm._v(" "),(
            _vm.promoData.partner_information.bonus_tc &&
            _vm.promoData.partner_information.terms &&
            _vm.promoData.partner_information.bonus_tc != '' &&
            _vm.promoData.partner_information.terms != ''
          )?_c('span',{staticClass:"promoData.partner_information-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(
            _vm.promoData.partner_information.terms &&
            _vm.promoData.partner_information.terms != ''
          )?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"title":_vm.promoData.partner_information.product_name,"href":_vm.getGoLink(
              _vm.promoData.partner_information.term_link,
              _vm.promoData.partner_information.slug
            ),"target":"_blank"}},[_vm._v(_vm._s(_vm.promoData.partner_information.terms))]):_vm._e()]):_vm._e()])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Author_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c373efe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Author_vue__ = __webpack_require__(636);
function injectStyle (ssrContext) {
  __webpack_require__(634)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Author_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c373efe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Author_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(635);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2e5ebb23", content, true, {});

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.author-wrapper-big-card{display:flex;flex-direction:column;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin-bottom:10px;background:#fff;padding:16px}@media (min-width:576px){.author-wrapper-big-card{flex-direction:row}}.author-wrapper-big-card .author-img{display:flex;margin-right:10px}@media (min-width:576px){.author-wrapper-big-card .author-img{width:50%}}.author-wrapper-big-card .author-img img{width:70px;height:70px;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin-right:16px}@media (min-width:576px){.author-wrapper-big-card .author-img img{width:100px;height:100px}}.author-wrapper-big-card .author-img-content{line-height:18px;height:70px;display:flex;flex-direction:column;justify-content:space-between}@media (min-width:576px){.author-wrapper-big-card .author-img-content{height:100px}}.author-wrapper-big-card .author-img-content .span-h2{margin:0;line-height:32px}.author-wrapper-big-card .author-img-content p.mob-nam{margin:0;font-weight:700}.author-wrapper-big-card .author-img-content .span-title{color:#9b9b9b}.author-wrapper-big-card .author-img-content a{cursor:pointer}.author-wrapper-big-card .author-content{display:flex;flex-direction:column;justify-content:center}@media (min-width:576px){.author-wrapper-big-card .author-content{width:calc(50% - 10px)}}@media (max-width:576px){.author-wrapper-big-card .author-content{margin-top:16px}}.author-wrapper-big-card .author-content .span-h5,.author-wrapper-big-card .author-content p{margin:0}.author-wrapper-small-card{display:flex;flex-direction:row;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin-bottom:16px;margin-right:10px}.author-wrapper-small-card img{width:40px;height:40px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;margin-right:16px}.author-wrapper-small-card .author-img-content{line-height:18px;display:flex;flex-direction:column}.author-wrapper-small-card .author-img-content .inner-wrap{display:flex;flex-direction:row;align-items:center}.author-wrapper-small-card .author-img-content .inner-wrap a{width:auto;height:auto;margin-left:0}.author-wrapper-small-card .author-img-content .p-bold{margin:0;font-weight:700}.author-wrapper-small-card .author-img-content .span-caption{color:#9b9b9b;line-height:10px}.author-wrapper-small-card .author-img-content a{cursor:pointer;margin-left:8px;width:16px;height:16px}.author-desktop-version{display:none}@media (min-width:576px){.author-desktop-version{display:flex}}.author-mobile-version{display:flex}@media (min-width:576px){.author-mobile-version{display:none}}@media (min-width:768px){.full-card{flex-direction:column!important}.full-card-img{width:100%!important;margin-right:0!important}.full-card-content{width:100%!important;margin-top:10px!important}}", ""]);

// exports


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.authorData &&
    Object.keys(_vm.authorData).length > 0 &&
    _vm.authorData.data &&
    _vm.authorData.data.length > 0
  )?_c('section',{staticClass:"author-section"},[_c('div',{staticClass:"container"},[(
        _vm.authorData.style === 'big' &&
        !(_vm.authorData.data.filter(function (ele) { return ele.description === ''; }).length > 0)
      )?_vm._l((_vm.authorData.data),function(data,index){return _c('div',{key:'desk' + index,class:{
          'author-wrapper-big-card': true,
          'full-card': _vm.authorData.move_author_description_below,
        }},[_c('div',{class:{
            'author-img': true,
            'full-card-img': _vm.authorData.move_author_description_below,
          }},[_c('img',{attrs:{"src":data.user_avatar_url,"width":"100","height":"100","alt":_vm.getAltText('', data.user_avatar_url)}}),_vm._v(" "),_c('div',{staticClass:"author-img-content"},[_c('div',[(data.profile_data.slug === '' && data.profile_data.post_type === '')?[_c('span',{staticClass:"span-h2 author-desktop-version"},[_vm._v(_vm._s(data.display_name))]),_vm._v(" "),_c('p',{staticClass:"mob-nam author-mobile-version"},[_vm._v("\n                  "+_vm._s(data.display_name)+"\n                ")])]:[_c('a',{attrs:{"href":_vm.getRouteLink(data.profile_data.slug,data.profile_data.post_type)}},[_c('span',{staticClass:"span-h2 author-desktop-version"},[_vm._v(_vm._s(data.display_name))]),_vm._v(" "),_c('p',{staticClass:"mob-nam author-mobile-version"},[_vm._v("\n                      "+_vm._s(data.display_name)+"\n                    ")])])],_vm._v(" "),_c('span',{staticClass:"span-title"},[_vm._v(_vm._s(data.role_title))])],2),_vm._v(" "),(
                data.social_links &&
                Object.keys(data.social_links).length > 0 &&
                data.social_links.linkedin &&
                data.social_links.linkedin != ''
              )?_c('a',{attrs:{"title":data.display_name,"href":data.social_links.linkedin,"target":"_blank","rel":"no-follow"}},[_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.1354 0C1.41118 0 0 1.41114 0 3.1354V12.8651C0 14.5893 1.41114 16 3.1354 16H12.8651C14.5894 16 16 14.5894 16 12.8651V3.1354C16 1.41118 14.5894 0 12.8651 0H3.1354ZM3.924 2.64032C4.75073 2.64032 5.25996 3.18306 5.27568 3.89647C5.27568 4.59414 4.7507 5.15212 3.90801 5.15212H3.8925C3.08151 5.15212 2.55733 4.59417 2.55733 3.89647C2.55733 3.18307 3.09737 2.64032 3.92399 2.64032H3.924ZM11.0484 5.97474C12.6384 5.97474 13.8303 7.01394 13.8303 9.24714V13.4162H11.4139V9.52666C11.4139 8.54927 11.0642 7.88245 10.1898 7.88245C9.52224 7.88245 9.12434 8.3319 8.94964 8.76607C8.88582 8.9214 8.87013 9.13834 8.87013 9.35564V13.4162H6.45383C6.45383 13.4162 6.48554 6.82746 6.45383 6.14525H8.87063V7.17488C9.19173 6.67946 9.76609 5.97472 11.0484 5.97472V5.97474ZM2.69985 6.14577H5.11616V13.4162H2.69985V6.14577Z","fill":"black"}})])]):_vm._e()])]),_vm._v(" "),_c('div',{class:{
            'author-content': true,
            'full-card-content': _vm.authorData.move_author_description_below,
          }},[_c('span',{staticClass:"span-h5"},[_vm._v(_vm._s(_vm.$root.i18n.about_the_author))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(data.description))])])])}):[_c('div',{staticClass:"row"},_vm._l((_vm.authorData.data),function(data,index){return _c('div',{key:'desk' + index,staticClass:"col-lg-3"},[_c('div',{staticClass:"author-wrapper-small-card"},[_c('img',{attrs:{"src":data.user_avatar_url,"width":"100","height":"100","alt":_vm.getAltText('', data.user_avatar_url)}}),_vm._v(" "),_c('div',{staticClass:"author-img-content"},[_c('div',{staticClass:"inner-wrap"},[(data.profile_data.slug === '' && data.profile_data.post_type === '')?[_c('p',{staticClass:"p-bold"},[_vm._v("\n                    "+_vm._s(data.display_name)+"\n                ")])]:[_c('a',{attrs:{"href":_vm.getRouteLink(data.profile_data.slug,data.profile_data.post_type)}},[_c('p',{staticClass:"p-bold"},[_vm._v("\n                      "+_vm._s(data.display_name)+"\n                    ")])])],_vm._v(" "),(
                    data.social_links &&
                    Object.keys(data.social_links).length > 0 &&
                    data.social_links.linkedin &&
                    data.social_links.linkedin != ''
                  )?_c('a',{attrs:{"title":data.display_name,"href":data.social_links.linkedin,"target":"_blank","rel":"no-follow"}},[_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.1354 0C1.41118 0 0 1.41114 0 3.1354V12.8651C0 14.5893 1.41114 16 3.1354 16H12.8651C14.5894 16 16 14.5894 16 12.8651V3.1354C16 1.41118 14.5894 0 12.8651 0H3.1354ZM3.924 2.64032C4.75073 2.64032 5.25996 3.18306 5.27568 3.89647C5.27568 4.59414 4.7507 5.15212 3.90801 5.15212H3.8925C3.08151 5.15212 2.55733 4.59417 2.55733 3.89647C2.55733 3.18307 3.09737 2.64032 3.92399 2.64032H3.924ZM11.0484 5.97474C12.6384 5.97474 13.8303 7.01394 13.8303 9.24714V13.4162H11.4139V9.52666C11.4139 8.54927 11.0642 7.88245 10.1898 7.88245C9.52224 7.88245 9.12434 8.3319 8.94964 8.76607C8.88582 8.9214 8.87013 9.13834 8.87013 9.35564V13.4162H6.45383C6.45383 13.4162 6.48554 6.82746 6.45383 6.14525H8.87063V7.17488C9.19173 6.67946 9.76609 5.97472 11.0484 5.97472V5.97474ZM2.69985 6.14577H5.11616V13.4162H2.69985V6.14577Z","fill":"black"}})])]):_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"span-caption"},[_vm._v(_vm._s(data.role_title))])])])])}),0)]],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(638);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d0a0956e", content, true, {});

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.modal-wrap{width:calc(100% - 16px);z-index:11;overflow:auto;margin:0 8px;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px}.modal-wrap.is-relative{display:flex;justify-content:center}@media (min-width:768px){.modal-wrap{overflow:hidden}}@media (max-width:576px){.modal-wrap{display:flex;align-items:center}}.modal-wrap:not(.is-relative){position:absolute;height:100%;left:0;top:0;background:rgba(0,0,0,.85)}.modal-wrap:not(.is-relative) .modal-body{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}@media (max-width:768px){.modal-wrap:not(.is-relative) .modal-body{top:10px;transform:translate(-50%);width:100%}}.modal-wrap .modal-body .modal-header{position:relative;border-bottom:.5px solid #fff;padding:38px 0 8px;text-align:center;margin:0 27.5px}@media (min-width:768px){.modal-wrap .modal-body .modal-header{padding:38px 0 10px;margin:0}}.modal-wrap .modal-body .modal-header p{font-family:Helvetica;font-weight:400;font-size:14px;line-height:22px;color:#fff;margin:0}@media (min-width:768px){.modal-wrap .modal-body .modal-header p{font-size:16px;line-height:26px}}.modal-wrap .modal-body .modal-header .close-btn{background:transparent;border:0;outline:0;box-shadow:none;position:absolute;top:0;left:50%;cursor:default;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);min-width:30px}@media (min-width:768px){.modal-wrap .modal-body .modal-header .close-btn{min-width:35px}}.modal-wrap .modal-body .modal-cont{padding-top:8px;margin:0 15px}@media (min-width:768px){.modal-wrap .modal-body .modal-cont{padding-top:10px}}.modal-wrap .modal-body .modal-cont .span-h4{font-family:Helvetica;font-weight:700;font-size:16px;line-height:26px;text-align:center;color:#fff;margin-bottom:8px}@media (min-width:768px){.modal-wrap .modal-body .modal-cont .span-h4{font-size:22px;line-height:25px;margin-bottom:18px}}.modal-wrap .modal-body .modal-cont .text-right{text-align:center!important}@media (min-width:768px){.modal-wrap .modal-body .modal-cont .text-right{text-align:center!important}}.modal-wrap .modal-body .modal-cont .full-list{display:inline-block;font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;text-decoration:underline;color:#fff;margin-top:5px}.modal-wrap .modal-body .modal-cont .full-list:hover{text-decoration:none}@media (min-width:768px){.modal-wrap .modal-body .modal-cont .full-list{margin-bottom:8px;padding-top:10px}}.modal-wrap .modal-body .modal-cont .row.payment-available{display:block}@media (min-width:768px){.modal-wrap .modal-body .modal-cont .row.payment-available{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;margin-top:40px}}@media (min-width:992px){.modal-wrap .modal-body .modal-cont .row.payment-available{display:-webkit-box;display:-ms-flexbox;display:flex;justify-content:center}}.modal-wrap .modal-body .modal-cont .row.payment-available .col-sm-12{width:100%}@media (min-width:768px){.modal-wrap .modal-body .modal-cont .row.payment-available .col-sm-12{width:25%}}.paymnt-card{width:100%;min-width:100%;background:#fff;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;padding:10px;text-align:center;margin-bottom:15px}@media (min-width:768px){.paymnt-card{margin-bottom:0;min-width:158px;padding:16px}}.paymnt-card-top{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;position:relative;margin-bottom:6px}@media (min-width:420px){.paymnt-card-top{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:0}}.paymnt-card-top .pay-title{font-family:Helvetica;font-weight:700;font-size:12px;line-height:14px;text-transform:uppercase;color:#222;margin:0 0 16px;display:block;text-align:left;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}@media (min-width:420px){.paymnt-card-top .pay-title{text-align:center;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}}.paymnt-card-top .pay-title span{display:block}@media (min-width:420px){.paymnt-card-top .pay-title span{display:inline-block}}.paymnt-card-top .pay-logo{display:block;margin-bottom:6px;max-width:47px;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;margin-right:8px}@media (min-width:420px){.paymnt-card-top .pay-logo{max-width:74px;margin-bottom:20px;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;margin-right:0}}.paymnt-card-top .pay-logo img{width:100%;height:100%;object-fit:cover}.paymnt-card .cta-see-more{padding:8px;margin-top:20px;font-family:Helvetica;font-weight:700;font-size:18px;line-height:21px;background:#fe4646;border-color:#fe4646;box-shadow:0 2px 4px rgba(0,0,0,.2);display:flex;align-items:center;justify-content:center;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.paymnt-card .cta-see-more:focus,.paymnt-card .cta-see-more:hover{color:#fff}@media (min-width:420px){.paymnt-card .cta-see-more{display:flex;align-items:center;justify-content:center}}@media (min-width:768px){.paymnt-card .cta-see-more{padding:8px;margin-top:15px}}.paymnt-card .cta-see-more-past{margin-top:0}@media (min-width:768px){.paymnt-card .cta-see-more-past{margin-top:15px}}.paymnt-card.cas-card .paymnt-card-top{padding-left:53px;margin-bottom:10px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;position:relative}@media (min-width:420px){.paymnt-card.cas-card .paymnt-card-top{padding-left:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:0}}@media (min-width:768px){.paymnt-card.cas-card .paymnt-card-top{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap}}.paymnt-card.cas-card .pay-title{margin-bottom:6px;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;width:100%}@media (min-width:768px){.paymnt-card.cas-card .pay-title{margin-bottom:12px;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;width:auto}}.paymnt-card.cas-card .pay-logo{margin-bottom:0;margin-right:0;max-width:37px;height:37px;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;position:absolute;left:0;top:0}.paymnt-card.cas-card .pay-logo,.paymnt-card.cas-card .pay-logo img{-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}@media (min-width:420px){.paymnt-card.cas-card .pay-logo{position:static;margin-bottom:10px}}@media (min-width:768px){.paymnt-card.cas-card .pay-logo{margin-bottom:12px;max-width:57px;height:57px;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}}.paymnt-card.cas-card .rating-wrapper{margin-bottom:0!important;-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}@media (min-width:420px){.paymnt-card.cas-card .rating-wrapper{margin-bottom:24px}}.paymnt-card.cas-card .rating-wrapper .rating-stars{padding-right:0}.paymnt-card.cas-card .rating-wrapper .rating-star-total{line-height:1}@media (min-width:768px){.pay-soft-modal{margin:8px auto 20px!important}}.pay-soft-modal .modal-header{padding:38px 0 8px!important}.pay-soft-modal .modal-cont{padding-top:8px!important}.pay-soft-modal .modal-cont .row.payment-available{margin-top:12px!important}.pay-soft-modal .modal-cont .row.payment-available .pay-logo{margin-bottom:0!important}.pay-soft-modal .modal-cont .row.payment-available .paymnt-card-top{align-items:center!important}.pay-soft-modal .modal-cont .row.payment-available .paymnt-card-top a{margin-bottom:0!important}@media (max-width:576px){.pay-soft-modal .modal-cont .row.payment-available .paymnt-card-top a{margin-bottom:0!important;display:flex!important;align-items:center!important}}.pay-soft-modal .modal-cont .span-h4{margin-bottom:0!important}.pay-soft-modal .modal-cont .full-list{margin-top:2px!important}@media (min-width:992px){.pay-soft-modal .modal-cont .full-list{padding-top:10px!important}}.center-text{margin:150px auto!important}.center-text .modal-header{border-bottom:0!important}", ""]);

// exports


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    !_vm.$root.disable_not_supported_banner &&
    _vm.notsupportbannerData &&
    Object.keys(_vm.notsupportbannerData).length > 0
  )?_c('div',{class:{
    'modal-wrap': true,
    'is-relative': _vm.relative,
  }},[_c('div',{class:{
      'modal-body': true,
      'pay-soft-modal':
        _vm.$root.notSupportPageType === 'payment' ||
        _vm.$root.notSupportPageType === 'software',
      'center-text': !(
        _vm.notsupportbannerData.best_available_data &&
        _vm.notsupportbannerData.best_available_data.length > 0
      ),
    }},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close-btn"},[_c('svg',{attrs:{"width":"35","height":"34","viewBox":"0 0 35 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M17.5 33.9889C26.8888 33.9889 34.5 26.3828 34.5 17.0001C34.5 7.61739 26.8888 0.0112305 17.5 0.0112305C8.11116 0.0112305 0.5 7.61739 0.5 17.0001C0.5 26.3828 8.11116 33.9889 17.5 33.9889Z","fill":"#E8321D"}}),_vm._v(" "),_c('path',{attrs:{"d":"M22.8933 25.0203L25.5225 22.3911L12.1085 8.97714L9.47933 11.6063L22.8933 25.0203Z","fill":"white"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.1091 25.0236L25.5231 11.6096L22.8939 8.98047L9.47994 22.3944L12.1091 25.0236Z","fill":"white"}})]),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"34","height":"34","fill":"white","transform":"translate(0.5)"}})])])])]),_vm._v(" "),(_vm.$root.notSupportPageType === 'review')?[_c('p',[_vm._v(_vm._s(_vm.notsupportbannerData.i18n.we_are_sorry))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.notsupportbannerData.i18n.not_available_text))])]:[(_vm.notSupportWidth > 991)?[_c('p',[_vm._v("\n            "+_vm._s(_vm.notsupportbannerData.i18n.we_are_sorry)+"\n            "+_vm._s(_vm.notsupportbannerData.i18n.not_available_text)+"\n          ")])]:[_c('p',[_vm._v(_vm._s(_vm.notsupportbannerData.i18n.we_are_sorry))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.notsupportbannerData.i18n.not_available_text))])]]],2),_vm._v(" "),(
        _vm.notsupportbannerData.best_available_data &&
        _vm.notsupportbannerData.best_available_data.length > 0
      )?_c('div',{staticClass:"modal-cont"},[_c('span',{staticClass:"span-h4"},[_vm._v(_vm._s(_vm.notsupportbannerData.i18n.best_available_text))]),_vm._v(" "),_c('div',{staticClass:"row payment-available"},[(_vm.$root.notSupportPageType === 'review')?_vm._l((_vm.notSupportWidth < 576
              ? _vm.notsupportbannerData.best_available_data.slice(0, 2)
              : _vm.notsupportbannerData.best_available_data.slice(0, 4)),function(data,index){return _c('div',{key:index,staticClass:"col-lg-4"},[_c('div',{staticClass:"paymnt-card cas-card"},[_c('div',{staticClass:"paymnt-card-top"},[(_vm.$root.enable_cta_partner_logo)?[_c('a',{staticClass:"pay-logo partner-logo cas-link",attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[(
                        _vm.$root.notsupportassetSizes &&
                        _vm.$root.notsupportassetSizes.pro_asset_sizes
                      )?_c('img',{staticClass:"partner-logo-castop-img pimg",attrs:{"src":data.product_assets.filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.$root.notsupportassetSizes.pro_asset_sizes.medium; }
                        ).length > 0
                          ? data.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.$root.notsupportassetSizes.pro_asset_sizes
                                    .medium; }
                              )
                              .shift().url
                          : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"height":"70","width":"70","alt":_vm.getAltText(
                          data.product_name,
                          data.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.$root.notsupportassetSizes.pro_asset_sizes
                                .medium; }
                          ).length > 0
                            ? data.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.$root.notsupportassetSizes.pro_asset_sizes
                                      .medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/failure.png'
                        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-notsup"},[_c('div',{staticClass:"partner-hover-inner",style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])])]:[_c('div',{staticClass:"pay-logo"},[(
                        _vm.$root.notsupportassetSizes &&
                        _vm.$root.notsupportassetSizes.pro_asset_sizes
                      )?_c('img',{staticClass:"partner-logo-castop-img pimg",attrs:{"src":data.product_assets.filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.$root.notsupportassetSizes.pro_asset_sizes.medium; }
                        ).length > 0
                          ? data.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.$root.notsupportassetSizes.pro_asset_sizes
                                    .medium; }
                              )
                              .shift().url
                          : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"height":"70","width":"70","alt":_vm.getAltText(
                          data.product_name,
                          data.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.$root.notsupportassetSizes.pro_asset_sizes
                                .medium; }
                          ).length > 0
                            ? data.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.$root.notsupportassetSizes.pro_asset_sizes
                                      .medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/failure.png'
                        )}}):_vm._e()])],_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(data.review_link)?_c('a',{staticClass:"\n                      pay-title\n                      custom-font-1\n                      text-underline text-hover\n                      review-title\n                    ",attrs:{"title":data.product_name,"href":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                        _vm.$root.i18n.review,
                        data.product_name
                      )))]):_c('span',{staticClass:"pay-title custom-font-1 review-title"},[_vm._v(_vm._s(data.product_name))])]:[(data.review_link)?_c('router-link',{staticClass:"\n                      pay-title\n                      custom-font-1\n                      text-underline text-hover\n                      review-title\n                    ",attrs:{"title":data.product_name,"to":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                        _vm.$root.i18n.review,
                        data.product_name
                      )))]):_c('span',{staticClass:"pay-title custom-font-1 review-title"},[_vm._v(_vm._s(data.product_name))])],_vm._v(" "),_c('StarRating',{attrs:{"rating":parseFloat((data.rating / 2).toFixed(1))}})],2),_vm._v(" "),(data.go_link)?_c('a',{class:{
                  'cta cta-primary cta-promotion custom-btn game-btn cta-large hover-btn btn-e cas-link cta-see-more': true,
                  'text-white': !_vm.getContrastYIQ(
                    _vm.$root.color_schema.primary_btn
                  ),
                  'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-cta-override': _vm.$root.override_ctabtntxt_color,
                },style:({
                  '--primary-btn': _vm.$root.color_schema.primary_btn,
                  '--primary-btn-hover': _vm.pSBC(
                    -0.2,
                    _vm.$root.color_schema.primary_btn
                  ),
                }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(data.cta_button_text))]),_vm._v(" "),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "toplipp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()])])}):_vm._e(),_vm._v(" "),(_vm.$root.notSupportPageType === 'payment')?_vm._l((_vm.notSupportWidth < 576
              ? _vm.notsupportbannerData.best_available_data
                  .filter(function (ele) { return ele.link != null; })
                  .slice(0, 2)
              : _vm.notsupportbannerData.best_available_data
                  .filter(function (ele) { return ele.link != null; })
                  .slice(0, 4)),function(data,index){return _c('div',{key:index,staticClass:"col-lg-4"},[_c('div',{staticClass:"paymnt-card"},[_c('div',{staticClass:"paymnt-card-top"},[(_vm.$root.enable_piwik_reload)?[(data)?_c('a',{staticClass:"pay-title payment-title text-hover",attrs:{"title":data.name,"href":_vm.getRouteLink(data.link, _vm.$root.notSupportType)}},[_vm._v("\n                    "+_vm._s(_vm.getBPMGlobalString(
                        !data.remove_cascount &&
                          data.hasOwnProperty("toplist_count")
                          ? data.toplist_count
                          : "",
                        _vm.$root.i18n.casinos_are_supporting,
                        data.name
                      )))]):_vm._e()]:[(data)?_c('router-link',{staticClass:"pay-title payment-title text-hover",attrs:{"title":data.name,"to":_vm.getRouteLink(data.link, _vm.$root.notSupportType)}},[_vm._v("\n                    "+_vm._s(_vm.getBPMGlobalString(
                        !data.remove_cascount &&
                          data.hasOwnProperty("toplist_count")
                          ? data.toplist_count
                          : "",
                        _vm.$root.i18n.casinos_are_supporting,
                        data.name
                      )))]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"pay-logo"},[(
                      _vm.$root.enable_lazyload &&
                      data &&
                      _vm.$root.notsupportassetSizes.pao_asset_sizes &&
                      data.asset_category_name ===
                        _vm.$root.notsupportassetSizes.pao_asset_sizes.medium
                    )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url),"width":"105","height":"105"}}):(
                      data &&
                      _vm.$root.notsupportassetSizes.pao_asset_sizes &&
                      data.asset_category_name ===
                        _vm.$root.notsupportassetSizes.pao_asset_sizes.medium
                    )?_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url),"width":"105","height":"105"}}):_vm._e()])],2),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(data)?_c('a',{staticClass:"\n                    cta cta-primary cta-block cta-promotion\n                    custom-btn\n                    hover-btn\n                    cta-see-more cta-see-more-past\n                  ",style:({
                    '--primary-btn': _vm.$root.color_schema.primary_btn,
                    '--primary-btn-hover': _vm.pSBC(
                      -0.2,
                      _vm.$root.color_schema.primary_btn
                    ),
                  }),attrs:{"title":data.name,"href":_vm.getRouteLink(data.link, _vm.$root.notSupportType)}},[_vm._v(_vm._s(_vm.$root.i18n.see_more))]):_vm._e()]:[(data)?_c('router-link',{staticClass:"\n                    cta cta-primary cta-block cta-promotion\n                    custom-btn\n                    hover-btn\n                    cta-see-more cta-see-more-past\n                  ",style:({
                    '--primary-btn': _vm.$root.color_schema.primary_btn,
                    '--primary-btn-hover': _vm.pSBC(
                      -0.2,
                      _vm.$root.color_schema.primary_btn
                    ),
                  }),attrs:{"title":data.name,"to":_vm.getRouteLink(data.link, _vm.$root.notSupportType)}},[_vm._v(_vm._s(_vm.$root.i18n.see_more))]):_vm._e()]],2)])}):_vm._e(),_vm._v(" "),(_vm.$root.notSupportPageType === 'software')?_vm._l((_vm.notSupportWidth < 576
              ? _vm.notsupportbannerData.best_available_data
                  .filter(function (ele) { return ele.swr_review_link != null; })
                  .slice(0, 2)
              : _vm.notsupportbannerData.best_available_data
                  .filter(function (ele) { return ele.swr_review_link != null; })
                  .slice(0, 4)),function(data,index){return _c('div',{key:index,staticClass:"col-lg-4"},[_c('div',{staticClass:"paymnt-card"},[_c('div',{staticClass:"paymnt-card-top"},[(_vm.$root.enable_piwik_reload)?[(data)?_c('a',{staticClass:"pay-title software-title text-hover",attrs:{"title":data.name,"href":_vm.getRouteLink(data.swr_review_link, _vm.$root.notSupportType)}},[_vm._v("\n                    "+_vm._s(_vm.getBPMGlobalString(
                        !data.remove_cascount &&
                          data.hasOwnProperty("toplist_count")
                          ? data.toplist_count
                          : "",
                        _vm.$root.i18n.casinos_are_supporting,
                        data.sw_name
                      )))]):_vm._e()]:[(data)?_c('router-link',{staticClass:"pay-title software-title text-hover",attrs:{"title":data.name,"to":_vm.getRouteLink(data.swr_review_link, _vm.$root.notSupportType)}},[_vm._v("\n                    "+_vm._s(_vm.getBPMGlobalString(
                        !data.remove_cascount &&
                          data.hasOwnProperty("toplist_count")
                          ? data.toplist_count
                          : "",
                        _vm.$root.i18n.casinos_are_supporting,
                        data.sw_name
                      )))]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"pay-logo"},[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.swa_url),expression:"data.swa_url"}],attrs:{"alt":_vm.getAltText(data.sw_name, data.swa_url),"width":"105","height":"105"}}):_c('img',{attrs:{"src":data.swa_url,"alt":_vm.getAltText(data.sw_name, data.swa_url),"width":"105","height":"105"}})])],2),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(data)?_c('a',{staticClass:"\n                    cta cta-primary cta-block cta-promotion\n                    custom-btn\n                    hover-btn\n                    cta-see-more cta-see-more-past\n                  ",style:({
                    '--primary-btn': _vm.$root.color_schema.primary_btn,
                    '--primary-btn-hover': _vm.pSBC(
                      -0.2,
                      _vm.$root.color_schema.primary_btn
                    ),
                  }),attrs:{"title":data.sw_name,"href":_vm.getRouteLink(data.swr_review_link, _vm.$root.notSupportType)}},[_vm._v(_vm._s(_vm.$root.i18n.see_more))]):_vm._e()]:[(data)?_c('router-link',{staticClass:"\n                    cta cta-primary cta-block cta-promotion\n                    custom-btn\n                    hover-btn\n                    cta-see-more cta-see-more-past\n                  ",style:({
                    '--primary-btn': _vm.$root.color_schema.primary_btn,
                    '--primary-btn-hover': _vm.pSBC(
                      -0.2,
                      _vm.$root.color_schema.primary_btn
                    ),
                  }),attrs:{"title":data.sw_name,"to":_vm.getRouteLink(data.swr_review_link, _vm.$root.notSupportType)}},[_vm._v(_vm._s(_vm.$root.i18n.see_more))]):_vm._e()]],2)])}):_vm._e()],2),_vm._v(" "),(
          _vm.notsupportbannerData.full_list_link &&
          _vm.notsupportbannerData.full_list_link != ''
        )?_c('div',{staticClass:"text-right"},[_c('a',{staticClass:"full-list",attrs:{"title":_vm.$root.i18n.full_list,"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"href":_vm.notsupportbannerData.full_list_link}},[_vm._v(_vm._s(_vm.$root.i18n.full_list))])]):_vm._e()]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(641);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1c2194f0", content, true, {});

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-022e2682]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-022e2682]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-022e2682]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-022e2682]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-022e2682]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-022e2682]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-022e2682]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-022e2682]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-022e2682]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-022e2682]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-022e2682]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-022e2682]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.page-not-found[data-v-022e2682]{display:block;min-height:100%;position:relative;overflow:hidden}.page-not-found[data-v-022e2682]:after{content:\"\";position:absolute;top:0;right:-422px;height:100%;width:838px;background:hsla(180,4%,95%,.1);transform:skewX(-31deg);-ms-transform:skewX(-31deg);opacity:0}@media (min-width:1024px){.page-not-found[data-v-022e2682]:after{opacity:1}}.error-wrapper[data-v-022e2682]{display:flex;flex-wrap:wrap-reverse;justify-content:space-between}.error-wrapper .error-text[data-v-022e2682]{width:100%;padding-top:45px;text-align:center}.error-wrapper .error-text .span-header[data-v-022e2682]{display:block;font-weight:900;font-size:40px;line-height:49px;color:inherit}@media (min-width:576px){.error-wrapper .error-text .span-header[data-v-022e2682]{font-size:120px;line-height:146px}}.error-wrapper .error-text .span-paragraph[data-v-022e2682]{display:block;font-weight:400;font-size:14px;line-height:119.97%;color:inherit}@media (min-width:576px){.error-wrapper .error-text .span-paragraph[data-v-022e2682]{font-size:24px}}.error-wrapper .error-text .button-wrap[data-v-022e2682]{margin-top:32px}.error-wrapper .error-text .button-wrap .back-button[data-v-022e2682]{width:80%;font-weight:700;font-size:14px;line-height:152%;border:3px solid;box-sizing:border-box;border-radius:100px;height:58px;color:inherit;padding:16px;display:inline-block;text-align:center}@media (min-width:576px){.error-wrapper .error-text .button-wrap .back-button[data-v-022e2682]{font-size:18px;line-height:22px}}@media (min-width:1024px){.error-wrapper .error-text .button-wrap .back-button[data-v-022e2682]{width:372px}}@media (min-width:1024px){.error-wrapper .error-text[data-v-022e2682]{width:50%;text-align:left}}.error-wrapper .error-img[data-v-022e2682]{padding-top:42px;width:100%;text-align:center}.error-wrapper .error-img img[data-v-022e2682]{width:180px}@media (min-width:576px){.error-wrapper .error-img img[data-v-022e2682]{width:438px}}@media (min-width:1024px){.error-wrapper .error-img[data-v-022e2682]{width:438px}}@media (min-width:1024px){.error-wrapper[data-v-022e2682]{flex-wrap:wrap;padding:0}}.content-wrapper[data-v-022e2682]{padding-top:25px}.mar-2[data-v-022e2682]{margin-left:2px}.play-card[data-v-022e2682]{box-shadow:0 4px 4px rgba(0,0,0,.25);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;background:#fff;padding:10px 15px 13px;border:2px solid transparent;min-width:280px}@media (min-width:1200px){.play-card[data-v-022e2682]{padding:15px}}.play-card.top-choice[data-v-022e2682]{border-color:#ffd039}.play-card-top[data-v-022e2682]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start}.play-card-top-img[data-v-022e2682]{min-width:68px;max-width:68px;height:68px}@media (min-width:992px){.play-card-top-img[data-v-022e2682]{min-width:72px;max-width:72px;height:72px}}.play-card-top-img img[data-v-022e2682]{width:100%;height:100%;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;object-fit:cover}.play-card-top-right[data-v-022e2682]{padding:0 8px;white-space:normal;min-height:100px}@media (min-width:1200px){.play-card-top-right[data-v-022e2682]{padding:0 16px}}.play-card-top-right h5[data-v-022e2682]{margin:0 0 5px;color:#222}.play-card-top-right .rating-wrapper[data-v-022e2682]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.play-card .cta[data-v-022e2682]{margin-top:0;padding:17px 18px;font-size:18px;line-height:100%}@media (min-width:1200px){.play-card .cta[data-v-022e2682]{padding:17px 18px;font-size:18px;line-height:100%}}.play-card .cta[data-v-022e2682]:hover{background:#9a2b28;border-color:#9a2b28;color:#fff;box-shadow:none;-webkit-box-shadow:none}.play-card .read-review[data-v-022e2682]{display:block;white-space:break-spaces;font-weight:400;font-size:14px;line-height:150%;color:#9b9b9b!important;margin:0 auto;text-decoration:underline;width:240px;margin-top:10px;text-align:center}@media (min-width:1080px){.play-card .read-review[data-v-022e2682]{width:350px}}.stripe[data-v-022e2682]{position:absolute;left:0;width:100%;height:18px;bottom:0;overflow:hidden;display:flex;justify-content:center;align-items:center;background-color:#ffd039;border-bottom-left-radius:7px;border-bottom-right-radius:7px}.stripe-text[data-v-022e2682]{display:flex;justify-content:center;align-items:center;font-weight:600;font-size:10px;line-height:100%}.stripe img[data-v-022e2682]{width:18px!important;height:14px!important;margin:3px auto;object-fit:contain!important}@media (max-width:576px){.stripe[data-v-022e2682]{position:relative;top:-17px}}.mw-300[data-v-022e2682]{min-width:300px}@media (min-width:992px){.mw-300[data-v-022e2682]{min-width:auto}}.mobile-container[data-v-022e2682]{padding-bottom:25px}.mobile-container .span-h1[data-v-022e2682]{color:var(--primary-color)}.terms_tc[data-v-022e2682]{text-decoration:underline;color:#080438;font-size:12px}.span-h5[data-v-022e2682]{line-height:21px!important;margin:0!important}.term-recas[data-v-022e2682]{border-bottom-left-radius:0;border-bottom-right-radius:0}.cas-terms[data-v-022e2682]{background:#dfe1e3;display:flex;padding:5px 15px;margin:0;width:100%;font-weight:400;color:#222;min-height:33px;border-bottom-left-radius:12px;border-bottom-right-radius:12px;line-height:15px;font-size:.75rem;white-space:pre-wrap;min-width:254px;align-items:center;box-shadow:0 3px 4px rgba(0,0,0,.25)}.cas-terms span[data-v-022e2682]{margin:auto 0}@media (min-width:768px){.cas-terms[data-v-022e2682]{line-height:18px;font-size:.75rem}}.cas-terms a[data-v-022e2682]{cursor:pointer;text-decoration:underline!important}.cas-terms a[data-v-022e2682]:hover{color:var(--primary-btn)}.rm-bottom-color[data-v-022e2682]{border-bottom-color:transparent!important}.terms-top-choice[data-v-022e2682]{border:2px solid #ffd039;border-top-color:transparent;box-shadow:0 2px 3px rgba(0,0,0,.25)}.cut-span[data-v-022e2682]{color:inherit}.emt-sp[data-v-022e2682]{display:block;margin-top:6px}.pos-relative[data-v-022e2682]{position:relative}", ""]);

// exports


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-not-found"},[_c('div',{style:({
      background: ("url('" + (_vm.page404Data.bg_image) + "') repeat," + (_vm.$root.color_schema.primary)),
    })},[_c('div',{class:{
        'container error-wrapper': true,
        'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
        'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
      }},[_c('div',{staticClass:"error-text"},[_c('h1',{staticClass:"span-header"},[_vm._v(_vm._s(_vm.page404Data.title))]),_vm._v(" "),_c('h2',{staticClass:"span-paragraph"},[_vm._v(_vm._s(_vm.page404Data.description))]),_vm._v(" "),_c('div',{staticClass:"button-wrap"},[_c('a',{staticClass:"back-button",attrs:{"title":_vm.$root.i18n.take_me_to_the_homepage,"href":_vm.page404Data.redirect_url}},[_vm._v(_vm._s(_vm.$root.i18n.take_me_to_the_homepage))])])]),_vm._v(" "),(_vm.page404Data.image)?_c('div',{staticClass:"error-img"},[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.page404Data.image),expression:"page404Data.image"}],attrs:{"width":"438","height":"411","alt":"Error-img"}}):_c('img',{attrs:{"src":_vm.page404Data.image,"width":"438","height":"411","alt":"Error-img"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"container content-wrapper mobile-scroll-container"},[_vm._l((_vm.page404DataBlocks),function(data,index){return [(
            data.blockName === 'wpvcb/casino-toplist' &&
            data.attrs &&
            data.attrs.style === 'gamepage_top_3' &&
            data.filtered_content &&
            data.filtered_content.length > 0)?[_c('div',{key:((data.blockName) + "-" + index),staticClass:"mobile-container"},[(!_vm.hideToplistLabelGB && _vm.gamesTop3.length > 0)?_vm._l((_vm.gamesTop3),function(val,index){return _c('div',{key:index},[_c('span',{class:{
                    'span-h2 cut-span custom-font-1': true,
                    'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
                    'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
                  }},[_vm._v(_vm._s(_vm.gamesTop3Title[index]))]),_vm._v(" "),_c('div',{staticClass:"mobile-scroller"},[_c('div',{staticClass:"row wd-auto"},_vm._l((val),function(data,index){return _c('div',{key:index,staticClass:"col-md-4 col-sm-4 mw-300"},[_c('div',{class:{
                          'play-card': true,
                          'term-recas':
                            (data.bonus_tc && data.bonus_tc != '') ||
                            (data.terms && data.terms != ''),
                          'top-choice': index === 0,
                          'rm-bottom-color':
                            index === 0 &&
                            ((data.bonus_tc && data.bonus_tc != '') ||
                              (data.terms && data.terms != '')),
                        }},[_c('div',{staticClass:"play-card-top"},[_c('div',{staticClass:"play-card-top-img pos-relative"},[_c('a',{staticClass:"partner-logo cas-link",attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"rel":_vm.$root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow',"target":"_blank"}},[(
                                  _vm.$root.enable_lazyload &&
                                  _vm.assets_images &&
                                  _vm.assets_images.pro_asset_sizes
                                )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                                  data.product_assets.filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  ).length > 0
                                    ? data.product_assets.filter(
                                        function (ele) { return ele.asset_category_name ===
                                          _vm.assets_images.pro_asset_sizes.medium; }
                                      )[0].url
                                    : ''
                                ),expression:"\n                                  data.product_assets.filter(\n                                    (ele) =>\n                                      ele.asset_category_name ===\n                                      assets_images.pro_asset_sizes.medium\n                                  ).length > 0\n                                    ? data.product_assets.filter(\n                                        (ele) =>\n                                          ele.asset_category_name ===\n                                          assets_images.pro_asset_sizes.medium\n                                      )[0].url\n                                    : ''\n                                "}],attrs:{"width":"72","height":"72","alt":_vm.getAltText(
                                    data.product_name,
                                    data.product_assets.filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    ).length > 0
                                      ? data.product_assets.filter(
                                          function (ele) { return ele.asset_category_name ===
                                            _vm.assets_images.pro_asset_sizes
                                              .medium; }
                                        )[0].url
                                      : ''
                                  )}}):(
                                  _vm.assets_images &&
                                  _vm.assets_images.pro_asset_sizes
                                )?_c('img',{attrs:{"src":data.product_assets.filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  ).length > 0
                                    ? data.product_assets.filter(
                                        function (ele) { return ele.asset_category_name ===
                                          _vm.assets_images.pro_asset_sizes.medium; }
                                      )[0].url
                                    : _vm.$root.site_url +
                                      _vm.$root.asset_path +
                                      '/failure.png',"width":"72","height":"72","alt":_vm.getAltText(
                                    data.product_name,
                                    data.product_assets.filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    ).length > 0
                                      ? data.product_assets.filter(
                                          function (ele) { return ele.asset_category_name ===
                                            _vm.assets_images.pro_asset_sizes
                                              .medium; }
                                        )[0].url
                                      : _vm.$root.site_url +
                                          _vm.$root.asset_path +
                                          '/failure.png'
                                  )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-recm"},[_c('div',{staticClass:"partner-hover-inner",style:({
                                    '--primary-btn':
                                      _vm.$root.color_schema.primary_btn,
                                    '--primary-btn-hover': _vm.pSBC(
                                      -0.2,
                                      _vm.$root.color_schema.primary_btn
                                    ),
                                  })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                                  Object.keys(_vm.hasTag(data.tags)).length > 0
                                )?_c('div',{class:{
                                  'stripe text-center': true,
                                  'font-dark': _vm.getContrastYIQ(
                                    Object.keys(_vm.hasTag(data.tags)).length > 0
                                      ? _vm.hasTag(data.tags).color
                                      : null
                                  ),
                                  'font-light': !_vm.getContrastYIQ(
                                    Object.keys(_vm.hasTag(data.tags)).length > 0
                                      ? _vm.hasTag(data.tags).color
                                      : null
                                  ),
                                },style:({
                                  backgroundColor:
                                    Object.keys(_vm.hasTag(data.tags)).length > 0
                                      ? _vm.hasTag(data.tags).color
                                      : null,
                                })},[_c('img',{attrs:{"src":_vm.hasTag(data.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"play-card-top-right gamefree-casino-404"},[_c('span',{staticClass:"span-h5 custom-font-1"},[(_vm.hideBonusLabelGB)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[_c('a',{staticClass:"bonus-link custom-font-1 cas-link",style:({
                                    '--color-hover':
                                      _vm.$root.color_schema.primary_btn,
                                  }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                      ? 'nofollow sponsored'
                                      : 'nofollow'}},[(
                                      data.bonus_match &&
                                      data.exclusive_bonus_amount &&
                                      data.exclusive_bonus_match
                                    )?_c('span',[_vm._v(_vm._s(data.exclusive_bonus_match)+"%\n                                    "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                                    "+_vm._s(_vm._f("currency")(data.exclusive_bonus_amount,data.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                                      data.bonus_match &&
                                      !data.exclusive_bonus_amount &&
                                      data.bonus_amount
                                    )?_c('span',[_vm._v(_vm._s(data.bonus_match)+"%\n                                    "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                                    "+_vm._s(_vm._f("currency")(data.bonus_amount,data.bonus_currency)))]):_vm._e(),_vm._v(" "),(data.freespin || data.freebie_name)?_c('span',[(
                                        (data.exclusive_bonus_amount ||
                                          data.bonus_amount) &&
                                        data.bonus_match
                                      )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(
                                        data.show_freebie_currency === '1'
                                      )?[_vm._v(_vm._s(_vm._f("currency")(data.freespin,data.bonus_currency)))]:[_vm._v(_vm._s(data.freespin))],_vm._v("\n                                    "+_vm._s(data.freebie_name)+"\n                                  ")],2):_vm._e()])]],2),_vm._v(" "),_c('div',{staticClass:"row mar-2"},[_c('StarRating',{attrs:{"rating":parseFloat((data.rating / 2).toFixed(1))}})],1)])]),_vm._v(" "),_c('a',{class:{
                            'cta cta-primary cta-promotion cta-block custom-btn hover-btn cas-link': true,
                            'text-white':
                              !_vm.$root.override_ctabtntxt_color &&
                              !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                            'text-gray':
                              !_vm.$root.override_ctabtntxt_color &&
                              _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                            'text-cta-override':
                              _vm.$root.override_ctabtntxt_color,
                          },style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[(index === 0)?_c('img',{attrs:{"src":_vm.crownIcon,"height":"16","width":"24","alt":"Crown"}}):_vm._e(),_vm._v(_vm._s(data.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "dfpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(data.review_link)?_c('a',{staticClass:"read-review",attrs:{"title":data.product_name,"href":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                                _vm.$root.i18n.partner_name_review,
                                data.product_name
                              )))]):_c('span',{staticClass:"emt-sp"},[_vm._v(" ")])]:[(data.review_link)?_c('router-link',{staticClass:"read-review",attrs:{"title":data.product_name,"to":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                                _vm.$root.i18n.partner_name_review,
                                data.product_name
                              )))]):_c('span',{staticClass:"emt-sp"},[_vm._v(" ")])]],2),_vm._v(" "),(
                          (data.bonus_tc && data.bonus_tc != '') ||
                          (data.terms && data.terms != '')
                        )?_c('div',{class:{
                          'cas-terms terms-404': true,
                          'terms-top-choice':
                            index === 0 &&
                            ((data.bonus_tc && data.bonus_tc != '') ||
                              (data.terms && data.terms != '')),
                        }},[(data.bonus_tc && data.bonus_tc != '')?_c('span',{staticClass:"cas-term",staticStyle:{"text-align":"center"},style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                          }),domProps:{"innerHTML":_vm._s(data.bonus_tc.trim())}}):_vm._e(),_vm._v(" "),(
                            data.bonus_tc &&
                            data.terms &&
                            data.bonus_tc != '' &&
                            data.terms != ''
                          )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(data.terms && data.terms != '')?_c('a',{staticClass:"cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"title":data.product_name,"href":_vm.getGoLink(data.term_link, data.slug),"target":"_blank"}},[_vm._v(_vm._s(data.terms))]):_vm._e()]):_vm._e()])}),0)])])}):_c('div',{staticClass:"text-center pt-10 span-no-text"},[_vm._v("\n              "+_vm._s(_vm.$root.i18n.no_toplist_available_intime)+"\n            ")])],2)]:[_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index,"pageValue":"404","scheme":_vm.getContrastYIQ(_vm.$root.color_schema.primary) ? 'light' : 'dark'}})]]})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):_c('main',{staticClass:"main-content-area"},[(
      !_vm.$root.disableNotSupportBanner &&
      _vm.pageData &&
      _vm.pageData.product_information
    )?_c('div',{staticClass:"sticky-review-card",attrs:{"id":"review-sticky-card"}},[_c('div',{staticClass:"sticky-inner",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn })},[(
          _vm.pageData &&
          _vm.pageData.product_id &&
          _vm.pageData.product_information &&
          _vm.pageData.product_information.product_assets.length > 0
        )?_c('a',{staticClass:"affliate-logo stick-img partner-logo cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
            _vm.pageData.product_information.go_link,
            _vm.pageData.product_information.slug
          ),"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"target":"_blank"}},[(_vm.assets_images && _vm.assets_images.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
              _vm.pageData.product_information.product_assets.filter(
                function (ele) { return ele.asset_category_name ===
                  _vm.assets_images.pro_asset_sizes.large; }
              ).length > 0
                ? _vm.pageData.product_information.product_assets
                    .filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assets_images.pro_asset_sizes.large; }
                    )
                    .shift().url
                : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
            ),expression:"\n              pageData.product_information.product_assets.filter(\n                (ele) =>\n                  ele.asset_category_name ===\n                  assets_images.pro_asset_sizes.large\n              ).length > 0\n                ? pageData.product_information.product_assets\n                    .filter(\n                      (ele) =>\n                        ele.asset_category_name ===\n                        assets_images.pro_asset_sizes.large\n                    )\n                    .shift().url\n                : $root.site_url + $root.asset_path + '/failure.png'\n            "}],attrs:{"height":"85","width":"85","alt":_vm.getAltText(
                _vm.pageData.product_information.name,
                _vm.pageData.product_information.product_assets.filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assets_images.pro_asset_sizes.large; }
                ).length > 0
                  ? _vm.pageData.product_information.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      )
                      .shift().url
                  : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
              )}}):_c('img',{attrs:{"src":_vm.pageData.product_information.product_assets.filter(
                function (ele) { return ele.asset_category_name ===
                  _vm.assets_images.pro_asset_sizes.large; }
              ).length > 0
                ? _vm.pageData.product_information.product_assets
                    .filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assets_images.pro_asset_sizes.large; }
                    )
                    .shift().url
                : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"height":"85","width":"85","alt":_vm.getAltText(
                _vm.pageData.product_information.name,
                _vm.pageData.product_information.product_assets.filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assets_images.pro_asset_sizes.large; }
                ).length > 0
                  ? _vm.pageData.product_information.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      )
                      .shift().url
                  : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
              )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-stic"},[_c('div',{staticClass:"partner-hover-inner",style:({
                '--primary-btn': _vm.$root.color_schema.primary_btn,
                '--primary-btn-hover': _vm.pSBC(
                  -0.2,
                  _vm.$root.color_schema.primary_btn
                ),
              })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
              Object.keys(_vm.hasTag(_vm.pageData.product_information.tags)).length >
              0
            )?_c('div',{class:{
              'stripe-sticky': true,
              'font-dark': _vm.getContrastYIQ(
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null
              ),
              'font-light': !_vm.getContrastYIQ(
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null
              ),
            },style:({
              backgroundColor:
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null,
            })},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"md-rating rating-wrapper-small"},[_c('div',{staticClass:"radio-stars"},[_c('img',{attrs:{"src":_vm.$root.site_url +
                _vm.$root.asset_path +
                '/svg-icons/yellow-star-big.svg',"alt":"Full Big Star"}})]),_vm._v(" "),_c('div',{staticClass:"radio-star-total"},[_c('span',[_vm._v(_vm._s(parseFloat((_vm.pageData.product_information.rating / 2).toFixed(1))))]),_vm._v("/5\n          ")])])],2):_c('div',{staticClass:"partner-logo affliate-logo"},[(
            _vm.assets_images &&
            _vm.assets_images.pro_asset_sizes &&
            _vm.pageData.product_information &&
            _vm.pageData.product_information.product_assets.length > 0
          )?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
              _vm.pageData.product_information.product_assets
                .filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assets_images.pro_asset_sizes.large; }
                )
                .shift().url
            ),expression:"\n              pageData.product_information.product_assets\n                .filter(\n                  (ele) =>\n                    ele.asset_category_name ===\n                    assets_images.pro_asset_sizes.large\n                )\n                .shift().url\n            "}],attrs:{"height":"85","width":"85","alt":_vm.getAltText(
                _vm.pageData.product_information.name,
                _vm.pageData.product_information.product_assets
                  .filter(
                    function (ele) { return ele.asset_category_name ===
                      _vm.assets_images.pro_asset_sizes.large; }
                  )
                  .shift().url
              )}}):_c('img',{attrs:{"src":_vm.pageData.product_information.product_assets
                .filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assets_images.pro_asset_sizes.large; }
                )
                .shift().url,"height":"85","width":"85","alt":_vm.getAltText(
                _vm.pageData.product_information.name,
                _vm.pageData.product_information.product_assets
                  .filter(
                    function (ele) { return ele.asset_category_name ===
                      _vm.assets_images.pro_asset_sizes.large; }
                  )
                  .shift().url
              )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-stic"},[_c('div',{staticClass:"partner-hover-inner",style:({
                '--primary-btn': _vm.$root.color_schema.primary_btn,
                '--primary-btn-hover': _vm.pSBC(
                  -0.2,
                  _vm.$root.color_schema.primary_btn
                ),
              })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
              Object.keys(_vm.hasTag(_vm.pageData.product_information.tags)).length >
              0
            )?_c('div',{class:{
              'stripe-sticky': true,
              'font-dark': _vm.getContrastYIQ(
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null
              ),
              'font-light': !_vm.getContrastYIQ(
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null
              ),
            },style:({
              backgroundColor:
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null,
            })},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"md-rating rating-wrapper-small"},[_c('div',{staticClass:"radio-stars"},[_c('img',{attrs:{"src":_vm.$root.site_url +
                _vm.$root.asset_path +
                '/svg-icons/yellow-star-big.svg',"alt":"Full Big Star"}})]),_vm._v(" "),_c('div',{staticClass:"radio-star-total"},[_c('span',[_vm._v(_vm._s(parseFloat((_vm.pageData.product_information.rating / 2).toFixed(1))))]),_vm._v("/5\n          ")])])],2),_vm._v(" "),_c('span',{staticClass:"sticky-text"},[_c('span',{staticClass:"product-name"},[_vm._v(_vm._s(_vm.pageData.product_information.name)+"\n          "),(
              _vm.pageData.product_information &&
              _vm.pageData.product_information.rating
            )?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat(
                  (
                    _vm.pageData.product_information &&
                    _vm.pageData.product_information.rating / 2
                  ).toFixed(1)
                ),"noText":""}})],1):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"sticky-title"},[_vm._v("\n          "+_vm._s(_vm.getPartnerGlobalString(
              _vm.$root.i18n.review,
              _vm.pageData.product_information.name
            ))+"\n          "),_c('StarRating',{attrs:{"rating":parseFloat(
                (
                  _vm.pageData.product_information &&
                  _vm.pageData.product_information.rating / 2
                ).toFixed(1)
              ),"classParam":'rev-star'}})],1),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('span',{staticClass:"bonus-text"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(!_vm.$root.disable_bonus_cta_on_review)?[(
                  _vm.pageData.product_information.bonus_match &&
                  _vm.pageData.product_information.exclusive_bonus_amount &&
                  _vm.pageData.product_information.exclusive_bonus_match
                )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                    _vm.pageData.product_information.go_link,
                    _vm.pageData.product_information.slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.exclusive_bonus_match)+"%\n                "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.exclusive_bonus_amount,_vm.pageData.product_information.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                  _vm.pageData.product_information.bonus_match &&
                  !_vm.pageData.product_information.exclusive_bonus_amount &&
                  _vm.pageData.product_information.bonus_amount
                )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                    _vm.pageData.product_information.go_link,
                    _vm.pageData.product_information.slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,_vm.pageData.product_information.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                  _vm.pageData.product_information.freespin ||
                  _vm.pageData.product_information.freebie_name
                )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                    _vm.pageData.product_information.go_link,
                    _vm.pageData.product_information.slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[(
                    (_vm.pageData.product_information.exclusive_bonus_amount ||
                      _vm.pageData.product_information.bonus_amount) &&
                    _vm.pageData.product_information.bonus_match
                  )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,_vm.pageData.product_information.bonus_currency)))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                  "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]],2):_vm._e()]:[(
                  _vm.pageData.product_information.bonus_match &&
                  _vm.pageData.product_information.exclusive_bonus_amount &&
                  _vm.pageData.product_information.exclusive_bonus_match
                )?[_vm._v(_vm._s(_vm.pageData.product_information.exclusive_bonus_match)+"%\n                "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.exclusive_bonus_amount,_vm.pageData.product_information.bonus_currency)))]:_vm._e(),_vm._v(" "),(
                  _vm.pageData.product_information.bonus_match &&
                  !_vm.pageData.product_information.exclusive_bonus_amount &&
                  _vm.pageData.product_information.bonus_amount
                )?[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,_vm.pageData.product_information.bonus_currency)))]:_vm._e(),_vm._v(" "),(
                  _vm.pageData.product_information.freespin ||
                  _vm.pageData.product_information.freebie_name
                )?[(
                    (_vm.pageData.product_information.exclusive_bonus_amount ||
                      _vm.pageData.product_information.bonus_amount) &&
                    _vm.pageData.product_information.bonus_match
                  )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,_vm.pageData.product_information.bonus_currency)))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                  "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]]:_vm._e()]]],2):_vm._e(),_vm._v(" "),(
            (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
            (_vm.pageData.terms && _vm.pageData.terms != '')
          )?_c('div',{staticClass:"terms-conditions desk-terms",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn })},[_c('span',{staticClass:"cas-term",domProps:{"innerHTML":_vm._s(_vm.pageData.bonus_tc)}}),_vm._v(" "),(
              _vm.pageData.bonus_tc &&
              _vm.pageData.terms &&
              _vm.pageData.bonus_tc != '' &&
              _vm.pageData.terms != ''
            )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.pageData.terms && _vm.pageData.terms != '')?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                ? 'nofollow sponsored'
                : 'nofollow',"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(_vm.pageData.term_link, _vm.pageData.slug),"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.terms))]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('a',{class:{
          'cta cta-primary cta-promotion cta-promo-review custom-btn sticky-play-btn-large hover-btn cas-link': true,
          'text-white':
                      !_vm.$root.override_ctabtntxt_color &&
                      !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-gray':
                      !_vm.$root.override_ctabtntxt_color &&
                      _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-cta-override': _vm.$root.override_ctabtntxt_color,
        },style:({
          '--primary-btn': _vm.$root.color_schema.primary_btn,
          '--primary-btn-hover': _vm.pSBC(-0.2, _vm.$root.color_schema.primary_btn),
        }),attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
            _vm.pageData.product_information.go_link,
            _vm.pageData.product_information.slug
          ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.pageData.product_information.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "revspp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e(),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('a',{class:{
          'cta cta-primary cta-promotion cta-promo-review custom-btn-white sticky-play-btn-medium cas-link': true,
          'text-white':
                      !_vm.$root.override_ctabtntxt_color &&
                      !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-gray':
                      !_vm.$root.override_ctabtntxt_color &&
                      _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-cta-override': _vm.$root.override_ctabtntxt_color,
        },style:({
          '--primary-btn': _vm.$root.color_schema.primary_btn,
          '--primary-btn-hover': _vm.pSBC(-0.2, _vm.$root.color_schema.primary_btn),
        }),attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
            _vm.pageData.product_information.go_link,
            _vm.pageData.product_information.slug
          ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}},[_vm._v(_vm._s(_vm.pageData.product_information.cta_button_text))]):_vm._e(),_vm._v(" "),(
          (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
          (_vm.pageData.terms && _vm.pageData.terms != '')
        )?_c('div',{staticClass:"mob-terms"},[(_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '')?_c('span',{staticClass:"cas-term terms-conditions",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(_vm.pageData.bonus_tc)}}):_vm._e(),_vm._v(" "),(
            _vm.pageData.bonus_tc &&
            _vm.pageData.terms &&
            _vm.pageData.bonus_tc != '' &&
            _vm.pageData.terms != ''
          )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.pageData.terms && _vm.pageData.terms != '')?_c('a',{staticClass:"cas-term mob-cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(_vm.pageData.term_link, _vm.pageData.slug),"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.terms))]):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('section',{class:{
      'ct-inner-banner ct-inner-banner__review pt-26': true,
    },style:({
      background: _vm.$root.color_schema.primary,
    })},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadCrumb,"dark":_vm.getContrastYIQ(_vm.$root.color_schema.primary)}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.$root.disableNotSupportBanner)?_c('NotSupportModal',{attrs:{"notsupportbannerData":_vm.$root.notsupportbannerData,"relative":!_vm.pageData || !_vm.pageData.product_information || Object.keys(_vm.pageData).length === 0}}):_vm._e(),_vm._v(" "),(
              _vm.pageData &&
              _vm.pageData.product_information &&
              Object.keys(_vm.pageData).length != 0
            )?_c('div',{class:{
              'casino-card new-review-banner-card': true,
              'terms-d': _vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '',
            }},[_c('div',{staticClass:"new-review-banner-card-top"},[_c('div',{staticClass:"new-review-banner-card-top-left"},[(
                    _vm.pageData.product_information.product_assets &&
                    _vm.pageData.product_information.product_assets.length > 0
                  )?_c('div',{staticClass:"review-left-img"},[(_vm.pageData && _vm.pageData.product_id)?_c('a',{staticClass:"partner-logo cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                        _vm.pageData.product_information.go_link,
                        _vm.pageData.product_information.slug
                      ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[(_vm.assets_images && _vm.assets_images.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                          _vm.pageData.product_information.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.large; }
                          ).length > 0
                            ? _vm.pageData.product_information.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.large; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/failure.png'
                        ),expression:"\n                          pageData.product_information.product_assets.filter(\n                            (ele) =>\n                              ele.asset_category_name ===\n                              assets_images.pro_asset_sizes.large\n                          ).length > 0\n                            ? pageData.product_information.product_assets\n                                .filter(\n                                  (ele) =>\n                                    ele.asset_category_name ===\n                                    assets_images.pro_asset_sizes.large\n                                )\n                                .shift().url\n                            : $root.site_url +\n                              $root.asset_path +\n                              '/failure.png'\n                        "}],attrs:{"height":"250","width":"250","alt":_vm.getAltText(
                            _vm.pageData.product_information.name,
                            _vm.pageData.product_information.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            ).length > 0
                              ? _vm.pageData.product_information.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.large; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png'
                          )}}):_c('img',{attrs:{"src":_vm.pageData.product_information.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.large; }
                          ).length > 0
                            ? _vm.pageData.product_information.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.large; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/failure.png',"height":"250","width":"250","alt":_vm.getAltText(
                            _vm.pageData.product_information.name,
                            _vm.pageData.product_information.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            ).length > 0
                              ? _vm.pageData.product_information.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.large; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png'
                          )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-bann"},[_c('div',{staticClass:"partner-hover-inner",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]:_vm._e(),_vm._v(" "),(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                      )?_c('span',{staticClass:"exclusive-tag",style:({
                        backgroundColor:
                          Object.keys(
                            _vm.hasTag(_vm.pageData.product_information.tags)
                          ).length > 0
                            ? _vm.hasTag(_vm.pageData.product_information.tags).color
                            : null,
                      })},[_c('p',{class:{
                          'desk-excl custom-font-2': true,
                          'text-gray': _vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(_vm.pageData.product_information.tags)
                            ).length > 0
                              ? _vm.hasTag(_vm.pageData.product_information.tags)
                                  .color
                              : null
                          ),
                          'text-light': !_vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(_vm.pageData.product_information.tags)
                            ).length > 0
                              ? _vm.hasTag(_vm.pageData.product_information.tags)
                                  .color
                              : null
                          ),
                        }},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                        "+_vm._s(_vm.titleCase(
                            _vm.hasTag(_vm.pageData.product_information.tags).tag_name
                          ))+"\n                      ")]),_vm._v(" "),_c('img',{staticClass:"mob-excl",attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()],2):[(_vm.assets_images && _vm.assets_images.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                          _vm.pageData.product_information.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            )
                            .shift().url
                        ),expression:"\n                          pageData.product_information.product_assets\n                            .filter(\n                              (ele) =>\n                                ele.asset_category_name ===\n                                assets_images.pro_asset_sizes.large\n                            )\n                            .shift().url\n                        "}],attrs:{"height":"250","width":"250","alt":_vm.getAltText(
                            _vm.pageData.product_information.name,
                            _vm.pageData.product_information.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.large; }
                              )
                              .shift().url
                          )}}):_c('img',{attrs:{"src":_vm.pageData.product_information.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            )
                            .shift().url,"height":"250","width":"250","alt":_vm.getAltText(
                            _vm.pageData.product_information.name,
                            _vm.pageData.product_information.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.large; }
                              )
                              .shift().url
                          )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-bann"},[_c('div',{staticClass:"partner-hover-inner",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]:_vm._e(),_vm._v(" "),(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                      )?_c('span',{staticClass:"exclusive-tag",style:({
                        backgroundColor:
                          Object.keys(
                            _vm.hasTag(_vm.pageData.product_information.tags)
                          ).length > 0
                            ? _vm.hasTag(_vm.pageData.product_information.tags).color
                            : null,
                      })},[_c('p',{class:{
                          'desk-excl custom-font-2': true,
                          'text-gray': _vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(_vm.pageData.product_information.tags)
                            ).length > 0
                              ? _vm.hasTag(_vm.pageData.product_information.tags)
                                  .color
                              : null
                          ),
                          'text-light': !_vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(_vm.pageData.product_information.tags)
                            ).length > 0
                              ? _vm.hasTag(_vm.pageData.product_information.tags)
                                  .color
                              : null
                          ),
                        }},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                        "+_vm._s(_vm.titleCase(
                            _vm.hasTag(_vm.pageData.product_information.tags).tag_name
                          ))+"\n                      ")]),_vm._v(" "),_c('img',{staticClass:"mob-excl",attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()]],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"review-left-content"},[_c('div',{staticClass:"exclusive-bar"},[_c('div',{staticClass:"exclusive-bar-title"},[_c('div',{staticClass:"trust"},[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/trust-tick.svg',"width":"8","height":"8","alt":"Approve Icon"}})]),_c('strong',[_vm._v(_vm._s(_vm.pageAttr.is_approved &&
                          _vm.pageAttr.approved_by_expert &&
                          _vm.pageAttr.approved_by_expert != ""
                            ? _vm.pageAttr.approved_by_expert
                            : _vm.$root.i18n.trusted_review))])]),_vm._v(" "),_c('p',{staticClass:"custom-font-2"},[_vm._v("\n                        "+_vm._s(_vm.pageData.product_information.name)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"exclusive-bar-rating"},[(_vm.pageData.product_information.rating)?[_c('StarRating',{attrs:{"rating":parseFloat(
                              (
                                _vm.pageData.product_information.rating / 2
                              ).toFixed(1)
                            )}})]:_vm._e(),_vm._v(" "),(
                          _vm.pageAttr.is_exclusive ||
                          (_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                            _vm.pageData.product_information
                              .exclusive_bonus_match)
                        )?_c('span',{staticClass:"exclusive-tag"},[_vm._v(_vm._s(_vm.$root.i18n.exclusive))]):_vm._e()],2)]),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('div',{staticClass:"review-left-content-title"},[_c('span',{class:{
                        'span-h1 cust-span custom-font-1': true,
                        'text-hover': !_vm.$root.disable_bonus_cta_on_review,
                      }},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(!_vm.$root.disable_bonus_cta_on_review)?[(
                              _vm.pageData.product_information.bonus_match &&
                              _vm.pageData.product_information
                                .exclusive_bonus_amount &&
                              _vm.pageData.product_information
                                .exclusive_bonus_match
                            )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                                _vm.pageData.product_information.go_link,
                                _vm.pageData.product_information.slug
                              ),"rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information
                                .exclusive_bonus_match)+"% "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                            "+_vm._s(_vm._f("currency")(_vm.pageData.product_information
                                .exclusive_bonus_amount,
                                  _vm.pageData.product_information.bonus_currency
                                )))]):_vm._e(),_vm._v(" "),(
                              _vm.pageData.product_information.bonus_match &&
                              !_vm.pageData.product_information
                                .exclusive_bonus_amount &&
                              _vm.pageData.product_information.bonus_amount
                            )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                                _vm.pageData.product_information.go_link,
                                _vm.pageData.product_information.slug
                              ),"rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                            "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                            "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                                  _vm.pageData.product_information.bonus_currency
                                )))]):_vm._e(),_vm._v(" "),(
                              _vm.pageData.product_information.freespin ||
                              _vm.pageData.product_information.freebie_name
                            )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                                _vm.pageData.product_information.go_link,
                                _vm.pageData.product_information.slug
                              ),"rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow',"target":"_blank"}},[(
                                (_vm.pageData.product_information
                                  .exclusive_bonus_amount ||
                                  _vm.pageData.product_information
                                    .bonus_amount) &&
                                _vm.pageData.product_information.bonus_match
                              )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                      _vm.pageData.product_information
                                        .bonus_currency
                                    )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                              "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                            ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]],2):_vm._e()]:[(
                              _vm.pageData.product_information.bonus_match &&
                              _vm.pageData.product_information
                                .exclusive_bonus_amount &&
                              _vm.pageData.product_information
                                .exclusive_bonus_match
                            )?[_vm._v(_vm._s(_vm.pageData.product_information
                                .exclusive_bonus_match)+"% "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                            "+_vm._s(_vm._f("currency")(_vm.pageData.product_information
                                .exclusive_bonus_amount,
                                  _vm.pageData.product_information.bonus_currency
                                )))]:_vm._e(),_vm._v(" "),(
                              _vm.pageData.product_information.bonus_match &&
                              !_vm.pageData.product_information
                                .exclusive_bonus_amount &&
                              _vm.pageData.product_information.bonus_amount
                            )?[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                            "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                            "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                                  _vm.pageData.product_information.bonus_currency
                                )))]:_vm._e(),_vm._v(" "),(
                              _vm.pageData.product_information.freespin ||
                              _vm.pageData.product_information.freebie_name
                            )?[(
                                (_vm.pageData.product_information
                                  .exclusive_bonus_amount ||
                                  _vm.pageData.product_information
                                    .bonus_amount) &&
                                _vm.pageData.product_information.bonus_match
                              )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                      _vm.pageData.product_information
                                        .bonus_currency
                                    )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                              "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                            ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]]:_vm._e()]]],2),_vm._v(" "),(_vm.pageData.product_information.go_link)?[_c('a',{class:{
                          'cta cta-primary cta-promotion cta-promo-review ct-btn custom-btn hover-btn cas-link': true,
                          'text-white':
                      !_vm.$root.override_ctabtntxt_color &&
                      !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-gray':
                      !_vm.$root.override_ctabtntxt_color &&
                      _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.pageData.product_information.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "revspp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]:_vm._e()],2):_vm._e()])]),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('div',{staticClass:"review-left-content-title view-mob"},[_c('span',{staticClass:"span-h1 custom-font-1"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(!_vm.$root.disable_bonus_cta_on_review)?[(
                          _vm.pageData.product_information.bonus_match &&
                          _vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          _vm.pageData.product_information.exclusive_bonus_match
                        )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.exclusive_bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.exclusive_bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            )))]):_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.bonus_match &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          _vm.pageData.product_information.bonus_amount
                        )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            )))]):_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.freespin &&
                          _vm.pageData.product_information.freebie_name &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          !_vm.pageData.product_information.bonus_amount
                        )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.freespin)+"\n                        "+_vm._s(_vm.pageData.product_information.freebie_name))]):_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.bonus_amount &&
                          !_vm.pageData.product_information.bonus_match &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          !_vm.pageData.product_information.freespin &&
                          _vm.pageData.product_information.freebie_name
                        )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            ))+"\n                        "+_vm._s(_vm.pageData.product_information.bonus_name))]):_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.freespin ||
                          _vm.pageData.product_information.freebie_name
                        )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[(
                            (_vm.pageData.product_information
                              .exclusive_bonus_amount ||
                              _vm.pageData.product_information.bonus_amount) &&
                            _vm.pageData.product_information.bonus_match
                          )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                  _vm.pageData.product_information.bonus_currency
                                )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                          "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                        ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]],2):_vm._e()]:[(
                          _vm.pageData.product_information.bonus_match &&
                          _vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          _vm.pageData.product_information.exclusive_bonus_match
                        )?[_vm._v(_vm._s(_vm.pageData.product_information.exclusive_bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.exclusive_bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            )))]:_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.bonus_match &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          _vm.pageData.product_information.bonus_amount
                        )?[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            )))]:_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.freespin &&
                          _vm.pageData.product_information.freebie_name &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          !_vm.pageData.product_information.bonus_amount
                        )?[_vm._v(_vm._s(_vm.pageData.product_information.freespin)+"\n                        "+_vm._s(_vm.pageData.product_information.freebie_name))]:_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.bonus_amount &&
                          !_vm.pageData.product_information.bonus_match &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          !_vm.pageData.product_information.freespin &&
                          _vm.pageData.product_information.freebie_name
                        )?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            ))+"\n                        "+_vm._s(_vm.pageData.product_information.bonus_name))]:_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.freespin ||
                          _vm.pageData.product_information.freebie_name
                        )?[(
                            (_vm.pageData.product_information
                              .exclusive_bonus_amount ||
                              _vm.pageData.product_information.bonus_amount) &&
                            _vm.pageData.product_information.bonus_match
                          )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                  _vm.pageData.product_information.bonus_currency
                                )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                          "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                        ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]]:_vm._e()]]],2),_vm._v(" "),_c('a',{class:{
                    'cta cta-primary cta-promotion cta-promo-review custom-btn hover-btn cas-link': true,
                    'text-white':
                      !_vm.$root.override_ctabtntxt_color &&
                      !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-gray':
                      !_vm.$root.override_ctabtntxt_color &&
                      _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-cta-override': _vm.$root.override_ctabtntxt_color,
                  },style:({
                    '--primary-btn': _vm.$root.color_schema.primary_btn,
                    '--primary-btn-hover': _vm.pSBC(
                      -0.2,
                      _vm.$root.color_schema.primary_btn
                    ),
                  }),attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                      _vm.pageData.product_information.go_link,
                      _vm.pageData.product_information.slug
                    ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.pageData.product_information.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "revbbpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"new-review-banner-card-top-right"},[_c('div',{staticClass:"overall-rating"},[_c('div',{staticClass:"rating-header"},[_c('span',{staticClass:"span-h2"},[_vm._v(_vm._s(_vm.$root.i18n.overall_rating))]),_vm._v(" "),_c('div',{staticClass:"rating-count",style:({
                        background: _vm.getFinalStarPercentage(
                          parseFloat(
                            (_vm.pageData.product_information.rating / 2).toFixed(
                              1
                            )
                          )
                        ),
                      })},[_c('div',{staticClass:"rating-count-top"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(parseFloat(
                            (_vm.pageData.product_information.rating / 2).toFixed(
                              1
                            )
                          )))]),_vm._v(" "),_c('i',{staticClass:"full-star"})]),_vm._v(" "),_c('span',{staticClass:"comment"},[_vm._v(_vm._s(_vm.getFinalStarPercentageLabel(
                            parseFloat(
                              (
                                _vm.pageData.product_information.rating / 2
                              ).toFixed(1)
                            )
                          ))+"!")])])]),_vm._v(" "),(
                      _vm.pageData.rating_data && _vm.pageData.rating_data.length > 0
                    )?_c('div',{staticClass:"progress-bar-block"},_vm._l((_vm.pageData.rating_data.filter(
                        function (ele, key) { return key != 0; }
                      )),function(rtn,ind){return _c('div',{key:ind,staticClass:"bar-row"},[_c('div',{staticClass:"label"},[_c('p',[_vm._v(_vm._s(rtn.criteria_name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(parseFloat((rtn.value / 2).toFixed(1)))+"\n                          "),_c('i',{staticClass:"full-star"})])]),_vm._v(" "),_c('div',{staticClass:"bar-rail"},[_c('div',{staticClass:"progress-indicator",style:(_vm.getStarPercentage(
                              parseFloat((rtn.value / 2).toFixed(1))
                            ))})])])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row mx-0 new-review-banner-card-bottom"},[_c('div',{staticClass:"col-12 col-md-3 px-0 wd-mar"},[(
                      _vm.pageData.software_provider &&
                      _vm.pageData.software_provider.length > 0
                    )?_c('div',{staticClass:"casino-card-lists"},[_c('span',{staticClass:"span-caption span-caption-override"},[_vm._v(_vm._s(_vm.$root.i18n.software_providers)+" ("+_vm._s(_vm.pageData.software_provider.length)+")")]),_vm._v(" "),_c('ul',{staticClass:"\n                        justify-flex-start\n                        flex-wrap\n                        review-banner-support\n                      "},[_vm._l((_vm.pageData.software_provider.slice(0, 4)),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}),_vm._v(" "),(_vm.pageData.software_provider.length === 5)?_vm._l((_vm.pageData.software_provider.slice(4)),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}):_vm._e(),_vm._v(" "),(
                          _vm.pageData.software_provider.length > 5 &&
                          !_vm.showHideObj.spTop
                        )?_c('li',[_c('a',{attrs:{"href":"#review-casino-card-software"}},[_c('figure',[_c('span',[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                              "+_vm._s(_vm.pageData.software_provider.length - 4)+"\n                            ")])])])]):_vm._e()],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"offset-md-1 col-12 col-md-3 px-0 wd-mar"},[(
                      _vm.pageData.supported_payments &&
                      _vm.pageData.supported_payments.length > 0
                    )?_c('div',{staticClass:"casino-card-lists"},[_c('span',{staticClass:"span-caption span-caption-override"},[_vm._v(_vm._s(_vm.$root.i18n.top_payment_methods)+" ("+_vm._s(_vm.pageData.supported_payments.length)+")")]),_vm._v(" "),_c('ul',{staticClass:"\n                        justify-flex-start\n                        flex-wrap\n                        review-banner-support\n                      "},[_vm._l((_vm.pageData.supported_payments.slice(
                          0,
                          4
                        )),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}),_vm._v(" "),(_vm.pageData.supported_payments.length === 5)?_vm._l((_vm.pageData.supported_payments.slice(4)),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}):_vm._e(),_vm._v(" "),(
                          _vm.pageData.supported_payments.length > 5 &&
                          !_vm.showHideObj.pmTop
                        )?_c('li',[_c('a',{attrs:{"href":"#review-casino-card-payment-method"}},[_c('figure',[_c('span',[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                              "+_vm._s(_vm.pageData.supported_payments.length - 4)+"\n                            ")])])])]):_vm._e()],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"offset-md-1 col-12 col-md-3 px-0 wd-mar"},[(
                      _vm.pageData.product_licences &&
                      _vm.pageData.product_licences.length > 0
                    )?_c('div',{staticClass:"casino-card-lists license-right"},[_c('span',{staticClass:"span-caption span-caption-override"},[_vm._v(_vm._s(_vm.$root.i18n.licenced_under))]),_vm._v(" "),_c('ul',{staticClass:"justify-flex-end flex-wrap review-banner-support"},[_vm._l((_vm.pageData.product_licences.slice(0, 4)),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}),_vm._v(" "),(_vm.pageData.product_licences.length === 5)?_vm._l((_vm.pageData.product_licences.slice(4)),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}):_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_licences.length > 5 &&
                          !_vm.showHideObj.liscTop
                        )?_c('li',[_c('a',{attrs:{"href":"#review-support-language"}},[_c('figure',[_c('span',[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                              "+_vm._s(_vm.pageData.product_licences.length - 4)+"\n                            ")])])])]):_vm._e()],2)]):_vm._e()])])]),_vm._v(" "),(_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '')?_c('div',{staticClass:"div-term"},[(_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '')?_c('span',{staticClass:"terms_tc cas-term",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(_vm.pageData.bonus_tc)}}):_vm._e(),_vm._v(" "),(
                  _vm.pageData.bonus_tc &&
                  _vm.pageData.terms &&
                  _vm.pageData.bonus_tc != '' &&
                  _vm.pageData.terms != ''
                )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.pageData.terms && _vm.pageData.terms != '')?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(_vm.pageData.term_link, _vm.pageData.slug),"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.terms))]):_vm._e()]):_vm._e()]):_vm._e()],1)])])]),_vm._v(" "),(
      _vm.pageIndex > 0 &&
      _vm.tabData &&
      _vm.tabData.filter(function (ele) { return ele.tab_content; }).length > 0
    )?_c('section',{staticClass:"ct-editor-section pb-25 pb-1"},[_c('vue-position-sticky',{attrs:{"id":"sticky-nav","offsetTop":_vm.stickyNavTop,"sticky-class":"sticky"}},[(_vm.showSticky)?_c('div',{staticClass:"review-top-menu"},[_c('nav',{staticClass:"scroll-nav"},_vm._l((_vm.tabData.filter(function (ele) { return ele.tab_content; })),function(data,index){return _c('span',{key:index,class:{
              'scroll-item': true,
              active: _vm.activeKey === data.tab_key,
            },on:{"click":function($event){return _vm.scrollPage(data.tab_key)}}},[_vm._v(_vm._s(data.tab_title))])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"editor-content"},_vm._l((_vm.tabData.filter(function (ele) { return ele.tab_content; })),function(val,index){return _c('div',{key:index},[(val.tab_content)?_c('div',{ref:val.tab_key,refInFor:true,staticClass:"sticky-content"},_vm._l((val.tab_content),function(data,key){return _c('div',{key:key},[(key === 'content_block')?_vm._l((data),function(data,index){return _c('div',{key:index + '-initial'},[_c('div',{staticClass:"custm-text tick-div-blue",style:({
                      '--heading-font': _vm.$root.font_family.heading,
                      '--paragraph-font': _vm.$root.font_family.paragraph,
                    }),domProps:{"innerHTML":_vm._s(data)}})])}):(key === 'content_icon_block')?[_c('ContentIcon',{attrs:{"contentIconData":Object.keys(data).length > 0 ? data : false,"partnerInfo":_vm.pageData && _vm.pageData.product_information
                      ? _vm.pageData.product_information
                      : '',"buttonCheck":_vm.pageData && _vm.pageData.product_id ? true : false,"templateCheck":'review'}})]:(key === 'featured_promotion')?[_c('PromotionBannerSuggest',{attrs:{"promoData":data.promotion}})]:(key === 'comparison_list')?[_c('ComparisonList',{attrs:{"comparisonData":data,"partnerProcons":data.hasOwnProperty('enabled_review_partner_procons') &&
                    data.enabled_review_partner_procons
                      ? _vm.pageData.procons && _vm.pageData.procons.length > 0
                        ? _vm.pageData.procons
                        : []
                      : [],"page":data.hasOwnProperty('enabled_review_partner_procons') &&
                    data.enabled_review_partner_procons
                      ? 'partner-review-block'
                      : 'review'}})]:(key === 'bonus_information')?[_c('BonusInformation',{attrs:{"hideBonusLabelB":_vm.hideBonusLabel,"assetsSize":_vm.assets_images,"bonusData":data,"bonusPartnerData":_vm.pageData ? _vm.pageData.product_information : {},"bonusPrimaryColour":_vm.pageData ? _vm.pageData.primary_colour : ''}})]:(key === 'software_provider_block')?_c('div',{staticClass:"casino-card casino-card-software",attrs:{"id":"review-casino-card-software"}},[(
                    _vm.pageData &&
                    _vm.pageData.product_information &&
                    _vm.pageData.product_information.online_since &&
                    _vm.pageData.product_information.online_since != ''
                  )?_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"developer-card"},[_c('div',{staticClass:"card-header"},[_c('p',{staticClass:"first-head"},[_c('i',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.icon),expression:"data.icon"}],attrs:{"alt":"Software Icon"}}):_c('img',{attrs:{"src":data.icon,"alt":"Software Icon"}})]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(data.software_providers_on_label &&
                          data.software_providers_on_label != ""
                            ? data.software_providers_on_label
                            : _vm.$root.i18n.software_providers))])]),_vm._v(" "),_c('p',{staticClass:"second-head"},[_vm._v("\n                        "+_vm._s(data.online_since_label &&
                          data.online_since_label != ""
                            ? data.online_since_label
                            : _vm.$root.i18n.online_since)+":\n                        "),_c('strong',[_vm._v(_vm._s(_vm.pageData && _vm.pageData.product_information
                            ? _vm.pageData.product_information.online_since
                            : ""))])])]),_vm._v(" "),(
                        _vm.pageData &&
                        _vm.pageData.software_provider &&
                        _vm.pageData.software_provider.length > 0
                      )?_c('div',{staticClass:"card-body casino-card-lists"},[_c('span',{staticClass:"span-h6"},[_vm._v(_vm._s(data.software_providers_on_label &&
                          data.software_providers_on_label != ""
                            ? data.software_providers_on_label
                            : _vm.$root.i18n.software_providers_on)+"\n                        "+_vm._s(_vm.pageData.product_name)+" ("+_vm._s(_vm.pageData.software_provider.length)+"):\n                      ")]),_vm._v(" "),_c('ul',{staticClass:"justify-flex-start flex-wrap"},_vm._l((_vm.pageData.software_provider),function(data){return _c('li',{key:data.software_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}),0)]):_vm._e(),_vm._v(" "),(
                        _vm.pageData &&
                        _vm.pageData.product_licences &&
                        _vm.pageData.product_licences.length > 0
                      )?_c('div',{staticClass:"card-footer casino-card-lists"},[_c('span',[_vm._v(_vm._s(_vm.pageData.product_name)+"\n                        "+_vm._s(data.licensed_under_label &&
                          data.licensed_under_label != ""
                            ? data.licensed_under_label
                            : _vm.$root.i18n.licenced_under)+":\n                        "),_vm._l((_vm.pageData.product_licences),function(data){return _c('i',{key:data.po_id},[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])})],2)]):_vm._e()])]):_vm._e()]):(key === 'payment_option_block')?_c('div',{staticClass:"\n                  casino-card casino-card-software casino-card-payment-method\n                ",attrs:{"id":"review-casino-card-payment-method"}},[_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"developer-card"},[_c('div',{staticClass:"card-header"},[_c('p',{staticClass:"first-head"},[_c('i',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.icon),expression:"data.icon"}],attrs:{"alt":"Payment Icon"}}):_c('img',{attrs:{"src":data.icon,"alt":"Payment Icon"}})]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$root.i18n.payment_informations))])]),_vm._v(" "),(
                          (_vm.pageData && _vm.pageData.minimum_deposit) ||
                          (_vm.pageData && _vm.pageData.minimum_withdraw)
                        )?_c('p',{staticClass:"second-head"},[(_vm.pageData && _vm.pageData.minimum_deposit)?[_vm._v("\n                          "+_vm._s(_vm.$root.i18n.minimum_deposit)+":\n                          "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.minimum_deposit,_vm.pageData.bonus_currency)))]),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),(_vm.pageData && _vm.pageData.minimum_withdraw)?[_vm._v(_vm._s(_vm.$root.i18n.minimum_withdrawal)+":\n                          "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.minimum_withdraw,_vm.pageData.bonus_currency)))])]:_vm._e()],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-body casino-card-lists"},[(
                          _vm.pageData &&
                          _vm.pageData.supported_payments.filter(
                            function (ele) { return ele.deposit === '1'; }
                          ).length > 0
                        )?[_c('span',{staticClass:"span-h6"},[_vm._v(_vm._s(data.deposit_methods_label &&
                            data.deposit_methods_label != ""
                              ? data.deposit_methods_label
                              : _vm.$root.i18n.deposit_methods)+"\n                          ("+_vm._s(_vm.pageData.supported_payments.filter(
                              function (ele) { return ele.deposit === "1"; }
                            ).length)+"):\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"justify-flex-start flex-wrap"},_vm._l((_vm.pageData.supported_payments.filter(
                              function (ele) { return ele.deposit === '1'; }
                            )),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}),0)]:_vm._e(),_vm._v(" "),(
                          _vm.pageData &&
                          _vm.pageData.supported_payments.filter(
                            function (ele) { return ele.withdrawal === '1'; }
                          ).length > 0
                        )?[_c('span',{staticClass:"span-h6 withdrl"},[_vm._v(_vm._s(data.withdrawal_methods_label &&
                            data.withdrawal_methods_label != ""
                              ? data.withdrawal_methods_label
                              : _vm.$root.i18n.withdrawal_methods)+"\n                          ("+_vm._s(_vm.pageData.supported_payments.filter(
                              function (ele) { return ele.withdrawal === "1"; }
                            ).length)+"):\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"justify-flex-start flex-wrap"},_vm._l((_vm.pageData.supported_payments.filter(
                              function (ele) { return ele.withdrawal === '1'; }
                            )),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}),0)]:_vm._e()],2)])])]):(key === 'supported_language_and_supports')?_c('div',{staticClass:"\n                  casino-card casino-card-software casino-card-payment-method\n                ",attrs:{"id":"review-support-language"}},[_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"developer-card"},[_c('div',{staticClass:"card-header"},[_c('p',{staticClass:"first-head"},[_c('i',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.icon),expression:"data.icon"}],attrs:{"alt":"Card Icon"}}):_c('img',{attrs:{"src":data.icon,"alt":"Card Icon"}})]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(data.supported_languages_label &&
                          data.supported_languages_label != ""
                            ? data.supported_languages_label
                            : _vm.$root.i18n.supported_languages))])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.supportedLang && _vm.supportedLang.length > 0)?_c('div',{staticClass:"casino-card-lang-lists"},[_c('ul',{staticClass:"flex-wrap"},_vm._l((_vm.supportedLang),function(lang,index){return _c('li',{key:index},[_c('img',{staticClass:"lang-flag",attrs:{"src":("" + (_vm.$root.site_url) + (_vm.$root.asset_path) + "/flag-svg/" + (lang.toLowerCase()) + ".svg"),"alt":lang}})])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"support-links"},[_c('p',[_c('i',[_c('svg',{attrs:{"width":"19","height":"14","viewBox":"0 0 19 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12.595 7.10355L19 11.4428V2.5813L12.595 7.10355Z","fill":"#0165F7"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 2.5813V11.4428L6.40505 7.10355L0 2.5813Z","fill":"#0165F7"}}),_vm._v(" "),_c('path',{attrs:{"d":"M17.8124 -0.00012207H1.18749C0.593747 -0.00012207 0.126171 0.473183 0.0371094 1.08172L9.49995 7.76368L18.9628 1.08172C18.8737 0.473183 18.4062 -0.00012207 17.8124 -0.00012207Z","fill":"#0165F7"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11.5076 7.87471L9.82652 9.05996C9.72632 9.13155 9.61499 9.16337 9.49995 9.16337C9.38492 9.16337 9.27359 9.12757 9.17339 9.05996L7.49235 7.87073L0.0371094 12.9259C0.129882 13.5305 0.597458 13.9998 1.18749 13.9998H17.8124C18.4025 13.9998 18.87 13.5305 18.9628 12.9259L11.5076 7.87471Z","fill":"#0165F7"}})])]),_vm._v("\n                          "+_vm._s(_vm.supportEmail)+"\n                        ")]),_vm._v(" "),_c('p',[_c('i',[_c('svg',{attrs:{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"opacity":"0.2","d":"M4.5 8.52929V11.7646C4.5 11.9362 4.56438 12.1008 4.67899 12.2221C4.7936 12.3435 4.94903 12.4116 5.11111 12.4116H12.4764L15.5 14.9999V4.64694C15.5 4.47533 15.4356 4.31074 15.321 4.1894C15.2064 4.06805 15.051 3.99988 14.8889 3.99988H11.8333V7.88223C11.8333 8.05384 11.7689 8.21842 11.6543 8.33977C11.5397 8.46112 11.3843 8.52929 11.2222 8.52929H4.5Z","fill":"#0165F7"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16.5 5.11989C16.4996 4.78053 16.3698 4.45518 16.1391 4.21521C15.9084 3.97525 15.5955 3.84027 15.2692 3.83989H12.8078V1.27988C12.8074 0.94052 12.6776 0.615168 12.4469 0.375203C12.2161 0.135239 11.9033 0.000259068 11.577 -0.00012207H1.73078C1.40447 0.000259068 1.09163 0.135239 0.86089 0.375203C0.630155 0.615168 0.500366 0.94052 0.5 1.27988V11.5199C0.499983 11.6408 0.532865 11.7591 0.594842 11.8614C0.656818 11.9636 0.745356 12.0455 0.850213 12.0975C0.95507 12.1496 1.07196 12.1697 1.18736 12.1556C1.30276 12.1415 1.41196 12.0936 1.50231 12.0177L4.19225 9.7559L4.19233 12.1599C4.19269 12.4993 4.32248 12.8246 4.55322 13.0646C4.78395 13.3045 5.09679 13.4395 5.4231 13.4399H12.6222L15.4978 15.8577C15.5882 15.9336 15.6974 15.9814 15.8128 15.9955C15.9281 16.0096 16.045 15.9895 16.1498 15.9374C16.2546 15.8853 16.3432 15.8035 16.4051 15.7013C16.4671 15.5991 16.5 15.4807 16.5 15.3599V5.11989ZM3.77332 8.4623L1.7307 10.1795V1.27988H11.5769V4.47837L11.5768 4.47997L11.5769 4.48149V8.3199H4.16017C4.01933 8.31992 3.88283 8.37018 3.77332 8.4623ZM13.2267 12.3023C13.1172 12.2102 12.9806 12.1599 12.8398 12.1599H5.4231L5.42302 9.5999H11.577C11.9033 9.59952 12.2161 9.46454 12.4469 9.22458C12.6776 8.98461 12.8074 8.65926 12.8078 8.3199V5.11989H15.2692L15.2693 14.0196L13.2267 12.3023Z","fill":"#0165F7"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 0.999878H1.5L1 9.99988L2 10.4999L2.5 9.99988L4.5 8.99988L12 8.49988V0.999878Z","fill":"#0165F7"}})]),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"16","height":"16","fill":"white","transform":"translate(0.5 -0.00012207)"}})])])])]),_vm._v("\n                          "+_vm._s(data.live_chat_available_label &&
                            data.live_chat_available_label != ""
                              ? data.live_chat_available_label
                              : _vm.$root.i18n
                                  .twentyfourbyseven_live_chat_available)+"\n                        ")]),_vm._v(" "),_c('p',[_c('i',[_c('svg',{attrs:{"width":"14","height":"16","viewBox":"0 0 14 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.6005 11.0995L10.538 9.6932C10.4072 9.63347 10.2618 9.62088 10.1237 9.65734C9.98562 9.6938 9.86232 9.77733 9.77238 9.89535L8.41613 11.6707C6.28762 10.5955 4.57467 8.76018 3.57109 6.47963L5.22813 5.02651C5.33851 4.93032 5.41663 4.79822 5.45067 4.65021C5.48472 4.50219 5.47283 4.34632 5.4168 4.2062L4.1043 0.924954C4.0428 0.773902 3.93405 0.650573 3.79678 0.576233C3.65951 0.501893 3.50233 0.481202 3.35234 0.517727L0.508594 1.22085C0.363992 1.25663 0.234977 1.34386 0.142607 1.46832C0.0502374 1.59277 -3.33104e-05 1.7471 1.65599e-08 1.9061C1.65599e-08 9.42074 5.68477 15.4998 12.6875 15.4998C12.836 15.4999 12.9801 15.4461 13.0963 15.3471C13.2125 15.2482 13.2939 15.1099 13.3273 14.9549L13.9836 11.908C14.0175 11.7466 13.9977 11.5775 13.9278 11.4299C13.8579 11.2823 13.7422 11.1655 13.6005 11.0995Z","fill":"#0165F7"}})])]),_vm._v(" "),(_vm.contactNumber)?[_vm._v("\n                            "+_vm._s(_vm.contactName)+"\n                            "),_c('br'),_vm._v("\n                            "+_vm._s(_vm.contactNumber)+"\n                          ")]:_vm._e(),_vm._v(" "),(!_vm.contactNumber)?[_vm._v("\n                            "+_vm._s(data.phone_is_not_available_label &&
                              data.phone_is_not_available_label != ""
                                ? data.phone_is_not_available_label
                                : _vm.$root.i18n.phone_is_not_available)+"\n                          ")]:_vm._e()],2)])])])])]):_vm._e()],2)}),0):_vm._e()])}),0)])],1):_vm._e(),_vm._v(" "),(_vm.pageIndex > 2)?_c('section',{staticClass:"ct-editor-section pb-25 pb-1"},[_c('div',{staticClass:"container"},[(
          _vm.pageData &&
          _vm.pageData.product_information &&
          Object.keys(_vm.pageData).length != 0
        )?[_c('div',{class:{
            'casino-card casino-card-software casino-card-software-recomend casino-card-bonus': true,
            'rm-border':
              (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
              (_vm.pageData.terms && _vm.pageData.terms != ''),
          }},[(
              _vm.pageData.product_information.product_assets &&
              _vm.pageData.product_information.product_assets.length > 0
            )?_c('div',{staticClass:"bonus-card-logo"},[(_vm.pageData && _vm.pageData.product_id)?_c('a',{staticClass:"h-100 w-100 partner-logo cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                  _vm.pageData.product_information.go_link,
                  _vm.pageData.product_information.slug
                ),"rel":_vm.$root.change_cta_to_sponsored
                  ? 'nofollow sponsored'
                  : 'nofollow',"target":"_blank"}},[(_vm.assets_images && _vm.assets_images.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                    _vm.pageData.product_information.product_assets.filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assets_images.pro_asset_sizes.large; }
                    ).length > 0
                      ? _vm.pageData.product_information.product_assets
                          .filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.large; }
                          )
                          .shift().url
                      : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
                  ),expression:"\n                    pageData.product_information.product_assets.filter(\n                      (ele) =>\n                        ele.asset_category_name ===\n                        assets_images.pro_asset_sizes.large\n                    ).length > 0\n                      ? pageData.product_information.product_assets\n                          .filter(\n                            (ele) =>\n                              ele.asset_category_name ===\n                              assets_images.pro_asset_sizes.large\n                          )\n                          .shift().url\n                      : $root.site_url + $root.asset_path + '/failure.png'\n                  "}],class:{
                    'no-terms':
                      (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
                      (_vm.pageData.terms && _vm.pageData.terms != ''),
                  },attrs:{"width":"300","height":"320","alt":_vm.getAltText(
                      _vm.pageData.product_information.name,
                      _vm.pageData.product_information.product_assets.filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      ).length > 0
                        ? _vm.pageData.product_information.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            )
                            .shift().url
                        : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
                    )}}):_c('img',{class:{
                    'no-terms':
                      (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
                      (_vm.pageData.terms && _vm.pageData.terms != ''),
                  },attrs:{"src":_vm.pageData.product_information.product_assets.filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assets_images.pro_asset_sizes.large; }
                    ).length > 0
                      ? _vm.pageData.product_information.product_assets
                          .filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.large; }
                          )
                          .shift().url
                      : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"width":"300","height":"320","alt":_vm.getAltText(
                      _vm.pageData.product_information.name,
                      _vm.pageData.product_information.product_assets.filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      ).length > 0
                        ? _vm.pageData.product_information.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            )
                            .shift().url
                        : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
                    )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-end"},[_c('div',{staticClass:"partner-hover-inner",style:({
                      '--primary-btn': _vm.$root.color_schema.primary_btn,
                      '--primary-btn-hover': _vm.pSBC(
                        -0.2,
                        _vm.$root.color_schema.primary_btn
                      ),
                    })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                    Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                      .length > 0
                  )?_c('span',{staticClass:"exclusive-tag-rev",style:({
                    backgroundColor:
                      Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                        .length > 0
                        ? _vm.hasTag(_vm.pageData.product_information.tags).color
                        : null,
                  })},[_c('p',{class:{
                      'custom-font-2': true,
                      'text-gray': _vm.getContrastYIQ(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                          ? _vm.hasTag(_vm.pageData.product_information.tags).color
                          : null
                      ),
                      'text-light': !_vm.getContrastYIQ(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                          ? _vm.hasTag(_vm.pageData.product_information.tags).color
                          : null
                      ),
                    }},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                    "+_vm._s(_vm.titleCase(
                        _vm.hasTag(_vm.pageData.product_information.tags).tag_name
                      ))+"\n                  ")])]):_vm._e()]:_vm._e()],2):[(_vm.assets_images && _vm.assets_images.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                    _vm.pageData.product_information.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      )
                      .shift().url
                  ),expression:"\n                    pageData.product_information.product_assets\n                      .filter(\n                        (ele) =>\n                          ele.asset_category_name ===\n                          assets_images.pro_asset_sizes.large\n                      )\n                      .shift().url\n                  "}],class:{
                    'no-terms':
                      (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
                      (_vm.pageData.terms && _vm.pageData.terms != ''),
                  },attrs:{"width":"300","height":"320","alt":_vm.getAltText(
                      _vm.pageData.product_information.name,
                      _vm.pageData.product_information.product_assets
                        .filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assets_images.pro_asset_sizes.large; }
                        )
                        .shift().url
                    )}}):_c('img',{class:{
                    'no-terms':
                      (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
                      (_vm.pageData.terms && _vm.pageData.terms != ''),
                  },attrs:{"src":_vm.pageData.product_information.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      )
                      .shift().url,"width":"300","height":"320","alt":_vm.getAltText(
                      _vm.pageData.product_information.name,
                      _vm.pageData.product_information.product_assets
                        .filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assets_images.pro_asset_sizes.large; }
                        )
                        .shift().url
                    )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-end"},[_c('div',{staticClass:"partner-hover-inner",style:({
                      '--primary-btn': _vm.$root.color_schema.primary_btn,
                      '--primary-btn-hover': _vm.pSBC(
                        -0.2,
                        _vm.$root.color_schema.primary_btn
                      ),
                    })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                    Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                      .length > 0
                  )?_c('span',{staticClass:"exclusive-tag-rev",style:({
                    backgroundColor:
                      Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                        .length > 0
                        ? _vm.hasTag(_vm.pageData.product_information.tags).color
                        : null,
                  })},[_c('p',{class:{
                      'custom-font-2': true,
                      'text-gray': _vm.getContrastYIQ(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                          ? _vm.hasTag(_vm.pageData.product_information.tags).color
                          : null
                      ),
                      'text-light': !_vm.getContrastYIQ(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                          ? _vm.hasTag(_vm.pageData.product_information.tags).color
                          : null
                      ),
                    }},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                    "+_vm._s(_vm.titleCase(
                        _vm.hasTag(_vm.pageData.product_information.tags).tag_name
                      ))+"\n                  ")])]):_vm._e()]:_vm._e()]],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bonus-card-content"},[_c('div',{staticClass:"bonus-card-content-top"},[_c('div',{staticClass:"half-column"},[_c('div',{staticClass:"half-column-cont"},[_c('div',{staticClass:"bonus-card-rating"},[_c('p',{staticClass:"custom-font-2"},[_vm._v("\n                      "+_vm._s(_vm.pageData.product_information.name)+"\n                    ")]),_vm._v(" "),(
                        _vm.pageData.product_information &&
                        _vm.pageData.product_information.rating
                      )?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat(
                            (
                              _vm.pageData.product_information &&
                              _vm.pageData.product_information.rating / 2
                            ).toFixed(1)
                          )}})],1):_vm._e()]),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('span',{staticClass:"custom-font-1"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(!_vm.$root.disable_bonus_cta_on_review)?[(
                            _vm.pageData.product_information.bonus_match &&
                            _vm.pageData.product_information
                              .exclusive_bonus_amount &&
                            _vm.pageData.product_information.exclusive_bonus_match
                          )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                              _vm.pageData.product_information.go_link,
                              _vm.pageData.product_information.slug
                            ),"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information
                              .exclusive_bonus_match)+"% "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                          "+_vm._s(_vm._f("currency")(_vm.pageData.product_information
                              .exclusive_bonus_amount,
                                _vm.pageData.product_information.bonus_currency
                              )))]):_vm._e(),_vm._v(" "),(
                            _vm.pageData.product_information.bonus_match &&
                            !_vm.pageData.product_information
                              .exclusive_bonus_amount &&
                            _vm.pageData.product_information.bonus_amount
                          )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                              _vm.pageData.product_information.go_link,
                              _vm.pageData.product_information.slug
                            ),"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                          "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                          "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                                _vm.pageData.product_information.bonus_currency
                              )))]):_vm._e(),_vm._v(" "),(
                            _vm.pageData.product_information.freespin ||
                            _vm.pageData.product_information.freebie_name
                          )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                              _vm.pageData.product_information.go_link,
                              _vm.pageData.product_information.slug
                            ),"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"target":"_blank"}},[(
                              (_vm.pageData.product_information
                                .exclusive_bonus_amount ||
                                _vm.pageData.product_information.bonus_amount) &&
                              _vm.pageData.product_information.bonus_match
                            )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                    _vm.pageData.product_information
                                      .bonus_currency
                                  )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                            "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                          ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]],2):_vm._e()]:[(
                            _vm.pageData.product_information.bonus_match &&
                            _vm.pageData.product_information
                              .exclusive_bonus_amount &&
                            _vm.pageData.product_information.exclusive_bonus_match
                          )?[_vm._v(_vm._s(_vm.pageData.product_information
                              .exclusive_bonus_match)+"% "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                          "+_vm._s(_vm._f("currency")(_vm.pageData.product_information
                              .exclusive_bonus_amount,
                                _vm.pageData.product_information.bonus_currency
                              )))]:_vm._e(),_vm._v(" "),(
                            _vm.pageData.product_information.bonus_match &&
                            !_vm.pageData.product_information
                              .exclusive_bonus_amount &&
                            _vm.pageData.product_information.bonus_amount
                          )?[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                          "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                          "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                                _vm.pageData.product_information.bonus_currency
                              )))]:_vm._e(),_vm._v(" "),(
                            _vm.pageData.product_information.freespin ||
                            _vm.pageData.product_information.freebie_name
                          )?[(
                              (_vm.pageData.product_information
                                .exclusive_bonus_amount ||
                                _vm.pageData.product_information.bonus_amount) &&
                              _vm.pageData.product_information.bonus_match
                            )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                    _vm.pageData.product_information
                                      .bonus_currency
                                  )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                            "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                          ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]]:_vm._e()]]],2):_vm._e()])]),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('div',{staticClass:"half-column"},[_c('div',{staticClass:"play_term_wrapper"},[(_vm.pageData.product_information.go_link)?[_c('a',{class:{
                        'cta cta-primary cta-promotion custom-btn cas-link hover-btn btn-cust': true,
                        'text-white':
                      !_vm.$root.override_ctabtntxt_color &&
                      !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-gray':
                      !_vm.$root.override_ctabtntxt_color &&
                      _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-cta-override': _vm.$root.override_ctabtntxt_color,
                      },style:({
                        '--primary-btn': _vm.$root.color_schema.primary_btn,
                        '--primary-btn-hover': _vm.pSBC(
                          -0.2,
                          _vm.$root.color_schema.primary_btn
                        ),
                      }),attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                          _vm.pageData.product_information.go_link,
                          _vm.pageData.product_information.slug
                        ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.pageData.product_information.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "revbpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]:_vm._e()],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bonus-card-content-bottom"},[_c('span',{staticClass:"span-h6"},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                  _vm.$root.i18n.why_to_choose,
                  _vm.pageData.product_information.name
                )))]),_vm._v(" "),_c('ul',{staticClass:"proslist-rev"},_vm._l((_vm.prosconsReview(_vm.pageData.procons)),function(procon,index){return _c('li',{key:index,class:{
                    pros: procon.is_positive === '1',
                    cons: procon.is_positive === '0',
                  }},[_vm._v("\n                  "+_vm._s(procon.description)+"\n                ")])}),0)])])]),_vm._v(" "),(
            (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
            (_vm.pageData.terms && _vm.pageData.terms != '')
          )?_c('div',{staticClass:"rev-terms-condition"},[(_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '')?_c('span',{staticClass:"terms_tc cas-term",style:({
              '--primary-btn': _vm.$root.color_schema.primary_btn,
            }),domProps:{"innerHTML":_vm._s(_vm.pageData.bonus_tc)}}):_vm._e(),_vm._v(" "),(
              _vm.pageData.bonus_tc &&
              _vm.pageData.terms &&
              _vm.pageData.bonus_tc != '' &&
              _vm.pageData.terms != ''
            )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.pageData.terms && _vm.pageData.terms != '')?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                ? 'nofollow sponsored'
                : 'nofollow',"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(_vm.pageData.term_link, _vm.pageData.slug),"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.terms))]):_vm._e()]):_vm._e()]:_vm._e(),_vm._v(" "),(
          _vm.metaData &&
          _vm.metaData.security_information &&
          _vm.metaData.security_white_box_section
        )?[(
            _vm.metaData.security_information.title != '' &&
            _vm.metaData.security_information.content != ''
          )?_c('div',{staticClass:"max-cntent-area"},[_c('h2',{staticClass:"custom-font-1"},[_vm._v("\n            "+_vm._s(_vm.metaData.security_information.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"custom-font",style:({
              '--heading-font': _vm.$root.font_family.heading,
              '--paragraph-font': _vm.$root.font_family.paragraph,
            }),domProps:{"innerHTML":_vm._s(_vm.metaData.security_information.content)}})]):_vm._e(),_vm._v(" "),(
            _vm.metaData.security_white_box_section.title_1 != '' &&
            _vm.metaData.security_white_box_section.content_1 != '' &&
            _vm.metaData.security_white_box_section.title_2 != '' &&
            _vm.metaData.security_white_box_section.content_2 != ''
          )?_c('div',{staticClass:"\n            casino-card\n            casino-card-software\n            casino-card-payment-method\n            casino-card-security\n          "},[_c('div',{staticClass:"card-icon"},[_c('img',{attrs:{"src":_vm.$root.site_url +
                _vm.$root.asset_path +
                '/svg-icons/security-icon.svg',"alt":"Security Icons"}})]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"card-content-bottom"},[_c('div',{staticClass:"half-column half-column__review"},[_c('div',{staticClass:"half-column-img"},[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.metaData.security_white_box_section.image_1),expression:"metaData.security_white_box_section.image_1"}],attrs:{"alt":"Security Image"}}):_c('img',{attrs:{"src":_vm.metaData.security_white_box_section.image_1,"alt":"Security Image"}})]),_vm._v(" "),_c('div',{staticClass:"half-column-text"},[_c('p',{staticClass:"p-caption"},[_vm._v("\n                    "+_vm._s(_vm.metaData.security_white_box_section.title_1)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"custom-font-2"},[_vm._v("\n                    "+_vm._s(_vm.metaData.security_white_box_section.content_1)+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"half-column half-column__review"},[_c('div',{staticClass:"half-column-img"},[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.metaData.security_white_box_section.image_2),expression:"metaData.security_white_box_section.image_2"}],attrs:{"alt":"Security Image"}}):_c('img',{attrs:{"src":_vm.metaData.security_white_box_section.image_2,"alt":"Security Image"}})]),_vm._v(" "),_c('div',{staticClass:"half-column-text"},[_c('p',{staticClass:"p-caption"},[_vm._v("\n                    "+_vm._s(_vm.metaData.security_white_box_section.title_2)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"custom-font-2"},[_vm._v("\n                    "+_vm._s(_vm.metaData.security_white_box_section.content_2)+"\n                  ")])])])])])]):_vm._e()]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(
      _vm.pageData &&
      _vm.pageData.similar_casinos &&
      _vm.pageData.similar_casinos.length != 0 &&
      _vm.pageIndex > 1
    )?[_c('SimilarCasino',{attrs:{"assetsSize":_vm.assets_images,"componentTitle":_vm.metaData.similar_casinos_title ? _vm.metaData.similar_casinos_title : '',"componentDescription":_vm.metaData.similar_casinos_description
          ? _vm.metaData.similar_casinos_description
          : '',"componentAttrs":{},"componentData":_vm.pageData.similar_casinos,"pageTemplate":'review-page'}})]:_vm._e(),_vm._v(" "),(_vm.morePaymentBottom && _vm.pageIndex > 3)?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(_vm.auhtorBlockdata && _vm.pageIndex > 3)?[_c('Author',{attrs:{"authorData":_vm.auhtorBlockdata}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(645);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("68f08ff4", content, true, {});

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(46);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-32f61dbd]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-32f61dbd]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-32f61dbd]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-32f61dbd]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-32f61dbd]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-32f61dbd]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-32f61dbd]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-32f61dbd]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-32f61dbd]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-32f61dbd]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-32f61dbd]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.lang-img[data-v-32f61dbd]{height:36px;width:36px}.px-0[data-v-32f61dbd]{padding-left:0!important;padding-right:0!important}.pb-1[data-v-32f61dbd]{padding-top:1px!important}.ct-inner-banner[data-v-32f61dbd]{padding:0 0 45px;background:#070438 url(" + escape(__webpack_require__(62)) + ") no-repeat 0 0}.ct-inner-banner .game-space[data-v-32f61dbd]{position:relative;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space[data-v-32f61dbd]{min-height:auto}}.ct-inner-banner .game-space img[data-v-32f61dbd]{border-radius:10px;box-shadow:0 5px 15px rgba(0,0,0,.05);height:100%;object-fit:cover;width:auto;max-height:321px;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space img[data-v-32f61dbd]{width:100%;max-height:none;min-height:auto}}.ct-inner-banner .game-space-content[data-v-32f61dbd]{position:absolute;left:0;right:0;top:0;bottom:0;padding:20px}.ct-inner-banner .game-space-content .button-block[data-v-32f61dbd],.ct-inner-banner .game-space-content[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-inner-banner .game-space-content .button-block[data-v-32f61dbd]{width:100%;margin-bottom:15px}.ct-inner-banner .game-space-content .button-block .cta[data-v-32f61dbd]{min-width:100%;margin:5px 0;font-weight:700;font-size:14px;line-height:17px;padding:10px 18px}@media (min-width:768px){.ct-inner-banner .game-space-content .button-block .cta[data-v-32f61dbd]{min-width:330px;margin:10px 0;padding:15px 18px;font-size:18px;line-height:22px}}.ct-inner-banner .game-space-content .game-logo img[data-v-32f61dbd]{box-shadow:none;max-height:none;min-height:auto}@media (min-width:768px){.ct-inner-banner .row .col-md-8[data-v-32f61dbd]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-8[data-v-32f61dbd]{width:66.66666667%;float:left}}@media (min-width:768px){.ct-inner-banner .row .col-md-4[data-v-32f61dbd]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-4[data-v-32f61dbd]{width:33.33333333%;float:left}}.ct-inner-banner-lft[data-v-32f61dbd]{margin-bottom:19px}@media (min-width:992px){.ct-inner-banner-lft[data-v-32f61dbd]{margin-bottom:0}}@media (min-width:1360px){.ct-inner-banner-lft[data-v-32f61dbd]{width:906px!important}}@media (min-width:1360px){.ct-inner-banner-rgt[data-v-32f61dbd]{width:314px!important}}.new-review-banner-card[data-v-32f61dbd]{padding:12px 16px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;box-shadow:none}@media (min-width:576px){.new-review-banner-card[data-v-32f61dbd]{padding:20px}}@media (min-width:1200px){.new-review-banner-card[data-v-32f61dbd]{padding:30px}}.new-review-banner-card-top[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:768px){.new-review-banner-card-top[data-v-32f61dbd]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-top-left[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:auto;margin:0 -7px 18px -6px}@media (min-width:350px){.new-review-banner-card-top-left[data-v-32f61dbd]{margin:0 -7px 18px 5px;justify-content:unset!important}}@media (min-width:576px){.new-review-banner-card-top-left[data-v-32f61dbd]{width:100%;margin:0 0 28px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}}@media (min-width:768px){.new-review-banner-card-top-left[data-v-32f61dbd]{margin:0 0 45px}}@media (min-width:1024px){.new-review-banner-card-top-left[data-v-32f61dbd]{width:calc(100% - 400px);margin:0 0 5px}}@media (min-width:1080px){.new-review-banner-card-top-left[data-v-32f61dbd]{width:calc(100% - 430px)}}@media (min-width:1200px){.new-review-banner-card-top-left[data-v-32f61dbd]{width:calc(100% - 495px)}}.new-review-banner-card-top-left .review-left-img[data-v-32f61dbd]{min-width:79px;max-width:79px;height:79px;background:#fff;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative}.new-review-banner-card-top-left .review-left-img a[data-v-32f61dbd]{box-shadow:0 2px 4px rgba(0,0,0,.2);border-radius:12px;overflow:visible;margin-top:0}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img a[data-v-32f61dbd]{margin-top:4px}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-img a[data-v-32f61dbd]{margin-top:4px}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-img a[data-v-32f61dbd]{margin-top:0}}.new-review-banner-card-top-left .review-left-img img[data-v-32f61dbd]{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img img[data-v-32f61dbd]{height:100%;width:100%}}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img[data-v-32f61dbd]{min-width:245px;max-width:245px;height:245px}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-img[data-v-32f61dbd]{min-width:245px;max-width:245px;height:245px}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-img[data-v-32f61dbd]{min-width:250px;max-width:250px;height:250px}}.new-review-banner-card-top-left .review-left-img .exclusive-tag[data-v-32f61dbd]{position:absolute;left:0;right:0;margin:auto;height:20px;font-size:12px;line-height:15px;width:100%;bottom:0;border-radius:0;border-bottom-left-radius:8px;border-bottom-right-radius:8px;display:flex;justify-content:center;align-items:center}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img .exclusive-tag[data-v-32f61dbd]{bottom:14px;width:210px;height:28px;font-size:17px;line-height:28px;z-index:10;border-radius:8px}}.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-32f61dbd]{width:18px!important;height:18px!important;border-radius:0!important;vertical-align:initial!important;object-fit:contain!important}@media (max-width:576px){.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-32f61dbd]{margin:0 auto;width:14px!important;height:14px!important}}@media (min-width:576px){.new-review-banner-card-top-left .review-left-img .exclusive-tag p[data-v-32f61dbd]{font-weight:700;margin-top:0;font-size:12px;margin:0}}@media (max-width:768px){.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-32f61dbd],.new-review-banner-card-top-left .review-left-img .exclusive-tag svg[data-v-32f61dbd]{width:12px}}.new-review-banner-card-top-left .review-left-content[data-v-32f61dbd]{padding:10px 0 5px 15px;height:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content[data-v-32f61dbd]{padding:0 30px}}.new-review-banner-card-top-left .review-left-content .approve[data-v-32f61dbd]{font-weight:400;font-size:12px;line-height:15px;color:#9b9b9b;margin-bottom:8px;margin-top:10px;display:block}.new-review-banner-card-top-left .review-left-content .approve i[data-v-32f61dbd]{margin-right:5px}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .approve i[data-v-32f61dbd]{margin-right:7px}}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .approve[data-v-32f61dbd]{font-size:14px;line-height:17px;color:#aeaeae}}.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:0;margin-top:0}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-32f61dbd]{margin-bottom:4px;margin-top:0}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-32f61dbd]{-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:4px;margin-top:0}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-32f61dbd]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:4px;margin-top:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar p[data-v-32f61dbd]{margin-bottom:4px;font-weight:400;color:#222;padding-right:7px}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .exclusive-bar p[data-v-32f61dbd]{margin-bottom:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar .exclusive-tag[data-v-32f61dbd]{margin-left:30px;display:none}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar .exclusive-tag[data-v-32f61dbd]{display:none}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-rating[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title[data-v-32f61dbd]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title p[data-v-32f61dbd]{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;margin-bottom:4px;margin-top:4px;font-size:14px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title p[data-v-32f61dbd]{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;margin-bottom:4px;font-size:16px}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:0;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;margin-bottom:5px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust[data-v-32f61dbd]{margin-left:8px;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;margin-bottom:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust strong[data-v-32f61dbd]{font-weight:700;font-size:10px;line-height:1;text-transform:uppercase;color:#4caf50}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust i[data-v-32f61dbd]{background:#4caf50;width:8.35px;height:8.35px;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:3.65px}.new-review-banner-card-top-left .review-left-content-title[data-v-32f61dbd]{display:none}.new-review-banner-card-top-left .review-left-content-title h1[data-v-32f61dbd]{margin-bottom:12px}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-content-title h1[data-v-32f61dbd]{margin-bottom:12px}}.new-review-banner-card-top-left .review-left-content-title .cta[data-v-32f61dbd]{min-width:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content-title[data-v-32f61dbd]{display:block}}.new-review-banner-card-top .view-mob[data-v-32f61dbd]{display:block;text-align:center}.new-review-banner-card-top .view-mob h1[data-v-32f61dbd]{margin-bottom:17px;padding:0 10%}.new-review-banner-card-top .view-mob .cta-promo-review[data-v-32f61dbd]{font-size:18px;line-height:100%;margin-top:0;display:block}@media (min-width:768px){.new-review-banner-card-top .view-mob[data-v-32f61dbd]{display:none}}.new-review-banner-card-top-right[data-v-32f61dbd]{min-width:100%;margin-top:17px;border-top:0;border-right:0;border-left:0;padding:0}@media (min-width:768px){.new-review-banner-card-top-right[data-v-32f61dbd]{width:calc(100% - 315px);min-width:calc(100% - 315px);border-right:1px solid #e5e5e5;border-left:0;padding:0 45px 0 0;margin-top:0}}@media (min-width:1024px){.new-review-banner-card-top-right[data-v-32f61dbd]{width:400px;min-width:auto;padding:0 0 0 35px;border-right:0;border-left:1px solid #e5e5e5}}@media (min-width:1080px){.new-review-banner-card-top-right[data-v-32f61dbd]{width:430px}}@media (min-width:1200px){.new-review-banner-card-top-right[data-v-32f61dbd]{width:495px}}.new-review-banner-card-top-right h6[data-v-32f61dbd]{color:#222}@media (min-width:576px){.new-review-banner-card-top-right h6[data-v-32f61dbd]{margin:0 0 3px;color:#222}}.new-review-banner-card-top-right p[data-v-32f61dbd]{color:#222}@media (min-width:576px){.new-review-banner-card-top-right p[data-v-32f61dbd]{margin:0 0 20px;color:#465867}}.new-review-banner-card-bottom[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-top:0;padding:16px 0 0;min-width:100%;width:100%}@media (min-width:768px){.new-review-banner-card-bottom[data-v-32f61dbd]{padding:0 0 0 45px;margin-top:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:315px;width:315px}}@media (min-width:1024px){.new-review-banner-card-bottom[data-v-32f61dbd]{border-top:1px solid #e5e5e5;width:100%;min-width:auto;padding:24px 0 0;margin-top:32px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-bottom .casino-card-lists[data-v-32f61dbd]{margin-bottom:0}@media (min-width:768px){.new-review-banner-card-bottom .casino-card-lists[data-v-32f61dbd]{margin-bottom:10px}}@media (min-width:1200px){.new-review-banner-card-bottom .casino-card-lists[data-v-32f61dbd]{margin-bottom:0}}.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-32f61dbd]{margin-right:15px}.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-32f61dbd]:last-child{margin-right:0}@media (min-width:992px){.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-32f61dbd]{margin-right:16px}}.ct-editor-section .container[data-v-32f61dbd]{position:static}.editor-content .max-cntent-area[data-v-32f61dbd]{max-width:960px}.editor-content h1[data-v-32f61dbd]{line-height:44px}.editor-content img[data-v-32f61dbd]{margin-bottom:20px}.editor-content ul[data-v-32f61dbd]{list-style-type:none;padding:0}.editor-content ul li[data-v-32f61dbd]{font-style:normal;font-weight:400;font-size:16px;line-height:25px;position:relative;padding-left:20px;margin-bottom:15px}.editor-content ul li span[data-v-32f61dbd]{font-weight:700}#sticky-nav[data-v-32f61dbd]{padding-bottom:30px}.review-top-menu[data-v-32f61dbd]{padding-bottom:30px;padding-top:14px;background:#fff;border-bottom:1px solid #bbb;padding:0 14px;height:53px;margin-bottom:0}.review-top-menu .scroll-nav[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow-x:auto;overflow-y:hidden;white-space:nowrap;border-bottom:1px solid #bbb;max-width:1210px;margin:0 auto;height:53px}.review-top-menu .scroll-nav .scroll-item[data-v-32f61dbd]{margin-right:30px;display:inline-block;padding:10px 0;position:relative;font-weight:700;font-size:18px;color:#222;line-height:25px;cursor:pointer;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s}.review-top-menu .scroll-nav .scroll-item.active[data-v-32f61dbd],.review-top-menu .scroll-nav .scroll-item[data-v-32f61dbd]:hover{color:var(--primary-btn)}.review-top-menu .scroll-nav .scroll-item.active[data-v-32f61dbd]:after,.review-top-menu .scroll-nav .scroll-item[data-v-32f61dbd]:hover:after{bottom:0}.review-top-menu .scroll-nav .scroll-item.active[data-v-32f61dbd]{font-weight:700}.sticky[data-v-32f61dbd]{position:-webkit-sticky;position:sticky;top:0;z-index:5}.casino-card-lists ul li[data-v-32f61dbd]{margin:0 32px 0 0}.casino-card-lang-lists ul[data-v-32f61dbd]{margin:0}@media (min-width:992px){.casino-card-lists ul[data-v-32f61dbd]{margin-bottom:20px}}.casino-card-lang-lists ul li[data-v-32f61dbd]{width:36px;height:36px;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;overflow:hidden;margin:0 6px 6px 0;padding:0;border:1px solid #bbb}.new-review-banner-card-top-right h6[data-v-32f61dbd],.review-banner-card-top-right h6[data-v-32f61dbd]{margin-bottom:3px}.review-top-menu ul li a[data-v-32f61dbd],.review-top-menu ul li a[data-v-32f61dbd]:active{padding:10px 20px 10px 0;font-weight:400;font-size:16px;color:#9b9b9b;line-height:25px}.rating-wrapper-small .radio-star-total[data-v-32f61dbd]{padding-left:10px;line-height:20px}.casino-card-lists ul li[data-v-32f61dbd]{margin:0 12px 0 0;padding:0;list-style-type:none}@media (min-width:374px){.casino-card-lists ul li[data-v-32f61dbd]{margin:0 16px 0 0}}.casino-card-lists__review h6[data-v-32f61dbd]{font-weight:400}.bonus-card-logo[data-v-32f61dbd]{background:#fff!important;height:280px!important}.bonus-card-logo a[data-v-32f61dbd]{text-align:center}.bonus-card-logo img[data-v-32f61dbd]{height:100%;width:100%;object-fit:cover;border-radius:12px 12px 0 0}@media (min-width:992px){.bonus-card-logo img[data-v-32f61dbd]{border-radius:12px 0 0 12px;width:100%}}@media (min-width:768px){.bonus-card-logo[data-v-32f61dbd]{height:100%!important}}.bonus-card-content[data-v-32f61dbd]{overflow:hidden;display:flex;flex-wrap:wrap;align-items:center}@media (min-width:768px){.bonus-card-content[data-v-32f61dbd]{padding:30px 45px}}.bonus-card-content-top[data-v-32f61dbd]{width:100%}.justify-flex-start[data-v-32f61dbd]{justify-content:flex-start!important}@media (max-width:990px){.license-right[data-v-32f61dbd]{display:flex;align-items:center;justify-content:flex-end;margin-top:10px;margin-bottom:10px!important}}@media (min-width:992px){.license-right[data-v-32f61dbd]{text-align:right}}@media (min-width:992px){.justify-flex-end[data-v-32f61dbd]{justify-content:flex-end!important}}.justify-flex-end li[data-v-32f61dbd]:last-child{margin-right:0}.casino-card-bonus[data-v-32f61dbd]{margin:0;flex-direction:row}@media (min-width:992px){.casino-card-bonus[data-v-32f61dbd]{padding:16px;min-height:296px}}@media (min-width:1200px){.casino-card-bonus[data-v-32f61dbd]{min-height:296px;height:auto}}.casino-card-bonus .bonus-card-logo[data-v-32f61dbd]{padding:16px;box-shadow:none;height:auto!important;min-height:280px!important;position:relative}@media (min-width:768px){.casino-card-bonus .bonus-card-logo[data-v-32f61dbd]{padding:0;box-shadow:0 5px 15px rgba(0,0,0,.05);width:265px;min-height:265px!important;border-radius:0;border-top-left-radius:12px}}@media (min-width:992px){.casino-card-bonus .bonus-card-logo[data-v-32f61dbd]{border-radius:5px}}.casino-card-bonus .bonus-card-logo img[data-v-32f61dbd]{border-radius:5px}@media (min-width:768px){.casino-card-bonus .bonus-card-logo img[data-v-32f61dbd]{border-radius:0;border-top-left-radius:12px;border-bottom-left-radius:12px}}@media (min-width:992px){.casino-card-bonus .bonus-card-logo img[data-v-32f61dbd]{border-radius:5px}}@media (min-width:768px){.casino-card-bonus .bonus-card-logo img.no-terms[data-v-32f61dbd]{border-bottom-left-radius:0}}@media (min-width:992px){.casino-card-bonus .bonus-card-logo img.no-terms[data-v-32f61dbd]{border-radius:5px}}.casino-card-bonus .bonus-card-content[data-v-32f61dbd]{padding:0 16px 16px}@media (min-width:768px){.casino-card-bonus .bonus-card-content[data-v-32f61dbd]{padding:20px 0 20px 16px;align-items:flex-start;width:calc(100% - 265px);flex-direction:row;min-height:265px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content[data-v-32f61dbd]{padding:0 0 0 16px}}.casino-card-bonus .bonus-card-content-top[data-v-32f61dbd]{flex-direction:column}@media (min-width:768px){.casino-card-bonus .bonus-card-content-top[data-v-32f61dbd]{align-items:center;flex-direction:row}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-top[data-v-32f61dbd]{margin-bottom:16px;align-items:flex-start}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-top .half-column-cont[data-v-32f61dbd]{max-width:450px}}.casino-card-bonus .bonus-card-content-top .half-column-cont .bonus-card-rating[data-v-32f61dbd]{flex-direction:column;justify-content:center;align-items:flex-start}.casino-card-bonus .bonus-card-content-top .half-column-cont .bonus-card-rating p[data-v-32f61dbd]{font-weight:700}.casino-card-bonus .bonus-card-content-top .half-column-cont span[data-v-32f61dbd]{font-size:22px}@media (min-width:992px){.casino-card-bonus .bonus-card-content-top .half-column-cont span[data-v-32f61dbd]{font-size:28px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-top .play_term_wrapper[data-v-32f61dbd]{align-items:flex-end}}.casino-card-bonus .bonus-card-content-top .play_term_wrapper a[data-v-32f61dbd]{min-width:100%}@media (min-width:768px){.casino-card-bonus .bonus-card-content-top .play_term_wrapper a[data-v-32f61dbd]{min-width:150px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-top .play_term_wrapper a[data-v-32f61dbd]{min-width:332px}}.casino-card-bonus .bonus-card-content-bottom[data-v-32f61dbd]{padding-top:16px;width:100%}@media (min-width:768px){.casino-card-bonus .bonus-card-content-bottom[data-v-32f61dbd]{padding-top:8px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-bottom[data-v-32f61dbd]{padding-top:16px}}.casino-card-bonus .bonus-card-content-bottom .span-h6[data-v-32f61dbd]{font-size:16px;margin-bottom:12px}@media (min-width:768px){.casino-card-bonus .bonus-card-content-bottom .span-h6[data-v-32f61dbd]{font-size:16px;margin-bottom:6px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-bottom .span-h6[data-v-32f61dbd]{font-size:16px;margin-bottom:12px}}.casino-card-bonus .bonus-card-content-bottom .proslist-rev li[data-v-32f61dbd]{margin-bottom:14px}@media (min-width:768px){.casino-card-bonus .bonus-card-content-bottom .proslist-rev li[data-v-32f61dbd]{margin-bottom:1px}}@media (min-width:992px){.casino-card-bonus .bonus-card-content-bottom .proslist-rev li[data-v-32f61dbd]{margin-bottom:14px}}@media (min-width:768px){.offset-md-1[data-v-32f61dbd]{margin-left:2.33333%}}.play_term_wrapper[data-v-32f61dbd]{display:flex;flex-direction:column;align-items:center}.play_term_wrapper .terms_tc[data-v-32f61dbd]{margin-bottom:8px}.play_term_wrapper .btn-cust[data-v-32f61dbd]{margin:18px 0!important}.mx-0[data-v-32f61dbd]{margin-left:0;margin-right:0}.flex-wrap[data-v-32f61dbd]{flex-wrap:wrap!important}.sticky-review-card[data-v-32f61dbd]{bottom:0;left:0;right:0;z-index:1000;position:fixed;color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.05);transition:top .3s ease-out}@media (min-width:992px){.sticky-review-card .rating-wrapper-small[data-v-32f61dbd]{display:inline-flex;height:24px;border-radius:50px;margin-left:15px;padding:1px 7px}.sticky-review-card .rating-wrapper-small .radio-star-total[data-v-32f61dbd]{margin-left:0}}.sticky-review-card .sticky-inner[data-v-32f61dbd]{background:var(--primary-btn);position:absolute;bottom:0;width:100%;max-width:78.125rem;padding:10px;display:flex;align-items:center;margin:0 auto;flex-wrap:wrap}@media (min-width:768px){.sticky-review-card .sticky-inner[data-v-32f61dbd]{flex-wrap:nowrap}}@media (min-width:992px){.sticky-review-card .sticky-inner[data-v-32f61dbd]{background:#fff;position:relative}}.sticky-review-card .sticky-inner .md-rating[data-v-32f61dbd]{margin-top:10px;display:none}@media (min-width:768px){.sticky-review-card .sticky-inner .md-rating[data-v-32f61dbd]{margin-top:8px;margin-left:-12px;display:inline-flex;height:18px;border-radius:50px;padding:1px 7px;align-items:stretch}}.sticky-review-card .sticky-inner .md-rating .radio-stars[data-v-32f61dbd]{height:14px;width:14px}.sticky-review-card .sticky-inner .md-rating .radio-stars img[data-v-32f61dbd]{border-radius:0;vertical-align:text-top}.sticky-review-card .sticky-inner .md-rating .radio-star-total[data-v-32f61dbd]{font-size:14px;line-height:15px;padding-left:0;display:inline-flex;align-items:center}.sticky-review-card .sticky-inner .md-rating .radio-star-total span[data-v-32f61dbd]{font-size:14px;line-height:15px}@media (min-width:992px){.sticky-review-card .sticky-inner .md-rating[data-v-32f61dbd]{display:none}}.sticky-review-card .sticky-inner .sticky-text[data-v-32f61dbd]{font-size:.875rem;margin-left:10px;margin-right:auto;line-height:.75rem;width:calc(100% - 60px)}@media (min-width:576px){.sticky-review-card .sticky-inner .sticky-text[data-v-32f61dbd]{line-height:unset}}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text[data-v-32f61dbd]{width:100%;margin-left:80px}}.sticky-review-card .sticky-inner .sticky-text .product-name[data-v-32f61dbd]{display:flex;padding:0 0 5px}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text .product-name[data-v-32f61dbd]{display:none}}.sticky-review-card .sticky-inner .sticky-text .product-name .best-rating[data-v-32f61dbd]{margin-left:8px}.sticky-review-card .sticky-inner .sticky-text .sticky-title[data-v-32f61dbd]{display:none}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .sticky-title[data-v-32f61dbd]{display:flex}}.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-32f61dbd]{font-weight:900;font-size:.875rem;line-height:14px}@media (min-width:576px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-32f61dbd]{line-height:25px}}.sticky-review-card .sticky-inner .sticky-text .bonus-text a[data-v-32f61dbd]{color:#fff}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-32f61dbd]{font-size:.85rem}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-32f61dbd]{font-size:1.625rem}.sticky-review-card .sticky-inner .sticky-text .bonus-text a[data-v-32f61dbd]{color:#222}}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text[data-v-32f61dbd]{font-size:.85rem}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text[data-v-32f61dbd]{margin-left:0}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .terms-conditions[data-v-32f61dbd]{padding-top:5px!important}}.sticky-review-card .sticky-inner .affliate-logo[data-v-32f61dbd]{height:50px;width:50px;min-height:50px;min-width:50px;box-shadow:0 5px 15px rgba(0,0,0,.09);left:0;position:relative}.sticky-review-card .sticky-inner .affliate-logo img[data-v-32f61dbd]{border-radius:12px}@media (min-width:768px){.sticky-review-card .sticky-inner .affliate-logo[data-v-32f61dbd]{top:-25px;position:absolute}}@media (min-width:992px){.sticky-review-card .sticky-inner .affliate-logo[data-v-32f61dbd]{width:85px;min-width:85px;height:85px;min-height:85px;top:0;left:0;position:relative;margin-right:30px}}.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-32f61dbd]{display:none;font-size:18px;line-height:100%;margin:auto 2px!important}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-32f61dbd]{display:block;background:var(--primary-btn);border-color:var(--primary-btn);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:inset 0 -4px 4px var(--primary-btn);min-width:280px;font-weight:900}}.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-32f61dbd]:hover{background:var(--primary-btn-hover);border-color:var(--primary-btn-hover);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn-hover);box-shadow:inset 0 -4px 4px var(--primary-btn-hover)}.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-32f61dbd]{display:none;font-size:18px;line-height:100%;color:#3672f8!important}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-32f61dbd]{display:block;background:#fff;border-color:var(--primary-btn);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:none;margin:0;min-width:210px;height:34px;margin-left:auto}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-32f61dbd]{display:none}}.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-32f61dbd]:hover{color:#fff;background:var(--primary-btn-hover);border-color:var(--primary-btn-hover);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn-hover);box-shadow:inset 0 -4px 4px var(--primary-btn-hover)}.sticky-review-card .sticky-inner .sticky-play-btn-mobile[data-v-32f61dbd]{background:#fff;color:var(--primary-btn);color:#3672f8!important;border-color:var(--primary-btn);box-shadow:none;margin:0;line-height:100%;font-size:.75rem;width:78px;height:34px;padding:10px 20px}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-play-btn-mobile[data-v-32f61dbd]{display:none}}@media (min-width:992px){.sticky-review-card[data-v-32f61dbd]{top:-110px;height:110px;background:#fff;color:#222}}.mr-30[data-v-32f61dbd]{margin-right:30px!important}.minus[data-v-32f61dbd]:before{content:\"-\";font-size:1.9rem}.h-100[data-v-32f61dbd]{height:100%}.w-100[data-v-32f61dbd]{width:100%}.lang-flag[data-v-32f61dbd]{height:34px!important;width:60px!important;object-fit:cover}.flex-wrap[data-v-32f61dbd]{display:flex;flex-wrap:wrap}figure>img[data-v-32f61dbd]{height:100%;width:100%}.md-rating .radio-star-total[data-v-32f61dbd],.md-rating .radio-star-total span[data-v-32f61dbd]{color:#000!important;font-size:10px!important;line-height:10px!important}.view-mob .span-h1[data-v-32f61dbd]{font-size:24px!important;line-height:27px!important}@media (min-width:576px){.view-mob .span-h1[data-v-32f61dbd]{font-size:36px!important;line-height:44px!important}}.rv-terms[data-v-32f61dbd]{display:block}.desk-terms[data-v-32f61dbd]{display:none}@media (min-width:576px){.desk-terms[data-v-32f61dbd]{display:block}}.mob-terms[data-v-32f61dbd]{display:block;font-size:.75rem;line-height:13px;width:100%;text-align:center;padding:10px 0 0}@media (min-width:576px){.mob-terms[data-v-32f61dbd]{display:none}}.mob-terms .terms-conditions[data-v-32f61dbd]{color:#fff}.mob-terms .terms-conditions a[data-v-32f61dbd]{color:#fff!important;text-decoration:underline!important}.mob-terms .mob-cas-term[data-v-32f61dbd]{color:#fff}.div-term[data-v-32f61dbd]{position:absolute;background-color:#dfe1e3;padding:7px;left:0;width:100%;border-bottom-right-radius:12px;border-bottom-left-radius:12px;line-height:20px;position:static;width:auto;margin:0 -16px -20px;text-align:center}@media (min-width:768px){.div-term[data-v-32f61dbd]{padding:10px 12px;text-align:left;position:static;width:auto;margin:0 -20px -20px}}@media (min-width:992px){.div-term[data-v-32f61dbd]{padding:5px 12px;position:static;width:auto;margin:0 -30px -30px}}.div-term a[data-v-32f61dbd]{cursor:pointer;color:var(--primary-btn)}.div-term a[data-v-32f61dbd]:hover{color:var(--primary-btn)}.terms-d[data-v-32f61dbd]{position:relative}.stick-img img[data-v-32f61dbd]{width:100%}.desk-bonus[data-v-32f61dbd]{display:none}@media (min-width:576px){.desk-bonus[data-v-32f61dbd]{display:block}}.mob-bonus[data-v-32f61dbd]{display:block}@media (min-width:576px){.mob-bonus[data-v-32f61dbd]{display:none}}.overall-rating[data-v-32f61dbd]{background:#fff;border:1px solid #f3f2f5;box-shadow:0 0 20px 0 rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.overall-rating .rating-header[data-v-32f61dbd]{background:#f7f7f7;-webkit-border-radius:12px 12px 0 0;-moz-border-radius:12px 12px 0 0;border-radius:12px 12px 0 0;padding:5px 10px 4px 16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}@media (min-width:992px){.overall-rating .rating-header[data-v-32f61dbd]{padding:7px 30px 6px 26px}}.overall-rating .rating-header .span-h2[data-v-32f61dbd]{font-weight:700;color:#020100;margin:0;font-size:20px}@media (min-width:576px){.overall-rating .rating-header .span-h2[data-v-32f61dbd]{font-size:22px}}.overall-rating .rating-header .rating-count[data-v-32f61dbd]{min-width:65px;min-height:43px;-webkit-border-radius:7.75px;-moz-border-radius:7.75px;border-radius:7.75px;position:relative}.overall-rating .rating-header .rating-count .comment[data-v-32f61dbd]{position:absolute;left:0;right:0;bottom:0;-webkit-border-radius:0 0 7.75px 7.75px;-moz-border-radius:0 0 7.75px 7.75px;border-radius:0 0 7.75px 7.75px;font-style:italic;font-weight:400;font-size:12px;line-height:15px;text-align:center;letter-spacing:-.03em;color:#fff;padding:1px 5px;display:block;box-shadow:inset 0 0 40px rgba(0,0,0,.2)}.overall-rating .rating-header .rating-count-top[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.overall-rating .rating-header .rating-count-top .value[data-v-32f61dbd]{font-weight:700;font-size:18px;line-height:27px;text-align:center;letter-spacing:-.03em;color:#fff;margin-top:2px}@media (min-width:576px){.overall-rating .rating-header .rating-count-top .value[data-v-32f61dbd]{font-size:20px}}.overall-rating .rating-header .rating-count-top .full-star[data-v-32f61dbd]{margin-left:4px;width:14px;height:14px;background:#fabf00;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;margin-right:0;position:relative;font-style:normal}.overall-rating .rating-header .rating-count-top .full-star[data-v-32f61dbd]:after{content:\" \\2605\";position:absolute;top:50%;left:50%;color:#fff;font-size:10px;transform:translate(-50%,-50%)}.overall-rating .progress-bar-block[data-v-32f61dbd]{padding:8px 8px 20px}@media (min-width:992px){.overall-rating .progress-bar-block[data-v-32f61dbd]{padding:20px 35px 19px 27px}}.overall-rating .progress-bar-block .bar-row[data-v-32f61dbd]{margin-bottom:20px}.overall-rating .progress-bar-block .bar-row[data-v-32f61dbd]:last-child{margin-bottom:0}.overall-rating .progress-bar-block .bar-row .label[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:5px}.overall-rating .progress-bar-block .bar-row .label p[data-v-32f61dbd]{font-weight:400;color:#222;margin:0;font-size:14px;overflow-wrap:anywhere;margin-right:10px}@media (min-width:992px){.overall-rating .progress-bar-block .bar-row .label p[data-v-32f61dbd]{font-size:16px}}.overall-rating .progress-bar-block .bar-row .label span[data-v-32f61dbd]{font-weight:700;font-size:18px;line-height:30px;text-align:right;text-transform:capitalize;color:#222;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (min-width:992px){.overall-rating .progress-bar-block .bar-row .label span[data-v-32f61dbd]{font-size:20px}}.overall-rating .progress-bar-block .bar-row .label span .full-star[data-v-32f61dbd]{margin-left:8.5px;width:14px;height:14px;background:#fabf00;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;margin-right:0;position:relative;bottom:1px;font-style:normal}.overall-rating .progress-bar-block .bar-row .label span .full-star[data-v-32f61dbd]:after{content:\" \\2605\";position:absolute;top:50%;left:50%;color:#fff;font-size:10px;transform:translate(-50%,-50%)}.overall-rating .progress-bar-block .bar-row .bar-rail[data-v-32f61dbd]{width:100%;height:6px;background:hsla(0,1%,81%,.6);-webkit-border-radius:52.8455px;-moz-border-radius:52.8455px;border-radius:52.8455px;overflow:hidden}.overall-rating .progress-bar-block .bar-row .bar-rail .progress-indicator[data-v-32f61dbd]{-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;height:6px}.wd-mar[data-v-32f61dbd]{width:100%!important}@media (max-width:1024px){.wd-mar[data-v-32f61dbd]{margin-left:0}}.cust-span[data-v-32f61dbd]{font-size:24px!important;line-height:27px!important}@media (min-width:576px){.cust-span[data-v-32f61dbd]{font-size:32px!important;line-height:40px!important}}@media (min-width:576px){.ct-btn[data-v-32f61dbd]{margin-top:0!important}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust i img[data-v-32f61dbd]{width:8.35px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content[data-v-32f61dbd]{width:calc(100% - 250px)}}.rev-terms-condition[data-v-32f61dbd]{background:#dfe1e3;border-bottom-left-radius:12px;border-bottom-right-radius:12px;padding:5px 12px;line-height:20px;width:100%;text-align:center}@media (min-width:768px){.rev-terms-condition[data-v-32f61dbd]{text-align:left}}.rev-terms-condition a[data-v-32f61dbd]{cursor:pointer}.rev-terms-condition a[data-v-32f61dbd]:hover{color:var(--primary-btn)}.rm-border[data-v-32f61dbd]{border-bottom-right-radius:0!important}.exclu-rev[data-v-32f61dbd],.exclu-rev img[data-v-32f61dbd],.rm-border[data-v-32f61dbd]{border-bottom-left-radius:0!important}.pay-i[data-v-32f61dbd],.prod-i[data-v-32f61dbd],.soft-i[data-v-32f61dbd]{margin-right:0!important}.sticky-nav-review-block[data-v-32f61dbd]{position:sticky;display:block;z-index:10}.stripe-sticky[data-v-32f61dbd]{display:block!important;text-align:center}.stripe-sticky p[data-v-32f61dbd]{font-weight:700}.stripe-sticky[data-v-32f61dbd]{position:absolute;width:50px;top:50%;transform:translateY(6px);overflow:hidden;border-bottom-left-radius:10px;border-bottom-right-radius:10px;background-color:#ffd039;display:none;height:20px;line-height:20px}@media (min-width:768px){.stripe-sticky[data-v-32f61dbd]{display:block;bottom:0;left:0;width:100%}}@media (min-width:992px){.stripe-sticky[data-v-32f61dbd]{transform:translateY(25px)}}.stripe-sticky img[data-v-32f61dbd]{width:14px!important;height:14px!important;margin:3px auto;border-radius:0!important}@media (max-width:768px){.stripe-sticky svg[data-v-32f61dbd]{width:12px}}.desk-excl[data-v-32f61dbd]{display:none}@media (min-width:768px){.desk-excl[data-v-32f61dbd]{display:flex}}.desk-excl img[data-v-32f61dbd]{margin-right:5px}.mob-excl[data-v-32f61dbd]{display:block}@media (min-width:768px){.mob-excl[data-v-32f61dbd]{display:none}}@media (max-width:767px){.mob-excl[data-v-32f61dbd]{display:block;margin:0 auto}}.desk-ra-excl[data-v-32f61dbd]{display:none}@media (min-width:768px){.desk-ra-excl[data-v-32f61dbd]{display:flex}}.mob-ra-excl[data-v-32f61dbd]{display:block}@media (min-width:768px){.mob-ra-excl[data-v-32f61dbd]{display:none}}.exclusive-tag-rev[data-v-32f61dbd]{position:absolute;left:0;right:0;margin:0 16px;font-size:12px;line-height:15px;border-radius:0 0 5px 5px;width:calc(100% - 32px);bottom:10px;height:28px;display:flex;justify-content:center}@media (min-width:768px){.exclusive-tag-rev[data-v-32f61dbd]{border-radius:8px;margin:auto;bottom:14px;width:90%;font-size:17px;line-height:28px;z-index:10}}@media (min-width:992px){.exclusive-tag-rev[data-v-32f61dbd]{width:210px;bottom:10px}}.exclusive-tag-rev img[data-v-32f61dbd]{width:18px!important;height:18px!important;border-radius:0!important;object-fit:contain!important;margin-right:5px}.exclusive-tag-rev p[data-v-32f61dbd]{font-weight:700;font-size:12px;margin:0;display:flex;align-items:center}.exclu-rev[data-v-32f61dbd]{position:relative}.casino-card ul.proslist-rev[data-v-32f61dbd]{margin:0;padding:0;list-style:none;column-count:0;display:block}@media (min-width:576px){.casino-card ul.proslist-rev[data-v-32f61dbd]{column-count:2;-ms-flex-wrap:wrap;flex-wrap:wrap;display:-webkit-box;display:-ms-flexbox;display:flex}}.casino-card ul.proslist-rev li[data-v-32f61dbd]{width:100%;text-align:left;padding-left:32px;line-height:25px;color:#222;margin-bottom:14px;background-size:15px 15px}.casino-card ul.proslist-rev li[data-v-32f61dbd]:last-child{margin-bottom:0}@media (min-width:576px){.casino-card ul.proslist-rev li[data-v-32f61dbd]{width:50%}}.casino-card ul.proslist-rev li.pros[data-v-32f61dbd]{column-count:unset;display:block;position:relative}.casino-card ul.proslist-rev li.pros[data-v-32f61dbd]:before{position:absolute;content:\"\";left:0;top:0;display:inline-block;transform:translateY(0);height:24px;width:24px;background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:14px}.casino-card ul.proslist-rev li.pros li[data-v-32f61dbd]{width:100%;font-size:16px;line-height:25px;margin-bottom:25px;background-position:0 5px}.casino-card ul.proslist-rev li.pros li[data-v-32f61dbd]:last-child{margin-bottom:0}.casino-card ul.proslist-rev li.cons[data-v-32f61dbd]{column-count:unset;display:block;position:relative}.casino-card ul.proslist-rev li.cons[data-v-32f61dbd]:before{position:absolute;content:\"\";left:0;top:0;display:inline-block;transform:translateY(0);height:24px;width:24px;background:#fe4646 url(" + escape(__webpack_require__(73)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:14px}.casino-card ul.proslist-rev li.cons li[data-v-32f61dbd]{width:100%;font-size:16px;line-height:25px;margin-bottom:25px;background-size:15px 15px}.casino-card ul.proslist-rev li.cons li[data-v-32f61dbd]:last-child{margin-bottom:0}.p-caption[data-v-32f61dbd]{font-weight:700;margin-bottom:0}.casino-card-lists ul li figure img[data-v-32f61dbd]{margin:0}.developer-card[data-v-32f61dbd]{background:#fff;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;padding:16px;width:100%;max-width:600px}.developer-card .card-header[data-v-32f61dbd]{background:#f1f2f3;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;padding:19px 16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:16px;flex-wrap:wrap}@media (min-width:576px){.developer-card .card-header[data-v-32f61dbd]{padding:20px 16px}}@media (min-width:992px){.developer-card .card-header[data-v-32f61dbd]{flex-wrap:nowrap}}.developer-card .card-header .first-head[data-v-32f61dbd]{margin-right:0}@media (min-width:992px){.developer-card .card-header .first-head[data-v-32f61dbd]{margin-right:8px}}.developer-card .card-header .second-head[data-v-32f61dbd]{margin-top:8px}@media (min-width:992px){.developer-card .card-header .second-head[data-v-32f61dbd]{margin-top:0}}.developer-card .card-header p[data-v-32f61dbd]{margin-bottom:0;font-family:Helvetica;font-weight:400;font-size:16px;line-height:1;color:#222}.developer-card .card-header p strong[data-v-32f61dbd]{font-weight:700}.developer-card .card-header p i[data-v-32f61dbd]{margin-right:8px}.developer-card .card-header p i img[data-v-32f61dbd]{width:19px;margin-bottom:0}.developer-card .card-body .withdrl[data-v-32f61dbd]{margin-top:16px}.developer-card .card-body .span-h6[data-v-32f61dbd]{font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;margin-bottom:8px}.developer-card .card-body ul[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin:0 -6px}.developer-card .card-body ul li[data-v-32f61dbd]{font-style:normal;font-weight:400;font-size:16px;line-height:25px;position:relative;margin:0 8px 12px}@media (min-width:375px){.developer-card .card-body ul li[data-v-32f61dbd]{margin:0 9px 12px}}@media (min-width:425px){.developer-card .card-body ul li[data-v-32f61dbd]{margin:0 14px 12px}}@media (min-width:576px){.developer-card .card-body ul li[data-v-32f61dbd]{margin:0 6px 8px}}.developer-card .card-body ul li figure[data-v-32f61dbd]{overflow:hidden;width:44px;height:44px;background:#f1f2f3;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;padding:0;font-weight:700;font-size:16px;line-height:25px;color:#aeaeae;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.developer-card .card-body ul li figure img[data-v-32f61dbd]{margin:0}@media (min-width:576px){.developer-card .card-body ul li figure[data-v-32f61dbd]{width:60px;height:60px}}.developer-card .card-body .support-links[data-v-32f61dbd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 0 0;flex-direction:column}@media (min-width:992px){.developer-card .card-body .support-links[data-v-32f61dbd]{-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;flex-direction:column}}.developer-card .card-body .support-links p[data-v-32f61dbd]{margin-bottom:14px;font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;margin-right:0}@media (min-width:576px){.developer-card .card-body .support-links p[data-v-32f61dbd]{margin-right:0;margin-bottom:18px}}.developer-card .card-body .support-links p[data-v-32f61dbd]:last-child{margin-bottom:0}.developer-card .card-body .support-links p i[data-v-32f61dbd]{top:2px;position:relative;margin-right:8px}@media (min-width:576px){.developer-card .card-body .support-links p i[data-v-32f61dbd]{margin-right:4px}}.developer-card .card-footer[data-v-32f61dbd]{border-top:1px solid #bdbdbe;padding:16px 0 0;margin-top:8px}.developer-card .card-footer span[data-v-32f61dbd]{font-family:Helvetica;font-weight:700;font-size:12px;line-height:14px;text-transform:uppercase;color:#222}.developer-card .card-footer span i[data-v-32f61dbd]{margin-left:8px}.developer-card .card-footer span i img[data-v-32f61dbd]{width:50px;margin-bottom:0}.casino-card-software-recomend[data-v-32f61dbd]{width:100%}.review-banner-support li[data-v-32f61dbd]{margin:0 auto 0 0!important}@media (min-width:576px){.review-banner-support li[data-v-32f61dbd]{margin:0 16px 0 0!important}}.review-banner-support li[data-v-32f61dbd]:last-child{margin:0!important}.review-banner-support li figure[data-v-32f61dbd]{width:44px;height:44px;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}@media (min-width:576px){.review-banner-support li figure[data-v-32f61dbd]{width:60px;height:60px}}.span-caption-override[data-v-32f61dbd]{font-size:16px!important;font-weight:700!important}", ""]);

// exports


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):_c('main',{staticClass:"main-content-area"},[(
      !_vm.$root.disableNotSupportBanner &&
      _vm.pageData &&
      _vm.pageData.product_information
    )?_c('div',{staticClass:"sticky-review-card",attrs:{"id":"review-sticky-card"}},[_c('div',{staticClass:"sticky-inner",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn })},[(
          _vm.pageData &&
          _vm.pageData.product_id &&
          _vm.pageData.product_information &&
          _vm.pageData.product_information.product_assets.length > 0
        )?_c('a',{staticClass:"affliate-logo stick-img partner-logo cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
            _vm.pageData.product_information.go_link,
            _vm.pageData.product_information.slug
          ),"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"target":"_blank"}},[(_vm.assets_images && _vm.assets_images.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
              _vm.pageData.product_information.product_assets.filter(
                function (ele) { return ele.asset_category_name ===
                  _vm.assets_images.pro_asset_sizes.large; }
              ).length > 0
                ? _vm.pageData.product_information.product_assets
                    .filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assets_images.pro_asset_sizes.large; }
                    )
                    .shift().url
                : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
            ),expression:"\n              pageData.product_information.product_assets.filter(\n                (ele) =>\n                  ele.asset_category_name ===\n                  assets_images.pro_asset_sizes.large\n              ).length > 0\n                ? pageData.product_information.product_assets\n                    .filter(\n                      (ele) =>\n                        ele.asset_category_name ===\n                        assets_images.pro_asset_sizes.large\n                    )\n                    .shift().url\n                : $root.site_url + $root.asset_path + '/failure.png'\n            "}],attrs:{"height":"85","width":"85","alt":_vm.getAltText(
                _vm.pageData.product_information.name,
                _vm.pageData.product_information.product_assets.filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assets_images.pro_asset_sizes.large; }
                ).length > 0
                  ? _vm.pageData.product_information.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      )
                      .shift().url
                  : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
              )}}):_c('img',{attrs:{"src":_vm.pageData.product_information.product_assets.filter(
                function (ele) { return ele.asset_category_name ===
                  _vm.assets_images.pro_asset_sizes.large; }
              ).length > 0
                ? _vm.pageData.product_information.product_assets
                    .filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assets_images.pro_asset_sizes.large; }
                    )
                    .shift().url
                : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"height":"85","width":"85","alt":_vm.getAltText(
                _vm.pageData.product_information.name,
                _vm.pageData.product_information.product_assets.filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assets_images.pro_asset_sizes.large; }
                ).length > 0
                  ? _vm.pageData.product_information.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      )
                      .shift().url
                  : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
              )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-stic"},[_c('div',{staticClass:"partner-hover-inner",style:({
                '--primary-btn': _vm.$root.color_schema.primary_btn,
                '--primary-btn-hover': _vm.pSBC(
                  -0.2,
                  _vm.$root.color_schema.primary_btn
                ),
              })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
              Object.keys(_vm.hasTag(_vm.pageData.product_information.tags)).length >
              0
            )?_c('div',{class:{
              'stripe-sticky': true,
              'font-dark': _vm.getContrastYIQ(
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null
              ),
              'font-light': !_vm.getContrastYIQ(
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null
              ),
            },style:({
              backgroundColor:
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null,
            })},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"md-rating rating-wrapper-small"},[_c('div',{staticClass:"radio-stars"},[_c('img',{attrs:{"src":_vm.$root.site_url +
                _vm.$root.asset_path +
                '/svg-icons/yellow-star-big.svg',"alt":"Full Big Star"}})]),_vm._v(" "),_c('div',{staticClass:"radio-star-total"},[_c('span',[_vm._v(_vm._s(parseFloat((_vm.pageData.product_information.rating / 2).toFixed(1))))]),_vm._v("/5\n          ")])])],2):_c('div',{staticClass:"partner-logo affliate-logo"},[(
            _vm.assets_images &&
            _vm.assets_images.pro_asset_sizes &&
            _vm.pageData.product_information &&
            _vm.pageData.product_information.product_assets.length > 0
          )?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
              _vm.pageData.product_information.product_assets
                .filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assets_images.pro_asset_sizes.large; }
                )
                .shift().url
            ),expression:"\n              pageData.product_information.product_assets\n                .filter(\n                  (ele) =>\n                    ele.asset_category_name ===\n                    assets_images.pro_asset_sizes.large\n                )\n                .shift().url\n            "}],attrs:{"height":"85","width":"85","alt":_vm.getAltText(
                _vm.pageData.product_information.name,
                _vm.pageData.product_information.product_assets
                  .filter(
                    function (ele) { return ele.asset_category_name ===
                      _vm.assets_images.pro_asset_sizes.large; }
                  )
                  .shift().url
              )}}):_c('img',{attrs:{"src":_vm.pageData.product_information.product_assets
                .filter(
                  function (ele) { return ele.asset_category_name ===
                    _vm.assets_images.pro_asset_sizes.large; }
                )
                .shift().url,"height":"85","width":"85","alt":_vm.getAltText(
                _vm.pageData.product_information.name,
                _vm.pageData.product_information.product_assets
                  .filter(
                    function (ele) { return ele.asset_category_name ===
                      _vm.assets_images.pro_asset_sizes.large; }
                  )
                  .shift().url
              )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-stic"},[_c('div',{staticClass:"partner-hover-inner",style:({
                '--primary-btn': _vm.$root.color_schema.primary_btn,
                '--primary-btn-hover': _vm.pSBC(
                  -0.2,
                  _vm.$root.color_schema.primary_btn
                ),
              })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
              Object.keys(_vm.hasTag(_vm.pageData.product_information.tags)).length >
              0
            )?_c('div',{class:{
              'stripe-sticky': true,
              'font-dark': _vm.getContrastYIQ(
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null
              ),
              'font-light': !_vm.getContrastYIQ(
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null
              ),
            },style:({
              backgroundColor:
                Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                  .length > 0
                  ? _vm.hasTag(_vm.pageData.product_information.tags).color
                  : null,
            })},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"md-rating rating-wrapper-small"},[_c('div',{staticClass:"radio-stars"},[_c('img',{attrs:{"src":_vm.$root.site_url +
                _vm.$root.asset_path +
                '/svg-icons/yellow-star-big.svg',"alt":"Full Big Star"}})]),_vm._v(" "),_c('div',{staticClass:"radio-star-total"},[_c('span',[_vm._v(_vm._s(parseFloat((_vm.pageData.product_information.rating / 2).toFixed(1))))]),_vm._v("/5\n          ")])])],2),_vm._v(" "),_c('span',{staticClass:"sticky-text"},[_c('span',{staticClass:"product-name"},[_vm._v(_vm._s(_vm.pageData.product_information.name)+"\n          "),(
              _vm.pageData.product_information &&
              _vm.pageData.product_information.rating
            )?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat(
                  (
                    _vm.pageData.product_information &&
                    _vm.pageData.product_information.rating / 2
                  ).toFixed(1)
                ),"noText":""}})],1):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"sticky-title"},[_vm._v("\n          "+_vm._s(_vm.getPartnerGlobalString(
              _vm.$root.i18n.review,
              _vm.pageData.product_information.name
            ))+"\n          "),_c('StarRating',{attrs:{"rating":parseFloat(
                (
                  _vm.pageData.product_information &&
                  _vm.pageData.product_information.rating / 2
                ).toFixed(1)
              ),"classParam":'rev-star'}})],1),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('span',{staticClass:"bonus-text"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(!_vm.$root.disable_bonus_cta_on_review)?[(
                  _vm.pageData.product_information.bonus_match &&
                  _vm.pageData.product_information.exclusive_bonus_amount &&
                  _vm.pageData.product_information.exclusive_bonus_match
                )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                    _vm.pageData.product_information.go_link,
                    _vm.pageData.product_information.slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.exclusive_bonus_match)+"%\n                "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.exclusive_bonus_amount,_vm.pageData.product_information.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                  _vm.pageData.product_information.bonus_match &&
                  !_vm.pageData.product_information.exclusive_bonus_amount &&
                  _vm.pageData.product_information.bonus_amount
                )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                    _vm.pageData.product_information.go_link,
                    _vm.pageData.product_information.slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,_vm.pageData.product_information.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                  _vm.pageData.product_information.freespin ||
                  _vm.pageData.product_information.freebie_name
                )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                    _vm.pageData.product_information.go_link,
                    _vm.pageData.product_information.slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[(
                    (_vm.pageData.product_information.exclusive_bonus_amount ||
                      _vm.pageData.product_information.bonus_amount) &&
                    _vm.pageData.product_information.bonus_match
                  )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,_vm.pageData.product_information.bonus_currency)))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                  "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]],2):_vm._e()]:[(
                  _vm.pageData.product_information.bonus_match &&
                  _vm.pageData.product_information.exclusive_bonus_amount &&
                  _vm.pageData.product_information.exclusive_bonus_match
                )?[_vm._v(_vm._s(_vm.pageData.product_information.exclusive_bonus_match)+"%\n                "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.exclusive_bonus_amount,_vm.pageData.product_information.bonus_currency)))]:_vm._e(),_vm._v(" "),(
                  _vm.pageData.product_information.bonus_match &&
                  !_vm.pageData.product_information.exclusive_bonus_amount &&
                  _vm.pageData.product_information.bonus_amount
                )?[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,_vm.pageData.product_information.bonus_currency)))]:_vm._e(),_vm._v(" "),(
                  _vm.pageData.product_information.freespin ||
                  _vm.pageData.product_information.freebie_name
                )?[(
                    (_vm.pageData.product_information.exclusive_bonus_amount ||
                      _vm.pageData.product_information.bonus_amount) &&
                    _vm.pageData.product_information.bonus_match
                  )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,_vm.pageData.product_information.bonus_currency)))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                  "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]]:_vm._e()]]],2):_vm._e(),_vm._v(" "),(
            (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
            (_vm.pageData.terms && _vm.pageData.terms != '')
          )?_c('div',{staticClass:"terms-conditions desk-terms",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn })},[_c('span',{staticClass:"cas-term",domProps:{"innerHTML":_vm._s(_vm.pageData.bonus_tc)}}),_vm._v(" "),(
              _vm.pageData.bonus_tc &&
              _vm.pageData.terms &&
              _vm.pageData.bonus_tc != '' &&
              _vm.pageData.terms != ''
            )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.pageData.terms && _vm.pageData.terms != '')?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                ? 'nofollow sponsored'
                : 'nofollow',"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(_vm.pageData.term_link, _vm.pageData.slug),"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.terms))]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('a',{class:{
          'cta cta-primary cta-promotion cta-promo-review custom-btn sticky-play-btn-large hover-btn cas-link': true,
          'text-white':
            !_vm.$root.override_ctabtntxt_color &&
            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
          'text-gray':
            !_vm.$root.override_ctabtntxt_color &&
            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
          'text-cta-override': _vm.$root.override_ctabtntxt_color,
        },style:({
          '--primary-btn': _vm.$root.color_schema.primary_btn,
          '--primary-btn-hover': _vm.pSBC(-0.2, _vm.$root.color_schema.primary_btn),
        }),attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
            _vm.pageData.product_information.go_link,
            _vm.pageData.product_information.slug
          ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.pageData.product_information.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "revspp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e(),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('a',{class:{
          'cta cta-primary cta-promotion cta-promo-review custom-btn-white sticky-play-btn-medium cas-link': true,
          'text-white':
            !_vm.$root.override_ctabtntxt_color &&
            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
          'text-gray':
            !_vm.$root.override_ctabtntxt_color &&
            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
          'text-cta-override': _vm.$root.override_ctabtntxt_color,
        },style:({
          '--primary-btn': _vm.$root.color_schema.primary_btn,
          '--primary-btn-hover': _vm.pSBC(-0.2, _vm.$root.color_schema.primary_btn),
        }),attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
            _vm.pageData.product_information.go_link,
            _vm.pageData.product_information.slug
          ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}},[_vm._v(_vm._s(_vm.pageData.product_information.cta_button_text))]):_vm._e(),_vm._v(" "),(
          (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
          (_vm.pageData.terms && _vm.pageData.terms != '')
        )?_c('div',{staticClass:"mob-terms"},[(_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '')?_c('span',{staticClass:"cas-term terms-conditions",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(_vm.pageData.bonus_tc)}}):_vm._e(),_vm._v(" "),(
            _vm.pageData.bonus_tc &&
            _vm.pageData.terms &&
            _vm.pageData.bonus_tc != '' &&
            _vm.pageData.terms != ''
          )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.pageData.terms && _vm.pageData.terms != '')?_c('a',{staticClass:"cas-term mob-cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow',"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(_vm.pageData.term_link, _vm.pageData.slug),"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.terms))]):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('section',{class:{
      'ct-inner-banner ct-inner-banner__review pt-26': true,
    },style:({
      background: _vm.$root.color_schema.primary,
    })},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadCrumb,"dark":_vm.getContrastYIQ(_vm.$root.color_schema.primary)}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.$root.disableNotSupportBanner)?_c('NotSupportModal',{attrs:{"notsupportbannerData":_vm.$root.notsupportbannerData,"relative":!_vm.pageData || !_vm.pageData.product_information || Object.keys(_vm.pageData).length === 0}}):_vm._e(),_vm._v(" "),(
              _vm.pageData &&
              _vm.pageData.product_information &&
              Object.keys(_vm.pageData).length != 0
            )?_c('div',{class:{
              'casino-card new-review-banner-card': true,
              'terms-d': _vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '',
            }},[_c('div',{staticClass:"new-review-banner-card-top"},[_c('div',{staticClass:"new-review-banner-card-top-left"},[(
                    _vm.pageData.product_information.product_assets &&
                    _vm.pageData.product_information.product_assets.length > 0
                  )?_c('div',{staticClass:"review-left-img"},[(_vm.pageData && _vm.pageData.product_id)?_c('a',{staticClass:"partner-logo cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                        _vm.pageData.product_information.go_link,
                        _vm.pageData.product_information.slug
                      ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[(_vm.assets_images && _vm.assets_images.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                          _vm.pageData.product_information.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.large; }
                          ).length > 0
                            ? _vm.pageData.product_information.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.large; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/failure.png'
                        ),expression:"\n                          pageData.product_information.product_assets.filter(\n                            (ele) =>\n                              ele.asset_category_name ===\n                              assets_images.pro_asset_sizes.large\n                          ).length > 0\n                            ? pageData.product_information.product_assets\n                                .filter(\n                                  (ele) =>\n                                    ele.asset_category_name ===\n                                    assets_images.pro_asset_sizes.large\n                                )\n                                .shift().url\n                            : $root.site_url +\n                              $root.asset_path +\n                              '/failure.png'\n                        "}],attrs:{"height":"250","width":"250","alt":_vm.getAltText(
                            _vm.pageData.product_information.name,
                            _vm.pageData.product_information.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            ).length > 0
                              ? _vm.pageData.product_information.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.large; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png'
                          )}}):_c('img',{attrs:{"src":_vm.pageData.product_information.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.large; }
                          ).length > 0
                            ? _vm.pageData.product_information.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.large; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/failure.png',"height":"250","width":"250","alt":_vm.getAltText(
                            _vm.pageData.product_information.name,
                            _vm.pageData.product_information.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            ).length > 0
                              ? _vm.pageData.product_information.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.large; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png'
                          )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-bann"},[_c('div',{staticClass:"partner-hover-inner",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]:_vm._e(),_vm._v(" "),(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                      )?_c('span',{staticClass:"exclusive-tag",style:({
                        backgroundColor:
                          Object.keys(
                            _vm.hasTag(_vm.pageData.product_information.tags)
                          ).length > 0
                            ? _vm.hasTag(_vm.pageData.product_information.tags).color
                            : null,
                      })},[_c('p',{class:{
                          'desk-excl custom-font-2': true,
                          'text-gray': _vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(_vm.pageData.product_information.tags)
                            ).length > 0
                              ? _vm.hasTag(_vm.pageData.product_information.tags)
                                  .color
                              : null
                          ),
                          'text-light': !_vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(_vm.pageData.product_information.tags)
                            ).length > 0
                              ? _vm.hasTag(_vm.pageData.product_information.tags)
                                  .color
                              : null
                          ),
                        }},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                        "+_vm._s(_vm.titleCase(
                            _vm.hasTag(_vm.pageData.product_information.tags).tag_name
                          ))+"\n                      ")]),_vm._v(" "),_c('img',{staticClass:"mob-excl",attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()],2):[(_vm.assets_images && _vm.assets_images.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                          _vm.pageData.product_information.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            )
                            .shift().url
                        ),expression:"\n                          pageData.product_information.product_assets\n                            .filter(\n                              (ele) =>\n                                ele.asset_category_name ===\n                                assets_images.pro_asset_sizes.large\n                            )\n                            .shift().url\n                        "}],attrs:{"height":"250","width":"250","alt":_vm.getAltText(
                            _vm.pageData.product_information.name,
                            _vm.pageData.product_information.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.large; }
                              )
                              .shift().url
                          )}}):_c('img',{attrs:{"src":_vm.pageData.product_information.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            )
                            .shift().url,"height":"250","width":"250","alt":_vm.getAltText(
                            _vm.pageData.product_information.name,
                            _vm.pageData.product_information.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.large; }
                              )
                              .shift().url
                          )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-bann"},[_c('div',{staticClass:"partner-hover-inner",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]:_vm._e(),_vm._v(" "),(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                      )?_c('span',{staticClass:"exclusive-tag",style:({
                        backgroundColor:
                          Object.keys(
                            _vm.hasTag(_vm.pageData.product_information.tags)
                          ).length > 0
                            ? _vm.hasTag(_vm.pageData.product_information.tags).color
                            : null,
                      })},[_c('p',{class:{
                          'desk-excl custom-font-2': true,
                          'text-gray': _vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(_vm.pageData.product_information.tags)
                            ).length > 0
                              ? _vm.hasTag(_vm.pageData.product_information.tags)
                                  .color
                              : null
                          ),
                          'text-light': !_vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(_vm.pageData.product_information.tags)
                            ).length > 0
                              ? _vm.hasTag(_vm.pageData.product_information.tags)
                                  .color
                              : null
                          ),
                        }},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                        "+_vm._s(_vm.titleCase(
                            _vm.hasTag(_vm.pageData.product_information.tags).tag_name
                          ))+"\n                      ")]),_vm._v(" "),_c('img',{staticClass:"mob-excl",attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()]],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"review-left-content"},[_c('div',{staticClass:"exclusive-bar"},[_c('div',{staticClass:"exclusive-bar-title"},[_c('div',{staticClass:"trust"},[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/trust-tick.svg',"width":"8","height":"8","alt":"Approve Icon"}})]),_c('strong',[_vm._v(_vm._s(_vm.pageAttr.is_approved &&
                          _vm.pageAttr.approved_by_expert &&
                          _vm.pageAttr.approved_by_expert != ""
                            ? _vm.pageAttr.approved_by_expert
                            : _vm.$root.i18n.trusted_review))])]),_vm._v(" "),_c('p',{staticClass:"custom-font-2"},[_vm._v("\n                        "+_vm._s(_vm.pageData.product_information.name)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"exclusive-bar-rating"},[(_vm.pageData.product_information.rating)?[_c('StarRating',{attrs:{"rating":parseFloat(
                              (
                                _vm.pageData.product_information.rating / 2
                              ).toFixed(1)
                            )}})]:_vm._e(),_vm._v(" "),(
                          _vm.pageAttr.is_exclusive ||
                          (_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                            _vm.pageData.product_information
                              .exclusive_bonus_match)
                        )?_c('span',{staticClass:"exclusive-tag"},[_vm._v(_vm._s(_vm.$root.i18n.exclusive))]):_vm._e()],2)]),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('div',{staticClass:"review-left-content-title"},[_c('span',{class:{
                        'span-h1 cust-span custom-font-1': true,
                        'text-hover': !_vm.$root.disable_bonus_cta_on_review,
                      }},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(!_vm.$root.disable_bonus_cta_on_review)?[(
                              _vm.pageData.product_information.bonus_match &&
                              _vm.pageData.product_information
                                .exclusive_bonus_amount &&
                              _vm.pageData.product_information
                                .exclusive_bonus_match
                            )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                                _vm.pageData.product_information.go_link,
                                _vm.pageData.product_information.slug
                              ),"rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information
                                .exclusive_bonus_match)+"% "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                            "+_vm._s(_vm._f("currency")(_vm.pageData.product_information
                                .exclusive_bonus_amount,
                                  _vm.pageData.product_information.bonus_currency
                                )))]):_vm._e(),_vm._v(" "),(
                              _vm.pageData.product_information.bonus_match &&
                              !_vm.pageData.product_information
                                .exclusive_bonus_amount &&
                              _vm.pageData.product_information.bonus_amount
                            )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                                _vm.pageData.product_information.go_link,
                                _vm.pageData.product_information.slug
                              ),"rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                            "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                            "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                                  _vm.pageData.product_information.bonus_currency
                                )))]):_vm._e(),_vm._v(" "),(
                              _vm.pageData.product_information.freespin ||
                              _vm.pageData.product_information.freebie_name
                            )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                                _vm.pageData.product_information.go_link,
                                _vm.pageData.product_information.slug
                              ),"rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow',"target":"_blank"}},[(
                                (_vm.pageData.product_information
                                  .exclusive_bonus_amount ||
                                  _vm.pageData.product_information
                                    .bonus_amount) &&
                                _vm.pageData.product_information.bonus_match
                              )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                      _vm.pageData.product_information
                                        .bonus_currency
                                    )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                              "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                            ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]],2):_vm._e()]:[(
                              _vm.pageData.product_information.bonus_match &&
                              _vm.pageData.product_information
                                .exclusive_bonus_amount &&
                              _vm.pageData.product_information
                                .exclusive_bonus_match
                            )?[_vm._v(_vm._s(_vm.pageData.product_information
                                .exclusive_bonus_match)+"% "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                            "+_vm._s(_vm._f("currency")(_vm.pageData.product_information
                                .exclusive_bonus_amount,
                                  _vm.pageData.product_information.bonus_currency
                                )))]:_vm._e(),_vm._v(" "),(
                              _vm.pageData.product_information.bonus_match &&
                              !_vm.pageData.product_information
                                .exclusive_bonus_amount &&
                              _vm.pageData.product_information.bonus_amount
                            )?[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                            "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                            "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                                  _vm.pageData.product_information.bonus_currency
                                )))]:_vm._e(),_vm._v(" "),(
                              _vm.pageData.product_information.freespin ||
                              _vm.pageData.product_information.freebie_name
                            )?[(
                                (_vm.pageData.product_information
                                  .exclusive_bonus_amount ||
                                  _vm.pageData.product_information
                                    .bonus_amount) &&
                                _vm.pageData.product_information.bonus_match
                              )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                      _vm.pageData.product_information
                                        .bonus_currency
                                    )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                              "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                            ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]]:_vm._e()]]],2),_vm._v(" "),(_vm.pageData.product_information.go_link)?[_c('a',{class:{
                          'cta cta-primary cta-promotion cta-promo-review ct-btn custom-btn hover-btn cas-link': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.pageData.product_information.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "revspp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]:_vm._e()],2):_vm._e()])]),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('div',{staticClass:"review-left-content-title view-mob"},[_c('span',{staticClass:"span-h1 custom-font-1"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(!_vm.$root.disable_bonus_cta_on_review)?[(
                          _vm.pageData.product_information.bonus_match &&
                          _vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          _vm.pageData.product_information.exclusive_bonus_match
                        )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.exclusive_bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.exclusive_bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            )))]):_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.bonus_match &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          _vm.pageData.product_information.bonus_amount
                        )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            )))]):_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.freespin &&
                          _vm.pageData.product_information.freebie_name &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          !_vm.pageData.product_information.bonus_amount
                        )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.freespin)+"\n                        "+_vm._s(_vm.pageData.product_information.freebie_name))]):_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.bonus_amount &&
                          !_vm.pageData.product_information.bonus_match &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          !_vm.pageData.product_information.freespin &&
                          _vm.pageData.product_information.freebie_name
                        )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            ))+"\n                        "+_vm._s(_vm.pageData.product_information.bonus_name))]):_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.freespin ||
                          _vm.pageData.product_information.freebie_name
                        )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                            _vm.pageData.product_information.go_link,
                            _vm.pageData.product_information.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[(
                            (_vm.pageData.product_information
                              .exclusive_bonus_amount ||
                              _vm.pageData.product_information.bonus_amount) &&
                            _vm.pageData.product_information.bonus_match
                          )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                  _vm.pageData.product_information.bonus_currency
                                )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                          "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                        ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]],2):_vm._e()]:[(
                          _vm.pageData.product_information.bonus_match &&
                          _vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          _vm.pageData.product_information.exclusive_bonus_match
                        )?[_vm._v(_vm._s(_vm.pageData.product_information.exclusive_bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.exclusive_bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            )))]:_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.bonus_match &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          _vm.pageData.product_information.bonus_amount
                        )?[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            )))]:_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.freespin &&
                          _vm.pageData.product_information.freebie_name &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          !_vm.pageData.product_information.bonus_amount
                        )?[_vm._v(_vm._s(_vm.pageData.product_information.freespin)+"\n                        "+_vm._s(_vm.pageData.product_information.freebie_name))]:_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.bonus_amount &&
                          !_vm.pageData.product_information.bonus_match &&
                          !_vm.pageData.product_information
                            .exclusive_bonus_amount &&
                          !_vm.pageData.product_information.freespin &&
                          _vm.pageData.product_information.freebie_name
                        )?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                              _vm.pageData.product_information.bonus_currency
                            ))+"\n                        "+_vm._s(_vm.pageData.product_information.bonus_name))]:_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_information.freespin ||
                          _vm.pageData.product_information.freebie_name
                        )?[(
                            (_vm.pageData.product_information
                              .exclusive_bonus_amount ||
                              _vm.pageData.product_information.bonus_amount) &&
                            _vm.pageData.product_information.bonus_match
                          )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                  _vm.pageData.product_information.bonus_currency
                                )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                          "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                        ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]]:_vm._e()]]],2),_vm._v(" "),_c('a',{class:{
                    'cta cta-primary cta-promotion cta-promo-review custom-btn hover-btn cas-link': true,
                    'text-white':
                      !_vm.$root.override_ctabtntxt_color &&
                      !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-gray':
                      !_vm.$root.override_ctabtntxt_color &&
                      _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                    'text-cta-override': _vm.$root.override_ctabtntxt_color,
                  },style:({
                    '--primary-btn': _vm.$root.color_schema.primary_btn,
                    '--primary-btn-hover': _vm.pSBC(
                      -0.2,
                      _vm.$root.color_schema.primary_btn
                    ),
                  }),attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                      _vm.pageData.product_information.go_link,
                      _vm.pageData.product_information.slug
                    ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.pageData.product_information.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "revbbpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"new-review-banner-card-top-right"},[_c('div',{staticClass:"overall-rating"},[_c('div',{staticClass:"rating-header"},[_c('span',{staticClass:"span-h2"},[_vm._v(_vm._s(_vm.$root.i18n.overall_rating))]),_vm._v(" "),_c('div',{staticClass:"rating-count",style:({
                        background: _vm.getFinalStarPercentage(
                          parseFloat(
                            (_vm.pageData.product_information.rating / 2).toFixed(
                              1
                            )
                          )
                        ),
                      })},[_c('div',{staticClass:"rating-count-top"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(parseFloat(
                            (_vm.pageData.product_information.rating / 2).toFixed(
                              1
                            )
                          )))]),_vm._v(" "),_c('i',{staticClass:"full-star"})]),_vm._v(" "),_c('span',{staticClass:"comment"},[_vm._v(_vm._s(_vm.getFinalStarPercentageLabel(
                            parseFloat(
                              (
                                _vm.pageData.product_information.rating / 2
                              ).toFixed(1)
                            )
                          ))+"!")])])]),_vm._v(" "),(
                      _vm.pageData.rating_data && _vm.pageData.rating_data.length > 0
                    )?_c('div',{staticClass:"progress-bar-block"},_vm._l((_vm.pageData.rating_data.filter(
                        function (ele, key) { return key != 0; }
                      )),function(rtn,ind){return _c('div',{key:ind,staticClass:"bar-row"},[_c('div',{staticClass:"label"},[_c('p',[_vm._v(_vm._s(rtn.criteria_name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(parseFloat((rtn.value / 2).toFixed(1)))+"\n                          "),_c('i',{staticClass:"full-star"})])]),_vm._v(" "),_c('div',{staticClass:"bar-rail"},[_c('div',{staticClass:"progress-indicator",style:(_vm.getStarPercentage(
                              parseFloat((rtn.value / 2).toFixed(1))
                            ))})])])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row mx-0 new-review-banner-card-bottom"},[_c('div',{staticClass:"col-12 col-md-3 px-0 wd-mar"},[(
                      _vm.pageData.software_provider &&
                      _vm.pageData.software_provider.length > 0
                    )?_c('div',{staticClass:"casino-card-lists"},[_c('span',{staticClass:"span-caption span-caption-override"},[_vm._v(_vm._s(_vm.$root.i18n.software_providers)+" ("+_vm._s(_vm.pageData.software_provider.length)+")")]),_vm._v(" "),_c('ul',{staticClass:"\n                        justify-flex-start\n                        flex-wrap\n                        review-banner-support\n                      "},[_vm._l((_vm.pageData.software_provider.slice(0, 4)),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}),_vm._v(" "),(_vm.pageData.software_provider.length === 5)?_vm._l((_vm.pageData.software_provider.slice(4)),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}):_vm._e(),_vm._v(" "),(
                          _vm.pageData.software_provider.length > 5 &&
                          !_vm.showHideObj.spTop
                        )?_c('li',[_c('a',{attrs:{"href":"#review-casino-card-software"}},[_c('figure',[_c('span',[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                              "+_vm._s(_vm.pageData.software_provider.length - 4)+"\n                            ")])])])]):_vm._e()],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"offset-md-1 col-12 col-md-3 px-0 wd-mar"},[(
                      _vm.pageData.supported_payments &&
                      _vm.pageData.supported_payments.length > 0
                    )?_c('div',{staticClass:"casino-card-lists"},[_c('span',{staticClass:"span-caption span-caption-override"},[_vm._v(_vm._s(_vm.$root.i18n.top_payment_methods)+" ("+_vm._s(_vm.pageData.supported_payments.length)+")")]),_vm._v(" "),_c('ul',{staticClass:"\n                        justify-flex-start\n                        flex-wrap\n                        review-banner-support\n                      "},[_vm._l((_vm.pageData.supported_payments.slice(
                          0,
                          4
                        )),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}),_vm._v(" "),(_vm.pageData.supported_payments.length === 5)?_vm._l((_vm.pageData.supported_payments.slice(4)),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}):_vm._e(),_vm._v(" "),(
                          _vm.pageData.supported_payments.length > 5 &&
                          !_vm.showHideObj.pmTop
                        )?_c('li',[_c('a',{attrs:{"href":"#review-casino-card-payment-method"}},[_c('figure',[_c('span',[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                              "+_vm._s(_vm.pageData.supported_payments.length - 4)+"\n                            ")])])])]):_vm._e()],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"offset-md-1 col-12 col-md-3 px-0 wd-mar"},[(
                      _vm.pageData.product_licences &&
                      _vm.pageData.product_licences.length > 0
                    )?_c('div',{staticClass:"casino-card-lists license-right"},[_c('span',{staticClass:"span-caption span-caption-override"},[_vm._v(_vm._s(_vm.$root.i18n.licenced_under))]),_vm._v(" "),_c('ul',{staticClass:"justify-flex-end flex-wrap review-banner-support"},[_vm._l((_vm.pageData.product_licences.slice(0, 4)),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}),_vm._v(" "),(_vm.pageData.product_licences.length === 5)?_vm._l((_vm.pageData.product_licences.slice(4)),function(data){return _c('li',{key:data.po_id},[_c('figure',[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(data.url),expression:"data.url"}],attrs:{"alt":_vm.getAltText(data.name, data.url)}}):_c('img',{attrs:{"src":data.url,"alt":_vm.getAltText(data.name, data.url)}})])])}):_vm._e(),_vm._v(" "),(
                          _vm.pageData.product_licences.length > 5 &&
                          !_vm.showHideObj.liscTop
                        )?_c('li',[_c('a',{attrs:{"href":"#review-support-language"}},[_c('figure',[_c('span',[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/svg-icons/plus.svg',"alt":"Plus Icon"}})]),_vm._v("\n                              "+_vm._s(_vm.pageData.product_licences.length - 4)+"\n                            ")])])])]):_vm._e()],2)]):_vm._e()])])]),_vm._v(" "),(_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '')?_c('div',{staticClass:"div-term"},[(_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '')?_c('span',{staticClass:"terms_tc cas-term",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(_vm.pageData.bonus_tc)}}):_vm._e(),_vm._v(" "),(
                  _vm.pageData.bonus_tc &&
                  _vm.pageData.terms &&
                  _vm.pageData.bonus_tc != '' &&
                  _vm.pageData.terms != ''
                )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.pageData.terms && _vm.pageData.terms != '')?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(_vm.pageData.term_link, _vm.pageData.slug),"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.terms))]):_vm._e()]):_vm._e()]):_vm._e()],1)])])]),_vm._v(" "),(_vm.pageIndex > 0 && _vm.tabData && _vm.tabData.length > 0)?[_c('section',{staticClass:"ct-editor-section pb-25 pb-1"},[_vm._l((_vm.tabData),function(data,index){return [(
            data.blockName === 'wpvcb/page-menu-blocks-scroll' &&
            data.filtered_content &&
            Object.keys(data.filtered_content).length > 0 &&
            data.filtered_content.menu.length > 0
          )?[_c('vue-position-sticky',{key:index,attrs:{"id":"sticky-nav","offsetTop":_vm.stickyNavTop}},[(_vm.showSticky)?_c('div',{staticClass:"review-top-menu"},[_c('nav',{staticClass:"scroll-nav"},_vm._l((data.filtered_content.menu),function(mn,index1){return _c('span',{key:index1,class:{
                      'scroll-item': true,
                      active: _vm.activeKey === mn.menu_block_id,
                    },on:{"click":function($event){return _vm.scrollPage(mn.menu_block_id)}}},[_vm._v(_vm._s(mn.menu_name))])}),0)]):_vm._e()])]:_c('div',{key:index,ref:data.attrs &&
                Object.keys(data.attrs).length > 0 &&
                data.attrs.blockID &&
                data.attrs.blockID != ''
                  ? ("" + (data.attrs.blockID)): '',refInFor:true},[_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"pageData":_vm.pageData,"blockIndex":index}})],1)]})],2)]:_vm._e(),_vm._v(" "),(_vm.pageIndex > 2)?_c('section',{staticClass:"ct-editor-section pb-25 pb-1"},[_c('div',{staticClass:"container"},[(
          _vm.pageData &&
          _vm.pageData.product_information &&
          Object.keys(_vm.pageData).length != 0
        )?[_c('div',{class:{
            'casino-card casino-card-software casino-card-software-recomend casino-card-bonus': true,
            'rm-border':
              (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
              (_vm.pageData.terms && _vm.pageData.terms != ''),
          }},[(
              _vm.pageData.product_information.product_assets &&
              _vm.pageData.product_information.product_assets.length > 0
            )?_c('div',{staticClass:"bonus-card-logo"},[(_vm.pageData && _vm.pageData.product_id)?_c('a',{staticClass:"h-100 w-100 partner-logo cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                  _vm.pageData.product_information.go_link,
                  _vm.pageData.product_information.slug
                ),"rel":_vm.$root.change_cta_to_sponsored
                  ? 'nofollow sponsored'
                  : 'nofollow',"target":"_blank"}},[(_vm.assets_images && _vm.assets_images.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                    _vm.pageData.product_information.product_assets.filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assets_images.pro_asset_sizes.large; }
                    ).length > 0
                      ? _vm.pageData.product_information.product_assets
                          .filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.large; }
                          )
                          .shift().url
                      : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
                  ),expression:"\n                    pageData.product_information.product_assets.filter(\n                      (ele) =>\n                        ele.asset_category_name ===\n                        assets_images.pro_asset_sizes.large\n                    ).length > 0\n                      ? pageData.product_information.product_assets\n                          .filter(\n                            (ele) =>\n                              ele.asset_category_name ===\n                              assets_images.pro_asset_sizes.large\n                          )\n                          .shift().url\n                      : $root.site_url + $root.asset_path + '/failure.png'\n                  "}],class:{
                    'no-terms':
                      (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
                      (_vm.pageData.terms && _vm.pageData.terms != ''),
                  },attrs:{"width":"300","height":"320","alt":_vm.getAltText(
                      _vm.pageData.product_information.name,
                      _vm.pageData.product_information.product_assets.filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      ).length > 0
                        ? _vm.pageData.product_information.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            )
                            .shift().url
                        : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
                    )}}):_c('img',{class:{
                    'no-terms':
                      (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
                      (_vm.pageData.terms && _vm.pageData.terms != ''),
                  },attrs:{"src":_vm.pageData.product_information.product_assets.filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assets_images.pro_asset_sizes.large; }
                    ).length > 0
                      ? _vm.pageData.product_information.product_assets
                          .filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.large; }
                          )
                          .shift().url
                      : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"width":"300","height":"320","alt":_vm.getAltText(
                      _vm.pageData.product_information.name,
                      _vm.pageData.product_information.product_assets.filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      ).length > 0
                        ? _vm.pageData.product_information.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            )
                            .shift().url
                        : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
                    )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-end"},[_c('div',{staticClass:"partner-hover-inner",style:({
                      '--primary-btn': _vm.$root.color_schema.primary_btn,
                      '--primary-btn-hover': _vm.pSBC(
                        -0.2,
                        _vm.$root.color_schema.primary_btn
                      ),
                    })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                    Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                      .length > 0
                  )?_c('span',{staticClass:"exclusive-tag-rev",style:({
                    backgroundColor:
                      Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                        .length > 0
                        ? _vm.hasTag(_vm.pageData.product_information.tags).color
                        : null,
                  })},[_c('p',{class:{
                      'custom-font-2': true,
                      'text-gray': _vm.getContrastYIQ(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                          ? _vm.hasTag(_vm.pageData.product_information.tags).color
                          : null
                      ),
                      'text-light': !_vm.getContrastYIQ(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                          ? _vm.hasTag(_vm.pageData.product_information.tags).color
                          : null
                      ),
                    }},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                    "+_vm._s(_vm.titleCase(
                        _vm.hasTag(_vm.pageData.product_information.tags).tag_name
                      ))+"\n                  ")])]):_vm._e()]:_vm._e()],2):[(_vm.assets_images && _vm.assets_images.pro_asset_sizes)?[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                    _vm.pageData.product_information.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      )
                      .shift().url
                  ),expression:"\n                    pageData.product_information.product_assets\n                      .filter(\n                        (ele) =>\n                          ele.asset_category_name ===\n                          assets_images.pro_asset_sizes.large\n                      )\n                      .shift().url\n                  "}],class:{
                    'no-terms':
                      (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
                      (_vm.pageData.terms && _vm.pageData.terms != ''),
                  },attrs:{"width":"300","height":"320","alt":_vm.getAltText(
                      _vm.pageData.product_information.name,
                      _vm.pageData.product_information.product_assets
                        .filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assets_images.pro_asset_sizes.large; }
                        )
                        .shift().url
                    )}}):_c('img',{class:{
                    'no-terms':
                      (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
                      (_vm.pageData.terms && _vm.pageData.terms != ''),
                  },attrs:{"src":_vm.pageData.product_information.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assets_images.pro_asset_sizes.large; }
                      )
                      .shift().url,"width":"300","height":"320","alt":_vm.getAltText(
                      _vm.pageData.product_information.name,
                      _vm.pageData.product_information.product_assets
                        .filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assets_images.pro_asset_sizes.large; }
                        )
                        .shift().url
                    )}}),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-rev-end"},[_c('div',{staticClass:"partner-hover-inner",style:({
                      '--primary-btn': _vm.$root.color_schema.primary_btn,
                      '--primary-btn-hover': _vm.pSBC(
                        -0.2,
                        _vm.$root.color_schema.primary_btn
                      ),
                    })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                    Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                      .length > 0
                  )?_c('span',{staticClass:"exclusive-tag-rev",style:({
                    backgroundColor:
                      Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                        .length > 0
                        ? _vm.hasTag(_vm.pageData.product_information.tags).color
                        : null,
                  })},[_c('p',{class:{
                      'custom-font-2': true,
                      'text-gray': _vm.getContrastYIQ(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                          ? _vm.hasTag(_vm.pageData.product_information.tags).color
                          : null
                      ),
                      'text-light': !_vm.getContrastYIQ(
                        Object.keys(_vm.hasTag(_vm.pageData.product_information.tags))
                          .length > 0
                          ? _vm.hasTag(_vm.pageData.product_information.tags).color
                          : null
                      ),
                    }},[_c('img',{attrs:{"src":_vm.hasTag(_vm.pageData.product_information.tags).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                    "+_vm._s(_vm.titleCase(
                        _vm.hasTag(_vm.pageData.product_information.tags).tag_name
                      ))+"\n                  ")])]):_vm._e()]:_vm._e()]],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bonus-card-content"},[_c('div',{staticClass:"bonus-card-content-top"},[_c('div',{staticClass:"half-column"},[_c('div',{staticClass:"half-column-cont"},[_c('div',{staticClass:"bonus-card-rating"},[_c('p',{staticClass:"custom-font-2"},[_vm._v("\n                      "+_vm._s(_vm.pageData.product_information.name)+"\n                    ")]),_vm._v(" "),(
                        _vm.pageData.product_information &&
                        _vm.pageData.product_information.rating
                      )?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat(
                            (
                              _vm.pageData.product_information &&
                              _vm.pageData.product_information.rating / 2
                            ).toFixed(1)
                          )}})],1):_vm._e()]),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('span',{staticClass:"custom-font-1"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(!_vm.$root.disable_bonus_cta_on_review)?[(
                            _vm.pageData.product_information.bonus_match &&
                            _vm.pageData.product_information
                              .exclusive_bonus_amount &&
                            _vm.pageData.product_information.exclusive_bonus_match
                          )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                              _vm.pageData.product_information.go_link,
                              _vm.pageData.product_information.slug
                            ),"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information
                              .exclusive_bonus_match)+"% "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                          "+_vm._s(_vm._f("currency")(_vm.pageData.product_information
                              .exclusive_bonus_amount,
                                _vm.pageData.product_information.bonus_currency
                              )))]):_vm._e(),_vm._v(" "),(
                            _vm.pageData.product_information.bonus_match &&
                            !_vm.pageData.product_information
                              .exclusive_bonus_amount &&
                            _vm.pageData.product_information.bonus_amount
                          )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                              _vm.pageData.product_information.go_link,
                              _vm.pageData.product_information.slug
                            ),"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                          "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                          "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                                _vm.pageData.product_information.bonus_currency
                              )))]):_vm._e(),_vm._v(" "),(
                            _vm.pageData.product_information.freespin ||
                            _vm.pageData.product_information.freebie_name
                          )?_c('a',{staticClass:"cas-link",attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                              _vm.pageData.product_information.go_link,
                              _vm.pageData.product_information.slug
                            ),"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"target":"_blank"}},[(
                              (_vm.pageData.product_information
                                .exclusive_bonus_amount ||
                                _vm.pageData.product_information.bonus_amount) &&
                              _vm.pageData.product_information.bonus_match
                            )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                    _vm.pageData.product_information
                                      .bonus_currency
                                  )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                            "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                          ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]],2):_vm._e()]:[(
                            _vm.pageData.product_information.bonus_match &&
                            _vm.pageData.product_information
                              .exclusive_bonus_amount &&
                            _vm.pageData.product_information.exclusive_bonus_match
                          )?[_vm._v(_vm._s(_vm.pageData.product_information
                              .exclusive_bonus_match)+"% "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                          "+_vm._s(_vm._f("currency")(_vm.pageData.product_information
                              .exclusive_bonus_amount,
                                _vm.pageData.product_information.bonus_currency
                              )))]:_vm._e(),_vm._v(" "),(
                            _vm.pageData.product_information.bonus_match &&
                            !_vm.pageData.product_information
                              .exclusive_bonus_amount &&
                            _vm.pageData.product_information.bonus_amount
                          )?[_vm._v(_vm._s(_vm.pageData.product_information.bonus_match)+"%\n                          "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                          "+_vm._s(_vm._f("currency")(_vm.pageData.product_information.bonus_amount,
                                _vm.pageData.product_information.bonus_currency
                              )))]:_vm._e(),_vm._v(" "),(
                            _vm.pageData.product_information.freespin ||
                            _vm.pageData.product_information.freebie_name
                          )?[(
                              (_vm.pageData.product_information
                                .exclusive_bonus_amount ||
                                _vm.pageData.product_information.bonus_amount) &&
                              _vm.pageData.product_information.bonus_match
                            )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.pageData.product_information.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.pageData.product_information.freespin,
                                    _vm.pageData.product_information
                                      .bonus_currency
                                  )))]:[_vm._v(_vm._s(_vm.pageData.product_information.freespin))],_vm._v("\n                            "+_vm._s(_vm.pageData.product_information.freebie_name)+"\n                          ")]:[_vm._v(_vm._s(_vm.pageData.product_information.freebie_name))]]:_vm._e()]]],2):_vm._e()])]),_vm._v(" "),(_vm.pageData && _vm.pageData.product_id)?_c('div',{staticClass:"half-column"},[_c('div',{staticClass:"play_term_wrapper"},[(_vm.pageData.product_information.go_link)?[_c('a',{class:{
                        'cta cta-primary cta-promotion custom-btn cas-link hover-btn btn-cust': true,
                        'text-white':
                          !_vm.$root.override_ctabtntxt_color &&
                          !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-gray':
                          !_vm.$root.override_ctabtntxt_color &&
                          _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-cta-override': _vm.$root.override_ctabtntxt_color,
                      },style:({
                        '--primary-btn': _vm.$root.color_schema.primary_btn,
                        '--primary-btn-hover': _vm.pSBC(
                          -0.2,
                          _vm.$root.color_schema.primary_btn
                        ),
                      }),attrs:{"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(
                          _vm.pageData.product_information.go_link,
                          _vm.pageData.product_information.slug
                        ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.pageData.product_information.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "revbpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]:_vm._e()],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bonus-card-content-bottom"},[_c('span',{staticClass:"span-h6"},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                  _vm.$root.i18n.why_to_choose,
                  _vm.pageData.product_information.name
                )))]),_vm._v(" "),_c('ul',{staticClass:"proslist-rev"},_vm._l((_vm.prosconsReview(_vm.pageData.procons)),function(procon,index){return _c('li',{key:index,class:{
                    pros: procon.is_positive === '1',
                    cons: procon.is_positive === '0',
                  }},[_vm._v("\n                  "+_vm._s(procon.description)+"\n                ")])}),0)])])]),_vm._v(" "),(
            (_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '') ||
            (_vm.pageData.terms && _vm.pageData.terms != '')
          )?_c('div',{staticClass:"rev-terms-condition"},[(_vm.pageData.bonus_tc && _vm.pageData.bonus_tc != '')?_c('span',{staticClass:"terms_tc cas-term",style:({
              '--primary-btn': _vm.$root.color_schema.primary_btn,
            }),domProps:{"innerHTML":_vm._s(_vm.pageData.bonus_tc)}}):_vm._e(),_vm._v(" "),(
              _vm.pageData.bonus_tc &&
              _vm.pageData.terms &&
              _vm.pageData.bonus_tc != '' &&
              _vm.pageData.terms != ''
            )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(_vm.pageData.terms && _vm.pageData.terms != '')?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                ? 'nofollow sponsored'
                : 'nofollow',"title":_vm.pageData.product_information.name,"href":_vm.getGoLink(_vm.pageData.term_link, _vm.pageData.slug),"target":"_blank"}},[_vm._v(_vm._s(_vm.pageData.terms))]):_vm._e()]):_vm._e()]:_vm._e(),_vm._v(" "),(
          _vm.metaData &&
          _vm.metaData.security_information &&
          _vm.metaData.security_white_box_section
        )?[(
            _vm.metaData.security_information.title != '' &&
            _vm.metaData.security_information.content != ''
          )?_c('div',{staticClass:"max-cntent-area"},[_c('h2',{staticClass:"custom-font-1"},[_vm._v("\n            "+_vm._s(_vm.metaData.security_information.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"custom-font",style:({
              '--heading-font': _vm.$root.font_family.heading,
              '--paragraph-font': _vm.$root.font_family.paragraph,
            }),domProps:{"innerHTML":_vm._s(_vm.metaData.security_information.content)}})]):_vm._e(),_vm._v(" "),(
            _vm.metaData.security_white_box_section.title_1 != '' &&
            _vm.metaData.security_white_box_section.content_1 != '' &&
            _vm.metaData.security_white_box_section.title_2 != '' &&
            _vm.metaData.security_white_box_section.content_2 != ''
          )?_c('div',{staticClass:"\n            casino-card\n            casino-card-software\n            casino-card-payment-method\n            casino-card-security\n          "},[_c('div',{staticClass:"card-icon"},[_c('img',{attrs:{"src":_vm.$root.site_url +
                _vm.$root.asset_path +
                '/svg-icons/security-icon.svg',"alt":"Security Icons"}})]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"card-content-bottom"},[_c('div',{staticClass:"half-column half-column__review"},[_c('div',{staticClass:"half-column-img"},[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.metaData.security_white_box_section.image_1),expression:"metaData.security_white_box_section.image_1"}],attrs:{"alt":"Security Image"}}):_c('img',{attrs:{"src":_vm.metaData.security_white_box_section.image_1,"alt":"Security Image"}})]),_vm._v(" "),_c('div',{staticClass:"half-column-text"},[_c('p',{staticClass:"p-caption"},[_vm._v("\n                    "+_vm._s(_vm.metaData.security_white_box_section.title_1)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"custom-font-2"},[_vm._v("\n                    "+_vm._s(_vm.metaData.security_white_box_section.content_1)+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"half-column half-column__review"},[_c('div',{staticClass:"half-column-img"},[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.metaData.security_white_box_section.image_2),expression:"metaData.security_white_box_section.image_2"}],attrs:{"alt":"Security Image"}}):_c('img',{attrs:{"src":_vm.metaData.security_white_box_section.image_2,"alt":"Security Image"}})]),_vm._v(" "),_c('div',{staticClass:"half-column-text"},[_c('p',{staticClass:"p-caption"},[_vm._v("\n                    "+_vm._s(_vm.metaData.security_white_box_section.title_2)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"custom-font-2"},[_vm._v("\n                    "+_vm._s(_vm.metaData.security_white_box_section.content_2)+"\n                  ")])])])])])]):_vm._e()]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(
      _vm.pageData &&
      _vm.pageData.similar_casinos &&
      _vm.pageData.similar_casinos.length != 0 &&
      _vm.pageIndex > 1
    )?[_c('SimilarCasino',{attrs:{"assetsSize":_vm.assets_images,"componentTitle":_vm.metaData.similar_casinos_title ? _vm.metaData.similar_casinos_title : '',"componentDescription":_vm.metaData.similar_casinos_description
          ? _vm.metaData.similar_casinos_description
          : '',"componentAttrs":{},"componentData":_vm.pageData.similar_casinos,"pageTemplate":'review-page'}})]:_vm._e(),_vm._v(" "),(_vm.morePaymentBottom && _vm.pageIndex > 3)?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(_vm.auhtorBlockdata && _vm.pageIndex > 3)?void 0:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(648);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("dcedd4d4", content, true, {});

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-7dca6d04]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-7dca6d04]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-7dca6d04]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-7dca6d04]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-7dca6d04]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-7dca6d04]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-7dca6d04]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-7dca6d04]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-7dca6d04]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-7dca6d04]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-7dca6d04]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-7dca6d04]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.guide-cat[data-v-7dca6d04]{padding:125px 140px 0 0}.ct-ggh .breadcrumbs[data-v-7dca6d04]{display:none}@media (min-width:768px){.ct-ggh .breadcrumbs[data-v-7dca6d04]{display:block}}.hide-mob[data-v-7dca6d04]{display:none}@media (min-width:768px){.hide-mob[data-v-7dca6d04]{display:block}}.casino-header[data-v-7dca6d04]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-7dca6d04]{text-align:center;color:#fff;font-weight:700;padding:8px}", ""]);

// exports


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{
    'main-content-area': true,
    'custom-background-image': _vm.$root.color_schema.site_bg_img,
  },style:({
    '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
    '--bg-color': _vm.$root.color_schema.site_bg_color,
  })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"observer",rawName:"v-observer",value:(_vm.mutationObserve),expression:"mutationObserve"}],class:{
      'custom-background-color': _vm.$root.color_schema.site_bg_img,
      'page-wrapper pt-26 pb-25': true,
    }},[_c('section',{staticClass:"ct-ggh"},[_c('div',{staticClass:"container overflow-auto"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.gameguideholderData.breadcrumb,"dark":true}})],1)])]),_vm._v(" "),_vm._l((_vm.blockData),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]}),_vm._v(" "),(
        _vm.morePaymentBottom &&
        _vm.blockData.length === _vm.gameguideholderData.content.blocks.length
      )?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(
        _vm.auhtorBlockdata &&
        _vm.blockData.length === _vm.gameguideholderData.content.blocks.length
      )?void 0:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(651);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0742aca6", content, true, {});

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(46);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-331378b8]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-331378b8]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-331378b8]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-331378b8]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-331378b8]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-331378b8]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-331378b8]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-331378b8]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-331378b8]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-331378b8]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-331378b8]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-331378b8]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.wrapper-iframe[data-v-331378b8]{height:557px}.wrapper-game-iframe[data-v-331378b8]{height:487px}.banner-img[data-v-331378b8]{height:557px}.banner-img-im[data-v-331378b8]{height:557px!important}.cas-iframe[data-v-331378b8]{min-width:100%;opacity:1;border-radius:0 0 10px 10px;height:100%;width:100%;overflow-x:hidden;transition:.5s;left:0;top:0;z-index:5;position:relative}@media (max-width:768px) and (orientation:landscape){.cas-iframe[data-v-331378b8]{position:fixed;z-index:999}}@media (width:768px){.z-con[data-v-331378b8]{z-index:8!important}}@media (max-width:576px){.z-con[data-v-331378b8]{z-index:8!important}}.pos-relative[data-v-331378b8]{position:relative}.mar-2[data-v-331378b8]{margin-left:2px}.stripe[data-v-331378b8]{position:absolute;left:0;width:100%;height:18px;bottom:0;overflow:hidden;display:flex;justify-content:center;align-items:center;background-color:#ffd039;border-bottom-left-radius:7px;border-bottom-right-radius:7px}.stripe-text[data-v-331378b8]{display:flex;justify-content:center;align-items:center;font-weight:600;font-size:10px;line-height:100%}.stripe img[data-v-331378b8]{width:18px!important;height:auto!important;margin:3px auto;display:table;border-radius:0!important}.terms_tc[data-v-331378b8]{text-decoration:underline;color:#080438;font-size:13px}.pt-6px[data-v-331378b8]{padding-top:6px}.pt-3px[data-v-331378b8]{padding-top:3px!important}.ct-inner-banner[data-v-331378b8]{padding:0 0 45px;background:#070438 url(" + escape(__webpack_require__(62)) + ") no-repeat 0 0}.ct-inner-banner .game-space[data-v-331378b8]{position:relative;min-height:321px}@media (min-width:768px){.ct-inner-banner .game-space[data-v-331378b8]{height:auto;min-height:557px}}.ct-inner-banner .game-space img[data-v-331378b8]{border-radius:10px;box-shadow:0 5px 15px rgba(0,0,0,.05);height:100%;object-fit:cover;width:auto;max-height:321px;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space img[data-v-331378b8]{width:100%;min-height:auto}}@media (min-width:768px){.ct-inner-banner .game-space img[data-v-331378b8]{max-height:none}}.ct-inner-banner .game-space-content[data-v-331378b8]{position:absolute;left:0;right:0;top:0;bottom:0;padding:20px;background:rgba(0,0,0,.5);-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px}.ct-inner-banner .game-space-content .button-block[data-v-331378b8],.ct-inner-banner .game-space-content[data-v-331378b8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-inner-banner .game-space-content .button-block[data-v-331378b8]{width:100%;margin-bottom:15px;margin-top:5px}.ct-inner-banner .game-space-content .button-block .cta[data-v-331378b8]{min-width:100%;margin:5px 0;font-weight:700;font-size:14px;line-height:17px;padding:10px 18px}@media (min-width:768px){.ct-inner-banner .game-space-content .button-block .cta[data-v-331378b8]{min-width:330px;margin:10px 0;padding:15px 18px;font-size:18px;line-height:22px}}.ct-inner-banner .game-space-content .game-logo[data-v-331378b8],.ct-inner-banner .game-space-content .game-logo a[data-v-331378b8]{width:136px;height:136px}.ct-inner-banner .game-space-content .game-logo a img[data-v-331378b8]{width:136px;height:136px;box-shadow:none;max-height:none;min-height:auto}@media (min-width:768px){.ct-inner-banner .row .col-md-8[data-v-331378b8]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-8[data-v-331378b8]{width:66.66666667%;float:left}}@media (min-width:768px){.ct-inner-banner .row .col-md-4[data-v-331378b8]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-4[data-v-331378b8]{width:33.33333333%;float:left}}.ct-inner-banner-lft[data-v-331378b8]{margin-bottom:19px}@media (min-width:992px){.ct-inner-banner-lft[data-v-331378b8]{margin-bottom:0}}@media (min-width:1360px){.ct-inner-banner-lft[data-v-331378b8]{width:906px!important}}@media (min-width:1360px){.ct-inner-banner-rgt[data-v-331378b8]{width:314px!important}}.live-dealer[data-v-331378b8]{position:relative;height:252px;margin-bottom:0}@media (min-width:768px){.live-dealer[data-v-331378b8]{margin-bottom:17px}}.live-dealer[data-v-331378b8]:before{content:\"\";position:absolute;height:100%;width:100%;border-radius:12px;background:linear-gradient(180deg,#191923,rgba(25,25,35,.610417) 41.67%,rgba(25,25,35,.15))}.live-dealer img[data-v-331378b8]{width:100%;height:100%;object-fit:cover;box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.live-dealer-content[data-v-331378b8]{position:absolute;left:0;right:0;top:0;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-bottom:25px;padding-top:15px}@media (min-width:768px){.live-dealer-content[data-v-331378b8]{padding-bottom:15px;padding-top:5px}}.live-dealer-content .span-h2[data-v-331378b8],.live-dealer-content h2[data-v-331378b8]{color:#fff;font-weight:900;margin-bottom:10px}.live-dealer-content .rating-wrapper .radio-stars[data-v-331378b8]{display:none}.live-dealer-content .rating-wrapper .radio-stars img[data-v-331378b8]{width:auto}@media (min-width:768px){.live-dealer-content .rating-wrapper .radio-stars[data-v-331378b8]{display:block}}.live-dealer-content .rating-wrapper .radio-stars-mob[data-v-331378b8]{display:flex}@media (min-width:768px){.live-dealer-content .rating-wrapper .radio-stars-mob[data-v-331378b8]{display:none}}.rating-wrapper-large[data-v-331378b8]{display:none}@media (min-width:768px){.rating-wrapper-large[data-v-331378b8]{display:block}}.expert-review[data-v-331378b8]{box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;background:#08043e;display:none}@media (min-width:768px){.expert-review[data-v-331378b8]{display:block}}@media (min-width:992px){.expert-review[data-v-331378b8]{background:url(" + escape(__webpack_require__(652)) + ") no-repeat -18px 0;background-size:425px}}.expert-review-inner[data-v-331378b8]{padding:16px 15px 12px}.expert-review .span-h2[data-v-331378b8],.expert-review h2[data-v-331378b8]{color:#fd0;margin-bottom:15px}.expert-review .expert-info[data-v-331378b8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;margin-bottom:10px}.expert-review .expert-info-pic[data-v-331378b8]{width:70px;height:70px;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%}.expert-review .expert-info-pic img[data-v-331378b8]{width:100%;height:100%;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;object-fit:cover}.expert-review .expert-info-right[data-v-331378b8]{text-align:left;padding-left:15px}.expert-review .expert-info-right .rating-wrapper[data-v-331378b8]{margin-bottom:10px;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.expert-review .expert-info-right h6[data-v-331378b8]{font-weight:700;color:#fff;margin-bottom:0}.expert-review .expert-info-right span[data-v-331378b8]{font-weight:700;font-size:12px;line-height:112.95%;color:#f3f3f3}.expert-review-bottom span[data-v-331378b8]{float:left;margin-right:10px}.expert-review-bottom p[data-v-331378b8]{font-style:italic;font-weight:300;color:#fff;overflow:hidden;margin-bottom:0}.top-cont[data-v-331378b8]{text-align:center}.play-casino-section[data-v-331378b8]{margin-top:30px}.play-casino-section h1[data-v-331378b8]{color:#fff;padding-left:8px}.play-card[data-v-331378b8]{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;background:#fff;padding:10px 15px 13px;border:1px solid #9b9b9b;min-width:280px}@media (min-width:1200px){.play-card[data-v-331378b8]{padding:15px}}.play-card.top-choice[data-v-331378b8]{border-color:#ffd039}.play-card-top[data-v-331378b8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start}.play-card-top-img[data-v-331378b8]{min-width:68px;max-width:68px;height:68px}@media (min-width:992px){.play-card-top-img[data-v-331378b8]{min-width:72px;max-width:72px;height:72px}}.play-card-top-img img[data-v-331378b8]{width:100%;height:100%;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;object-fit:cover}.play-card-top-right[data-v-331378b8]{padding:0 8px;white-space:normal;min-height:100px}@media (min-width:1200px){.play-card-top-right[data-v-331378b8]{padding:0 16px}}.play-card-top-right h5[data-v-331378b8]{margin:0 0 5px;color:#222}.play-card-top-right .rating-wrapper[data-v-331378b8]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.play-card .cta[data-v-331378b8]{margin-top:0;padding:17px 18px;font-size:18px;line-height:100%}@media (min-width:1200px){.play-card .cta[data-v-331378b8]{padding:17px 18px;font-size:18px;line-height:100%}}.play-card .cta[data-v-331378b8]:hover{background:#9a2b28;border-color:#9a2b28;color:#fff;box-shadow:none;-webkit-box-shadow:none}.play-card .read-review[data-v-331378b8]{display:block;white-space:break-spaces;font-weight:400;font-size:14px;line-height:150%;color:#222;margin:0 auto;text-decoration:underline;width:240px;margin-top:10px;text-align:center}@media (min-width:1080px){.play-card .read-review[data-v-331378b8]{width:350px}}.play-card-index[data-v-331378b8]{display:flex;justify-content:center;align-items:center;position:absolute;width:17px;height:17px;top:0;left:0;background:#dfe1e3;border-radius:0 0 2px;font-size:12px;z-index:1;font-weight:bolder}.play-card-index-0[data-v-331378b8]{background:#ffd03a}.mt-35[data-v-331378b8]{margin-top:35px}.ct-section-title[data-v-331378b8]{margin-top:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ct-section-title h2[data-v-331378b8]{font-weight:600;margin-bottom:0}.ct-section-title h2 img[data-v-331378b8]{width:18px;height:18px}.ct-section-link[data-v-331378b8]{position:relative;margin-top:3px;margin-right:13px;margin-left:auto;color:#3d29b1}.ct-section-link:hover .arrow[data-v-331378b8]{color:#222}.ct-online-casino[data-v-331378b8]{padding:30px 0}.ct-online-casino h1.widget-title[data-v-331378b8]{margin-bottom:15px}.ct-online-casino .content p[data-v-331378b8]{margin-bottom:0}.ct-online-casino-games[data-v-331378b8]{padding:40px 0}.ct-bonus-banner[data-v-331378b8]{padding:30px 0}.ct-card-horizontal[data-v-331378b8]{padding:0;background-color:#f1f2f3}.ct-card-horizontal-game[data-v-331378b8]{padding:0}.ct-card-horizontal-game .casino-card-horizontal[data-v-331378b8]:first-child{margin-top:20px}.top-choice-card[data-v-331378b8]{width:fit-content;padding:6px 10px;background:#ffd039;text-align:center;display:table;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;font-weight:700;font-size:12px;line-height:97.44%;color:#222;display:flex;justify-content:center;align-items:center}.top-choice-card img[data-v-331378b8]{display:inline-block;width:18px!important;height:18px!important;border-radius:0!important;object-fit:contain!important;margin-right:5px}.cta-yellow__lg[data-v-331378b8]{line-height:38px;min-width:270px;color:#fff!important}.cta-yellow__lg[data-v-331378b8]:hover{color:#fff}.selection-cont[data-v-331378b8]{max-width:960px}.show_btn[data-v-331378b8]{margin-top:0!important;line-height:22px}.rating-wrapper[data-v-331378b8]{display:flex;align-items:center;justify-content:center}.rating-wrapper .radio-stars-mob[data-v-331378b8]{background:hsla(0,0%,96%,.3);border-radius:43.0894px;padding:3px 5px}.rating-wrapper .radio-stars-mob img[data-v-331378b8]{margin-right:2px;border-radius:0;width:auto}.sticky-review-card[data-v-331378b8]{z-index:9000;color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.05);transition:top .3s ease-out;border-radius:10px 10px 0 0;padding:3px 8px;display:none}@media (min-width:992px){.sticky-review-card .rating-wrapper-small[data-v-331378b8]{display:inline-flex;height:24px;border-radius:50px;margin-left:15px;padding:1px 7px}.sticky-review-card .rating-wrapper-small .radio-star-total[data-v-331378b8]{margin-left:0}}.sticky-review-card .sticky-inner-wrapper[data-v-331378b8]{width:100%;max-width:78.125rem;padding:10px;display:flex;align-items:center;border-radius:10px}@media (min-width:992px){.sticky-review-card .sticky-inner-wrapper[data-v-331378b8]{background:#fff;position:relative}}.sticky-review-card .sticky-inner-wrapper .sticky-text[data-v-331378b8]{font-size:.75rem}.sticky-review-card .sticky-inner-wrapper .sticky-text div.termsgam[data-v-331378b8]{font-size:12px;line-height:160%}.sticky-review-card .sticky-inner-wrapper .sticky-text .bonus-text[data-v-331378b8]{font-weight:900;font-size:.75rem}.sticky-review-card .sticky-inner-wrapper .sticky-text .bonus-text a[data-v-331378b8]{color:#fff}@media (min-width:768px){.sticky-review-card .sticky-inner-wrapper .sticky-text .bonus-text[data-v-331378b8]{font-size:.85rem}}@media (min-width:992px){.sticky-review-card .sticky-inner-wrapper .sticky-text .bonus-text[data-v-331378b8]{font-size:1.075rem}.sticky-review-card .sticky-inner-wrapper .sticky-text .bonus-text a[data-v-331378b8]{color:#222}}@media (min-width:768px){.sticky-review-card .sticky-inner-wrapper .sticky-text[data-v-331378b8]{font-size:.85rem}}@media (min-width:992px){.sticky-review-card .sticky-inner-wrapper .sticky-text[data-v-331378b8]{margin-left:0}}.sticky-review-card .sticky-inner-wrapper .sticky-text .terms-conditions[data-v-331378b8]{color:#fff}@media (min-width:992px){.sticky-review-card .sticky-inner-wrapper .sticky-text .terms-conditions[data-v-331378b8]{color:#aeaeae}}.sticky-review-card .sticky-inner-wrapper .affliate-logo[data-v-331378b8]{width:65px;min-width:65px;height:65px;min-height:65px;position:relative;margin-right:15px;box-shadow:0 5px 15px rgba(0,0,0,.09)}.sticky-review-card .sticky-inner-wrapper .affliate-logo img[data-v-331378b8]{border-radius:12px}.sticky-review-card .sticky-inner-wrapper .sticky-play-btn[data-v-331378b8]{display:block;color:#fff;box-shadow:none;margin:0;min-width:210px;margin-left:auto}@media (min-width:769px){.sticky-review-card[data-v-331378b8]{min-height:90px;background:#fff;color:#222;display:block}}.pb-25[data-v-331378b8]{padding-bottom:25px}.pt-37[data-v-331378b8]{padding-top:37px}.helpful[data-v-331378b8]{background:#fff;width:100%;height:101px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:27px 17px 27px 22px;margin:25px 0 30px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}@media (min-width:768px){.helpful[data-v-331378b8]{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}}@media (min-width:992px){.helpful[data-v-331378b8]{margin:45px 0 52px;padding:33px 41px 33px 37px}}.helpful h3[data-v-331378b8]{margin-bottom:0}.hide-mob[data-v-331378b8]{display:none}@media (min-width:768px){.hide-mob[data-v-331378b8]{display:block}}.casino-header[data-v-331378b8]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-331378b8]{text-align:center;color:#fff;font-weight:700;padding:8px}.rotate-svg[data-v-331378b8]{margin-bottom:20px;-webkit-animation:rotateRight-data-v-331378b8 .7s ease 1s forwards;-moz-animation:rotateRight-data-v-331378b8 .7s ease 1s forwards;animation:rotateRight-data-v-331378b8 .7s ease 1s forwards}.rotate-msg[data-v-331378b8]{position:absolute;top:0;left:0;align-items:center;justify-content:center;flex-direction:column;display:flex;height:100vh;z-index:9;width:100vw;background-color:#080438;background-color:var(--primary-bg)}@media (orientation:landscape){.rotate-msg[data-v-331378b8]{display:none}}@media (min-width:992px){.rotate-msg[data-v-331378b8]{display:none}}.rotate-msg svg[data-v-331378b8]{fill:var(--primary-color);height:110px}.rotate-msg span[data-v-331378b8]{color:var(--primary-color);font-size:1.25rem;width:75%;margin-bottom:30px;opacity:1;text-align:center}.rotate-msg .back-btn[data-v-331378b8]{color:var(--primary-color);border-color:var(--primary-color)!important;width:80%;z-index:10}@-webkit-keyframes rotateRight-data-v-331378b8{to{-webkit-transform:rotate(90deg);transform:rotate(90deg)}}@keyframes rotateRight-data-v-331378b8{to{-webkit-transform:rotate(90deg);transform:rotate(90deg)}}.font-dark[data-v-331378b8]{color:#222}.font-dark svg[data-v-331378b8]{fill:#222}.font-light[data-v-331378b8]{color:#fff}.font-light svg[data-v-331378b8]{fill:#fff}.pt-20[data-v-331378b8]{padding-top:20px!important}.bonus-link[data-v-331378b8]{text-decoration:underline}.bonus-link span[data-v-331378b8]{display:block}.bonus-link:hover span[data-v-331378b8],.bonus-link[data-v-331378b8]:hover{color:var(--color-hover)!important}.gamefree-casino:hover a[data-v-331378b8]{color:var(--hover-color)}.cta-promotion[data-v-331378b8],.cta-yellow[data-v-331378b8]{font-weight:700!important;font-size:18px!important;line-height:100%!important;padding:17px 18px!important}.bg-link[data-v-331378b8]{position:absolute;height:100%;width:100%;z-index:1}.button-block a[data-v-331378b8],.game-logo[data-v-331378b8],.z-index-2[data-v-331378b8]{z-index:2}.banner-wd[data-v-331378b8]{width:100%!important}.mw-300[data-v-331378b8]{min-width:300px}@media (min-width:992px){.mw-300[data-v-331378b8]{min-width:auto}}.iframe-full .block-wrapper[data-v-331378b8],.iframe-full .play-casino-section[data-v-331378b8]{display:none}@media (min-width:320px){.cta-overlay-enable-mobile[data-v-331378b8]{display:flex!important;position:absolute;padding:20px 0}}@media (min-width:350px){.cta-overlay-enable-mobile[data-v-331378b8]{display:flex!important;position:absolute!important;padding:20px 0}}@media (min-width:576px){.cta-overlay-enable-mobile[data-v-331378b8]{display:flex!important;position:fixed!important;padding:20px 0}}.cta-overlay-enable-mobile img[data-v-331378b8]{width:102px!important;min-height:102px!important}.cta-overlay-enable-mobile .text-wrapper[data-v-331378b8]{padding:0!important}.cta-overlay[data-v-331378b8]{top:0;left:0;width:100%;height:100%;z-index:1000;display:none;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;text-align:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}@media (min-width:350px){.cta-overlay[data-v-331378b8]{display:flex;position:fixed;padding:20px 0}}@media (min-width:768px){.cta-overlay[data-v-331378b8]{top:0}}@media (min-width:992px){.cta-overlay[data-v-331378b8]{position:absolute;top:0}}.cta-overlay .cta-promotion .best-rating[data-v-331378b8]{padding:15px 0}.cta-overlay .cta-promotion .best-rating .rating-wrapper .rating-star-total[data-v-331378b8]{display:none}.cta-overlay .span[data-v-331378b8]{color:var(--primary-color)!important}.cta-overlay .how-about[data-v-331378b8]{color:var(--primary-color)!important;font-weight:700;font-size:1.25rem;line-height:25px;display:flex;justify-content:center;width:90%}@media (min-width:768px){.cta-overlay .how-about[data-v-331378b8]{font-size:1.75rem;line-height:120%}}@media (min-width:992px){.cta-overlay .how-about[data-v-331378b8]{font-size:1.75rem;line-height:150%;width:60%}}.cta-overlay .ct-btn[data-v-331378b8]{margin:12px auto 0}@media (min-width:992px){.cta-overlay .ct-btn[data-v-331378b8]{margin:25px auto 0}}.cta-overlay .back-btn[data-v-331378b8]{color:var(--primary-color);border-color:var(--primary-color)!important;z-index:10;width:100%}.cta-overlay .get-a[data-v-331378b8]{color:var(--primary-color);text-decoration:underline}.text-wrapper[data-v-331378b8]{width:75%;padding:0 45px}@media (min-width:768px){.text-wrapper[data-v-331378b8]{width:60%;margin:0 auto}}@media (min-width:992px){.text-wrapper[data-v-331378b8]{width:38%;margin:0 auto}}.img-cas[data-v-331378b8]{display:block;width:102px;height:102px}@media (min-width:768px){.img-cas[data-v-331378b8]{display:block}}@media (min-width:992px){.img-cas[data-v-331378b8]{margin-bottom:11px!important}}.cust-h1[data-v-331378b8]{font-size:26px;line-height:31px}.span-h5[data-v-331378b8]{line-height:160%!important;margin:0!important}.term-recas[data-v-331378b8]{border-bottom-left-radius:0;border-bottom-right-radius:0}.cas-terms[data-v-331378b8]{background:#dfe1e3;display:flex;padding:5px 15px;margin:0;width:100%;font-weight:400;color:#222;min-height:33px;border-bottom-left-radius:12px;border-bottom-right-radius:12px;line-height:15px;font-size:.75rem;white-space:pre-wrap;min-width:254px;box-shadow:0 3px 4px rgba(0,0,0,.25)}.cas-terms span[data-v-331378b8]{margin:auto 0}@media (min-width:768px){.cas-terms[data-v-331378b8]{line-height:18px;font-size:.75rem}}.hover-btn .cta-text[data-v-331378b8]{width:100%}.rm-bottom-color[data-v-331378b8]{border-bottom-color:transparent!important}.terms-top-choice[data-v-331378b8]{border:2px solid #ffd039;border-top-color:transparent}.emt-sp[data-v-331378b8]{display:block;margin-top:6px}.games-banner-block[data-v-331378b8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}@media (min-width:992px){.games-banner-block[data-v-331378b8]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.games-banner-block .ct-inner-banner-lft[data-v-331378b8]{width:100%;margin-right:0}@media (min-width:992px){.games-banner-block .ct-inner-banner-lft[data-v-331378b8]{width:calc(100% - 320px);margin-right:30px}}.games-banner-block .ct-inner-banner-rgt[data-v-331378b8]{min-width:100%;max-width:100%}@media (min-width:992px){.games-banner-block .ct-inner-banner-rgt[data-v-331378b8]{min-width:320px;max-width:320px}}.games-banner-block .ct-inner-banner-rgt .span-h1[data-v-331378b8]{font-weight:900;color:#fff;margin:0 0 16px;display:block;text-align:left}@media (min-width:992px){.games-banner-block .ct-inner-banner-rgt .span-h1[data-v-331378b8]{text-align:center}}.games-banner-block .ct-inner-banner-rgt .mobile-scroller[data-v-331378b8]{display:block;padding:0}@media (min-width:768px){.games-banner-block .ct-inner-banner-rgt .mobile-scroller[data-v-331378b8]{display:-webkit-box;display:-ms-flexbox;display:flex}}@media (min-width:992px){.games-banner-block .ct-inner-banner-rgt .mobile-scroller[data-v-331378b8]{display:block}}.games-banner-block .play-card[data-v-331378b8]{position:relative;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;padding:8px;margin-bottom:16px}@media (min-width:768px){.games-banner-block .play-card[data-v-331378b8]{margin-bottom:0;margin-right:16px;min-width:320px}}@media (min-width:992px){.games-banner-block .play-card[data-v-331378b8]{margin-right:0;margin-bottom:16px}}.games-banner-block .play-card[data-v-331378b8]:last-child{margin-bottom:0}.games-banner-block .play-card .top-choice-medal[data-v-331378b8]{position:absolute;right:20px;top:9px}.games-banner-block .play-card .top-choice-medal img[data-v-331378b8]{max-width:31px}.games-banner-block .play-card-top[data-v-331378b8]{margin-bottom:14px}.games-banner-block .play-card-top-img[data-v-331378b8]{min-width:40px;max-width:40px;height:40px}.games-banner-block .play-card-top-right[data-v-331378b8]{padding:0 12px;min-height:auto}.games-banner-block .play-card-top-right .casino-title[data-v-331378b8]{font-weight:700;font-size:16px;line-height:20px;letter-spacing:-.03em;color:#222;display:block;padding-right:35px}.games-banner-block .play-card-mid[data-v-331378b8]{margin-bottom:8px}.games-banner-block .play-card-mid .bonus-link[data-v-331378b8]{font-weight:900;font-size:16px;line-height:140%;text-align:center;color:#002844;display:inline-block;white-space:normal}.games-banner-block .play-card .terms-text[data-v-331378b8]{margin-top:8px}.games-banner-block .play-card .terms-text p[data-v-331378b8]{font-weight:400;text-align:center;color:#aeaeae;margin:0}.game-terms-text[data-v-331378b8]{font-size:12px!important;display:block;white-space:break-spaces;margin-top:5px;line-height:14px}.gm-terms a[data-v-331378b8]{cursor:pointer;text-decoration:underline!important}.gm-terms a[data-v-331378b8]:hover{color:var(--primary-btn)}.game-bonus-text[data-v-331378b8]{text-align:center}.mob-game-title[data-v-331378b8]{display:block}@media (min-width:992px){.mob-game-title[data-v-331378b8]{display:none!important}}.cta-game-large[data-v-331378b8]{display:block}.stick-part-1[data-v-331378b8]{min-width:130px}.stick-part-2[data-v-331378b8]{padding:0 10px}.stripe-gam[data-v-331378b8]{display:block!important;text-align:center}.stripe-gam span[data-v-331378b8]{font-size:12px;line-height:160%;font-weight:700;display:flex;justify-content:center;align-items:center;height:28px}.stripe-gam span img[data-v-331378b8]{margin-right:5px}.stripe-gam p[data-v-331378b8]{font-weight:700}.stripe-gam[data-v-331378b8]{position:absolute;width:100%;height:28px;bottom:0;left:0;overflow:hidden;border-bottom-left-radius:10px;border-bottom-right-radius:10px;background-color:#ffd039;display:none}@media (min-width:576px){.stripe-gam[data-v-331378b8]{display:block}}@media (max-width:992px){.stripe-gam[data-v-331378b8]{top:50%;transform:translateY(41px);width:136px}}.stripe-gam img[data-v-331378b8]{width:18px!important;height:18px!important;border-radius:0!important;object-fit:contain!important}.stripe-gam-overlay[data-v-331378b8]{display:block!important;text-align:center}.stripe-gam-overlay span[data-v-331378b8]{font-size:12px;line-height:160%;font-weight:700;display:flex;justify-content:center;align-items:center;height:28px}.stripe-gam-overlay span img[data-v-331378b8]{margin-right:5px}.stripe-gam-overlay p[data-v-331378b8]{font-weight:700}.stripe-gam-overlay[data-v-331378b8]{position:absolute;height:28px;width:100%;top:calc(100% - 28px);left:0;overflow:hidden;border-bottom-left-radius:10px;border-bottom-right-radius:10px;background-color:#ffd039;display:none}@media (min-width:576px){.stripe-gam-overlay[data-v-331378b8]{display:block}}@media (min-width:992px){.stripe-gam-overlay[data-v-331378b8]{top:calc(100% - 28px);width:102px}}.stripe-gam-overlay img[data-v-331378b8]{width:18px!important;height:18px!important;border-radius:0!important;object-fit:contain!important}.gam-strp[data-v-331378b8]{position:relative}.best-rating[data-v-331378b8]{margin-left:8px;margin-top:8px;margin-bottom:5px}@media (min-width:992px){.best-rating[data-v-331378b8]{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVgAAAF1BAMAAABfcO+bAAAAJ1BMVEX///9HcEwAAAD///////////////////////////////////////8gFj0oAAAADXRSTlMNAAEMAQYFCgIJCAsHJyo3RwAAAdhJREFUeNrt0jFKg0EQgNGVIIJYONEkglU8QYSAdXoLA14g4AFMbRlQsBM9gIUXsLTzaBYq6v4LsZzA+7qFWeYVU2KDKrCwsLCwsC3s+U1J19lVG3tXUvbSwg4mObG9eQP7XpK218UOStrmHewqL3bawT7nxe7U2KOSuFmFHWbGzivsKDN2WWEPMmNfK+x+ZuwWLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCws7AZgjzNjTyvsKDP2ocIOMmMXFfYwM3ZWYeM6r3U3auwqL3bawQ7zn+wPNi6yWrejix1Oclp7iwY27nNin6KFjdvHfNS3y2hjvzuJiOh/PcaxvvE/537V//zQj8aaP/tjDTZtsLCwsLCwsLCwsLCw3T4A4Ou+lGcwf1wAAAAASUVORK5CYII=");

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroBlock_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b539fa6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroBlock_vue__ = __webpack_require__(659);
function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b539fa6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b539fa6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(655);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("21a2a1a2", content, true, {});

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-1b539fa6]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-1b539fa6]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-1b539fa6]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-1b539fa6]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-1b539fa6]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-1b539fa6]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-1b539fa6]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-1b539fa6]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-1b539fa6]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-1b539fa6]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-1b539fa6]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-1b539fa6]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.intro-block[data-v-1b539fa6]{padding-bottom:26px}.show-cls[data-v-1b539fa6]{display:block;text-decoration:underline;cursor:pointer;padding-bottom:5px}.content-left[data-v-1b539fa6]{text-align:left}.content-center[data-v-1b539fa6]{text-align:center}.content-right[data-v-1b539fa6]{text-align:right}.intro-content[data-v-1b539fa6]{position:relative;overflow:hidden}.none-height[data-v-1b539fa6]{max-height:none!important}.intro-hover[data-v-1b539fa6]:after{content:\"\";position:absolute;bottom:0;left:0;width:100%;display:block;height:26px;background:linear-gradient(1turn,var(--bg-color) 100.95%,transparent 360%);opacity:.5}.author-section[data-v-1b539fa6]{background:transparent}.author-section .row .col-lg-3[data-v-1b539fa6],.author-section .row[data-v-1b539fa6]{padding-left:0;padding-right:0}.author-wrapper-big-card[data-v-1b539fa6]{display:flex;flex-direction:column;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin-bottom:10px;background:#fff;padding:16px}@media (min-width:576px){.author-wrapper-big-card[data-v-1b539fa6]{flex-direction:row}}.author-wrapper-big-card .author-img[data-v-1b539fa6]{display:flex;margin-right:10px}.pubdate[data-v-1b539fa6]{float:right}.publish-date[data-v-1b539fa6]{font-size:12px;color:#9b9b9b;display:flex;align-items:center;margin-bottom:16px}.publish-date-icon[data-v-1b539fa6]{margin-right:6px;margin-top:2px}@media (min-width:576px){.author-wrapper-big-card .author-img[data-v-1b539fa6]{width:50%}}.author-wrapper-big-card .author-img img[data-v-1b539fa6]{width:70px;height:70px;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin-right:16px}@media (min-width:576px){.author-wrapper-big-card .author-img img[data-v-1b539fa6]{width:100px;height:100px}}.author-wrapper-big-card .author-img-content[data-v-1b539fa6]{line-height:18px;height:70px;display:flex;flex-direction:column;justify-content:space-between}@media (min-width:576px){.author-wrapper-big-card .author-img-content[data-v-1b539fa6]{height:100px}}.author-wrapper-big-card .author-img-content .span-h2[data-v-1b539fa6]{margin:0;line-height:32px}.author-wrapper-big-card .author-img-content p.mob-nam[data-v-1b539fa6]{margin:0;font-weight:700}.author-wrapper-big-card .author-img-content .span-title[data-v-1b539fa6]{color:#9b9b9b}.author-wrapper-big-card .author-img-content a[data-v-1b539fa6]{cursor:pointer}.author-wrapper-big-card .author-content[data-v-1b539fa6]{display:flex;flex-direction:column;justify-content:center}@media (min-width:576px){.author-wrapper-big-card .author-content[data-v-1b539fa6]{width:calc(50% - 10px)}}@media (max-width:576px){.author-wrapper-big-card .author-content[data-v-1b539fa6]{margin-top:16px}}.author-wrapper-big-card .author-content .span-h5[data-v-1b539fa6],.author-wrapper-big-card .author-content p[data-v-1b539fa6]{margin:0}.author-wrapper-small-card[data-v-1b539fa6]{display:flex;flex-direction:row;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin-bottom:16px;margin-right:10px}.author-wrapper-small-card img[data-v-1b539fa6]{width:40px;height:40px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;margin-right:16px}.author-wrapper-small-card .author-img-content[data-v-1b539fa6]{line-height:18px;display:flex;flex-direction:column}.author-wrapper-small-card .author-img-content .inner-wrap[data-v-1b539fa6]{display:flex;flex-direction:row;align-items:center}.author-wrapper-small-card .author-img-content .inner-wrap a[data-v-1b539fa6]{width:auto;height:auto;margin-left:0}.author-wrapper-small-card .author-img-content .p-bold[data-v-1b539fa6]{margin:0;font-weight:700;color:#fff}.author-wrapper-small-card .author-img-content .span-caption[data-v-1b539fa6]{color:#9b9b9b;line-height:10px}.author-wrapper-small-card .author-img-content a[data-v-1b539fa6]{cursor:pointer;margin-left:8px;width:16px;height:16px}.author-desktop-version[data-v-1b539fa6]{display:none}@media (min-width:576px){.author-desktop-version[data-v-1b539fa6]{display:flex}}.author-mobile-version[data-v-1b539fa6]{display:flex}@media (min-width:576px){.author-mobile-version[data-v-1b539fa6]{display:none}}@media (min-width:768px){.full-card[data-v-1b539fa6]{flex-direction:column!important}.full-card-img[data-v-1b539fa6]{width:100%!important;margin-right:0!important}.full-card-content[data-v-1b539fa6]{width:100%!important;margin-top:10px!important}}", ""]);

// exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(657);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("cf3aa2bc", content, true, {});

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-07b6b668]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-07b6b668]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-07b6b668]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-07b6b668]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-07b6b668]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-07b6b668]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-07b6b668]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-07b6b668]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-07b6b668]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-07b6b668]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-07b6b668]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-07b6b668]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.block-content-light h1[data-v-07b6b668],.block-content-light h2[data-v-07b6b668],.block-content-light h3[data-v-07b6b668],.block-content-light h4[data-v-07b6b668],.block-content-light h5[data-v-07b6b668],.block-content-light h6[data-v-07b6b668],.block-content-light span[data-v-07b6b668]{color:#fff}.block-content-gray h1[data-v-07b6b668],.block-content-gray h2[data-v-07b6b668],.block-content-gray h3[data-v-07b6b668],.block-content-gray h4[data-v-07b6b668],.block-content-gray h5[data-v-07b6b668],.block-content-gray h6[data-v-07b6b668],.block-content-gray span[data-v-07b6b668]{color:#f5f6fc}.tg[data-v-07b6b668]{margin-bottom:0!important;line-height:20px!important}@media (max-width:576px){.intro-head[data-v-07b6b668]{line-height:140%!important}}.article-header[data-v-07b6b668]{color:#fff;margin:0 10px 0 5px}@media (min-width:768px){.article-header[data-v-07b6b668]{margin:0 100px}}.no-margin[data-v-07b6b668]{margin:20px 0;font-weight:700}.head-left[data-v-07b6b668]{text-align:left}.head-center[data-v-07b6b668]{text-align:center}.head-right[data-v-07b6b668]{text-align:right}.home-font[data-v-07b6b668]{font-size:16px!important;margin-bottom:10px!important;font-weight:700;display:block;text-align:left!important}@media (min-width:576px){.home-font[data-v-07b6b668]{font-size:18px!important;margin-bottom:20px!important}}.gm-title[data-v-07b6b668]{text-align:left;line-height:31px}@media (min-width:992px){.gm-title[data-v-07b6b668]{text-align:center}}.cust-h1[data-v-07b6b668]{font-size:26px;line-height:31px;font-weight:900;margin:0 0 16px;display:block}.new-card-title[data-v-07b6b668]{font-size:22px}@media (min-width:992px){.home-ban-title[data-v-07b6b668]{max-width:605px}}.team-header[data-v-07b6b668]{border-bottom:1px solid #bdbdbe;padding-bottom:16px}.team-head-margin[data-v-07b6b668]{margin-bottom:32px}@media (min-width:992px){.team-head-margin[data-v-07b6b668]{margin-bottom:48px}}", ""]);

// exports


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.block === 'usBlock')?[_c(_vm.usTag,{tag:"component",class:[
        'custom-font-1',
        _vm.tag != 'span' ? '' : 'span-h2',
        !_vm.getContrastYIQ(_vm.$root.color_schema.primary) && _vm.sty
          ? 'text-white'
          : '',
        _vm.getContrastYIQ(_vm.$root.color_schema.primary) && _vm.sty ? 'text-gray' : '' ]},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'newCard')?[_c(_vm.usTag,{tag:"component",class:[
        'custom-font-1 new-card-title',
        _vm.tag != 'span' ? '' : 'span-h2',
        _vm.sty === 'white' ? 'text-white' : '',
        _vm.sty === 'black' ? 'text-gray' : '' ]},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'introBlock')?[_c(_vm.usTag,{tag:"component",class:[
        'custom-font-1 intro-head',
        _vm.tag != 'span' ? '' : 'span-h2',
        !_vm.getContrastYIQ(_vm.sty) ? 'text-white' : '',
        _vm.getContrastYIQ(_vm.sty) ? 'text-gray' : '',
        _vm.titleAlign === 'left' ? 'head-left' : '',
        _vm.titleAlign === 'center' ? 'head-center' : '',
        _vm.titleAlign === 'right' ? 'head-right' : '' ]},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'articleBanner')?[_c(_vm.usTag,{tag:"component",staticClass:"article-header"},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'geoText')?[_c(_vm.usTag,{tag:"component",class:[
        _vm.usTag === 'p' ? 'custom-font-2' : 'custom-font-1',
        _vm.tag != 'span' ? '' : 'span-h2' ]},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'promoBanner')?[_c(_vm.usTag,{tag:"component",staticClass:"text-white no-margin"},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'gamepageBanner')?[_c(_vm.usTag,{tag:"component",class:{ 'text-white gm-title': true, 'cust-h1': _vm.usTag === 'span' }},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'homeBanner')?[_c(_vm.usTag,{tag:"component",class:[_vm.sty === '' ? 'text-white' : '', 'home-ban-title'],style:({ color: _vm.sty })},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'homeBanner-second')?[_c(_vm.usTag,{tag:"component",class:[_vm.sty === '' ? 'text-white' : '', 'home-font'],style:({ color: _vm.sty })},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'howto')?[_c(_vm.usTag,{tag:"component",style:({ color: _vm.sty })},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'bestPayment')?[_c(_vm.usTag,{tag:"component",class:[_vm.usTag === 'span' ? 'span-h2' : '', 'text-white']},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'homePage')?[_c(_vm.usTag,{tag:"component"},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'homePageTestimonial')?[_c(_vm.usTag,{tag:"component",class:[_vm.usTag === 'span' ? 'span-h5' : '']},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'blueProgressive')?[_c(_vm.usTag,{tag:"component",class:[_vm.usTag === 'span' ? 'span-h3' : '']},[_vm._v(_vm._s(_vm.title))])]:(_vm.block === 'teamSection')?[_c(_vm.usTag,{tag:"component",class:[
        _vm.usTag === 'span' ? 'span-h2' : '',
        _vm.sty === 'show' ? 'team-head-margin' : '',
        'team-header' ]},[_vm._v(_vm._s(_vm.title))])]:[_c(_vm.tag,{tag:"component",class:['custom-font-1', _vm.tag != 'span' ? '' : 'span-h2']},[_vm._v(_vm._s(_vm.title))])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.introBlockData).length > 0)?_c('div',{class:{
    'intro-block': true,
    'pt-26': _vm.pageName === 'home' && _vm.introBlockData.enable_top_space,
  },style:({
    background: _vm.introBlockData.enable_bg_color
      ? _vm.$root.color_schema.primary
      : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
        _vm.introBlockData.custom_bg_color != ''
      ? _vm.introBlockData.custom_bg_color
      : null,
  })},[_c('div',{staticClass:"container"},[_c('TagBlock',{attrs:{"attrs":{},"title":_vm.introBlockData.title,"block":'introBlock',"usTag":_vm.introBlockData.title_tag,"sty":_vm.introBlockData.enable_bg_color
          ? _vm.$root.color_schema.primary
          : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
            _vm.introBlockData.custom_bg_color != ''
          ? _vm.introBlockData.custom_bg_color
          : false,"colorEnable":_vm.introBlockData.enable_bg_color,"titleAlign":_vm.introBlockData.alignment}}),_vm._v(" "),(_vm.introBlockData.enable_author_info && _vm.introBlockData.authors)?[_c('section',{staticClass:"author-section"},[_c('div',{staticClass:"container"},[(
        _vm.blockStyle === 'big' &&
        !(_vm.introBlockData.authors.filter(function (ele) { return ele.description === ''; }).length > 0)
      )?_vm._l((_vm.introBlockData.authors),function(data,index){return _c('div',{key:'desk' + index,class:{
          'author-wrapper-big-card': true,
        }},[_c('div',{class:{
            'author-img': true,
          }},[_c('img',{attrs:{"src":data.user_avatar_url,"width":"100","height":"100","alt":_vm.getAltText('', data.user_avatar_url)}}),_vm._v(" "),_c('div',{staticClass:"author-img-content"},[_c('div',[(
                  data.profile_data.slug === ''
                  && data.profile_data.post_type === ''
                )?[_c('span',{staticClass:"span-h2 author-desktop-version"},[_vm._v("\n                  "+_vm._s(data.display_name)+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"mob-nam author-mobile-version"},[_vm._v("\n                        "+_vm._s(data.display_name)+"\n                      ")])]:[_c('a',{attrs:{"href":_vm.getRouteLink(data.profile_data.slug,data.profile_data.post_type)}},[_c('span',{staticClass:"span-h2 author-desktop-version"},[_vm._v("\n                      "+_vm._s(data.display_name)+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"mob-nam author-mobile-version"},[_vm._v("\n                          "+_vm._s(data.display_name)+"\n                        ")])])],_vm._v(" "),_c('span',{staticClass:"span-title"},[_vm._v(_vm._s(data.role_title))])],2),_vm._v(" "),(
                data.social_links &&
                Object.keys(data.social_links).length > 0 &&
                data.social_links.linkedin &&
                data.social_links.linkedin != ''
              )?_c('a',{staticStyle:{"margin-left":"10px"},attrs:{"title":data.display_name,"href":data.social_links.linkedin,"target":"_blank","rel":"no-follow"}},[_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.1354 0C1.41118 0 0 1.41114 0 3.1354V12.8651C0 14.5893 1.41114 16 3.1354 16H12.8651C14.5894 16 16 14.5894 16 12.8651V3.1354C16 1.41118 14.5894 0 12.8651 0H3.1354ZM3.924 2.64032C4.75073 2.64032 5.25996 3.18306 5.27568 3.89647C5.27568 4.59414 4.7507 5.15212 3.90801 5.15212H3.8925C3.08151 5.15212 2.55733 4.59417 2.55733 3.89647C2.55733 3.18307 3.09737 2.64032 3.92399 2.64032H3.924ZM11.0484 5.97474C12.6384 5.97474 13.8303 7.01394 13.8303 9.24714V13.4162H11.4139V9.52666C11.4139 8.54927 11.0642 7.88245 10.1898 7.88245C9.52224 7.88245 9.12434 8.3319 8.94964 8.76607C8.88582 8.9214 8.87013 9.13834 8.87013 9.35564V13.4162H6.45383C6.45383 13.4162 6.48554 6.82746 6.45383 6.14525H8.87063V7.17488C9.19173 6.67946 9.76609 5.97472 11.0484 5.97472V5.97474ZM2.69985 6.14577H5.11616V13.4162H2.69985V6.14577Z","fill":"lightgrey"}})])]):_vm._e()])]),_vm._v(" "),_c('div',{class:{
            'author-content': true,
          }},[_c('span',{staticClass:"span-h5"},[_vm._v(_vm._s(_vm.i18n.about_the_author))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(data.description))])])])}):[_c('div',{staticClass:"row"},[_vm._l((_vm.introBlockData.authors),function(data,index){return _c('div',{key:'desk' + index,staticClass:"col-lg-3"},[_c('div',{staticClass:"author-wrapper-small-card"},[_c('img',{attrs:{"src":data.user_avatar_url,"width":"100","height":"100","alt":_vm.getAltText('', data.user_avatar_url)}}),_vm._v(" "),_c('div',{staticClass:"author-img-content"},[_c('div',{staticClass:"inner-wrap"},[(
                  data.profile_data.slug === ''
                  && data.profile_data.post_type === ''
                )?[_c('p',{staticClass:"p-bold"},[_vm._v("\n                          "+_vm._s(data.display_name)+"\n                        ")])]:[_c('a',{attrs:{"href":_vm.getRouteLink(data.profile_data.slug,data.profile_data.post_type)}},[_c('p',{staticClass:"p-bold"},[_vm._v("\n                            "+_vm._s(data.display_name)+"\n                          ")])])],_vm._v(" "),(
                    data.social_links &&
                    Object.keys(data.social_links).length > 0 &&
                    data.social_links.linkedin &&
                    data.social_links.linkedin != ''
                  )?_c('a',{staticStyle:{"margin-left":"10px"},attrs:{"title":data.display_name,"href":data.social_links.linkedin,"target":"_blank","rel":"no-follow"}},[_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.1354 0C1.41118 0 0 1.41114 0 3.1354V12.8651C0 14.5893 1.41114 16 3.1354 16H12.8651C14.5894 16 16 14.5894 16 12.8651V3.1354C16 1.41118 14.5894 0 12.8651 0H3.1354ZM3.924 2.64032C4.75073 2.64032 5.25996 3.18306 5.27568 3.89647C5.27568 4.59414 4.7507 5.15212 3.90801 5.15212H3.8925C3.08151 5.15212 2.55733 4.59417 2.55733 3.89647C2.55733 3.18307 3.09737 2.64032 3.92399 2.64032H3.924ZM11.0484 5.97474C12.6384 5.97474 13.8303 7.01394 13.8303 9.24714V13.4162H11.4139V9.52666C11.4139 8.54927 11.0642 7.88245 10.1898 7.88245C9.52224 7.88245 9.12434 8.3319 8.94964 8.76607C8.88582 8.9214 8.87013 9.13834 8.87013 9.35564V13.4162H6.45383C6.45383 13.4162 6.48554 6.82746 6.45383 6.14525H8.87063V7.17488C9.19173 6.67946 9.76609 5.97472 11.0484 5.97472V5.97474ZM2.69985 6.14577H5.11616V13.4162H2.69985V6.14577Z","fill":"lightgrey"}})])]):_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"span-caption"},[_vm._v(_vm._s(data.role_title))])])])])}),_vm._v(" "),_c('div',{staticClass:"col-lg-3 float-right justify-content-end pubdate"},[_c('div',{staticClass:"publish-date text-right"},[_c('span',{staticClass:"span-caption"},[_c('svg',{attrs:{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 1.5H10V0.499969C10 0.22403 9.776 0 9.49997 0H9C8.72397 0 8.50003 0.22403 8.50003 0.499969V1.5H3.49997V0.499969C3.49997 0.22403 3.27603 0 3 0H2.50003C2.224 0 1.99997 0.22403 1.99997 0.499969V1.5H1.5C0.673004 1.5 0 2.173 0 3V10.5C0 11.327 0.673004 12 1.5 12H10.5C11.327 12 12 11.327 12 10.5V3C12 2.173 11.327 1.5 10.5 1.5ZM11 10.5C11 10.7755 10.7755 11 10.5 11H1.5C1.22452 11 1.00003 10.7755 1.00003 10.5V5.02002H11V10.5Z","fill":"#9B9B9B"}})]),_vm._v("\n                    "+_vm._s(_vm.introBlockData.post_date_read_time)+"\n                  ")])])])],2)]],2)])]:_vm._e(),_vm._v(" "),(_vm.introinnerWidth < 576)?[(!_vm.introBlockData.disable_showmore_mobile)?[(
            _vm.introBlockData.content.length > 0 &&
            _vm.introBlockData.content.length <
              44 * _vm.introBlockData.no_of_lines_mobile -
                (_vm.introBlockData.no_of_lines_mobile === '1'
                  ? 0
                  : 3 * _vm.introBlockData.no_of_lines_mobile)
          )?[_c('div',{class:{
              'intro-content intro-content': true,
              'block-content-light': _vm.introBlockData.enable_bg_color
                ? !_vm.getContrastYIQ(_vm.$root.color_schema.primary)
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? !_vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                : false,
              'block-content-dark': _vm.introBlockData.enable_bg_color
                ? _vm.getContrastYIQ(_vm.$root.color_schema.primary)
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? _vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                : false,
              'content-left': _vm.introBlockData.alignment === 'left',
              'content-center': _vm.introBlockData.alignment === 'center',
              'content-right': _vm.introBlockData.alignment === 'right',
            },style:({
              '--bg-color': _vm.introBlockData.enable_bg_color
                ? _vm.$root.color_schema.primary
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? _vm.introBlockData.custom_bg_color
                : false,
            }),domProps:{"innerHTML":_vm._s(_vm.introBlockData.content)}})]:(
            _vm.introBlockData.content.length > 0 &&
            _vm.introBlockData.content.length >=
              44 * _vm.introBlockData.no_of_lines_mobile -
                (_vm.introBlockData.no_of_lines_mobile === '1'
                  ? 0
                  : 3 * _vm.introBlockData.no_of_lines_mobile)
          )?[_c('div',{class:{
              'intro-content intro-hover': true,
              'block-content-light': _vm.introBlockData.enable_bg_color
                ? !_vm.getContrastYIQ(_vm.$root.color_schema.primary)
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? !_vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                : false,
              'block-content-dark': _vm.introBlockData.enable_bg_color
                ? _vm.getContrastYIQ(_vm.$root.color_schema.primary)
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? _vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                : false,
              'content-left': _vm.introBlockData.alignment === 'left',
              'content-center': _vm.introBlockData.alignment === 'center',
              'content-right': _vm.introBlockData.alignment === 'right',
            },style:({
              '--bg-color': _vm.introBlockData.enable_bg_color
                ? _vm.$root.color_schema.primary
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? _vm.introBlockData.custom_bg_color
                : false,
              'max-height': ((25 * _vm.introBlockData.no_of_lines_mobile) + "px"),
            }),domProps:{"innerHTML":_vm._s(_vm.introBlockData.content)}}),_vm._v(" "),(_vm.introBlockData.disable_showmore_mobile)?void 0:[(!_vm.showFullText)?_c('a',{class:{
                'show-cls': true,
                'text-white': _vm.introBlockData.enable_bg_color
                  ? !_vm.getContrastYIQ(_vm.$root.color_schema.primary)
                  : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                    _vm.introBlockData.custom_bg_color != ''
                  ? !_vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                  : false,
                'text-gray': _vm.introBlockData.enable_bg_color
                  ? _vm.getContrastYIQ(_vm.$root.color_schema.primary)
                  : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                    _vm.introBlockData.custom_bg_color != ''
                  ? _vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                  : false,
                'content-left': _vm.introBlockData.alignment === 'left',
                'content-center': _vm.introBlockData.alignment === 'center',
                'content-right': _vm.introBlockData.alignment === 'right',
              },attrs:{"title":_vm.$root.i18n.show_more},on:{"click":function($event){return _vm.showMoreText()}}},[_vm._v(_vm._s(_vm.$root.i18n.show_more))]):_c('a',{class:{
                'show-cls': true,
                'text-white': _vm.introBlockData.enable_bg_color
                  ? !_vm.getContrastYIQ(_vm.$root.color_schema.primary)
                  : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                    _vm.introBlockData.custom_bg_color != ''
                  ? !_vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                  : false,
                'text-gray': _vm.introBlockData.enable_bg_color
                  ? _vm.getContrastYIQ(_vm.$root.color_schema.primary)
                  : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                    _vm.introBlockData.custom_bg_color != ''
                  ? _vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                  : false,
                'content-left': _vm.introBlockData.alignment === 'left',
                'content-center': _vm.introBlockData.alignment === 'center',
                'content-right': _vm.introBlockData.alignment === 'right',
              },attrs:{"title":_vm.$root.i18n.show_less},on:{"click":function($event){return _vm.showMoreText()}}},[_vm._v(_vm._s(_vm.$root.i18n.show_less))])]]:_vm._e()]:[_c('div',{class:{
            'intro-content': true,
            'block-content-light': _vm.introBlockData.enable_bg_color
              ? !_vm.getContrastYIQ(_vm.$root.color_schema.primary)
              : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                _vm.introBlockData.custom_bg_color != ''
              ? !_vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
              : false,
            'block-content-dark': _vm.introBlockData.enable_bg_color
              ? _vm.getContrastYIQ(_vm.$root.color_schema.primary)
              : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                _vm.introBlockData.custom_bg_color != ''
              ? _vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
              : false,
            'content-left': _vm.introBlockData.alignment === 'left',
            'content-center': _vm.introBlockData.alignment === 'center',
            'content-right': _vm.introBlockData.alignment === 'right',
          },domProps:{"innerHTML":_vm._s(_vm.introBlockData.content)}})]]:[(!_vm.introBlockData.disable_showmore)?[(
            _vm.introBlockData.content.length > 0 &&
            _vm.introBlockData.content.length <
              185 * _vm.introBlockData.no_of_lines -
                (_vm.introBlockData.no_of_lines === '1'
                  ? 0
                  : 10 * _vm.introBlockData.no_of_lines)
          )?[_c('div',{class:{
              'intro-content intro-content': true,
              'block-content-light': _vm.introBlockData.enable_bg_color
                ? !_vm.getContrastYIQ(_vm.$root.color_schema.primary)
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? !_vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                : false,
              'block-content-dark': _vm.introBlockData.enable_bg_color
                ? _vm.getContrastYIQ(_vm.$root.color_schema.primary)
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? _vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                : false,
              'content-left': _vm.introBlockData.alignment === 'left',
              'content-center': _vm.introBlockData.alignment === 'center',
              'content-right': _vm.introBlockData.alignment === 'right',
            },style:({
              '--bg-color': _vm.introBlockData.enable_bg_color
                ? _vm.$root.color_schema.primary
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? _vm.introBlockData.custom_bg_color
                : false,
              padding: ("0 " + (_vm.introBlockData.content_padding_lr) + "px"),
            }),domProps:{"innerHTML":_vm._s(_vm.introBlockData.content)}})]:(
            _vm.introBlockData.content.length > 0 &&
            _vm.introBlockData.content.length >=
              185 * _vm.introBlockData.no_of_lines -
                (_vm.introBlockData.no_of_lines === '1'
                  ? 0
                  : 10 * _vm.introBlockData.no_of_lines)
          )?[_c('div',{class:{
              'intro-content intro-hover': true,
              'block-content-light': _vm.introBlockData.enable_bg_color
                ? !_vm.getContrastYIQ(_vm.$root.color_schema.primary)
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? !_vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                : false,
              'block-content-dark': _vm.introBlockData.enable_bg_color
                ? _vm.getContrastYIQ(_vm.$root.color_schema.primary)
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? _vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                : false,
              'content-left': _vm.introBlockData.alignment === 'left',
              'content-center': _vm.introBlockData.alignment === 'center',
              'content-right': _vm.introBlockData.alignment === 'right',
            },style:({
              '--bg-color': _vm.introBlockData.enable_bg_color
                ? _vm.$root.color_schema.primary
                : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                  _vm.introBlockData.custom_bg_color != ''
                ? _vm.introBlockData.custom_bg_color
                : false,
              'max-height': ((25 * _vm.introBlockData.no_of_lines) + "px"),
              padding: ("0 " + (_vm.introBlockData.content_padding_lr) + "px"),
            }),domProps:{"innerHTML":_vm._s(_vm.introBlockData.content)}}),_vm._v(" "),(_vm.introBlockData.disable_showmore)?void 0:[(!_vm.showFullText)?_c('a',{class:{
                'show-cls': true,
                'text-white': _vm.introBlockData.enable_bg_color
                  ? !_vm.getContrastYIQ(_vm.$root.color_schema.primary)
                  : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                    _vm.introBlockData.custom_bg_color != ''
                  ? !_vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                  : false,
                'text-gray': _vm.introBlockData.enable_bg_color
                  ? _vm.getContrastYIQ(_vm.$root.color_schema.primary)
                  : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                    _vm.introBlockData.custom_bg_color != ''
                  ? _vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                  : false,
                'content-left': _vm.introBlockData.alignment === 'left',
                'content-center': _vm.introBlockData.alignment === 'center',
                'content-right': _vm.introBlockData.alignment === 'right',
              },attrs:{"title":_vm.$root.i18n.show_more},on:{"click":function($event){return _vm.showMoreText()}}},[_vm._v(_vm._s(_vm.$root.i18n.show_more))]):_c('a',{class:{
                'show-cls': true,
                'text-white': _vm.introBlockData.enable_bg_color
                  ? !_vm.getContrastYIQ(_vm.$root.color_schema.primary)
                  : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                    _vm.introBlockData.custom_bg_color != ''
                  ? !_vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                  : false,
                'text-gray': _vm.introBlockData.enable_bg_color
                  ? _vm.getContrastYIQ(_vm.$root.color_schema.primary)
                  : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                    _vm.introBlockData.custom_bg_color != ''
                  ? _vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
                  : false,
                'content-left': _vm.introBlockData.alignment === 'left',
                'content-center': _vm.introBlockData.alignment === 'center',
                'content-right': _vm.introBlockData.alignment === 'right',
              },attrs:{"title":_vm.$root.i18n.show_less},on:{"click":function($event){return _vm.showMoreText()}}},[_vm._v(_vm._s(_vm.$root.i18n.show_less))])]]:_vm._e()]:[_c('div',{class:{
            'intro-content': true,
            'block-content-light': _vm.introBlockData.enable_bg_color
              ? !_vm.getContrastYIQ(_vm.$root.color_schema.primary)
              : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                _vm.introBlockData.custom_bg_color != ''
              ? !_vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
              : false,
            'block-content-dark': _vm.introBlockData.enable_bg_color
              ? _vm.getContrastYIQ(_vm.$root.color_schema.primary)
              : _vm.introBlockData.hasOwnProperty('custom_bg_color') &&
                _vm.introBlockData.custom_bg_color != ''
              ? _vm.getContrastYIQ(_vm.introBlockData.custom_bg_color)
              : false,
            'content-left': _vm.introBlockData.alignment === 'left',
            'content-center': _vm.introBlockData.alignment === 'center',
            'content-right': _vm.introBlockData.alignment === 'right',
          },domProps:{"innerHTML":_vm._s(_vm.introBlockData.content)}})]]],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueFullscreen=t():e.VueFullscreen=t()}(this,function(){return function(e){function t(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return e[i].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,i){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:i})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=5)}([function(e,t,n){"use strict";function i(){var e={},t=!1,n=0,r=arguments.length;for("[object Boolean]"===Object.prototype.toString.call(arguments[0])&&(t=arguments[0],n++);n<r;n++){var l=arguments[n];!function(n){for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t&&"[object Object]"===Object.prototype.toString.call(n[r])?e[r]=i(!0,e[r],n[r]):e[r]=n[r])}(l)}return e}t.a=i},function(e,t){!function(){"use strict";var t="undefined"!=typeof window&&void 0!==window.document?window.document:{},n=void 0!==e&&e.exports,i=function(){for(var e,n=[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["webkitRequestFullScreen","webkitCancelFullScreen","webkitCurrentFullScreenElement","webkitCancelFullScreen","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],i=0,r=n.length,l={};i<r;i++)if((e=n[i])&&e[1]in t){for(i=0;i<e.length;i++)l[n[0][i]]=e[i];return l}return!1}(),r={change:i.fullscreenchange,error:i.fullscreenerror},l={request:function(e,n){return new Promise(function(r,l){var s=function(){this.off("change",s),r()}.bind(this);this.on("change",s),e=e||t.documentElement;var o=e[i.requestFullscreen](n);o instanceof Promise&&o.then(s).catch(l)}.bind(this))},exit:function(){return new Promise(function(e,n){if(!this.isFullscreen)return void e();var r=function(){this.off("change",r),e()}.bind(this);this.on("change",r);var l=t[i.exitFullscreen]();l instanceof Promise&&l.then(r).catch(n)}.bind(this))},toggle:function(e,t){return this.isFullscreen?this.exit():this.request(e,t)},onchange:function(e){this.on("change",e)},onerror:function(e){this.on("error",e)},on:function(e,n){var i=r[e];i&&t.addEventListener(i,n,!1)},off:function(e,n){var i=r[e];i&&t.removeEventListener(i,n,!1)},raw:i};if(!i)return void(n?e.exports={isEnabled:!1}:window.screenfull={isEnabled:!1});Object.defineProperties(l,{isFullscreen:{get:function(){return Boolean(t[i.fullscreenElement])}},element:{enumerable:!0,get:function(){return t[i.fullscreenElement]}},isEnabled:{enumerable:!0,get:function(){return Boolean(t[i.fullscreenEnabled])}}}),n?e.exports=l:window.screenfull=l}()},function(e,t,n){"use strict";function i(e,t){e.style.position=t.position,e.style.left=t.left,e.style.top=t.top,e.style.width=t.width,e.style.height=t.height}function r(e){var t=e.element;t&&(t.classList.remove(e.options.fullscreenClass),(e.options.teleport||e.options.pageOnly)&&(e.options.teleport&&a&&(a.insertBefore(t,u),a.removeChild(u)),t.__styleCache&&i(t,t.__styleCache)))}var l=n(1),s=n.n(l),o=n(0),c={callback:function(){},fullscreenClass:"fullscreen",pageOnly:!1,teleport:!1},u=void 0,a=void 0,f={options:null,element:null,isFullscreen:!1,isEnabled:s.a.isEnabled,toggle:function(e,t,n){return void 0===n?this.isFullscreen?this.exit():this.request(e,t):n?this.request(e,t):this.exit()},request:function(e,t){var l=this;if(this.isFullscreen)return Promise.resolve();if(e||(e=document.body),this.options=n.i(o.a)({},c,t),e===document.body&&(this.options.teleport=!1),s.a.isEnabled||(this.options.pageOnly=!0),e.classList.add(this.options.fullscreenClass),this.options.teleport||this.options.pageOnly){var f=e.style,h=f.position,p=f.left,d=f.top,m=f.width,v=f.height;e.__styleCache={position:h,left:p,top:d,width:m,height:v},i(e,{position:"fixed",left:"0",top:"0",width:"100%",height:"100%"})}if(this.options.teleport&&(a=e.parentNode)&&(u=document.createComment("fullscreen-token"),a.insertBefore(u,e),document.body.appendChild(e)),this.options.pageOnly){var b=function e(t){"Escape"===t.key&&(document.removeEventListener("keyup",e),l.exit())};return this.isFullscreen=!0,this.element=e,document.removeEventListener("keyup",b),document.addEventListener("keyup",b),this.options.callback&&this.options.callback(this.isFullscreen),Promise.resolve()}var y=function t(){s.a.isFullscreen||(s.a.off("change",t),r(l)),l.isFullscreen=s.a.isFullscreen,l.options.teleport?l.element=e||null:l.element=s.a.element,l.options.callback&&l.options.callback(s.a.isFullscreen)};return s.a.on("change",y),s.a.request(this.options.teleport?document.body:e)},exit:function(){return this.isFullscreen?this.options.pageOnly?(r(this),this.isFullscreen=!1,this.element=null,this.options.callback&&this.options.callback(this.isFullscreen),Promise.resolve()):s.a.exit():Promise.resolve()}};f.support=f.isEnabled,f.getState=function(){return f.isFullscreen},f.enter=f.request,t.a=f},function(e,t,n){"use strict";function i(e,t){var n={};for(var i in e)t.indexOf(i)>=0||Object.prototype.hasOwnProperty.call(e,i)&&(n[i]=e[i]);return n}var r=n(2),l=n(0),s=function(e,t){var s=function(){var e=void 0,s={teleport:t.modifiers.teleport,pageOnly:t.modifiers.pageOnly};if(t.value)if("string"==typeof t.value)e=t.value;else{var o=t.value,c=o.target,u=i(o,["target"]);e=c,s=n.i(l.a)(s,u)}"string"==typeof e&&(e=document.querySelector(e)),r.a.toggle(e,s)};e._onClickFullScreen&&e.removeEventListener("click",e._onClickFullScreen),e.addEventListener("click",s),e._onClickFullScreen=s};t.a=s},function(e,t,n){var i=n(7)(n(6),n(8),null,null);e.exports=i.exports},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(4),r=n.n(i),l=n(2),s=n(3),o=n(1),c=n.n(o),u=n(0);n.d(t,"screenfull",function(){return c.a}),n.d(t,"api",function(){return l.a}),n.d(t,"directive",function(){return s.a}),n.d(t,"component",function(){return r.a}),t.default={install:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=t.name||"fullscreen";e.component(i,n.i(u.a)(r.a,{name:i})),e.prototype["$"+i]=l.a,e.directive(i,s.a)}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(1),r=n.n(i);t.default={props:{value:{type:Boolean,default:!1},fullscreen:{type:Boolean,default:!1},exitOnClickWrapper:{type:Boolean,default:!0},fullscreenClass:{type:String,default:"fullscreen"},pageOnly:{type:Boolean,default:!1},teleport:{type:Boolean,default:!1}},data:function(){return{isFullscreen:!1,isEnabled:!1}},computed:{support:function(){return this.isEnabled},isPageOnly:function(){return this.pageOnly||!r.a.isEnabled},wrapperStyle:function(){return(this.isPageOnly||this.teleport)&&this.isFullscreen?{position:"fixed",left:"0",top:"0",width:"100%",height:"100%"}:void 0}},methods:{toggle:function(e){void 0===e?this.isFullscreen?this.exit():this.request():e?this.request():this.exit()},request:function(){if(this.isPageOnly?(this.isFullscreen=!0,this.onChangeFullScreen(),document.removeEventListener("keyup",this.keypressCallback),document.addEventListener("keyup",this.keypressCallback)):(r.a.off("change",this.fullScreenCallback),r.a.on("change",this.fullScreenCallback),r.a.request(this.teleport?document.body:this.$el)),this.teleport){if(this.$el.parentNode===document.body)return;this.__parentNode=this.$el.parentNode,this.__token=document.createComment("fullscreen-token"),this.__parentNode.insertBefore(this.__token,this.$el),document.body.appendChild(this.$el)}},exit:function(){this.isFullscreen&&(this.isPageOnly?(this.isFullscreen=!1,this.onChangeFullScreen(),document.removeEventListener("keyup",this.keypressCallback)):r.a.exit())},shadeClick:function(e){e.target===this.$el&&this.exitOnClickWrapper&&this.exit()},fullScreenCallback:function(){r.a.isFullscreen||r.a.off("change",this.fullScreenCallback),this.isFullscreen=r.a.isFullscreen,this.onChangeFullScreen()},keypressCallback:function(e){"Escape"===e.key&&this.exit()},onChangeFullScreen:function(){this.isFullscreen||this.teleport&&this.__parentNode&&(this.__parentNode.insertBefore(this.$el,this.__token),this.__parentNode.removeChild(this.__token)),this.$emit("change",this.isFullscreen),this.$emit("update:fullscreen",this.isFullscreen),this.$emit("input",this.isFullscreen)},enter:function(){this.request()},getState:function(){return this.isFullscreen}},watch:{value:function(e){e!==this.isFullscreen&&(e?this.request():this.exit())},fullscreen:function(e){e!==this.isFullscreen&&(e?this.request():this.exit())}},created:function(){this.isEnabled=r.a.isEnabled}}},function(e,t){e.exports=function(e,t,n,i){var r,l=e=e||{},s=typeof e.default;"object"!==s&&"function"!==s||(r=e,l=e.default);var o="function"==typeof l?l.options:l;if(t&&(o.render=t.render,o.staticRenderFns=t.staticRenderFns),n&&(o._scopeId=n),i){var c=Object.create(o.computed||null);Object.keys(i).forEach(function(e){var t=i[e];c[e]=function(){return t}}),o.computed=c}return{esModule:r,exports:l,options:o}}},function(e,t){e.exports={render:function(){var e,t=this,n=t.$createElement;return(t._self._c||n)("div",t._b({ref:"wrapper",class:(e={},e[t.fullscreenClass]=t.isFullscreen,e),style:t.wrapperStyle,on:{click:function(e){return t.shadeClick(e)}}},"div",t.$attrs,!1),[t._t("default")],2)},staticRenderFns:[]}}])});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):(this.gamespageData)?_c('main',{staticClass:"main-content-area"},[(
      !(
        this.gamespageData.meta &&
        this.gamespageData.meta.enable_different_free_game_url_for_mobile
      )
    )?[(!_vm.showData)?_c('div',{staticClass:"rotate-msg",style:({
        '--primary-bg': _vm.$root.color_schema.primary,
        '--primary-color': _vm.getContrastYIQ(_vm.$root.color_schema.primary)
          ? '#333'
          : '#fff',
      }),attrs:{"id":"rotate-msg"}},[_c('span',{staticClass:"rotate-svg"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"phoneIcon","viewBox":"0 0 100 180"}},[_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M90,0H10A10,10,0,0,0,0,10V170a10,10,0,0,0,10,10H90a10,10,0,0,0,10-10V10A10,10,0,0,0,90,0ZM4,24.51H96V150H4ZM10,4H90a6,6,0,0,1,6,6V20.51H4V10A6,6,0,0,1,10,4ZM90,176H10a6,6,0,0,1-6-6V154H96v16A6,6,0,0,1,90,176Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M40.63,14.25H59.37a2,2,0,1,0,0-4H40.63a2,2,0,0,0,0,4Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M50,159.8a5.2,5.2,0,1,0,5.2,5.2A5.2,5.2,0,0,0,50,159.8Zm0,6.4a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,50,166.2Z"}})])])])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$root.i18n.please_turn_your_phone_to_enjoy_the_game))]),_vm._v(" "),_c('button',{staticClass:"cta cta-secondary cta-promotion cta-large cta-lg-br back-btn",on:{"click":function($event){_vm.showData = true}}},[_vm._v("\n        "+_vm._s(_vm.$root.i18n.go_back)+"\n      ")])]):_vm._e()]:_vm._e(),_vm._v(" "),(this.gamespageData.meta && this.gamespageData.meta.banner_image)?_c('section',{staticClass:"ct-inner-banner pt-26",style:({
      background:
        this.gamespageData.meta && this.gamespageData.meta.banner_image
          ? _vm.$root.color_schema.footer_bg
          : 'none',
    })},[_c('div',{staticClass:"container z-con"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":this.gamespageData.breadcrumb,"dark":_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg)}})],1)]),_vm._v(" "),(Object.keys(_vm.introblockData).length > 0)?[_c('IntroBlock',{attrs:{"introBlockData":_vm.introblockData,"pageName":'game'}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"container z-con"},[(this.gamespageData.meta && this.gamespageData.meta.banner_image)?_c('div',{class:{
          row: !this.gameTemplate,
          'games-banner-block': this.gameTemplate,
        }},[_c('div',{class:[
            this.gameTemplate ? '' : 'col-md-8',
            'ct-inner-banner-lft',
            (this.gamespageData.meta.play_with_live_dealer &&
              this.gamespageData.meta.play_with_live_dealer.banner) ||
            (this.gamespageData.meta &&
              this.gamespageData.meta.our_expert_review &&
              Object.keys(this.gamespageData.meta.our_expert_review).length >
                0 &&
              this.gamespageData.meta.our_expert_review.reviewer_image)
              ? ''
              : 'banner-wd',
            !this.gameTemplate ||
            (this.gameTemplate &&
              _vm.gamesTop3 &&
              _vm.gamesTop3.length > 0 &&
              _vm.gamesTop3[0] &&
              _vm.gamesTop3[0].length > 0)
              ? ''
              : 'banner-wd' ]},[(_vm.showData)?_c('div',{class:{
              'game-space': true,
              'game-left':
                this.gameTemplate &&
                _vm.gamesTop3 &&
                _vm.gamesTop3.length > 0 &&
                _vm.gamesTop3[0] &&
                _vm.gamesTop3[0].length > 0,
            }},[(_vm.hideToplistLabelGB)?void 0:[(
                  this.gamespageData.meta.geo_provider_partners_data &&
                  this.gamespageData.meta.geo_provider_partners_data
                    .current &&
                  this.gamespageData.meta.geo_provider_partners_data.current
                    .go_link
                )?_c('a',{staticClass:"bg-link cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data.current
                    .product_name,"href":_vm.getGoLink(
                    this.gamespageData.meta.geo_provider_partners_data.current
                      .go_link,
                    this.gamespageData.meta.geo_provider_partners_data.current
                      .slug
                  ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow'}}):_vm._e()],_vm._v(" "),(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(this.gamespageData.meta.banner_image),expression:"this.gamespageData.meta.banner_image"}],class:{
                'banner-img-im':
                  !this.gameTemplate ||
                  !(
                    this.gameTemplate &&
                    _vm.gamesTop3 &&
                    _vm.gamesTop3.length > 0 &&
                    _vm.gamesTop3[0] &&
                    _vm.gamesTop3[0].length > 0
                  ),
                'banner-img':
                  this.gameTemplate &&
                  _vm.gamesTop3 &&
                  _vm.gamesTop3.length > 0 &&
                  _vm.gamesTop3[0] &&
                  _vm.gamesTop3[0].length > 0,
                'game-left':
                  this.gameTemplate &&
                  _vm.gamesTop3 &&
                  _vm.gamesTop3.length > 0 &&
                  _vm.gamesTop3[0] &&
                  _vm.gamesTop3[0].length > 0,
              },attrs:{"width":"860","height":"557","alt":"Banner Image"}}):_c('img',{class:{
                'banner-img-im':
                  !this.gameTemplate ||
                  !(
                    this.gameTemplate &&
                    _vm.gamesTop3 &&
                    _vm.gamesTop3.length > 0 &&
                    _vm.gamesTop3[0] &&
                    _vm.gamesTop3[0].length > 0
                  ),
                'banner-img':
                  this.gameTemplate &&
                  _vm.gamesTop3 &&
                  _vm.gamesTop3.length > 0 &&
                  _vm.gamesTop3[0] &&
                  _vm.gamesTop3[0].length > 0,
                'game-left':
                  this.gameTemplate &&
                  _vm.gamesTop3 &&
                  _vm.gamesTop3.length > 0 &&
                  _vm.gamesTop3[0] &&
                  _vm.gamesTop3[0].length > 0,
              },attrs:{"src":this.gamespageData.meta.banner_image,"width":"860","height":"557","alt":"Banner Image"}}),_vm._v(" "),_c('div',{staticClass:"game-space-content"},[(
                  !_vm.$root.disable_freegame_banner_outlink &&
                  this.gamespageData.meta.geo_provider_partners_data &&
                  this.gamespageData.meta.geo_provider_partners_data.current
                )?_c('div',{staticClass:"game-logo"},[(_vm.hideToplistLabelGB)?void 0:[_c('a',{staticClass:"partner-logo cas-link gam-strp",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                        .current.product_name,"href":_vm.getGoLink(
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link,
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.slug
                      ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[(
                        _vm.$root.enable_lazyload &&
                        _vm.assets_images &&
                        _vm.assets_images.pro_asset_sizes &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.product_assets.length > 0
                      )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                        this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assets_images.pro_asset_sizes.medium; }
                        ).length > 0
                          ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              )
                              .shift().url
                          : ''
                      ),expression:"\n                        this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(\n                          (ele) =>\n                            ele.asset_category_name ===\n                            assets_images.pro_asset_sizes.medium\n                        ).length > 0\n                          ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets\n                              .filter(\n                                (ele) =>\n                                  ele.asset_category_name ===\n                                  assets_images.pro_asset_sizes.medium\n                              )\n                              .shift().url\n                          : ''\n                      "}],attrs:{"width":"136","height":"136","alt":_vm.getAltText(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : ''
                        )}}):(
                        _vm.assets_images &&
                        _vm.assets_images.pro_asset_sizes &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.product_assets.length > 0
                      )?_c('img',{attrs:{"src":this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assets_images.pro_asset_sizes.medium; }
                        ).length > 0
                          ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              )
                              .shift().url
                          : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"width":"136","height":"136","alt":_vm.getAltText(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/failure.png'
                        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-bann"},[_c('div',{staticClass:"partner-hover-inner",style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                        Object.keys(
                          _vm.hasTag(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.tags
                          )
                        ).length > 0
                      )?_c('div',{staticClass:"stripe-gam",style:({
                        backgroundColor:
                          Object.keys(
                            _vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            )
                          ).length > 0
                            ? _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).color
                            : null,
                      })},[_c('span',{class:{
                          'custom-font-2': true,
                          'text-gray': _vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null
                          ),
                          'text-light': !_vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null
                          ),
                        }},[_c('img',{attrs:{"src":_vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            ).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                        "+_vm._s(_vm.titleCase(
                            _vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            ).tag_name
                          ))+"\n                      ")])]):_vm._e()])]],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"button-block"},[(!_vm.$root.disable_freegame_banner_outlink)?[(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current
                      )?_c('a',{class:{
                        'cta cta-primary cta-promotion custom-btn cas-link hover-btn ': true,
                        'text-white game-btn':
                          !_vm.$root.override_ctabtntxt_color &&
                          !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-gray':
                          !_vm.$root.override_ctabtntxt_color &&
                          _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-cta-override': _vm.$root.override_ctabtntxt_color,
                      },style:({
                        '--primary-btn': _vm.$root.color_schema.primary_btn,
                        '--primary-btn-hover': _vm.pSBC(
                          -0.2,
                          _vm.$root.color_schema.primary_btn
                        ),
                      }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(this.gamespageData.meta.play_for_real_label))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()]]:_vm._e(),_vm._v(" "),(_vm.checkPlayFreeButton())?_c('a',{staticClass:"cta cta-primary cta-promotion cta-outline",attrs:{"title":this.gamespageData.meta.play_for_free_label,"href":"javascript:void(0)"},on:{"click":function($event){return _vm.showIframe()}}},[_vm._v(_vm._s(this.gamespageData.meta.play_for_free_label))]):_vm._e()],2)])],2):_c('div',{staticClass:"game-space"},[(!_vm.$root.disable_freegame_banner_outlink)?[(_vm.hideToplistLabelGB)?void 0:[(
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  )?_c('a',{staticClass:"game_review_flex cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data.current
                      .product_name,"href":_vm.getGoLink(
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.go_link,
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.slug
                    ),"id":"game_review_flex","rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow',"target":"_blank"}},[_c('div',{staticClass:"sticky-review-card"},[_c('div',{staticClass:"sticky-inner-wrapper"},[_c('a',{staticClass:"affliate-logo partner-logo cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,"href":_vm.getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[(
                            _vm.$root.enable_lazyload &&
                            _vm.assets_images &&
                            _vm.assets_images.pro_asset_sizes
                          )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.large; }
                                  )
                                  .shift().url
                              : ''
                          ),expression:"\n                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(\n                              (ele) =>\n                                ele.asset_category_name ===\n                                assets_images.pro_asset_sizes.large\n                            ).length > 0\n                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets\n                                  .filter(\n                                    (ele) =>\n                                      ele.asset_category_name ===\n                                      assets_images.pro_asset_sizes.large\n                                  )\n                                  .shift().url\n                              : ''\n                          "}],attrs:{"width":"65","height":"65","alt":_vm.getAltText(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current
                                .product_name,
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.large; }
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.large; }
                                    )
                                    .shift().url
                                : ''
                            )}}):(
                            _vm.assets_images && _vm.assets_images.pro_asset_sizes
                          )?_c('img',{attrs:{"src":this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.large; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/failure.png',"width":"65","height":"65","alt":_vm.getAltText(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current
                                .product_name,
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.large; }
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.large; }
                                    )
                                    .shift().url
                                : _vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/failure.png'
                            )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-stick"},[_c('div',{staticClass:"partner-hover-inner",style:({
                              '--primary-btn': _vm.$root.color_schema.primary_btn,
                              '--primary-btn-hover': _vm.pSBC(
                                -0.2,
                                _vm.$root.color_schema.primary_btn
                              ),
                            })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]),_vm._v(" "),_c('span',{staticClass:"sticky-text stick-part-1"},[_c('span',{staticClass:"sticky-title text-hover",staticStyle:{"font-size":"1.175rem","font-weight":"700"}},[_vm._v(_vm._s(this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name))]),_vm._v(" "),_c('span',{staticClass:"bonus-text"},[_c('div',{staticClass:"pt-6px"},[(
                                Object.keys(
                                  _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  )
                                ).length > 0
                              )?_c('div',{class:{
                                'top-choice-card': true,
                                'font-dark': _vm.getContrastYIQ(
                                  Object.keys(
                                    _vm.hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current
                                        .tags
                                    )
                                  ).length > 0
                                    ? _vm.hasTag(
                                        this.gamespageData.meta
                                          .geo_provider_partners_data.current
                                          .tags
                                      ).color
                                    : null
                                ),
                                'font-light': !_vm.getContrastYIQ(
                                  Object.keys(
                                    _vm.hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current
                                        .tags
                                    )
                                  ).length > 0
                                    ? _vm.hasTag(
                                        this.gamespageData.meta
                                          .geo_provider_partners_data.current
                                          .tags
                                      ).color
                                    : null
                                ),
                              },style:({
                                backgroundColor:
                                  Object.keys(
                                    _vm.hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current
                                        .tags
                                    )
                                  ).length > 0
                                    ? _vm.hasTag(
                                        this.gamespageData.meta
                                          .geo_provider_partners_data.current
                                          .tags
                                      ).color
                                    : null,
                              })},[_c('img',{attrs:{"src":_vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                              "+_vm._s(_vm.titleCase(
                                  _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).tag_name
                                ))+"\n                            ")]):_vm._e()])])]),_vm._v(" "),_c('span',{staticClass:"sticky-text text-hover stick-part-2",staticStyle:{"margin":"auto"}},[_c('span',{staticClass:"bonus-text"},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                              _vm.$root.i18n.get_best_bonus_for_this_game,
                              this.gamespageData.meta
                                .geo_provider_partners_data.current
                                .product_name
                            ))+"!")]),_vm._v(" "),(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.bonus_tc &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.bonus_tc != ''
                          )?_c('div',{staticClass:"termsgam",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                          }),domProps:{"innerHTML":_vm._s(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.bonus_tc
                          )}}):_vm._e(),_vm._v(" "),(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.bonus_tc &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.terms &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.bonus_tc != '' &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.terms != ''
                          )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.terms &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.terms != ''
                          )?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"title":this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,"href":_vm.getGoLink(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.term_link,
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.slug
                            ),"target":"_blank"}},[_vm._v(_vm._s(this.gamespageData.meta.geo_provider_partners_data
                              .current.terms))]):_vm._e()]),_vm._v(" "),_c('a',{class:{
                          'cta cta-primary cta-promotion cta-promo-review sticky-play-btn custom-btn hover-btn cas-link': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,"href":_vm.getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(this.gamespageData.meta.geo_provider_partners_data
                            .current.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambspp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)])])]):_vm._e()]]:_vm._e(),_vm._v(" "),(
                !(
                  this.gamespageData.meta &&
                  this.gamespageData.meta
                    .enable_different_free_game_url_for_mobile
                )
              )?[_c('fullscreen',{ref:"fullscreen"},[_c('div',{class:{
                    'wrapper-iframe': true,
                    'wrapper-game-iframe':
                      this.gameTemplate &&
                      _vm.gamesTop3 &&
                      _vm.gamesTop3.length > 0 &&
                      _vm.gamesTop3[0] &&
                      _vm.gamesTop3[0].length > 0,
                  },attrs:{"id":"wrapper-iframe"}},[_c('iframe',{staticClass:"cas-iframe",attrs:{"id":"cas-iframe","src":this.gamespageData.meta.play_for_free_url},on:{"load":function($event){return _vm.openFullscreen()}}})]),_vm._v(" "),(
                    !_vm.$root.disable_freegame_banner_outlink &&
                    _vm.gameOverlay &&
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  )?_c('div',{staticClass:"cta-overlay",style:({
                    'background-color': _vm.color,
                    '--primary-color': _vm.getContrastYIQ('#060236')
                      ? '#333'
                      : '#fff',
                  })},[(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"img-cas partner-logo cas-link gam-strp",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[(
                          _vm.$root.enable_lazyload &&
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : ''
                        ),expression:"\n                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(\n                            (ele) =>\n                              ele.asset_category_name ===\n                              assets_images.pro_asset_sizes.medium\n                          ).length > 0\n                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets\n                                .filter(\n                                  (ele) =>\n                                    ele.asset_category_name ===\n                                    assets_images.pro_asset_sizes.medium\n                                )\n                                .shift().url\n                            : ''\n                        "}],staticClass:"img-over",attrs:{"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : ''
                          )}}):(
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{staticClass:"img-over",attrs:{"src":this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/failure.png',"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png'
                          )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-ifrm"},[_c('div',{staticClass:"partner-hover-inner",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                          Object.keys(
                            _vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            )
                          ).length > 0
                        )?_c('div',{staticClass:"stripe-gam-overlay",style:({
                          backgroundColor:
                            Object.keys(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null,
                        })},[_c('span',{class:{
                            'custom-font-2': true,
                            'text-gray': _vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                            'text-light': !_vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                          }},[_c('img',{attrs:{"src":_vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                          "+_vm._s(_vm.titleCase(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).tag_name
                            ))+"\n                        ")])]):_vm._e()]):_vm._e()],_vm._v(" "),(
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.rating
                    )?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat(
                          (
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.rating / 2
                          ).toFixed(1)
                        ),"noText":""}})],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"how-about"},[_vm._v(_vm._s(_vm.$root.i18n.how_about_a_special_offer_from)+"\n                    "+_vm._s(this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current
                        ? this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        : "")+"\n                    ?")]),_vm._v(" "),(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"get-a cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.$root.i18n.get_best_bonus_for_this_game)+"!!")]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"text-wrapper"},[(_vm.hideToplistLabelGB)?void 0:[(
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        )?_c('a',{class:{
                          'cta cta-block cta-primary cta-promotion custom-btn cas-link hover-btn ct-btn': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,"href":_vm.getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.$root.i18n.get_bonus))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambsppp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()],_vm._v(" "),_c('span',{staticClass:"\n                        cta cta-secondary cta-promotion cta-lg-br\n                        back-btn\n                        ct-btn\n                      ",on:{"click":function($event){return _vm.overlayHide()}}},[_vm._v(_vm._s(_vm.$root.i18n.no_thanks))])],2)],2):_vm._e()])]:[(
                  _vm.widthofgamesection < 576 &&
                  this.gamespageData.meta &&
                  this.gamespageData.meta.mobile_game_iframe_url &&
                  this.gamespageData.meta.mobile_game_iframe_url != ''
                )?[_c('div',{class:{
                    'wrapper-iframe': true,
                    'wrapper-game-iframe':
                      this.gameTemplate &&
                      _vm.gamesTop3 &&
                      _vm.gamesTop3.length > 0 &&
                      _vm.gamesTop3[0] &&
                      _vm.gamesTop3[0].length > 0,
                  },attrs:{"id":"wrapper-iframe"}},[_c('iframe',{staticClass:"cas-iframe",attrs:{"id":"cas-iframe","src":this.gamespageData.meta.mobile_game_iframe_url},on:{"load":function($event){return _vm.openFullscreen()}}})]),_vm._v(" "),(
                    !_vm.$root.disable_freegame_banner_outlink &&
                    _vm.gameOverlay &&
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  )?_c('div',{staticClass:"cta-overlay cta-overlay-enable-mobile",style:({
                    'background-color': _vm.color,
                    '--primary-color': _vm.getContrastYIQ('#060236')
                      ? '#333'
                      : '#fff',
                  })},[(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"img-cas partner-logo cas-link gam-strp",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[(
                          _vm.$root.enable_lazyload &&
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : ''
                        ),expression:"\n                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(\n                            (ele) =>\n                              ele.asset_category_name ===\n                              assets_images.pro_asset_sizes.medium\n                          ).length > 0\n                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets\n                                .filter(\n                                  (ele) =>\n                                    ele.asset_category_name ===\n                                    assets_images.pro_asset_sizes.medium\n                                )\n                                .shift().url\n                            : ''\n                        "}],staticClass:"img-over",attrs:{"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : ''
                          )}}):(
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{staticClass:"img-over",attrs:{"src":this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/failure.png',"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png'
                          )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-ifrm"},[_c('div',{staticClass:"partner-hover-inner",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                          Object.keys(
                            _vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            )
                          ).length > 0
                        )?_c('div',{staticClass:"stripe-gam-overlay",style:({
                          backgroundColor:
                            Object.keys(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null,
                        })},[_c('span',{class:{
                            'custom-font-2': true,
                            'text-gray': _vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                            'text-light': !_vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                          }},[_c('img',{attrs:{"src":_vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                          "+_vm._s(_vm.titleCase(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).tag_name
                            ))+"\n                        ")])]):_vm._e()]):_vm._e()],_vm._v(" "),(
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.rating
                    )?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat(
                          (
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.rating / 2
                          ).toFixed(1)
                        ),"noText":""}})],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"how-about"},[_vm._v(_vm._s(_vm.$root.i18n.how_about_a_special_offer_from)+"\n                    "+_vm._s(this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current
                        ? this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        : "")+"\n                    ?")]),_vm._v(" "),(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"get-a cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.$root.i18n.get_best_bonus_for_this_game)+"!!")]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"text-wrapper"},[(_vm.hideToplistLabelGB)?void 0:[(
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        )?_c('a',{class:{
                          'cta cta-block cta-primary cta-promotion custom-btn cas-link hover-btn ct-btn': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,"href":_vm.getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.$root.i18n.get_bonus))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambsppp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()],_vm._v(" "),_c('span',{staticClass:"\n                        cta cta-secondary cta-promotion cta-lg-br\n                        back-btn\n                        ct-btn\n                      ",on:{"click":function($event){return _vm.overlayHide()}}},[_vm._v(_vm._s(_vm.$root.i18n.no_thanks))])],2)],2):_vm._e()]:[_c('div',{class:{
                    'wrapper-iframe': true,
                    'wrapper-game-iframe':
                      this.gameTemplate &&
                      _vm.gamesTop3 &&
                      _vm.gamesTop3.length > 0 &&
                      _vm.gamesTop3[0] &&
                      _vm.gamesTop3[0].length > 0,
                  },attrs:{"id":"wrapper-iframe"}},[_c('iframe',{staticClass:"cas-iframe",attrs:{"id":"cas-iframe","src":this.gamespageData.meta.play_for_free_url},on:{"load":function($event){return _vm.openFullscreen()}}})]),_vm._v(" "),(
                    !_vm.$root.disable_freegame_banner_outlink &&
                    _vm.gameOverlay &&
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  )?_c('div',{staticClass:"cta-overlay",style:({
                    'background-color': _vm.color,
                    '--primary-color': _vm.getContrastYIQ('#060236')
                      ? '#333'
                      : '#fff',
                  })},[(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"img-cas partner-logo cas-link gam-strp",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[(
                          _vm.$root.enable_lazyload &&
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : ''
                        ),expression:"\n                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(\n                            (ele) =>\n                              ele.asset_category_name ===\n                              assets_images.pro_asset_sizes.medium\n                          ).length > 0\n                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets\n                                .filter(\n                                  (ele) =>\n                                    ele.asset_category_name ===\n                                    assets_images.pro_asset_sizes.medium\n                                )\n                                .shift().url\n                            : ''\n                        "}],staticClass:"img-over",attrs:{"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : ''
                          )}}):(
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{staticClass:"img-over",attrs:{"src":this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/failure.png',"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png'
                          )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-ifrm"},[_c('div',{staticClass:"partner-hover-inner",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                          Object.keys(
                            _vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            )
                          ).length > 0
                        )?_c('div',{staticClass:"stripe-gam-overlay",style:({
                          backgroundColor:
                            Object.keys(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null,
                        })},[_c('span',{class:{
                            'custom-font-2': true,
                            'text-gray': _vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                            'text-light': !_vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                          }},[_c('img',{attrs:{"src":_vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                          "+_vm._s(_vm.titleCase(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).tag_name
                            ))+"\n                        ")])]):_vm._e()]):_vm._e()],_vm._v(" "),(
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.rating
                    )?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat(
                          (
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.rating / 2
                          ).toFixed(1)
                        ),"noText":""}})],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"how-about"},[_vm._v(_vm._s(_vm.$root.i18n.how_about_a_special_offer_from)+"\n                    "+_vm._s(this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current
                        ? this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        : "")+"\n                    ?")]),_vm._v(" "),(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"get-a cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.$root.i18n.get_best_bonus_for_this_game)+"!!")]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"text-wrapper"},[(_vm.hideToplistLabelGB)?void 0:[(
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        )?_c('a',{class:{
                          'cta cta-block cta-primary cta-promotion custom-btn cas-link hover-btn ct-btn': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,"href":_vm.getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.$root.i18n.get_bonus))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambsppp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()],_vm._v(" "),_c('span',{staticClass:"\n                        cta cta-secondary cta-promotion cta-lg-br\n                        back-btn\n                        ct-btn\n                      ",on:{"click":function($event){return _vm.overlayHide()}}},[_vm._v(_vm._s(_vm.$root.i18n.no_thanks))])],2)],2):_vm._e()]]],2)]),_vm._v(" "),_c('div',{class:{
            'col-md-4': !this.gameTemplate,
            'game-right':
              this.gameTemplate &&
              _vm.gamesTop3 &&
              _vm.gamesTop3.length > 0 &&
              _vm.gamesTop3[0] &&
              _vm.gamesTop3[0].length > 0,
            'ct-inner-banner-rgt':
              (this.gameTemplate &&
                _vm.gamesTop3 &&
                _vm.gamesTop3.length > 0 &&
                _vm.gamesTop3[0] &&
                _vm.gamesTop3[0].length > 0) ||
              !this.gameTemplate,
          }},[(this.gameTemplate)?[(_vm.gamesTop3.length > 0)?_vm._l((_vm.gamesTop3),function(val,index){return _c('div',{key:index},[_c(_vm.titleComponent,{tag:"component",class:{
                      'text-white gm-title': true, 
                      'cust-h1': _vm.titleComponent === 'span'   
                  }},[_vm._v("\n                  "+_vm._s(_vm.gamesTop3Title[index])+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"mobile-scroller"},_vm._l((val),function(data,index){return _c('div',{key:index,staticClass:"play-card",style:({
                      'border': index === 0 ? "2px solid #ffd03a" : null,
                      'background-color': index === 0 ? '#FFF9E8' : null,
                      'overflow': 'hidden'
                    })},[_c('div',{class:("play-card-index play-card-index-" + index)},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('div',{staticClass:"play-card-top"},[_c('div',{staticClass:"play-card-top-img"},[_c('a',{staticClass:"partner-logo cas-link",attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"target":"_blank"}},[(
                              _vm.$root.enable_lazyload &&
                              _vm.assets_images &&
                              _vm.assets_images.pro_asset_sizes
                            )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                              data.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              ).length > 0
                                ? data.product_assets.filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )[0].url
                                : ''
                            ),expression:"\n                              data.product_assets.filter(\n                                (ele) =>\n                                  ele.asset_category_name ===\n                                  assets_images.pro_asset_sizes.medium\n                              ).length > 0\n                                ? data.product_assets.filter(\n                                    (ele) =>\n                                      ele.asset_category_name ===\n                                      assets_images.pro_asset_sizes.medium\n                                  )[0].url\n                                : ''\n                            "}],attrs:{"width":"40","height":"40","alt":_vm.getAltText(
                                data.product_name,
                                data.product_assets.filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                ).length > 0
                                  ? data.product_assets.filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )[0].url
                                  : ''
                              )}}):(
                              _vm.assets_images && _vm.assets_images.pro_asset_sizes
                            )?_c('img',{attrs:{"src":data.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              ).length > 0
                                ? data.product_assets.filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )[0].url
                                : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png',"width":"40","height":"40","alt":_vm.getAltText(
                                data.product_name,
                                data.product_assets.filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                ).length > 0
                                  ? data.product_assets.filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )[0].url
                                  : _vm.$root.site_url +
                                      _vm.$root.asset_path +
                                      '/failure.png'
                              )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-cas"},[_c('div',{staticClass:"partner-hover-inner",style:({
                                '--primary-btn':
                                  _vm.$root.color_schema.primary_btn,
                                '--primary-btn-hover': _vm.pSBC(
                                  -0.2,
                                  _vm.$root.color_schema.primary_btn
                                ),
                              })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"play-card-top-right"},[(_vm.$root.enable_piwik_reload)?[(data.review_link)?_c('a',{staticClass:"casino-title text-hover",attrs:{"title":data.product_name,"href":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                                _vm.$root.i18n.partner_name_review,
                                data.product_name
                              )))]):_c('span',{staticClass:"emt-sp"},[_vm._v(" ")])]:[(data.review_link)?_c('router-link',{staticClass:"casino-title text-hover",attrs:{"title":data.product_name,"to":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                                _vm.$root.i18n.partner_name_review,
                                data.product_name
                              )))]):_c('span',{staticClass:"emt-sp"},[_vm._v(" ")])],_vm._v(" "),_c('StarRating',{attrs:{"rating":parseFloat((data.rating / 2).toFixed(1))}})],2)]),_vm._v(" "),_c('div',{staticClass:"play-card-mid"},[_c('span',{staticClass:"span-h5 custom-font-1 game-bonus-text"},[(_vm.hideBonusLabelGB)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[_c('a',{staticClass:"bonus-link custom-font-1 cas-link",style:({
                              '--color-hover': _vm.$root.color_schema.primary_btn,
                            }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'}},[(
                                data.bonus_match &&
                                data.exclusive_bonus_amount &&
                                data.exclusive_bonus_match
                              )?_c('span',[_vm._v(_vm._s(data.exclusive_bonus_match)+"%\n                              "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                              "+_vm._s(_vm._f("currency")(data.exclusive_bonus_amount,data.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                                data.bonus_match &&
                                !data.exclusive_bonus_amount &&
                                data.bonus_amount
                              )?_c('span',[_vm._v(_vm._s(data.bonus_match)+"%\n                              "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                              "+_vm._s(_vm._f("currency")(data.bonus_amount,data.bonus_currency)))]):_vm._e(),_vm._v(" "),(data.freespin || data.freebie_name)?_c('span',[(
                                  (data.exclusive_bonus_amount ||
                                    data.bonus_amount) &&
                                  data.bonus_match
                                )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(data.freespin)?[(data.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(data.freespin,data.bonus_currency)))]:[_vm._v(_vm._s(data.freespin))],_vm._v("\n                                "+_vm._s(data.freebie_name)+"\n                              ")]:[_vm._v(_vm._s(data.freebie_name))]],2):_vm._e()])]],2)]),_vm._v(" "),_c('a',{class:{
                        'cta cta-primary cta-promotion cta-block custom-btn cta-game-large hover-btn cas-link': true,
                        'text-white':
                          !_vm.$root.override_ctabtntxt_color &&
                          !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-gray':
                          !_vm.$root.override_ctabtntxt_color &&
                          _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-cta-override': _vm.$root.override_ctabtntxt_color,
                      },style:({
                        '--primary-btn': _vm.$root.color_schema.primary_btn,
                        '--primary-btn-hover': _vm.pSBC(
                          -0.2,
                          _vm.$root.color_schema.primary_btn
                        ),
                      }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[(index === 0)?_c('img',{attrs:{"src":_vm.crownIcon,"alt":"Crown","height":"16","width":"24"}}):_vm._e(),_vm._v("\n                        "+_vm._s(data.cta_button_text))]),_vm._v(" "),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gamcpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2),_vm._v(" "),(
                        (data.bonus_tc && data.bonus_tc != '') ||
                        (data.terms && data.terms != '')
                      )?_c('div',{staticClass:"gm-terms"},[(data.bonus_tc && data.bonus_tc != '')?_c('span',{staticClass:"cas-term game-terms-text",staticStyle:{"text-align":"center"},style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                        }),domProps:{"innerHTML":_vm._s(data.bonus_tc.trim())}}):_vm._e(),_vm._v(" "),(
                          data.bonus_tc &&
                          data.terms &&
                          data.bonus_tc != '' &&
                          data.terms != ''
                        )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(data.terms && data.terms != '')?_c('a',{staticClass:"cas-term game-terms-text",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"title":data.product_name,"href":_vm.getGoLink(data.term_link, data.slug),"target":"_blank"}},[_vm._v(_vm._s(data.terms))]):_vm._e()]):_vm._e()])}),0)],1)}):_vm._e()]:[(
                this.gamespageData.meta.play_with_live_dealer &&
                this.gamespageData.meta.play_with_live_dealer.banner
              )?_c('div',{staticClass:"live-dealer"},[(_vm.hideToplistLabelGB)?void 0:[(
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  )?_c('a',{staticClass:"bg-link cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data.current
                      .product_name,"href":_vm.getGoLink(
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.go_link,
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.slug
                    ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'}}):_vm._e()],_vm._v(" "),(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(this.gamespageData.meta.play_with_live_dealer.banner),expression:"this.gamespageData.meta.play_with_live_dealer.banner"}],attrs:{"alt":_vm.getAltText(
                    this.gamespageData.meta.play_with_live_dealer.title,
                    this.gamespageData.meta.play_with_live_dealer.banner
                  )}}):_c('img',{attrs:{"src":this.gamespageData.meta.play_with_live_dealer.banner,"alt":_vm.getAltText(
                    this.gamespageData.meta.play_with_live_dealer.title,
                    this.gamespageData.meta.play_with_live_dealer.banner
                  )}}),_vm._v(" "),_c('div',{staticClass:"live-dealer-content"},[_c('div',{staticClass:"top-cont"},[_c('span',{staticClass:"span-h2 custom-font-1"},[_vm._v(_vm._s(this.gamespageData.meta.play_with_live_dealer.title))]),_vm._v(" "),_c('div',{staticClass:"rating-wrapper-large"},[_c('StarRating',{attrs:{"rating":parseFloat(
                          this.gamespageData.meta.play_with_live_dealer.rating
                        ),"no-text":""}})],1),_vm._v(" "),_c('div',{staticClass:"rating-wrapper"},[_c('div',{staticClass:"radio-stars radio-stars-mob"},[_vm._l((_vm.getRoundedRating(
                          parseFloat(
                            this.gamespageData.meta.play_with_live_dealer
                              .rating
                          )
                        )),function(index){return _c('img',{key:index,attrs:{"src":_vm.$root.site_url +
                          _vm.$root.asset_path +
                          '/svg-icons/star-mob.svg',"alt":"Star Mobile"}})}),_vm._v(" "),_vm._l((5 -
                        _vm.getRoundedRating(
                          parseFloat(
                            this.gamespageData.meta.play_with_live_dealer
                              .rating
                          )
                        )),function(index){return _c('img',{key:index + 10,attrs:{"src":_vm.$root.site_url +
                          _vm.$root.asset_path +
                          '/svg-icons/star-mob-clr.svg',"alt":"Star Mobile Clear"}})})],2)])]),_vm._v(" "),(_vm.hideToplistLabelGB)?void 0:[(
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current
                    )?_c('a',{class:{
                      'cta cta-primary cta-yellow cta-yellow__lg z-index-2 custom-btn hover-btn cas-link': true,
                      'font-dark': _vm.getContrastYIQ(
                        _vm.$root.color_schema.primary_btn
                      ),
                      'font-light': !_vm.getContrastYIQ(
                        _vm.$root.color_schema.primary_btn
                      ),
                    },style:({
                      '--primary-btn': _vm.$root.color_schema.primary_btn,
                      '--primary-btn-hover': _vm.pSBC(
                        -0.2,
                        _vm.$root.color_schema.primary_btn
                      ),
                    }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                        .current.product_name,"href":_vm.getGoLink(
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link,
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.slug
                      ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(this.gamespageData.meta.play_with_live_dealer
                        .button_label))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambsdpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()]],2)],2):_vm._e(),_vm._v(" "),(
                this.gamespageData.meta &&
                this.gamespageData.meta.our_expert_review &&
                Object.keys(this.gamespageData.meta.our_expert_review)
                  .length > 0 &&
                this.gamespageData.meta.our_expert_review.reviewer_image
              )?_c('div',{staticClass:"expert-review",style:({
                backgroundColor: _vm.pSBC(0.1, _vm.$root.color_schema.footer_bg),
              })},[_c('div',{staticClass:"expert-review-inner"},[_c('span',{staticClass:"span-h2 custom-font-1"},[_vm._v(_vm._s(this.gamespageData.meta.our_expert_review.title))]),_vm._v(" "),_c('div',{staticClass:"expert-info"},[_c('div',{staticClass:"expert-info-pic"},[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                        this.gamespageData.meta.our_expert_review
                          .reviewer_image
                      ),expression:"\n                        this.gamespageData.meta.our_expert_review\n                          .reviewer_image\n                      "}],attrs:{"alt":_vm.getAltText(
                          this.gamespageData.meta.our_expert_review.title,
                          this.gamespageData.meta.our_expert_review
                            .reviewer_image
                        )}}):_c('img',{attrs:{"src":this.gamespageData.meta.our_expert_review
                          .reviewer_image,"alt":_vm.getAltText(
                          this.gamespageData.meta.our_expert_review.title,
                          this.gamespageData.meta.our_expert_review
                            .reviewer_image
                        )}})]),_vm._v(" "),_c('div',{staticClass:"expert-info-right"},[_c('StarRating',{attrs:{"rating":parseFloat(
                          this.gamespageData.meta.our_expert_review
                            .review_rating
                        ),"no-text":""}}),_vm._v(" "),_c('span',{staticClass:"span-h6 custom-font-1"},[_vm._v(_vm._s(this.gamespageData.meta.our_expert_review.reviewer_name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$root.i18n.reviewed_on)+"\n                      "+_vm._s(this.gamespageData.meta.our_expert_review.review_date))])],1)]),_vm._v(" "),_c('div',{staticClass:"expert-review-bottom"},[_c('span',[_c('img',{attrs:{"src":_vm.$root.site_url +
                        _vm.$root.asset_path +
                        '/svg-icons/expert-icon.svg',"alt":"Expert Icon"}})]),_vm._v(" "),_c('p',{staticClass:"custom-font-2"},[_vm._v("\n                    "+_vm._s(this.gamespageData.meta.our_expert_review.review_content)+"\n                  ")])])])]):_vm._e()]],2)]):_vm._e()]),_vm._v(" "),(
        this.gamespageData.meta &&
        this.gamespageData.meta.geo_provider_partners_data &&
        this.gamespageData.meta.geo_provider_partners_data.current &&
        !this.gameTemplate
      )?_c('div',{staticClass:"play-casino-section"},[_c('div',{staticClass:"container mobile-scroll-container"},[(_vm.hideToplistLabelGB)?[_c('div',{staticClass:"text-center pt-10 font-light"},[_vm._v("\n            "+_vm._s(_vm.$root.i18n.no_toplist_available_intime)+"\n          ")])]:[(_vm.gamesTop3.length > 0)?_vm._l((_vm.gamesTop3),function(val,index){return _c('div',{key:index},[(val && val.length > 0)?_c('TagBlock',{attrs:{"attrs":{},"title":_vm.gamesTop3Title[index],"block":'gamepageBanner',"usTag":_vm.gamesTop3Attrs &&
                  _vm.gamesTop3Attrs.hasOwnProperty('title_tag') &&
                  _vm.gamesTop3Attrs.title_tag != ''
                    ? _vm.gamesTop3Attrs.title_tag
                    : 'span'}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobile-scroller"},[_c('div',{staticClass:"row wd-auto"},_vm._l((val),function(data,index){return _c('div',{key:index,staticClass:"col-md-4 col-sm-4 mw-300"},[_c('div',{class:{
                        'play-card': true,
                        'term-recas':
                          (data.bonus_tc && data.bonus_tc != '') ||
                          (data.terms && data.terms != ''),
                        'top-choice': index === 0,
                        'rm-bottom-color':
                          index === 0 &&
                          ((data.bonus_tc && data.bonus_tc != '') ||
                            (data.terms && data.terms != '')),
                      }},[_c('div',{staticClass:"play-card-top"},[_c('div',{staticClass:"play-card-top-img pos-relative"},[_c('a',{staticClass:"partner-logo cas-link",attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow',"target":"_blank"}},[(
                                _vm.$root.enable_lazyload &&
                                _vm.assets_images &&
                                _vm.assets_images.pro_asset_sizes
                              )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                                data.product_assets.filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                ).length > 0
                                  ? data.product_assets.filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )[0].url
                                  : ''
                              ),expression:"\n                                data.product_assets.filter(\n                                  (ele) =>\n                                    ele.asset_category_name ===\n                                    assets_images.pro_asset_sizes.medium\n                                ).length > 0\n                                  ? data.product_assets.filter(\n                                      (ele) =>\n                                        ele.asset_category_name ===\n                                        assets_images.pro_asset_sizes.medium\n                                    )[0].url\n                                  : ''\n                              "}],attrs:{"alt":_vm.getAltText(
                                  data.product_name,
                                  data.product_assets.filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  ).length > 0
                                    ? data.product_assets.filter(
                                        function (ele) { return ele.asset_category_name ===
                                          _vm.assets_images.pro_asset_sizes.medium; }
                                      )[0].url
                                    : ''
                                )}}):(
                                _vm.assets_images && _vm.assets_images.pro_asset_sizes
                              )?_c('img',{attrs:{"src":data.product_assets.filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                ).length > 0
                                  ? data.product_assets.filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )[0].url
                                  : _vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/failure.png',"alt":_vm.getAltText(
                                  data.product_name,
                                  data.product_assets.filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  ).length > 0
                                    ? data.product_assets.filter(
                                        function (ele) { return ele.asset_category_name ===
                                          _vm.assets_images.pro_asset_sizes.medium; }
                                      )[0].url
                                    : _vm.$root.site_url +
                                        _vm.$root.asset_path +
                                        '/failure.png'
                                )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-cas"},[_c('div',{staticClass:"partner-hover-inner",style:({
                                  '--primary-btn':
                                    _vm.$root.color_schema.primary_btn,
                                  '--primary-btn-hover': _vm.pSBC(
                                    -0.2,
                                    _vm.$root.color_schema.primary_btn
                                  ),
                                })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(Object.keys(_vm.hasTag(data.tags)).length > 0)?_c('div',{class:{
                                'stripe text-center': true,
                                'font-dark': _vm.getContrastYIQ(
                                  Object.keys(_vm.hasTag(data.tags)).length > 0
                                    ? _vm.hasTag(data.tags).color
                                    : null
                                ),
                                'font-light': !_vm.getContrastYIQ(
                                  Object.keys(_vm.hasTag(data.tags)).length > 0
                                    ? _vm.hasTag(data.tags).color
                                    : null
                                ),
                              },style:({
                                backgroundColor:
                                  Object.keys(_vm.hasTag(data.tags)).length > 0
                                    ? _vm.hasTag(data.tags).color
                                    : null,
                              })},[_c('img',{attrs:{"src":_vm.hasTag(data.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"play-card-top-right gamefree-casino"},[_c('span',{staticClass:"span-h5 custom-font-1"},[(_vm.hideBonusLabelGB)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[_c('a',{staticClass:"bonus-link custom-font-1 cas-link",style:({
                                  '--color-hover':
                                    _vm.$root.color_schema.primary_btn,
                                }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                    ? 'nofollow sponsored'
                                    : 'nofollow'}},[(
                                    data.bonus_match &&
                                    data.exclusive_bonus_amount &&
                                    data.exclusive_bonus_match
                                  )?_c('span',[_vm._v(_vm._s(data.exclusive_bonus_match)+"%\n                                  "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                                  "+_vm._s(_vm._f("currency")(data.exclusive_bonus_amount,data.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                                    data.bonus_match &&
                                    !data.exclusive_bonus_amount &&
                                    data.bonus_amount
                                  )?_c('span',[_vm._v(_vm._s(data.bonus_match)+"%\n                                  "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                                  "+_vm._s(_vm._f("currency")(data.bonus_amount,data.bonus_currency)))]):_vm._e(),_vm._v(" "),(data.freespin || data.freebie_name)?_c('span',[(
                                      (data.exclusive_bonus_amount ||
                                        data.bonus_amount) &&
                                      data.bonus_match
                                    )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(data.freespin)?[(
                                        data.show_freebie_currency === '1'
                                      )?[_vm._v(_vm._s(_vm._f("currency")(data.freespin,data.bonus_currency)))]:[_vm._v(_vm._s(data.freespin))],_vm._v("\n                                    "+_vm._s(data.freebie_name)+"\n                                  ")]:[_vm._v(_vm._s(data.freebie_name))]],2):_vm._e()])]],2),_vm._v(" "),_c('div',{staticClass:"row mar-2"},[_c('StarRating',{attrs:{"rating":parseFloat((data.rating / 2).toFixed(1))}})],1)])]),_vm._v(" "),_c('a',{class:{
                          'cta cta-primary cta-promotion cta-block custom-btn hover-btn cas-link': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[(index === 0)?_c('img',{attrs:{"src":_vm.crownIcon,"height":"16","width":"24","alt":"Crown"}}):_vm._e(),_vm._v("\n                          "+_vm._s(data.cta_button_text))]),_vm._v(" "),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gamcpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(data.review_link)?_c('a',{staticClass:"read-review",attrs:{"title":data.product_name,"href":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                              _vm.$root.i18n.partner_name_review,
                              data.product_name
                            )))]):_c('span',{staticClass:"emt-sp"},[_vm._v(" ")])]:[(data.review_link)?_c('router-link',{staticClass:"read-review",attrs:{"title":data.product_name,"to":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                              _vm.$root.i18n.partner_name_review,
                              data.product_name
                            )))]):_c('span',{staticClass:"emt-sp"},[_vm._v(" ")])]],2),_vm._v(" "),(
                        (data.bonus_tc && data.bonus_tc != '') ||
                        (data.terms && data.terms != '')
                      )?_c('div',{class:{
                        'cas-terms gam-term': true,
                        'terms-top-choice':
                          index === 0 &&
                          ((data.bonus_tc && data.bonus_tc != '') ||
                            (data.terms && data.terms != '')),
                      }},[(data.bonus_tc && data.bonus_tc != '')?_c('span',{staticClass:"read-review cas-term",staticStyle:{"text-align":"center"},style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                        }),domProps:{"innerHTML":_vm._s(data.bonus_tc.trim())}}):_vm._e(),_vm._v(" "),(
                          data.bonus_tc &&
                          data.terms &&
                          data.bonus_tc != '' &&
                          data.terms != ''
                        )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(data.terms && data.terms != '')?_c('a',{staticClass:"read-review cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"title":data.product_name,"href":_vm.getGoLink(data.term_link, data.slug),"target":"_blank"}},[_vm._v(_vm._s(data.terms))]):_vm._e()]):_vm._e()])}),0)])],1)}):_vm._e()]],2)]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{class:{
      'block-wrapper': true,
      'custom-background-image': _vm.$root.color_schema.site_bg_img,
    },style:({
      '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
      '--bg-color': _vm.$root.color_schema.site_bg_color,
    })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"observer",rawName:"v-observer:subtree",value:(_vm.mutationObserve),expression:"mutationObserve",arg:"subtree"}],class:{
        'custom-background-color': _vm.$root.color_schema.site_bg_img,
        'pb-25': true,
      }},[(
          !(this.gamespageData.meta && this.gamespageData.meta.banner_image)
        )?_c('section',{staticClass:"pt-26"},[_c('div',{staticClass:"container z-con overflow-auto"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":this.gamespageData.breadcrumb,"dark":true,"templateName":'',"gameBlockTitle":''}})],1)])]):_vm._e(),_vm._v(" "),_c('section',{class:{
          'ct-card-horizontal-game': true,
          'pt-20':
            this.gamespageData.meta && this.gamespageData.meta.banner_image,
        }},[(_vm.blockData)?[_vm._l((_vm.blockData),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]})]:_vm._e()],2),_vm._v(" "),(_vm.endOfblockData && _vm.morePaymentBottom)?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(_vm.auhtorBlockdata && _vm.endOfblockData)?void 0:_vm._e()],2)])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(663);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("27cde507", content, true, {});

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-7695d3b2]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-7695d3b2]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-7695d3b2]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-7695d3b2]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-7695d3b2]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-7695d3b2]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-7695d3b2]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-7695d3b2]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-7695d3b2]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-7695d3b2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-7695d3b2]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-7695d3b2]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-article[data-v-7695d3b2]{padding-bottom:15px}.ct-article h1[data-v-7695d3b2]{margin:0!important}.ct-card-horizontal[data-v-7695d3b2]{padding:0}.casino-header[data-v-7695d3b2]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-7695d3b2]{text-align:center;color:#fff;font-weight:700;padding:8px}.casino-header-home[data-v-7695d3b2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:10px 0}.casino-header-home .casino-inner[data-v-7695d3b2]{color:#fff;text-align:center;padding:0 20px;border-right:1px solid #fff;-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;display:none}.casino-header-home .casino-inner[data-v-7695d3b2]:last-child{border-right:0;display:block}.casino-header-home .casino-inner h2[data-v-7695d3b2]{color:#fff;border-right:0;font-weight:700;padding:0 8px}.casino-header-home .casino-inner img[data-v-7695d3b2]{vertical-align:top;margin-right:8px;margin-top:3px}@media (min-width:768px){.casino-header-home .casino-inner[data-v-7695d3b2]{display:block}}.progressive-content-box[data-v-7695d3b2]{margin:0!important}.ct-editor-section[data-v-7695d3b2]{padding:7px 0}.pt-20[data-v-7695d3b2]{padding-top:20px}", ""]);

// exports


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{
    'main-content-area': true,
    'custom-background-image': _vm.$root.color_schema.site_bg_img,
  },style:({
    '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
    '--bg-color': _vm.$root.color_schema.site_bg_color,
  })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"observer",rawName:"v-observer",value:(_vm.mutationObserveDefault),expression:"mutationObserveDefault"}],class:{
      'custom-background-color': _vm.$root.color_schema.site_bg_img,
      'page-wrapper pt-26 pb-25': true,
    }},[_c('section',{staticClass:"ct-article"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.defaultPageData.breadcrumb,"dark":true}})],1)])]),_vm._v(" "),_vm._l((_vm.blockData),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]}),_vm._v(" "),(
        _vm.morePaymentBottom &&
        _vm.blockData.length === _vm.defaultPageData.content.blocks.length
      )?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(
        _vm.auhtorBlockdata &&
        _vm.blockData.length === _vm.defaultPageData.content.blocks.length
      )?void 0:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(666);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3a1e0154", content, true, {});

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-5118edfa]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-5118edfa]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-5118edfa]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-5118edfa]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-5118edfa]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-5118edfa]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-5118edfa]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-5118edfa]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-5118edfa]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-5118edfa]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-5118edfa]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-5118edfa]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-article[data-v-5118edfa]{padding-bottom:15px}.ct-article h1[data-v-5118edfa]{margin:0!important}.ct-card-horizontal[data-v-5118edfa]{padding:0}.casino-header[data-v-5118edfa]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-5118edfa]{text-align:center;color:#fff;font-weight:700;padding:8px}.casino-header-home[data-v-5118edfa]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:10px 0}.casino-header-home .casino-inner[data-v-5118edfa]{color:#fff;text-align:center;padding:0 20px;border-right:1px solid #fff;-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;display:none}.casino-header-home .casino-inner[data-v-5118edfa]:last-child{border-right:0;display:block}.casino-header-home .casino-inner h2[data-v-5118edfa]{color:#fff;border-right:0;font-weight:700;padding:0 8px}.casino-header-home .casino-inner img[data-v-5118edfa]{vertical-align:top;margin-right:8px;margin-top:3px}@media (min-width:768px){.casino-header-home .casino-inner[data-v-5118edfa]{display:block}}.progressive-content-box[data-v-5118edfa]{margin:0!important}.ct-editor-section[data-v-5118edfa]{padding:7px 0}.pt-20[data-v-5118edfa]{padding-top:20px}", ""]);

// exports


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_USMap_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_251f7169_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_USMap_vue__ = __webpack_require__(671);
function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-251f7169"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_USMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_251f7169_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_USMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(669);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("13a3138e", content, true, {});

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-251f7169]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-251f7169]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-251f7169]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-251f7169]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-251f7169]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-251f7169]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-251f7169]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-251f7169]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-251f7169]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-251f7169]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-251f7169]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-251f7169]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.wd-100[data-v-251f7169]{width:100%!important}.ct-online-casino[data-v-251f7169]{position:relative;clear:both;display:flex;align-items:center;width:100%;padding:0!important;margin-top:0}.mb-24[data-v-251f7169]{margin-bottom:24px}.svg-states[data-v-251f7169]{display:block;width:100%;height:245px;margin-bottom:24px}@media (min-width:768px){.svg-states[data-v-251f7169]{margin-bottom:36px;height:460px}}@media (min-width:992px){.svg-states[data-v-251f7169]{height:767px}}.map__legend-group[data-v-251f7169],.map__legend[data-v-251f7169]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.map__legend-group[data-v-251f7169]{margin-right:16px}@media (min-width:768px){.map__legend-group[data-v-251f7169]{margin-right:56px}}.map__legend-color[data-v-251f7169]{width:12px;height:12px;min-width:12px;min-height:12px;border-radius:100%}@media (min-width:768px){.map__legend-color[data-v-251f7169]{width:23px;height:23px;min-width:23px;min-height:23px}}.map__legend-age[data-v-251f7169]{display:block;margin-left:4px;font-weight:700;font-size:.75rem}@media (min-width:768px){.map__legend-age[data-v-251f7169]{margin-left:10px;font-size:1.5rem}}@media (min-width:1280px){.map__tooltip[data-v-251f7169]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;padding:8px 12px 12px;width:236px;min-width:236px;height:auto;min-height:auto;background:#fff;box-shadow:0 2px 2px rgba(0,0,0,.15);position:absolute;left:-13px;top:13px;z-index:1;text-align:center}.map__tooltip-state[data-v-251f7169]{display:block;margin-bottom:4px;line-height:120%;font-size:1.125rem;font-weight:700;text-transform:uppercase;color:#221d47}.map__tooltip-state .map__tooltip-state[data-age*=\"21\"][data-v-251f7169]{color:#891ec7}.map__tooltip-state .map__tooltip-state[data-age*=null][data-v-251f7169]{color:#fbbb40}.map__tooltip-state .map__tooltip-state[data-age*=\"18\"][data-v-251f7169]{color:#58fba4}.map__tooltip-age[data-v-251f7169]{display:inline-block;vertical-align:middle;line-height:120%;font-weight:700;text-align:center;color:#0a0433}.map__tooltip-button[data-v-251f7169]{display:block;margin:9px 0;padding:0;width:100%;min-width:100%;height:39px;min-height:39px;line-height:39px;font-size:.875rem;font-weight:700;position:static}.map__tooltip .map__tooltip-age--suffix[data-v-251f7169]{font-weight:400}.map__tooltip[data-v-251f7169]:after{display:block;width:0;height:0;border-bottom:inset;content:\"\";border-color:transparent transparent #fff;border-style:inset inset solid;border-width:0 20.5px 35.506px;position:absolute;z-index:-1;left:0;bottom:-9px;-webkit-transform:matrix(-.97,-.28,.24,-.96,0,0);transform:matrix(-.97,-.28,.24,-.96,0,0)}}.flex-table[data-v-251f7169]{display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;flex-direction:column;-webkit-box-pack:start;justify-content:flex-start;-webkit-box-align:start;align-items:flex-start;width:100%;overflow:hidden}@media (min-width:576px){.flex-table[data-v-251f7169]{display:inline-table}}.flex-table thead[data-v-251f7169]{width:100%}.flex-table thead tr[data-v-251f7169]{background:#060033;color:#fff}@media (max-width:576px){.flex-table thead tr th[data-v-251f7169]{white-space:pre}}.flex-table tbody[data-v-251f7169]{width:100%}.flex-table tbody tr[data-v-251f7169]{color:#373a3c}.flex-table tbody tr[data-v-251f7169]:nth-child(odd){background:#f3f3f3}.flex-table tbody tr[data-v-251f7169]:nth-child(2n){background:#fff}.flex-table tbody tr td[data-v-251f7169]{width:33.33333%;min-width:33.33333%;min-height:39px;padding:0 12px;line-height:18px;font-size:.75rem;font-weight:400;align-items:center;text-align:center}@media (min-width:768px){.flex-table tbody tr td[data-v-251f7169]{line-height:26px;font-size:1rem;width:20%;min-width:20%;min-height:80px}}@media (min-width:1280px){.flex-table tbody tr td[data-v-251f7169]{line-height:26px;font-size:1.5rem;width:16.66%;min-width:16.66%}}.flex-table tbody tr a[data-v-251f7169]{line-height:160%;font-weight:700;text-decoration:underline;display:inline;margin:auto;text-align:center}.flex-table tr[data-v-251f7169]{border-radius:15px;box-shadow:0 0 4px rgba(0,0,0,.1);-webkit-box-pack:justify;justify-content:space-between}.flex-table td[data-v-251f7169],.flex-table th[data-v-251f7169],.flex-table tr[data-v-251f7169]{display:flex;-webkit-box-direction:normal;-webkit-box-orient:horizontal;flex-direction:row;align-content:center}.flex-table td[data-v-251f7169],.flex-table th[data-v-251f7169]{-webkit-box-pack:center;justify-content:center;width:33.33333%;min-width:33.33333%;min-height:39px}@media (min-width:768px){.flex-table td[data-v-251f7169],.flex-table th[data-v-251f7169]{width:20%;min-width:20%;min-height:83px}}@media (min-width:1280px){.flex-table td[data-v-251f7169],.flex-table th[data-v-251f7169]{width:16.66%;min-width:16.66%;min-height:83px}}.flex-table th span[data-v-251f7169]{display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;padding:0 20px;line-height:17px;font-size:.875rem;font-weight:700}@media (min-width:1024px){.flex-table th span[data-v-251f7169]{line-height:26px;font-size:1.5rem}}@media (min-width:768px){.flex-table th span[data-v-251f7169]{line-height:26px;font-size:1.375rem}}", ""]);

// exports


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCountryCode; });
var us_states = [{
  state_name: "Alaska",
  state_code: "AK",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M161.1,453.7l-0.3,85.4l1.6,1l3.1,0.2l1.5-1.1h2.6l0.2,2.9l7,6.8l0.5,2.6l3.4-1.9l0.6-0.2l0.3-3.1 l1.5-1.6l1.1-0.2l1.9-1.5l3.1,2.1l0.6,2.9l1.9,1.1l1.1,2.4l3.9,1.8l3.4,6l2.7,3.9l2.3,2.7l1.5,3.7l5,1.8l5.2,2.1l1,4.4l0.5,3.1 l-1,3.4l-1.8,2.3l-1.6-0.8l-1.5-3.1l-2.7-1.5l-1.8-1.1l-0.8,0.8l1.5,2.7l0.2,3.7l-1.1,0.5l-1.9-1.9l-2.1-1.3l0.5,1.6l1.3,1.8 l-0.8,0.8c0,0-0.8-0.3-1.3-1c-0.5-0.6-2.1-3.4-2.1-3.4l-1-2.3c0,0-0.3,1.3-1,1c-0.6-0.3-1.3-1.5-1.3-1.5l1.8-1.9l-1.5-1.5v-5h-0.8 l-0.8,3.4l-1.1,0.5l-1-3.7l-0.6-3.7l-0.8-0.5l0.3,5.7v1.1l-1.5-1.3l-3.6-6l-2.1-0.5l-0.6-3.7l-1.6-2.9l-1.6-1.1v-2.3l2.1-1.3 l-0.5-0.3l-2.6,0.6l-3.4-2.4l-2.6-2.9l-4.8-2.6l-4-2.6l1.3-3.2v-1.6l-1.8,1.6l-2.9,1.1l-3.7-1.1l-5.7-2.4h-5.5l-0.6,0.5l-6.5-3.9 l-2.1-0.3l-2.7-5.8l-3.6,0.3l-3.6,1.5l0.5,4.5l1.1-2.9l1,0.3l-1.5,4.4l3.2-2.7l0.6,1.6l-3.9,4.4l-1.3-0.3l-0.5-1.9l-1.3-0.8 l-1.3,1.1l-2.7-1.8l-3.1,2.1l-1.8,2.1l-3.4,2.1l-4.7-0.2l-0.5-2.1l3.7-0.6v-1.3l-2.3-0.6l1-2.4l2.3-3.9v-1.8l0.2-0.8l4.4-2.3l1,1.3 h2.7l-1.3-2.6l-3.7-0.3l-5,2.7l-2.4,3.4l-1.8,2.6l-1.1,2.3l-4.2,1.5l-3.1,2.6l-0.3,1.6l2.3,1l0.8,2.1l-2.7,3.2l-6.5,4.2l-7.8,4.2 l-2.1,1.1l-5.3,1.1l-5.3,2.3l1.8,1.3l-1.5,1.5l-0.5,1.1l-2.7-1l-3.2,0.2l-0.8,2.3h-1l0.3-2.4l-3.6,1.3l-2.9,1l-3.4-1.3l-2.9,1.9 h-3.2l-2.1,1.3l-1.6,0.8l-2.1-0.3l-2.6-1.1l-2.3,0.6l-1,1l-1.6-1.1v-1.9l3.1-1.3l6.3,0.6l4.4-1.6l2.1-2.1l2.9-0.6l1.8-0.8l2.7,0.2 l1.6,1.3l1-0.3l2.3-2.7l3.1-1l3.4-0.6l1.3-0.3l0.6,0.5h0.8l1.3-3.7l4-1.5l1.9-3.7l2.3-4.5l1.6-1.5l0.3-2.6l-1.6,1.3l-3.4,0.6 l-0.6-2.4l-1.3-0.3l-1,1l-0.2,2.9l-1.5-0.2l-1.5-5.8l-1.3,1.3l-1.1-0.5l-0.3-1.9l-4,0.2l-2.1,1.1l-2.6-0.3l1.5-1.5l0.5-2.6 l-0.6-1.9l1.5-1l1.3-0.2l-0.6-1.8v-4.4l-1-1l-0.8,1.5h-6.1l-1.5-1.3l-0.6-3.9l-2.1-3.6v-1l2.1-0.8l0.2-2.1l1.1-1.1l-0.8-0.5 l-1.3,0.5l-1.1-2.7l1-5l4.5-3.2l2.6-1.6l1.9-3.7l2.7-1.3l2.6,1.1l0.3,2.4l2.4-0.3l3.2-2.4l1.6,0.6l1,0.6h1.6l2.3-1.3l0.8-4.4 c0,0,0.3-2.9,1-3.4c0.6-0.5,1-1,1-1l-1.1-1.9l-2.6,0.8l-3.2,0.8l-1.9-0.5l-3.6-1.8l-5-0.2l-3.6-3.7l0.5-3.9l0.6-2.4l-2.1-1.8 l-1.9-3.7l0.5-0.8l6.8-0.5h2.1l1,1h0.6l-0.2-1.6l3.9-0.6l2.6,0.3l1.5,1.1l-1.5,2.1l-0.5,1.5l2.7,1.6l5,1.8l1.8-1l-2.3-4.4l-1-3.2 l1-0.8l-3.4-1.9l-0.5-1.1l0.5-1.6l-0.8-3.9l-2.9-4.7l-2.4-4.2l2.9-1.9h3.2l1.8,0.6l4.2-0.2l3.7-3.6l1.1-3.1l3.7-2.4l1.6,1l2.7-0.6 l3.7-2.1l1.1-0.2l1,0.8l4.5-0.2l2.7-3.1h1.1l3.6,2.4l1.9,2.1l-0.5,1.1l0.6,1.1l1.6-1.6l3.9,0.3l0.3,3.7l1.9,1.5l7.1,0.6l6.3,4.2 l1.5-1l5.2,2.6l2.1-0.6l1.9-0.8l4.8,1.9L161.1,453.7z M46,482.6l2.1,5.3l-0.2,1l-2.9-0.3l-1.8-4l-1.8-1.5H39l-0.2-2.6l1.8-2.4 l1.1,2.4l1.5,1.5L46,482.6z M43.4,516.1l3.7,0.8l3.7,1l0.8,1l-1.6,3.7l-3.1-0.2l-3.4-3.6L43.4,516.1z M22.7,502l1.1,2.6 l1.1,1.6l-1.1,0.8l-2.1-3.1V502H22.7z M9,575.1l3.4-2.3l3.4-1l2.6,0.3l0.5,1.6l1.9,0.5l1.9-1.9l-0.3-1.6l2.7-0.6l2.9,2.6 l-1.1,1.8l-4.4,1.1l-2.7-0.5l-3.7-1.1l-4.4,1.5l-1.6,0.3L9,575.1z M57.9,570.6l1.6,1.9l2.1-1.6l-1.5-1.3L57.9,570.6z M60.8,573.6l1.1-2.3l2.1,0.3l-0.8,1.9H60.8z M84.4,571.7l1.5,1.8l1-1.1l-0.8-1.9L84.4,571.7z M93.2,559.2l1.1,5.8l2.9,0.8 l5-2.9l4.4-2.6l-1.6-2.4l0.5-2.4l-2.1,1.3l-2.9-0.8l1.6-1.1l1.9,0.8l3.9-1.8l0.5-1.5l-2.4-0.8l0.8-1.9l-2.7,1.9l-4.7,3.6l-4.8,2.9L93.2,559.2z M135.5,539.4l2.4-1.5l-1-1.8l-1.8,1L135.5,539.4z"
}, {
  state_name: "Alabama",
  state_code: "AL",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M625.6,466.8l-1.6-15.2l-2.7-18.8l0.2-14.1l0.8-31l-0.2-16.7l0.2-6.4l7.8-0.4l27.8-2.6l8.9-0.7 l-0.1,2.2l0.2,2.1l0.6,3.4l3.4,7.9l2.4,9.9l1.5,6.1l1.6,4.8l1.5,7l2.1,6.3l2.6,3.4l0.5,3.4l1.9,0.8l0.2,2.1l-1.8,4.8l-0.5,3.2 l-0.2,1.9l1.6,4.4l0.3,5.3l-0.8,2.4l0.6,0.8l1.5,0.8l1,2.5h-6.3l-6.8,0.6l-25.5,2.9l-10.4,1.4l-0.1,3.8l1.8,1.8l2.6,1.9l0.6,7.9 l-5.5,2.6l-2.7-0.3l2.7-1.9v-1l-3.1-6l-2.3-0.6l-1.5,4.4l-1.3,2.7l-0.6-0.2H625.6z"
}, {
  state_name: "Arkansas",
  state_code: "AR",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M591,345l-3.8,0.9l-6.2-0.5l0.7-3l3.2-2.7l0.5-2.3l-1.8-3l-11,0.5l-20.8,0.9l-23.3,0.7L505,337 l1.6,6.9v8.2l1.4,11l0.2,37.8l2.3,1.9l3-1.4l2.7,1.1l0.4,10.3l22.9-0.1l18.9-0.8l10.1-0.2l1.1-2.1l-0.3-3.5l-1.8-3l1.6-1.5 l-1.6-2.5l0.7-2.5l1.4-5.6l2.5-2.1l-0.7-2.3l3.7-5.4l2.7-1.4l-0.1-1.5l-0.3-1.8l2.9-5.6l2.4-1.3l0.4-3.4l1.8-1.2l0.9-4.2l-1.3-4 l4-2.4l0.6-2l1.2-4.3L591,345z"
}, {
  state_name: "Arizona",
  state_code: "AZ",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M137.7,387.5l-2.6,2.2l-0.3,1.5l0.5,1l18.9,10.7l12.1,7.6l14.7,8.6l16.8,10l12.3,2.4l25.1,2.7 l2.5-12.5l3.8-27.2l7-52.9l4.3-31l-24.6-3.7l-27.2-4.6l-33.4-6.3l-2.9,18.1l-0.5,0.5l-1.7,2.6l-2.5-0.1l-1.3-2.7l-2.7-0.3l-0.9-1.1 h-0.9l-0.9,0.6l-1.9,1l-0.1,7l-0.2,1.7l-0.6,12.6l-1.5,2.2l-0.6,3.3l2.7,4.9l1.3,5.8l0.8,1l1,0.6l-0.1,2.3l-1.6,1.4l-3.4,1.7 l-1.9,1.9l-1.5,3.7l-0.6,4.9l-2.9,2.7l-2.1,0.7l-0.1,5.8l-0.5,1.7l0.5,0.8l3.7,0.6l-0.6,2.7l-1.5,2.2L137.7,387.5z"
}, {
  state_name: "California",
  state_code: "CA",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M136.9,386.8l3.8-0.5l1.5-2l0.7-1.9l-3.2-0.1l-1.1-1.8l0.8-1.7l0-6.2l2.2-1.3l2.7-2.6l0.4-4.9 l1.6-3.5l1.9-2.1l3.3-1.7l1.3-0.7l0.8-1.5l-0.9-0.9l-1-1.5l-0.9-5.3l-2.9-5.2l0.1-2.8l-2.2-3.2l-15-23.2l-19.4-28.7l-22.4-33 l-12.7-19.5l1.8-7.2l6.8-25.9l8.1-31.4l-12.4-3.3l-13.5-3.4l-12.6-4.1l-7.5-2.1l-11.4-3l-7.1-2.4l-1.6,4.7l-0.2,7.4l-5.2,11.8 l-3.1,2.6l-0.3,1.1l-1.8,0.8l-1.5,4.2l-0.8,3.2l2.7,4.2l1.6,4.2l1.1,3.6l-0.3,6.5l-1.8,3.1l-0.6,5.8l-1,3.7l1.8,3.9l2.7,4.5 l2.3,4.8l1.3,4l-0.3,3.2l-0.3,0.5v2.1l5.7,6.3l-0.5,2.4l-0.6,2.3l-0.6,1.9l0.2,8.2l2.1,3.7l1.9,2.6l2.7,0.5l1,2.7l-1.1,3.6 l-2.1,1.6h-1.1l-0.8,3.9l0.5,2.9l3.2,4.4l1.6,5.3l1.5,4.7l1.3,3.1l3.4,5.8l1.5,2.6l0.5,2.9l1.6,1v2.4l-0.8,1.9l-1.8,7.1l-0.5,1.9 l2.4,2.7l4.2,0.5l4.5,1.8l3.9,2.1h2.9l2.9,3.1l2.6,4.8l1.1,2.3l3.9,2.1l4.8,0.8l1.5,2.1l0.6,3.2l-1.5,0.6l0.3,1l3.2,0.8l2.7,0.2 l2.9,4.7l3.9,4.2l0.8,2.3l2.6,4.2l0.3,3.2v9.4l0.5,1.8l10,1.5l19.7,2.7L136.9,386.8z M48.8,337l1.3,1.5l-0.2,1.3l-3.2-0.1 l-0.6-1.2l-0.6-1.5L48.8,337z M50.7,337l1.2-0.6l3.6,2.1l3.1,1.2l-0.9,0.6l-4.5-0.2l-1.6-1.6L50.7,337z M71.4,356.8l1.8,2.3 l0.8,1l1.5,0.6l0.6-1.5l-1-1.8l-2.7-2l-1.1,0.2V356.8z M70,365.5l1.8,3.2l1.2,1.9l-1.5,0.2l-1.3-1.2c0,0-0.7-1.5-0.7-1.9 s0-2.2,0-2.2L70,365.5z"
}, {
  state_name: "Colorado",
  state_code: "CO",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M378.6,256.8l1.4-21.3l-32.1-3.1l-24.5-2.7l-37.3-4.1l-20.7-2.5l-2.6,22.2l-3.2,22.4l-3.8,28 l-1.5,11.1l-0.3,2.8l33.9,3.8l37.7,4.3l32,3.2l16.6,0.8"
}, {
  state_name: "Connecticut",
  state_code: "CT",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M873.2,180.1l-0.6-4.2l-0.8-4.4l-1.6-6l-4.2,0.9l-21.8,4.8l0.6,3.3l1.5,7.3v8.1l-1.1,2.3l1.8,2.1 l5-3.4l3.6-3.2l1.9-2.1l0.8,0.6l2.7-1.5l5.2-1.1L873.2,180.1z"
}, {
  state_name: "Delaware",
  state_code: "DE",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M822.4,230.4l0.6-2.1l0-1.2l-1.3-0.1l-2.1,1.6l-1.5,1.5l1.5,4.2l2.3,5.7l2.1,9.7l1.6,6.3l5-0.2 l6.1-1.2l-2.3-7.4l-1,0.5l-3.6-2.4l-1.8-4.7l-1.9-3.6l-2.3-1l-2.1-3.6L822.4,230.4z"
}, {
  state_name: "Florida",
  state_code: "FL",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M755.4,445.5l2.3,7.3l3.7,9.7l5.3,9.4l3.7,6.3l4.8,5.5l4,3.7l1.6,2.9l-1.1,1.3L779,493l2.9,7.4 l2.9,2.9l2.6,5.3l3.6,5.8l4.5,8.2l1.3,7.6l0.5,12l0.6,1.8l-0.3,3.4l-2.4,1.3l0.3,1.9l-0.6,1.9l0.3,2.4l0.5,1.9l-2.7,3.2l-3.1,1.5 l-3.9,0.2l-1.5,1.6l-2.4,1l-1.3-0.5l-1.1-1l-0.3-2.9l-0.8-3.4l-3.4-5.2l-3.6-2.3l-3.9-0.3l-0.8,1.3l-3.1-4.4l-0.6-3.6l-2.6-4 l-1.8-1.1l-1.6,2.1l-1.8-0.3l-2.1-5l-2.9-3.9l-2.9-5.3l-2.6-3.1l-3.6-3.7l2.1-2.4l3.2-5.5l-0.2-1.6l-4.5-1l-1.6,0.6l0.3,0.6l2.6,1 l-1.5,4.5l-0.8,0.5l-1.8-4l-1.3-4.8l-0.3-2.7l1.5-4.7v-9.5L736,485l-1.3-3.1l-5.2-1.3l-1.9-0.6l-1.6-2.6l-3.4-1.6l-1.1-3.4l-2.7-1 l-2.4-3.7l-4.2-1.5l-2.9-1.5h-2.6l-4,0.8l-0.2,1.9l0.8,1l-0.5,1.1l-3.1-0.2l-3.7,3.6l-3.6,1.9h-3.9l-3.2,1.3l-0.3-2.7l-1.6-1.9 l-2.9-1.1l-1.6-1.5l-8.1-3.9l-7.6-1.8l-4.4,0.6l-6,0.5l-6,2.1l-3.5,0.6l-0.2-8l-2.6-1.9l-1.8-1.8l0.3-3.1l10.2-1.3l25.5-2.9 l6.8-0.6l5.4,0.3l2.6,3.9l1.5,1.5l8.1,0.5l10.8-0.6l21.5-1.3l5.4-0.7l4.6,0l0.2,2.9l3.8,0.8l0.3-4.8l-1.6-4.5l1-0.7l5.1,0.5 L755.4,445.5z M767.9,577.9l2.4-0.6l1.3-0.2l1.5-2.3l2.3-1.6l1.3,0.5l1.7,0.3l0.4,1.1l-3.5,1.2l-4.2,1.5l-2.3,1.2L767.9,577.9z M781.4,572.9l1.2,1.1l2.7-2.1l5.3-4.2l3.7-3.9l2.5-6.6l1-1.7l0.2-3.4l-0.7,0.5l-1,2.8l-1.5,4.6l-3.2,5.3l-4.4,4.2l-3.4,1.9 L781.4,572.9z"
}, {
  state_name: "Georgia",
  state_code: "GA",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M689.6,358l-4.8,0.8l-8.4,1.1l-8.6,0.9v2.2l0.2,2.1l0.6,3.4l3.4,7.9l2.4,9.9l1.5,6.1l1.6,4.8l1.5,7 l2.1,6.3l2.6,3.4l0.5,3.4l1.9,0.8l0.2,2.1l-1.8,4.8l-0.5,3.2l-0.2,1.9l1.6,4.4l0.3,5.3l-0.8,2.4l0.6,0.8l1.5,0.8l0.6,3.4l2.6,3.9 l1.5,1.5l7.9,0.2l10.8-0.6l21.5-1.3l5.4-0.7l4.6,0l0.2,2.9l2.6,0.8l0.3-4.4l-1.6-4.5l1.1-1.6l5.8,0.8l5,0.3l-0.8-6.3l2.3-10 l1.5-4.2l-0.5-2.6l3.3-6.2l-0.5-1.4l-1.9,0.7l-2.6-1.3l-0.6-2.1l-1.3-3.6l-2.3-2.1l-2.6-0.6l-1.6-4.8l-2.9-6.3l-4.2-1.9l-2.1-1.9 l-1.3-2.6l-2.1-1.9l-2.3-1.3l-2.3-2.9l-3.1-2.3l-4.5-1.8l-0.5-1.5l-2.4-2.9l-0.5-1.5l-3.4-4.9l-3.4,0.2l-4.1-3l-1.3-1.3l-0.3-1.8 l0.8-1.9l2.4-1.2l-1.1-1.2l0.1-0.3l-5.8,1l-7,0.8L689.6,358z"
}, {
  state_name: "Hawaii",
  state_code: "HI",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M233.1,519.3l1.9-3.6l2.3-0.3l0.3,0.8l-2.1,3.1H233.1z M243.3,515.6l6.1,2.6l2.1-0.3l1.6-3.9 l-0.6-3.4l-4.2-0.5l-4,1.8L243.3,515.6z M274,525.6l3.7,5.5l2.4-0.3l1.1-0.5l1.5,1.3l3.7-0.2l1-1.5l-2.9-1.8l-1.9-3.7l-2.1-3.6 l-5.8,2.9L274,525.6z M294.2,534.5l1.3-1.9l4.7,1l0.6-0.5l6.1,0.6l-0.3,1.3l-2.6,1.5l-4.4-0.3L294.2,534.5z M299.5,539.7l1.9,3.9 l3.1-1.1l0.3-1.6l-1.6-2.1l-3.7-0.3V539.7z M306.5,538.5l2.3-2.9l4.7,2.4l4.4,1.1l4.4,2.7v1.9l-3.6,1.8l-4.8,1l-2.4-1.5 L306.5,538.5z M323.1,554.1l1.6-1.3l3.4,1.6l7.6,3.6l3.4,2.1l1.6,2.4l1.9,4.4l4,2.6l-0.3,1.3l-3.9,3.2l-4.2,1.5l-1.5-0.6l-3.1,1.8 l-2.4,3.2l-2.3,2.9l-1.8-0.2l-3.6-2.6l-0.3-4.5l0.6-2.4l-1.6-5.7l-2.1-1.8l-0.2-2.6l2.3-1l2.1-3.1l0.5-1l-1.6-1.8L323.1,554.1z"
}, {
  state_name: "Iowa",
  state_code: "IA",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M566.6,201.6l0.2,1.9l2.3,1.1l1.1,1.3l0.3,1.3l3.9,3.2l0.7,2.2l-0.8,2.9l-1.5,3.5l-0.8,2.7 l-2.2,1.6l-1.7,0.6l-5.5,1.5l-0.7,2.3l-0.8,2.3l0.6,1.4l1.7,1.7l0,3.7l-2.2,1.6l-0.5,1.5v2.5l-1.5,0.5l-1.7,1.4l-0.5,1.5l0.5,1.7 l-1.4,1.2l-2.3-2.9l-1.5-2.6l-8.3,0.8l-10.2,0.6l-25,0.7l-13,0.2l-9.4,0.2l-1.3,0.1l-1.7-4.5l-0.2-6.6l-1.6-4.1l-0.7-5.3l-2.3-3.7 l-0.9-4.8l-2.7-7.5l-1.1-5.4l-1.4-2.2l-1.6-2.7l1.8-4.3l1.4-5.7l-2.7-2.1l-0.5-2.7l0.9-2.5h1.7h11.5l49.6-0.7l19.9-0.7l1.9,2.7 l1.8,2.6l0.5,0.8l-1.8,2.7l0.5,4.2l2.5,3.9l3,1.8l2.4,0.2L566.6,201.6z"
}, {
  state_name: "Idaho",
  state_code: "ID",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M162.1,181c-22.6-4.3-14.1-2.8-21.1-4.4l4.4-17.5l4.3-17.7l1.4-4.2l2.5-5.9l-1.3-2.3l-2.5,0.1 l-0.8-1l0.5-1.1l0.3-3.1l4.5-5.5l1.8-0.5l1.1-1.1l0.6-3.2l0.9-0.7l3.9-5.8l3.9-4.3l0.2-3.8l-3.4-2.6l-1.3-4.4l0.4-9.7l3.7-16.5 l4.5-20.8l3.8-13.5l0.8-3.8l13,2.5l-4.2,21.5l2.9,7.7l-1.1,4.6l2,4.6l3.2,1.7l4.5,9.8l2.7,3.8l0.6,1.1l3.4,1.1l0.5,2.5l-6.9,16.8 l0.3,3.3l2.7,2.9l1.9,0.5l4.8-3.6l0.4-0.5l0.2,0.8l0.3,4.1l2.6,12.9l3.5,2.7l0.4,0.8l2.1,2.4l-0.8,2.8l0.7,3.8l1.9,0.9l2.1-1.6 l2.6-0.5l3.4,1.6l2.5-0.6l3.8-0.2l4,1.6l2.7-0.3l0.9-2.3l2.5-1.6l0.7,1.7l0.6,2.2l2.3,2.5l-3.8,24l-5.1,29l-4.2-0.3l-8.2-1.5 l-9.8-1.8l-12.2-2.4l-12.5-2.5l-8.5-1.8l-9.3-1.7L162.1,181z"
}, {
  state_name: "Illinois",
  state_code: "IL",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M617.8,301.5v-3.6l0.3-4.9l2.4-3.1l1.8-3.8l2.6-3.9l-0.4-5.3l-2-3.5l-0.1-3.3l0.7-5.3l-0.8-7.2 l-1.1-15.8l-1.3-15l-0.9-11.6l-0.3-0.9l-0.8-2.6l-1.3-3.7l-1.6-1.8l-1.5-2.6l-0.2-5.5l-9.9,1.3l-27.2,1.7l-8.7-0.4l0.2,2.4l2.3,0.7 l0.9,1.1l0.5,1.8l3.9,3.4l0.7,2.3l-0.7,3.4l-1.8,3.7l-0.7,2.5l-2.3,1.8l-1.8,0.7l-5.3,1.4l-0.7,1.8L562,230l0.7,1.4l1.8,1.6 l-0.2,4.1l-1.8,1.6l-0.7,1.6v2.7l-1.8,0.5l-1.6,1.1l-0.2,1.4l0.2,2.1l-1.7,1.3l-1,2.8l0.5,3.7l2.3,7.3l7.3,7.5l5.5,3.7l-0.2,4.3 l0.9,1.4l6.4,0.5l2.7,1.4l-0.7,3.7l-2.3,5.9l-0.7,3.2l2.3,3.9l6.4,5.3l4.6,0.7l2.1,5l2.1,3.2l-0.9,3l1.6,4.1l1.8,2.1l1.9-0.8 l0.7-2.2l2-1.4l3.2-1.1l3.1,1.2l2.9,1.1l0.8-0.2l-0.1-1.2l-1.1-2.8l0.4-2.4l2.3-1.6l2.4-1l1.2-0.4l-0.6-1.3l-0.8-2.2l1.2-1.3 L617.8,301.5z"
}, {
  state_name: "Indiana",
  state_code: "IN",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M618.4,300.9l0.1-2.9l0.5-4.5l2.3-2.9l1.8-3.9l2.6-4.2l-0.5-5.8l-1.8-2.7l-0.3-3.2l0.8-5.5l-0.5-7 l-1.3-16l-1.3-15.4l-1-11.7l3.1,0.9l1.5,1l1.1-0.3l2.1-1.9l2.8-1.6l5.1-0.2l22-2.3l5.6-0.5l1.5,16l4.3,36.8l0.6,5.8L669,271 l1.2,1.8l0.1,1.4l-2.5,1.6l-3.5,1.6l-3.2,0.6l-0.6,4.9l-4.6,3.3l-2.8,4l0.3,2.4l-0.6,1.5h-3.3l-1.6-1.6l-2.5,1.3l-2.7,1.5l0.2,3.1 l-1.2,0.3l-0.5-1l-2.2-1.5l-3.3,1.3l-1.6,3l-1.4-0.8l-1.5-1.6l-4.5,0.5l-5.6,1L618.4,300.9z"
}, {
  state_name: "Kansas",
  state_code: "KS",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M503.4,325.1l-12.6,0.2l-46.1-0.5l-44.6-2.1l-24.6-1.3l4.1-64.7l21.8,0.8l40.5,1.4l44.1,0.5h5.1 l3.2,3.2l2.8,0.2l0.9,1.1v2l-1.8,1.6l-0.5,2.6l2.2,3.6l2.5,3.1l2.5,2l1.1,11.2L503.4,325.1z"
}, {
  state_name: "Kentucky",
  state_code: "KY",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M721.8,297.8l-2.3,2.7l-4.2,3.6L711,310l-1.8,1.8v2.1l-3.9,2.1l-5.7,3.4l-3.5,0.4l-51.9,4.9 l-15.8,1.8l-4.6,0.5l-3.9,0l-0.2,4.2l-8.2,0.1l-7,0.6l-10.4,0.2l1.9-0.2l2.2-1.8l2.1-1.1l0.2-3.2l0.9-1.8l-1.6-2.5l0.8-1.9l2.3-1.8 l2.1-0.6l2.7,1.3l3.6,1.3l1.1-0.3l0.2-2.3l-1.3-2.4l0.3-2.3l1.9-1.5l2.6-0.6l1.6-0.6l-0.8-1.8l-0.6-1.9l1.1-0.8l1.1-3.3l3-1.7 l5.8-1l3.6-0.5l1.5,1.9l1.8,0.8l1.8-3.2l2.9-1.5l1.9,1.6l0.8,1.1l2.1-0.5l-0.2-3.4l2.9-1.6l1.1-0.8l1.1,1.6h4.7l0.8-2.1l-0.3-2.3 l2.9-3.6l4.7-3.9l0.5-4.5l2.7-0.3l3.9-1.8l2.7-1.9l-0.3-1.9l-1.5-1.5l0.6-2.2l4.1-0.2l2.4-0.8l2.9,1.6l1.6,4.4l5.8,0.3l1.8,1.8 l2.1,0.2l2.4-1.5l3.1,0.5l1.3,1.5l2.7-2.6l1.8-1.3h1.6l0.6,2.7l1.8,1l2.4,2.2l0.2,5.5l0.8,1.6l2.6,1.5l0.6,2.3l2.9,3.7l2.6,2.7 L721.8,297.8z"
}, {
  state_name: "Louisiana",
  state_code: "LA",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M602.2,473l-1-2.6l-1.1-3.1l-3.3-3.5l0.9-6.8l-0.1-1.1l-1.3,0.3l-8.2,0.9l-25,0.5l-0.7-2.4l0.9-8.5 l3.3-5.9l5-8.7l-0.6-2.4l1.3-0.7l0.5-2l-2.3-2.1l-0.1-1.9l-1.8-4.3l-0.5-5.9l-9.7,0.1l-19.2,0.9l-22.2,0l0,9.6l0.7,9.4l0.7,3.9 l2.5,4.1l0.9,5l4.3,5.5l0.2,3.2l0.7,0.7l-0.7,8.5l-3,5l1.6,2.1l-0.7,2.5l-0.7,7.3l-1.4,3.2l0.1,3.6l4.7-1.5l8.1-0.3l10.3,3.6 l6.5,1.1l3.7-1.5l3.2,1.1l3.2,1l0.8-2.1l-3.2-1.1l-2.6,0.5l-2.7-1.6c0,0,0.2-1.3,0.8-1.5c0.6-0.2,3.1-1,3.1-1l1.8,1.5l1.8-1 l3.2,0.6l1.5,2.4l0.3,2.3l4.5,0.3l1.8,1.8l-0.8,1.6l-1.3,0.8l1.6,1.6l8.4,3.6l3.6-1.3l1-2.4l2.6-0.6l1.8-1.5l1.3,1l0.8,2.9 l-2.3,0.8l0.6,0.6l3.4-1.3l2.3-3.4l0.8-0.5l-2.1-0.3l0.8-1.6l-0.2-1.5l2.1-0.5l1.1-1.3l0.6,0.8c0,0-0.2,3.1,0.6,3.1 c0.8,0,4.2,0.6,4.2,0.6l4,1.9l1,1.5h2.9l1.1,1l2.3-3.1v-1.5h-1.3l-3.4-2.7l-5.8-0.8l-3.2-2.3l1.1-2.7l2.3,0.3l0.2-0.6l-1.8-1v-0.5 h3.2l1.8-3.1l-1.3-1.9l-0.3-2.7l-1.5,0.2l-1.9,2.1l-0.6,2.6l-3.1-0.6l-1-1.8l1.8-1.9l2-1.8L602.2,473z"
}, {
  state_name: "Massachusetts",
  state_code: "MA",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M900,173.9l2.2-0.7l0.5-1.7l1,0.1l1,2.3l-1.3,0.5l-3.9,0.1L900,173.9z M890.6,174.7l2.3-2.6h1.6 l1.8,1.5l-2.4,1l-2.2,1L890.6,174.7z M855.8,152.7l17.5-4.2l2.3-0.6l2.1-3.2l3.7-1.7l2.9,4.4l-2.4,5.2l-0.3,1.5l1.9,2.6l1.1-0.8 h1.8l2.3,2.6l3.9,6l3.6,0.5l2.3-1l1.8-1.8l-0.8-2.7l-2.1-1.6l-1.5,0.8l-1-1.3l0.5-0.5l2.1-0.2l1.8,0.8l1.9,2.4l1,2.9l0.3,2.4 l-4.2,1.5l-3.9,1.9l-3.9,4.5l-1.9,1.5v-1l2.4-1.5l0.5-1.8l-0.8-3.1l-2.9,1.5l-0.8,1.5l0.5,2.3l-2.1,1l-2.7-4.5l-3.4-4.4l-2.1-1.8 l-6.5,1.9l-5.1,1.1l-21.8,4.8l-0.4-4.9l0.6-10.6l5.2-0.9L855.8,152.7z"
}, {
  state_name: "Maryland",
  state_code: "MD",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M837,255.3l-6.1,1.3l-5.8,0.2l-1.8-7.1l-2.1-9.7l-2.3-5.7l-1.3-4.4l-7.5,1.6l-14.9,2.8l-37.5,7.6 l1.1,5l1,5.7l0.3-0.3l2.1-2.4l2.3-2.6l2.4-0.6l1.5-1.5l1.8-2.6l1.3,0.6l2.9-0.3l2.6-2.1l2-1.5l1.8-0.5l1.6,1.1l2.9,1.5l1.9,1.8 l1.2,1.5l4.1,1.7v2.9l5.5,1.3l1.1,0.5l1.4-2l2.9,2l-1.3,2.5l-0.8,4l-1.8,2.6v2.1l0.6,1.8l5.1,1.4l4.3-0.1l3.1,1l2.1,0.3l1-2.1 l-1.5-2.1v-1.8l-2.4-2.1l-2.1-5.5l1.3-5.3l-0.2-2.1l-1.3-1.3c0,0,1.5-1.6,1.5-2.3c0-0.6,0.5-2.1,0.5-2.1l1.9-1.3l1.9-1.6l0.5,1 l-1.5,1.6l-1.3,3.7l0.3,1.1l1.8,0.3l0.5,5.5l-2.1,1l0.3,3.6l0.5-0.2l1.1-1.9l1.6,1.8l-1.6,1.3l-0.3,3.4l2.6,3.4l3.9,0.5l1.6-0.8 l3.2,4.2l1.4,0.5l6.7-2.8l2-4L837,255.3z M820.3,264.3l1.1,2.5l0.2,1.8l1.1,1.9c0,0,0.9-0.9,0.9-1.2c0-0.3-0.7-3.1-0.7-3.1 l-0.7-2.3L820.3,264.3z"
}, {
  state_name: "Maine",
  state_code: "ME",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M923.2,77.3l1.9,2.1l2.3,3.7v1.9l-2.1,4.7l-1.9,0.6l-3.4,3.1l-4.8,5.5c0,0-0.6,0-1.3,0 c-0.6,0-1-2.1-1-2.1l-1.8,0.2l-1,1.5l-2.4,1.5l-1,1.5l1.6,1.5l-0.5,0.6l-0.5,2.7l-1.9-0.2v-1.6l-0.3-1.3l-1.5,0.3l-1.8-3.2 l-2.1,1.3l1.3,1.5l0.3,1.1l-0.8,1.3l0.3,3.1l0.2,1.6l-1.6,2.6l-2.9,0.5l-0.3,2.9l-5.3,3.1l-1.3,0.5l-1.6-1.5l-3.1,3.6l1,3.2 l-1.5,1.3l-0.2,4.4l-1.1,6.3l-2.5-1.2l-0.5-3.1l-3.9-1.1l-0.3-2.7l-7.3-23.4l-4.2-13.6l1.4-0.1l1.5,0.4v-2.6l0.8-5.5l2.6-4.7l1.5-4 l-1.9-2.4v-6l0.8-1l0.8-2.7l-0.2-1.5l-0.2-4.8l1.8-4.8l2.9-8.9l2.1-4.2h1.3l1.3,0.2v1.1l1.3,2.3l2.7,0.6l0.8-0.8v-1l4-2.9l1.8-1.8 l1.5,0.2l6,2.4l1.9,1l9.1,29.9h6l0.8,1.9l0.2,4.8l2.9,2.3h0.8l0.2-0.5l-0.5-1.1L923.2,77.3z M902.3,107.5l1.5-1.5l1.4,1.1 l0.6,2.4l-1.7,0.9L902.3,107.5z M909,101.6l1.8,1.9c0,0,1.3,0.1,1.3-0.2s0.2-2,0.2-2l0.9-0.8l-0.8-1.8l-2,0.7L909,101.6z"
}, {
  state_name: "Michigan",
  state_code: "MI",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M581.6,82.1l1.8-2.1l2.2-0.8l5.4-3.9l2.3-0.6l0.5,0.5l-5.1,5.1l-3.3,1.9l-2.1,0.9L581.6,82.1z M667.8,114.2l0.6,2.5l3.2,0.2l1.3-1.2c0,0-0.1-1.5-0.4-1.6c-0.3-0.2-1.6-1.9-1.6-1.9l-2.2,0.2l-1.6,0.2l-0.3,1.1L667.8,114.2z M697.9,177.2l-3.2-8.2l-2.3-9.1l-2.4-3.2l-2.6-1.8l-1.6,1.1l-3.9,1.8l-1.9,5l-2.7,3.7l-1.1,0.6l-1.5-0.6c0,0-2.6-1.5-2.4-2.1 c0.2-0.6,0.5-5,0.5-5l3.4-1.3l0.8-3.4l0.6-2.6l2.4-1.6l-0.3-10l-1.6-2.3l-1.3-0.8l-0.8-2.1l0.8-0.8l1.6,0.3l0.2-1.6L676,131 l-1.3-2.6h-2.6l-4.5-1.5l-5.5-3.4h-2.7l-0.6,0.6l-1-0.5l-3.1-2.3l-2.9,1.8l-2.9,2.3l0.3,3.6l1,0.3l2.1,0.5l0.5,0.8l-2.6,0.8 l-2.6,0.3l-1.5,1.8l-0.3,2.1l0.3,1.6l0.3,5.5l-3.6,2.1l-0.6-0.2v-4.2l1.3-2.4l0.6-2.4l-0.8-0.8l-1.9,0.8l-1,4.2l-2.7,1.1l-1.8,1.9 l-0.2,1l0.6,0.8l-0.6,2.6l-2.3,0.5v1.1l0.8,2.4l-1.1,6.1l-1.6,4l0.6,4.7l0.5,1.1l-0.8,2.4l-0.3,0.8l-0.3,2.7l3.6,6l2.9,6.5l1.5,4.8 l-0.8,4.7l-1,6l-2.4,5.2l-0.3,2.7l-3.3,3.1l4.4-0.2l21.4-2.3l7.3-1l0.1,1.7l6.9-1.2l10.3-1.5l3.9-0.5l0.1-0.6l0.2-1.5l2.1-3.7 l2-1.7l-0.2-5.1l1.6-1.6l1.1-0.3l0.2-3.6l1.5-3l1.1,0.6l0.2,0.6l0.8,0.2l1.9-1L697.9,177.2z M567.5,111.2l0.7-0.6l2.7-0.8l3.6-2.3 v-1l0.6-0.6l6-1l2.4-1.9l4.4-2.1l0.2-1.3l1.9-2.9l1.8-0.8l1.3-1.8l2.3-2.3l4.4-2.4l4.7-0.5l1.1,1.1l-0.3,1l-3.7,1l-1.5,3.1 l-2.3,0.8l-0.5,2.4l-2.4,3.2l-0.3,2.6l0.8,0.5l1-1.1l3.6-2.9l1.3,1.3h2.3l3.2,1l1.5,1.1l1.5,3.1l2.7,2.7l3.9-0.2l1.5-1l1.6,1.3 l1.6,0.5l1.3-0.8h1.1l1.6-1l4-3.6l3.4-1.1l6.6-0.3l4.5-1.9l2.6-1.3l1.5,0.2v5.7l0.5,0.3l2.9,0.8l1.9-0.5l6.1-1.6l1.1-1.1l1.5,0.5v7 l3.2,3.1l1.3,0.6l1.3,1l-1.3,0.3l-0.8-0.3l-3.7-0.5l-2.1,0.6l-2.3-0.2l-3.2,1.5h-1.8l-5.8-1.3l-5.2,0.2l-1.9,2.6l-7,0.6l-2.4,0.8 l-1.1,3.1l-1.3,1.1l-0.5-0.2l-1.5-1.6l-4.5,2.4h-0.6l-1.1-1.6l-0.8,0.2l-1.9,4.4l-1,4l-3.2,7l-1.2-1l-1.4-1l-1.9-10.3l-3.5-1.4 l-2.1-2.3l-12.1-2.7l-2.9-1l-8.2-2.2l-7.9-1.1L567.5,111.2z"
}, {
  state_name: "Minnesota",
  state_code: "MN",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M471.9,128.5l-0.5-8.5l-1.8-7.3l-1.8-13.5l-0.5-9.8l-1.8-3.4l-1.6-5v-10.3l0.7-3.9l-1.8-5.5l30.1,0 l0.3-8.2l0.6-0.2l2.3,0.5l1.9,0.8l0.8,5.5l1.5,6.1l1.6,1.6h4.8l0.3,1.5l6.3,0.3v2.1h4.8l0.3-1.3l1.1-1.1l2.3-0.6l1.3,1h2.9l3.9,2.6 l5.3,2.4l2.4,0.5l0.5-1l1.5-0.5l0.5,2.9l2.6,1.3l0.5-0.5l1.3,0.2v2.1l2.6,1h3.1l1.6-0.8l3.2-3.2l2.6-0.5l0.8,1.8l0.5,1.3h1l1-0.8 l8.9-0.3l1.8,3.1h0.6l0.7-1.1l4.4-0.4l-0.6,2.3l-3.9,1.8l-9.2,4.1l-4.8,2l-3.1,2.6l-2.4,3.6l-2.3,3.9l-1.8,0.8l-4.5,5l-1.3,0.2 l-3.8,2.9l-2.8,3.2l-0.2,3l0.2,7.8l-1.6,1.6L530,128l-1.8,5.7l2.5,3.6l0.5,2.5l-1.1,3l-0.2,3.7l0.5,7.1l3.4,4.1h3l2.5,2.3l3.2,1.4 l3.7,5l7.1,5l1.8,2.1l0.2,5.7l-20.6,0.7l-60.2,0.5l-0.3-35.7l-0.5-3l-4.1-3.4l-1.1-1.8v-1.6l2.1-1.6l1.4-1.4L471.9,128.5z"
}, {
  state_name: "Missouri",
  state_code: "MO",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M555.8,249.5l-2.5-3.1l-1.1-2.3l-7.8,0.7l-9.8,0.5l-25.4,0.9l-13.5,0.2l-7.9,0.1l-2.3,0.1l1.3,2.5 l-0.2,2.3l2.5,3.9l3.1,4.1l3.1,2.7l2.3,0.2l1.4,0.9v3l-1.8,1.6l-0.5,2.3l2.1,3.4l2.5,3l2.5,1.8l1.4,11.7l-0.7,35.3l0.2,4.7l0.5,5.4 l23.4-0.1l23.2-0.7l20.8-0.8l11.7-0.2l2.2,3.4l-0.7,3.3l-3.1,2.4l-0.6,1.8l5.4,0.5l3.9-0.7l1.7-5.5l0.7-5.9l2.3-2l1.7-1.5l2.1-1 l0.1-2.9l0.6-1.7l-1-1.7l-2.7,0.1l-2.2-2.6l-1.4-4.2l0.8-2.5l-1.9-3.4l-1.8-4.6l-4.8-0.8l-7-5.6l-1.7-4.1l0.8-3.2l2.1-6.1l0.5-2.9 l-1.9-1l-6.9-0.8l-1-1.7l-0.1-4.2l-5.5-3.4l-7-7.8l-2.3-7.3l-0.2-4.2L555.8,249.5z"
}, {
  state_name: "Mississippi",
  state_code: "MS",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M624.6,467l-0.3,1.3h-5.2l-1.5-0.8l-2.1-0.3l-6.8,1.9l-1.8-0.8l-2.6,4.2l-1.1,0.8l-1.1-2.5 l-1.1-3.9l-3.4-3.2l1.1-7.5l-0.7-0.9l-1.8,0.2l-8.2,0.7l-24.2,0.7l-0.5-1.6l0.7-8l3.4-6.2l5.3-9.1l-0.9-2.1h1.1l0.7-3.2l-2.3-1.8 l0.2-1.8l-2.1-4.6l-0.3-5.3l1.4-2.7l-0.4-4.3l-1.4-3l1.4-1.4l-1.4-2.1l0.5-1.8l0.9-6.2l3-2.7l-0.7-2.1l3.7-5.3l2.7-0.9v-2.5 l-0.7-1.4l2.7-5.3l2.7-1.1l0.1-3.4l8.7-0.1l24.1-1.9l4.6-0.2l0,6.4l0.2,16.7l-0.8,31l-0.2,14.1l2.7,18.8L624.6,467z"
}, {
  state_name: "Montana",
  state_code: "MT",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M356.7,122.3l0.6-11.2l2.3-24.8c0.5-5,1.1-8.5,1.4-15.4l0.9-14.6l-30.7-2.8L302,50l-29.3-4 l-32.3-5.3l-18.4-3.4l-32.7-6.9l-4.5,21.3l3.4,7.5l-1.4,4.6l1.8,4.6l3.2,1.4l4.6,10.8l2.7,3.2l0.5,1.1l3.4,1.1l0.5,2.1l-7.1,17.6 v2.5l2.5,3.2h0.9l4.8-3l0.7-1.1l1.6,0.7l-0.2,5.3l2.7,12.6l3,2.5l0.9,0.7l1.8,2.3l-0.5,3.4l0.7,3.4l1.1,0.9l2.3-2.3h2.7l3.2,1.6 l2.5-0.9h4.1l3.7,1.6l2.7-0.5l0.5-3l3-0.7l1.4,1.4l0.5,3.2l1.8,1.4l1.5-11.6l20.7,3l28.2,4l16.6,1.9l31.4,3.5l11,1.5l1.1-15.4 L356.7,122.3z"
}, {
  state_name: "North Carolina",
  state_code: "NC",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M832.1,298.5l1.7,4.7l3.6,6.5l2.4,2.4l0.6,2.3l-2.4,0.2l0.8,0.6l-0.3,4.2l-2.6,1.3l-0.6,2.1 l-1.3,2.9l-3.7,1.6l-2.4-0.3l-1.5-0.2l-1.6-1.3l0.3,1.3v1h1.9l0.8,1.3l-1.9,6.3h4.2l0.6,1.6l2.3-2.3l1.3-0.5l-1.9,3.6l-3.1,4.8 h-1.3l-1.1-0.5l-2.7,0.6l-5.2,2.4l-6.5,5.3l-3.4,4.7l-1.9,6.5l-0.5,2.4l-4.7,0.5l-5.5,1.3l-9.9-8.2l-12.6-7.6l-2.9-0.8l-12.6,1.5 l-4.3,0.8l-1.6-3.2l-3-2.1l-16.5,0.5l-7.3,0.8l-9.1,4.5l-6.1,2.6l-1.6,0.3l-5.8,1l-7,0.8l-6.8,0.5l0.5-4.1l1.8-1.5l2.7-0.6l0.6-3.7 l4.2-2.7l3.9-1.5l4.2-3.6l4.4-2.1l0.6-3.1l3.9-3.9l0.6-0.2c0,0,0,1.1,0.8,1.1c0.8,0,1.9,0.3,1.9,0.3l2.3-3.6l2.1-0.6l2.3,0.3 l1.6-3.6l2.9-2.6l0.5-2.1v-4l4.5,0.7l7.1-1.3l15.8-1.9l17.1-2.6l19.9-4l19.7-4.2l11.4-2.8L832.1,298.5z M836,331.5l2.6-2.5 l3.2-2.6l1.5-0.6l0.2-2l-0.6-6.1l-1.5-2.3l-0.6-1.9l0.7-0.2l2.7,5.5l0.4,4.4l-0.2,3.4l-3.4,1.5l-2.8,2.4l-1.1,1.2L836,331.5z"
}, {
  state_name: "North Dakota",
  state_code: "ND",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M471.3,127.7l-0.4-7.5l-2-7.3l-1.8-13.6l-0.5-9.8l-2-3.1l-1.6-5.4v-10.3l0.7-3.9l-2.1-5.5 l-28.4-0.6l-18.6-0.6l-26.5-1.3l-24.9-1.9l-1.3,14.2l-1.4,15.1l-2.3,24.9l-0.5,11l56.8,3.8L471.3,127.7z"
}, {
  state_name: "Nebraska",
  state_code: "NE",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M484.2,247l1.4,2.7l0.1,2.1l2.4,3.7l2.7,3.2h-5l-43.5-0.9l-40.8-0.9l-21.2-1l1.1-21.3l-33.4-2.7 l4.3-44l15.5,1L388,190l17.8,1.1l23.8,1.1l10.7-0.5l2.1,2.3l4.8,3l1.1,0.9l4.3-1.4l3.9-0.5l2.7-0.2l1.8,1.4l5,1.6l3,1.6l0.5,1.6 l0.9,2.1h1.8l0.8,0l1,5.2l2.7,8l1.2,4.6l2.1,3.8l0.5,4.9l1.4,4.3l0.5,6.5"
}, {
  state_name: "New Hampshire",
  state_code: "NH",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M880.8,142.4l0.9-1.1l1.1-3.3l-2.5-0.9l-0.5-3.1l-3.9-1.1l-0.3-2.7l-7.3-23.4l-4.6-14.5l-0.9,0 l-0.6,1.6l-0.6-0.5l-1-1l-1.5,1.9l0,5l0.3,5.7l1.9,2.7v4l-3.7,5.1l-2.6,1.1v1.1l1.1,1.8v8.6l-0.8,9.2l-0.2,4.8l1,1.3l-0.2,4.5 l-0.5,1.8l1.5,0.9l16.4-4.7l2.3-0.6l1.5-2.6L880.8,142.4z"
}, {
  state_name: "New Jersey",
  state_code: "NJ",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M828.2,190.3l-2.1,2.4v3.1l-1.9,3.1l-0.2,1.6l1.3,1.3l-0.2,2.4l-2.3,1.1l0.8,2.7l0.2,1.1l2.7,0.3 l1,2.6l3.6,2.4l2.4,1.6v0.8l-3.2,3.1l-1.6,2.3l-1.5,2.7l-2.3,1.3l-1.2,0.7l-0.2,1.2l-0.6,2.6l1.1,2.2l3.2,2.9l4.8,2.3l4,0.6 l0.2,1.5l-0.8,1l0.3,2.7h0.8l2.1-2.4l0.8-4.8l2.7-4l3.1-6.5l1.1-5.5l-0.6-1.1l-0.2-9.4l-1.6-3.4l-1.1,0.8l-2.7,0.3l-0.5-0.5l1.1-1 l2.1-1.9l0.1-1.1l-0.4-3.4l0.5-2.7l-0.2-2.1l-2.6-1.1l-4.5-1l-3.9-1.1L828.2,190.3z"
}, {
  state_name: "New Mexico",
  state_code: "NM",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M282.7,431l-0.7-6.1l8.6,0.5l29.5,3.1l28.4,1.4l2-22.3l3.7-55.9l1.1-19.4l2,0.3l0-11.1l-32.2-2.4 l-36.9-4.4l-34.5-4.1l-4.2,30.8l-7,53.2l-3.8,26.9l-2,13.3l15.5,2l1.3-10l16.7,2.6L282.7,431z"
}, {
  state_name: "Nevada",
  state_code: "NV",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M140.7,177.6l21,4.5l9.7,1.9l9.3,1.8l6.6,1.6l-0.6,5.9l-3.5,17.3l-4.1,20l-1.9,9.7l-2.2,13.3 l-3.2,16.4l-3.5,15.7l-2,10.2l-2.5,16.8l-0.5,1.1l-1.1,2.5l-1.9-0.1l-1.1-2.7l-2.7-0.5l-1.4-1l-2,0.3l-0.9,0.7l-1.3,1.3l-0.4,7 l-0.5,1.7l-0.4,12.1l-1.3,1.7l-1.9-2.3l-14.5-22.7l-19.4-29L89.6,249l-12.4-18.6l1.6-6.6l7-25.9l7.9-31.3l33.6,8.1l13.7,3"
}, {
  state_name: "New York",
  state_code: "NY",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M828.9,189.3l-1.1-1l-2.6-0.2l-2.3-1.9l-1.6-6.1l-3.5,0.1l-2.4-2.7l-19.4,4.4l-43,8.7l-7.5,1.2 l-0.7-6.5l1.4-1.1l1.3-1.1l1-1.6l1.8-1.1l1.9-1.8l0.5-1.6l2.1-2.7l1.1-1l-0.2-1l-1.3-3.1l-1.8-0.2l-1.9-6.1l2.9-1.8l4.4-1.5l4-1.3 l3.2-0.5l6.3-0.2l1.9,1.3l1.6,0.2l2.1-1.3l2.6-1.1l5.2-0.5l2.1-1.8l1.8-3.2l1.6-1.9h2.1l1.9-1.1l0.2-2.3l-1.5-2.1l-0.3-1.5l1.1-2.1 v-1.5h-1.8l-1.8-0.8l-0.8-1.1l-0.2-2.6l5.8-5.5l0.6-0.8l1.5-2.9l2.9-4.5l2.7-3.7l2.1-2.4l2.4-1.8l3.1-1.2l5.5-1.3l3.2,0.2l4.5-1.5 l7.6-2.1l0.5,5l2.4,6.5l0.8,5.2l-1,3.9l2.6,4.5l0.8,2.1l-0.8,2.9l2.9,1.3l0.6,0.3l3.1,11l-0.5,5.1l-0.5,10.8l0.8,5.5l0.8,3.6 l1.5,7.3v8.1l-1.1,2.3l1.8,2l0.8,1.7l-1.9,1.8l0.3,1.3l1.3-0.3l1.5-1.3l2.3-2.6l1.1-0.6l1.6,0.6l2.3,0.2l7.9-3.9l2.9-2.7l1.3-1.5 l4.2,1.6l-3.4,3.6l-3.9,2.9l-7.1,5.3l-2.6,1l-5.8,1.9l-4,1.1l-1.2-0.5l-0.2-3.7l0.5-2.7l-0.2-2.1l-2.8-1.7l-4.5-1l-3.9-1.1 L828.9,189.3z"
}, {
  state_name: "Ohio",
  state_code: "OH",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M731.4,195l-6.1,4.1l-3.9,2.3l-3.4,3.7l-4,3.9l-3.2,0.8l-2.9,0.5l-5.5,2.6l-2.1,0.2l-3.4-3.1 l-5.2,0.6l-2.6-1.5l-2.4-1.4l-4.9,0.7l-10.2,1.6l-7.8,1.2l1.3,14.6l1.8,13.7l2.6,23.4l0.6,4.8l4.1-0.1l2.4-0.8l3.4,1.5l2.1,4.4 l5.1,0l1.9,2.1l1.8-0.1l2.5-1.3l2.5,0.4l2,1.5l1.7-2.1l2.3-1.3l2.1-0.7l0.6,2.7l1.8,1l3.5,2.3l2.2-0.1l1.1-1.1l-0.1-1.4l1.6-1.5 l0.2-5l1-3.9l1.5-1.4l1.5,0.9l0.8,1.2l1.2-0.2l-0.4-2.4l-0.6-0.6v-2.4l1-1.3l2.3-3.4l1.3-1.5l2.1,0.5l2.3-1.6l3.1-3.4l2.3-3.9 l0.2-5.4l0.5-5v-4.7l-1.1-3.1l1-1.5l0.9-1l-1.4-9.8L731.4,195z"
}, {
  state_name: "Oklahoma",
  state_code: "OK",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M375.3,322.6l-10.7-0.5l-6.4-0.5l0.3,0.2l-0.7,10.4l22,1.4l32.1,1.3l-2.3,24.4l-0.5,17.8l0.2,1.6 l4.3,3.7l2.1,1.1l0.7-0.2l0.7-2.1l1.4,1.8h2.1v-1.4l2.7,1.4l-0.5,3.9l4.1,0.2l2.5,1.1l4.1,0.7l2.5,1.8l2.3-2.1l3.4,0.7l2.5,3.4h0.9 v2.3l2.3,0.7l2.3-2.3l1.8,0.7h2.5l0.9,2.5l4.8,1.8l1.4-0.7l1.8-4.1h1.1l1.1,2.1l4.1,0.7l3.7,1.4l3,0.9l1.8-0.9l0.7-2.5h4.3l2.1,0.9 l2.7-2.1h1.1l0.7,1.6h4.1l1.6-2.1l1.8,0.5l2.1,2.5l3.2,1.8l3.2,0.9l1.9,1.1l-0.4-37.2l-1.4-11l-0.2-8.9l-1.4-6.5l-0.8-7.2l-0.1-3.8 l-12.1,0.3l-46.4-0.5l-45-2.1L375.3,322.6z"
}, {
  state_name: "Oregon",
  state_code: "OR",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M140.2,176.8l4.3-17.9l4.7-17.9l1.1-4.2l2.4-5.6l-0.6-1.2l-2.5,0l-1.3-1.7l0.5-1.5l0.5-3.2l4.5-5.5 l1.8-1.1l1.1-1.1l1.5-3.6l4-5.7l3.6-3.9l0.2-3.5l-3.3-2.5l-1.2-4.5l-13.2-3.7l-15.1-3.5l-15.4,0.1l-0.5-1.4l-5.5,2.1l-4.5-0.6 l-2.4-1.6l-1.3,0.7L99,84l-1.7-1.3l-5.3-2h-0.8l-4.3-1.4l-1.9,1.8l-6.2-0.3l-5.9-4.1l0.7-0.8l0.2-7.8l-2.3-3.9l-4.1-0.6 l-0.7-2.5l-2.4-0.5l-5.8,2.1l-2.3,6.5l-3.2,10l-3.2,6.5l-5,14.1l-6.5,13.6l-8.1,12.6l-1.9,2.9l-0.8,8.6l-1.3,6l2.7,3.5l6.7,2.3 l11.6,3.3l7.9,2.5l12.4,3.6l13.3,3.6l13.2,3.6"
}, {
  state_name: "Pennsylvania",
  state_code: "PA",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M822.2,226.3l1.1-0.6l2.3-0.6l1.5-2.7l1.6-2.3l3.2-3.1v-0.8l-2.4-1.6l-3.6-2.4l-1-2.6l-2.7-0.3 l-0.2-1.1l-0.8-2.7l2.3-1.1l0.2-2.4l-1.3-1.3l0.2-1.6l1.9-3.1v-3.1l2.3-2.4l0.2-1.1l-2.6-0.2l-2.3-1.9l-2.4-5.3l-3-0.9l-2.3-2.1 l-18.6,4l-43,8.7l-8.9,1.5l-0.5-7.1l-5.5,5.6l-1.3,0.5l-4.2,3l2.9,19.1l2.9,9.5l3.6,19.3l3.3-0.6l11.9-1.5l37.9-7.7l14.9-2.8 l8.3-1.6l0.3-0.2l2.1-1.6L822.2,226.3z"
}, {
  state_name: "Rhode Island",
  state_code: "RI",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M874.1,179.8l-0.5-4.2l-0.8-4.4l-1.7-5.9l5.7-1.5l1.6,1.1l3.4,4.4l2.9,4.4l-2.9,1.5l-1.3-0.2 l-1.1,1.8l-2.4,1.9L874.1,179.8z"
}, {
  state_name: "South Carolina",
  state_code: "SC",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M761.2,412.9l-1.8,1l-2.6-1.3l-0.6-2.1l-1.3-3.6l-2.3-2.1l-2.6-0.6l-1.6-4.8l-2.7-6l-4.2-1.9 l-2.1-1.9l-1.3-2.6L736,385l-2.3-1.3l-2.3-2.9l-3.1-2.3l-4.5-1.8l-0.5-1.5l-2.4-2.9l-0.5-1.5l-3.4-5.2l-3.4,0.2l-4-2.4l-1.3-1.3 l-0.3-1.8l0.8-1.9l2.3-1l-0.3-2.1l6.1-2.6l9.1-4.5l7.3-0.8l16.5-0.5l2.3,1.9l1.6,3.2l4.4-0.5l12.6-1.5l2.9,0.8l12.6,7.6l10.1,8.1 l-5.4,5.5l-2.6,6.1l-0.5,6.3l-1.6,0.8l-1.1,2.7l-2.4,0.6l-2.1,3.6l-2.7,2.7l-2.3,3.4l-1.6,0.8l-3.6,3.4l-2.9,0.2l1,3.2l-5,5.5 L761.2,412.9z"
}, {
  state_name: "South Dakota",
  state_code: "SD",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M472.8,203.2l-1-1.1l-1.5-3.6l1.8-3.7l1.1-5.6l-2.6-2.1l-0.3-2.7l0.6-3l2.2-0.8l0.3-5.7l-0.1-30.1 l-0.6-3l-4.1-3.6l-1-2v-1.9l1.9-1.3l1.5-1.9l0.2-2.7l-57.4-1.6l-56.2-3.9l-0.8,5.3l-1.6,15.9l-1.3,17.9l-1.6,24.6l16,1l19.6,1.1 l18,1.3l23.8,1.3l10.7-0.8l2.9,2.3l4.3,3l1,0.8l3.5-0.9l4-0.3l2.7-0.1l3.1,1.2l4.5,1.4l3.1,1.8l0.6,1.9l0.9,1.9l0.7-0.5 L472.8,203.2z"
}, {
  state_name: "Tennessee",
  state_code: "TN",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M697.1,320.6l-51.9,5l-15.8,1.8l-4.6,0.5l-3.9,0v3.9l-8.4,0.5l-7,0.6l-11.1,0.1l-0.3,5.8l-2.1,6.3 l-1,3l-1.3,4.4l-0.3,2.6l-4,2.3l1.5,3.6l-1,4.4l-1,0.8l7.3-0.2l24.1-1.9l5.3-0.2l8.1-0.5l27.8-2.6l10.2-0.8l8.4-1l8.4-1.1l4.8-0.8 l-0.1-4.5l1.8-1.5l2.7-0.6l0.6-3.7l4.2-2.7l3.9-1.5l4.2-3.6l4.4-2.1l0.9-3.5l4.3-3.9l0.6-0.2c0,0,0,1.1,0.8,1.1s1.9,0.3,1.9,0.3 l2.3-3.6l2.1-0.6l2.3,0.3l1.6-3.6l2.1-2.2l0.6-1l0.2-3.9l-1.5-0.3l-2.4,1.9l-7.9,0.2l-12,1.9L697.1,320.6z"
}, {
  state_name: "Texas",
  state_code: "TX",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M357.1,333.4l22.7,1.1l31.1,1.1l-2.3,23.5l-0.3,18.2l0.1,2.1l4.3,3.8l1.7,0.8l1.8,0.3l0.7-1.3 l0.9,0.9l1.7,0.5l1.6-0.7l1.1,0.4l-0.3,3.4l4.3,1l2.7,0.8l4,0.5l2.2,1.8l3.2-1.6l2.8,0.4l2,2.8l1.1,0.3l-0.2,2l3.1,1.2l2.8-1.8 l1.5,0.4l2.4,0.2l0.4,1.9l4.6,2l2.7-0.2l2-4.1h0.3l1.1,1.9l4.4,1l3.3,1.2l3.3,0.8l2.1-0.8l0.8-2.5h3.7l1.9,0.8l3.1-1.6h0.7l0.4,1.1 h4.3l2.4-1.3l1.7,0.3l1.4,1.9l2.9,1.7l3.5,1.1l2.7,1.4l2.4,1.6l3.3-0.9l1.9,1l0.5,10.1l0.3,9.7l0.7,9.5l0.5,4l2.7,4.6l1.1,4.1 l3.9,6.3l0.5,2.9l0.5,1l-0.7,7.5l-2.7,4.4l1,2.9l-0.4,2.5l-0.8,7.3l-1.4,2.7l0.6,4.4l-5.7,1.6l-9.9,4.5l-1,1.9l-2.6,1.9l-2.1,1.5 l-1.3,0.8l-5.7,5.3l-2.7,2.1l-5.3,3.2l-5.7,2.4l-6.3,3.4l-1.8,1.5l-5.8,3.6l-3.4,0.6l-3.9,5.5l-4,0.3l-1,1.9l2.3,1.9l-1.5,5.5 l-1.3,4.5l-1.1,3.9l-0.8,4.5l0.8,2.4l1.8,7l1,6.1l1.8,2.7l-1,1.5l-3.1,1.9l-5.7-3.9l-5.5-1.1l-1.3,0.5l-3.2-0.6l-4.2-3.1l-5.2-1.1 l-7.6-3.4l-2.1-3.9l-1.3-6.5l-3.2-1.9l-0.6-2.3l0.6-0.6l0.3-3.4l-1.3-0.6l-0.6-1l1.3-4.4l-1.6-2.3l-3.2-1.3l-3.4-4.4l-3.6-6.6 l-4.2-2.6l0.2-1.9l-5.3-12.3l-0.8-4.2l-1.8-1.9l-0.2-1.5l-6-5.3l-2.6-3.1v-1.1l-2.6-2.1l-6.8-1.1l-7.4-0.6l-3.1-2.3l-4.5,1.8 l-3.6,1.5l-2.3,3.2l-1,3.7l-4.4,6.1l-2.4,2.4l-2.6-1l-1.8-1.1l-1.9-0.6l-3.9-2.3v-0.6l-1.8-1.9l-5.2-2.1l-7.4-7.8l-2.3-4.7v-8.1 l-3.2-6.5l-0.5-2.7l-1.6-1l-1.1-2.1l-5-2.1l-1.3-1.6l-7.1-7.9l-1.3-3.2l-4.7-2.3l-1.5-4.4l-2.6-2.9l-1.9-0.5l-0.6-4.7l8,0.7l29,2.7 l29.3,1.6l2.3-23.8l3.9-55.6l1.6-18.7l1.4,0 M457.2,567.3l-0.6-7.1l-2.7-7.2l-0.6-7l1.5-8.2l3.3-6.9l3.5-5.4l3.2-3.6l0.6,0.2 l-4.8,6.6l-4.4,6.5l-2,6.6l-0.3,5.2l0.9,6.1l2.6,7.2l0.5,5.2l0.2,1.5L457.2,567.3z"
}, {
  state_name: "Utah",
  state_code: "UT",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M253,309.3l-24.6-3.5l-26.6-4.9l-33.8-6l1.6-9.2l3.2-15.2L176,254l2.2-13.6l1.9-8.9l3.8-20.5 l3.5-17.5l1.1-5.6l12.7,2.3l12,2.1l10.3,1.8l8.3,1.4l3.7,0.5l-1.5,10.6l-2.3,13.2l7.8,0.9l16.4,1.8l8.2,0.9l-2.1,22l-3.2,22.6 l-3.8,27.8l-1.7,11.1L253,309.3z"
}, {
  state_name: "Virginia",
  state_code: "VA",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M828.9,269.2l-0.1-1.9l6.5-2.5l-0.8,3.2l-2.9,3.8l-0.4,4.6l0.5,3.4l-1.8,5l-2.2,1.9l-1.5-4.6 l0.4-5.4l1.6-4.2L828.9,269.2z M831.2,297.5L773,310.1l-37.4,5.3l-6.7-0.4l-2.6,1.9l-7.3,0.2l-8.4,1l-8.9,1l8.5-4.9l0-2.1 l1.5-2.1l10.6-11.5l3.9,4.5l3.8,1l2.5-1.1l2.2-1.3l2.5,1.3l3.9-1.4l1.9-4.6l2.6,0.5l2.9-2.1l1.8,0.5l2.8-3.7l0.3-2.1l-1-1.3l1-1.9 l5.3-12.3l0.6-5.7l1.2-0.5l2.2,2.4l3.9-0.3l1.9-7.6l2.8-0.6l1-2.7l2.6-2.3l1.3-2.3l1.5-3.4l0.1-5.1l9.8,3.8 c0.7,0.3,0.7-4.8,0.7-4.8l4.1,1.4l-0.5,2.6l8.2,2.9l1.3,1.8l-0.9,3.7l-1.3,1.3l-0.5,1.7l0.5,2.4l2,1.3l3.9,1.4l2.9,1l4.9,0.9 l2.2,2.1l3.2,0.4l0.9,1.2l-0.4,4.7l1.4,1.1l-0.5,1.9l1.2,0.8l-0.2,1.4l-2.7-0.1l0.1,1.6l2.3,1.5l0.1,1.4l1.8,1.8l0.5,2.5l-2.6,1.4 l1.6,1.5l5.8-1.7L831.2,297.5z"
}, {
  state_name: "Vermont",
  state_code: "VT",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M844.3,153.7l-0.8-5.7l-2.4-10l-0.6-0.3l-2.9-1.3l0.8-2.9l-0.8-2.1l-2.7-4.6l1-3.9l-0.8-5.2 l-2.4-6.5l-0.8-4.9l26.2-6.7l0.3,5.8l1.9,2.7v4l-3.7,4l-2.6,1.1v1.1l1.1,1.8v8.6l-0.8,9.2l-0.2,4.8l1,1.3l-0.2,4.5l-0.5,1.8 l0.7,1.6l-7,1.4L844.3,153.7z"
}, {
  state_name: "Washington",
  state_code: "WA",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M93.6,6.4l4.4,1.5l9.7,2.7l8.6,1.9l20,5.7l23,5.7l15.2,3.4l-1,3.9l-4.1,13.8l-4.5,20.8 l-3.2,16.1l-0.4,9.4l-13.2-3.9l-15.6-3.4l-13.7,0.6l-1.6-1.5l-5.3,1.9l-4-0.3l-2.7-1.8l-1.6,0.5l-4.2-0.2l-1.9-1.4l-4.8-1.7 l-1.4-0.2l-5-1.3l-1.8,1.5l-5.7-0.3l-4.8-3.8l0.2-0.8l0.1-7.9l-2.1-3.9l-4.1-0.7l-0.4-2.4l-2.5-0.6l-2.9-0.5l-1.8,1l-2.3-2.9 l0.3-2.9l2.7-0.3l1.6-4l-2.6-1.1l0.2-3.7l4.4-0.6l-2.7-2.7l-1.5-7.1l0.6-2.9v-7.9l-1.8-3.2l2.3-9.4l2.1,0.5l2.4,2.9l2.7,2.6 l3.2,1.9l4.5,2.1l3.1,0.6l2.9,1.5l3.4,1l2.3-0.2v-2.4l1.3-1.1l2.1-1.3l0.3,1.1l0.3,1.8l-2.3,0.5l-0.3,2.1l1.8,1.5l1.1,2.4l0.6,1.9 l1.5-0.2l0.2-1.3l-1-1.3l-0.5-3.2l0.8-1.8l-0.6-1.5V19l1.8-3.6l-1.1-2.6l-2.4-4.8l0.3-0.8L93.6,6.4z M84.1,12.3l2-0.2 l0.5,1.4l1.5-1.6h2.3l0.8,1.5l-1.5,1.7l0.6,0.8l-0.7,2l-1.4,0.4c0,0-0.9,0.1-0.9-0.2s1.5-2.6,1.5-2.6l-1.7-0.6l-0.3,1.5l-0.7,0.6 l-1.5-2.3L84.1,12.3z"
}, {
  state_name: "Wisconsin",
  state_code: "WI",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M612.9,197.2l0.4-3l-1.6-4.5l-0.6-6.1l-1.1-2.4l1-3.1l0.8-2.9l1.5-2.6l-0.6-3.4l-0.6-3.6l0.5-1.8 l1.9-2.4l0.2-2.7l-0.8-1.3l0.6-2.6l0.5-3.2l2.7-5.7l2.9-6.8l0.2-2.3l-0.3-1l-0.8,0.5l-4.2,6.3l-2.7,4l-1.9,1.8l-0.8,2.3l-1.5,0.8 l-1.1,1.9l-1.5-0.3l-0.2-1.8l1.3-2.4l2.1-4.7l1.8-1.6l1.1-2.3l-1.6-0.9l-1.4-1.4l-1.6-10.3l-3.7-1.1l-1.4-2.3l-12.6-2.7l-2.5-1.1 l-8.2-2.3l-8.2-1.1l-4.2-5.4l-0.5,1.3l-1.1-0.2l-0.6-1.1l-2.7-0.8l-1.1,0.2l-1.8,1l-1-0.6l0.6-1.9l1.9-3.1l1.1-1.1l-1.9-1.5 l-2.1,0.8l-2.9,1.9l-7.4,3.2l-2.9,0.6l-2.9-0.5l-1-0.9l-2.1,2.8l-0.2,2.7v8.5l-1.1,1.6l-5.3,3.9l-2.3,5.9l0.5,0.2l2.5,2.1l0.7,3.2 l-1.8,3.2v3.9l0.5,6.6l3,3h3.4l1.8,3.2l3.4,0.5l3.9,5.7l7.1,4.1l2.1,2.7l0.9,7.4l0.7,3.3l2.3,1.6l0.2,1.4l-2.1,3.4l0.2,3.2l2.5,3.9 l2.5,1.1l3,0.5l1.3,1.4l9.2,0l26.1-1.5L612.9,197.2z"
}, {
  state_name: "West Virginia",
  state_code: "WV",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M756.4,242.2l1.1,4.9l1.1,6.9l3.6-2.7l2.3-3.1l2.5-0.6l1.5-1.5l1.8-2.6l1.2,0.6l2.9-0.3l2.6-2.1 l2-1.5l1.8-0.5l1.3,1l2.2,1.1l1.9,1.8l1.4,1.3l-0.1,4.7l-5.7-3.1l-4.5-1.8l-0.2,5.3l-0.5,2.1l-1.6,2.7l-0.6,1.6l-3.1,2.4l-0.5,2.3 l-3.4,0.3l-0.3,3.1l-1.1,5.5h-2.6l-1.3-0.8l-1.6-2.7l-1.8,0.2l-0.3,4.4l-2.1,6.6l-5,10.8l0.8,1.3l-0.2,2.7l-2.1,1.9l-1.5-0.3 l-3.2,2.4l-2.6-1l-1.8,4.7c0,0-3.7,0.8-4.4,1c-0.6,0.2-2.4-1.3-2.4-1.3l-2.4,2.3l-2.6,0.6l-2.9-0.8l-1.3-1.3l-2.2-3l-3.1-2 l-2.6-2.7l-2.9-3.7l-0.6-2.3l-2.6-1.5l-0.8-1.6l-0.2-5.3l2.2-0.1l1.9-0.8l0.2-2.7l1.6-1.5l0.2-5l1-3.9l1.3-0.6l1.3,1.1l0.5,1.8 l1.8-1l0.5-1.6l-1.1-1.8v-2.4l1-1.3l2.3-3.4l1.3-1.5l2.1,0.5l2.3-1.6l3.1-3.4l2.3-3.9l0.3-5.7l0.5-5v-4.7l-1.1-3.1l1-1.5l1.3-1.3 l3.5,19.8l4.6-0.8L756.4,242.2z"
}, {
  state_name: "Wyoming",
  state_code: "WY",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M354.3,143.8l-10.5-0.8l-32.1-3.3l-16.2-2.1l-28.3-4.1l-19.9-3l-1.4,11.2l-3.8,24.3l-5.3,30.4 l-1.5,10.5l-1.7,11.9l6.5,0.9l25.9,2.5l20.6,2.3l36.8,4.1l23.8,2.9l4.5-44.2l1.4-25.4L354.3,143.8z"
}];
var nl_states = [{
  state_name: "Drenthe",
  state_code: "NLD894",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M467.85,123.65L472.18,125.25L474.19,119.96L475.36,119.6L475.73,116.23L478.15,109.81L478.42,108.02L479.4,107.05L480.47,105.28L481.09,105.07L481.8,104.33L482.02,102.31L482.29,101.78L483.84,101.12L486.03,99.65L486.2,99.33L487.32,99.04L488.72,97.7L488.81,96.77L491.49,96.25L494.16,95.38L495.58,95.4L496.91,95.06L501.2,96.93L502.31,96.99L503.37,99.04L503.31,99.57L503.91,99.59L506.25,103.68L507.39,106.86L509.4,105.99L509.78,106.05L510.47,107.23L510.47,108.23L510.96,110.15L512.28,110.15L514.32,111.94L515.11,112.99L515.82,113.26L516.88,116.18L517.58,116.73L517.94,117.97L518.62,118.31L518.66,120.12L525.19,117.15L527.91,116.41L534.48,116.76L535.73,117.6L536.52,118.73L543.33,125.72L546.46,129.32L548.96,131.66L557.98,141.95L565.51,149.53L570.02,155.75L578.22,168.14L578.41,168.09L579.75,169.47L583.09,170.36L578.6,181.27L582.36,181.67L582.85,183.52L583.44,183.47L585.78,186.9L586.19,187.05L586.81,187.94L587.24,188.07L587.88,187.71L588.06,187.81L587.66,189.04L587.52,190.53L590.7,190.37L590.7,190.37L587.39,197.87L587.41,200.82L584.61,240.77L584.74,241.37L582.54,243.97L581.57,243.37L580.4,243.42L577.84,242.8L577.04,242.25L576.62,241.63L574.7,241.76L573.23,240.77L572,240.38L570.91,241.53L569.66,241.4L568.61,242.46L567.41,242.31L565.94,242.72L564.7,242.18L564.39,241.81L562.99,241.84L562.54,240.25L560.83,239.76L560.41,239.83L559.61,239.24L557.11,239.5L555.98,238.56L554.29,239.6L553.02,239.55L552.49,239.78L550.14,238.9L549.5,239.05L547.87,240.04L545.49,239.65L544.99,239.08L543.36,239.26L542.83,238.79L541.98,238.74L540.79,238.98L539.89,239.47L539.37,240.3L537.93,239.78L537.06,240.43L536.73,239.96L535.33,240.56L533.18,242.85L532.55,243.81L531.06,244.54L530.46,245.61L530.46,245.61L528.64,245.5L529.21,243.89L528.89,243.35L529.91,242.23L529.68,241.71L529.35,241.6L530.16,239.76L524.76,237.88L515.13,233.3L505.03,235.57L503.73,236.3L499,240.2L498.89,240.69L499.24,243.71L499.73,245.17L500.17,249.53L499.94,249.98L499.57,249.98L499.49,249.43L499.13,249.4L498.86,248.75L498.15,248.7L497.72,247.9L496.72,247.9L495.77,247.48L494.76,247.43L494.43,247.71L493.23,247.58L493.05,247.17L492.39,246.91L492.42,246.26L491.72,245.89L491.11,247.82L490.6,248.36L488.86,248.88L487.93,248.73L486.98,248.13L486.45,247.45L486.5,246.44L486.07,246.02L485.9,245.43L485.46,246.23L484.51,246.93L484.4,247.53L483.94,247.9L482.51,247.17L482.01,248.08L480.5,248.03L480.11,248.7L478.68,249.46L478.46,249.4L478.32,248.68L477.92,248.68L477.34,247.9L477.26,247.06L476.79,246.26L476.94,245.19L476.26,244.23L476,242.96L475,241.71L475.16,241.37L474.46,240.85L473.97,240.9L473.65,240.56L473.56,240.02L472.12,239.16L471.72,238.64L470.49,238.2L469.32,237.15L469.27,235.98L469.7,235.46L469.16,234.53L468.21,234.58L466.25,235.51L465.04,235.59L464.47,236.43L463.94,236.5L463.48,236.24L462.51,234.92L461.93,234.84L461.23,235.72L460.8,235.8L460,235.28L459.46,234.55L458.33,234.47L457.4,233.77L456.56,232.36L456.56,232.36L455.69,232.44L455.69,232.44L454.49,231.84L454.32,231.48L453.87,231.64L452.45,230.83L452.28,230.15L451.02,230.62L450.17,230.65L449.32,231.82L447.29,231.58L446.91,231.14L445.69,231.64L444.93,230.07L444.41,229.58L444.21,229.71L443.67,229.37L442.69,228.07L441.88,225.26L440.09,221.35L436.89,213.11L437.61,211.86L437.95,211.62L441.59,210.74L444.66,209.2L444.85,207.94L450.01,202.23L448.98,201.19L445.98,197.06L444.85,196.43L439.24,189.9L438.45,188.86L438.1,187.84L436.89,186.27L436.89,186.27L443.56,181.12L450.2,176.85L454.41,170.99L456.42,169.4L457.15,167.98L458.3,167.25L459.3,167.17L465.8,167.8L470.77,172.9L480.14,166.2L485.66,155.75L475.31,139.67L476,130.74L466.56,127.17z"
}, {
  state_name: "Friesland",
  state_code: "NLD895",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M349.56,192.59l0.1,0.34l-0.33,0.03l-1.41,-0.55l0.22,-0.24h0.92L349.56,192.59zM343.09,191.42l-0.7,-0.31l0.17,-0.13l0.52,0.18V191.42zM323.85,160.39l-0.22,-0.26l0.16,-0.52l0.27,0.31L323.85,160.39zM322.47,149.9l-0.3,-0.87l0.13,-0.18l0.3,0.89L322.47,149.9zM317.98,128.19l0.41,0.76l0.59,0.24l0.71,-0.18l0.84,0.87l0.35,1.55l1.03,2l-3.05,-0.21l-0.33,-0.95l-1.04,-1.5l-0.35,-2.34l0.09,-0.21L317.98,128.19zM312.42,128.35l0.21,0.76l-0.14,0.34l-0.55,-0.18l-0.65,0.39l-0.44,-0.13l-4.1,1.18l-12.99,11.45l-0.08,0.68l-0.74,0.6l-0.36,-0.26l-0.55,0.45l0.73,0.29l0.57,-0.45l0.11,0.13l-0.6,0.5l-0.98,-0.29l-5.62,4.88l0,0l-0.65,-0.87l0,0l5.51,-4.83l-0.09,-0.58l0.73,-0.39l-0.59,0.5l0.1,0.34l14.79,-13.05l0.67,-0.37l4.02,-1.1l0.1,-0.18l0.51,0.31l0.6,-0.16l0.14,-0.24L312.42,128.35zM270.93,66.85l4.19,0.79l0.22,0.13l0.19,1.19l-0.73,0.45l-0.49,0.69l-0.71,-0.32l0.3,0.55l-0.66,-0.26l-1.25,-0.05l-2.36,0.66l-1.22,1.24l-1.95,1.35l-2.63,1.21l-5.84,2.06l-2.83,1.4l-0.28,0.63l1.03,2.48l-0.3,0.37l-0.9,0.16l-0.27,0.34l-0.08,1.4l0.43,0.18l-0.3,0.98l-3.86,1.58l-2.15,2.32l-0.97,0.47l-2.14,-0.18l-1.34,0.24l-2.9,1.58l-0.79,0.05l-0.52,-0.42l-0.78,-1.48l0.02,-0.76l8.96,-5.67l1.36,-1.21l3.35,-3.93l2.41,-1.95l9.3,-6.34l2.15,-0.61l3.15,-1.32H270.93zM282.06,71.45l-0.51,0.74l-0.66,0.11l-0.84,1.08l-0.36,0.13l-0.71,-0.34l-0.89,0.16l0.02,-0.53l0.57,-0.05l0.33,-0.4l-0.41,-0.74l-0.68,-0.21l1.5,-1.48l0.16,-0.4l1.46,-1.06l0.92,-1.19l0.54,-0.34l0.95,-0.05l0.47,0.95l-0.11,0.79l-0.87,1.72L282.06,71.45zM289.65,44.22l-0.1,-0.21l0.36,-0.42L289.65,44.22zM448.11,39.72l-3.69,5.38l0.13,3.36l0.81,2.38l0.54,0.85l1.14,0.95l5.22,1.43l0.68,0.37l0.59,0.9l0.44,1.67l0.7,0.85l1.11,-0.13l1.85,-1.3l2.63,0.63l2.9,1.27l-0.84,7.32l0.06,0.24l1.49,0.34l0.41,0.63l-0.93,1.08l-1.38,0.5l-0.49,0.79l-0.08,0.92l-0.47,0.55l-0.19,1.11l-0.24,0.19l-1.23,-0.37l-1.17,0.69l-0.28,3.04l0.54,1.56l-0.08,0.92h-0.44l-0.38,0.4l-0.41,-0.53l-0.3,0.03l-0.41,0.84l-0.68,0.61l0.08,0.74l-0.27,0.55l-0.96,0.37l0.46,0.66l-0.1,0.4l-0.71,0.58l0.22,0.74l-0.06,1.29l-2.74,0.45l0.44,1.66l1.3,1.03l0.25,1.27l0.68,0.92L454,91.03l-0.51,0.58l-0.24,0.98l-0.74,1.24l-1.03,0.84l-0.57,0.9l-0.95,0.11l-0.47,0.32l-0.22,1.4l-1.04,1l-0.25,0.84l-2.03,3.74l-0.44,2.77l-0.25,6.66l2.83,3.53l1.99,1.76l5.21,0.79l4.37,-0.18l2.31,1.24l1.16,1.13l0.93,1.47l3.8,1.52l0,0l-1.28,3.52l9.43,3.57l-0.68,8.93l10.35,16.08l-5.52,10.45l-9.37,6.7l-4.97,-5.1l-6.5,-0.63l-1,0.08l-1.16,0.73l-0.73,1.41l-2.01,1.6l-4.21,5.86l-6.65,4.26l-6.66,5.15l0,0l-1.95,1.65l-1.92,1.23l-0.85,0.08l-0.79,0.44l-0.6,0.63l-0.71,0.13l-2.06,-0.24l-1.79,0.73l0.52,2.61l-0.32,0.57l-2.39,1.46l-1.34,0.55l-0.71,-1.44l-1.8,0.24l-1.31,0.44l-0.49,0.42l-0.52,0.03l-0.68,-0.13l-0.81,-0.73l-0.6,-0.13l-0.74,-2.01l-0.92,-1.36l-0.49,-2.01l-2.14,0.47l-0.7,0.47l-0.19,0.39l0.17,0.99l-1.47,-0.6l-0.76,0.31l-1.65,0.21l-0.06,0.55l-0.65,0.31l0.24,0.44l-0.19,0.29l-0.03,1.31l-1.42,0.94l-0.81,1.23l-1.38,0.86l-0.6,0.94l-3.31,1.57l-0.76,-0.08l-1.46,-0.78l-0.74,0.03l-0.57,-0.34l-1.49,0.05l-0.85,-0.44l-0.62,0.57h-0.38l-0.35,-1.07l-1.93,-1.1l-0.24,-0.39l-3.78,2.64l0,0l-0.59,0.34l-0.98,-3.79l-5.73,-5.8l-3.17,-0.97l0.98,2.95l-1.08,0.44l-1.25,-1.23l-1.58,-0.31l0,0l0.11,-1.12l-0.4,0.44h-0.3l-0.27,-0.34l-0.49,0.47l-0.38,-0.39l0.06,-0.78l-0.38,-0.31l-2.07,-0.31l-1.92,0.1l0.32,-0.91l-0.21,-0.08l-0.35,1.05l-0.54,0.1l-0.03,0.55l-0.51,-0.42l-1.17,0.13l-0.09,-0.34l-0.63,-0.5l0.38,-0.31l-0.08,-1.78l-1.77,-1.31l-1.03,0.26l-3.2,2.2l-2.21,-0.31l-2.83,0.65l-0.38,0.71l-0.33,1.7l-0.35,0.37l-1.88,1.1l-2.26,0.47l-0.78,-0.1l-3.51,-1.36l-6.55,-3.03l-4.02,-1.2l-1.04,-0.08l-0.49,0.24l-0.11,0.6l-1.52,0.13l-2.26,0.76l-1.41,-0.5l-2.94,-1.7l-2.42,-2.61l-2.04,-1.49l-0.81,-0.94l0.25,-0.5l-0.11,-0.26l-0.74,-0.13l-1.09,-1.8l0.74,-0.65l0.47,-0.94l1.57,-1.81l2.25,-1.02l0.65,-0.65l1.63,-0.45l0.87,-1.23l0.16,-2.67l-0.32,-0.55l-0.52,-3.59l-0.87,-1.05l0.84,-0.73l0.54,0.16l0.41,-0.29l-0.08,-0.24l-0.58,0.05l0.06,-0.24l0.62,-0.05l0.24,0.31l0.22,-0.24l-0.02,-1.83l0.14,-0.18l0.32,0.34l-0.02,-0.29l-0.49,-0.73l-0.06,-0.65l-0.51,0.18l-0.25,-0.16l1.17,-0.29l0.16,-1.21l-0.85,-3.17l-0.33,-0.37l-0.3,-1.13l0.08,-0.55l-0.32,-0.18l-0.22,-1.39l0.06,-2.57l-0.41,-0.47l1.38,-2.33l-0.33,-0.52l0.38,-2.18l-0.4,0.13l-1,-0.52l0.19,-1.18l-0.44,-0.26l0.16,-0.29h0.57l0.11,-1.1l0.21,0.37l0.22,-0.05l-0.49,-1.44l0.28,-2.49l-0.47,1.76l-0.08,2.05l-0.6,0.42l-0.41,-0.45l-0.06,-0.89L321,137.2l-0.44,-0.71l-1.11,-1l-0.25,-1.55l0.22,-0.21h1l0.19,0.68l0.63,0.03v-0.68l0.67,-0.05l0.49,0.79l0.73,-0.1l-0.74,-1.76l-0.57,-0.66l-0.46,-1.02l-0.3,-1.18l0.22,-0.89l-0.22,-1.05l-1.44,-3.13l-0.27,-0.13l-0.59,0.13l-3.97,3.73l-1.11,0.53l-0.27,0.5l-0.47,-0.05l-0.44,-1.47l0.21,-0.24l0.33,0.21l0.92,-0.29l0.62,-0.42l4.42,-4.28l0.3,-0.42l0.44,-2.13l-0.33,-0.58l0.09,-0.32l2.56,-1.55l1.35,-1.76l0.9,-3.24l0.44,-5.9l0.49,-2.21l-0.05,-1.11l-0.85,-0.47l-0.21,-0.58l0.57,-0.58l0.19,-0.55l1.14,-0.63l0.19,-0.66l-0.24,-0.16l1.27,-3.87l0.74,-1.37l0.63,-1.9l1.61,-2.58l2.37,-2.11l3.12,-3.53l1.3,-0.53l1.87,-1.45l1.9,-1.08l0.36,-0.45l1.71,-0.95l1.55,-1.9l2.86,-2.64l0.96,-2.69l4.4,-4.44l4.46,-2.3l1.96,-0.42l5.95,-2.25l1.47,-0.29l1.42,-0.71l1.06,-0.05l1.71,-1.24l9.89,-5.79l3.66,-1.43l1.49,-0.87l0.67,-0.13l0.43,-0.45l2.31,-0.61l1.82,-1.27l3.42,-1.9l2.41,-0.79l0.9,-0.98l1.69,-0.48l0.71,-0.45l-1.71,-2.46l0.11,-0.24l0.44,0.61l0.35,-0.37l0.3,0.66l-0.22,0.34l0.9,1.27l1.28,0.21l0.98,-0.56l2.29,0.32l4.56,-1.35l1.88,-0.85l1.93,-0.26l0.24,-0.5l0.43,0.45l2.36,-0.42l4.21,-1.35l4.26,-0.34l4.1,-0.74l2.55,0.69l0.28,-0.69l0.32,0.69l0.67,-1.03l0.32,0.48l1.46,0.05l5.17,0.93l6.28,-2.97l1.06,-0.08L448.11,39.72zM342.85,30.28l-1.84,0.16l-0.17,0.32l0.27,0.32l4.22,-0.58l0.63,0.08l0.36,0.72l-0.47,1.83l-2.44,1.4l-0.74,0.21l-1.11,0.24l-0.3,-0.13l0.14,-0.21l-0.17,-0.13l-0.27,0.21l-0.36,-0.11l-1.85,1.43l-2.77,1.43l-1.47,-0.21l-0.84,-0.77l-0.11,0.66l0.41,0.72l-0.02,0.87l-1.54,-0.37l-1.27,-0.93l-0.87,-0.16l-0.11,0.34l0.19,0.21l1.95,1.38l2.45,0.93l-0.3,0.37l-0.47,-0.34l-0.43,0.13l-0.35,0.4l0.3,0.26l-0.44,0.29l-1.49,0.34l-6.54,-0.21l-2.09,0.13l-2.47,0.64l-1.3,0.58l-2.98,3.04l-1.85,1.24l-1.08,0.42l-0.79,0.05l-1.42,1.03l-1.87,-0.69l-0.38,0.74l-1.01,0.5L307,49.06l-0.46,0.64l-0.14,0.63l-1.42,-0.16l-1.47,-0.56l-1.58,0.56l-1.38,-0.42l-2.47,2.17l-0.11,-0.26l-0.63,-0.29l-2.61,0.32l-0.66,0.9l0.08,1.27l-0.22,0.19l0.24,0.45l-0.55,0.08l-0.6,-0.48h-0.65l-0.25,0.4l-0.78,0.42l-0.9,1.22l-0.82,0.4l-0.7,0.87l-1.87,-0.45l-2.44,-1.56l-0.22,-0.37l-0.44,-2.2v-1.08l0.89,-1.11l2.52,-2.22l1.57,-2.33l0.62,-1.56h0.19l-0.17,0.79l0.27,-0.03l0.17,-1.01l0.68,-0.79l-0.08,-0.19L290,43.37l0.46,-0.32l16.84,-3.15l3.04,-0.74l0.43,0.37l0.82,-0.11l15.4,-5.01l0.74,-0.74l3.09,-0.87l9.56,-3.84l3.12,-0.58l1.66,0.03l0.78,0.16l0.27,0.34l-0.03,0.58l-0.3,0.37L342.85,30.28zM427.56,26.92l0.27,2.12l-0.4,-0.69l-0.47,0.61l-1.19,0.58l-0.51,0.66l-0.87,-0.42l-0.33,-1.48l0.92,-1.35l1.23,0.11l1.23,-0.29L427.56,26.92zM374.01,26.86l8.47,-0.34l10.68,-1.22l2.26,0.4l11.24,-0.58l5.87,0.24l1.08,0.19l0.67,0.66l-0.32,0.64l-0.59,0.32l-1.6,0.34l-3.72,-0.13l-1.38,0.21l-3.35,-0.29l-2.22,1.03l-0.74,0.61l-2.52,0.64l-0.49,-0.05l-1.31,0.64l-4.38,0.95l-0.25,0.27l-4.38,1.22l-2.93,-0.16l-1.55,0.27l-0.16,-0.13l-0.09,0.93l-0.32,0.34l-0.35,-0.19l0.28,-0.21l0.05,-1.3l-3.13,-0.19l-2.94,-0.74l-1.6,0.11l-0.58,0.4l-0.51,1.22l-2.21,1.7l-2.39,0.72l-1.33,0.72l-1.99,0.11l-0.03,0.87l-0.46,0.37l-0.92,-0.27l-2.29,-1.54l-2.23,-1.03l-1.17,-1.33l-1.42,-2.28l-0.05,-1.59l0.68,-3.34l0.68,-1.14l0.76,-0.61l0.95,-0.34l1.52,-0.03l3.37,1.35l5.55,1.3L374.01,26.86zM441.64,13.81l1.42,0.27l1.55,1.46l2.15,0.37l2.36,0.11l11.58,-1.59l6.44,-0.61l5.78,-0.24l0.29,0.45l-0.25,0.66l-2.52,1.3l-1.5,0.64l-1.66,0.29l-3.58,1.72l-1.93,0.35l-1.06,1.33l-3.96,1.86l-1.04,0.24l-3.13,0.08l-3.64,0.82l0.81,0.98l-0.06,0.27l-0.78,-0.48l-0.35,-0.64h-4.23l0.02,1.03l-0.33,0.03l-0.16,-1.01l-1.08,0.21l-0.3,0.69l-0.41,0.19l0.41,0.56l-1.35,-0.19l-0.43,0.34l0.43,0.61l-0.3,0.24l-0.06,0.45l0.51,0.72l-0.95,0.19l-1.42,-0.53l-0.84,0.08l-1.12,1.51l-0.52,0.08l-0.63,-0.27l-0.05,-0.21l0.4,-1.14l0.27,-2.2l0.52,-1.8l1.14,-2.23l1.42,-2.07l3.09,-2.76l0.79,-0.32l-0.24,-0.37l-5.95,-1.38l-1.17,2.97l-0.7,0.05l-0.33,-0.21l0.11,-0.96l1.09,-2.52h1.95L441.64,13.81z"
}, {
  state_name: "Gelderland",
  state_code: "NLD896",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M396.24,273.37L398.39,272.57L400.85,274.75L402.95,277.37L404.06,279.26L405.71,282.76L406.21,284.37L407.41,283.82L408.03,284.39L410.04,282.89L410.97,282.66L412.34,284.63L419.23,277.5L420.94,276.9L421.61,276.36L422.05,275.58L423.03,276.12L423.65,276.2L426.69,278.59L427.7,281.05L428.51,282.27L429.77,283.3L432.16,284.37L433.51,286L433.94,287.27L434.13,290.09L433.97,292.53L434.58,293.33L435.83,294.26L438.18,297.73L439.08,300.32L439.17,301.28L438.29,304.69L437.59,306.09L437.54,308.52L437.2,309.24L436.78,309.71L433.89,310.82L430.75,311.42L430.12,312.29L430.09,313.22L430.38,313.82L430.74,314.13L432,314.41L432.5,314.83L432.72,315.37L431.85,316.09L430.25,316.58L429.85,317.26L430.06,319.87L429.84,322.4L429.58,324.23L428.95,325.01L428.93,325.52L430.5,325.73L431.04,326.92L431.13,329.73L432.19,330.07L433.84,330.09L434.17,330.69L434.62,332.13L435.44,333.29L435.57,335.79L437.08,337.65L437.53,339.61L438.41,340.39L437.5,341.7L437.5,342.71L439.3,343.12L440.19,343.76L442.15,343.58L442.23,344.1L441.96,345L440.85,345.72L440.52,346.57L440.95,348.22L442.02,349L443.37,349.33L443.79,350.08L443.75,350.9L444.09,351.21L444.38,350.9L444.41,350.44L443.84,349.77L443.54,348.92L444.16,349.18L444.28,348.94L443.95,348.69L444.32,348.02L445.04,348.79L445.19,347.27L445.41,346.37L445.63,346.26L446.34,346.34L446.99,346.06L448.02,346.37L449.76,346.29L452.07,348.02L454.51,348.35L455.6,348.76L456.69,348.74L457.12,349.07L459.21,348.89L460.74,349.33L460.82,348.58L461.86,348.94L462.23,348.43L464.06,347.94L464.19,348.35L464.67,348.45L464.78,348.89L465.27,349.33L468.54,349.36L469.81,349L471.2,348.94L471.29,346.75L472.34,346.06L472.97,345.95L473.29,345.26L476.28,345.08L478.04,344.33L478.94,344.77L480.98,344.64L483.56,344.95L483.51,346.24L484.62,347.81L485.27,349.67L488.46,353.01L489.76,355.64L490.7,356L491.74,356.05L492.06,356.36L492.13,357.78L493,359.74L493.53,360.43L495.06,361.18L495.58,361.69L496.12,361.87L499.14,360.79L505.43,361.82L511.12,360.66L511.23,360.4L511.71,360.69L511.76,361.1L512.74,361.51L513.05,362.13L513.75,362.62L513.24,363.67L513.35,364.09L514.68,365.32L516.01,364.32L516.68,364.09L516.95,363.26L517.33,362.95L518.17,363.21L518.94,364.29L519.72,362.93L520.38,362.98L523.64,364.7L524.08,365.11L524.37,365.96L524.34,366.58L523.83,367.33L524.27,367.56L524.24,368.97L524.45,369.69L524.24,371.34L522.56,374.04L524.89,375.12L528.34,375.76L531.05,377.02L538.18,376.97L538.18,376.97L537.5,382.29L536.95,383.16L536.81,382.8L536.41,382.65L535.49,383.52L535.63,384.19L536.38,384.91L536.41,385.63L534.45,388.07L527.72,389.2L528.07,389.87L527.98,390.64L526.98,392.72L526.44,392.95L526.38,393.95L526.62,394.23L526.6,397.23L530.92,397.23L537.07,400.18L538.61,401.54L539.13,402.6L540.21,403.03L545.59,407.44L545.6,408.39L545.89,408.72L548.75,409.16L549.26,410.8L549.1,412.59L549.62,414.64L549.32,415.75L548.86,416.56L546.76,416.64L545.98,417.38L544.32,417.97L543.88,421.25L543.91,423.43L542.25,425.12L542.61,425.53L540.1,428.6L537.2,429.8L537.17,430.7L536.85,431.03L534.51,431.85L533.75,433.25L532.26,433.97L529.64,431.9L529.13,431.34L529.02,430.34L528.63,430.54L528.31,430.41L527.75,429.03L526.96,429.01L526.2,428.55L525.43,428.78L519.13,431.77L518.12,432.82L517.56,432.87L516.77,432.59L509.45,435.04L507.55,436.35L506.38,437.47L505.92,437.5L505.22,436.55L504.02,437.04L502.85,438.29L501.28,439.31L499.48,440.06L497.99,441.1L497.53,441.54L497.5,442.28L496.83,443.23L493.62,444.09L492.26,444.89L491.41,444.58L489.81,442.43L489.11,441.84L488.26,442.54L486.31,443.51L485.81,443.1L485.52,441.67L483.81,441.1L483.4,440.49L480.79,440.26L479.98,439.52L479.63,439.67L479.76,440.34L479.14,442.08L479.25,442.43L481.68,444.38L482.85,444.68L482.93,445.09L481.72,446.78L481.71,447.75L482.42,449.23L482.34,449.41L481.74,449.25L482.26,451.02L482.12,451.43L481.61,451.6L478.95,449.84L476.49,449.77L475.49,449.31L475.71,448.62L475.11,447.11L473.97,446.09L469.25,445.47L466.33,445.75L465.52,442.1L465.11,441.84L465.3,441.08L463.6,440.26L462.81,440.16L462.26,439.62L461.06,439.44L460.36,439.72L459.67,440.64L458.4,441.03L455.83,440.98L455.14,440.75L452.24,441.1L451.48,440.92L449.52,439.77L447.31,437.5L447.2,436.48L448.41,436.25L448.02,435.79L448.07,435.25L444.68,432.67L444.47,433.15L442.59,431.97L438.98,432.59L437.91,433.41L436.74,432.49L436.17,433.61L435.66,433.31L435.34,433.61L435.41,434.28L434.62,434.92L437.07,434.97L438.75,436.17L439.85,436.68L440.72,439.11L440.82,440.52L443.9,443L443.84,444.53L444.19,448.05L440.8,446.83L438.43,446.32L435.71,446.42L433.67,445.96L432.37,445.32L429.88,443.1L428.08,441.97L427.21,443.58L426.18,444.02L426.55,444.86L426.4,445.42L424.52,446.47L423.19,447.7L422.67,447.16L420.8,447.85L419.99,449.46L418.13,450.4L415.83,450.66L414.35,450.1L413.14,450L411.83,449.18L409.27,452.35L411.37,453.98L410.86,454.64L410.63,454.46L410.41,454.69L410.04,454.41L409.85,454.57L409.6,454.34L409.31,454.67L409.41,455.18L412.1,456.63L412.68,457.66L414.31,458.93L414.38,459.29L413.81,459.65L414.17,460.03L413.57,461.2L414.08,462.25L415.07,462.22L415.79,462.71L416.26,462.55L416.43,462.81L415.39,463.86L415.22,465.21L416.31,466.46L416.23,467.2L411.4,470.79L410.86,470.95L410.53,471.38L410.52,472.65L410.52,472.65L409.92,472.65L409.76,473.14L409.41,473.32L407.59,473.44L406.94,472.76L406.91,472.3L406.24,471.71L405.12,471.15L404.44,471.15L403.92,468.29L400.93,464.47L399.93,464.29L396.65,464.72L396.59,465.31L397.45,468.45L396.56,469.39L396.56,469.39L394.19,468.96L387.05,469.75L383.22,470.74L380.91,470.72L379.82,470.49L378.52,469.85L377.59,469.06L376.76,467.73L376.94,467.58L376.51,466.84L375.31,465.62L374.6,465.21L371.56,464.7L370.8,463.96L369.67,462.02L368.47,460.87L365.51,460.36L363.82,459.29L362.73,457.68L361.79,454.9L360.75,453.75L359.94,453.52L357.96,453.57L357.06,453.21L354.41,451.48L352.4,450.99L350.48,451.38L347.68,451.58L346.97,452.19L345.8,454.13L344.78,454.44L341.49,453.62L339.06,451.2L338.08,450.69L337.49,450.69L335.95,451.35L335.38,452.45L335.15,453.9L334.47,454.87L333.6,455.49L331.62,455.97L330.59,456.12L328.39,455.92L326.81,455.26L325.35,453.19L324.85,452.86L323.55,452.88L323.06,453.29L322.27,454.72L320.4,457.12L317.65,461.79L316.67,465.05L316.52,468.4L315.91,469.47L315.11,470.05L310.11,472.35L306.93,474.54L306.19,474.59L304.07,473.83L302.31,473.67L301.19,474.06L299.97,475.08L298.96,475.41L297.8,474.97L296.16,473.5L295.02,473.01L294.12,472.91L290.4,473.72L287.26,472.96L285.21,473.04L279.62,474.46L279.56,472.6L281.39,471.07L282.09,470.03L281.35,469.39L281.06,468.73L281.13,467.71L281.6,466.36L281.49,465.62L277.88,463.86L276.28,462.2L275.49,461.79L274.53,461.64L273.61,462.04L272.07,463.68L270.95,463.83L270.38,463.6L268.99,462.07L268.29,460.59L267.5,460.05L267.52,459.34L267.15,458.96L262.91,457.02L261.69,455.95L260.84,453.88L259.91,453.21L259.91,453.21L262.28,453.26L263.31,448.28L259.91,447.82L258.96,446.24L259.3,444.83L258.72,442.97L259.13,442.54L260.93,444.12L264.94,444.02L266.47,444.63L266.99,444.04L268.78,443.33L269.37,442.77L268.28,442.1L267.88,441.23L268.13,440.36L269.43,439.72L271.35,439.7L272.45,439.08L273.5,437.52L273.67,436.27L274.12,435.91L275.06,436.2L276.09,435.94L277.79,436.35L278.15,435.66L278.44,433.48L280.63,429.42L281.38,429.77L281.28,428.16L283.31,425.22L283.18,424.58L283.64,424.48L288.21,415.77L288.21,415.77L290.38,417.18L292.41,417.62L293.26,417.41L294.39,416.41L295.78,413.72L296.46,412.88L297.66,412.57L298.91,413.31L300.76,415.23L302.52,416.18L304.53,416.72L307.09,417.05L309.54,418.69L310.89,418.77L312.82,417.79L314.39,415.77L315.64,414.9L316.98,414.69L319.28,415.18L320.79,415.08L325.76,413.18L327.84,411.42L328.88,410.85L333.2,411.7L335.99,411.39L336.9,411.62L339.06,412.93L340.1,413.88L345.21,415.77L346.35,417.59L347.49,418.49L348.72,419.02L352.82,420.07L355.5,421.87L357.09,420.46L358,420.97L357.93,419.66L358.87,419.43L358.88,417.9L358.19,416.23L358.16,415.54L358.57,414.9L358.74,413.82L357.14,411.93L356.79,409.83L356.11,408.77L355.12,408.57L353.85,407.39L353.2,406.7L353.06,405.06L352.79,404.62L352.3,404.08L351.92,404.49L350.37,402.8L351.24,402.78L351.45,398.29L348.44,397.16L348.65,395.39L347.44,394.87L348,393.36L348.39,389.58L348.22,389.23L348.68,387.33L348.42,385.32L347.98,385.3L347.46,384.68L347.33,382.83L346.73,382.42L347.03,381.7L346.76,380.23L345.69,380.39L345.77,380.88L345.43,380.95L345.02,380.47L343.61,380.83L343.72,381.49L344.2,381.65L344.21,382.01L344.61,382.34L344.17,383.37L345.02,383.6L344.94,384.27L344.83,384.78L343.55,384.4L343.04,385.3L344.09,385.73L342.57,387.35L341.25,387.07L339.85,387.17L339.44,388.56L337.58,388.58L336.24,389.05L333.52,387.43L333.42,386.94L332.79,386.79L332.49,386.45L334.2,384.27L336.48,382.83L336.27,380.16L337.65,378.82L337.73,378.33L336.62,377.61L339.89,377.95L339.89,377.59L339.23,377.23L339.26,376.35L338.49,376.1L337.76,375.2L338.12,375.27L338.34,373.83L340.07,373.58L340.84,372.09L338.71,371.03L338.6,370.65L338.9,369.15L337.27,369.1L335.99,368.54L336.21,366.81L335.76,366.66L335.86,366.12L334.83,365.68L334.75,365.29L328.71,364.47L326.19,363.57L326.32,362.64L326.06,361.1L325.54,360.58L326.22,360.04L327.41,360.4L328.06,359.86L328.47,357.88L328.42,356.36L321.95,351.08L323.77,343.25L323.77,343.25L326.11,342.35L343.69,337.32L344.28,336.49L345.34,333.6L350.58,317.41L352.43,314.54L352.82,314.16L355.12,313.66L355.66,313.74L356.38,314.65L357.46,313.77L361.38,311.91L361.95,312.09L362.71,312.89L367.03,309.19L368.5,309.22L369.99,308.78L371.32,307.48L373.06,306.79L374.2,305.96L374.58,305.31L375.39,304.67L375.12,304.17L375.21,303.81L375.55,303.73L376.15,304.28L376.56,304.3L379.03,302.31L379.22,301.95L379.79,301.79L383.16,298.69L384.41,297.94L387.49,294.91L387.82,293.9L389.57,291.36L388.66,290.04L388.71,289.75L390.93,285.53L391.37,285.32L392.48,285.69L392.78,285.38L392.76,284.88L393.76,282.14L394.17,279.65L395.15,278.22z"
}, {
  state_name: "Groningen",
  state_code: "NLD897",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M542.88,27.47l0.65,0.42l0.74,-0.08l2.03,-1.88l0.52,-0.19l2.75,1.11l0.33,0.93l-0.06,0.74l-0.33,0.56l-2.75,-0.56l-0.11,0.5l2.47,0.61l-0.17,0.72l-1.28,-0.24l-0.16,0.42l2.09,0.5l1.08,-0.13l1.19,0.32l0.11,-0.53l-1.28,-0.24l-0.25,-0.29l0.67,-2.54l3.1,0.98l3.5,3.34l-0.08,1.25l-1.25,3.52l-0.17,3.71l0.89,0.9l1.41,2.41l-0.43,0.69l0.57,0.24l0.21,0.48l-0.21,2.78l0.9,2.7l-0.05,1.27l0.89,3.94l0.33,0.56h1l2.88,2.56l0.67,0.87l0.79,0.11v0.45l-0.59,0.13l-0.35,1.27l1.65,0.53l0.43,0.61l0.54,-0.08l1.93,0.71l0.52,0.4l0.87,-0.03l0.84,0.26l2.52,1.22l0.84,0.19l1.09,1l1.12,0.66l2.59,1l2.07,-0.08l1.01,0.34l0.38,0.42l4.68,-0.11l0.66,-0.95l1.8,-0.34l0.59,-0.66h0.43l0.03,0.69l-0.43,0.13l-0.96,1.29l-0.93,0.71l-0.33,2.35l0.28,1.87l-1.27,3.51l0.08,1l0.57,0.29l0.08,0.74l0.46,0.53l1.14,0.55l0.4,0.47l0.63,0.08l0.29,0.55l2.04,0.08l0.74,-0.26l0.02,0.42l0.19,0.05l2.48,0.11l1.61,1.19l1.87,0.5l1.09,-0.42l1.47,1.11l1.87,0.34l0.43,0.37l2.86,0.71l0.25,0.24l0.3,-0.26l-0.22,-0.61l0.47,-1.16l0.54,3.72l-0.06,1.19l0.66,2l0.21,4.72l-0.24,0.79l-1,1.16l-0.25,0.66l2.91,2.13l0.05,0.61l-2.47,1.11l-1.31,0.05l-1.69,3.21l-0.05,0.66l-0.41,0.82l-0.06,2.53l-1,1.84l-0.55,0.37l0.63,4.39l2.85,2.1l-0.33,8.75l2.06,17.36l0.81,2.07l-1.28,1.6l-3.92,13.71l-0.24,1.55l-12.14,20.13l-2.63,3.37l-0.35,0.76l0.79,2.95l0,0l-3.18,0.16l0.14,-1.49l0.4,-1.23l-0.17,-0.1l-0.65,0.37l-0.43,-0.13l-0.62,-0.89l-0.41,-0.16l-2.34,-3.42l-0.59,0.05l-0.49,-1.86l-3.77,-0.39l4.49,-10.91l-3.34,-0.89l-1.34,-1.39l-0.19,0.05l-8.2,-12.39l-4.51,-6.21l-7.53,-7.58l-9.02,-10.29l-2.5,-2.34l-3.13,-3.6l-6.8,-6.99l-0.79,-1.13l-1.25,-0.84l-6.57,-0.34l-2.72,0.74l-6.54,2.97l-0.03,-1.81l-0.68,-0.34l-0.36,-1.24l-0.7,-0.55l-1.06,-2.92l-0.71,-0.26l-0.79,-1.05l-2.04,-1.79h-1.31l-0.49,-1.92v-1l-0.7,-1.18l-0.38,-0.05l-2.01,0.87l-1.14,-3.19l-2.34,-4.08l-0.6,-0.03l0.06,-0.53l-1.06,-2.06l-1.11,-0.05l-4.29,-1.87l-1.33,0.34l-1.42,-0.03l-2.67,0.87l-2.67,0.53l-0.09,0.92l-1.39,1.34l-1.12,0.29l-0.17,0.32l-2.18,1.48l-1.55,0.66l-0.27,0.53l-0.22,2.03l-0.71,0.74l-0.62,0.21l-1.08,1.76l-0.98,0.97l-0.27,1.79l-2.42,6.42l-0.36,3.37l-1.17,0.37l-2.01,5.28l-4.34,-1.6l0,0l-3.8,-1.52l-0.93,-1.47l-1.16,-1.13l-2.31,-1.24l-4.37,0.18l-5.21,-0.79l-1.99,-1.76l-2.83,-3.53l0.25,-6.66l0.44,-2.77l2.03,-3.74l0.25,-0.84l1.04,-1l0.22,-1.4l0.47,-0.32l0.95,-0.11l0.57,-0.9l1.03,-0.84l0.74,-1.24l0.24,-0.98l0.51,-0.58l0.22,-1.19l-0.68,-0.92l-0.25,-1.27l-1.3,-1.03l-0.44,-1.66l2.74,-0.45l0.06,-1.29l-0.22,-0.74l0.71,-0.58l0.1,-0.4l-0.46,-0.66l0.96,-0.37l0.27,-0.55l-0.08,-0.74l0.68,-0.61l0.41,-0.84l0.3,-0.03l0.41,0.53l0.38,-0.4h0.44l0.08,-0.92l-0.54,-1.56l0.28,-3.04l1.17,-0.69l1.23,0.37l0.24,-0.19l0.19,-1.11l0.47,-0.55l0.08,-0.92l0.49,-0.79l1.38,-0.5l0.93,-1.08l-0.41,-0.63l-1.49,-0.34l-0.06,-0.24l0.84,-7.32l-2.9,-1.27l-2.63,-0.63l-1.85,1.3l-1.11,0.13l-0.7,-0.85l-0.44,-1.67l-0.59,-0.9l-0.68,-0.37l-5.22,-1.43l-1.14,-0.95l-0.54,-0.85l-0.81,-2.38l-0.13,-3.36l3.69,-5.38l0,0l0.57,-0.32l0.82,-0.08l0.27,0.26l-0.3,0.34l0.08,0.4l0.63,0.03l6.01,-1.77l1.54,-0.11l1.33,0.4l5.19,2.91l0.79,0.53l1.33,1.99h0.24l2.29,-1.43l1.8,-1.62l4.81,-2.2l4.48,-1.72l6.65,-1.11l19.67,-2.25l4.75,-1.38l2.8,-1.11l2.41,-1.33l4.46,-1.78l7.48,-2.44l7.12,-0.88h1.72l4,1.3L542.88,27.47zM482.21,10.71l0.74,0.13l-0.08,0.66l-2.15,-0.29l-1.69,0.11l-0.22,-0.42l0.28,-0.45l0.89,-0.08L482.21,10.71zM510.46,9.17h0.93l0.17,0.19l-0.08,0.29l-0.54,0.24l0.13,0.53l-0.17,0.19l-2.18,-0.8l-0.36,-0.56l0.14,-0.42l1.06,-0.13L510.46,9.17zM515.16,4.65l0.08,0.32l-0.19,0.21l-1.44,-0.48l-0.79,0.19l-0.09,0.56l0.93,0.8l-0.05,0.58l-3.24,-1.54l-0.65,-0.13l-1.91,0.37l-0.38,-0.5l0.06,-0.42l0.93,-1.12l1.01,-0.29l3.42,0.37L515.16,4.65zM495.68,4.01l1.44,0.11l1.12,0.48l2.71,2.26l-0.03,0.37l-0.54,0.08l-2.04,-0.66l-0.63,0.11l-0.82,-1.01l-0.19,0.03l-0.33,0.45l0.3,1.06l-0.3,0.56l-1.58,0.03L494,7.57l-0.85,0.58l0.6,0.69l-0.11,0.58l-0.78,0.53l-1.39,-0.4l-0.71,-0.58l-0.35,-2.1l-1.87,-1.33l-0.65,-0.98l-0.1,-1.94l0.87,-2.52l0.6,0.08l0.68,2.31L495.68,4.01z"
}, {
  state_name: "Limburg",
  state_code: "NLD898",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M396.56,469.39L397.45,468.45L396.59,465.31L396.65,464.72L399.93,464.29L400.93,464.47L403.92,468.29L404.44,471.15L405.12,471.15L406.24,471.71L406.91,472.3L406.94,472.76L407.59,473.44L409.41,473.32L409.76,473.14L409.92,472.65L410.52,472.65L410.52,472.65L410.8,474.08L416.83,474.23L418.6,475.53L421.99,476.99L422.91,477.93L423.41,479.13L423.73,479.36L424.08,479.05L424.84,479.64L424.92,480.04L424.63,480.78L423.38,480.63L423.02,480.78L422.23,481.27L422.04,482L422.32,483.69L422.94,484.42L423.05,485.21L423.1,486.1L422.34,487.02L422.72,488.57L422.61,489.62L422.99,490.56L424.25,491.37L426.42,491.98L430.14,493.46L430.36,493.92L431.31,493.59L431.67,493.87L431.67,494.3L433.05,494.3L436.31,495.11L436.28,496.67L435.79,497.46L435.44,497.63L434.52,501.32L434.24,501.37L433.32,504.19L432.72,503.91L432.73,505.77L432.29,507.93L434.74,509.66L437.04,511.64L438.03,513.54L439.74,515.42L442.31,517.68L443.29,518.88L444.79,522.63L446.04,525.1L447.64,526.16L449.43,527.76L451.69,531.72L451.66,537.01L452.45,538.79L453.27,541.96L452.53,547.33L452.58,548.31L451.94,548.37L451.75,548.67L451.69,553.25L450.5,560.21L453.64,560.06L453.62,560.51L451.77,563.55L453.64,570L448.02,575.18L447.96,575.53L448.41,576.67L444.58,577.5L444.54,578.38L443.67,579.37L443.16,580.46L443.1,581.62L442.37,582.78L442.29,583.74L440.55,586.39L438.35,589.19L437.46,591.28L437.35,592.12L431.34,598.75L429.24,600.04L431.48,604.82L431.28,605.2L429.5,605.1L428.68,605.5L428.63,605.86L429.08,608.6L429.63,615.08L431.04,617.82L432.05,618.15L433.73,618.22L434.19,617.77L434.79,617.67L435.83,616.99L437.34,615.4L444.11,612.13L445.12,612.71L446.74,614.17L440.23,617.19L440.04,617.49L445.49,620.89L445.61,621.29L443.67,622.63L443.59,623.68L442.97,623.66L442.54,623.91L441.25,623.78L438.68,624.74L438.18,624.49L437.46,624.89L437,625.57L434.79,626.7L432.38,627.13L431.77,628.84L431.4,629.04L431.5,629.82L431.13,629.89L430.68,629.34L430.5,630.3L429.96,630.52L429.46,631.15L427.64,631.73L426.99,632.18L426.78,633.46L424.82,635.73L422.99,637.13L421.23,637.66L420.53,637.23L420.29,637.84L419.58,637.94L418.95,638.89L417.08,640.33L416.13,642.23L414.66,642.76L414.92,643.57L414.08,644.9L413.21,645.65L413.29,646.3L412.92,646.98L413.14,647.53L412.86,648.04L412.89,649.72L411.88,650.37L411.12,650.54L411.42,651.95L410.82,652.15L410.37,651.7L409.09,651.67L407.89,652.1L407.64,650.77L406.1,648.61L405.07,645.25L404.23,644.27L400.71,647.53L396.53,648.11L396.81,649.67L398.7,651.98L398.44,653.23L397.9,653.28L397.81,653.73L398.82,656.29L399.76,657.47L401.43,658.25L401.39,659.73L402.86,660.38L402.48,662.14L402.64,663.94L401.01,665.75L401.75,667.2L402.89,667.27L405.44,666.25L407.49,664.62L410.61,663.92L410.85,663.97L411.15,664.64L412.35,665.47L412.73,666.15L413.7,665.92L414.06,665.54L415.03,665.17L421.89,664.94L422.1,665.42L420.31,670.06L419.96,670.63L418.74,671.61L420.56,672.74L420.5,673.86L421.02,677.35L424.6,678.37L425.2,678.85L426.05,678.55L426.74,679.2L426.56,680.43L428.62,680.65L429.33,680.15L429.79,680.2L431.18,680.65L432.04,681.6L432.45,680.83L432.97,680.58L432.75,681.58L431.78,682.23L431.58,683L430.93,683.63L429.85,687.73L430.12,689.13L431.29,690.81L432.05,692.66L431.64,693.24L431.39,694.49L430.98,694.69L430.83,695.16L430.15,695.94L429.68,699.31L428.93,699.21L427.1,698.01L426.78,696.96L422.37,699.19L421.31,699.56L420.96,699.49L420.85,702.96L421.39,703.78L421.83,703.98L421.81,704.46L422.46,705.96L421.91,706.43L421.62,706.41L421.89,707.18L420.42,708.61L419.57,709.98L419.2,710.2L418.44,710.4L417.84,709.85L416.77,709.35L416.12,708.63L415.48,708.53L414.72,709.11L413.92,710.35L413.79,711.85L415.82,712.45L417.05,713.38L417.7,714.82L422.1,717.52L422.13,717.92L421.07,719.99L420.53,720.44L421.21,722.06L420.47,722.03L418.1,722.58L414.93,722.48L414.36,722.26L414.23,721.31L413.57,720.56L411.88,720.16L407.3,721.63L406.01,722.73L404.83,723.11L404.74,722.11L404.39,722.01L403.03,722.16L402.33,723.01L400.4,721.61L400.42,720.19L399.82,718.52L396.05,720.46L394.39,722.18L394.11,722.11L393.43,719.69L391.34,721.04L389.79,721.04L388.77,721.58L387.67,721.81L385.09,718.17L383.93,718.82L383.71,718.74L382.37,715.2L380.78,715.47L377.55,719.19L376.7,720.76L374.9,720.76L373.57,719.84L372.73,720.89L370.97,721.19L370.07,722.03L369.03,721.86L368.49,721.41L367.71,721.39L367.84,720.44L369.85,717.69L370.61,715.32L370.54,714.67L369.17,711.85L369.2,711.33L370.24,709.85L370.21,709.38L369.31,707.96L367.19,707.78L366.94,706.78L366.04,706.78L365.64,706.36L364.74,706.46L363.46,705.86L363.25,705.53L363.46,705.18L363.33,704.71L362.7,703.98L362.32,704.13L362.62,702.81L361.51,701.41L361.78,701.01L361.27,700.76L361.24,699.96L360.88,699.44L361.02,698.64L361.3,698.34L361.02,697.44L361.4,696.79L361.24,695.61L361.38,695.34L361.08,694.91L362.22,693.94L361.62,693.19L362.03,692.64L362.81,692.51L365.61,690.74L366.94,690.74L367.51,689.06L368.93,687.78L369.45,687.01L369.8,684.13L370.29,683.4L371.49,683.15L373.14,684.1L373.96,683.68L374.45,682.75L374.45,680.9L374.91,679.52L376.81,677.12L377.7,674.32L379.42,673.46L379.38,672.41L378.95,671.51L378.43,671.03L377.32,670.83L376.05,671.94L374.85,672.24L373.77,671.66L373.63,670.38L375.72,667.9L376.27,666.5L377.98,665.54L379.5,662.99L380.43,662.16L380.8,661.48L380.96,660.86L380.81,658.45L382.27,655.74L382.37,655.11L381.73,654.01L379.69,653.16L379.5,652.43L380.56,650.7L381.62,648.14L381.75,645.67L381.99,645.27L382.87,645.27L384.77,646.28L385.72,646.08L386.12,645.57L386.16,644.9L385.59,642.74L385.97,642.08L386.8,641.43L386.91,640.98L386.51,640.02L385.5,638.77L385.44,638.01L386.34,637.13L387.57,636.81L389.9,637.74L390.96,636.81L391.15,636.38L391.37,634.95L390.72,633.99L390.09,633.72L388.36,633.69L387.59,633.24L387.37,632.26L387.62,631.35L389.87,628.59L390.44,628.31L392.51,628.06L393.24,625.77L394.79,624.69L391.84,622.4L392.05,621.52L391.38,620.96L391.29,620.16L390.56,619.61L389.99,618.7L388.7,619.91L388.39,620.89L388.01,620.89L387.16,620.06L386.86,620.03L386.24,620.92L385.5,621.34L384.79,621.39L383.44,622.53L382.59,622.75L382.21,621.82L382.37,621.27L382.84,620.76L382.84,620.01L382.37,619.91L382.32,619.33L381.59,619.48L381.42,618.73L381.43,618.3L382.46,618L382.59,617.74L381.81,617.57L382.21,616.21L380.74,614.7L378.76,614.32L377.38,613.49L376.75,613.99L376.61,614.37L376.02,614.07L375.36,614.47L374.69,614.22L374.47,614.52L373.14,614.55L371.91,615.5L370.66,615.05L370.4,614.75L369.8,614.67L369.66,614.97L369.26,614.95L368.73,614.4L366.78,614.97L366.53,614.5L365.96,614.22L364.71,614.12L363.84,614.34L362.84,612.73L362.79,612.31L363.17,612.03L362.81,611.15L360.96,610.19L348.91,605.28L348.91,605.28L353.53,603.87L353.5,604.42L357.52,602.4L358.25,598.07L358.49,591.89L365.53,581.87L397.67,571.84L406.96,563.88L397.37,547.53L395.51,536.96L394.3,533.87L391.97,517.81L400.37,519.46L403.03,521.57L408.24,521.03L413.1,519.46L418.65,517.18L420.58,518.72L422.54,521.16L423.46,520.27L423.76,520.22L424.22,520.6L424.68,520.17L425.09,520.12L425.15,519.84L424.42,519L423.95,517.94L423.93,513.67L422.27,511.23L421.8,510.06L421.58,508.34L421.67,505.97L421.17,504.24L417.19,500.35L413.71,498.22L413.25,497.71L413,496.44L414.2,494.02L414.23,492.85L413.22,492.39L411.5,492.39L410.93,491.81L410.86,490.94L412.11,489.01L411.01,484.63L410.67,481.55L410.06,480.99L407.78,480.02L403.4,479.43L402.45,479.2L400.75,478.36L399.65,476.96L399.31,474.31L398.58,471.3z"
}, {
  state_name: "Overijssel",
  state_code: "NLD899",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M436.89,186.27L438.1,187.84L438.45,188.86L439.24,189.9L444.85,196.43L445.98,197.06L448.98,201.19L450.01,202.23L444.85,207.94L444.66,209.2L441.59,210.74L437.95,211.62L437.61,211.86L436.89,213.11L440.09,221.35L441.88,225.26L442.69,228.07L443.67,229.37L444.21,229.71L444.41,229.58L444.93,230.07L445.69,231.64L446.91,231.14L447.29,231.58L449.32,231.82L450.17,230.65L451.02,230.62L452.28,230.15L452.45,230.83L453.87,231.64L454.32,231.48L454.49,231.84L455.69,232.44L455.69,232.44L456.56,232.36L456.56,232.36L457.4,233.77L458.33,234.47L459.46,234.55L460,235.28L460.8,235.8L461.23,235.72L461.93,234.84L462.51,234.92L463.48,236.24L463.94,236.5L464.47,236.43L465.04,235.59L466.25,235.51L468.21,234.58L469.16,234.53L469.7,235.46L469.27,235.98L469.32,237.15L470.49,238.2L471.72,238.64L472.12,239.16L473.56,240.02L473.65,240.56L473.97,240.9L474.46,240.85L475.16,241.37L475,241.71L476,242.96L476.26,244.23L476.94,245.19L476.79,246.26L477.26,247.06L477.34,247.9L477.92,248.68L478.32,248.68L478.46,249.4L478.68,249.46L480.11,248.7L480.5,248.03L482.01,248.08L482.51,247.17L483.94,247.9L484.4,247.53L484.51,246.93L485.46,246.23L485.9,245.43L486.07,246.02L486.5,246.44L486.45,247.45L486.98,248.13L487.93,248.73L488.86,248.88L490.6,248.36L491.11,247.82L491.72,245.89L492.42,246.26L492.39,246.91L493.05,247.17L493.23,247.58L494.43,247.71L494.76,247.43L495.77,247.48L496.72,247.9L497.72,247.9L498.15,248.7L498.86,248.75L499.13,249.4L499.49,249.43L499.57,249.98L499.94,249.98L500.17,249.53L499.73,245.17L499.24,243.71L498.89,240.69L499,240.2L503.73,236.3L505.03,235.57L515.13,233.3L524.76,237.88L530.16,239.76L529.35,241.6L529.68,241.71L529.91,242.23L528.89,243.35L529.21,243.89L528.64,245.5L530.46,245.61L530.46,245.61L530.75,245.66L531.41,246.73L531.84,246.96L532.66,248.55L532.23,251.59L531.68,253.46L531.58,255.51L539.08,262.13L536.92,262.94L536.01,262.99L534.94,262.55L534.07,262.6L532.53,262.21L531.73,264.89L530.92,265.54L530.86,265.93L525.35,264.81L529.29,273.04L528.17,281.98L530.71,283.93L531.68,284.5L532.63,284.68L536.81,287.89L538.12,288.43L540.73,289.21L550.07,288.87L551.87,289.29L552.83,289.19L552.82,291.62L554.45,291.28L561.44,293.3L566.81,295.3L567.88,294.91L570.11,292.73L570.7,291.83L572.44,287.81L574.2,286.57L574.99,287.58L575.08,288.25L576.38,291.36L577.68,296.77L579.45,298.38L581.73,303.55L581.68,304.02L582.58,303.97L584.2,304.61L584.85,304.23L585.31,304.43L585.32,305.23L586.13,306.48L587.68,311.18L587.57,316.69L584.91,320.41L584.63,322.17L583.5,323.84L583.61,325.11L583.23,326.37L582.08,328.67L581.57,329.14L580.3,331.98L580.19,332.75L580.24,333.91L580.59,335.02L580.56,335.67L580.35,335.82L580.43,336.98L581.33,337.94L582.96,341.67L586.13,345.21L585.43,346.83L582,349.05L579.36,349.23L578.88,349.61L578.47,349.2L576.49,348.66L575.1,348.97L574.7,348.81L573.61,349.36L573.49,349.92L572.73,350.57L572.84,352.24L572.11,354.15L571.25,355.28L569.85,358.29L568.23,360.77L567.92,361L565.19,361.54L561.36,362.1L561.05,362.59L560.91,363.8L557.36,367.1L555.86,373.81L553.2,376.38L547.52,376.97L538.18,376.97L538.18,376.97L531.05,377.02L528.34,375.76L524.89,375.12L522.56,374.04L524.24,371.34L524.45,369.69L524.24,368.97L524.27,367.56L523.83,367.33L524.34,366.58L524.37,365.96L524.08,365.11L523.64,364.7L520.38,362.98L519.72,362.93L518.94,364.29L518.17,363.21L517.33,362.95L516.95,363.26L516.68,364.09L516.01,364.32L514.68,365.32L513.35,364.09L513.24,363.67L513.75,362.62L513.05,362.13L512.74,361.51L511.76,361.1L511.71,360.69L511.23,360.4L511.12,360.66L505.43,361.82L499.14,360.79L496.12,361.87L495.58,361.69L495.06,361.18L493.53,360.43L493,359.74L492.13,357.78L492.06,356.36L491.74,356.05L490.7,356L489.76,355.64L488.46,353.01L485.27,349.67L484.62,347.81L483.51,346.24L483.56,344.95L480.98,344.64L478.94,344.77L478.04,344.33L476.28,345.08L473.29,345.26L472.97,345.95L472.34,346.06L471.29,346.75L471.2,348.94L469.81,349L468.54,349.36L465.27,349.33L464.78,348.89L464.67,348.45L464.19,348.35L464.06,347.94L462.23,348.43L461.86,348.94L460.82,348.58L460.74,349.33L459.21,348.89L457.12,349.07L456.69,348.74L455.6,348.76L454.51,348.35L452.07,348.02L449.76,346.29L448.02,346.37L446.99,346.06L446.34,346.34L445.63,346.26L445.41,346.37L445.19,347.27L445.04,348.79L444.32,348.02L443.95,348.69L444.28,348.94L444.16,349.18L443.54,348.92L443.84,349.77L444.41,350.44L444.38,350.9L444.09,351.21L443.75,350.9L443.79,350.08L443.37,349.33L442.02,349L440.95,348.22L440.52,346.57L440.85,345.72L441.96,345L442.23,344.1L442.15,343.58L440.19,343.76L439.3,343.12L437.5,342.71L437.5,341.7L438.41,340.39L437.53,339.61L437.08,337.65L435.57,335.79L435.44,333.29L434.62,332.13L434.17,330.69L433.84,330.09L432.19,330.07L431.13,329.73L431.04,326.92L430.5,325.73L428.93,325.52L428.95,325.01L429.58,324.23L429.84,322.4L430.06,319.87L429.85,317.26L430.25,316.58L431.85,316.09L432.72,315.37L432.5,314.83L432,314.41L430.74,314.13L430.38,313.82L430.09,313.22L430.12,312.29L430.75,311.42L433.89,310.82L436.78,309.71L437.2,309.24L437.54,308.52L437.59,306.09L438.29,304.69L439.17,301.28L439.08,300.32L438.18,297.73L435.83,294.26L434.58,293.33L433.97,292.53L434.13,290.09L433.94,287.27L433.51,286L432.16,284.37L429.77,283.3L428.51,282.27L427.7,281.05L426.69,278.59L423.65,276.2L423.03,276.12L422.05,275.58L421.61,276.36L420.94,276.9L419.23,277.5L412.34,284.63L410.97,282.66L410.04,282.89L408.03,284.39L407.41,283.82L406.21,284.37L405.71,282.76L404.06,279.26L402.95,277.37L400.85,274.75L398.39,272.57L396.24,273.37L396.24,273.37L394.99,266.24L394.5,264.76L387.76,257.56L386.31,257.3L382.57,257.36L382.63,250.5L392.02,250.52L392.45,249.82L393.27,249.48L402.59,247.43L403.85,247.92L404.65,248.78L406.99,248.49L410.63,246.44L410.86,245.87L416.1,244.72L419.66,242.36L420.49,241.4L420.45,241L420.06,240.35L418.17,238.48L415.6,237.78L413.08,235.57L411.54,235.05L410.45,234.97L408.35,234.14L408.33,234.5L407.65,234.42L407.27,233.98L407.21,233.09L409,231.06L410.47,230.05L411.37,228.98L411.88,228.9L412.29,228.22L412.26,227.31L411.58,225.8L411.05,225.39L410.74,225.41L410.74,224.5L410.2,223.56L409.09,222.99L407.49,217.46L406.37,214.57L405.8,213.68L402.75,210.79L402.18,210.76L401.23,210.16L399.61,208.78L398.68,207.47L395.58,205.33L394.19,204.66L392.32,204.32L391.99,204.08L389.09,204.08L389.06,203.59L386.92,201.71L385.51,199.2L385.51,199.2L389.3,196.56L389.53,196.96L391.46,198.05L391.81,199.12L392.19,199.12L392.81,198.55L393.66,198.99L395.15,198.94L395.72,199.28L396.46,199.25L397.92,200.04L398.68,200.11L401.99,198.55L402.59,197.61L403.96,196.75L404.77,195.52L406.2,194.58L406.23,193.27L406.42,192.98L406.18,192.54L406.83,192.23L406.89,191.68L408.54,191.47L409.3,191.16L410.77,191.76L410.59,190.76L410.79,190.37L411.48,189.9L413.62,189.43L414.11,191.44L415.03,192.8L415.77,194.81L416.37,194.94L417.18,195.68L417.86,195.81L418.38,195.78L418.87,195.36L420.18,194.92L421.99,194.68L422.7,196.12L424.04,195.57L426.43,194.11L426.75,193.53L426.23,190.92L428.02,190.19L430.07,190.42L430.79,190.29L431.39,189.67L432.18,189.22L433.03,189.14L434.95,187.92z"
}, {
  state_name: "Flevoland",
  state_code: "NLD902",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M327.09,271.35l-0.63,-0.23l-0.05,-0.52l0.32,-0.34l0.4,-2.08l2.06,-4.91l1.23,-1.22l2.61,-1.27l0.33,-0.6l-0.03,-0.52l-1.82,-5.61l-8.78,-14.14l0,0l0.36,-0.26l0,0l8.85,14.14l1.87,6.05l-0.4,1.27l-2.98,1.4l-0.93,1.04l-2.1,5.11L327.09,271.35zM372.13,190.84l1.58,0.31l1.25,1.23l1.08,-0.44l-0.98,-2.95l3.17,0.97l5.73,5.8l0.98,3.79l0.59,-0.34l0,0l1.41,2.51l2.14,1.88l0.03,0.5h2.9l0.33,0.23l1.87,0.34l1.39,0.68l3.1,2.14l0.93,1.3l1.61,1.38l0.95,0.6l0.57,0.03l3.05,2.9l0.57,0.89l1.12,2.89l1.6,5.53l1.11,0.57l0.54,0.94v0.91l0.32,-0.03l0.52,0.42l0.68,1.51l0.03,0.91l-0.41,0.68l-0.51,0.08l-0.9,1.07l-1.47,1.02l-1.79,2.03l0.06,0.89l0.38,0.44l0.68,0.08l0.02,-0.36l2.11,0.83l1.09,0.08l1.53,0.52l2.52,2.21l2.58,0.7l1.88,1.87l0.4,0.65l0.03,0.39l-0.82,0.96l-3.56,2.37l-5.24,1.14l-0.24,0.57l-3.64,2.05l-2.34,0.29l-0.79,-0.86l-1.27,-0.49l-9.32,2.05l-0.82,0.34l-0.43,0.7l-9.38,-0.03l-0.06,6.86l3.73,-0.05l1.46,0.26l6.74,7.19l0.49,1.48l1.25,7.14l0,0l-1.09,4.85l-0.98,1.43l-0.41,2.49l-1,2.75l0.02,0.49l-0.3,0.31l-1.11,-0.36l-0.44,0.21l-2.21,4.22l-0.05,0.29l0.9,1.32l-1.74,2.54l-0.33,1.01l-3.08,3.03l-1.25,0.75l-3.37,3.11l-0.57,0.16l-0.19,0.36l-2.47,1.99l-0.41,-0.03l-0.6,-0.54l-0.33,0.08l-0.09,0.36l0.27,0.49l-0.81,0.65l-0.38,0.65l-1.14,0.83l-1.74,0.7l-1.33,1.29l-1.49,0.44l-1.47,-0.03l-4.32,3.7l-0.76,-0.8l-0.57,-0.18l-3.92,1.86l-1.08,0.88l-0.73,-0.9l-0.54,-0.08l-2.29,0.49l-0.4,0.39l-1.85,2.87l-5.24,16.19l-1.06,2.89l-0.58,0.83l-17.58,5.03l-2.34,0.9l0,0l-3.07,-2.63l-8.04,-7.95l0,0l-3.81,-3.77l-4.65,-3.07l-9.73,-2.45l-11,1.88l-1.08,-0.62l-1.16,-1.45l0,0l0.22,-0.21l-0.27,-0.49l1.08,-0.98l-1.41,-1.34l-0.41,-0.03l-0.17,0.21l-0.13,-0.23l0.49,-0.54l0.17,-0.7l-0.27,-5.01l-1.63,-3.1l0.03,-1.53l5.41,-3.26l0.81,-1.86l7.18,-4.24l1.87,-0.05l0.73,-0.39l0.49,-0.34l0.97,-1.71l3.2,-1.97l20.44,-14.4l1.6,-0.23l0.98,-0.57l6.12,-5.5l0.3,-0.99l-0.51,-0.88l-0.09,-1.22l-0.41,0.23l-0.57,-0.03l0.14,-1.38l0.6,-0.16l0.14,0.39l0.19,-0.42l0.73,-0.21l0.74,-0.67l1.41,-3.27l1.03,-1.35l4.81,-0.29l0.67,-0.29l5.36,-5.12l0.17,-0.26l-0.65,-0.7l0.55,-0.55l0.57,0.52l-0.24,0.18l0.19,0.16l4.48,-4.6l10.59,-3.07l1.49,-1.33h0.46l1.57,-1.56l-5,-8.06l-2.83,-2.08l-0.06,-0.23l0.58,-0.21l-0.74,-0.96l-1,0.18l0.27,-26.71l10.57,-17.2l0.98,-0.6l6.25,-0.78l0.46,-0.08L372.13,190.84z"
}, {
  state_name: "Zeeland",
  state_code: "NLD903",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M122.86,569.59l0.43,0.03l0.03,-0.38l0.16,0.1l0.73,1.57l-0.28,0.2l-1.55,0.15l-1.95,-0.86l-0.49,-0.56l1.19,-0.78l1.42,0.2L122.86,569.59zM29.64,559.63l2.94,0.94l-0.21,0.61l0.19,0.13l0.4,-0.18l0.16,0.2l0.92,0.03l1.57,1.85l0.95,0.33l1.65,0.05l0.9,0.25l0.25,0.48l0.95,0.25l0.21,0.48l3.94,1.14l7.17,1.14l0.78,0.91l0.11,0.46l0.36,0.15l0.11,0.46l2.55,1.67l1.22,1.72l1.52,0.15l1.23,-0.4l3.88,0.78l0.16,0.5l-0.63,0.51l-0.09,0.93l1.66,0.88l0.6,0.03l0.06,-0.28l-0.3,-2.73l0.13,-0.35l3.05,0.08l0.57,0.71l1.16,0.63l1.52,0.23l-0.46,0.5l-0.03,0.46l1.16,2.25l0.33,-0.18l-0.44,-1.44l0.54,-0.23L72,574.49l0.47,0.05l-0.14,0.35l0.27,0.83l0.47,-0.25l0.35,-0.93l0.35,0.03l-0.24,0.35l0.3,0.35l1.22,0.18l1.22,0.76l4.04,-0.1l1.06,-1.34l0.35,-0.96l2.36,-0.71l0.68,-0.88l2.83,-1.95l1.71,-0.73l2.6,-0.56l0.09,-0.23l1.19,-0.38l0.52,0.08l0.33,-0.3l0.78,0.61l0.21,-1.04l-0.17,-0.4l0.54,-1.06l0.11,-1.54l0.87,-0.94L96,562.92l-0.16,-2.23l1.65,-2.33l2.58,0.23l0.38,0.53l3.94,0.61l-0.32,0.53l0.38,0.38l0.41,-0.18l0.62,1.04l0.55,0.2l0.65,2.33l-0.27,0.18l0.19,0.63h0.65l1.2,2.58l0.93,1.14l4.49,0.28l2.07,0.35l3.7,3.23l2.77,3.29l1.63,0.93l-1.74,-2.27l-0.84,-1.84l1.71,-0.66l1,-0.05l0.49,0.35l0.49,1.01h0.9l0.7,0.5l0.85,1.21l-0.08,0.48l0.3,0.05l0.41,-0.63l-0.7,-0.61l-0.33,-0.76l2.48,0.13l-0.38,-0.4l-2.18,-0.4l-0.38,-0.38l3.58,-0.18l1.22,0.28l-0.66,-0.66l-3.05,-0.02l-1.38,-0.43l-1.31,-2.25l0.08,-1.16l1.04,-0.33l0.65,0.23l0.98,-0.83l0.59,-0.13l0.43,3.08l2.28,1.34l1.12,0.2l-1.8,-0.94l-0.97,-0.86l-0.3,-0.71l0.03,-1.29l0.3,-0.28l0.43,0.33l0.17,1.06l0.17,-2.17l0.63,-0.71h1.33l1.08,0.46l0.46,-0.03l1.12,0.86l0.65,2.15l0.97,1.62l1.69,1.87l-2.26,3.44l-8.09,10.45l-10.74,8.12l-2.91,1.89l-0.63,0.63l-2.04,1.06l-0.54,0.96l-2.91,0.68l-0.44,-0.2l-0.51,-0.86l-0.65,0.53l-1.19,0.48l-0.57,-0.96l-1.04,0.03l-1.99,1.11l-0.74,0.83l-0.76,0.3l-0.78,0.73l-0.3,-0.38l-1.41,2.34l-2.26,0.4l-0.06,0.73l-0.65,1.21l-1.73,0.13l-0.79,0.25l-0.02,0.33l-1.06,0.33l-0.47,-1.11l-0.76,-0.86l-0.48,0.81l-0.92,0.05l-0.49,0.83l0.21,1.11l-0.47,0.08l-0.59,0.81l-1.72,0.78l-0.89,-0.33l-0.32,0.4l-0.84,0.43l-0.32,-0.78l-0.92,-1.06l1.84,-1.41l0.46,-0.91l-0.93,-1.56l-1.38,0.71l-3.21,2.29l-1.11,-0.68l-0.4,0.3l-0.35,-0.15l-0.74,0.4l-0.92,-0.38l-1.11,0.86l-1.08,0.25l-2.03,-0.91l-0.81,-0.13l-0.17,0.2l0.22,0.83l-0.14,0.13l-0.79,-0.66l-0.32,-0.68l-0.9,-0.23l-0.24,-0.48l-0.17,-2.85l0.16,-4.26l0.97,-2.67l-0.22,-0.35l-1.19,-0.3l-1.46,-1.31l-0.71,-0.3l-0.27,0.58l-0.68,0.35l-0.79,-0.53l-0.87,-1.69l-0.62,-0.38l-0.62,0.33l-3.92,-0.93l-1.01,0.4l-3.5,-1.01l-0.38,-0.23l-0.55,-1.08l-1.68,-0.03l-0.41,-0.68l-2.93,-1.72h-2.01l-0.73,0.5l-2.26,-1.34l-0.73,0.08l-0.46,-0.78l-4.38,-2.32l-1.57,1.87l0.76,1.36l-0.6,0.43l0.27,0.68l-0.28,0.48l-0.49,-0.48l-0.52,0.13l-0.71,-0.61l-0.05,-0.35l-1.36,-0.68l-0.52,0.2l-0.21,0.66l-0.49,0.35l-1.79,-0.23l-0.81,1.72l-0.87,0.13l-1.19,-1.19l-1.55,0.3l1.92,10.37l-7.18,0.86l-4.75,0.33l-0.95,-0.1l-2.26,-0.86l-0.63,0.05l-0.44,-2.34l-0.27,-0.35l-1.14,-1.08l-1.14,0.73l-0.65,-1.34l-1.68,-1.06l-0.92,-1.82l-1.39,-0.35l-0.57,-0.71l0.95,-0.78l-0.03,-1.44l-0.28,-0.45l-1.39,-0.96l-0.62,-1.57l1.42,-0.76l-2.67,-3.16L0,581.39l3.99,-4.52L3.7,574.6l-1.36,-1.77l-0.13,-0.78l0.22,-1.87l-1.31,-2.53l0.79,-1.14l1.36,-0.96l0.02,0.4l0.28,-0.03l0.09,-0.51l2.86,-1.04l3.67,-1.85l1.31,-0.2l0.19,0.78l0.71,0.23l0.14,-0.51l1.96,-0.61l0.76,-0.61l2.33,-0.33l2.31,-0.76l0.92,-0.43l0.13,-0.43l0.87,-0.05l1.58,-1.39l1.77,-0.18l0.71,0.3l2.64,0.25l1,0.35L29.64,559.63zM54.73,531.23l0.17,0.2l-0.59,-0.15l-0.3,-0.36h0.46L54.73,531.23zM52.87,528.75l-0.3,-0.1l0.35,-0.1L52.87,528.75zM52.53,527.66l-0.13,0.15l-0.13,-0.25l0.17,-0.48L52.53,527.66zM56.92,527.63l-0.08,0.23l-0.17,-0.1l-0.13,-0.38l0.51,-0.96L56.92,527.63zM57.55,526.49v0.36l-0.22,-0.79l0.36,-0.41l0.16,0.28L57.55,526.49zM52.44,525.81h-0.22l0.41,-0.25l0.35,-0.76l0.14,0.66L52.44,525.81zM63.8,523.22l0.76,0.08l0.28,-0.2l0.78,0.53l-1.22,0.28l-2.55,-0.05l0.02,-0.63l0.25,-0.33l0.55,-0.05L63.8,523.22zM81.63,522.61l-0.36,-0.03v-0.18l0.49,-0.51l0.25,0.36L81.63,522.61zM66.14,522.63l-1.01,-0.56l0.08,-0.13l0.43,-0.1l0.73,0.3L66.14,522.63zM64.77,521.92l0.17,0.84l-1.73,-0.18l-0.43,-0.43l1.44,-0.43h0.41L64.77,521.92zM51.4,521.69l0.68,0.3l0.62,0.61l0.32,0.71l0.06,0.96l-0.44,-0.13l-0.41,1.27l-0.3,-0.23l-0.29,-1.42l-0.66,-1.47l0.03,-0.76L51.4,521.69zM49.88,520.93l-0.13,0.15l-0.38,-0.91l0.55,0.08L49.88,520.93zM49.07,519.21l0.32,0.05l0.1,0.48l-0.41,-0.25l-0.59,0.08l0.06,-0.3L49.07,519.21zM127.65,507.62l-0.55,-0.15l0.35,-0.13L127.65,507.62zM75.57,469.26l1.31,1.28l4.53,1.43l1.61,-0.31l3.21,-4.08l2.44,-1.45l3.04,-0.79l2.93,0.41l2.25,2.04l6.04,1.35l0.44,0.66l0.63,2.73l2.61,3.7l0.24,4.94l0.51,2.01l1.39,2.44l1.14,0.46l6.96,0.56l2.99,1.07l2.98,-0.08l2.33,0.25l7.25,5.5l5.16,3.56l2.96,0.97l0,0l-1.68,3.15l-4.35,1.91l-1.8,1.78l-1.14,2.47l-0.21,2.29l0.11,0.99l0.63,1.6l5.22,6.4l1.23,2.11l0.17,0.68l0.1,1.45l-0.19,1.09l-1.76,4.72l0.11,0.25l-1.03,3.09l0.03,1.95l2.07,4.36l6,14.21l0.78,1.27l-1.28,1.16l-0.62,1.24l0.76,3.64l0.05,1.32l-0.41,0.48l0.06,1.49l-0.32,0.3l0.52,1.14l1,0.13l0.54,1.59l0,0l-5.7,0.25l0.32,-0.56l0.08,-1.37l-1.95,-3.24l-2.88,-1.32l-1.04,0.2l-0.35,-0.99l-0.68,-0.63l-1.42,0.15l-1.28,0.83l-0.89,0.33h-0.73l-2.44,1.49h-1.04l-1.8,-0.35l-1.28,-0.76l-3.81,-0.68l-3.8,-1.42l-0.4,-0.1l-0.21,0.18l-0.95,-1.09l-1.73,-0.51l-1.65,-1.67l0.03,-0.38l-0.81,-1.14l0.55,-0.86l-2.55,-0.79l-0.16,-1.09l-0.25,-0.1L106,551l-2.33,-1.11l-0.78,-0.86l-0.87,-0.03l-0.27,-0.48l-0.57,-0.28l-0.24,-0.56l-1.66,-1.14l-0.9,-1.52l-0.9,-0.56l-2.06,1.44l-1.84,0.15l-2.6,1.8l-1.25,-0.61l-0.22,0.13l0.17,1.29l-0.71,0.15l0.66,1.57l0.03,0.89l-0.9,1.67l-0.38,1.67L88,555.05l-0.06,0.73l-0.41,0.41l-1.8,5.06l-1.11,0.53l-3.53,-1.06l-1.35,0.71l-0.79,0.83l-1.19,-0.08L77,562.84l-1.28,0.18l-0.78,0.41l-2.69,0.18l-0.13,0.3l-0.68,-0.23l-1.68,-2.05l-1.57,-1.09l-0.19,-0.4l-2.29,-1.49l0.27,-1.09l-1.95,-0.13l-1.71,-1.11l-1.49,0.83h-1.53l-0.47,-0.23l-0.92,-0.76l-0.84,-2.94l-0.79,0.08l-0.73,-1.57l-1.66,-1.65l-2.42,-1.95l-1.12,-0.61l-4.86,-0.2l-0.89,0.84l-0.08,0.76l-0.95,0.56l-0.43,0.18l-1.01,-0.15l-0.73,0.28l-0.81,-0.2l-1.2,0.3l-1.17,-0.94L38.14,547l-0.55,0.08l-0.1,2.1l-0.79,-0.23v-0.83l-0.33,0.68l-0.19,-0.08l0.09,-0.73l-0.24,-0.08l-0.21,0.63l-0.05,0.2l1.68,0.81v0.2l-1.39,-0.33l-0.93,0.2l-0.05,0.43l-0.35,-0.23l-0.76,0.41l-0.82,-0.41l-0.4,-0.94l-1.39,-1.34l-0.93,0.08l-0.27,-0.46l-2.26,-1.57l-1.47,-1.39l-0.74,-0.96l-2.26,-4.31l-1.52,-2.18l-1.61,-1.55l-0.98,-0.25l-4.26,-3.12l-1.66,-2.23l-0.78,-0.43l-0.28,-0.81l-0.62,-0.36l0.22,-2.05l0.71,-1.95l3.4,-1.98l3.4,-2.72l2.53,-1.63l3.91,-2.34l1.27,-0.43l2.09,-1.6l4.3,-2.21l1.47,-0.28l1.87,0.43l1.41,-0.1l1.72,0.36l1.8,1.22l0.68,-0.03l4.87,-1.85l2.15,-0.48l0.74,-0.46l0.6,-3.1l0.09,-1.91l0.27,-0.15l-0.16,-0.58l-0.38,-0.08l-0.32,-0.38l1.14,-0.2l0.6,-0.94l3.18,-3.28l-0.24,-0.48l0.78,-0.2l0.96,-2.11l-0.51,-0.64l0.16,-0.2l0.62,-0.03l0.03,-2.88l-2.34,-0.74l-1.82,-1.5l-1.71,-2.65l-0.51,-1.55l-0.24,-1.55l0.06,-1.73l1.22,-2.85l1.31,-2.34l0.9,-0.99l0.93,-0.41l3.16,-1.04l1.71,-0.1l4.97,-2.04l4.08,-0.03l4.18,0.84l0.68,-3.16l0.68,-0.97L75.57,469.26zM70.04,485.62l0.54,0.13V486l-0.81,-0.23l-0.17,-0.76l-0.73,0.13l-0.71,0.51l-0.57,1.32l0.24,0.43l-4.68,3.18l-0.93,0.56l-4.57,1.6l-0.05,2.82l0.79,0.1l-0.3,1.07l-0.87,0.03l-1.31,3.18l0.32,0.08l0.52,-0.61l0.06,0.36l-1.44,1.58l1.46,0.76l-0.22,0.15l-1.36,-0.61l-0.51,0.46l0.25,1.09l-0.36,0.66l-0.14,-0.25l0.17,-0.51l-0.92,-0.76l-1.46,1.27l-0.03,0.2l0.27,0.13l-0.36,0.2l-0.11,0.74l-0.25,0.13l0.03,0.36l-0.33,0.53l-0.43,3.76l0.33,-0.1l-0.1,0.58l0.84,-0.61l0.03,0.51l1.57,-0.33l1.79,1.22h0.47l0.38,0.69l1.84,0.03l1.46,-0.91l1.14,0.18l0.7,-0.61l1.88,-0.05l0.43,-0.53l1.9,0.41l1.01,-0.96l2.96,-0.28l0.63,-0.58l1.25,-0.03l1.68,0.58l1.84,-0.61h0.74l0.62,0.79l3.05,0.56l1.69,1.8l2.61,4.55l0.52,-0.46l0.09,0.48l-0.59,0.23l0.11,0.36h0.3l0.22,0.91l0.65,1.19l0.36,0.1l-0.19,0.79l-1.04,0.66l-2.71,0.76l-1.77,2.39l-1.27,0.41l-0.59,-0.25l-1.16,-1.22l-0.24,-0.71l-1.49,-1.01l-2.75,0.63l-1.87,1.52l-2.61,-0.61l-0.14,0.15l-2.12,-1.24l-1.61,-0.2l-0.25,0.25l-0.22,-0.18l-4.23,2.46l-0.97,1.17l-2.31,1.57l-1.08,1.85l-0.49,0.3l-0.79,-1.78l0.44,-1.52l0.46,0.23l0.54,1.67l0.16,-0.05l-0.11,-0.63l-0.38,-0.53l-0.03,-0.58l-0.46,-0.33l-0.57,-1.95l-1.52,-2.13l1.9,-2.49l-0.16,-0.1l-0.38,0.46l-1.22,1.78l-0.65,0.15l-1.14,-0.71l-1.06,-1.22l-1.55,-0.76l-0.22,-0.51l-0.54,0.23l-0.7,-0.43l-1.25,-3.17l-0.11,-0.74l0.27,-0.13l0.13,-0.46l-1.22,0.3l-1.82,0.96l0.28,2.36l0.32,0.58l1.38,1.32l-0.08,0.51l0.9,0.89l0.11,0.46l1.35,0.58l1.82,1.47l0.57,0.15l1.41,2.94l0.95,2.82l2.12,3.12l0.62,0.53v0.58l0.25,-0.46l0.54,0.99l-0.35,-0.91l0.51,0.3l-0.11,-0.28l2.14,-0.43l-0.46,-0.2l-1.41,0.15l-0.46,-0.61l1.47,-0.63l0.87,-0.91l1.23,-0.25l0.08,-0.18l-0.51,-0.38l-0.11,-0.48l1.01,-1.88l0.19,-1.17l1.77,-1.14l0.76,0.05l-0.43,1.02l0.49,-0.03l0.19,-0.71l3.8,-0.08l3.23,0.43l1.28,-0.43l0.36,-0.61l0.41,-0.18l1.49,-0.23l0.25,-0.33l1.9,-0.08l0.84,0.15l1.16,0.66l0.33,0.51l-0.05,0.38l0.55,0.48l1.88,0.38l0.49,-0.23l-0.14,-0.71l0.59,-0.36l0.3,0.03l0.29,0.81l2.5,-0.69l1.41,0.48l0.36,-0.36l0.44,0.3l0.25,-0.61l0.87,-0.03l0.79,-0.51l0.97,0.43l1.28,-0.05l0.46,0.63l0.17,1.27l0.35,0.74l1.39,2l2.45,-1.07l1.84,0.33l3.53,1.27l1.57,0.79l0.32,-0.1l-0.1,1.14l0.25,0.91h0.49l-0.17,-2.03l1.14,0.71l0.82,0.1l0.66,1.34l0.52,0.08l0.11,0.3l1.93,1.34l0.87,0.91l1.17,-0.36l0.54,0.84l-0.32,1.06l0.36,1.17l0.33,0.2l0.38,0.76v0.41l-0.47,0.81l0.14,0.15l-0.27,0.33l0.35,0.35l0.33,1.06l0.41,0.2l1.11,1.6l0.24,-0.08l0.19,0.3l-0.19,0.13l1.3,2.03l0.82,0.03l1.42,3.09l1.5,0.35l3.72,2.35l0.08,-0.18l0.33,0.08l0.59,0.91l0.9,0.13l2.42,-0.41l0.81,-0.76l2.56,-1.34l0.76,-0.05l0.35,-0.46l3.05,0.53l0.47,0.25l0.3,0.48l0.78,0.23l1.74,-0.13l-0.48,-4.89l0.36,-1.22l-0.92,-6.92l-6.8,-3.07l-0.57,-0.96l-0.06,-0.61l0.89,-1.83l-1.22,-1.01l-0.3,-0.74l-1.82,-0.13l-0.57,-0.28l-0.44,0.56l-0.73,0.18l-0.25,-0.03l-0.98,-1.09l-1.33,0.51l-3.83,-0.15l-0.17,-0.23l-1.39,0.08l-0.13,-0.46l-2.72,-0.2l-0.46,-0.53l0.28,-0.43l-0.44,-0.13l0.11,-0.2l-0.24,-0.25l-0.6,0.05l-0.81,-2.16l0.24,-0.41l-1,-0.89l-0.38,0.15l-0.27,-0.3l-0.09,-1.19l-2.64,-0.48l-1.04,-0.58l0.43,-1.19l-1.01,-1.5l-1.68,-0.71l-0.63,-0.81l-0.98,-0.56l-2.17,-0.33l-0.87,-1.17l0.06,-1.32l1.01,-1.55l1.91,-0.2l-0.02,-0.2l1.06,-0.41l0.51,0.23l1.01,-0.66l0.66,0.25l2.47,-1.83l1.23,-0.08l1.14,-1.22l0.87,-0.23l0.4,0.15l0.16,-0.36l2.06,-0.64l1.25,0.41l0.84,-0.13l1.96,0.41l0.49,0.53l0.49,1.35l0.41,-0.2l0.32,0.15l1,1.02l-0.21,-0.71l1.71,0.03l2.75,-0.56l0.54,0.43l1.31,-0.1l0.19,0.18l0.27,-0.74l1.84,-0.28l0.08,-0.56h-0.73l-0.02,-0.2l1.04,-0.58l-0.06,-0.92l-0.74,-0.05l-0.74,0.48l-0.49,-0.28l-0.81,0.53l-4.68,-0.13l-1.53,-3.08l-1.33,-1.07l-0.55,-0.03l-0.6,-0.48l-0.13,-2.64l0.22,-0.38l0.7,0.28v-0.81l2.37,-2.09l1.61,0.05l2.88,0.84l1.12,0.56l0.81,0.71l2.21,0.97l2.71,1.65l-0.11,-1.32l-0.68,-1.2l-1.69,-0.99l-0.13,0.31l-0.47,0.13l-2.53,-1.58l-0.22,-0.33l0.47,-0.89l-0.09,-0.18l-0.35,-0.03l-0.73,1.02l-2.12,-0.74l0.14,-0.31l-0.32,-0.25l0.06,-0.18l0.43,0.28l2.86,-0.2l0.06,-0.51l-0.54,-0.08l0.03,-0.25l-0.33,-0.2l-1.69,0.18l-0.82,0.48l-0.1,-0.15l0.73,-0.43l1.55,-0.15l0.19,-0.41h0.21l0.03,0.31l0.47,0.05l0.11,-0.41l0.36,-0.23l-0.71,-1.88l-0.47,-0.36l-0.33,-0.64l-0.97,0.61l-5.55,0.84l-2.17,1.5l0.19,0.51l1.52,1.55l-0.27,0.76h-0.74l-0.36,0.79l0.43,0.2l-0.02,0.3l-0.25,0.31l-0.33,-0.03l-0.06,0.74l-2.17,1.35l-0.33,0.84l-1.54,1.63l-1.88,0.92l-1.49,-0.66l-1.6,0.84l-0.28,0.48l-2.14,0.79l-2.29,1.25l-2.6,0.05l-0.89,0.76L96.56,506l-1.17,-0.64l-1.99,-2.08h-0.44l-0.98,-2.01l-0.38,-0.36l-0.25,0.03l-0.81,1.27l-0.97,0.31l0.02,-0.31l-0.84,-0.08l-0.57,0.23l-3.04,-0.94l-0.19,-0.36l3.59,-3.18l1.17,-0.46l-1.31,0.33l-3.56,3.2l-0.81,0.25l0.08,-2.42l-0.78,-1.42L83.5,497l-0.41,-1.58l-0.6,-0.38l-0.79,-1.32l0.08,-1.12l-2.77,-2.62l-0.43,-0.2l-1.28,0.41l-3.91,-2.01l0.21,-0.69l-0.09,-0.84l-0.82,-1.22l-0.71,-0.38l-1,-0.15l-1.01,0.13L70.04,485.62z"
}, {
  state_name: "Noord-Brabant",
  state_code: "NLD3483",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M259.91,453.21l0.93,0.66l0.85,2.07l1.22,1.07l4.24,1.94l0.36,0.38l-0.02,0.71l0.79,0.54l0.7,1.48l1.39,1.53l0.57,0.23l1.12,-0.15l1.54,-1.63l0.92,-0.41l0.97,0.15l0.79,0.41l1.6,1.66l3.61,1.76l0.11,0.74l-0.47,1.35l-0.06,1.02l0.29,0.66l0.74,0.64l-0.7,1.04l-1.84,1.53l0.06,1.86l5.59,-1.43l2.06,-0.08l3.13,0.76l3.72,-0.82l0.9,0.1l1.14,0.48l1.65,1.48l1.16,0.43l1.01,-0.33l1.22,-1.02l1.12,-0.38l1.76,0.15l2.12,0.76l0.74,-0.05l3.18,-2.19l5,-2.29l0.79,-0.59l0.62,-1.07l0.14,-3.34l0.98,-3.26l2.75,-4.67l1.87,-2.4l0.79,-1.43l0.49,-0.41l1.3,-0.03l0.51,0.33l1.46,2.07l1.58,0.66l2.2,0.2l1.03,-0.15l1.98,-0.49l0.87,-0.61l0.68,-0.97l0.24,-1.46l0.57,-1.1l1.54,-0.66h0.59l0.98,0.51l2.44,2.43l3.29,0.82l1.01,-0.31l1.17,-1.94l0.71,-0.61l2.8,-0.2l1.92,-0.38l2.01,0.48l2.66,1.74l0.9,0.36l1.98,-0.05l0.81,0.23l1.04,1.15l0.93,2.78l1.09,1.61l1.69,1.07l2.96,0.51l1.2,1.15l1.12,1.94l0.76,0.74l3.04,0.51l0.71,0.41l1.2,1.22l0.43,0.74l-0.17,0.15l0.82,1.33l0.93,0.79l1.3,0.64l1.09,0.23l2.31,0.03l3.83,-1l7.14,-0.79l2.37,0.43l0,0l2.03,1.91l0.73,3.01l0.33,2.65l1.11,1.4l1.69,0.84l0.95,0.23l4.38,0.59l2.28,0.97l0.62,0.56l0.33,3.08l1.11,4.38l-1.25,1.93l0.06,0.87l0.57,0.58h1.72l1.01,0.46l-0.03,1.17l-1.2,2.42l0.25,1.27l0.46,0.51l3.48,2.14l3.97,3.89l0.51,1.73l-0.09,2.36l0.22,1.73l0.48,1.17l1.66,2.44l0.02,4.27l0.47,1.07l0.73,0.84l-0.06,0.28l-0.41,0.05l-0.46,0.43l-0.46,-0.38l-0.3,0.05l-0.92,0.89l-1.96,-2.44l-1.93,-1.55l-5.55,2.29l-4.86,1.57l-5.21,0.53l-2.66,-2.11l-8.4,-1.65l2.33,16.06l1.22,3.09l1.85,10.57l9.59,16.35l-9.29,7.96l-32.14,10.03l-7.04,10.02l-0.24,6.18l-0.73,4.34l-4.02,2.02l0.03,-0.55l-4.62,1.41l0,0l-0.6,-0.53l-0.71,-4.92l0.22,-1.97l-0.21,-0.96l0.22,-0.28l-0.08,-0.68l0.22,-0.66l-0.24,-1.24l-1.85,-1.31l-2.77,-3l-1.17,-1.61l-0.58,-1.46l-4.05,-1.14l-0.95,-0.08l-0.08,0.33l-0.71,0.66l-0.43,1.29l-1.65,1.51l-3.85,0.73l-0.49,1.49l-0.89,0.1l-2.6,3.46l-5.47,-1.31l-5.84,-1.71l-0.22,0.2l0.03,0.73l-0.57,1.46l-0.81,0.68l-3.51,-0.05l-3.21,0.4l-4.78,-1.21l-3.78,1.29l-0.63,-0.28l-1.44,-1.39l2.36,-8.88l-0.22,-0.63l-6.19,-4.01l-4.13,1.36l-1.77,1.39l-4.46,-1.36l-0.41,-8.26l-1.16,-0.99l-0.68,-0.91l-0.52,-1.44l-0.63,-0.88l-6.54,-7.31l3.35,-6.78l1.8,-3.06l-4.15,-9.83l-4.45,-0.13l-0.78,-0.2l-1.12,-1.93l0.08,-1.67l-0.71,-0.3l-0.46,0.13l-1.79,1.47l-0.76,1.39l-0.98,0.86l-0.57,1.57l0.41,2.91l-0.84,1.24l0.1,1.17l-6.22,5.27l-0.98,0.99l-4.57,6l-0.06,-0.86l-0.47,0.03l-0.11,0.53l0.41,0.46l-1.01,0.46l-1.14,-0.33l1.6,-0.43l-0.36,-0.46l-0.6,0.18l-0.19,-0.48l-0.98,-0.71l-0.24,-1.09l-1.01,-0.96l-0.32,-0.78l-0.51,-0.03l-0.43,0.58l-0.35,-0.68l-0.93,-0.18l0.19,-0.61l-0.49,0.13l-0.11,0.35l-1.38,-0.35l-0.11,0.35l-1.14,0.96v0.61l-0.16,0.03l-1.11,-0.38l0.02,-0.71l-0.95,-0.08l-0.48,-0.33l-0.81,0.68l-1.17,-0.53l-7.47,1.49l-1.66,-0.71l-1.11,-0.81l-0.43,-1.09l0.03,-1.09l-0.28,-1.17l0.41,-0.78l0.52,-0.15l1.72,-0.15l0.41,0.81l0.81,0.33l1.61,0.18l1.9,0.71l0.85,0.58l1.12,0.23l1.22,0.63l0.02,0.48l1.28,-0.03l-0.03,-0.3l-0.47,-0.25l1,-0.86l-0.14,-0.13l-1.06,0.43l-1.38,-0.1l-0.13,-0.2l-0.7,-2.94l0.08,-1.09l-0.41,-1.95l0.02,-0.38l0.7,-0.53l0.82,-1.24l0.14,-0.76l0.28,0.48l0.55,0.18l0.87,-0.79l-1.57,-1.19l0.6,-2.2l0.25,-2.31l-0.59,-0.33l-2.56,-0.43l-0.29,-0.66l-0.17,-1.65l-0.4,-0.56l-2.86,-1.17l-1.22,0.13l-0.92,-0.2l-0.6,-0.91l-1.31,-0.15l-1.91,0.43l-0.38,0.63l-0.87,0.13l-0.59,0.79l0.02,0.66l-0.55,1.09l-2.55,1.34l-1.25,2.51l-0.87,0.61l-0.06,0.73l-1.93,0.46l-0.68,2.1l-0.95,1.75l-1.38,0.3l-2.72,1.57l0.38,4.43l-1.63,0.53l-1.17,-0.43l-1.9,0.99l-1.74,-0.89l-8.42,-1.57l-6.31,2.35l-0.85,-6.58l2.72,-5.95l-1.68,-2.46l-7.91,1.24l-1.3,-0.2l-0.89,0.15l-1.58,1.65l-3.42,0.61l-8.7,4.81l-0.57,0.1l-0.73,0.91l0.85,0.3l1.41,-0.03l0.7,1.11l-0.17,1.14l0.47,0.43l-0.28,0.56h-0.63l0.35,1.21h-0.57l-0.19,0.58l-1,1.11l1.35,3.31l6.2,8.17l-0.87,1.04l0.82,1.72l-1.44,-0.28l-4.37,2.2l-1.82,0.33l-0.89,-0.08l-2.61,-0.66l-2.94,-0.1l-0.87,-4.2l-0.35,-0.56l-9.19,0.28l0,0l-0.54,-1.59l-1,-0.13l-0.52,-1.14l0.32,-0.3l-0.06,-1.49l0.41,-0.48l-0.05,-1.32l-0.76,-3.64l0.62,-1.24l1.28,-1.16l-0.78,-1.27l-6,-14.21l-2.07,-4.36l-0.03,-1.95l1.03,-3.09l-0.11,-0.25l1.76,-4.72l0.19,-1.09l-0.1,-1.45l-0.17,-0.68l-1.23,-2.11l-5.22,-6.4l-0.63,-1.6l-0.11,-0.99l0.21,-2.29l1.14,-2.47l1.8,-1.78l4.35,-1.91l1.68,-3.15l0,0l4.29,0.51l3.8,-0.89l2.17,-0.97l3.12,-0.66l3.29,-1.53l1.39,-0.81l1.39,-1.45l1.08,-1.78l0.38,-1.65l1.98,-1.96l0.46,-1.02l0.89,-0.03l0.44,-1.15l1.04,-0.66l2.17,-2.04l11.88,3.97l3.48,0.36l11.87,-3.26l2.5,-2.01l9.97,-2.85l4.79,-3.39l3.5,-3.11l2.01,-2.22l0.71,-1.12l1.53,-4.62l2.45,-2.91l2.37,-1.28l2.2,-0.71l2.14,-0.13l4.04,0.61l1.74,-0.38l0.93,-0.38l2.45,-1.76l2.86,-2.96l3.73,-1.86l1.77,-0.41h2.61l4.6,1.02L259.91,453.21zM248.08,547.28l0.02,0.48l0.79,-0.05l-0.28,0.2l0.16,0.28l0.6,-0.05l-0.66,1.01l-0.44,0.13l0.09,0.68l-0.33,0.15l-0.27,-0.89l0.21,-0.28l-0.08,-0.48l-0.51,0.43l-0.14,-0.28l0.25,-0.28l-0.11,-0.38l-0.87,0.53l0.59,0.71l-0.35,0.56l0.19,0.25l-0.11,0.73l-0.32,-0.05l-0.59,0.51l1.84,0.38l0.41,0.96l0.93,-0.23l0.41,0.46l0.55,-0.78v-0.66l-0.38,0.02l0.35,-0.53l0.29,0.15l0.35,-0.3l-0.33,-0.1l0.14,-0.35l-0.63,-0.13l0.02,0.33l-0.3,0.05l-0.13,-0.35l-0.19,0.18l-0.19,-0.81l0.97,0.1l-0.06,-0.68l-0.28,-0.15l-0.33,0.18l0.06,-0.46l0.28,-0.18l0.27,0.23l0.6,-0.71l0.35,-0.1l0.22,0.53l0.13,-0.35l0.68,-0.2l-0.09,-0.38l0.27,-0.23l-0.35,-0.58l-0.17,0.46l-0.57,0.28l-2.01,0.25L248.08,547.28zM250.74,548.8l0.06,0.28l1.06,-0.13l-0.71,-0.58l-0.08,0.3L250.74,548.8zM242.82,554.21l0.14,-0.2l-0.17,-0.23l-0.4,0.53L242.82,554.21zM238.64,556.79l0.02,-0.3l-0.3,0.05l0.03,0.28L238.64,556.79zM249.67,558.77l-0.16,-1.29l-0.76,0.38l-0.84,0.08l0.59,0.58l-0.66,0.56L249.67,558.77z"
}, {
  state_name: "Utrecht",
  state_code: "NLD3484",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M227.2,348.02L228.88,347.86L229.67,348.02L232.64,346.65L235.16,344.64L235.92,343.04L236.31,342.65L237.53,341.65L238.18,341.39L240.19,341.29L240.73,341.06L244.95,341.26L245.63,340.69L245.62,339.95L246.12,339.02L246.95,338.81L247.14,338.06L247.66,337.6L248.45,337.32L248.24,335.07L249.45,334.56L250.71,335.25L251.31,335.07L253.89,335.48L254.37,335.23L255.25,333.76L256.52,332.85L257.33,332.62L258.97,332.67L259.95,333.09L261.31,336.28L262.01,336.28L262.22,335.61L262.8,335.46L263.2,334.35L263.7,334.79L264.15,333.6L264.86,333.4L266.36,334.66L267.6,333.19L267.94,333.55L268.7,333.01L269.27,333.06L269.83,333.83L270.03,335.05L269.51,334.79L269.51,334.22L269.29,334.01L268.83,334.12L267.55,334.79L267.37,335.92L266.16,335.95L264.95,336.44L264.45,337.14L263.32,337.14L264.05,338.66L264.07,339.61L264.62,340.18L264.57,341.29L264.83,341.83L265.35,342.01L266.19,341.26L266.8,343.22L266.76,344.12L268.94,346.26L265.63,347.76L266.28,348.48L266.27,349.95L269.48,351.52L271.5,352.09L278.29,351.91L278.78,350.95L280.68,352.01L282.68,355.98L281.84,357.47L280.7,358.5L278.91,359.43L279.19,360.56L287.23,361.15L290.02,361.15L293.14,355.36L294.39,352.42L294.78,350.36L294.88,344.48L298.34,341.39L300.87,336.18L301.81,336.59L303.31,335.23L307.93,336.05L312.66,332.67L312.66,332.67L320.7,340.62L323.77,343.25L323.77,343.25L321.95,351.08L328.42,356.36L328.47,357.88L328.06,359.86L327.41,360.4L326.22,360.04L325.54,360.58L326.06,361.1L326.32,362.64L326.19,363.57L328.71,364.47L334.75,365.29L334.83,365.68L335.86,366.12L335.76,366.66L336.21,366.81L335.99,368.54L337.27,369.1L338.9,369.15L338.6,370.65L338.71,371.03L340.84,372.09L340.07,373.58L338.34,373.83L338.12,375.27L337.76,375.2L338.49,376.1L339.26,376.35L339.23,377.23L339.89,377.59L339.89,377.95L336.62,377.61L337.73,378.33L337.65,378.82L336.27,380.16L336.48,382.83L334.2,384.27L332.49,386.45L332.79,386.79L333.42,386.94L333.52,387.43L336.24,389.05L337.58,388.58L339.44,388.56L339.85,387.17L341.25,387.07L342.57,387.35L344.09,385.73L343.04,385.3L343.55,384.4L344.83,384.78L344.94,384.27L345.02,383.6L344.17,383.37L344.61,382.34L344.21,382.01L344.2,381.65L343.72,381.49L343.61,380.83L345.02,380.47L345.43,380.95L345.77,380.88L345.69,380.39L346.76,380.23L347.03,381.7L346.73,382.42L347.33,382.83L347.46,384.68L347.98,385.3L348.42,385.32L348.68,387.33L348.22,389.23L348.39,389.58L348,393.36L347.44,394.87L348.65,395.39L348.44,397.16L351.45,398.29L351.24,402.78L350.37,402.8L351.92,404.49L352.3,404.08L352.79,404.62L353.06,405.06L353.2,406.7L353.85,407.39L355.12,408.57L356.11,408.77L356.79,409.83L357.14,411.93L358.74,413.82L358.57,414.9L358.16,415.54L358.19,416.23L358.88,417.9L358.87,419.43L357.93,419.66L358,420.97L357.09,420.46L355.5,421.87L352.82,420.07L348.72,419.02L347.49,418.49L346.35,417.59L345.21,415.77L340.1,413.88L339.06,412.93L336.9,411.62L335.99,411.39L333.2,411.7L328.88,410.85L327.84,411.42L325.76,413.18L320.79,415.08L319.28,415.18L316.98,414.69L315.64,414.9L314.39,415.77L312.82,417.79L310.89,418.77L309.54,418.69L307.09,417.05L304.53,416.72L302.52,416.18L300.76,415.23L298.91,413.31L297.66,412.57L296.46,412.88L295.78,413.72L294.39,416.41L293.26,417.41L292.41,417.62L290.38,417.18L288.21,415.77L288.21,415.77L287.19,415.1L284.37,414.62L283.23,413.95L282.44,412.29L282.09,409.65L281.68,408.88L279.62,407.67L278.04,407.08L276.84,406.7L275.03,406.6L273.36,407.08L270.33,408.57L269.78,409.39L266.98,411.59L265.95,412.72L265.54,413.95L264.72,415.08L263.12,415.26L260.68,413.34L259.48,413.11L258.85,413.23L257.41,414.08L255.35,417L254.45,417.62L253.24,417.54L250.85,416.59L249.97,416.59L248.89,417.72L247.83,420.25L246.63,421.76L243.54,422.56L242.07,422.69L240.43,423.25L239.14,418.2L238.04,417.31L237.64,415.92L236.45,415.18L234.59,413.05L232.94,410.72L233.56,410.44L232.55,409.06L231.34,408.65L229.94,406.78L236.28,405.21L236.42,404.88L235.13,402.39L234.11,402.93L231.49,402.83L230.52,403.52L228.75,403.7L228.31,402.26L228.31,401.34L229.7,400.34L229.43,398.41L230.57,397.57L232.61,394.39L235.22,392.41L238.53,391.2L239.33,389.56L234.41,389.61L232.85,390L232.91,388.63L232.02,387.56L231.74,386.3L231.47,382.39L231.56,380.06L226.15,376.17L226.41,375.12L228.35,374.25L228.67,372.19L229.57,370.88L230.84,370.34L232.32,370.05L233.24,369.57L233.61,371.08L234.49,371.78L237.58,372.19L238.72,372.01L238.8,371.73L239.51,371.39L238.92,367.35L242.17,366.09L242.21,365.73L236.91,362.05L234.52,361.2L230,356.21L229.68,355.41L228.61,355.46L228.35,354.1L228.38,351.57L227.26,349.72z"
}, {
  state_name: "Zuid-Holland",
  state_code: "NLD3485",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M155.8,478.39l1.06,0.92l0.3,-0.15l0.46,0.13l0.17,0.48l1.11,0.59l0.05,0.38l-2.9,0.13l-1.08,-0.28l-1.09,-1.2l1.53,-0.97L155.8,478.39zM143.96,470.44l1.27,0.03l4.04,1l5.25,2.37l2.52,0.82l0.87,0.46l0.08,0.82l-3.66,1.43l-2.6,-0.1l-1.93,-0.48l-2.48,-1.45l-4.98,-3.42l-0.35,-0.43l0.14,-0.74l0.65,-0.38L143.96,470.44zM179.49,322.71l10.74,4.85l1,-1.86l2.14,-0.59l0.43,-0.03l3.88,1.65l-1.28,1.86l-1.04,2.74l-0.02,0.65l-1.47,3.2l-3.13,3.17l0.29,2.04l-1.25,6.55l-1.3,1.62l-0.09,0.49l0.16,1.31l1.08,0.88l2.33,0.54l1.68,-0.57l2.36,0.93l2.25,0.28l3.24,-0.23l5.13,-2.99l3.01,-0.18l0.4,-0.26l0.21,0.15l1.16,-1.21l1.5,-0.62l3.09,0.49l-0.22,2.94l0.57,1.26l0.08,0.93l-0.19,0.46l0.92,0.7l1.23,-1.55l1.93,-1.24l1.46,-0.33l1.38,-1.08l0.92,-1.34l1.55,-0.67l1.65,0.36l0,0l0.06,1.7l1.12,1.85l-0.03,2.52l0.25,1.37l1.08,-0.05l0.32,0.8l4.53,4.99l2.39,0.85l5.3,3.68l-0.05,0.36l-3.24,1.26l0.59,4.04l-0.71,0.33l-0.08,0.28l-1.14,0.18l-3.09,-0.41l-0.89,-0.69l-0.36,-1.52l-0.92,0.49l-1.49,0.28l-1.27,0.54l-0.9,1.31l-0.32,2.06l-1.95,0.87l-0.25,1.05l5.41,3.88l-0.09,2.34l0.27,3.9l0.28,1.26l0.89,1.08l-0.06,1.36l1.57,-0.38l4.92,-0.05l-0.81,1.64l-3.31,1.21l-2.61,1.98l-2.04,3.18l-1.14,0.85l0.27,1.92l-1.39,1v0.92l0.44,1.44l1.77,-0.18l0.97,-0.69l2.63,0.1l1.01,-0.54l1.3,2.49l-0.14,0.33l-6.35,1.56l1.41,1.87l1.2,0.41l1.01,1.38l-0.62,0.28l1.65,2.33l1.87,2.13l1.19,0.74l0.4,1.38l1.11,0.9l1.28,5.04l1.65,-0.56l1.47,-0.13l3.09,-0.79l1.2,-1.51l1.06,-2.54l1.08,-1.13h0.89l2.39,0.95l1.2,0.08l0.9,-0.62l2.06,-2.92l1.44,-0.85l0.63,-0.13l1.2,0.23l2.44,1.92l1.6,-0.18l0.82,-1.13l0.41,-1.23l1.03,-1.13l2.8,-2.2l0.55,-0.82l3.02,-1.49l1.68,-0.49l1.8,0.1l1.2,0.38l1.58,0.59l2.06,1.2l0.41,0.77l0.35,2.64l0.79,1.67l1.14,0.67l2.82,0.49l1.03,0.67l0,0l-4.57,8.71l-0.46,0.1l0.13,0.64l-2.03,2.94l0.1,1.61l-0.74,-0.36l-2.2,4.07l-0.28,2.17l-0.36,0.69l-1.69,-0.41l-1.03,0.26l-0.95,-0.28l-0.44,0.36l-0.17,1.25l-1.04,1.56l-1.11,0.61l-1.91,0.03l-1.3,0.64l-0.25,0.87l0.4,0.87l1.09,0.67l-0.59,0.56l-1.79,0.72l-0.52,0.59l-1.53,-0.61l-4,0.1l-1.8,-1.58l-0.41,0.43l0.59,1.87l-0.35,1.41l0.95,1.58l3.4,0.46l-1.03,4.98l-2.37,-0.05l0,0l-5.35,-0.79l-4.6,-1.02h-2.61l-1.77,0.41l-3.73,1M155.8,478.39l1.06,0.92l0.3,-0.15l0.46,0.13l0.17,0.48l1.11,0.59l0.05,0.38l-2.9,0.13l-1.08,-0.28l-1.09,-1.2l1.53,-0.97L155.8,478.39zM143.96,470.44l1.27,0.03l4.04,1l5.25,2.37l2.52,0.82l0.87,0.46l0.08,0.82l-3.66,1.43l-2.6,-0.1l-1.93,-0.48l-2.48,-1.45l-4.98,-3.42l-0.35,-0.43l0.14,-0.74l0.65,-0.38L143.96,470.44zM179.49,322.71l10.74,4.85l1,-1.86l2.14,-0.59l0.43,-0.03l3.88,1.65l-1.28,1.86l-1.04,2.74l-0.02,0.65l-1.47,3.2l-3.13,3.17l0.29,2.04l-1.25,6.55l-1.3,1.62l-0.09,0.49l0.16,1.31l1.08,0.88l2.33,0.54l1.68,-0.57l2.36,0.93l2.25,0.28l3.24,-0.23l5.13,-2.99l3.01,-0.18l0.4,-0.26l0.21,0.15l1.16,-1.21l1.5,-0.62l3.09,0.49l-0.22,2.94l0.57,1.26l0.08,0.93l-0.19,0.46l0.92,0.7l1.23,-1.55l1.93,-1.24l1.46,-0.33l1.38,-1.08l0.92,-1.34l1.55,-0.67l1.65,0.36l0,0l0.06,1.7l1.12,1.85l-0.03,2.52l0.25,1.37l1.08,-0.05l0.32,0.8l4.53,4.99l2.39,0.85l5.3,3.68l-0.05,0.36l-3.24,1.26l0.59,4.04l-0.71,0.33l-0.08,0.28l-1.14,0.18l-3.09,-0.41l-0.89,-0.69l-0.36,-1.52l-0.92,0.49l-1.49,0.28l-1.27,0.54l-0.9,1.31l-0.32,2.06l-1.95,0.87l-0.25,1.05l5.41,3.88l-0.09,2.34l0.27,3.9l0.28,1.26l0.89,1.08l-0.06,1.36l1.57,-0.38l4.92,-0.05l-0.81,1.64l-3.31,1.21l-2.61,1.98l-2.04,3.18l-1.14,0.85l0.27,1.92l-1.39,1v0.92l0.44,1.44l1.77,-0.18l0.97,-0.69l2.63,0.1l1.01,-0.54l1.3,2.49l-0.14,0.33l-6.35,1.56l1.41,1.87l1.2,0.41l1.01,1.38l-0.62,0.28l1.65,2.33l1.87,2.13l1.19,0.74l0.4,1.38l1.11,0.9l1.28,5.04l1.65,-0.56l1.47,-0.86l-2.86,2.96l-2.45,1.76l-0.93,0.38l-1.74,0.38l-4.04,-0.61l-2.14,0.13l-2.2,0.71l-2.37,1.28l-2.45,2.91l-1.53,4.62l-0.71,1.12l-2.01,2.22l-3.5,3.11l-4.79,3.39l-9.97,2.85l-2.5,2.01l-11.87,3.26l-3.48,-0.36l-11.88,-3.97l-2.17,2.04l-1.04,0.66l-0.44,1.15l-0.89,0.03l-0.46,1.02l-1.98,1.96l-0.38,1.65l-1.08,1.78l-1.39,1.45l-1.39,0.81l-3.29,1.53l-3.12,0.66l-2.17,0.97l-3.8,0.89l-4.29,-0.51l0,0l-2.96,-0.97l-5.16,-3.56l-7.25,-5.5l-2.33,-0.25l-2.98,0.08l-2.99,-1.07l-6.96,-0.56l-1.14,-0.46l-1.39,-2.44l-0.51,-2.01l-0.24,-4.94l-2.61,-3.7l-0.63,-2.73l-0.44,-0.66l-6.04,-1.35l-2.25,-2.04l-2.93,-0.41l-3.04,0.79l-2.44,1.45l-3.21,4.08l-1.61,0.31l-4.53,-1.43l-1.31,-1.28l0,0l2.07,-1.07l0.82,-0.79l1.44,-3.75l0.43,-1.25l-0.11,-0.61l-1.61,-3.93l-0.05,-1.58l1.22,-1.89l1.41,-1.1l1.49,-0.31l2.26,-0.87l1.82,-0.05l1.36,-0.36l4.62,-2.17l4.75,-1.81l1.79,-0.46l3.26,0.05l1.58,0.74l0.68,0.64l-1.42,-0.28l-0.22,1.12l2.06,1.25l1.01,1.2l0.78,0.33l0.22,-0.23l-0.54,-0.64l0.02,-0.46l0.7,0.18l0.51,-0.38l0.28,0.21l1.58,-1.84l-0.25,-0.28l0.16,-0.28l1.22,-0.97l1.2,-0.54l0.08,-0.89l-0.71,-1.69l-4.7,-6.98l-0.4,-0.95l0.25,-1.94l0.76,-1.1l1.82,-3.89l0.52,-0.38l-0.11,-0.79l-1.2,-1.05l-0.89,-0.38l-0.59,0.97l0.03,1.1l-0.41,-0.41h-0.17l-0.06,0.46l-0.21,-0.08l-0.4,-0.69l-1.03,-0.33l-0.7,0.56l-0.32,-0.13l-0.84,0.51l-1.06,0.1l-0.55,-0.26l-0.3,-0.54l0.17,-1.38l2.26,-7.99l0.05,-2.1l-0.22,-0.18l-0.57,0.28v-1.38l0.97,-2.25l0.68,-0.51l1.12,0.18l1.12,-1.67l0.43,-0.15l1.47,0.67l0.28,-0.21l1.17,-0.03l1.08,0.69l1.98,0.79l0.95,0.79l3.34,-2.95l2.28,-1.54l1.34,-1.15l0.73,-1l0.98,-0.69l1.76,-2.97l2.01,-2.77l12.2,-14.14l3.42,-4.37l0.03,-0.39l0.38,-0.1l0.68,0.57l0.74,-1.1l-0.21,-0.13l-0.62,0.77l-0.33,-0.28l-0.05,-0.46l3.26,-3.34l1.09,-0.8l2.58,-2.8l7.04,-9.03l4.75,-6.98l6.11,-10.64l4.43,-8.25L179.49,322.71zM110.12,449.38l-1.55,1.89l0.27,0.26l-0.3,0.89l0.1,0.54l-0.52,-0.1l0.17,0.43l-0.25,0.28l0.22,0.2l-0.1,0.25l0.25,0.08l0.74,-0.77l1.11,0.59l1.49,1.35l5.76,2.58l1.96,1.46l4.62,2.3l3.01,2.02l4.38,1.45l-0.11,0.2l0.27,0.2l0.4,-0.1l3.45,3.77l2.12,1.84l1.87,1.27l0.38,0.82l2.72,3.36l0.76,0.69l3.48,2.19l1.49,0.31l2.58,1.83l2.77,1.07l2.09,0.38l5.79,0.31l1.11,-0.13l0.47,-0.43l0.33,-0.56l0.02,-0.89l0.44,-0.03l1,-3.34l-1.22,-0.69l-0.05,-0.33l-0.33,0.18l-6.22,-3.64l-5.51,-2.55v-0.23l-0.41,-0.1l-0.02,0.23l-6.61,-1.99l-3.81,-1.43l-1.17,-0.89l-1.74,-2.45l-0.19,-0.48l0.24,-0.25l0.02,-1.61l-2.41,-2.68l-2.26,-1.25l-1.42,-0.1l-0.79,0.33l-0.6,-0.26l-3.21,-3.91l-0.63,-0.33l-0.43,-0.56l-1.27,0.18l-0.98,-0.18l-0.33,0.1l-0.24,0.46l-0.4,0.05l-1.58,-0.1l-0.68,-0.51l0.11,-0.84l-0.52,-0.13l-0.32,1.05l-0.6,-0.77l-3.77,-1.33l-1.19,-1.12l-1.19,-1.87l-2.26,1.07l-0.49,0.64L110.12,449.38z"
}, {
  state_name: "Noord-Holland",
  state_code: "NLD3486",
  url: null,
  age_casinos: null,
  age_casinos_lbl: null,
  age_poker_rooms: null,
  age_poker_rooms_lbl: null,
  age_bingo: null,
  age_bingo_lbl: null,
  age_lottery: null,
  age_lottery_lbl: null,
  age_dog_horse_racing: null,
  age_dog_horse_racing_lbl: null,
  d: "M276.62,318.81l-0.97,-0.7l-0.13,-0.34l1.01,0.52l0.25,0.36L276.62,318.81zM264.29,317.23l-0.17,-0.13l0.22,-0.36l0.57,0.03L264.29,317.23zM270.54,313.48l-0.22,-0.05l-0.02,-0.31l0.28,0.03L270.54,313.48zM261.84,311.65l-0.24,0.05l-0.02,-0.31l0.43,-0.13L261.84,311.65zM269.53,243.45l-0.17,-0.05l0.1,-0.52L269.53,243.45zM307.38,228.33l8.62,3.83l7.09,7.5l0,0l-0.36,0.26l0,0l-7.01,-7.42l-8.23,-3.59l-2.07,0.21l-0.71,-0.21l0.27,-0.36L307.38,228.33zM212.99,155.72l-0.6,0.31l-2.8,-0.24l-1.5,0.13l-3.34,0.81l-1.69,0.92l0.02,0.37l0.79,0.45l-0.55,0.55l-1.39,-0.1l-0.71,-0.55l-0.16,-0.79l0.17,-0.92l0.73,-0.76l1.57,-0.87l1.47,-1.31l1.09,-0.26h1.14l2.23,0.47l3.42,1.23L212.99,155.72zM268.4,164.24l-0.16,0.55l-0.41,-0.08l-1.57,1.26l-0.29,0.65l-0.09,1.83l1.47,-0.26l4.08,7.77l0.4,0.21l0.59,1.88l5.29,10.38l-1.52,18.28l1.22,0.08l0.67,1.17l0.87,3.63l2.34,2.14l0.54,0.83l1.55,1.54l1.17,0.39l1.77,0.03l1.41,-0.94l0.57,-0.5l1.95,-3.21l2.06,-0.05l2.41,0.31l0.68,0.39l1,0.18l0.55,0.65l1.15,0.55l0.89,0.03l0.4,-0.34l0.36,0.18l1.9,-0.57l0.43,0.5l-1.5,0.34l-0.05,0.21l2.15,-0.13l1.06,0.91l0.79,0.31l0.62,2.22l-0.46,0.6l0.35,0.73l-0.33,0.7l0.22,1.54l0.4,0.26l-0.11,1.09l2.04,1.56l0.96,0.08l0.1,0.26l-0.19,0.26l-1.01,-0.36l-0.35,0.34l0.13,1.04l-0.81,0.47l-0.36,0.57l-1.12,0.05l-0.14,0.16l0.3,0.26l-0.81,0.16l-0.05,0.26l0.79,0.65l-0.24,0.39l-0.25,-0.23l-0.44,0.03l-1.17,1.02l-2.1,0.34l-0.29,0.23l-0.43,-0.16l-1.11,0.26l-0.4,1.09l-0.11,2.08l-1.14,4.14l-0.79,1.17l-3.69,2.06l-1.01,0.99l-0.49,1.17l-1.33,0.03l-1.46,0.34l-1.14,0.65l-2.33,2.47l-2.33,0.23l-2.72,0.65l-0.52,-0.81l0.3,-1.09l-0.95,-1.43l-2.15,0.16l-1.79,-1.61l-0.84,-1.17l-2.2,0.65l-1.17,1.2l-0.41,-0.34l0.21,-0.34l-0.46,0.29l-0.9,-0.08l-0.13,0.62l0.24,0.34l-0.49,-0.16l0.14,-0.91l-0.73,-0.88l-0.93,0.03l-1.16,1.25l-1.12,0.18l-0.57,0.55l-1.06,0.52l-0.44,1.01l-0.08,1.61l0.57,3.2l-0.13,0.75l0.3,0.42l-0.14,0.55l0.29,0.68l-0.43,1.01l0.44,1.27l0.76,1.27l-0.08,0.52l0.81,2.31l-0.25,1.66l1.91,1.79l0.17,1.14l1.74,3.12l-0.11,1.53l0.73,0.78l0.95,2.02l0.14,1.17l0.68,1.19l0.7,0.03l-0.17,1.01l1.08,0.88l0.66,2.2l-1.58,2.72l-0.49,0.29l-0.27,0.52l-0.54,0.16l-0.57,-0.23l-0.47,0.62l-0.11,1.43l0.19,1.3l1.16,1.35l0.11,0.39l-0.21,0.73l-1.63,0.18l-1.09,-0.31l-1.91,0.96l-0.7,-0.41l0.55,1.32l0.59,0.23l-0.08,0.34l0.25,0.18l0.79,-1.06l0.66,-0.03l0.41,0.29l-0.81,1.66l-0.09,1.58l0.38,1.04l-0.27,1.06l0.27,0.34h0.96l0.68,0.31l1.03,-0.21l1.84,0.47l1.39,-0.08l0.25,-0.34l0.3,-3.26l0.35,-0.83l0.62,-0.67l0.36,-0.08l0.13,-0.34l-0.24,-1.35l0.24,-0.57l-1.46,-5.55l0.19,-0.26l0.3,0.03l1.52,5.24l1.23,1.14l0.13,0.52l1.87,0.05l1.08,-0.21l0.68,0.13l0.13,0.31l-1.58,0.6l-0.82,0.83l-1.35,0.18l-1.09,1.14h-1.17l-0.47,3.21L273.7,296l-0.25,0.34h-0.44l-0.09,-0.34l0.22,-0.44l-0.21,-0.13l-0.46,0.67l-0.7,0.36l-0.4,1.04l-0.21,1.5l-0.57,0.72l-0.33,1.09l-1.54,-0.31l-0.54,0.21l-0.36,0.23l-0.85,1.55l-1.36,0.54l-0.84,0.93l-1.22,3.41l-0.73,0.26l-0.41,0.62h-0.81l-0.19,0.26l0.43,0.67l-0.27,0.7l0.08,0.41l-0.44,0.75l-0.36,0.13l-0.95,-0.59l-0.51,-0.8l-1.12,0.21l-1.71,0.98l-1.39,-1.55l-0.35,0.08l-0.9,-0.9l-0.71,0.83l0.47,1.24l1.14,0.16l1.41,1.16l-0.17,0.26l-0.66,0.08l0.14,0.52l-0.52,0.54L255,312.5l-0.46,-0.18h-0.47l-0.38,0.72l0.7,0.7l1.06,0.31l0.59,0.85l0.95,0.26l0.27,0.75l0.85,0.54l0.47,0.83l0.82,0.8l0.89,0.36l1.46,0.1l0.89,-0.88l1.3,-0.16l1.12,1.09l-0.14,0.93l-0.84,0.44v0.52l0.44,0.44l0.74,-0.08l-0.29,-0.59l0.13,-0.1l1.42,0.54l2.39,-0.49l1.63,0.28l1.28,-0.93l2.28,0.34l1.6,1.01l1.39,1.24l1.69,0.26l1.19,0.59l0.76,-0.21l0.51,0.41l0,0l1.16,1.45l1.08,0.62l11,-1.88l9.73,2.45l4.65,3.07l3.81,3.77l0,0l-4.73,3.38l-4.62,-0.83l-1.5,1.37l-0.93,-0.41l-2.53,5.21l-3.47,3.09l-0.1,5.88l-0.4,2.06l-1.25,2.94l-3.12,5.79h-2.79l-8.04,-0.59l-0.28,-1.13l1.79,-0.93l1.14,-1.03l0.84,-1.49l-1.99,-3.97l-1.9,-1.06l-0.49,0.95l-6.79,0.18l-2.03,-0.57l-3.21,-1.57l0.02,-1.47l-0.65,-0.72l3.31,-1.49l-2.18,-2.14l0.05,-0.9l-0.62,-1.96l-0.84,0.75l-0.52,-0.18l-0.25,-0.54l0.05,-1.11l-0.55,-0.57l-0.02,-0.95l-0.73,-1.52h1.12l0.51,-0.7l1.2,-0.49l1.22,-0.03l0.17,-1.14l1.28,-0.67l0.46,-0.1l0.22,0.21v0.57l0.52,0.26l-0.21,-1.21l-0.55,-0.77l-0.57,-0.05l-0.76,0.54l-0.35,-0.36l-1.23,1.47l-1.5,-1.26l-0.71,0.21l-0.44,1.19l-0.51,-0.44l-0.4,1.11l-0.59,0.15l-0.21,0.67h-0.7l-1.36,-3.2l-0.98,-0.41l-1.65,-0.05l-0.81,0.23l-1.27,0.9l-0.89,1.47l-0.47,0.26l-2.58,-0.41l-0.6,0.18l-1.27,-0.7l-1.2,0.52l0.21,2.24l-0.79,0.28l-0.52,0.46l-0.19,0.75l-0.82,0.21l-0.51,0.93l0.02,0.75l-0.68,0.57l-4.23,-0.21l-0.54,0.23l-2.01,0.1l-0.65,0.26l-1.22,1.01l-0.4,0.39l-0.76,1.6l-2.52,2.01l-2.98,1.37l-0.79,-0.15l-1.68,0.15l0,0l-1.65,-0.36l-1.55,0.67l-0.92,1.34l-1.38,1.08l-1.46,0.33l-1.93,1.24l-1.23,1.55l-0.92,-0.7l0.19,-0.46l-0.08,-0.93l-0.57,-1.26l0.22,-2.94l-3.09,-0.49l-1.5,0.62l-1.16,1.21l-0.21,-0.15l-0.4,0.26l-3.01,0.18l-5.13,2.99l-3.24,0.23l-2.25,-0.28l-2.36,-0.93l-1.68,0.57l-2.33,-0.54l-1.08,-0.88l-0.16,-1.31l0.09,-0.49l1.3,-1.62l1.25,-6.55l-0.29,-2.04l3.13,-3.17l1.47,-3.2l0.02,-0.65l1.04,-2.74l1.28,-1.86l-3.88,-1.65l-0.43,0.03l-2.14,0.59l-1,1.86l-10.74,-4.85l0,0l8.78,-22.26l1.79,-5.2l0.63,-2.72l0.22,-3.32l0.81,-1.11l-0.6,-1.71l1.25,-2.69l1.82,-5.08l1.93,-9.44l2.12,-13.14l1,-9.95l1.23,-8.12l0.06,-1.87l0.87,-5.88l1.49,-13.26l1.42,-6.7l0.92,-2.4l1.36,-2.64l2.67,-9.06l3.67,-14.66l0.82,-3.79l0.7,-14.14l0.54,-2.28l1.14,-2.2l0.87,-1.07l0.55,-0.24l2.29,-0.42l0.89,0.26l1.23,-0.6l2.56,0.13l-0.13,0.58l0.57,-0.31l0.43,0.26l-0.11,0.29l-0.36,-0.21l-0.32,0.58l0.17,0.73l0.4,0.45l0.33,0.03l0.11,0.63h0.17l1.16,-0.31l-0.13,-0.76l0.68,-0.52l-0.21,-0.45l-0.48,0.34l-0.28,-0.76l1.54,-0.31l0.46,1.05l-0.06,1l-1.54,3.3l-0.44,2.17l0.25,0.24l0.06,0.6h0.41l0.11,0.76l1.76,3.95l0.44,0.6l10.35,5.94l5.14,-1.36l1.79,-1.18l3.18,-1.33l-0.16,-0.47l0.57,-0.05l2.01,-2.54l0.43,-0.94l0.25,-1.39l1.5,-1.34l2.03,-0.5l1.04,0.03l2.36,-1.1l1.84,0.52l1.33,-0.26l1.14,-0.55l0.41,0.39l0.28,-0.1l0.63,0.65l1.79,-1.34l-0.21,-0.31l0.24,-0.31l18.09,-15.67l0,0l0.65,0.87l0,0L268.4,164.24zM240.79,107.05l0.73,-0.24l0.55,0.5l1.22,1.68l1.82,3.53l-0.14,0.92l-0.44,0.05l-0.22,0.71l-0.32,-0.87l-0.41,8.21l0.32,2.42l-0.03,1.84l-0.62,1.89l-0.7,0.26l-1.9,1.6l-0.21,0.89l-1.04,0.63l-0.14,2.71l-1.25,1.71l-0.44,1.34l-0.55,0.52l-0.24,-0.39l-0.89,0.73l0.1,0.47l-0.7,1.02l-0.68,0.39l-1.23,0.5l-2.23,0.1l-0.41,0.34l-4.26,5.54l0.02,0.47l0.7,0.42l-0.46,0.66h-1.27l-0.52,-0.6l-0.43,0.31l-1.06,-0.66h-0.84l-2.34,-1.1l-0.41,0.34l0.43,0.21l0.17,0.79l1.84,0.73l0.24,0.55l1.04,0.66l0.16,0.34l-0.46,0.03l-1.06,-0.5l0.14,0.21l-1.85,0.79l0.02,0.29l0.46,0.08l-0.05,0.21l-1.58,0.52l-1.31,-0.21l-0.97,0.55l0.38,0.13l-0.44,0.5l-0.59,-0.08l-1.3,-1.21l-1.39,-2.81l-0.55,-2.86l0.25,-4.88l1.01,-5.17l0.81,-2.73l1.5,-3.68l3.02,-5.68l4.68,-7.49l1.69,-2.26l5.14,-8.4l2.15,-2.63l1.91,-1.69l1.46,-0.55h0.4l0.6,0.42l1,1.71l0.68,0.45l0.81,1.76l-0.08,1.47l0.17,0.95L240.79,107.05z"
}];
var states = [];

var getCountryCode = function getCountryCode(cn) {
  if (cn === 'NL') {
    return states = nl_states;
  } else if (cn === 'US') {
    return states = us_states;
  }
};



/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"ct-online-casino mb-24",style:({
      'background-color': _vm.$root.color_schema.primary,
    })},[_c('div',{class:{ 'container editor-content pb-25': true, 'pt-20': _vm.heightVal },attrs:{"id":"pt"}},[(_vm.usmapData && _vm.usmapData.heading && _vm.usmapData.heading != '')?[_c('TagBlock',{attrs:{"attrs":_vm.usmapData,"title":_vm.usmapData.heading,"block":'usBlock',"usTag":_vm.usmapData && _vm.usmapData.heading_tag
              ? _vm.usmapData.heading_tag
              : 'span',"sty":true}})]:_vm._e(),_vm._v(" "),(
          _vm.usmapData && _vm.usmapData.sub_heading && _vm.usmapData.sub_heading != ''
        )?[_c('TagBlock',{attrs:{"attrs":_vm.usmapData,"title":_vm.usmapData.sub_heading,"block":'usBlock',"usTag":_vm.usmapData && _vm.usmapData.subheading_tag
              ? _vm.usmapData.subheading_tag
              : 'span',"sty":true}})]:_vm._e(),_vm._v(" "),(_vm.usmapData.selected_map === 'US')?[_c('svg',{staticClass:"svg-states",attrs:{"viewBox":"0 0 959 593","width":"1240","height":"767"}},[_c('g',{attrs:{"id":"states"}},_vm._l((_vm.states),function(state){return _c('path',{key:state.state_code,attrs:{"id":state.state_code,"fill":_vm.getFillColor(state.age_casinos),"d":state.d,"data-name":state.state_code,"data-age":state.age_casinos},on:{"mouseover":_vm.setInfoBoxPosition,"mousemove":_vm.moveOnLocation}})}),0)])]:(_vm.usmapData.selected_map === 'NL')?[_c('svg',{staticClass:"svg-states",attrs:{"viewBox":"0 0 559 753","width":"1240","height":"767"}},[_c('g',{attrs:{"id":"states"}},_vm._l((_vm.states),function(state){return _c('path',{key:state.state_code,attrs:{"id":state.state_code,"title":state.state_name,"fill":_vm.getFillColor(state.age_casinos),"d":state.d,"data-name":state.state_code,"data-age":state.age_casinos},on:{"mouseover":_vm.setInfoBoxPosition,"mousemove":_vm.moveOnLocation}})}),0)])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"map__legend"},[_c('span',{staticClass:"map__legend-group"},[_c('span',{staticClass:"map__legend-color map__legend-color--green",style:({
              background: _vm.usmapData.colors ? _vm.usmapData.colors.color_18 : null,
            })}),_vm._v(" "),_c('span',{class:{
              'map__legend-age': true,
              'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
              'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
            }},[_vm._v("18")])]),_vm._v(" "),_c('span',{staticClass:"map__legend-group"},[_c('span',{staticClass:"map__legend-color map__legend-color--yellow",style:({
              background: _vm.usmapData.colors ? _vm.usmapData.colors.color_20 : null,
            })}),_vm._v(" "),_c('span',{class:{
              'map__legend-age': true,
              'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
              'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
            }},[_vm._v("20")])]),_vm._v(" "),_c('span',{staticClass:"map__legend-group"},[_c('span',{staticClass:"map__legend-color map__legend-color--purple",style:({
              background: _vm.usmapData.colors ? _vm.usmapData.colors.color_21 : null,
            })}),_vm._v(" "),_c('span',{class:{
              'map__legend-age': true,
              'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
              'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
            }},[_vm._v("21")])]),_vm._v(" "),_c('span',{staticClass:"map__legend-group"},[_c('span',{staticClass:"map__legend-color map__legend-color--unset",style:({
              background: _vm.usmapData.colors ? _vm.usmapData.colors.color_na : null,
            })}),_vm._v(" "),_c('span',{class:{
              'map__legend-age': true,
              'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
              'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
            }},[_vm._v(_vm._s(_vm.$root.i18n.n_a))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateLegalStatus),expression:"stateLegalStatus"}],staticClass:"map__tooltip",style:(_vm.infoPosition),attrs:{"id":"js-map-tooltip"}},[_c('div',{staticClass:"map__tooltip-state",style:({ color: _vm.getFillColor(_vm.$root.selectedState.age_casinos) }),attrs:{"data-age":_vm.$root.selectedState.age_casinos}},[_vm._v("\n          "+_vm._s(_vm.$root.selectedState.state_name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"map__tooltip-age"},[_vm._v("\n          "+_vm._s(_vm.$root.i18n.legal_age)+":\n          "),_c('span',{staticClass:"map__tooltip-age map__tooltip-age--suffix"},[_vm._v(_vm._s(_vm.$root.selectedState.age_casinos))])]),_vm._v(" "),(_vm.$root.selectedState.url)?[_c('a',{staticClass:"cta cta-primary custom-btn map__tooltip-button",style:({
              '--primary-btn': _vm.$root.color_schema.primary_btn,
              '--primary-btn-hover': _vm.pSBC(
                -0.2,
                _vm.$root.color_schema.primary_btn
              ),
            }),attrs:{"title":_vm.$root.selectedState.state_name,"href":_vm.$root.selectedState.url}},[_vm._v(_vm._s(_vm.$root.i18n.best_casinos_in)+"\n            "+_vm._s(_vm.$root.selectedState.state_name))])]:_c('p',{staticClass:"map__tooltip-error"},[_vm._v("\n          "+_vm._s(_vm.$root.i18n.sorry_there_are_no_casinos_available_in_this_state_yet)+".\n        ")])],2)],2)]),_vm._v(" "),(_vm.usmapData && _vm.usmapData.enable_table_data)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"editor-content"},[_c('section',{staticClass:"ct-online-table mb-24"},[(
            _vm.usmapData &&
            _vm.usmapData.table_heading &&
            _vm.usmapData.table_heading != ''
          )?[_c('TagBlock',{attrs:{"attrs":_vm.usmapData,"title":_vm.usmapData.table_heading,"block":'usBlock',"usTag":_vm.usmapData && _vm.usmapData.table_heading_tag
                ? _vm.usmapData.table_heading_tag
                : 'span',"sty":false}})]:_vm._e(),_vm._v(" "),_c('table',{staticClass:"flex-table"},[_c('thead',[_c('tr',[_c('th',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.us_states))])]),_vm._v(" "),_c('th',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.casinos))])]),_vm._v(" "),_c('th',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.poker_rooms))])]),_vm._v(" "),_c('th',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.bingo))])]),_vm._v(" "),_c('th',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.lottery))])]),_vm._v(" "),_c('th',[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.dog_horse_racing))])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.stateTopList),function(stateList,index){return _c('div',{key:index},[(index <= _vm.currentListIndex)?[_c('transition-group',{attrs:{"name":"fade","tag":"div","appear":""}},_vm._l((stateList),function(state){return _c('tr',{key:state.state_code},[_c('td',[_c('a',{attrs:{"title":state.state_name,"href":state.url}},[_vm._v(_vm._s(state.state_name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(state.age_casinos_lbl))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(state.age_poker_rooms_lbl))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(state.age_bingo_lbl))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(state.age_lottery_lbl))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(state.age_dog_horse_racing_lbl))])])}),0)]:_vm._e()],2)}),0)]),_vm._v(" "),(
            _vm.currentListIndex < _vm.stateTopList.length - 1 &&
            Object.keys(_vm.usmapData.states_data).length > _vm.stateDefaultDisplay
          )?[_c('div',{staticClass:"col-md-12 text-center ct-card-grp"},[_c('a',{staticClass:"\n                cta cta-secondary cta-promotion cta-large cta-lg-br\n                custom-btn-clr\n              ",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),attrs:{"title":_vm.$root.i18n.load_more_states},on:{"click":function($event){++_vm.currentListIndex}}},[_vm._v("\n              "+_vm._s(_vm.$root.i18n.load_more_states)+"\n            ")])])]:_vm._e(),_vm._v(" "),(
            _vm.currentListIndex === _vm.stateTopList.length - 1 &&
            Object.keys(_vm.usmapData.states_data).length > _vm.stateDefaultDisplay
          )?[_c('div',{staticClass:"col-md-12 text-center ct-card-grp"},[_c('a',{staticClass:"\n                cta cta-secondary cta-promotion cta-large cta-lg-br\n                custom-btn-clr\n              ",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),attrs:{"title":_vm.$root.i18n.load_less_states},on:{"click":function($event){_vm.currentListIndex = 0}}},[_vm._v("\n              "+_vm._s(_vm.$root.i18n.load_less_states)+"\n            ")])])]:_vm._e()],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{
      'main-content-area': true,
      'custom-background-image': _vm.$root.color_schema.site_bg_img,
    },style:({
      '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
      '--bg-color': _vm.$root.color_schema.site_bg_color,
    })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"observer",rawName:"v-observer",value:(_vm.mutationObserveDefault),expression:"mutationObserveDefault"}],class:{
        'custom-background-color': _vm.$root.color_schema.site_bg_img,
        'page-wrapper pb-25': true,
        'pt-26': _vm.mapBlock ? false : true,
      }},[_c('section',{class:{ 'ct-article': true, 'pt-26': _vm.mapBlock ? true : false },style:({
          'background-color': _vm.mapBlock ? _vm.$root.color_schema.primary : null,
        })},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.mapTemplateData.breadcrumb,"dark":_vm.mapBlock ? _vm.getContrastYIQ(_vm.$root.color_schema.primary) : true}})],1)])]),_vm._v(" "),_vm._l((_vm.blockData),function(data,index){return [(data.blockName === 'wpvcb/us-map-data' && data.filtered_content)?[_c('USMap',{key:((data.blockName) + "-" + index),attrs:{"usmapData":data.filtered_content,"heightVal":_vm.mapBlock ? false : true}})]:_vm._e(),_vm._v(" "),_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]}),_vm._v(" "),(
          _vm.morePaymentBottom &&
          _vm.blockData.length === _vm.mapTemplateData.content.blocks.length
        )?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(
          _vm.auhtorBlockdata &&
          _vm.blockData.length === _vm.mapTemplateData.content.blocks.length
        )?void 0:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(674);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("313015a2", content, true, {});

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-a8296bac]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-a8296bac]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-a8296bac]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-a8296bac]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-a8296bac]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-a8296bac]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-a8296bac]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-a8296bac]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-a8296bac]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-a8296bac]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-a8296bac]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-a8296bac]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.banner-section[data-v-a8296bac]{position:relative;padding:0 0 45px}.banner-section .img-wrapper[data-v-a8296bac]{position:absolute;left:0;top:0;bottom:0;width:100%;height:100%}.banner-section-content[data-v-a8296bac]{padding:15px 0 10px}@media (min-width:576px){.banner-section-content[data-v-a8296bac]{padding:45px 0}}@media (min-width:768px){.banner-section-content[data-v-a8296bac]{padding:20px 0}}@media (min-width:992px){.banner-section-content[data-v-a8296bac]{padding:30px 0}}@media (min-width:1200px){.banner-section-content[data-v-a8296bac]{padding:50px 0}}.banner-section-content .text_content[data-v-a8296bac]{max-width:665px;text-align:center;margin:0 auto}.banner-section-content .text_content label[data-v-a8296bac]{font-family:Helvetica;font-style:normal;font-weight:300;font-size:28px;line-height:36px;color:#fff;margin:0}@media (min-width:768px){.banner-section-content .text_content label[data-v-a8296bac]{font-size:36px;line-height:48px}}@media (min-width:992px){.banner-section-content .text_content label[data-v-a8296bac]{font-size:42px;line-height:54px}}@media (min-width:1200px){.banner-section-content .text_content label[data-v-a8296bac]{font-size:48px;line-height:62px}}.values-section[data-v-a8296bac]{padding:32px 0;background:#f1f2f3}@media (min-width:1080px){.values-section[data-v-a8296bac]{padding:64px 0}}.values-section .values-header[data-v-a8296bac]{border-bottom:1px solid #bdbdbe;font-family:Helvetica;font-weight:700;font-size:22px;line-height:25px;color:#222;padding-bottom:16px;margin-bottom:32px}@media (min-width:768px){.values-section .values-header[data-v-a8296bac]{font-size:28px;line-height:32px}}@media (min-width:992px){.values-section .values-header[data-v-a8296bac]{margin-bottom:48px}}.values-section .values-blocks-item[data-v-a8296bac]{max-width:322px;margin:0 auto 35px}@media (min-width:768px){.values-section .values-blocks-item[data-v-a8296bac]{margin:0 auto}}.values-section .values-blocks-item .value-icon[data-v-a8296bac]{display:block;min-height:150px;margin-bottom:32px}.values-section .values-blocks-item h2[data-v-a8296bac]{font-family:Helvetica;font-weight:700;font-size:22px;line-height:25px;color:#222;margin-bottom:8px}@media (min-width:768px){.values-section .values-blocks-item h2[data-v-a8296bac]{font-size:28px;line-height:32px;margin-bottom:16px}}.values-section .values-blocks-item p[data-v-a8296bac]{font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;margin:0}.fundamental-section[data-v-a8296bac]{background:#f7d42b;position:relative;padding:32px 0}@media (min-width:1080px){.fundamental-section[data-v-a8296bac]{padding:67px 0}}.fundamental-section .fundamental-img-wrapper[data-v-a8296bac]{position:absolute;left:0;top:0;bottom:0;width:100%;height:100%}.fundamental-section .fundamental-block[data-v-a8296bac]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;max-width:805px;margin:0 auto}@media (min-width:768px){.fundamental-section .fundamental-block[data-v-a8296bac]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.fundamental-section .fundamental-block-logo[data-v-a8296bac]{width:239px;min-width:239px;margin:0 auto 64px}@media (min-width:768px){.fundamental-section .fundamental-block-logo[data-v-a8296bac]{margin:auto}}.fundamental-section .fundamental-block-cont[data-v-a8296bac]{padding-left:0}@media (min-width:768px){.fundamental-section .fundamental-block-cont[data-v-a8296bac]{padding-left:55px}}@media (min-width:992px){.fundamental-section .fundamental-block-cont[data-v-a8296bac]{padding-left:105px}}.fundamental-section .fundamental-block-cont .header[data-v-a8296bac]{border-bottom:1px solid rgba(34,34,34,.2);font-family:Helvetica;font-weight:700;font-size:22px;line-height:25px;color:#222;padding-bottom:16px;margin-bottom:32px}@media (min-width:768px){.fundamental-section .fundamental-block-cont .header[data-v-a8296bac]{font-size:28px;line-height:32px}}.fundamental-section .fundamental-block-cont ul li[data-v-a8296bac]{margin-bottom:16px;font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;padding-left:42px;background:url(\"\") no-repeat left 0;background-size:27px 26px}.team-section[data-v-a8296bac]{background:#f1f2f3;padding:0 0 32px}@media (min-width:1080px){.team-section[data-v-a8296bac]{padding:0 0 64px}}.team-section .team-header[data-v-a8296bac]{border-bottom:1px solid #bdbdbe;font-family:Helvetica;font-weight:700;font-size:22px;line-height:25px;color:#222;padding-bottom:16px;margin-bottom:32px}@media (min-width:768px){.team-section .team-header[data-v-a8296bac]{font-size:28px;line-height:32px}}@media (min-width:992px){.team-section .team-header[data-v-a8296bac]{margin-bottom:48px}}.team-section .team-blocks[data-v-a8296bac]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin:0}@media (min-width:576px){.team-section .team-blocks[data-v-a8296bac]{margin:0 -1%}}@media (min-width:768px){.team-section .team-blocks[data-v-a8296bac]{margin:0 -1% -16px}}.team-section .team-blocks .team-item[data-v-a8296bac]{background:#fff;box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;padding:16px;margin:0 8px 16px;margin:0 0 16px;width:100%;max-width:none}@media (min-width:576px){.team-section .team-blocks .team-item[data-v-a8296bac]{margin:0 1% 16px;width:48%}}@media (min-width:768px){.team-section .team-blocks .team-item[data-v-a8296bac]{width:32%;max-width:298px}}@media (min-width:992px){.team-section .team-blocks .team-item[data-v-a8296bac]{width:23%}}.team-section .team-blocks .team-item .team-pic[data-v-a8296bac]{-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;overflow:hidden;height:auto;margin-bottom:24px}@media (min-width:576px){.team-section .team-blocks .team-item .team-pic[data-v-a8296bac]{height:261px}}.team-section .team-blocks .team-item .team-pic img[data-v-a8296bac]{width:100%;height:100%;object-fit:cover;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px}.team-section .team-blocks .team-item .tm-title[data-v-a8296bac]{font-family:Helvetica;font-weight:700;font-size:22px;line-height:25px;color:#222;margin-bottom:8px}.team-section .team-blocks .team-item .department[data-v-a8296bac]{font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#222;margin:0}.timeline-section[data-v-a8296bac]{background:#222;padding:32px 0 74px}@media (min-width:1080px){.timeline-section[data-v-a8296bac]{padding:64px 0 100px}}.timeline-section .timeline-header[data-v-a8296bac]{border-bottom:1px solid #bdbdbe;font-family:Helvetica;font-weight:700;font-size:22px;line-height:25px;color:#fff;padding-bottom:16px;margin-bottom:32px}@media (min-width:768px){.timeline-section .timeline-header[data-v-a8296bac]{font-size:28px;line-height:32px}}@media (min-width:992px){.timeline-section .timeline-header[data-v-a8296bac]{margin-bottom:48px}}.timeline-block[data-v-a8296bac]{width:100%;max-width:788px;margin:0 auto;position:relative;padding-left:20px}@media (min-width:640px){.timeline-block[data-v-a8296bac]{padding-left:0}}.timeline-block[data-v-a8296bac]:after{width:3px;height:100%;position:absolute;background:#f1f2f3;top:0;left:20px;content:\"\";transform:translateX(-50%);-o-transform:translateX(-50%);-ms-transform:translateX(-50%);-moz-transform:translateX(-50%);-webkit-transform:translateX(-50%)}@media (min-width:640px){.timeline-block[data-v-a8296bac]:after{left:50%}}.timeline-block[data-v-a8296bac]:before{width:31px;height:31px;background:transparent;border:3px solid #f1f2f3;content:\"\";position:absolute;bottom:-35px;left:0;border-radius:50%}@media (min-width:640px){.timeline-block[data-v-a8296bac]:before{left:50%;transform:translateX(-50%);-o-transform:translateX(-50%);-ms-transform:translateX(-50%);-moz-transform:translateX(-50%);-webkit-transform:translateX(-50%)}}.timeline-block li[data-v-a8296bac]{width:100%;color:#fff;position:relative;z-index:2;padding-bottom:48px}@media (min-width:640px){.timeline-block li[data-v-a8296bac]{width:50%}}.timeline-block li[data-v-a8296bac]:after{width:31px;height:31px;background:var(--li-color);border:3px solid var(--primary-color);content:\"\";position:absolute;top:-5px;left:-18.5px;border-radius:50%}.timeline-block li[data-v-a8296bac]:before{width:3px;height:100%;position:absolute;background:var(--li-color);top:0;left:0;content:\"\";transform:translateX(-50%);-o-transform:translateX(-50%);-ms-transform:translateX(-50%);-moz-transform:translateX(-50%);-webkit-transform:translateX(-50%)}.timeline-block li[data-v-a8296bac]:nth-child(odd){margin-left:auto;padding-left:24px}.timeline-block li[data-v-a8296bac]:nth-child(2n+2){padding-right:0;padding-left:24px;text-align:left}@media (min-width:640px){.timeline-block li[data-v-a8296bac]:nth-child(2n+2){padding-right:24px;text-align:right}}.timeline-block li[data-v-a8296bac]:nth-child(2n+2):after{left:-18.5px;right:auto}@media (min-width:640px){.timeline-block li[data-v-a8296bac]:nth-child(2n+2):after{left:auto;right:-18.5px}}.timeline-block li[data-v-a8296bac]:nth-child(2n+2):before{left:0;right:auto}@media (min-width:640px){.timeline-block li[data-v-a8296bac]:nth-child(2n+2):before{left:auto;right:-3px}}.timeline-block li[data-v-a8296bac]:last-child{padding-bottom:15px}@media (min-width:640px){.timeline-block li[data-v-a8296bac]:last-child{padding-bottom:10px}}.timeline-block li[data-v-a8296bac]:last-child:before{background:#f1f2f3}.timeline-block li .date[data-v-a8296bac]{font-family:Helvetica;font-weight:700;font-size:16px;line-height:26px;color:#ffd03a;display:block;margin-bottom:11px}.timeline-block li h4[data-v-a8296bac]{font-family:Helvetica;font-weight:700;font-size:22px;line-height:25px;color:#fff;margin-bottom:16px}.timeline-block li p[data-v-a8296bac]{font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#fff;margin-bottom:0}.casino-header[data-v-a8296bac]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-a8296bac]{text-align:center;color:#fff;font-weight:700;font-size:16px;line-height:150%;padding:8px}@media (min-width:576px){.casino-header h2[data-v-a8296bac]{font-size:28px}}.stripe[data-v-a8296bac]{text-align:center}.stripe p[data-v-a8296bac]{font-size:12px;font-weight:700;line-height:20px}.stripe[data-v-a8296bac]{position:absolute;width:100%;height:20px;bottom:0;top:50%;transform:translateY(27px);left:0;overflow:hidden;border-bottom-left-radius:10px;border-bottom-right-radius:10px;background-color:#ffd039;display:none}@media (min-width:576px){.stripe[data-v-a8296bac]{display:block}}.stripe img[data-v-a8296bac]{width:18px!important;height:14px!important;border-radius:0!important;object-fit:contain!important}.stripe img[data-v-a8296bac],.stripe svg[data-v-a8296bac]{display:block;margin:3px auto;width:15px}", ""]);

// exports


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):_c('main',{directives:[{name:"observer",rawName:"v-observer:subtree",value:(_vm.mutationObserve),expression:"mutationObserve",arg:"subtree"}],staticClass:"main-content-area"},[_c('section',{},[(
        (_vm.pageBlockData1 && _vm.pageBlockData1.length > 0) ||
        (_vm.pageBlockData2 && _vm.pageBlockData2.length > 0) ||
        (_vm.pageBlockData3 && _vm.pageBlockData3.length > 0)
      )?[_vm._l((_vm.pageBlockData1),function(block,index1){return _c('div',{key:("fi+" + index1)},[(block.blockName === 'header_section')?_c('div',{staticClass:"banner-section pt-26"},[_c('div',{staticClass:"img-wrapper",style:({
              background: ("url('" + (block.data.image ? block.data.image : '') + "'), " + (_vm.$root.color_schema.primary)),
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            })}),_vm._v(" "),_c('div',{staticClass:"container"},[(_vm.breadcrumb && _vm.breadcrumb.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadcrumb,"dark":_vm.getContrastYIQ(_vm.$root.color_schema.primary)}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"banner-section-content"},[_c('div',{staticClass:"text_content"},[_c('label',[_vm._v(" “"+_vm._s(block.data.text)+"” ")])])])])]):(
            block.blockName === 'values_section' &&
            Object.keys(block.data.items).length > 0
          )?_c('div',{staticClass:"values-section"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"values-header"},[_vm._v(_vm._s(_vm.$root.i18n.our_values))]),_vm._v(" "),_c('div',{staticClass:"row values-blocks"},_vm._l((block.data.items),function(val,indx){return _c('div',{key:indx,staticClass:"col-md-4"},[_c('div',{staticClass:"values-blocks-item text-center"},[_c('span',{staticClass:"value-icon"},[_c('img',{attrs:{"src":val.icon,"alt":_vm.getAltText('', val.icon)}})]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(val.title))]),_vm._v(" "),_c('p',[_vm._v("\n                    "+_vm._s(val.text)+"\n                  ")])])])}),0)])]):(block.blockName === 'fundamentals_section')?_c('div',{staticClass:"fundamental-section editor-content"},[_c('div',{staticClass:"fundamental-img-wrapper",style:({
              background: ("url('" + (block.data.background_image ? block.data.background_image : '') + "')"),
              backgroundColor: '#f2d93700',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            })}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"fundamental-block"},[_c('div',{staticClass:"fundamental-block-logo"},[_c('img',{attrs:{"src":block.data.logo,"alt":_vm.getAltText('', block.data.logo)}})]),_vm._v(" "),_c('div',{staticClass:"fundamental-block-cont"},[_c('h2',{staticClass:"header"},[_vm._v(_vm._s(_vm.$root.i18n.our_fundamentals))]),_vm._v(" "),_c('div',{class:{
                    'tick-div-green':
                      block.data.list_style === 'green' &&
                      block.data.list_content.indexOf('ul') > 0,
                    'tick-div-blue':
                      block.data.list_style === 'blue' &&
                      block.data.list_content.indexOf('ul') > 0,
                  },domProps:{"innerHTML":_vm._s(block.data.list_content)}})])])])]):_vm._e()])}),_vm._v(" "),_c('div',{class:{ 'custom-background-image': _vm.$root.color_schema.site_bg_img },style:({
          '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
          '--bg-color': _vm.$root.color_schema.site_bg_color,
        })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{class:{
            'custom-background-color': _vm.$root.color_schema.site_bg_img,
            'pb-25': _vm.pageBlockData2.length > 0,
            'pt-26': !_vm.pageBlockData1,
          }},[(_vm.pageBlockData2.length > 0)?_c('section',{class:{ 'ct-card-horizontal-game': _vm.pageBlockData1 }},[_vm._l((_vm.pageBlockData2),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]}),_vm._v(" "),(
                _vm.auhtorBlockdata && _vm.pageBlockData2.length === _vm.blockData2.length
              )?void 0:_vm._e()],2):_vm._e()])]),_vm._v(" "),_vm._l((_vm.pageBlockData3),function(block,index3){return _c('div',{key:("th+" + index3)},[(
            block.blockName === 'teams_section' &&
            Object.keys(block.data.teams).length > 0
          )?_c('div',{staticClass:"team-section"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"team-header"},[_vm._v(_vm._s(_vm.$root.i18n.our_teams))]),_vm._v(" "),_c('div',{staticClass:"team-blocks"},_vm._l((block.data.teams),function(team,intm){return _c('div',{key:intm,staticClass:"team-item"},[_c('div',{staticClass:"team-pic"},[_c('img',{attrs:{"src":team.user.user_avatar_url,"alt":_vm.getAltText('', team.user.user_avatar_url)}})]),_vm._v(" "),_c('h4',{staticClass:"tm-title"},[_vm._v(_vm._s(team.user.display_name))]),_vm._v(" "),_c('p',{staticClass:"department"},[_vm._v(_vm._s(team.role_title))])])}),0)])]):(
            block.blockName === 'timeline_section' &&
            Object.keys(block.data.timelines).length > 0
          )?_c('div',{staticClass:"timeline-section",style:({
            background: ("url('" + (block.data.background_image ? block.data.background_image : '') + "'), " + (block.data.background_color && block.data.background_color != ''
                ? block.data.background_color
                : _vm.$root.color_schema.primary)),
          })},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"timeline-header"},[_vm._v(_vm._s(_vm.$root.i18n.our_timeline))]),_vm._v(" "),_c('ul',{staticClass:"timeline-block"},_vm._l((block.data.timelines),function(timeline,timein){return _c('li',{key:timein,style:({
                  '--li-color': block.data.timeline_color,
                  '--primary-color': _vm.$root.color_schema.footer_bg,
                })},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(timeline.date))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(timeline.title))]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(timeline.text)+"\n                ")])])}),0)])]):_vm._e()])})]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(677);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("183829c4", content, true, {});

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-713899e7]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-713899e7]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-713899e7]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-713899e7]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-713899e7]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-713899e7]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-713899e7]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-713899e7]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-713899e7]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-713899e7]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-713899e7]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-713899e7]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-article[data-v-713899e7]{padding-bottom:15px}.ct-article h1[data-v-713899e7]{margin:0!important}.ct-card-horizontal[data-v-713899e7]{padding:0}.casino-header[data-v-713899e7]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-713899e7]{text-align:center;color:#fff;font-weight:700;padding:8px}.casino-header-home[data-v-713899e7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:10px 0}.casino-header-home .casino-inner[data-v-713899e7]{color:#fff;text-align:center;padding:0 20px;border-right:1px solid #fff;-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;display:none}.casino-header-home .casino-inner[data-v-713899e7]:last-child{border-right:0;display:block}.casino-header-home .casino-inner h2[data-v-713899e7]{color:#fff;border-right:0;font-weight:700;padding:0 8px}.casino-header-home .casino-inner img[data-v-713899e7]{vertical-align:top;margin-right:8px;margin-top:3px}@media (min-width:768px){.casino-header-home .casino-inner[data-v-713899e7]{display:block}}.progressive-content-box[data-v-713899e7]{margin:0!important}.ct-editor-section[data-v-713899e7]{padding:7px 0}.pt-20[data-v-713899e7]{padding-top:20px}", ""]);

// exports


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdventCalendar_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbf4a916_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdventCalendar_vue__ = __webpack_require__(681);
function injectStyle (ssrContext) {
  __webpack_require__(679)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dbf4a916"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdventCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbf4a916_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdventCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(680);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("150b330c", content, true, {});

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-dbf4a916]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-dbf4a916]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-dbf4a916]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-dbf4a916]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-dbf4a916]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-dbf4a916]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-dbf4a916]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-dbf4a916]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-dbf4a916]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-dbf4a916]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-dbf4a916]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-dbf4a916]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.advent-calendar-section[data-v-dbf4a916]{background-size:100% auto;padding:22px 0}@media (min-width:768px){.advent-calendar-section[data-v-dbf4a916]{padding:13px 0}}@media (min-width:1200px){.advent-calendar-section[data-v-dbf4a916]{padding:49px 0}}.advent-calendar-section .container[data-v-dbf4a916]{padding:0 15px}.advent-header[data-v-dbf4a916]{margin-bottom:23px}@media (min-width:768px){.advent-header[data-v-dbf4a916]{margin-bottom:27px}}@media (min-width:1200px){.advent-header[data-v-dbf4a916]{margin-bottom:49px}}.advent-header .span-h1[data-v-dbf4a916]{text-align:center;font-family:cinzel;color:#ebe2d0;margin-bottom:0}.advent-header span[data-v-dbf4a916]{text-align:center}.advent-header p[data-v-dbf4a916]{text-align:center;color:#fff;margin-bottom:0}.advent-cards-wrapper[data-v-dbf4a916]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;padding:0;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:308px;margin:0 auto}@media (min-width:576px){.advent-cards-wrapper[data-v-dbf4a916]{width:460px}}@media (min-width:768px){.advent-cards-wrapper[data-v-dbf4a916]{padding:0 32px;width:755px}}@media (min-width:992px){.advent-cards-wrapper[data-v-dbf4a916]{padding:0;width:890px}}@media (min-width:1200px){.advent-cards-wrapper[data-v-dbf4a916]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:1184px}}@media (min-width:1280px){.advent-cards-wrapper[data-v-dbf4a916]{margin:0 -10px;width:1240px}}.advent-cards-wrapper-outer[data-v-dbf4a916]{display:none}@media (max-width:768px){.advent-cards-wrapper-outer[data-v-dbf4a916]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;padding:0;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}}@media (max-width:768px) and (min-width:768px){.advent-cards-wrapper-outer[data-v-dbf4a916]{padding:0 32px}}@media (max-width:768px) and (min-width:992px){.advent-cards-wrapper-outer[data-v-dbf4a916]{padding:0}}@media (max-width:768px) and (min-width:1200px){.advent-cards-wrapper-outer[data-v-dbf4a916]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}}@media (max-width:768px) and (min-width:1280px){.advent-cards-wrapper-outer[data-v-dbf4a916]{margin:0 -10px}}.advent-card[data-v-dbf4a916]{width:140px;height:140px;border:3px solid #f8efd3;filter:drop-shadow(0 5px 15px rgba(0,0,0,.05));-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;position:relative;background-size:cover;margin:0 6px 12px;overflow:hidden}@media (min-width:768px){.advent-card[data-v-dbf4a916]{margin:0 8px 14px;width:156px;height:156px}}@media (min-width:992px){.advent-card[data-v-dbf4a916]{width:282px;height:282px;margin:0 7px 14px}}@media (min-width:1280px){.advent-card[data-v-dbf4a916]{margin:0 10px 20px;width:290px;height:290px}}.advent-card .ring[data-v-dbf4a916]{background-size:cover;width:101px;height:95px;position:absolute;left:0;right:0;top:0;bottom:0;margin:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (min-width:768px){.advent-card .ring[data-v-dbf4a916]{width:120px;height:113px}}@media (min-width:992px){.advent-card .ring[data-v-dbf4a916]{width:223px;height:210px}}.advent-card .ring span[data-v-dbf4a916]{font-family:var(--default-regular);font-weight:800;font-size:48px;line-height:60px;text-align:center;color:#fff}@media (min-width:992px){.advent-card .ring span[data-v-dbf4a916]{font-size:96px;line-height:120px}}.advent-card-yellow[data-v-dbf4a916]{background:#fff9e8;border:2px solid #ebe2d0}.advent-card-yellow .advent-card-bg[data-v-dbf4a916]{position:absolute;z-index:-1;top:0;left:0;bottom:0;right:0;overflow:hidden}.advent-card-yellow .advent-card-bg img[data-v-dbf4a916]{width:100%;height:100%;object-fit:cover}.advent-card-yellow .advent-card-content[data-v-dbf4a916]{padding:15px 10px 5px;text-align:center}@media (min-width:420px){.advent-card-yellow .advent-card-content[data-v-dbf4a916]{padding:17px 10px 5px}}.advent-card-yellow .advent-card-content .ribbon[data-v-dbf4a916]{position:absolute;left:0;top:0;max-width:154px}@media (min-width:576px){.advent-card-yellow .advent-card-content .ribbon[data-v-dbf4a916]{max-width:250px}}@media (min-width:768px){.advent-card-yellow .advent-card-content .ribbon[data-v-dbf4a916]{max-width:307px}}@media (min-width:992px){.advent-card-yellow .advent-card-content .ribbon[data-v-dbf4a916]{max-width:154px}}.advent-card-yellow .advent-card-content .cas-logo[data-v-dbf4a916]{display:block!important;margin:0 auto 5px;width:74px;height:74px;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;border:1px solid #decd89}.advent-card-yellow .advent-card-content .cas-logo img[data-v-dbf4a916]{-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.advent-card-yellow .advent-card-content .cas-title[data-v-dbf4a916]{display:inline-block;font-weight:700;font-size:16px;line-height:160%;color:#decd89}@media (min-width:420px){.advent-card-yellow .advent-card-content .cas-title[data-v-dbf4a916]{font-size:16px;line-height:160%}}.advent-card-yellow .advent-card-content .bonus[data-v-dbf4a916]{font-weight:400;font-size:14px;line-height:21px;color:#fff;display:block}.advent-card-yellow .advent-card-content .bonus-amt[data-v-dbf4a916]{font-weight:700;font-size:24px;line-height:23px;color:#fff;margin-bottom:8px;display:inline-block;max-width:255px}@media (min-width:420px){.advent-card-yellow .advent-card-content .bonus-amt[data-v-dbf4a916]{margin-bottom:10px}}@media (min-width:992px){.advent-card-yellow .advent-card-content .bonus-amt[data-v-dbf4a916]{max-width:none}}@media (min-width:992px){.advent-card-yellow .advent-card-content .div-tt[data-v-dbf4a916]{line-height:13px}}.advent-card-yellow .advent-card-content .tc-text[data-v-dbf4a916]{font-weight:400;font-size:12px;line-height:160%;color:#fff;margin:0}@media (min-width:992px){.advent-card-yellow .advent-card-content .tc-text[data-v-dbf4a916]{line-height:12px}}@media (min-width:1280px){.advent-card-yellow .advent-card-content .tc-text[data-v-dbf4a916]{line-height:12px}}.advent-card-yellow .advent-card-content .cta-play[data-v-dbf4a916]{display:block;width:100%;background:#fe4646;box-shadow:0 2px 4px rgba(0,0,0,.2);-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;font-weight:700;font-size:18px;line-height:22px;text-align:center;color:#fff;padding:8px;margin:0 auto 10px;max-width:525px}.advent-card-yellow .advent-card-content .cta-play[data-v-dbf4a916]:focus,.advent-card-yellow .advent-card-content .cta-play[data-v-dbf4a916]:hover{opacity:.7}@media (min-width:992px){.advent-card-yellow .advent-card-content .cta-play[data-v-dbf4a916]{max-width:none;margin:0 auto 2px}}@media (min-width:1280px){.advent-card-yellow .advent-card-content .cta-play[data-v-dbf4a916]{margin:0 auto 10px}}.advent-card-yellow .advent-card-content .offer-meta-bg[data-v-dbf4a916]{position:absolute;z-index:-1;left:-3px;top:-3px;right:-3px;bottom:-3px;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;overflow:hidden}.advent-card-yellow .advent-card-content .offer-meta-bg[data-v-dbf4a916]:before{content:\"\";position:absolute;height:100%;width:100%;top:0;left:0;background:linear-gradient(180deg,rgba(0,0,0,.4),rgba(0,0,0,.6));z-index:0}.advent-card-yellow .advent-card-content .offer-meta[data-v-dbf4a916]{display:-webkit-box;display:-ms-flexbox;display:flex}.advent-card-yellow .advent-card-content .offer-meta-logo[data-v-dbf4a916]{height:50px;width:50px;min-width:50px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;overflow:hidden}.advent-card-yellow .advent-card-content .offer-meta-logo .partner-logo[data-v-dbf4a916]{display:block}.advent-card-yellow .advent-card-content .offer-meta-logo .partner-logo img[data-v-dbf4a916]{width:100%;height:100%;object-fit:cover;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.advent-card-yellow .advent-card-content .offer-meta-title[data-v-dbf4a916]{font-size:14px;line-height:150%;font-weight:700;margin-left:8px;color:#fff;text-align:left}.advent-card-yellow .advent-card-content .offer-meta-title .partner-name[data-v-dbf4a916]{color:#fff}.advent-card-yellow .advent-card-content .offer-meta-bonus[data-v-dbf4a916]{width:100%;margin:10px auto;padding:10px 12px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;border:2px dashed #fff}.advent-card-yellow .advent-card-content .offer-meta-bonus .card-tags[data-v-dbf4a916]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:10px}.advent-card-yellow .advent-card-content .offer-meta-bonus .card-tags .promotion-tag[data-v-dbf4a916]{background:#ffd039;text-align:center;font-weight:600;-webkit-border-radius:100px;-moz-border-radius:100px;border-radius:100px;padding:6px;font-size:12px;line-height:8px;margin:0 3px}.advent-card-yellow .advent-card-content .offer-meta-bonus .bonus-text[data-v-dbf4a916]{font-size:16px;line-height:18px;width:100%;margin:0 auto;display:block;text-align:center;color:#fff}.advent-card-yellow .advent-card-content .offer-meta-bonus .partner-name[data-v-dbf4a916]{color:#fff!important}.advent-card-yellow .advent-card-content .offer-meta-bonus .partner-name span.bonus-text[data-v-dbf4a916]{color:#fff}.advent-card-yellow .advent-card-content .timer-text[data-v-dbf4a916]{margin:10px auto;display:block;text-align:center;font-size:14px;line-height:15px;color:#fe4646;white-space:normal}.advent-card-yellow .advent-card-content .timer-text svg[data-v-dbf4a916]{vertical-align:text-bottom;margin-right:6px}.advent-card-yellow .advent-card-content .terms[data-v-dbf4a916]{padding:5px 11px;background:rgba(239,241,245,.1);margin:0;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;left:0;right:0;bottom:0;width:auto}.advent-card-yellow .advent-card-content .terms span[data-v-dbf4a916]{font-size:12px;line-height:160%;color:#fff}.advent-card .overlay[data-v-dbf4a916]{position:absolute;content:\"\";left:-3px;top:-3px;right:-3px;bottom:-3px;display:block;background:rgba(41,53,90,.8);-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px}.advent-card-big[data-v-dbf4a916]{width:290px;height:290px;margin:0 auto 14px}@media (min-width:576px){.advent-card-big[data-v-dbf4a916]{width:100%;height:290px;margin:0 8px 14px}}@media (min-width:992px){.advent-card-big[data-v-dbf4a916]{width:282px;height:282px;margin:0 7px 14px}}@media (min-width:1280px){.advent-card-big[data-v-dbf4a916]{width:290px;height:290px;margin:0 7px 14px}}.advent-card-mobile[data-v-dbf4a916]{display:none}@media (min-width:992px){.advent-card-mobile[data-v-dbf4a916]{display:block}}.advent-bonus[data-v-dbf4a916]{display:flex;justify-content:center;align-items:center}.advent-promo-card[data-v-dbf4a916]{display:none}.advent-promo-card-up-bg img[data-v-dbf4a916]{z-index:1}.span-h1[data-v-dbf4a916]{color:#fff!important}.current-no-active[data-v-dbf4a916]{display:none}@media (min-width:769px){.current-no-active[data-v-dbf4a916]{display:block}}.ring-title[data-v-dbf4a916]{position:absolute;top:50%;left:50%;font-size:48px;line-height:60px;font-weight:800;color:#424f5a;font-family:DM Serif Display;transform:translate(-50%,-50%)}@media (min-width:992px){.ring-title[data-v-dbf4a916]{font-size:173px;line-height:120px}}", ""]);

// exports


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.adventCalendarData.data).length > 0)?_c('section',{staticClass:"advent-calendar-section",style:({
    background: ("url('" + (_vm.adventCalendarAttrs.feast_background) + "'), " + (_vm.$root.color_schema.secondary)),
  })},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[(_vm.activeBreadcrumb)?_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.adventCalendarBreadcrumbs,"dark":false}})],1):_vm._e(),_vm._v(" "),(
          _vm.adventCalendarAttrs && Object.keys(_vm.adventCalendarAttrs).length > 0
        )?_c('div',{staticClass:"advent-header"},[(_vm.adventCalendarAttrs.feast_heading)?_c('span',{class:{
            'span-h1': true,
            'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
            'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
          }},[_vm._v(_vm._s(_vm.adventCalendarAttrs.feast_heading))]):_vm._e(),_vm._v(" "),(_vm.adventCalendarAttrs.feast_sub_heading)?_c('p',{staticClass:"custom-font-2"},[_vm._v("\n          "+_vm._s(_vm.adventCalendarAttrs.feast_sub_heading)+"\n        ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"advent-cards-wrapper-outer"},_vm._l((_vm.currentData),function(data,index){return _c('div',{key:index,class:{
            'advent-card advent-card-yellow': true,
            'advent-card-big':
              _vm.getTimeStamp(data.Ymd, 'addate') === _vm.getTimeStamp('', 'today'),
            'advent-card-mobile':
              _vm.getTimeStamp(data.Ymd, 'addate') < _vm.getTimeStamp('', 'today'),
            'advent-promo-card':
              _vm.getTimeStamp(data.Ymd, 'addate') < _vm.getTimeStamp('', 'today') &&
              _vm.getTimeStamp(data.Ymd, 'addate') < _vm.getTimeStamp('', 'today', 2),
            'not-active':
              !_vm.getTimeStamp(data.Ymd, 'addate') <= _vm.getTimeStamp('', 'today'),
          }},[(
              data.type === 'partner' &&
              Object.keys(data.partner_information).length > 0
            )?[_c('div',{class:{
                'advent-card-bg': true,
                'advent-promo-card-up-bg': !(
                  _vm.getTimeStamp(data.Ymd, 'addate') <=
                  _vm.getTimeStamp('', 'today')
                ),
              }},[(
                  !(
                    _vm.getTimeStamp(data.Ymd, 'addate') <=
                    _vm.getTimeStamp('', 'today')
                  )
                )?[(_vm.adventCalendarAttrs.card_coming_soon_image)?_c('img',{attrs:{"src":_vm.adventCalendarAttrs.card_coming_soon_image,"alt":"\n                 Advent card bg image\n                "}}):_vm._e()]:[(_vm.adventCalendarAttrs.feast_card_background)?_c('img',{attrs:{"src":_vm.adventCalendarAttrs.feast_card_background,"alt":"\n                 Advent card bg image\n                "}}):_vm._e()]],2),_vm._v(" "),_c('div',{class:{
                'advent-card-content': true,
                'advent-promo-card': !(
                  _vm.getTimeStamp(data.Ymd, 'addate') <=
                  _vm.getTimeStamp('', 'today')
                ),
              }},[(data.partner_information.go_link)?_c('a',{staticClass:"cas-logo partner-logo pt-100 cas-link",attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                    data.partner_information.go_link,
                    data.partner_information.slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[(
                    _vm.assetsSize &&
                    _vm.assetsSize.pro_asset_sizes &&
                    data.partner_information.product_assets &&
                    data.partner_information.product_assets.length > 0
                  )?_c('img',{attrs:{"src":data.partner_information.product_assets
                      .filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assetsSize.pro_asset_sizes.medium; }
                      )
                      .shift().url,"alt":_vm.getAltText(
                      data.partner_information.product_name,
                      data.partner_information.product_assets
                        .filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assetsSize.pro_asset_sizes.medium; }
                        )
                        .shift().url
                    )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-promo"},[_c('div',{staticClass:"partner-hover-inner",style:({
                      '--primary-btn': _vm.$root.color_schema.primary_btn,
                      '--primary-btn-hover': _vm.pSBC(
                        -0.2,
                        _vm.$root.color_schema.primary_btn
                      ),
                    })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]):_vm._e(),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(data.partner_information.review_link)?_c('a',{staticClass:"cas-title custom-font-1 text-hover",attrs:{"title":data.partner_information.product_name,"href":_vm.getRouteLink(
                      data.partner_information.review_link,
                      'review'
                    )}},[_vm._v(_vm._s(data.partner_information.product_name))]):_c('span',{staticClass:"cas-title custom-font-1"},[_vm._v(_vm._s(data.partner_information.product_name))])]:[(data.partner_information.review_link)?_c('router-link',{staticClass:"cas-title custom-font-1 text-hover",attrs:{"title":data.partner_information.product_name,"to":_vm.getRouteLink(
                      data.partner_information.review_link,
                      'review'
                    )}},[_vm._v(_vm._s(data.partner_information.product_name))]):_c('span',{staticClass:"cas-title custom-font-1"},[_vm._v(_vm._s(data.partner_information.product_name))])],_vm._v(" "),_c('div',{staticClass:"advent-bonus"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(data.partner_information.go_link)?_c('a',{staticClass:"cas-link text-hover",attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                        data.partner_information.go_link,
                        data.partner_information.slug
                      ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[_c('span',{staticClass:"bonus"},[_vm._v(_vm._s(_vm.$root.i18n.christmas_special_bonus))]),_vm._v(" "),(
                        data.partner_information.bonus_match &&
                        data.partner_information.exclusive_bonus_amount &&
                        data.partner_information.exclusive_bonus_match
                      )?_c('span',{staticClass:"bonus bonus-amt custom-font-1"},[_vm._v(_vm._s(data.partner_information.exclusive_bonus_match)+"%\n                      "+_vm._s(_vm.$root.i18n.up_to)+"\n                      "+_vm._s(_vm._f("currency")(data.partner_information.exclusive_bonus_amount,data.partner_information.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                        data.partner_information.bonus_match &&
                        !data.partner_information.exclusive_bonus_amount &&
                        data.partner_information.bonus_amount
                      )?_c('span',{staticClass:"bonus bonus-amt custom-font-1"},[_vm._v(_vm._s(data.partner_information.bonus_match)+"%\n                      "+_vm._s(_vm.$root.i18n.up_to)+"\n                      "+_vm._s(_vm._f("currency")(data.partner_information.bonus_amount,data.partner_information.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                        data.partner_information.freespin ||
                        data.partner_information.freebie_name
                      )?_c('span',{class:{
                        'bonus bonus-amt custom-font-1': true,
                      }},[(
                          (data.partner_information.exclusive_bonus_amount ||
                            data.partner_information.bonus_amount) &&
                          data.partner_information.bonus_match
                        )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(data.partner_information.freespin)?[(
                            data.partner_information.show_freebie_currency ===
                            '1'
                          )?[_vm._v(_vm._s(_vm._f("currency")(data.partner_information.freespin,
                                data.partner_information.bonus_currency
                              )))]:[_vm._v(_vm._s(data.partner_information.freespin))],_vm._v("\n                        "+_vm._s(data.partner_information.freebie_name)+"\n                      ")]:[_vm._v(_vm._s(data.partner_information.freebie_name))]],2):_vm._e()]):_vm._e()]],2),_vm._v(" "),(data.partner_information.go_link)?_c('a',{class:{
                  'cta cta-play custom-btn hover-btn cas-link': true,
                  'text-white':
                    !_vm.$root.override_ctabtntxt_color &&
                    !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-gray':
                    !_vm.$root.override_ctabtntxt_color &&
                    _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-cta-override': _vm.$root.override_ctabtntxt_color,
                },style:({
                  '--primary-btn': _vm.$root.color_schema.primary_btn,
                  '--primary-btn-hover': _vm.pSBC(
                    -0.2,
                    _vm.$root.color_schema.primary_btn
                  ),
                }),attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                    data.partner_information.go_link,
                    data.partner_information.slug
                  ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[(index === 1)?_c('img',{attrs:{"src":_vm.crownIcon,"alt":"Crown"}}):_vm._e(),_vm._v("\n                  "+_vm._s(data.partner_information.cta_button_text))]),_vm._v(" "),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "cardtpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"div-tt"},[(
                    (data.partner_information.bonus_tc &&
                      data.partner_information.bonus_tc != '') ||
                    (data.partner_information.terms &&
                      data.partner_information.terms != '')
                  )?_c('span',{staticClass:"tc-text cas-term",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(data.partner_information.bonus_tc)}}):_vm._e(),_vm._v(" "),(
                    data.partner_information.bonus_tc &&
                    data.partner_information.terms &&
                    data.partner_information.bonus_tc != '' &&
                    data.partner_information.terms != ''
                  )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(
                    data.partner_information.terms &&
                    data.partner_information.terms != ''
                  )?_c('a',{staticClass:"tc-text cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow',"title":data.partner_information.product_name,"href":_vm.getGoLink(
                      data.partner_information.term_link,
                      data.partner_information.slug
                    ),"target":"_blank"}},[_vm._v(_vm._s(data.partner_information.terms))]):_vm._e()])],2),_vm._v(" "),(
                _vm.getTimeStamp(data.Ymd, 'addate') < _vm.getTimeStamp('', 'today')
              )?_c('div',{staticClass:"overlay"}):_vm._e()]:(
              data.type === 'promotion' &&
              Object.keys(data.partner_information).length > 0 &&
              Object.keys(data.promotion_information).length > 0
            )?[_c('div',{staticClass:"advent-card-bg"},[(
                  !(
                    _vm.getTimeStamp(data.Ymd, 'addate') <=
                    _vm.getTimeStamp('', 'today')
                  )
                )?[(_vm.adventCalendarAttrs.card_coming_soon_image)?_c('img',{attrs:{"src":_vm.adventCalendarAttrs.card_coming_soon_image,"alt":"\n                 Advent card bg image\n                "}}):_vm._e()]:[(_vm.adventCalendarAttrs.feast_card_background)?_c('img',{attrs:{"src":_vm.adventCalendarAttrs.feast_card_background,"alt":"\n                 Advent card bg image\n                "}}):_vm._e()]],2),_vm._v(" "),_c('div',{class:{
                'advent-card-content': true,
                'advent-promo-card': !(
                  _vm.getTimeStamp(data.Ymd, 'addate') <=
                  _vm.getTimeStamp('', 'today')
                ),
              }},[_c('div',{staticClass:"offer-meta-bg"}),_vm._v(" "),_c('div',{staticClass:"offer-meta"},[_c('div',{staticClass:"offer-meta-logo"},[(data.partner_information.go_link)?_c('a',{staticClass:"partner-logo pt-100 cas-link",attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                        data.partner_information.go_link,
                        data.partner_information.slug
                      ),"rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow',"target":"_blank"}},[(
                        _vm.assetsSize &&
                        _vm.assetsSize.pro_asset_sizes &&
                        data.partner_information.product_assets &&
                        data.partner_information.product_assets.length > 0
                      )?_c('img',{attrs:{"src":data.partner_information.product_assets
                          .filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assetsSize.pro_asset_sizes.medium; }
                          )
                          .shift().url,"alt":_vm.getAltText(
                          data.partner_information.product_name,
                          data.partner_information.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assetsSize.pro_asset_sizes.medium; }
                            )
                            .shift().url
                        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-promo"},[_c('div',{staticClass:"partner-hover-inner",style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"offer-meta-title"},[(_vm.$root.enable_piwik_reload)?[(data.partner_information.review_link)?_c('a',{staticClass:"partner-name custom-font-1 text-hover",attrs:{"title":data.partner_information.product_name,"href":_vm.getRouteLink(
                          data.partner_information.review_link,
                          'review'
                        )}},[_vm._v(_vm._s(data.partner_information.product_name))]):_c('span',{staticClass:"partner-name custom-font-1"},[_vm._v(_vm._s(data.partner_information.product_name))])]:[(data.partner_information.review_link)?_c('router-link',{staticClass:"partner-name custom-font-1 text-hover",attrs:{"title":data.partner_information.product_name,"to":_vm.getRouteLink(
                          data.partner_information.review_link,
                          'review'
                        )}},[_vm._v(_vm._s(data.partner_information.product_name))]):_c('span',{staticClass:"partner-name custom-font-1"},[_vm._v(_vm._s(data.partner_information.product_name))])],_vm._v(" "),_c('StarRating',{attrs:{"rating":parseFloat(
                        (data.partner_information.rating / 2).toFixed(1)
                      ),"classParam":_vm.strCls}})],2)]),_vm._v(" "),_c('div',{staticClass:"offer-meta-bonus"},[_c('div',{staticClass:"card-tags"},[_c('span',{staticClass:"promotion-tag"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"5","height":"9","viewBox":"0 0 5 9","fill":"none"}},[_c('path',{attrs:{"d":"M4.98659 3.18601C4.96308 3.13409 4.91245 3.10077 4.85668 3.10077H3.1576L4.83445 0.37757C4.86241 0.332151 4.86413 0.274634 4.83891 0.227591C4.81367 0.180392 4.76548 0.151184 4.71329 0.151184H2.41918C2.36484 0.151184 2.31522 0.182742 2.29086 0.232741L0.140119 4.65711C0.117889 4.70269 0.120326 4.75696 0.14642 4.80046C0.172666 4.84396 0.218688 4.8705 0.268441 4.8705H1.74284L0.136238 8.79522C0.108849 8.86232 0.13323 8.94018 0.193585 8.97824C0.216806 8.99284 0.242615 8.99991 0.26829 8.99991C0.309439 8.99991 0.350018 8.98177 0.378128 8.94756L4.96637 3.34335C5.00235 3.29942 5.01009 3.23807 4.98659 3.18601Z","fill":"black"}})]),_vm._v("\n                    "+_vm._s(_vm.$root.i18n.promotion)+"\n                  ")])]),_vm._v(" "),(data.partner_information.go_link)?_c('a',{staticClass:"partner-name custom-font-1 cas-link text-hover",attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                      data.partner_information.go_link,
                      data.partner_information.slug
                    ),"rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow',"target":"_blank"}},[(
                      data.promotion_information &&
                      data.promotion_information.post_excerpt.length < 100
                    )?_c('span',{staticClass:"bonus-text prob-text"},[_vm._v(_vm._s(data.promotion_information.post_excerpt))]):_c('span',{staticClass:"bonus-text prob-text"},[_vm._v(_vm._s(data.promotion_information.post_excerpt.slice(0, 100) +
                    "..."))])]):_vm._e()]),_vm._v(" "),(data.partner_information.go_link)?_c('a',{class:{
                  'cta cta-play custom-btn hover-btn cas-link': true,
                  'text-white':
                    !_vm.$root.override_ctabtntxt_color &&
                    !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-gray':
                    !_vm.$root.override_ctabtntxt_color &&
                    _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-cta-override': _vm.$root.override_ctabtntxt_color,
                },style:({
                  '--primary-btn': _vm.$root.color_schema.primary_btn,
                  '--primary-btn-hover': _vm.pSBC(
                    -0.2,
                    _vm.$root.color_schema.primary_btn
                  ),
                }),attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                    data.partner_information.go_link,
                    data.partner_information.slug
                  ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[(index === 1)?_c('img',{attrs:{"src":_vm.crownIcon,"alt":"Crown"}}):_vm._e(),_vm._v("\n                  "+_vm._s(data.partner_information.cta_button_text))]),_vm._v(" "),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "cardtpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e(),_vm._v(" "),(
                  (data.partner_information.bonus_tc &&
                    data.partner_information.bonus_tc != '') ||
                  (data.partner_information.terms &&
                    data.partner_information.terms != '')
                )?_c('div',{staticClass:"terms prob-term"},[(
                    data.partner_information.bonus_tc &&
                    data.partner_information.bonus_tc != ''
                  )?_c('span',{class:{
                    'terms_tc cas-term term-text-font-color': true,
                  },style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(data.partner_information.bonus_tc)}}):_vm._e(),_vm._v(" "),(
                    data.partner_information.bonus_tc &&
                    data.partner_information.terms &&
                    data.partner_information.bonus_tc != '' &&
                    data.partner_information.terms != ''
                  )?_c('span',{staticClass:"data.partner_information-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(
                    data.partner_information.terms &&
                    data.partner_information.terms != ''
                  )?_c('a',{class:{
                    'terms_tc cas-term term-text-font-color': true,
                  },attrs:{"rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow',"title":data.partner_information.product_name,"href":_vm.getGoLink(
                      data.partner_information.term_link,
                      data.partner_information.slug
                    ),"target":"_blank"}},[_vm._v(_vm._s(data.partner_information.terms))]):_vm._e()]):_vm._e()]),_vm._v(" "),(
                _vm.getTimeStamp(data.Ymd, 'addate') < _vm.getTimeStamp('', 'today')
              )?_c('div',{staticClass:"overlay"}):_vm._e()]:_vm._e()],2)}),0),_vm._v(" "),_c('div',{staticClass:"advent-cards-wrapper"},_vm._l((_vm.adventFinalData),function(data,index){return _c('div',{key:index,class:{
            'advent-card advent-card-yellow': true,
            'advent-card-big current-no-active':
              _vm.getTimeStamp(data.Ymd, 'addate') === _vm.getTimeStamp('', 'today'),
            'advent-card-mobile':
              _vm.getTimeStamp(data.Ymd, 'addate') < _vm.getTimeStamp('', 'today'),
            'advent-promo-card':
              _vm.getTimeStamp(data.Ymd, 'addate') < _vm.getTimeStamp('', 'today') &&
              _vm.getTimeStamp(data.Ymd, 'addate') < _vm.getTimeStamp('', 'today', 2),
            'not-active':
              !_vm.getTimeStamp(data.Ymd, 'addate') <= _vm.getTimeStamp('', 'today'),
          }},[(
              data.type === 'partner' &&
              Object.keys(data.partner_information).length > 0
            )?[_c('div',{class:{
                'advent-card-bg': true,
                'advent-promo-card-up-bg': !(
                  _vm.getTimeStamp(data.Ymd, 'addate') <=
                  _vm.getTimeStamp('', 'today')
                ),
              }},[(
                  !(
                    _vm.getTimeStamp(data.Ymd, 'addate') <=
                    _vm.getTimeStamp('', 'today')
                  )
                )?[(_vm.adventCalendarAttrs.card_coming_soon_image)?_c('img',{attrs:{"src":_vm.adventCalendarAttrs.card_coming_soon_image,"alt":"\n                 Advent card bg image\n                "}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ring-title custom-font-1"},[_vm._v(_vm._s(Number(data.Ymd.slice(6, 8))))])]:[(_vm.adventCalendarAttrs.feast_card_background)?_c('img',{attrs:{"src":_vm.adventCalendarAttrs.feast_card_background,"alt":"\n                 Advent card bg image\n                "}}):_vm._e()]],2),_vm._v(" "),_c('div',{class:{
                'advent-card-content': true,
                'advent-promo-card': !(
                  _vm.getTimeStamp(data.Ymd, 'addate') <=
                  _vm.getTimeStamp('', 'today')
                ),
              }},[(data.partner_information.go_link)?_c('a',{staticClass:"cas-logo partner-logo pt-100 cas-link",attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                    data.partner_information.go_link,
                    data.partner_information.slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[(
                    _vm.assetsSize &&
                    _vm.assetsSize.pro_asset_sizes &&
                    data.partner_information.product_assets &&
                    data.partner_information.product_assets.length > 0
                  )?_c('img',{attrs:{"src":data.partner_information.product_assets.filter(
                      function (ele) { return ele.asset_category_name ===
                        _vm.assetsSize.pro_asset_sizes.medium; }
                    ).length > 0
                      ? data.partner_information.product_assets
                          .filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assetsSize.pro_asset_sizes.medium; }
                          )
                          .shift().url
                      : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"alt":_vm.getAltText(
                      data.partner_information.product_name,
                      data.partner_information.product_assets.filter(
                        function (ele) { return ele.asset_category_name ===
                          _vm.assetsSize.pro_asset_sizes.medium; }
                      ).length > 0
                        ? data.partner_information.product_assets
                            .filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assetsSize.pro_asset_sizes.medium; }
                            )
                            .shift().url
                        : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png'
                    )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-promo"},[_c('div',{staticClass:"partner-hover-inner",style:({
                      '--primary-btn': _vm.$root.color_schema.primary_btn,
                      '--primary-btn-hover': _vm.pSBC(
                        -0.2,
                        _vm.$root.color_schema.primary_btn
                      ),
                    })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]):_vm._e(),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(data.partner_information.review_link)?_c('a',{staticClass:"cas-title custom-font-1 text-hover",attrs:{"title":data.partner_information.product_name,"href":_vm.getRouteLink(
                      data.partner_information.review_link,
                      'review'
                    )}},[_vm._v(_vm._s(data.partner_information.product_name))]):_c('span',{staticClass:"cas-title custom-font-1"},[_vm._v(_vm._s(data.partner_information.product_name))])]:[(data.partner_information.review_link)?_c('router-link',{staticClass:"cas-title custom-font-1 text-hover",attrs:{"title":data.partner_information.product_name,"to":_vm.getRouteLink(
                      data.partner_information.review_link,
                      'review'
                    )}},[_vm._v(_vm._s(data.partner_information.product_name))]):_c('span',{staticClass:"cas-title custom-font-1"},[_vm._v(_vm._s(data.partner_information.product_name))])],_vm._v(" "),_c('div',{staticClass:"advent-bonus"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(data.partner_information.go_link)?_c('a',{staticClass:"cas-link text-hover",attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                        data.partner_information.go_link,
                        data.partner_information.slug
                      ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[_c('span',{staticClass:"bonus"},[_vm._v(_vm._s(_vm.$root.i18n.christmas_special_bonus))]),_vm._v(" "),(
                        data.partner_information.bonus_match &&
                        data.partner_information.exclusive_bonus_amount &&
                        data.partner_information.exclusive_bonus_match
                      )?_c('span',{staticClass:"bonus bonus-amt custom-font-1"},[_vm._v(_vm._s(data.partner_information.exclusive_bonus_match)+"%\n                      "+_vm._s(_vm.$root.i18n.up_to)+"\n                      "+_vm._s(_vm._f("currency")(data.partner_information.exclusive_bonus_amount,data.partner_information.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                        data.partner_information.bonus_match &&
                        !data.partner_information.exclusive_bonus_amount &&
                        data.partner_information.bonus_amount
                      )?_c('span',{staticClass:"bonus bonus-amt custom-font-1"},[_vm._v(_vm._s(data.partner_information.bonus_match)+"%\n                      "+_vm._s(_vm.$root.i18n.up_to)+"\n                      "+_vm._s(_vm._f("currency")(data.partner_information.bonus_amount,data.partner_information.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                        data.partner_information.freespin ||
                        data.partner_information.freebie_name
                      )?_c('span',{class:{
                        'bonus bonus-amt custom-font-1': true,
                      }},[(
                          (data.partner_information.exclusive_bonus_amount ||
                            data.partner_information.bonus_amount) &&
                          data.partner_information.bonus_match
                        )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(data.partner_information.freespin)?[(
                            data.partner_information.show_freebie_currency ===
                            '1'
                          )?[_vm._v(_vm._s(_vm._f("currency")(data.partner_information.freespin,
                                data.partner_information.bonus_currency
                              )))]:[_vm._v(_vm._s(data.partner_information.freespin))],_vm._v("\n                        "+_vm._s(data.partner_information.freebie_name)+"\n                      ")]:[_vm._v(_vm._s(data.partner_information.freebie_name))]],2):_vm._e()]):_vm._e()]],2),_vm._v(" "),(data.partner_information.go_link)?_c('a',{class:{
                  'cta cta-play custom-btn hover-btn cas-link': true,
                  'text-white':
                    !_vm.$root.override_ctabtntxt_color &&
                    !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-gray':
                    !_vm.$root.override_ctabtntxt_color &&
                    _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-cta-override': _vm.$root.override_ctabtntxt_color,
                },style:({
                  '--primary-btn': _vm.$root.color_schema.primary_btn,
                  '--primary-btn-hover': _vm.pSBC(
                    -0.2,
                    _vm.$root.color_schema.primary_btn
                  ),
                }),attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                    data.partner_information.go_link,
                    data.partner_information.slug
                  ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[(index === 1)?_c('img',{attrs:{"src":_vm.crownIcon,"alt":"Crown"}}):_vm._e(),_vm._v("\n                  "+_vm._s(data.partner_information.cta_button_text))]),_vm._v(" "),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "cardtpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"div-tt"},[(
                    (data.partner_information.bonus_tc &&
                      data.partner_information.bonus_tc != '') ||
                    (data.partner_information.terms &&
                      data.partner_information.terms != '')
                  )?_c('span',{staticClass:"tc-text cas-term",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(data.partner_information.bonus_tc)}}):_vm._e(),_vm._v(" "),(
                    data.partner_information.bonus_tc &&
                    data.partner_information.terms &&
                    data.partner_information.bonus_tc != '' &&
                    data.partner_information.terms != ''
                  )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(
                    data.partner_information.terms &&
                    data.partner_information.terms != ''
                  )?_c('a',{staticClass:"tc-text cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow',"title":data.partner_information.product_name,"href":_vm.getGoLink(
                      data.partner_information.term_link,
                      data.partner_information.slug
                    ),"target":"_blank"}},[_vm._v(_vm._s(data.partner_information.terms))]):_vm._e()])],2),_vm._v(" "),(
                _vm.getTimeStamp(data.Ymd, 'addate') < _vm.getTimeStamp('', 'today')
              )?_c('div',{staticClass:"overlay"}):_vm._e()]:(
              data.type === 'promotion' &&
              Object.keys(data.partner_information).length > 0 &&
              Object.keys(data.promotion_information).length > 0
            )?[_c('div',{staticClass:"advent-card-bg"},[(
                  !(
                    _vm.getTimeStamp(data.Ymd, 'addate') <=
                    _vm.getTimeStamp('', 'today')
                  )
                )?[(_vm.adventCalendarAttrs.card_coming_soon_image)?_c('img',{attrs:{"src":_vm.adventCalendarAttrs.card_coming_soon_image,"alt":"\n                 Advent card bg image\n                "}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ring-title custom-font-1"},[_vm._v(_vm._s(Number(data.Ymd.slice(6, 8))))])]:[(_vm.adventCalendarAttrs.feast_card_background)?_c('img',{attrs:{"src":_vm.adventCalendarAttrs.feast_card_background,"alt":"\n                 Advent card bg image\n                "}}):_vm._e()]],2),_vm._v(" "),_c('div',{class:{
                'advent-card-content': true,
                'advent-promo-card': !(
                  _vm.getTimeStamp(data.Ymd, 'addate') <=
                  _vm.getTimeStamp('', 'today')
                ),
              }},[_c('div',{staticClass:"offer-meta-bg"}),_vm._v(" "),_c('div',{staticClass:"offer-meta"},[_c('div',{staticClass:"offer-meta-logo"},[(data.partner_information.go_link)?_c('a',{staticClass:"partner-logo pt-100 cas-link",attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                        data.partner_information.go_link,
                        data.partner_information.slug
                      ),"rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow',"target":"_blank"}},[(
                        _vm.assetsSize &&
                        _vm.assetsSize.pro_asset_sizes &&
                        data.partner_information.product_assets &&
                        data.partner_information.product_assets.length > 0
                      )?_c('img',{attrs:{"src":data.partner_information.product_assets.filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assetsSize.pro_asset_sizes.medium; }
                        ).length > 0
                          ? data.partner_information.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assetsSize.pro_asset_sizes.medium; }
                              )
                              .shift().url
                          : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"alt":_vm.getAltText(
                          data.partner_information.product_name,
                          data.partner_information.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assetsSize.pro_asset_sizes.medium; }
                          ).length > 0
                            ? data.partner_information.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assetsSize.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/failure.png'
                        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-promo"},[_c('div',{staticClass:"partner-hover-inner",style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"offer-meta-title"},[(_vm.$root.enable_piwik_reload)?[(data.partner_information.review_link)?_c('a',{staticClass:"partner-name custom-font-1 text-hover",attrs:{"title":data.partner_information.product_name,"href":_vm.getRouteLink(
                          data.partner_information.review_link,
                          'review'
                        )}},[_vm._v(_vm._s(data.partner_information.product_name))]):_c('span',{staticClass:"partner-name custom-font-1"},[_vm._v(_vm._s(data.partner_information.product_name))])]:[(data.partner_information.review_link)?_c('router-link',{staticClass:"partner-name custom-font-1 text-hover",attrs:{"title":data.partner_information.product_name,"to":_vm.getRouteLink(
                          data.partner_information.review_link,
                          'review'
                        )}},[_vm._v(_vm._s(data.partner_information.product_name))]):_c('span',{staticClass:"partner-name custom-font-1"},[_vm._v(_vm._s(data.partner_information.product_name))])],_vm._v(" "),_c('StarRating',{attrs:{"rating":parseFloat(
                        (data.partner_information.rating / 2).toFixed(1)
                      ),"classParam":_vm.strCls}})],2)]),_vm._v(" "),_c('div',{staticClass:"offer-meta-bonus"},[_c('div',{staticClass:"card-tags"},[_c('span',{staticClass:"promotion-tag"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"5","height":"9","viewBox":"0 0 5 9","fill":"none"}},[_c('path',{attrs:{"d":"M4.98659 3.18601C4.96308 3.13409 4.91245 3.10077 4.85668 3.10077H3.1576L4.83445 0.37757C4.86241 0.332151 4.86413 0.274634 4.83891 0.227591C4.81367 0.180392 4.76548 0.151184 4.71329 0.151184H2.41918C2.36484 0.151184 2.31522 0.182742 2.29086 0.232741L0.140119 4.65711C0.117889 4.70269 0.120326 4.75696 0.14642 4.80046C0.172666 4.84396 0.218688 4.8705 0.268441 4.8705H1.74284L0.136238 8.79522C0.108849 8.86232 0.13323 8.94018 0.193585 8.97824C0.216806 8.99284 0.242615 8.99991 0.26829 8.99991C0.309439 8.99991 0.350018 8.98177 0.378128 8.94756L4.96637 3.34335C5.00235 3.29942 5.01009 3.23807 4.98659 3.18601Z","fill":"black"}})]),_vm._v("\n                    "+_vm._s(_vm.$root.i18n.promotion)+"\n                  ")])]),_vm._v(" "),(data.partner_information.go_link)?_c('a',{staticClass:"partner-name custom-font-1 cas-link text-hover",attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                      data.partner_information.go_link,
                      data.partner_information.slug
                    ),"rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow',"target":"_blank"}},[(
                      data.promotion_information &&
                      data.promotion_information.post_excerpt.length < 100
                    )?_c('span',{staticClass:"bonus-text prob-text"},[_vm._v(_vm._s(data.promotion_information.post_excerpt))]):_c('span',{staticClass:"bonus-text prob-text"},[_vm._v(_vm._s(data.promotion_information.post_excerpt.slice(0, 100) +
                    "..."))])]):_vm._e()]),_vm._v(" "),(data.partner_information.go_link)?_c('a',{class:{
                  'cta cta-play custom-btn hover-btn cas-link': true,
                  'text-white':
                    !_vm.$root.override_ctabtntxt_color &&
                    !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-gray':
                    !_vm.$root.override_ctabtntxt_color &&
                    _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                  'text-cta-override': _vm.$root.override_ctabtntxt_color,
                },style:({
                  '--primary-btn': _vm.$root.color_schema.primary_btn,
                  '--primary-btn-hover': _vm.pSBC(
                    -0.2,
                    _vm.$root.color_schema.primary_btn
                  ),
                }),attrs:{"title":data.partner_information.product_name,"href":_vm.getGoLink(
                    data.partner_information.go_link,
                    data.partner_information.slug
                  ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[(index === 1)?_c('img',{attrs:{"src":_vm.crownIcon,"alt":"Crown"}}):_vm._e(),_vm._v("\n                  "+_vm._s(data.partner_information.cta_button_text))]),_vm._v(" "),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "cardtpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e(),_vm._v(" "),(
                  (data.partner_information.bonus_tc &&
                    data.partner_information.bonus_tc != '') ||
                  (data.partner_information.terms &&
                    data.partner_information.terms != '')
                )?_c('div',{staticClass:"terms prob-term"},[(
                    data.partner_information.bonus_tc &&
                    data.partner_information.bonus_tc != ''
                  )?_c('span',{class:{
                    'terms_tc cas-term term-text-font-color': true,
                  },style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(data.partner_information.bonus_tc)}}):_vm._e(),_vm._v(" "),(
                    data.partner_information.bonus_tc &&
                    data.partner_information.terms &&
                    data.partner_information.bonus_tc != '' &&
                    data.partner_information.terms != ''
                  )?_c('span',{staticClass:"data.partner_information-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(
                    data.partner_information.terms &&
                    data.partner_information.terms != ''
                  )?_c('a',{class:{
                    'terms_tc cas-term term-text-font-color': true,
                  },attrs:{"rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow',"title":data.partner_information.product_name,"href":_vm.getGoLink(
                      data.partner_information.term_link,
                      data.partner_information.slug
                    ),"target":"_blank"}},[_vm._v(_vm._s(data.partner_information.terms))]):_vm._e()]):_vm._e()]),_vm._v(" "),(
                _vm.getTimeStamp(data.Ymd, 'addate') < _vm.getTimeStamp('', 'today')
              )?_c('div',{staticClass:"overlay"}):_vm._e()]:_vm._e()],2)}),0)])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{
      'main-content-area': true,
      'custom-background-image': _vm.$root.color_schema.site_bg_img,
    },style:({
      '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
      '--bg-color': _vm.$root.color_schema.site_bg_color,
    })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"observer",rawName:"v-observer",value:(_vm.mutationObserveDefault),expression:"mutationObserveDefault"}],class:{
        'custom-background-color': _vm.$root.color_schema.site_bg_img,
        'page-wrapper pb-25': true,
        'pt-26': _vm.calendarBlock ? false : true,
      }},[(!_vm.calendarBlock)?_c('section',{staticClass:"ct-article"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.calendarData.breadcrumb,"dark":true}})],1)])]):_vm._e(),_vm._v(" "),(
          _vm.calendarData &&
          _vm.calendarData.feast_data &&
          Object.keys(_vm.calendarData.feast_data).length > 0
        )?[_c('AdventCalendar',{attrs:{"adventCalendarAttrs":_vm.adventCalendarAttrs_,"adventCalendarData":_vm.calendarData.feast_data,"adventCalendarBreadcrumbs":_vm.calendarData.breadcrumb,"activeBreadcrumb":_vm.calendarBlock ? true : false,"assetsSize":_vm.assets_images}})]:_vm._e(),_vm._v(" "),_vm._l((_vm.blockData),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]}),_vm._v(" "),(
          _vm.morePaymentBottom &&
          _vm.blockData.length === _vm.calendarData.content.blocks.length
        )?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(
          _vm.auhtorBlockdata &&
          _vm.blockData.length === _vm.calendarData.content.blocks.length
        )?void 0:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(684);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3c241084", content, true, {});

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(46);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-71c4e1f1]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-71c4e1f1]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-71c4e1f1]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-71c4e1f1]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-71c4e1f1]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-71c4e1f1]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-71c4e1f1]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-71c4e1f1]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-71c4e1f1]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-71c4e1f1]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-71c4e1f1]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-71c4e1f1]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-inner-banner[data-v-71c4e1f1]{padding:0 0 45px;background:#070438 url(" + escape(__webpack_require__(62)) + ") no-repeat 0 0}.ct-inner-banner .game-space[data-v-71c4e1f1]{position:relative;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space[data-v-71c4e1f1]{min-height:auto}}.ct-inner-banner .game-space img[data-v-71c4e1f1]{border-radius:10px;box-shadow:0 5px 15px rgba(0,0,0,.05);height:100%;object-fit:cover;width:auto;max-height:321px;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space img[data-v-71c4e1f1]{width:100%;max-height:none;min-height:auto}}.ct-inner-banner .game-space-content[data-v-71c4e1f1]{position:absolute;left:0;right:0;top:0;bottom:0;padding:20px}.ct-inner-banner .game-space-content .button-block[data-v-71c4e1f1],.ct-inner-banner .game-space-content[data-v-71c4e1f1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-inner-banner .game-space-content .button-block[data-v-71c4e1f1]{width:100%;margin-bottom:15px}.ct-inner-banner .game-space-content .button-block .cta[data-v-71c4e1f1]{min-width:100%;margin:5px 0;font-weight:700;font-size:14px;line-height:17px;padding:10px 18px}@media (min-width:768px){.ct-inner-banner .game-space-content .button-block .cta[data-v-71c4e1f1]{min-width:330px;margin:10px 0;padding:15px 18px;font-size:18px;line-height:22px}}.ct-inner-banner .game-space-content .game-logo img[data-v-71c4e1f1]{box-shadow:none;max-height:none;min-height:auto}@media (min-width:768px){.ct-inner-banner .row .col-md-8[data-v-71c4e1f1]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-8[data-v-71c4e1f1]{width:66.66666667%;float:left}}@media (min-width:768px){.ct-inner-banner .row .col-md-4[data-v-71c4e1f1]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-4[data-v-71c4e1f1]{width:33.33333333%;float:left}}.ct-inner-banner-lft[data-v-71c4e1f1]{margin-bottom:19px}@media (min-width:992px){.ct-inner-banner-lft[data-v-71c4e1f1]{margin-bottom:0}}@media (min-width:1360px){.ct-inner-banner-lft[data-v-71c4e1f1]{width:906px!important}}@media (min-width:1360px){.ct-inner-banner-rgt[data-v-71c4e1f1]{width:314px!important}}.review-tab-menu ul[data-v-71c4e1f1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow-x:auto;overflow-y:hidden;white-space:nowrap;border-bottom:1px solid #bbb;max-width:960px}.review-tab-menu ul li[data-v-71c4e1f1]{margin-right:30px;display:inline-block;padding:10px 0;font-weight:400;font-size:16px;color:#9b9b9b;line-height:25px;cursor:pointer;position:relative}.review-tab-menu ul li[data-v-71c4e1f1]:after{position:absolute;content:\"\";left:0;bottom:-5px;width:100%;height:3px;background:#e8321d;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s}.review-tab-menu ul li.active[data-v-71c4e1f1],.review-tab-menu ul li[data-v-71c4e1f1]:hover{color:#e8321d}.review-tab-menu ul li.active[data-v-71c4e1f1]:after,.review-tab-menu ul li[data-v-71c4e1f1]:hover:after{bottom:0}.review-tab-menu ul li.active[data-v-71c4e1f1]{font-weight:700}.review-tab-menu-toplist ul[data-v-71c4e1f1]{border-bottom:0;margin-bottom:0}.review-tab-menu-toplist ul li[data-v-71c4e1f1]{font-size:12px;line-height:15px;color:#222;background:#f1f2f3;box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;text-align:center;min-width:130px;padding:10px 5px;margin-right:10px}.review-tab-menu-toplist ul li[data-v-71c4e1f1]:after,.review-tab-menu-toplist ul li[data-v-71c4e1f1]:before{display:none}.review-tab-menu-toplist ul li.active[data-v-71c4e1f1],.review-tab-menu-toplist ul li[data-v-71c4e1f1]:hover{background:#ffd039;color:#222;font-weight:400}.review-tab-container[data-v-71c4e1f1]{margin:0}.review-tab-container .tab-content[data-v-71c4e1f1]{display:none;padding-top:30px;padding-bottom:30px}.review-tab-container .tab-content.active[data-v-71c4e1f1]{display:block}.review-tab-container-toplist .tab-content[data-v-71c4e1f1]{padding-top:15px}.review-tab-container-toplist .tab-content .casino-card-horizontal[data-v-71c4e1f1]:first-child{margin-top:0}.ct-card-promotion[data-v-71c4e1f1]{padding:24px 0 17px;background-color:#080438;background-image:url(" + escape(__webpack_require__(254)) + ");background-repeat:no-repeat;background-position:100% 100%;background-size:60%}@media (min-width:768px){.ct-card-promotion[data-v-71c4e1f1]{padding:48px 0 20px}}.ct-card-promotion h2[data-v-71c4e1f1]{color:#fff}.ct-card-promotion .promotion-card[data-v-71c4e1f1]{background:#fff;box-shadow:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:5px 9px 11px;border-bottom:1px solid #f1f2f3}@media (min-width:992px){.ct-card-promotion .promotion-card[data-v-71c4e1f1]{display:block;box-shadow:0 1px 8px rgba(0,0,0,.2);padding:0;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;border-bottom:0}}.ct-card-promotion .promotion-card-img[data-v-71c4e1f1]{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;background:#f1f2f3;width:62px;height:62px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:5px 12px;position:relative}@media (min-width:992px){.ct-card-promotion .promotion-card-img[data-v-71c4e1f1]{background:linear-gradient(129.32deg,#f6f5f5 6.36%,#f6f5f5 71.95%);-webkit-border-radius:12px 12px 0 0;-moz-border-radius:12px 12px 0 0;border-radius:12px 12px 0 0;height:200px;width:100%;padding:0;display:block}}.ct-card-promotion .promotion-card-img img[data-v-71c4e1f1]{min-width:auto;height:auto;margin-bottom:0}@media (min-width:992px){.ct-card-promotion .promotion-card-img img[data-v-71c4e1f1]{min-width:114px}}.ct-card-promotion .promotion-card-content[data-v-71c4e1f1]{padding:0 12px}@media (min-width:992px){.ct-card-promotion .promotion-card-content[data-v-71c4e1f1]{padding:20px}}.ct-card-promotion .promotion-card-content .promotion-title a[data-v-71c4e1f1]{font-size:16px;font-weight:700}@media (min-width:992px){.ct-card-promotion .promotion-card-content .promotion-title a[data-v-71c4e1f1]{font-weight:400}}.ct-card-promotion .promotion-card-content p[data-v-71c4e1f1]{display:none}@media (min-width:992px){.ct-card-promotion .promotion-card-content p[data-v-71c4e1f1]{color:#7e7e7e;margin:10px 0;display:block}}.ct-card-promotion .promotion-card-content h5[data-v-71c4e1f1]{margin-bottom:0}@media (min-width:992px){.ct-card-promotion .promotion-card-content h5[data-v-71c4e1f1]{display:none}}.ct-card-promotion .promotion-card-content .cta-gray[data-v-71c4e1f1]{display:none}@media (min-width:992px){.ct-card-promotion .promotion-card-content .cta-gray[data-v-71c4e1f1]{display:block}}.ct-card-promotion-toplist[data-v-71c4e1f1]{background-image:none;background-color:transparent;padding:10px 0 45px;margin-right:-20px}@media (min-width:768px){.ct-card-promotion-toplist[data-v-71c4e1f1]{margin-right:-15px}}@media (min-width:992px){.ct-card-promotion-toplist[data-v-71c4e1f1]{margin-right:0}}.ct-card-promotion-toplist .promotion-card[data-v-71c4e1f1]{box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;display:block;padding:0;min-width:250px}@media (min-width:992px){.ct-card-promotion-toplist .promotion-card[data-v-71c4e1f1]{min-width:auto}}.ct-card-promotion-toplist .promotion-card-img[data-v-71c4e1f1]{-webkit-border-radius:12px 12px 0 0;-moz-border-radius:12px 12px 0 0;border-radius:12px 12px 0 0;background:#f6f5f5;height:154px;width:100%}.ct-card-promotion-toplist .promotion-card-img img[data-v-71c4e1f1]{width:auto;max-width:115px;margin:0}@media (min-width:768px){.ct-card-promotion-toplist .promotion-card-img img[data-v-71c4e1f1]{width:auto;max-width:none}}.ct-card-promotion-toplist .promotion-card-content[data-v-71c4e1f1]{padding:25px 15px;text-align:center;white-space:normal}@media (min-width:1080px){.ct-card-promotion-toplist .promotion-card-content[data-v-71c4e1f1]{padding:25px 20px}}.ct-card-promotion-toplist .promotion-card-content h6[data-v-71c4e1f1]{margin-bottom:10px}.ct-card-promotion-toplist .promotion-card-content h6 a[data-v-71c4e1f1]{color:#222}.ct-card-promotion-toplist .promotion-card-content p[data-v-71c4e1f1]{text-align:center;color:#222;display:block}.ct-card-promotion-toplist .promotion-card-content .cta[data-v-71c4e1f1]{padding:15px 10px;font-size:16px;display:block}@media (min-width:1080px){.ct-card-promotion-toplist .promotion-card-content .cta[data-v-71c4e1f1]{font-size:18px}}@media (min-width:1200px){.ct-card-promotion-toplist .promotion-card-content .cta[data-v-71c4e1f1]{padding:15px}}.ct-card-promotion__m .row[data-v-71c4e1f1]{margin:0}@media (min-width:992px){.ct-card-promotion__m .row[data-v-71c4e1f1]{margin:0 -8px}}.ct-card-promotion__m .row [class^=col-][data-v-71c4e1f1]{padding:0}@media (min-width:992px){.ct-card-promotion__m .row [class^=col-][data-v-71c4e1f1]{padding:0 8px}}.promotion-inner[data-v-71c4e1f1]{position:static;width:auto;text-align:center}@media (min-width:992px){.promotion-inner[data-v-71c4e1f1]{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute}}.promotion-inner p[data-v-71c4e1f1]{white-space:nowrap;font-weight:700;margin-bottom:0;margin-top:25px;display:none}@media (min-width:992px){.promotion-inner p[data-v-71c4e1f1]{display:inline-block}}.promotion-inner-img[data-v-71c4e1f1]{min-height:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (min-width:992px){.promotion-inner-img[data-v-71c4e1f1]{min-height:92px}}.ct-selection-casino .selection-cont[data-v-71c4e1f1]{max-width:960px}.ct-selection-casino .selection-cont h2[data-v-71c4e1f1]{color:#030030;margin-bottom:16px}@media (min-width:768px){.ct-selection-casino .selection-cont h2[data-v-71c4e1f1]{margin-bottom:16px;color:#222}}.ct-related-page-links[data-v-71c4e1f1]{background:#222;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;padding:18px 20px;margin:0;display:block}@media (min-width:768px){.ct-related-page-links[data-v-71c4e1f1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;margin:35px 0 25px}}.ct-related-page-links h6[data-v-71c4e1f1]{font-weight:700;color:#fff;margin-bottom:12px;white-space:nowrap}@media (min-width:768px){.ct-related-page-links h6[data-v-71c4e1f1]{margin-bottom:0;margin-right:27px}}.ct-related-page-links ul[data-v-71c4e1f1]{overflow-x:auto;white-space:nowrap}.ct-related-page-links ul li[data-v-71c4e1f1]{margin-right:40px;display:inline-block}.ct-related-page-links ul li[data-v-71c4e1f1]:last-child{margin-right:0}.ct-related-page-links ul li a[data-v-71c4e1f1]{font-size:16px;line-height:19px;color:#fff}.ct-similar-casino-cards[data-v-71c4e1f1]{padding-bottom:30px}.ct-similar-casino-cards .container[data-v-71c4e1f1]{padding-right:0}@media (min-width:1024px){.ct-similar-casino-cards .container[data-v-71c4e1f1]{padding:0 15px}}.ct-similar-casino-cards .mobile-scroller[data-v-71c4e1f1]::-webkit-scrollbar-track{background-color:#fff}.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-71c4e1f1]{padding:0 8px}@media (min-width:992px){.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-71c4e1f1]{padding:0 4px}}@media (min-width:1200px){.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-71c4e1f1]{padding:0 8px}}.ct-similar-casino-cards .mobile-scroller .casino-card-similar[data-v-71c4e1f1]{padding:15px;white-space:normal;min-width:254px}@media (min-width:992px){.ct-similar-casino-cards .mobile-scroller .casino-card-similar[data-v-71c4e1f1]{padding:10px;min-width:auto}}@media (min-width:1200px){.ct-similar-casino-cards .mobile-scroller .casino-card-similar[data-v-71c4e1f1]{padding:15px}}.ct-review-toplist-page[data-v-71c4e1f1]{padding-top:30px}.pb-25[data-v-71c4e1f1]{padding-bottom:25px}.show_btn[data-v-71c4e1f1]{margin-top:0!important}.pros-cons-tab[data-v-71c4e1f1]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;display:block;margin-top:30px}@media (min-width:768px){.pros-cons-tab[data-v-71c4e1f1]{display:none}}.pros-cons-tab .pros-cons-tab-content[data-v-71c4e1f1]{margin:0;padding:60px 25px 30px}.pros-cons-tab .pros-cons-tab-content .item-content[data-v-71c4e1f1]{display:none}.pros-cons-tab .pros-cons-tab-content .item-content.active[data-v-71c4e1f1]{display:block}.pros-cons-tab ul.tab-items[data-v-71c4e1f1]{list-style-type:none;display:-webkit-box;display:-ms-flexbox;display:flex;margin:0 0 -26px}.pros-cons-tab ul.tab-items li[data-v-71c4e1f1]{background:#f1f2f3;box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-left:0;width:59px;height:52px;line-height:1;margin:0 12px 0 0;cursor:pointer}.pros-cons-tab ul.tab-items li[data-v-71c4e1f1]:before{display:none}.pros-cons-tab ul.tab-items li i img[data-v-71c4e1f1]{margin:0}.pros-cons-tab ul.tab-items li span[data-v-71c4e1f1]{padding-left:10px;font-weight:700;font-size:16px;line-height:20px;color:#222;display:none}.pros-cons-tab ul.tab-items li.active[data-v-71c4e1f1]{background:#fff;width:153px}.pros-cons-tab ul.tab-items li.active span[data-v-71c4e1f1]{display:block}.pros-cons-tab-content .item-content h3[data-v-71c4e1f1]{color:#222}.page-links-outr .container[data-v-71c4e1f1]{padding:0}@media (min-width:768px){.page-links-outr .container[data-v-71c4e1f1]{padding:0 15px}}@media (max-width:576px){.page-links-outr .ct-related-page-links[data-v-71c4e1f1]{background-color:#060236}}.page-links-outr .ct-related-page-links .router-link-exact-active[data-v-71c4e1f1]{color:#fff}.best-choice-casino-icon img[data-v-71c4e1f1]{border-radius:12px}.alter-pt12[data-v-71c4e1f1]{padding-bottom:12px!important}.hide-mob[data-v-71c4e1f1]{display:none}@media (min-width:768px){.hide-mob[data-v-71c4e1f1]{display:block}}.casino-header[data-v-71c4e1f1]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-71c4e1f1]{text-align:center;color:#fff;font-weight:700;padding:8px}.ct-card-horizontal[data-v-71c4e1f1]{padding:45px 0;background-color:#f1f2f3}.ct-card-horizontal-game[data-v-71c4e1f1]{padding:32px 0}.ct-card-horizontal-game .casino-card-horizontal[data-v-71c4e1f1]:first-child{margin-top:20px}.bonus-card-logo[data-v-71c4e1f1]{padding:0!important;background:#fff!important}.bonus-card-logo img[data-v-71c4e1f1]{height:100%!important;width:auto;object-fit:cover}@media (min-width:768px){.bonus-card-logo img[data-v-71c4e1f1]{height:100%!important}}.best-choice-casino-cont-title .span-h2 a[data-v-71c4e1f1]:hover,.best-choice-casino-cont-title h2 a[data-v-71c4e1f1]:hover{color:var(--hover-color)}.bonus-card-content-top .span-h6[data-v-71c4e1f1]{font-size:16px}.best-choice-casino-cont[data-v-71c4e1f1]{padding-left:15px!important}.best-choice[data-v-71c4e1f1]{display:flex;align-items:start!important;flex-direction:column}@media (min-width:992px){.best-choice[data-v-71c4e1f1]{flex-direction:row;align-items:flex-end!important}}.best-choice-cont[data-v-71c4e1f1]{padding-left:0!important}@media (min-width:992px){.best-choice-cont[data-v-71c4e1f1]{padding-left:10px!important}}.best-rating[data-v-71c4e1f1]{padding-left:0}@media (min-width:992px){.best-rating[data-v-71c4e1f1]{padding-left:16px}}.btn-block .read-review[data-v-71c4e1f1]{text-decoration:underline}.pt-30[data-v-71c4e1f1]{padding-top:30px!important}.pt-20[data-v-71c4e1f1]{padding-top:20px!important}.pb-0[data-v-71c4e1f1]{padding-bottom:15px!important}@media (min-width:768px){.pb-0[data-v-71c4e1f1]{padding-bottom:16px!important}}@media (min-width:992px){.pb-0[data-v-71c4e1f1]{padding-bottom:30px!important}}.pb-10[data-v-71c4e1f1]{padding-bottom:10px!important}.span-fix[data-v-71c4e1f1]{font-size:16px;line-height:18px;display:block;margin-bottom:0}.color-orange[data-v-71c4e1f1]{color:#e8321d}.half-col .proslist li[data-v-71c4e1f1]{width:100%!important}.stripe[data-v-71c4e1f1]{text-align:center}.stripe p[data-v-71c4e1f1]{font-weight:700}.stripe[data-v-71c4e1f1]{position:absolute;width:100%;height:20px;bottom:0;top:50%;transform:translateY(27px);left:0;overflow:hidden;border-bottom-left-radius:10px;border-bottom-right-radius:10px;background-color:#ffd039;display:none}@media (min-width:576px){.stripe[data-v-71c4e1f1]{display:block}}.stripe img[data-v-71c4e1f1]{width:14px!important;height:14px!important;border-radius:0!important;object-fit:contain!important}.stripe img[data-v-71c4e1f1],.stripe svg[data-v-71c4e1f1]{display:block;margin:3px auto;width:15px}.proslist-pay[data-v-71c4e1f1]{margin:0;padding:0;list-style:none;column-count:0;display:block;height:26px;overflow:hidden;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s;column-count:unset}@media (min-width:576px){.proslist-pay[data-v-71c4e1f1]{-ms-flex-wrap:wrap;flex-wrap:wrap;display:-webkit-box;display:-ms-flexbox;display:flex}}@media (min-width:992px){.proslist-pay[data-v-71c4e1f1]{column-count:2;height:auto;overflow:visible}}@media (max-width:576px){.proslist-pay[data-v-71c4e1f1]{padding-bottom:6px}}.proslist-pay li[data-v-71c4e1f1]{position:relative;text-align:left;padding-left:32px;line-height:25px;color:#222;margin-bottom:18px;background-size:15px 15px;margin-bottom:22px;width:100%}.proslist-pay li[data-v-71c4e1f1]:last-child{margin-bottom:0}@media (min-width:992px){.proslist-pay li[data-v-71c4e1f1]{margin-right:10px;width:calc(50% - 10px)}}.proslist-pay li.pros-green[data-v-71c4e1f1]:before{background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;background-position:50%;background-size:14px}.proslist-pay li.pros-green[data-v-71c4e1f1]:before,.proslist-pay li.pros-red[data-v-71c4e1f1]:before{position:absolute;content:\"\";left:0;top:0;display:inline-block;transform:translateY(0);height:26px;width:26px;border-radius:100%}.proslist-pay li.pros-red[data-v-71c4e1f1]:before{background:#fe4646 url(" + escape(__webpack_require__(73)) + ") no-repeat;background-position:50%;background-size:14px}.why-use.expanded ul.proslist-pay[data-v-71c4e1f1]{height:100%}.tab-items .posi[data-v-71c4e1f1]{background:#5abc5e}.tab-items .negi[data-v-71c4e1f1],.tab-items .posi[data-v-71c4e1f1]{width:26px;height:26px;border-radius:100%;display:flex;justify-content:center;align-items:center;margin-right:0}.tab-items .negi[data-v-71c4e1f1]{background:#fe4646}.payment-ad-dis-container[data-v-71c4e1f1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0 -10px}@media (max-width:1024px){.payment-ad-dis-container[data-v-71c4e1f1]{flex-wrap:wrap}}.payment-ad-dis-container .advantage-green[data-v-71c4e1f1]{width:100%;background:#e2f3e3;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:0 10px}@media (min-width:992px){.payment-ad-dis-container .advantage-green[data-v-71c4e1f1]{width:610px}}.payment-ad-dis-container .advantage-green-header[data-v-71c4e1f1]{padding:15px;background:#5abc5e;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:10px 10px 0}.payment-ad-dis-container .advantage-green-header h3[data-v-71c4e1f1]{font-weight:700;color:#fff;margin-bottom:0;position:relative}.payment-ad-dis-container .advantage-green-header i[data-v-71c4e1f1]{width:22px;height:22px;position:relative;float:left;top:7px;right:0;margin-right:10px}.payment-ad-dis-container .advantage-green-header i img[data-v-71c4e1f1]{margin-bottom:0!important}.payment-ad-dis-container .advantage-green-content[data-v-71c4e1f1]{padding:18px 18px 0 24px}.payment-ad-dis-container .advantage-green-content ul[data-v-71c4e1f1]{margin-bottom:16px}.payment-ad-dis-container .advantage-green-content ul li[data-v-71c4e1f1]{position:relative;margin-bottom:20px;font-weight:400;font-size:18px;line-height:28px;padding-left:37px}.payment-ad-dis-container .advantage-green-content ul li[data-v-71c4e1f1]:last-child{margin-bottom:0}.payment-ad-dis-container .advantage-green-content ul li strong[data-v-71c4e1f1]{font-weight:700}.payment-ad-dis-container .advantage-green-content ul li[data-v-71c4e1f1]:after{position:absolute;content:\"\";left:0;top:6px;width:15px;height:16px}.payment-ad-dis-container .disadvantage-red[data-v-71c4e1f1]{width:100%;background:#f9e6e6;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:0 10px}@media (min-width:992px){.payment-ad-dis-container .disadvantage-red[data-v-71c4e1f1]{width:610px;margin:0 10px}}@media (max-width:992px){.payment-ad-dis-container .disadvantage-red[data-v-71c4e1f1]{margin-top:20px}}.payment-ad-dis-container .disadvantage-red-header[data-v-71c4e1f1]{padding:15px;background:#fe4646;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;margin:10px 10px 0}.payment-ad-dis-container .disadvantage-red-header h3[data-v-71c4e1f1]{font-weight:700;color:#fff;margin-bottom:0;position:relative}.payment-ad-dis-container .disadvantage-red-header i[data-v-71c4e1f1]{width:26px;height:26px;position:relative;top:8px;right:0;float:left;margin-right:10px}.payment-ad-dis-container .disadvantage-red-header i img[data-v-71c4e1f1]{margin-bottom:0!important}.payment-ad-dis-container .disadvantage-red-content[data-v-71c4e1f1]{padding:18px 18px 0 24px}.payment-ad-dis-container .disadvantage-red-content ul[data-v-71c4e1f1]{margin-bottom:16px}.payment-ad-dis-container .disadvantage-red-content ul li[data-v-71c4e1f1]{position:relative;margin-bottom:20px;font-weight:400;font-size:18px;line-height:28px;padding-left:37px}.payment-ad-dis-container .disadvantage-red-content ul li[data-v-71c4e1f1]:last-child{margin-bottom:0}.payment-ad-dis-container .disadvantage-red-content ul li strong[data-v-71c4e1f1]{font-weight:700}.payment-ad-dis-container .disadvantage-red-content ul li[data-v-71c4e1f1]:after{position:absolute;content:\"\";left:0;top:6px;width:15px;height:16px}.payment-ad-dis-container .disadvantage-red .online-gambling-red-header[data-v-71c4e1f1]{background:#fe4646}.payment-ad-dis-container .disadvantage-red .online-gambling-red-header i[data-v-71c4e1f1]{padding:0}.rm-top-padding[data-v-71c4e1f1]{border-top:none}.casino-card-software[data-v-71c4e1f1]{width:100%}", ""]);

// exports


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):_c('main',{staticClass:"main-content-area"},[(_vm.feature_image)?_c('section',{staticClass:"ct-inner-banner pt-26",style:({ background: _vm.$root.color_schema.primary })},[_c('div',{staticClass:"container"},[(_vm.breadcrumb && _vm.breadcrumb.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadcrumb,"dark":_vm.getContrastYIQ(_vm.$root.color_schema.primary)}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.$root.disableNotSupportBanner)?_c('NotSupportModal',{attrs:{"notsupportbannerData":_vm.$root.notsupportbannerData}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"\n              casino-card\n              casino-card-software\n              casino-card-bonus\n              casino-card-payment-toplist\n            ",style:({
              height:
                !_vm.$root.disable_not_supported_banner &&
                _vm.$root.disableNotSupportBanner &&
                _vm.paymentWidth < 576
                  ? '565px'
                  : null,
            })},[_c('div',{staticClass:"bonus-card-logo"},[(_vm.$root.enable_lazyload && _vm.feature_image)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.feature_image),expression:"feature_image"}],attrs:{"width":"400","height":"400","alt":_vm.getAltText(_vm.page_title, _vm.feature_image)}}):(_vm.feature_image)?_c('img',{attrs:{"src":_vm.feature_image,"width":"400","height":"400","alt":_vm.getAltText(_vm.page_title, _vm.feature_image)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bonus-card-content"},[(
                  (_vm.paymentProcons && _vm.paymentProconsArr.length > 0) ||
                  (_vm.top_section &&
                    _vm.top_section.procons &&
                    _vm.top_section.procons.length > 0)
                )?_c('div',{staticClass:"bonus-card-content-top"},[(_vm.page_title)?[_c('span',{staticClass:"span-h6 custom-font-1"},[_vm._v(_vm._s(_vm.$root.i18n.why_use)+"\n                    "+_vm._s(_vm.page_title.split(" ").shift())+"?")])]:_vm._e(),_vm._v(" "),_c('div',{class:{ 'why-use': true, expanded: _vm.showMorePros }},[(_vm.paymentProcons && _vm.paymentProconsArr.length > 0)?[_c('ul',{staticClass:"proslist-pay"},_vm._l((_vm.paymentProconsArr
                          .filter(function (ele) { return ele.is_featured === '1'; })
                          .sort(
                            function (ele1, ele2) { return ele2.is_positive - ele1.is_positive; }
                          )
                          .slice(0, 4)),function(data){return _c('li',{key:data.id,class:{
                          'pros-green':
                            data.is_featured === '1' &&
                            data.is_positive === '1',
                          'pros-red':
                            data.is_featured === '1' &&
                            data.is_positive === '0',
                        }},[_vm._v("\n                        "+_vm._s(data.description)+"\n                      ")])}),0)]:[(
                        _vm.top_section &&
                        _vm.top_section.procons &&
                        _vm.top_section.procons.length > 0
                      )?_c('ul',{staticClass:"proslist-pay"},_vm._l((_vm.top_section.procons
                          .filter(function (ele) { return ele.is_positive === '1'; })
                          .slice(0, 4)),function(data){return _c('li',{key:data.id,staticClass:"pros-green"},[_vm._v("\n                        "+_vm._s(data.description)+"\n                      ")])}),0):_vm._e()],_vm._v(" "),(_vm.paymentProcons)?[(_vm.paymentProconsArr.length > 1)?[(!_vm.showMorePros)?_c('a',{staticClass:"show-more",attrs:{"title":_vm.$root.i18n.show_more_pros},on:{"click":function($event){_vm.showMorePros = true}}},[_c('i'),_vm._v(_vm._s(_vm.$root.i18n.show_more_pros))]):_vm._e(),_vm._v(" "),(_vm.showMorePros)?_c('a',{staticClass:"show-less",attrs:{"title":_vm.$root.i18n.show_less_pros},on:{"click":function($event){_vm.showMorePros = false}}},[_c('i'),_vm._v(_vm._s(_vm.$root.i18n.show_less_pros))]):_vm._e()]:_vm._e()]:(
                      _vm.top_section &&
                      _vm.top_section.procons &&
                      _vm.top_section.procons.length > 1
                    )?[(!_vm.showMorePros)?_c('a',{staticClass:"show-more",attrs:{"title":_vm.$root.i18n.show_more_pros},on:{"click":function($event){_vm.showMorePros = true}}},[_c('i'),_vm._v(_vm._s(_vm.$root.i18n.show_more_pros))]):_vm._e(),_vm._v(" "),(_vm.showMorePros)?_c('a',{staticClass:"show-less",attrs:{"title":_vm.$root.i18n.show_less_pros},on:{"click":function($event){_vm.showMorePros = false}}},[_c('i'),_vm._v(_vm._s(_vm.$root.i18n.show_less_pros))]):_vm._e()]:_vm._e()],2)],2):_vm._e(),_vm._v(" "),_c('div',{class:{
                  'bonus-card-content-bottom pb-0': true,
                  'rm-top-padding': !(
                    (_vm.paymentProcons && _vm.paymentProconsArr.length > 0) ||
                    (_vm.top_section &&
                      _vm.top_section.procons &&
                      _vm.top_section.procons.length > 0)
                  ),
                }},[(_vm.hideToplistLabel)?void 0:[(_vm.top_section && _vm.top_section.product_id)?[(_vm.top_section && _vm.top_section.go_link)?_c('div',{staticClass:"best-choice-casino-icon"},[_c('a',{staticClass:"partner-logo cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[(
                            _vm.$root.enable_lazyload &&
                            _vm.assets_images &&
                            _vm.assets_images.pro_asset_sizes
                          )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                            _vm.top_section.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? _vm.top_section.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : ''
                          ),expression:"\n                            top_section.product_assets.filter(\n                              (ele) =>\n                                ele.asset_category_name ===\n                                assets_images.pro_asset_sizes.medium\n                            ).length > 0\n                              ? top_section.product_assets\n                                  .filter(\n                                    (ele) =>\n                                      ele.asset_category_name ===\n                                      assets_images.pro_asset_sizes.medium\n                                  )\n                                  .shift().url\n                              : ''\n                          "}],attrs:{"width":"90","height":"90","alt":_vm.getAltText(
                              _vm.top_section.product_name,
                              _vm.top_section.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              ).length > 0
                                ? _vm.top_section.product_assets
                                    .filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )
                                    .shift().url
                                : ''
                            )}}):(
                            _vm.assets_images && _vm.assets_images.pro_asset_sizes
                          )?_c('img',{attrs:{"src":_vm.top_section.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? _vm.top_section.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/failure.png',"width":"90","height":"90","alt":_vm.getAltText(
                              _vm.top_section.product_name,
                              _vm.top_section.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              ).length > 0
                                ? _vm.top_section.product_assets
                                    .filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )
                                    .shift().url
                                : _vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/failure.png'
                            )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-pay-bann"},[_c('div',{staticClass:"partner-hover-inner",style:({
                              '--primary-btn': _vm.$root.color_schema.primary_btn,
                              '--primary-btn-hover': _vm.pSBC(
                                -0.2,
                                _vm.$root.color_schema.primary_btn
                              ),
                            })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                            Object.keys(_vm.hasTag(_vm.top_section.tags)).length > 0
                          )?_c('div',{class:{
                            stripe: true,
                            'font-dark': _vm.getContrastYIQ(
                              Object.keys(_vm.hasTag(_vm.top_section.tags)).length > 0
                                ? _vm.hasTag(_vm.top_section.tags).color
                                : null
                            ),
                            'font-light': !_vm.getContrastYIQ(
                              Object.keys(_vm.hasTag(_vm.top_section.tags)).length > 0
                                ? _vm.hasTag(_vm.top_section.tags).color
                                : null
                            ),
                          },style:({
                            backgroundColor:
                              Object.keys(_vm.hasTag(_vm.top_section.tags)).length > 0
                                ? _vm.hasTag(_vm.top_section.tags).color
                                : null,
                          })},[_c('img',{attrs:{"src":_vm.hasTag(_vm.top_section.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"best-reward"},[_c('img',{attrs:{"src":_vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/svg-icons/cup-icon.svg',"alt":"Cup Icon","width":"20","height":"29"}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"best-choice-casino-cont"},[_c('div',{staticClass:"best-choice"},[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/svg-icons/cup-icon.svg',"alt":"Cup Icon","width":"20","height":"29"}})]),_vm._v(" "),(_vm.top_section.go_link)?[_c('a',{staticClass:"best-choice-cont cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'}},[_c('span',{staticClass:"\n                                span-h6 span-fix\n                                color-orange\n                                custom-font-1\n                              "},[_vm._v(_vm._s(_vm.$root.i18n.best_choice_casino))]),_vm._v(" "),_c('span',{staticClass:"span-fix"},[_vm._v(_vm._s(_vm.$root.i18n.play_at)+"\n                              "+_vm._s(_vm.top_section.product_name))])])]:_vm._e(),_vm._v(" "),(_vm.top_section.rating)?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat((_vm.top_section.rating / 2).toFixed(1))}})],1):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"best-choice-casino-cont-title",style:({
                          '--hover-color': _vm.$root.color_schema.primary_btn,
                        })},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(
                              _vm.top_section.bonus_match &&
                              _vm.top_section.exclusive_bonus_amount &&
                              _vm.top_section.exclusive_bonus_match
                            )?_c('span',{staticClass:"span-h2 text-hover custom-font-1"},[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(
                                  _vm.top_section.go_link,
                                  _vm.top_section.slug
                                ),"rel":_vm.$root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.top_section.exclusive_bonus_match)+"%\n                              "+_vm._s(_vm.$root.i18n.up_to)+"\n                              "+_vm._s(_vm._f("currency")(_vm.top_section.exclusive_bonus_amount,_vm.top_section.bonus_currency))+"\n                              "),(
                                  _vm.top_section.freespin ||
                                  _vm.top_section.freebie_name
                                )?[(
                                    (_vm.top_section.exclusive_bonus_amount ||
                                      _vm.top_section.bonus_amount) &&
                                    _vm.top_section.bonus_match
                                  )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.top_section.freespin)?[(
                                      _vm.pageData.show_freebie_currency === '1'
                                    )?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                                  "+_vm._s(_vm.top_section.freebie_name)+"\n                                ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(
                              _vm.top_section.bonus_match &&
                              !_vm.top_section.exclusive_bonus_amount &&
                              _vm.top_section.bonus_amount
                            )?_c('span',{staticClass:"span-h2 custom-font-1"},[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(
                                  _vm.top_section.go_link,
                                  _vm.top_section.slug
                                ),"rel":_vm.$root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.top_section.bonus_match)+"%\n                              "+_vm._s(_vm.$root.i18n.up_to)+"\n                              "+_vm._s(_vm._f("currency")(_vm.top_section.bonus_amount,_vm.top_section.bonus_currency))+"\n                              "),(
                                  _vm.top_section.freespin ||
                                  _vm.top_section.freebie_name
                                )?[(
                                    (_vm.top_section.exclusive_bonus_amount ||
                                      _vm.top_section.bonus_amount) &&
                                    _vm.top_section.bonus_match
                                  )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.top_section.freespin)?[(
                                      _vm.pageData.show_freebie_currency === '1'
                                    )?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                                  "+_vm._s(_vm.top_section.freebie_name)+"\n                                ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]]:_vm._e()],2)]):(
                              (_vm.top_section.bonus_match ||
                                _vm.top_section.exclusive_bonus_amount) &&
                              !_vm.top_section.exclusive_bonus_match
                            )?_c('span',{staticClass:"span-h2 custom-font-1 text-hover"},[(
                                _vm.top_section.freespin ||
                                _vm.top_section.freebie_name
                              )?[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(
                                    _vm.top_section.go_link,
                                    _vm.top_section.slug
                                  ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                    ? 'nofollow sponsored'
                                    : 'nofollow'}},[(_vm.top_section.freespin)?[(
                                      _vm.pageData.show_freebie_currency === '1'
                                    )?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                                  "+_vm._s(_vm.top_section.freebie_name)+"\n                                ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]],2)]:_vm._e()],2):_vm._e()],_vm._v(" "),_c('div',{staticClass:"btn-block"},[(_vm.top_section.go_link)?[_c('a',{class:{
                                'cta cta-primary cta-promotion cas-link custom-btn hover-btn': true,
                                'text-white':
                                  !_vm.$root.override_ctabtntxt_color &&
                                  !_vm.getContrastYIQ(
                                    _vm.$root.color_schema.primary_btn
                                  ),
                                'text-gray':
                                  !_vm.$root.override_ctabtntxt_color &&
                                  _vm.getContrastYIQ(
                                    _vm.$root.color_schema.primary_btn
                                  ),
                                'text-cta-override':
                                  _vm.$root.override_ctabtntxt_color,
                              },style:({
                                '--primary-btn':
                                  _vm.$root.color_schema.primary_btn,
                                '--primary-btn-hover': _vm.pSBC(
                                  -0.2,
                                  _vm.$root.color_schema.primary_btn
                                ),
                              }),attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(
                                  _vm.top_section.go_link,
                                  _vm.top_section.slug
                                ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.top_section.cta_button_text))]),_vm._l((_vm.$root.i18n
                                  .go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "paypp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]:_vm._e(),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(_vm.top_section.review_link)?_c('a',{staticClass:"read-review",attrs:{"title":_vm.top_section.product_name,"href":_vm.getRouteLink(
                                  _vm.top_section.review_link,
                                  'review'
                                )}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                                  _vm.$root.i18n.read_our_review,
                                  _vm.top_section.product_name
                                )))]):_vm._e()]:[(_vm.top_section.review_link)?_c('router-link',{staticClass:"read-review",attrs:{"title":_vm.top_section.product_name,"to":_vm.getRouteLink(
                                  _vm.top_section.review_link,
                                  'review'
                                )}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                                  _vm.$root.i18n.read_our_review,
                                  _vm.top_section.product_name
                                )))]):_vm._e()]],2)],2)])]:[(_vm.noPartnerAvailableOption)?[_c('span',[_vm._v(_vm._s(_vm.noPartnerAvailableText))])]:_vm._e()]]],2),_vm._v(" "),(_vm.top_section && _vm.top_section.product_id)?[_c('div',{staticClass:"best-choice-casino-cont-title view-mob pb-10"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(
                        _vm.top_section.bonus_match &&
                        _vm.top_section.exclusive_bonus_amount &&
                        _vm.top_section.exclusive_bonus_match
                      )?_c('span',{staticClass:"span-h2 text-hover custom-font-1"},[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.top_section.exclusive_bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.top_section.exclusive_bonus_amount,_vm.top_section.bonus_currency))+"\n                        "),(
                            _vm.top_section.freespin || _vm.top_section.freebie_name
                          )?[(
                              (_vm.top_section.exclusive_bonus_amount ||
                                _vm.top_section.bonus_amount) &&
                              _vm.top_section.bonus_match
                            )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.top_section.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                            "+_vm._s(_vm.top_section.freebie_name)+"\n                          ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(
                        _vm.top_section.bonus_match &&
                        !_vm.top_section.exclusive_bonus_amount &&
                        _vm.top_section.bonus_amount
                      )?_c('span',{staticClass:"span-h2 custom-font-1"},[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.top_section.bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.top_section.bonus_amount,_vm.top_section.bonus_currency))+"\n                        "),(
                            _vm.top_section.freespin || _vm.top_section.freebie_name
                          )?[(
                              (_vm.top_section.exclusive_bonus_amount ||
                                _vm.top_section.bonus_amount) &&
                              _vm.top_section.bonus_match
                            )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.top_section.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                            "+_vm._s(_vm.top_section.freebie_name)+"\n                          ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]]:_vm._e()],2)]):(
                        (_vm.top_section.bonus_match ||
                          _vm.top_section.exclusive_bonus_amount) &&
                        !_vm.top_section.exclusive_bonus_match
                      )?_c('span',{staticClass:"span-h2 custom-font-1 text-hover"},[(
                          _vm.top_section.freespin || _vm.top_section.freebie_name
                        )?[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'}},[(_vm.top_section.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                            "+_vm._s(_vm.top_section.freebie_name)+"\n                          ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]],2)]:_vm._e()],2):_vm._e()],_vm._v(" "),_c('div',{staticClass:"btn-block"},[(_vm.top_section.go_link)?[_c('a',{class:{
                          'cta cta-primary cta-promotion cas-link custom-btn hover-btn': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.top_section.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "paypp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]:_vm._e(),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(_vm.top_section.review_link)?_c('a',{staticClass:"read-review",attrs:{"title":_vm.top_section.product_name,"href":_vm.getRouteLink(_vm.top_section.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                            _vm.$root.i18n.read_our_review,
                            _vm.top_section.product_name
                          )))]):_vm._e()]:[(_vm.top_section.review_link)?_c('router-link',{staticClass:"read-review",attrs:{"title":_vm.top_section.product_name,"to":_vm.getRouteLink(_vm.top_section.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                            _vm.$root.i18n.read_our_review,
                            _vm.top_section.product_name
                          )))]):_vm._e()]],2)],2)]:_vm._e()],2)])],1)])])]):[(
        !_vm.$root.disable_not_supported_banner && _vm.$root.disableNotSupportBanner
      )?[_c('section',{staticClass:"ct-inner-banner pt-26",style:({ background: _vm.$root.color_schema.primary })},[_c('div',{staticClass:"container"},[(_vm.breadcrumb && _vm.breadcrumb.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadcrumb,"dark":_vm.getContrastYIQ(_vm.$root.color_schema.primary)}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.$root.disableNotSupportBanner)?_c('NotSupportModal',{attrs:{"notsupportbannerData":_vm.$root.notsupportbannerData}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"\n                  casino-card\n                  casino-card-software\n                  casino-card-bonus\n                  casino-card-payment-toplist\n                ",style:({
                  height:
                    !_vm.$root.disable_not_supported_banner &&
                    _vm.$root.disableNotSupportBanner &&
                    _vm.paymentWidth < 576
                      ? '565px'
                      : null,
                })})],1)])])])]:_vm._e()],_vm._v(" "),_c('div',{class:{ 'custom-background-image': _vm.$root.color_schema.site_bg_img },style:({
      '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
      '--bg-color': _vm.$root.color_schema.site_bg_color,
    })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"observer",rawName:"v-observer:subtree",value:(_vm.mutationObserve),expression:"mutationObserve",arg:"subtree"}],class:{
        'custom-background-color': _vm.$root.color_schema.site_bg_img,
        'pb-25': _vm.blockData.length > 0,
        'pt-26':
          !_vm.feature_image &&
          !(
            !_vm.$root.disable_not_supported_banner &&
            _vm.$root.disableNotSupportBanner
          ),
      }},[(
          !_vm.feature_image &&
          !(
            !_vm.$root.disable_not_supported_banner &&
            _vm.$root.disableNotSupportBanner
          )
        )?_c('section',[_c('div',{staticClass:"container overflow-auto"},[(_vm.breadcrumb && _vm.breadcrumb.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadcrumb,"dark":true}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.blockData.length > 0)?_c('section',{class:{
          'ct-card-horizontal-game':
            _vm.feature_image ||
            (!_vm.$root.disable_not_supported_banner &&
              _vm.$root.disableNotSupportBanner),
        }},[_vm._l((_vm.blockData),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]})],2):_vm._e(),_vm._v(" "),(
          _vm.endOfblockData &&
          _vm.advantage.title &&
          _vm.advantage.options &&
          _vm.disadvantage.title &&
          _vm.disadvantage.options
        )?_c('section',{staticClass:"ct-editor-section editor-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"payment-ad-dis-container"},[_c('div',{staticClass:"advantage-green"},[_c('div',{staticClass:"advantage-green-header"},[_c('h3',{staticClass:"custom-font-1"},[_c('i',[_c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19.8644 2.43441C17.5097 0.245343 14.0078 0.639093 11.8464 3.07191L10.9999 4.02347L10.1535 3.07191C7.99643 0.639093 4.49018 0.245343 2.13549 2.43441C-0.562943 4.94691 -0.70474 9.45628 1.7101 12.1797L10.0246 21.5453C10.5617 22.15 11.4339 22.15 11.971 21.5453L20.2855 12.1797C22.7046 9.45628 22.5628 4.94691 19.8644 2.43441Z","fill":"white"}})])]),_vm._v(_vm._s(_vm.advantage.title)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"advantage-green-content"},[_c('div',{staticClass:"tick-div-green"},[_c('ul',{},_vm._l((_vm.advantage.options),function(pros,index){return _c('li',{key:index,staticClass:"pros"},[_vm._v("\n                      "+_vm._s(pros.option)+"\n                    ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"disadvantage-red"},[_c('div',{staticClass:"disadvantage-red-header"},[_c('h3',{staticClass:"custom-font-1"},[_c('i',[_c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20.3541 1.95916L20.251 1.84197C18.2744 -0.361156 15.1806 -0.581468 12.9635 1.14822L14.4373 5.99509L10.3123 8.99509L12.3748 14.9951L6.18728 8.24509L10.3123 5.24509L9.08338 1.19041C6.86189 -0.581468 3.73807 -0.375218 1.74861 1.84666L1.64549 1.95916C-0.447091 4.29353 -0.537325 8.01072 1.33182 10.4998L10.4455 20.7467C10.7506 21.0888 11.2447 21.0888 11.5498 20.7467L20.6678 10.4951C22.5369 8.01072 22.4467 4.29353 20.3541 1.95916Z","fill":"white"}})])]),_vm._v(_vm._s(_vm.disadvantage.title)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"disadvantage-red-content"},[_c('div',{staticClass:"cross-div"},[_c('ul',{},_vm._l((_vm.disadvantage.options),function(cons,index){return _c('li',{key:index,staticClass:"cons"},[_vm._v("\n                      "+_vm._s(cons.option)+"\n                    ")])}),0)])])])])])]):_vm._e(),_vm._v(" "),(_vm.endOfblockData && _vm.morePaymentBottom)?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(_vm.auhtorBlockdata && _vm.endOfblockData)?void 0:_vm._e()],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(687);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("722eee07", content, true, {});

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(46);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-ce5355d2]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-ce5355d2]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-ce5355d2]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-ce5355d2]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-ce5355d2]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-ce5355d2]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-ce5355d2]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-ce5355d2]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-ce5355d2]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-ce5355d2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-ce5355d2]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-ce5355d2]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-inner-banner[data-v-ce5355d2]{padding:0 0 45px;background:#070438 url(" + escape(__webpack_require__(62)) + ") no-repeat 0 0}.ct-inner-banner .game-space[data-v-ce5355d2]{position:relative;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space[data-v-ce5355d2]{min-height:auto}}.ct-inner-banner .game-space img[data-v-ce5355d2]{border-radius:10px;box-shadow:0 5px 15px rgba(0,0,0,.05);height:100%;object-fit:cover;width:auto;max-height:321px;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space img[data-v-ce5355d2]{width:100%;max-height:none;min-height:auto}}.ct-inner-banner .game-space-content[data-v-ce5355d2]{position:absolute;left:0;right:0;top:0;bottom:0;padding:20px}.ct-inner-banner .game-space-content .button-block[data-v-ce5355d2],.ct-inner-banner .game-space-content[data-v-ce5355d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-inner-banner .game-space-content .button-block[data-v-ce5355d2]{width:100%;margin-bottom:15px}.ct-inner-banner .game-space-content .button-block .cta[data-v-ce5355d2]{min-width:100%;margin:5px 0;font-weight:700;font-size:14px;line-height:17px;padding:10px 18px}@media (min-width:768px){.ct-inner-banner .game-space-content .button-block .cta[data-v-ce5355d2]{min-width:330px;margin:10px 0;padding:15px 18px;font-size:18px;line-height:22px}}.ct-inner-banner .game-space-content .game-logo img[data-v-ce5355d2]{box-shadow:none;max-height:none;min-height:auto}@media (min-width:768px){.ct-inner-banner .row .col-md-8[data-v-ce5355d2]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-8[data-v-ce5355d2]{width:66.66666667%;float:left}}@media (min-width:768px){.ct-inner-banner .row .col-md-4[data-v-ce5355d2]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-4[data-v-ce5355d2]{width:33.33333333%;float:left}}.ct-inner-banner-lft[data-v-ce5355d2]{margin-bottom:19px}@media (min-width:992px){.ct-inner-banner-lft[data-v-ce5355d2]{margin-bottom:0}}@media (min-width:1360px){.ct-inner-banner-lft[data-v-ce5355d2]{width:906px!important}}@media (min-width:1360px){.ct-inner-banner-rgt[data-v-ce5355d2]{width:314px!important}}.review-tab-menu ul[data-v-ce5355d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow-x:auto;overflow-y:hidden;white-space:nowrap;border-bottom:1px solid #bbb;max-width:960px}.review-tab-menu ul li[data-v-ce5355d2]{margin-right:30px;display:inline-block;padding:10px 0;font-weight:400;font-size:16px;color:#9b9b9b;line-height:25px;cursor:pointer;position:relative}.review-tab-menu ul li[data-v-ce5355d2]:after{position:absolute;content:\"\";left:0;bottom:-5px;width:100%;height:3px;background:#e8321d;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s}.review-tab-menu ul li.active[data-v-ce5355d2],.review-tab-menu ul li[data-v-ce5355d2]:hover{color:#e8321d}.review-tab-menu ul li.active[data-v-ce5355d2]:after,.review-tab-menu ul li[data-v-ce5355d2]:hover:after{bottom:0}.review-tab-menu ul li.active[data-v-ce5355d2]{font-weight:700}.review-tab-menu-toplist ul[data-v-ce5355d2]{border-bottom:0;margin-bottom:0}.review-tab-menu-toplist ul li[data-v-ce5355d2]{font-size:12px;line-height:15px;color:#222;background:#f1f2f3;box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;text-align:center;min-width:130px;padding:10px 5px;margin-right:10px}.review-tab-menu-toplist ul li[data-v-ce5355d2]:after,.review-tab-menu-toplist ul li[data-v-ce5355d2]:before{display:none}.review-tab-menu-toplist ul li.active[data-v-ce5355d2],.review-tab-menu-toplist ul li[data-v-ce5355d2]:hover{background:#ffd039;color:#222;font-weight:400}.review-tab-container[data-v-ce5355d2]{margin:0}.review-tab-container .tab-content[data-v-ce5355d2]{display:none;padding-top:30px;padding-bottom:30px}.review-tab-container .tab-content.active[data-v-ce5355d2]{display:block}.review-tab-container-toplist .tab-content[data-v-ce5355d2]{padding-top:15px}.review-tab-container-toplist .tab-content .casino-card-horizontal[data-v-ce5355d2]:first-child{margin-top:0}.ct-card-promotion[data-v-ce5355d2]{padding:24px 0 17px;background-color:#080438;background-image:url(" + escape(__webpack_require__(254)) + ");background-repeat:no-repeat;background-position:100% 100%;background-size:60%}@media (min-width:768px){.ct-card-promotion[data-v-ce5355d2]{padding:48px 0 20px}}.ct-card-promotion h2[data-v-ce5355d2]{color:#fff}.ct-card-promotion .promotion-card[data-v-ce5355d2]{background:#fff;box-shadow:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:5px 9px 11px;border-bottom:1px solid #f1f2f3}@media (min-width:992px){.ct-card-promotion .promotion-card[data-v-ce5355d2]{display:block;box-shadow:0 1px 8px rgba(0,0,0,.2);padding:0;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;border-bottom:0}}.ct-card-promotion .promotion-card-img[data-v-ce5355d2]{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;background:#f1f2f3;width:62px;height:62px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:5px 12px;position:relative}@media (min-width:992px){.ct-card-promotion .promotion-card-img[data-v-ce5355d2]{background:linear-gradient(129.32deg,#f6f5f5 6.36%,#f6f5f5 71.95%);-webkit-border-radius:12px 12px 0 0;-moz-border-radius:12px 12px 0 0;border-radius:12px 12px 0 0;height:200px;width:100%;padding:0;display:block}}.ct-card-promotion .promotion-card-img img[data-v-ce5355d2]{min-width:auto;height:auto;margin-bottom:0}@media (min-width:992px){.ct-card-promotion .promotion-card-img img[data-v-ce5355d2]{min-width:114px}}.ct-card-promotion .promotion-card-content[data-v-ce5355d2]{padding:0 12px}@media (min-width:992px){.ct-card-promotion .promotion-card-content[data-v-ce5355d2]{padding:20px}}.ct-card-promotion .promotion-card-content .promotion-title a[data-v-ce5355d2]{font-size:16px;font-weight:700}@media (min-width:992px){.ct-card-promotion .promotion-card-content .promotion-title a[data-v-ce5355d2]{font-weight:400}}.ct-card-promotion .promotion-card-content p[data-v-ce5355d2]{display:none}@media (min-width:992px){.ct-card-promotion .promotion-card-content p[data-v-ce5355d2]{color:#7e7e7e;margin:10px 0;display:block}}.ct-card-promotion .promotion-card-content h5[data-v-ce5355d2]{margin-bottom:0}@media (min-width:992px){.ct-card-promotion .promotion-card-content h5[data-v-ce5355d2]{display:none}}.ct-card-promotion .promotion-card-content .cta-gray[data-v-ce5355d2]{display:none}@media (min-width:992px){.ct-card-promotion .promotion-card-content .cta-gray[data-v-ce5355d2]{display:block}}.ct-card-promotion-toplist[data-v-ce5355d2]{background-image:none;background-color:transparent;padding:10px 0 45px;margin-right:-20px}@media (min-width:768px){.ct-card-promotion-toplist[data-v-ce5355d2]{margin-right:-15px}}@media (min-width:992px){.ct-card-promotion-toplist[data-v-ce5355d2]{margin-right:0}}.ct-card-promotion-toplist .promotion-card[data-v-ce5355d2]{box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;display:block;padding:0;min-width:250px}@media (min-width:992px){.ct-card-promotion-toplist .promotion-card[data-v-ce5355d2]{min-width:auto}}.ct-card-promotion-toplist .promotion-card-img[data-v-ce5355d2]{-webkit-border-radius:12px 12px 0 0;-moz-border-radius:12px 12px 0 0;border-radius:12px 12px 0 0;background:#f6f5f5;height:154px;width:100%}.ct-card-promotion-toplist .promotion-card-img img[data-v-ce5355d2]{width:auto;max-width:115px;margin:0}@media (min-width:768px){.ct-card-promotion-toplist .promotion-card-img img[data-v-ce5355d2]{width:auto;max-width:none}}.ct-card-promotion-toplist .promotion-card-content[data-v-ce5355d2]{padding:25px 15px;text-align:center;white-space:normal}@media (min-width:1080px){.ct-card-promotion-toplist .promotion-card-content[data-v-ce5355d2]{padding:25px 20px}}.ct-card-promotion-toplist .promotion-card-content h6[data-v-ce5355d2]{margin-bottom:10px}.ct-card-promotion-toplist .promotion-card-content h6 a[data-v-ce5355d2]{color:#222}.ct-card-promotion-toplist .promotion-card-content p[data-v-ce5355d2]{text-align:center;color:#222;display:block}.ct-card-promotion-toplist .promotion-card-content .cta[data-v-ce5355d2]{padding:15px 10px;font-size:16px;display:block}@media (min-width:1080px){.ct-card-promotion-toplist .promotion-card-content .cta[data-v-ce5355d2]{font-size:18px}}@media (min-width:1200px){.ct-card-promotion-toplist .promotion-card-content .cta[data-v-ce5355d2]{padding:15px}}.ct-card-promotion__m .row[data-v-ce5355d2]{margin:0}@media (min-width:992px){.ct-card-promotion__m .row[data-v-ce5355d2]{margin:0 -8px}}.ct-card-promotion__m .row [class^=col-][data-v-ce5355d2]{padding:0}@media (min-width:992px){.ct-card-promotion__m .row [class^=col-][data-v-ce5355d2]{padding:0 8px}}.promotion-inner[data-v-ce5355d2]{position:static;width:auto;text-align:center}@media (min-width:992px){.promotion-inner[data-v-ce5355d2]{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute}}.promotion-inner p[data-v-ce5355d2]{white-space:nowrap;font-weight:700;margin-bottom:0;margin-top:25px;display:none}@media (min-width:992px){.promotion-inner p[data-v-ce5355d2]{display:inline-block}}.promotion-inner-img[data-v-ce5355d2]{min-height:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (min-width:992px){.promotion-inner-img[data-v-ce5355d2]{min-height:92px}}.ct-selection-casino .selection-cont[data-v-ce5355d2]{max-width:960px}.ct-selection-casino .selection-cont h2[data-v-ce5355d2]{color:#030030;margin-bottom:16px}@media (min-width:768px){.ct-selection-casino .selection-cont h2[data-v-ce5355d2]{margin-bottom:16px;color:#222}}.ct-related-page-links[data-v-ce5355d2]{background:#222;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;padding:18px 20px;margin:0;display:block}@media (min-width:768px){.ct-related-page-links[data-v-ce5355d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;margin:35px 0 25px}}.ct-related-page-links h6[data-v-ce5355d2]{font-weight:700;color:#fff;margin-bottom:12px;white-space:nowrap}@media (min-width:768px){.ct-related-page-links h6[data-v-ce5355d2]{margin-bottom:0;margin-right:27px}}.ct-related-page-links ul[data-v-ce5355d2]{overflow-x:auto;white-space:nowrap}.ct-related-page-links ul li[data-v-ce5355d2]{margin-right:40px;display:inline-block}.ct-related-page-links ul li[data-v-ce5355d2]:last-child{margin-right:0}.ct-related-page-links ul li a[data-v-ce5355d2]{font-size:16px;line-height:160%;color:#fff;font-family:var(--default-regular)}.ct-similar-casino-cards[data-v-ce5355d2]{padding-bottom:30px}.ct-similar-casino-cards .container[data-v-ce5355d2]{padding-right:0}@media (min-width:1024px){.ct-similar-casino-cards .container[data-v-ce5355d2]{padding:0 15px}}.ct-similar-casino-cards .mobile-scroller[data-v-ce5355d2]::-webkit-scrollbar-track{background-color:#fff}.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-ce5355d2]{padding:0 8px}@media (min-width:992px){.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-ce5355d2]{padding:0 4px}}@media (min-width:1200px){.ct-similar-casino-cards .mobile-scroller .row [class^=col-][data-v-ce5355d2]{padding:0 8px}}.ct-similar-casino-cards .mobile-scroller .casino-card-similar[data-v-ce5355d2]{padding:15px;white-space:normal;min-width:254px}@media (min-width:992px){.ct-similar-casino-cards .mobile-scroller .casino-card-similar[data-v-ce5355d2]{padding:10px;min-width:auto}}@media (min-width:1200px){.ct-similar-casino-cards .mobile-scroller .casino-card-similar[data-v-ce5355d2]{padding:15px}}.ct-review-toplist-page[data-v-ce5355d2]{padding-top:30px}.pb-25[data-v-ce5355d2]{padding-bottom:25px}.show_btn[data-v-ce5355d2]{margin-top:0!important}.pros-cons-tab[data-v-ce5355d2]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;display:block;margin-top:30px}@media (min-width:768px){.pros-cons-tab[data-v-ce5355d2]{display:none}}.pros-cons-tab .pros-cons-tab-content[data-v-ce5355d2]{margin:0;padding:60px 25px 30px}.pros-cons-tab .pros-cons-tab-content .item-content[data-v-ce5355d2]{display:none}.pros-cons-tab .pros-cons-tab-content .item-content.active[data-v-ce5355d2]{display:block}.pros-cons-tab ul.tab-items[data-v-ce5355d2]{list-style-type:none;display:-webkit-box;display:-ms-flexbox;display:flex;margin:0 0 -26px}.pros-cons-tab ul.tab-items li[data-v-ce5355d2]{background:#f1f2f3;box-shadow:0 5px 15px rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-left:0;width:59px;height:52px;line-height:1;margin:0 12px 0 0;cursor:pointer}.pros-cons-tab ul.tab-items li[data-v-ce5355d2]:before{display:none}.pros-cons-tab ul.tab-items li i img[data-v-ce5355d2]{margin:0}.pros-cons-tab ul.tab-items li span[data-v-ce5355d2]{padding-left:10px;font-weight:700;font-size:16px;line-height:20px;color:#222;display:none}.pros-cons-tab ul.tab-items li.active[data-v-ce5355d2]{background:#fff;width:153px}.pros-cons-tab ul.tab-items li.active span[data-v-ce5355d2]{display:block}.pros-cons-tab-content .item-content h3[data-v-ce5355d2]{color:#222}.page-links-outr .container[data-v-ce5355d2]{padding:0}@media (min-width:768px){.page-links-outr .container[data-v-ce5355d2]{padding:0 15px}}@media (max-width:576px){.page-links-outr .ct-related-page-links[data-v-ce5355d2]{background-color:#060236}}.page-links-outr .ct-related-page-links .router-link-exact-active[data-v-ce5355d2]{color:#fff}.best-choice-casino-icon img[data-v-ce5355d2]{border-radius:12px}.alter-pt12[data-v-ce5355d2]{padding-bottom:12px!important}.pt-37[data-v-ce5355d2]{padding-top:37px}.hide-mob[data-v-ce5355d2]{display:none}@media (min-width:768px){.hide-mob[data-v-ce5355d2]{display:block}}.casino-header[data-v-ce5355d2]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-ce5355d2]{text-align:center;color:#fff;font-weight:700;padding:8px}.ct-card-horizontal[data-v-ce5355d2]{padding:45px 0;background-color:#f1f2f3}.ct-card-horizontal-game[data-v-ce5355d2]{padding:32px 0}.ct-card-horizontal-game .casino-card-horizontal[data-v-ce5355d2]:first-child{margin-top:20px}.bonus-card-logo[data-v-ce5355d2]{padding:0!important;background:#fff!important}.bonus-card-logo img[data-v-ce5355d2]{height:100%!important;width:auto;object-fit:cover}@media (min-width:768px){.bonus-card-logo img[data-v-ce5355d2]{height:100%!important}}.best-choice-casino-cont-title h2 a[data-v-ce5355d2]:hover{color:var(--hover-color)}.best-choice-casino-cont-title .span-h2[data-v-ce5355d2]{margin:0 0 6px!important}.best-choice-casino-cont-title .span-h2 a[data-v-ce5355d2]:hover{color:var(--hover-color)}.best-choice-casino-cont[data-v-ce5355d2]{padding-left:15px!important}.best-choice[data-v-ce5355d2]{display:flex;align-items:start!important;flex-direction:column}@media (min-width:992px){.best-choice[data-v-ce5355d2]{flex-direction:row;align-items:flex-end!important}}.best-choice-cont[data-v-ce5355d2]{padding-left:0!important}@media (min-width:992px){.best-choice-cont[data-v-ce5355d2]{padding-left:10px!important}}.best-rating[data-v-ce5355d2]{padding-left:0}@media (min-width:992px){.best-rating[data-v-ce5355d2]{padding-left:16px}}.btn-block .custom-btn[data-v-ce5355d2]{margin-top:0!important}.btn-block .read-review[data-v-ce5355d2]{text-decoration:underline}.pt-30[data-v-ce5355d2]{padding-top:30px!important}.pt-20[data-v-ce5355d2]{padding-top:20px!important}.pb-0[data-v-ce5355d2]{padding-bottom:15px!important}@media (min-width:768px){.pb-0[data-v-ce5355d2]{padding-bottom:16px!important}}@media (min-width:992px){.pb-0[data-v-ce5355d2]{padding-bottom:30px!important}}.pb-10[data-v-ce5355d2]{padding-bottom:10px!important}.span-fix[data-v-ce5355d2]{font-size:16px;line-height:18px;display:block;margin-bottom:0}.bonus-card-content[data-v-ce5355d2]{display:flex;flex-direction:column}.bonus-card-content-bottom[data-v-ce5355d2]{margin-top:auto}.bonus-card-content-top .span-h6[data-v-ce5355d2]{font-size:16px}.half-col .proslist li[data-v-ce5355d2]{width:100%!important}.stripe[data-v-ce5355d2]{text-align:center}.stripe p[data-v-ce5355d2]{font-weight:700}.stripe[data-v-ce5355d2]{position:absolute;width:100%;height:20px;bottom:0;top:50%;transform:translateY(27px);left:0;overflow:hidden;border-bottom-left-radius:10px;border-bottom-right-radius:10px;background-color:#ffd039;display:none}@media (min-width:576px){.stripe[data-v-ce5355d2]{display:block}}.stripe img[data-v-ce5355d2]{width:14px!important;height:14px!important;border-radius:0!important;object-fit:contain!important}.stripe img[data-v-ce5355d2],.stripe svg[data-v-ce5355d2]{display:block;margin:3px auto;width:15px}.proslist-soft[data-v-ce5355d2]{margin:0;padding:0;list-style:none;column-count:0;display:block;height:26px;overflow:hidden;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s;column-count:unset}@media (min-width:576px){.proslist-soft[data-v-ce5355d2]{-ms-flex-wrap:wrap;flex-wrap:wrap;display:-webkit-box;display:-ms-flexbox;display:flex}}@media (min-width:992px){.proslist-soft[data-v-ce5355d2]{column-count:2;height:auto;overflow:visible}}@media (max-width:576px){.proslist-soft[data-v-ce5355d2]{padding-bottom:6px}}.proslist-soft li[data-v-ce5355d2]{position:relative;text-align:left;padding-left:32px;line-height:25px;color:#222;margin-bottom:18px;background-size:15px 15px;margin-bottom:22px;width:100%}.proslist-soft li[data-v-ce5355d2]:last-child{margin-bottom:0}@media (min-width:992px){.proslist-soft li[data-v-ce5355d2]{margin-right:10px;width:calc(50% - 10px)}}.proslist-soft li.pros-green[data-v-ce5355d2]:before{background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;background-position:50%;background-size:14px}.proslist-soft li.pros-green[data-v-ce5355d2]:before,.proslist-soft li.pros-red[data-v-ce5355d2]:before{position:absolute;content:\"\";left:0;top:0;display:inline-block;transform:translateY(0);height:26px;width:26px;border-radius:100%}.proslist-soft li.pros-red[data-v-ce5355d2]:before{background:#fe4646 url(" + escape(__webpack_require__(73)) + ") no-repeat;background-position:50%;background-size:14px}.why-use.expanded ul.proslist-soft[data-v-ce5355d2]{height:auto;padding-bottom:10px}.rm-top-padding[data-v-ce5355d2]{border-top:none}.casino-card-software[data-v-ce5355d2]{width:100%}", ""]);

// exports


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):_c('main',{staticClass:"main-content-area"},[(_vm.feature_image)?_c('section',{staticClass:"ct-inner-banner pt-26",style:({ background: _vm.$root.color_schema.primary })},[_c('div',{staticClass:"container"},[(_vm.breadcrumb && _vm.breadcrumb.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadcrumb,"dark":_vm.getContrastYIQ(_vm.$root.color_schema.primary)}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.$root.disableNotSupportBanner)?_c('NotSupportModal',{attrs:{"notsupportbannerData":_vm.$root.notsupportbannerData}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"\n              casino-card\n              casino-card-software\n              casino-card-bonus\n              casino-card-payment-toplist\n            ",style:({
              height:
                !_vm.$root.disable_not_supported_banner &&
                _vm.$root.disableNotSupportBanner &&
                _vm.softwareWidth < 576
                  ? '565px'
                  : null,
            })},[_c('div',{staticClass:"bonus-card-logo"},[(_vm.$root.enable_lazyload && _vm.feature_image)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.feature_image),expression:"feature_image"}],attrs:{"width":"400","height":"400","alt":_vm.getAltText(_vm.page_title, _vm.feature_image)}}):(_vm.feature_image)?_c('img',{attrs:{"src":_vm.feature_image,"width":"400","height":"400","alt":_vm.getAltText(_vm.page_title, _vm.feature_image)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bonus-card-content"},[(
                  (_vm.softwareProcons && _vm.softwareProconsArr.length > 0) ||
                  (_vm.top_section &&
                    _vm.top_section.procons &&
                    _vm.top_section.procons.length > 0)
                )?_c('div',{staticClass:"bonus-card-content-top"},[(_vm.feature_pro_name && _vm.feature_pro_name != '')?[_c('span',{staticClass:"span-h6 custom-font-1"},[_vm._v(_vm._s(_vm.$root.i18n.why_use)+" "+_vm._s(_vm.feature_pro_name)+"?")])]:_vm._e(),_vm._v(" "),_c('div',{class:{ 'why-use': true, expanded: _vm.showMorePros }},[(_vm.softwareProcons && _vm.softwareProconsArr.length > 0)?[_c('ul',{staticClass:"proslist-soft"},_vm._l((_vm.softwareProconsArr
                          .filter(function (ele) { return ele.is_featured === '1'; })
                          .sort(
                            function (ele1, ele2) { return ele2.is_positive - ele1.is_positive; }
                          )
                          .slice(0, 4)),function(data){return _c('li',{key:data.id,class:{
                          'pros-green':
                            data.is_featured === '1' &&
                            data.is_positive === '1',
                          'pros-red':
                            data.is_featured === '1' &&
                            data.is_positive === '0',
                        }},[_vm._v("\n                        "+_vm._s(data.description)+"\n                      ")])}),0)]:[(
                        _vm.top_section &&
                        _vm.top_section.procons &&
                        _vm.top_section.procons.length > 0
                      )?_c('ul',{staticClass:"proslist-soft"},_vm._l((_vm.top_section.procons
                          .filter(function (ele) { return ele.is_positive === '1'; })
                          .slice(0, 4)),function(data){return _c('li',{key:data.id,staticClass:"pros-green"},[_vm._v("\n                        "+_vm._s(data.description)+"\n                      ")])}),0):_vm._e()],_vm._v(" "),(_vm.softwareProcons)?[(_vm.softwareProconsArr.length > 1)?[(!_vm.showMorePros)?_c('a',{staticClass:"show-more",attrs:{"title":_vm.$root.i18n.show_more_pros},on:{"click":function($event){_vm.showMorePros = true}}},[_c('i'),_vm._v(_vm._s(_vm.$root.i18n.show_more_pros))]):_vm._e(),_vm._v(" "),(_vm.showMorePros)?_c('a',{staticClass:"show-less",attrs:{"title":_vm.$root.i18n.show_less_pros},on:{"click":function($event){_vm.showMorePros = false}}},[_c('i'),_vm._v(_vm._s(_vm.$root.i18n.show_less_pros))]):_vm._e()]:_vm._e()]:(
                      _vm.top_section &&
                      _vm.top_section.procons &&
                      _vm.top_section.procons.length > 1
                    )?[(!_vm.showMorePros)?_c('a',{staticClass:"show-more",attrs:{"title":_vm.$root.i18n.show_more_pros},on:{"click":function($event){_vm.showMorePros = true}}},[_c('i'),_vm._v(_vm._s(_vm.$root.i18n.show_more_pros))]):_vm._e(),_vm._v(" "),(_vm.showMorePros)?_c('a',{staticClass:"show-less",attrs:{"title":_vm.$root.i18n.show_less_pros},on:{"click":function($event){_vm.showMorePros = false}}},[_c('i'),_vm._v(_vm._s(_vm.$root.i18n.show_less_pros))]):_vm._e()]:_vm._e()],2)],2):_vm._e(),_vm._v(" "),_c('div',{class:{
                  'bonus-card-content-bottom pb-0': true,
                  'rm-top-padding': !(
                    (_vm.softwareProcons && _vm.softwareProconsArr.length > 0) ||
                    (_vm.top_section &&
                      _vm.top_section.procons &&
                      _vm.top_section.procons.length > 0)
                  ),
                }},[(_vm.hideToplistLabel)?void 0:[(_vm.top_section && _vm.top_section.product_id)?[(_vm.top_section && _vm.top_section.go_link)?_c('div',{staticClass:"best-choice-casino-icon"},[_c('a',{staticClass:"partner-logo cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[(
                            _vm.$root.enable_lazyload &&
                            _vm.assets_images &&
                            _vm.assets_images.pro_asset_sizes
                          )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                            _vm.top_section.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? _vm.top_section.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : ''
                          ),expression:"\n                            top_section.product_assets.filter(\n                              (ele) =>\n                                ele.asset_category_name ===\n                                assets_images.pro_asset_sizes.medium\n                            ).length > 0\n                              ? top_section.product_assets\n                                  .filter(\n                                    (ele) =>\n                                      ele.asset_category_name ===\n                                      assets_images.pro_asset_sizes.medium\n                                  )\n                                  .shift().url\n                              : ''\n                          "}],attrs:{"width":"90","height":"90","alt":_vm.getAltText(
                              _vm.top_section.product_name,
                              _vm.top_section.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              ).length > 0
                                ? _vm.top_section.product_assets
                                    .filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )
                                    .shift().url
                                : ''
                            )}}):(
                            _vm.assets_images && _vm.assets_images.pro_asset_sizes
                          )?_c('img',{attrs:{"src":_vm.top_section.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? _vm.top_section.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/failure.png',"width":"90","height":"90","alt":_vm.getAltText(
                              _vm.top_section.product_name,
                              _vm.top_section.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              ).length > 0
                                ? _vm.top_section.product_assets
                                    .filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )
                                    .shift().url
                                : _vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/failure.png'
                            )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-soft-bann"},[_c('div',{staticClass:"partner-hover-inner",style:({
                              '--primary-btn': _vm.$root.color_schema.primary_btn,
                              '--primary-btn-hover': _vm.pSBC(
                                -0.2,
                                _vm.$root.color_schema.primary_btn
                              ),
                            })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                            Object.keys(_vm.hasTag(_vm.top_section.tags)).length > 0
                          )?_c('div',{class:{
                            stripe: true,
                            'font-dark': _vm.getContrastYIQ(
                              Object.keys(_vm.hasTag(_vm.top_section.tags)).length > 0
                                ? _vm.hasTag(_vm.top_section.tags).color
                                : null
                            ),
                            'font-light': !_vm.getContrastYIQ(
                              Object.keys(_vm.hasTag(_vm.top_section.tags)).length > 0
                                ? _vm.hasTag(_vm.top_section.tags).color
                                : null
                            ),
                          },style:({
                            backgroundColor:
                              Object.keys(_vm.hasTag(_vm.top_section.tags)).length > 0
                                ? _vm.hasTag(_vm.top_section.tags).color
                                : null,
                          })},[_c('img',{attrs:{"src":_vm.hasTag(_vm.top_section.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"best-reward"},[_c('img',{attrs:{"src":_vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/svg-icons/cup-icon.svg',"width":"20","height":"29","alt":"Cup Icon"}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"best-choice-casino-cont"},[_c('div',{staticClass:"best-choice"},[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/svg-icons/cup-icon.svg',"width":"20","height":"29","alt":"Cup Icon"}})]),_vm._v(" "),(_vm.top_section.go_link)?[_c('a',{staticClass:"best-choice-cont cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'}},[_c('span',{staticClass:"\n                                span-h6 span-fix\n                                color-orange\n                                custom-font-1\n                              "},[_vm._v(_vm._s(_vm.$root.i18n.best_choice_casino))]),_vm._v(" "),_c('span',{staticClass:"span-fix"},[_vm._v(_vm._s(_vm.$root.i18n.play_at)+"\n                              "+_vm._s(_vm.top_section.product_name))])])]:_vm._e(),_vm._v(" "),(_vm.top_section.rating)?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat((_vm.top_section.rating / 2).toFixed(1))}})],1):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"best-choice-casino-cont-title",style:({
                          '--hover-color': _vm.$root.color_schema.primary_btn,
                        })},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(
                              _vm.top_section.bonus_match &&
                              _vm.top_section.exclusive_bonus_amount &&
                              _vm.top_section.exclusive_bonus_match
                            )?_c('span',{staticClass:"span-h2 text-hover custom-font-1"},[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(
                                  _vm.top_section.go_link,
                                  _vm.top_section.slug
                                ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow'}},[_vm._v(_vm._s(_vm.top_section.exclusive_bonus_match)+"%\n                              "+_vm._s(_vm.$root.i18n.up_to)+"\n                              "+_vm._s(_vm._f("currency")(_vm.top_section.exclusive_bonus_amount,_vm.top_section.bonus_currency))+"\n                              "),(
                                  _vm.top_section.freespin ||
                                  _vm.top_section.freebie_name
                                )?[(
                                    (_vm.top_section.exclusive_bonus_amount ||
                                      _vm.top_section.bonus_amount) &&
                                    _vm.top_section.bonus_match
                                  )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.top_section.freespin)?[(
                                      _vm.pageData.show_freebie_currency === '1'
                                    )?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                                  "+_vm._s(_vm.top_section.freebie_name)+"\n                                ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(
                              _vm.top_section.bonus_match &&
                              !_vm.top_section.exclusive_bonus_amount &&
                              _vm.top_section.bonus_amount
                            )?_c('span',{staticClass:"span-h2 custom-font-1"},[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(
                                  _vm.top_section.go_link,
                                  _vm.top_section.slug
                                ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow'}},[_vm._v(_vm._s(_vm.top_section.bonus_match)+"%\n                              "+_vm._s(_vm.$root.i18n.up_to)+"\n                              "+_vm._s(_vm._f("currency")(_vm.top_section.bonus_amount,_vm.top_section.bonus_currency))+"\n                              "),(
                                  _vm.top_section.freespin ||
                                  _vm.top_section.freebie_name
                                )?[(
                                    (_vm.top_section.exclusive_bonus_amount ||
                                      _vm.top_section.bonus_amount) &&
                                    _vm.top_section.bonus_match
                                  )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.top_section.freespin)?[(
                                      _vm.pageData.show_freebie_currency === '1'
                                    )?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                                  "+_vm._s(_vm.top_section.freebie_name)+"\n                                ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]]:_vm._e()],2)]):(
                              (_vm.top_section.bonus_match ||
                                _vm.top_section.exclusive_bonus_amount) &&
                              !_vm.top_section.exclusive_bonus_match
                            )?_c('span',{staticClass:"span-h2 custom-font-1 text-hover"},[(
                                _vm.top_section.freespin ||
                                _vm.top_section.freebie_name
                              )?[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(
                                    _vm.top_section.go_link,
                                    _vm.top_section.slug
                                  ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                    ? 'nofollow sponsored'
                                    : 'nofollow'}},[(_vm.top_section.freespin)?[(
                                      _vm.pageData.show_freebie_currency === '1'
                                    )?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                                  "+_vm._s(_vm.top_section.freebie_name)+"\n                                ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]],2)]:_vm._e()],2):_vm._e()],_vm._v(" "),_c('div',{staticClass:"btn-block"},[(_vm.top_section.go_link)?[_c('a',{class:{
                                'cta cta-primary cta-promotion cas-link custom-btn hover-btn': true,
                                'text-white':
                                  !_vm.$root.override_ctabtntxt_color &&
                                  !_vm.getContrastYIQ(
                                    _vm.$root.color_schema.primary_btn
                                  ),
                                'text-gray':
                                  !_vm.$root.override_ctabtntxt_color &&
                                  _vm.getContrastYIQ(
                                    _vm.$root.color_schema.primary_btn
                                  ),
                                'text-cta-override':
                                  _vm.$root.override_ctabtntxt_color,
                              },style:({
                                '--primary-btn':
                                  _vm.$root.color_schema.primary_btn,
                                '--primary-btn-hover': _vm.pSBC(
                                  -0.2,
                                  _vm.$root.color_schema.primary_btn
                                ),
                              }),attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(
                                  _vm.top_section.go_link,
                                  _vm.top_section.slug
                                ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.top_section.cta_button_text))]),_vm._l((_vm.$root.i18n
                                  .go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "softpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]:_vm._e(),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(_vm.top_section.review_link)?_c('a',{staticClass:"read-review",attrs:{"title":_vm.top_section.product_name,"href":_vm.getRouteLink(
                                  _vm.top_section.review_link,
                                  'review'
                                )}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                                  _vm.$root.i18n.read_our_review,
                                  _vm.top_section.product_name
                                )))]):_vm._e()]:[(_vm.top_section.review_link)?_c('router-link',{staticClass:"read-review",attrs:{"title":_vm.top_section.product_name,"to":_vm.getRouteLink(
                                  _vm.top_section.review_link,
                                  'review'
                                )}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                                  _vm.$root.i18n.read_our_review,
                                  _vm.top_section.product_name
                                )))]):_vm._e()]],2)],2)])]:[(_vm.noPartnerAvailableOption)?[_c('span',[_vm._v(_vm._s(_vm.noPartnerAvailableText))])]:_vm._e()]]],2),_vm._v(" "),(_vm.top_section && _vm.top_section.product_id)?[_c('div',{staticClass:"best-choice-casino-cont-title view-mob pb-10"},[(_vm.hideBonusLabel)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[(
                        _vm.top_section.bonus_match &&
                        _vm.top_section.exclusive_bonus_amount &&
                        _vm.top_section.exclusive_bonus_match
                      )?_c('span',{staticClass:"span-h2 text-hover custom-font-1"},[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'}},[_vm._v(_vm._s(_vm.top_section.exclusive_bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.top_section.exclusive_bonus_amount,_vm.top_section.bonus_currency))+"\n                        "),(
                            _vm.top_section.freespin || _vm.top_section.freebie_name
                          )?[(
                              (_vm.top_section.exclusive_bonus_amount ||
                                _vm.top_section.bonus_amount) &&
                              _vm.top_section.bonus_match
                            )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.top_section.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                            "+_vm._s(_vm.top_section.freebie_name)+"\n                          ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(
                        _vm.top_section.bonus_match &&
                        !_vm.top_section.exclusive_bonus_amount &&
                        _vm.top_section.bonus_amount
                      )?_c('span',{staticClass:"span-h2 custom-font-1"},[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'}},[_vm._v(_vm._s(_vm.top_section.bonus_match)+"%\n                        "+_vm._s(_vm.$root.i18n.up_to)+"\n                        "+_vm._s(_vm._f("currency")(_vm.top_section.bonus_amount,_vm.top_section.bonus_currency))+"\n                        "),(
                            _vm.top_section.freespin || _vm.top_section.freebie_name
                          )?[(
                              (_vm.top_section.exclusive_bonus_amount ||
                                _vm.top_section.bonus_amount) &&
                              _vm.top_section.bonus_match
                            )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(_vm.top_section.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                            "+_vm._s(_vm.top_section.freebie_name)+"\n                          ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]]:_vm._e()],2)]):(
                        (_vm.top_section.bonus_match ||
                          _vm.top_section.exclusive_bonus_amount) &&
                        !_vm.top_section.exclusive_bonus_match
                      )?_c('span',{staticClass:"span-h2 custom-font-1 text-hover"},[(
                          _vm.top_section.freespin || _vm.top_section.freebie_name
                        )?[_c('a',{staticClass:"cas-link",attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'}},[(_vm.top_section.freespin)?[(_vm.pageData.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(_vm.top_section.freespin,_vm.top_section.bonus_currency)))]:[_vm._v(_vm._s(_vm.top_section.freespin))],_vm._v("\n                            "+_vm._s(_vm.top_section.freebie_name)+"\n                          ")]:[_vm._v(_vm._s(_vm.top_section.freebie_name))]],2)]:_vm._e()],2):_vm._e()],_vm._v(" "),_c('div',{staticClass:"btn-block"},[(_vm.top_section.go_link)?[_c('a',{class:{
                          'cta cta-primary cta-promotion cas-link custom-btn hover-btn': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":_vm.top_section.product_name,"href":_vm.getGoLink(_vm.top_section.go_link, _vm.top_section.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.top_section.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "softpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)]:_vm._e(),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(_vm.top_section.review_link)?_c('a',{staticClass:"read-review",attrs:{"title":_vm.top_section.product_name,"href":_vm.getRouteLink(_vm.top_section.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                            _vm.$root.i18n.read_our_review,
                            _vm.top_section.product_name
                          )))]):_vm._e()]:[(_vm.top_section.review_link)?_c('router-link',{staticClass:"read-review",attrs:{"title":_vm.top_section.product_name,"to":_vm.getRouteLink(_vm.top_section.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                            _vm.$root.i18n.read_our_review,
                            _vm.top_section.product_name
                          )))]):_vm._e()]],2)],2)]:_vm._e()],2)])],1)])])]):[(
        !_vm.$root.disable_not_supported_banner && _vm.$root.disableNotSupportBanner
      )?[_c('section',{staticClass:"ct-inner-banner pt-26",style:({ background: _vm.$root.color_schema.primary })},[_c('div',{staticClass:"container"},[(_vm.breadcrumb && _vm.breadcrumb.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadcrumb,"dark":_vm.getContrastYIQ(_vm.$root.color_schema.primary)}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.$root.disableNotSupportBanner)?_c('NotSupportModal',{attrs:{"notsupportbannerData":_vm.$root.notsupportbannerData}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"\n                  casino-card\n                  casino-card-software\n                  casino-card-bonus\n                  casino-card-payment-toplist\n                ",style:({
                  height:
                    !_vm.$root.disable_not_supported_banner &&
                    _vm.$root.disableNotSupportBanner &&
                    _vm.softwareWidth < 576
                      ? '565px'
                      : null,
                })})],1)])])])]:_vm._e()],_vm._v(" "),_c('div',{class:{ 'custom-background-image': _vm.$root.color_schema.site_bg_img },style:({
      '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
      '--bg-color': _vm.$root.color_schema.site_bg_color,
    })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"observer",rawName:"v-observer:subtree",value:(_vm.mutationObserve),expression:"mutationObserve",arg:"subtree"}],class:{
        'custom-background-color': _vm.$root.color_schema.site_bg_img,
        'pb-25': _vm.blockData.length > 0,
        'pt-26':
          !_vm.feature_image &&
          !(
            !_vm.$root.disable_not_supported_banner &&
            _vm.$root.disableNotSupportBanner
          ),
      }},[(
          !_vm.feature_image &&
          !(
            !_vm.$root.disable_not_supported_banner &&
            _vm.$root.disableNotSupportBanner
          )
        )?_c('section',[_c('div',{staticClass:"container overflow-auto"},[(_vm.breadcrumb && _vm.breadcrumb.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadcrumb,"dark":true}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.blockData.length > 0)?_c('section',{class:{
          'ct-card-horizontal-game':
            _vm.feature_image ||
            (!_vm.$root.disable_not_supported_banner &&
              _vm.$root.disableNotSupportBanner),
        }},[_vm._l((_vm.blockData),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]})],2):_vm._e(),_vm._v(" "),(
          _vm.endOfblockData &&
          _vm.advantage.title &&
          _vm.advantage.options &&
          _vm.disadvantage.title &&
          _vm.disadvantage.options
        )?_c('section',{staticClass:"ct-editor-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"casino-card casino-card-pros-cons desk-view"},[_c('div',{staticClass:"half-col"},[_c('h2',{staticClass:"custom-font-1"},[_vm._v(_vm._s(_vm.advantage.title))]),_vm._v(" "),_c('ul',{staticClass:"proslist"},_vm._l((_vm.advantage.options),function(pros,index){return _c('li',{key:index,staticClass:"pros"},[_vm._v("\n                  "+_vm._s(pros.option)+"\n                ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"half-col"},[_c('h2',{staticClass:"custom-font-1"},[_vm._v(_vm._s(_vm.disadvantage.title))]),_vm._v(" "),_c('ul',{staticClass:"proslist"},_vm._l((_vm.disadvantage.options),function(cons,index){return _c('li',{key:index,staticClass:"cons"},[_vm._v("\n                  "+_vm._s(cons.option)+"\n                ")])}),0)])]),_vm._v(" "),(
              _vm.advantage.title &&
              _vm.advantage.options &&
              _vm.disadvantage.title &&
              _vm.disadvantage.options
            )?_c('div',{staticClass:"pros-cons-tab"},[_c('ul',{staticClass:"tab-items"},[(_vm.advantage.title && _vm.disadvantage.title)?[_c('li',{class:{ active: _vm.showPros },on:{"click":_vm.showProConsTab}},[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                        _vm.$root.asset_path +
                        '/svg-icons/polygon-green.svg',"alt":"Green Polygon"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.advantage.title.split(" ").shift()))])]),_vm._v(" "),_c('li',{class:{ active: !_vm.showPros },on:{"click":_vm.showProConsTab}},[_c('i',[_c('img',{attrs:{"src":_vm.$root.site_url +
                        _vm.$root.asset_path +
                        '/svg-icons/polygon-orange.svg',"alt":"Orange Polygon"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.disadvantage.title.split(" ").shift()))])])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"casino-card casino-card-pros-cons pros-cons-tab-content"},[_c('div',{class:{ 'item-content': true, active: _vm.showPros }},[_c('h3',{staticClass:"custom-font-1"},[_vm._v(_vm._s(_vm.advantage.title))]),_vm._v(" "),_c('ul',{staticClass:"proslist"},_vm._l((_vm.disadvantage.options),function(cons,index){return _c('li',{key:index,staticClass:"pros"},[_vm._v("\n                    "+_vm._s(cons.option)+"\n                  ")])}),0)]),_vm._v(" "),_c('div',{class:{ 'item-content': true, active: !_vm.showPros }},[_c('h3',{staticClass:"custom-font-1"},[_vm._v(_vm._s(_vm.disadvantage.title))]),_vm._v(" "),_c('ul',{staticClass:"proslist"},_vm._l((_vm.disadvantage.options),function(cons,index){return _c('li',{key:index,staticClass:"cons"},[_vm._v("\n                    "+_vm._s(cons.option)+"\n                  ")])}),0)])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.endOfblockData && _vm.morePaymentBottom)?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(_vm.auhtorBlockdata && _vm.endOfblockData)?void 0:_vm._e()],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(690);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("698e1f43", content, true, {});

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-4b4b1a8a]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-4b4b1a8a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-4b4b1a8a]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-4b4b1a8a]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-4b4b1a8a]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-4b4b1a8a]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-4b4b1a8a]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-4b4b1a8a]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-4b4b1a8a]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-4b4b1a8a]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-4b4b1a8a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-4b4b1a8a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.pt-37[data-v-4b4b1a8a]{padding-top:37px}.hide-mob[data-v-4b4b1a8a]{display:none}@media (min-width:768px){.hide-mob[data-v-4b4b1a8a]{display:block}}.casino-header[data-v-4b4b1a8a]{display:table;width:100%;background:#080438;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.casino-header h2[data-v-4b4b1a8a]{text-align:center;color:#fff;font-weight:700;padding:8px}.offer-card[data-v-4b4b1a8a]{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;padding:0 12px;position:relative;overflow:hidden}.offer-card[data-v-4b4b1a8a]:before{content:\"\";position:absolute;height:100%;width:100%;top:0;left:0;background:linear-gradient(180deg,transparent,rgba(0,0,0,.522118) 6.04%,rgba(0,0,0,.83));z-index:0}.offer-card-big .timer-text[data-v-4b4b1a8a]{margin:24px auto}.offer-card-big .timer-text svg[data-v-4b4b1a8a]{margin-right:22px}.offer-card-big .terms[data-v-4b4b1a8a]{display:block}@media (min-width:576px){.offer-card-big .terms[data-v-4b4b1a8a]{display:none}}.offer-card-big.suggested[data-v-4b4b1a8a]{border:2px solid #0165f7}.offer-card-bg[data-v-4b4b1a8a]{position:absolute;top:0;left:0;height:100%;width:100%;z-index:-1}.offer-card-bg img[data-v-4b4b1a8a]{object-fit:cover;height:100%}.offer-card-meta[data-v-4b4b1a8a]{display:inline-flex;position:relative;top:8px}@media (min-width:576px){.offer-card-meta[data-v-4b4b1a8a]{position:relative;top:12px}}@media (min-width:1200px){.offer-card-meta[data-v-4b4b1a8a]{position:absolute;top:12px}}.offer-card-logo[data-v-4b4b1a8a]{height:50px;width:50px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;overflow:hidden}.offer-card-title[data-v-4b4b1a8a]{font-size:16px;line-height:115%;font-weight:700;margin-left:8px;color:#fff}@media (min-width:576px){.offer-card-title[data-v-4b4b1a8a]{line-height:150%}}.offer-card-bonus[data-v-4b4b1a8a]{position:relative;width:100%;margin:20px auto;padding:10px 16px 18px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;border:2px dashed #fff}.offer-card-bonus .bonus-text[data-v-4b4b1a8a]{display:block;margin:0 auto;color:#fff;text-align:center;font-size:16px;line-height:20px;font-weight:700}@media (min-width:576px){.offer-card-bonus .bonus-text[data-v-4b4b1a8a]{font-size:32px;line-height:43px;width:465px}}@media (min-width:576px){.offer-card-bonus[data-v-4b4b1a8a]{width:643px;padding:27px;margin:40px auto}}.offer-card-bonus .mobile-tags[data-v-4b4b1a8a]{display:flex;justify-content:center;margin-bottom:6px}.offer-card-bonus .mobile-tags span[data-v-4b4b1a8a]{padding:7px 6px 5px;font-size:12px;line-height:11px;margin:0 3px}.offer-card-bonus .mobile-tags span svg[data-v-4b4b1a8a]{top:1px!important}@media (min-width:576px){.offer-card-bonus .mobile-tags[data-v-4b4b1a8a]{display:none}}.offer-card-tags[data-v-4b4b1a8a]{position:absolute;top:12px;right:12px;display:none}.offer-card-tags span[data-v-4b4b1a8a]{display:block;margin-bottom:7px;padding:4px 12px;font-size:12px;line-height:18px}@media (min-width:576px){.offer-card-tags[data-v-4b4b1a8a]{display:inline-block}}@media (min-width:768px){.offer-card-small[data-v-4b4b1a8a]{width:360px}}@media (min-width:1200px){.offer-card-small[data-v-4b4b1a8a]{width:380px}}.offer-card-small .card-tags[data-v-4b4b1a8a]{display:flex;justify-content:center;margin-bottom:6px}.offer-card-small .card-tags span[data-v-4b4b1a8a]{padding:3px 6px;width:64px;font-size:8px;line-height:8px;margin:0 3px}.offer-card-small .card-tags span svg[data-v-4b4b1a8a]{top:1px!important}.offer-card-small .offer-card-meta[data-v-4b4b1a8a]{position:relative;top:12px}.offer-card-small .offer-card-bonus[data-v-4b4b1a8a]{width:100%;padding:10px 16px 18px}.offer-card-small .offer-card-bonus .bonus-text[data-v-4b4b1a8a]{font-size:16px;line-height:18px;width:calc(100% - 32px);font-family:var(--paragraph-font)}@media (min-width:576px){.offer-card-small .offer-card-bonus .bonus-text[data-v-4b4b1a8a]{font-size:24px;line-height:26px;width:339px}}.offer-card .pro-promotion-tag[data-v-4b4b1a8a]{background:#ffd039;text-align:center;font-weight:600;-webkit-border-radius:100px;-moz-border-radius:100px;border-radius:100px}.offer-card .pro-promotion-tag svg[data-v-4b4b1a8a]{position:relative;top:5px}.offer-card .pro-suggestion-tag[data-v-4b4b1a8a]{color:#fff;background:#0165f7;text-align:center;font-weight:600;-webkit-border-radius:100px;-moz-border-radius:100px;border-radius:100px}.offer-card .pro-suggestion-tag svg[data-v-4b4b1a8a]{position:relative;top:5px}.offer-card .cta[data-v-4b4b1a8a]{max-width:375px;margin:0 auto;display:block}.offer-card .timer-text[data-v-4b4b1a8a]{position:relative;margin:14px auto;display:block;text-align:center;font-size:12px;line-height:15px;color:#fe4646;white-space:normal;margin-bottom:24px}@media (min-width:768px){.offer-card .timer-text[data-v-4b4b1a8a]{font-size:16px;line-height:19px}}@media (min-width:992px){.offer-card .timer-text[data-v-4b4b1a8a]{font-size:16px}}.offer-card .timer-text svg[data-v-4b4b1a8a]{vertical-align:text-bottom;margin-right:6px}@media (min-width:576px){.offer-card .timer-text svg[data-v-4b4b1a8a]{margin-right:16px}}.offer-card .terms[data-v-4b4b1a8a]{padding:5px 11px;background:rgba(239,241,245,.1);margin:0 -12px;text-align:center}.offer-card .terms span[data-v-4b4b1a8a]{font-size:10px;line-height:15px;color:#c4c7c9}.text-bold[data-v-4b4b1a8a]{font-weight:700;margin-left:5px}.wrapper-header[data-v-4b4b1a8a]{font-weight:900;font-size:26px;line-height:31px;padding-bottom:8px;display:flex;align-items:baseline}.wrapper-header .hd-span[data-v-4b4b1a8a]{color:#fff;margin-left:12px}@media (min-width:768px){.wrapper-header[data-v-4b4b1a8a]{font-size:36px;line-height:54px}}.img-desktop[data-v-4b4b1a8a]{width:100%;object-fit:cover}.img-mobile[data-v-4b4b1a8a]{display:block;height:100%;width:100%;object-position:center;object-fit:cover}@media (min-width:992px){.img-mobile[data-v-4b4b1a8a]{display:none}}.img-desktop[data-v-4b4b1a8a]{display:none}@media (min-width:992px){.img-desktop[data-v-4b4b1a8a]{display:block}}.star-cls[data-v-4b4b1a8a]{justify-content:normal!important}.time-text[data-v-4b4b1a8a]{width:70px}@media (min-width:576px){.time-text[data-v-4b4b1a8a]{width:75px}}.partner-name[data-v-4b4b1a8a]{color:#fff}.pt-100 img[data-v-4b4b1a8a],.pt-100[data-v-4b4b1a8a]{width:100%;height:100%}.game-btn[data-v-4b4b1a8a],.promto-term[data-v-4b4b1a8a]{position:relative}.desk-text[data-v-4b4b1a8a]{display:none}@media (min-width:576px){.desk-text[data-v-4b4b1a8a]{display:block}}.mob-text[data-v-4b4b1a8a]{display:block}@media (min-width:576px){.mob-text[data-v-4b4b1a8a]{display:none}}", ""]);

// exports


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):_c('main',{staticClass:"main-content-area"},[(
      _vm.promotionPageData &&
      _vm.promotionPageData.featured_promotion &&
      _vm.promotionPageData.featured_promotion.metadata &&
      _vm.promotionPageData.featured_promotion.partner_information &&
      Object.keys(_vm.promotionPageData.featured_promotion.partner_information)
        .length > 0
    )?_c('section',{staticClass:"ct-inner-banner promo-bann pt-26 pb-25",style:({
      background: true ? '#232529' : 'none',
    })},[_c('div',{staticClass:"container z-con"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.promotionPageData.breadcrumb,"dark":_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg)}})],1),_vm._v(" "),(
          _vm.promotionPageData.featured_promotion_label &&
          _vm.promotionPageData.featured_promotion_label != ''
        )?_c('div',{staticClass:"wrapper-header"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"22","viewBox":"0 0 15 27","fill":"none"}},[_c('path',{attrs:{"d":"M14.5561 9.2487H8.52244L14.1157 0.44043H7.06908L0.462891 13.6528H5.65974L0.462891 25.9844L14.5561 9.2487Z","fill":"#FFDD09"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.83071 0.44043H7.06908L0.462891 13.6528H2.22452L8.83071 0.44043Z","fill":"white"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.3535 9.24866L1.78361 21.8004L0.0219727 25.9844L14.1151 9.24866H12.3535Z","fill":"#FD9808"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0.462446 26.4248C0.374346 26.4248 0.286298 26.4248 0.242223 26.3807C0.0660749 26.2486 -0.0220249 26.0284 0.0660748 25.8522L4.99868 14.0932H0.462446C0.330322 14.0932 0.154174 14.0051 0.0660748 13.873C-0.0220249 13.7409 -0.0220249 13.5647 0.0660748 13.4326L6.67226 0.220223C6.76036 0.0880997 6.89249 0 7.06863 0H14.1152C14.2914 0 14.4235 0.0880997 14.5116 0.220223C14.5997 0.352347 14.5997 0.528495 14.5116 0.660619L9.35876 8.80827H14.5556C14.7318 8.80827 14.8639 8.89637 14.952 9.07252C15.0401 9.24866 14.996 9.42486 14.908 9.55699L0.814742 26.2926C0.726694 26.3807 0.59457 26.4248 0.462446 26.4248ZM1.16709 13.2124H5.6593C5.79142 13.2124 5.92354 13.3005 6.01164 13.3885C6.09974 13.5206 6.09974 13.6528 6.05567 13.7849L2.00386 23.474L13.6307 9.68906H8.52194C8.3458 9.68906 8.21367 9.60096 8.12557 9.46883C8.03747 9.33671 8.03747 9.16056 8.12557 9.02844L13.3225 0.880842H7.33288L1.16709 13.2124Z","fill":"black"}})]),_vm._v(" "),_c('h1',{staticClass:"custom-font-1 hd-span"},[_vm._v("\n          "+_vm._s(_vm.promotionPageData.featured_promotion_label)+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.promotionPageData.featured_promotion.metadata)?_c('div',{staticClass:"offer-wrapper"},[_c('div',{staticClass:"offer-card offer-card-big suggested"},[_c('div',{staticClass:"offer-card-bg"},[_c('img',{staticClass:"img-desktop",attrs:{"src":_vm.promotionPageData.featured_promotion.metadata
                  .desktop_header_image,"alt":_vm.promotionPageData.featured_promotion.metadata.partner
                  ? _vm.getAltText(
                      _vm.promotionPageData.featured_promotion.metadata.partner
                        .post_title,
                      _vm.promotionPageData.featured_promotion.metadata
                        .desktop_header_image
                    )
                  : 'Header Desktop Image'}}),_vm._v(" "),_c('img',{staticClass:"img-mobile",attrs:{"src":_vm.promotionPageData.featured_promotion.metadata
                  .mobile_header_image,"alt":_vm.promotionPageData.featured_promotion.metadata.partner
                  ? _vm.getAltText(
                      _vm.promotionPageData.featured_promotion.metadata.partner
                        .post_title,
                      _vm.promotionPageData.featured_promotion.metadata
                        .desktop_header_image
                    )
                  : 'Header Mobile Image'}})]),_vm._v(" "),(_vm.promotionPageData.featured_promotion.partner_information)?_c('div',{staticClass:"offer-card-meta"},[_c('div',{staticClass:"offer-card-logo"},[(
                  _vm.promotionPageData.featured_promotion.partner_information
                    .go_link
                )?_c('a',{staticClass:"affiliate-logo partner-logo pt-100 cas-link",attrs:{"title":_vm.promotionPageData.featured_promotion.partner_information
                    .product_name,"href":_vm.getGoLink(
                    _vm.promotionPageData.featured_promotion.partner_information
                      .go_link,
                    _vm.promotionPageData.featured_promotion.partner_information
                      .slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[(
                    _vm.promotionPageData.featured_promotion.partner_information
                      .product_assets &&
                    _vm.getPartnerImg(
                      _vm.promotionPageData.featured_promotion.partner_information
                        .product_assets
                    )
                  )?_c('img',{attrs:{"src":_vm.getPartnerImg(
                      _vm.promotionPageData.featured_promotion.partner_information
                        .product_assets
                    ),"alt":_vm.getAltText(
                      _vm.promotionPageData.featured_promotion.partner_information
                        .product_name,
                      _vm.getPartnerImg(
                        _vm.promotionPageData.featured_promotion
                          .partner_information.product_assets
                      )
                    )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-promo"},[_c('div',{staticClass:"partner-hover-inner",style:({
                      '--primary-btn': _vm.$root.color_schema.primary_btn,
                      '--primary-btn-hover': _vm.pSBC(
                        -0.2,
                        _vm.$root.color_schema.primary_btn
                      ),
                    })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"offer-card-title"},[(_vm.$root.enable_piwik_reload)?[(
                    _vm.promotionPageData.featured_promotion.partner_information
                      .review_link
                  )?_c('a',{staticClass:"partner-name custom-font-1 text-hover",attrs:{"title":_vm.promotionPageData.featured_promotion.partner_information
                      .product_name,"href":_vm.getRouteLink(
                      _vm.promotionPageData.featured_promotion.partner_information
                        .review_link,
                      'review'
                    )}},[_c('span',[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                        _vm.$root.i18n.partner_name_review,
                        _vm.promotionPageData.featured_promotion
                          .partner_information.product_name
                      ))+"\n                  ")])]):_c('span',{staticClass:"partner-name custom-font-1"},[_vm._v(_vm._s(_vm.promotionPageData.featured_promotion.partner_information
                    .product_name))])]:[(
                    _vm.promotionPageData.featured_promotion.partner_information
                      .review_link
                  )?_c('router-link',{staticClass:"partner-name custom-font-1 text-hover",attrs:{"title":_vm.promotionPageData.featured_promotion.partner_information
                      .product_name,"to":_vm.getRouteLink(
                      _vm.promotionPageData.featured_promotion.partner_information
                        .review_link,
                      'review'
                    )}},[_c('span',[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                        _vm.$root.i18n.partner_name_review,
                        _vm.promotionPageData.featured_promotion
                          .partner_information.product_name
                      ))+"\n                  ")])]):_c('span',{staticClass:"partner-name custom-font-1"},[_vm._v(_vm._s(_vm.promotionPageData.featured_promotion.partner_information
                    .product_name))])],_vm._v(" "),_c('StarRating',{attrs:{"rating":parseFloat(
                    (
                      _vm.promotionPageData.featured_promotion.partner_information
                        .rating / 2
                    ).toFixed(1)
                  ),"classParam":_vm.strCls}})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"offer-card-tags"},[_c('span',{staticClass:"pro-promotion-tag"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"}},[_c('path',{attrs:{"d":"M7.97849 4.95613C7.94088 4.87537 7.85987 4.82354 7.77065 4.82354H5.05211L7.73508 0.587447C7.77981 0.516795 7.78256 0.427324 7.7422 0.354146C7.70182 0.280725 7.62472 0.235291 7.54122 0.235291H3.87063C3.78369 0.235291 3.7043 0.284381 3.66532 0.362157L0.224142 7.24451C0.188574 7.31541 0.192472 7.39982 0.234223 7.46749C0.276217 7.53516 0.349852 7.57645 0.429457 7.57645H2.78849L0.217931 13.6816C0.17411 13.786 0.213119 13.9071 0.309687 13.9663C0.346841 13.989 0.388135 14 0.429214 14C0.495054 14 0.559979 13.9718 0.604957 13.9185L7.94615 5.20088C8.00371 5.13254 8.0161 5.03711 7.97849 4.95613Z","fill":"black"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.97849 4.95613C7.94088 4.87537 7.85987 4.82354 7.77065 4.82354H5.05211L7.73508 0.587447C7.77981 0.516795 7.78256 0.427324 7.7422 0.354146C7.70182 0.280725 7.62472 0.235291 7.54122 0.235291H3.87063C3.78369 0.235291 3.7043 0.284381 3.66532 0.362157L0.224142 7.24451C0.188574 7.31541 0.192472 7.39982 0.234223 7.46749C0.276217 7.53516 0.349852 7.57645 0.429457 7.57645H2.78849L0.217931 13.6816C0.17411 13.786 0.213119 13.9071 0.309687 13.9663C0.346841 13.989 0.388135 14 0.429214 14C0.495054 14 0.559979 13.9718 0.604957 13.9185L7.94615 5.20088C8.00371 5.13254 8.0161 5.03711 7.97849 4.95613Z","fill":"black"}})]),_vm._v("\n              "+_vm._s(_vm.$root.i18n.promotion)+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"pro-suggestion-tag"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}},[_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M10.4896 9.65479C10.2314 9.65479 10.0217 9.4458 10.021 9.18738C10.0201 8.92859 10.2294 8.71802 10.4883 8.71729C11.6658 8.71362 12.786 8.00269 13.6426 6.71533C14.4647 5.47974 14.9478 3.86389 15.0214 2.12354H12.9567C12.6978 2.12354 12.4879 1.9137 12.4879 1.65479C12.4879 1.39587 12.6978 1.18604 12.9567 1.18604H15.5C15.7589 1.18604 15.9688 1.39587 15.9688 1.65479C15.9688 3.75513 15.4198 5.73669 14.4232 7.23474C13.3878 8.79065 11.9915 9.65015 10.4912 9.65479C10.4907 9.65479 10.4902 9.65479 10.4896 9.65479Z","fill":"#FF8E1D"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.44788 9.65479C5.44727 9.65479 5.4469 9.65479 5.44641 9.65479C3.94617 9.65015 2.54968 8.79065 1.5144 7.23474C0.5177 5.73669 -0.03125 3.75513 -0.03125 1.65479C-0.03125 1.39587 0.178589 1.18604 0.4375 1.18604H2.98084C3.23975 1.18604 3.44959 1.39587 3.44959 1.65479C3.44959 1.9137 3.23975 2.12354 2.98084 2.12354H0.916138C0.989746 3.86389 1.47278 5.47974 2.29492 6.71533C3.15149 8.00269 4.27173 8.71362 5.44922 8.71729C5.70813 8.71802 5.91736 8.92859 5.91651 9.18738C5.91577 9.4458 5.70606 9.65466 5.44788 9.65479Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.9897 0.03125H2.948C2.68921 0.03125 2.47925 0.241089 2.47925 0.5C2.47925 3.25354 3.01917 5.84973 3.99939 7.81018C4.62744 9.06616 5.39551 9.97791 6.24487 10.4999V13.052C6.24487 13.3109 6.45483 13.5208 6.71362 13.5208H9.22412C9.48303 13.5208 9.69287 13.3109 9.69287 13.052V10.4999C10.5422 9.97803 11.3104 9.06616 11.9384 7.81018C12.9186 5.84973 13.4585 3.25354 13.4585 0.5C13.4585 0.241089 13.2487 0.03125 12.9897 0.03125Z","fill":"#FFD12B"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9.69275 13.052V10.4999C10.5421 9.97803 11.3103 9.06616 11.9382 7.81018C12.9185 5.84973 13.4584 3.25354 13.4584 0.5C13.4584 0.241089 13.2485 0.03125 12.9896 0.03125H7.96875V13.5208H9.224C9.48291 13.5208 9.69275 13.3109 9.69275 13.052Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.4791 12.5833H5.45837C4.50781 12.5833 3.73438 13.3567 3.73438 14.3073V15.5625C3.73438 15.8213 3.94421 16.0311 4.20312 16.0311H11.7344C11.9933 16.0311 12.2031 15.8213 12.2031 15.5625V14.3073C12.2031 13.3567 11.4298 12.5833 10.4791 12.5833Z","fill":"#FF8E1D"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.4791 12.5833H7.96875V16.0311H11.7344C11.9933 16.0311 12.2031 15.8213 12.2031 15.5625V14.3073C12.2031 13.3567 11.4298 12.5833 10.4791 12.5833Z","fill":"#FF6D15"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.2363 16.0311H3.70093C3.44214 16.0311 3.23218 15.8213 3.23218 15.5625C3.23218 15.3036 3.44214 15.0938 3.70093 15.0938H12.2363C12.4952 15.0938 12.7051 15.3036 12.7051 15.5625C12.7051 15.8213 12.4952 16.0311 12.2363 16.0311Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.2365 15.0938H7.96875V16.0311H12.2365C12.4954 16.0311 12.7052 15.8213 12.7052 15.5625C12.7052 15.3036 12.4954 15.0938 12.2365 15.0938Z","fill":"#FF8E1D"}})]),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"16","height":"16","fill":"white"}})])])]),_vm._v("\n              "+_vm._s(_vm.$root.i18n.suggested)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"offer-card-bonus"},[_c('div',{staticClass:"mobile-tags"},[_c('span',{staticClass:"pro-promotion-tag"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"5","height":"9","viewBox":"0 0 5 9","fill":"none"}},[_c('path',{attrs:{"d":"M4.98659 3.18601C4.96308 3.13409 4.91245 3.10077 4.85668 3.10077H3.1576L4.83445 0.37757C4.86241 0.332151 4.86413 0.274634 4.83891 0.227591C4.81367 0.180392 4.76548 0.151184 4.71329 0.151184H2.41918C2.36484 0.151184 2.31522 0.182742 2.29086 0.232741L0.140119 4.65711C0.117889 4.70269 0.120326 4.75696 0.14642 4.80046C0.172666 4.84396 0.218688 4.8705 0.268441 4.8705H1.74284L0.136238 8.79522C0.108849 8.86232 0.13323 8.94018 0.193585 8.97824C0.216806 8.99284 0.242615 8.99991 0.26829 8.99991C0.309439 8.99991 0.350018 8.98177 0.378128 8.94756L4.96637 3.34335C5.00235 3.29942 5.01009 3.23807 4.98659 3.18601Z","fill":"black"}})]),_vm._v("\n                "+_vm._s(_vm.$root.i18n.promotion)+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"pro-suggestion-tag"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"}},[_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M5.24506 4.82739C5.11597 4.82739 5.01111 4.7229 5.01074 4.59369C5.01032 4.46429 5.11493 4.35901 5.24439 4.35864C5.83313 4.35681 6.39325 4.00134 6.82154 3.35767C7.23261 2.73987 7.47413 1.93195 7.51093 1.06177H6.47858C6.34913 1.06177 6.24421 0.956848 6.24421 0.827393C6.24421 0.697937 6.34913 0.593018 6.47858 0.593018H7.75025C7.87971 0.593018 7.98463 0.697937 7.98463 0.827393C7.98463 1.87756 7.71015 2.86835 7.21186 3.61737C6.69416 4.39532 5.99598 4.82507 5.24585 4.82739C5.24561 4.82739 5.24536 4.82739 5.24506 4.82739Z","fill":"#FF8E1D"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.72394 4.82739C2.72363 4.82739 2.72345 4.82739 2.72321 4.82739C1.97308 4.82507 1.27484 4.39532 0.757202 3.61737C0.25885 2.86835 -0.015625 1.87756 -0.015625 0.827393C-0.015625 0.697937 0.0892945 0.593018 0.21875 0.593018H1.49042C1.61987 0.593018 1.72479 0.697937 1.72479 0.827393C1.72479 0.956848 1.61987 1.06177 1.49042 1.06177H0.458069C0.494873 1.93195 0.736389 2.73987 1.14746 3.35767C1.57574 4.00134 2.13586 4.35681 2.72461 4.35864C2.85407 4.35901 2.95868 4.46429 2.95825 4.59369C2.95789 4.7229 2.85303 4.82733 2.72394 4.82739Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.495 0.015625H1.47412C1.34473 0.015625 1.23975 0.120544 1.23975 0.25C1.23975 1.62677 1.5097 2.92487 1.99982 3.90509C2.31384 4.53308 2.69788 4.98895 3.12256 5.24994V6.526C3.12256 6.65546 3.22754 6.76038 3.35693 6.76038H4.61218C4.74164 6.76038 4.84656 6.65546 4.84656 6.526V5.24994C5.27124 4.98901 5.65533 4.53308 5.9693 3.90509C6.45941 2.92487 6.72937 1.62677 6.72937 0.25C6.72937 0.120544 6.62445 0.015625 6.495 0.015625Z","fill":"#FFD12B"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4.84637 6.526V5.24994C5.27106 4.98901 5.65515 4.53308 5.96912 3.90509C6.45923 2.92487 6.72919 1.62677 6.72919 0.25C6.72919 0.120544 6.62427 0.015625 6.49481 0.015625H3.98438V6.76038H4.612C4.74146 6.76038 4.84637 6.65546 4.84637 6.526Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.23956 6.29163H2.72919C2.25391 6.29163 1.86719 6.67835 1.86719 7.15363V7.78126C1.86719 7.91065 1.97211 8.01557 2.10156 8.01557H5.86719C5.99664 8.01557 6.10156 7.91065 6.10156 7.78126V7.15363C6.10156 6.67835 5.7149 6.29163 5.23956 6.29163Z","fill":"#FF8E1D"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.23956 6.29163H3.98438V8.01557H5.86719C5.99664 8.01557 6.10156 7.91065 6.10156 7.78126V7.15363C6.10156 6.67835 5.7149 6.29163 5.23956 6.29163Z","fill":"#FF6D15"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.11829 8.01557H1.85059C1.72119 8.01557 1.61621 7.91065 1.61621 7.78125C1.61621 7.6518 1.72119 7.54688 1.85059 7.54688H6.11829C6.24774 7.54688 6.35266 7.6518 6.35266 7.78125C6.35266 7.91065 6.24774 8.01557 6.11829 8.01557Z","fill":"#FFB023"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.11822 7.54688H3.98438V8.01557H6.11822C6.24768 8.01557 6.3526 7.91065 6.3526 7.78125C6.3526 7.6518 6.24768 7.54688 6.11822 7.54688Z","fill":"#FF8E1D"}})]),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"8","height":"8","fill":"white"}})])])]),_vm._v("\n                "+_vm._s(_vm.$root.i18n.suggested)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"desk-text"},[(
                  _vm.promotionPageData.featured_promotion.partner_information
                    .go_link
                )?_c('a',{staticClass:"\n                  partner-name\n                  promto-text\n                  custom-font-1\n                  cas-link\n                  text-hover\n                ",attrs:{"title":_vm.promotionPageData.featured_promotion.partner_information
                    .product_name,"href":_vm.getGoLink(
                    _vm.promotionPageData.featured_promotion.partner_information
                      .go_link,
                    _vm.promotionPageData.featured_promotion.partner_information
                      .slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[(
                    _vm.promotionPageData.featured_promotion.short_descrp.length <
                    130
                  )?_c('span',{staticClass:"bonus-text"},[_vm._v(_vm._s(_vm.promotionPageData.featured_promotion.short_descrp))]):_c('span',{staticClass:"bonus-text"},[_vm._v(_vm._s(_vm.promotionPageData.featured_promotion.short_descrp.slice(
                    0,
                    130
                  ) + "..."))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mob-text"},[(
                  _vm.promotionPageData.featured_promotion.partner_information
                    .go_link
                )?_c('a',{staticClass:"\n                  partner-name\n                  promto-text\n                  custom-font-1\n                  cas-link\n                  text-hover\n                ",attrs:{"title":_vm.promotionPageData.featured_promotion.partner_information
                    .product_name,"href":_vm.getGoLink(
                    _vm.promotionPageData.featured_promotion.partner_information
                      .go_link,
                    _vm.promotionPageData.featured_promotion.partner_information
                      .slug
                  ),"rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow',"target":"_blank"}},[(
                    _vm.promotionPageData.featured_promotion.short_descrp.length <
                    100
                  )?_c('span',{staticClass:"bonus-text"},[_vm._v(_vm._s(_vm.promotionPageData.featured_promotion.short_descrp))]):_c('span',{staticClass:"bonus-text"},[_vm._v(_vm._s(_vm.promotionPageData.featured_promotion.short_descrp.slice(
                    0,
                    100
                  ) + "..."))])]):_vm._e()])]),_vm._v(" "),(
              _vm.promotionPageData.featured_promotion.partner_information &&
              _vm.promotionPageData.featured_promotion.partner_information.go_link
            )?_c('a',{class:{
              'cta cta-primary cta-promotion ml-0 custom-btn btn-width cta-large hover-btn cas-link': true,
              'text-white game-btn':
                !_vm.$root.override_ctabtntxt_color &&
                !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
              'text-gray':
                !_vm.$root.override_ctabtntxt_color &&
                _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
              'text-cta-override': _vm.$root.override_ctabtntxt_color,
            },style:({
              '--primary-btn': _vm.$root.color_schema.primary_btn,
              '--primary-btn-hover': _vm.pSBC(
                -0.2,
                _vm.$root.color_schema.primary_btn
              ),
            }),attrs:{"title":_vm.promotionPageData.featured_promotion.partner_information
                .product_name,"href":_vm.getGoLink(
                _vm.promotionPageData.featured_promotion.partner_information
                  .go_link,
                _vm.promotionPageData.featured_promotion.partner_information.slug
              ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                ? 'nofollow sponsored'
                : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.promotionPageData.featured_promotion.partner_information
                .cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "simpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e(),_vm._v(" "),(_vm.timer_html.length > 0)?_c('span',{staticClass:"timer-text promto-time"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"}},[_c('path',{attrs:{"d":"M13.1265 2.24486L12.4548 3.40718L14.7823 4.75061L15.454 3.58826C15.639 3.26561 15.5289 2.85623 15.2075 2.66983L14.0452 1.99809C13.7236 1.81188 13.313 1.92205 13.1265 2.24486Z","fill":"#FE4646"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.9999 3.02484C9.42474 3.02484 9.83974 3.06641 10.2499 3.125V2.03781L11.1093 2.03124V0.625C11.1093 0.279543 10.8297 0 10.4843 0H7.52209C7.17664 0 6.89709 0.279543 6.89709 0.625V2.03124L7.7499 2.03781V3.125C8.16007 3.06641 8.57507 3.02484 8.9999 3.02484Z","fill":"#FE4646"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9 3.75C4.51268 3.75 0.875 7.38765 0.875 11.875C0.875 16.3624 4.51268 20 9 20C13.4873 20 17.125 16.3624 17.125 11.875C17.125 7.38765 13.4873 3.75 9 3.75ZM12.7969 15.6938L8.06248 12.4161V7.78889H9.42876V11.7003L13.5745 14.5705L12.7969 15.6938Z","fill":"#FE4646"}})]),_vm._v(" "),_c('span',{staticClass:"time-text"},[_vm._v("\n              "+_vm._s(_vm.$root.i18n.time_left.charAt(0).toUpperCase() +
                _vm.$root.i18n.time_left.slice(1))+":\n            ")]),_vm._v(" "),_c('span',{staticClass:"text-bold",domProps:{"innerHTML":_vm._s(_vm.timer_html)}})]):_vm._e(),_vm._v(" "),(
              _vm.promotionPageData.featured_promotion.partner_information
                .bonus_tc &&
              _vm.promotionPageData.featured_promotion.partner_information
                .bonus_tc != ''
            )?_c('div',{staticClass:"terms promto-term"},[(
                _vm.promotionPageData.featured_promotion.partner_information
                  .bonus_tc &&
                _vm.promotionPageData.featured_promotion.partner_information
                  .bonus_tc != ''
              )?_c('span',{staticClass:"terms_tc cas-term",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),domProps:{"innerHTML":_vm._s(
                _vm.promotionPageData.featured_promotion.partner_information
                  .bonus_tc
              )}}):_vm._e(),_vm._v(" "),(
                _vm.promotionPageData.featured_promotion.partner_information
                  .bonus_tc &&
                _vm.promotionPageData.featured_promotion.partner_information
                  .terms &&
                _vm.promotionPageData.featured_promotion.partner_information
                  .bonus_tc != '' &&
                _vm.promotionPageData.featured_promotion.partner_information
                  .terms != ''
              )?_c('span',{staticClass:"\n                promotionPageData.featured_promotion.metadata.featured_promotion.partner_information-stroke\n              "},[_vm._v("|")]):_vm._e(),_vm._v(" "),(
                _vm.promotionPageData.featured_promotion.partner_information
                  .terms &&
                _vm.promotionPageData.featured_promotion.partner_information
                  .terms != ''
              )?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                  ? 'nofollow sponsored'
                  : 'nofollow',"title":_vm.promotionPageData.featured_promotion.partner_information
                  .product_name,"href":_vm.getGoLink(
                  _vm.promotionPageData.featured_promotion.partner_information
                    .term_link,
                  _vm.promotionPageData.featured_promotion.partner_information
                    .slug
                ),"target":"_blank"}},[_vm._v(_vm._s(_vm.promotionPageData.featured_promotion.partner_information.terms))]):_vm._e()]):_vm._e()])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{class:{
      'block-wrapper': true,
      'custom-background-image': _vm.$root.color_schema.site_bg_img,
    },style:({
      '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
      '--bg-color': _vm.$root.color_schema.site_bg_color,
    })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"observer",rawName:"v-observer",value:(_vm.mutationObserve),expression:"mutationObserve"}],class:{
        'custom-background-color': _vm.$root.color_schema.site_bg_img,
        'pb-25 pt-26': true,
      }},[(
          !(
            _vm.promotionPageData &&
            _vm.promotionPageData.featured_promotion &&
            _vm.promotionPageData.featured_promotion.metadata &&
            _vm.promotionPageData.featured_promotion.partner_information &&
            Object.keys(
              _vm.promotionPageData.featured_promotion.partner_information
            ).length > 0
          )
        )?_c('section',{staticClass:"ct-article"},[_c('div',{staticClass:"container overflow-auto"},[(_vm.promotionPageData.breadcrumb)?_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.promotionPageData.breadcrumb,"dark":true}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._l((_vm.blockData),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]}),_vm._v(" "),(
          _vm.morePaymentBottom &&
          _vm.promotionPageData &&
          _vm.promotionPageData.content &&
          _vm.blockData.length === _vm.promotionPageData.content.blocks.length
        )?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(
          _vm.auhtorBlockdata &&
          _vm.promotionPageData &&
          _vm.promotionPageData.content &&
          _vm.blockData.length === _vm.promotionPageData.content.blocks.length
        )?void 0:_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(693);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0dcc384e", content, true, {});

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(46);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-8d6b8e08]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-8d6b8e08]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-8d6b8e08]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-8d6b8e08]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-8d6b8e08]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-8d6b8e08]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-8d6b8e08]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-8d6b8e08]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-8d6b8e08]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-8d6b8e08]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-8d6b8e08]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.lang-img[data-v-8d6b8e08]{height:36px;width:36px}.px-0[data-v-8d6b8e08]{padding-left:0!important;padding-right:0!important}.pb-1[data-v-8d6b8e08]{padding-top:1px!important}.ct-inner-banner[data-v-8d6b8e08]{padding:0 0 45px;background:#070438 url(" + escape(__webpack_require__(62)) + ") no-repeat 0 0}.ct-inner-banner .game-space[data-v-8d6b8e08]{position:relative;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space[data-v-8d6b8e08]{min-height:auto}}.ct-inner-banner .game-space img[data-v-8d6b8e08]{border-radius:10px;box-shadow:0 5px 15px rgba(0,0,0,.05);height:100%;object-fit:cover;width:auto;max-height:321px;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space img[data-v-8d6b8e08]{width:100%;max-height:none;min-height:auto}}.ct-inner-banner .game-space-content[data-v-8d6b8e08]{position:absolute;left:0;right:0;top:0;bottom:0;padding:20px}.ct-inner-banner .game-space-content .button-block[data-v-8d6b8e08],.ct-inner-banner .game-space-content[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-inner-banner .game-space-content .button-block[data-v-8d6b8e08]{width:100%;margin-bottom:15px}.ct-inner-banner .game-space-content .button-block .cta[data-v-8d6b8e08]{min-width:100%;margin:5px 0;font-weight:700;font-size:14px;line-height:17px;padding:10px 18px}@media (min-width:768px){.ct-inner-banner .game-space-content .button-block .cta[data-v-8d6b8e08]{min-width:330px;margin:10px 0;padding:15px 18px;font-size:18px;line-height:22px}}.ct-inner-banner .game-space-content .game-logo img[data-v-8d6b8e08]{box-shadow:none;max-height:none;min-height:auto}@media (min-width:768px){.ct-inner-banner .row .col-md-8[data-v-8d6b8e08]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-8[data-v-8d6b8e08]{width:66.66666667%;float:left}}@media (min-width:768px){.ct-inner-banner .row .col-md-4[data-v-8d6b8e08]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-4[data-v-8d6b8e08]{width:33.33333333%;float:left}}.ct-inner-banner-lft[data-v-8d6b8e08]{margin-bottom:19px}@media (min-width:992px){.ct-inner-banner-lft[data-v-8d6b8e08]{margin-bottom:0}}@media (min-width:1360px){.ct-inner-banner-lft[data-v-8d6b8e08]{width:906px!important}}@media (min-width:1360px){.ct-inner-banner-rgt[data-v-8d6b8e08]{width:314px!important}}.new-review-banner-card[data-v-8d6b8e08]{padding:12px 16px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;box-shadow:none}@media (min-width:576px){.new-review-banner-card[data-v-8d6b8e08]{padding:20px}}@media (min-width:1200px){.new-review-banner-card[data-v-8d6b8e08]{padding:30px}}.new-review-banner-card-top[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:768px){.new-review-banner-card-top[data-v-8d6b8e08]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-top-left[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:auto;margin:0 -7px 18px -6px}@media (min-width:350px){.new-review-banner-card-top-left[data-v-8d6b8e08]{margin:0 -7px 18px 5px;justify-content:unset!important}}@media (min-width:576px){.new-review-banner-card-top-left[data-v-8d6b8e08]{width:100%;margin:0 0 28px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}}@media (min-width:768px){.new-review-banner-card-top-left[data-v-8d6b8e08]{margin:0 0 45px}}@media (min-width:1024px){.new-review-banner-card-top-left[data-v-8d6b8e08]{width:calc(100% - 400px);margin:0 0 5px}}@media (min-width:1080px){.new-review-banner-card-top-left[data-v-8d6b8e08]{width:calc(100% - 430px)}}@media (min-width:1200px){.new-review-banner-card-top-left[data-v-8d6b8e08]{width:calc(100% - 495px)}}.new-review-banner-card-top-left .review-left-img[data-v-8d6b8e08]{min-width:79px;max-width:79px;height:79px;background:#fff;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative}.new-review-banner-card-top-left .review-left-img a[data-v-8d6b8e08]{box-shadow:0 2px 4px rgba(0,0,0,.2);border-radius:12px;overflow:visible;margin-top:0}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img a[data-v-8d6b8e08]{margin-top:4px}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-img a[data-v-8d6b8e08]{margin-top:4px}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-img a[data-v-8d6b8e08]{margin-top:0}}.new-review-banner-card-top-left .review-left-img img[data-v-8d6b8e08]{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img img[data-v-8d6b8e08]{height:100%;width:100%}}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img[data-v-8d6b8e08]{min-width:245px;max-width:245px;height:245px}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-img[data-v-8d6b8e08]{min-width:245px;max-width:245px;height:245px}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-img[data-v-8d6b8e08]{min-width:250px;max-width:250px;height:250px}}.new-review-banner-card-top-left .review-left-img .exclusive-tag[data-v-8d6b8e08]{position:absolute;left:0;right:0;margin:auto;height:20px;font-size:12px;line-height:15px;width:100%;bottom:0;border-radius:0;border-bottom-left-radius:8px;border-bottom-right-radius:8px;display:flex;justify-content:center;align-items:center}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img .exclusive-tag[data-v-8d6b8e08]{bottom:14px;width:210px;height:28px;font-size:17px;line-height:28px;z-index:10;border-radius:8px}}.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-8d6b8e08]{width:18px!important;height:18px!important;border-radius:0!important;vertical-align:initial!important;object-fit:contain!important}@media (max-width:576px){.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-8d6b8e08]{margin:0 auto;width:14px!important;height:14px!important}}@media (min-width:576px){.new-review-banner-card-top-left .review-left-img .exclusive-tag p[data-v-8d6b8e08]{font-weight:700;margin-top:0;font-size:12px;margin:0}}@media (max-width:768px){.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-8d6b8e08],.new-review-banner-card-top-left .review-left-img .exclusive-tag svg[data-v-8d6b8e08]{width:12px}}.new-review-banner-card-top-left .review-left-content[data-v-8d6b8e08]{padding:10px 0 5px 15px;height:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content[data-v-8d6b8e08]{padding:0 30px}}.new-review-banner-card-top-left .review-left-content .approve[data-v-8d6b8e08]{font-weight:400;font-size:12px;line-height:15px;color:#9b9b9b;margin-bottom:8px;margin-top:10px;display:block}.new-review-banner-card-top-left .review-left-content .approve i[data-v-8d6b8e08]{margin-right:5px}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .approve i[data-v-8d6b8e08]{margin-right:7px}}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .approve[data-v-8d6b8e08]{font-size:14px;line-height:17px;color:#aeaeae}}.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:0;margin-top:0}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-8d6b8e08]{margin-bottom:4px;margin-top:0}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-8d6b8e08]{-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:4px;margin-top:0}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-8d6b8e08]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:4px;margin-top:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar p[data-v-8d6b8e08]{margin-bottom:4px;font-weight:400;color:#222;padding-right:7px}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .exclusive-bar p[data-v-8d6b8e08]{margin-bottom:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar .exclusive-tag[data-v-8d6b8e08]{margin-left:30px;display:none}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar .exclusive-tag[data-v-8d6b8e08]{display:none}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-rating[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title[data-v-8d6b8e08]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title p[data-v-8d6b8e08]{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;margin-bottom:4px;margin-top:4px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title p[data-v-8d6b8e08]{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;margin-bottom:4px}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:0;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;margin-bottom:5px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust[data-v-8d6b8e08]{margin-left:8px;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;margin-bottom:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust strong[data-v-8d6b8e08]{font-weight:700;font-size:10px;line-height:1;text-transform:uppercase;color:#4caf50}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust i[data-v-8d6b8e08]{background:#4caf50;width:8.35px;height:8.35px;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:3.65px}.new-review-banner-card-top-left .review-left-content-title[data-v-8d6b8e08]{display:none}.new-review-banner-card-top-left .review-left-content-title h1[data-v-8d6b8e08]{margin-bottom:12px}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-content-title h1[data-v-8d6b8e08]{margin-bottom:12px}}.new-review-banner-card-top-left .review-left-content-title .cta[data-v-8d6b8e08]{min-width:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content-title[data-v-8d6b8e08]{display:block}}.new-review-banner-card-top .view-mob[data-v-8d6b8e08]{display:block;text-align:center}.new-review-banner-card-top .view-mob h1[data-v-8d6b8e08]{margin-bottom:17px;padding:0 10%}.new-review-banner-card-top .view-mob .cta-promo-review[data-v-8d6b8e08]{font-size:18px;line-height:100%;margin-top:0;display:block}@media (min-width:768px){.new-review-banner-card-top .view-mob[data-v-8d6b8e08]{display:none}}.new-review-banner-card-top-right[data-v-8d6b8e08]{min-width:100%;margin-top:17px;border-top:0;border-right:0;border-left:0;padding:0}@media (min-width:768px){.new-review-banner-card-top-right[data-v-8d6b8e08]{width:calc(100% - 315px);min-width:calc(100% - 315px);border-right:1px solid #e5e5e5;border-left:0;padding:0 45px 0 0;margin-top:0}}@media (min-width:1024px){.new-review-banner-card-top-right[data-v-8d6b8e08]{width:400px;min-width:auto;padding:0 0 0 35px;border-right:0;border-left:1px solid #e5e5e5}}@media (min-width:1080px){.new-review-banner-card-top-right[data-v-8d6b8e08]{width:430px}}@media (min-width:1200px){.new-review-banner-card-top-right[data-v-8d6b8e08]{width:495px}}.new-review-banner-card-top-right h6[data-v-8d6b8e08]{color:#222}@media (min-width:576px){.new-review-banner-card-top-right h6[data-v-8d6b8e08]{margin:0 0 3px;color:#222}}.new-review-banner-card-top-right p[data-v-8d6b8e08]{color:#222}@media (min-width:576px){.new-review-banner-card-top-right p[data-v-8d6b8e08]{margin:0 0 20px;color:#465867}}.new-review-banner-card-bottom[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-top:0;padding:16px 0 0;min-width:100%;width:100%}@media (min-width:768px){.new-review-banner-card-bottom[data-v-8d6b8e08]{padding:0 0 0 45px;margin-top:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:315px;width:315px}}@media (min-width:1024px){.new-review-banner-card-bottom[data-v-8d6b8e08]{border-top:1px solid #e5e5e5;width:100%;min-width:auto;padding:24px 0 0;margin-top:32px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-bottom .casino-card-lists[data-v-8d6b8e08]{margin-bottom:0}@media (min-width:768px){.new-review-banner-card-bottom .casino-card-lists[data-v-8d6b8e08]{margin-bottom:10px}}@media (min-width:1200px){.new-review-banner-card-bottom .casino-card-lists[data-v-8d6b8e08]{margin-bottom:0}}.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-8d6b8e08]{margin-right:15px}.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-8d6b8e08]:last-child{margin-right:0}@media (min-width:992px){.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-8d6b8e08]{margin-right:16px}}.ct-editor-section .container[data-v-8d6b8e08]{position:static}.editor-content .max-cntent-area[data-v-8d6b8e08]{max-width:960px}.editor-content h1[data-v-8d6b8e08]{line-height:44px}.editor-content img[data-v-8d6b8e08]{margin-bottom:20px}.editor-content ul[data-v-8d6b8e08]{list-style-type:none;padding:0}.editor-content ul li[data-v-8d6b8e08]{font-style:normal;font-weight:400;font-size:16px;line-height:25px;position:relative;padding-left:20px;margin-bottom:15px}.editor-content ul li span[data-v-8d6b8e08]{font-weight:700}#sticky-nav[data-v-8d6b8e08]{position:-webkit-sticky;position:fixed;width:100%;border-bottom:1px solid #bbb;z-index:10}.review-top-menu[data-v-8d6b8e08]{padding-bottom:30px;padding-top:14px;background:#fff;border-bottom:1px solid #bbb;margin:0 -15px;padding:0 14px;height:53px}.review-top-menu .scroll-nav[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow-x:auto;overflow-y:hidden;white-space:nowrap;max-width:1210px;margin:0 auto;height:53px}.review-top-menu .scroll-nav .scroll-item[data-v-8d6b8e08]{margin-right:30px;display:inline-block;padding:10px 0;position:relative;font-weight:700;font-size:18px;color:#222;line-height:20px;cursor:pointer;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s}.review-top-menu .scroll-nav .scroll-item[data-v-8d6b8e08]:after{position:absolute;content:\"\";left:0;bottom:-5px;width:100%;height:3px;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s}.review-top-menu .scroll-nav .scroll-item.active[data-v-8d6b8e08],.review-top-menu .scroll-nav .scroll-item[data-v-8d6b8e08]:hover{color:var(--bg-clr)}.review-top-menu .scroll-nav .scroll-item.active[data-v-8d6b8e08]:after,.review-top-menu .scroll-nav .scroll-item[data-v-8d6b8e08]:hover:after{bottom:0}.review-top-menu .scroll-nav .scroll-item.active[data-v-8d6b8e08]{font-weight:700}.sticky[data-v-8d6b8e08]{position:-webkit-sticky;position:sticky;top:0;z-index:5}.casino-card-lists ul li[data-v-8d6b8e08]{margin:0 32px 0 0}.casino-card-lang-lists ul[data-v-8d6b8e08]{margin:0}@media (min-width:992px){.casino-card-lists ul[data-v-8d6b8e08]{margin-bottom:20px}}.casino-card-lang-lists ul li[data-v-8d6b8e08]{width:36px;height:36px;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;overflow:hidden;margin:0 6px 6px 0;padding:0;border:1px solid #bbb}.new-review-banner-card-top-right h6[data-v-8d6b8e08],.review-banner-card-top-right h6[data-v-8d6b8e08]{margin-bottom:3px}.review-top-menu ul li a[data-v-8d6b8e08],.review-top-menu ul li a[data-v-8d6b8e08]:active{padding:10px 20px 10px 0;font-weight:400;font-size:16px;color:#9b9b9b;line-height:25px}.rating-wrapper-small .radio-star-total[data-v-8d6b8e08]{padding-left:10px;line-height:20px}.casino-card-lists ul li[data-v-8d6b8e08]{margin:0 12px 0 0;padding:0;list-style-type:none}@media (min-width:374px){.casino-card-lists ul li[data-v-8d6b8e08]{margin:0 16px 0 0}}.casino-card-lists__review h6[data-v-8d6b8e08]{font-weight:400}.bonus-card-logo[data-v-8d6b8e08]{background:#fff!important;height:280px!important}.bonus-card-logo a[data-v-8d6b8e08]{text-align:center}.bonus-card-logo img[data-v-8d6b8e08]{height:100%;width:100%;object-fit:cover;border-radius:12px 12px 0 0}@media (min-width:992px){.bonus-card-logo img[data-v-8d6b8e08]{border-radius:12px 0 0 12px;width:100%}}@media (min-width:768px){.bonus-card-logo[data-v-8d6b8e08]{height:100%!important}}.bonus-card-content[data-v-8d6b8e08]{overflow:hidden;display:flex;flex-wrap:wrap;align-items:center}@media (min-width:768px){.bonus-card-content[data-v-8d6b8e08]{padding:30px 45px}}.bonus-card-content-top[data-v-8d6b8e08]{width:100%}.justify-flex-start[data-v-8d6b8e08]{justify-content:flex-start!important}@media (min-width:1200px){.casino-card-bonus[data-v-8d6b8e08]{height:300px}}@media (min-width:768px){.offset-md-1[data-v-8d6b8e08]{margin-left:8.33333%}}.play_term_wrapper[data-v-8d6b8e08]{display:flex;flex-direction:column;align-items:center}.play_term_wrapper .terms_tc[data-v-8d6b8e08]{margin-bottom:8px}.play_term_wrapper .btn-cust[data-v-8d6b8e08]{margin:18px 0!important}.mx-0[data-v-8d6b8e08]{margin-left:0;margin-right:0}.flex-wrap[data-v-8d6b8e08]{flex-wrap:wrap!important}.sticky-review-card[data-v-8d6b8e08]{bottom:0;left:0;right:0;z-index:1000;position:fixed;color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.05);transition:top .3s ease-out}@media (min-width:992px){.sticky-review-card .rating-wrapper-small[data-v-8d6b8e08]{display:inline-flex;height:24px;border-radius:50px;margin-left:15px;padding:1px 7px}.sticky-review-card .rating-wrapper-small .radio-star-total[data-v-8d6b8e08]{margin-left:0}}.sticky-review-card .sticky-inner[data-v-8d6b8e08]{background:var(--primary-btn);position:absolute;bottom:0;width:100%;max-width:78.125rem;padding:10px;display:flex;align-items:center;margin:0 auto;flex-wrap:wrap}@media (min-width:768px){.sticky-review-card .sticky-inner[data-v-8d6b8e08]{flex-wrap:nowrap}}@media (min-width:992px){.sticky-review-card .sticky-inner[data-v-8d6b8e08]{background:#fff;position:relative}}.sticky-review-card .sticky-inner .md-rating[data-v-8d6b8e08]{margin-top:10px;display:none}@media (min-width:768px){.sticky-review-card .sticky-inner .md-rating[data-v-8d6b8e08]{margin-top:8px;margin-left:-12px;display:inline-flex;height:18px;border-radius:50px;padding:1px 7px;align-items:stretch}}.sticky-review-card .sticky-inner .md-rating .radio-stars[data-v-8d6b8e08]{height:14px;width:14px}.sticky-review-card .sticky-inner .md-rating .radio-stars img[data-v-8d6b8e08]{border-radius:0;vertical-align:text-top}.sticky-review-card .sticky-inner .md-rating .radio-star-total[data-v-8d6b8e08]{font-size:14px;line-height:15px;padding-left:0;display:inline-flex;align-items:center}.sticky-review-card .sticky-inner .md-rating .radio-star-total span[data-v-8d6b8e08]{font-size:14px;line-height:15px}@media (min-width:992px){.sticky-review-card .sticky-inner .md-rating[data-v-8d6b8e08]{display:none}}.sticky-review-card .sticky-inner .sticky-text[data-v-8d6b8e08]{font-size:.875rem;margin-left:10px;margin-right:auto;line-height:.75rem;width:calc(100% - 60px)}@media (min-width:576px){.sticky-review-card .sticky-inner .sticky-text[data-v-8d6b8e08]{line-height:unset}}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text[data-v-8d6b8e08]{width:100%;margin-left:80px}}.sticky-review-card .sticky-inner .sticky-text .product-name[data-v-8d6b8e08]{display:flex;padding:0 0 5px}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text .product-name[data-v-8d6b8e08]{display:none}}.sticky-review-card .sticky-inner .sticky-text .product-name .best-rating[data-v-8d6b8e08]{margin-left:8px}.sticky-review-card .sticky-inner .sticky-text .sticky-title[data-v-8d6b8e08]{display:none}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .sticky-title[data-v-8d6b8e08]{display:flex}}.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-8d6b8e08]{font-weight:900;font-size:.875rem;line-height:14px}@media (min-width:576px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-8d6b8e08]{line-height:25px}}.sticky-review-card .sticky-inner .sticky-text .bonus-text a[data-v-8d6b8e08]{color:#fff}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-8d6b8e08]{font-size:.85rem}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-8d6b8e08]{font-size:1.625rem}.sticky-review-card .sticky-inner .sticky-text .bonus-text a[data-v-8d6b8e08]{color:#222}}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text[data-v-8d6b8e08]{font-size:.85rem}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text[data-v-8d6b8e08]{margin-left:0}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .terms-conditions[data-v-8d6b8e08]{padding-top:5px!important}}.sticky-review-card .sticky-inner .sticky-text .terms-conditions a[data-v-8d6b8e08]{color:#fff}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .terms-conditions a[data-v-8d6b8e08]{color:#aeaeae}}.sticky-review-card .sticky-inner .affliate-logo[data-v-8d6b8e08]{height:50px;width:50px;min-height:50px;min-width:50px;box-shadow:0 5px 15px rgba(0,0,0,.09);left:15px}.sticky-review-card .sticky-inner .affliate-logo img[data-v-8d6b8e08]{border-radius:12px}@media (min-width:768px){.sticky-review-card .sticky-inner .affliate-logo[data-v-8d6b8e08]{top:-25px;position:absolute}}@media (min-width:992px){.sticky-review-card .sticky-inner .affliate-logo[data-v-8d6b8e08]{width:85px;min-width:85px;height:85px;min-height:85px;top:0;left:0;position:relative;margin-right:30px}}.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-8d6b8e08]{display:none;font-size:18px;line-height:100%;margin:auto 2px!important;color:#fff!important}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-8d6b8e08]{display:block;background:var(--primary-btn);border-color:var(--primary-btn);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:inset 0 -4px 4px var(--primary-btn);min-width:280px;font-weight:900}}.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-8d6b8e08]:hover{background:var(--primary-btn-hover);border-color:var(--primary-btn-hover);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn-hover);box-shadow:inset 0 -4px 4px var(--primary-btn-hover)}.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-8d6b8e08]{display:none;font-size:18px;line-height:100%;color:#3672f8!important}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-8d6b8e08]{display:block;background:#fff;border-color:var(--primary-btn);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:none;margin:0;min-width:210px;height:34px;margin-left:auto}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-8d6b8e08]{display:none}}.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-8d6b8e08]:hover{color:#fff;background:var(--primary-btn-hover);border-color:var(--primary-btn-hover);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn-hover);box-shadow:inset 0 -4px 4px var(--primary-btn-hover)}.sticky-review-card .sticky-inner .sticky-play-btn-mobile[data-v-8d6b8e08]{background:#fff;color:var(--primary-btn);color:#3672f8!important;border-color:var(--primary-btn);box-shadow:none;margin:0;line-height:100%;font-size:.75rem;width:78px;height:34px;padding:10px 20px}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-play-btn-mobile[data-v-8d6b8e08]{display:none}}@media (min-width:992px){.sticky-review-card[data-v-8d6b8e08]{top:-110px;height:110px;background:#fff;color:#222}}.mr-30[data-v-8d6b8e08]{margin-right:30px!important}.minus[data-v-8d6b8e08]:before{content:\"-\";font-size:1.9rem}.h-100[data-v-8d6b8e08]{height:100%}.w-100[data-v-8d6b8e08]{width:100%}.lang-flag[data-v-8d6b8e08]{height:34px!important;width:60px!important;object-fit:cover}.flex-wrap[data-v-8d6b8e08]{display:flex;flex-wrap:wrap}figure>img[data-v-8d6b8e08]{height:100%;width:100%}.md-rating .radio-star-total[data-v-8d6b8e08],.md-rating .radio-star-total span[data-v-8d6b8e08]{color:#000!important;font-size:10px!important;line-height:10px!important}.view-mob .span-h1[data-v-8d6b8e08]{font-size:24px!important;line-height:27px!important}@media (min-width:576px){.view-mob .span-h1[data-v-8d6b8e08]{font-size:36px!important;line-height:44px!important}}.rv-terms[data-v-8d6b8e08]{display:block}.desk-terms[data-v-8d6b8e08]{display:none}@media (min-width:576px){.desk-terms[data-v-8d6b8e08]{display:block}}.desk-terms a[data-v-8d6b8e08]{color:#9b9b9b!important}.mob-terms[data-v-8d6b8e08]{display:block;font-size:.75rem;line-height:13px;width:100%;text-align:center;padding:10px 0 0}@media (min-width:576px){.mob-terms[data-v-8d6b8e08]{display:none}}.mob-terms .terms-conditions[data-v-8d6b8e08]{color:#fff}.mob-terms .terms-conditions a[data-v-8d6b8e08]{color:#fff!important;text-decoration:underline!important}.mob-terms .mob-cas-term[data-v-8d6b8e08]{color:#fff}.div-term[data-v-8d6b8e08]{position:absolute;background-color:#dfe1e3;padding:10px 12px;left:0;width:100%;border-bottom-right-radius:12px;border-bottom-left-radius:12px;line-height:20px;position:static;width:auto;margin:0 -16px -20px;text-align:center}@media (min-width:768px){.div-term[data-v-8d6b8e08]{text-align:left;position:static;width:auto;margin:0 -20px -20px}}@media (min-width:992px){.div-term[data-v-8d6b8e08]{padding:5px 12px;position:static;width:auto;margin:0 -30px -30px}}.terms-d[data-v-8d6b8e08]{position:relative}.stick-img img[data-v-8d6b8e08]{width:100%}.desk-bonus[data-v-8d6b8e08]{display:none}@media (min-width:576px){.desk-bonus[data-v-8d6b8e08]{display:block}}.mob-bonus[data-v-8d6b8e08]{display:block}@media (min-width:576px){.mob-bonus[data-v-8d6b8e08]{display:none}}.overall-rating[data-v-8d6b8e08]{background:#fff;border:1px solid #f3f2f5;box-shadow:0 0 20px 0 rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.overall-rating .rating-header[data-v-8d6b8e08]{background:#f7f7f7;-webkit-border-radius:12px 12px 0 0;-moz-border-radius:12px 12px 0 0;border-radius:12px 12px 0 0;padding:5px 10px 4px 16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}@media (min-width:992px){.overall-rating .rating-header[data-v-8d6b8e08]{padding:7px 30px 6px 26px}}.overall-rating .rating-header h2[data-v-8d6b8e08]{font-weight:700;color:#020100;margin:0}.overall-rating .rating-header .rating-count[data-v-8d6b8e08]{min-width:65px;min-height:43px;-webkit-border-radius:7.75px;-moz-border-radius:7.75px;border-radius:7.75px;position:relative}.overall-rating .rating-header .rating-count .comment[data-v-8d6b8e08]{position:absolute;left:0;right:0;bottom:0;-webkit-border-radius:0 0 7.75px 7.75px;-moz-border-radius:0 0 7.75px 7.75px;border-radius:0 0 7.75px 7.75px;font-style:italic;font-weight:400;font-size:10px;line-height:15px;text-align:center;letter-spacing:-.03em;color:#fff;padding:1px 5px;display:block;box-shadow:inset 0 0 40px rgba(0,0,0,.2)}.overall-rating .rating-header .rating-count-top[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.overall-rating .rating-header .rating-count-top .value[data-v-8d6b8e08]{font-weight:700;font-size:20px;line-height:27px;text-align:center;letter-spacing:-.03em;color:#fff;margin-top:2px}.overall-rating .rating-header .rating-count-top .full-star[data-v-8d6b8e08]{margin-left:4px;width:14px;height:14px;background:#fabf00;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;margin-right:0;position:relative}.overall-rating .rating-header .rating-count-top .full-star[data-v-8d6b8e08]:after{content:\" \\2605\";position:absolute;top:50%;left:50%;color:#fff;font-size:10px;transform:translate(-50%,-50%)}.overall-rating .progress-bar-block[data-v-8d6b8e08]{padding:8px 8px 20px}@media (min-width:992px){.overall-rating .progress-bar-block[data-v-8d6b8e08]{padding:20px 35px 19px 27px}}.overall-rating .progress-bar-block .bar-row[data-v-8d6b8e08]{margin-bottom:20px}.overall-rating .progress-bar-block .bar-row[data-v-8d6b8e08]:last-child{margin-bottom:0}.overall-rating .progress-bar-block .bar-row .label[data-v-8d6b8e08]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:5px}.overall-rating .progress-bar-block .bar-row .label p[data-v-8d6b8e08]{font-weight:400;color:#222;margin:0}.overall-rating .progress-bar-block .bar-row .label span[data-v-8d6b8e08]{font-weight:700;font-size:20px;line-height:30px;text-align:right;text-transform:capitalize;color:#222;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.overall-rating .progress-bar-block .bar-row .label span .full-star[data-v-8d6b8e08]{margin-left:8.5px;width:14px;height:14px;background:#fabf00;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;margin-right:0;position:relative;bottom:1px}.overall-rating .progress-bar-block .bar-row .label span .full-star[data-v-8d6b8e08]:after{content:\" \\2605\";position:absolute;top:50%;left:50%;color:#fff;font-size:10px;transform:translate(-50%,-50%)}.overall-rating .progress-bar-block .bar-row .bar-rail[data-v-8d6b8e08]{width:100%;height:6px;background:hsla(0,1%,81%,.6);-webkit-border-radius:52.8455px;-moz-border-radius:52.8455px;border-radius:52.8455px;overflow:hidden}.overall-rating .progress-bar-block .bar-row .bar-rail .progress-indicator[data-v-8d6b8e08]{-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;height:6px}.wd-mar[data-v-8d6b8e08]{width:100%!important}@media (max-width:1024px){.wd-mar[data-v-8d6b8e08]{margin-left:0}}.cust-span[data-v-8d6b8e08]{font-size:24px!important;line-height:27px!important}@media (min-width:576px){.cust-span[data-v-8d6b8e08]{font-size:32px!important;line-height:40px!important}}@media (min-width:576px){.ct-btn[data-v-8d6b8e08]{margin-top:0!important}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust i img[data-v-8d6b8e08]{width:8.35px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content[data-v-8d6b8e08]{width:calc(100% - 250px)}}.rev-terms-condition[data-v-8d6b8e08]{background:#dfe1e3;border-bottom-left-radius:12px;border-bottom-right-radius:12px;padding:5px 12px;line-height:20px;width:100%;text-align:center}@media (min-width:768px){.rev-terms-condition[data-v-8d6b8e08]{text-align:left}}@media (min-width:1200px){.rm-border[data-v-8d6b8e08]{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}}.exclu-rev[data-v-8d6b8e08],.exclu-rev img[data-v-8d6b8e08]{border-bottom-left-radius:0!important}.pay-i[data-v-8d6b8e08],.prod-i[data-v-8d6b8e08],.soft-i[data-v-8d6b8e08]{margin-right:0!important}.sticky-nav-review-block[data-v-8d6b8e08]{position:sticky;display:block;z-index:10}.stripe-sticky[data-v-8d6b8e08]{display:block!important;text-align:center}.stripe-sticky p[data-v-8d6b8e08]{font-weight:700}.stripe-sticky[data-v-8d6b8e08]{position:absolute;width:50px;top:50%;transform:translateY(6px);overflow:hidden;border-bottom-left-radius:10px;border-bottom-right-radius:10px;background-color:#ffd039;display:none;height:20px;line-height:20px}@media (min-width:768px){.stripe-sticky[data-v-8d6b8e08]{display:block;bottom:0;left:0;width:100%}}@media (min-width:992px){.stripe-sticky[data-v-8d6b8e08]{transform:translateY(25px)}}.stripe-sticky img[data-v-8d6b8e08]{width:14px!important;height:14px!important;margin:3px auto;border-radius:0!important}@media (max-width:768px){.stripe-sticky svg[data-v-8d6b8e08]{width:12px}}.desk-excl[data-v-8d6b8e08]{display:none}@media (min-width:768px){.desk-excl[data-v-8d6b8e08]{display:block}}.mob-excl[data-v-8d6b8e08]{display:block}@media (min-width:768px){.mob-excl[data-v-8d6b8e08]{display:none}}@media (max-width:768px){.mob-excl[data-v-8d6b8e08]{display:block;margin:0 auto}}.desk-ra-excl[data-v-8d6b8e08]{display:none}@media (min-width:768px){.desk-ra-excl[data-v-8d6b8e08]{display:flex}}.mob-ra-excl[data-v-8d6b8e08]{display:block}@media (min-width:768px){.mob-ra-excl[data-v-8d6b8e08]{display:none}}.exclusive-tag-rev[data-v-8d6b8e08]{position:absolute;left:0;right:0;margin:auto;font-size:12px;line-height:15px;border-radius:8px;width:90%;bottom:10px;height:28px;display:flex;justify-content:center}@media (min-width:768px){.exclusive-tag-rev[data-v-8d6b8e08]{bottom:14px;width:90%;font-size:17px;line-height:28px;z-index:10}}@media (min-width:992px){.exclusive-tag-rev[data-v-8d6b8e08]{width:210px;bottom:10px}}.exclusive-tag-rev img[data-v-8d6b8e08]{width:18px!important;height:18px!important;border-radius:0!important;object-fit:contain!important;margin-right:5px}.exclusive-tag-rev p[data-v-8d6b8e08]{font-weight:700;font-size:12px;margin:0;display:flex;align-items:center}.exclu-rev[data-v-8d6b8e08]{position:relative}.casino-card ul.proslist-rev[data-v-8d6b8e08]{margin:0;padding:0;list-style:none;column-count:0;display:block}@media (min-width:576px){.casino-card ul.proslist-rev[data-v-8d6b8e08]{column-count:2;-ms-flex-wrap:wrap;flex-wrap:wrap;display:-webkit-box;display:-ms-flexbox;display:flex}}.casino-card ul.proslist-rev li[data-v-8d6b8e08]{width:100%;text-align:left;padding-left:32px;line-height:25px;color:#222;margin-bottom:14px;background-size:15px 15px}.casino-card ul.proslist-rev li[data-v-8d6b8e08]:last-child{margin-bottom:0}@media (min-width:576px){.casino-card ul.proslist-rev li[data-v-8d6b8e08]{width:50%}}.casino-card ul.proslist-rev li.pros[data-v-8d6b8e08]{column-count:unset;display:block;position:relative}.casino-card ul.proslist-rev li.pros[data-v-8d6b8e08]:before{position:absolute;content:\"\";left:0;top:0;display:inline-block;transform:translateY(0);height:26px;width:26px;background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:14px}.casino-card ul.proslist-rev li.pros li[data-v-8d6b8e08]{width:100%;font-size:16px;line-height:25px;margin-bottom:25px;background-position:0 5px}.casino-card ul.proslist-rev li.pros li[data-v-8d6b8e08]:last-child{margin-bottom:0}.casino-card ul.proslist-rev li.cons[data-v-8d6b8e08]{column-count:unset;display:block;position:relative}.casino-card ul.proslist-rev li.cons[data-v-8d6b8e08]:before{position:absolute;content:\"\";left:0;top:0;display:inline-block;transform:translateY(0);height:26px;width:26px;background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:14px}.casino-card ul.proslist-rev li.cons li[data-v-8d6b8e08]{width:100%;font-size:16px;line-height:25px;margin-bottom:25px;background-size:15px 15px}.casino-card ul.proslist-rev li.cons li[data-v-8d6b8e08]:last-child{margin-bottom:0}.p-caption[data-v-8d6b8e08]{font-weight:700;margin-bottom:0}.casino-card-lists ul li figure img[data-v-8d6b8e08]{margin:0}.pt-65[data-v-8d6b8e08]{padding-top:65px}", ""]);

// exports


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):_c('main',{class:{
    'main-content-area': true,
    'pb-25': !(
      _vm.pageData &&
      _vm.pageData.product_information &&
      Object.keys(_vm.pageData).length != 0
    ),
    'pt-65': _vm.pageMenuBlock,
    'pt-26': !_vm.pageMenuBlock,
  }},[_c('section',{staticClass:"ct-article"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadCrumb,"dark":true}})],1)])]),_vm._v(" "),(_vm.tabData && _vm.tabData.length > 0)?[_c('section',{staticClass:"ct-editor-section pb-25 pb-1"},[_vm._l((_vm.tabData),function(data,index){return [(
          data.blockName === 'wpvcb/page-menu-blocks-scroll' &&
          data.filtered_content &&
          Object.keys(data.filtered_content).length > 0 &&
          data.filtered_content.menu.length > 0)?[_c('div',{key:((data.blockName) + "-" + index),style:({ top: _vm.stickyNavTop }),attrs:{"id":"sticky-nav"}},[(_vm.showSticky)?_c('div',{staticClass:"review-top-menu"},[_c('nav',{staticClass:"scroll-nav"},_vm._l((data.filtered_content.menu),function(mn,index){return _c('span',{key:index,class:{
                    'scroll-item': true,
                    active: _vm.activeKey === mn.menu_block_id,
                  },style:({ '--bg-clr': _vm.$root.color_schema.primary_btn }),on:{"click":function($event){return _vm.scrollPage(mn.menu_block_id)}}},[_vm._v("\n                  "+_vm._s(mn.menu_name)+"\n                ")])}),0)]):_vm._e()])]:_vm._e(),_vm._v(" "),_c('div',{key:((data.blockName) + "-" + index),ref:data.attrs &&
              Object.keys(data.attrs).length > 0 &&
              data.attrs.blockID &&
              data.attrs.blockID != ''
                ? ("" + (data.attrs.blockID))
                : '',refInFor:true},[_c('CustomComponent',{attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})],1)]})],2)]:_vm._e(),_vm._v(" "),(_vm.morePaymentBottom)?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(_vm.auhtorBlockdata)?void 0:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(696);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1dc8c0d8", content, true, {});

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(46);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-356e2eb1]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-356e2eb1]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-356e2eb1]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-356e2eb1]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-356e2eb1]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-356e2eb1]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-356e2eb1]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-356e2eb1]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-356e2eb1]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-356e2eb1]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-356e2eb1]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.lang-img[data-v-356e2eb1]{height:36px;width:36px}.px-0[data-v-356e2eb1]{padding-left:0!important;padding-right:0!important}.pb-1[data-v-356e2eb1]{padding-top:1px!important}.ct-inner-banner[data-v-356e2eb1]{padding:0 0 45px;background:#070438 url(" + escape(__webpack_require__(62)) + ") no-repeat 0 0}.ct-inner-banner .game-space[data-v-356e2eb1]{position:relative;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space[data-v-356e2eb1]{min-height:auto}}.ct-inner-banner .game-space img[data-v-356e2eb1]{border-radius:10px;box-shadow:0 5px 15px rgba(0,0,0,.05);height:100%;object-fit:cover;width:auto;max-height:321px;min-height:321px}@media (min-width:420px){.ct-inner-banner .game-space img[data-v-356e2eb1]{width:100%;max-height:none;min-height:auto}}.ct-inner-banner .game-space-content[data-v-356e2eb1]{position:absolute;left:0;right:0;top:0;bottom:0;padding:20px}.ct-inner-banner .game-space-content .button-block[data-v-356e2eb1],.ct-inner-banner .game-space-content[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-inner-banner .game-space-content .button-block[data-v-356e2eb1]{width:100%;margin-bottom:15px}.ct-inner-banner .game-space-content .button-block .cta[data-v-356e2eb1]{min-width:100%;margin:5px 0;font-weight:700;font-size:14px;line-height:17px;padding:10px 18px}@media (min-width:768px){.ct-inner-banner .game-space-content .button-block .cta[data-v-356e2eb1]{min-width:330px;margin:10px 0;padding:15px 18px;font-size:18px;line-height:22px}}.ct-inner-banner .game-space-content .game-logo img[data-v-356e2eb1]{box-shadow:none;max-height:none;min-height:auto}@media (min-width:768px){.ct-inner-banner .row .col-md-8[data-v-356e2eb1]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-8[data-v-356e2eb1]{width:66.66666667%;float:left}}@media (min-width:768px){.ct-inner-banner .row .col-md-4[data-v-356e2eb1]{width:100%;float:none}}@media (min-width:992px){.ct-inner-banner .row .col-md-4[data-v-356e2eb1]{width:33.33333333%;float:left}}.ct-inner-banner-lft[data-v-356e2eb1]{margin-bottom:19px}@media (min-width:992px){.ct-inner-banner-lft[data-v-356e2eb1]{margin-bottom:0}}@media (min-width:1360px){.ct-inner-banner-lft[data-v-356e2eb1]{width:906px!important}}@media (min-width:1360px){.ct-inner-banner-rgt[data-v-356e2eb1]{width:314px!important}}.new-review-banner-card[data-v-356e2eb1]{padding:12px 16px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;box-shadow:none}@media (min-width:576px){.new-review-banner-card[data-v-356e2eb1]{padding:20px}}@media (min-width:1200px){.new-review-banner-card[data-v-356e2eb1]{padding:30px}}.new-review-banner-card-top[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:768px){.new-review-banner-card-top[data-v-356e2eb1]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-top-left[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:auto;margin:0 -7px 18px -6px}@media (min-width:350px){.new-review-banner-card-top-left[data-v-356e2eb1]{margin:0 -7px 18px 5px;justify-content:unset!important}}@media (min-width:576px){.new-review-banner-card-top-left[data-v-356e2eb1]{width:100%;margin:0 0 28px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}}@media (min-width:768px){.new-review-banner-card-top-left[data-v-356e2eb1]{margin:0 0 45px}}@media (min-width:1024px){.new-review-banner-card-top-left[data-v-356e2eb1]{width:calc(100% - 400px);margin:0 0 5px}}@media (min-width:1080px){.new-review-banner-card-top-left[data-v-356e2eb1]{width:calc(100% - 430px)}}@media (min-width:1200px){.new-review-banner-card-top-left[data-v-356e2eb1]{width:calc(100% - 495px)}}.new-review-banner-card-top-left .review-left-img[data-v-356e2eb1]{min-width:79px;max-width:79px;height:79px;background:#fff;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative}.new-review-banner-card-top-left .review-left-img a[data-v-356e2eb1]{box-shadow:0 2px 4px rgba(0,0,0,.2);border-radius:12px;overflow:visible;margin-top:0}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img a[data-v-356e2eb1]{margin-top:4px}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-img a[data-v-356e2eb1]{margin-top:4px}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-img a[data-v-356e2eb1]{margin-top:0}}.new-review-banner-card-top-left .review-left-img img[data-v-356e2eb1]{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img img[data-v-356e2eb1]{height:100%;width:100%}}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img[data-v-356e2eb1]{min-width:245px;max-width:245px;height:245px}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-img[data-v-356e2eb1]{min-width:245px;max-width:245px;height:245px}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-img[data-v-356e2eb1]{min-width:250px;max-width:250px;height:250px}}.new-review-banner-card-top-left .review-left-img .exclusive-tag[data-v-356e2eb1]{position:absolute;left:0;right:0;margin:auto;height:20px;font-size:12px;line-height:15px;width:100%;bottom:0;border-radius:0;border-bottom-left-radius:8px;border-bottom-right-radius:8px;display:flex;justify-content:center;align-items:center}@media (min-width:768px){.new-review-banner-card-top-left .review-left-img .exclusive-tag[data-v-356e2eb1]{bottom:14px;width:210px;height:28px;font-size:17px;line-height:28px;z-index:10;border-radius:8px}}.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-356e2eb1]{width:18px!important;height:18px!important;border-radius:0!important;vertical-align:initial!important;object-fit:contain!important}@media (max-width:576px){.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-356e2eb1]{margin:0 auto;width:14px!important;height:14px!important}}@media (min-width:576px){.new-review-banner-card-top-left .review-left-img .exclusive-tag p[data-v-356e2eb1]{font-weight:700;margin-top:0;font-size:12px;margin:0}}@media (max-width:768px){.new-review-banner-card-top-left .review-left-img .exclusive-tag img[data-v-356e2eb1],.new-review-banner-card-top-left .review-left-img .exclusive-tag svg[data-v-356e2eb1]{width:12px}}.new-review-banner-card-top-left .review-left-content[data-v-356e2eb1]{padding:10px 0 5px 15px;height:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content[data-v-356e2eb1]{padding:0 30px}}.new-review-banner-card-top-left .review-left-content .approve[data-v-356e2eb1]{font-weight:400;font-size:12px;line-height:15px;color:#9b9b9b;margin-bottom:8px;margin-top:10px;display:block}.new-review-banner-card-top-left .review-left-content .approve i[data-v-356e2eb1]{margin-right:5px}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .approve i[data-v-356e2eb1]{margin-right:7px}}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .approve[data-v-356e2eb1]{font-size:14px;line-height:17px;color:#aeaeae}}.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:0;margin-top:0}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-356e2eb1]{margin-bottom:4px;margin-top:0}}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-356e2eb1]{-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:4px;margin-top:0}}@media (min-width:1200px){.new-review-banner-card-top-left .review-left-content .exclusive-bar[data-v-356e2eb1]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:4px;margin-top:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar p[data-v-356e2eb1]{margin-bottom:4px;font-weight:400;color:#222;padding-right:7px}@media (min-width:576px){.new-review-banner-card-top-left .review-left-content .exclusive-bar p[data-v-356e2eb1]{margin-bottom:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar .exclusive-tag[data-v-356e2eb1]{margin-left:30px;display:none}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar .exclusive-tag[data-v-356e2eb1]{display:none}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-rating[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title[data-v-356e2eb1]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title p[data-v-356e2eb1]{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;margin-bottom:4px;margin-top:4px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title p[data-v-356e2eb1]{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;margin-bottom:4px}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:0;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;margin-bottom:5px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust[data-v-356e2eb1]{margin-left:8px;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;margin-bottom:0}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust strong[data-v-356e2eb1]{font-weight:700;font-size:10px;line-height:1;text-transform:uppercase;color:#4caf50}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust i[data-v-356e2eb1]{background:#4caf50;width:8.35px;height:8.35px;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:3.65px}.new-review-banner-card-top-left .review-left-content-title[data-v-356e2eb1]{display:none}.new-review-banner-card-top-left .review-left-content-title h1[data-v-356e2eb1]{margin-bottom:12px}@media (min-width:1080px){.new-review-banner-card-top-left .review-left-content-title h1[data-v-356e2eb1]{margin-bottom:12px}}.new-review-banner-card-top-left .review-left-content-title .cta[data-v-356e2eb1]{min-width:100%}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content-title[data-v-356e2eb1]{display:block}}.new-review-banner-card-top .view-mob[data-v-356e2eb1]{display:block;text-align:center}.new-review-banner-card-top .view-mob h1[data-v-356e2eb1]{margin-bottom:17px;padding:0 10%}.new-review-banner-card-top .view-mob .cta-promo-review[data-v-356e2eb1]{font-size:18px;line-height:100%;margin-top:0;display:block}@media (min-width:768px){.new-review-banner-card-top .view-mob[data-v-356e2eb1]{display:none}}.new-review-banner-card-top-right[data-v-356e2eb1]{min-width:100%;margin-top:17px;border-top:0;border-right:0;border-left:0;padding:0}@media (min-width:768px){.new-review-banner-card-top-right[data-v-356e2eb1]{width:calc(100% - 315px);min-width:calc(100% - 315px);border-right:1px solid #e5e5e5;border-left:0;padding:0 45px 0 0;margin-top:0}}@media (min-width:1024px){.new-review-banner-card-top-right[data-v-356e2eb1]{width:400px;min-width:auto;padding:0 0 0 35px;border-right:0;border-left:1px solid #e5e5e5}}@media (min-width:1080px){.new-review-banner-card-top-right[data-v-356e2eb1]{width:430px}}@media (min-width:1200px){.new-review-banner-card-top-right[data-v-356e2eb1]{width:495px}}.new-review-banner-card-top-right h6[data-v-356e2eb1]{color:#222}@media (min-width:576px){.new-review-banner-card-top-right h6[data-v-356e2eb1]{margin:0 0 3px;color:#222}}.new-review-banner-card-top-right p[data-v-356e2eb1]{color:#222}@media (min-width:576px){.new-review-banner-card-top-right p[data-v-356e2eb1]{margin:0 0 20px;color:#465867}}.new-review-banner-card-bottom[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-top:0;padding:16px 0 0;min-width:100%;width:100%}@media (min-width:768px){.new-review-banner-card-bottom[data-v-356e2eb1]{padding:0 0 0 45px;margin-top:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:315px;width:315px}}@media (min-width:1024px){.new-review-banner-card-bottom[data-v-356e2eb1]{border-top:1px solid #e5e5e5;width:100%;min-width:auto;padding:24px 0 0;margin-top:32px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.new-review-banner-card-bottom .casino-card-lists[data-v-356e2eb1]{margin-bottom:0}@media (min-width:768px){.new-review-banner-card-bottom .casino-card-lists[data-v-356e2eb1]{margin-bottom:10px}}@media (min-width:1200px){.new-review-banner-card-bottom .casino-card-lists[data-v-356e2eb1]{margin-bottom:0}}.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-356e2eb1]{margin-right:15px}.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-356e2eb1]:last-child{margin-right:0}@media (min-width:992px){.new-review-banner-card-bottom .casino-card-lists:nth-child(2) ul li[data-v-356e2eb1]{margin-right:16px}}.ct-editor-section .container[data-v-356e2eb1]{position:static}.editor-content .max-cntent-area[data-v-356e2eb1]{max-width:960px}.editor-content h1[data-v-356e2eb1]{line-height:44px}.editor-content img[data-v-356e2eb1]{margin-bottom:20px}.editor-content ul[data-v-356e2eb1]{list-style-type:none;padding:0}.editor-content ul li[data-v-356e2eb1]{font-style:normal;font-weight:400;font-size:16px;line-height:25px;position:relative;padding-left:20px;margin-bottom:15px}.editor-content ul li span[data-v-356e2eb1]{font-weight:700}#sticky-nav[data-v-356e2eb1]{position:-webkit-sticky;position:fixed;width:100%;border-bottom:1px solid #bbb;z-index:10}.review-top-menu[data-v-356e2eb1]{padding-bottom:30px;padding-top:14px;background:#fff;border-bottom:1px solid #bbb;margin:0 -15px;padding:0 14px;height:53px}.review-top-menu .scroll-nav[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow-x:auto;overflow-y:hidden;white-space:nowrap;max-width:1210px;margin:0 auto;height:53px}.review-top-menu .scroll-nav .scroll-item[data-v-356e2eb1]{margin-right:30px;display:inline-block;padding:10px 0;position:relative;font-weight:700;font-size:18px;color:#222;line-height:20px;cursor:pointer;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s}.review-top-menu .scroll-nav .scroll-item[data-v-356e2eb1]:after{position:absolute;content:\"\";left:0;bottom:-5px;width:100%;height:3px;-webkit-transition:all .3s;-moz-transition:all .3s;-ms-transition:all .3s;-o-transition:all .3s;transition:all .3s}.review-top-menu .scroll-nav .scroll-item.active[data-v-356e2eb1],.review-top-menu .scroll-nav .scroll-item[data-v-356e2eb1]:hover{color:var(--bg-clr)}.review-top-menu .scroll-nav .scroll-item.active[data-v-356e2eb1]:after,.review-top-menu .scroll-nav .scroll-item[data-v-356e2eb1]:hover:after{bottom:0}.review-top-menu .scroll-nav .scroll-item.active[data-v-356e2eb1]{font-weight:700}.sticky[data-v-356e2eb1]{position:-webkit-sticky;position:sticky;top:0;z-index:5}.casino-card-lists ul li[data-v-356e2eb1]{margin:0 32px 0 0}.casino-card-lang-lists ul[data-v-356e2eb1]{margin:0}@media (min-width:992px){.casino-card-lists ul[data-v-356e2eb1]{margin-bottom:20px}}.casino-card-lang-lists ul li[data-v-356e2eb1]{width:36px;height:36px;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;overflow:hidden;margin:0 6px 6px 0;padding:0;border:1px solid #bbb}.new-review-banner-card-top-right h6[data-v-356e2eb1],.review-banner-card-top-right h6[data-v-356e2eb1]{margin-bottom:3px}.review-top-menu ul li a[data-v-356e2eb1],.review-top-menu ul li a[data-v-356e2eb1]:active{padding:10px 20px 10px 0;font-weight:400;font-size:16px;color:#9b9b9b;line-height:25px}.rating-wrapper-small .radio-star-total[data-v-356e2eb1]{padding-left:10px;line-height:20px}.casino-card-lists ul li[data-v-356e2eb1]{margin:0 12px 0 0;padding:0;list-style-type:none}@media (min-width:374px){.casino-card-lists ul li[data-v-356e2eb1]{margin:0 16px 0 0}}.casino-card-lists__review h6[data-v-356e2eb1]{font-weight:400}.bonus-card-logo[data-v-356e2eb1]{background:#fff!important;height:280px!important}.bonus-card-logo a[data-v-356e2eb1]{text-align:center}.bonus-card-logo img[data-v-356e2eb1]{height:100%;width:100%;object-fit:cover;border-radius:12px 12px 0 0}@media (min-width:992px){.bonus-card-logo img[data-v-356e2eb1]{border-radius:12px 0 0 12px;width:100%}}@media (min-width:768px){.bonus-card-logo[data-v-356e2eb1]{height:100%!important}}.bonus-card-content[data-v-356e2eb1]{overflow:hidden;display:flex;flex-wrap:wrap;align-items:center}@media (min-width:768px){.bonus-card-content[data-v-356e2eb1]{padding:30px 45px}}.bonus-card-content-top[data-v-356e2eb1]{width:100%}.justify-flex-start[data-v-356e2eb1]{justify-content:flex-start!important}@media (min-width:1200px){.casino-card-bonus[data-v-356e2eb1]{height:300px}}@media (min-width:768px){.offset-md-1[data-v-356e2eb1]{margin-left:8.33333%}}.play_term_wrapper[data-v-356e2eb1]{display:flex;flex-direction:column;align-items:center}.play_term_wrapper .terms_tc[data-v-356e2eb1]{margin-bottom:8px}.play_term_wrapper .btn-cust[data-v-356e2eb1]{margin:18px 0!important}.mx-0[data-v-356e2eb1]{margin-left:0;margin-right:0}.flex-wrap[data-v-356e2eb1]{flex-wrap:wrap!important}.sticky-review-card[data-v-356e2eb1]{bottom:0;left:0;right:0;z-index:1000;position:fixed;color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.05);transition:top .3s ease-out}@media (min-width:992px){.sticky-review-card .rating-wrapper-small[data-v-356e2eb1]{display:inline-flex;height:24px;border-radius:50px;margin-left:15px;padding:1px 7px}.sticky-review-card .rating-wrapper-small .radio-star-total[data-v-356e2eb1]{margin-left:0}}.sticky-review-card .sticky-inner[data-v-356e2eb1]{background:var(--primary-btn);position:absolute;bottom:0;width:100%;max-width:78.125rem;padding:10px;display:flex;align-items:center;margin:0 auto;flex-wrap:wrap}@media (min-width:768px){.sticky-review-card .sticky-inner[data-v-356e2eb1]{flex-wrap:nowrap}}@media (min-width:992px){.sticky-review-card .sticky-inner[data-v-356e2eb1]{background:#fff;position:relative}}.sticky-review-card .sticky-inner .md-rating[data-v-356e2eb1]{margin-top:10px;display:none}@media (min-width:768px){.sticky-review-card .sticky-inner .md-rating[data-v-356e2eb1]{margin-top:8px;margin-left:-12px;display:inline-flex;height:18px;border-radius:50px;padding:1px 7px;align-items:stretch}}.sticky-review-card .sticky-inner .md-rating .radio-stars[data-v-356e2eb1]{height:14px;width:14px}.sticky-review-card .sticky-inner .md-rating .radio-stars img[data-v-356e2eb1]{border-radius:0;vertical-align:text-top}.sticky-review-card .sticky-inner .md-rating .radio-star-total[data-v-356e2eb1]{font-size:14px;line-height:15px;padding-left:0;display:inline-flex;align-items:center}.sticky-review-card .sticky-inner .md-rating .radio-star-total span[data-v-356e2eb1]{font-size:14px;line-height:15px}@media (min-width:992px){.sticky-review-card .sticky-inner .md-rating[data-v-356e2eb1]{display:none}}.sticky-review-card .sticky-inner .sticky-text[data-v-356e2eb1]{font-size:.875rem;margin-left:10px;margin-right:auto;line-height:.75rem;width:calc(100% - 60px)}@media (min-width:576px){.sticky-review-card .sticky-inner .sticky-text[data-v-356e2eb1]{line-height:unset}}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text[data-v-356e2eb1]{width:100%;margin-left:80px}}.sticky-review-card .sticky-inner .sticky-text .product-name[data-v-356e2eb1]{display:flex;padding:0 0 5px}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text .product-name[data-v-356e2eb1]{display:none}}.sticky-review-card .sticky-inner .sticky-text .product-name .best-rating[data-v-356e2eb1]{margin-left:8px}.sticky-review-card .sticky-inner .sticky-text .sticky-title[data-v-356e2eb1]{display:none}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .sticky-title[data-v-356e2eb1]{display:flex}}.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-356e2eb1]{font-weight:900;font-size:.875rem;line-height:14px}@media (min-width:576px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-356e2eb1]{line-height:25px}}.sticky-review-card .sticky-inner .sticky-text .bonus-text a[data-v-356e2eb1]{color:#fff}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-356e2eb1]{font-size:.85rem}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .bonus-text[data-v-356e2eb1]{font-size:1.625rem}.sticky-review-card .sticky-inner .sticky-text .bonus-text a[data-v-356e2eb1]{color:#222}}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-text[data-v-356e2eb1]{font-size:.85rem}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text[data-v-356e2eb1]{margin-left:0}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .terms-conditions[data-v-356e2eb1]{padding-top:5px!important}}.sticky-review-card .sticky-inner .sticky-text .terms-conditions a[data-v-356e2eb1]{color:#fff}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-text .terms-conditions a[data-v-356e2eb1]{color:#aeaeae}}.sticky-review-card .sticky-inner .affliate-logo[data-v-356e2eb1]{height:50px;width:50px;min-height:50px;min-width:50px;box-shadow:0 5px 15px rgba(0,0,0,.09);left:15px}.sticky-review-card .sticky-inner .affliate-logo img[data-v-356e2eb1]{border-radius:12px}@media (min-width:768px){.sticky-review-card .sticky-inner .affliate-logo[data-v-356e2eb1]{top:-25px;position:absolute}}@media (min-width:992px){.sticky-review-card .sticky-inner .affliate-logo[data-v-356e2eb1]{width:85px;min-width:85px;height:85px;min-height:85px;top:0;left:0;position:relative;margin-right:30px}}.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-356e2eb1]{display:none;font-size:18px;line-height:100%;margin:auto 2px!important;color:#fff!important}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-356e2eb1]{display:block;background:var(--primary-btn);border-color:var(--primary-btn);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:inset 0 -4px 4px var(--primary-btn);min-width:280px;font-weight:900}}.sticky-review-card .sticky-inner .sticky-play-btn-large[data-v-356e2eb1]:hover{background:var(--primary-btn-hover);border-color:var(--primary-btn-hover);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn-hover);box-shadow:inset 0 -4px 4px var(--primary-btn-hover)}.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-356e2eb1]{display:none;font-size:18px;line-height:100%;color:#3672f8!important}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-356e2eb1]{display:block;background:#fff;border-color:var(--primary-btn);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:inset 0 -4px 4px var(--primary-btn);box-shadow:none;margin:0;min-width:210px;height:34px;margin-left:auto}}@media (min-width:992px){.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-356e2eb1]{display:none}}.sticky-review-card .sticky-inner .sticky-play-btn-medium[data-v-356e2eb1]:hover{color:#fff;background:var(--primary-btn-hover);border-color:var(--primary-btn-hover);-webkit-box-shadow:inset 0 -4px 4px var(--primary-btn-hover);box-shadow:inset 0 -4px 4px var(--primary-btn-hover)}.sticky-review-card .sticky-inner .sticky-play-btn-mobile[data-v-356e2eb1]{background:#fff;color:var(--primary-btn);color:#3672f8!important;border-color:var(--primary-btn);box-shadow:none;margin:0;line-height:100%;font-size:.75rem;width:78px;height:34px;padding:10px 20px}@media (min-width:768px){.sticky-review-card .sticky-inner .sticky-play-btn-mobile[data-v-356e2eb1]{display:none}}@media (min-width:992px){.sticky-review-card[data-v-356e2eb1]{top:-110px;height:110px;background:#fff;color:#222}}.mr-30[data-v-356e2eb1]{margin-right:30px!important}.minus[data-v-356e2eb1]:before{content:\"-\";font-size:1.9rem}.h-100[data-v-356e2eb1]{height:100%}.w-100[data-v-356e2eb1]{width:100%}.lang-flag[data-v-356e2eb1]{height:34px!important;width:60px!important;object-fit:cover}.flex-wrap[data-v-356e2eb1]{display:flex;flex-wrap:wrap}figure>img[data-v-356e2eb1]{height:100%;width:100%}.md-rating .radio-star-total[data-v-356e2eb1],.md-rating .radio-star-total span[data-v-356e2eb1]{color:#000!important;font-size:10px!important;line-height:10px!important}.view-mob .span-h1[data-v-356e2eb1]{font-size:24px!important;line-height:27px!important}@media (min-width:576px){.view-mob .span-h1[data-v-356e2eb1]{font-size:36px!important;line-height:44px!important}}.rv-terms[data-v-356e2eb1]{display:block}.desk-terms[data-v-356e2eb1]{display:none}@media (min-width:576px){.desk-terms[data-v-356e2eb1]{display:block}}.desk-terms a[data-v-356e2eb1]{color:#9b9b9b!important}.mob-terms[data-v-356e2eb1]{display:block;font-size:.75rem;line-height:13px;width:100%;text-align:center;padding:10px 0 0}@media (min-width:576px){.mob-terms[data-v-356e2eb1]{display:none}}.mob-terms .terms-conditions[data-v-356e2eb1]{color:#fff}.mob-terms .terms-conditions a[data-v-356e2eb1]{color:#fff!important;text-decoration:underline!important}.mob-terms .mob-cas-term[data-v-356e2eb1]{color:#fff}.div-term[data-v-356e2eb1]{position:absolute;background-color:#dfe1e3;padding:10px 12px;left:0;width:100%;border-bottom-right-radius:12px;border-bottom-left-radius:12px;line-height:20px;position:static;width:auto;margin:0 -16px -20px;text-align:center}@media (min-width:768px){.div-term[data-v-356e2eb1]{text-align:left;position:static;width:auto;margin:0 -20px -20px}}@media (min-width:992px){.div-term[data-v-356e2eb1]{padding:5px 12px;position:static;width:auto;margin:0 -30px -30px}}.terms-d[data-v-356e2eb1]{position:relative}.stick-img img[data-v-356e2eb1]{width:100%}.desk-bonus[data-v-356e2eb1]{display:none}@media (min-width:576px){.desk-bonus[data-v-356e2eb1]{display:block}}.mob-bonus[data-v-356e2eb1]{display:block}@media (min-width:576px){.mob-bonus[data-v-356e2eb1]{display:none}}.overall-rating[data-v-356e2eb1]{background:#fff;border:1px solid #f3f2f5;box-shadow:0 0 20px 0 rgba(0,0,0,.05);-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px}.overall-rating .rating-header[data-v-356e2eb1]{background:#f7f7f7;-webkit-border-radius:12px 12px 0 0;-moz-border-radius:12px 12px 0 0;border-radius:12px 12px 0 0;padding:5px 10px 4px 16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}@media (min-width:992px){.overall-rating .rating-header[data-v-356e2eb1]{padding:7px 30px 6px 26px}}.overall-rating .rating-header h2[data-v-356e2eb1]{font-weight:700;color:#020100;margin:0}.overall-rating .rating-header .rating-count[data-v-356e2eb1]{min-width:65px;min-height:43px;-webkit-border-radius:7.75px;-moz-border-radius:7.75px;border-radius:7.75px;position:relative}.overall-rating .rating-header .rating-count .comment[data-v-356e2eb1]{position:absolute;left:0;right:0;bottom:0;-webkit-border-radius:0 0 7.75px 7.75px;-moz-border-radius:0 0 7.75px 7.75px;border-radius:0 0 7.75px 7.75px;font-style:italic;font-weight:400;font-size:10px;line-height:15px;text-align:center;letter-spacing:-.03em;color:#fff;padding:1px 5px;display:block;box-shadow:inset 0 0 40px rgba(0,0,0,.2)}.overall-rating .rating-header .rating-count-top[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.overall-rating .rating-header .rating-count-top .value[data-v-356e2eb1]{font-weight:700;font-size:20px;line-height:27px;text-align:center;letter-spacing:-.03em;color:#fff;margin-top:2px}.overall-rating .rating-header .rating-count-top .full-star[data-v-356e2eb1]{margin-left:4px;width:14px;height:14px;background:#fabf00;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;margin-right:0;position:relative}.overall-rating .rating-header .rating-count-top .full-star[data-v-356e2eb1]:after{content:\" \\2605\";position:absolute;top:50%;left:50%;color:#fff;font-size:10px;transform:translate(-50%,-50%)}.overall-rating .progress-bar-block[data-v-356e2eb1]{padding:8px 8px 20px}@media (min-width:992px){.overall-rating .progress-bar-block[data-v-356e2eb1]{padding:20px 35px 19px 27px}}.overall-rating .progress-bar-block .bar-row[data-v-356e2eb1]{margin-bottom:20px}.overall-rating .progress-bar-block .bar-row[data-v-356e2eb1]:last-child{margin-bottom:0}.overall-rating .progress-bar-block .bar-row .label[data-v-356e2eb1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:5px}.overall-rating .progress-bar-block .bar-row .label p[data-v-356e2eb1]{font-weight:400;color:#222;margin:0}.overall-rating .progress-bar-block .bar-row .label span[data-v-356e2eb1]{font-weight:700;font-size:20px;line-height:30px;text-align:right;text-transform:capitalize;color:#222;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.overall-rating .progress-bar-block .bar-row .label span .full-star[data-v-356e2eb1]{margin-left:8.5px;width:14px;height:14px;background:#fabf00;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;margin-right:0;position:relative;bottom:1px}.overall-rating .progress-bar-block .bar-row .label span .full-star[data-v-356e2eb1]:after{content:\" \\2605\";position:absolute;top:50%;left:50%;color:#fff;font-size:10px;transform:translate(-50%,-50%)}.overall-rating .progress-bar-block .bar-row .bar-rail[data-v-356e2eb1]{width:100%;height:6px;background:hsla(0,1%,81%,.6);-webkit-border-radius:52.8455px;-moz-border-radius:52.8455px;border-radius:52.8455px;overflow:hidden}.overall-rating .progress-bar-block .bar-row .bar-rail .progress-indicator[data-v-356e2eb1]{-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;height:6px}.wd-mar[data-v-356e2eb1]{width:100%!important}@media (max-width:1024px){.wd-mar[data-v-356e2eb1]{margin-left:0}}.cust-span[data-v-356e2eb1]{font-size:24px!important;line-height:27px!important}@media (min-width:576px){.cust-span[data-v-356e2eb1]{font-size:32px!important;line-height:40px!important}}@media (min-width:576px){.ct-btn[data-v-356e2eb1]{margin-top:0!important}}.new-review-banner-card-top-left .review-left-content .exclusive-bar-title .trust i img[data-v-356e2eb1]{width:8.35px}@media (min-width:768px){.new-review-banner-card-top-left .review-left-content[data-v-356e2eb1]{width:calc(100% - 250px)}}.rev-terms-condition[data-v-356e2eb1]{background:#dfe1e3;border-bottom-left-radius:12px;border-bottom-right-radius:12px;padding:5px 12px;line-height:20px;width:100%;text-align:center}@media (min-width:768px){.rev-terms-condition[data-v-356e2eb1]{text-align:left}}@media (min-width:1200px){.rm-border[data-v-356e2eb1]{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}}.exclu-rev[data-v-356e2eb1],.exclu-rev img[data-v-356e2eb1]{border-bottom-left-radius:0!important}.pay-i[data-v-356e2eb1],.prod-i[data-v-356e2eb1],.soft-i[data-v-356e2eb1]{margin-right:0!important}.sticky-nav-review-block[data-v-356e2eb1]{position:sticky;display:block;z-index:10}.stripe-sticky[data-v-356e2eb1]{display:block!important;text-align:center}.stripe-sticky p[data-v-356e2eb1]{font-weight:700}.stripe-sticky[data-v-356e2eb1]{position:absolute;width:50px;top:50%;transform:translateY(6px);overflow:hidden;border-bottom-left-radius:10px;border-bottom-right-radius:10px;background-color:#ffd039;display:none;height:20px;line-height:20px}@media (min-width:768px){.stripe-sticky[data-v-356e2eb1]{display:block;bottom:0;left:0;width:100%}}@media (min-width:992px){.stripe-sticky[data-v-356e2eb1]{transform:translateY(25px)}}.stripe-sticky img[data-v-356e2eb1]{width:14px!important;height:14px!important;margin:3px auto;border-radius:0!important}@media (max-width:768px){.stripe-sticky svg[data-v-356e2eb1]{width:12px}}.desk-excl[data-v-356e2eb1]{display:none}@media (min-width:768px){.desk-excl[data-v-356e2eb1]{display:block}}.mob-excl[data-v-356e2eb1]{display:block}@media (min-width:768px){.mob-excl[data-v-356e2eb1]{display:none}}@media (max-width:768px){.mob-excl[data-v-356e2eb1]{display:block;margin:0 auto}}.desk-ra-excl[data-v-356e2eb1]{display:none}@media (min-width:768px){.desk-ra-excl[data-v-356e2eb1]{display:flex}}.mob-ra-excl[data-v-356e2eb1]{display:block}@media (min-width:768px){.mob-ra-excl[data-v-356e2eb1]{display:none}}.exclusive-tag-rev[data-v-356e2eb1]{position:absolute;left:0;right:0;margin:auto;font-size:12px;line-height:15px;border-radius:8px;width:90%;bottom:10px;height:28px;display:flex;justify-content:center}@media (min-width:768px){.exclusive-tag-rev[data-v-356e2eb1]{bottom:14px;width:90%;font-size:17px;line-height:28px;z-index:10}}@media (min-width:992px){.exclusive-tag-rev[data-v-356e2eb1]{width:210px;bottom:10px}}.exclusive-tag-rev img[data-v-356e2eb1]{width:18px!important;height:18px!important;border-radius:0!important;object-fit:contain!important;margin-right:5px}.exclusive-tag-rev p[data-v-356e2eb1]{font-weight:700;font-size:12px;margin:0;display:flex;align-items:center}.exclu-rev[data-v-356e2eb1]{position:relative}.casino-card ul.proslist-rev[data-v-356e2eb1]{margin:0;padding:0;list-style:none;column-count:0;display:block}@media (min-width:576px){.casino-card ul.proslist-rev[data-v-356e2eb1]{column-count:2;-ms-flex-wrap:wrap;flex-wrap:wrap;display:-webkit-box;display:-ms-flexbox;display:flex}}.casino-card ul.proslist-rev li[data-v-356e2eb1]{width:100%;text-align:left;padding-left:32px;line-height:25px;color:#222;margin-bottom:14px;background-size:15px 15px}.casino-card ul.proslist-rev li[data-v-356e2eb1]:last-child{margin-bottom:0}@media (min-width:576px){.casino-card ul.proslist-rev li[data-v-356e2eb1]{width:50%}}.casino-card ul.proslist-rev li.pros[data-v-356e2eb1]{column-count:unset;display:block;position:relative}.casino-card ul.proslist-rev li.pros[data-v-356e2eb1]:before{position:absolute;content:\"\";left:0;top:0;display:inline-block;transform:translateY(0);height:26px;width:26px;background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:14px}.casino-card ul.proslist-rev li.pros li[data-v-356e2eb1]{width:100%;font-size:16px;line-height:25px;margin-bottom:25px;background-position:0 5px}.casino-card ul.proslist-rev li.pros li[data-v-356e2eb1]:last-child{margin-bottom:0}.casino-card ul.proslist-rev li.cons[data-v-356e2eb1]{column-count:unset;display:block;position:relative}.casino-card ul.proslist-rev li.cons[data-v-356e2eb1]:before{position:absolute;content:\"\";left:0;top:0;display:inline-block;transform:translateY(0);height:26px;width:26px;background:#5abc5e url(" + escape(__webpack_require__(22)) + ") no-repeat;border-radius:100%;background-position:50%;background-size:14px}.casino-card ul.proslist-rev li.cons li[data-v-356e2eb1]{width:100%;font-size:16px;line-height:25px;margin-bottom:25px;background-size:15px 15px}.casino-card ul.proslist-rev li.cons li[data-v-356e2eb1]:last-child{margin-bottom:0}.p-caption[data-v-356e2eb1]{font-weight:700;margin-bottom:0}.casino-card-lists ul li figure img[data-v-356e2eb1]{margin:0}.pt-65[data-v-356e2eb1]{padding-top:65px}iframe[data-v-356e2eb1]{border:0;border-radius:10px}", ""]);

// exports


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):_c('main',{class:{
    'main-content-area': true,
    'pt-65': _vm.pageMenuBlock,
    'pt-26': !_vm.pageMenuBlock,
  }},[_c('section',{staticClass:"ct-article"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadCrumb,"dark":true}})],1)])]),_vm._v(" "),[_c('section',{staticClass:"ct-editor-section pb-25"},[_c('div',{staticClass:"container pb-25 overflow-auto"},[_c('h1',{staticClass:"custom-font-1"},[_vm._v("\n          "+_vm._s(_vm.streamsData.title)+"\n        ")]),_vm._v(" "),(_vm.videoId)?_c('div',{staticClass:"wp-has-aspect-ratio ratio-16-9"},[_c('iframe',{attrs:{"src":("https://player.twitch.tv/?video=" + _vm.videoId + "&parent=" + _vm.host + "&autoplay=false"),"height":"100%","width":"100%","allowfullscreen":""}})]):_vm._e()]),_vm._v(" "),_vm._l((_vm.tabData),function(data,index){return [(
          data.blockName === 'wpvcb/page-menu-blocks-scroll' &&
          data.filtered_content &&
          Object.keys(data.filtered_content).length > 0 &&
          data.filtered_content.menu.length > 0)?[_c('div',{key:((data.blockName) + "-" + index),style:({ top: _vm.stickyNavTop }),attrs:{"id":"sticky-nav"}},[(_vm.showSticky)?_c('div',{staticClass:"review-top-menu"},[_c('nav',{staticClass:"scroll-nav"},_vm._l((data.filtered_content.menu),function(mn,index){return _c('span',{key:index,class:{
                    'scroll-item': true,
                    active: _vm.activeKey === mn.menu_block_id,
                  },style:({ '--bg-clr': _vm.$root.color_schema.primary_btn }),on:{"click":function($event){return _vm.scrollPage(mn.menu_block_id)}}},[_vm._v("\n                  "+_vm._s(mn.menu_name)+"\n                ")])}),0)]):_vm._e()])]:_vm._e(),_vm._v(" "),_c('div',{key:((data.blockName) + "-" + index),ref:data.attrs &&
              Object.keys(data.attrs).length > 0 &&
              data.attrs.blockID &&
              data.attrs.blockID != ''
                ? ("" + (data.attrs.blockID))
                : '',refInFor:true},[_c('CustomComponent',{attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.bluebar : {},"blockIndex":index}})],1)]})],2)],_vm._v(" "),(_vm.morePaymentBottom)?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(_vm.auhtorBlockdata)?void 0:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.typeCheck === 'post' && _vm.responseData)?_c('Article',{attrs:{"articleData":_vm.responseData}}):(
    this.typeCheck === 'review' && !this.templateCheck && _vm.responseData
  )?_c('Review',{attrs:{"reviewData":_vm.responseData}}):(
    this.typeCheck === 'review' && this.templateCheck && _vm.responseData
  )?_c('ReviewWithBlocks',{attrs:{"reviewNewData":_vm.responseData}}):(this.typeCheck === 'payment_options' && _vm.responseData)?_c('PaymentOptions',{attrs:{"paymentData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'game-guide-holder' &&
    _vm.responseData
  )?_c('GameGuideHolder',{attrs:{"gameguideholderData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'about-us' &&
    _vm.responseData
  )?_c('AboutUs',{attrs:{"aboutUsData":_vm.responseData}}):(
    (this.typeCheck === 'game_free' || this.typeCheck === 'game_paid') &&
    _vm.responseData
  )?_c('GameFree',{attrs:{"gamesData":_vm.responseData,"gameTemplate":this.typeCheck}}):(
    this.typeCheck === 'page' &&
    (this.templateCheck === 'default-page' || this.templateCheck === '') &&
    _vm.responseData
  )?_c('DefaultPage',{attrs:{"defaultPageData":_vm.responseData}}):(this.typeCheck === 'news' && _vm.responseData)?_c('News',{attrs:{"newsData":_vm.responseData}}):(this.typeCheck === 'streams' && _vm.responseData)?_c('Streams',{attrs:{"streamsData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'feast-group' &&
    _vm.responseData
  )?_c('CalendarTemplate',{attrs:{"calendarData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'usmap-page' &&
    _vm.responseData
  )?_c('MapTemplate',{attrs:{"mapTemplateData":_vm.responseData}}):(this.typeCheck === 'software_providers' && _vm.responseData)?_c('SoftwareProviders',{attrs:{"softwareProviderData":_vm.responseData}}):(
    (this.typeCheck === 'promotions' ||
      (this.typeCheck === 'page' &&
        this.templateCheck === 'promotions-landing')) &&
    _vm.responseData
  )?_c('Promotions',{attrs:{"promotionData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'home-with-default' &&
    _vm.responseData
  )?_c('HomeLayout2',{attrs:{"homeLayout2Data":_vm.responseData}}):(
    this.typeCheck === 'page' && this.templateCheck === '' && _vm.responseData
  )?_c('HomeLayout1',{attrs:{"homeLayout1Data":_vm.responseData}}):(this.typeCheck === 'error')?_c('NotFound'):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(700);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6a4f1b3b", content, true, {});

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-eb74eadc]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-eb74eadc]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-eb74eadc]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-eb74eadc]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-eb74eadc]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-eb74eadc]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-eb74eadc]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-eb74eadc]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-eb74eadc]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-eb74eadc]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-eb74eadc]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-eb74eadc]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-search[data-v-eb74eadc]{padding:37px 0 25px}.ct-search-sort[data-v-eb74eadc]{cursor:pointer}.ct-search-count[data-v-eb74eadc]{display:flex;justify-content:space-between;font-weight:700;font-size:.75rem}.ct-search-result[data-v-eb74eadc]{padding:0;padding-bottom:.75rem}.ct-search-result ul li[data-v-eb74eadc]{padding:.75rem 0;cursor:pointer}.ct-search-result ul li[data-v-eb74eadc]:not(:last-child){border-bottom:1px solid #ccc}@media (min-width:768px){.ct-search-result[data-v-eb74eadc]{padding:0}}.ct-search-pagination[data-v-eb74eadc]{display:flex;justify-content:center;padding-top:20px}.ct-search-pagination .page[data-v-eb74eadc]{height:auto;display:inline-block;text-align:center;width:24px;border-radius:8px;font-size:1rem;background:#070438;color:#fff;cursor:pointer}.ct-search-pagination .page[data-v-eb74eadc]:not(:first-child){margin-left:10px}.ct-search-pagination .active[data-v-eb74eadc]{background:red}.next-prev-page[data-v-eb74eadc]{font-size:1rem;cursor:pointer}.search-item[data-v-eb74eadc]{padding:15px}@media (min-width:768px){.search-item[data-v-eb74eadc]{padding:22px 28px}}.search-card-link a[data-v-eb74eadc]{text-decoration:underline;font-size:14px;overflow-wrap:anywhere}@media (min-width:768px){.search-card-link a[data-v-eb74eadc]{font-size:160%}}.search-card-title[data-v-eb74eadc]{font-size:1rem;margin-bottom:9px;font-weight:900}@media (min-width:768px){.search-card-title[data-v-eb74eadc]{font-size:1.4rem}}.search-card-title[data-v-eb74eadc]:hover{color:var(--primary-color-hover)}.search-card-desc[data-v-eb74eadc]{font-size:1rem}.search-read-btn[data-v-eb74eadc]{max-width:100%;width:100%}@media (min-width:768px){.search-read-btn[data-v-eb74eadc]{max-width:180px;width:180px}}.mt-0[data-v-eb74eadc]{margin-top:0!important}.mw-80[data-v-eb74eadc]{max-width:100%!important}@media (min-width:768px){.mw-80[data-v-eb74eadc]{max-width:80%!important}}.fw-900[data-v-eb74eadc]{font-weight:900!important}.seperator[data-v-eb74eadc]{padding:0 4px}.pagination-wrap[data-v-eb74eadc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:40px}@media (min-width:768px){.pagination-wrap[data-v-eb74eadc]{margin-top:16px}}.pagination-wrap ul[data-v-eb74eadc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.pagination-wrap ul li[data-v-eb74eadc]{cursor:pointer}@media (min-width:768px){.pagination-wrap ul li[data-v-eb74eadc]{margin:0 6px}}.pagination-wrap ul li a[data-v-eb74eadc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:2px solid transparent;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#bdbdbe;width:34px;height:34px}.pagination-wrap ul li a.next img[data-v-eb74eadc],.pagination-wrap ul li a.prev img[data-v-eb74eadc]{-webkit-filter:grayscale(1) invert(1);filter:grayscale(1) invert(1)}.pagination-wrap ul li a.prev img[data-v-eb74eadc]{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.pagination-wrap ul li.active a[data-v-eb74eadc],.pagination-wrap ul li:hover a[data-v-eb74eadc],.pagination-wrap ul li a.active[data-v-eb74eadc]{border-color:#264860;color:#264860}.pagination-wrap ul li.active a.next[data-v-eb74eadc],.pagination-wrap ul li.active a.prev[data-v-eb74eadc],.pagination-wrap ul li:hover a.next[data-v-eb74eadc],.pagination-wrap ul li:hover a.prev[data-v-eb74eadc]{border-color:transparent}.pagination-wrap ul li.active a.next img[data-v-eb74eadc],.pagination-wrap ul li.active a.prev img[data-v-eb74eadc],.pagination-wrap ul li:hover a.next img[data-v-eb74eadc],.pagination-wrap ul li:hover a.prev img[data-v-eb74eadc]{-webkit-filter:grayscale(0) invert(0);filter:grayscale(0) invert(0)}.card-text[data-v-eb74eadc]{overflow:auto}", ""]);

// exports


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{
    'main-content-area': true,
    'custom-background-image': _vm.$root.color_schema.site_bg_img,
  },style:({
    '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
    '--bg-color': _vm.$root.color_schema.site_bg_color,
  })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('section',{class:{
      'ct-search': true,
      'custom-background-color': _vm.$root.color_schema.site_bg_img,
    }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadcrumbData,"dark":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h2',{staticClass:"custom-font-1 fw-900"},[_vm._v("\n        "+_vm._s(_vm.$root.i18n.search_results)+" / "+_vm._s(_vm._f("titleCase")(_vm.searchText))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"ct-search-count"},[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.showing_results)+" "+_vm._s(_vm.calcResultCount.firstCount)+" -\n          "+_vm._s(_vm.calcResultCount.lastCount)+" of "+_vm._s(_vm.totalResultsCount))]),_vm._v(" "),(_vm.pageData.length > 0)?[(_vm.sortAsc)?_c('span',{staticClass:"ct-search-sort",on:{"click":function($event){return _vm.sortResult()}}},[_vm._v("\n            A\n            "),_c('i',{staticClass:"fas fa-long-arrow-alt-down"})]):_vm._e(),_vm._v(" "),(!_vm.sortAsc)?_c('span',{staticClass:"ct-search-sort",on:{"click":function($event){return _vm.sortResult()}}},[_vm._v("\n            Z\n            "),_c('i',{staticClass:"fas fa-long-arrow-alt-down"})]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"ct-search-result"},[_c('div',{staticClass:"row"},_vm._l((_vm.pageData),function(data){return _c('div',{key:data.id,staticClass:"col-12"},[_c('div',{staticClass:"\n                casino-card casino-card-horizontal casino-card-horizontal__m\n                search-item\n              "},[_c('div',{staticClass:"casino-card-row"},[_c('div',{staticClass:"casino-card-row-left mw-80"},[_c('div',{staticClass:"card-text casino-card-text"},[_c('div',{staticClass:"search-card-title",style:({
                        '--primary-color-hover':
                          _vm.$root.color_schema.primary_btn,
                      })},[(_vm.$root.enable_piwik_reload)?[_c('a',{attrs:{"title":data.title,"href":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(data.title))])]:[_c('router-link',{attrs:{"title":data.title,"to":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(data.title))])]],2),_vm._v(" "),_c('div',{staticClass:"search-card-link"},[(_vm.$root.enable_piwik_reload)?[_c('a',{style:({ color: _vm.$root.color_schema.primary_btn }),attrs:{"title":data.title,"href":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(("" + (_vm.$root.site_url) + (_vm.getRouteLink(
                              data.slug,
                              data.type,
                              data.base_slug
                            )))))])]:[_c('router-link',{style:({ color: _vm.$root.color_schema.primary_btn }),attrs:{"title":data.title,"to":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(("" + (_vm.$root.site_url) + (_vm.getRouteLink(
                              data.slug,
                              data.type,
                              data.base_slug
                            )))))])]],2),_vm._v(" "),(data.excerpt)?_c('div',{staticClass:"search-card-desc"},[_vm._v("\n                      "+_vm._s(data.excerpt)+"\n                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"casino-card-row-right"},[(_vm.$root.enable_piwik_reload)?[_c('a',{class:{
                        'cta cta-primary cta-promotion mt-0 search-read-btn custom-btn': true,
                        'text-white':
                          !_vm.$root.override_ctabtntxt_color &&
                          !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-gray':
                          !_vm.$root.override_ctabtntxt_color &&
                          _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-cta-override': _vm.$root.override_ctabtntxt_color,
                      },style:({
                        '--primary-btn': _vm.$root.color_schema.primary_btn,
                        '--primary-btn-hover': _vm.pSBC(
                          -0.2,
                          _vm.$root.color_schema.primary_btn
                        ),
                      }),attrs:{"title":_vm.$root.i18n.read_more,"href":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(_vm.$root.i18n.read_more))])]:[_c('router-link',{class:{
                        'cta cta-primary cta-promotion mt-0 search-read-btn custom-btn': true,
                        'text-white':
                          !_vm.$root.override_ctabtntxt_color &&
                          !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-gray':
                          !_vm.$root.override_ctabtntxt_color &&
                          _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-cta-override': _vm.$root.override_ctabtntxt_color,
                      },style:({
                        '--primary-btn': _vm.$root.color_schema.primary_btn,
                        '--primary-btn-hover': _vm.pSBC(
                          -0.2,
                          _vm.$root.color_schema.primary_btn
                        ),
                      }),attrs:{"title":_vm.$root.i18n.read_more,"to":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(_vm.$root.i18n.read_more))])]],2)])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"pagination-wrap"},[_c('ul',[_c('li',[(_vm.currentPage > 1)?_c('a',{staticClass:"prev",attrs:{"title":_vm.currentPage - 1},on:{"click":function($event){return _vm.prevPage()}}},[_c('img',{attrs:{"src":_vm.$root.site_url + _vm.$root.asset_path + '/p-arrow.svg',"alt":""}})]):_vm._e()]),_vm._v(" "),(_vm.paginationNumbers > 6)?[(_vm.currentPage < _vm.paginationNumbers - 6)?[_vm._l((_vm.getRange(_vm.currentPage, 3, _vm.paginationNumbers - 3)),function(i){return _c('li',{key:i + 'first'},[_c('a',{class:{ active: i === _vm.currentPage },attrs:{"title":_vm.currentPage},on:{"click":function($event){return _vm.changePage(i)}}},[_vm._v(_vm._s(i))])])}),_vm._v(" "),_c('li',[_vm._v("...")])]:_vm._l((_vm.getRange(
                  _vm.paginationNumbers - 6,
                  4,
                  _vm.paginationNumbers - 3
                )),function(i){return _c('li',{key:i + 'first'},[_c('a',{class:{ active: i === _vm.currentPage },attrs:{"title":_vm.currentPage},on:{"click":function($event){return _vm.changePage(i)}}},[_vm._v(_vm._s(i))])])}),_vm._v(" "),_vm._l((_vm.getRange(
                _vm.paginationNumbers - 2,
                3,
                _vm.paginationNumbers
              )),function(i){return _c('li',{key:i + 'second'},[_c('a',{class:{ active: i === _vm.currentPage },attrs:{"title":_vm.currentPage},on:{"click":function($event){return _vm.changePage(i)}}},[_vm._v(_vm._s(i))])])})]:_vm._l((_vm.paginationNumbers),function(pagination,pageIn){return _c('li',{key:pageIn},[(
                  _vm.paginationNumbers != 0 && _vm.currentPage != _vm.paginationNumbers
                )?_c('a',{class:{ active: pageIn + 1 === _vm.currentPage },attrs:{"title":_vm.currentPage},on:{"click":function($event){return _vm.nextPage(pageIn + 1)}}},[_vm._v(_vm._s(pageIn + 1))]):_vm._e()])}),_vm._v(" "),_c('li',[(
                _vm.paginationNumbers != 0 && _vm.currentPage != _vm.paginationNumbers
              )?_c('a',{staticClass:"next",attrs:{"title":_vm.currentPage + 1},on:{"click":function($event){return _vm.nextPage(_vm.currentPage + 1)}}},[_c('img',{attrs:{"src":_vm.$root.site_url + _vm.$root.asset_path + '/p-arrow.svg',"alt":""}})]):_vm._e()])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.typeCheck === 'post' && _vm.responseData)?_c('Article',{attrs:{"articleData":_vm.responseData}}):(
    this.typeCheck === 'review' && !this.templateCheck && _vm.responseData
  )?_c('Review',{attrs:{"reviewData":_vm.responseData}}):(
    this.typeCheck === 'review' && this.templateCheck && _vm.responseData
  )?_c('ReviewWithBlocks',{attrs:{"reviewNewData":_vm.responseData}}):(this.typeCheck === 'payment_options' && _vm.responseData)?_c('PaymentOptions',{attrs:{"paymentData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'game-guide-holder' &&
    _vm.responseData
  )?_c('GameGuideHolder',{attrs:{"gameguideholderData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'about-us' &&
    _vm.responseData
  )?_c('AboutUs',{attrs:{"aboutUsData":_vm.responseData}}):(
    (this.typeCheck === 'game_free' || this.typeCheck === 'game_paid') &&
    _vm.responseData
  )?_c('GameFree',{attrs:{"gamesData":_vm.responseData,"gameTemplate":this.typeCheck}}):(
    this.typeCheck === 'page' &&
    (this.templateCheck === 'default-page' || this.templateCheck === '') &&
    _vm.responseData
  )?_c('DefaultPage',{attrs:{"defaultPageData":_vm.responseData}}):(this.typeCheck === 'news' && _vm.responseData)?_c('News',{attrs:{"newsData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'feast-group' &&
    _vm.responseData
  )?_c('CalendarTemplate',{attrs:{"calendarData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'usmap-page' &&
    _vm.responseData
  )?_c('MapTemplate',{attrs:{"mapTemplateData":_vm.responseData}}):(this.typeCheck === 'software_providers' && _vm.responseData)?_c('SoftwareProviders',{attrs:{"softwareProviderData":_vm.responseData}}):(
    (this.typeCheck === 'promotions' ||
      (this.typeCheck === 'page' &&
        this.templateCheck === 'promotions-landing')) &&
    _vm.responseData
  )?_c('Promotions',{attrs:{"promotionData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'home-with-default' &&
    _vm.responseData
  )?_c('HomeLayout2',{attrs:{"homeLayout2Data":_vm.responseData}}):(
    this.typeCheck === 'page' && this.templateCheck === '' && _vm.responseData
  )?_c('HomeLayout1',{attrs:{"homeLayout1Data":_vm.responseData}}):(this.typeCheck === 'error')?_c('NotFound'):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(704);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("bf6291d8", content, true, {});

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-72c838b0]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-72c838b0]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-72c838b0]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-72c838b0]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-72c838b0]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-72c838b0]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-72c838b0]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-72c838b0]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-72c838b0]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-72c838b0]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-72c838b0]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-72c838b0]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-archive[data-v-72c838b0]{padding:37px 0 25px}.ct-archive-sort[data-v-72c838b0]{cursor:pointer}.ct-archive-count[data-v-72c838b0]{display:flex;justify-content:space-between;font-weight:700;font-size:.75rem}.ct-archive-result[data-v-72c838b0]{padding:0;padding-bottom:.75rem}.ct-archive-result ul li[data-v-72c838b0]{padding:.75rem 0;cursor:pointer}.ct-archive-result ul li[data-v-72c838b0]:not(:last-child){border-bottom:1px solid #ccc}@media (min-width:768px){.ct-archive-result[data-v-72c838b0]{padding:0}}.ct-archive-pagination[data-v-72c838b0]{display:flex;justify-content:center;padding-top:20px}.ct-archive-pagination .page[data-v-72c838b0]{height:auto;display:inline-block;text-align:center;width:24px;border-radius:8px;font-size:1rem;background:#070438;color:#fff;cursor:pointer}.ct-archive-pagination .page[data-v-72c838b0]:not(:first-child){margin-left:10px}.ct-archive-pagination .active[data-v-72c838b0]{background:red}.next-prev-page[data-v-72c838b0]{font-size:1rem;cursor:pointer}.archive-item[data-v-72c838b0]{padding:15px}@media (min-width:768px){.archive-item[data-v-72c838b0]{padding:22px 28px}}.archive-card-link a[data-v-72c838b0]{text-decoration:underline;font-size:14px;overflow-wrap:anywhere}@media (min-width:768px){.archive-card-link a[data-v-72c838b0]{font-size:160%}}.archive-card-title[data-v-72c838b0]{font-size:1rem;margin-bottom:9px;font-weight:900}@media (min-width:768px){.archive-card-title[data-v-72c838b0]{font-size:1.4rem}}.archive-card-title[data-v-72c838b0]:hover{color:var(--primary-color-hover)}.archive-card-desc[data-v-72c838b0]{font-size:1rem}.archive-read-btn[data-v-72c838b0]{max-width:100%;width:100%}@media (min-width:768px){.archive-read-btn[data-v-72c838b0]{max-width:180px;width:180px}}.mt-0[data-v-72c838b0]{margin-top:0!important}.mw-80[data-v-72c838b0]{max-width:100%!important}@media (min-width:768px){.mw-80[data-v-72c838b0]{max-width:80%!important}}.fw-900[data-v-72c838b0]{font-weight:900!important}.seperator[data-v-72c838b0]{padding:0 4px}.pagination-wrap[data-v-72c838b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:40px}@media (min-width:768px){.pagination-wrap[data-v-72c838b0]{margin-top:16px}}.pagination-wrap ul[data-v-72c838b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.pagination-wrap ul li[data-v-72c838b0]{cursor:pointer}@media (min-width:768px){.pagination-wrap ul li[data-v-72c838b0]{margin:0 6px}}.pagination-wrap ul li a[data-v-72c838b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:2px solid transparent;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;font-family:Helvetica;font-weight:400;font-size:16px;line-height:26px;color:#bdbdbe;width:34px;height:34px}.pagination-wrap ul li a.next img[data-v-72c838b0],.pagination-wrap ul li a.prev img[data-v-72c838b0]{-webkit-filter:grayscale(1) invert(1);filter:grayscale(1) invert(1)}.pagination-wrap ul li a.prev img[data-v-72c838b0]{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.pagination-wrap ul li.active a[data-v-72c838b0],.pagination-wrap ul li:hover a[data-v-72c838b0],.pagination-wrap ul li a.active[data-v-72c838b0]{border-color:#264860;color:#264860}.pagination-wrap ul li.active a.next[data-v-72c838b0],.pagination-wrap ul li.active a.prev[data-v-72c838b0],.pagination-wrap ul li:hover a.next[data-v-72c838b0],.pagination-wrap ul li:hover a.prev[data-v-72c838b0]{border-color:transparent}.pagination-wrap ul li.active a.next img[data-v-72c838b0],.pagination-wrap ul li.active a.prev img[data-v-72c838b0],.pagination-wrap ul li:hover a.next img[data-v-72c838b0],.pagination-wrap ul li:hover a.prev img[data-v-72c838b0]{-webkit-filter:grayscale(0) invert(0);filter:grayscale(0) invert(0)}.card-text[data-v-72c838b0]{overflow:auto}", ""]);

// exports


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):_c('main',{class:{
    'main-content-area': true,
    'custom-background-image': _vm.$root.color_schema.site_bg_img,
  },style:({
    '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
    '--bg-color': _vm.$root.color_schema.site_bg_color,
  })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('section',{class:{
      'ct-archive': true,
      'custom-background-color': _vm.$root.color_schema.site_bg_img,
    }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":_vm.breadcrumbData,"dark":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h2',{staticClass:"custom-font-1 fw-900"},[_vm._v("\n        "+_vm._s(_vm.$root.i18n.archive)+" / "+_vm._s(_vm.term.name)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"ct-archive-count"},[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.showing_results)+" "+_vm._s(_vm.calcResultCount.firstCount)+" -\n          "+_vm._s(_vm.calcResultCount.lastCount)+" of "+_vm._s(_vm.totalResultsCount))]),_vm._v(" "),(_vm.pageData.length > 0)?[(_vm.sortAsc)?_c('span',{staticClass:"ct-archive-sort",on:{"click":function($event){return _vm.sortResult()}}},[_vm._v("\n            A\n            "),_c('i',{staticClass:"fas fa-long-arrow-alt-down"})]):_vm._e(),_vm._v(" "),(!_vm.sortAsc)?_c('span',{staticClass:"ct-archive-sort",on:{"click":function($event){return _vm.sortResult()}}},[_vm._v("\n            Z\n            "),_c('i',{staticClass:"fas fa-long-arrow-alt-down"})]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"ct-archive-result"},[_c('div',{staticClass:"row"},_vm._l((_vm.pageData),function(data){return _c('div',{key:data.id,staticClass:"col-12"},[_c('div',{staticClass:"\n                casino-card casino-card-horizontal casino-card-horizontal__m\n                archive-item\n              "},[_c('div',{staticClass:"casino-card-row"},[_c('div',{staticClass:"casino-card-row-left mw-80"},[_c('div',{staticClass:"card-text casino-card-text"},[_c('div',{staticClass:"archive-card-title",style:({
                        '--primary-color-hover':
                          _vm.$root.color_schema.primary_btn,
                      })},[(_vm.$root.enable_piwik_reload)?[_c('a',{attrs:{"title":data.title,"href":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(data.title))])]:[_c('router-link',{attrs:{"title":data.title,"to":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(data.title))])]],2),_vm._v(" "),_c('div',{staticClass:"archive-card-link"},[(_vm.$root.enable_piwik_reload)?[_c('a',{style:({ color: _vm.$root.color_schema.primary_btn }),attrs:{"title":data.title,"href":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(("" + (_vm.$root.site_url) + (_vm.getRouteLink(
                              data.slug,
                              data.type,
                              data.base_slug
                            )))))])]:[_c('router-link',{style:({ color: _vm.$root.color_schema.primary_btn }),attrs:{"title":data.title,"to":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(("" + (_vm.$root.site_url) + (_vm.getRouteLink(
                              data.slug,
                              data.type,
                              data.base_slug
                            )))))])]],2),_vm._v(" "),(data.excerpt)?_c('div',{staticClass:"archive-card-desc"},[_vm._v("\n                      "+_vm._s(data.excerpt)+"\n                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"casino-card-row-right"},[(_vm.$root.enable_piwik_reload)?[_c('a',{class:{
                        'cta cta-primary cta-promotion mt-0 archive-read-btn custom-btn': true,
                        'text-white':
                          !_vm.$root.override_ctabtntxt_color &&
                          !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-gray':
                          !_vm.$root.override_ctabtntxt_color &&
                          _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-cta-override': _vm.$root.override_ctabtntxt_color,
                      },style:({
                        '--primary-btn': _vm.$root.color_schema.primary_btn,
                        '--primary-btn-hover': _vm.pSBC(
                          -0.2,
                          _vm.$root.color_schema.primary_btn
                        ),
                      }),attrs:{"title":_vm.$root.i18n.read_more,"href":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(_vm.$root.i18n.read_more))])]:[_c('router-link',{class:{
                        'cta cta-primary cta-promotion mt-0 archive-read-btn custom-btn': true,
                        'text-white':
                          !_vm.$root.override_ctabtntxt_color &&
                          !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-gray':
                          !_vm.$root.override_ctabtntxt_color &&
                          _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-cta-override': _vm.$root.override_ctabtntxt_color,
                      },style:({
                        '--primary-btn': _vm.$root.color_schema.primary_btn,
                        '--primary-btn-hover': _vm.pSBC(
                          -0.2,
                          _vm.$root.color_schema.primary_btn
                        ),
                      }),attrs:{"title":_vm.$root.i18n.read_more,"to":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(_vm.$root.i18n.read_more))])]],2)])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"pagination-wrap"},[_c('ul',[_c('li',[(_vm.currentPage > 1)?_c('a',{staticClass:"prev",attrs:{"title":_vm.currentPage - 1},on:{"click":function($event){return _vm.prevPage()}}},[_c('img',{attrs:{"src":_vm.$root.site_url + _vm.$root.asset_path + '/p-arrow.svg',"alt":""}})]):_vm._e()]),_vm._v(" "),(_vm.paginationNumbers > 6)?[(_vm.currentPage < _vm.paginationNumbers - 6)?[_vm._l((_vm.getRange(_vm.currentPage, 3, _vm.paginationNumbers - 3)),function(i){return _c('li',{key:i + 'first'},[_c('a',{class:{ active: i === _vm.currentPage },attrs:{"title":_vm.currentPage},on:{"click":function($event){return _vm.changePage(i)}}},[_vm._v(_vm._s(i))])])}),_vm._v(" "),_c('li',[_vm._v("...")])]:_vm._l((_vm.getRange(
                  _vm.paginationNumbers - 6,
                  4,
                  _vm.paginationNumbers - 3
                )),function(i){return _c('li',{key:i + 'first'},[_c('a',{class:{ active: i === _vm.currentPage },attrs:{"title":_vm.currentPage},on:{"click":function($event){return _vm.changePage(i)}}},[_vm._v(_vm._s(i))])])}),_vm._v(" "),_vm._l((_vm.getRange(
                _vm.paginationNumbers - 2,
                3,
                _vm.paginationNumbers
              )),function(i){return _c('li',{key:i + 'second'},[_c('a',{class:{ active: i === _vm.currentPage },attrs:{"title":_vm.currentPage},on:{"click":function($event){return _vm.changePage(i)}}},[_vm._v(_vm._s(i))])])})]:_vm._l((_vm.paginationNumbers),function(pagination,pageIn){return _c('li',{key:pageIn},[(
                  _vm.paginationNumbers != 0 && _vm.currentPage != _vm.paginationNumbers
                )?_c('a',{class:{ active: pageIn + 1 === _vm.currentPage },attrs:{"title":_vm.currentPage},on:{"click":function($event){return _vm.nextPage(pageIn + 1)}}},[_vm._v(_vm._s(pageIn + 1))]):_vm._e()])}),_vm._v(" "),_c('li',[(
                _vm.paginationNumbers != 0 && _vm.currentPage != _vm.paginationNumbers
              )?_c('a',{staticClass:"next",attrs:{"title":_vm.currentPage + 1},on:{"click":function($event){return _vm.nextPage(_vm.currentPage + 1)}}},[_c('img',{attrs:{"src":_vm.$root.site_url + _vm.$root.asset_path + '/p-arrow.svg',"alt":""}})]):_vm._e()])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.vue": [
		23
	],
	"./AboutUs.vue": [
		104
	],
	"./Archive.vue": [
		145
	],
	"./Article.vue": [
		97
	],
	"./CalendarTemplate.vue": [
		105
	],
	"./DefaultPage.vue": [
		102
	],
	"./GameFree/GameFree.vue": [
		101
	],
	"./GameGuideHolder.vue": [
		100
	],
	"./Home.vue": [
		141
	],
	"./HomeLayout1.vue": [
		78
	],
	"./HomeLayout2.vue": [
		79
	],
	"./Index.vue": [
		142
	],
	"./MapTemplate.vue": [
		103
	],
	"./News/News.vue": [
		109
	],
	"./PaymentOptions/PaymentOptions.vue": [
		106
	],
	"./Preview.vue": [
		144
	],
	"./Promotions/Promotions.vue": [
		108
	],
	"./Review/Review.vue": [
		98
	],
	"./Review/ReviewWithBlocks.vue": [
		99
	],
	"./Search/Search.vue": [
		143
	],
	"./SoftwareProviders/SoftwareProviders.vue": [
		107
	],
	"./Streams/Streams.vue": [
		110
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 706;
module.exports = webpackAsyncContext;

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-md-none"},[_c('a',{class:{
      button: true,
      'd-none': _vm.menuOpen,
    },style:({
      '--font-color': _vm.getContrastYIQ(_vm.$root.color_schema.primary)
        ? '#333'
        : '#fff',
    }),on:{"click":_vm.openMobMenu}},[_c('svg',{staticClass:"menu-bars",attrs:{"width":"24","height":"16","viewBox":"0 0 24 16","fill":_vm.getContrastYIQ(_vm.$root.color_schema.primary) ? '#333' : '#fff',"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 16H24V13.3333H0V16ZM0 9.33333H24V6.66667H0V9.33333ZM0 0V2.66667H24V0H0Z"}})])]),_vm._v(" "),_c('a',{class:{
      'button menu-opened': true,
      'd-none': !_vm.menuOpen,
    },style:({
      '--font-color': _vm.getContrastYIQ(_vm.$root.color_schema.primary)
        ? '#333'
        : '#fff',
    }),on:{"click":_vm.closeMobMenu}},[_c('span',{staticClass:"menu-close",style:({
        color: _vm.getContrastYIQ(_vm.$root.color_schema.primary) ? '#333' : '#fff',
      })},[_vm._v("×")])]),_vm._v(" "),_c('nav',{style:({
      '--primary-color': _vm.$root.color_schema.primary,
      '--top': _vm.getHeaderHeight(
        _vm.regulationBanner,
        _vm.carnivalBanner,
        _vm.regulationBannerSticky
      ),
      '--font-color': _vm.getContrastYIQ(_vm.$root.color_schema.primary)
        ? '#333'
        : '#fff',
    }),attrs:{"id":"mob-menu"}},[_c('ul',[_c('li',[_c('a',{staticClass:"search search-bg",style:({
            '--primary-search-bg': _vm.pSBC(0.4, _vm.$root.color_schema.primary),
            '--search-icon': ("url(" + (_vm.$root.site_url) + (_vm.$root.asset_path) + "/svg-icons/search-sml.svg)"),
          })},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-bg",attrs:{"type":"search","placeholder":_vm.$root.i18n.search},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchItem.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})])]),_vm._v(" "),_vm._l((_vm.menus),function(menu){return _c('li',{key:menu.ID},[(menu.children && menu.children.length > 0)?[_c('a',{staticClass:"page-links"},[_c('img',{staticClass:"grayscale-invert",attrs:{"width":"17","height":"17","src":menu.menu_item_icon,"alt":_vm.getAltText(menu.title, menu.menu_item_icon)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(menu.title))])]),_vm._v(" "),_c('MobileChildMenu',{attrs:{"menus":menu.children,"parent":menu},on:{"closePanel":_vm.closeMobMenu}})]:[(menu.object === 'custom')?[(menu.url && menu.url != '')?_c('a',{staticClass:"page-links",attrs:{"href":menu.url}},[_c('img',{staticClass:"grayscale-invert",attrs:{"width":"17","height":"17","src":menu.menu_item_icon,"alt":_vm.getAltText(menu.title, menu.menu_item_icon)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(menu.title))])]):[_c('img',{staticClass:"grayscale-invert",attrs:{"width":"17","height":"17","src":menu.menu_item_icon,"alt":_vm.getAltText(menu.title, menu.menu_item_icon)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(menu.title))])]]:[(_vm.$root.enable_piwik_reload)?[_c('a',{staticClass:"page-links",attrs:{"href":_vm.getRouteLink(menu.slug, menu.object, menu.base_slug)},on:{"click":_vm.closeMobMenu}},[_c('img',{staticClass:"grayscale-invert",attrs:{"width":"17","height":"17","src":menu.menu_item_icon,"alt":_vm.getAltText(menu.title, menu.menu_item_icon)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(menu.title))])])]:[_c('router-link',{staticClass:"page-links",attrs:{"to":_vm.getRouteLink(menu.slug, menu.object, menu.base_slug)},nativeOn:{"click":function($event){return _vm.closeMobMenu.apply(null, arguments)}}},[_c('img',{staticClass:"grayscale-invert",attrs:{"width":"17","height":"17","src":menu.menu_item_icon,"alt":_vm.getAltText(menu.title, menu.menu_item_icon)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(menu.title))])])]]]],2)})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    navbar: true,
    'mob-fixed': _vm.$root.show_stickymenu && _vm.$root.show_stickymenu_mobile,
  },attrs:{"id":"navbar"}},[(_vm.headerComponent.regulationBanner.enable_regulation_banner_sticky)?[(_vm.headerComponent.regulationBanner.show_top_bar)?_c('div',{staticClass:"regulation-banner",attrs:{"id":"sticky-regulation-banner"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"regulation-banner-row"},[_c('div',{staticClass:"regulation-banner-text desk-reg"},[_c('span',[_vm._v(_vm._s(_vm.headerComponent.regulationBanner.heading))])]),_vm._v(" "),(
              _vm.headerComponent.regulationBanner
                .show_regulation_banner_text_in_mobile
            )?_c('div',{staticClass:"regulation-banner-text mob-reg"},[_c('span',[_vm._v(_vm._s(_vm.headerComponent.regulationBanner.heading))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"icons-column"},_vm._l((_vm.headerComponent.regulationBanner.icons),function(icon,index){return _c('span',{key:index,staticClass:"icon-wrap"},[(icon.goto_link)?_c('a',{attrs:{"href":icon.goto_link,"target":"_blank"}},[_c('img',{attrs:{"src":icon.links,"alt":icon.alt_text ? icon.alt_text : ("Regulation Banner Icon " + index),"width":icon.img_width || 'auto',"height":icon.img_height || 'auto'}})]):_c('img',{attrs:{"src":icon.links,"alt":icon.alt_text ? icon.alt_text : ("Regulation Banner Icon " + index),"width":icon.img_width || 'auto',"height":icon.img_height || 'auto'}})])}),0)])])]):_vm._e()]:[(_vm.headerComponent.regulationBanner.show_top_bar)?_c('div',{staticClass:"regulation-banner",style:({
        top: _vm.headerComponent.regulationBanner.enable_regulation_banner_sticky
          ? _vm.stickyRegulationBannerTop
          : '',
      }),attrs:{"id":"regulation-banner"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"regulation-banner-row"},[_c('div',{staticClass:"regulation-banner-text desk-reg"},[_c('span',[_vm._v(_vm._s(_vm.headerComponent.regulationBanner.heading))])]),_vm._v(" "),(
              _vm.headerComponent.regulationBanner
                .show_regulation_banner_text_in_mobile
            )?_c('div',{staticClass:"regulation-banner-text mob-reg"},[_c('span',[_vm._v(_vm._s(_vm.headerComponent.regulationBanner.heading))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"icons-column"},_vm._l((_vm.headerComponent.regulationBanner.icons),function(icon,index){return _c('span',{key:index,staticClass:"icon-wrap"},[(icon.goto_link)?_c('a',{attrs:{"href":icon.goto_link,"target":"_blank"}},[_c('img',{attrs:{"src":icon.links,"alt":icon.alt_text ? icon.alt_text : ("Regulation Banner Icon " + index),"width":icon.img_width || 'auto',"height":icon.img_height || 'auto'}})]):_c('img',{attrs:{"src":icon.links,"alt":icon.alt_text ? icon.alt_text : ("Regulation Banner Icon " + index),"width":icon.img_width || 'auto',"height":icon.img_height || 'auto'}})])}),0)])])]):_vm._e()],_vm._v(" "),(
      _vm.headerComponent.carnivalBanner &&
      Object.keys(_vm.headerComponent.carnivalBanner).length > 0 &&
      _vm.headerComponent.carnivalBanner.url &&
      _vm.headerComponent.carnivalBanner.enable_banner
    )?[_c('a',{attrs:{"href":_vm.headerComponent.carnivalBanner.url,"target":_vm.headerComponent.carnivalBanner.link_target,"rel":_vm.headerComponent.carnivalBanner.link_rel}},[(
          _vm.headerComponent.carnivalBanner &&
          Object.keys(_vm.headerComponent.carnivalBanner).length > 0
        )?_c('div',{staticClass:"carnival-banner",style:({
          background: ("url('" + (_vm.headerComponent.carnivalBanner.background_image) + "') no-repeat,\n        " + (_vm.headerComponent.carnivalBanner.background_color)),
        }),attrs:{"id":"carnival-banner"}},[_c('span',{class:{
            'first-text custom-font-1': true,
            'text-white': !_vm.getContrastYIQ(
              _vm.headerComponent.carnivalBanner.background_color
            ),
            'text-gray': _vm.getContrastYIQ(
              _vm.headerComponent.carnivalBanner.background_color
            ),
          }},[_vm._v(_vm._s(_vm.headerComponent.carnivalBanner.banner_text))])]):_vm._e()])]:[(
        _vm.headerComponent.carnivalBanner &&
        Object.keys(_vm.headerComponent.carnivalBanner).length > 0 &&
        _vm.headerComponent.carnivalBanner.enable_banner
      )?_c('div',{staticClass:"carnival-banner",style:({
        background: ("url('" + (_vm.headerComponent.carnivalBanner.background_image) + "') no-repeat,\n        " + (_vm.headerComponent.carnivalBanner.background_color)),
      }),attrs:{"id":"carnival-banner"}},[_c('span',{class:{
          'first-text custom-font-1': true,
          'text-white': !_vm.getContrastYIQ(
            _vm.headerComponent.carnivalBanner.background_color
          ),
          'text-gray': _vm.getContrastYIQ(
            _vm.headerComponent.carnivalBanner.background_color
          ),
        }},[_vm._v(_vm._s(_vm.headerComponent.carnivalBanner.banner_text))])]):_vm._e()],_vm._v(" "),_c('header',{class:{
      'mobile-menu-open': _vm.mobileMenuOpen,
      'mobile-menu-close': !_vm.mobileMenuOpen,
    },style:({ 'background-color': _vm.$root.color_schema.primary }),attrs:{"id":"header"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"cssmenu",attrs:{"id":"cssmenu"}},[_c('div',{staticClass:"logo"},[(_vm.$root.enable_piwik_reload)?[_c('a',{staticClass:"log-img",attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.headerComponent.logo,"alt":_vm.siteName,"width":"130","height":"52"}})])]:[_c('router-link',{staticClass:"log-img",attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.headerComponent.logo,"alt":_vm.siteName,"width":"130","height":"52"}})])]],2),_vm._v(" "),_c('div',{attrs:{"id":"head-mobile"}}),_vm._v(" "),(_vm.headerComponent.menus)?_c('ul',{style:({ '--primary-color': _vm.$root.color_schema.primary }),attrs:{"id":"header-content"}},[_vm._l((_vm.headerComponent.menus),function(menu){return _c('NavMenu',{key:menu.ID,attrs:{"menu":menu}})}),_vm._v(" "),_c('li',{staticClass:"search-wrapper",style:({ '--primary-color': _vm.$root.color_schema.primary })},[_c('span',[_c('svg',{staticClass:"src-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"}},[_c('path',{attrs:{"opacity":"0.6","d":"M11.6881 10.1168L8.918 7.38291C9.56287 6.3991 9.81949 5.21593 9.6392 4.05779C9.45891 2.89966 8.85425 1.84708 7.93989 1.09968C7.02553 0.352278 5.86505 -0.0379789 4.67852 0.00291729C3.49198 0.0438135 2.36192 0.513019 1.50261 1.32155C0.64331 2.13009 0.114528 3.22173 0.0165455 4.38946C-0.0814373 5.55719 0.258192 6.7198 0.971027 7.65682C1.68386 8.59385 2.72033 9.24012 3.88388 9.47308C5.04744 9.70605 6.25716 9.50951 7.28364 8.92072L10.0538 11.6546C10.2604 11.8685 10.5446 11.9926 10.844 11.9997C11.1434 12.0067 11.4333 11.8961 11.65 11.6922C11.8668 11.4883 11.9925 11.2077 11.9997 10.9123C12.0068 10.6168 11.8948 10.3307 11.6881 10.1168ZM1.54949 4.80623C1.544 4.15489 1.73469 3.51661 2.09736 2.9724C2.46003 2.42819 2.97834 2.00258 3.5865 1.74956C4.19467 1.49654 4.86529 1.42752 5.51327 1.55126C6.16125 1.67501 6.75737 1.98593 7.22601 2.44459C7.69464 2.90325 8.01466 3.48896 8.14545 4.12741C8.27624 4.76586 8.21191 5.42826 7.96063 6.03056C7.70934 6.63287 7.28242 7.14793 6.73405 7.51039C6.18567 7.87285 5.54056 8.06636 4.88056 8.06639C4.00244 8.06464 3.16038 7.72145 2.53686 7.11121C1.91335 6.50097 1.5586 5.67282 1.54949 4.80623Z","fill":"#030030"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],attrs:{"type":"search","placeholder":_vm.$root.i18n.search},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchItem.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})])])],2):_vm._e(),_vm._v(" "),(
            _vm.headerComponent.menus &&
            _vm.headerComponent.menus.length > 0
          )?[_c('HeaderMobMenu',{attrs:{"menus":_vm.headerComponent.menus,"regulationBanner":_vm.headerComponent.regulationBanner.show_top_bar &&
              _vm.regulationBanner
                ? true
                : false,"regulationBannerSticky":_vm.headerComponent.regulationBanner
                .enable_regulation_banner_sticky && _vm.regulationBanner
                ? true
                : false,"carnivalBanner":_vm.headerComponent.carnivalBanner.enable_banner && _vm.carnivalBanner
                ? true
                : false},on:{"menuOpen":_vm.menuOpen}})]:_vm._e()],2)])]),_vm._v(" "),(_vm.$root.show_stickymenu && _vm.$root.show_stickymenu_desktop)?_c('header',{staticClass:"sticky-header",style:({
      'background-color': _vm.$root.color_schema.primary,
    }),attrs:{"id":"sticky-header"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"cssmenu",attrs:{"id":"cssmenu"}},[_c('div',{staticClass:"logo"},[(_vm.$root.enable_piwik_reload)?[_c('a',{staticClass:"log-img",attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.headerComponent.logo,"alt":_vm.siteName,"width":"130","height":"52"}})])]:[_c('router-link',{staticClass:"log-img",attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.headerComponent.logo,"alt":_vm.siteName,"width":"130","height":"52"}})])]],2),_vm._v(" "),_c('div',{attrs:{"id":"head-mobile"}}),_vm._v(" "),(_vm.headerComponent.menus)?_c('ul',{style:({ '--primary-color': _vm.$root.color_schema.primary })},[_vm._l((_vm.headerComponent.menus),function(menu){return _c('NavMenu',{key:menu.ID,attrs:{"menu":menu}})}),_vm._v(" "),_c('li',{staticClass:"search-wrapper",style:({ '--primary-color': _vm.$root.color_schema.primary })},[_c('span',[_c('svg',{staticClass:"src-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"}},[_c('path',{attrs:{"opacity":"0.6","d":"M11.6881 10.1168L8.918 7.38291C9.56287 6.3991 9.81949 5.21593 9.6392 4.05779C9.45891 2.89966 8.85425 1.84708 7.93989 1.09968C7.02553 0.352278 5.86505 -0.0379789 4.67852 0.00291729C3.49198 0.0438135 2.36192 0.513019 1.50261 1.32155C0.64331 2.13009 0.114528 3.22173 0.0165455 4.38946C-0.0814373 5.55719 0.258192 6.7198 0.971027 7.65682C1.68386 8.59385 2.72033 9.24012 3.88388 9.47308C5.04744 9.70605 6.25716 9.50951 7.28364 8.92072L10.0538 11.6546C10.2604 11.8685 10.5446 11.9926 10.844 11.9997C11.1434 12.0067 11.4333 11.8961 11.65 11.6922C11.8668 11.4883 11.9925 11.2077 11.9997 10.9123C12.0068 10.6168 11.8948 10.3307 11.6881 10.1168ZM1.54949 4.80623C1.544 4.15489 1.73469 3.51661 2.09736 2.9724C2.46003 2.42819 2.97834 2.00258 3.5865 1.74956C4.19467 1.49654 4.86529 1.42752 5.51327 1.55126C6.16125 1.67501 6.75737 1.98593 7.22601 2.44459C7.69464 2.90325 8.01466 3.48896 8.14545 4.12741C8.27624 4.76586 8.21191 5.42826 7.96063 6.03056C7.70934 6.63287 7.28242 7.14793 6.73405 7.51039C6.18567 7.87285 5.54056 8.06636 4.88056 8.06639C4.00244 8.06464 3.16038 7.72145 2.53686 7.11121C1.91335 6.50097 1.5586 5.67282 1.54949 4.80623Z","fill":"#030030"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],attrs:{"type":"search","placeholder":_vm.$root.i18n.search},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchItem.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})])])],2):_vm._e()])])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06aec038_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(715);
function injectStyle (ssrContext) {
  __webpack_require__(710)
  __webpack_require__(712)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06aec038"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06aec038_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(711);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0a74ef5d", content, true, {});

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-06aec038]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-06aec038]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-06aec038]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-06aec038]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-06aec038]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-06aec038]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-06aec038]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-06aec038]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-06aec038]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-06aec038]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-06aec038]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-06aec038]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.rotate-180[data-v-06aec038]{transform:rotate(180deg)!important}.ct-footer-top[data-v-06aec038]{background:#070438;padding:0 0 30px}@media (min-width:1024px){.ct-footer-top[data-v-06aec038]{padding:45px 0}}.ct-footer-top .row .col-lg-3[data-v-06aec038]{width:100%}@media (min-width:992px){.ct-footer-top .row .col-lg-3[data-v-06aec038]{width:23%}}.ct-footer-top .row .col-lg-3[data-v-06aec038]:last-child{width:100%}@media (min-width:992px){.ct-footer-top .row .col-lg-3[data-v-06aec038]:last-child{width:31%}}.ct-footer-top .row .col-lg-3:last-child .footer-mnu[data-v-06aec038]{border-bottom:none}.ct-footer-bottom[data-v-06aec038]{background:#2d1d8a;padding:20px}.ct-footer-bottom p.copy-right[data-v-06aec038]{color:#fff;margin:0}.ct-footer .menu-col .span-h4[data-v-06aec038]{color:#fff;font-weight:700;margin-bottom:0}@media (max-width:576px){.ct-footer .menu-col .span-h4[data-v-06aec038]{display:block;margin:0 auto}}.ct-footer .menu-col ul.footer-menu[data-v-06aec038]{padding-bottom:0}@media (max-width:576px){.ct-footer .menu-col ul.footer-menu[data-v-06aec038]{text-align:center}}.ct-footer .menu-col ul.footer-menu li[data-v-06aec038]{margin:7px 0;line-height:1.4}.ct-footer .menu-col ul.footer-menu li[data-v-06aec038]:first-child{margin:0 0 5px}.ct-footer .menu-col ul.footer-menu li a[data-v-06aec038]{color:#e3e3e3;font-size:16px;display:inline-block}.ct-footer .menu-col ul.footer-menu li a[data-v-06aec038]:focus,.ct-footer .menu-col ul.footer-menu li a[data-v-06aec038]:hover{color:#fff}.ct-footer .menu-col ul.footer-menu.disclaimer[data-v-06aec038]{margin-top:25px}.ct-footer .menu-col ul.footer-menu.disclaimer li a[data-v-06aec038]{color:#b4a8fb}.ct-footer .menu-col ul.footer-menu.disclaimer li a[data-v-06aec038]:focus,.ct-footer .menu-col ul.footer-menu.disclaimer li a[data-v-06aec038]:hover{color:#222}.ct-footer .footer-legal[data-v-06aec038]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ct-footer .footer-legal .legal-icon[data-v-06aec038]{display:block}.ct-footer .footer-legal .legal-icon[data-v-06aec038]:first-child{margin-bottom:80px}.ct-footer .footer-legal .legal-icon img[data-v-06aec038]{max-height:75px;max-width:145px}.ct-footer .info hr[data-v-06aec038]{border:none;height:1px;background:#6454c1}.ct-footer .info p[data-v-06aec038]{color:#b4a8fb;margin:0}.legal-icon[data-v-06aec038]{margin-bottom:20px;display:inline-block}.copyright[data-v-06aec038]{color:#fff;font-size:14px;position:relative;bottom:0;margin:15px 0 5px}@media (min-width:992px){.copyright[data-v-06aec038]{width:35%;float:left;margin:0}}.copyright-nt[data-v-06aec038]{color:#fff;font-size:14px;position:relative;bottom:0;margin:0}@media (min-width:992px){.copyright-nt[data-v-06aec038]{width:51%;float:left;text-align:right}}.footer-menu[data-v-06aec038]{display:none;padding-top:13px}@media (min-width:992px){.footer-menu[data-v-06aec038]{display:block;padding-top:0}}.footer-menu-open[data-v-06aec038]{display:block}.footer-mnu[data-v-06aec038]{border-bottom:1px solid #5d5d5d;padding:17px 0 8px}@media (min-width:992px){.footer-mnu[data-v-06aec038]{border-bottom:none;padding:0}}.menu-header[data-v-06aec038]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:0;pointer-events:auto}@media (min-width:992px){.menu-header[data-v-06aec038]{pointer-events:none;margin-bottom:10px}}.menu-header img[data-v-06aec038]{vertical-align:middle;display:block;width:15px}@media (min-width:992px){.menu-header img[data-v-06aec038]{display:none}}.img-rotate[data-v-06aec038]{transform:rotate(0deg);transition:.3s}.img-rotate2[data-v-06aec038]{transform:rotate(180deg);transition:.3s}.footer-icons[data-v-06aec038]{margin-top:13px}@media (max-width:767px){.footer-icons[data-v-06aec038]{display:flex;flex-wrap:wrap;justify-content:space-between;align-items:center}}@media (min-width:992px){.footer-icons[data-v-06aec038]{margin-top:0;margin-right:-12px}}@media (min-width:768px){.footer-icons span[data-v-06aec038]{margin-right:20px}}.footer-icons span img[data-v-06aec038]{width:78px}@media (min-width:375px){.footer-icons span img[data-v-06aec038]{width:85px}}@media (min-width:425px){.footer-icons span img[data-v-06aec038]{width:97px}}@media (min-width:768px){.footer-icons span img[data-v-06aec038]{width:78px}}.social-icons[data-v-06aec038]{display:flex;flex-wrap:wrap;justify-content:flex-end}@media (max-width:992px){.social-icons[data-v-06aec038]{justify-content:space-evenly;padding:15px 0;border-top:1px solid #5d5d5d;border-bottom:1px solid #5d5d5d;margin-bottom:15px}}@media (min-width:992px){.social-icons[data-v-06aec038]{width:14%;float:left}}.social-icons p[data-v-06aec038]{display:flex;flex-wrap:wrap;width:18px;height:18px;margin-left:13px;margin-bottom:3px}@media (max-width:992px){.social-icons p[data-v-06aec038]{width:24px;height:24px}}.social-icons p img[data-v-06aec038]{width:18px;height:18px}@media (max-width:992px){.social-icons p img[data-v-06aec038]{width:24px;height:24px}}.router-link-active[data-v-06aec038]{color:#e3e3e3!important}.grayscale-invert[data-v-06aec038]{filter:grayscale(1) invert(1);-webkit-filter:grayscale(1) invert(1)}.security-section[data-v-06aec038]{padding-top:17px}@media (min-width:992px){.security-section[data-v-06aec038]{padding-top:0}}.ace-imgs[data-v-06aec038]{display:flex}@media (max-width:992px){.ace-imgs[data-v-06aec038]{justify-content:center;padding:10px 0}}.ace-imgs svg[data-v-06aec038]{width:20px;height:25px;margin-right:25px;fill:#e3e3e3}.fill-gray svg[data-v-06aec038]{fill:#222}.ptf-20[data-v-06aec038]{padding-top:20px!important}.mob-foot-show[data-v-06aec038]{display:block;text-align:center}@media (min-width:992px){.mob-foot-show[data-v-06aec038]{display:none}}.desk-foot-show[data-v-06aec038]{display:none}@media (min-width:992px){.desk-foot-show[data-v-06aec038]{display:block}}@media (min-width:992px){.overlap-width[data-v-06aec038]{width:31%!important;display:flex}}@media (max-width:992px){.fix-wrap-mobile-css[data-v-06aec038]{text-align:center;float:left}}.mob-foot-show .copyright-nt[data-v-06aec038]{padding-top:20px}", ""]);

// exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(713);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3f52c9a6", content, true, {});

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".disclaimer{padding-top:20px}.disclaimer p{font-size:12px;color:#f0f0f0}.disclaimer p:last-child{margin-bottom:0}", ""]);

// exports


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slideUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slideDown; });
var defaults = {
  duration: 400,
  easing: function easing(currentTime, startValue, diffValue, dureation) {
    return -diffValue * (currentTime /= dureation) * (currentTime - 2) + startValue;
  }
};
var directions = {
  OPEN: 1,
  CLOSE: 2
};

var animate = function animate(element, options, now) {
  if (!options.startTime) {
    options.startTime = now;
  }

  var currentTime = now - options.startTime;
  var animationContinue = currentTime < options.duration;
  var newHeight = options.easing(currentTime, options.startingHeight, options.distanceHeight, options.duration);

  if (animationContinue) {
    element.style.height = "".concat(newHeight.toFixed(2), "px");
    window.requestAnimationFrame(function (timestamp) {
      return animate(element, options, timestamp);
    });
  } else {
    if (options.direction === directions.CLOSE) {
      element.style.display = 'none';
    }

    if (options.direction === directions.OPEN) {
      element.style.display = 'block';
    }

    removeElementAnimationStyles(element);
  }
};

var setElementAnimationStyles = function setElementAnimationStyles(element) {
  element.style.display = 'block';
  element.style.overflow = 'hidden';
  element.style.marginTop = '0';
  element.style.marginBottom = '0';
  element.style.paddingTop = '0';
  element.style.paddingBottom = '0';
};

var removeElementAnimationStyles = function removeElementAnimationStyles(element) {
  element.style.height = null;
  element.style.overflow = null;
  element.style.marginTop = null;
  element.style.marginBottom = null;
  element.style.paddingTop = null;
  element.style.paddingBottom = null;
};

var isInteger = function isInteger(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  } else {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  }
};

var extend = function extend(defaults, options) {
  var extendedOptions = {};

  for (var key in defaults) {
    extendedOptions[key] = options[key] || defaults[key];
  }

  return extendedOptions;
};

var slideUp = function slideUp(element) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isInteger(args)) {
    args = {
      duration: args
    };
  }

  var options = extend(defaults, args);
  options.direction = directions.CLOSE;
  options.to = 0;
  options.startingHeight = element.scrollHeight;
  options.distanceHeight = -options.startingHeight;
  setElementAnimationStyles(element);
  window.requestAnimationFrame(function (timestamp) {
    return animate(element, options, timestamp);
  });
};

var slideDown = function slideDown(element) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isInteger(args)) {
    args = {
      duration: args
    };
  }

  element.style.height = '0px';
  setElementAnimationStyles(element);
  var options = extend(defaults, args);
  options.direction = directions.OPEN;
  options.to = element.scrollHeight;
  options.startingHeight = 0;
  options.distanceHeight = options.to;
  window.requestAnimationFrame(function (timestamp) {
    return animate(element, options, timestamp);
  });
};



/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"ct-footer"},[_c('div',{staticClass:"ct-footer-top",style:({ backgroundColor: _vm.$root.color_schema.footer_bg })},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-md-6 col-sm-12"},[(_vm.footerComponent.footerMenuTitle1)?_c('nav',{staticClass:"menu-col footer-mnu"},[_c('div',{staticClass:"menu-header",on:{"click":function($event){return _vm.expandFooterMenu(0)}}},[(_vm.footerComponent.footerMenuTitle1)?_c('span',{class:{
                  'custom-font-1 span-h4': true,
                  'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                  'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                }},[_vm._v("\n                "+_vm._s(_vm.footerComponent.footerMenuTitle1)+"\n              ")]):_vm._e(),_vm._v(" "),_c('img',{class:{
                  'arrow-img img-rotate': true,
                  'grayscale-invert': _vm.getContrastYIQ(
                    _vm.$root.color_schema.footer_bg
                  ),
                },attrs:{"id":"footer-icon-0","width":"15","height":"10","src":_vm.$root.site_url +
                  _vm.$root.asset_path +
                  '/svg-icons/footer-arrow.svg',"alt":"Arrow Icon"}})]),_vm._v(" "),_c('ul',{staticClass:"footer-menu two-columns",attrs:{"id":"footer-content-0"}},[(
                  _vm.footerComponent.footerMenu1 &&
                  _vm.footerComponent.footerMenu1.length > 0
                )?[_vm._l((_vm.footerComponent.footerMenu1.slice(
                    0,
                    _vm.footerComponent.footerMenuOffset1
                  )),function(data){return _c('li',{key:data.ID,class:{
                    'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                    'text-light': !_vm.getContrastYIQ(
                      _vm.$root.color_schema.footer_bg
                    ),
                  }},[(_vm.$root.enable_piwik_reload)?[(data.object === 'custom')?_c('a',{attrs:{"title":data.title,"href":data.url}},[_vm._v(_vm._s(data.title))]):_c('a',{staticClass:"cat-cls",attrs:{"title":data.title,"href":_vm.getRouteLink(data.slug, data.object)}},[_vm._v(_vm._s(data.title))])]:[(data.object === 'custom')?_c('a',{attrs:{"title":data.title,"href":data.url}},[_vm._v(_vm._s(data.title))]):_c('router-link',{staticClass:"cat-cls",attrs:{"title":data.title,"to":_vm.getRouteLink(data.slug, data.object)}},[_vm._v(_vm._s(data.title))])]],2)}),_vm._v(" "),(
                    _vm.footerComponent.footerMenu1.length >
                    _vm.footerComponent.footerMenuOffset1
                  )?_c('li',{class:{
                    'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                    'text-light': !_vm.getContrastYIQ(
                      _vm.$root.color_schema.footer_bg
                    ),
                  }},[_c('a',{attrs:{"title":"footer menu","href":_vm.footerComponent.footerMenuLink1}},[_vm._v(_vm._s(_vm.footerComponent.footerMenuText1))])]):_vm._e()]:_vm._e()],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-12"},[(_vm.footerComponent.footerMenuTitle2)?_c('nav',{staticClass:"menu-col footer-mnu"},[_c('div',{staticClass:"menu-header",on:{"click":function($event){return _vm.expandFooterMenu(1)}}},[(_vm.footerComponent.footerMenuTitle2)?_c('span',{class:{
                  'custom-font-1 span-h4': true,
                  'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                  'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                }},[_vm._v("\n                "+_vm._s(_vm.footerComponent.footerMenuTitle2)+"\n              ")]):_vm._e(),_vm._v(" "),_c('img',{class:{
                  'arrow-img img-rotate': true,
                  'grayscale-invert': _vm.getContrastYIQ(
                    _vm.$root.color_schema.footer_bg
                  ),
                },attrs:{"width":"15","height":"10","id":"footer-icon-1","src":_vm.$root.site_url +
                  _vm.$root.asset_path +
                  '/svg-icons/footer-arrow.svg',"alt":"Arrow Icon"}})]),_vm._v(" "),_c('ul',{staticClass:"footer-menu",attrs:{"id":"footer-content-1"}},[(
                  _vm.footerComponent.footerMenu2 &&
                  _vm.footerComponent.footerMenu2.length > 0
                )?[_vm._l((_vm.footerComponent.footerMenu2.slice(
                    0,
                    _vm.footerComponent.footerMenuOffset2
                  )),function(data){return _c('li',{key:data.ID,class:{
                    'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                    'text-light': !_vm.getContrastYIQ(
                      _vm.$root.color_schema.footer_bg
                    ),
                  }},[(_vm.$root.enable_piwik_reload)?[(data.object === 'custom')?_c('a',{attrs:{"title":data.title,"href":data.url}},[_vm._v(_vm._s(data.title))]):_c('a',{staticClass:"cat-cls",attrs:{"title":data.title,"href":_vm.getRouteLink(data.slug, data.object)}},[_vm._v(_vm._s(data.title))])]:[(data.object === 'custom')?_c('a',{attrs:{"title":data.title,"href":data.url}},[_vm._v(_vm._s(data.title))]):_c('router-link',{staticClass:"cat-cls",attrs:{"title":data.title,"to":_vm.getRouteLink(data.slug, data.object)}},[_vm._v(_vm._s(data.title))])]],2)}),_vm._v(" "),(
                    _vm.footerComponent.footerMenu2.length >
                    _vm.footerComponent.footerMenuOffset2
                  )?_c('li',{class:{
                    'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                    'text-light': !_vm.getContrastYIQ(
                      _vm.$root.color_schema.footer_bg
                    ),
                  }},[_c('a',{attrs:{"title":"footer menu 2","href":_vm.footerComponent.footerMenuLink2}},[_vm._v(_vm._s(_vm.footerComponent.footerMenuText2))])]):_vm._e()]:_vm._e()],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-12"},[(_vm.footerComponent.footerMenuTitle3)?_c('nav',{staticClass:"menu-col footer-mnu"},[_c('div',{staticClass:"menu-header",on:{"click":function($event){return _vm.expandFooterMenu(2)}}},[(_vm.footerComponent.footerMenuTitle3)?_c('span',{class:{
                  'custom-font-1 span-h4': true,
                  'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                  'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                }},[_vm._v("\n                "+_vm._s(_vm.footerComponent.footerMenuTitle3)+"\n              ")]):_vm._e(),_vm._v(" "),_c('img',{class:{
                  'arrow-img img-rotate': true,
                  'grayscale-invert': _vm.getContrastYIQ(
                    _vm.$root.color_schema.footer_bg
                  ),
                },attrs:{"width":"15","height":"10","id":"footer-icon-2","src":_vm.$root.site_url +
                  _vm.$root.asset_path +
                  '/svg-icons/footer-arrow.svg',"alt":"Arrow Icon"}})]),_vm._v(" "),_c('ul',{staticClass:"footer-menu",attrs:{"id":"footer-content-2"}},[(
                  _vm.footerComponent.footerMenu3 &&
                  _vm.footerComponent.footerMenu3.length > 0
                )?[_vm._l((_vm.footerComponent.footerMenu3.slice(
                    0,
                    _vm.footerComponent.footerMenuOffset3
                  )),function(data){return _c('li',{key:data.ID,class:{
                    'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                    'text-light': !_vm.getContrastYIQ(
                      _vm.$root.color_schema.footer_bg
                    ),
                  }},[(_vm.$root.enable_piwik_reload)?[(data.object === 'custom')?_c('a',{attrs:{"title":data.title,"href":data.url}},[_vm._v(_vm._s(data.title))]):_c('a',{staticClass:"cat-cls",attrs:{"title":data.title,"href":_vm.getRouteLink(data.slug, data.object)}},[_vm._v(_vm._s(data.title))])]:[(data.object === 'custom')?_c('a',{attrs:{"title":data.title,"href":data.url}},[_vm._v(_vm._s(data.title))]):_c('router-link',{staticClass:"cat-cls",attrs:{"title":data.title,"to":_vm.getRouteLink(data.slug, data.object)}},[_vm._v(_vm._s(data.title))])]],2)}),_vm._v(" "),(
                    _vm.footerComponent.footerMenu3.length >
                    _vm.footerComponent.footerMenuOffset3
                  )?_c('li',{class:{
                    'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                    'text-light': !_vm.getContrastYIQ(
                      _vm.$root.color_schema.footer_bg
                    ),
                  }},[_c('a',{attrs:{"title":"footer menu 2","href":_vm.footerComponent.footerMenuLink3}},[_vm._v(_vm._s(_vm.footerComponent.footerMenuText3))])]):_vm._e()]:_vm._e()],2)]):_vm._e()]),_vm._v(" "),(
            _vm.footerComponent.securityImages &&
            _vm.footerComponent.securityImages.length > 0
          )?_c('div',{class:{
            'overlap-width': true,
            'col-lg-3 col-md-3 col-sm-12': true,
            'fix-wrap-mobile-css': true,
          }},[_c('nav',{staticClass:"menu-col footer-mnu security-section"},[_c('div',{staticClass:"menu-header"},[_c('span',{class:{
                  'custom-font-1 span-h4': true,
                  'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                  'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                }},[_vm._v("\n                "+_vm._s(_vm.$root.i18n.security)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"footer-icons"},_vm._l((_vm.footerComponent.securityImages),function(imgData,index){return _c('span',{key:index},[(
                    imgData.link && imgData.link != '' && imgData.link != ' '
                  )?_c('a',{attrs:{"title":imgData.tooltip ? imgData.tooltip : _vm.getAltText(imgData.alt_text, imgData.image),"href":imgData.link,"target":"_blank","rel":imgData.rel}},[_c('img',{class:{
                      'legal-icon': true,
                      'grayscale-invert': _vm.getContrastYIQ(
                        _vm.$root.color_schema.footer_bg
                      ),
                    },attrs:{"width":"78","height":"32","src":imgData.image,"alt":_vm.getAltText(imgData.alt_text, imgData.image)}})]):_c('img',{class:{
                    'legal-icon': true,
                    'grayscale-invert': _vm.getContrastYIQ(
                      _vm.$root.color_schema.footer_bg
                    ),
                  },attrs:{"width":"78","height":"32","src":imgData.image,"alt":("security image " + (index + 1))}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mob-foot-show"},[(
                _vm.footerComponent.socialIcons &&
                Object.keys(_vm.footerComponent.socialIcons).length > 0
              )?_c('div',{staticClass:"social-icons"},[_vm._l((_vm.footerComponent.socialIcons),function(iconData,index){return [_c('p',{key:index},[(
                      iconData.link &&
                      iconData.link != '' &&
                      iconData.link != ' '
                    )?_c('a',{attrs:{"title":("social image " + (index + 1)),"href":iconData.link,"target":"_blank","rel":iconData.rel}},[_c('img',{class:{
                        'grayscale-invert': _vm.getContrastYIQ(
                          _vm.$root.color_schema.footer_bg
                        ),
                      },attrs:{"width":"18","height":"18","src":iconData.icon,"alt":("social image " + (index + 1))}})]):_c('img',{class:{
                      'grayscale-invert': _vm.getContrastYIQ(
                        _vm.$root.color_schema.footer_bg
                      ),
                    },attrs:{"width":"18","height":"18","src":iconData.icon,"alt":("social image " + (index + 1))}})])]})],2):_vm._e(),_vm._v(" "),(_vm.footerComponent.disclaimer)?_c('div',{staticClass:"disclaimer",domProps:{"innerHTML":_vm._s(_vm.footerComponent.disclaimer)}}):_vm._e(),_vm._v(" "),(_vm.footerComponent.footer_text2)?_c('p',{class:{
                'copyright-nt custom-font-2': true,
                'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
              },domProps:{"innerHTML":_vm._s(_vm.footerComponent.footer_text2)}}):_vm._e(),_vm._v(" "),(_vm.footerComponent.copyright_text)?_c('p',{class:{
                'copyright custom-font-2': true,
                'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
                'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
              },domProps:{"innerHTML":_vm._s(_vm.footerComponent.copyright_text)}}):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.footerComponent.disclaimer)?_c('div',{staticClass:"col-xs-12 desk-foot-show"},[_c('div',{staticClass:"disclaimer",domProps:{"innerHTML":_vm._s(_vm.footerComponent.disclaimer)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-12 ptf-20 desk-foot-show"},[(_vm.footerComponent.copyright_text)?_c('p',{class:{
              'copyright custom-font-2': true,
              'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
              'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
            },domProps:{"innerHTML":_vm._s(_vm.footerComponent.copyright_text)}}):_vm._e(),_vm._v(" "),(_vm.footerComponent.footer_text2)?_c('p',{class:{
              'copyright-nt custom-font-2': true,
              'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
              'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
            },domProps:{"innerHTML":_vm._s(_vm.footerComponent.footer_text2)}}):_c('span',{class:{
              'copyright-nt custom-font-2': true,
              'text-gray': _vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
              'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
            }},[_vm._v(" ")]),_vm._v(" "),(
              _vm.footerComponent.socialIcons &&
              Object.keys(_vm.footerComponent.socialIcons).length > 0
            )?_c('div',{staticClass:"social-icons"},[_vm._l((_vm.footerComponent.socialIcons),function(iconData,index){return [_c('p',{key:index},[(
                    iconData.link &&
                    iconData.link != '' &&
                    iconData.link != ' '
                  )?_c('a',{attrs:{"title":("social image " + (index + 1)),"href":iconData.link,"target":"_blank","rel":iconData.rel}},[_c('img',{class:{
                      'grayscale-invert': _vm.getContrastYIQ(
                        _vm.$root.color_schema.footer_bg
                      ),
                    },attrs:{"width":"18","height":"18","src":iconData.icon,"alt":("social image " + (index + 1))}})]):_c('img',{class:{
                    'grayscale-invert': _vm.getContrastYIQ(
                      _vm.$root.color_schema.footer_bg
                    ),
                  },attrs:{"width":"18","height":"18","src":iconData.icon,"alt":("social image " + (index + 1))}})])]})],2):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoaderSpinner_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_576af1e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoaderSpinner_vue__ = __webpack_require__(719);
function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-576af1e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoaderSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_576af1e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoaderSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(718);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f56c4ed6", content, true, {});

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-576af1e6]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-576af1e6]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-576af1e6]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-576af1e6]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-576af1e6]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-576af1e6]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-576af1e6]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-576af1e6]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-576af1e6]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-576af1e6]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-576af1e6]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-576af1e6]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.loader-wrapper[data-v-576af1e6]{position:fixed;z-index:999999;top:0;left:0;height:100vh;width:100vw;min-height:360px;background:#070438;display:flex;flex-direction:column;justify-content:center;align-items:center}.loader-wrapper h3[data-v-576af1e6]{color:#fff;text-align:center}.loader[data-v-576af1e6]{border-radius:50%;color:#fff;font-size:11px;text-indent:-99999em;margin:55px auto;position:relative;width:10em;height:10em;box-shadow:inset 0 0 0 1em;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0)}.loader[data-v-576af1e6]:after,.loader[data-v-576af1e6]:before{border-radius:50%;position:absolute;content:\"\"}.loader[data-v-576af1e6]:before{width:5.2em;height:10.2em;background:var(--primary-color);border-radius:10.2em 0 0 10.2em;top:-.1em;left:-.1em;-webkit-transform-origin:5.1em 5.1em;transform-origin:5.1em 5.1em;-webkit-animation:load2-data-v-576af1e6 2s infinite ease 1.5s;animation:load2-data-v-576af1e6 2s infinite ease 1.5s}.loader[data-v-576af1e6]:after{width:5.3em;height:10.2em;background:var(--primary-color);border-radius:0 10.2em 10.2em 0;top:-.1em;left:4.9em;-webkit-transform-origin:.1em 5.1em;transform-origin:.1em 5.1em;-webkit-animation:load2-data-v-576af1e6 2s infinite ease;animation:load2-data-v-576af1e6 2s infinite ease}@-webkit-keyframes load2-data-v-576af1e6{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes load2-data-v-576af1e6{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.img-container[data-v-576af1e6]{width:100px;height:auto;position:relative;margin-bottom:15px;overflow:hidden}.bottom[data-v-576af1e6]{filter:brightness(0) invert(1)}.top-img-holder[data-v-576af1e6]{position:absolute;bottom:0;left:0;height:100%;width:100%}.top[data-v-576af1e6]{position:absolute;width:100px;height:50px;object-fit:cover;object-position:bottom;bottom:0;animation:loading-data-v-576af1e6 6s infinite linear}@keyframes loading-data-v-576af1e6{0%{height:0}90%{height:100%;opacity:1}to{height:100%;opacity:0}}", ""]);

// exports


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"loader-wrapper",style:({ background: _vm.$root.color_schema.primary })},[(_vm.$root.custom_loader && _vm.$root.custom_loader != '')?[_c('div',{staticClass:"img-container"},[_c('img',{staticClass:"bottom",attrs:{"src":_vm.$root.custom_loader,"width":"100"}}),_vm._v(" "),_c('div',{staticClass:"top-img-holder"},[_c('img',{staticClass:"top",attrs:{"src":_vm.$root.custom_loader,"width":"100"}})])])]:[_c('div',{staticClass:"loader",style:({ '--primary-color': _vm.$root.color_schema.primary })},[_vm._v("\n      "+_vm._s(_vm.$root.i18n.loading)+"...\n    ")])],_vm._v(" "),_c('h3',{staticClass:"custom-font-1"},[_vm._v(_vm._s(_vm.$root.i18n.loading)+"...")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPanelBar_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4654761a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPanelBar_vue__ = __webpack_require__(723);
function injectStyle (ssrContext) {
  __webpack_require__(721)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4654761a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPanelBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4654761a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPanelBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(722);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1a19b002", content, true, {});

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-4654761a]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-4654761a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-4654761a]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-4654761a]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-4654761a]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-4654761a]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-4654761a]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-4654761a]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-4654761a]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-4654761a]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-4654761a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-4654761a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.panel-wrapper[data-v-4654761a]{display:none;justify-content:space-between;padding:0 .75rem;background-color:#000;position:sticky;top:0;z-index:1000}.panel-wrapper .login-info[data-v-4654761a]{padding:0 7px}.panel-wrapper .login-info a[data-v-4654761a]{font-size:12px;color:#fff!important}.panel-wrapper .login-info[data-v-4654761a]:hover{background-color:#222}.panel-wrapper .login-info:hover a[data-v-4654761a]{color:#0ff!important}@media (min-width:768px){.panel-wrapper[data-v-4654761a]{display:flex}}.panel-links[data-v-4654761a]{padding:0 7px}.panel-links a[data-v-4654761a]{font-size:12px;color:#fff!important}.panel-links[data-v-4654761a]:hover{background-color:#222}.panel-links:hover a[data-v-4654761a]{color:#0ff!important}", ""]);

// exports


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.adminBarData)?_c('div',{staticClass:"panel-wrapper",attrs:{"id":"panel-wrapper"}},[_vm._l((_vm.adminBarData.items),function(data,index){return _c('div',{key:index,staticClass:"panel-links"},[_c('a',{attrs:{"title":data.label,"href":data.link,"target":"_blank"}},[_vm._v(_vm._s(data.label))])])}),_vm._v(" "),_c('div',{staticClass:"login-info"},[_c('a',{attrs:{"title":_vm.adminBarData.account,"href":_vm.adminBarData.account_link,"target":"_blank"}},[_vm._v(_vm._s(_vm.adminBarData.account))])])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsletter_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28ac571a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newsletter_vue__ = __webpack_require__(727);
function injectStyle (ssrContext) {
  __webpack_require__(725)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28ac571a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsletter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28ac571a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newsletter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(726);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2936fdcb", content, true, {});

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".display-flex[data-v-28ac571a]{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-flow[data-v-28ac571a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.align-items-flex-end[data-v-28ac571a]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.align-items-flex-start[data-v-28ac571a]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.justify-content-space-between[data-v-28ac571a]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.justify-content-center[data-v-28ac571a]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-content-flex-start[data-v-28ac571a]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-content-space-evenly[data-v-28ac571a]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.justify-content-space-around[data-v-28ac571a]{-ms-flex-pack:distribute;justify-content:space-around}.display-inline-flex[data-v-28ac571a]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.flex-direction-row[data-v-28ac571a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-direction-column[data-v-28ac571a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.sticky-newsletter[data-v-28ac571a]{position:fixed;right:0;bottom:50%;-webkit-transform:translateY(50%);transform:translateY(50%);z-index:11}@media (max-width:1024px){.sticky-newsletter[data-v-28ac571a]{left:0}}.sticky-newsletter__button[data-v-28ac571a]{background-color:var(--primary-btn);color:#fff;right:0;position:absolute;border-radius:5px 0 0 5px;display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:10px;gap:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;bottom:50%;padding:10px;cursor:pointer}@media (min-width:1024px){.sticky-newsletter__button[data-v-28ac571a]{-webkit-transform:rotate(270deg);transform:rotate(270deg);right:-47px;border-radius:5px 5px 0 0;bottom:50%;margin-bottom:-22px;padding:10px 15px}}.sticky-newsletter-checkbox:checked~.sticky-newsletter .sticky-newsletter__button[data-v-28ac571a]{bottom:50%;margin-bottom:-22px;right:unset;left:450px;-webkit-animation:buttonSlideIn-data-v-28ac571a .25s forwards;animation:buttonSlideIn-data-v-28ac571a .25s forwards}.sticky-newsletter__sign-up[data-v-28ac571a]{padding:25px 15px;width:100%;border-radius:5px;-webkit-transform:translateX(100%);transform:translateX(100%);display:none;position:relative;z-index:1}.sticky-newsletter__sign-up[data-v-28ac571a]:after{position:absolute;content:\"\";left:0;top:0;height:100%;width:100%;background:rgba(0,0,0,.25);z-index:-2}.sticky-newsletter__sign-up.is-submitted[data-v-28ac571a]{padding-top:50px}@media (min-width:1024px){.sticky-newsletter__sign-up[data-v-28ac571a]{width:520px;padding:25px 40px}}.sticky-newsletter-checkbox:checked~.sticky-newsletter .sticky-newsletter__sign-up[data-v-28ac571a]{-webkit-animation:boxSlideIn-data-v-28ac571a .25s forwards;animation:boxSlideIn-data-v-28ac571a .25s forwards;display:block}.sticky-newsletter__close[data-v-28ac571a]{position:absolute;right:20px;top:10px;color:#fff;cursor:pointer}.sticky-newsletter__title[data-v-28ac571a]{color:#fff;font-size:30px;line-height:30px;margin-bottom:15px;display:block;font-weight:700}.sticky-newsletter__text[data-v-28ac571a]{font-size:16px;color:#fff}.sticky-newsletter__form[data-v-28ac571a]{padding:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;border-radius:5px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:1024px){.sticky-newsletter__form[data-v-28ac571a]{background-color:#fff;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin-bottom:20px}}.sticky-newsletter__form input[data-v-28ac571a]{width:100%}@media (min-width:1024px){.sticky-newsletter__form input[data-v-28ac571a]{padding:0}.sticky-newsletter__form .email[data-v-28ac571a]{width:300px}}.sticky-newsletter__checkbox[data-v-28ac571a]{color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;grid-gap:10px;gap:10px;margin:15px 0;font-size:12px}@media (min-width:1024px){.sticky-newsletter__checkbox[data-v-28ac571a]{position:absolute;bottom:0}}.sticky-newsletter__form input[data-v-28ac571a]{border:transparent;padding:20px;border-radius:5px}@media (min-width:1024px){.sticky-newsletter__form input[data-v-28ac571a]{padding:0}}.sticky-newsletter__checkbox label[data-v-28ac571a]{margin:0}.sticky-newsletter__form .submit[data-v-28ac571a]{cursor:pointer;padding:10px 15px;border:0;border-radius:5px;font-weight:700;background-color:#ffd03a}.sticky-newsletter__overlay[data-v-28ac571a]{position:fixed;width:100%;height:100%;background:rgba(0,0,0,.8);display:none;z-index:1;top:0;left:0}.sticky-newsletter-checkbox:checked~.sticky-newsletter__overlay[data-v-28ac571a]{display:block}@-webkit-keyframes buttonSlideIn-data-v-28ac571a{to{left:-86px}}@keyframes buttonSlideIn-data-v-28ac571a{to{left:-86px}}@-webkit-keyframes boxSlideIn-data-v-28ac571a{to{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes boxSlideIn-data-v-28ac571a{to{-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes boxSlideOut-data-v-28ac571a{to{-webkit-transform:translateX(100%);transform:translateX(100%)}}@keyframes boxSlideOut-data-v-28ac571a{to{-webkit-transform:translateX(100%);transform:translateX(100%)}}.sticky-newsletter__sign-up[data-v-28ac571a]{padding-bottom:60px}.sticky-newsletter__form .email-wrapper[data-v-28ac571a]{display:flex;align-items:center;width:100%;border-radius:5px;background:#fff;padding:0 10px;flex-grow:1}@media (min-width:1024px){.sticky-newsletter__form .email-wrapper[data-v-28ac571a]{background:transparent;padding:0}}.sticky-newsletter__form .submit[data-v-28ac571a]{margin:0;min-height:38px;max-width:100%;text-align:center;font-size:16px}@media (min-width:1024px){.sticky-newsletter__form .submit[data-v-28ac571a]{max-width:120px}}.sticky-newsletter__form input[data-v-28ac571a]{margin-left:10px}.sticky-newsletter__checkbox[data-v-28ac571a]{flex-direction:column;align-items:flex-start;grid-gap:0;gap:0}.sticky-newsletter__button-text[data-v-28ac571a]{display:none}@media (min-width:1024px){.sticky-newsletter__button-text[data-v-28ac571a]{display:inline-block}}.sticky-newsletter__form .email-error[data-v-28ac571a]{position:absolute;top:-58px;left:38px;width:auto;white-space:nowrap}.sticky-newsletter__checkbox .checkbox-error[data-v-28ac571a]{position:absolute;top:24px;z-index:1}.sticky-newsletter__checkbox .checkbox-error-two[data-v-28ac571a]{position:absolute;top:30px;z-index:1}.email-chk-outer[data-v-28ac571a]{display:flex;align-items:center;flex-grow:1}.ct-newsletter[data-v-28ac571a]{padding:0;margin:0;position:absolute;z-index:1001}.ct-newsletter-wrapper[data-v-28ac571a]{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;color:#fff;padding:50px 5px 38px;box-shadow:0 4px 4px rgba(0,0,0,.25);background-size:cover}.ct-newsletter-image[data-v-28ac571a]{text-align:center}.ct-newsletter-image svg[data-v-28ac571a]{width:48px;height:45px}.ct-newsletter-content[data-v-28ac571a]{color:#fff;text-align:center;max-width:350px;margin:0 auto}.ct-newsletter-content h2[data-v-28ac571a],.ct-newsletter-content p[data-v-28ac571a]{color:#fff}.ct-newsletter-form[data-v-28ac571a]{display:flex;flex-direction:column;text-align:left}.ct-newsletter-form input[data-v-28ac571a]{margin:12px 0}.ct-newsletter-form .checkbox[data-v-28ac571a]{-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;border:none}.ct-newsletter-form input[type=email][data-v-28ac571a]{border:none;padding:12px;text-indent:26px;display:inline-block;outline:none;width:100%}.ct-newsletter-form .email-wrapper[data-v-28ac571a]{position:relative}.ct-newsletter-form .email-wrapper svg[data-v-28ac571a]{height:18px;width:18px;fill:#797979;top:25px;left:12px;position:absolute}.ct-newsletter-form .custom-btn-sec[data-v-28ac571a]{padding:17px 18px}.ct-newsletter-form .custom-btn-sec[data-v-28ac571a]:hover{background-color:var(--primary-btn)!important;border-color:var(--primary-btn)!important}.checkbox-label[data-v-28ac571a]{position:relative;padding-left:25px;margin-top:10px}.checkbox-label .checkbox[data-v-28ac571a]{display:none}.checkbox-label[data-v-28ac571a]:before{content:\"\";position:absolute;left:0;top:0;width:18px;height:18px;transition:transform .28s ease;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;background-color:#fff}.checkbox-label-error[data-v-28ac571a]:before{border:2px solid var(--primary-btn)}.checkbox-label-selected[data-v-28ac571a]{position:relative;padding-left:25px;margin-top:10px}.checkbox-label-selected .checkbox[data-v-28ac571a]{display:none}.checkbox-label-selected[data-v-28ac571a]:before{content:\"\";position:absolute;left:0;top:0;width:18px;height:18px;transition:transform .28s ease;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;background-color:var(--primary-btn)}.checkbox-label-selected[data-v-28ac571a]:after{content:\"\";display:block;width:8px;height:4px;border-bottom:2px solid #fff;border-left:2px solid #fff;transition:transform .25s ease;position:absolute;top:4px;transform:rotate(-45deg) scale(1);left:4px}.checkbox-error[data-v-28ac571a]{text-align:center;width:auto;padding:5px;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;background:var(--primary-btn);color:#fff;position:relative;margin-bottom:8px;white-space:nowrap}.arrow-up[data-v-28ac571a]{border-bottom:10px solid var(--primary-btn);top:-6px}.arrow-down[data-v-28ac571a],.arrow-up[data-v-28ac571a]{width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;transform:translate(-50%);position:absolute;left:50%}.arrow-down[data-v-28ac571a]{border-top:10px solid var(--primary-btn);bottom:-8px}.email-error[data-v-28ac571a]{text-align:center;width:100%;padding:5px;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;background:var(--primary-btn);color:#fff;position:relative;margin-top:8px}.email-error-input[data-v-28ac571a]{border:1.4px solid var(--primary-btn)!important;color:var(--primary-btn)}.email-error-wrapper svg[data-v-28ac571a]{fill:var(--primary-btn)!important}.form-inner-wrapper[data-v-28ac571a]{width:90%;margin:0 auto;display:flex;flex-direction:column}.submission-spinner[data-v-28ac571a]{text-align:center;max-height:38px}.submission-spinner svg[data-v-28ac571a]{fill:var(--primary-btn)}", ""]);

// exports


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ct-newsletter"},[_c('input',{staticClass:"sticky-newsletter-checkbox",attrs:{"type":"checkbox","name":"sticky-newsletter-checkbox","id":"sticky-newsletter-checkbox","hidden":""}}),_vm._v(" "),_c('div',{staticClass:"sticky-newsletter__overlay"}),_vm._v(" "),_c('div',{staticClass:"sticky-newsletter",attrs:{"id":"sticky-newsletter"}},[_c('label',{staticClass:"sticky-newsletter__button",attrs:{"for":"sticky-newsletter-checkbox"}},[_c('svg',{attrs:{"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.258 8.119L20 13.078V2.95l-6.742 5.17zM0 2.95v10.128l6.742-4.96L0 2.95zM18.75 0H1.25C.625 0 .133.54.04 1.236L10 8.873l9.96-7.637C19.868.541 19.376 0 18.75 0zm-6.637 9l-1.77 1.354a.55.55 0 01-.343.119.578.578 0 01-.344-.119l-1.77-1.359L.04 14.773C.137 15.463.63 16 1.25 16h17.5c.621 0 1.113-.536 1.21-1.227L12.114 9z","fill":"#fff"}})]),_vm._v(" "),_c('span',{staticClass:"sticky-newsletter__button-text"},[_vm._v("Newsletter")])]),_vm._v(" "),_c('form',{class:{
          'sticky-newsletter__sign-up': true,
          'is-submitted': _vm.submitted
        },style:({ '--primary-btn': _vm.$root.color_schema.primary_btn, background: ("" + (_vm.$root.color_schema.primary))}),attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('label',{staticClass:"sticky-newsletter__close",attrs:{"for":"sticky-newsletter-checkbox"}},[_vm._v("X")]),_vm._v(" "),(!_vm.submitted)?_c('span',{staticClass:"sticky-newsletter__title"},[_vm._v(_vm._s(_vm.$root.i18n.sign_up_to_receive_updates))]):_vm._e(),_vm._v(" "),(!_vm.submitted)?_c('div',{staticClass:"sticky-newsletter__form"},[_c('div',{staticClass:"email-chk-outer",staticStyle:{"position":"relative"}},[(!_vm.validation.email)?_c('div',{staticClass:"email-error"},[_vm._v("\n                "+_vm._s(_vm.$root.i18n.this_must_be_a_valid_email_address)+"\n                "),_c('span',{staticClass:"arrow-down"})]):_vm._e(),_vm._v(" "),_c('label',{class:{
                'email-wrapper': true,
                'email-error-wrapper': !_vm.validation.email,
              },on:{"focus":function($event){_vm.validation.email = true}}},[_c('svg',{attrs:{"width":"20","height":"16","viewBox":"0 0 16 12"}},[_c('path',{attrs:{"d":"M8.45626 8.04793C8.30525 8.14393 8.13537 8.18233 7.98437 8.18233C7.83336 8.18233 7.66348 8.14393 7.51248 8.04793L0 3.38232V9.58393C0 10.9087 1.05703 11.9839 2.35945 11.9839H13.6282C14.9306 11.9839 15.9876 10.9087 15.9876 9.58393V3.38232L8.45626 8.04793Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M13.6283 0.00341797H2.35963C1.24597 0.00341797 0.302191 0.809818 0.0756836 1.88502L8.00343 6.80022L15.9123 1.88502C15.6858 0.809818 14.742 0.00341797 13.6283 0.00341797Z"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email",class:{ 'email-error-input': !_vm.validation.email },attrs:{"type":"email","name":"email","placeholder":_vm.$root.i18n.your_email},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"sticky-newsletter__checkbox"},[_c('div',{staticClass:"chk-outer",staticStyle:{"position":"relative"}},[_c('label',{class:{
                  'checkbox-label': !_vm.checkbox.checkbox1,
                  'checkbox-label-error':
                    !_vm.checkbox.checkbox1 && !_vm.validation.checkbox1,
                  'checkbox-label-selected': _vm.checkbox.checkbox1,
                }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkbox.checkbox1),expression:"checkbox.checkbox1"}],staticClass:"checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkbox.checkbox1)?_vm._i(_vm.checkbox.checkbox1,null)>-1:(_vm.checkbox.checkbox1)},on:{"change":function($event){var $$a=_vm.checkbox.checkbox1,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkbox, "checkbox1", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkbox, "checkbox1", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkbox, "checkbox1", $$c)}}}}),_vm._v("\n                "+_vm._s(_vm.$root.i18n.yes_i_would_like_to_receive_the_latest_news)+"\n              ")]),_vm._v(" "),(!_vm.validation.checkbox1 && !_vm.checkbox.checkbox1)?_c('div',{staticClass:"checkbox-error"},[_vm._v("\n                "+_vm._s(_vm.$root.i18n.you_must_check_this_box_to_register)+"\n                "),_c('span',{staticClass:"arrow-up"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"chk-outer",staticStyle:{"position":"relative"}},[_c('label',{class:{
                  'checkbox-label': !_vm.checkbox.checkbox2,
                  'checkbox-label-error':
                    !_vm.checkbox.checkbox2 && !_vm.validation.checkbox2,
                  'checkbox-label-selected': _vm.checkbox.checkbox2,
                }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkbox.checkbox2),expression:"checkbox.checkbox2"}],staticClass:"checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkbox.checkbox2)?_vm._i(_vm.checkbox.checkbox2,null)>-1:(_vm.checkbox.checkbox2)},on:{"change":function($event){var $$a=_vm.checkbox.checkbox2,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkbox, "checkbox2", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkbox, "checkbox2", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkbox, "checkbox2", $$c)}}}}),_vm._v("\n                "+_vm._s(_vm.$root.i18n.yes_i_am_over_18_years_old)+"\n              ")]),_vm._v(" "),(!_vm.validation.checkbox2 && !_vm.checkbox.checkbox2)?_c('div',{staticClass:"checkbox-error checkbox-error-two"},[_vm._v("\n                "+_vm._s(_vm.$root.i18n.you_must_check_this_box_to_register)+"\n                "),_c('span',{staticClass:"arrow-up"})]):_vm._e()])]),_vm._v(" "),(!_vm.submission)?_c('button',{staticClass:"submit cta cta-primary cta-block cta-promotion cta-gray custom-btn-sec text-white",style:({ '--primary-btn': _vm.$root.color_schema.primary_btn }),attrs:{"type":"submit","name":"submit"}},[_vm._v("\n            "+_vm._s(_vm.$root.i18n.send)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.submission)?_c('div',{staticClass:"submission-spinner"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{"version":"1.1","id":"loader-1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"40px","height":"40px","viewBox":"0 0 50 50","xml:space":"preserve"}},[_c('path',{attrs:{"d":"M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z","transform":"rotate(127.435 25 25)"}},[_c('animateTransform',{attrs:{"attributeType":"xml","attributeName":"transform","type":"rotate","from":"0 25 25","to":"360 25 25","dur":"0.6s","repeatCount":"indefinite"}})],1)])]):_vm._e()]):_c('div',{staticClass:"ct-newsletter-content"},[_c('h2',{staticClass:"custom-font-1"},[_vm._v(_vm._s(_vm.$root.i18n.thank_you))]),_vm._v(" "),_c('p',{staticClass:"custom-font-2",staticStyle:{"margin-bottom":"0"}},[_vm._v("\n            "+_vm._s(_vm.$root.i18n.you_are_signed_up_to_our_newsletter)+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$root.disable)?_c('AdminPanelBar',{attrs:{"adminBarData":_vm.$root.adminBarData}}):_vm._e(),_vm._v(" "),(_vm.$root.loading && _vm.$root.enable_loader)?_c('LoaderSpinner'):_vm._e(),_vm._v(" "),(_vm.pageSideImages && _vm.pageSideImages.size === 'large')?_c('a',{staticClass:"background-logo left-side background-logo-large",style:({
      backgroundImage: ("url(" + (_vm.pageSideImages.image) + ")"),
      backgroundColor: _vm.pageSideImages.background_color,
    }),attrs:{"href":_vm.pageSideImages.url,"target":"_blank","rel":"nofollow"}}):_vm._e(),_vm._v(" "),(_vm.pageSideImages && _vm.pageSideImages.size === 'large')?_c('a',{staticClass:"background-logo right-side background-logo-large",style:({
      backgroundImage: ("url(" + (_vm.pageSideImages.image) + ")"),
      backgroundColor: _vm.pageSideImages.background_color,
    }),attrs:{"href":_vm.pageSideImages.url,"target":"_blank","rel":"nofollow"}}):_vm._e(),_vm._v(" "),(_vm.pageSideImages && _vm.pageSideImages.size === 'small')?_c('div',{staticClass:"background-logo left-side background-logo-small"},[_c('a',{attrs:{"href":_vm.pageSideImages.url,"target":"_blank","rel":"nofollow"}},[_c('img',{attrs:{"src":_vm.pageSideImages.image}})])]):_vm._e(),_vm._v(" "),(_vm.pageSideImages && _vm.pageSideImages.size === 'small')?_c('div',{staticClass:"background-logo right-side background-logo-small"},[_c('a',{attrs:{"href":_vm.pageSideImages.url,"target":"_blank","rel":"nofollow"}},[_c('img',{attrs:{"src":_vm.pageSideImages.image}})])]):_vm._e(),_vm._v(" "),(
      _vm.headerComponent.regulationBanner &&
        _vm.headerComponent.menus &&
        _vm.headerComponent.logo
    )?[_c('Header',{attrs:{"headerComponent":_vm.headerComponent}})]:_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.$root.campaignmonitor.enable_newsletter)?[_c('Newsletter')]:_vm._e(),_vm._v(" "),(_vm.footerComponent && _vm.$root.show_footer && _vm.$root.body_loading_status)?[_c('Footer',{attrs:{"footerComponent":_vm.footerComponent}})]:_vm._e(),_vm._v(" "),_c('a',{staticClass:"to-top",attrs:{"id":"top-btn","title":"to-top"},on:{"click":_vm.scrollToTop}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 38 38"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M33,38H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h28c2.8,0,5,2.2,5,5v28C38,35.8,35.8,38,33,38z","fill":"#373737"}})]),_vm._v(" "),_c('polygon',{attrs:{"points":"19,14.5 22.6,19 26.2,23.5 19,23.5 11.8,23.5 15.4,19","fill":"#f5f5f5"}})])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * css-vars-ponyfill
 * v2.4.7
 * https://jhildenbiddle.github.io/css-vars-ponyfill/
 * (c) 2018-2021 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
function _extends() {
    _extends = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

/*!
 * get-css-data
 * v2.0.2
 * https://github.com/jhildenbiddle/get-css-data
 * (c) 2018-2021 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */ function getUrls(urls) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var settings = {
        mimeType: options.mimeType || null,
        onBeforeSend: options.onBeforeSend || Function.prototype,
        onSuccess: options.onSuccess || Function.prototype,
        onError: options.onError || Function.prototype,
        onComplete: options.onComplete || Function.prototype
    };
    var urlArray = Array.isArray(urls) ? urls : [ urls ];
    var urlQueue = Array.apply(null, Array(urlArray.length)).map((function(x) {
        return null;
    }));
    function isValidCss(text) {
        var isString = typeof text === "string";
        var isHTML = isString && text.trim().charAt(0) === "<";
        return isString && !isHTML;
    }
    function onError(xhr, urlIndex) {
        settings.onError(xhr, urlArray[urlIndex], urlIndex);
    }
    function onSuccess(responseText, urlIndex) {
        var returnVal = settings.onSuccess(responseText, urlArray[urlIndex], urlIndex);
        responseText = returnVal === false ? "" : returnVal || responseText;
        urlQueue[urlIndex] = responseText;
        if (urlQueue.indexOf(null) === -1) {
            settings.onComplete(urlQueue);
        }
    }
    var parser = document.createElement("a");
    urlArray.forEach((function(url, i) {
        parser.setAttribute("href", url);
        parser.href = String(parser.href);
        var isIElte9 = Boolean(document.all && !window.atob);
        var isIElte9CORS = isIElte9 && parser.host.split(":")[0] !== location.host.split(":")[0];
        if (isIElte9CORS) {
            var isSameProtocol = parser.protocol === location.protocol;
            if (isSameProtocol) {
                var xdr = new XDomainRequest;
                xdr.open("GET", url);
                xdr.timeout = 0;
                xdr.onprogress = Function.prototype;
                xdr.ontimeout = Function.prototype;
                xdr.onload = function() {
                    var text = xdr.responseText;
                    if (isValidCss(text)) {
                        onSuccess(text, i);
                    } else {
                        onError(xdr, i);
                    }
                };
                xdr.onerror = function(err) {
                    onError(xdr, i);
                };
                setTimeout((function() {
                    xdr.send();
                }), 0);
            } else {
                console.warn("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(url, ")"));
                onError(null, i);
            }
        } else {
            var xhr = new XMLHttpRequest;
            xhr.open("GET", url);
            if (settings.mimeType && xhr.overrideMimeType) {
                xhr.overrideMimeType(settings.mimeType);
            }
            settings.onBeforeSend(xhr, url, i);
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    var text = xhr.responseText;
                    if (xhr.status < 400 && isValidCss(text)) {
                        onSuccess(text, i);
                    } else if (xhr.status === 0 && isValidCss(text)) {
                        onSuccess(text, i);
                    } else {
                        onError(xhr, i);
                    }
                }
            };
            xhr.send();
        }
    }));
}

/**
 * Gets CSS data from <style> and <link> nodes (including @imports), then
 * returns data in order processed by DOM. Allows specifying nodes to
 * include/exclude and filtering CSS data using RegEx.
 *
 * @preserve
 * @param {object}   [options] The options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes.
 * @param {string}   [options.include] CSS selector matching <link> and <style>
 *                   nodes to include
 * @param {string}   [options.exclude] CSS selector matching <link> and <style>
 *                   nodes to exclude
 * @param {object}   [options.filter] Regular expression used to filter node CSS
 *                   data. Each block of CSS data is tested against the filter,
 *                   and only matching data is included.
 * @param {boolean}  [options.skipDisabled=true] Determines if disabled
 *                   stylesheets will be skipped while collecting CSS data.
 * @param {boolean}  [options.useCSSOM=false] Determines if CSS data will be
 *                   collected from a stylesheet's runtime values instead of its
 *                   text content. This is required to get accurate CSS data
 *                   when a stylesheet has been modified using the deleteRule()
 *                   or insertRule() methods because these modifications will
 *                   not be reflected in the stylesheet's text content.
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments.
 * @param {function} [options.onSuccess] Callback on each CSS node read. Passes
 *                   1) CSS text, 2) source node reference, and 3) the source
 *                   URL as arguments.
 * @param {function} [options.onError] Callback on each error. Passes 1) the XHR
 *                   object for inspection, 2) soure node reference, and 3) the
 *                   source URL that failed (either a <link> href or an @import)
 *                   as arguments
 * @param {function} [options.onComplete] Callback after all nodes have been
 *                   processed. Passes 1) concatenated CSS text, 2) an array of
 *                   CSS text in DOM order, and 3) an array of nodes in DOM
 *                   order as arguments.
 *
 * @example
 *
 *   getCssData({
 *     rootElement : document,
 *     include     : 'style,link[rel="stylesheet"]',
 *     exclude     : '[href="skip.css"]',
 *     filter      : /red/,
 *     skipDisabled: true,
 *     useCSSOM    : false,
 *     onBeforeSend(xhr, node, url) {
 *       // ...
 *     }
 *     onSuccess(cssText, node, url) {
 *       // ...
 *     }
 *     onError(xhr, node, url) {
 *       // ...
 *     },
 *     onComplete(cssText, cssArray, nodeArray) {
 *       // ...
 *     }
 *   });
 */ function getCssData(options) {
    var regex = {
        cssComments: /\/\*[\s\S]+?\*\//g,
        cssImports: /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g
    };
    var settings = {
        rootElement: options.rootElement || document,
        include: options.include || 'style,link[rel="stylesheet"]',
        exclude: options.exclude || null,
        filter: options.filter || null,
        skipDisabled: options.skipDisabled !== false,
        useCSSOM: options.useCSSOM || false,
        onBeforeSend: options.onBeforeSend || Function.prototype,
        onSuccess: options.onSuccess || Function.prototype,
        onError: options.onError || Function.prototype,
        onComplete: options.onComplete || Function.prototype
    };
    var sourceNodes = Array.apply(null, settings.rootElement.querySelectorAll(settings.include)).filter((function(node) {
        return !matchesSelector(node, settings.exclude);
    }));
    var cssArray = Array.apply(null, Array(sourceNodes.length)).map((function(x) {
        return null;
    }));
    function handleComplete() {
        var isComplete = cssArray.indexOf(null) === -1;
        if (isComplete) {
            cssArray.reduce((function(skipIndices, value, i) {
                if (value === "") {
                    skipIndices.push(i);
                }
                return skipIndices;
            }), []).reverse().forEach((function(skipIndex) {
                return [ sourceNodes, cssArray ].forEach((function(arr) {
                    return arr.splice(skipIndex, 1);
                }));
            }));
            var cssText = cssArray.join("");
            settings.onComplete(cssText, cssArray, sourceNodes);
        }
    }
    function handleSuccess(cssText, cssIndex, node, sourceUrl) {
        var returnVal = settings.onSuccess(cssText, node, sourceUrl);
        cssText = returnVal !== undefined && Boolean(returnVal) === false ? "" : returnVal || cssText;
        resolveImports(cssText, node, sourceUrl, (function(resolvedCssText, errorData) {
            if (cssArray[cssIndex] === null) {
                errorData.forEach((function(data) {
                    return settings.onError(data.xhr, node, data.url);
                }));
                if (!settings.filter || settings.filter.test(resolvedCssText)) {
                    cssArray[cssIndex] = resolvedCssText;
                } else {
                    cssArray[cssIndex] = "";
                }
                handleComplete();
            }
        }));
    }
    function parseImportData(cssText, baseUrl) {
        var ignoreRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var importData = {};
        importData.rules = (cssText.replace(regex.cssComments, "").match(regex.cssImports) || []).filter((function(rule) {
            return ignoreRules.indexOf(rule) === -1;
        }));
        importData.urls = importData.rules.map((function(rule) {
            return rule.replace(regex.cssImports, "$1");
        }));
        importData.absoluteUrls = importData.urls.map((function(url) {
            return getFullUrl$1(url, baseUrl);
        }));
        importData.absoluteRules = importData.rules.map((function(rule, i) {
            var oldUrl = importData.urls[i];
            var newUrl = getFullUrl$1(importData.absoluteUrls[i], baseUrl);
            return rule.replace(oldUrl, newUrl);
        }));
        return importData;
    }
    function resolveImports(cssText, node, baseUrl, callbackFn) {
        var __errorData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var __errorRules = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var importData = parseImportData(cssText, baseUrl, __errorRules);
        if (importData.rules.length) {
            getUrls(importData.absoluteUrls, {
                onBeforeSend: function onBeforeSend(xhr, url, urlIndex) {
                    settings.onBeforeSend(xhr, node, url);
                },
                onSuccess: function onSuccess(cssText, url, urlIndex) {
                    var returnVal = settings.onSuccess(cssText, node, url);
                    cssText = returnVal === false ? "" : returnVal || cssText;
                    var responseImportData = parseImportData(cssText, url, __errorRules);
                    responseImportData.rules.forEach((function(rule, i) {
                        cssText = cssText.replace(rule, responseImportData.absoluteRules[i]);
                    }));
                    return cssText;
                },
                onError: function onError(xhr, url, urlIndex) {
                    __errorData.push({
                        xhr: xhr,
                        url: url
                    });
                    __errorRules.push(importData.rules[urlIndex]);
                    resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
                },
                onComplete: function onComplete(responseArray) {
                    responseArray.forEach((function(importText, i) {
                        cssText = cssText.replace(importData.rules[i], importText);
                    }));
                    resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
                }
            });
        } else {
            callbackFn(cssText, __errorData);
        }
    }
    if (sourceNodes.length) {
        sourceNodes.forEach((function(node, i) {
            var linkHref = node.getAttribute("href");
            var linkRel = node.getAttribute("rel");
            var isLink = node.nodeName.toLowerCase() === "link" && linkHref && linkRel && linkRel.toLowerCase().indexOf("stylesheet") !== -1;
            var isSkip = settings.skipDisabled === false ? false : node.disabled;
            var isStyle = node.nodeName.toLowerCase() === "style";
            if (isLink && !isSkip) {
                getUrls(linkHref, {
                    mimeType: "text/css",
                    onBeforeSend: function onBeforeSend(xhr, url, urlIndex) {
                        settings.onBeforeSend(xhr, node, url);
                    },
                    onSuccess: function onSuccess(cssText, url, urlIndex) {
                        var sourceUrl = getFullUrl$1(linkHref);
                        handleSuccess(cssText, i, node, sourceUrl);
                    },
                    onError: function onError(xhr, url, urlIndex) {
                        cssArray[i] = "";
                        settings.onError(xhr, node, url);
                        handleComplete();
                    }
                });
            } else if (isStyle && !isSkip) {
                var cssText = node.textContent;
                if (settings.useCSSOM) {
                    cssText = Array.apply(null, node.sheet.cssRules).map((function(rule) {
                        return rule.cssText;
                    })).join("");
                }
                handleSuccess(cssText, i, node, location.href);
            } else {
                cssArray[i] = "";
                handleComplete();
            }
        }));
    } else {
        settings.onComplete("", []);
    }
}

function getFullUrl$1(url, base) {
    var d = document.implementation.createHTMLDocument("");
    var b = d.createElement("base");
    var a = d.createElement("a");
    d.head.appendChild(b);
    d.body.appendChild(a);
    b.href = base || document.baseURI || (document.querySelector("base") || {}).href || location.href;
    a.href = url;
    return a.href;
}

function matchesSelector(elm, selector) {
    var matches = elm.matches || elm.matchesSelector || elm.webkitMatchesSelector || elm.mozMatchesSelector || elm.msMatchesSelector || elm.oMatchesSelector;
    return matches.call(elm, selector);
}

var balancedMatch = balanced;

function balanced(a, b, str) {
    if (a instanceof RegExp) a = maybeMatch(a, str);
    if (b instanceof RegExp) b = maybeMatch(b, str);
    var r = range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}

function maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}

balanced.range = range;

function range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        if (a === b) {
            return [ ai, bi ];
        }
        begs = [];
        left = str.length;
        while (i >= 0 && !result) {
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) {
                result = [ begs.pop(), bi ];
            } else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) {
            result = [ left, right ];
        }
    }
    return result;
}

function parseCss(css) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        preserveStatic: true,
        removeComments: false
    };
    var settings = _extends({}, defaults, options);
    var errors = [];
    function error(msg) {
        throw new Error("CSS parse error: ".concat(msg));
    }
    function match(re) {
        var m = re.exec(css);
        if (m) {
            css = css.slice(m[0].length);
            return m;
        }
    }
    function open() {
        return match(/^{\s*/);
    }
    function close() {
        return match(/^}/);
    }
    function whitespace() {
        match(/^\s*/);
    }
    function comment() {
        whitespace();
        if (css[0] !== "/" || css[1] !== "*") {
            return;
        }
        var i = 2;
        while (css[i] && (css[i] !== "*" || css[i + 1] !== "/")) {
            i++;
        }
        if (!css[i]) {
            return error("end of comment is missing");
        }
        var str = css.slice(2, i);
        css = css.slice(i + 2);
        return {
            type: "comment",
            comment: str
        };
    }
    function comments() {
        var cmnts = [];
        var c;
        while (c = comment()) {
            cmnts.push(c);
        }
        return settings.removeComments ? [] : cmnts;
    }
    function selector() {
        whitespace();
        while (css[0] === "}") {
            error("extra closing bracket");
        }
        var m = match(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
        if (m) {
            var _selector = m[0].trim();
            var selectorItems;
            var hasComment = /\/\*/.test(_selector);
            if (hasComment) {
                _selector = _selector.replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, "");
            }
            var hasCommaInQuotes = /["']\w*,\w*["']/.test(_selector);
            if (hasCommaInQuotes) {
                _selector = _selector.replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, (function(m) {
                    return m.replace(/,/g, "‌");
                }));
            }
            var hasMultipleSelectors = /,/.test(_selector);
            if (hasMultipleSelectors) {
                selectorItems = _selector.split(/\s*(?![^(]*\)),\s*/);
            } else {
                selectorItems = [ _selector ];
            }
            if (hasCommaInQuotes) {
                selectorItems = selectorItems.map((function(s) {
                    return s.replace(/\u200C/g, ",");
                }));
            }
            return selectorItems;
        }
    }
    function declaration() {
        if (css[0] === "@") {
            return at_rule();
        }
        match(/^([;\s]*)+/);
        var comment_regexp = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
        var prop = match(/^(\*?[-#/*\\\w.]+(\[[0-9a-z_-]+\])?)\s*/);
        if (!prop) {
            return;
        }
        prop = prop[0].trim();
        if (!match(/^:\s*/)) {
            return error("property missing ':'");
        }
        var val = match(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/);
        var ret = {
            type: "declaration",
            property: prop.replace(comment_regexp, ""),
            value: val ? val[0].replace(comment_regexp, "").trim() : ""
        };
        match(/^[;\s]*/);
        return ret;
    }
    function declarations() {
        if (!open()) {
            return error("missing '{'");
        }
        var d;
        var decls = comments();
        while (d = declaration()) {
            decls.push(d);
            decls = decls.concat(comments());
        }
        if (!close()) {
            return error("missing '}'");
        }
        return decls;
    }
    function keyframe() {
        whitespace();
        var vals = [];
        var m;
        while (m = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)) {
            vals.push(m[1]);
            match(/^,\s*/);
        }
        if (vals.length) {
            return {
                type: "keyframe",
                values: vals,
                declarations: declarations()
            };
        }
    }
    function at_keyframes() {
        var m = match(/^@([-\w]+)?keyframes\s*/);
        if (!m) {
            return;
        }
        var vendor = m[1];
        m = match(/^([-\w]+)\s*/);
        if (!m) {
            return error("@keyframes missing name");
        }
        var name = m[1];
        if (!open()) {
            return error("@keyframes missing '{'");
        }
        var frame;
        var frames = comments();
        while (frame = keyframe()) {
            frames.push(frame);
            frames = frames.concat(comments());
        }
        if (!close()) {
            return error("@keyframes missing '}'");
        }
        return {
            type: "keyframes",
            name: name,
            vendor: vendor,
            keyframes: frames
        };
    }
    function at_page() {
        var m = match(/^@page */);
        if (m) {
            var sel = selector() || [];
            return {
                type: "page",
                selectors: sel,
                declarations: declarations()
            };
        }
    }
    function at_page_margin_box() {
        var m = match(/@(top|bottom|left|right)-(left|center|right|top|middle|bottom)-?(corner)?\s*/);
        if (m) {
            var name = "".concat(m[1], "-").concat(m[2]) + (m[3] ? "-".concat(m[3]) : "");
            return {
                type: "page-margin-box",
                name: name,
                declarations: declarations()
            };
        }
    }
    function at_fontface() {
        var m = match(/^@font-face\s*/);
        if (m) {
            return {
                type: "font-face",
                declarations: declarations()
            };
        }
    }
    function at_supports() {
        var m = match(/^@supports *([^{]+)/);
        if (m) {
            return {
                type: "supports",
                supports: m[1].trim(),
                rules: rules()
            };
        }
    }
    function at_host() {
        var m = match(/^@host\s*/);
        if (m) {
            return {
                type: "host",
                rules: rules()
            };
        }
    }
    function at_media() {
        var m = match(/^@media([^{]+)*/);
        if (m) {
            return {
                type: "media",
                media: (m[1] || "").trim(),
                rules: rules()
            };
        }
    }
    function at_custom_m() {
        var m = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
        if (m) {
            return {
                type: "custom-media",
                name: m[1].trim(),
                media: m[2].trim()
            };
        }
    }
    function at_document() {
        var m = match(/^@([-\w]+)?document *([^{]+)/);
        if (m) {
            return {
                type: "document",
                document: m[2].trim(),
                vendor: m[1] ? m[1].trim() : null,
                rules: rules()
            };
        }
    }
    function at_x() {
        var m = match(/^@(import|charset|namespace)\s*([^;]+);/);
        if (m) {
            return {
                type: m[1],
                name: m[2].trim()
            };
        }
    }
    function at_rule() {
        whitespace();
        if (css[0] === "@") {
            var ret = at_x() || at_fontface() || at_media() || at_keyframes() || at_supports() || at_document() || at_custom_m() || at_host() || at_page() || at_page_margin_box();
            if (ret && !settings.preserveStatic) {
                var hasVarFunc = false;
                if (ret.declarations) {
                    hasVarFunc = ret.declarations.some((function(decl) {
                        return /var\(/.test(decl.value);
                    }));
                } else {
                    var arr = ret.keyframes || ret.rules || [];
                    hasVarFunc = arr.some((function(obj) {
                        return (obj.declarations || []).some((function(decl) {
                            return /var\(/.test(decl.value);
                        }));
                    }));
                }
                return hasVarFunc ? ret : {};
            }
            return ret;
        }
    }
    function rule() {
        if (!settings.preserveStatic) {
            var balancedMatch$1 = balancedMatch("{", "}", css);
            if (balancedMatch$1) {
                var hasVarDecl = /:(?:root|host)(?![.:#(])/.test(balancedMatch$1.pre) && /--\S*\s*:/.test(balancedMatch$1.body);
                var hasVarFunc = /var\(/.test(balancedMatch$1.body);
                if (!hasVarDecl && !hasVarFunc) {
                    css = css.slice(balancedMatch$1.end + 1);
                    return {};
                }
            }
        }
        var sel = selector() || [];
        var decls = settings.preserveStatic ? declarations() : declarations().filter((function(decl) {
            var hasVarDecl = sel.some((function(s) {
                return /:(?:root|host)(?![.:#(])/.test(s);
            })) && /^--\S/.test(decl.property);
            var hasVarFunc = /var\(/.test(decl.value);
            return hasVarDecl || hasVarFunc;
        }));
        if (!sel.length) {
            error("selector missing");
        }
        return {
            type: "rule",
            selectors: sel,
            declarations: decls
        };
    }
    function rules(core) {
        if (!core && !open()) {
            return error("missing '{'");
        }
        var node;
        var rules = comments();
        while (css.length && (core || css[0] !== "}") && (node = at_rule() || rule())) {
            if (node.type) {
                rules.push(node);
            }
            rules = rules.concat(comments());
        }
        if (!core && !close()) {
            return error("missing '}'");
        }
        return rules;
    }
    return {
        type: "stylesheet",
        stylesheet: {
            rules: rules(true),
            errors: errors
        }
    };
}

function parseVars(cssData) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        parseHost: false,
        store: {},
        onWarning: function onWarning() {}
    };
    var settings = _extends({}, defaults, options);
    var reVarDeclSelectors = new RegExp(":".concat(settings.parseHost ? "host" : "root", "$"));
    if (typeof cssData === "string") {
        cssData = parseCss(cssData, settings);
    }
    cssData.stylesheet.rules.forEach((function(rule) {
        if (rule.type !== "rule" || !rule.selectors.some((function(s) {
            return reVarDeclSelectors.test(s);
        }))) {
            return;
        }
        rule.declarations.forEach((function(decl, i) {
            var prop = decl.property;
            var value = decl.value;
            if (prop && prop.indexOf("--") === 0) {
                settings.store[prop] = value;
            }
        }));
    }));
    return settings.store;
}

function stringifyCss(tree) {
    var delim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var renderMethods = {
        charset: function charset(node) {
            return "@charset " + node.name + ";";
        },
        comment: function comment(node) {
            return node.comment.indexOf("__CSSVARSPONYFILL") === 0 ? "/*" + node.comment + "*/" : "";
        },
        "custom-media": function customMedia(node) {
            return "@custom-media " + node.name + " " + node.media + ";";
        },
        declaration: function declaration(node) {
            return node.property + ":" + node.value + ";";
        },
        document: function document(node) {
            return "@" + (node.vendor || "") + "document " + node.document + "{" + visit(node.rules) + "}";
        },
        "font-face": function fontFace(node) {
            return "@font-face" + "{" + visit(node.declarations) + "}";
        },
        host: function host(node) {
            return "@host" + "{" + visit(node.rules) + "}";
        },
        import: function _import(node) {
            return "@import " + node.name + ";";
        },
        keyframe: function keyframe(node) {
            return node.values.join(",") + "{" + visit(node.declarations) + "}";
        },
        keyframes: function keyframes(node) {
            return "@" + (node.vendor || "") + "keyframes " + node.name + "{" + visit(node.keyframes) + "}";
        },
        media: function media(node) {
            return "@media " + node.media + "{" + visit(node.rules) + "}";
        },
        namespace: function namespace(node) {
            return "@namespace " + node.name + ";";
        },
        page: function page(node) {
            return "@page " + (node.selectors.length ? node.selectors.join(", ") : "") + "{" + visit(node.declarations) + "}";
        },
        "page-margin-box": function pageMarginBox(node) {
            return "@" + node.name + "{" + visit(node.declarations) + "}";
        },
        rule: function rule(node) {
            var decls = node.declarations;
            if (decls.length) {
                return node.selectors.join(",") + "{" + visit(decls) + "}";
            }
        },
        supports: function supports(node) {
            return "@supports " + node.supports + "{" + visit(node.rules) + "}";
        }
    };
    function visit(nodes) {
        var buf = "";
        for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            if (cb) {
                cb(n);
            }
            var txt = renderMethods[n.type](n);
            if (txt) {
                buf += txt;
                if (txt.length && n.selectors) {
                    buf += delim;
                }
            }
        }
        return buf;
    }
    return visit(tree.stylesheet.rules);
}

function walkCss(node, fn) {
    node.rules.forEach((function(rule) {
        if (rule.rules) {
            walkCss(rule, fn);
            return;
        }
        if (rule.keyframes) {
            rule.keyframes.forEach((function(keyframe) {
                if (keyframe.type === "keyframe") {
                    fn(keyframe.declarations, rule);
                }
            }));
            return;
        }
        if (!rule.declarations) {
            return;
        }
        fn(rule.declarations, node);
    }));
}

var VAR_PROP_IDENTIFIER = "--";

var VAR_FUNC_IDENTIFIER = "var";

function transformCss(cssData) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        preserveStatic: true,
        preserveVars: false,
        variables: {},
        onWarning: function onWarning() {}
    };
    var settings = _extends({}, defaults, options);
    if (typeof cssData === "string") {
        cssData = parseCss(cssData, settings);
    }
    walkCss(cssData.stylesheet, (function(declarations, node) {
        for (var i = 0; i < declarations.length; i++) {
            var decl = declarations[i];
            var type = decl.type;
            var prop = decl.property;
            var value = decl.value;
            if (type !== "declaration") {
                continue;
            }
            if (!settings.preserveVars && prop && prop.indexOf(VAR_PROP_IDENTIFIER) === 0) {
                declarations.splice(i, 1);
                i--;
                continue;
            }
            if (value.indexOf(VAR_FUNC_IDENTIFIER + "(") !== -1) {
                var resolvedValue = resolveValue(value, settings);
                if (resolvedValue !== decl.value) {
                    resolvedValue = fixNestedCalc(resolvedValue);
                    if (!settings.preserveVars) {
                        decl.value = resolvedValue;
                    } else {
                        declarations.splice(i, 0, {
                            type: type,
                            property: prop,
                            value: resolvedValue
                        });
                        i++;
                    }
                }
            }
        }
    }));
    return stringifyCss(cssData);
}

function fixNestedCalc(value) {
    var reCalcVal = /calc\(([^)]+)\)/g;
    (value.match(reCalcVal) || []).forEach((function(match) {
        var newVal = "calc".concat(match.split("calc").join(""));
        value = value.replace(match, newVal);
    }));
    return value;
}

function resolveValue(value) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var __recursiveFallback = arguments.length > 2 ? arguments[2] : undefined;
    if (value.indexOf("var(") === -1) {
        return value;
    }
    var valueData = balancedMatch("(", ")", value);
    function resolveFunc(value) {
        var name = value.split(",")[0].replace(/[\s\n\t]/g, "");
        var fallback = (value.match(/(?:\s*,\s*){1}(.*)?/) || [])[1];
        var match = Object.prototype.hasOwnProperty.call(settings.variables, name) ? String(settings.variables[name]) : undefined;
        var replacement = match || (fallback ? String(fallback) : undefined);
        var unresolvedFallback = __recursiveFallback || value;
        if (!match) {
            settings.onWarning('variable "'.concat(name, '" is undefined'));
        }
        if (replacement && replacement !== "undefined" && replacement.length > 0) {
            return resolveValue(replacement, settings, unresolvedFallback);
        } else {
            return "var(".concat(unresolvedFallback, ")");
        }
    }
    if (!valueData) {
        if (value.indexOf("var(") !== -1) {
            settings.onWarning('missing closing ")" in the value "'.concat(value, '"'));
        }
        return value;
    } else if (valueData.pre.slice(-3) === "var") {
        var isEmptyVarFunc = valueData.body.trim().length === 0;
        if (isEmptyVarFunc) {
            settings.onWarning("var() must contain a non-whitespace string");
            return value;
        } else {
            return valueData.pre.slice(0, -3) + resolveFunc(valueData.body) + resolveValue(valueData.post, settings);
        }
    } else {
        return valueData.pre + "(".concat(resolveValue(valueData.body, settings), ")") + resolveValue(valueData.post, settings);
    }
}

var isBrowser = typeof window !== "undefined";

var isNativeSupport = isBrowser && window.CSS && window.CSS.supports && window.CSS.supports("(--a: 0)");

var counters = {
    group: 0,
    job: 0
};

var defaults = {
    rootElement: isBrowser ? document : null,
    shadowDOM: false,
    include: "style,link[rel=stylesheet]",
    exclude: "",
    variables: {},
    onlyLegacy: true,
    preserveStatic: true,
    preserveVars: false,
    silent: false,
    updateDOM: true,
    updateURLs: true,
    watch: null,
    onBeforeSend: function onBeforeSend() {},
    onError: function onError() {},
    onWarning: function onWarning() {},
    onSuccess: function onSuccess() {},
    onComplete: function onComplete() {},
    onFinally: function onFinally() {}
};

var regex = {
    cssComments: /\/\*[\s\S]+?\*\//g,
    cssKeyframes: /@(?:-\w*-)?keyframes/,
    cssMediaQueries: /@media[^{]+\{([\s\S]+?})\s*}/g,
    cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,
    cssVarDeclRules: /(?::(?:root|host)(?![.:#(])[\s,]*[^{]*{\s*[^}]*})/g,
    cssVarDecls: /(?:[\s;]*)(-{2}\w[\w-]*)(?:\s*:\s*)([^;]*);/g,
    cssVarFunc: /var\(\s*--[\w-]/,
    cssVars: /(?:(?::(?:root|host)(?![.:#(])[\s,]*[^{]*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/
};

var variableStore = {
    dom: {},
    job: {},
    user: {}
};

var cssVarsIsRunning = false;

var cssVarsObserver = null;

var cssVarsSrcNodeCount = 0;

var debounceTimer = null;

var isShadowDOMReady = false;

/**
 * Fetches, parses, and transforms CSS custom properties from specified
 * <style> and <link> elements into static values, then appends a new <style>
 * element with static values to the DOM to provide CSS custom property
 * compatibility for legacy browsers. Also provides a single interface for
 * live updates of runtime values in both modern and legacy browsers.
 *
 * @preserve
 * @param {object}   [options] Options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes
 * @param {boolean}  [options.shadowDOM=false] Determines if shadow DOM <link>
 *                   and <style> nodes will be processed.
 * @param {string}   [options.include="style,link[rel=stylesheet]"] CSS selector
 *                   matching <link re="stylesheet"> and <style> nodes to
 *                   process
 * @param {string}   [options.exclude] CSS selector matching <link
 *                   rel="stylehseet"> and <style> nodes to exclude from those
 *                   matches by options.include
 * @param {object}   [options.variables] A map of custom property name/value
 *                   pairs. Property names can omit or include the leading
 *                   double-hyphen (—), and values specified will override
 *                   previous values
 * @param {boolean}  [options.onlyLegacy=true] Determines if the ponyfill will
 *                   only generate legacy-compatible CSS in browsers that lack
 *                   native support (i.e., legacy browsers)
 * @param {boolean}  [options.preserveStatic=true] Determines if CSS
 *                   declarations that do not reference a custom property will
 *                   be preserved in the transformed CSS
 * @param {boolean}  [options.preserveVars=false] Determines if CSS custom
 *                   property declarations will be preserved in the transformed
 *                   CSS
 * @param {boolean}  [options.silent=false] Determines if warning and error
 *                   messages will be displayed on the console
 * @param {boolean}  [options.updateDOM=true] Determines if the ponyfill will
 *                   update the DOM after processing CSS custom properties
 * @param {boolean}  [options.updateURLs=true] Determines if relative url()
 *                   paths will be converted to absolute urls in external CSS
 * @param {boolean}  [options.watch=false] Determines if a MutationObserver will
 *                   be created that will execute the ponyfill when a <link> or
 *                   <style> DOM mutation is observed
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments
 * @param {function} [options.onError] Callback after a CSS parsing error has
 *                   occurred or an XHR request has failed. Passes 1) an error
 *                   message, and 2) source node reference, 3) xhr, and 4 url as
 *                   arguments.
 * @param {function} [options.onWarning] Callback after each CSS parsing warning
 *                   has occurred. Passes 1) a warning message as an argument.
 * @param {function} [options.onSuccess] Callback after CSS data has been
 *                   collected from each node and before CSS custom properties
 *                   have been transformed. Allows modifying the CSS data before
 *                   it is transformed by returning any string value (or false
 *                   to skip). Passes 1) CSS text, 2) source node reference, and
 *                   3) the source URL as arguments.
 * @param {function} [options.onComplete] Callback after all CSS has been
 *                   processed, legacy-compatible CSS has been generated, and
 *                   (optionally) the DOM has been updated. Passes 1) a CSS
 *                   string with CSS variable values resolved, 2) an array of
 *                   output <style> node references that have been appended to
 *                   the DOM, 3) an object containing all custom properies names
 *                   and values, and 4) the ponyfill execution time in
 *                   milliseconds.
 * @param {function} [options.onFinally] Callback in modern and legacy browsers
 *                   after the ponyfill has finished all tasks. Passes 1) a
 *                   boolean indicating if the last ponyfill call resulted in a
 *                   style change, 2) a boolean indicating if the current
 *                   browser provides native support for CSS custom properties,
 *                   and 3) the ponyfill execution time in milliseconds.
 * @example
 *
 *   cssVars({
 *     rootElement   : document,
 *     shadowDOM     : false,
 *     include       : 'style,link[rel="stylesheet"]',
 *     exclude       : '',
 *     variables     : {},
 *     onlyLegacy    : true,
 *     preserveStatic: true,
 *     preserveVars  : false,
 *     silent        : false,
 *     updateDOM     : true,
 *     updateURLs    : true,
 *     watch         : false,
 *     onBeforeSend(xhr, node, url) {},
 *     onError(message, node, xhr, url) {},
 *     onWarning(message) {},
 *     onSuccess(cssText, node, url) {},
 *     onComplete(cssText, styleNode, cssVariables, benchmark) {},
 *     onFinally(hasChanged, hasNativeSupport, benchmark)
 *   });
 */ function cssVars() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var msgPrefix = "cssVars(): ";
    var settings = _extends({}, defaults, options);
    function handleError(message, sourceNode, xhr, url) {
        if (!settings.silent && window.console) {
            console.error("".concat(msgPrefix).concat(message, "\n"), sourceNode);
        }
        settings.onError(message, sourceNode, xhr, url);
    }
    function handleWarning(message) {
        if (!settings.silent && window.console) {
            console.warn("".concat(msgPrefix).concat(message));
        }
        settings.onWarning(message);
    }
    function handleFinally(hasChanged) {
        settings.onFinally(Boolean(hasChanged), isNativeSupport, getTimeStamp() - settings.__benchmark);
    }
    if (!isBrowser) {
        return;
    }
    if (settings.watch) {
        settings.watch = defaults.watch;
        addMutationObserver(settings);
        cssVars(settings);
        return;
    } else if (settings.watch === false && cssVarsObserver) {
        cssVarsObserver.disconnect();
        cssVarsObserver = null;
    }
    if (!settings.__benchmark) {
        if (cssVarsIsRunning === settings.rootElement) {
            cssVarsDebounced(options);
            return;
        }
        var srcNodes = [].slice.call(settings.rootElement.querySelectorAll('[data-cssvars]:not([data-cssvars="out"])'));
        settings.__benchmark = getTimeStamp();
        settings.exclude = [ cssVarsObserver ? '[data-cssvars]:not([data-cssvars=""])' : '[data-cssvars="out"]', "link[disabled]:not([data-cssvars])", settings.exclude ].filter((function(selector) {
            return selector;
        })).join(",");
        settings.variables = fixVarNames(settings.variables);
        srcNodes.forEach((function(srcNode) {
            var hasStyleCache = srcNode.nodeName.toLowerCase() === "style" && srcNode.__cssVars.text;
            var hasStyleChanged = hasStyleCache && srcNode.textContent !== srcNode.__cssVars.text;
            if (hasStyleCache && hasStyleChanged) {
                srcNode.sheet && (srcNode.sheet.disabled = false);
                srcNode.setAttribute("data-cssvars", "");
            }
        }));
        if (!cssVarsObserver) {
            var outNodes = [].slice.call(settings.rootElement.querySelectorAll('[data-cssvars="out"]'));
            outNodes.forEach((function(outNode) {
                var dataGroup = outNode.getAttribute("data-cssvars-group");
                var srcNode = dataGroup ? settings.rootElement.querySelector('[data-cssvars="src"][data-cssvars-group="'.concat(dataGroup, '"]')) : null;
                if (!srcNode) {
                    outNode.parentNode.removeChild(outNode);
                }
            }));
            if (cssVarsSrcNodeCount && srcNodes.length < cssVarsSrcNodeCount) {
                cssVarsSrcNodeCount = srcNodes.length;
                variableStore.dom = {};
            }
        }
    }
    if (document.readyState !== "loading") {
        if (isNativeSupport && settings.onlyLegacy) {
            var hasVarChange = false;
            if (settings.updateDOM) {
                var targetElm = settings.rootElement.host || (settings.rootElement === document ? document.documentElement : settings.rootElement);
                Object.keys(settings.variables).forEach((function(key) {
                    var varValue = settings.variables[key];
                    hasVarChange = hasVarChange || varValue !== getComputedStyle(targetElm).getPropertyValue(key);
                    targetElm.style.setProperty(key, varValue);
                }));
            }
            handleFinally(hasVarChange);
        } else if (!isShadowDOMReady && (settings.shadowDOM || settings.rootElement.shadowRoot || settings.rootElement.host)) {
            getCssData({
                rootElement: defaults.rootElement,
                include: defaults.include,
                exclude: settings.exclude,
                skipDisabled: false,
                onSuccess: function onSuccess(cssText, node, url) {
                    var isUserDisabled = (node.sheet || {}).disabled && !node.__cssVars;
                    if (isUserDisabled) {
                        return false;
                    }
                    cssText = cssText.replace(regex.cssComments, "").replace(regex.cssMediaQueries, "");
                    cssText = (cssText.match(regex.cssVarDeclRules) || []).join("");
                    return cssText || false;
                },
                onComplete: function onComplete(cssText, cssArray, nodeArray) {
                    parseVars(cssText, {
                        store: variableStore.dom,
                        onWarning: handleWarning
                    });
                    isShadowDOMReady = true;
                    cssVars(settings);
                }
            });
        } else {
            cssVarsIsRunning = settings.rootElement;
            getCssData({
                rootElement: settings.rootElement,
                include: settings.include,
                exclude: settings.exclude,
                skipDisabled: false,
                onBeforeSend: settings.onBeforeSend,
                onError: function onError(xhr, node, url) {
                    var responseUrl = xhr.responseURL || getFullUrl(url, location.href);
                    var statusText = xhr.statusText ? "(".concat(xhr.statusText, ")") : "Unspecified Error" + (xhr.status === 0 ? " (possibly CORS related)" : "");
                    var errorMsg = "CSS XHR Error: ".concat(responseUrl, " ").concat(xhr.status, " ").concat(statusText);
                    handleError(errorMsg, node, xhr, responseUrl);
                },
                onSuccess: function onSuccess(cssText, node, url) {
                    var isUserDisabled = (node.sheet || {}).disabled && !node.__cssVars;
                    if (isUserDisabled) {
                        return false;
                    }
                    var isLink = node.nodeName.toLowerCase() === "link";
                    var isStyleImport = node.nodeName.toLowerCase() === "style" && cssText !== node.textContent;
                    var returnVal = settings.onSuccess(cssText, node, url);
                    cssText = returnVal !== undefined && Boolean(returnVal) === false ? "" : returnVal || cssText;
                    if (settings.updateURLs && (isLink || isStyleImport)) {
                        cssText = fixRelativeCssUrls(cssText, url);
                    }
                    return cssText;
                },
                onComplete: function onComplete(cssText, cssArray) {
                    var nodeArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                    var currentVars = _extends({}, variableStore.dom, variableStore.user);
                    var hasVarChange = false;
                    variableStore.job = {};
                    nodeArray.forEach((function(node, i) {
                        var nodeCSS = cssArray[i];
                        node.__cssVars = node.__cssVars || {};
                        node.__cssVars.text = nodeCSS;
                        if (regex.cssVars.test(nodeCSS)) {
                            try {
                                var cssTree = parseCss(nodeCSS, {
                                    preserveStatic: settings.preserveStatic,
                                    removeComments: true
                                });
                                parseVars(cssTree, {
                                    parseHost: Boolean(settings.rootElement.host),
                                    store: variableStore.dom,
                                    onWarning: handleWarning
                                });
                                node.__cssVars.tree = cssTree;
                            } catch (err) {
                                handleError(err.message, node);
                            }
                        }
                    }));
                    _extends(variableStore.job, variableStore.dom);
                    if (settings.updateDOM) {
                        _extends(variableStore.user, settings.variables);
                        _extends(variableStore.job, variableStore.user);
                    } else {
                        _extends(variableStore.job, variableStore.user, settings.variables);
                        _extends(currentVars, settings.variables);
                    }
                    hasVarChange = counters.job > 0 && Boolean(Object.keys(variableStore.job).length > Object.keys(currentVars).length || Boolean(Object.keys(currentVars).length && Object.keys(variableStore.job).some((function(key) {
                        return variableStore.job[key] !== currentVars[key];
                    }))));
                    if (hasVarChange) {
                        resetCssNodes(settings.rootElement);
                        cssVars(settings);
                    } else {
                        var outCssArray = [];
                        var outNodeArray = [];
                        var hasKeyframesWithVars = false;
                        if (settings.updateDOM) {
                            counters.job++;
                        }
                        nodeArray.forEach((function(node, i) {
                            var isSkip = !node.__cssVars.tree;
                            if (node.__cssVars.tree) {
                                try {
                                    transformCss(node.__cssVars.tree, _extends({}, settings, {
                                        variables: variableStore.job,
                                        onWarning: handleWarning
                                    }));
                                    var outCss = stringifyCss(node.__cssVars.tree);
                                    if (settings.updateDOM) {
                                        var nodeCSS = cssArray[i];
                                        var hasCSSVarFunc = regex.cssVarFunc.test(nodeCSS);
                                        if (!node.getAttribute("data-cssvars")) {
                                            node.setAttribute("data-cssvars", "src");
                                        }
                                        if (outCss.length && hasCSSVarFunc) {
                                            var dataGroup = node.getAttribute("data-cssvars-group") || ++counters.group;
                                            var outCssNoSpaces = outCss.replace(/\s/g, "");
                                            var outNode = settings.rootElement.querySelector('[data-cssvars="out"][data-cssvars-group="'.concat(dataGroup, '"]')) || document.createElement("style");
                                            hasKeyframesWithVars = hasKeyframesWithVars || regex.cssKeyframes.test(outCss);
                                            if (settings.preserveStatic) {
                                                node.sheet && (node.sheet.disabled = true);
                                            }
                                            if (!outNode.hasAttribute("data-cssvars")) {
                                                outNode.setAttribute("data-cssvars", "out");
                                            }
                                            if (outCssNoSpaces === node.textContent.replace(/\s/g, "")) {
                                                isSkip = true;
                                                if (outNode && outNode.parentNode) {
                                                    node.removeAttribute("data-cssvars-group");
                                                    outNode.parentNode.removeChild(outNode);
                                                }
                                            } else if (outCssNoSpaces !== outNode.textContent.replace(/\s/g, "")) {
                                                [ node, outNode ].forEach((function(n) {
                                                    n.setAttribute("data-cssvars-job", counters.job);
                                                    n.setAttribute("data-cssvars-group", dataGroup);
                                                }));
                                                outNode.textContent = outCss;
                                                outCssArray.push(outCss);
                                                outNodeArray.push(outNode);
                                                if (!outNode.parentNode) {
                                                    node.parentNode.insertBefore(outNode, node.nextSibling);
                                                }
                                            }
                                        }
                                    } else {
                                        if (node.textContent.replace(/\s/g, "") !== outCss) {
                                            outCssArray.push(outCss);
                                        }
                                    }
                                } catch (err) {
                                    handleError(err.message, node);
                                }
                            }
                            if (isSkip) {
                                node.setAttribute("data-cssvars", "skip");
                            }
                            if (!node.hasAttribute("data-cssvars-job")) {
                                node.setAttribute("data-cssvars-job", counters.job);
                            }
                        }));
                        cssVarsSrcNodeCount = settings.rootElement.querySelectorAll('[data-cssvars]:not([data-cssvars="out"])').length;
                        if (settings.shadowDOM) {
                            var elms = [].concat(settings.rootElement).concat([].slice.call(settings.rootElement.querySelectorAll("*")));
                            for (var i = 0, elm; elm = elms[i]; ++i) {
                                if (elm.shadowRoot && elm.shadowRoot.querySelector("style")) {
                                    var shadowSettings = _extends({}, settings, {
                                        rootElement: elm.shadowRoot
                                    });
                                    cssVars(shadowSettings);
                                }
                            }
                        }
                        if (settings.updateDOM && hasKeyframesWithVars) {
                            fixKeyframes(settings.rootElement);
                        }
                        cssVarsIsRunning = false;
                        settings.onComplete(outCssArray.join(""), outNodeArray, JSON.parse(JSON.stringify(variableStore.job)), getTimeStamp() - settings.__benchmark);
                        handleFinally(outNodeArray.length);
                    }
                }
            });
        }
    } else {
        document.addEventListener("DOMContentLoaded", (function init(evt) {
            cssVars(options);
            document.removeEventListener("DOMContentLoaded", init);
        }));
    }
}

cssVars.reset = function() {
    counters.job = 0;
    counters.group = 0;
    cssVarsIsRunning = false;
    if (cssVarsObserver) {
        cssVarsObserver.disconnect();
        cssVarsObserver = null;
    }
    cssVarsSrcNodeCount = 0;
    debounceTimer = null;
    isShadowDOMReady = false;
    for (var prop in variableStore) {
        variableStore[prop] = {};
    }
};

function addMutationObserver(settings) {
    function isDisabled(node) {
        var isDisabledAttr = isLink(node) && node.hasAttribute("disabled");
        var isDisabledSheet = (node.sheet || {}).disabled;
        return isDisabledAttr || isDisabledSheet;
    }
    function isLink(node) {
        var isStylesheet = node.nodeName.toLowerCase() === "link" && (node.getAttribute("rel") || "").indexOf("stylesheet") !== -1;
        return isStylesheet;
    }
    function isStyle(node) {
        return node.nodeName.toLowerCase() === "style";
    }
    function isValidAttributeMutation(mutation) {
        var isValid = false;
        if (mutation.type === "attributes" && isLink(mutation.target) && !isDisabled(mutation.target)) {
            var isEnabledMutation = mutation.attributeName === "disabled";
            var isHrefMutation = mutation.attributeName === "href";
            var isSkipNode = mutation.target.getAttribute("data-cssvars") === "skip";
            var isSrcNode = mutation.target.getAttribute("data-cssvars") === "src";
            if (isEnabledMutation) {
                isValid = !isSkipNode && !isSrcNode;
            } else if (isHrefMutation) {
                if (isSkipNode) {
                    mutation.target.setAttribute("data-cssvars", "");
                } else if (isSrcNode) {
                    resetCssNodes(settings.rootElement, true);
                }
                isValid = true;
            }
        }
        return isValid;
    }
    function isValidStyleTextMutation(mutation) {
        var isValid = false;
        if (mutation.type === "childList") {
            var isStyleElm = isStyle(mutation.target);
            var isOutNode = mutation.target.getAttribute("data-cssvars") === "out";
            isValid = isStyleElm && !isOutNode;
        }
        return isValid;
    }
    function isValidAddMutation(mutation) {
        var isValid = false;
        if (mutation.type === "childList") {
            isValid = [].slice.call(mutation.addedNodes).some((function(node) {
                var isElm = node.nodeType === 1;
                var hasAttr = isElm && node.hasAttribute("data-cssvars");
                var isStyleWithVars = isStyle(node) && regex.cssVars.test(node.textContent);
                var isValid = !hasAttr && (isLink(node) || isStyleWithVars);
                return isValid && !isDisabled(node);
            }));
        }
        return isValid;
    }
    function isValidRemoveMutation(mutation) {
        var isValid = false;
        if (mutation.type === "childList") {
            isValid = [].slice.call(mutation.removedNodes).some((function(node) {
                var isElm = node.nodeType === 1;
                var isOutNode = isElm && node.getAttribute("data-cssvars") === "out";
                var isSrcNode = isElm && node.getAttribute("data-cssvars") === "src";
                var isValid = isSrcNode;
                if (isSrcNode || isOutNode) {
                    var dataGroup = node.getAttribute("data-cssvars-group");
                    var orphanNode = settings.rootElement.querySelector('[data-cssvars-group="'.concat(dataGroup, '"]'));
                    if (isSrcNode) {
                        resetCssNodes(settings.rootElement, true);
                    }
                    if (orphanNode) {
                        orphanNode.parentNode.removeChild(orphanNode);
                    }
                }
                return isValid;
            }));
        }
        return isValid;
    }
    if (!window.MutationObserver) {
        return;
    }
    if (cssVarsObserver) {
        cssVarsObserver.disconnect();
        cssVarsObserver = null;
    }
    cssVarsObserver = new MutationObserver((function(mutations) {
        var hasValidMutation = mutations.some((function(mutation) {
            return isValidAttributeMutation(mutation) || isValidStyleTextMutation(mutation) || isValidAddMutation(mutation) || isValidRemoveMutation(mutation);
        }));
        if (hasValidMutation) {
            cssVars(settings);
        }
    }));
    cssVarsObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [ "disabled", "href" ],
        childList: true,
        subtree: true
    });
}

function cssVarsDebounced(settings) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout((function() {
        settings.__benchmark = null;
        cssVars(settings);
    }), delay);
}

function fixKeyframes(rootElement) {
    var animationNameProp = [ "animation-name", "-moz-animation-name", "-webkit-animation-name" ].filter((function(prop) {
        return getComputedStyle(document.body)[prop];
    }))[0];
    if (animationNameProp) {
        var allNodes = rootElement.getElementsByTagName("*");
        var keyframeNodes = [];
        var nameMarker = "__CSSVARSPONYFILL-KEYFRAMES__";
        for (var i = 0, len = allNodes.length; i < len; i++) {
            var node = allNodes[i];
            var animationName = getComputedStyle(node)[animationNameProp];
            if (animationName !== "none") {
                node.style[animationNameProp] += nameMarker;
                keyframeNodes.push(node);
            }
        }
        void document.body.offsetHeight;
        for (var _i = 0, _len = keyframeNodes.length; _i < _len; _i++) {
            var nodeStyle = keyframeNodes[_i].style;
            nodeStyle[animationNameProp] = nodeStyle[animationNameProp].replace(nameMarker, "");
        }
    }
}

function fixRelativeCssUrls(cssText, baseUrl) {
    var cssUrls = cssText.replace(regex.cssComments, "").match(regex.cssUrls) || [];
    cssUrls.forEach((function(cssUrl) {
        var oldUrl = cssUrl.replace(regex.cssUrls, "$1");
        var newUrl = getFullUrl(oldUrl, baseUrl);
        cssText = cssText.replace(cssUrl, cssUrl.replace(oldUrl, newUrl));
    }));
    return cssText;
}

function fixVarNames() {
    var varObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reLeadingHyphens = /^-{2}/;
    return Object.keys(varObj).reduce((function(obj, value) {
        var key = reLeadingHyphens.test(value) ? value : "--".concat(value.replace(/^-+/, ""));
        obj[key] = varObj[value];
        return obj;
    }), {});
}

function getFullUrl(url) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
    var d = document.implementation.createHTMLDocument("");
    var b = d.createElement("base");
    var a = d.createElement("a");
    d.head.appendChild(b);
    d.body.appendChild(a);
    b.href = base;
    a.href = url;
    return a.href;
}

function getTimeStamp() {
    return isBrowser && (window.performance || {}).now ? window.performance.now() : (new Date).getTime();
}

function resetCssNodes(rootElement) {
    var resetDOMVariableStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var resetNodes = [].slice.call(rootElement.querySelectorAll('[data-cssvars="skip"],[data-cssvars="src"]'));
    resetNodes.forEach((function(node) {
        return node.setAttribute("data-cssvars", "");
    }));
    if (resetDOMVariableStore) {
        variableStore.dom = {};
    }
}

/* harmony default export */ __webpack_exports__["a"] = (cssVars);
//# sourceMappingURL=css-vars-ponyfill.esm.js.map


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Vue Cookies v1.8.1
 * https://github.com/cmp-cc/vue-cookies
 *
 * Copyright 2016, cmp-cc
 * Released under the MIT license
 */

 (function () {

  var defaultConfig = {
    expires: '1d',
    path: '; path=/',
    domain: '',
    secure: '',
    sameSite: '; SameSite=Lax'
  };

  var VueCookies = {
    // install of Vue
    install: function (Vue, options) {
      if (options) this.config(options.expires, options.path, options.domain, options.secure, options.sameSite);
      if (Vue.prototype) Vue.prototype.$cookies = this;
      if (Vue.config && Vue.config.globalProperties) {
        Vue.config.globalProperties.$cookies = this;
        Vue.provide('$cookies', this);
      }
      Vue.$cookies = this;
    },
    config: function (expires, path, domain, secure, sameSite) {
      defaultConfig.expires = expires ? expires : '1d';
      defaultConfig.path = path ? '; path=' + path : '; path=/';
      defaultConfig.domain = domain ? '; domain=' + domain : '';
      defaultConfig.secure = secure ? '; Secure' : '';
      defaultConfig.sameSite = sameSite ? '; SameSite=' + sameSite : '; SameSite=Lax';
    },
    get: function (key) {
      var value = decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;

      if (value && value.substring(0, 1) === '{' && value.substring(value.length - 1, value.length) === '}') {
        try {
          value = JSON.parse(value);
        } catch (e) {
          return value;
        }
      }
      return value;
    },
    set: function (key, value, expires, path, domain, secure, sameSite) {
      if (!key) {
        throw new Error('Cookie name is not found in the first argument.');
      } else if (/^(?:expires|max\-age|path|domain|secure|SameSite)$/i.test(key)) {
        throw new Error('Cookie name illegality. Cannot be set to ["expires","max-age","path","domain","secure","SameSite"]\t current key name: ' + key);
      }
      // support json object
      if (value && value.constructor === Object) {
        value = JSON.stringify(value);
      }
      var _expires = '';
      expires = expires == undefined ? defaultConfig.expires : expires;
      if (expires && expires != 0) {
        switch (expires.constructor) {
          case Number:
            if (expires === Infinity || expires === -1) _expires = '; expires=Fri, 31 Dec 9999 23:59:59 GMT';
            else _expires = '; max-age=' + expires;
            break;
          case String:
            if (/^(?:\d+(y|m|d|h|min|s))$/i.test(expires)) {
              // get capture number group
              var _expireTime = expires.replace(/^(\d+)(?:y|m|d|h|min|s)$/i, '$1');
              // get capture type group , to lower case
              switch (expires.replace(/^(?:\d+)(y|m|d|h|min|s)$/i, '$1').toLowerCase()) {
                  // Frequency sorting
                case 'm':
                  _expires = '; max-age=' + +_expireTime * 2592000;
                  break; // 60 * 60 * 24 * 30
                case 'd':
                  _expires = '; max-age=' + +_expireTime * 86400;
                  break; // 60 * 60 * 24
                case 'h':
                  _expires = '; max-age=' + +_expireTime * 3600;
                  break; // 60 * 60
                case 'min':
                  _expires = '; max-age=' + +_expireTime * 60;
                  break; // 60
                case 's':
                  _expires = '; max-age=' + _expireTime;
                  break;
                case 'y':
                  _expires = '; max-age=' + +_expireTime * 31104000;
                  break; // 60 * 60 * 24 * 30 * 12
                default:
                  new Error('unknown exception of "set operation"');
              }
            } else {
              _expires = '; expires=' + expires;
            }
            break;
          case Date:
            _expires = '; expires=' + expires.toUTCString();
            break;
        }
      }
      document.cookie =
          encodeURIComponent(key) + '=' + encodeURIComponent(value) +
          _expires +
          (domain ? '; domain=' + domain : defaultConfig.domain) +
          (path ? '; path=' + path : defaultConfig.path) +
          (secure == undefined ? defaultConfig.secure : secure ? '; Secure' : '') +
          (sameSite == undefined ? defaultConfig.sameSite : (sameSite ? '; SameSite=' + sameSite : ''));
      return this;
    },
    remove: function (key, path, domain) {
      if (!key || !this.isKey(key)) {
        return false;
      }
      document.cookie = encodeURIComponent(key) +
          '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
          (domain ? '; domain=' + domain : defaultConfig.domain) +
          (path ? '; path=' + path : defaultConfig.path) +
          '; SameSite=Lax';
      return true;
    },
    isKey: function (key) {
      return (new RegExp('(?:^|;\\s*)' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=')).test(document.cookie);
    },
    keys: function () {
      if (!document.cookie) return [];
      var _keys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
      for (var _index = 0; _index < _keys.length; _index++) {
        _keys[_index] = decodeURIComponent(_keys[_index]);
      }
      return _keys;
    }
  };

  if (true) {
    module.exports = VueCookies;
  } else if (typeof define == 'function' && define.amd) {
    define([], function () {
      return VueCookies;
    });
  } else if (window.Vue && window.Vue.use) {
    Vue.use(VueCookies);
  }
  // vue-cookies can exist independently,no dependencies library
  if (typeof window !== 'undefined') {
    window.$cookies = VueCookies;
  }

})();


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loadScript__ = __webpack_require__(733);

var MyMixin = {
  methods: {
    loadComponentScript: function loadComponentScript(componentName) {
      Object(__WEBPACK_IMPORTED_MODULE_0__loadScript__["a" /* loadScript */])("".concat(this.$root.site_url, "/wp-content/themes/wpvue/elements/").concat(componentName, "/").concat(componentName, ".min.js")).then(function () {}).catch(function () {
        return console.log("".concat(componentName, " script load error!!"));
      });
    },
    checkImageAsset: function checkImageAsset(assets) {
      if (assets) {
        return true;
      } else {
        throw new Error('Product assets missing');
      }
    },
    getBPMGlobalString: function getBPMGlobalString(num, text, name) {
      var globalString1 = text.replace("%numbercasino", num === null ? 0 : num);
      var globalString2 = globalString1.replace("%casino_casinos", num > 1 ? this.$root.i18n.casinos : this.$root.i18n.casino);
      var globalString3 = globalString2.replace("%payment", name);
      return globalString3;
    },
    getPLGlobalString: function getPLGlobalString(num, text, name) {
      var globalString1 = text.replace("%numbercasino", num === null ? 0 : num);
      var globalString2 = globalString1.replace("%casino_casinos", num > 1 ? this.$root.i18n.casinos : this.$root.i18n.casino);
      var globalString3 = globalString2.replace("%software", name);
      return globalString3;
    },
    getPaymentGlobalString: function getPaymentGlobalString(text, payment) {
      var globalString = text.replace("%payment", payment);
      return globalString;
    },
    getPartnerGlobalString: function getPartnerGlobalString(text, partner) {
      var globalString = text.replace("%partner", partner);
      return globalString;
    },
    checkPlayFreeButton: function checkPlayFreeButton() {
      var countryCode = this.$cookies.get("wp-country");

      if (this.$root.free_games_global_countries != '') {
        if (this.$root.free_games_global_countries.includes(countryCode)) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    validPromotionCountryCode: function validPromotionCountryCode(data) {
      var countryCode = this.$cookies.get("wp-country");

      if (data && data.country_code && data.country_code != '') {
        if (data.country_code.includes(countryCode)) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    getCASToplistShowHideData: function getCASToplistShowHideData(partner) {
      var hideBonus = partner.hasOwnProperty('show_bonus') && partner.show_bonus === '1' ? "0" : "1";
      var hideToplist = partner.hasOwnProperty('hide_toplist') ? partner.hide_toplist : "0";

      if (partner.banned_time_from != null && partner.banned_time_to != null) {
        var current_time = new Date(); //Current Time
        // Start Time

        var startTime = partner.banned_time_from;
        var banned_time_from = new Date(current_time.getTime());
        banned_time_from.setHours(startTime.split(":")[0]);
        banned_time_from.setMinutes(startTime.split(":")[1]);
        banned_time_from.setSeconds(startTime.split(":")[2]); //End Time

        var endTime = partner.banned_time_to;
        var banned_time_to = new Date(current_time.getTime());
        banned_time_to.setHours(endTime.split(":")[0]);
        banned_time_to.setMinutes(endTime.split(":")[1]);
        banned_time_to.setSeconds(endTime.split(":")[2]); //if (banned_time_from > banned_time_to) (new Date(partner.banned_time_from).setDate
        //(new Date(partner.banned_time_from).getDate() + 1))

        if (banned_time_from <= current_time && current_time <= banned_time_to) {
          // Hide Bonus and modify variablesbanned_time_from <= (new Date().setDate
          //(new Date().getDate() + 1)) &&
          hideBonus = partner.hide_bonus;
          hideToplist = partner.hide_toplist;
        }
      }

      return {
        'hide_bonus': hideBonus,
        'hide_toplist': hideToplist
      };
    },
    getCASDataImage: function getCASDataImage(assetdata, size) {
      return assetdata.filter(function (ele) {
        return ele.asset_category_name === size;
      }).length > 0 ? true : false;
    },
    getAltText: function getAltText(altText, url) {
      var textAlt = '';

      if (altText && altText != '') {
        textAlt = altText;
      } else {
        if (url) textAlt = url.substring(url.lastIndexOf('/') + 1).split('.')[0];
      }

      return textAlt;
    },
    getProviderLink: function getProviderLink(provider_link, slug) {
      var expression = /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
      var regex = new RegExp(expression);

      if (provider_link) {
        if (provider_link.match(regex)) {
          return provider_link;
        } else {
          return "https://".concat(provider_link);
        }
      } else {
        throw new Error('Provider Link missing');
      }
    },
    getGoLink: function getGoLink(go_link, slug) {
      var expression = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
      var regex = new RegExp(expression);

      if (go_link) {
        if (go_link.match(regex)) {
          return go_link;
        } else {
          return "".concat(this.$root.site_url, "/").concat(go_link, "/").concat(slug);
        }
      } else {
        throw new Error('Goto Link missing');
      }
    },
    getRouteLink: function getRouteLink(slug, type) {
      var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var post_types = Object.values(wpvue_script_data_params.data.post_types);

      if (slug === 'home') {
        return "/";
      } else {
        if (post_types.indexOf(type) > -1) return base ? "/".concat(base, "/").concat(slug) : "/".concat(type, "/").concat(slug ? slug.replace('/', '') : '');else return base ? "/".concat(base, "/").concat(slug) : "/".concat(slug ? slug.replace('/', '') : '');
      }
    },
    hasCoreBlock: function hasCoreBlock(block) {
      var vue_blocks = Object.values(wpvue_script_data_params.data.vue_blocks);
      if (!(vue_blocks.indexOf(block) > -1)) return true;else return false;
    },
    hasTag: function hasTag(tags) {
      if (tags) {
        var wpTags = wpvue_script_data_params.data.site_data.cas_data.tags_label;

        if (wpTags && wpTags.length > 0) {
          var casTags = tags.split(',');
          var tagObject = {};

          for (var i = 0; i < wpTags.length; i++) {
            var count = 0;

            for (var j = 0; j < casTags.length; j++) {
              if (wpTags[i].tag_name.toLowerCase() === casTags[j].toLowerCase() && count === 0) {
                tagObject = wpTags[i];
                count++;
                break;
              }
            }

            if (count === 1) {
              break;
            }
          }

          return tagObject;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    utf8Decode: function utf8Decode(utf8String) {
      if (typeof utf8String != 'string') throw new TypeError('parameter ‘utf8String’ is not a string'); // note: decode 3-byte chars first as decoded 2-byte strings could appear to be 3-byte char!

      var unicodeString = utf8String.replace(/[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g, // 3-byte chars
      function (c) {
        // (note parentheses for precedence)
        var cc = (c.charCodeAt(0) & 0x0f) << 12 | (c.charCodeAt(1) & 0x3f) << 6 | c.charCodeAt(2) & 0x3f;
        return String.fromCharCode(cc);
      }).replace(/[\u00c0-\u00df][\u0080-\u00bf]/g, // 2-byte chars
      function (c) {
        // (note parentheses for precedence)
        var cc = (c.charCodeAt(0) & 0x1f) << 6 | c.charCodeAt(1) & 0x3f;
        return String.fromCharCode(cc);
      });
      return unicodeString;
    },
    youtubeInit: function youtubeInit() {
      var recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', this.$root.youtube_script_path);
      document.head.appendChild(recaptchaScript);
    },
    fbInit: function fbInit() {
      window.fbAsyncInit = function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];

        if (d.getElementById(id)) {
          return;
        }

        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, "script", "facebook-jssdk");
    },
    twitterInit: function twitterInit() {
      window.twttr = function (d, s, id) {
        var t,
            js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
        return window.twttr || (t = {
          _e: [],
          ready: function ready(f) {
            t._e.push(f);
          }
        });
      }(document, "script", "twitter-wjs");
    },
    instagramInit: function instagramInit() {
      window.instagram = function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];

        if (!d.getElementById(id)) {
          js = d.createElement(s);
          js.setAttribute("onLoad", "window.instgrm.Embeds.process()");
          js.id = id;
          js.src = "https://platform.instagram.com/en_US/embeds.js";
          fjs.parentNode.insertBefore(js, fjs);
        }
      }(document, "script", "instagram-wjs");
    },
    tumblrInit: function tumblrInit() {
      window.tumblr = function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];

        if (d.getElementById(id)) {
          return;
        }

        js = d.createElement(s);
        js.id = id;
        js.src = "https://assets.tumblr.com/post.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, "script", "tumblr-wjs");
    },
    tiktokInit: function tiktokInit() {
      window.tiktok = function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];

        if (d.getElementById(id)) {
          return;
        }

        js = d.createElement(s);
        js.id = id;
        js.src = "https://www.tiktok.com/embed.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, "script", "tiktok-wjs");
    },
    titleCase: function titleCase(str) {
      var splitStr = str.toLowerCase().split(' ');

      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      } // Directly return the joined string


      return splitStr.join(' ');
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (MyMixin);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unloadScript */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadScript; });
function loadScript(src) {
  // eslint-disable-line no-param-reassign
  return new Promise(function (resolve, reject) {
    var shouldAppend = false;
    var el = document.querySelector('script[src="' + src + '"]');

    if (!el) {
      el = document.createElement("script");
      el.type = "text/javascript";
      el.async = true;
      el.src = src;
      shouldAppend = true;
    } else if (el.hasAttribute("data-loaded")) {
      resolve(el);
      return;
    }

    el.addEventListener("error", reject);
    el.addEventListener("abort", reject);
    el.addEventListener("load", function loadScriptHandler() {
      el.setAttribute("data-loaded", true);
      resolve(el);
    });
    if (shouldAppend) document.head.appendChild(el);
  });
}

function unloadScript(src) {
  // eslint-disable-line no-param-reassign
  return new Promise(function (resolve, reject) {
    var el = document.querySelector('script[src="' + src + '"]');

    if (!el) {
      reject();
      return;
    }

    document.head.removeChild(el);
    resolve();
  });
}



/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports["vue-js-modal"]=e():t["vue-js-modal"]=e()}(window,function(){return i={},o.m=n=[function(t,e,n){var i=n(7);"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);(0,n(4).default)("d763679c",i,!1,{})},function(t,e,n){var i=n(10);"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);(0,n(4).default)("6b9cc0e0",i,!1,{})},function(t,e,n){var i=n(12);"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);(0,n(4).default)("663c004e",i,!1,{})},function(t,e){t.exports=function(n){var s=[];return s.toString=function(){return this.map(function(t){var e=function(t,e){var n=t[1]||"",i=t[3];if(!i)return n;if(e&&"function"==typeof btoa){var o=function(t){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */"}(i),r=i.sources.map(function(t){return"/*# sourceURL="+i.sourceRoot+t+" */"});return[n].concat(r).concat([o]).join("\n")}return[n].join("\n")}(t,n);return t[2]?"@media "+t[2]+"{"+e+"}":e}).join("")},s.i=function(t,e){"string"==typeof t&&(t=[[null,t,""]]);for(var n={},i=0;i<this.length;i++){var o=this[i][0];"number"==typeof o&&(n[o]=!0)}for(i=0;i<t.length;i++){var r=t[i];"number"==typeof r[0]&&n[r[0]]||(e&&!r[2]?r[2]=e:e&&(r[2]="("+r[2]+") and ("+e+")"),s.push(r))}},s}},function(t,e,n){"use strict";function l(t,e){for(var n=[],i={},o=0;o<e.length;o++){var r=e[o],s=r[0],a={id:t+":"+o,css:r[1],media:r[2],sourceMap:r[3]};i[s]?i[s].parts.push(a):n.push(i[s]={id:s,parts:[a]})}return n}n.r(e),n.d(e,"default",function(){return v});var i="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!i)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var u={},o=i&&(document.head||document.getElementsByTagName("head")[0]),r=null,s=0,c=!1,a=function(){},d=null,h="data-vue-ssr-id",f="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function v(s,t,e,n){c=e,d=n||{};var a=l(s,t);return p(a),function(t){for(var e=[],n=0;n<a.length;n++){var i=a[n];(o=u[i.id]).refs--,e.push(o)}t?p(a=l(s,t)):a=[];for(n=0;n<e.length;n++){var o;if(0===(o=e[n]).refs){for(var r=0;r<o.parts.length;r++)o.parts[r]();delete u[o.id]}}}}function p(t){for(var e=0;e<t.length;e++){var n=t[e],i=u[n.id];if(i){i.refs++;for(var o=0;o<i.parts.length;o++)i.parts[o](n.parts[o]);for(;o<n.parts.length;o++)i.parts.push(b(n.parts[o]));i.parts.length>n.parts.length&&(i.parts.length=n.parts.length)}else{var r=[];for(o=0;o<n.parts.length;o++)r.push(b(n.parts[o]));u[n.id]={id:n.id,refs:1,parts:r}}}}function m(){var t=document.createElement("style");return t.type="text/css",o.appendChild(t),t}function b(e){var n,i,t=document.querySelector("style["+h+'~="'+e.id+'"]');if(t){if(c)return a;t.parentNode.removeChild(t)}if(f){var o=s++;t=r=r||m(),n=w.bind(null,t,o,!1),i=w.bind(null,t,o,!0)}else t=m(),n=function(t,e){var n=e.css,i=e.media,o=e.sourceMap;i&&t.setAttribute("media",i);d.ssrId&&t.setAttribute(h,e.id);o&&(n+="\n/*# sourceURL="+o.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */");if(t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}.bind(null,t),i=function(){t.parentNode.removeChild(t)};return n(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;n(e=t)}else i()}}var g,y=(g=[],function(t,e){return g[t]=e,g.filter(Boolean).join("\n")});function w(t,e,n,i){var o=n?"":i.css;if(t.styleSheet)t.styleSheet.cssText=y(e,o);else{var r=document.createTextNode(o),s=t.childNodes;s[e]&&t.removeChild(s[e]),s.length?t.insertBefore(r,s[e]):t.appendChild(r)}}},function(t,z,e){"use strict";(function(t){var i=function(){if("undefined"!=typeof Map)return Map;function i(t,n){var i=-1;return t.some(function(t,e){return t[0]===n&&(i=e,!0)}),i}return Object.defineProperty(t.prototype,"size",{get:function(){return this.__entries__.length},enumerable:!0,configurable:!0}),t.prototype.get=function(t){var e=i(this.__entries__,t),n=this.__entries__[e];return n&&n[1]},t.prototype.set=function(t,e){var n=i(this.__entries__,t);~n?this.__entries__[n][1]=e:this.__entries__.push([t,e])},t.prototype.delete=function(t){var e=this.__entries__,n=i(e,t);~n&&e.splice(n,1)},t.prototype.has=function(t){return!!~i(this.__entries__,t)},t.prototype.clear=function(){this.__entries__.splice(0)},t.prototype.forEach=function(t,e){void 0===e&&(e=null);for(var n=0,i=this.__entries__;n<i.length;n++){var o=i[n];t.call(e,o[1],o[0])}},t;function t(){this.__entries__=[]}}(),n="undefined"!=typeof window&&"undefined"!=typeof document&&window.document===document,e=void 0!==t&&t.Math===Math?t:"undefined"!=typeof self&&self.Math===Math?self:"undefined"!=typeof window&&window.Math===Math?window:Function("return this")(),l="function"==typeof requestAnimationFrame?requestAnimationFrame.bind(e):function(t){return setTimeout(function(){return t(Date.now())},1e3/60)},u=2;var o=["top","right","bottom","left","width","height","size","weight"],r="undefined"!=typeof MutationObserver,s=(a.prototype.addObserver=function(t){~this.observers_.indexOf(t)||this.observers_.push(t),this.connected_||this.connect_()},a.prototype.removeObserver=function(t){var e=this.observers_,n=e.indexOf(t);~n&&e.splice(n,1),!e.length&&this.connected_&&this.disconnect_()},a.prototype.refresh=function(){this.updateObservers_()&&this.refresh()},a.prototype.updateObservers_=function(){var t=this.observers_.filter(function(t){return t.gatherActive(),t.hasActive()});return t.forEach(function(t){return t.broadcastActive()}),0<t.length},a.prototype.connect_=function(){n&&!this.connected_&&(document.addEventListener("transitionend",this.onTransitionEnd_),window.addEventListener("resize",this.refresh),r?(this.mutationsObserver_=new MutationObserver(this.refresh),this.mutationsObserver_.observe(document,{attributes:!0,childList:!0,characterData:!0,subtree:!0})):(document.addEventListener("DOMSubtreeModified",this.refresh),this.mutationEventsAdded_=!0),this.connected_=!0)},a.prototype.disconnect_=function(){n&&this.connected_&&(document.removeEventListener("transitionend",this.onTransitionEnd_),window.removeEventListener("resize",this.refresh),this.mutationsObserver_&&this.mutationsObserver_.disconnect(),this.mutationEventsAdded_&&document.removeEventListener("DOMSubtreeModified",this.refresh),this.mutationsObserver_=null,this.mutationEventsAdded_=!1,this.connected_=!1)},a.prototype.onTransitionEnd_=function(t){var e=t.propertyName,n=void 0===e?"":e;o.some(function(t){return!!~n.indexOf(t)})&&this.refresh()},a.getInstance=function(){return this.instance_||(this.instance_=new a),this.instance_},a.instance_=null,a);function a(){function t(){r&&(r=!1,i()),s&&n()}function e(){l(t)}function n(){var t=Date.now();if(r){if(t-a<u)return;s=!0}else s=!(r=!0),setTimeout(e,o);a=t}var i,o,r,s,a;this.connected_=!1,this.mutationEventsAdded_=!1,this.mutationsObserver_=null,this.observers_=[],this.onTransitionEnd_=this.onTransitionEnd_.bind(this),this.refresh=(i=this.refresh.bind(this),s=r=!(o=20),a=0,n)}var c=function(t,e){for(var n=0,i=Object.keys(e);n<i.length;n++){var o=i[n];Object.defineProperty(t,o,{value:e[o],enumerable:!1,writable:!1,configurable:!0})}return t},h=function(t){return t&&t.ownerDocument&&t.ownerDocument.defaultView||e},f=g(0,0,0,0);function v(t){return parseFloat(t)||0}function p(n){for(var t=[],e=1;e<arguments.length;e++)t[e-1]=arguments[e];return t.reduce(function(t,e){return t+v(n["border-"+e+"-width"])},0)}function d(t){var e=t.clientWidth,n=t.clientHeight;if(!e&&!n)return f;var i,o=h(t).getComputedStyle(t),r=function(t){for(var e={},n=0,i=["top","right","bottom","left"];n<i.length;n++){var o=i[n],r=t["padding-"+o];e[o]=v(r)}return e}(o),s=r.left+r.right,a=r.top+r.bottom,l=v(o.width),u=v(o.height);if("border-box"===o.boxSizing&&(Math.round(l+s)!==e&&(l-=p(o,"left","right")+s),Math.round(u+a)!==n&&(u-=p(o,"top","bottom")+a)),(i=t)!==h(i).document.documentElement){var c=Math.round(l+s)-e,d=Math.round(u+a)-n;1!==Math.abs(c)&&(l-=c),1!==Math.abs(d)&&(u-=d)}return g(r.left,r.top,l,u)}var m="undefined"!=typeof SVGGraphicsElement?function(t){return t instanceof h(t).SVGGraphicsElement}:function(t){return t instanceof h(t).SVGElement&&"function"==typeof t.getBBox};function b(t){return n?m(t)?g(0,0,(e=t.getBBox()).width,e.height):d(t):f;var e}function g(t,e,n,i){return{x:t,y:e,width:n,height:i}}var y=(w.prototype.isActive=function(){var t=b(this.target);return(this.contentRect_=t).width!==this.broadcastWidth||t.height!==this.broadcastHeight},w.prototype.broadcastRect=function(){var t=this.contentRect_;return this.broadcastWidth=t.width,this.broadcastHeight=t.height,t},w);function w(t){this.broadcastWidth=0,this.broadcastHeight=0,this.contentRect_=g(0,0,0,0),this.target=t}var _=function(t,e){var n,i,o,r,s,a,l,u=(i=(n=e).x,o=n.y,r=n.width,s=n.height,a="undefined"!=typeof DOMRectReadOnly?DOMRectReadOnly:Object,l=Object.create(a.prototype),c(l,{x:i,y:o,width:r,height:s,top:o,right:i+r,bottom:s+o,left:i}),l);c(this,{target:t,contentRect:u})},E=(x.prototype.observe=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof h(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)||(e.set(t,new y(t)),this.controller_.addObserver(this),this.controller_.refresh())}},x.prototype.unobserve=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof h(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)&&(e.delete(t),e.size||this.controller_.removeObserver(this))}},x.prototype.disconnect=function(){this.clearActive(),this.observations_.clear(),this.controller_.removeObserver(this)},x.prototype.gatherActive=function(){var e=this;this.clearActive(),this.observations_.forEach(function(t){t.isActive()&&e.activeObservations_.push(t)})},x.prototype.broadcastActive=function(){if(this.hasActive()){var t=this.callbackCtx_,e=this.activeObservations_.map(function(t){return new _(t.target,t.broadcastRect())});this.callback_.call(t,e,t),this.clearActive()}},x.prototype.clearActive=function(){this.activeObservations_.splice(0)},x.prototype.hasActive=function(){return 0<this.activeObservations_.length},x);function x(t,e,n){if(this.activeObservations_=[],this.observations_=new i,"function"!=typeof t)throw new TypeError("The callback provided as parameter 1 is not a function.");this.callback_=t,this.controller_=e,this.callbackCtx_=n}var T=new("undefined"!=typeof WeakMap?WeakMap:i),O=function t(e){if(!(this instanceof t))throw new TypeError("Cannot call a class as a function.");if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");var n=s.getInstance(),i=new E(e,n,this);T.set(this,i)};["observe","unobserve","disconnect"].forEach(function(e){O.prototype[e]=function(){var t;return(t=T.get(this))[e].apply(t,arguments)}});var S=void 0!==e.ResizeObserver?e.ResizeObserver:O;z.a=S}).call(this,e(8))},function(t,e,n){"use strict";var i=n(0);n.n(i).a},function(t,e,n){(t.exports=n(3)(!1)).push([t.i,"\n.vue-modal-top,\n.vue-modal-bottom,\n.vue-modal-left,\n.vue-modal-right,\n.vue-modal-topRight,\n.vue-modal-topLeft,\n.vue-modal-bottomLeft,\n.vue-modal-bottomRight {\n  display: block;\n  overflow: hidden;\n  position: absolute;\n  background: transparent;\n  z-index: 9999999;\n}\n.vue-modal-topRight,\n.vue-modal-topLeft,\n.vue-modal-bottomLeft,\n.vue-modal-bottomRight {\n  width: 12px;\n  height: 12px;\n}\n.vue-modal-top {\n  right: 12;\n  top: 0;\n  width: 100%;\n  height: 12px;\n  cursor: n-resize;\n}\n.vue-modal-bottom {\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 12px;\n  cursor: s-resize;\n}\n.vue-modal-left {\n  left: 0;\n  top: 0;\n  width: 12px;\n  height: 100%;\n  cursor: w-resize;\n}\n.vue-modal-right {\n  right: 0;\n  top: 0;\n  width: 12px;\n  height: 100%;\n  cursor: e-resize;\n}\n.vue-modal-topRight {\n  right: 0;\n  top: 0;\n  background: transparent;\n  cursor: ne-resize;\n}\n.vue-modal-topLeft {\n  left: 0;\n  top: 0;\n  cursor: nw-resize;\n}\n.vue-modal-bottomLeft {\n  left: 0;\n  bottom: 0;\n  cursor: sw-resize;\n}\n.vue-modal-bottomRight {\n  right: 0;\n  bottom: 0;\n  cursor: se-resize;\n}\n#vue-modal-triangle::after {\n  display: block;\n  position: absolute;\n  content: '';\n  background: transparent;\n  left: 0;\n  top: 0;\n  width: 0;\n  height: 0;\n  border-bottom: 10px solid #ddd;\n  border-left: 10px solid transparent;\n}\n#vue-modal-triangle.clicked::after {\n  border-bottom: 10px solid #369be9;\n}\n",""])},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";var i=n(1);n.n(i).a},function(t,e,n){(t.exports=n(3)(!1)).push([t.i,"\n.vm--block-scroll {\n  overflow: hidden;\n  width: 100vw;\n}\n.vm--container {\n  position: fixed;\n  box-sizing: border-box;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 999;\n}\n.vm--overlay {\n  position: fixed;\n  box-sizing: border-box;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.2);\n  /* z-index: 999; */\n  opacity: 1;\n}\n.vm--container.scrollable {\n  height: 100%;\n  min-height: 100vh;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.vm--modal {\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  background-color: white;\n  border-radius: 3px;\n  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);\n}\n.vm--container.scrollable .vm--modal {\n  margin-bottom: 2px;\n}\n.vm--top-right-slot {\n  display: block;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.vm-transition--overlay-enter-active,\n.vm-transition--overlay-leave-active {\n  transition: all 50ms;\n}\n.vm-transition--overlay-enter,\n.vm-transition--overlay-leave-active {\n  opacity: 0;\n}\n.vm-transition--modal-enter-active,\n.vm-transition--modal-leave-active {\n  transition: all 400ms;\n}\n.vm-transition--modal-enter,\n.vm-transition--modal-leave-active {\n  opacity: 0;\n  transform: translateY(-20px);\n}\n.vm-transition--default-enter-active,\n.vm-transition--default-leave-active {\n  transition: all 2ms;\n}\n.vm-transition--default-enter,\n.vm-transition--default-leave-active {\n  opacity: 0;\n}\n",""])},function(t,e,n){"use strict";var i=n(2);n.n(i).a},function(t,e,n){(t.exports=n(3)(!1)).push([t.i,"\n.vue-dialog {\n  font-size: 14px;\n}\n.vue-dialog div {\n  box-sizing: border-box;\n}\n.vue-dialog-content {\n  flex: 1 0 auto;\n  width: 100%;\n  padding: 14px;\n}\n.vue-dialog-content-title {\n  font-weight: 600;\n  padding-bottom: 14px;\n}\n.vue-dialog-buttons {\n  display: flex;\n  flex: 0 1 auto;\n  width: 100%;\n  border-top: 1px solid #eee;\n}\n.vue-dialog-buttons-none {\n  width: 100%;\n  padding-bottom: 14px;\n}\n.vue-dialog-button {\n  font-size: inherit;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  cursor: pointer;\n  box-sizing: border-box;\n  line-height: 40px;\n  height: 40px;\n  color: inherit;\n  font: inherit;\n  outline: none;\n}\n.vue-dialog-button:hover {\n  background: #f9f9f9;\n}\n.vue-dialog-button:active {\n  background: #f3f3f3;\n}\n.vue-dialog-button:not(:first-of-type) {\n  border-left: 1px solid #eee;\n}\n",""])},function(t,e,n){"use strict";n.r(e),n.d(e,"Modal",function(){return W}),n.d(e,"Dialog",function(){return X}),n.d(e,"version",function(){return J});function i(){var e=this,t=e.$createElement,n=e._self._c||t;return e.visible?n("div",{class:e.containerClass},[n("transition",{attrs:{name:e.guaranteedOverlayTransition},on:{"before-enter":e.beforeOverlayTransitionEnter,"after-enter":e.afterOverlayTransitionEnter,"before-leave":e.beforeOverlayTransitionLeave,"after-leave":e.afterOverlayTransitionLeave}},[e.visibility.overlay?n("div",{staticClass:"vm--overlay",attrs:{"data-modal":e.name,"aria-expanded":e.visibility.overlay.toString()},on:{click:function(t){return t.target!==t.currentTarget?null:(t.stopPropagation(),e.onOverlayClick(t))}}},[n("div",{staticClass:"vm--top-right-slot"},[e._t("top-right")],2)]):e._e()]),e._v(" "),n("transition",{attrs:{name:e.guaranteedModalTransition},on:{"before-enter":e.beforeModalTransitionEnter,"after-enter":e.afterModalTransitionEnter,"before-leave":e.beforeModalTransitionLeave,"after-leave":e.afterModalTransitionLeave}},[e.visibility.modal?n("div",{ref:"modal",class:e.modalClass,style:e.modalStyle,attrs:{"aria-expanded":e.visibility.modal.toString(),role:"dialog","aria-modal":"true"}},[e._t("default"),e._v(" "),e.resizable&&!e.isAutoHeight?n("resizer",{attrs:{"min-width":e.minWidth,"min-height":e.minHeight,"max-width":e.maxWidth,"max-height":e.maxHeight,"viewport-height":e.viewportHeight,"viewport-width":e.viewportWidth,"resize-indicator":e.resizeIndicator,"resize-edges":e.resizeEdges},on:{resize:e.onModalResize}}):e._e()],2):e._e()])],1):e._e()}function o(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[this.resizeEdges.includes("t")?n("div",{staticClass:"vue-modal-top"}):t._e(),t._v(" "),this.resizeEdges.includes("b")?n("div",{staticClass:"vue-modal-bottom"}):t._e(),t._v(" "),this.resizeEdges.includes("l")?n("div",{staticClass:"vue-modal-left"}):t._e(),t._v(" "),this.resizeEdges.includes("r")?n("div",{staticClass:"vue-modal-right"}):t._e(),t._v(" "),this.resizeEdges.includes("tr")?n("div",{staticClass:"vue-modal-topRight"}):t._e(),t._v(" "),this.resizeEdges.includes("tl")?n("div",{staticClass:"vue-modal-topLeft"}):t._e(),t._v(" "),this.resizeEdges.includes("br")?n("div",{class:t.className,attrs:{id:t.getID}}):t._e(),t._v(" "),this.resizeEdges.includes("bl")?n("div",{staticClass:"vue-modal-bottomLeft"}):t._e()])}o._withStripped=i._withStripped=!0;function h(t,e,n){return n<t?t:e<n?e:n}function r(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function s(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=[],i=!0,o=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(i=(s=a.next()).done)&&(n.push(s.value),!e||n.length!==e);i=!0);}catch(t){o=!0,r=t}finally{try{i||null==a.return||a.return()}finally{if(o)throw r}}return n}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function u(){var t=window.innerWidth,e=document.documentElement.clientWidth;return t&&e?Math.min(t,e):e||t}function a(t){return t.split(";").map(function(t){return t.trim()}).filter(Boolean).map(function(t){return t.split(":")}).reduce(function(t,e){var n=s(e,2);return function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable}))),i.forEach(function(t){r(e,t,n[t])})}return e}({},t,r({},n[0],n[1]))},{})}function f(t){return t.touches&&0<t.touches.length?t.touches[0]:t}var v=["INPUT","TEXTAREA","SELECT"],c=function(t){var e=0<arguments.length&&void 0!==t?t:0;return function(){return(e++).toString()}}(),l={name:"VueJsModalResizer",props:{minHeight:{type:Number,default:0},minWidth:{type:Number,default:0},maxWidth:{type:Number,default:Number.MAX_SAFE_INTEGER},maxHeight:{type:Number,default:Number.MAX_SAFE_INTEGER},viewportWidth:{type:Number,required:!0},viewportHeight:{type:Number,required:!0},resizeIndicator:{type:Boolean,default:!0},resizeEdges:{type:Array,required:!0}},data:function(){return{clicked:!1,targetClass:"",size:{},initialX:0,initialY:0}},mounted:function(){this.$el.addEventListener("mousedown",this.start,!1)},computed:{className:function(){return["vue-modal-bottomRight",{clicked:this.clicked}]},getID:function(){return this.resizeIndicator?"vue-modal-triangle":""}},methods:{start:function(t){this.targetClass=t.target.className,this.clicked=!0,this.initialX=t.clientX,this.initialY=t.clientY,window.addEventListener("mousemove",this.mousemove,!1),window.addEventListener("mouseup",this.stop,!1),t.stopPropagation(),t.preventDefault()},stop:function(){this.clicked=!1,this.clicked=!1,this.targetClass="",this.initialX=0,this.initialY=0,window.removeEventListener("mousemove",this.mousemove,!1),window.removeEventListener("mouseup",this.stop,!1),this.$emit("resize-stop",{element:this.$el.parentElement,size:this.size})},mousemove:function(t){this.resize(t)},resize:function(t){var e=this.$el.parentElement,n=t.clientX,i=t.clientY,o=parseInt(e.style.width.replace("px","")),r=parseInt(e.style.height.replace("px",""));if(!(t.clientX>this.viewportWidth||t.clientX<0)&&!(t.clientY>this.viewportHeight||t.clientY<0)&&e){switch(this.targetClass){case"vue-modal-right":n-=e.offsetLeft,i=r;break;case"vue-modal-left":i=r,n=o+(this.initialX-t.clientX);break;case"vue-modal-top":n=o,i=r+(this.initialY-t.clientY);break;case"vue-modal-bottom":n=o,i-=e.offsetTop;break;case"vue-modal-bottomRight":n-=e.offsetLeft,i-=e.offsetTop;break;case"vue-modal-topRight":n-=e.offsetLeft,i=r+(this.initialY-t.clientY);break;case"vue-modal-bottomLeft":n=o+(this.initialX-t.clientX),i-=e.offsetTop;break;case"vue-modal-topLeft":n=o+(this.initialX-t.clientX),i=r+(this.initialY-t.clientY);break;default:console.error("Incorrrect/no resize direction.")}var s=Math.min(u(),this.maxWidth),a=Math.min(window.innerHeight,this.maxHeight);n=h(this.minWidth,s,n),i=h(this.minHeight,a,i),this.initialX=t.clientX,this.initialY=t.clientY,this.size={width:n,height:i};var l={width:n-o,height:i-r};e.style.width=n+"px",e.style.height=i+"px",this.$emit("resize",{element:e,size:this.size,direction:this.targetClass,dimGrowth:l})}}}};n(6);function d(t,e,n,i,o,r,s,a){var l,u="function"==typeof t?t.options:t;if(e&&(u.render=e,u.staticRenderFns=n,u._compiled=!0),i&&(u.functional=!0),r&&(u._scopeId="data-v-"+r),s?(l=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),o&&o.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(s)},u._ssrRegister=l):o&&(l=a?function(){o.call(this,this.$root.$options.shadowRoot)}:o),l)if(u.functional){u._injectStyles=l;var c=u.render;u.render=function(t,e){return l.call(e),c(t,e)}}else{var d=u.beforeCreate;u.beforeCreate=d?[].concat(d,l):[l]}return{exports:t,options:u}}var p=d(l,o,[],!1,null,null,null);p.options.__file="src/components/Resizer.vue";var m=p.exports;function b(t){return(b="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function g(t){switch(b(t)){case"number":return{type:"px",value:t};case"string":return function(e){if("auto"===e)return{type:e,value:0};var t=_.find(function(t){return t.regexp.test(e)});return t?{type:t.name,value:parseFloat(e)}:{type:"",value:e}}(t);default:return{type:"",value:t}}}function y(t){if("string"!=typeof t)return 0<=t;var e=g(t);return("%"===e.type||"px"===e.type)&&0<e.value}var w="[-+]?[0-9]*.?[0-9]+",_=[{name:"px",regexp:new RegExp("^".concat(w,"px$"))},{name:"%",regexp:new RegExp("^".concat(w,"%$"))},{name:"px",regexp:new RegExp("^".concat(w,"$"))}],E=n(5),x="undefined"!=typeof window&&window.ResizeObserver?ResizeObserver:E.a;function T(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function O(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function S(t){return e='button:not([disabled]), select:not([disabled]), a[href]:not([disabled]), area[href]:not([disabled]), [contentEditable=""]:not([disabled]), [contentEditable="true"]:not([disabled]), [contentEditable="TRUE"]:not([disabled]), textarea:not([disabled]), iframe:not([disabled]), input:not([disabled]), summary:not([disabled]), [tabindex]:not([tabindex="-1"])',O(t.querySelectorAll(e)||[]);var e}function z(t){return t==document.activeElement}var M=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.root=null,this.elements=[],this.onKeyDown=this.onKeyDown.bind(this),this.enable=this.enable.bind(this),this.disable=this.disable.bind(this),this.firstElement=this.firstElement.bind(this),this.lastElement=this.lastElement.bind(this)}var e,n,i;return e=t,(n=[{key:"lastElement",value:function(){return this.elements[this.elements.length-1]||null}},{key:"firstElement",value:function(){return this.elements[0]||null}},{key:"onKeyDown",value:function(t){var e;if("Tab"===(e=t).key||9===e.keyCode)return t.shiftKey&&z(this.firstElement())?(this.lastElement().focus(),void t.preventDefault()):!document.activeElement||z(this.lastElement())?(this.firstElement().focus(),void t.preventDefault()):void 0}},{key:"enabled",value:function(){return!!this.root}},{key:"enable",value:function(t){if(t){this.root=t,this.elements=S(this.root);var e=this.firstElement();e&&e.focus(),this.root.addEventListener("keydown",this.onKeyDown)}}},{key:"disable",value:function(){this.root.removeEventListener("keydown",this.onKeyDown),this.root=null}}])&&T(e.prototype,n),i&&T(e,i),t}();function L(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function k(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=[],i=!0,o=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(i=(s=a.next()).done)&&(n.push(s.value),!e||n.length!==e);i=!0);}catch(t){o=!0,r=t}finally{try{i||null==a.return||a.return()}finally{if(o)throw r}}return n}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}var R="vm-transition--default",C="enter",$="entering",A="leave",j="leavng",H={name:"VueJsModal",props:{name:{required:!0,type:String},resizable:{type:Boolean,default:!1},resizeEdges:{default:function(){return["r","br","b","bl","l","tl","t","tr"]},validator:function(e){return["r","br","b","bl","l","tl","t","tr"].filter(function(t){return-1!==e.indexOf(t)}).length===e.length},type:Array},centerResize:{type:Boolean,default:!0},resizeIndicator:{type:Boolean,default:!0},adaptive:{type:Boolean,default:!1},draggable:{type:[Boolean,String],default:!1},scrollable:{type:Boolean,default:!1},focusTrap:{type:Boolean,default:!1},reset:{type:Boolean,default:!1},overlayTransition:{type:String,default:"vm-transition--overlay"},transition:{type:String,default:"vm-transition--modal"},clickToClose:{type:Boolean,default:!0},classes:{type:[String,Array],default:function(){return[]}},styles:{type:[String,Array,Object]},minWidth:{type:Number,default:0,validator:function(t){return 0<=t}},minHeight:{type:Number,default:0,validator:function(t){return 0<=t}},maxWidth:{type:Number,default:Number.MAX_SAFE_INTEGER},maxHeight:{type:Number,default:Number.MAX_SAFE_INTEGER},width:{type:[Number,String],default:600,validator:function(t){return"auto"===t||y(t)}},height:{type:[Number,String],default:300,validator:function(t){return"auto"===t||y(t)}},shiftX:{type:Number,default:.5,validator:function(t){return 0<=t&&t<=1}},shiftY:{type:Number,default:.5,validator:function(t){return 0<=t&&t<=1}}},components:{Resizer:m},data:function(){return{visible:!1,visibility:{modal:!1,overlay:!1},overlayTransitionState:null,modalTransitionState:null,shiftLeft:0,shiftTop:0,modal:{width:0,widthType:"px",height:0,heightType:"px",renderedHeight:0},viewportHeight:0,viewportWidth:0}},created:function(){this.setInitialSize()},beforeMount:function(){this.$modal.subscription.$on("toggle",this.onToggle),window.addEventListener("resize",this.onWindowResize),window.addEventListener("orientationchange",this.onWindowResize),this.onWindowResize(),this.scrollable&&!this.isAutoHeight&&console.warn('Modal "'.concat(this.name,'" has scrollable flag set to true ')+'but height is not "auto" ('.concat(this.height,")")),this.clickToClose&&window.addEventListener("keyup",this.onEscapeKeyUp)},mounted:function(){var n=this;this.resizeObserver=new x(function(t){if(0<t.length){var e=k(t,1)[0];n.modal.renderedHeight=e.contentRect.height}}),this.$focusTrap=new M},beforeDestroy:function(){this.$modal.subscription.$off("toggle",this.onToggle),window.removeEventListener("resize",this.onWindowResize),window.removeEventListener("orientationchange",this.onWindowResize),this.clickToClose&&window.removeEventListener("keyup",this.onEscapeKeyUp),document.body.classList.remove("vm--block-scroll")},computed:{guaranteedOverlayTransition:function(){return this.overlayTransition||R},guaranteedModalTransition:function(){return this.transition||R},isAutoHeight:function(){return"auto"===this.modal.heightType},position:function(){var t=this.viewportHeight,e=this.viewportWidth,n=this.shiftLeft,i=this.shiftTop,o=this.shiftX,r=this.shiftY,s=this.trueModalWidth,a=this.trueModalHeight,l=e-s,u=Math.max(t-a,0),c=i+r*u;return{left:parseInt(h(0,l,n+o*l)),top:!a&&this.isAutoHeight?void 0:parseInt(h(0,u,c))}},trueModalWidth:function(){var t=this.viewportWidth,e=this.modal,n=this.adaptive,i=this.minWidth,o=this.maxWidth,r="%"===e.widthType?t/100*e.width:e.width;if(n){var s=Math.max(i,Math.min(t,o));return h(i,s,r)}return r},trueModalHeight:function(){var t=this.viewportHeight,e=this.modal,n=this.isAutoHeight,i=this.adaptive,o=this.minHeight,r=this.maxHeight,s="%"===e.heightType?t/100*e.height:e.height;if(n)return this.modal.renderedHeight;if(i){var a=Math.max(o,Math.min(t,r));return h(o,a,s)}return s},autoHeight:function(){return this.adaptive&&this.modal.renderedHeight>=this.viewportHeight?Math.max(this.minHeight,this.viewportHeight)+"px":"auto"},containerClass:function(){return["vm--container",this.scrollable&&this.isAutoHeight&&"scrollable"]},modalClass:function(){return["vm--modal",this.classes]},stylesProp:function(){return"string"==typeof this.styles?a(this.styles):this.styles},modalStyle:function(){return[this.stylesProp,{top:this.position.top+"px",left:this.position.left+"px",width:this.trueModalWidth+"px",height:this.isAutoHeight?this.autoHeight:this.trueModalHeight+"px"}]},isComponentReadyToBeDestroyed:function(){return this.overlayTransitionState===A&&this.modalTransitionState===A}},watch:{isComponentReadyToBeDestroyed:function(t){t&&(this.visible=!1)}},methods:{startTransitionEnter:function(){this.visibility.overlay=!0,this.visibility.modal=!0},startTransitionLeave:function(){this.visibility.overlay=!1,this.visibility.modal=!1},beforeOverlayTransitionEnter:function(){this.overlayTransitionState=$},afterOverlayTransitionEnter:function(){this.overlayTransitionState=C},beforeOverlayTransitionLeave:function(){this.overlayTransitionState=j},afterOverlayTransitionLeave:function(){this.overlayTransitionState=A},beforeModalTransitionEnter:function(){var t=this;this.modalTransitionState=$,this.$nextTick(function(){t.resizeObserver.observe(t.$refs.modal)})},afterModalTransitionEnter:function(){this.modalTransitionState=C,this.draggable&&this.addDraggableListeners(),this.focusTrap&&this.$focusTrap.enable(this.$refs.modal);var t=this.createModalEvent({state:"opened"});this.$emit("opened",t)},beforeModalTransitionLeave:function(){this.modalTransitionState=j,this.resizeObserver.unobserve(this.$refs.modal),this.$focusTrap.enabled()&&this.$focusTrap.disable()},afterModalTransitionLeave:function(){this.modalTransitionState=A;var t=this.createModalEvent({state:"closed"});this.$emit("closed",t)},onToggle:function(t,e,n){if(this.name===t){var i=void 0===e?!this.visible:e;this.toggle(i,n)}},setInitialSize:function(){var t=g(this.width),e=g(this.height);this.modal.width=t.value,this.modal.widthType=t.type,this.modal.height=e.value,this.modal.heightType=e.type},onEscapeKeyUp:function(t){27===t.which&&this.visible&&this.$modal.hide(this.name)},onWindowResize:function(){this.viewportWidth=u(),this.viewportHeight=window.innerHeight,this.ensureShiftInWindowBounds()},createModalEvent:function(t){var e=0<arguments.length&&void 0!==t?t:{};return function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable}))),i.forEach(function(t){L(e,t,n[t])})}return e}({name:this.name,ref:this.$refs.modal||null},e)},onModalResize:function(t){this.modal.widthType="px",this.modal.width=t.size.width,this.modal.heightType="px",this.modal.height=t.size.height,this.centerResize||(this.shiftLeft=this.getResizedShiftLeft(t),this.shiftTop=this.getResizedShiftTop(t));var e=this.modal.size;this.$emit("resize",this.createModalEvent({size:e}))},getResizedShiftLeft:function(t){this.viewportHeight,this.viewportWidth,this.trueModalWidth,this.trueModalHeight;var e=this.shiftLeft;switch(t.direction){case"vue-modal-topRight":case"vue-modal-bottomRight":case"vue-modal-right":e+=.5*t.dimGrowth.width;break;case"vue-modal-bottomLeft":case"vue-modal-topLeft":case"vue-modal-left":e-=.5*t.dimGrowth.width;break;case"vue-modal-top":case"vue-modal-bottom":break;default:console.error("Could not Find Resize Direction In ShiftLeft")}return e},getResizedShiftTop:function(t){this.viewportHeight,this.viewportWidth,this.trueModalWidth,this.trueModalHeight;var e=this.shiftTop;switch(t.direction){case"vue-modal-bottom":case"vue-modal-bottomRight":case"vue-modal-bottomLeft":e+=.5*t.dimGrowth.height;break;case"vue-modal-top":case"vue-modal-topRight":case"vue-modal-topLeft":e-=.5*t.dimGrowth.height;break;case"vue-modal-left":case"vue-modal-right":break;default:console.error("Could not Find Resize Direction In ShiftTop")}return e},open:function(t){var e=this;this.reset&&(this.setInitialSize(),this.shiftLeft=0,this.shiftTop=0),this.scrollable&&document.body.classList.add("vm--block-scroll");var n=!1,i=this.createModalEvent({cancel:function(){n=!0},state:"before-open",params:t});this.$emit("before-open",i),n?this.scrollable&&document.body.classList.remove("vm--block-scroll"):("undefined"!=typeof document&&document.activeElement&&"BODY"!==document.activeElement.tagName&&document.activeElement.blur&&document.activeElement.blur(),this.visible=!0,this.$nextTick(function(){e.startTransitionEnter()}))},close:function(t){this.scrollable&&document.body.classList.remove("vm--block-scroll");var e=!1,n=this.createModalEvent({cancel:function(){e=!0},state:"before-close",params:t});this.$emit("before-close",n),e||this.startTransitionLeave()},toggle:function(t,e){this.visible!==t&&(t?this.open(e):this.close(e))},getDraggableElement:function(){return!0===this.draggable?this.$refs.modal:"string"==typeof this.draggable?this.$refs.modal.querySelector(this.draggable):null},onOverlayClick:function(){this.clickToClose&&this.toggle(!1)},addDraggableListeners:function(){var s=this,t=this.getDraggableElement();if(t){var a=0,l=0,u=0,c=0,e=function(t){var e=t.target;if(!(n=e)||-1===v.indexOf(n.nodeName)){var n,i=f(t),o=i.clientX,r=i.clientY;document.addEventListener("mousemove",d),document.addEventListener("touchmove",d),document.addEventListener("mouseup",h),document.addEventListener("touchend",h),a=o,l=r,u=s.shiftLeft,c=s.shiftTop}},d=function(t){var e=f(t),n=e.clientX,i=e.clientY;s.shiftLeft=u+n-a,s.shiftTop=c+i-l,t.preventDefault()},h=function t(e){s.ensureShiftInWindowBounds(),document.removeEventListener("mousemove",d),document.removeEventListener("touchmove",d),document.removeEventListener("mouseup",t),document.removeEventListener("touchend",t),e.preventDefault()};t.addEventListener("mousedown",e),t.addEventListener("touchstart",e)}},ensureShiftInWindowBounds:function(){var t=this.viewportHeight,e=this.viewportWidth,n=this.shiftLeft,i=this.shiftTop,o=this.shiftX,r=this.shiftY,s=this.trueModalWidth,a=this.trueModalHeight,l=e-s,u=Math.max(t-a,0),c=n+o*l,d=i+r*u;this.shiftLeft-=c-h(0,l,c),this.shiftTop-=d-h(0,u,d)}}},N=(n(9),d(H,i,[],!1,null,null,null));N.options.__file="src/components/Modal.vue";function D(){var n=this,t=n.$createElement,i=n._self._c||t;return i(n.$modal.context.componentName,{tag:"component",attrs:{name:"dialog",height:"auto",classes:["vue-dialog",this.params.class],width:n.width,"shift-y":.3,adaptive:!0,"focus-trap":!0,clickToClose:n.clickToClose,transition:n.transition},on:{"before-open":n.beforeOpened,"before-close":n.beforeClosed,opened:function(t){return n.$emit("opened",t)},closed:function(t){return n.$emit("closed",t)}}},[i("div",{staticClass:"vue-dialog-content"},[n.params.title?i("div",{staticClass:"vue-dialog-content-title",domProps:{innerHTML:n._s(n.params.title||"")}}):n._e(),n._v(" "),n.params.component?i(n.params.component,n._b({tag:"component"},"component",n.params.props,!1)):i("div",{domProps:{innerHTML:n._s(n.params.text||"")}})],1),n._v(" "),n.buttons?i("div",{staticClass:"vue-dialog-buttons"},n._l(n.buttons,function(t,e){return i("button",{key:e,class:t.class||"vue-dialog-button",style:n.buttonStyle,attrs:{type:"button",tabindex:"0"},domProps:{innerHTML:n._s(t.title)},on:{click:function(t){return t.stopPropagation(),n.click(e,t)}}},[n._v(n._s(t.title))])}),0):i("div",{staticClass:"vue-dialog-buttons-none"})])}var W=N.exports;D._withStripped=!0;var I={name:"VueJsDialog",props:{width:{type:[Number,String],default:400},clickToClose:{type:Boolean,default:!0},transition:{type:String}},data:function(){return{params:{}}},computed:{buttons:function(){return this.params.buttons||[]},buttonStyle:function(){return{flex:"1 1 ".concat(100/this.buttons.length,"%")}}},methods:{beforeOpened:function(t){this.params=t.params||{},this.$emit("before-opened",t)},beforeClosed:function(t){this.params={},this.$emit("before-closed",t)},click:function(t,e,n){var i=2<arguments.length&&void 0!==n?n:"click",o=this.buttons[t],r=null==o?void 0:o.handler;"function"==typeof r&&r(t,e,{source:i})}}},P=(n(11),d(I,D,[],!1,null,null,null));P.options.__file="src/components/Dialog.vue";function B(){var n=this,t=n.$createElement,i=n._self._c||t;return i("div",{attrs:{id:"modals-container"}},n._l(n.modals,function(e){return i("modal",n._g(n._b({key:e.id,on:{closed:function(t){return n.remove(e.id)}}},"modal",e.modalAttrs,!1),e.modalListeners),[i(e.component,n._g(n._b({tag:"component",on:{close:function(t){return n.$modal.hide(e.modalAttrs.name,t)}}},"component",e.componentAttrs,!1),n.$listeners))],1)}),1)}var X=P.exports;function Y(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}B._withStripped=!0;var G=d({data:function(){return{modals:[]}},created:function(){this.$root.__modalContainer=this},mounted:function(){var t=this;this.$modal.subscription.$on("hide-all",function(){t.modals=[]})},methods:{add:function(t,e,n,i){var o=this,r=1<arguments.length&&void 0!==e?e:{},s=2<arguments.length&&void 0!==n?n:{},a=3<arguments.length&&void 0!==i?i:{},l=c(),u=s.name||"dynamic_modal_"+l;this.modals.push({id:l,modalAttrs:function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable}))),i.forEach(function(t){Y(e,t,n[t])})}return e}({},s,{name:u}),modalListeners:a,component:t,componentAttrs:r}),this.$nextTick(function(){o.$modal.show(u)})},remove:function(e){var t=this.modals.findIndex(function(t){return t.id===e});-1!==t&&this.modals.splice(t,1)}}},B,[],!1,null,null,null);G.options.__file="src/components/ModalsContainer.vue";var U=G.exports;function F(t){return(F="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function q(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var V=function(i,t){function o(t,e,n,i){var o,r=2<arguments.length&&void 0!==n?n:{},s=3<arguments.length?i:void 0,a=null===(o=c.root)||void 0===o?void 0:o.__modalContainer,l=u.dynamicDefaults||{};null!=a&&a.add(t,e,function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable}))),i.forEach(function(t){q(e,t,n[t])})}return e}({},l,r),s)}var u=1<arguments.length&&void 0!==t?t:{},r=new i,c={root:null,componentName:u.componentName||"Modal"};return{context:c,subscription:r,show:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];var i=e[0];switch(F(i)){case"string":(function(t,e){r.$emit("toggle",t,!0,e)}).apply(void 0,e);break;case"object":case"function":o.apply(void 0,e);break;default:console.warn("[vue-js-modal] $modal() received an unsupported argument as a first argument.",i)}},hide:function(t,e){r.$emit("toggle",t,!1,e)},hideAll:function(){r.$emit("hide-all")},toggle:function(t,e){r.$emit("toggle",t,void 0,e)},setDynamicModalContainer:function(t){c.root=t;var e,n=(e=document.createElement("div"),document.body.appendChild(e),e);new i({parent:t,render:function(t){return t(U)}}).$mount(n)}}},K={install:function(e,t){var n=1<arguments.length&&void 0!==t?t:{};if(!e.prototype.$modal){var i=new V(e,n);if(Object.defineProperty(e.prototype,"$modal",{get:function(){if(this instanceof e){var t=this.$root;i.context.root||i.setDynamicModalContainer(t)}return i}}),e.component(i.context.componentName,W),n.dialog){var o=n.dialogComponentName||"VDialog";e.component(o,X)}}}},J="__VERSION__";e.default=K}],o.c=i,o.d=function(t,e,n){o.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},o.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},o.t=function(e,t){if(1&t&&(e=o(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)o.d(n,i,function(t){return e[t]}.bind(null,i));return n},o.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return o.d(e,"a",e),e},o.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},o.p="/dist/",o(o.s=13);function o(t){if(i[t])return i[t].exports;var e=i[t]={i:t,l:!1,exports:{}};return n[t].call(e.exports,e,e.exports,o),e.l=!0,e.exports}var n,i});
//# sourceMappingURL=index.js.map

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Vue-Lazyload.js v1.3.3
 * (c) 2019 Awe <hilongjw@gmail.com>
 * Released under the MIT License.
 */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/*!
 * is-primitive <https://github.com/jonschlinkert/is-primitive>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

// see http://jsperf.com/testing-value-is-primitive/7

var isPrimitive = function isPrimitive(value) {
  return value == null || typeof value !== 'function' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object';
};

/*!
 * assign-symbols <https://github.com/jonschlinkert/assign-symbols>
 *
 * Copyright (c) 2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

var assignSymbols = function assignSymbols(receiver, objects) {
  if (receiver === null || typeof receiver === 'undefined') {
    throw new TypeError('expected first argument to be an object.');
  }

  if (typeof objects === 'undefined' || typeof Symbol === 'undefined') {
    return receiver;
  }

  if (typeof Object.getOwnPropertySymbols !== 'function') {
    return receiver;
  }

  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var target = Object(receiver);
  var len = arguments.length,
      i = 0;

  while (++i < len) {
    var provider = Object(arguments[i]);
    var names = Object.getOwnPropertySymbols(provider);

    for (var j = 0; j < names.length; j++) {
      var key = names[j];

      if (isEnumerable.call(provider, key)) {
        target[key] = provider[key];
      }
    }
  }
  return target;
};

var toString = Object.prototype.toString;

/**
 * Get the native `typeof` a value.
 *
 * @param  {*} `val`
 * @return {*} Native javascript type
 */

var kindOf = function kindOf(val) {
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);

  // primitivies
  if (type === 'undefined') {
    return 'undefined';
  }
  if (val === null) {
    return 'null';
  }
  if (val === true || val === false || val instanceof Boolean) {
    return 'boolean';
  }
  if (type === 'string' || val instanceof String) {
    return 'string';
  }
  if (type === 'number' || val instanceof Number) {
    return 'number';
  }

  // functions
  if (type === 'function' || val instanceof Function) {
    if (typeof val.constructor.name !== 'undefined' && val.constructor.name.slice(0, 9) === 'Generator') {
      return 'generatorfunction';
    }
    return 'function';
  }

  // array
  if (typeof Array.isArray !== 'undefined' && Array.isArray(val)) {
    return 'array';
  }

  // check for instances of RegExp and Date before calling `toString`
  if (val instanceof RegExp) {
    return 'regexp';
  }
  if (val instanceof Date) {
    return 'date';
  }

  // other objects
  type = toString.call(val);

  if (type === '[object RegExp]') {
    return 'regexp';
  }
  if (type === '[object Date]') {
    return 'date';
  }
  if (type === '[object Arguments]') {
    return 'arguments';
  }
  if (type === '[object Error]') {
    return 'error';
  }
  if (type === '[object Promise]') {
    return 'promise';
  }

  // buffer
  if (isBuffer(val)) {
    return 'buffer';
  }

  // es6: Map, WeakMap, Set, WeakSet
  if (type === '[object Set]') {
    return 'set';
  }
  if (type === '[object WeakSet]') {
    return 'weakset';
  }
  if (type === '[object Map]') {
    return 'map';
  }
  if (type === '[object WeakMap]') {
    return 'weakmap';
  }
  if (type === '[object Symbol]') {
    return 'symbol';
  }

  if (type === '[object Map Iterator]') {
    return 'mapiterator';
  }
  if (type === '[object Set Iterator]') {
    return 'setiterator';
  }
  if (type === '[object String Iterator]') {
    return 'stringiterator';
  }
  if (type === '[object Array Iterator]') {
    return 'arrayiterator';
  }

  // typed arrays
  if (type === '[object Int8Array]') {
    return 'int8array';
  }
  if (type === '[object Uint8Array]') {
    return 'uint8array';
  }
  if (type === '[object Uint8ClampedArray]') {
    return 'uint8clampedarray';
  }
  if (type === '[object Int16Array]') {
    return 'int16array';
  }
  if (type === '[object Uint16Array]') {
    return 'uint16array';
  }
  if (type === '[object Int32Array]') {
    return 'int32array';
  }
  if (type === '[object Uint32Array]') {
    return 'uint32array';
  }
  if (type === '[object Float32Array]') {
    return 'float32array';
  }
  if (type === '[object Float64Array]') {
    return 'float64array';
  }

  // must be a plain object
  return 'object';
};

/**
 * If you need to support Safari 5-7 (8-10 yr-old browser),
 * take a look at https://github.com/feross/is-buffer
 */

function isBuffer(val) {
  return val.constructor && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

function assign(target /*, objects*/) {
  target = target || {};
  var len = arguments.length,
      i = 0;
  if (len === 1) {
    return target;
  }
  while (++i < len) {
    var val = arguments[i];
    if (isPrimitive(target)) {
      target = val;
    }
    if (isObject$1(val)) {
      extend(target, val);
    }
  }
  return target;
}

/**
 * Shallow extend
 */

function extend(target, obj) {
  assignSymbols(target, obj);

  for (var key in obj) {
    if (key !== '__proto__' && hasOwn(obj, key)) {
      var val = obj[key];
      if (isObject$1(val)) {
        if (kindOf(target[key]) === 'undefined' && kindOf(val) === 'function') {
          target[key] = val;
        }
        target[key] = assign(target[key] || {}, val);
      } else {
        target[key] = val;
      }
    }
  }
  return target;
}

/**
 * Returns true if the object is a plain object or a function.
 */

function isObject$1(obj) {
  return kindOf(obj) === 'object' || kindOf(obj) === 'function';
}

/**
 * Returns true if the given `key` is an own property of `obj`.
 */

function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

/**
 * Expose `assign`
 */

var assignDeep = assign;

var inBrowser = typeof window !== 'undefined';
var hasIntersectionObserver = checkIntersectionObserver();

function checkIntersectionObserver() {
  if (inBrowser && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get$$1() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return true;
  }
  return false;
}

var modeType = {
  event: 'event',
  observer: 'observer'

  // CustomEvent polyfill
};var CustomEvent = function () {
  if (!inBrowser) return;
  if (typeof window.CustomEvent === 'function') return window.CustomEvent;
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
  CustomEvent.prototype = window.Event.prototype;
  return CustomEvent;
}();

function remove(arr, item) {
  if (!arr.length) return;
  var index = arr.indexOf(item);
  if (index > -1) return arr.splice(index, 1);
}

function some(arr, fn) {
  var has = false;
  for (var i = 0, len = arr.length; i < len; i++) {
    if (fn(arr[i])) {
      has = true;
      break;
    }
  }
  return has;
}

function getBestSelectionFromSrcset(el, scale) {
  if (el.tagName !== 'IMG' || !el.getAttribute('data-srcset')) return;

  var options = el.getAttribute('data-srcset');
  var result = [];
  var container = el.parentNode;
  var containerWidth = container.offsetWidth * scale;

  var spaceIndex = void 0;
  var tmpSrc = void 0;
  var tmpWidth = void 0;

  options = options.trim().split(',');

  options.map(function (item) {
    item = item.trim();
    spaceIndex = item.lastIndexOf(' ');
    if (spaceIndex === -1) {
      tmpSrc = item;
      tmpWidth = 999998;
    } else {
      tmpSrc = item.substr(0, spaceIndex);
      tmpWidth = parseInt(item.substr(spaceIndex + 1, item.length - spaceIndex - 2), 10);
    }
    result.push([tmpWidth, tmpSrc]);
  });

  result.sort(function (a, b) {
    if (a[0] < b[0]) {
      return 1;
    }
    if (a[0] > b[0]) {
      return -1;
    }
    if (a[0] === b[0]) {
      if (b[1].indexOf('.webp', b[1].length - 5) !== -1) {
        return 1;
      }
      if (a[1].indexOf('.webp', a[1].length - 5) !== -1) {
        return -1;
      }
    }
    return 0;
  });
  var bestSelectedSrc = '';
  var tmpOption = void 0;

  for (var i = 0; i < result.length; i++) {
    tmpOption = result[i];
    bestSelectedSrc = tmpOption[1];
    var next = result[i + 1];
    if (next && next[0] < containerWidth) {
      bestSelectedSrc = tmpOption[1];
      break;
    } else if (!next) {
      bestSelectedSrc = tmpOption[1];
      break;
    }
  }

  return bestSelectedSrc;
}

function find(arr, fn) {
  var item = void 0;
  for (var i = 0, len = arr.length; i < len; i++) {
    if (fn(arr[i])) {
      item = arr[i];
      break;
    }
  }
  return item;
}

var getDPR = function getDPR() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return inBrowser ? window.devicePixelRatio || scale : scale;
};

function supportWebp() {
  if (!inBrowser) return false;

  var support = true;
  var d = document;

  try {
    var el = d.createElement('object');
    el.type = 'image/webp';
    el.style.visibility = 'hidden';
    el.innerHTML = '!';
    d.body.appendChild(el);
    support = !el.offsetWidth;
    d.body.removeChild(el);
  } catch (err) {
    support = false;
  }

  return support;
}

function throttle(action, delay) {
  var timeout = null;
  var lastRun = 0;
  return function () {
    if (timeout) {
      return;
    }
    var elapsed = Date.now() - lastRun;
    var context = this;
    var args = arguments;
    var runCallback = function runCallback() {
      lastRun = Date.now();
      timeout = false;
      action.apply(context, args);
    };
    if (elapsed >= delay) {
      runCallback();
    } else {
      timeout = setTimeout(runCallback, delay);
    }
  };
}

function testSupportsPassive() {
  if (!inBrowser) return;
  var support = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get$$1() {
        support = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}
  return support;
}

var supportsPassive = testSupportsPassive();

var _ = {
  on: function on(el, type, func) {
    var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (supportsPassive) {
      el.addEventListener(type, func, {
        capture: capture,
        passive: true
      });
    } else {
      el.addEventListener(type, func, capture);
    }
  },
  off: function off(el, type, func) {
    var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    el.removeEventListener(type, func, capture);
  }
};

var loadImageAsync = function loadImageAsync(item, resolve, reject) {
  var image = new Image();
  if (!item || !item.src) {
    var err = new Error('image src is required');
    return reject(err);
  }

  image.src = item.src;

  image.onload = function () {
    resolve({
      naturalHeight: image.naturalHeight,
      naturalWidth: image.naturalWidth,
      src: image.src
    });
  };

  image.onerror = function (e) {
    reject(e);
  };
};

var style = function style(el, prop) {
  return typeof getComputedStyle !== 'undefined' ? getComputedStyle(el, null).getPropertyValue(prop) : el.style[prop];
};

var overflow = function overflow(el) {
  return style(el, 'overflow') + style(el, 'overflow-y') + style(el, 'overflow-x');
};

var scrollParent = function scrollParent(el) {
  if (!inBrowser) return;
  if (!(el instanceof HTMLElement)) {
    return window;
  }

  var parent = el;

  while (parent) {
    if (parent === document.body || parent === document.documentElement) {
      break;
    }

    if (!parent.parentNode) {
      break;
    }

    if (/(scroll|auto)/.test(overflow(parent))) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return window;
};

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

function ObjectKeys(obj) {
  if (!(obj instanceof Object)) return [];
  if (Object.keys) {
    return Object.keys(obj);
  } else {
    var keys = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        keys.push(key);
      }
    }
    return keys;
  }
}

function ArrayFrom(arrLike) {
  var len = arrLike.length;
  var list = [];
  for (var i = 0; i < len; i++) {
    list.push(arrLike[i]);
  }
  return list;
}

function noop() {}

var ImageCache = function () {
  function ImageCache(_ref) {
    var max = _ref.max;
    classCallCheck(this, ImageCache);

    this.options = {
      max: max || 100
    };
    this._caches = [];
  }

  createClass(ImageCache, [{
    key: 'has',
    value: function has(key) {
      return this._caches.indexOf(key) > -1;
    }
  }, {
    key: 'add',
    value: function add(key) {
      if (this.has(key)) return;
      this._caches.push(key);
      if (this._caches.length > this.options.max) {
        this.free();
      }
    }
  }, {
    key: 'free',
    value: function free() {
      this._caches.shift();
    }
  }]);
  return ImageCache;
}();

// el: {
//     state,
//     src,
//     error,
//     loading
// }

var ReactiveListener = function () {
  function ReactiveListener(_ref) {
    var el = _ref.el,
        src = _ref.src,
        error = _ref.error,
        loading = _ref.loading,
        bindType = _ref.bindType,
        $parent = _ref.$parent,
        options = _ref.options,
        elRenderer = _ref.elRenderer,
        imageCache = _ref.imageCache;
    classCallCheck(this, ReactiveListener);

    this.el = el;
    this.src = src;
    this.error = error;
    this.loading = loading;
    this.bindType = bindType;
    this.attempt = 0;

    this.naturalHeight = 0;
    this.naturalWidth = 0;

    this.options = options;

    this.rect = null;

    this.$parent = $parent;
    this.elRenderer = elRenderer;
    this._imageCache = imageCache;
    this.performanceData = {
      init: Date.now(),
      loadStart: 0,
      loadEnd: 0
    };

    this.filter();
    this.initState();
    this.render('loading', false);
  }

  /*
   * init listener state
   * @return
   */


  createClass(ReactiveListener, [{
    key: 'initState',
    value: function initState() {
      if ('dataset' in this.el) {
        this.el.dataset.src = this.src;
      } else {
        this.el.setAttribute('data-src', this.src);
      }

      this.state = {
        loading: false,
        error: false,
        loaded: false,
        rendered: false
      };
    }

    /*
     * record performance
     * @return
     */

  }, {
    key: 'record',
    value: function record(event) {
      this.performanceData[event] = Date.now();
    }

    /*
     * update image listener data
     * @param  {String} image uri
     * @param  {String} loading image uri
     * @param  {String} error image uri
     * @return
     */

  }, {
    key: 'update',
    value: function update(_ref2) {
      var src = _ref2.src,
          loading = _ref2.loading,
          error = _ref2.error;

      var oldSrc = this.src;
      this.src = src;
      this.loading = loading;
      this.error = error;
      this.filter();
      if (oldSrc !== this.src) {
        this.attempt = 0;
        this.initState();
      }
    }

    /*
     * get el node rect
     * @return
     */

  }, {
    key: 'getRect',
    value: function getRect() {
      this.rect = this.el.getBoundingClientRect();
    }

    /*
     *  check el is in view
     * @return {Boolean} el is in view
     */

  }, {
    key: 'checkInView',
    value: function checkInView() {
      this.getRect();
      return this.rect.top < window.innerHeight * this.options.preLoad && this.rect.bottom > this.options.preLoadTop && this.rect.left < window.innerWidth * this.options.preLoad && this.rect.right > 0;
    }

    /*
     * listener filter
     */

  }, {
    key: 'filter',
    value: function filter() {
      var _this = this;

      ObjectKeys(this.options.filter).map(function (key) {
        _this.options.filter[key](_this, _this.options);
      });
    }

    /*
     * render loading first
     * @params cb:Function
     * @return
     */

  }, {
    key: 'renderLoading',
    value: function renderLoading(cb) {
      var _this2 = this;

      this.state.loading = true;
      loadImageAsync({
        src: this.loading
      }, function (data) {
        _this2.render('loading', false);
        _this2.state.loading = false;
        cb();
      }, function () {
        // handler `loading image` load failed
        cb();
        _this2.state.loading = false;
        if (!_this2.options.silent) console.warn('VueLazyload log: load failed with loading image(' + _this2.loading + ')');
      });
    }

    /*
     * try load image and  render it
     * @return
     */

  }, {
    key: 'load',
    value: function load() {
      var _this3 = this;

      var onFinish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

      if (this.attempt > this.options.attempt - 1 && this.state.error) {
        if (!this.options.silent) console.log('VueLazyload log: ' + this.src + ' tried too more than ' + this.options.attempt + ' times');
        onFinish();
        return;
      }
      if (this.state.rendered && this.state.loaded) return;
      if (this._imageCache.has(this.src)) {
        this.state.loaded = true;
        this.render('loaded', true);
        this.state.rendered = true;
        return onFinish();
      }

      this.renderLoading(function () {
        _this3.attempt++;

        _this3.options.adapter['beforeLoad'] && _this3.options.adapter['beforeLoad'](_this3, _this3.options);
        _this3.record('loadStart');

        loadImageAsync({
          src: _this3.src
        }, function (data) {
          _this3.naturalHeight = data.naturalHeight;
          _this3.naturalWidth = data.naturalWidth;
          _this3.state.loaded = true;
          _this3.state.error = false;
          _this3.record('loadEnd');
          _this3.render('loaded', false);
          _this3.state.rendered = true;
          _this3._imageCache.add(_this3.src);
          onFinish();
        }, function (err) {
          !_this3.options.silent && console.error(err);
          _this3.state.error = true;
          _this3.state.loaded = false;
          _this3.render('error', false);
        });
      });
    }

    /*
     * render image
     * @param  {String} state to render // ['loading', 'src', 'error']
     * @param  {String} is form cache
     * @return
     */

  }, {
    key: 'render',
    value: function render(state, cache) {
      this.elRenderer(this, state, cache);
    }

    /*
     * output performance data
     * @return {Object} performance data
     */

  }, {
    key: 'performance',
    value: function performance() {
      var state = 'loading';
      var time = 0;

      if (this.state.loaded) {
        state = 'loaded';
        time = (this.performanceData.loadEnd - this.performanceData.loadStart) / 1000;
      }

      if (this.state.error) state = 'error';

      return {
        src: this.src,
        state: state,
        time: time
      };
    }

    /*
     * $destroy
     * @return
     */

  }, {
    key: '$destroy',
    value: function $destroy() {
      this.el = null;
      this.src = null;
      this.error = null;
      this.loading = null;
      this.bindType = null;
      this.attempt = 0;
    }
  }]);
  return ReactiveListener;
}();

var DEFAULT_URL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
var DEFAULT_EVENTS = ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'];
var DEFAULT_OBSERVER_OPTIONS = {
  rootMargin: '0px',
  threshold: 0
};

var Lazy = function (Vue) {
  return function () {
    function Lazy(_ref) {
      var preLoad = _ref.preLoad,
          error = _ref.error,
          throttleWait = _ref.throttleWait,
          preLoadTop = _ref.preLoadTop,
          dispatchEvent = _ref.dispatchEvent,
          loading = _ref.loading,
          attempt = _ref.attempt,
          _ref$silent = _ref.silent,
          silent = _ref$silent === undefined ? true : _ref$silent,
          scale = _ref.scale,
          listenEvents = _ref.listenEvents,
          hasbind = _ref.hasbind,
          filter = _ref.filter,
          adapter = _ref.adapter,
          observer = _ref.observer,
          observerOptions = _ref.observerOptions;
      classCallCheck(this, Lazy);

      this.version = '1.3.3';
      this.mode = modeType.event;
      this.ListenerQueue = [];
      this.TargetIndex = 0;
      this.TargetQueue = [];
      this.options = {
        silent: silent,
        dispatchEvent: !!dispatchEvent,
        throttleWait: throttleWait || 200,
        preLoad: preLoad || 1.3,
        preLoadTop: preLoadTop || 0,
        error: error || DEFAULT_URL,
        loading: loading || DEFAULT_URL,
        attempt: attempt || 3,
        scale: scale || getDPR(scale),
        ListenEvents: listenEvents || DEFAULT_EVENTS,
        hasbind: false,
        supportWebp: supportWebp(),
        filter: filter || {},
        adapter: adapter || {},
        observer: !!observer,
        observerOptions: observerOptions || DEFAULT_OBSERVER_OPTIONS
      };
      this._initEvent();
      this._imageCache = new ImageCache({ max: 200 });
      this.lazyLoadHandler = throttle(this._lazyLoadHandler.bind(this), this.options.throttleWait);

      this.setMode(this.options.observer ? modeType.observer : modeType.event);
    }

    /**
     * update config
     * @param  {Object} config params
     * @return
     */


    createClass(Lazy, [{
      key: 'config',
      value: function config() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        assignDeep(this.options, options);
      }

      /**
       * output listener's load performance
       * @return {Array}
       */

    }, {
      key: 'performance',
      value: function performance() {
        var list = [];

        this.ListenerQueue.map(function (item) {
          list.push(item.performance());
        });

        return list;
      }

      /*
       * add lazy component to queue
       * @param  {Vue} vm lazy component instance
       * @return
       */

    }, {
      key: 'addLazyBox',
      value: function addLazyBox(vm) {
        this.ListenerQueue.push(vm);
        if (inBrowser) {
          this._addListenerTarget(window);
          this._observer && this._observer.observe(vm.el);
          if (vm.$el && vm.$el.parentNode) {
            this._addListenerTarget(vm.$el.parentNode);
          }
        }
      }

      /*
       * add image listener to queue
       * @param  {DOM} el
       * @param  {object} binding vue directive binding
       * @param  {vnode} vnode vue directive vnode
       * @return
       */

    }, {
      key: 'add',
      value: function add(el, binding, vnode) {
        var _this = this;

        if (some(this.ListenerQueue, function (item) {
          return item.el === el;
        })) {
          this.update(el, binding);
          return Vue.nextTick(this.lazyLoadHandler);
        }

        var _valueFormatter2 = this._valueFormatter(binding.value),
            src = _valueFormatter2.src,
            loading = _valueFormatter2.loading,
            error = _valueFormatter2.error;

        Vue.nextTick(function () {
          src = getBestSelectionFromSrcset(el, _this.options.scale) || src;
          _this._observer && _this._observer.observe(el);

          var container = Object.keys(binding.modifiers)[0];
          var $parent = void 0;

          if (container) {
            $parent = vnode.context.$refs[container];
            // if there is container passed in, try ref first, then fallback to getElementById to support the original usage
            $parent = $parent ? $parent.$el || $parent : document.getElementById(container);
          }

          if (!$parent) {
            $parent = scrollParent(el);
          }

          var newListener = new ReactiveListener({
            bindType: binding.arg,
            $parent: $parent,
            el: el,
            loading: loading,
            error: error,
            src: src,
            elRenderer: _this._elRenderer.bind(_this),
            options: _this.options,
            imageCache: _this._imageCache
          });

          _this.ListenerQueue.push(newListener);

          if (inBrowser) {
            _this._addListenerTarget(window);
            _this._addListenerTarget($parent);
          }

          _this.lazyLoadHandler();
          Vue.nextTick(function () {
            return _this.lazyLoadHandler();
          });
        });
      }

      /**
      * update image src
      * @param  {DOM} el
      * @param  {object} vue directive binding
      * @return
      */

    }, {
      key: 'update',
      value: function update(el, binding, vnode) {
        var _this2 = this;

        var _valueFormatter3 = this._valueFormatter(binding.value),
            src = _valueFormatter3.src,
            loading = _valueFormatter3.loading,
            error = _valueFormatter3.error;

        src = getBestSelectionFromSrcset(el, this.options.scale) || src;

        var exist = find(this.ListenerQueue, function (item) {
          return item.el === el;
        });
        if (!exist) {
          this.add(el, binding, vnode);
        } else {
          exist.update({
            src: src,
            loading: loading,
            error: error
          });
        }
        if (this._observer) {
          this._observer.unobserve(el);
          this._observer.observe(el);
        }
        this.lazyLoadHandler();
        Vue.nextTick(function () {
          return _this2.lazyLoadHandler();
        });
      }

      /**
      * remove listener form list
      * @param  {DOM} el
      * @return
      */

    }, {
      key: 'remove',
      value: function remove$$1(el) {
        if (!el) return;
        this._observer && this._observer.unobserve(el);
        var existItem = find(this.ListenerQueue, function (item) {
          return item.el === el;
        });
        if (existItem) {
          this._removeListenerTarget(existItem.$parent);
          this._removeListenerTarget(window);
          remove(this.ListenerQueue, existItem);
          existItem.$destroy();
        }
      }

      /*
       * remove lazy components form list
       * @param  {Vue} vm Vue instance
       * @return
       */

    }, {
      key: 'removeComponent',
      value: function removeComponent(vm) {
        if (!vm) return;
        remove(this.ListenerQueue, vm);
        this._observer && this._observer.unobserve(vm.el);
        if (vm.$parent && vm.$el.parentNode) {
          this._removeListenerTarget(vm.$el.parentNode);
        }
        this._removeListenerTarget(window);
      }
    }, {
      key: 'setMode',
      value: function setMode(mode) {
        var _this3 = this;

        if (!hasIntersectionObserver && mode === modeType.observer) {
          mode = modeType.event;
        }

        this.mode = mode; // event or observer

        if (mode === modeType.event) {
          if (this._observer) {
            this.ListenerQueue.forEach(function (listener) {
              _this3._observer.unobserve(listener.el);
            });
            this._observer = null;
          }

          this.TargetQueue.forEach(function (target) {
            _this3._initListen(target.el, true);
          });
        } else {
          this.TargetQueue.forEach(function (target) {
            _this3._initListen(target.el, false);
          });
          this._initIntersectionObserver();
        }
      }

      /*
      *** Private functions ***
      */

      /*
       * add listener target
       * @param  {DOM} el listener target
       * @return
       */

    }, {
      key: '_addListenerTarget',
      value: function _addListenerTarget(el) {
        if (!el) return;
        var target = find(this.TargetQueue, function (target) {
          return target.el === el;
        });
        if (!target) {
          target = {
            el: el,
            id: ++this.TargetIndex,
            childrenCount: 1,
            listened: true
          };
          this.mode === modeType.event && this._initListen(target.el, true);
          this.TargetQueue.push(target);
        } else {
          target.childrenCount++;
        }
        return this.TargetIndex;
      }

      /*
       * remove listener target or reduce target childrenCount
       * @param  {DOM} el or window
       * @return
       */

    }, {
      key: '_removeListenerTarget',
      value: function _removeListenerTarget(el) {
        var _this4 = this;

        this.TargetQueue.forEach(function (target, index) {
          if (target.el === el) {
            target.childrenCount--;
            if (!target.childrenCount) {
              _this4._initListen(target.el, false);
              _this4.TargetQueue.splice(index, 1);
              target = null;
            }
          }
        });
      }

      /*
       * add or remove eventlistener
       * @param  {DOM} el DOM or Window
       * @param  {boolean} start flag
       * @return
       */

    }, {
      key: '_initListen',
      value: function _initListen(el, start) {
        var _this5 = this;

        this.options.ListenEvents.forEach(function (evt) {
          return _[start ? 'on' : 'off'](el, evt, _this5.lazyLoadHandler);
        });
      }
    }, {
      key: '_initEvent',
      value: function _initEvent() {
        var _this6 = this;

        this.Event = {
          listeners: {
            loading: [],
            loaded: [],
            error: []
          }
        };

        this.$on = function (event, func) {
          if (!_this6.Event.listeners[event]) _this6.Event.listeners[event] = [];
          _this6.Event.listeners[event].push(func);
        };

        this.$once = function (event, func) {
          var vm = _this6;
          function on() {
            vm.$off(event, on);
            func.apply(vm, arguments);
          }
          _this6.$on(event, on);
        };

        this.$off = function (event, func) {
          if (!func) {
            if (!_this6.Event.listeners[event]) return;
            _this6.Event.listeners[event].length = 0;
            return;
          }
          remove(_this6.Event.listeners[event], func);
        };

        this.$emit = function (event, context, inCache) {
          if (!_this6.Event.listeners[event]) return;
          _this6.Event.listeners[event].forEach(function (func) {
            return func(context, inCache);
          });
        };
      }

      /**
       * find nodes which in viewport and trigger load
       * @return
       */

    }, {
      key: '_lazyLoadHandler',
      value: function _lazyLoadHandler() {
        var _this7 = this;

        var freeList = [];
        this.ListenerQueue.forEach(function (listener, index) {
          if (!listener.el || !listener.el.parentNode) {
            freeList.push(listener);
          }
          var catIn = listener.checkInView();
          if (!catIn) return;
          listener.load();
        });
        freeList.forEach(function (item) {
          remove(_this7.ListenerQueue, item);
          item.$destroy();
        });
      }
      /**
      * init IntersectionObserver
      * set mode to observer
      * @return
      */

    }, {
      key: '_initIntersectionObserver',
      value: function _initIntersectionObserver() {
        var _this8 = this;

        if (!hasIntersectionObserver) return;
        this._observer = new IntersectionObserver(this._observerHandler.bind(this), this.options.observerOptions);
        if (this.ListenerQueue.length) {
          this.ListenerQueue.forEach(function (listener) {
            _this8._observer.observe(listener.el);
          });
        }
      }

      /**
      * init IntersectionObserver
      * @return
      */

    }, {
      key: '_observerHandler',
      value: function _observerHandler(entries, observer) {
        var _this9 = this;

        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            _this9.ListenerQueue.forEach(function (listener) {
              if (listener.el === entry.target) {
                if (listener.state.loaded) return _this9._observer.unobserve(listener.el);
                listener.load();
              }
            });
          }
        });
      }

      /**
      * set element attribute with image'url and state
      * @param  {object} lazyload listener object
      * @param  {string} state will be rendered
      * @param  {bool} inCache  is rendered from cache
      * @return
      */

    }, {
      key: '_elRenderer',
      value: function _elRenderer(listener, state, cache) {
        if (!listener.el) return;
        var el = listener.el,
            bindType = listener.bindType;


        var src = void 0;
        switch (state) {
          case 'loading':
            src = listener.loading;
            break;
          case 'error':
            src = listener.error;
            break;
          default:
            src = listener.src;
            break;
        }

        if (bindType) {
          el.style[bindType] = 'url("' + src + '")';
        } else if (el.getAttribute('src') !== src) {
          el.setAttribute('src', src);
        }

        el.setAttribute('lazy', state);

        this.$emit(state, listener, cache);
        this.options.adapter[state] && this.options.adapter[state](listener, this.options);

        if (this.options.dispatchEvent) {
          var event = new CustomEvent(state, {
            detail: listener
          });
          el.dispatchEvent(event);
        }
      }

      /**
      * generate loading loaded error image url
      * @param {string} image's src
      * @return {object} image's loading, loaded, error url
      */

    }, {
      key: '_valueFormatter',
      value: function _valueFormatter(value) {
        var src = value;
        var loading = this.options.loading;
        var error = this.options.error;

        // value is object
        if (isObject(value)) {
          if (!value.src && !this.options.silent) console.error('Vue Lazyload warning: miss src with ' + value);
          src = value.src;
          loading = value.loading || this.options.loading;
          error = value.error || this.options.error;
        }
        return {
          src: src,
          loading: loading,
          error: error
        };
      }
    }]);
    return Lazy;
  }();
};

var LazyComponent = (function (lazy) {
  return {
    props: {
      tag: {
        type: String,
        default: 'div'
      }
    },
    render: function render(h) {
      if (this.show === false) {
        return h(this.tag);
      }
      return h(this.tag, null, this.$slots.default);
    },
    data: function data() {
      return {
        el: null,
        state: {
          loaded: false
        },
        rect: {},
        show: false
      };
    },
    mounted: function mounted() {
      this.el = this.$el;
      lazy.addLazyBox(this);
      lazy.lazyLoadHandler();
    },
    beforeDestroy: function beforeDestroy() {
      lazy.removeComponent(this);
    },

    methods: {
      getRect: function getRect() {
        this.rect = this.$el.getBoundingClientRect();
      },
      checkInView: function checkInView() {
        this.getRect();
        return inBrowser && this.rect.top < window.innerHeight * lazy.options.preLoad && this.rect.bottom > 0 && this.rect.left < window.innerWidth * lazy.options.preLoad && this.rect.right > 0;
      },
      load: function load() {
        this.show = true;
        this.state.loaded = true;
        this.$emit('show', this);
      },
      destroy: function destroy() {
        return this.$destroy;
      }
    }
  };
});

var LazyContainerMananger = function () {
  function LazyContainerMananger(_ref) {
    var lazy = _ref.lazy;
    classCallCheck(this, LazyContainerMananger);

    this.lazy = lazy;
    lazy.lazyContainerMananger = this;
    this._queue = [];
  }

  createClass(LazyContainerMananger, [{
    key: 'bind',
    value: function bind(el, binding, vnode) {
      var container = new LazyContainer$1({ el: el, binding: binding, vnode: vnode, lazy: this.lazy });
      this._queue.push(container);
    }
  }, {
    key: 'update',
    value: function update(el, binding, vnode) {
      var container = find(this._queue, function (item) {
        return item.el === el;
      });
      if (!container) return;
      container.update({ el: el, binding: binding, vnode: vnode });
    }
  }, {
    key: 'unbind',
    value: function unbind(el, binding, vnode) {
      var container = find(this._queue, function (item) {
        return item.el === el;
      });
      if (!container) return;
      container.clear();
      remove(this._queue, container);
    }
  }]);
  return LazyContainerMananger;
}();

var defaultOptions = {
  selector: 'img'
};

var LazyContainer$1 = function () {
  function LazyContainer(_ref2) {
    var el = _ref2.el,
        binding = _ref2.binding,
        vnode = _ref2.vnode,
        lazy = _ref2.lazy;
    classCallCheck(this, LazyContainer);

    this.el = null;
    this.vnode = vnode;
    this.binding = binding;
    this.options = {};
    this.lazy = lazy;

    this._queue = [];
    this.update({ el: el, binding: binding });
  }

  createClass(LazyContainer, [{
    key: 'update',
    value: function update(_ref3) {
      var _this = this;

      var el = _ref3.el,
          binding = _ref3.binding;

      this.el = el;
      this.options = assignDeep({}, defaultOptions, binding.value);

      var imgs = this.getImgs();
      imgs.forEach(function (el) {
        _this.lazy.add(el, assignDeep({}, _this.binding, {
          value: {
            src: 'dataset' in el ? el.dataset.src : el.getAttribute('data-src'),
            error: ('dataset' in el ? el.dataset.error : el.getAttribute('data-error')) || _this.options.error,
            loading: ('dataset' in el ? el.dataset.loading : el.getAttribute('data-loading')) || _this.options.loading
          }
        }), _this.vnode);
      });
    }
  }, {
    key: 'getImgs',
    value: function getImgs() {
      return ArrayFrom(this.el.querySelectorAll(this.options.selector));
    }
  }, {
    key: 'clear',
    value: function clear() {
      var _this2 = this;

      var imgs = this.getImgs();
      imgs.forEach(function (el) {
        return _this2.lazy.remove(el);
      });

      this.vnode = null;
      this.binding = null;
      this.lazy = null;
    }
  }]);
  return LazyContainer;
}();

var LazyImage = (function (lazyManager) {
  return {
    props: {
      src: [String, Object],
      tag: {
        type: String,
        default: 'img'
      }
    },
    render: function render(h) {
      return h(this.tag, {
        attrs: {
          src: this.renderSrc
        }
      }, this.$slots.default);
    },
    data: function data() {
      return {
        el: null,
        options: {
          src: '',
          error: '',
          loading: '',
          attempt: lazyManager.options.attempt
        },
        state: {
          loaded: false,
          error: false,
          attempt: 0
        },
        rect: {},
        renderSrc: ''
      };
    },

    watch: {
      src: function src() {
        this.init();
        lazyManager.addLazyBox(this);
        lazyManager.lazyLoadHandler();
      }
    },
    created: function created() {
      this.init();
      this.renderSrc = this.options.loading;
    },
    mounted: function mounted() {
      this.el = this.$el;
      lazyManager.addLazyBox(this);
      lazyManager.lazyLoadHandler();
    },
    beforeDestroy: function beforeDestroy() {
      lazyManager.removeComponent(this);
    },

    methods: {
      init: function init() {
        var _lazyManager$_valueFo = lazyManager._valueFormatter(this.src),
            src = _lazyManager$_valueFo.src,
            loading = _lazyManager$_valueFo.loading,
            error = _lazyManager$_valueFo.error;

        this.state.loaded = false;
        this.options.src = src;
        this.options.error = error;
        this.options.loading = loading;
        this.renderSrc = this.options.loading;
      },
      getRect: function getRect() {
        this.rect = this.$el.getBoundingClientRect();
      },
      checkInView: function checkInView() {
        this.getRect();
        return inBrowser && this.rect.top < window.innerHeight * lazyManager.options.preLoad && this.rect.bottom > 0 && this.rect.left < window.innerWidth * lazyManager.options.preLoad && this.rect.right > 0;
      },
      load: function load() {
        var _this = this;

        var onFinish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

        if (this.state.attempt > this.options.attempt - 1 && this.state.error) {
          if (!lazyManager.options.silent) console.log('VueLazyload log: ' + this.options.src + ' tried too more than ' + this.options.attempt + ' times');
          onFinish();
          return;
        }
        var src = this.options.src;
        loadImageAsync({ src: src }, function (_ref) {
          var src = _ref.src;

          _this.renderSrc = src;
          _this.state.loaded = true;
        }, function (e) {
          _this.state.attempt++;
          _this.renderSrc = _this.options.error;
          _this.state.error = true;
        });
      }
    }
  };
});

var index = {
  /*
  * install function
  * @param  {Vue} Vue
  * @param  {object} options  lazyload options
  */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var LazyClass = Lazy(Vue);
    var lazy = new LazyClass(options);
    var lazyContainer = new LazyContainerMananger({ lazy: lazy });

    var isVue2 = Vue.version.split('.')[0] === '2';

    Vue.prototype.$Lazyload = lazy;

    if (options.lazyComponent) {
      Vue.component('lazy-component', LazyComponent(lazy));
    }

    if (options.lazyImage) {
      Vue.component('lazy-image', LazyImage(lazy));
    }

    if (isVue2) {
      Vue.directive('lazy', {
        bind: lazy.add.bind(lazy),
        update: lazy.update.bind(lazy),
        componentUpdated: lazy.lazyLoadHandler.bind(lazy),
        unbind: lazy.remove.bind(lazy)
      });
      Vue.directive('lazy-container', {
        bind: lazyContainer.bind.bind(lazyContainer),
        componentUpdated: lazyContainer.update.bind(lazyContainer),
        unbind: lazyContainer.unbind.bind(lazyContainer)
      });
    } else {
      Vue.directive('lazy', {
        bind: lazy.lazyLoadHandler.bind(lazy),
        update: function update(newValue, oldValue) {
          assignDeep(this.vm.$refs, this.vm.$els);
          lazy.add(this.el, {
            modifiers: this.modifiers || {},
            arg: this.arg,
            value: newValue,
            oldValue: oldValue
          }, {
            context: this.vm
          });
        },
        unbind: function unbind() {
          lazy.remove(this.el);
        }
      });

      Vue.directive('lazy-container', {
        update: function update(newValue, oldValue) {
          lazyContainer.update(this.el, {
            modifiers: this.modifiers || {},
            arg: this.arg,
            value: newValue,
            oldValue: oldValue
          }, {
            context: this.vm
          });
        },
        unbind: function unbind() {
          lazyContainer.unbind(this.el);
        }
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = global || self, factory(global.VueInlineSvg = {}));
}(this, (function (exports) { 'use strict';

    /** @type Object{string: Promise<Element>} */
    var cache = {};
    /**
     * Remove false attrs
     * @param {Object} attrs
     */

    function filterAttrs(attrs) {
      return Object.keys(attrs).reduce(function (result, key) {
        if (attrs[key] !== false && attrs[key] !== null && attrs[key] !== undefined) {
          result[key] = attrs[key];
        }

        return result;
      }, {});
    }

    var InlineSvgComponent = {
      // name: 'inline-svg',
      inheritAttrs: false,
      render: function render(createElement) {
        if (!this.isLoaded) {
          return null;
        }

        return createElement('svg', {
          on: this.$listeners,
          attrs: Object.assign(this.svgAttrs, filterAttrs(this.$attrs)),
          domProps: {
            innerHTML: this.svgContent
          }
        });
      },
      props: {
        src: {
          type: String,
          required: true
        },
        transformSource: {
          type: Function,
          "default": function _default(svg) {
            return svg;
          }
        }
      },
      data: function data() {
        return {
          isLoaded: false,
          svgAttrs: {},
          svgContent: ''
        };
      },
      watch: {
        src: function src(newValue) {
          // re-generate inline svg
          this.inline(newValue);
        }
      },
      mounted: function mounted() {
        // generate inline svg
        this.inline(this.src);
      },
      methods: {
        /**
         * Replace image with loaded svg
         * @param {string} src
         */
        inline: function inline(src) {
          var _this = this;

          // fill cache by src with promise
          if (!cache[src]) {
            // notify svg is unloaded
            if (this.isLoaded) {
              this.isLoaded = false;
              this.$emit('unloaded');
            } // download


            cache[src] = this.download(src);
          } // inline svg when cached promise resolves


          cache[src].then(function (svg) {
            // copy attrs
            _this.svgAttrs = {};
            var attrs = svg.attributes;

            for (var i = attrs.length - 1; i >= 0; i--) {
              _this.svgAttrs[attrs[i].name] = attrs[i].value;
            } // copy inner html


            _this.svgContent = svg.innerHTML; // render svg element

            _this.isLoaded = true; // wait to render

            _this.$nextTick(function () {
              // notify
              _this.$emit('loaded', _this.$el);
            });
          })["catch"](function (err) {
            // remove cached rejected promise so next image can try load again
            delete cache[src];

            _this.$emit('error', err);
          });
        },

        /**
         * Get the contents of the SVG
         * @param {string} url
         * @returns {Promise<Element>}
         */
        download: function download(url) {
          var _this2 = this;

          return new Promise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.open('GET', url, true);

            request.onload = function () {
              if (request.status >= 200 && request.status < 400) {
                try {
                  // Setup a parser to convert the response to text/xml in order for it to be manipulated and changed
                  var parser = new DOMParser();
                  var result = parser.parseFromString(request.responseText, 'text/xml');
                  var svgEl = result.getElementsByTagName('svg')[0];

                  if (svgEl) {
                    svgEl = _this2.transformSource(svgEl);
                    resolve(svgEl);
                  } else {
                    reject(new Error('Loaded file is not valid SVG"'));
                  }
                } catch (e) {
                  reject(e);
                }
              } else {
                reject(new Error('Error loading SVG'));
              }
            };

            request.onerror = reject;
            request.send();
          });
        }
      }
    };
    var InlineSvgPlugin = {
      install: function install(Vue) {
        Vue.component('inline-svg', InlineSvgComponent);
      }
    };

    exports.InlineSvgComponent = InlineSvgComponent;
    exports.InlineSvgPlugin = InlineSvgPlugin;
    exports.default = InlineSvgComponent;

    Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.vueMutationObserver={})}(this,function(e){"use strict";var f=void 0,v={attributes:!0,attributeOldValue:!0,childList:!0,characterData:!0,characterDataOldValue:!0},t={bind:function(e,t){var a=t.value;if(!a)return console.warn('vue-mutation-observer: "Please set callback or config object."');var r="function"==typeof a&&a||a.callback;f=new MutationObserver(r)},inserted:function(e,t){var a=t.value,r=t.modifiers,i=t.arg,n={},o=!0,c=!1,s=void 0;try{for(var u,l=Object.keys(r)[Symbol.iterator]();!(o=(u=l.next()).done);o=!0){var b=u.value;switch(b){case"characterData":n=Object.assign(n,{characterData:!0,characterDataOldValue:!0});break;case"attributes":n=Object.assign(n,{attributes:!0,attributeOldValue:!0});break;case"childList":n=Object.assign(n,{childList:!0});break;default:console.warn('vue-mutation-observer: "Unknown modifier: '+b+'."')}}}catch(e){c=!0,s=e}finally{try{!o&&l.return&&l.return()}finally{if(c)throw s}}a.config&&(n=Object.assign(n,a.config));var d=0<Object.keys(n).length&&n||v;d.subtree=!!i&&"subtree"===i;try{f.observe(e,d)}catch(e){console.error('vue-mutation-observer: "'+e+'."')}}};t.install=function(e){e.directive("observer",t)},"undefined"!=typeof window&&window.Vue&&window.Vue.use(t);var a=t;e.observer=a,e.default=t,Object.defineProperty(e,"__esModule",{value:!0})});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

(function(t,e){ true?module.exports=e():"function"===typeof define&&define.amd?define([],e):"object"===typeof exports?exports["vue-position-sticky"]=e():t["vue-position-sticky"]=e()})("undefined"!==typeof self?self:this,function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"===typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t["default"]}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s="fb15")}({"0d58":function(t,e,n){var r=n("ce10"),o=n("e11e");t.exports=Object.keys||function(t){return r(t,o)}},"11e9":function(t,e,n){var r=n("52a7"),o=n("4630"),i=n("6821"),c=n("6a99"),s=n("69a8"),u=n("c69a"),f=Object.getOwnPropertyDescriptor;e.f=n("9e1e")?f:function(t,e){if(t=i(t),e=c(e,!0),u)try{return f(t,e)}catch(t){}if(s(t,e))return o(!r.f.call(t,e),t[e])}},1495:function(t,e,n){var r=n("86cc"),o=n("cb7c"),i=n("0d58");t.exports=n("9e1e")?Object.defineProperties:function(t,e){o(t);var n,c=i(e),s=c.length,u=0;while(s>u)r.f(t,n=c[u++],e[n]);return t}},"1eb2":function(t,e,n){var r;"undefined"!==typeof window&&((r=window.document.currentScript)&&(r=r.src.match(/(.+\/)[^/]+\.js$/))&&(n.p=r[1]))},"230e":function(t,e,n){var r=n("d3f4"),o=n("7726").document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},2350:function(t,e){function n(t,e){var n=t[1]||"",o=t[3];if(!o)return n;if(e&&"function"===typeof btoa){var i=r(o),c=o.sources.map(function(t){return"/*# sourceURL="+o.sourceRoot+t+" */"});return[n].concat(c).concat([i]).join("\n")}return[n].join("\n")}function r(t){var e=btoa(unescape(encodeURIComponent(JSON.stringify(t)))),n="sourceMappingURL=data:application/json;charset=utf-8;base64,"+e;return"/*# "+n+" */"}t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var r=n(e,t);return e[2]?"@media "+e[2]+"{"+r+"}":r}).join("")},e.i=function(t,n){"string"===typeof t&&(t=[[null,t,""]]);for(var r={},o=0;o<this.length;o++){var i=this[o][0];"number"===typeof i&&(r[i]=!0)}for(o=0;o<t.length;o++){var c=t[o];"number"===typeof c[0]&&r[c[0]]||(n&&!c[2]?c[2]=n:n&&(c[2]="("+c[2]+") and ("+n+")"),e.push(c))}},e}},"2aba":function(t,e,n){var r=n("7726"),o=n("32e9"),i=n("69a8"),c=n("ca5a")("src"),s="toString",u=Function[s],f=(""+u).split(s);n("8378").inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,s){var u="function"==typeof n;u&&(i(n,"name")||o(n,"name",e)),t[e]!==n&&(u&&(i(n,c)||o(n,c,t[e]?""+t[e]:f.join(String(e)))),t===r?t[e]=n:s?t[e]?t[e]=n:o(t,e,n):(delete t[e],o(t,e,n)))})(Function.prototype,s,function(){return"function"==typeof this&&this[c]||u.call(this)})},"2aeb":function(t,e,n){var r=n("cb7c"),o=n("1495"),i=n("e11e"),c=n("613b")("IE_PROTO"),s=function(){},u="prototype",f=function(){var t,e=n("230e")("iframe"),r=i.length,o="<",c=">";e.style.display="none",n("fab2").appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write(o+"script"+c+"document.F=Object"+o+"/script"+c),t.close(),f=t.F;while(r--)delete f[u][i[r]];return f()};t.exports=Object.create||function(t,e){var n;return null!==t?(s[u]=r(t),n=new s,s[u]=null,n[c]=t):n=f(),void 0===e?n:o(n,e)}},"2d00":function(t,e){t.exports=!1},"2d95":function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},"32e9":function(t,e,n){var r=n("86cc"),o=n("4630");t.exports=n("9e1e")?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},"3ebe":function(t,e,n){e=t.exports=n("2350")(!1),e.push([t.i,"\n.vue-position-sticky {\n  position: fixed;\n  z-index: 999;\n}\n",""])},4588:function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},4630:function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},"499e":function(t,e,n){"use strict";function r(t,e){for(var n=[],r={},o=0;o<e.length;o++){var i=e[o],c=i[0],s=i[1],u=i[2],f=i[3],a={id:t+":"+o,css:s,media:u,sourceMap:f};r[c]?r[c].parts.push(a):n.push(r[c]={id:c,parts:[a]})}return n}n.r(e),n.d(e,"default",function(){return h});var o="undefined"!==typeof document;if("undefined"!==typeof DEBUG&&DEBUG&&!o)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var i={},c=o&&(document.head||document.getElementsByTagName("head")[0]),s=null,u=0,f=!1,a=function(){},p=null,l="data-vue-ssr-id",d="undefined"!==typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function h(t,e,n,o){f=n,p=o||{};var c=r(t,e);return v(c),function(e){for(var n=[],o=0;o<c.length;o++){var s=c[o],u=i[s.id];u.refs--,n.push(u)}e?(c=r(t,e),v(c)):c=[];for(o=0;o<n.length;o++){u=n[o];if(0===u.refs){for(var f=0;f<u.parts.length;f++)u.parts[f]();delete i[u.id]}}}}function v(t){for(var e=0;e<t.length;e++){var n=t[e],r=i[n.id];if(r){r.refs++;for(var o=0;o<r.parts.length;o++)r.parts[o](n.parts[o]);for(;o<n.parts.length;o++)r.parts.push(b(n.parts[o]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length)}else{var c=[];for(o=0;o<n.parts.length;o++)c.push(b(n.parts[o]));i[n.id]={id:n.id,refs:1,parts:c}}}}function y(){var t=document.createElement("style");return t.type="text/css",c.appendChild(t),t}function b(t){var e,n,r=document.querySelector("style["+l+'~="'+t.id+'"]');if(r){if(f)return a;r.parentNode.removeChild(r)}if(d){var o=u++;r=s||(s=y()),e=m.bind(null,r,o,!1),n=m.bind(null,r,o,!0)}else r=y(),e=w.bind(null,r),n=function(){r.parentNode.removeChild(r)};return e(t),function(r){if(r){if(r.css===t.css&&r.media===t.media&&r.sourceMap===t.sourceMap)return;e(t=r)}else n()}}var g=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}();function m(t,e,n,r){var o=n?"":r.css;if(t.styleSheet)t.styleSheet.cssText=g(e,o);else{var i=document.createTextNode(o),c=t.childNodes;c[e]&&t.removeChild(c[e]),c.length?t.insertBefore(i,c[e]):t.appendChild(i)}}function w(t,e){var n=e.css,r=e.media,o=e.sourceMap;if(r&&t.setAttribute("media",r),p.ssrId&&t.setAttribute(l,e.id),o&&(n+="\n/*# sourceURL="+o.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else{while(t.firstChild)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}},"52a7":function(t,e){e.f={}.propertyIsEnumerable},5537:function(t,e,n){var r=n("8378"),o=n("7726"),i="__core-js_shared__",c=o[i]||(o[i]={});(t.exports=function(t,e){return c[t]||(c[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n("2d00")?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},"5ca1":function(t,e,n){var r=n("7726"),o=n("8378"),i=n("32e9"),c=n("2aba"),s=n("9b43"),u="prototype",f=function(t,e,n){var a,p,l,d,h=t&f.F,v=t&f.G,y=t&f.S,b=t&f.P,g=t&f.B,m=v?r:y?r[e]||(r[e]={}):(r[e]||{})[u],w=v?o:o[e]||(o[e]={}),x=w[u]||(w[u]={});for(a in v&&(n=e),n)p=!h&&m&&void 0!==m[a],l=(p?m:n)[a],d=g&&p?s(l,r):b&&"function"==typeof l?s(Function.call,l):l,m&&c(m,a,l,t&f.U),w[a]!=l&&i(w,a,d),b&&x[a]!=l&&(x[a]=l)};r.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},"5dbc":function(t,e,n){var r=n("d3f4"),o=n("8b97").set;t.exports=function(t,e,n){var i,c=e.constructor;return c!==n&&"function"==typeof c&&(i=c.prototype)!==n.prototype&&r(i)&&o&&o(t,i),t}},"613b":function(t,e,n){var r=n("5537")("keys"),o=n("ca5a");t.exports=function(t){return r[t]||(r[t]=o(t))}},"626a":function(t,e,n){var r=n("2d95");t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},"67de":function(t,e,n){"use strict";var r=n("8759"),o=n.n(r);o.a},6821:function(t,e,n){var r=n("626a"),o=n("be13");t.exports=function(t){return r(o(t))}},"69a8":function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},"6a99":function(t,e,n){var r=n("d3f4");t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},7726:function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},"77f1":function(t,e,n){var r=n("4588"),o=Math.max,i=Math.min;t.exports=function(t,e){return t=r(t),t<0?o(t+e,0):i(t,e)}},"79e5":function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},8378:function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},"86cc":function(t,e,n){var r=n("cb7c"),o=n("c69a"),i=n("6a99"),c=Object.defineProperty;e.f=n("9e1e")?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return c(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},8759:function(t,e,n){var r=n("3ebe");"string"===typeof r&&(r=[[t.i,r,""]]),r.locals&&(t.exports=r.locals);var o=n("499e").default;o("6dee41cc",r,!0,{sourceMap:!1,shadowMode:!1})},"8b97":function(t,e,n){var r=n("d3f4"),o=n("cb7c"),i=function(t,e){if(o(t),!r(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,r){try{r=n("9b43")(Function.call,n("11e9").f(Object.prototype,"__proto__").set,2),r(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return i(t,n),e?t.__proto__=n:r(t,n),t}}({},!1):void 0),check:i}},9093:function(t,e,n){var r=n("ce10"),o=n("e11e").concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},"9b43":function(t,e,n){var r=n("d8e8");t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},"9def":function(t,e,n){var r=n("4588"),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},"9e1e":function(t,e,n){t.exports=!n("79e5")(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},aa77:function(t,e,n){var r=n("5ca1"),o=n("be13"),i=n("79e5"),c=n("fdef"),s="["+c+"]",u="​",f=RegExp("^"+s+s+"*"),a=RegExp(s+s+"*$"),p=function(t,e,n){var o={},s=i(function(){return!!c[t]()||u[t]()!=u}),f=o[t]=s?e(l):c[t];n&&(o[n]=f),r(r.P+r.F*s,"String",o)},l=p.trim=function(t,e){return t=String(o(t)),1&e&&(t=t.replace(f,"")),2&e&&(t=t.replace(a,"")),t};t.exports=p},be13:function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},c366:function(t,e,n){var r=n("6821"),o=n("9def"),i=n("77f1");t.exports=function(t){return function(e,n,c){var s,u=r(e),f=o(u.length),a=i(c,f);if(t&&n!=n){while(f>a)if(s=u[a++],s!=s)return!0}else for(;f>a;a++)if((t||a in u)&&u[a]===n)return t||a||0;return!t&&-1}}},c5f6:function(t,e,n){"use strict";var r=n("7726"),o=n("69a8"),i=n("2d95"),c=n("5dbc"),s=n("6a99"),u=n("79e5"),f=n("9093").f,a=n("11e9").f,p=n("86cc").f,l=n("aa77").trim,d="Number",h=r[d],v=h,y=h.prototype,b=i(n("2aeb")(y))==d,g="trim"in String.prototype,m=function(t){var e=s(t,!1);if("string"==typeof e&&e.length>2){e=g?e.trim():l(e,3);var n,r,o,i=e.charCodeAt(0);if(43===i||45===i){if(n=e.charCodeAt(2),88===n||120===n)return NaN}else if(48===i){switch(e.charCodeAt(1)){case 66:case 98:r=2,o=49;break;case 79:case 111:r=8,o=55;break;default:return+e}for(var c,u=e.slice(2),f=0,a=u.length;f<a;f++)if(c=u.charCodeAt(f),c<48||c>o)return NaN;return parseInt(u,r)}}return+e};if(!h(" 0o1")||!h("0b1")||h("+0x1")){h=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof h&&(b?u(function(){y.valueOf.call(n)}):i(n)!=d)?c(new v(m(e)),n,h):m(e)};for(var w,x=n("9e1e")?f(v):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),S=0;x.length>S;S++)o(v,w=x[S])&&!o(h,w)&&p(h,w,a(v,w));h.prototype=y,y.constructor=h,n("2aba")(r,d,h)}},c69a:function(t,e,n){t.exports=!n("9e1e")&&!n("79e5")(function(){return 7!=Object.defineProperty(n("230e")("div"),"a",{get:function(){return 7}}).a})},ca5a:function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},cb7c:function(t,e,n){var r=n("d3f4");t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},ce10:function(t,e,n){var r=n("69a8"),o=n("6821"),i=n("c366")(!1),c=n("613b")("IE_PROTO");t.exports=function(t,e){var n,s=o(t),u=0,f=[];for(n in s)n!=c&&r(s,n)&&f.push(n);while(e.length>u)r(s,n=e[u++])&&(~i(f,n)||f.push(n));return f}},d3f4:function(t,e){t.exports=function(t){return"object"===typeof t?null!==t:"function"===typeof t}},d8e8:function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},e11e:function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},fab2:function(t,e,n){var r=n("7726").document;t.exports=r&&r.documentElement},fb15:function(t,e,n){"use strict";n.r(e);n("1eb2");var r=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{style:t.wrapperStyles},[n("div",{class:[{"vue-position-sticky":t.sticky},t.stickyClass],style:t.stickyStyles},[t._t("default")],2)])},o=[],i=(n("c5f6"),{name:"sticky",props:{offsetTop:{type:Number,default:0},offsetBottom:{type:Number},stickyClass:{type:String}},data:function(){return{sticky:!1,wrapperStyles:{},stickyStyles:{}}},computed:{offsetType:function(){var t="top";return this.offsetBottom>=0&&(t="bottom"),t}},methods:{getScroll:function(t,e){var n=e?"pageYOffset":"pageXOffset";return t[n]},getOffset:function(t){var e=t.getBoundingClientRect(),n=this.getScroll(window,!0),r=this.getScroll(window),o=window.document.body,i=o.clientTop||0,c=o.clientLeft||0;return{top:e.top+n-i,left:e.left+r-c,width:e.width,height:e.height}},handleScroll:function(){var t=this.sticky,e=this.getScroll(window,!0),n=this.getOffset(this.$el),r=window.innerHeight,o=this.$el.getElementsByTagName("div")[0].offsetHeight;n.top-this.offsetTop<=e&&"top"===this.offsetType&&!t?(this.sticky=!0,this.wrapperStyles={width:"".concat(n.width,"px"),"min-width":"".concat(n.width,"px"),height:"".concat(n.height,"px"),"min-height":"".concat(n.height,"px")},this.stickyStyles={top:"".concat(this.offsetTop,"px"),left:"".concat(n.left,"px"),width:"".concat(this.$el.offsetWidth,"px")},this.$emit("change",!0)):n.top-this.offsetTop>e&&"top"===this.offsetType&&t&&(this.sticky=!1,this.wrapperStyles=null,this.stickyStyles=null,this.$emit("change",!1)),n.top+this.offsetBottom+o>e+r&&"bottom"===this.offsetType&&!t?(this.sticky=!0,this.wrapperStyles={width:"".concat(n.width,"px"),"min-width":"".concat(n.width,"px"),height:"".concat(n.height,"px"),"min-height":"".concat(n.height,"px")},this.stickyStyles={bottom:"".concat(this.offsetBottom,"px"),left:"".concat(n.left,"px"),width:"".concat(this.$el.offsetWidth,"px")},this.$emit("change",!0)):n.top+this.offsetBottom+o<e+r&&"bottom"===this.offsetType&&t&&(this.sticky=!1,this.wrapperStyles=null,this.stickyStyles=null,this.$emit("change",!1))},handleResize:function(){var t=this;this.sticky=!1,this.wrapperStyles=null,this.stickyStyles=null,this.$nextTick(function(){t.handleScroll()})}},mounted:function(){window.addEventListener("scroll",this.handleScroll,!1),window.addEventListener("resize",this.handleResize,!1)},beforeDestroy:function(){window.removeEventListener("scroll",this.handleScroll,!1),window.removeEventListener("resize",this.handleResize,!1)}}),c=i;n("67de");function s(t,e,n,r,o,i,c,s){var u,f="function"===typeof t?t.options:t;if(e&&(f.render=e,f.staticRenderFns=n,f._compiled=!0),r&&(f.functional=!0),i&&(f._scopeId="data-v-"+i),c?(u=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"===typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),o&&o.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(c)},f._ssrRegister=u):o&&(u=s?function(){o.call(this,this.$root.$options.shadowRoot)}:o),u)if(f.functional){f._injectStyles=u;var a=f.render;f.render=function(t,e){return u.call(e),a(t,e)}}else{var p=f.beforeCreate;f.beforeCreate=p?[].concat(p,u):[u]}return{exports:t,options:f}}var u=s(c,r,o,!1,null,null,null),f=u.exports,a={install:function(t){t.component("vue-position-sticky",f)}};"undefined"!==typeof window&&window.Vue&&window.Vue.component("vue-position-sticky",f);e["default"]=a},fdef:function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"}})});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scripts/build.js